var Tz = Object.defineProperty;
var xz = (t, e, r) => e in t ? Tz(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var kc = (t, e, r) => (xz(t, typeof e != "symbol" ? e + "" : e, r), r);
function Il(t, e) {
  const r = /* @__PURE__ */ Object.create(null), n = t.split(",");
  for (let s = 0; s < n.length; s++)
    r[n[s]] = !0;
  return e ? (s) => !!r[s.toLowerCase()] : (s) => !!r[s];
}
const ar = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, vd = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], Pn = () => {
}, IB = () => !1, Sz = /^on[^a-z]/, Op = (t) => Sz.test(t), Wg = (t) => t.startsWith("onUpdate:"), pr = Object.assign, mk = (t, e) => {
  const r = t.indexOf(e);
  r > -1 && t.splice(r, 1);
}, Ez = Object.prototype.hasOwnProperty, Et = (t, e) => Ez.call(t, e), ze = Array.isArray, pu = (t) => v0(t) === "[object Map]", PB = (t) => v0(t) === "[object Set]", dt = (t) => typeof t == "function", yr = (t) => typeof t == "string", gk = (t) => typeof t == "symbol", jt = (t) => t !== null && typeof t == "object", yk = (t) => jt(t) && dt(t.then) && dt(t.catch), RB = Object.prototype.toString, v0 = (t) => RB.call(t), bk = (t) => v0(t).slice(8, -1), MB = (t) => v0(t) === "[object Object]", _k = (t) => yr(t) && t !== "NaN" && t[0] !== "-" && "" + parseInt(t, 10) === t, bg = /* @__PURE__ */ Il(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), $z = /* @__PURE__ */ Il(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), m0 = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  return (r) => e[r] || (e[r] = t(r));
}, kz = /-(\w)/g, Aa = m0((t) => t.replace(kz, (e, r) => r ? r.toUpperCase() : "")), Dz = /\B([A-Z])/g, xo = m0(
  (t) => t.replace(Dz, "-$1").toLowerCase()
), Nu = m0(
  (t) => t.charAt(0).toUpperCase() + t.slice(1)
), Jl = m0(
  (t) => t ? `on${Nu(t)}` : ""
), Vf = (t, e) => !Object.is(t, e), Yh = (t, e) => {
  for (let r = 0; r < t.length; r++)
    t[r](e);
}, jg = (t, e, r) => {
  Object.defineProperty(t, e, {
    configurable: !0,
    enumerable: !1,
    value: r
  });
}, Oz = (t) => {
  const e = parseFloat(t);
  return isNaN(e) ? t : e;
}, Az = (t) => {
  const e = yr(t) ? Number(t) : NaN;
  return isNaN(e) ? t : e;
};
let DC;
const Kg = () => DC || (DC = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function ri(t) {
  if (ze(t)) {
    const e = {};
    for (let r = 0; r < t.length; r++) {
      const n = t[r], s = yr(n) ? Rz(n) : ri(n);
      if (s)
        for (const a in s)
          e[a] = s[a];
    }
    return e;
  } else {
    if (yr(t))
      return t;
    if (jt(t))
      return t;
  }
}
const Cz = /;(?![^(]*\))/g, Iz = /:([^]+)/, Pz = /\/\*[^]*?\*\//g;
function Rz(t) {
  const e = {};
  return t.replace(Pz, "").split(Cz).forEach((r) => {
    if (r) {
      const n = r.split(Iz);
      n.length > 1 && (e[n[0].trim()] = n[1].trim());
    }
  }), e;
}
function wt(t) {
  let e = "";
  if (yr(t))
    e = t;
  else if (ze(t))
    for (let r = 0; r < t.length; r++) {
      const n = wt(t[r]);
      n && (e += n + " ");
    }
  else if (jt(t))
    for (const r in t)
      t[r] && (e += r + " ");
  return e.trim();
}
function Hn(t) {
  if (!t)
    return null;
  let { class: e, style: r } = t;
  return e && !yr(e) && (t.class = wt(e)), r && (t.style = ri(r)), t;
}
const Mz = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot", Lz = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view", Nz = /* @__PURE__ */ Il(Mz), Fz = /* @__PURE__ */ Il(Lz), Bz = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", Uz = /* @__PURE__ */ Il(Bz);
function LB(t) {
  return !!t || t === "";
}
const er = (t) => yr(t) ? t : t == null ? "" : ze(t) || jt(t) && (t.toString === RB || !dt(t.toString)) ? JSON.stringify(t, NB, 2) : String(t), NB = (t, e) => e && e.__v_isRef ? NB(t, e.value) : pu(e) ? {
  [`Map(${e.size})`]: [...e.entries()].reduce((r, [n, s]) => (r[`${n} =>`] = s, r), {})
} : PB(e) ? {
  [`Set(${e.size})`]: [...e.values()]
} : jt(e) && !ze(e) && !MB(e) ? String(e) : e;
function zg(t, ...e) {
  console.warn(`[Vue warn] ${t}`, ...e);
}
let Mi;
class Vz {
  constructor(e = !1) {
    this.detached = e, this._active = !0, this.effects = [], this.cleanups = [], this.parent = Mi, !e && Mi && (this.index = (Mi.scopes || (Mi.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  run(e) {
    if (this._active) {
      const r = Mi;
      try {
        return Mi = this, e();
      } finally {
        Mi = r;
      }
    } else
      process.env.NODE_ENV !== "production" && zg("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    Mi = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    Mi = this.parent;
  }
  stop(e) {
    if (this._active) {
      let r, n;
      for (r = 0, n = this.effects.length; r < n; r++)
        this.effects[r].stop();
      for (r = 0, n = this.cleanups.length; r < n; r++)
        this.cleanups[r]();
      if (this.scopes)
        for (r = 0, n = this.scopes.length; r < n; r++)
          this.scopes[r].stop(!0);
      if (!this.detached && this.parent && !e) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0, this._active = !1;
    }
  }
}
function Yz(t, e = Mi) {
  e && e.active && e.effects.push(t);
}
function wk() {
  return Mi;
}
function FB(t) {
  Mi ? Mi.cleanups.push(t) : process.env.NODE_ENV !== "production" && zg(
    "onScopeDispose() is called when there is no active effect scope to be associated with."
  );
}
const Yf = (t) => {
  const e = new Set(t);
  return e.w = 0, e.n = 0, e;
}, BB = (t) => (t.w & El) > 0, UB = (t) => (t.n & El) > 0, Hz = ({ deps: t }) => {
  if (t.length)
    for (let e = 0; e < t.length; e++)
      t[e].w |= El;
}, Gz = (t) => {
  const { deps: e } = t;
  if (e.length) {
    let r = 0;
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      BB(s) && !UB(s) ? s.delete(t) : e[r++] = s, s.w &= ~El, s.n &= ~El;
    }
    e.length = r;
  }
}, qg = /* @__PURE__ */ new WeakMap();
let df = 0, El = 1;
const AT = 30;
let Zn;
const vu = Symbol(process.env.NODE_ENV !== "production" ? "iterate" : ""), CT = Symbol(process.env.NODE_ENV !== "production" ? "Map key iterate" : "");
class Tk {
  constructor(e, r = null, n) {
    this.fn = e, this.scheduler = r, this.active = !0, this.deps = [], this.parent = void 0, Yz(this, n);
  }
  run() {
    if (!this.active)
      return this.fn();
    let e = Zn, r = pl;
    for (; e; ) {
      if (e === this)
        return;
      e = e.parent;
    }
    try {
      return this.parent = Zn, Zn = this, pl = !0, El = 1 << ++df, df <= AT ? Hz(this) : OC(this), this.fn();
    } finally {
      df <= AT && Gz(this), El = 1 << --df, Zn = this.parent, pl = r, this.parent = void 0, this.deferStop && this.stop();
    }
  }
  stop() {
    Zn === this ? this.deferStop = !0 : this.active && (OC(this), this.onStop && this.onStop(), this.active = !1);
  }
}
function OC(t) {
  const { deps: e } = t;
  if (e.length) {
    for (let r = 0; r < e.length; r++)
      e[r].delete(t);
    e.length = 0;
  }
}
let pl = !0;
const VB = [];
function ec() {
  VB.push(pl), pl = !1;
}
function tc() {
  const t = VB.pop();
  pl = t === void 0 ? !0 : t;
}
function Ln(t, e, r) {
  if (pl && Zn) {
    let n = qg.get(t);
    n || qg.set(t, n = /* @__PURE__ */ new Map());
    let s = n.get(r);
    s || n.set(r, s = Yf());
    const a = process.env.NODE_ENV !== "production" ? { effect: Zn, target: t, type: e, key: r } : void 0;
    IT(s, a);
  }
}
function IT(t, e) {
  let r = !1;
  df <= AT ? UB(t) || (t.n |= El, r = !BB(t)) : r = !t.has(Zn), r && (t.add(Zn), Zn.deps.push(t), process.env.NODE_ENV !== "production" && Zn.onTrack && Zn.onTrack(
    pr(
      {
        effect: Zn
      },
      e
    )
  ));
}
function Ca(t, e, r, n, s, a) {
  const o = qg.get(t);
  if (!o)
    return;
  let l = [];
  if (e === "clear")
    l = [...o.values()];
  else if (r === "length" && ze(t)) {
    const c = Number(n);
    o.forEach((d, h) => {
      (h === "length" || h >= c) && l.push(d);
    });
  } else
    switch (r !== void 0 && l.push(o.get(r)), e) {
      case "add":
        ze(t) ? _k(r) && l.push(o.get("length")) : (l.push(o.get(vu)), pu(t) && l.push(o.get(CT)));
        break;
      case "delete":
        ze(t) || (l.push(o.get(vu)), pu(t) && l.push(o.get(CT)));
        break;
      case "set":
        pu(t) && l.push(o.get(vu));
        break;
    }
  const u = process.env.NODE_ENV !== "production" ? { target: t, type: e, key: r, newValue: n, oldValue: s, oldTarget: a } : void 0;
  if (l.length === 1)
    l[0] && (process.env.NODE_ENV !== "production" ? ed(l[0], u) : ed(l[0]));
  else {
    const c = [];
    for (const d of l)
      d && c.push(...d);
    process.env.NODE_ENV !== "production" ? ed(Yf(c), u) : ed(Yf(c));
  }
}
function ed(t, e) {
  const r = ze(t) ? t : [...t];
  for (const n of r)
    n.computed && AC(n, e);
  for (const n of r)
    n.computed || AC(n, e);
}
function AC(t, e) {
  (t !== Zn || t.allowRecurse) && (process.env.NODE_ENV !== "production" && t.onTrigger && t.onTrigger(pr({ effect: t }, e)), t.scheduler ? t.scheduler() : t.run());
}
function Wz(t, e) {
  var r;
  return (r = qg.get(t)) == null ? void 0 : r.get(e);
}
const jz = /* @__PURE__ */ Il("__proto__,__v_isRef,__isVue"), YB = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((t) => t !== "arguments" && t !== "caller").map((t) => Symbol[t]).filter(gk)
), Kz = /* @__PURE__ */ g0(), zz = /* @__PURE__ */ g0(!1, !0), qz = /* @__PURE__ */ g0(!0), Xz = /* @__PURE__ */ g0(!0, !0), CC = /* @__PURE__ */ Qz();
function Qz() {
  const t = {};
  return ["includes", "indexOf", "lastIndexOf"].forEach((e) => {
    t[e] = function(...r) {
      const n = gt(this);
      for (let a = 0, o = this.length; a < o; a++)
        Ln(n, "get", a + "");
      const s = n[e](...r);
      return s === -1 || s === !1 ? n[e](...r.map(gt)) : s;
    };
  }), ["push", "pop", "shift", "unshift", "splice"].forEach((e) => {
    t[e] = function(...r) {
      ec();
      const n = gt(this)[e].apply(this, r);
      return tc(), n;
    };
  }), t;
}
function Zz(t) {
  const e = gt(this);
  return Ln(e, "has", t), e.hasOwnProperty(t);
}
function g0(t = !1, e = !1) {
  return function(n, s, a) {
    if (s === "__v_isReactive")
      return !t;
    if (s === "__v_isReadonly")
      return t;
    if (s === "__v_isShallow")
      return e;
    if (s === "__v_raw" && a === (t ? e ? XB : qB : e ? zB : KB).get(n))
      return n;
    const o = ze(n);
    if (!t) {
      if (o && Et(CC, s))
        return Reflect.get(CC, s, a);
      if (s === "hasOwnProperty")
        return Zz;
    }
    const l = Reflect.get(n, s, a);
    return (gk(s) ? YB.has(s) : jz(s)) || (t || Ln(n, "get", s), e) ? l : Or(l) ? o && _k(s) ? l : l.value : jt(l) ? t ? Sk(l) : Na(l) : l;
  };
}
const Jz = /* @__PURE__ */ HB(), e9 = /* @__PURE__ */ HB(!0);
function HB(t = !1) {
  return function(r, n, s, a) {
    let o = r[n];
    if ($l(o) && Or(o) && !Or(s))
      return !1;
    if (!t && (!Xg(s) && !$l(s) && (o = gt(o), s = gt(s)), !ze(r) && Or(o) && !Or(s)))
      return o.value = s, !0;
    const l = ze(r) && _k(n) ? Number(n) < r.length : Et(r, n), u = Reflect.set(r, n, s, a);
    return r === gt(a) && (l ? Vf(s, o) && Ca(r, "set", n, s, o) : Ca(r, "add", n, s)), u;
  };
}
function t9(t, e) {
  const r = Et(t, e), n = t[e], s = Reflect.deleteProperty(t, e);
  return s && r && Ca(t, "delete", e, void 0, n), s;
}
function r9(t, e) {
  const r = Reflect.has(t, e);
  return (!gk(e) || !YB.has(e)) && Ln(t, "has", e), r;
}
function n9(t) {
  return Ln(t, "iterate", ze(t) ? "length" : vu), Reflect.ownKeys(t);
}
const GB = {
  get: Kz,
  set: Jz,
  deleteProperty: t9,
  has: r9,
  ownKeys: n9
}, WB = {
  get: qz,
  set(t, e) {
    return process.env.NODE_ENV !== "production" && zg(
      `Set operation on key "${String(e)}" failed: target is readonly.`,
      t
    ), !0;
  },
  deleteProperty(t, e) {
    return process.env.NODE_ENV !== "production" && zg(
      `Delete operation on key "${String(e)}" failed: target is readonly.`,
      t
    ), !0;
  }
}, i9 = /* @__PURE__ */ pr(
  {},
  GB,
  {
    get: zz,
    set: e9
  }
), s9 = /* @__PURE__ */ pr(
  {},
  WB,
  {
    get: Xz
  }
), xk = (t) => t, y0 = (t) => Reflect.getPrototypeOf(t);
function um(t, e, r = !1, n = !1) {
  t = t.__v_raw;
  const s = gt(t), a = gt(e);
  r || (e !== a && Ln(s, "get", e), Ln(s, "get", a));
  const { has: o } = y0(s), l = n ? xk : r ? Ek : Hf;
  if (o.call(s, e))
    return l(t.get(e));
  if (o.call(s, a))
    return l(t.get(a));
  t !== s && t.get(e);
}
function cm(t, e = !1) {
  const r = this.__v_raw, n = gt(r), s = gt(t);
  return e || (t !== s && Ln(n, "has", t), Ln(n, "has", s)), t === s ? r.has(t) : r.has(t) || r.has(s);
}
function dm(t, e = !1) {
  return t = t.__v_raw, !e && Ln(gt(t), "iterate", vu), Reflect.get(t, "size", t);
}
function IC(t) {
  t = gt(t);
  const e = gt(this);
  return y0(e).has.call(e, t) || (e.add(t), Ca(e, "add", t, t)), this;
}
function PC(t, e) {
  e = gt(e);
  const r = gt(this), { has: n, get: s } = y0(r);
  let a = n.call(r, t);
  a ? process.env.NODE_ENV !== "production" && jB(r, n, t) : (t = gt(t), a = n.call(r, t));
  const o = s.call(r, t);
  return r.set(t, e), a ? Vf(e, o) && Ca(r, "set", t, e, o) : Ca(r, "add", t, e), this;
}
function RC(t) {
  const e = gt(this), { has: r, get: n } = y0(e);
  let s = r.call(e, t);
  s ? process.env.NODE_ENV !== "production" && jB(e, r, t) : (t = gt(t), s = r.call(e, t));
  const a = n ? n.call(e, t) : void 0, o = e.delete(t);
  return s && Ca(e, "delete", t, void 0, a), o;
}
function MC() {
  const t = gt(this), e = t.size !== 0, r = process.env.NODE_ENV !== "production" ? pu(t) ? new Map(t) : new Set(t) : void 0, n = t.clear();
  return e && Ca(t, "clear", void 0, void 0, r), n;
}
function hm(t, e) {
  return function(n, s) {
    const a = this, o = a.__v_raw, l = gt(o), u = e ? xk : t ? Ek : Hf;
    return !t && Ln(l, "iterate", vu), o.forEach((c, d) => n.call(s, u(c), u(d), a));
  };
}
function fm(t, e, r) {
  return function(...n) {
    const s = this.__v_raw, a = gt(s), o = pu(a), l = t === "entries" || t === Symbol.iterator && o, u = t === "keys" && o, c = s[t](...n), d = r ? xk : e ? Ek : Hf;
    return !e && Ln(
      a,
      "iterate",
      u ? CT : vu
    ), {
      // iterator protocol
      next() {
        const { value: h, done: f } = c.next();
        return f ? { value: h, done: f } : {
          value: l ? [d(h[0]), d(h[1])] : d(h),
          done: f
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function Ko(t) {
  return function(...e) {
    if (process.env.NODE_ENV !== "production") {
      const r = e[0] ? `on key "${e[0]}" ` : "";
      console.warn(
        `${Nu(t)} operation ${r}failed: target is readonly.`,
        gt(this)
      );
    }
    return t === "delete" ? !1 : this;
  };
}
function a9() {
  const t = {
    get(a) {
      return um(this, a);
    },
    get size() {
      return dm(this);
    },
    has: cm,
    add: IC,
    set: PC,
    delete: RC,
    clear: MC,
    forEach: hm(!1, !1)
  }, e = {
    get(a) {
      return um(this, a, !1, !0);
    },
    get size() {
      return dm(this);
    },
    has: cm,
    add: IC,
    set: PC,
    delete: RC,
    clear: MC,
    forEach: hm(!1, !0)
  }, r = {
    get(a) {
      return um(this, a, !0);
    },
    get size() {
      return dm(this, !0);
    },
    has(a) {
      return cm.call(this, a, !0);
    },
    add: Ko("add"),
    set: Ko("set"),
    delete: Ko("delete"),
    clear: Ko("clear"),
    forEach: hm(!0, !1)
  }, n = {
    get(a) {
      return um(this, a, !0, !0);
    },
    get size() {
      return dm(this, !0);
    },
    has(a) {
      return cm.call(this, a, !0);
    },
    add: Ko("add"),
    set: Ko("set"),
    delete: Ko("delete"),
    clear: Ko("clear"),
    forEach: hm(!0, !0)
  };
  return ["keys", "values", "entries", Symbol.iterator].forEach((a) => {
    t[a] = fm(
      a,
      !1,
      !1
    ), r[a] = fm(
      a,
      !0,
      !1
    ), e[a] = fm(
      a,
      !1,
      !0
    ), n[a] = fm(
      a,
      !0,
      !0
    );
  }), [
    t,
    r,
    e,
    n
  ];
}
const [
  o9,
  l9,
  u9,
  c9
] = /* @__PURE__ */ a9();
function b0(t, e) {
  const r = e ? t ? c9 : u9 : t ? l9 : o9;
  return (n, s, a) => s === "__v_isReactive" ? !t : s === "__v_isReadonly" ? t : s === "__v_raw" ? n : Reflect.get(
    Et(r, s) && s in n ? r : n,
    s,
    a
  );
}
const d9 = {
  get: /* @__PURE__ */ b0(!1, !1)
}, h9 = {
  get: /* @__PURE__ */ b0(!1, !0)
}, f9 = {
  get: /* @__PURE__ */ b0(!0, !1)
}, p9 = {
  get: /* @__PURE__ */ b0(!0, !0)
};
function jB(t, e, r) {
  const n = gt(r);
  if (n !== r && e.call(t, n)) {
    const s = bk(t);
    console.warn(
      `Reactive ${s} contains both the raw and reactive versions of the same object${s === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const KB = /* @__PURE__ */ new WeakMap(), zB = /* @__PURE__ */ new WeakMap(), qB = /* @__PURE__ */ new WeakMap(), XB = /* @__PURE__ */ new WeakMap();
function v9(t) {
  switch (t) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function m9(t) {
  return t.__v_skip || !Object.isExtensible(t) ? 0 : v9(bk(t));
}
function Na(t) {
  return $l(t) ? t : _0(
    t,
    !1,
    GB,
    d9,
    KB
  );
}
function g9(t) {
  return _0(
    t,
    !1,
    i9,
    h9,
    zB
  );
}
function Sk(t) {
  return _0(
    t,
    !0,
    WB,
    f9,
    qB
  );
}
function hf(t) {
  return _0(
    t,
    !0,
    s9,
    p9,
    XB
  );
}
function _0(t, e, r, n, s) {
  if (!jt(t))
    return process.env.NODE_ENV !== "production" && console.warn(`value cannot be made reactive: ${String(t)}`), t;
  if (t.__v_raw && !(e && t.__v_isReactive))
    return t;
  const a = s.get(t);
  if (a)
    return a;
  const o = m9(t);
  if (o === 0)
    return t;
  const l = new Proxy(
    t,
    o === 2 ? n : r
  );
  return s.set(t, l), l;
}
function mu(t) {
  return $l(t) ? mu(t.__v_raw) : !!(t && t.__v_isReactive);
}
function $l(t) {
  return !!(t && t.__v_isReadonly);
}
function Xg(t) {
  return !!(t && t.__v_isShallow);
}
function Qg(t) {
  return mu(t) || $l(t);
}
function gt(t) {
  const e = t && t.__v_raw;
  return e ? gt(e) : t;
}
function QB(t) {
  return jg(t, "__v_skip", !0), t;
}
const Hf = (t) => jt(t) ? Na(t) : t, Ek = (t) => jt(t) ? Sk(t) : t;
function ZB(t) {
  pl && Zn && (t = gt(t), process.env.NODE_ENV !== "production" ? IT(t.dep || (t.dep = Yf()), {
    target: t,
    type: "get",
    key: "value"
  }) : IT(t.dep || (t.dep = Yf())));
}
function JB(t, e) {
  t = gt(t);
  const r = t.dep;
  r && (process.env.NODE_ENV !== "production" ? ed(r, {
    target: t,
    type: "set",
    key: "value",
    newValue: e
  }) : ed(r));
}
function Or(t) {
  return !!(t && t.__v_isRef === !0);
}
function ue(t) {
  return y9(t, !1);
}
function y9(t, e) {
  return Or(t) ? t : new b9(t, e);
}
class b9 {
  constructor(e, r) {
    this.__v_isShallow = r, this.dep = void 0, this.__v_isRef = !0, this._rawValue = r ? e : gt(e), this._value = r ? e : Hf(e);
  }
  get value() {
    return ZB(this), this._value;
  }
  set value(e) {
    const r = this.__v_isShallow || Xg(e) || $l(e);
    e = r ? e : gt(e), Vf(e, this._rawValue) && (this._rawValue = e, this._value = r ? e : Hf(e), JB(this, e));
  }
}
function X(t) {
  return Or(t) ? t.value : t;
}
const _9 = {
  get: (t, e, r) => X(Reflect.get(t, e, r)),
  set: (t, e, r, n) => {
    const s = t[e];
    return Or(s) && !Or(r) ? (s.value = r, !0) : Reflect.set(t, e, r, n);
  }
};
function e3(t) {
  return mu(t) ? t : new Proxy(t, _9);
}
function t3(t) {
  process.env.NODE_ENV !== "production" && !Qg(t) && console.warn("toRefs() expects a reactive object but received a plain one.");
  const e = ze(t) ? new Array(t.length) : {};
  for (const r in t)
    e[r] = r3(t, r);
  return e;
}
class w9 {
  constructor(e, r, n) {
    this._object = e, this._key = r, this._defaultValue = n, this.__v_isRef = !0;
  }
  get value() {
    const e = this._object[this._key];
    return e === void 0 ? this._defaultValue : e;
  }
  set value(e) {
    this._object[this._key] = e;
  }
  get dep() {
    return Wz(gt(this._object), this._key);
  }
}
class T9 {
  constructor(e) {
    this._getter = e, this.__v_isRef = !0, this.__v_isReadonly = !0;
  }
  get value() {
    return this._getter();
  }
}
function Zg(t, e, r) {
  return Or(t) ? t : dt(t) ? new T9(t) : jt(t) && arguments.length > 1 ? r3(t, e, r) : ue(t);
}
function r3(t, e, r) {
  const n = t[e];
  return Or(n) ? n : new w9(
    t,
    e,
    r
  );
}
class x9 {
  constructor(e, r, n, s) {
    this._setter = r, this.dep = void 0, this.__v_isRef = !0, this.__v_isReadonly = !1, this._dirty = !0, this.effect = new Tk(e, () => {
      this._dirty || (this._dirty = !0, JB(this));
    }), this.effect.computed = this, this.effect.active = this._cacheable = !s, this.__v_isReadonly = n;
  }
  get value() {
    const e = gt(this);
    return ZB(e), (e._dirty || !e._cacheable) && (e._dirty = !1, e._value = e.effect.run()), e._value;
  }
  set value(e) {
    this._setter(e);
  }
}
function S9(t, e, r = !1) {
  let n, s;
  const a = dt(t);
  a ? (n = t, s = process.env.NODE_ENV !== "production" ? () => {
    console.warn("Write operation failed: computed value is readonly");
  } : Pn) : (n = t.get, s = t.set);
  const o = new x9(n, s, a || !s, r);
  return process.env.NODE_ENV !== "production" && e && !r && (o.effect.onTrack = e.onTrack, o.effect.onTrigger = e.onTrigger), o;
}
const gu = [];
function _g(t) {
  gu.push(t);
}
function wg() {
  gu.pop();
}
function Ee(t, ...e) {
  if (process.env.NODE_ENV === "production")
    return;
  ec();
  const r = gu.length ? gu[gu.length - 1].component : null, n = r && r.appContext.config.warnHandler, s = E9();
  if (n)
    co(
      n,
      r,
      11,
      [
        t + e.join(""),
        r && r.proxy,
        s.map(
          ({ vnode: a }) => `at <${A0(r, a.type)}>`
        ).join(`
`),
        s
      ]
    );
  else {
    const a = [`[Vue warn]: ${t}`, ...e];
    s.length && a.push(`
`, ...$9(s)), console.warn(...a);
  }
  tc();
}
function E9() {
  let t = gu[gu.length - 1];
  if (!t)
    return [];
  const e = [];
  for (; t; ) {
    const r = e[0];
    r && r.vnode === t ? r.recurseCount++ : e.push({
      vnode: t,
      recurseCount: 0
    });
    const n = t.component && t.component.parent;
    t = n && n.vnode;
  }
  return e;
}
function $9(t) {
  const e = [];
  return t.forEach((r, n) => {
    e.push(...n === 0 ? [] : [`
`], ...k9(r));
  }), e;
}
function k9({ vnode: t, recurseCount: e }) {
  const r = e > 0 ? `... (${e} recursive calls)` : "", n = t.component ? t.component.parent == null : !1, s = ` at <${A0(
    t.component,
    t.type,
    n
  )}`, a = ">" + r;
  return t.props ? [s, ...D9(t.props), a] : [s + a];
}
function D9(t) {
  const e = [], r = Object.keys(t);
  return r.slice(0, 3).forEach((n) => {
    e.push(...n3(n, t[n]));
  }), r.length > 3 && e.push(" ..."), e;
}
function n3(t, e, r) {
  return yr(e) ? (e = JSON.stringify(e), r ? e : [`${t}=${e}`]) : typeof e == "number" || typeof e == "boolean" || e == null ? r ? e : [`${t}=${e}`] : Or(e) ? (e = n3(t, gt(e.value), !0), r ? e : [`${t}=Ref<`, e, ">"]) : dt(e) ? [`${t}=fn${e.name ? `<${e.name}>` : ""}`] : (e = gt(e), r ? e : [`${t}=`, e]);
}
function O9(t, e) {
  process.env.NODE_ENV !== "production" && t !== void 0 && (typeof t != "number" ? Ee(`${e} is not a valid number - got ${JSON.stringify(t)}.`) : isNaN(t) && Ee(`${e} is NaN - the duration expression might be incorrect.`));
}
const $k = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function co(t, e, r, n) {
  let s;
  try {
    s = n ? t(...n) : t();
  } catch (a) {
    w0(a, e, r);
  }
  return s;
}
function us(t, e, r, n) {
  if (dt(t)) {
    const a = co(t, e, r, n);
    return a && yk(a) && a.catch((o) => {
      w0(o, e, r);
    }), a;
  }
  const s = [];
  for (let a = 0; a < t.length; a++)
    s.push(us(t[a], e, r, n));
  return s;
}
function w0(t, e, r, n = !0) {
  const s = e ? e.vnode : null;
  if (e) {
    let a = e.parent;
    const o = e.proxy, l = process.env.NODE_ENV !== "production" ? $k[r] : r;
    for (; a; ) {
      const c = a.ec;
      if (c) {
        for (let d = 0; d < c.length; d++)
          if (c[d](t, o, l) === !1)
            return;
      }
      a = a.parent;
    }
    const u = e.appContext.config.errorHandler;
    if (u) {
      co(
        u,
        null,
        10,
        [t, o, l]
      );
      return;
    }
  }
  A9(t, r, s, n);
}
function A9(t, e, r, n = !0) {
  if (process.env.NODE_ENV !== "production") {
    const s = $k[e];
    if (r && _g(r), Ee(`Unhandled error${s ? ` during execution of ${s}` : ""}`), r && wg(), n)
      throw t;
    console.error(t);
  } else
    console.error(t);
}
let Gf = !1, PT = !1;
const Yn = [];
let fa = 0;
const md = [];
let ca = null, rl = 0;
const i3 = /* @__PURE__ */ Promise.resolve();
let kk = null;
const C9 = 100;
function Ia(t) {
  const e = kk || i3;
  return t ? e.then(this ? t.bind(this) : t) : e;
}
function I9(t) {
  let e = fa + 1, r = Yn.length;
  for (; e < r; ) {
    const n = e + r >>> 1;
    Wf(Yn[n]) < t ? e = n + 1 : r = n;
  }
  return e;
}
function T0(t) {
  (!Yn.length || !Yn.includes(
    t,
    Gf && t.allowRecurse ? fa + 1 : fa
  )) && (t.id == null ? Yn.push(t) : Yn.splice(I9(t.id), 0, t), s3());
}
function s3() {
  !Gf && !PT && (PT = !0, kk = i3.then(l3));
}
function P9(t) {
  const e = Yn.indexOf(t);
  e > fa && Yn.splice(e, 1);
}
function a3(t) {
  ze(t) ? md.push(...t) : (!ca || !ca.includes(
    t,
    t.allowRecurse ? rl + 1 : rl
  )) && md.push(t), s3();
}
function LC(t, e = Gf ? fa + 1 : 0) {
  for (process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()); e < Yn.length; e++) {
    const r = Yn[e];
    if (r && r.pre) {
      if (process.env.NODE_ENV !== "production" && Dk(t, r))
        continue;
      Yn.splice(e, 1), e--, r();
    }
  }
}
function o3(t) {
  if (md.length) {
    const e = [...new Set(md)];
    if (md.length = 0, ca) {
      ca.push(...e);
      return;
    }
    for (ca = e, process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()), ca.sort((r, n) => Wf(r) - Wf(n)), rl = 0; rl < ca.length; rl++)
      process.env.NODE_ENV !== "production" && Dk(t, ca[rl]) || ca[rl]();
    ca = null, rl = 0;
  }
}
const Wf = (t) => t.id == null ? 1 / 0 : t.id, R9 = (t, e) => {
  const r = Wf(t) - Wf(e);
  if (r === 0) {
    if (t.pre && !e.pre)
      return -1;
    if (e.pre && !t.pre)
      return 1;
  }
  return r;
};
function l3(t) {
  PT = !1, Gf = !0, process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()), Yn.sort(R9);
  const e = process.env.NODE_ENV !== "production" ? (r) => Dk(t, r) : Pn;
  try {
    for (fa = 0; fa < Yn.length; fa++) {
      const r = Yn[fa];
      if (r && r.active !== !1) {
        if (process.env.NODE_ENV !== "production" && e(r))
          continue;
        co(r, null, 14);
      }
    }
  } finally {
    fa = 0, Yn.length = 0, o3(t), Gf = !1, kk = null, (Yn.length || md.length) && l3(t);
  }
}
function Dk(t, e) {
  if (!t.has(e))
    t.set(e, 1);
  else {
    const r = t.get(e);
    if (r > C9) {
      const n = e.ownerInstance, s = n && Lk(n.type);
      return Ee(
        `Maximum recursive updates exceeded${s ? ` in component <${s}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`
      ), !0;
    } else
      t.set(e, r + 1);
  }
}
let vl = !1;
const Xc = /* @__PURE__ */ new Set();
process.env.NODE_ENV !== "production" && (Kg().__VUE_HMR_RUNTIME__ = {
  createRecord: c_(u3),
  rerender: c_(N9),
  reload: c_(F9)
});
const Fu = /* @__PURE__ */ new Map();
function M9(t) {
  const e = t.type.__hmrId;
  let r = Fu.get(e);
  r || (u3(e, t.type), r = Fu.get(e)), r.instances.add(t);
}
function L9(t) {
  Fu.get(t.type.__hmrId).instances.delete(t);
}
function u3(t, e) {
  return Fu.has(t) ? !1 : (Fu.set(t, {
    initialDef: bf(e),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function bf(t) {
  return H3(t) ? t.__vccOpts : t;
}
function N9(t, e) {
  const r = Fu.get(t);
  r && (r.initialDef.render = e, [...r.instances].forEach((n) => {
    e && (n.render = e, bf(n.type).render = e), n.renderCache = [], vl = !0, n.update(), vl = !1;
  }));
}
function F9(t, e) {
  const r = Fu.get(t);
  if (!r)
    return;
  e = bf(e), NC(r.initialDef, e);
  const n = [...r.instances];
  for (const s of n) {
    const a = bf(s.type);
    Xc.has(a) || (a !== r.initialDef && NC(a, e), Xc.add(a)), s.appContext.propsCache.delete(s.type), s.appContext.emitsCache.delete(s.type), s.appContext.optionsCache.delete(s.type), s.ceReload ? (Xc.add(a), s.ceReload(e.styles), Xc.delete(a)) : s.parent ? T0(s.parent.update) : s.appContext.reload ? s.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    );
  }
  a3(() => {
    for (const s of n)
      Xc.delete(
        bf(s.type)
      );
  });
}
function NC(t, e) {
  pr(t, e);
  for (const r in t)
    r !== "__file" && !(r in e) && delete t[r];
}
function c_(t) {
  return (e, r) => {
    try {
      return t(e, r);
    } catch (n) {
      console.error(n), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let pa, ff = [], RT = !1;
function Ap(t, ...e) {
  pa ? pa.emit(t, ...e) : RT || ff.push({ event: t, args: e });
}
function c3(t, e) {
  var r, n;
  pa = t, pa ? (pa.enabled = !0, ff.forEach(({ event: s, args: a }) => pa.emit(s, ...a)), ff = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  !((n = (r = window.navigator) == null ? void 0 : r.userAgent) != null && n.includes("jsdom")) ? ((e.__VUE_DEVTOOLS_HOOK_REPLAY__ = e.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((a) => {
    c3(a, e);
  }), setTimeout(() => {
    pa || (e.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, RT = !0, ff = []);
  }, 3e3)) : (RT = !0, ff = []);
}
function B9(t, e) {
  Ap("app:init", t, e, {
    Fragment: Je,
    Text: Ip,
    Comment: Tn,
    Static: bd
  });
}
function U9(t) {
  Ap("app:unmount", t);
}
const V9 = /* @__PURE__ */ Ok(
  "component:added"
  /* COMPONENT_ADDED */
), d3 = /* @__PURE__ */ Ok(
  "component:updated"
  /* COMPONENT_UPDATED */
), Y9 = /* @__PURE__ */ Ok(
  "component:removed"
  /* COMPONENT_REMOVED */
), H9 = (t) => {
  pa && typeof pa.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !pa.cleanupBuffer(t) && Y9(t);
};
function Ok(t) {
  return (e) => {
    Ap(
      t,
      e.appContext.app,
      e.uid,
      e.parent ? e.parent.uid : void 0,
      e
    );
  };
}
const G9 = /* @__PURE__ */ h3(
  "perf:start"
  /* PERFORMANCE_START */
), W9 = /* @__PURE__ */ h3(
  "perf:end"
  /* PERFORMANCE_END */
);
function h3(t) {
  return (e, r, n) => {
    Ap(t, e.appContext.app, e.uid, e, r, n);
  };
}
function j9(t, e, r) {
  Ap(
    "component:emit",
    t.appContext.app,
    t,
    e,
    r
  );
}
function K9(t, e, ...r) {
  if (t.isUnmounted)
    return;
  const n = t.vnode.props || ar;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: d,
      propsOptions: [h]
    } = t;
    if (d)
      if (!(e in d))
        (!h || !(Jl(e) in h)) && Ee(
          `Component emitted event "${e}" but it is neither declared in the emits option nor as an "${Jl(e)}" prop.`
        );
      else {
        const f = d[e];
        dt(f) && (f(...r) || Ee(
          `Invalid event arguments: event validation failed for event "${e}".`
        ));
      }
  }
  let s = r;
  const a = e.startsWith("update:"), o = a && e.slice(7);
  if (o && o in n) {
    const d = `${o === "modelValue" ? "model" : o}Modifiers`, { number: h, trim: f } = n[d] || ar;
    f && (s = r.map((p) => yr(p) ? p.trim() : p)), h && (s = r.map(Oz));
  }
  if (process.env.NODE_ENV !== "production" && j9(t, e, s), process.env.NODE_ENV !== "production") {
    const d = e.toLowerCase();
    d !== e && n[Jl(d)] && Ee(
      `Event "${d}" is emitted in component ${A0(
        t,
        t.type
      )} but the handler is registered for "${e}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${xo(e)}" instead of "${e}".`
    );
  }
  let l, u = n[l = Jl(e)] || // also try camelCase event handler (#2249)
  n[l = Jl(Aa(e))];
  !u && a && (u = n[l = Jl(xo(e))]), u && us(
    u,
    t,
    6,
    s
  );
  const c = n[l + "Once"];
  if (c) {
    if (!t.emitted)
      t.emitted = {};
    else if (t.emitted[l])
      return;
    t.emitted[l] = !0, us(
      c,
      t,
      6,
      s
    );
  }
}
function f3(t, e, r = !1) {
  const n = e.emitsCache, s = n.get(t);
  if (s !== void 0)
    return s;
  const a = t.emits;
  let o = {}, l = !1;
  if (!dt(t)) {
    const u = (c) => {
      const d = f3(c, e, !0);
      d && (l = !0, pr(o, d));
    };
    !r && e.mixins.length && e.mixins.forEach(u), t.extends && u(t.extends), t.mixins && t.mixins.forEach(u);
  }
  return !a && !l ? (jt(t) && n.set(t, null), null) : (ze(a) ? a.forEach((u) => o[u] = null) : pr(o, a), jt(t) && n.set(t, o), o);
}
function x0(t, e) {
  return !t || !Op(e) ? !1 : (e = e.slice(2).replace(/Once$/, ""), Et(t, e[0].toLowerCase() + e.slice(1)) || Et(t, xo(e)) || Et(t, e));
}
let cn = null, S0 = null;
function Jg(t) {
  const e = cn;
  return cn = t, S0 = t && t.type.__scopeId || null, e;
}
function rc(t) {
  S0 = t;
}
function nc() {
  S0 = null;
}
function tt(t, e = cn, r) {
  if (!e || t._n)
    return t;
  const n = (...s) => {
    n._d && JC(-1);
    const a = Jg(e);
    let o;
    try {
      o = t(...s);
    } finally {
      Jg(a), n._d && JC(1);
    }
    return process.env.NODE_ENV !== "production" && d3(e), o;
  };
  return n._n = !0, n._c = !0, n._d = !0, n;
}
let MT = !1;
function ey() {
  MT = !0;
}
function d_(t) {
  const {
    type: e,
    vnode: r,
    proxy: n,
    withProxy: s,
    props: a,
    propsOptions: [o],
    slots: l,
    attrs: u,
    emit: c,
    render: d,
    renderCache: h,
    data: f,
    setupState: p,
    ctx: m,
    inheritAttrs: b
  } = t;
  let y, _;
  const x = Jg(t);
  process.env.NODE_ENV !== "production" && (MT = !1);
  try {
    if (r.shapeFlag & 4) {
      const E = s || n;
      y = Cs(
        d.call(
          E,
          E,
          h,
          a,
          p,
          f,
          m
        )
      ), _ = u;
    } else {
      const E = e;
      process.env.NODE_ENV !== "production" && u === a && ey(), y = Cs(
        E.length > 1 ? E(
          a,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return ey(), u;
            },
            slots: l,
            emit: c
          } : { attrs: u, slots: l, emit: c }
        ) : E(
          a,
          null
          /* we know it doesn't need it */
        )
      ), _ = e.props ? u : q9(u);
    }
  } catch (E) {
    Tf.length = 0, w0(E, t, 1), y = je(Tn);
  }
  let T = y, k;
  if (process.env.NODE_ENV !== "production" && y.patchFlag > 0 && y.patchFlag & 2048 && ([T, k] = z9(y)), _ && b !== !1) {
    const E = Object.keys(_), { shapeFlag: F } = T;
    if (E.length) {
      if (F & 7)
        o && E.some(Wg) && (_ = X9(
          _,
          o
        )), T = Pa(T, _);
      else if (process.env.NODE_ENV !== "production" && !MT && T.type !== Tn) {
        const R = Object.keys(u), $ = [], O = [];
        for (let P = 0, N = R.length; P < N; P++) {
          const I = R[P];
          Op(I) ? Wg(I) || $.push(I[2].toLowerCase() + I.slice(3)) : O.push(I);
        }
        O.length && Ee(
          `Extraneous non-props attributes (${O.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes.`
        ), $.length && Ee(
          `Extraneous non-emits event listeners (${$.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return r.dirs && (process.env.NODE_ENV !== "production" && !FC(T) && Ee(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), T = Pa(T), T.dirs = T.dirs ? T.dirs.concat(r.dirs) : r.dirs), r.transition && (process.env.NODE_ENV !== "production" && !FC(T) && Ee(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), T.transition = r.transition), process.env.NODE_ENV !== "production" && k ? k(T) : y = T, Jg(x), y;
}
const z9 = (t) => {
  const e = t.children, r = t.dynamicChildren, n = p3(e);
  if (!n)
    return [t, void 0];
  const s = e.indexOf(n), a = r ? r.indexOf(n) : -1, o = (l) => {
    e[s] = l, r && (a > -1 ? r[a] = l : l.patchFlag > 0 && (t.dynamicChildren = [...r, l]));
  };
  return [Cs(n), o];
};
function p3(t) {
  let e;
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    if (Ad(n)) {
      if (n.type !== Tn || n.children === "v-if") {
        if (e)
          return;
        e = n;
      }
    } else
      return;
  }
  return e;
}
const q9 = (t) => {
  let e;
  for (const r in t)
    (r === "class" || r === "style" || Op(r)) && ((e || (e = {}))[r] = t[r]);
  return e;
}, X9 = (t, e) => {
  const r = {};
  for (const n in t)
    (!Wg(n) || !(n.slice(9) in e)) && (r[n] = t[n]);
  return r;
}, FC = (t) => t.shapeFlag & 7 || t.type === Tn;
function Q9(t, e, r) {
  const { props: n, children: s, component: a } = t, { props: o, children: l, patchFlag: u } = e, c = a.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (s || l) && vl || e.dirs || e.transition)
    return !0;
  if (r && u >= 0) {
    if (u & 1024)
      return !0;
    if (u & 16)
      return n ? BC(n, o, c) : !!o;
    if (u & 8) {
      const d = e.dynamicProps;
      for (let h = 0; h < d.length; h++) {
        const f = d[h];
        if (o[f] !== n[f] && !x0(c, f))
          return !0;
      }
    }
  } else
    return (s || l) && (!l || !l.$stable) ? !0 : n === o ? !1 : n ? o ? BC(n, o, c) : !0 : !!o;
  return !1;
}
function BC(t, e, r) {
  const n = Object.keys(e);
  if (n.length !== Object.keys(t).length)
    return !0;
  for (let s = 0; s < n.length; s++) {
    const a = n[s];
    if (e[a] !== t[a] && !x0(r, a))
      return !0;
  }
  return !1;
}
function Z9({ vnode: t, parent: e }, r) {
  for (; e && e.subTree === t; )
    (t = e.vnode).el = r, e = e.parent;
}
const J9 = (t) => t.__isSuspense;
function eq(t, e) {
  e && e.pendingBranch ? ze(t) ? e.effects.push(...t) : e.effects.push(t) : a3(t);
}
function UC(t, e) {
  return E0(t, null, e);
}
function tq(t, e) {
  return E0(
    t,
    null,
    process.env.NODE_ENV !== "production" ? pr({}, e, { flush: "post" }) : { flush: "post" }
  );
}
const pm = {};
function Lr(t, e, r) {
  return process.env.NODE_ENV !== "production" && !dt(e) && Ee(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), E0(t, e, r);
}
function E0(t, e, { immediate: r, deep: n, flush: s, onTrack: a, onTrigger: o } = ar) {
  var l;
  process.env.NODE_ENV !== "production" && !e && (r !== void 0 && Ee(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), n !== void 0 && Ee(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const u = (E) => {
    Ee(
      "Invalid watch source: ",
      E,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, c = wk() === ((l = on) == null ? void 0 : l.scope) ? on : null;
  let d, h = !1, f = !1;
  if (Or(t) ? (d = () => t.value, h = Xg(t)) : mu(t) ? (d = () => t, n = !0) : ze(t) ? (f = !0, h = t.some((E) => mu(E) || Xg(E)), d = () => t.map((E) => {
    if (Or(E))
      return E.value;
    if (mu(E))
      return uu(E);
    if (dt(E))
      return co(E, c, 2);
    process.env.NODE_ENV !== "production" && u(E);
  })) : dt(t) ? e ? d = () => co(t, c, 2) : d = () => {
    if (!(c && c.isUnmounted))
      return p && p(), us(
        t,
        c,
        3,
        [m]
      );
  } : (d = Pn, process.env.NODE_ENV !== "production" && u(t)), e && n) {
    const E = d;
    d = () => uu(E());
  }
  let p, m = (E) => {
    p = T.onStop = () => {
      co(E, c, 4);
    };
  }, b;
  if (Kf)
    if (m = Pn, e ? r && us(e, c, 3, [
      d(),
      f ? [] : void 0,
      m
    ]) : d(), s === "sync") {
      const E = sX();
      b = E.__watcherHandles || (E.__watcherHandles = []);
    } else
      return Pn;
  let y = f ? new Array(t.length).fill(pm) : pm;
  const _ = () => {
    if (T.active)
      if (e) {
        const E = T.run();
        (n || h || (f ? E.some(
          (F, R) => Vf(F, y[R])
        ) : Vf(E, y))) && (p && p(), us(e, c, 3, [
          E,
          // pass undefined as the old value when it's changed for the first time
          y === pm ? void 0 : f && y[0] === pm ? [] : y,
          m
        ]), y = E);
      } else
        T.run();
  };
  _.allowRecurse = !!e;
  let x;
  s === "sync" ? x = _ : s === "post" ? x = () => gi(_, c && c.suspense) : (_.pre = !0, c && (_.id = c.uid), x = () => T0(_));
  const T = new Tk(d, x);
  process.env.NODE_ENV !== "production" && (T.onTrack = a, T.onTrigger = o), e ? r ? _() : y = T.run() : s === "post" ? gi(
    T.run.bind(T),
    c && c.suspense
  ) : T.run();
  const k = () => {
    T.stop(), c && c.scope && mk(c.scope.effects, T);
  };
  return b && b.push(k), k;
}
function rq(t, e, r) {
  const n = this.proxy, s = yr(t) ? t.includes(".") ? v3(n, t) : () => n[t] : t.bind(n, n);
  let a;
  dt(e) ? a = e : (a = e.handler, r = e);
  const o = on;
  Cd(this);
  const l = E0(s, a.bind(n), r);
  return o ? Cd(o) : bu(), l;
}
function v3(t, e) {
  const r = e.split(".");
  return () => {
    let n = t;
    for (let s = 0; s < r.length && n; s++)
      n = n[r[s]];
    return n;
  };
}
function uu(t, e) {
  if (!jt(t) || t.__v_skip || (e = e || /* @__PURE__ */ new Set(), e.has(t)))
    return t;
  if (e.add(t), Or(t))
    uu(t.value, e);
  else if (ze(t))
    for (let r = 0; r < t.length; r++)
      uu(t[r], e);
  else if (PB(t) || pu(t))
    t.forEach((r) => {
      uu(r, e);
    });
  else if (MB(t))
    for (const r in t)
      uu(t[r], e);
  return t;
}
function m3(t) {
  $z(t) && Ee("Do not use built-in directive ids as custom directive id: " + t);
}
function gd(t, e) {
  const r = cn;
  if (r === null)
    return process.env.NODE_ENV !== "production" && Ee("withDirectives can only be used inside render functions."), t;
  const n = O0(r) || r.proxy, s = t.dirs || (t.dirs = []);
  for (let a = 0; a < e.length; a++) {
    let [o, l, u, c = ar] = e[a];
    o && (dt(o) && (o = {
      mounted: o,
      updated: o
    }), o.deep && uu(l), s.push({
      dir: o,
      instance: n,
      value: l,
      oldValue: void 0,
      arg: u,
      modifiers: c
    }));
  }
  return t;
}
function Gl(t, e, r, n) {
  const s = t.dirs, a = e && e.dirs;
  for (let o = 0; o < s.length; o++) {
    const l = s[o];
    a && (l.oldValue = a[o].value);
    let u = l.dir[n];
    u && (ec(), us(u, r, 8, [
      t.el,
      l,
      t,
      e
    ]), tc());
  }
}
function nq() {
  const t = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return Nr(() => {
    t.isMounted = !0;
  }), nh(() => {
    t.isUnmounting = !0;
  }), t;
}
const ts = [Function, Array], g3 = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: ts,
  onEnter: ts,
  onAfterEnter: ts,
  onEnterCancelled: ts,
  // leave
  onBeforeLeave: ts,
  onLeave: ts,
  onAfterLeave: ts,
  onLeaveCancelled: ts,
  // appear
  onBeforeAppear: ts,
  onAppear: ts,
  onAfterAppear: ts,
  onAppearCancelled: ts
}, iq = {
  name: "BaseTransition",
  props: g3,
  setup(t, { slots: e }) {
    const r = D0(), n = nq();
    let s;
    return () => {
      const a = e.default && b3(e.default(), !0);
      if (!a || !a.length)
        return;
      let o = a[0];
      if (a.length > 1) {
        let b = !1;
        for (const y of a)
          if (y.type !== Tn) {
            if (process.env.NODE_ENV !== "production" && b) {
              Ee(
                "<transition> can only be used on a single element or component. Use <transition-group> for lists."
              );
              break;
            }
            if (o = y, b = !0, process.env.NODE_ENV === "production")
              break;
          }
      }
      const l = gt(t), { mode: u } = l;
      if (process.env.NODE_ENV !== "production" && u && u !== "in-out" && u !== "out-in" && u !== "default" && Ee(`invalid <transition> mode: ${u}`), n.isLeaving)
        return h_(o);
      const c = VC(o);
      if (!c)
        return h_(o);
      const d = LT(
        c,
        l,
        n,
        r
      );
      NT(c, d);
      const h = r.subTree, f = h && VC(h);
      let p = !1;
      const { getTransitionKey: m } = c.type;
      if (m) {
        const b = m();
        s === void 0 ? s = b : b !== s && (s = b, p = !0);
      }
      if (f && f.type !== Tn && (!su(c, f) || p)) {
        const b = LT(
          f,
          l,
          n,
          r
        );
        if (NT(f, b), u === "out-in")
          return n.isLeaving = !0, b.afterLeave = () => {
            n.isLeaving = !1, r.update.active !== !1 && r.update();
          }, h_(o);
        u === "in-out" && c.type !== Tn && (b.delayLeave = (y, _, x) => {
          const T = y3(
            n,
            f
          );
          T[String(f.key)] = f, y._leaveCb = () => {
            _(), y._leaveCb = void 0, delete d.delayedLeave;
          }, d.delayedLeave = x;
        });
      }
      return o;
    };
  }
}, sq = iq;
function y3(t, e) {
  const { leavingVNodes: r } = t;
  let n = r.get(e.type);
  return n || (n = /* @__PURE__ */ Object.create(null), r.set(e.type, n)), n;
}
function LT(t, e, r, n) {
  const {
    appear: s,
    mode: a,
    persisted: o = !1,
    onBeforeEnter: l,
    onEnter: u,
    onAfterEnter: c,
    onEnterCancelled: d,
    onBeforeLeave: h,
    onLeave: f,
    onAfterLeave: p,
    onLeaveCancelled: m,
    onBeforeAppear: b,
    onAppear: y,
    onAfterAppear: _,
    onAppearCancelled: x
  } = e, T = String(t.key), k = y3(r, t), E = ($, O) => {
    $ && us(
      $,
      n,
      9,
      O
    );
  }, F = ($, O) => {
    const P = O[1];
    E($, O), ze($) ? $.every((N) => N.length <= 1) && P() : $.length <= 1 && P();
  }, R = {
    mode: a,
    persisted: o,
    beforeEnter($) {
      let O = l;
      if (!r.isMounted)
        if (s)
          O = b || l;
        else
          return;
      $._leaveCb && $._leaveCb(
        !0
        /* cancelled */
      );
      const P = k[T];
      P && su(t, P) && P.el._leaveCb && P.el._leaveCb(), E(O, [$]);
    },
    enter($) {
      let O = u, P = c, N = d;
      if (!r.isMounted)
        if (s)
          O = y || u, P = _ || c, N = x || d;
        else
          return;
      let I = !1;
      const B = $._enterCb = (W) => {
        I || (I = !0, W ? E(N, [$]) : E(P, [$]), R.delayedLeave && R.delayedLeave(), $._enterCb = void 0);
      };
      O ? F(O, [$, B]) : B();
    },
    leave($, O) {
      const P = String(t.key);
      if ($._enterCb && $._enterCb(
        !0
        /* cancelled */
      ), r.isUnmounting)
        return O();
      E(h, [$]);
      let N = !1;
      const I = $._leaveCb = (B) => {
        N || (N = !0, O(), B ? E(m, [$]) : E(p, [$]), $._leaveCb = void 0, k[P] === t && delete k[P]);
      };
      k[P] = t, f ? F(f, [$, I]) : I();
    },
    clone($) {
      return LT($, e, r, n);
    }
  };
  return R;
}
function h_(t) {
  if (Cp(t))
    return t = Pa(t), t.children = null, t;
}
function VC(t) {
  return Cp(t) ? t.children ? t.children[0] : void 0 : t;
}
function NT(t, e) {
  t.shapeFlag & 6 && t.component ? NT(t.component.subTree, e) : t.shapeFlag & 128 ? (t.ssContent.transition = e.clone(t.ssContent), t.ssFallback.transition = e.clone(t.ssFallback)) : t.transition = e;
}
function b3(t, e = !1, r) {
  let n = [], s = 0;
  for (let a = 0; a < t.length; a++) {
    let o = t[a];
    const l = r == null ? o.key : String(r) + String(o.key != null ? o.key : a);
    o.type === Je ? (o.patchFlag & 128 && s++, n = n.concat(
      b3(o.children, e, l)
    )) : (e || o.type !== Tn) && n.push(l != null ? Pa(o, { key: l }) : o);
  }
  if (s > 1)
    for (let a = 0; a < n.length; a++)
      n[a].patchFlag = -2;
  return n;
}
function Dt(t, e) {
  return dt(t) ? (
    // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (() => pr({ name: t.name }, e, { setup: t }))()
  ) : t;
}
const _f = (t) => !!t.type.__asyncLoader, Cp = (t) => t.type.__isKeepAlive;
function aq(t, e) {
  _3(t, "a", e);
}
function oq(t, e) {
  _3(t, "da", e);
}
function _3(t, e, r = on) {
  const n = t.__wdc || (t.__wdc = () => {
    let s = r;
    for (; s; ) {
      if (s.isDeactivated)
        return;
      s = s.parent;
    }
    return t();
  });
  if ($0(e, n, r), r) {
    let s = r.parent;
    for (; s && s.parent; )
      Cp(s.parent.vnode) && lq(n, e, r, s), s = s.parent;
  }
}
function lq(t, e, r, n) {
  const s = $0(
    e,
    t,
    n,
    !0
    /* prepend */
  );
  ih(() => {
    mk(n[e], s);
  }, r);
}
function $0(t, e, r = on, n = !1) {
  if (r) {
    const s = r[t] || (r[t] = []), a = e.__weh || (e.__weh = (...o) => {
      if (r.isUnmounted)
        return;
      ec(), Cd(r);
      const l = us(e, r, t, o);
      return bu(), tc(), l;
    });
    return n ? s.unshift(a) : s.push(a), a;
  } else if (process.env.NODE_ENV !== "production") {
    const s = Jl($k[t].replace(/ hook$/, ""));
    Ee(
      `${s} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const Co = (t) => (e, r = on) => (
  // post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
  (!Kf || t === "sp") && $0(t, (...n) => e(...n), r)
), uq = Co("bm"), Nr = Co("m"), w3 = Co("bu"), cq = Co("u"), nh = Co("bum"), ih = Co("um"), dq = Co("sp"), hq = Co(
  "rtg"
), fq = Co(
  "rtc"
);
function pq(t, e = on) {
  $0("ec", t, e);
}
const ty = "components";
function Hh(t, e) {
  return x3(ty, t, !0, e) || t;
}
const T3 = Symbol.for("v-ndc");
function Ak(t) {
  return yr(t) ? x3(ty, t, !1) || t : t || T3;
}
function x3(t, e, r = !0, n = !1) {
  const s = cn || on;
  if (s) {
    const a = s.type;
    if (t === ty) {
      const l = Lk(
        a,
        !1
        /* do not include inferred name to avoid breaking existing code */
      );
      if (l && (l === e || l === Aa(e) || l === Nu(Aa(e))))
        return a;
    }
    const o = (
      // local registration
      // check instance[type] first which is resolved for options API
      YC(s[t] || a[t], e) || // global registration
      YC(s.appContext[t], e)
    );
    if (!o && n)
      return a;
    if (process.env.NODE_ENV !== "production" && r && !o) {
      const l = t === ty ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : "";
      Ee(`Failed to resolve ${t.slice(0, -1)}: ${e}${l}`);
    }
    return o;
  } else
    process.env.NODE_ENV !== "production" && Ee(
      `resolve${Nu(t.slice(0, -1))} can only be used in render() or setup().`
    );
}
function YC(t, e) {
  return t && (t[e] || t[Aa(e)] || t[Nu(Aa(e))]);
}
function Mr(t, e, r, n) {
  let s;
  const a = r && r[n];
  if (ze(t) || yr(t)) {
    s = new Array(t.length);
    for (let o = 0, l = t.length; o < l; o++)
      s[o] = e(t[o], o, void 0, a && a[o]);
  } else if (typeof t == "number") {
    process.env.NODE_ENV !== "production" && !Number.isInteger(t) && Ee(`The v-for range expect an integer value but got ${t}.`), s = new Array(t);
    for (let o = 0; o < t; o++)
      s[o] = e(o + 1, o, void 0, a && a[o]);
  } else if (jt(t))
    if (t[Symbol.iterator])
      s = Array.from(
        t,
        (o, l) => e(o, l, void 0, a && a[l])
      );
    else {
      const o = Object.keys(t);
      s = new Array(o.length);
      for (let l = 0, u = o.length; l < u; l++) {
        const c = o[l];
        s[l] = e(t[c], c, l, a && a[l]);
      }
    }
  else
    s = [];
  return r && (r[n] = s), s;
}
function Si(t, e) {
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (ze(n))
      for (let s = 0; s < n.length; s++)
        t[n[s].name] = n[s].fn;
    else
      n && (t[n.name] = n.key ? (...s) => {
        const a = n.fn(...s);
        return a && (a.key = n.key), a;
      } : n.fn);
  }
  return t;
}
function We(t, e, r = {}, n, s) {
  if (cn.isCE || cn.parent && _f(cn.parent) && cn.parent.isCE)
    return e !== "default" && (r.name = e), je("slot", r, n && n());
  let a = t[e];
  process.env.NODE_ENV !== "production" && a && a.length > 1 && (Ee(
    "SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template."
  ), a = () => []), a && a._c && (a._d = !1), re();
  const o = a && S3(a(r)), l = ot(
    Je,
    {
      key: r.key || // slot content array of a dynamic conditional slot may have a branch
      // key attached in the `createSlots` helper, respect that
      o && o.key || `_${e}`
    },
    o || (n ? n() : []),
    o && t._ === 1 ? 64 : -2
  );
  return !s && l.scopeId && (l.slotScopeIds = [l.scopeId + "-s"]), a && a._c && (a._d = !0), l;
}
function S3(t) {
  return t.some((e) => Ad(e) ? !(e.type === Tn || e.type === Je && !S3(e.children)) : !0) ? t : null;
}
const FT = (t) => t ? U3(t) ? O0(t) || t.proxy : FT(t.parent) : null, yu = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ pr(/* @__PURE__ */ Object.create(null), {
    $: (t) => t,
    $el: (t) => t.vnode.el,
    $data: (t) => t.data,
    $props: (t) => process.env.NODE_ENV !== "production" ? hf(t.props) : t.props,
    $attrs: (t) => process.env.NODE_ENV !== "production" ? hf(t.attrs) : t.attrs,
    $slots: (t) => process.env.NODE_ENV !== "production" ? hf(t.slots) : t.slots,
    $refs: (t) => process.env.NODE_ENV !== "production" ? hf(t.refs) : t.refs,
    $parent: (t) => FT(t.parent),
    $root: (t) => FT(t.root),
    $emit: (t) => t.emit,
    $options: (t) => Ik(t),
    $forceUpdate: (t) => t.f || (t.f = () => T0(t.update)),
    $nextTick: (t) => t.n || (t.n = Ia.bind(t.proxy)),
    $watch: (t) => rq.bind(t)
  })
), Ck = (t) => t === "_" || t === "$", f_ = (t, e) => t !== ar && !t.__isScriptSetup && Et(t, e), E3 = {
  get({ _: t }, e) {
    const { ctx: r, setupState: n, data: s, props: a, accessCache: o, type: l, appContext: u } = t;
    if (process.env.NODE_ENV !== "production" && e === "__isVue")
      return !0;
    let c;
    if (e[0] !== "$") {
      const p = o[e];
      if (p !== void 0)
        switch (p) {
          case 1:
            return n[e];
          case 2:
            return s[e];
          case 4:
            return r[e];
          case 3:
            return a[e];
        }
      else {
        if (f_(n, e))
          return o[e] = 1, n[e];
        if (s !== ar && Et(s, e))
          return o[e] = 2, s[e];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (c = t.propsOptions[0]) && Et(c, e)
        )
          return o[e] = 3, a[e];
        if (r !== ar && Et(r, e))
          return o[e] = 4, r[e];
        BT && (o[e] = 0);
      }
    }
    const d = yu[e];
    let h, f;
    if (d)
      return e === "$attrs" ? (Ln(t, "get", e), process.env.NODE_ENV !== "production" && ey()) : process.env.NODE_ENV !== "production" && e === "$slots" && Ln(t, "get", e), d(t);
    if (
      // css module (injected by vue-loader)
      (h = l.__cssModules) && (h = h[e])
    )
      return h;
    if (r !== ar && Et(r, e))
      return o[e] = 4, r[e];
    if (
      // global properties
      f = u.config.globalProperties, Et(f, e)
    )
      return f[e];
    process.env.NODE_ENV !== "production" && cn && (!yr(e) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    e.indexOf("__v") !== 0) && (s !== ar && Ck(e[0]) && Et(s, e) ? Ee(
      `Property ${JSON.stringify(
        e
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : t === cn && Ee(
      `Property ${JSON.stringify(e)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: t }, e, r) {
    const { data: n, setupState: s, ctx: a } = t;
    return f_(s, e) ? (s[e] = r, !0) : process.env.NODE_ENV !== "production" && s.__isScriptSetup && Et(s, e) ? (Ee(`Cannot mutate <script setup> binding "${e}" from Options API.`), !1) : n !== ar && Et(n, e) ? (n[e] = r, !0) : Et(t.props, e) ? (process.env.NODE_ENV !== "production" && Ee(`Attempting to mutate prop "${e}". Props are readonly.`), !1) : e[0] === "$" && e.slice(1) in t ? (process.env.NODE_ENV !== "production" && Ee(
      `Attempting to mutate public property "${e}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && e in t.appContext.config.globalProperties ? Object.defineProperty(a, e, {
      enumerable: !0,
      configurable: !0,
      value: r
    }) : a[e] = r, !0);
  },
  has({
    _: { data: t, setupState: e, accessCache: r, ctx: n, appContext: s, propsOptions: a }
  }, o) {
    let l;
    return !!r[o] || t !== ar && Et(t, o) || f_(e, o) || (l = a[0]) && Et(l, o) || Et(n, o) || Et(yu, o) || Et(s.config.globalProperties, o);
  },
  defineProperty(t, e, r) {
    return r.get != null ? t._.accessCache[e] = 0 : Et(r, "value") && this.set(t, e, r.value, null), Reflect.defineProperty(t, e, r);
  }
};
process.env.NODE_ENV !== "production" && (E3.ownKeys = (t) => (Ee(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(t)));
function vq(t) {
  const e = {};
  return Object.defineProperty(e, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => t
  }), Object.keys(yu).forEach((r) => {
    Object.defineProperty(e, r, {
      configurable: !0,
      enumerable: !1,
      get: () => yu[r](t),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: Pn
    });
  }), e;
}
function mq(t) {
  const {
    ctx: e,
    propsOptions: [r]
  } = t;
  r && Object.keys(r).forEach((n) => {
    Object.defineProperty(e, n, {
      enumerable: !0,
      configurable: !0,
      get: () => t.props[n],
      set: Pn
    });
  });
}
function gq(t) {
  const { ctx: e, setupState: r } = t;
  Object.keys(gt(r)).forEach((n) => {
    if (!r.__isScriptSetup) {
      if (Ck(n[0])) {
        Ee(
          `setup() return property ${JSON.stringify(
            n
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(e, n, {
        enumerable: !0,
        configurable: !0,
        get: () => r[n],
        set: Pn
      });
    }
  });
}
function sh() {
  return yq().slots;
}
function yq() {
  const t = D0();
  return process.env.NODE_ENV !== "production" && !t && Ee("useContext() called without active instance."), t.setupContext || (t.setupContext = Y3(t));
}
function HC(t) {
  return ze(t) ? t.reduce(
    (e, r) => (e[r] = null, e),
    {}
  ) : t;
}
function bq() {
  const t = /* @__PURE__ */ Object.create(null);
  return (e, r) => {
    t[r] ? Ee(`${e} property "${r}" is already defined in ${t[r]}.`) : t[r] = e;
  };
}
let BT = !0;
function _q(t) {
  const e = Ik(t), r = t.proxy, n = t.ctx;
  BT = !1, e.beforeCreate && GC(e.beforeCreate, t, "bc");
  const {
    // state
    data: s,
    computed: a,
    methods: o,
    watch: l,
    provide: u,
    inject: c,
    // lifecycle
    created: d,
    beforeMount: h,
    mounted: f,
    beforeUpdate: p,
    updated: m,
    activated: b,
    deactivated: y,
    beforeDestroy: _,
    beforeUnmount: x,
    destroyed: T,
    unmounted: k,
    render: E,
    renderTracked: F,
    renderTriggered: R,
    errorCaptured: $,
    serverPrefetch: O,
    // public API
    expose: P,
    inheritAttrs: N,
    // assets
    components: I,
    directives: B,
    filters: W
  } = e, Q = process.env.NODE_ENV !== "production" ? bq() : null;
  if (process.env.NODE_ENV !== "production") {
    const [H] = t.propsOptions;
    if (H)
      for (const A in H)
        Q("Props", A);
  }
  if (c && wq(c, n, Q), o)
    for (const H in o) {
      const A = o[H];
      dt(A) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(n, H, {
        value: A.bind(r),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : n[H] = A.bind(r), process.env.NODE_ENV !== "production" && Q("Methods", H)) : process.env.NODE_ENV !== "production" && Ee(
        `Method "${H}" has type "${typeof A}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (s) {
    process.env.NODE_ENV !== "production" && !dt(s) && Ee(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const H = s.call(r, r);
    if (process.env.NODE_ENV !== "production" && yk(H) && Ee(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !jt(H))
      process.env.NODE_ENV !== "production" && Ee("data() should return an object.");
    else if (t.data = Na(H), process.env.NODE_ENV !== "production")
      for (const A in H)
        Q("Data", A), Ck(A[0]) || Object.defineProperty(n, A, {
          configurable: !0,
          enumerable: !0,
          get: () => H[A],
          set: Pn
        });
  }
  if (BT = !0, a)
    for (const H in a) {
      const A = a[H], V = dt(A) ? A.bind(r, r) : dt(A.get) ? A.get.bind(r, r) : Pn;
      process.env.NODE_ENV !== "production" && V === Pn && Ee(`Computed property "${H}" has no getter.`);
      const M = !dt(A) && dt(A.set) ? A.set.bind(r) : process.env.NODE_ENV !== "production" ? () => {
        Ee(
          `Write operation failed: computed property "${H}" is readonly.`
        );
      } : Pn, Z = Ce({
        get: V,
        set: M
      });
      Object.defineProperty(n, H, {
        enumerable: !0,
        configurable: !0,
        get: () => Z.value,
        set: (U) => Z.value = U
      }), process.env.NODE_ENV !== "production" && Q("Computed", H);
    }
  if (l)
    for (const H in l)
      $3(l[H], n, r, H);
  if (u) {
    const H = dt(u) ? u.call(r) : u;
    Reflect.ownKeys(H).forEach((A) => {
      vf(A, H[A]);
    });
  }
  d && GC(d, t, "c");
  function te(H, A) {
    ze(A) ? A.forEach((V) => H(V.bind(r))) : A && H(A.bind(r));
  }
  if (te(uq, h), te(Nr, f), te(w3, p), te(cq, m), te(aq, b), te(oq, y), te(pq, $), te(fq, F), te(hq, R), te(nh, x), te(ih, k), te(dq, O), ze(P))
    if (P.length) {
      const H = t.exposed || (t.exposed = {});
      P.forEach((A) => {
        Object.defineProperty(H, A, {
          get: () => r[A],
          set: (V) => r[A] = V
        });
      });
    } else
      t.exposed || (t.exposed = {});
  E && t.render === Pn && (t.render = E), N != null && (t.inheritAttrs = N), I && (t.components = I), B && (t.directives = B);
}
function wq(t, e, r = Pn) {
  ze(t) && (t = UT(t));
  for (const n in t) {
    const s = t[n];
    let a;
    jt(s) ? "default" in s ? a = tr(
      s.from || n,
      s.default,
      !0
      /* treat default function as factory */
    ) : a = tr(s.from || n) : a = tr(s), Or(a) ? Object.defineProperty(e, n, {
      enumerable: !0,
      configurable: !0,
      get: () => a.value,
      set: (o) => a.value = o
    }) : e[n] = a, process.env.NODE_ENV !== "production" && r("Inject", n);
  }
}
function GC(t, e, r) {
  us(
    ze(t) ? t.map((n) => n.bind(e.proxy)) : t.bind(e.proxy),
    e,
    r
  );
}
function $3(t, e, r, n) {
  const s = n.includes(".") ? v3(r, n) : () => r[n];
  if (yr(t)) {
    const a = e[t];
    dt(a) ? Lr(s, a) : process.env.NODE_ENV !== "production" && Ee(`Invalid watch handler specified by key "${t}"`, a);
  } else if (dt(t))
    Lr(s, t.bind(r));
  else if (jt(t))
    if (ze(t))
      t.forEach((a) => $3(a, e, r, n));
    else {
      const a = dt(t.handler) ? t.handler.bind(r) : e[t.handler];
      dt(a) ? Lr(s, a, t) : process.env.NODE_ENV !== "production" && Ee(`Invalid watch handler specified by key "${t.handler}"`, a);
    }
  else
    process.env.NODE_ENV !== "production" && Ee(`Invalid watch option: "${n}"`, t);
}
function Ik(t) {
  const e = t.type, { mixins: r, extends: n } = e, {
    mixins: s,
    optionsCache: a,
    config: { optionMergeStrategies: o }
  } = t.appContext, l = a.get(e);
  let u;
  return l ? u = l : !s.length && !r && !n ? u = e : (u = {}, s.length && s.forEach(
    (c) => ry(u, c, o, !0)
  ), ry(u, e, o)), jt(e) && a.set(e, u), u;
}
function ry(t, e, r, n = !1) {
  const { mixins: s, extends: a } = e;
  a && ry(t, a, r, !0), s && s.forEach(
    (o) => ry(t, o, r, !0)
  );
  for (const o in e)
    if (n && o === "expose")
      process.env.NODE_ENV !== "production" && Ee(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const l = Tq[o] || r && r[o];
      t[o] = l ? l(t[o], e[o]) : e[o];
    }
  return t;
}
const Tq = {
  data: WC,
  props: jC,
  emits: jC,
  // objects
  methods: pf,
  computed: pf,
  // lifecycle
  beforeCreate: Xn,
  created: Xn,
  beforeMount: Xn,
  mounted: Xn,
  beforeUpdate: Xn,
  updated: Xn,
  beforeDestroy: Xn,
  beforeUnmount: Xn,
  destroyed: Xn,
  unmounted: Xn,
  activated: Xn,
  deactivated: Xn,
  errorCaptured: Xn,
  serverPrefetch: Xn,
  // assets
  components: pf,
  directives: pf,
  // watch
  watch: Sq,
  // provide / inject
  provide: WC,
  inject: xq
};
function WC(t, e) {
  return e ? t ? function() {
    return pr(
      dt(t) ? t.call(this, this) : t,
      dt(e) ? e.call(this, this) : e
    );
  } : e : t;
}
function xq(t, e) {
  return pf(UT(t), UT(e));
}
function UT(t) {
  if (ze(t)) {
    const e = {};
    for (let r = 0; r < t.length; r++)
      e[t[r]] = t[r];
    return e;
  }
  return t;
}
function Xn(t, e) {
  return t ? [...new Set([].concat(t, e))] : e;
}
function pf(t, e) {
  return t ? pr(/* @__PURE__ */ Object.create(null), t, e) : e;
}
function jC(t, e) {
  return t ? ze(t) && ze(e) ? [.../* @__PURE__ */ new Set([...t, ...e])] : pr(
    /* @__PURE__ */ Object.create(null),
    HC(t),
    HC(e ?? {})
  ) : e;
}
function Sq(t, e) {
  if (!t)
    return e;
  if (!e)
    return t;
  const r = pr(/* @__PURE__ */ Object.create(null), t);
  for (const n in e)
    r[n] = Xn(t[n], e[n]);
  return r;
}
function k3() {
  return {
    app: null,
    config: {
      isNativeTag: IB,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Eq = 0;
function $q(t, e) {
  return function(n, s = null) {
    dt(n) || (n = pr({}, n)), s != null && !jt(s) && (process.env.NODE_ENV !== "production" && Ee("root props passed to app.mount() must be an object."), s = null);
    const a = k3();
    process.env.NODE_ENV !== "production" && Object.defineProperty(a.config, "unwrapInjectedRef", {
      get() {
        return !0;
      },
      set() {
        Ee(
          "app.config.unwrapInjectedRef has been deprecated. 3.3 now alawys unwraps injected refs in Options API."
        );
      }
    });
    const o = /* @__PURE__ */ new Set();
    let l = !1;
    const u = a.app = {
      _uid: Eq++,
      _component: n,
      _props: s,
      _container: null,
      _context: a,
      _instance: null,
      version: nI,
      get config() {
        return a.config;
      },
      set config(c) {
        process.env.NODE_ENV !== "production" && Ee(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(c, ...d) {
        return o.has(c) ? process.env.NODE_ENV !== "production" && Ee("Plugin has already been applied to target app.") : c && dt(c.install) ? (o.add(c), c.install(u, ...d)) : dt(c) ? (o.add(c), c(u, ...d)) : process.env.NODE_ENV !== "production" && Ee(
          'A plugin must either be a function or an object with an "install" function.'
        ), u;
      },
      mixin(c) {
        return a.mixins.includes(c) ? process.env.NODE_ENV !== "production" && Ee(
          "Mixin has already been applied to target app" + (c.name ? `: ${c.name}` : "")
        ) : a.mixins.push(c), u;
      },
      component(c, d) {
        return process.env.NODE_ENV !== "production" && WT(c, a.config), d ? (process.env.NODE_ENV !== "production" && a.components[c] && Ee(`Component "${c}" has already been registered in target app.`), a.components[c] = d, u) : a.components[c];
      },
      directive(c, d) {
        return process.env.NODE_ENV !== "production" && m3(c), d ? (process.env.NODE_ENV !== "production" && a.directives[c] && Ee(`Directive "${c}" has already been registered in target app.`), a.directives[c] = d, u) : a.directives[c];
      },
      mount(c, d, h) {
        if (l)
          process.env.NODE_ENV !== "production" && Ee(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && c.__vue_app__ && Ee(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const f = je(
            n,
            s
          );
          return f.appContext = a, process.env.NODE_ENV !== "production" && (a.reload = () => {
            t(Pa(f), c, h);
          }), d && e ? e(f, c) : t(f, c, h), l = !0, u._container = c, c.__vue_app__ = u, process.env.NODE_ENV !== "production" && (u._instance = f.component, B9(u, nI)), O0(f.component) || f.component.proxy;
        }
      },
      unmount() {
        l ? (t(null, u._container), process.env.NODE_ENV !== "production" && (u._instance = null, U9(u)), delete u._container.__vue_app__) : process.env.NODE_ENV !== "production" && Ee("Cannot unmount an app that is not mounted.");
      },
      provide(c, d) {
        return process.env.NODE_ENV !== "production" && c in a.provides && Ee(
          `App already provides property with key "${String(c)}". It will be overwritten with the new value.`
        ), a.provides[c] = d, u;
      },
      runWithContext(c) {
        ny = u;
        try {
          return c();
        } finally {
          ny = null;
        }
      }
    };
    return u;
  };
}
let ny = null;
function vf(t, e) {
  if (!on)
    process.env.NODE_ENV !== "production" && Ee("provide() can only be used inside setup().");
  else {
    let r = on.provides;
    const n = on.parent && on.parent.provides;
    n === r && (r = on.provides = Object.create(n)), r[t] = e;
  }
}
function tr(t, e, r = !1) {
  const n = on || cn;
  if (n || ny) {
    const s = n ? n.parent == null ? n.vnode.appContext && n.vnode.appContext.provides : n.parent.provides : ny._context.provides;
    if (s && t in s)
      return s[t];
    if (arguments.length > 1)
      return r && dt(e) ? e.call(n && n.proxy) : e;
    process.env.NODE_ENV !== "production" && Ee(`injection "${String(t)}" not found.`);
  } else
    process.env.NODE_ENV !== "production" && Ee("inject() can only be used inside setup() or functional components.");
}
function kq(t, e, r, n = !1) {
  const s = {}, a = {};
  jg(a, k0, 1), t.propsDefaults = /* @__PURE__ */ Object.create(null), D3(t, e, s, a);
  for (const o in t.propsOptions[0])
    o in s || (s[o] = void 0);
  process.env.NODE_ENV !== "production" && A3(e || {}, s, t), r ? t.props = n ? s : g9(s) : t.type.props ? t.props = s : t.props = a, t.attrs = a;
}
function Dq(t) {
  for (; t; ) {
    if (t.type.__hmrId)
      return !0;
    t = t.parent;
  }
}
function Oq(t, e, r, n) {
  const {
    props: s,
    attrs: a,
    vnode: { patchFlag: o }
  } = t, l = gt(s), [u] = t.propsOptions;
  let c = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(process.env.NODE_ENV !== "production" && Dq(t)) && (n || o > 0) && !(o & 16)
  ) {
    if (o & 8) {
      const d = t.vnode.dynamicProps;
      for (let h = 0; h < d.length; h++) {
        let f = d[h];
        if (x0(t.emitsOptions, f))
          continue;
        const p = e[f];
        if (u)
          if (Et(a, f))
            p !== a[f] && (a[f] = p, c = !0);
          else {
            const m = Aa(f);
            s[m] = VT(
              u,
              l,
              m,
              p,
              t,
              !1
              /* isAbsent */
            );
          }
        else
          p !== a[f] && (a[f] = p, c = !0);
      }
    }
  } else {
    D3(t, e, s, a) && (c = !0);
    let d;
    for (const h in l)
      (!e || // for camelCase
      !Et(e, h) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((d = xo(h)) === h || !Et(e, d))) && (u ? r && // for camelCase
      (r[h] !== void 0 || // for kebab-case
      r[d] !== void 0) && (s[h] = VT(
        u,
        l,
        h,
        void 0,
        t,
        !0
        /* isAbsent */
      )) : delete s[h]);
    if (a !== l)
      for (const h in a)
        (!e || !Et(e, h)) && (delete a[h], c = !0);
  }
  c && Ca(t, "set", "$attrs"), process.env.NODE_ENV !== "production" && A3(e || {}, s, t);
}
function D3(t, e, r, n) {
  const [s, a] = t.propsOptions;
  let o = !1, l;
  if (e)
    for (let u in e) {
      if (bg(u))
        continue;
      const c = e[u];
      let d;
      s && Et(s, d = Aa(u)) ? !a || !a.includes(d) ? r[d] = c : (l || (l = {}))[d] = c : x0(t.emitsOptions, u) || (!(u in n) || c !== n[u]) && (n[u] = c, o = !0);
    }
  if (a) {
    const u = gt(r), c = l || ar;
    for (let d = 0; d < a.length; d++) {
      const h = a[d];
      r[h] = VT(
        s,
        u,
        h,
        c[h],
        t,
        !Et(c, h)
      );
    }
  }
  return o;
}
function VT(t, e, r, n, s, a) {
  const o = t[r];
  if (o != null) {
    const l = Et(o, "default");
    if (l && n === void 0) {
      const u = o.default;
      if (o.type !== Function && !o.skipFactory && dt(u)) {
        const { propsDefaults: c } = s;
        r in c ? n = c[r] : (Cd(s), n = c[r] = u.call(
          null,
          e
        ), bu());
      } else
        n = u;
    }
    o[
      0
      /* shouldCast */
    ] && (a && !l ? n = !1 : o[
      1
      /* shouldCastTrue */
    ] && (n === "" || n === xo(r)) && (n = !0));
  }
  return n;
}
function O3(t, e, r = !1) {
  const n = e.propsCache, s = n.get(t);
  if (s)
    return s;
  const a = t.props, o = {}, l = [];
  let u = !1;
  if (!dt(t)) {
    const d = (h) => {
      u = !0;
      const [f, p] = O3(h, e, !0);
      pr(o, f), p && l.push(...p);
    };
    !r && e.mixins.length && e.mixins.forEach(d), t.extends && d(t.extends), t.mixins && t.mixins.forEach(d);
  }
  if (!a && !u)
    return jt(t) && n.set(t, vd), vd;
  if (ze(a))
    for (let d = 0; d < a.length; d++) {
      process.env.NODE_ENV !== "production" && !yr(a[d]) && Ee("props must be strings when using array syntax.", a[d]);
      const h = Aa(a[d]);
      KC(h) && (o[h] = ar);
    }
  else if (a) {
    process.env.NODE_ENV !== "production" && !jt(a) && Ee("invalid props options", a);
    for (const d in a) {
      const h = Aa(d);
      if (KC(h)) {
        const f = a[d], p = o[h] = ze(f) || dt(f) ? { type: f } : pr({}, f);
        if (p) {
          const m = qC(Boolean, p.type), b = qC(String, p.type);
          p[
            0
            /* shouldCast */
          ] = m > -1, p[
            1
            /* shouldCastTrue */
          ] = b < 0 || m < b, (m > -1 || Et(p, "default")) && l.push(h);
        }
      }
    }
  }
  const c = [o, l];
  return jt(t) && n.set(t, c), c;
}
function KC(t) {
  return t[0] !== "$" ? !0 : (process.env.NODE_ENV !== "production" && Ee(`Invalid prop name: "${t}" is a reserved property.`), !1);
}
function YT(t) {
  const e = t && t.toString().match(/^\s*(function|class) (\w+)/);
  return e ? e[2] : t === null ? "null" : "";
}
function zC(t, e) {
  return YT(t) === YT(e);
}
function qC(t, e) {
  return ze(e) ? e.findIndex((r) => zC(r, t)) : dt(e) && zC(e, t) ? 0 : -1;
}
function A3(t, e, r) {
  const n = gt(e), s = r.propsOptions[0];
  for (const a in s) {
    let o = s[a];
    o != null && Aq(
      a,
      n[a],
      o,
      !Et(t, a) && !Et(t, xo(a))
    );
  }
}
function Aq(t, e, r, n) {
  const { type: s, required: a, validator: o, skipCheck: l } = r;
  if (a && n) {
    Ee('Missing required prop: "' + t + '"');
    return;
  }
  if (!(e == null && !a)) {
    if (s != null && s !== !0 && !l) {
      let u = !1;
      const c = ze(s) ? s : [s], d = [];
      for (let h = 0; h < c.length && !u; h++) {
        const { valid: f, expectedType: p } = Iq(e, c[h]);
        d.push(p || ""), u = f;
      }
      if (!u) {
        Ee(Pq(t, e, d));
        return;
      }
    }
    o && !o(e) && Ee('Invalid prop: custom validator check failed for prop "' + t + '".');
  }
}
const Cq = /* @__PURE__ */ Il(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function Iq(t, e) {
  let r;
  const n = YT(e);
  if (Cq(n)) {
    const s = typeof t;
    r = s === n.toLowerCase(), !r && s === "object" && (r = t instanceof e);
  } else
    n === "Object" ? r = jt(t) : n === "Array" ? r = ze(t) : n === "null" ? r = t === null : r = t instanceof e;
  return {
    valid: r,
    expectedType: n
  };
}
function Pq(t, e, r) {
  let n = `Invalid prop: type check failed for prop "${t}". Expected ${r.map(Nu).join(" | ")}`;
  const s = r[0], a = bk(e), o = XC(e, s), l = XC(e, a);
  return r.length === 1 && QC(s) && !Rq(s, a) && (n += ` with value ${o}`), n += `, got ${a} `, QC(a) && (n += `with value ${l}.`), n;
}
function XC(t, e) {
  return e === "String" ? `"${t}"` : e === "Number" ? `${Number(t)}` : `${t}`;
}
function QC(t) {
  return ["string", "number", "boolean"].some((r) => t.toLowerCase() === r);
}
function Rq(...t) {
  return t.some((e) => e.toLowerCase() === "boolean");
}
const C3 = (t) => t[0] === "_" || t === "$stable", Pk = (t) => ze(t) ? t.map(Cs) : [Cs(t)], Mq = (t, e, r) => {
  if (e._n)
    return e;
  const n = tt((...s) => (process.env.NODE_ENV !== "production" && on && Ee(
    `Slot "${t}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), Pk(e(...s))), r);
  return n._c = !1, n;
}, I3 = (t, e, r) => {
  const n = t._ctx;
  for (const s in t) {
    if (C3(s))
      continue;
    const a = t[s];
    if (dt(a))
      e[s] = Mq(s, a, n);
    else if (a != null) {
      process.env.NODE_ENV !== "production" && Ee(
        `Non-function value encountered for slot "${s}". Prefer function slots for better performance.`
      );
      const o = Pk(a);
      e[s] = () => o;
    }
  }
}, P3 = (t, e) => {
  process.env.NODE_ENV !== "production" && !Cp(t.vnode) && Ee(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const r = Pk(e);
  t.slots.default = () => r;
}, Lq = (t, e) => {
  if (t.vnode.shapeFlag & 32) {
    const r = e._;
    r ? (t.slots = gt(e), jg(e, "_", r)) : I3(
      e,
      t.slots = {}
    );
  } else
    t.slots = {}, e && P3(t, e);
  jg(t.slots, k0, 1);
}, Nq = (t, e, r) => {
  const { vnode: n, slots: s } = t;
  let a = !0, o = ar;
  if (n.shapeFlag & 32) {
    const l = e._;
    l ? process.env.NODE_ENV !== "production" && vl ? (pr(s, e), Ca(t, "set", "$slots")) : r && l === 1 ? a = !1 : (pr(s, e), !r && l === 1 && delete s._) : (a = !e.$stable, I3(e, s)), o = e;
  } else
    e && (P3(t, e), o = { default: 1 });
  if (a)
    for (const l in s)
      !C3(l) && !(l in o) && delete s[l];
};
function HT(t, e, r, n, s = !1) {
  if (ze(t)) {
    t.forEach(
      (f, p) => HT(
        f,
        e && (ze(e) ? e[p] : e),
        r,
        n,
        s
      )
    );
    return;
  }
  if (_f(n) && !s)
    return;
  const a = n.shapeFlag & 4 ? O0(n.component) || n.component.proxy : n.el, o = s ? null : a, { i: l, r: u } = t;
  if (process.env.NODE_ENV !== "production" && !l) {
    Ee(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const c = e && e.r, d = l.refs === ar ? l.refs = {} : l.refs, h = l.setupState;
  if (c != null && c !== u && (yr(c) ? (d[c] = null, Et(h, c) && (h[c] = null)) : Or(c) && (c.value = null)), dt(u))
    co(u, l, 12, [o, d]);
  else {
    const f = yr(u), p = Or(u);
    if (f || p) {
      const m = () => {
        if (t.f) {
          const b = f ? Et(h, u) ? h[u] : d[u] : u.value;
          s ? ze(b) && mk(b, a) : ze(b) ? b.includes(a) || b.push(a) : f ? (d[u] = [a], Et(h, u) && (h[u] = d[u])) : (u.value = [a], t.k && (d[t.k] = u.value));
        } else
          f ? (d[u] = o, Et(h, u) && (h[u] = o)) : p ? (u.value = o, t.k && (d[t.k] = o)) : process.env.NODE_ENV !== "production" && Ee("Invalid template ref type:", u, `(${typeof u})`);
      };
      o ? (m.id = -1, gi(m, r)) : m();
    } else
      process.env.NODE_ENV !== "production" && Ee("Invalid template ref type:", u, `(${typeof u})`);
  }
}
let Gh, ol;
function Za(t, e) {
  t.appContext.config.performance && iy() && ol.mark(`vue-${e}-${t.uid}`), process.env.NODE_ENV !== "production" && G9(t, e, iy() ? ol.now() : Date.now());
}
function Ja(t, e) {
  if (t.appContext.config.performance && iy()) {
    const r = `vue-${e}-${t.uid}`, n = r + ":end";
    ol.mark(n), ol.measure(
      `<${A0(t, t.type)}> ${e}`,
      r,
      n
    ), ol.clearMarks(r), ol.clearMarks(n);
  }
  process.env.NODE_ENV !== "production" && W9(t, e, iy() ? ol.now() : Date.now());
}
function iy() {
  return Gh !== void 0 || (typeof window < "u" && window.performance ? (Gh = !0, ol = window.performance) : Gh = !1), Gh;
}
function Fq() {
  const t = [];
  if (process.env.NODE_ENV !== "production" && t.length) {
    const e = t.length > 1;
    console.warn(
      `Feature flag${e ? "s" : ""} ${t.join(", ")} ${e ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const gi = eq;
function Bq(t) {
  return Uq(t);
}
function Uq(t, e) {
  Fq();
  const r = Kg();
  r.__VUE__ = !0, process.env.NODE_ENV !== "production" && c3(r.__VUE_DEVTOOLS_GLOBAL_HOOK__, r);
  const {
    insert: n,
    remove: s,
    patchProp: a,
    createElement: o,
    createText: l,
    createComment: u,
    setText: c,
    setElementText: d,
    parentNode: h,
    nextSibling: f,
    setScopeId: p = Pn,
    insertStaticContent: m
  } = t, b = (L, K, ie, ce = null, ve = null, De = null, Re = !1, Se = null, xe = process.env.NODE_ENV !== "production" && vl ? !1 : !!K.dynamicChildren) => {
    if (L === K)
      return;
    L && !su(L, K) && (ce = fe(L), pe(L, ve, De, !0), L = null), K.patchFlag === -2 && (xe = !1, K.dynamicChildren = null);
    const { type: me, ref: Ye, shapeFlag: Fe } = K;
    switch (me) {
      case Ip:
        y(L, K, ie, ce);
        break;
      case Tn:
        _(L, K, ie, ce);
        break;
      case bd:
        L == null ? x(K, ie, ce, Re) : process.env.NODE_ENV !== "production" && T(L, K, ie, Re);
        break;
      case Je:
        B(
          L,
          K,
          ie,
          ce,
          ve,
          De,
          Re,
          Se,
          xe
        );
        break;
      default:
        Fe & 1 ? F(
          L,
          K,
          ie,
          ce,
          ve,
          De,
          Re,
          Se,
          xe
        ) : Fe & 6 ? W(
          L,
          K,
          ie,
          ce,
          ve,
          De,
          Re,
          Se,
          xe
        ) : Fe & 64 || Fe & 128 ? me.process(
          L,
          K,
          ie,
          ce,
          ve,
          De,
          Re,
          Se,
          xe,
          ee
        ) : process.env.NODE_ENV !== "production" && Ee("Invalid VNode type:", me, `(${typeof me})`);
    }
    Ye != null && ve && HT(Ye, L && L.ref, De, K || L, !K);
  }, y = (L, K, ie, ce) => {
    if (L == null)
      n(
        K.el = l(K.children),
        ie,
        ce
      );
    else {
      const ve = K.el = L.el;
      K.children !== L.children && c(ve, K.children);
    }
  }, _ = (L, K, ie, ce) => {
    L == null ? n(
      K.el = u(K.children || ""),
      ie,
      ce
    ) : K.el = L.el;
  }, x = (L, K, ie, ce) => {
    [L.el, L.anchor] = m(
      L.children,
      K,
      ie,
      ce,
      L.el,
      L.anchor
    );
  }, T = (L, K, ie, ce) => {
    if (K.children !== L.children) {
      const ve = f(L.anchor);
      E(L), [K.el, K.anchor] = m(
        K.children,
        ie,
        ve,
        ce
      );
    } else
      K.el = L.el, K.anchor = L.anchor;
  }, k = ({ el: L, anchor: K }, ie, ce) => {
    let ve;
    for (; L && L !== K; )
      ve = f(L), n(L, ie, ce), L = ve;
    n(K, ie, ce);
  }, E = ({ el: L, anchor: K }) => {
    let ie;
    for (; L && L !== K; )
      ie = f(L), s(L), L = ie;
    s(K);
  }, F = (L, K, ie, ce, ve, De, Re, Se, xe) => {
    Re = Re || K.type === "svg", L == null ? R(
      K,
      ie,
      ce,
      ve,
      De,
      Re,
      Se,
      xe
    ) : P(
      L,
      K,
      ve,
      De,
      Re,
      Se,
      xe
    );
  }, R = (L, K, ie, ce, ve, De, Re, Se) => {
    let xe, me;
    const { type: Ye, props: Fe, shapeFlag: Me, transition: Ae, dirs: j } = L;
    if (xe = L.el = o(
      L.type,
      De,
      Fe && Fe.is,
      Fe
    ), Me & 8 ? d(xe, L.children) : Me & 16 && O(
      L.children,
      xe,
      null,
      ce,
      ve,
      De && Ye !== "foreignObject",
      Re,
      Se
    ), j && Gl(L, null, ce, "created"), $(xe, L, L.scopeId, Re, ce), Fe) {
      for (const ge in Fe)
        ge !== "value" && !bg(ge) && a(
          xe,
          ge,
          null,
          Fe[ge],
          De,
          L.children,
          ce,
          ve,
          he
        );
      "value" in Fe && a(xe, "value", null, Fe.value), (me = Fe.onVnodeBeforeMount) && aa(me, ce, L);
    }
    process.env.NODE_ENV !== "production" && (Object.defineProperty(xe, "__vnode", {
      value: L,
      enumerable: !1
    }), Object.defineProperty(xe, "__vueParentComponent", {
      value: ce,
      enumerable: !1
    })), j && Gl(L, null, ce, "beforeMount");
    const ne = (!ve || ve && !ve.pendingBranch) && Ae && !Ae.persisted;
    ne && Ae.beforeEnter(xe), n(xe, K, ie), ((me = Fe && Fe.onVnodeMounted) || ne || j) && gi(() => {
      me && aa(me, ce, L), ne && Ae.enter(xe), j && Gl(L, null, ce, "mounted");
    }, ve);
  }, $ = (L, K, ie, ce, ve) => {
    if (ie && p(L, ie), ce)
      for (let De = 0; De < ce.length; De++)
        p(L, ce[De]);
    if (ve) {
      let De = ve.subTree;
      if (process.env.NODE_ENV !== "production" && De.patchFlag > 0 && De.patchFlag & 2048 && (De = p3(De.children) || De), K === De) {
        const Re = ve.vnode;
        $(
          L,
          Re,
          Re.scopeId,
          Re.slotScopeIds,
          ve.parent
        );
      }
    }
  }, O = (L, K, ie, ce, ve, De, Re, Se, xe = 0) => {
    for (let me = xe; me < L.length; me++) {
      const Ye = L[me] = Se ? nl(L[me]) : Cs(L[me]);
      b(
        null,
        Ye,
        K,
        ie,
        ce,
        ve,
        De,
        Re,
        Se
      );
    }
  }, P = (L, K, ie, ce, ve, De, Re) => {
    const Se = K.el = L.el;
    let { patchFlag: xe, dynamicChildren: me, dirs: Ye } = K;
    xe |= L.patchFlag & 16;
    const Fe = L.props || ar, Me = K.props || ar;
    let Ae;
    ie && Wl(ie, !1), (Ae = Me.onVnodeBeforeUpdate) && aa(Ae, ie, K, L), Ye && Gl(K, L, ie, "beforeUpdate"), ie && Wl(ie, !0), process.env.NODE_ENV !== "production" && vl && (xe = 0, Re = !1, me = null);
    const j = ve && K.type !== "foreignObject";
    if (me ? (N(
      L.dynamicChildren,
      me,
      Se,
      ie,
      ce,
      j,
      De
    ), process.env.NODE_ENV !== "production" && wf(L, K)) : Re || V(
      L,
      K,
      Se,
      null,
      ie,
      ce,
      j,
      De,
      !1
    ), xe > 0) {
      if (xe & 16)
        I(
          Se,
          K,
          Fe,
          Me,
          ie,
          ce,
          ve
        );
      else if (xe & 2 && Fe.class !== Me.class && a(Se, "class", null, Me.class, ve), xe & 4 && a(Se, "style", Fe.style, Me.style, ve), xe & 8) {
        const ne = K.dynamicProps;
        for (let ge = 0; ge < ne.length; ge++) {
          const Ge = ne[ge], xt = Fe[Ge], vn = Me[Ge];
          (vn !== xt || Ge === "value") && a(
            Se,
            Ge,
            xt,
            vn,
            ve,
            L.children,
            ie,
            ce,
            he
          );
        }
      }
      xe & 1 && L.children !== K.children && d(Se, K.children);
    } else
      !Re && me == null && I(
        Se,
        K,
        Fe,
        Me,
        ie,
        ce,
        ve
      );
    ((Ae = Me.onVnodeUpdated) || Ye) && gi(() => {
      Ae && aa(Ae, ie, K, L), Ye && Gl(K, L, ie, "updated");
    }, ce);
  }, N = (L, K, ie, ce, ve, De, Re) => {
    for (let Se = 0; Se < K.length; Se++) {
      const xe = L[Se], me = K[Se], Ye = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        xe.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (xe.type === Je || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !su(xe, me) || // - In the case of a component, it could contain anything.
        xe.shapeFlag & 70) ? h(xe.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          ie
        )
      );
      b(
        xe,
        me,
        Ye,
        null,
        ce,
        ve,
        De,
        Re,
        !0
      );
    }
  }, I = (L, K, ie, ce, ve, De, Re) => {
    if (ie !== ce) {
      if (ie !== ar)
        for (const Se in ie)
          !bg(Se) && !(Se in ce) && a(
            L,
            Se,
            ie[Se],
            null,
            Re,
            K.children,
            ve,
            De,
            he
          );
      for (const Se in ce) {
        if (bg(Se))
          continue;
        const xe = ce[Se], me = ie[Se];
        xe !== me && Se !== "value" && a(
          L,
          Se,
          me,
          xe,
          Re,
          K.children,
          ve,
          De,
          he
        );
      }
      "value" in ce && a(L, "value", ie.value, ce.value);
    }
  }, B = (L, K, ie, ce, ve, De, Re, Se, xe) => {
    const me = K.el = L ? L.el : l(""), Ye = K.anchor = L ? L.anchor : l("");
    let { patchFlag: Fe, dynamicChildren: Me, slotScopeIds: Ae } = K;
    process.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    (vl || Fe & 2048) && (Fe = 0, xe = !1, Me = null), Ae && (Se = Se ? Se.concat(Ae) : Ae), L == null ? (n(me, ie, ce), n(Ye, ie, ce), O(
      K.children,
      ie,
      Ye,
      ve,
      De,
      Re,
      Se,
      xe
    )) : Fe > 0 && Fe & 64 && Me && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    L.dynamicChildren ? (N(
      L.dynamicChildren,
      Me,
      ie,
      ve,
      De,
      Re,
      Se
    ), process.env.NODE_ENV !== "production" ? wf(L, K) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (K.key != null || ve && K === ve.subTree) && wf(
        L,
        K,
        !0
        /* shallow */
      )
    )) : V(
      L,
      K,
      ie,
      Ye,
      ve,
      De,
      Re,
      Se,
      xe
    );
  }, W = (L, K, ie, ce, ve, De, Re, Se, xe) => {
    K.slotScopeIds = Se, L == null ? K.shapeFlag & 512 ? ve.ctx.activate(
      K,
      ie,
      ce,
      Re,
      xe
    ) : Q(
      K,
      ie,
      ce,
      ve,
      De,
      Re,
      xe
    ) : te(L, K, xe);
  }, Q = (L, K, ie, ce, ve, De, Re) => {
    const Se = L.component = Xq(
      L,
      ce,
      ve
    );
    if (process.env.NODE_ENV !== "production" && Se.type.__hmrId && M9(Se), process.env.NODE_ENV !== "production" && (_g(L), Za(Se, "mount")), Cp(L) && (Se.ctx.renderer = ee), process.env.NODE_ENV !== "production" && Za(Se, "init"), Zq(Se), process.env.NODE_ENV !== "production" && Ja(Se, "init"), Se.asyncDep) {
      if (ve && ve.registerDep(Se, H), !L.el) {
        const xe = Se.subTree = je(Tn);
        _(null, xe, K, ie);
      }
      return;
    }
    H(
      Se,
      L,
      K,
      ie,
      ve,
      De,
      Re
    ), process.env.NODE_ENV !== "production" && (wg(), Ja(Se, "mount"));
  }, te = (L, K, ie) => {
    const ce = K.component = L.component;
    if (Q9(L, K, ie))
      if (ce.asyncDep && !ce.asyncResolved) {
        process.env.NODE_ENV !== "production" && _g(K), A(ce, K, ie), process.env.NODE_ENV !== "production" && wg();
        return;
      } else
        ce.next = K, P9(ce.update), ce.update();
    else
      K.el = L.el, ce.vnode = K;
  }, H = (L, K, ie, ce, ve, De, Re) => {
    const Se = () => {
      if (L.isMounted) {
        let { next: Ye, bu: Fe, u: Me, parent: Ae, vnode: j } = L, ne = Ye, ge;
        process.env.NODE_ENV !== "production" && _g(Ye || L.vnode), Wl(L, !1), Ye ? (Ye.el = j.el, A(L, Ye, Re)) : Ye = j, Fe && Yh(Fe), (ge = Ye.props && Ye.props.onVnodeBeforeUpdate) && aa(ge, Ae, Ye, j), Wl(L, !0), process.env.NODE_ENV !== "production" && Za(L, "render");
        const Ge = d_(L);
        process.env.NODE_ENV !== "production" && Ja(L, "render");
        const xt = L.subTree;
        L.subTree = Ge, process.env.NODE_ENV !== "production" && Za(L, "patch"), b(
          xt,
          Ge,
          // parent may have changed if it's in a teleport
          h(xt.el),
          // anchor may have changed if it's in a fragment
          fe(xt),
          L,
          ve,
          De
        ), process.env.NODE_ENV !== "production" && Ja(L, "patch"), Ye.el = Ge.el, ne === null && Z9(L, Ge.el), Me && gi(Me, ve), (ge = Ye.props && Ye.props.onVnodeUpdated) && gi(
          () => aa(ge, Ae, Ye, j),
          ve
        ), process.env.NODE_ENV !== "production" && d3(L), process.env.NODE_ENV !== "production" && wg();
      } else {
        let Ye;
        const { el: Fe, props: Me } = K, { bm: Ae, m: j, parent: ne } = L, ge = _f(K);
        if (Wl(L, !1), Ae && Yh(Ae), !ge && (Ye = Me && Me.onVnodeBeforeMount) && aa(Ye, ne, K), Wl(L, !0), Fe && ut) {
          const Ge = () => {
            process.env.NODE_ENV !== "production" && Za(L, "render"), L.subTree = d_(L), process.env.NODE_ENV !== "production" && Ja(L, "render"), process.env.NODE_ENV !== "production" && Za(L, "hydrate"), ut(
              Fe,
              L.subTree,
              L,
              ve,
              null
            ), process.env.NODE_ENV !== "production" && Ja(L, "hydrate");
          };
          ge ? K.type.__asyncLoader().then(
            // note: we are moving the render call into an async callback,
            // which means it won't track dependencies - but it's ok because
            // a server-rendered async wrapper is already in resolved state
            // and it will never need to change.
            () => !L.isUnmounted && Ge()
          ) : Ge();
        } else {
          process.env.NODE_ENV !== "production" && Za(L, "render");
          const Ge = L.subTree = d_(L);
          process.env.NODE_ENV !== "production" && Ja(L, "render"), process.env.NODE_ENV !== "production" && Za(L, "patch"), b(
            null,
            Ge,
            ie,
            ce,
            L,
            ve,
            De
          ), process.env.NODE_ENV !== "production" && Ja(L, "patch"), K.el = Ge.el;
        }
        if (j && gi(j, ve), !ge && (Ye = Me && Me.onVnodeMounted)) {
          const Ge = K;
          gi(
            () => aa(Ye, ne, Ge),
            ve
          );
        }
        (K.shapeFlag & 256 || ne && _f(ne.vnode) && ne.vnode.shapeFlag & 256) && L.a && gi(L.a, ve), L.isMounted = !0, process.env.NODE_ENV !== "production" && V9(L), K = ie = ce = null;
      }
    }, xe = L.effect = new Tk(
      Se,
      () => T0(me),
      L.scope
      // track it in component's effect scope
    ), me = L.update = () => xe.run();
    me.id = L.uid, Wl(L, !0), process.env.NODE_ENV !== "production" && (xe.onTrack = L.rtc ? (Ye) => Yh(L.rtc, Ye) : void 0, xe.onTrigger = L.rtg ? (Ye) => Yh(L.rtg, Ye) : void 0, me.ownerInstance = L), me();
  }, A = (L, K, ie) => {
    K.component = L;
    const ce = L.vnode.props;
    L.vnode = K, L.next = null, Oq(L, K.props, ce, ie), Nq(L, K.children, ie), ec(), LC(), tc();
  }, V = (L, K, ie, ce, ve, De, Re, Se, xe = !1) => {
    const me = L && L.children, Ye = L ? L.shapeFlag : 0, Fe = K.children, { patchFlag: Me, shapeFlag: Ae } = K;
    if (Me > 0) {
      if (Me & 128) {
        Z(
          me,
          Fe,
          ie,
          ce,
          ve,
          De,
          Re,
          Se,
          xe
        );
        return;
      } else if (Me & 256) {
        M(
          me,
          Fe,
          ie,
          ce,
          ve,
          De,
          Re,
          Se,
          xe
        );
        return;
      }
    }
    Ae & 8 ? (Ye & 16 && he(me, ve, De), Fe !== me && d(ie, Fe)) : Ye & 16 ? Ae & 16 ? Z(
      me,
      Fe,
      ie,
      ce,
      ve,
      De,
      Re,
      Se,
      xe
    ) : he(me, ve, De, !0) : (Ye & 8 && d(ie, ""), Ae & 16 && O(
      Fe,
      ie,
      ce,
      ve,
      De,
      Re,
      Se,
      xe
    ));
  }, M = (L, K, ie, ce, ve, De, Re, Se, xe) => {
    L = L || vd, K = K || vd;
    const me = L.length, Ye = K.length, Fe = Math.min(me, Ye);
    let Me;
    for (Me = 0; Me < Fe; Me++) {
      const Ae = K[Me] = xe ? nl(K[Me]) : Cs(K[Me]);
      b(
        L[Me],
        Ae,
        ie,
        null,
        ve,
        De,
        Re,
        Se,
        xe
      );
    }
    me > Ye ? he(
      L,
      ve,
      De,
      !0,
      !1,
      Fe
    ) : O(
      K,
      ie,
      ce,
      ve,
      De,
      Re,
      Se,
      xe,
      Fe
    );
  }, Z = (L, K, ie, ce, ve, De, Re, Se, xe) => {
    let me = 0;
    const Ye = K.length;
    let Fe = L.length - 1, Me = Ye - 1;
    for (; me <= Fe && me <= Me; ) {
      const Ae = L[me], j = K[me] = xe ? nl(K[me]) : Cs(K[me]);
      if (su(Ae, j))
        b(
          Ae,
          j,
          ie,
          null,
          ve,
          De,
          Re,
          Se,
          xe
        );
      else
        break;
      me++;
    }
    for (; me <= Fe && me <= Me; ) {
      const Ae = L[Fe], j = K[Me] = xe ? nl(K[Me]) : Cs(K[Me]);
      if (su(Ae, j))
        b(
          Ae,
          j,
          ie,
          null,
          ve,
          De,
          Re,
          Se,
          xe
        );
      else
        break;
      Fe--, Me--;
    }
    if (me > Fe) {
      if (me <= Me) {
        const Ae = Me + 1, j = Ae < Ye ? K[Ae].el : ce;
        for (; me <= Me; )
          b(
            null,
            K[me] = xe ? nl(K[me]) : Cs(K[me]),
            ie,
            j,
            ve,
            De,
            Re,
            Se,
            xe
          ), me++;
      }
    } else if (me > Me)
      for (; me <= Fe; )
        pe(L[me], ve, De, !0), me++;
    else {
      const Ae = me, j = me, ne = /* @__PURE__ */ new Map();
      for (me = j; me <= Me; me++) {
        const Ot = K[me] = xe ? nl(K[me]) : Cs(K[me]);
        Ot.key != null && (process.env.NODE_ENV !== "production" && ne.has(Ot.key) && Ee(
          "Duplicate keys found during update:",
          JSON.stringify(Ot.key),
          "Make sure keys are unique."
        ), ne.set(Ot.key, me));
      }
      let ge, Ge = 0;
      const xt = Me - j + 1;
      let vn = !1, Es = 0;
      const Ii = new Array(xt);
      for (me = 0; me < xt; me++)
        Ii[me] = 0;
      for (me = Ae; me <= Fe; me++) {
        const Ot = L[me];
        if (Ge >= xt) {
          pe(Ot, ve, De, !0);
          continue;
        }
        let Ur;
        if (Ot.key != null)
          Ur = ne.get(Ot.key);
        else
          for (ge = j; ge <= Me; ge++)
            if (Ii[ge - j] === 0 && su(Ot, K[ge])) {
              Ur = ge;
              break;
            }
        Ur === void 0 ? pe(Ot, ve, De, !0) : (Ii[Ur - j] = me + 1, Ur >= Es ? Es = Ur : vn = !0, b(
          Ot,
          K[Ur],
          ie,
          null,
          ve,
          De,
          Re,
          Se,
          xe
        ), Ge++);
      }
      const na = vn ? Vq(Ii) : vd;
      for (ge = na.length - 1, me = xt - 1; me >= 0; me--) {
        const Ot = j + me, Ur = K[Ot], ia = Ot + 1 < Ye ? K[Ot + 1].el : ce;
        Ii[me] === 0 ? b(
          null,
          Ur,
          ie,
          ia,
          ve,
          De,
          Re,
          Se,
          xe
        ) : vn && (ge < 0 || me !== na[ge] ? U(Ur, ie, ia, 2) : ge--);
      }
    }
  }, U = (L, K, ie, ce, ve = null) => {
    const { el: De, type: Re, transition: Se, children: xe, shapeFlag: me } = L;
    if (me & 6) {
      U(L.component.subTree, K, ie, ce);
      return;
    }
    if (me & 128) {
      L.suspense.move(K, ie, ce);
      return;
    }
    if (me & 64) {
      Re.move(L, K, ie, ee);
      return;
    }
    if (Re === Je) {
      n(De, K, ie);
      for (let Fe = 0; Fe < xe.length; Fe++)
        U(xe[Fe], K, ie, ce);
      n(L.anchor, K, ie);
      return;
    }
    if (Re === bd) {
      k(L, K, ie);
      return;
    }
    if (ce !== 2 && me & 1 && Se)
      if (ce === 0)
        Se.beforeEnter(De), n(De, K, ie), gi(() => Se.enter(De), ve);
      else {
        const { leave: Fe, delayLeave: Me, afterLeave: Ae } = Se, j = () => n(De, K, ie), ne = () => {
          Fe(De, () => {
            j(), Ae && Ae();
          });
        };
        Me ? Me(De, j, ne) : ne();
      }
    else
      n(De, K, ie);
  }, pe = (L, K, ie, ce = !1, ve = !1) => {
    const {
      type: De,
      props: Re,
      ref: Se,
      children: xe,
      dynamicChildren: me,
      shapeFlag: Ye,
      patchFlag: Fe,
      dirs: Me
    } = L;
    if (Se != null && HT(Se, null, ie, L, !0), Ye & 256) {
      K.ctx.deactivate(L);
      return;
    }
    const Ae = Ye & 1 && Me, j = !_f(L);
    let ne;
    if (j && (ne = Re && Re.onVnodeBeforeUnmount) && aa(ne, K, L), Ye & 6)
      se(L.component, ie, ce);
    else {
      if (Ye & 128) {
        L.suspense.unmount(ie, ce);
        return;
      }
      Ae && Gl(L, null, K, "beforeUnmount"), Ye & 64 ? L.type.remove(
        L,
        K,
        ie,
        ve,
        ee,
        ce
      ) : me && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (De !== Je || Fe > 0 && Fe & 64) ? he(
        me,
        K,
        ie,
        !1,
        !0
      ) : (De === Je && Fe & 384 || !ve && Ye & 16) && he(xe, K, ie), ce && q(L);
    }
    (j && (ne = Re && Re.onVnodeUnmounted) || Ae) && gi(() => {
      ne && aa(ne, K, L), Ae && Gl(L, null, K, "unmounted");
    }, ie);
  }, q = (L) => {
    const { type: K, el: ie, anchor: ce, transition: ve } = L;
    if (K === Je) {
      process.env.NODE_ENV !== "production" && L.patchFlag > 0 && L.patchFlag & 2048 && ve && !ve.persisted ? L.children.forEach((Re) => {
        Re.type === Tn ? s(Re.el) : q(Re);
      }) : Y(ie, ce);
      return;
    }
    if (K === bd) {
      E(L);
      return;
    }
    const De = () => {
      s(ie), ve && !ve.persisted && ve.afterLeave && ve.afterLeave();
    };
    if (L.shapeFlag & 1 && ve && !ve.persisted) {
      const { leave: Re, delayLeave: Se } = ve, xe = () => Re(ie, De);
      Se ? Se(L.el, De, xe) : xe();
    } else
      De();
  }, Y = (L, K) => {
    let ie;
    for (; L !== K; )
      ie = f(L), s(L), L = ie;
    s(K);
  }, se = (L, K, ie) => {
    process.env.NODE_ENV !== "production" && L.type.__hmrId && L9(L);
    const { bum: ce, scope: ve, update: De, subTree: Re, um: Se } = L;
    ce && Yh(ce), ve.stop(), De && (De.active = !1, pe(Re, L, K, ie)), Se && gi(Se, K), gi(() => {
      L.isUnmounted = !0;
    }, K), K && K.pendingBranch && !K.isUnmounted && L.asyncDep && !L.asyncResolved && L.suspenseId === K.pendingId && (K.deps--, K.deps === 0 && K.resolve()), process.env.NODE_ENV !== "production" && H9(L);
  }, he = (L, K, ie, ce = !1, ve = !1, De = 0) => {
    for (let Re = De; Re < L.length; Re++)
      pe(L[Re], K, ie, ce, ve);
  }, fe = (L) => L.shapeFlag & 6 ? fe(L.component.subTree) : L.shapeFlag & 128 ? L.suspense.next() : f(L.anchor || L.el), Te = (L, K, ie) => {
    L == null ? K._vnode && pe(K._vnode, null, null, !0) : b(K._vnode || null, L, K, null, null, null, ie), LC(), o3(), K._vnode = L;
  }, ee = {
    p: b,
    um: pe,
    m: U,
    r: q,
    mt: Q,
    mc: O,
    pc: V,
    pbc: N,
    n: fe,
    o: t
  };
  let Oe, ut;
  return e && ([Oe, ut] = e(
    ee
  )), {
    render: Te,
    hydrate: Oe,
    createApp: $q(Te, Oe)
  };
}
function Wl({ effect: t, update: e }, r) {
  t.allowRecurse = e.allowRecurse = r;
}
function wf(t, e, r = !1) {
  const n = t.children, s = e.children;
  if (ze(n) && ze(s))
    for (let a = 0; a < n.length; a++) {
      const o = n[a];
      let l = s[a];
      l.shapeFlag & 1 && !l.dynamicChildren && ((l.patchFlag <= 0 || l.patchFlag === 32) && (l = s[a] = nl(s[a]), l.el = o.el), r || wf(o, l)), l.type === Ip && (l.el = o.el), process.env.NODE_ENV !== "production" && l.type === Tn && !l.el && (l.el = o.el);
    }
}
function Vq(t) {
  const e = t.slice(), r = [0];
  let n, s, a, o, l;
  const u = t.length;
  for (n = 0; n < u; n++) {
    const c = t[n];
    if (c !== 0) {
      if (s = r[r.length - 1], t[s] < c) {
        e[n] = s, r.push(n);
        continue;
      }
      for (a = 0, o = r.length - 1; a < o; )
        l = a + o >> 1, t[r[l]] < c ? a = l + 1 : o = l;
      c < t[r[a]] && (a > 0 && (e[n] = r[a - 1]), r[a] = n);
    }
  }
  for (a = r.length, o = r[a - 1]; a-- > 0; )
    r[a] = o, o = e[o];
  return r;
}
const Yq = (t) => t.__isTeleport, yd = (t) => t && (t.disabled || t.disabled === ""), ZC = (t) => typeof SVGElement < "u" && t instanceof SVGElement, GT = (t, e) => {
  const r = t && t.to;
  if (yr(r))
    if (e) {
      const n = e(r);
      return n || process.env.NODE_ENV !== "production" && Ee(
        `Failed to locate Teleport target with selector "${r}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`
      ), n;
    } else
      return process.env.NODE_ENV !== "production" && Ee(
        "Current renderer does not support string target for Teleports. (missing querySelector renderer option)"
      ), null;
  else
    return process.env.NODE_ENV !== "production" && !r && !yd(t) && Ee(`Invalid Teleport target: ${r}`), r;
}, Hq = {
  __isTeleport: !0,
  process(t, e, r, n, s, a, o, l, u, c) {
    const {
      mc: d,
      pc: h,
      pbc: f,
      o: { insert: p, querySelector: m, createText: b, createComment: y }
    } = c, _ = yd(e.props);
    let { shapeFlag: x, children: T, dynamicChildren: k } = e;
    if (process.env.NODE_ENV !== "production" && vl && (u = !1, k = null), t == null) {
      const E = e.el = process.env.NODE_ENV !== "production" ? y("teleport start") : b(""), F = e.anchor = process.env.NODE_ENV !== "production" ? y("teleport end") : b("");
      p(E, r, n), p(F, r, n);
      const R = e.target = GT(e.props, m), $ = e.targetAnchor = b("");
      R ? (p($, R), o = o || ZC(R)) : process.env.NODE_ENV !== "production" && !_ && Ee("Invalid Teleport target on mount:", R, `(${typeof R})`);
      const O = (P, N) => {
        x & 16 && d(
          T,
          P,
          N,
          s,
          a,
          o,
          l,
          u
        );
      };
      _ ? O(r, F) : R && O(R, $);
    } else {
      e.el = t.el;
      const E = e.anchor = t.anchor, F = e.target = t.target, R = e.targetAnchor = t.targetAnchor, $ = yd(t.props), O = $ ? r : F, P = $ ? E : R;
      if (o = o || ZC(F), k ? (f(
        t.dynamicChildren,
        k,
        O,
        s,
        a,
        o,
        l
      ), wf(t, e, !0)) : u || h(
        t,
        e,
        O,
        P,
        s,
        a,
        o,
        l,
        !1
      ), _)
        $ || vm(
          e,
          r,
          E,
          c,
          1
        );
      else if ((e.props && e.props.to) !== (t.props && t.props.to)) {
        const N = e.target = GT(
          e.props,
          m
        );
        N ? vm(
          e,
          N,
          null,
          c,
          0
        ) : process.env.NODE_ENV !== "production" && Ee(
          "Invalid Teleport target on update:",
          F,
          `(${typeof F})`
        );
      } else
        $ && vm(
          e,
          F,
          R,
          c,
          1
        );
    }
    M3(e);
  },
  remove(t, e, r, n, { um: s, o: { remove: a } }, o) {
    const { shapeFlag: l, children: u, anchor: c, targetAnchor: d, target: h, props: f } = t;
    if (h && a(d), (o || !yd(f)) && (a(c), l & 16))
      for (let p = 0; p < u.length; p++) {
        const m = u[p];
        s(
          m,
          e,
          r,
          !0,
          !!m.dynamicChildren
        );
      }
  },
  move: vm,
  hydrate: Gq
};
function vm(t, e, r, { o: { insert: n }, m: s }, a = 2) {
  a === 0 && n(t.targetAnchor, e, r);
  const { el: o, anchor: l, shapeFlag: u, children: c, props: d } = t, h = a === 2;
  if (h && n(o, e, r), (!h || yd(d)) && u & 16)
    for (let f = 0; f < c.length; f++)
      s(
        c[f],
        e,
        r,
        2
      );
  h && n(l, e, r);
}
function Gq(t, e, r, n, s, a, {
  o: { nextSibling: o, parentNode: l, querySelector: u }
}, c) {
  const d = e.target = GT(
    e.props,
    u
  );
  if (d) {
    const h = d._lpa || d.firstChild;
    if (e.shapeFlag & 16)
      if (yd(e.props))
        e.anchor = c(
          o(t),
          e,
          l(t),
          r,
          n,
          s,
          a
        ), e.targetAnchor = h;
      else {
        e.anchor = o(t);
        let f = h;
        for (; f; )
          if (f = o(f), f && f.nodeType === 8 && f.data === "teleport anchor") {
            e.targetAnchor = f, d._lpa = e.targetAnchor && o(e.targetAnchor);
            break;
          }
        c(
          h,
          e,
          d,
          r,
          n,
          s,
          a
        );
      }
    M3(e);
  }
  return e.anchor && o(e.anchor);
}
const R3 = Hq;
function M3(t) {
  const e = t.ctx;
  if (e && e.ut) {
    let r = t.children[0].el;
    for (; r !== t.targetAnchor; )
      r.nodeType === 1 && r.setAttribute("data-v-owner", e.uid), r = r.nextSibling;
    e.ut();
  }
}
const Je = Symbol.for("v-fgt"), Ip = Symbol.for("v-txt"), Tn = Symbol.for("v-cmt"), bd = Symbol.for("v-stc"), Tf = [];
let Ns = null;
function re(t = !1) {
  Tf.push(Ns = t ? null : []);
}
function Wq() {
  Tf.pop(), Ns = Tf[Tf.length - 1] || null;
}
let jf = 1;
function JC(t) {
  jf += t;
}
function L3(t) {
  return t.dynamicChildren = jf > 0 ? Ns || vd : null, Wq(), jf > 0 && Ns && Ns.push(t), t;
}
function ye(t, e, r, n, s, a) {
  return L3(
    ke(
      t,
      e,
      r,
      n,
      s,
      a,
      !0
      /* isBlock */
    )
  );
}
function ot(t, e, r, n, s) {
  return L3(
    je(
      t,
      e,
      r,
      n,
      s,
      !0
      /* isBlock: prevent a block from tracking itself */
    )
  );
}
function Ad(t) {
  return t ? t.__v_isVNode === !0 : !1;
}
function su(t, e) {
  return process.env.NODE_ENV !== "production" && e.shapeFlag & 6 && Xc.has(e.type) ? (t.shapeFlag &= -257, e.shapeFlag &= -513, !1) : t.type === e.type && t.key === e.key;
}
const jq = (...t) => F3(
  ...t
), k0 = "__vInternal", N3 = ({ key: t }) => t ?? null, Tg = ({
  ref: t,
  ref_key: e,
  ref_for: r
}) => (typeof t == "number" && (t = "" + t), t != null ? yr(t) || Or(t) || dt(t) ? { i: cn, r: t, k: e, f: !!r } : t : null);
function ke(t, e = null, r = null, n = 0, s = null, a = t === Je ? 0 : 1, o = !1, l = !1) {
  const u = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: t,
    props: e,
    key: e && N3(e),
    ref: e && Tg(e),
    scopeId: S0,
    slotScopeIds: null,
    children: r,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: a,
    patchFlag: n,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: cn
  };
  return l ? (Rk(u, r), a & 128 && t.normalize(u)) : r && (u.shapeFlag |= yr(r) ? 8 : 16), process.env.NODE_ENV !== "production" && u.key !== u.key && Ee("VNode created with invalid key (NaN). VNode type:", u.type), jf > 0 && // avoid a block node from tracking itself
  !o && // has current parent block
  Ns && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (u.patchFlag > 0 || a & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  u.patchFlag !== 32 && Ns.push(u), u;
}
const je = process.env.NODE_ENV !== "production" ? jq : F3;
function F3(t, e = null, r = null, n = 0, s = null, a = !1) {
  if ((!t || t === T3) && (process.env.NODE_ENV !== "production" && !t && Ee(`Invalid vnode type when creating vnode: ${t}.`), t = Tn), Ad(t)) {
    const l = Pa(
      t,
      e,
      !0
      /* mergeRef: true */
    );
    return r && Rk(l, r), jf > 0 && !a && Ns && (l.shapeFlag & 6 ? Ns[Ns.indexOf(t)] = l : Ns.push(l)), l.patchFlag |= -2, l;
  }
  if (H3(t) && (t = t.__vccOpts), e) {
    e = Hi(e);
    let { class: l, style: u } = e;
    l && !yr(l) && (e.class = wt(l)), jt(u) && (Qg(u) && !ze(u) && (u = pr({}, u)), e.style = ri(u));
  }
  const o = yr(t) ? 1 : J9(t) ? 128 : Yq(t) ? 64 : jt(t) ? 4 : dt(t) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && o & 4 && Qg(t) && (t = gt(t), Ee(
    "Vue received a Component which was made a reactive object. This can lead to unnecessary performance overhead, and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    t
  )), ke(
    t,
    e,
    r,
    n,
    s,
    o,
    a,
    !0
  );
}
function Hi(t) {
  return t ? Qg(t) || k0 in t ? pr({}, t) : t : null;
}
function Pa(t, e, r = !1) {
  const { props: n, ref: s, patchFlag: a, children: o } = t, l = e ? ni(n || {}, e) : n;
  return {
    __v_isVNode: !0,
    __v_skip: !0,
    type: t.type,
    props: l,
    key: l && N3(l),
    ref: e && e.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      r && s ? ze(s) ? s.concat(Tg(e)) : [s, Tg(e)] : Tg(e)
    ) : s,
    scopeId: t.scopeId,
    slotScopeIds: t.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && a === -1 && ze(o) ? o.map(B3) : o,
    target: t.target,
    targetAnchor: t.targetAnchor,
    staticCount: t.staticCount,
    shapeFlag: t.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: e && t.type !== Je ? a === -1 ? 16 : a | 16 : a,
    dynamicProps: t.dynamicProps,
    dynamicChildren: t.dynamicChildren,
    appContext: t.appContext,
    dirs: t.dirs,
    transition: t.transition,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: t.component,
    suspense: t.suspense,
    ssContent: t.ssContent && Pa(t.ssContent),
    ssFallback: t.ssFallback && Pa(t.ssFallback),
    el: t.el,
    anchor: t.anchor,
    ctx: t.ctx,
    ce: t.ce
  };
}
function B3(t) {
  const e = Pa(t);
  return ze(t.children) && (e.children = t.children.map(B3)), e;
}
function Ra(t = " ", e = 0) {
  return je(Ip, null, t, e);
}
function Kq(t, e) {
  const r = je(bd, null, t);
  return r.staticCount = e, r;
}
function be(t = "", e = !1) {
  return e ? (re(), ot(Tn, null, t)) : je(Tn, null, t);
}
function Cs(t) {
  return t == null || typeof t == "boolean" ? je(Tn) : ze(t) ? je(
    Je,
    null,
    // #3666, avoid reference pollution when reusing vnode
    t.slice()
  ) : typeof t == "object" ? nl(t) : je(Ip, null, String(t));
}
function nl(t) {
  return t.el === null && t.patchFlag !== -1 || t.memo ? t : Pa(t);
}
function Rk(t, e) {
  let r = 0;
  const { shapeFlag: n } = t;
  if (e == null)
    e = null;
  else if (ze(e))
    r = 16;
  else if (typeof e == "object")
    if (n & 65) {
      const s = e.default;
      s && (s._c && (s._d = !1), Rk(t, s()), s._c && (s._d = !0));
      return;
    } else {
      r = 32;
      const s = e._;
      !s && !(k0 in e) ? e._ctx = cn : s === 3 && cn && (cn.slots._ === 1 ? e._ = 1 : (e._ = 2, t.patchFlag |= 1024));
    }
  else
    dt(e) ? (e = { default: e, _ctx: cn }, r = 32) : (e = String(e), n & 64 ? (r = 16, e = [Ra(e)]) : r = 8);
  t.children = e, t.shapeFlag |= r;
}
function ni(...t) {
  const e = {};
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    for (const s in n)
      if (s === "class")
        e.class !== n.class && (e.class = wt([e.class, n.class]));
      else if (s === "style")
        e.style = ri([e.style, n.style]);
      else if (Op(s)) {
        const a = e[s], o = n[s];
        o && a !== o && !(ze(a) && a.includes(o)) && (e[s] = a ? [].concat(a, o) : o);
      } else
        s !== "" && (e[s] = n[s]);
  }
  return e;
}
function aa(t, e, r, n = null) {
  us(t, e, 7, [
    r,
    n
  ]);
}
const zq = k3();
let qq = 0;
function Xq(t, e, r) {
  const n = t.type, s = (e ? e.appContext : t.appContext) || zq, a = {
    uid: qq++,
    vnode: t,
    type: n,
    parent: e,
    appContext: s,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    scope: new Vz(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: e ? e.provides : Object.create(s.provides),
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: O3(n, s),
    emitsOptions: f3(n, s),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: ar,
    // inheritAttrs
    inheritAttrs: n.inheritAttrs,
    // state
    ctx: ar,
    data: ar,
    props: ar,
    attrs: ar,
    slots: ar,
    refs: ar,
    setupState: ar,
    setupContext: null,
    attrsProxy: null,
    slotsProxy: null,
    // suspense related
    suspense: r,
    suspenseId: r ? r.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? a.ctx = vq(a) : a.ctx = { _: a }, a.root = e ? e.root : a, a.emit = K9.bind(null, a), t.ce && t.ce(a), a;
}
let on = null;
const D0 = () => on || cn;
let Mk, Dc, eI = "__VUE_INSTANCE_SETTERS__";
(Dc = Kg()[eI]) || (Dc = Kg()[eI] = []), Dc.push((t) => on = t), Mk = (t) => {
  Dc.length > 1 ? Dc.forEach((e) => e(t)) : Dc[0](t);
};
const Cd = (t) => {
  Mk(t), t.scope.on();
}, bu = () => {
  on && on.scope.off(), Mk(null);
}, Qq = /* @__PURE__ */ Il("slot,component");
function WT(t, e) {
  const r = e.isNativeTag || IB;
  (Qq(t) || r(t)) && Ee(
    "Do not use built-in or reserved HTML elements as component id: " + t
  );
}
function U3(t) {
  return t.vnode.shapeFlag & 4;
}
let Kf = !1;
function Zq(t, e = !1) {
  Kf = e;
  const { props: r, children: n } = t.vnode, s = U3(t);
  kq(t, r, s, e), Lq(t, n);
  const a = s ? Jq(t, e) : void 0;
  return Kf = !1, a;
}
function Jq(t, e) {
  var r;
  const n = t.type;
  if (process.env.NODE_ENV !== "production") {
    if (n.name && WT(n.name, t.appContext.config), n.components) {
      const a = Object.keys(n.components);
      for (let o = 0; o < a.length; o++)
        WT(a[o], t.appContext.config);
    }
    if (n.directives) {
      const a = Object.keys(n.directives);
      for (let o = 0; o < a.length; o++)
        m3(a[o]);
    }
    n.compilerOptions && eX() && Ee(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  t.accessCache = /* @__PURE__ */ Object.create(null), t.proxy = QB(new Proxy(t.ctx, E3)), process.env.NODE_ENV !== "production" && mq(t);
  const { setup: s } = n;
  if (s) {
    const a = t.setupContext = s.length > 1 ? Y3(t) : null;
    Cd(t), ec();
    const o = co(
      s,
      t,
      0,
      [process.env.NODE_ENV !== "production" ? hf(t.props) : t.props, a]
    );
    if (tc(), bu(), yk(o)) {
      if (o.then(bu, bu), e)
        return o.then((l) => {
          tI(t, l, e);
        }).catch((l) => {
          w0(l, t, 0);
        });
      if (t.asyncDep = o, process.env.NODE_ENV !== "production" && !t.suspense) {
        const l = (r = n.name) != null ? r : "Anonymous";
        Ee(
          `Component <${l}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      tI(t, o, e);
  } else
    V3(t, e);
}
function tI(t, e, r) {
  dt(e) ? t.type.__ssrInlineRender ? t.ssrRender = e : t.render = e : jt(e) ? (process.env.NODE_ENV !== "production" && Ad(e) && Ee(
    "setup() should not return VNodes directly - return a render function instead."
  ), process.env.NODE_ENV !== "production" && (t.devtoolsRawSetupState = e), t.setupState = e3(e), process.env.NODE_ENV !== "production" && gq(t)) : process.env.NODE_ENV !== "production" && e !== void 0 && Ee(
    `setup() should return an object. Received: ${e === null ? "null" : typeof e}`
  ), V3(t, r);
}
let jT;
const eX = () => !jT;
function V3(t, e, r) {
  const n = t.type;
  if (!t.render) {
    if (!e && jT && !n.render) {
      const s = n.template || Ik(t).template;
      if (s) {
        process.env.NODE_ENV !== "production" && Za(t, "compile");
        const { isCustomElement: a, compilerOptions: o } = t.appContext.config, { delimiters: l, compilerOptions: u } = n, c = pr(
          pr(
            {
              isCustomElement: a,
              delimiters: l
            },
            o
          ),
          u
        );
        n.render = jT(s, c), process.env.NODE_ENV !== "production" && Ja(t, "compile");
      }
    }
    t.render = n.render || Pn;
  }
  Cd(t), ec(), _q(t), tc(), bu(), process.env.NODE_ENV !== "production" && !n.render && t.render === Pn && !e && (n.template ? Ee(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
    /* should not happen */
  ) : Ee("Component is missing template or render function."));
}
function rI(t) {
  return t.attrsProxy || (t.attrsProxy = new Proxy(
    t.attrs,
    process.env.NODE_ENV !== "production" ? {
      get(e, r) {
        return ey(), Ln(t, "get", "$attrs"), e[r];
      },
      set() {
        return Ee("setupContext.attrs is readonly."), !1;
      },
      deleteProperty() {
        return Ee("setupContext.attrs is readonly."), !1;
      }
    } : {
      get(e, r) {
        return Ln(t, "get", "$attrs"), e[r];
      }
    }
  ));
}
function tX(t) {
  return t.slotsProxy || (t.slotsProxy = new Proxy(t.slots, {
    get(e, r) {
      return Ln(t, "get", "$slots"), e[r];
    }
  }));
}
function Y3(t) {
  const e = (r) => {
    if (process.env.NODE_ENV !== "production" && (t.exposed && Ee("expose() should be called only once per setup()."), r != null)) {
      let n = typeof r;
      n === "object" && (ze(r) ? n = "array" : Or(r) && (n = "ref")), n !== "object" && Ee(
        `expose() should be passed a plain object, received ${n}.`
      );
    }
    t.exposed = r || {};
  };
  return process.env.NODE_ENV !== "production" ? Object.freeze({
    get attrs() {
      return rI(t);
    },
    get slots() {
      return tX(t);
    },
    get emit() {
      return (r, ...n) => t.emit(r, ...n);
    },
    expose: e
  }) : {
    get attrs() {
      return rI(t);
    },
    slots: t.slots,
    emit: t.emit,
    expose: e
  };
}
function O0(t) {
  if (t.exposed)
    return t.exposeProxy || (t.exposeProxy = new Proxy(e3(QB(t.exposed)), {
      get(e, r) {
        if (r in e)
          return e[r];
        if (r in yu)
          return yu[r](t);
      },
      has(e, r) {
        return r in e || r in yu;
      }
    }));
}
const rX = /(?:^|[-_])(\w)/g, nX = (t) => t.replace(rX, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function Lk(t, e = !0) {
  return dt(t) ? t.displayName || t.name : t.name || e && t.__name;
}
function A0(t, e, r = !1) {
  let n = Lk(e);
  if (!n && e.__file) {
    const s = e.__file.match(/([^/\\]+)\.\w+$/);
    s && (n = s[1]);
  }
  if (!n && t && t.parent) {
    const s = (a) => {
      for (const o in a)
        if (a[o] === e)
          return o;
    };
    n = s(
      t.components || t.parent.type.components
    ) || s(t.appContext.components);
  }
  return n ? nX(n) : r ? "App" : "Anonymous";
}
function H3(t) {
  return dt(t) && "__vccOpts" in t;
}
const Ce = (t, e) => S9(t, e, Kf);
function G3(t, e, r) {
  const n = arguments.length;
  return n === 2 ? jt(e) && !ze(e) ? Ad(e) ? je(t, null, [e]) : je(t, e) : je(t, null, e) : (n > 3 ? r = Array.prototype.slice.call(arguments, 2) : n === 3 && Ad(r) && (r = [r]), je(t, e, r));
}
const iX = Symbol.for("v-scx"), sX = () => {
  {
    const t = tr(iX);
    return t || process.env.NODE_ENV !== "production" && Ee(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), t;
  }
};
function p_(t) {
  return !!(t && t.__v_isShallow);
}
function aX() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const t = { style: "color:#3ba776" }, e = { style: "color:#0b1bc9" }, r = { style: "color:#b62e24" }, n = { style: "color:#9d288c" }, s = {
    header(h) {
      return jt(h) ? h.__isVue ? ["div", t, "VueInstance"] : Or(h) ? [
        "div",
        {},
        ["span", t, d(h)],
        "<",
        l(h.value),
        ">"
      ] : mu(h) ? [
        "div",
        {},
        ["span", t, p_(h) ? "ShallowReactive" : "Reactive"],
        "<",
        l(h),
        `>${$l(h) ? " (readonly)" : ""}`
      ] : $l(h) ? [
        "div",
        {},
        ["span", t, p_(h) ? "ShallowReadonly" : "Readonly"],
        "<",
        l(h),
        ">"
      ] : null : null;
    },
    hasBody(h) {
      return h && h.__isVue;
    },
    body(h) {
      if (h && h.__isVue)
        return [
          "div",
          {},
          ...a(h.$)
        ];
    }
  };
  function a(h) {
    const f = [];
    h.type.props && h.props && f.push(o("props", gt(h.props))), h.setupState !== ar && f.push(o("setup", h.setupState)), h.data !== ar && f.push(o("data", gt(h.data)));
    const p = u(h, "computed");
    p && f.push(o("computed", p));
    const m = u(h, "inject");
    return m && f.push(o("injected", m)), f.push([
      "div",
      {},
      [
        "span",
        {
          style: n.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: h }]
    ]), f;
  }
  function o(h, f) {
    return f = pr({}, f), Object.keys(f).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        h
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(f).map((p) => [
          "div",
          {},
          ["span", n, p + ": "],
          l(f[p], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function l(h, f = !0) {
    return typeof h == "number" ? ["span", e, h] : typeof h == "string" ? ["span", r, JSON.stringify(h)] : typeof h == "boolean" ? ["span", n, h] : jt(h) ? ["object", { object: f ? gt(h) : h }] : ["span", r, String(h)];
  }
  function u(h, f) {
    const p = h.type;
    if (dt(p))
      return;
    const m = {};
    for (const b in h.ctx)
      c(p, b, f) && (m[b] = h.ctx[b]);
    return m;
  }
  function c(h, f, p) {
    const m = h[p];
    if (ze(m) && m.includes(f) || jt(m) && f in m || h.extends && c(h.extends, f, p) || h.mixins && h.mixins.some((b) => c(b, f, p)))
      return !0;
  }
  function d(h) {
    return p_(h) ? "ShallowRef" : h.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(s) : window.devtoolsFormatters = [s];
}
const nI = "3.3.4", oX = "http://www.w3.org/2000/svg", au = typeof document < "u" ? document : null, iI = au && /* @__PURE__ */ au.createElement("template"), lX = {
  insert: (t, e, r) => {
    e.insertBefore(t, r || null);
  },
  remove: (t) => {
    const e = t.parentNode;
    e && e.removeChild(t);
  },
  createElement: (t, e, r, n) => {
    const s = e ? au.createElementNS(oX, t) : au.createElement(t, r ? { is: r } : void 0);
    return t === "select" && n && n.multiple != null && s.setAttribute("multiple", n.multiple), s;
  },
  createText: (t) => au.createTextNode(t),
  createComment: (t) => au.createComment(t),
  setText: (t, e) => {
    t.nodeValue = e;
  },
  setElementText: (t, e) => {
    t.textContent = e;
  },
  parentNode: (t) => t.parentNode,
  nextSibling: (t) => t.nextSibling,
  querySelector: (t) => au.querySelector(t),
  setScopeId(t, e) {
    t.setAttribute(e, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(t, e, r, n, s, a) {
    const o = r ? r.previousSibling : e.lastChild;
    if (s && (s === a || s.nextSibling))
      for (; e.insertBefore(s.cloneNode(!0), r), !(s === a || !(s = s.nextSibling)); )
        ;
    else {
      iI.innerHTML = n ? `<svg>${t}</svg>` : t;
      const l = iI.content;
      if (n) {
        const u = l.firstChild;
        for (; u.firstChild; )
          l.appendChild(u.firstChild);
        l.removeChild(u);
      }
      e.insertBefore(l, r);
    }
    return [
      // first
      o ? o.nextSibling : e.firstChild,
      // last
      r ? r.previousSibling : e.lastChild
    ];
  }
};
function uX(t, e, r) {
  const n = t._vtc;
  n && (e = (e ? [e, ...n] : [...n]).join(" ")), e == null ? t.removeAttribute("class") : r ? t.setAttribute("class", e) : t.className = e;
}
function cX(t, e, r) {
  const n = t.style, s = yr(r);
  if (r && !s) {
    if (e && !yr(e))
      for (const a in e)
        r[a] == null && KT(n, a, "");
    for (const a in r)
      KT(n, a, r[a]);
  } else {
    const a = n.display;
    s ? e !== r && (n.cssText = r) : e && t.removeAttribute("style"), "_vod" in t && (n.display = a);
  }
}
const dX = /[^\\];\s*$/, sI = /\s*!important$/;
function KT(t, e, r) {
  if (ze(r))
    r.forEach((n) => KT(t, e, n));
  else if (r == null && (r = ""), process.env.NODE_ENV !== "production" && dX.test(r) && Ee(
    `Unexpected semicolon at the end of '${e}' style value: '${r}'`
  ), e.startsWith("--"))
    t.setProperty(e, r);
  else {
    const n = hX(t, e);
    sI.test(r) ? t.setProperty(
      xo(n),
      r.replace(sI, ""),
      "important"
    ) : t[n] = r;
  }
}
const aI = ["Webkit", "Moz", "ms"], v_ = {};
function hX(t, e) {
  const r = v_[e];
  if (r)
    return r;
  let n = Aa(e);
  if (n !== "filter" && n in t)
    return v_[e] = n;
  n = Nu(n);
  for (let s = 0; s < aI.length; s++) {
    const a = aI[s] + n;
    if (a in t)
      return v_[e] = a;
  }
  return e;
}
const oI = "http://www.w3.org/1999/xlink";
function fX(t, e, r, n, s) {
  if (n && e.startsWith("xlink:"))
    r == null ? t.removeAttributeNS(oI, e.slice(6, e.length)) : t.setAttributeNS(oI, e, r);
  else {
    const a = Uz(e);
    r == null || a && !LB(r) ? t.removeAttribute(e) : t.setAttribute(e, a ? "" : r);
  }
}
function pX(t, e, r, n, s, a, o) {
  if (e === "innerHTML" || e === "textContent") {
    n && o(n, s, a), t[e] = r ?? "";
    return;
  }
  const l = t.tagName;
  if (e === "value" && l !== "PROGRESS" && // custom elements may use _value internally
  !l.includes("-")) {
    t._value = r;
    const c = l === "OPTION" ? t.getAttribute("value") : t.value, d = r ?? "";
    c !== d && (t.value = d), r == null && t.removeAttribute(e);
    return;
  }
  let u = !1;
  if (r === "" || r == null) {
    const c = typeof t[e];
    c === "boolean" ? r = LB(r) : r == null && c === "string" ? (r = "", u = !0) : c === "number" && (r = 0, u = !0);
  }
  try {
    t[e] = r;
  } catch (c) {
    process.env.NODE_ENV !== "production" && !u && Ee(
      `Failed setting prop "${e}" on <${l.toLowerCase()}>: value ${r} is invalid.`,
      c
    );
  }
  u && t.removeAttribute(e);
}
function vX(t, e, r, n) {
  t.addEventListener(e, r, n);
}
function mX(t, e, r, n) {
  t.removeEventListener(e, r, n);
}
function gX(t, e, r, n, s = null) {
  const a = t._vei || (t._vei = {}), o = a[e];
  if (n && o)
    o.value = n;
  else {
    const [l, u] = yX(e);
    if (n) {
      const c = a[e] = wX(n, s);
      vX(t, l, c, u);
    } else
      o && (mX(t, l, o, u), a[e] = void 0);
  }
}
const lI = /(?:Once|Passive|Capture)$/;
function yX(t) {
  let e;
  if (lI.test(t)) {
    e = {};
    let n;
    for (; n = t.match(lI); )
      t = t.slice(0, t.length - n[0].length), e[n[0].toLowerCase()] = !0;
  }
  return [t[2] === ":" ? t.slice(3) : xo(t.slice(2)), e];
}
let m_ = 0;
const bX = /* @__PURE__ */ Promise.resolve(), _X = () => m_ || (bX.then(() => m_ = 0), m_ = Date.now());
function wX(t, e) {
  const r = (n) => {
    if (!n._vts)
      n._vts = Date.now();
    else if (n._vts <= r.attached)
      return;
    us(
      TX(n, r.value),
      e,
      5,
      [n]
    );
  };
  return r.value = t, r.attached = _X(), r;
}
function TX(t, e) {
  if (ze(e)) {
    const r = t.stopImmediatePropagation;
    return t.stopImmediatePropagation = () => {
      r.call(t), t._stopped = !0;
    }, e.map((n) => (s) => !s._stopped && n && n(s));
  } else
    return e;
}
const uI = /^on[a-z]/, xX = (t, e, r, n, s = !1, a, o, l, u) => {
  e === "class" ? uX(t, n, s) : e === "style" ? cX(t, r, n) : Op(e) ? Wg(e) || gX(t, e, r, n, o) : (e[0] === "." ? (e = e.slice(1), !0) : e[0] === "^" ? (e = e.slice(1), !1) : SX(t, e, n, s)) ? pX(
    t,
    e,
    n,
    a,
    o,
    l,
    u
  ) : (e === "true-value" ? t._trueValue = n : e === "false-value" && (t._falseValue = n), fX(t, e, n, s));
};
function SX(t, e, r, n) {
  return n ? !!(e === "innerHTML" || e === "textContent" || e in t && uI.test(e) && dt(r)) : e === "spellcheck" || e === "draggable" || e === "translate" || e === "form" || e === "list" && t.tagName === "INPUT" || e === "type" && t.tagName === "TEXTAREA" || uI.test(e) && yr(r) ? !1 : e in t;
}
function EX(t) {
  const e = D0();
  if (!e) {
    process.env.NODE_ENV !== "production" && Ee("useCssVars is called without current active component instance.");
    return;
  }
  const r = e.ut = (s = t(e.proxy)) => {
    Array.from(
      document.querySelectorAll(`[data-v-owner="${e.uid}"]`)
    ).forEach((a) => qT(a, s));
  }, n = () => {
    const s = t(e.proxy);
    zT(e.subTree, s), r(s);
  };
  tq(n), Nr(() => {
    const s = new MutationObserver(n);
    s.observe(e.subTree.el.parentNode, { childList: !0 }), ih(() => s.disconnect());
  });
}
function zT(t, e) {
  if (t.shapeFlag & 128) {
    const r = t.suspense;
    t = r.activeBranch, r.pendingBranch && !r.isHydrating && r.effects.push(() => {
      zT(r.activeBranch, e);
    });
  }
  for (; t.component; )
    t = t.component.subTree;
  if (t.shapeFlag & 1 && t.el)
    qT(t.el, e);
  else if (t.type === Je)
    t.children.forEach((r) => zT(r, e));
  else if (t.type === bd) {
    let { el: r, anchor: n } = t;
    for (; r && (qT(r, e), r !== n); )
      r = r.nextSibling;
  }
}
function qT(t, e) {
  if (t.nodeType === 1) {
    const r = t.style;
    for (const n in e)
      r.setProperty(`--${n}`, e[n]);
  }
}
const zo = "transition", Wh = "animation", gs = (t, { slots: e }) => G3(sq, $X(t), e);
gs.displayName = "Transition";
const W3 = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
};
gs.props = /* @__PURE__ */ pr(
  {},
  g3,
  W3
);
const jl = (t, e = []) => {
  ze(t) ? t.forEach((r) => r(...e)) : t && t(...e);
}, cI = (t) => t ? ze(t) ? t.some((e) => e.length > 1) : t.length > 1 : !1;
function $X(t) {
  const e = {};
  for (const I in t)
    I in W3 || (e[I] = t[I]);
  if (t.css === !1)
    return e;
  const {
    name: r = "v",
    type: n,
    duration: s,
    enterFromClass: a = `${r}-enter-from`,
    enterActiveClass: o = `${r}-enter-active`,
    enterToClass: l = `${r}-enter-to`,
    appearFromClass: u = a,
    appearActiveClass: c = o,
    appearToClass: d = l,
    leaveFromClass: h = `${r}-leave-from`,
    leaveActiveClass: f = `${r}-leave-active`,
    leaveToClass: p = `${r}-leave-to`
  } = t, m = kX(s), b = m && m[0], y = m && m[1], {
    onBeforeEnter: _,
    onEnter: x,
    onEnterCancelled: T,
    onLeave: k,
    onLeaveCancelled: E,
    onBeforeAppear: F = _,
    onAppear: R = x,
    onAppearCancelled: $ = T
  } = e, O = (I, B, W) => {
    Kl(I, B ? d : l), Kl(I, B ? c : o), W && W();
  }, P = (I, B) => {
    I._isLeaving = !1, Kl(I, h), Kl(I, p), Kl(I, f), B && B();
  }, N = (I) => (B, W) => {
    const Q = I ? R : x, te = () => O(B, I, W);
    jl(Q, [B, te]), dI(() => {
      Kl(B, I ? u : a), qo(B, I ? d : l), cI(Q) || hI(B, n, b, te);
    });
  };
  return pr(e, {
    onBeforeEnter(I) {
      jl(_, [I]), qo(I, a), qo(I, o);
    },
    onBeforeAppear(I) {
      jl(F, [I]), qo(I, u), qo(I, c);
    },
    onEnter: N(!1),
    onAppear: N(!0),
    onLeave(I, B) {
      I._isLeaving = !0;
      const W = () => P(I, B);
      qo(I, h), AX(), qo(I, f), dI(() => {
        I._isLeaving && (Kl(I, h), qo(I, p), cI(k) || hI(I, n, y, W));
      }), jl(k, [I, W]);
    },
    onEnterCancelled(I) {
      O(I, !1), jl(T, [I]);
    },
    onAppearCancelled(I) {
      O(I, !0), jl($, [I]);
    },
    onLeaveCancelled(I) {
      P(I), jl(E, [I]);
    }
  });
}
function kX(t) {
  if (t == null)
    return null;
  if (jt(t))
    return [g_(t.enter), g_(t.leave)];
  {
    const e = g_(t);
    return [e, e];
  }
}
function g_(t) {
  const e = Az(t);
  return process.env.NODE_ENV !== "production" && O9(e, "<transition> explicit duration"), e;
}
function qo(t, e) {
  e.split(/\s+/).forEach((r) => r && t.classList.add(r)), (t._vtc || (t._vtc = /* @__PURE__ */ new Set())).add(e);
}
function Kl(t, e) {
  e.split(/\s+/).forEach((n) => n && t.classList.remove(n));
  const { _vtc: r } = t;
  r && (r.delete(e), r.size || (t._vtc = void 0));
}
function dI(t) {
  requestAnimationFrame(() => {
    requestAnimationFrame(t);
  });
}
let DX = 0;
function hI(t, e, r, n) {
  const s = t._endId = ++DX, a = () => {
    s === t._endId && n();
  };
  if (r)
    return setTimeout(a, r);
  const { type: o, timeout: l, propCount: u } = OX(t, e);
  if (!o)
    return n();
  const c = o + "end";
  let d = 0;
  const h = () => {
    t.removeEventListener(c, f), a();
  }, f = (p) => {
    p.target === t && ++d >= u && h();
  };
  setTimeout(() => {
    d < u && h();
  }, l + 1), t.addEventListener(c, f);
}
function OX(t, e) {
  const r = window.getComputedStyle(t), n = (m) => (r[m] || "").split(", "), s = n(`${zo}Delay`), a = n(`${zo}Duration`), o = fI(s, a), l = n(`${Wh}Delay`), u = n(`${Wh}Duration`), c = fI(l, u);
  let d = null, h = 0, f = 0;
  e === zo ? o > 0 && (d = zo, h = o, f = a.length) : e === Wh ? c > 0 && (d = Wh, h = c, f = u.length) : (h = Math.max(o, c), d = h > 0 ? o > c ? zo : Wh : null, f = d ? d === zo ? a.length : u.length : 0);
  const p = d === zo && /\b(transform|all)(,|$)/.test(
    n(`${zo}Property`).toString()
  );
  return {
    type: d,
    timeout: h,
    propCount: f,
    hasTransform: p
  };
}
function fI(t, e) {
  for (; t.length < e.length; )
    t = t.concat(t);
  return Math.max(...e.map((r, n) => pI(r) + pI(t[n])));
}
function pI(t) {
  return Number(t.slice(0, -1).replace(",", ".")) * 1e3;
}
function AX() {
  return document.body.offsetHeight;
}
const CX = ["ctrl", "shift", "alt", "meta"], IX = {
  stop: (t) => t.stopPropagation(),
  prevent: (t) => t.preventDefault(),
  self: (t) => t.target !== t.currentTarget,
  ctrl: (t) => !t.ctrlKey,
  shift: (t) => !t.shiftKey,
  alt: (t) => !t.altKey,
  meta: (t) => !t.metaKey,
  left: (t) => "button" in t && t.button !== 0,
  middle: (t) => "button" in t && t.button !== 1,
  right: (t) => "button" in t && t.button !== 2,
  exact: (t, e) => CX.some((r) => t[`${r}Key`] && !e.includes(r))
}, kt = (t, e) => (r, ...n) => {
  for (let s = 0; s < e.length; s++) {
    const a = IX[e[s]];
    if (a && a(r, e))
      return;
  }
  return t(r, ...n);
}, PX = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
}, pt = (t, e) => (r) => {
  if (!("key" in r))
    return;
  const n = xo(r.key);
  if (e.some((s) => s === n || PX[s] === n))
    return t(r);
}, _d = {
  beforeMount(t, { value: e }, { transition: r }) {
    t._vod = t.style.display === "none" ? "" : t.style.display, r && e ? r.beforeEnter(t) : jh(t, e);
  },
  mounted(t, { value: e }, { transition: r }) {
    r && e && r.enter(t);
  },
  updated(t, { value: e, oldValue: r }, { transition: n }) {
    !e != !r && (n ? e ? (n.beforeEnter(t), jh(t, !0), n.enter(t)) : n.leave(t, () => {
      jh(t, !1);
    }) : jh(t, e));
  },
  beforeUnmount(t, { value: e }) {
    jh(t, e);
  }
};
function jh(t, e) {
  t.style.display = e ? t._vod : "none";
}
const RX = /* @__PURE__ */ pr({ patchProp: xX }, lX);
let vI;
function j3() {
  return vI || (vI = Bq(RX));
}
const mI = (...t) => {
  j3().render(...t);
}, MX = (...t) => {
  const e = j3().createApp(...t);
  process.env.NODE_ENV !== "production" && (LX(e), NX(e));
  const { mount: r } = e;
  return e.mount = (n) => {
    const s = FX(n);
    if (!s)
      return;
    const a = e._component;
    !dt(a) && !a.render && !a.template && (a.template = s.innerHTML), s.innerHTML = "";
    const o = r(s, !1, s instanceof SVGElement);
    return s instanceof Element && (s.removeAttribute("v-cloak"), s.setAttribute("data-v-app", "")), o;
  }, e;
};
function LX(t) {
  Object.defineProperty(t.config, "isNativeTag", {
    value: (e) => Nz(e) || Fz(e),
    writable: !1
  });
}
function NX(t) {
  {
    const e = t.config.isCustomElement;
    Object.defineProperty(t.config, "isCustomElement", {
      get() {
        return e;
      },
      set() {
        Ee(
          "The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead."
        );
      }
    });
    const r = t.config.compilerOptions, n = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
    Object.defineProperty(t.config, "compilerOptions", {
      get() {
        return Ee(n), r;
      },
      set() {
        Ee(n);
      }
    });
  }
}
function FX(t) {
  if (yr(t)) {
    const e = document.querySelector(t);
    return process.env.NODE_ENV !== "production" && !e && Ee(
      `Failed to mount app: mount target selector "${t}" returned null.`
    ), e;
  }
  return process.env.NODE_ENV !== "production" && window.ShadowRoot && t instanceof window.ShadowRoot && t.mode === "closed" && Ee(
    'mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'
  ), t;
}
function BX() {
  aX();
}
process.env.NODE_ENV !== "production" && BX();
function K3(t) {
  return wk() ? (FB(t), !0) : !1;
}
function zf(t) {
  return typeof t == "function" ? t() : X(t);
}
const Nk = typeof window < "u", Id = () => {
}, UX = /* @__PURE__ */ VX();
function VX() {
  var t;
  return Nk && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && /* @__PURE__ */ /iP(ad|hone|od)/.test(window.navigator.userAgent);
}
function z3(t, e) {
  function r(...n) {
    return new Promise((s, a) => {
      Promise.resolve(t(() => e.apply(this, n), { fn: e, thisArg: this, args: n })).then(s).catch(a);
    });
  }
  return r;
}
function YX(t, e = {}) {
  let r, n, s = Id;
  const a = (l) => {
    clearTimeout(l), s(), s = Id;
  };
  return (l) => {
    const u = zf(t), c = zf(e.maxWait);
    return r && a(r), u <= 0 || c !== void 0 && c <= 0 ? (n && (a(n), n = null), Promise.resolve(l())) : new Promise((d, h) => {
      s = e.rejectOnCancel ? h : d, c && !n && (n = setTimeout(() => {
        r && a(r), n = null, d(l());
      }, c)), r = setTimeout(() => {
        n && a(n), n = null, d(l());
      }, u);
    });
  };
}
function HX(t, e = !0, r = !0, n = !1) {
  let s = 0, a, o = !0, l = Id, u;
  const c = () => {
    a && (clearTimeout(a), a = void 0, l(), l = Id);
  };
  return (h) => {
    const f = zf(t), p = Date.now() - s, m = () => u = h();
    return c(), f <= 0 ? (s = Date.now(), m()) : (p > f && (r || !o) ? (s = Date.now(), m()) : e && (u = new Promise((b, y) => {
      l = n ? y : b, a = setTimeout(() => {
        s = Date.now(), o = !0, b(m()), c();
      }, Math.max(0, f - p));
    })), !r && !a && (a = setTimeout(() => o = !0, f)), o = !1, u);
  };
}
function wd(t, e = !1, r = "Timeout") {
  return new Promise((n, s) => {
    setTimeout(e ? () => s(r) : n, t);
  });
}
function Fk(t, e = 200, r = {}) {
  return z3(
    YX(e, r),
    t
  );
}
function y_(t, e = 200, r = !1, n = !0, s = !1) {
  return z3(
    HX(e, r, n, s),
    t
  );
}
var GX = Object.defineProperty, WX = Object.defineProperties, jX = Object.getOwnPropertyDescriptors, gI = Object.getOwnPropertySymbols, KX = Object.prototype.hasOwnProperty, zX = Object.prototype.propertyIsEnumerable, yI = (t, e, r) => e in t ? GX(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, qX = (t, e) => {
  for (var r in e || (e = {}))
    KX.call(e, r) && yI(t, r, e[r]);
  if (gI)
    for (var r of gI(e))
      zX.call(e, r) && yI(t, r, e[r]);
  return t;
}, XX = (t, e) => WX(t, jX(e));
function QX(t, e, r) {
  return Lr(
    t,
    e,
    XX(qX({}, r), {
      immediate: !0
    })
  );
}
function io(t) {
  var e;
  const r = zf(t);
  return (e = r == null ? void 0 : r.$el) != null ? e : r;
}
const Pp = Nk ? window : void 0, ZX = Nk ? window.document : void 0;
function Vr(...t) {
  let e, r, n, s;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([r, n, s] = t, e = Pp) : [e, r, n, s] = t, !e)
    return Id;
  Array.isArray(r) || (r = [r]), Array.isArray(n) || (n = [n]);
  const a = [], o = () => {
    a.forEach((d) => d()), a.length = 0;
  }, l = (d, h, f, p) => (d.addEventListener(h, f, p), () => d.removeEventListener(h, f, p)), u = Lr(
    () => [io(e), zf(s)],
    ([d, h]) => {
      o(), d && a.push(
        ...r.flatMap((f) => n.map((p) => l(d, f, p, h)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    u(), o();
  };
  return K3(c), c;
}
let bI = !1;
function q3(t, e, r = {}) {
  const { window: n = Pp, ignore: s = [], capture: a = !0, detectIframe: o = !1 } = r;
  if (!n)
    return;
  UX && !bI && (bI = !0, Array.from(n.document.body.children).forEach((f) => f.addEventListener("click", Id)));
  let l = !0;
  const u = (f) => s.some((p) => {
    if (typeof p == "string")
      return Array.from(n.document.querySelectorAll(p)).some((m) => m === f.target || f.composedPath().includes(m));
    {
      const m = io(p);
      return m && (f.target === m || f.composedPath().includes(m));
    }
  }), d = [
    Vr(n, "click", (f) => {
      const p = io(t);
      if (!(!p || p === f.target || f.composedPath().includes(p))) {
        if (f.detail === 0 && (l = !u(f)), !l) {
          l = !0;
          return;
        }
        e(f);
      }
    }, { passive: !0, capture: a }),
    Vr(n, "pointerdown", (f) => {
      const p = io(t);
      p && (l = !f.composedPath().includes(p) && !u(f));
    }, { passive: !0 }),
    o && Vr(n, "blur", (f) => {
      setTimeout(() => {
        var p;
        const m = io(t);
        ((p = n.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(m != null && m.contains(n.document.activeElement)) && e(f);
      }, 0);
    })
  ].filter(Boolean);
  return () => d.forEach((f) => f());
}
function JX() {
  const t = ue(!1);
  return D0() && Nr(() => {
    t.value = !0;
  }), t;
}
function eQ(t) {
  const e = JX();
  return Ce(() => (e.value, !!t()));
}
const _I = [
  "fullscreenchange",
  "webkitfullscreenchange",
  "webkitendfullscreen",
  "mozfullscreenchange",
  "MSFullscreenChange"
];
function tQ(t, e = {}) {
  const {
    document: r = ZX,
    autoExit: n = !1
  } = e, s = Ce(() => {
    var _;
    return (_ = io(t)) != null ? _ : r == null ? void 0 : r.querySelector("html");
  }), a = ue(!1), o = Ce(() => [
    "requestFullscreen",
    "webkitRequestFullscreen",
    "webkitEnterFullscreen",
    "webkitEnterFullScreen",
    "webkitRequestFullScreen",
    "mozRequestFullScreen",
    "msRequestFullscreen"
  ].find((_) => r && _ in r || s.value && _ in s.value)), l = Ce(() => [
    "exitFullscreen",
    "webkitExitFullscreen",
    "webkitExitFullScreen",
    "webkitCancelFullScreen",
    "mozCancelFullScreen",
    "msExitFullscreen"
  ].find((_) => r && _ in r || s.value && _ in s.value)), u = Ce(() => [
    "fullScreen",
    "webkitIsFullScreen",
    "webkitDisplayingFullscreen",
    "mozFullScreen",
    "msFullscreenElement"
  ].find((_) => r && _ in r || s.value && _ in s.value)), c = [
    "fullscreenElement",
    "webkitFullscreenElement",
    "mozFullScreenElement",
    "msFullscreenElement"
  ].find((_) => r && _ in r), d = eQ(
    () => s.value && r && o.value !== void 0 && l.value !== void 0 && u.value !== void 0
  ), h = () => c ? (r == null ? void 0 : r[c]) === s.value : !1, f = () => {
    if (u.value) {
      if (r && r[u.value] != null)
        return r[u.value];
      {
        const _ = s.value;
        if ((_ == null ? void 0 : _[u.value]) != null)
          return !!_[u.value];
      }
    }
    return !1;
  };
  async function p() {
    if (!(!d.value || !a.value)) {
      if (l.value)
        if ((r == null ? void 0 : r[l.value]) != null)
          await r[l.value]();
        else {
          const _ = s.value;
          (_ == null ? void 0 : _[l.value]) != null && await _[l.value]();
        }
      a.value = !1;
    }
  }
  async function m() {
    if (!d.value || a.value)
      return;
    f() && await p();
    const _ = s.value;
    o.value && (_ == null ? void 0 : _[o.value]) != null && (await _[o.value](), a.value = !0);
  }
  async function b() {
    await (a.value ? p() : m());
  }
  const y = () => {
    const _ = f();
    (!_ || _ && h()) && (a.value = _);
  };
  return Vr(r, _I, y, !1), Vr(() => io(s), _I, y, !1), n && K3(p), {
    isSupported: d,
    isFullscreen: a,
    enter: m,
    exit: p,
    toggle: b
  };
}
const rQ = {
  page: (t) => [t.pageX, t.pageY],
  client: (t) => [t.clientX, t.clientY],
  screen: (t) => [t.screenX, t.screenY],
  movement: (t) => t instanceof Touch ? null : [t.movementX, t.movementY]
};
function nQ(t = {}) {
  const {
    type: e = "page",
    touch: r = !0,
    resetOnTouchEnds: n = !1,
    initialValue: s = { x: 0, y: 0 },
    window: a = Pp,
    target: o = a,
    eventFilter: l
  } = t, u = ue(s.x), c = ue(s.y), d = ue(null), h = typeof e == "function" ? e : rQ[e], f = (_) => {
    const x = h(_);
    x && ([u.value, c.value] = x, d.value = "mouse");
  }, p = (_) => {
    if (_.touches.length > 0) {
      const x = h(_.touches[0]);
      x && ([u.value, c.value] = x, d.value = "touch");
    }
  }, m = () => {
    u.value = s.x, c.value = s.y;
  }, b = l ? (_) => l(() => f(_), {}) : (_) => f(_), y = l ? (_) => l(() => p(_), {}) : (_) => p(_);
  return o && (Vr(o, "mousemove", b, { passive: !0 }), Vr(o, "dragover", b, { passive: !0 }), r && e !== "movement" && (Vr(o, "touchstart", y, { passive: !0 }), Vr(o, "touchmove", y, { passive: !0 }), n && Vr(o, "touchend", m, { passive: !0 }))), {
    x: u,
    y: c,
    sourceType: d
  };
}
function X3(t, e = {}) {
  const {
    handleOutside: r = !0,
    window: n = Pp
  } = e, { x: s, y: a, sourceType: o } = nQ(e), l = ue(t ?? (n == null ? void 0 : n.document.body)), u = ue(0), c = ue(0), d = ue(0), h = ue(0), f = ue(0), p = ue(0), m = ue(!0);
  let b = () => {
  };
  return n && (b = Lr(
    [l, s, a],
    () => {
      const y = io(l);
      if (!y)
        return;
      const {
        left: _,
        top: x,
        width: T,
        height: k
      } = y.getBoundingClientRect();
      d.value = _ + n.pageXOffset, h.value = x + n.pageYOffset, f.value = k, p.value = T;
      const E = s.value - d.value, F = a.value - h.value;
      m.value = T === 0 || k === 0 || E < 0 || F < 0 || E > T || F > k, (r || !m.value) && (u.value = E, c.value = F);
    },
    { immediate: !0 }
  ), Vr(document, "mouseleave", () => {
    m.value = !0;
  })), {
    x: s,
    y: a,
    sourceType: o,
    elementX: u,
    elementY: c,
    elementPositionX: d,
    elementPositionY: h,
    elementHeight: f,
    elementWidth: p,
    isOutside: m,
    stop: b
  };
}
function Q3(t = {}) {
  const {
    touch: e = !0,
    drag: r = !0,
    initialValue: n = !1,
    window: s = Pp
  } = t, a = ue(n), o = ue(null);
  if (!s)
    return {
      pressed: a,
      sourceType: o
    };
  const l = (d) => () => {
    a.value = !0, o.value = d;
  }, u = () => {
    a.value = !1, o.value = null;
  }, c = Ce(() => io(t.target) || s);
  return Vr(c, "mousedown", l("mouse"), { passive: !0 }), Vr(s, "mouseleave", u, { passive: !0 }), Vr(s, "mouseup", u, { passive: !0 }), r && (Vr(c, "dragstart", l("mouse"), { passive: !0 }), Vr(s, "drop", u, { passive: !0 }), Vr(s, "dragend", u, { passive: !0 })), e && (Vr(c, "touchstart", l("touch"), { passive: !0 }), Vr(s, "touchend", u, { passive: !0 }), Vr(s, "touchcancel", u, { passive: !0 })), {
    pressed: a,
    sourceType: o
  };
}
function iQ(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Z3 = { exports: {} };
(function(t, e) {
  (function(r) {
    var n = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, s = /^(?=([^\/?#]*))\1([^]*)$/, a = /(?:\/|^)\.(?=\/)/g, o = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, l = {
      // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
      // E.g
      // With opts.alwaysNormalize = false (default, spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
      // With opts.alwaysNormalize = true (not spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
      buildAbsoluteURL: function(u, c, d) {
        if (d = d || {}, u = u.trim(), c = c.trim(), !c) {
          if (!d.alwaysNormalize)
            return u;
          var h = l.parseURL(u);
          if (!h)
            throw new Error("Error trying to parse base URL.");
          return h.path = l.normalizePath(
            h.path
          ), l.buildURLFromParts(h);
        }
        var f = l.parseURL(c);
        if (!f)
          throw new Error("Error trying to parse relative URL.");
        if (f.scheme)
          return d.alwaysNormalize ? (f.path = l.normalizePath(f.path), l.buildURLFromParts(f)) : c;
        var p = l.parseURL(u);
        if (!p)
          throw new Error("Error trying to parse base URL.");
        if (!p.netLoc && p.path && p.path[0] !== "/") {
          var m = s.exec(p.path);
          p.netLoc = m[1], p.path = m[2];
        }
        p.netLoc && !p.path && (p.path = "/");
        var b = {
          // 2c) Otherwise, the embedded URL inherits the scheme of
          // the base URL.
          scheme: p.scheme,
          netLoc: f.netLoc,
          path: null,
          params: f.params,
          query: f.query,
          fragment: f.fragment
        };
        if (!f.netLoc && (b.netLoc = p.netLoc, f.path[0] !== "/"))
          if (!f.path)
            b.path = p.path, f.params || (b.params = p.params, f.query || (b.query = p.query));
          else {
            var y = p.path, _ = y.substring(0, y.lastIndexOf("/") + 1) + f.path;
            b.path = l.normalizePath(_);
          }
        return b.path === null && (b.path = d.alwaysNormalize ? l.normalizePath(f.path) : f.path), l.buildURLFromParts(b);
      },
      parseURL: function(u) {
        var c = n.exec(u);
        return c ? {
          scheme: c[1] || "",
          netLoc: c[2] || "",
          path: c[3] || "",
          params: c[4] || "",
          query: c[5] || "",
          fragment: c[6] || ""
        } : null;
      },
      normalizePath: function(u) {
        for (u = u.split("").reverse().join("").replace(a, ""); u.length !== (u = u.replace(o, "")).length; )
          ;
        return u.split("").reverse().join("");
      },
      buildURLFromParts: function(u) {
        return u.scheme + u.netLoc + u.path + u.params + u.query + u.fragment;
      }
    };
    t.exports = l;
  })();
})(Z3);
var Bk = Z3.exports;
function wI(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ei(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wI(Object(r), !0).forEach(function(n) {
      sQ(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : wI(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function sQ(t, e, r) {
  return e = oQ(e), e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function hn() {
  return hn = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, hn.apply(this, arguments);
}
function aQ(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function oQ(t) {
  var e = aQ(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
const et = Number.isFinite || function(t) {
  return typeof t == "number" && isFinite(t);
};
let D = /* @__PURE__ */ function(t) {
  return t.MEDIA_ATTACHING = "hlsMediaAttaching", t.MEDIA_ATTACHED = "hlsMediaAttached", t.MEDIA_DETACHING = "hlsMediaDetaching", t.MEDIA_DETACHED = "hlsMediaDetached", t.BUFFER_RESET = "hlsBufferReset", t.BUFFER_CODECS = "hlsBufferCodecs", t.BUFFER_CREATED = "hlsBufferCreated", t.BUFFER_APPENDING = "hlsBufferAppending", t.BUFFER_APPENDED = "hlsBufferAppended", t.BUFFER_EOS = "hlsBufferEos", t.BUFFER_FLUSHING = "hlsBufferFlushing", t.BUFFER_FLUSHED = "hlsBufferFlushed", t.MANIFEST_LOADING = "hlsManifestLoading", t.MANIFEST_LOADED = "hlsManifestLoaded", t.MANIFEST_PARSED = "hlsManifestParsed", t.LEVEL_SWITCHING = "hlsLevelSwitching", t.LEVEL_SWITCHED = "hlsLevelSwitched", t.LEVEL_LOADING = "hlsLevelLoading", t.LEVEL_LOADED = "hlsLevelLoaded", t.LEVEL_UPDATED = "hlsLevelUpdated", t.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", t.LEVELS_UPDATED = "hlsLevelsUpdated", t.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", t.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", t.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", t.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", t.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", t.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", t.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", t.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", t.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", t.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", t.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", t.CUES_PARSED = "hlsCuesParsed", t.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", t.INIT_PTS_FOUND = "hlsInitPtsFound", t.FRAG_LOADING = "hlsFragLoading", t.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", t.FRAG_LOADED = "hlsFragLoaded", t.FRAG_DECRYPTED = "hlsFragDecrypted", t.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", t.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", t.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", t.FRAG_PARSED = "hlsFragParsed", t.FRAG_BUFFERED = "hlsFragBuffered", t.FRAG_CHANGED = "hlsFragChanged", t.FPS_DROP = "hlsFpsDrop", t.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", t.ERROR = "hlsError", t.DESTROYING = "hlsDestroying", t.KEY_LOADING = "hlsKeyLoading", t.KEY_LOADED = "hlsKeyLoaded", t.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", t.BACK_BUFFER_REACHED = "hlsBackBufferReached", t;
}({}), it = /* @__PURE__ */ function(t) {
  return t.NETWORK_ERROR = "networkError", t.MEDIA_ERROR = "mediaError", t.KEY_SYSTEM_ERROR = "keySystemError", t.MUX_ERROR = "muxError", t.OTHER_ERROR = "otherError", t;
}({}), le = /* @__PURE__ */ function(t) {
  return t.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", t.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", t.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", t.KEY_SYSTEM_NO_CONFIGURED_LICENSE = "keySystemNoConfiguredLicense", t.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", t.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED = "keySystemServerCertificateRequestFailed", t.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED = "keySystemServerCertificateUpdateFailed", t.KEY_SYSTEM_SESSION_UPDATE_FAILED = "keySystemSessionUpdateFailed", t.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED = "keySystemStatusOutputRestricted", t.KEY_SYSTEM_STATUS_INTERNAL_ERROR = "keySystemStatusInternalError", t.MANIFEST_LOAD_ERROR = "manifestLoadError", t.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", t.MANIFEST_PARSING_ERROR = "manifestParsingError", t.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", t.LEVEL_EMPTY_ERROR = "levelEmptyError", t.LEVEL_LOAD_ERROR = "levelLoadError", t.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", t.LEVEL_PARSING_ERROR = "levelParsingError", t.LEVEL_SWITCH_ERROR = "levelSwitchError", t.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", t.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", t.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", t.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", t.FRAG_LOAD_ERROR = "fragLoadError", t.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", t.FRAG_DECRYPT_ERROR = "fragDecryptError", t.FRAG_PARSING_ERROR = "fragParsingError", t.FRAG_GAP = "fragGap", t.REMUX_ALLOC_ERROR = "remuxAllocError", t.KEY_LOAD_ERROR = "keyLoadError", t.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", t.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", t.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", t.BUFFER_APPEND_ERROR = "bufferAppendError", t.BUFFER_APPENDING_ERROR = "bufferAppendingError", t.BUFFER_STALLED_ERROR = "bufferStalledError", t.BUFFER_FULL_ERROR = "bufferFullError", t.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", t.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", t.INTERNAL_EXCEPTION = "internalException", t.INTERNAL_ABORTED = "aborted", t.UNKNOWN = "unknown", t;
}({});
const eu = function() {
}, XT = {
  trace: eu,
  debug: eu,
  log: eu,
  warn: eu,
  info: eu,
  error: eu
};
let xf = XT;
function lQ(t) {
  const e = self.console[t];
  return e ? e.bind(self.console, `[${t}] >`) : eu;
}
function uQ(t, ...e) {
  e.forEach(function(r) {
    xf[r] = t[r] ? t[r].bind(t) : lQ(r);
  });
}
function cQ(t, e) {
  if (self.console && t === !0 || typeof t == "object") {
    uQ(
      t,
      // Remove out from list here to hard-disable a log-level
      // 'trace',
      "debug",
      "log",
      "info",
      "warn",
      "error"
    );
    try {
      xf.log(`Debug logs enabled for "${e}" in hls.js version 1.4.10`);
    } catch {
      xf = XT;
    }
  } else
    xf = XT;
}
const J = xf, dQ = /^(\d+)x(\d+)$/, TI = /(.+?)=(".*?"|.*?)(?:,|$)/g;
class Ir {
  constructor(e) {
    typeof e == "string" && (e = Ir.parseAttrList(e));
    for (const r in e)
      e.hasOwnProperty(r) && (r.substring(0, 2) === "X-" && (this.clientAttrs = this.clientAttrs || [], this.clientAttrs.push(r)), this[r] = e[r]);
  }
  decimalInteger(e) {
    const r = parseInt(this[e], 10);
    return r > Number.MAX_SAFE_INTEGER ? 1 / 0 : r;
  }
  hexadecimalInteger(e) {
    if (this[e]) {
      let r = (this[e] || "0x").slice(2);
      r = (r.length & 1 ? "0" : "") + r;
      const n = new Uint8Array(r.length / 2);
      for (let s = 0; s < r.length / 2; s++)
        n[s] = parseInt(r.slice(s * 2, s * 2 + 2), 16);
      return n;
    } else
      return null;
  }
  hexadecimalIntegerAsNumber(e) {
    const r = parseInt(this[e], 16);
    return r > Number.MAX_SAFE_INTEGER ? 1 / 0 : r;
  }
  decimalFloatingPoint(e) {
    return parseFloat(this[e]);
  }
  optionalFloat(e, r) {
    const n = this[e];
    return n ? parseFloat(n) : r;
  }
  enumeratedString(e) {
    return this[e];
  }
  bool(e) {
    return this[e] === "YES";
  }
  decimalResolution(e) {
    const r = dQ.exec(this[e]);
    if (r !== null)
      return {
        width: parseInt(r[1], 10),
        height: parseInt(r[2], 10)
      };
  }
  static parseAttrList(e) {
    let r;
    const n = {}, s = '"';
    for (TI.lastIndex = 0; (r = TI.exec(e)) !== null; ) {
      let a = r[2];
      a.indexOf(s) === 0 && a.lastIndexOf(s) === a.length - 1 && (a = a.slice(1, -1));
      const o = r[1].trim();
      n[o] = a;
    }
    return n;
  }
}
function hQ(t) {
  return t !== "ID" && t !== "CLASS" && t !== "START-DATE" && t !== "DURATION" && t !== "END-DATE" && t !== "END-ON-NEXT";
}
function fQ(t) {
  return t === "SCTE35-OUT" || t === "SCTE35-IN";
}
class J3 {
  constructor(e, r) {
    if (this.attr = void 0, this._startDate = void 0, this._endDate = void 0, this._badValueForSameId = void 0, r) {
      const n = r.attr;
      for (const s in n)
        if (Object.prototype.hasOwnProperty.call(e, s) && e[s] !== n[s]) {
          J.warn(`DATERANGE tag attribute: "${s}" does not match for tags with ID: "${e.ID}"`), this._badValueForSameId = s;
          break;
        }
      e = hn(new Ir({}), n, e);
    }
    if (this.attr = e, this._startDate = new Date(e["START-DATE"]), "END-DATE" in this.attr) {
      const n = new Date(this.attr["END-DATE"]);
      et(n.getTime()) && (this._endDate = n);
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    if (this._endDate)
      return this._endDate;
    const e = this.duration;
    return e !== null ? new Date(this._startDate.getTime() + e * 1e3) : null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const e = this.attr.decimalFloatingPoint("DURATION");
      if (et(e))
        return e;
    } else if (this._endDate)
      return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
    return null;
  }
  get plannedDuration() {
    return "PLANNED-DURATION" in this.attr ? this.attr.decimalFloatingPoint("PLANNED-DURATION") : null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && et(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
  }
}
class C0 {
  constructor() {
    this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
      start: 0,
      first: 0,
      end: 0
    }, this.parsing = {
      start: 0,
      end: 0
    }, this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}
var or = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class eU {
  // baseurl is the URL to the playlist
  // relurl is the portion of the URL that comes from inside the playlist.
  // Holds the types of data this fragment supports
  constructor(e) {
    this._byteRange = null, this._url = null, this.baseurl = void 0, this.relurl = void 0, this.elementaryStreams = {
      [or.AUDIO]: null,
      [or.VIDEO]: null,
      [or.AUDIOVIDEO]: null
    }, this.baseurl = e;
  }
  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(e, r) {
    const n = e.split("@", 2), s = [];
    n.length === 1 ? s[0] = r ? r.byteRangeEndOffset : 0 : s[0] = parseInt(n[1]), s[1] = parseInt(n[0]) + s[0], this._byteRange = s;
  }
  get byteRange() {
    return this._byteRange ? this._byteRange : [];
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get url() {
    return !this._url && this.baseurl && this.relurl && (this._url = Bk.buildAbsoluteURL(this.baseurl, this.relurl, {
      alwaysNormalize: !0
    })), this._url || "";
  }
  set url(e) {
    this._url = e;
  }
}
class b_ extends eU {
  // EXTINF has to be present for a m3u8 to be considered valid
  // sn notates the sequence number for a segment, and if set to a string can be 'initSegment'
  // levelkeys are the EXT-X-KEY tags that apply to this segment for decryption
  // core difference from the private field _decryptdata is the lack of the initialized IV
  // _decryptdata will set the IV for this segment based on the segment number in the fragment
  // A string representing the fragment type
  // A reference to the loader. Set while the fragment is loading, and removed afterwards. Used to abort fragment loading
  // A reference to the key loader. Set while the key is loading, and removed afterwards. Used to abort key loading
  // The level/track index to which the fragment belongs
  // The continuity counter of the fragment
  // The starting Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
  // The ending Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
  // The starting Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
  // The ending Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
  // The start time of the fragment, as listed in the manifest. Updated after transmux complete.
  // Set by `updateFragPTSDTS` in level-helper
  // The maximum starting Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
  // The minimum ending Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
  // Load/parse timing information
  // A flag indicating whether the segment was downloaded in order to test bitrate, and was not buffered
  // #EXTINF  segment title
  // The Media Initialization Section for this segment
  // Fragment is the last fragment in the media playlist
  // Fragment is marked by an EXT-X-GAP tag indicating that it does not contain media data and should not be loaded
  constructor(e, r) {
    super(r), this._decryptdata = null, this.rawProgramDateTime = null, this.programDateTime = null, this.tagList = [], this.duration = 0, this.sn = 0, this.levelkeys = void 0, this.type = void 0, this.loader = null, this.keyLoader = null, this.level = -1, this.cc = 0, this.startPTS = void 0, this.endPTS = void 0, this.startDTS = void 0, this.endDTS = void 0, this.start = 0, this.deltaPTS = void 0, this.maxStartPTS = void 0, this.minEndPTS = void 0, this.stats = new C0(), this.urlId = 0, this.data = void 0, this.bitrateTest = !1, this.title = null, this.initSegment = null, this.endList = void 0, this.gap = void 0, this.type = e;
  }
  get decryptdata() {
    const {
      levelkeys: e
    } = this;
    if (!e && !this._decryptdata)
      return null;
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const r = this.levelkeys.identity;
      if (r)
        this._decryptdata = r.getDecryptData(this.sn);
      else {
        const n = Object.keys(this.levelkeys);
        if (n.length === 1)
          return this._decryptdata = this.levelkeys[n[0]].getDecryptData(this.sn);
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null || !et(this.programDateTime))
      return null;
    const e = et(this.duration) ? this.duration : 0;
    return this.programDateTime + e * 1e3;
  }
  get encrypted() {
    var e;
    if ((e = this._decryptdata) != null && e.encrypted)
      return !0;
    if (this.levelkeys) {
      const r = Object.keys(this.levelkeys), n = r.length;
      if (n > 1 || n === 1 && this.levelkeys[r[0]].encrypted)
        return !0;
    }
    return !1;
  }
  setKeyFormat(e) {
    if (this.levelkeys) {
      const r = this.levelkeys[e];
      r && !this._decryptdata && (this._decryptdata = r.getDecryptData(this.sn));
    }
  }
  abortRequests() {
    var e, r;
    (e = this.loader) == null || e.abort(), (r = this.keyLoader) == null || r.abort();
  }
  setElementaryStreamInfo(e, r, n, s, a, o = !1) {
    const {
      elementaryStreams: l
    } = this, u = l[e];
    if (!u) {
      l[e] = {
        startPTS: r,
        endPTS: n,
        startDTS: s,
        endDTS: a,
        partial: o
      };
      return;
    }
    u.startPTS = Math.min(u.startPTS, r), u.endPTS = Math.max(u.endPTS, n), u.startDTS = Math.min(u.startDTS, s), u.endDTS = Math.max(u.endDTS, a);
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams: e
    } = this;
    e[or.AUDIO] = null, e[or.VIDEO] = null, e[or.AUDIOVIDEO] = null;
  }
}
class pQ extends eU {
  constructor(e, r, n, s, a) {
    super(n), this.fragOffset = 0, this.duration = 0, this.gap = !1, this.independent = !1, this.relurl = void 0, this.fragment = void 0, this.index = void 0, this.stats = new C0(), this.duration = e.decimalFloatingPoint("DURATION"), this.gap = e.bool("GAP"), this.independent = e.bool("INDEPENDENT"), this.relurl = e.enumeratedString("URI"), this.fragment = r, this.index = s;
    const o = e.enumeratedString("BYTERANGE");
    o && this.setByteRange(o, a), a && (this.fragOffset = a.fragOffset + a.duration);
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams: e
    } = this;
    return !!(e.audio || e.video || e.audiovideo);
  }
}
const vQ = 10;
class mQ {
  // Manifest reload synchronization
  constructor(e) {
    this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.dateRanges = void 0, this.live = !0, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.availabilityDelay = void 0, this.misses = 0, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.encryptedFragments = void 0, this.playlistParsingError = null, this.variableList = null, this.hasVariableRefs = !1, this.fragments = [], this.encryptedFragments = [], this.dateRanges = {}, this.url = e;
  }
  reloaded(e) {
    if (!e) {
      this.advanced = !0, this.updated = !0;
      return;
    }
    const r = this.lastPartSn - e.lastPartSn, n = this.lastPartIndex - e.lastPartIndex;
    this.updated = this.endSN !== e.endSN || !!n || !!r, this.advanced = this.endSN > e.endSN || r > 0 || r === 0 && n > 0, this.updated || this.advanced ? this.misses = Math.floor(e.misses * 0.6) : this.misses = e.misses + 1, this.availabilityDelay = e.availabilityDelay;
  }
  get hasProgramDateTime() {
    return this.fragments.length ? et(this.fragments[this.fragments.length - 1].programDateTime) : !1;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || vQ;
  }
  get drift() {
    const e = this.driftEndTime - this.driftStartTime;
    return e > 0 ? (this.driftEnd - this.driftStart) * 1e3 / e : 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
  }
  get fragmentEnd() {
    var e;
    return (e = this.fragments) != null && e.length ? this.fragments[this.fragments.length - 1].end : 0;
  }
  get age() {
    return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
  }
  get lastPartIndex() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].index : -1;
  }
  get lastPartSn() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
  }
}
function Uk(t) {
  return Uint8Array.from(atob(t), (e) => e.charCodeAt(0));
}
function gQ(t) {
  const e = tU(t).subarray(0, 16), r = new Uint8Array(16);
  return r.set(e, 16 - e.length), r;
}
function yQ(t) {
  const e = function(n, s, a) {
    const o = n[s];
    n[s] = n[a], n[a] = o;
  };
  e(t, 0, 3), e(t, 1, 2), e(t, 4, 5), e(t, 6, 7);
}
function bQ(t) {
  const e = t.split(":");
  let r = null;
  if (e[0] === "data" && e.length === 2) {
    const n = e[1].split(";"), s = n[n.length - 1].split(",");
    if (s.length === 2) {
      const a = s[0] === "base64", o = s[1];
      a ? (n.splice(-1, 1), r = Uk(o)) : r = gQ(o);
    }
  }
  return r;
}
function tU(t) {
  return Uint8Array.from(unescape(encodeURIComponent(t)), (e) => e.charCodeAt(0));
}
var Pr = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
}, bi = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function xI(t) {
  switch (t) {
    case bi.FAIRPLAY:
      return Pr.FAIRPLAY;
    case bi.PLAYREADY:
      return Pr.PLAYREADY;
    case bi.WIDEVINE:
      return Pr.WIDEVINE;
    case bi.CLEARKEY:
      return Pr.CLEARKEY;
  }
}
var rU = {
  WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function _Q(t) {
  if (t === rU.WIDEVINE)
    return Pr.WIDEVINE;
}
function SI(t) {
  switch (t) {
    case Pr.FAIRPLAY:
      return bi.FAIRPLAY;
    case Pr.PLAYREADY:
      return bi.PLAYREADY;
    case Pr.WIDEVINE:
      return bi.WIDEVINE;
    case Pr.CLEARKEY:
      return bi.CLEARKEY;
  }
}
function __(t) {
  const {
    drmSystems: e,
    widevineLicenseUrl: r
  } = t, n = e ? [Pr.FAIRPLAY, Pr.WIDEVINE, Pr.PLAYREADY, Pr.CLEARKEY].filter((s) => !!e[s]) : [];
  return !n[Pr.WIDEVINE] && r && n.push(Pr.WIDEVINE), n;
}
const nU = function() {
  return typeof self < "u" && self.navigator && self.navigator.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
}();
function wQ(t, e, r, n) {
  let s;
  switch (t) {
    case Pr.FAIRPLAY:
      s = ["cenc", "sinf"];
      break;
    case Pr.WIDEVINE:
    case Pr.PLAYREADY:
      s = ["cenc"];
      break;
    case Pr.CLEARKEY:
      s = ["cenc", "keyids"];
      break;
    default:
      throw new Error(`Unknown key-system: ${t}`);
  }
  return TQ(s, e, r, n);
}
function TQ(t, e, r, n) {
  return [{
    initDataTypes: t,
    persistentState: n.persistentState || "not-allowed",
    distinctiveIdentifier: n.distinctiveIdentifier || "not-allowed",
    sessionTypes: n.sessionTypes || [n.sessionType || "temporary"],
    audioCapabilities: e.map((a) => ({
      contentType: `audio/mp4; codecs="${a}"`,
      robustness: n.audioRobustness || "",
      encryptionScheme: n.audioEncryptionScheme || null
    })),
    videoCapabilities: r.map((a) => ({
      contentType: `video/mp4; codecs="${a}"`,
      robustness: n.videoRobustness || "",
      encryptionScheme: n.videoEncryptionScheme || null
    }))
  }];
}
function _u(t, e, r) {
  return Uint8Array.prototype.slice ? t.slice(e, r) : new Uint8Array(Array.prototype.slice.call(t, e, r));
}
const Vk = (t, e) => e + 10 <= t.length && t[e] === 73 && t[e + 1] === 68 && t[e + 2] === 51 && t[e + 3] < 255 && t[e + 4] < 255 && t[e + 6] < 128 && t[e + 7] < 128 && t[e + 8] < 128 && t[e + 9] < 128, iU = (t, e) => e + 10 <= t.length && t[e] === 51 && t[e + 1] === 68 && t[e + 2] === 73 && t[e + 3] < 255 && t[e + 4] < 255 && t[e + 6] < 128 && t[e + 7] < 128 && t[e + 8] < 128 && t[e + 9] < 128, sy = (t, e) => {
  const r = e;
  let n = 0;
  for (; Vk(t, e); ) {
    n += 10;
    const s = I0(t, e + 6);
    n += s, iU(t, e + 10) && (n += 10), e += n;
  }
  if (n > 0)
    return t.subarray(r, r + n);
}, I0 = (t, e) => {
  let r = 0;
  return r = (t[e] & 127) << 21, r |= (t[e + 1] & 127) << 14, r |= (t[e + 2] & 127) << 7, r |= t[e + 3] & 127, r;
}, xQ = (t, e) => Vk(t, e) && I0(t, e + 6) + 10 <= t.length - e, SQ = (t) => {
  const e = aU(t);
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (sU(n))
      return AQ(n);
  }
}, sU = (t) => t && t.key === "PRIV" && t.info === "com.apple.streaming.transportStreamTimestamp", EQ = (t) => {
  const e = String.fromCharCode(t[0], t[1], t[2], t[3]), r = I0(t, 4), n = 10;
  return {
    type: e,
    size: r,
    data: t.subarray(n, n + r)
  };
}, aU = (t) => {
  let e = 0;
  const r = [];
  for (; Vk(t, e); ) {
    const n = I0(t, e + 6);
    e += 10;
    const s = e + n;
    for (; e + 8 < s; ) {
      const a = EQ(t.subarray(e)), o = $Q(a);
      o && r.push(o), e += a.size + 10;
    }
    iU(t, e) && (e += 10);
  }
  return r;
}, $Q = (t) => t.type === "PRIV" ? kQ(t) : t.type[0] === "W" ? OQ(t) : DQ(t), kQ = (t) => {
  if (t.size < 2)
    return;
  const e = xa(t.data, !0), r = new Uint8Array(t.data.subarray(e.length + 1));
  return {
    key: t.type,
    info: e,
    data: r.buffer
  };
}, DQ = (t) => {
  if (t.size < 2)
    return;
  if (t.type === "TXXX") {
    let r = 1;
    const n = xa(t.data.subarray(r), !0);
    r += n.length + 1;
    const s = xa(t.data.subarray(r));
    return {
      key: t.type,
      info: n,
      data: s
    };
  }
  const e = xa(t.data.subarray(1));
  return {
    key: t.type,
    data: e
  };
}, OQ = (t) => {
  if (t.type === "WXXX") {
    if (t.size < 2)
      return;
    let r = 1;
    const n = xa(t.data.subarray(r), !0);
    r += n.length + 1;
    const s = xa(t.data.subarray(r));
    return {
      key: t.type,
      info: n,
      data: s
    };
  }
  const e = xa(t.data);
  return {
    key: t.type,
    data: e
  };
}, AQ = (t) => {
  if (t.data.byteLength === 8) {
    const e = new Uint8Array(t.data), r = e[3] & 1;
    let n = (e[4] << 23) + (e[5] << 15) + (e[6] << 7) + e[7];
    return n /= 45, r && (n += 4772185884e-2), Math.round(n);
  }
}, xa = (t, e = !1) => {
  const r = CQ();
  if (r) {
    const c = r.decode(t);
    if (e) {
      const d = c.indexOf("\0");
      return d !== -1 ? c.substring(0, d) : c;
    }
    return c.replace(/\0/g, "");
  }
  const n = t.length;
  let s, a, o, l = "", u = 0;
  for (; u < n; ) {
    if (s = t[u++], s === 0 && e)
      return l;
    if (s === 0 || s === 3)
      continue;
    switch (s >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        l += String.fromCharCode(s);
        break;
      case 12:
      case 13:
        a = t[u++], l += String.fromCharCode((s & 31) << 6 | a & 63);
        break;
      case 14:
        a = t[u++], o = t[u++], l += String.fromCharCode((s & 15) << 12 | (a & 63) << 6 | (o & 63) << 0);
        break;
    }
  }
  return l;
};
let w_;
function CQ() {
  return !w_ && typeof self.TextDecoder < "u" && (w_ = new self.TextDecoder("utf-8")), w_;
}
const da = {
  hexDump: function(t) {
    let e = "";
    for (let r = 0; r < t.length; r++) {
      let n = t[r].toString(16);
      n.length < 2 && (n = "0" + n), e += n;
    }
    return e;
  }
}, ay = Math.pow(2, 32) - 1, IQ = [].push, oU = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function Cn(t) {
  return String.fromCharCode.apply(null, t);
}
function lU(t, e) {
  const r = t[e] << 8 | t[e + 1];
  return r < 0 ? 65536 + r : r;
}
function ht(t, e) {
  const r = uU(t, e);
  return r < 0 ? 4294967296 + r : r;
}
function uU(t, e) {
  return t[e] << 24 | t[e + 1] << 16 | t[e + 2] << 8 | t[e + 3];
}
function T_(t, e, r) {
  t[e] = r >> 24, t[e + 1] = r >> 16 & 255, t[e + 2] = r >> 8 & 255, t[e + 3] = r & 255;
}
function Nt(t, e) {
  const r = [];
  if (!e.length)
    return r;
  const n = t.byteLength;
  for (let s = 0; s < n; ) {
    const a = ht(t, s), o = Cn(t.subarray(s + 4, s + 8)), l = a > 1 ? s + a : n;
    if (o === e[0])
      if (e.length === 1)
        r.push(t.subarray(s + 8, l));
      else {
        const u = Nt(t.subarray(s + 8, l), e.slice(1));
        u.length && IQ.apply(r, u);
      }
    s = l;
  }
  return r;
}
function PQ(t) {
  const e = [], r = t[0];
  let n = 8;
  const s = ht(t, n);
  n += 4;
  const a = 0, o = 0;
  r === 0 ? n += 8 : n += 16, n += 2;
  let l = t.length + o;
  const u = lU(t, n);
  n += 2;
  for (let c = 0; c < u; c++) {
    let d = n;
    const h = ht(t, d);
    d += 4;
    const f = h & 2147483647;
    if ((h & 2147483648) >>> 31 === 1)
      return J.warn("SIDX has hierarchical references (not supported)"), null;
    const m = ht(t, d);
    d += 4, e.push({
      referenceSize: f,
      subsegmentDuration: m,
      // unscaled
      info: {
        duration: m / s,
        start: l,
        end: l + f - 1
      }
    }), l += f, d += 4, n = d;
  }
  return {
    earliestPresentationTime: a,
    timescale: s,
    version: r,
    referencesCount: u,
    references: e
  };
}
function cU(t) {
  const e = [], r = Nt(t, ["moov", "trak"]);
  for (let s = 0; s < r.length; s++) {
    const a = r[s], o = Nt(a, ["tkhd"])[0];
    if (o) {
      let l = o[0], u = l === 0 ? 12 : 20;
      const c = ht(o, u), d = Nt(a, ["mdia", "mdhd"])[0];
      if (d) {
        l = d[0], u = l === 0 ? 12 : 20;
        const h = ht(d, u), f = Nt(a, ["mdia", "hdlr"])[0];
        if (f) {
          const p = Cn(f.subarray(8, 12)), m = {
            soun: or.AUDIO,
            vide: or.VIDEO
          }[p];
          if (m) {
            const b = Nt(a, ["mdia", "minf", "stbl", "stsd"])[0];
            let y;
            b && (y = Cn(b.subarray(12, 16))), e[c] = {
              timescale: h,
              type: m
            }, e[m] = {
              timescale: h,
              id: c,
              codec: y
            };
          }
        }
      }
    }
  }
  return Nt(t, ["moov", "mvex", "trex"]).forEach((s) => {
    const a = ht(s, 4), o = e[a];
    o && (o.default = {
      duration: ht(s, 12),
      flags: ht(s, 20)
    });
  }), e;
}
function RQ(t, e) {
  if (!t || !e)
    return t;
  const r = e.keyId;
  return r && e.isCommonEncryption && Nt(t, ["moov", "trak"]).forEach((s) => {
    const o = Nt(s, ["mdia", "minf", "stbl", "stsd"])[0].subarray(8);
    let l = Nt(o, ["enca"]);
    const u = l.length > 0;
    u || (l = Nt(o, ["encv"])), l.forEach((c) => {
      const d = u ? c.subarray(28) : c.subarray(78);
      Nt(d, ["sinf"]).forEach((f) => {
        const p = dU(f);
        if (p) {
          const m = p.subarray(8, 24);
          m.some((b) => b !== 0) || (J.log(`[eme] Patching keyId in 'enc${u ? "a" : "v"}>sinf>>tenc' box: ${da.hexDump(m)} -> ${da.hexDump(r)}`), p.set(r, 8));
        }
      });
    });
  }), t;
}
function dU(t) {
  const e = Nt(t, ["schm"])[0];
  if (e) {
    const r = Cn(e.subarray(4, 8));
    if (r === "cbcs" || r === "cenc")
      return Nt(t, ["schi", "tenc"])[0];
  }
  return J.error("[eme] missing 'schm' box"), null;
}
function MQ(t, e) {
  return Nt(e, ["moof", "traf"]).reduce((r, n) => {
    const s = Nt(n, ["tfdt"])[0], a = s[0], o = Nt(n, ["tfhd"]).reduce((l, u) => {
      const c = ht(u, 4), d = t[c];
      if (d) {
        let h = ht(s, 4);
        if (a === 1) {
          if (h === ay)
            return J.warn("[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time"), l;
          h *= ay + 1, h += ht(s, 8);
        }
        const f = d.timescale || 9e4, p = h / f;
        if (isFinite(p) && (l === null || p < l))
          return p;
      }
      return l;
    }, null);
    return o !== null && isFinite(o) && (r === null || o < r) ? o : r;
  }, null);
}
function LQ(t, e) {
  let r = 0, n = 0, s = 0;
  const a = Nt(t, ["moof", "traf"]);
  for (let o = 0; o < a.length; o++) {
    const l = a[o], u = Nt(l, ["tfhd"])[0], c = ht(u, 4), d = e[c];
    if (!d)
      continue;
    const h = d.default, f = ht(u, 0) | (h == null ? void 0 : h.flags);
    let p = h == null ? void 0 : h.duration;
    f & 8 && (f & 2 ? p = ht(u, 12) : p = ht(u, 8));
    const m = d.timescale || 9e4, b = Nt(l, ["trun"]);
    for (let y = 0; y < b.length; y++) {
      if (r = NQ(b[y]), !r && p) {
        const _ = ht(b[y], 4);
        r = p * _;
      }
      d.type === or.VIDEO ? n += r / m : d.type === or.AUDIO && (s += r / m);
    }
  }
  if (n === 0 && s === 0) {
    let o = 0;
    const l = Nt(t, ["sidx"]);
    for (let u = 0; u < l.length; u++) {
      const c = PQ(l[u]);
      c != null && c.references && (o += c.references.reduce((d, h) => d + h.info.duration || 0, 0));
    }
    return o;
  }
  return n || s;
}
function NQ(t) {
  const e = ht(t, 0);
  let r = 8;
  e & 1 && (r += 4), e & 4 && (r += 4);
  let n = 0;
  const s = ht(t, 4);
  for (let a = 0; a < s; a++) {
    if (e & 256) {
      const o = ht(t, r);
      n += o, r += 4;
    }
    e & 512 && (r += 4), e & 1024 && (r += 4), e & 2048 && (r += 4);
  }
  return n;
}
function FQ(t, e, r) {
  Nt(e, ["moof", "traf"]).forEach((n) => {
    Nt(n, ["tfhd"]).forEach((s) => {
      const a = ht(s, 4), o = t[a];
      if (!o)
        return;
      const l = o.timescale || 9e4;
      Nt(n, ["tfdt"]).forEach((u) => {
        const c = u[0];
        let d = ht(u, 4);
        if (c === 0)
          d -= r * l, d = Math.max(d, 0), T_(u, 4, d);
        else {
          d *= Math.pow(2, 32), d += ht(u, 8), d -= r * l, d = Math.max(d, 0);
          const h = Math.floor(d / (ay + 1)), f = Math.floor(d % (ay + 1));
          T_(u, 4, h), T_(u, 8, f);
        }
      });
    });
  });
}
function BQ(t) {
  const e = {
    valid: null,
    remainder: null
  }, r = Nt(t, ["moof"]);
  if (r) {
    if (r.length < 2)
      return e.remainder = t, e;
  } else
    return e;
  const n = r[r.length - 1];
  return e.valid = _u(t, 0, n.byteOffset - 8), e.remainder = _u(t, n.byteOffset - 8), e;
}
function Bu(t, e) {
  const r = new Uint8Array(t.length + e.length);
  return r.set(t), r.set(e, t.length), r;
}
function EI(t, e) {
  const r = [], n = e.samples, s = e.timescale, a = e.id;
  let o = !1;
  return Nt(n, ["moof"]).map((u) => {
    const c = u.byteOffset - 8;
    Nt(u, ["traf"]).map((h) => {
      const f = Nt(h, ["tfdt"]).map((p) => {
        const m = p[0];
        let b = ht(p, 4);
        return m === 1 && (b *= Math.pow(2, 32), b += ht(p, 8)), b / s;
      })[0];
      return f !== void 0 && (t = f), Nt(h, ["tfhd"]).map((p) => {
        const m = ht(p, 4), b = ht(p, 0) & 16777215, y = (b & 1) !== 0, _ = (b & 2) !== 0, x = (b & 8) !== 0;
        let T = 0;
        const k = (b & 16) !== 0;
        let E = 0;
        const F = (b & 32) !== 0;
        let R = 8;
        m === a && (y && (R += 8), _ && (R += 4), x && (T = ht(p, R), R += 4), k && (E = ht(p, R), R += 4), F && (R += 4), e.type === "video" && (o = UQ(e.codec)), Nt(h, ["trun"]).map(($) => {
          const O = $[0], P = ht($, 0) & 16777215, N = (P & 1) !== 0;
          let I = 0;
          const B = (P & 4) !== 0, W = (P & 256) !== 0;
          let Q = 0;
          const te = (P & 512) !== 0;
          let H = 0;
          const A = (P & 1024) !== 0, V = (P & 2048) !== 0;
          let M = 0;
          const Z = ht($, 4);
          let U = 8;
          N && (I = ht($, U), U += 4), B && (U += 4);
          let pe = I + c;
          for (let q = 0; q < Z; q++) {
            if (W ? (Q = ht($, U), U += 4) : Q = T, te ? (H = ht($, U), U += 4) : H = E, A && (U += 4), V && (O === 0 ? M = ht($, U) : M = uU($, U), U += 4), e.type === or.VIDEO) {
              let Y = 0;
              for (; Y < H; ) {
                const se = ht(n, pe);
                if (pe += 4, VQ(o, n[pe])) {
                  const he = n.subarray(pe, pe + se);
                  hU(he, o ? 2 : 1, t + M / s, r);
                }
                pe += se, Y += se + 4;
              }
            }
            t += Q / s;
          }
        }));
      });
    });
  }), r;
}
function UQ(t) {
  if (!t)
    return !1;
  const e = t.indexOf("."), r = e < 0 ? t : t.substring(0, e);
  return r === "hvc1" || r === "hev1" || // Dolby Vision
  r === "dvh1" || r === "dvhe";
}
function VQ(t, e) {
  if (t) {
    const r = e >> 1 & 63;
    return r === 39 || r === 40;
  } else
    return (e & 31) === 6;
}
function hU(t, e, r, n) {
  const s = fU(t);
  let a = 0;
  a += e;
  let o = 0, l = 0, u = !1, c = 0;
  for (; a < s.length; ) {
    o = 0;
    do {
      if (a >= s.length)
        break;
      c = s[a++], o += c;
    } while (c === 255);
    l = 0;
    do {
      if (a >= s.length)
        break;
      c = s[a++], l += c;
    } while (c === 255);
    const d = s.length - a;
    if (!u && o === 4 && a < s.length) {
      if (u = !0, s[a++] === 181) {
        const f = lU(s, a);
        if (a += 2, f === 49) {
          const p = ht(s, a);
          if (a += 4, p === 1195456820) {
            const m = s[a++];
            if (m === 3) {
              const b = s[a++], y = 31 & b, _ = 64 & b, x = _ ? 2 + y * 3 : 0, T = new Uint8Array(x);
              if (_) {
                T[0] = b;
                for (let k = 1; k < x; k++)
                  T[k] = s[a++];
              }
              n.push({
                type: m,
                payloadType: o,
                pts: r,
                bytes: T
              });
            }
          }
        }
      }
    } else if (o === 5 && l < d) {
      if (u = !0, l > 16) {
        const h = [];
        for (let m = 0; m < 16; m++) {
          const b = s[a++].toString(16);
          h.push(b.length == 1 ? "0" + b : b), (m === 3 || m === 5 || m === 7 || m === 9) && h.push("-");
        }
        const f = l - 16, p = new Uint8Array(f);
        for (let m = 0; m < f; m++)
          p[m] = s[a++];
        n.push({
          payloadType: o,
          pts: r,
          uuid: h.join(""),
          userData: xa(p),
          userDataBytes: p
        });
      }
    } else if (l < d)
      a += l;
    else if (l > d)
      break;
  }
}
function fU(t) {
  const e = t.byteLength, r = [];
  let n = 1;
  for (; n < e - 2; )
    t[n] === 0 && t[n + 1] === 0 && t[n + 2] === 3 ? (r.push(n + 2), n += 2) : n++;
  if (r.length === 0)
    return t;
  const s = e - r.length, a = new Uint8Array(s);
  let o = 0;
  for (n = 0; n < s; o++, n++)
    o === r[0] && (o++, r.shift()), a[n] = t[o];
  return a;
}
function YQ(t) {
  const e = t[0];
  let r = "", n = "", s = 0, a = 0, o = 0, l = 0, u = 0, c = 0;
  if (e === 0) {
    for (; Cn(t.subarray(c, c + 1)) !== "\0"; )
      r += Cn(t.subarray(c, c + 1)), c += 1;
    for (r += Cn(t.subarray(c, c + 1)), c += 1; Cn(t.subarray(c, c + 1)) !== "\0"; )
      n += Cn(t.subarray(c, c + 1)), c += 1;
    n += Cn(t.subarray(c, c + 1)), c += 1, s = ht(t, 12), a = ht(t, 16), l = ht(t, 20), u = ht(t, 24), c = 28;
  } else if (e === 1) {
    c += 4, s = ht(t, c), c += 4;
    const h = ht(t, c);
    c += 4;
    const f = ht(t, c);
    for (c += 4, o = 2 ** 32 * h + f, Number.isSafeInteger(o) || (o = Number.MAX_SAFE_INTEGER, J.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")), l = ht(t, c), c += 4, u = ht(t, c), c += 4; Cn(t.subarray(c, c + 1)) !== "\0"; )
      r += Cn(t.subarray(c, c + 1)), c += 1;
    for (r += Cn(t.subarray(c, c + 1)), c += 1; Cn(t.subarray(c, c + 1)) !== "\0"; )
      n += Cn(t.subarray(c, c + 1)), c += 1;
    n += Cn(t.subarray(c, c + 1)), c += 1;
  }
  const d = t.subarray(c, t.byteLength);
  return {
    schemeIdUri: r,
    value: n,
    timeScale: s,
    presentationTime: o,
    presentationTimeDelta: a,
    eventDuration: l,
    id: u,
    payload: d
  };
}
function HQ(t, ...e) {
  const r = e.length;
  let n = 8, s = r;
  for (; s--; )
    n += e[s].byteLength;
  const a = new Uint8Array(n);
  for (a[0] = n >> 24 & 255, a[1] = n >> 16 & 255, a[2] = n >> 8 & 255, a[3] = n & 255, a.set(t, 4), s = 0, n = 8; s < r; s++)
    a.set(e[s], n), n += e[s].byteLength;
  return a;
}
function GQ(t, e, r) {
  if (t.byteLength !== 16)
    throw new RangeError("Invalid system id");
  let n, s;
  if (e) {
    n = 1, s = new Uint8Array(e.length * 16);
    for (let l = 0; l < e.length; l++) {
      const u = e[l];
      if (u.byteLength !== 16)
        throw new RangeError("Invalid key");
      s.set(u, l * 16);
    }
  } else
    n = 0, s = new Uint8Array();
  let a;
  n > 0 ? (a = new Uint8Array(4), e.length > 0 && new DataView(a.buffer).setUint32(0, e.length, !1)) : a = new Uint8Array();
  const o = new Uint8Array(4);
  return r && r.byteLength > 0 && new DataView(o.buffer).setUint32(0, r.byteLength, !1), HQ(
    [112, 115, 115, 104],
    new Uint8Array([
      n,
      0,
      0,
      0
      // Flags
    ]),
    t,
    // 16 bytes
    a,
    s,
    o,
    r || new Uint8Array()
  );
}
function WQ(t) {
  if (!(t instanceof ArrayBuffer) || t.byteLength < 32)
    return null;
  const e = {
    version: 0,
    systemId: "",
    kids: null,
    data: null
  }, r = new DataView(t), n = r.getUint32(0);
  if (t.byteLength !== n && n > 44 || r.getUint32(4) !== 1886614376 || (e.version = r.getUint32(8) >>> 24, e.version > 1))
    return null;
  e.systemId = da.hexDump(new Uint8Array(t, 12, 16));
  const a = r.getUint32(28);
  if (e.version === 0) {
    if (n - 32 < a)
      return null;
    e.data = new Uint8Array(t, 32, a);
  } else if (e.version === 1) {
    e.kids = [];
    for (let o = 0; o < a; o++)
      e.kids.push(new Uint8Array(t, 32 + o * 16, 16));
  }
  return e;
}
let mm = {};
class qf {
  static clearKeyUriToKeyIdMap() {
    mm = {};
  }
  constructor(e, r, n, s = [1], a = null) {
    this.uri = void 0, this.method = void 0, this.keyFormat = void 0, this.keyFormatVersions = void 0, this.encrypted = void 0, this.isCommonEncryption = void 0, this.iv = null, this.key = null, this.keyId = null, this.pssh = null, this.method = e, this.uri = r, this.keyFormat = n, this.keyFormatVersions = s, this.iv = a, this.encrypted = e ? e !== "NONE" : !1, this.isCommonEncryption = this.encrypted && e !== "AES-128";
  }
  isSupported() {
    if (this.method) {
      if (this.method === "AES-128" || this.method === "NONE")
        return !0;
      if (this.keyFormat === "identity")
        return this.method === "SAMPLE-AES";
      switch (this.keyFormat) {
        case bi.FAIRPLAY:
        case bi.WIDEVINE:
        case bi.PLAYREADY:
        case bi.CLEARKEY:
          return ["ISO-23001-7", "SAMPLE-AES", "SAMPLE-AES-CENC", "SAMPLE-AES-CTR"].indexOf(this.method) !== -1;
      }
    }
    return !1;
  }
  getDecryptData(e) {
    if (!this.encrypted || !this.uri)
      return null;
    if (this.method === "AES-128" && this.uri && !this.iv) {
      typeof e != "number" && (this.method === "AES-128" && !this.iv && J.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`), e = 0);
      const n = jQ(e);
      return new qf(this.method, this.uri, "identity", this.keyFormatVersions, n);
    }
    const r = bQ(this.uri);
    if (r)
      switch (this.keyFormat) {
        case bi.WIDEVINE:
          this.pssh = r, r.length >= 22 && (this.keyId = r.subarray(r.length - 22, r.length - 6));
          break;
        case bi.PLAYREADY: {
          const n = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
          this.pssh = GQ(n, null, r);
          const s = new Uint16Array(r.buffer, r.byteOffset, r.byteLength / 2), a = String.fromCharCode.apply(null, Array.from(s)), o = a.substring(a.indexOf("<"), a.length), c = new DOMParser().parseFromString(o, "text/xml").getElementsByTagName("KID")[0];
          if (c) {
            const d = c.childNodes[0] ? c.childNodes[0].nodeValue : c.getAttribute("VALUE");
            if (d) {
              const h = Uk(d).subarray(0, 16);
              yQ(h), this.keyId = h;
            }
          }
          break;
        }
        default: {
          let n = r.subarray(0, 16);
          if (n.length !== 16) {
            const s = new Uint8Array(16);
            s.set(n, 16 - n.length), n = s;
          }
          this.keyId = n;
          break;
        }
      }
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let n = mm[this.uri];
      if (!n) {
        const s = Object.keys(mm).length % Number.MAX_SAFE_INTEGER;
        n = new Uint8Array(16), new DataView(n.buffer, 12, 4).setUint32(0, s), mm[this.uri] = n;
      }
      this.keyId = n;
    }
    return this;
  }
}
function jQ(t) {
  const e = new Uint8Array(16);
  for (let r = 12; r < 16; r++)
    e[r] = t >> 8 * (15 - r) & 255;
  return e;
}
const pU = /\{\$([a-zA-Z0-9-_]+)\}/g;
function $I(t) {
  return pU.test(t);
}
function vi(t, e, r) {
  if (t.variableList !== null || t.hasVariableRefs)
    for (let n = r.length; n--; ) {
      const s = r[n], a = e[s];
      a && (e[s] = QT(t, a));
    }
}
function QT(t, e) {
  if (t.variableList !== null || t.hasVariableRefs) {
    const r = t.variableList;
    return e.replace(pU, (n) => {
      const s = n.substring(2, n.length - 1), a = r == null ? void 0 : r[s];
      return a === void 0 ? (t.playlistParsingError || (t.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${s}"`)), n) : a;
    });
  }
  return e;
}
function kI(t, e, r) {
  let n = t.variableList;
  n || (t.variableList = n = {});
  let s, a;
  if ("QUERYPARAM" in e) {
    s = e.QUERYPARAM;
    try {
      const o = new self.URL(r).searchParams;
      if (o.has(s))
        a = o.get(s);
      else
        throw new Error(`"${s}" does not match any query parameter in URI: "${r}"`);
    } catch (o) {
      t.playlistParsingError || (t.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${o.message}`));
    }
  } else
    s = e.NAME, a = e.VALUE;
  s in n ? t.playlistParsingError || (t.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${s}"`)) : n[s] = a || "";
}
function KQ(t, e, r) {
  const n = e.IMPORT;
  if (r && n in r) {
    let s = t.variableList;
    s || (t.variableList = s = {}), s[n] = r[n];
  } else
    t.playlistParsingError || (t.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${n}"`));
}
function P0() {
  if (!(typeof self > "u"))
    return self.MediaSource || self.WebKitMediaSource;
}
const zQ = {
  audio: {
    a3ds: !0,
    "ac-3": !0,
    "ac-4": !0,
    alac: !0,
    alaw: !0,
    dra1: !0,
    "dts+": !0,
    "dts-": !0,
    dtsc: !0,
    dtse: !0,
    dtsh: !0,
    "ec-3": !0,
    enca: !0,
    g719: !0,
    g726: !0,
    m4ae: !0,
    mha1: !0,
    mha2: !0,
    mhm1: !0,
    mhm2: !0,
    mlpa: !0,
    mp4a: !0,
    "raw ": !0,
    Opus: !0,
    opus: !0,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: !0,
    sawb: !0,
    sawp: !0,
    sevc: !0,
    sqcp: !0,
    ssmv: !0,
    twos: !0,
    ulaw: !0
  },
  video: {
    avc1: !0,
    avc2: !0,
    avc3: !0,
    avc4: !0,
    avcp: !0,
    av01: !0,
    drac: !0,
    dva1: !0,
    dvav: !0,
    dvh1: !0,
    dvhe: !0,
    encv: !0,
    hev1: !0,
    hvc1: !0,
    mjp2: !0,
    mp4v: !0,
    mvc1: !0,
    mvc2: !0,
    mvc3: !0,
    mvc4: !0,
    resv: !0,
    rv60: !0,
    s263: !0,
    svc1: !0,
    svc2: !0,
    "vc-1": !0,
    vp08: !0,
    vp09: !0
  },
  text: {
    stpp: !0,
    wvtt: !0
  }
}, DI = P0();
function qQ(t, e) {
  const r = zQ[e];
  return !!r && r[t.slice(0, 4)] === !0;
}
function x_(t, e) {
  var r;
  return (r = DI == null ? void 0 : DI.isTypeSupported(`${e || "video"}/mp4;codecs="${t}"`)) != null ? r : !1;
}
const OI = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g, AI = /#EXT-X-MEDIA:(.*)/g, XQ = /^#EXT(?:INF|-X-TARGETDURATION):/m, CI = new RegExp([
  /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
  // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
  /(?!#) *(\S[\S ]*)/.source,
  // segment URI, group 3 => the URI (note newline is not eaten)
  /#EXT-X-BYTERANGE:*(.+)/.source,
  // next segment's byterange, group 4 => range spec (x@y)
  /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
  // next segment's program date/time group 5 => the datetime spec
  /#.*/.source
  // All other non-segment oriented tags will match with all groups empty
].join("|"), "g"), QQ = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|"));
class Ms {
  static findGroup(e, r) {
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      if (s.id === r)
        return s;
    }
  }
  static convertAVC1ToAVCOTI(e) {
    const r = e.split(".");
    if (r.length > 2) {
      let n = r.shift() + ".";
      return n += parseInt(r.shift()).toString(16), n += ("000" + parseInt(r.shift()).toString(16)).slice(-4), n;
    }
    return e;
  }
  static resolve(e, r) {
    return Bk.buildAbsoluteURL(r, e, {
      alwaysNormalize: !0
    });
  }
  static isMediaPlaylist(e) {
    return XQ.test(e);
  }
  static parseMasterPlaylist(e, r) {
    const n = $I(e), s = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs: n
    }, a = [];
    OI.lastIndex = 0;
    let o;
    for (; (o = OI.exec(e)) != null; )
      if (o[1]) {
        var l;
        const c = new Ir(o[1]);
        vi(s, c, ["CODECS", "SUPPLEMENTAL-CODECS", "ALLOWED-CPC", "PATHWAY-ID", "STABLE-VARIANT-ID", "AUDIO", "VIDEO", "SUBTITLES", "CLOSED-CAPTIONS", "NAME"]);
        const d = QT(s, o[2]), h = {
          attrs: c,
          bitrate: c.decimalInteger("AVERAGE-BANDWIDTH") || c.decimalInteger("BANDWIDTH"),
          name: c.NAME,
          url: Ms.resolve(d, r)
        }, f = c.decimalResolution("RESOLUTION");
        f && (h.width = f.width, h.height = f.height), ZQ((c.CODECS || "").split(/[ ,]+/).filter((p) => p), h), h.videoCodec && h.videoCodec.indexOf("avc1") !== -1 && (h.videoCodec = Ms.convertAVC1ToAVCOTI(h.videoCodec)), (l = h.unknownCodecs) != null && l.length || a.push(h), s.levels.push(h);
      } else if (o[3]) {
        const c = o[3], d = o[4];
        switch (c) {
          case "SESSION-DATA": {
            const h = new Ir(d);
            vi(s, h, ["DATA-ID", "LANGUAGE", "VALUE", "URI"]);
            const f = h["DATA-ID"];
            f && (s.sessionData === null && (s.sessionData = {}), s.sessionData[f] = h);
            break;
          }
          case "SESSION-KEY": {
            const h = II(d, r, s);
            h.encrypted && h.isSupported() ? (s.sessionKeys === null && (s.sessionKeys = []), s.sessionKeys.push(h)) : J.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${d}"`);
            break;
          }
          case "DEFINE": {
            {
              const h = new Ir(d);
              vi(s, h, ["NAME", "VALUE", "QUERYPARAM"]), kI(s, h, r);
            }
            break;
          }
          case "CONTENT-STEERING": {
            const h = new Ir(d);
            vi(s, h, ["SERVER-URI", "PATHWAY-ID"]), s.contentSteering = {
              uri: Ms.resolve(h["SERVER-URI"], r),
              pathwayId: h["PATHWAY-ID"] || "."
            };
            break;
          }
          case "START": {
            s.startTimeOffset = PI(d);
            break;
          }
        }
      }
    const u = a.length > 0 && a.length < s.levels.length;
    return s.levels = u ? a : s.levels, s.levels.length === 0 && (s.playlistParsingError = new Error("no levels found in manifest")), s;
  }
  static parseMasterPlaylistMedia(e, r, n) {
    let s;
    const a = {}, o = n.levels, l = {
      AUDIO: o.map((c) => ({
        id: c.attrs.AUDIO,
        audioCodec: c.audioCodec
      })),
      SUBTITLES: o.map((c) => ({
        id: c.attrs.SUBTITLES,
        textCodec: c.textCodec
      })),
      "CLOSED-CAPTIONS": []
    };
    let u = 0;
    for (AI.lastIndex = 0; (s = AI.exec(e)) !== null; ) {
      const c = new Ir(s[1]), d = c.TYPE;
      if (d) {
        const h = l[d], f = a[d] || [];
        a[d] = f, vi(n, c, ["URI", "GROUP-ID", "LANGUAGE", "ASSOC-LANGUAGE", "STABLE-RENDITION-ID", "NAME", "INSTREAM-ID", "CHARACTERISTICS", "CHANNELS"]);
        const p = {
          attrs: c,
          bitrate: 0,
          id: u++,
          groupId: c["GROUP-ID"] || "",
          instreamId: c["INSTREAM-ID"],
          name: c.NAME || c.LANGUAGE || "",
          type: d,
          default: c.bool("DEFAULT"),
          autoselect: c.bool("AUTOSELECT"),
          forced: c.bool("FORCED"),
          lang: c.LANGUAGE,
          url: c.URI ? Ms.resolve(c.URI, r) : ""
        };
        if (h != null && h.length) {
          const m = Ms.findGroup(h, p.groupId) || h[0];
          RI(p, m, "audioCodec"), RI(p, m, "textCodec");
        }
        f.push(p);
      }
    }
    return a;
  }
  static parseLevelPlaylist(e, r, n, s, a, o) {
    const l = new mQ(r), u = l.fragments;
    let c = null, d = 0, h = 0, f = 0, p = 0, m = null, b = new b_(s, r), y, _, x, T = -1, k = !1;
    for (CI.lastIndex = 0, l.m3u8 = e, l.hasVariableRefs = $I(e); (y = CI.exec(e)) !== null; ) {
      k && (k = !1, b = new b_(s, r), b.start = f, b.sn = d, b.cc = p, b.level = n, c && (b.initSegment = c, b.rawProgramDateTime = c.rawProgramDateTime, c.rawProgramDateTime = null));
      const $ = y[1];
      if ($) {
        b.duration = parseFloat($);
        const O = (" " + y[2]).slice(1);
        b.title = O || null, b.tagList.push(O ? ["INF", $, O] : ["INF", $]);
      } else if (y[3]) {
        if (et(b.duration)) {
          b.start = f, x && NI(b, x, l), b.sn = d, b.level = n, b.cc = p, b.urlId = a, u.push(b);
          const O = (" " + y[3]).slice(1);
          b.relurl = QT(l, O), MI(b, m), m = b, f += b.duration, d++, h = 0, k = !0;
        }
      } else if (y[4]) {
        const O = (" " + y[4]).slice(1);
        m ? b.setByteRange(O, m) : b.setByteRange(O);
      } else if (y[5])
        b.rawProgramDateTime = (" " + y[5]).slice(1), b.tagList.push(["PROGRAM-DATE-TIME", b.rawProgramDateTime]), T === -1 && (T = u.length);
      else {
        if (y = y[0].match(QQ), !y) {
          J.warn("No matches on slow regex match for level playlist!");
          continue;
        }
        for (_ = 1; _ < y.length && !(typeof y[_] < "u"); _++)
          ;
        const O = (" " + y[_]).slice(1), P = (" " + y[_ + 1]).slice(1), N = y[_ + 2] ? (" " + y[_ + 2]).slice(1) : "";
        switch (O) {
          case "PLAYLIST-TYPE":
            l.type = P.toUpperCase();
            break;
          case "MEDIA-SEQUENCE":
            d = l.startSN = parseInt(P);
            break;
          case "SKIP": {
            const I = new Ir(P);
            vi(l, I, ["RECENTLY-REMOVED-DATERANGES"]);
            const B = I.decimalInteger("SKIPPED-SEGMENTS");
            if (et(B)) {
              l.skippedSegments = B;
              for (let Q = B; Q--; )
                u.unshift(null);
              d += B;
            }
            const W = I.enumeratedString("RECENTLY-REMOVED-DATERANGES");
            W && (l.recentlyRemovedDateranges = W.split("	"));
            break;
          }
          case "TARGETDURATION":
            l.targetduration = Math.max(parseInt(P), 1);
            break;
          case "VERSION":
            l.version = parseInt(P);
            break;
          case "EXTM3U":
            break;
          case "ENDLIST":
            l.live = !1;
            break;
          case "#":
            (P || N) && b.tagList.push(N ? [P, N] : [P]);
            break;
          case "DISCONTINUITY":
            p++, b.tagList.push(["DIS"]);
            break;
          case "GAP":
            b.gap = !0, b.tagList.push([O]);
            break;
          case "BITRATE":
            b.tagList.push([O, P]);
            break;
          case "DATERANGE": {
            const I = new Ir(P);
            vi(l, I, ["ID", "CLASS", "START-DATE", "END-DATE", "SCTE35-CMD", "SCTE35-OUT", "SCTE35-IN"]), vi(l, I, I.clientAttrs);
            const B = new J3(I, l.dateRanges[I.ID]);
            B.isValid || l.skippedSegments ? l.dateRanges[B.id] = B : J.warn(`Ignoring invalid DATERANGE tag: "${P}"`), b.tagList.push(["EXT-X-DATERANGE", P]);
            break;
          }
          case "DEFINE": {
            {
              const I = new Ir(P);
              vi(l, I, ["NAME", "VALUE", "IMPORT", "QUERYPARAM"]), "IMPORT" in I ? KQ(l, I, o) : kI(l, I, r);
            }
            break;
          }
          case "DISCONTINUITY-SEQUENCE":
            p = parseInt(P);
            break;
          case "KEY": {
            const I = II(P, r, l);
            if (I.isSupported()) {
              if (I.method === "NONE") {
                x = void 0;
                break;
              }
              x || (x = {}), x[I.keyFormat] && (x = hn({}, x)), x[I.keyFormat] = I;
            } else
              J.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${P}"`);
            break;
          }
          case "START":
            l.startTimeOffset = PI(P);
            break;
          case "MAP": {
            const I = new Ir(P);
            if (vi(l, I, ["BYTERANGE", "URI"]), b.duration) {
              const B = new b_(s, r);
              LI(B, I, n, x), c = B, b.initSegment = c, c.rawProgramDateTime && !b.rawProgramDateTime && (b.rawProgramDateTime = c.rawProgramDateTime);
            } else
              LI(b, I, n, x), c = b, k = !0;
            break;
          }
          case "SERVER-CONTROL": {
            const I = new Ir(P);
            l.canBlockReload = I.bool("CAN-BLOCK-RELOAD"), l.canSkipUntil = I.optionalFloat("CAN-SKIP-UNTIL", 0), l.canSkipDateRanges = l.canSkipUntil > 0 && I.bool("CAN-SKIP-DATERANGES"), l.partHoldBack = I.optionalFloat("PART-HOLD-BACK", 0), l.holdBack = I.optionalFloat("HOLD-BACK", 0);
            break;
          }
          case "PART-INF": {
            const I = new Ir(P);
            l.partTarget = I.decimalFloatingPoint("PART-TARGET");
            break;
          }
          case "PART": {
            let I = l.partList;
            I || (I = l.partList = []);
            const B = h > 0 ? I[I.length - 1] : void 0, W = h++, Q = new Ir(P);
            vi(l, Q, ["BYTERANGE", "URI"]);
            const te = new pQ(Q, b, r, W, B);
            I.push(te), b.duration += te.duration;
            break;
          }
          case "PRELOAD-HINT": {
            const I = new Ir(P);
            vi(l, I, ["URI"]), l.preloadHint = I;
            break;
          }
          case "RENDITION-REPORT": {
            const I = new Ir(P);
            vi(l, I, ["URI"]), l.renditionReports = l.renditionReports || [], l.renditionReports.push(I);
            break;
          }
          default:
            J.warn(`line parsed but not handled: ${y}`);
            break;
        }
      }
    }
    m && !m.relurl ? (u.pop(), f -= m.duration, l.partList && (l.fragmentHint = m)) : l.partList && (MI(b, m), b.cc = p, l.fragmentHint = b, x && NI(b, x, l));
    const E = u.length, F = u[0], R = u[E - 1];
    if (f += l.skippedSegments * l.targetduration, f > 0 && E && R) {
      l.averagetargetduration = f / E;
      const $ = R.sn;
      l.endSN = $ !== "initSegment" ? $ : 0, l.live || (R.endList = !0), F && (l.startCC = F.cc);
    } else
      l.endSN = 0, l.startCC = 0;
    return l.fragmentHint && (f += l.fragmentHint.duration), l.totalduration = f, l.endCC = p, T > 0 && JQ(u, T), l;
  }
}
function II(t, e, r) {
  var n, s;
  const a = new Ir(t);
  vi(r, a, ["KEYFORMAT", "KEYFORMATVERSIONS", "URI", "IV", "URI"]);
  const o = (n = a.METHOD) != null ? n : "", l = a.URI, u = a.hexadecimalInteger("IV"), c = a.KEYFORMATVERSIONS, d = (s = a.KEYFORMAT) != null ? s : "identity";
  l && a.IV && !u && J.error(`Invalid IV: ${a.IV}`);
  const h = l ? Ms.resolve(l, e) : "", f = (c || "1").split("/").map(Number).filter(Number.isFinite);
  return new qf(o, h, d, f, u);
}
function PI(t) {
  const r = new Ir(t).decimalFloatingPoint("TIME-OFFSET");
  return et(r) ? r : null;
}
function ZQ(t, e) {
  ["video", "audio", "text"].forEach((r) => {
    const n = t.filter((s) => qQ(s, r));
    if (n.length) {
      const s = n.filter((a) => a.lastIndexOf("avc1", 0) === 0 || a.lastIndexOf("mp4a", 0) === 0);
      e[`${r}Codec`] = s.length > 0 ? s[0] : n[0], t = t.filter((a) => n.indexOf(a) === -1);
    }
  }), e.unknownCodecs = t;
}
function RI(t, e, r) {
  const n = e[r];
  n && (t[r] = n);
}
function JQ(t, e) {
  let r = t[e];
  for (let n = e; n--; ) {
    const s = t[n];
    if (!s)
      return;
    s.programDateTime = r.programDateTime - s.duration * 1e3, r = s;
  }
}
function MI(t, e) {
  t.rawProgramDateTime ? t.programDateTime = Date.parse(t.rawProgramDateTime) : e != null && e.programDateTime && (t.programDateTime = e.endProgramDateTime), et(t.programDateTime) || (t.programDateTime = null, t.rawProgramDateTime = null);
}
function LI(t, e, r, n) {
  t.relurl = e.URI, e.BYTERANGE && t.setByteRange(e.BYTERANGE), t.level = r, t.sn = "initSegment", n && (t.levelkeys = n), t.initSegment = null;
}
function NI(t, e, r) {
  t.levelkeys = e;
  const {
    encryptedFragments: n
  } = r;
  (!n.length || n[n.length - 1].levelkeys !== e) && Object.keys(e).some((s) => e[s].isCommonEncryption) && n.push(t);
}
var Vt = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
}, at = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};
function FI(t) {
  const {
    type: e
  } = t;
  switch (e) {
    case Vt.AUDIO_TRACK:
      return at.AUDIO;
    case Vt.SUBTITLE_TRACK:
      return at.SUBTITLE;
    default:
      return at.MAIN;
  }
}
function S_(t, e) {
  let r = t.url;
  return (r === void 0 || r.indexOf("data:") === 0) && (r = e.url), r;
}
class eZ {
  constructor(e) {
    this.hls = void 0, this.loaders = /* @__PURE__ */ Object.create(null), this.variableList = null, this.hls = e, this.registerListeners();
  }
  startLoad(e) {
  }
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(D.MANIFEST_LOADING, this.onManifestLoading, this), e.on(D.LEVEL_LOADING, this.onLevelLoading, this), e.on(D.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.on(D.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(D.MANIFEST_LOADING, this.onManifestLoading, this), e.off(D.LEVEL_LOADING, this.onLevelLoading, this), e.off(D.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.off(D.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(e) {
    const r = this.hls.config, n = r.pLoader, s = r.loader, a = n || s, o = new a(r);
    return this.loaders[e.type] = o, o;
  }
  getInternalLoader(e) {
    return this.loaders[e.type];
  }
  resetInternalLoader(e) {
    this.loaders[e] && delete this.loaders[e];
  }
  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const e in this.loaders) {
      const r = this.loaders[e];
      r && r.destroy(), this.resetInternalLoader(e);
    }
  }
  destroy() {
    this.variableList = null, this.unregisterListeners(), this.destroyInternalLoaders();
  }
  onManifestLoading(e, r) {
    const {
      url: n
    } = r;
    this.variableList = null, this.load({
      id: null,
      level: 0,
      responseType: "text",
      type: Vt.MANIFEST,
      url: n,
      deliveryDirectives: null
    });
  }
  onLevelLoading(e, r) {
    const {
      id: n,
      level: s,
      url: a,
      deliveryDirectives: o
    } = r;
    this.load({
      id: n,
      level: s,
      responseType: "text",
      type: Vt.LEVEL,
      url: a,
      deliveryDirectives: o
    });
  }
  onAudioTrackLoading(e, r) {
    const {
      id: n,
      groupId: s,
      url: a,
      deliveryDirectives: o
    } = r;
    this.load({
      id: n,
      groupId: s,
      level: null,
      responseType: "text",
      type: Vt.AUDIO_TRACK,
      url: a,
      deliveryDirectives: o
    });
  }
  onSubtitleTrackLoading(e, r) {
    const {
      id: n,
      groupId: s,
      url: a,
      deliveryDirectives: o
    } = r;
    this.load({
      id: n,
      groupId: s,
      level: null,
      responseType: "text",
      type: Vt.SUBTITLE_TRACK,
      url: a,
      deliveryDirectives: o
    });
  }
  load(e) {
    var r;
    const n = this.hls.config;
    let s = this.getInternalLoader(e);
    if (s) {
      const c = s.context;
      if (c && c.url === e.url) {
        J.trace("[playlist-loader]: playlist request ongoing");
        return;
      }
      J.log(`[playlist-loader]: aborting previous loader for type: ${e.type}`), s.abort();
    }
    let a;
    if (e.type === Vt.MANIFEST ? a = n.manifestLoadPolicy.default : a = hn({}, n.playlistLoadPolicy.default, {
      timeoutRetry: null,
      errorRetry: null
    }), s = this.createInternalLoader(e), (r = e.deliveryDirectives) != null && r.part) {
      let c;
      if (e.type === Vt.LEVEL && e.level !== null ? c = this.hls.levels[e.level].details : e.type === Vt.AUDIO_TRACK && e.id !== null ? c = this.hls.audioTracks[e.id].details : e.type === Vt.SUBTITLE_TRACK && e.id !== null && (c = this.hls.subtitleTracks[e.id].details), c) {
        const d = c.partTarget, h = c.targetduration;
        if (d && h) {
          const f = Math.max(d * 3, h * 0.8) * 1e3;
          a = hn({}, a, {
            maxTimeToFirstByteMs: Math.min(f, a.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(f, a.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const o = a.errorRetry || a.timeoutRetry || {}, l = {
      loadPolicy: a,
      timeout: a.maxLoadTimeMs,
      maxRetry: o.maxNumRetry || 0,
      retryDelay: o.retryDelayMs || 0,
      maxRetryDelay: o.maxRetryDelayMs || 0
    }, u = {
      onSuccess: (c, d, h, f) => {
        const p = this.getInternalLoader(h);
        this.resetInternalLoader(h.type);
        const m = c.data;
        if (m.indexOf("#EXTM3U") !== 0) {
          this.handleManifestParsingError(c, h, new Error("no EXTM3U delimiter"), f || null, d);
          return;
        }
        d.parsing.start = performance.now(), Ms.isMediaPlaylist(m) ? this.handleTrackOrLevelPlaylist(c, d, h, f || null, p) : this.handleMasterPlaylist(c, d, h, f);
      },
      onError: (c, d, h, f) => {
        this.handleNetworkError(d, h, !1, c, f);
      },
      onTimeout: (c, d, h) => {
        this.handleNetworkError(d, h, !0, void 0, c);
      }
    };
    s.load(e, l, u);
  }
  handleMasterPlaylist(e, r, n, s) {
    const a = this.hls, o = e.data, l = S_(e, n), u = Ms.parseMasterPlaylist(o, l);
    if (u.playlistParsingError) {
      this.handleManifestParsingError(e, n, u.playlistParsingError, s, r);
      return;
    }
    const {
      contentSteering: c,
      levels: d,
      sessionData: h,
      sessionKeys: f,
      startTimeOffset: p,
      variableList: m
    } = u;
    this.variableList = m;
    const {
      AUDIO: b = [],
      SUBTITLES: y,
      "CLOSED-CAPTIONS": _
    } = Ms.parseMasterPlaylistMedia(o, l, u);
    b.length && !b.some((T) => !T.url) && d[0].audioCodec && !d[0].attrs.AUDIO && (J.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), b.unshift({
      type: "main",
      name: "main",
      groupId: "main",
      default: !1,
      autoselect: !1,
      forced: !1,
      id: -1,
      attrs: new Ir({}),
      bitrate: 0,
      url: ""
    })), a.trigger(D.MANIFEST_LOADED, {
      levels: d,
      audioTracks: b,
      subtitles: y,
      captions: _,
      contentSteering: c,
      url: l,
      stats: r,
      networkDetails: s,
      sessionData: h,
      sessionKeys: f,
      startTimeOffset: p,
      variableList: m
    });
  }
  handleTrackOrLevelPlaylist(e, r, n, s, a) {
    const o = this.hls, {
      id: l,
      level: u,
      type: c
    } = n, d = S_(e, n), h = et(l) ? l : 0, f = et(u) ? u : h, p = FI(n), m = Ms.parseLevelPlaylist(e.data, d, f, p, h, this.variableList);
    if (c === Vt.MANIFEST) {
      const b = {
        attrs: new Ir({}),
        bitrate: 0,
        details: m,
        name: "",
        url: d
      };
      o.trigger(D.MANIFEST_LOADED, {
        levels: [b],
        audioTracks: [],
        url: d,
        stats: r,
        networkDetails: s,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }
    r.parsing.end = performance.now(), n.levelDetails = m, this.handlePlaylistLoaded(m, e, r, n, s, a);
  }
  handleManifestParsingError(e, r, n, s, a) {
    this.hls.trigger(D.ERROR, {
      type: it.NETWORK_ERROR,
      details: le.MANIFEST_PARSING_ERROR,
      fatal: r.type === Vt.MANIFEST,
      url: e.url,
      err: n,
      error: n,
      reason: n.message,
      response: e,
      context: r,
      networkDetails: s,
      stats: a
    });
  }
  handleNetworkError(e, r, n = !1, s, a) {
    let o = `A network ${n ? "timeout" : "error" + (s ? " (status " + s.code + ")" : "")} occurred while loading ${e.type}`;
    e.type === Vt.LEVEL ? o += `: ${e.level} id: ${e.id}` : (e.type === Vt.AUDIO_TRACK || e.type === Vt.SUBTITLE_TRACK) && (o += ` id: ${e.id} group-id: "${e.groupId}"`);
    const l = new Error(o);
    J.warn(`[playlist-loader]: ${o}`);
    let u = le.UNKNOWN, c = !1;
    const d = this.getInternalLoader(e);
    switch (e.type) {
      case Vt.MANIFEST:
        u = n ? le.MANIFEST_LOAD_TIMEOUT : le.MANIFEST_LOAD_ERROR, c = !0;
        break;
      case Vt.LEVEL:
        u = n ? le.LEVEL_LOAD_TIMEOUT : le.LEVEL_LOAD_ERROR, c = !1;
        break;
      case Vt.AUDIO_TRACK:
        u = n ? le.AUDIO_TRACK_LOAD_TIMEOUT : le.AUDIO_TRACK_LOAD_ERROR, c = !1;
        break;
      case Vt.SUBTITLE_TRACK:
        u = n ? le.SUBTITLE_TRACK_LOAD_TIMEOUT : le.SUBTITLE_LOAD_ERROR, c = !1;
        break;
    }
    d && this.resetInternalLoader(e.type);
    const h = {
      type: it.NETWORK_ERROR,
      details: u,
      fatal: c,
      url: e.url,
      loader: d,
      context: e,
      error: l,
      networkDetails: r,
      stats: a
    };
    if (s) {
      const f = (r == null ? void 0 : r.url) || e.url;
      h.response = Ei({
        url: f,
        data: void 0
      }, s);
    }
    this.hls.trigger(D.ERROR, h);
  }
  handlePlaylistLoaded(e, r, n, s, a, o) {
    const l = this.hls, {
      type: u,
      level: c,
      id: d,
      groupId: h,
      deliveryDirectives: f
    } = s, p = S_(r, s), m = FI(s), b = typeof s.level == "number" && m === at.MAIN ? c : void 0;
    if (!e.fragments.length) {
      const _ = new Error("No Segments found in Playlist");
      l.trigger(D.ERROR, {
        type: it.NETWORK_ERROR,
        details: le.LEVEL_EMPTY_ERROR,
        fatal: !1,
        url: p,
        error: _,
        reason: _.message,
        response: r,
        context: s,
        level: b,
        parent: m,
        networkDetails: a,
        stats: n
      });
      return;
    }
    e.targetduration || (e.playlistParsingError = new Error("Missing Target Duration"));
    const y = e.playlistParsingError;
    if (y) {
      l.trigger(D.ERROR, {
        type: it.NETWORK_ERROR,
        details: le.LEVEL_PARSING_ERROR,
        fatal: !1,
        url: p,
        error: y,
        reason: y.message,
        response: r,
        context: s,
        level: b,
        parent: m,
        networkDetails: a,
        stats: n
      });
      return;
    }
    switch (e.live && o && (o.getCacheAge && (e.ageHeader = o.getCacheAge() || 0), (!o.getCacheAge || isNaN(e.ageHeader)) && (e.ageHeader = 0)), u) {
      case Vt.MANIFEST:
      case Vt.LEVEL:
        l.trigger(D.LEVEL_LOADED, {
          details: e,
          level: b || 0,
          id: d || 0,
          stats: n,
          networkDetails: a,
          deliveryDirectives: f
        });
        break;
      case Vt.AUDIO_TRACK:
        l.trigger(D.AUDIO_TRACK_LOADED, {
          details: e,
          id: d || 0,
          groupId: h || "",
          stats: n,
          networkDetails: a,
          deliveryDirectives: f
        });
        break;
      case Vt.SUBTITLE_TRACK:
        l.trigger(D.SUBTITLE_TRACK_LOADED, {
          details: e,
          id: d || 0,
          groupId: h || "",
          stats: n,
          networkDetails: a,
          deliveryDirectives: f
        });
        break;
    }
  }
}
function vU(t, e) {
  let r;
  try {
    r = new Event("addtrack");
  } catch {
    r = document.createEvent("Event"), r.initEvent("addtrack", !1, !1);
  }
  r.track = t, e.dispatchEvent(r);
}
function mU(t, e) {
  const r = t.mode;
  if (r === "disabled" && (t.mode = "hidden"), t.cues && !t.cues.getCueById(e.id))
    try {
      if (t.addCue(e), !t.cues.getCueById(e.id))
        throw new Error(`addCue is failed for: ${e}`);
    } catch (n) {
      J.debug(`[texttrack-utils]: ${n}`);
      try {
        const s = new self.TextTrackCue(e.startTime, e.endTime, e.text);
        s.id = e.id, t.addCue(s);
      } catch (s) {
        J.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${s}`);
      }
    }
  r === "disabled" && (t.mode = r);
}
function td(t) {
  const e = t.mode;
  if (e === "disabled" && (t.mode = "hidden"), t.cues)
    for (let r = t.cues.length; r--; )
      t.removeCue(t.cues[r]);
  e === "disabled" && (t.mode = e);
}
function ZT(t, e, r, n) {
  const s = t.mode;
  if (s === "disabled" && (t.mode = "hidden"), t.cues && t.cues.length > 0) {
    const a = rZ(t.cues, e, r);
    for (let o = 0; o < a.length; o++)
      (!n || n(a[o])) && t.removeCue(a[o]);
  }
  s === "disabled" && (t.mode = s);
}
function tZ(t, e) {
  if (e < t[0].startTime)
    return 0;
  const r = t.length - 1;
  if (e > t[r].endTime)
    return -1;
  let n = 0, s = r;
  for (; n <= s; ) {
    const a = Math.floor((s + n) / 2);
    if (e < t[a].startTime)
      s = a - 1;
    else if (e > t[a].startTime && n < r)
      n = a + 1;
    else
      return a;
  }
  return t[n].startTime - e < e - t[s].startTime ? n : s;
}
function rZ(t, e, r) {
  const n = [], s = tZ(t, e);
  if (s > -1)
    for (let a = s, o = t.length; a < o; a++) {
      const l = t[a];
      if (l.startTime >= e && l.endTime <= r)
        n.push(l);
      else if (l.startTime > r)
        return n;
    }
  return n;
}
var Is = {
  audioId3: "org.id3",
  dateRange: "com.apple.quicktime.HLS",
  emsg: "https://aomedia.org/emsg/ID3"
};
const nZ = 0.25;
function JT() {
  if (!(typeof self > "u"))
    return self.WebKitDataCue || self.VTTCue || self.TextTrackCue;
}
const gm = (() => {
  const t = JT();
  try {
    new t(0, Number.POSITIVE_INFINITY, "");
  } catch {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
function E_(t, e) {
  return t.getTime() / 1e3 - e;
}
function iZ(t) {
  return Uint8Array.from(t.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
}
class sZ {
  constructor(e) {
    this.hls = void 0, this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = e, this._registerListeners();
  }
  destroy() {
    this._unregisterListeners(), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(D.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(D.MANIFEST_LOADING, this.onManifestLoading, this), e.on(D.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.on(D.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(D.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(D.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(D.MANIFEST_LOADING, this.onManifestLoading, this), e.off(D.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.off(D.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(D.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  // Add ID3 metatadata text track.
  onMediaAttached(e, r) {
    this.media = r.media;
  }
  onMediaDetaching() {
    this.id3Track && (td(this.id3Track), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {});
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(e) {
    const r = this.getID3Track(e.textTracks);
    return r.mode = "hidden", r;
  }
  getID3Track(e) {
    if (this.media) {
      for (let r = 0; r < e.length; r++) {
        const n = e[r];
        if (n.kind === "metadata" && n.label === "id3")
          return vU(n, this.media), n;
      }
      return this.media.addTextTrack("metadata", "id3");
    }
  }
  onFragParsingMetadata(e, r) {
    if (!this.media)
      return;
    const {
      hls: {
        config: {
          enableEmsgMetadataCues: n,
          enableID3MetadataCues: s
        }
      }
    } = this;
    if (!n && !s)
      return;
    const {
      samples: a
    } = r;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const o = JT();
    for (let l = 0; l < a.length; l++) {
      const u = a[l].type;
      if (u === Is.emsg && !n || !s)
        continue;
      const c = aU(a[l].data);
      if (c) {
        const d = a[l].pts;
        let h = d + a[l].duration;
        h > gm && (h = gm), h - d <= 0 && (h = d + nZ);
        for (let p = 0; p < c.length; p++) {
          const m = c[p];
          if (!sU(m)) {
            this.updateId3CueEnds(d, u);
            const b = new o(d, h, "");
            b.value = m, u && (b.type = u), this.id3Track.addCue(b);
          }
        }
      }
    }
  }
  updateId3CueEnds(e, r) {
    var n;
    const s = (n = this.id3Track) == null ? void 0 : n.cues;
    if (s)
      for (let a = s.length; a--; ) {
        const o = s[a];
        o.type === r && o.startTime < e && o.endTime === gm && (o.endTime = e);
      }
  }
  onBufferFlushing(e, {
    startOffset: r,
    endOffset: n,
    type: s
  }) {
    const {
      id3Track: a,
      hls: o
    } = this;
    if (!o)
      return;
    const {
      config: {
        enableEmsgMetadataCues: l,
        enableID3MetadataCues: u
      }
    } = o;
    if (a && (l || u)) {
      let c;
      s === "audio" ? c = (d) => d.type === Is.audioId3 && u : s === "video" ? c = (d) => d.type === Is.emsg && l : c = (d) => d.type === Is.audioId3 && u || d.type === Is.emsg && l, ZT(a, r, n, c);
    }
  }
  onLevelUpdated(e, {
    details: r
  }) {
    if (!this.media || !r.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues)
      return;
    const {
      dateRangeCuesAppended: n,
      id3Track: s
    } = this, {
      dateRanges: a
    } = r, o = Object.keys(a);
    if (s) {
      const d = Object.keys(n).filter((h) => !o.includes(h));
      for (let h = d.length; h--; ) {
        const f = d[h];
        Object.keys(n[f].cues).forEach((p) => {
          s.removeCue(n[f].cues[p]);
        }), delete n[f];
      }
    }
    const l = r.fragments[r.fragments.length - 1];
    if (o.length === 0 || !et(l == null ? void 0 : l.programDateTime))
      return;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const u = l.programDateTime / 1e3 - l.start, c = JT();
    for (let d = 0; d < o.length; d++) {
      const h = o[d], f = a[h], p = n[h], m = (p == null ? void 0 : p.cues) || {};
      let b = (p == null ? void 0 : p.durationKnown) || !1;
      const y = E_(f.startDate, u);
      let _ = gm;
      const x = f.endDate;
      if (x)
        _ = E_(x, u), b = !0;
      else if (f.endOnNext && !b) {
        const k = o.reduce((E, F) => {
          const R = a[F];
          return R.class === f.class && R.id !== F && R.startDate > f.startDate && E.push(R), E;
        }, []).sort((E, F) => E.startDate.getTime() - F.startDate.getTime())[0];
        k && (_ = E_(k.startDate, u), b = !0);
      }
      const T = Object.keys(f.attr);
      for (let k = 0; k < T.length; k++) {
        const E = T[k];
        if (!hQ(E))
          continue;
        let F = m[E];
        if (F)
          b && !p.durationKnown && (F.endTime = _);
        else {
          let R = f.attr[E];
          F = new c(y, _, ""), fQ(E) && (R = iZ(R)), F.value = {
            key: E,
            data: R
          }, F.type = Is.dateRange, F.id = h, this.id3Track.addCue(F), m[E] = F;
        }
      }
      n[h] = {
        cues: m,
        dateRange: f,
        durationKnown: b
      };
    }
  }
}
class aZ {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.levelDetails = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this.timeupdateHandler = () => this.timeupdate(), this.hls = e, this.config = e.config, this.registerListeners();
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config: e,
      levelDetails: r
    } = this;
    return e.liveMaxLatencyDuration !== void 0 ? e.liveMaxLatencyDuration : r ? e.liveMaxLatencyDurationCount * r.targetduration : 0;
  }
  get targetLatency() {
    const {
      levelDetails: e
    } = this;
    if (e === null)
      return null;
    const {
      holdBack: r,
      partHoldBack: n,
      targetduration: s
    } = e, {
      liveSyncDuration: a,
      liveSyncDurationCount: o,
      lowLatencyMode: l
    } = this.config, u = this.hls.userConfig;
    let c = l && n || r;
    (u.liveSyncDuration || u.liveSyncDurationCount || c === 0) && (c = a !== void 0 ? a : o * s);
    const d = s, h = 1;
    return c + Math.min(this.stallCount * h, d);
  }
  get liveSyncPosition() {
    const e = this.estimateLiveEdge(), r = this.targetLatency, n = this.levelDetails;
    if (e === null || r === null || n === null)
      return null;
    const s = n.edge, a = e - r - this.edgeStalled, o = s - n.totalduration, l = s - (this.config.lowLatencyMode && n.partTarget || n.targetduration);
    return Math.min(Math.max(o, a), l);
  }
  get drift() {
    const {
      levelDetails: e
    } = this;
    return e === null ? 1 : e.drift;
  }
  get edgeStalled() {
    const {
      levelDetails: e
    } = this;
    if (e === null)
      return 0;
    const r = (this.config.lowLatencyMode && e.partTarget || e.targetduration) * 3;
    return Math.max(e.age - r, 0);
  }
  get forwardBufferLength() {
    const {
      media: e,
      levelDetails: r
    } = this;
    if (!e || !r)
      return 0;
    const n = e.buffered.length;
    return (n ? e.buffered.end(n - 1) : r.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetaching(), this.levelDetails = null, this.hls = this.timeupdateHandler = null;
  }
  registerListeners() {
    this.hls.on(D.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(D.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.on(D.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(D.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.on(D.ERROR, this.onError, this);
  }
  unregisterListeners() {
    this.hls.off(D.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(D.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.off(D.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(D.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.off(D.ERROR, this.onError, this);
  }
  onMediaAttached(e, r) {
    this.media = r.media, this.media.addEventListener("timeupdate", this.timeupdateHandler);
  }
  onMediaDetaching() {
    this.media && (this.media.removeEventListener("timeupdate", this.timeupdateHandler), this.media = null);
  }
  onManifestLoading() {
    this.levelDetails = null, this._latency = null, this.stallCount = 0;
  }
  onLevelUpdated(e, {
    details: r
  }) {
    this.levelDetails = r, r.advanced && this.timeupdate(), !r.live && this.media && this.media.removeEventListener("timeupdate", this.timeupdateHandler);
  }
  onError(e, r) {
    var n;
    r.details === le.BUFFER_STALLED_ERROR && (this.stallCount++, (n = this.levelDetails) != null && n.live && J.warn("[playback-rate-controller]: Stall detected, adjusting target latency"));
  }
  timeupdate() {
    const {
      media: e,
      levelDetails: r
    } = this;
    if (!e || !r)
      return;
    this.currentTime = e.currentTime;
    const n = this.computeLatency();
    if (n === null)
      return;
    this._latency = n;
    const {
      lowLatencyMode: s,
      maxLiveSyncPlaybackRate: a
    } = this.config;
    if (!s || a === 1)
      return;
    const o = this.targetLatency;
    if (o === null)
      return;
    const l = n - o, u = Math.min(this.maxLatency, o + r.targetduration), c = l < u;
    if (r.live && c && l > 0.05 && this.forwardBufferLength > 1) {
      const d = Math.min(2, Math.max(1, a)), h = Math.round(2 / (1 + Math.exp(-0.75 * l - this.edgeStalled)) * 20) / 20;
      e.playbackRate = Math.min(d, Math.max(1, h));
    } else
      e.playbackRate !== 1 && e.playbackRate !== 0 && (e.playbackRate = 1);
  }
  estimateLiveEdge() {
    const {
      levelDetails: e
    } = this;
    return e === null ? null : e.edge + e.age;
  }
  computeLatency() {
    const e = this.estimateLiveEdge();
    return e === null ? null : e - this.currentTime;
  }
}
const ex = ["NONE", "TYPE-0", "TYPE-1", null];
var Sf = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function oZ(t, e) {
  const {
    canSkipUntil: r,
    canSkipDateRanges: n,
    endSN: s
  } = t, a = e !== void 0 ? e - s : 0;
  return r && a < r ? n ? Sf.v2 : Sf.Yes : Sf.No;
}
class BI {
  constructor(e, r, n) {
    this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = e, this.part = r, this.skip = n;
  }
  addDirectives(e) {
    const r = new self.URL(e);
    return this.msn !== void 0 && r.searchParams.set("_HLS_msn", this.msn.toString()), this.part !== void 0 && r.searchParams.set("_HLS_part", this.part.toString()), this.skip && r.searchParams.set("_HLS_skip", this.skip), r.href;
  }
}
class Xf {
  constructor(e) {
    this._attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.videoCodec = void 0, this.width = void 0, this.unknownCodecs = void 0, this.audioGroupIds = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.textGroupIds = void 0, this.url = void 0, this._urlId = 0, this.url = [e.url], this._attrs = [e.attrs], this.bitrate = e.bitrate, e.details && (this.details = e.details), this.id = e.id || 0, this.name = e.name, this.width = e.width || 0, this.height = e.height || 0, this.audioCodec = e.audioCodec, this.videoCodec = e.videoCodec, this.unknownCodecs = e.unknownCodecs, this.codecSet = [e.videoCodec, e.audioCodec].filter((r) => r).join(",").replace(/\.[^.,]+/g, "");
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get attrs() {
    return this._attrs[this._urlId];
  }
  get pathwayId() {
    return this.attrs["PATHWAY-ID"] || ".";
  }
  get uri() {
    return this.url[this._urlId] || "";
  }
  get urlId() {
    return this._urlId;
  }
  set urlId(e) {
    const r = e % this.url.length;
    this._urlId !== r && (this.fragmentError = 0, this.loadError = 0, this.details = void 0, this._urlId = r);
  }
  get audioGroupId() {
    var e;
    return (e = this.audioGroupIds) == null ? void 0 : e[this.urlId];
  }
  get textGroupId() {
    var e;
    return (e = this.textGroupIds) == null ? void 0 : e[this.urlId];
  }
  addFallback(e) {
    this.url.push(e.url), this._attrs.push(e.attrs);
  }
}
function $_(t, e) {
  const r = e.startPTS;
  if (et(r)) {
    let n = 0, s;
    e.sn > t.sn ? (n = r - t.start, s = t) : (n = t.start - r, s = e), s.duration !== n && (s.duration = n);
  } else
    e.sn > t.sn ? t.cc === e.cc && t.minEndPTS ? e.start = t.start + (t.minEndPTS - t.start) : e.start = t.start + t.duration : e.start = Math.max(t.start - e.duration, 0);
}
function gU(t, e, r, n, s, a) {
  n - r <= 0 && (J.warn("Fragment should have a positive duration", e), n = r + e.duration, a = s + e.duration);
  let l = r, u = n;
  const c = e.startPTS, d = e.endPTS;
  if (et(c)) {
    const y = Math.abs(c - r);
    et(e.deltaPTS) ? e.deltaPTS = Math.max(y, e.deltaPTS) : e.deltaPTS = y, l = Math.max(r, c), r = Math.min(r, c), s = Math.min(s, e.startDTS), u = Math.min(n, d), n = Math.max(n, d), a = Math.max(a, e.endDTS);
  }
  const h = r - e.start;
  e.start !== 0 && (e.start = r), e.duration = n - e.start, e.startPTS = r, e.maxStartPTS = l, e.startDTS = s, e.endPTS = n, e.minEndPTS = u, e.endDTS = a;
  const f = e.sn;
  if (!t || f < t.startSN || f > t.endSN)
    return 0;
  let p;
  const m = f - t.startSN, b = t.fragments;
  for (b[m] = e, p = m; p > 0; p--)
    $_(b[p], b[p - 1]);
  for (p = m; p < b.length - 1; p++)
    $_(b[p], b[p + 1]);
  return t.fragmentHint && $_(b[b.length - 1], t.fragmentHint), t.PTSKnown = t.alignedSliding = !0, h;
}
function lZ(t, e) {
  let r = null;
  const n = t.fragments;
  for (let u = n.length - 1; u >= 0; u--) {
    const c = n[u].initSegment;
    if (c) {
      r = c;
      break;
    }
  }
  t.fragmentHint && delete t.fragmentHint.endPTS;
  let s = 0, a;
  if (dZ(t, e, (u, c) => {
    u.relurl && (s = u.cc - c.cc), et(u.startPTS) && et(u.endPTS) && (c.start = c.startPTS = u.startPTS, c.startDTS = u.startDTS, c.maxStartPTS = u.maxStartPTS, c.endPTS = u.endPTS, c.endDTS = u.endDTS, c.minEndPTS = u.minEndPTS, c.duration = u.endPTS - u.startPTS, c.duration && (a = c), e.PTSKnown = e.alignedSliding = !0), c.elementaryStreams = u.elementaryStreams, c.loader = u.loader, c.stats = u.stats, c.urlId = u.urlId, u.initSegment && (c.initSegment = u.initSegment, r = u.initSegment);
  }), r && (e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments).forEach((c) => {
    var d;
    (!c.initSegment || c.initSegment.relurl === ((d = r) == null ? void 0 : d.relurl)) && (c.initSegment = r);
  }), e.skippedSegments)
    if (e.deltaUpdateFailed = e.fragments.some((u) => !u), e.deltaUpdateFailed) {
      J.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
      for (let u = e.skippedSegments; u--; )
        e.fragments.shift();
      e.startSN = e.fragments[0].sn, e.startCC = e.fragments[0].cc;
    } else
      e.canSkipDateRanges && (e.dateRanges = uZ(t.dateRanges, e.dateRanges, e.recentlyRemovedDateranges));
  const o = e.fragments;
  if (s) {
    J.warn("discontinuity sliding from playlist, take drift into account");
    for (let u = 0; u < o.length; u++)
      o[u].cc += s;
  }
  e.skippedSegments && (e.startCC = e.fragments[0].cc), cZ(t.partList, e.partList, (u, c) => {
    c.elementaryStreams = u.elementaryStreams, c.stats = u.stats;
  }), a ? gU(e, a, a.startPTS, a.endPTS, a.startDTS, a.endDTS) : yU(t, e), o.length && (e.totalduration = e.edge - o[0].start), e.driftStartTime = t.driftStartTime, e.driftStart = t.driftStart;
  const l = e.advancedDateTime;
  if (e.advanced && l) {
    const u = e.edge;
    e.driftStart || (e.driftStartTime = l, e.driftStart = u), e.driftEndTime = l, e.driftEnd = u;
  } else
    e.driftEndTime = t.driftEndTime, e.driftEnd = t.driftEnd, e.advancedDateTime = t.advancedDateTime;
}
function uZ(t, e, r) {
  const n = hn({}, t);
  return r && r.forEach((s) => {
    delete n[s];
  }), Object.keys(e).forEach((s) => {
    const a = new J3(e[s].attr, n[s]);
    a.isValid ? n[s] = a : J.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(e[s].attr)}"`);
  }), n;
}
function cZ(t, e, r) {
  if (t && e) {
    let n = 0;
    for (let s = 0, a = t.length; s <= a; s++) {
      const o = t[s], l = e[s + n];
      o && l && o.index === l.index && o.fragment.sn === l.fragment.sn ? r(o, l) : n--;
    }
  }
}
function dZ(t, e, r) {
  const n = e.skippedSegments, s = Math.max(t.startSN, e.startSN) - e.startSN, a = (t.fragmentHint ? 1 : 0) + (n ? e.endSN : Math.min(t.endSN, e.endSN)) - e.startSN, o = e.startSN - t.startSN, l = e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments, u = t.fragmentHint ? t.fragments.concat(t.fragmentHint) : t.fragments;
  for (let c = s; c <= a; c++) {
    const d = u[o + c];
    let h = l[c];
    n && !h && c < n && (h = e.fragments[c] = d), d && h && r(d, h);
  }
}
function yU(t, e) {
  const r = e.startSN + e.skippedSegments - t.startSN, n = t.fragments;
  r < 0 || r >= n.length || tx(e, n[r].start);
}
function tx(t, e) {
  if (e) {
    const r = t.fragments;
    for (let n = t.skippedSegments; n < r.length; n++)
      r[n].start += e;
    t.fragmentHint && (t.fragmentHint.start += e);
  }
}
function hZ(t, e = 1 / 0) {
  let r = 1e3 * t.targetduration;
  if (t.updated) {
    const n = t.fragments, s = 4;
    if (n.length && r * s > e) {
      const a = n[n.length - 1].duration * 1e3;
      a < r && (r = a);
    }
  } else
    r /= 2;
  return Math.round(r);
}
function fZ(t, e, r) {
  if (!(t != null && t.details))
    return null;
  const n = t.details;
  let s = n.fragments[e - n.startSN];
  return s || (s = n.fragmentHint, s && s.sn === e) ? s : e < n.startSN && r && r.sn === e ? r : null;
}
function UI(t, e, r) {
  var n;
  return t != null && t.details ? bU((n = t.details) == null ? void 0 : n.partList, e, r) : null;
}
function bU(t, e, r) {
  if (t)
    for (let n = t.length; n--; ) {
      const s = t[n];
      if (s.index === r && s.fragment.sn === e)
        return s;
    }
  return null;
}
function oy(t) {
  switch (t.details) {
    case le.FRAG_LOAD_TIMEOUT:
    case le.KEY_LOAD_TIMEOUT:
    case le.LEVEL_LOAD_TIMEOUT:
    case le.MANIFEST_LOAD_TIMEOUT:
      return !0;
  }
  return !1;
}
function VI(t, e) {
  const r = oy(e);
  return t.default[`${r ? "timeout" : "error"}Retry`];
}
function Yk(t, e) {
  const r = t.backoff === "linear" ? 1 : Math.pow(2, e);
  return Math.min(r * t.retryDelayMs, t.maxRetryDelayMs);
}
function YI(t) {
  return Ei(Ei({}, t), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function ly(t, e, r, n) {
  return !!t && e < t.maxNumRetry && (pZ(n) || !!r);
}
function pZ(t) {
  return t === 0 && navigator.onLine === !1 || !!t && (t < 400 || t > 499);
}
const _U = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function(t, e) {
    let r = 0, n = t.length - 1, s = null, a = null;
    for (; r <= n; ) {
      s = (r + n) / 2 | 0, a = t[s];
      const o = e(a);
      if (o > 0)
        r = s + 1;
      else if (o < 0)
        n = s - 1;
      else
        return a;
    }
    return null;
  }
};
function vZ(t, e, r) {
  if (e === null || !Array.isArray(t) || !t.length || !et(e))
    return null;
  const n = t[0].programDateTime;
  if (e < (n || 0))
    return null;
  const s = t[t.length - 1].endProgramDateTime;
  if (e >= (s || 0))
    return null;
  r = r || 0;
  for (let a = 0; a < t.length; ++a) {
    const o = t[a];
    if (mZ(e, r, o))
      return o;
  }
  return null;
}
function Qf(t, e, r = 0, n = 0) {
  let s = null;
  if (t ? s = e[t.sn - e[0].sn + 1] || null : r === 0 && e[0].start === 0 && (s = e[0]), s && rx(r, n, s) === 0)
    return s;
  const a = _U.search(e, rx.bind(null, r, n));
  return a && (a !== t || !s) ? a : s;
}
function rx(t = 0, e = 0, r) {
  if (r.start <= t && r.start + r.duration > t)
    return 0;
  const n = Math.min(e, r.duration + (r.deltaPTS ? r.deltaPTS : 0));
  return r.start + r.duration - n <= t ? 1 : r.start - n > t && r.start ? -1 : 0;
}
function mZ(t, e, r) {
  const n = Math.min(e, r.duration + (r.deltaPTS ? r.deltaPTS : 0)) * 1e3;
  return (r.endProgramDateTime || 0) - n > t;
}
function gZ(t, e) {
  return _U.search(t, (r) => r.cc < e ? 1 : r.cc > e ? -1 : 0);
}
const yZ = 3e5;
var Un = {
  DoNothing: 0,
  SendEndCallback: 1,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  InsertDiscontinuity: 4,
  RetryRequest: 5
}, ns = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2,
  SwitchToSDR: 4
};
class bZ {
  constructor(e) {
    this.hls = void 0, this.playlistError = 0, this.penalizedRenditions = {}, this.log = void 0, this.warn = void 0, this.error = void 0, this.hls = e, this.log = J.log.bind(J, "[info]:"), this.warn = J.warn.bind(J, "[warning]:"), this.error = J.error.bind(J, "[error]:"), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(D.ERROR, this.onError, this), e.on(D.MANIFEST_LOADING, this.onManifestLoading, this), e.on(D.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(D.ERROR, this.onError, this), e.off(D.ERROR, this.onErrorOut, this), e.off(D.MANIFEST_LOADING, this.onManifestLoading, this), e.off(D.LEVEL_UPDATED, this.onLevelUpdated, this));
  }
  destroy() {
    this.unregisterListeners(), this.hls = null, this.penalizedRenditions = {};
  }
  startLoad(e) {
    this.playlistError = 0;
  }
  stopLoad() {
  }
  getVariantLevelIndex(e) {
    return (e == null ? void 0 : e.type) === at.MAIN ? e.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0, this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(e, r) {
    var n, s;
    if (r.fatal)
      return;
    const a = this.hls, o = r.context;
    switch (r.details) {
      case le.FRAG_LOAD_ERROR:
      case le.FRAG_LOAD_TIMEOUT:
      case le.KEY_LOAD_ERROR:
      case le.KEY_LOAD_TIMEOUT:
        r.errorAction = this.getFragRetryOrSwitchAction(r);
        return;
      case le.FRAG_PARSING_ERROR:
        if ((n = r.frag) != null && n.gap) {
          r.errorAction = {
            action: Un.DoNothing,
            flags: ns.None
          };
          return;
        }
      case le.FRAG_GAP:
      case le.FRAG_DECRYPT_ERROR: {
        r.errorAction = this.getFragRetryOrSwitchAction(r), r.errorAction.action = Un.SendAlternateToPenaltyBox;
        return;
      }
      case le.LEVEL_EMPTY_ERROR:
      case le.LEVEL_PARSING_ERROR:
        {
          var l, u;
          const c = r.parent === at.MAIN ? r.level : a.loadLevel;
          r.details === le.LEVEL_EMPTY_ERROR && ((l = r.context) != null && (u = l.levelDetails) != null && u.live) ? r.errorAction = this.getPlaylistRetryOrSwitchAction(r, c) : (r.levelRetry = !1, r.errorAction = this.getLevelSwitchAction(r, c));
        }
        return;
      case le.LEVEL_LOAD_ERROR:
      case le.LEVEL_LOAD_TIMEOUT:
        typeof (o == null ? void 0 : o.level) == "number" && (r.errorAction = this.getPlaylistRetryOrSwitchAction(r, o.level));
        return;
      case le.AUDIO_TRACK_LOAD_ERROR:
      case le.AUDIO_TRACK_LOAD_TIMEOUT:
      case le.SUBTITLE_LOAD_ERROR:
      case le.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (o) {
          const c = a.levels[a.loadLevel];
          if (c && (o.type === Vt.AUDIO_TRACK && o.groupId === c.audioGroupId || o.type === Vt.SUBTITLE_TRACK && o.groupId === c.textGroupId)) {
            r.errorAction = this.getPlaylistRetryOrSwitchAction(r, a.loadLevel), r.errorAction.action = Un.SendAlternateToPenaltyBox, r.errorAction.flags = ns.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case le.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const c = a.levels[a.loadLevel], d = c == null ? void 0 : c.attrs["HDCP-LEVEL"];
          d && (r.errorAction = {
            action: Un.SendAlternateToPenaltyBox,
            flags: ns.MoveAllAlternatesMatchingHDCP,
            hdcpLevel: d
          });
        }
        return;
      case le.BUFFER_ADD_CODEC_ERROR:
      case le.REMUX_ALLOC_ERROR:
        r.errorAction = this.getLevelSwitchAction(r, (s = r.level) != null ? s : a.loadLevel);
        return;
      case le.INTERNAL_EXCEPTION:
      case le.BUFFER_APPENDING_ERROR:
      case le.BUFFER_APPEND_ERROR:
      case le.BUFFER_FULL_ERROR:
      case le.LEVEL_SWITCH_ERROR:
      case le.BUFFER_STALLED_ERROR:
      case le.BUFFER_SEEK_OVER_HOLE:
      case le.BUFFER_NUDGE_ON_STALL:
        r.errorAction = {
          action: Un.DoNothing,
          flags: ns.None
        };
        return;
    }
    if (r.type === it.KEY_SYSTEM_ERROR) {
      const c = this.getVariantLevelIndex(r.frag);
      r.levelRetry = !1, r.errorAction = this.getLevelSwitchAction(r, c);
      return;
    }
  }
  getPlaylistRetryOrSwitchAction(e, r) {
    var n;
    const s = this.hls, a = VI(s.config.playlistLoadPolicy, e), o = this.playlistError++, l = (n = e.response) == null ? void 0 : n.code;
    if (ly(a, o, oy(e), l))
      return {
        action: Un.RetryRequest,
        flags: ns.None,
        retryConfig: a,
        retryCount: o
      };
    const c = this.getLevelSwitchAction(e, r);
    return a && (c.retryConfig = a, c.retryCount = o), c;
  }
  getFragRetryOrSwitchAction(e) {
    const r = this.hls, n = this.getVariantLevelIndex(e.frag), s = r.levels[n], {
      fragLoadPolicy: a,
      keyLoadPolicy: o
    } = r.config, l = VI(e.details.startsWith("key") ? o : a, e), u = r.levels.reduce((h, f) => h + f.fragmentError, 0);
    if (s) {
      var c;
      e.details !== le.FRAG_GAP && s.fragmentError++;
      const h = (c = e.response) == null ? void 0 : c.code;
      if (ly(l, u, oy(e), h))
        return {
          action: Un.RetryRequest,
          flags: ns.None,
          retryConfig: l,
          retryCount: u
        };
    }
    const d = this.getLevelSwitchAction(e, n);
    return l && (d.retryConfig = l, d.retryCount = u), d;
  }
  getLevelSwitchAction(e, r) {
    const n = this.hls;
    r == null && (r = n.loadLevel);
    const s = this.hls.levels[r];
    if (s && (s.loadError++, n.autoLevelEnabled)) {
      var a, o;
      let l = -1;
      const {
        levels: u,
        loadLevel: c,
        minAutoLevel: d,
        maxAutoLevel: h
      } = n, f = (a = e.frag) == null ? void 0 : a.type, {
        type: p,
        groupId: m
      } = (o = e.context) != null ? o : {};
      for (let b = u.length; b--; ) {
        const y = (b + c) % u.length;
        if (y !== c && y >= d && y <= h && u[y].loadError === 0) {
          const _ = u[y];
          if (e.details === le.FRAG_GAP && e.frag) {
            const x = u[y].details;
            if (x) {
              const T = Qf(e.frag, x.fragments, e.frag.start);
              if (T != null && T.gap)
                continue;
            }
          } else {
            if (p === Vt.AUDIO_TRACK && m === _.audioGroupId || p === Vt.SUBTITLE_TRACK && m === _.textGroupId)
              continue;
            if (f === at.AUDIO && s.audioGroupId === _.audioGroupId || f === at.SUBTITLE && s.textGroupId === _.textGroupId)
              continue;
          }
          l = y;
          break;
        }
      }
      if (l > -1 && n.loadLevel !== l)
        return e.levelRetry = !0, this.playlistError = 0, {
          action: Un.SendAlternateToPenaltyBox,
          flags: ns.None,
          nextAutoLevel: l
        };
    }
    return {
      action: Un.SendAlternateToPenaltyBox,
      flags: ns.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(e, r) {
    var n;
    switch ((n = r.errorAction) == null ? void 0 : n.action) {
      case Un.DoNothing:
        break;
      case Un.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(r), !r.errorAction.resolved && r.details !== le.FRAG_GAP && (r.fatal = !0);
        break;
    }
    if (r.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(e) {
    const r = this.hls, n = e.errorAction;
    if (!n)
      return;
    const {
      flags: s,
      hdcpLevel: a,
      nextAutoLevel: o
    } = n;
    switch (s) {
      case ns.None:
        this.switchLevel(e, o);
        break;
      case ns.MoveAllAlternatesMatchingHost:
        n.resolved || (n.resolved = this.redundantFailover(e));
        break;
      case ns.MoveAllAlternatesMatchingHDCP:
        a && (r.maxHdcpLevel = ex[ex.indexOf(a) - 1], n.resolved = !0), this.warn(`Restricting playback to HDCP-LEVEL of "${r.maxHdcpLevel}" or lower`);
        break;
    }
    n.resolved || this.switchLevel(e, o);
  }
  switchLevel(e, r) {
    r !== void 0 && e.errorAction && (this.warn(`switching to level ${r} after ${e.details}`), this.hls.nextAutoLevel = r, e.errorAction.resolved = !0, this.hls.nextLoadLevel = this.hls.nextAutoLevel);
  }
  redundantFailover(e) {
    const {
      hls: r,
      penalizedRenditions: n
    } = this, s = e.parent === at.MAIN ? e.level : r.loadLevel, a = r.levels[s], o = a.url.length, l = e.frag ? e.frag.urlId : a.urlId;
    a.urlId === l && (!e.frag || a.details) && this.penalizeRendition(a, e);
    for (let u = 1; u < o; u++) {
      const c = (l + u) % o, d = n[c];
      if (!d || _Z(d, e, n[l]))
        return this.warn(`Switching to Redundant Stream ${c + 1}/${o}: "${a.url[c]}" after ${e.details}`), this.playlistError = 0, r.levels.forEach((h) => {
          h.urlId = c;
        }), r.nextLoadLevel = s, !0;
    }
    return !1;
  }
  penalizeRendition(e, r) {
    const {
      penalizedRenditions: n
    } = this, s = n[e.urlId] || {
      lastErrorPerfMs: 0,
      errors: [],
      details: void 0
    };
    s.lastErrorPerfMs = performance.now(), s.errors.push(r), s.details = e.details, n[e.urlId] = s;
  }
}
function _Z(t, e, r) {
  if (performance.now() - t.lastErrorPerfMs > yZ)
    return !0;
  const n = t.details;
  if (e.details === le.FRAG_GAP && n && e.frag) {
    const s = e.frag.start, a = Qf(null, n.fragments, s);
    if (a && !a.gap)
      return !0;
  }
  if (r && t.errors.length < r.errors.length) {
    const s = t.errors[t.errors.length - 1];
    if (n && s.frag && e.frag && Math.abs(s.frag.start - e.frag.start) > n.targetduration * 3)
      return !0;
  }
  return !1;
}
class Hk {
  constructor(e, r) {
    this.hls = void 0, this.timer = -1, this.requestScheduled = -1, this.canLoad = !1, this.log = void 0, this.warn = void 0, this.log = J.log.bind(J, `${r}:`), this.warn = J.warn.bind(J, `${r}:`), this.hls = e;
  }
  destroy() {
    this.clearTimer(), this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    clearTimeout(this.timer), this.timer = -1;
  }
  startLoad() {
    this.canLoad = !0, this.requestScheduled = -1, this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = !1, this.clearTimer();
  }
  switchParams(e, r) {
    const n = r == null ? void 0 : r.renditionReports;
    if (n) {
      let s = -1;
      for (let a = 0; a < n.length; a++) {
        const o = n[a];
        let l;
        try {
          l = new self.URL(o.URI, r.url).href;
        } catch (u) {
          J.warn(`Could not construct new URL for Rendition Report: ${u}`), l = o.URI || "";
        }
        if (l === e) {
          s = a;
          break;
        } else
          l === e.substring(0, l.length) && (s = a);
      }
      if (s !== -1) {
        const a = n[s], o = parseInt(a["LAST-MSN"]) || (r == null ? void 0 : r.lastPartSn);
        let l = parseInt(a["LAST-PART"]) || (r == null ? void 0 : r.lastPartIndex);
        if (this.hls.config.lowLatencyMode) {
          const u = Math.min(r.age - r.partTarget, r.targetduration);
          l >= 0 && u > r.partTarget && (l += 1);
        }
        return new BI(o, l >= 0 ? l : void 0, Sf.No);
      }
    }
  }
  loadPlaylist(e) {
    this.requestScheduled === -1 && (this.requestScheduled = self.performance.now());
  }
  shouldLoadPlaylist(e) {
    return this.canLoad && !!e && !!e.url && (!e.details || e.details.live);
  }
  shouldReloadPlaylist(e) {
    return this.timer === -1 && this.requestScheduled === -1 && this.shouldLoadPlaylist(e);
  }
  playlistLoaded(e, r, n) {
    const {
      details: s,
      stats: a
    } = r, o = self.performance.now(), l = a.loading.first ? Math.max(0, o - a.loading.first) : 0;
    if (s.advancedDateTime = Date.now() - l, s.live || n != null && n.live) {
      if (s.reloaded(n), n && this.log(`live playlist ${e} ${s.advanced ? "REFRESHED " + s.lastPartSn + "-" + s.lastPartIndex : "MISSED"}`), n && s.fragments.length > 0 && lZ(n, s), !this.canLoad || !s.live)
        return;
      let u, c, d;
      if (s.canBlockReload && s.endSN && s.advanced) {
        const y = this.hls.config.lowLatencyMode, _ = s.lastPartSn, x = s.endSN, T = s.lastPartIndex, k = T !== -1, E = _ === x, F = y ? 0 : T;
        k ? (c = E ? x + 1 : _, d = E ? F : T + 1) : c = x + 1;
        const R = s.age, $ = R + s.ageHeader;
        let O = Math.min($ - s.partTarget, s.targetduration * 1.5);
        if (O > 0) {
          if (n && O > n.tuneInGoal)
            this.warn(`CDN Tune-in goal increased from: ${n.tuneInGoal} to: ${O} with playlist age: ${s.age}`), O = 0;
          else {
            const P = Math.floor(O / s.targetduration);
            if (c += P, d !== void 0) {
              const N = Math.round(O % s.targetduration / s.partTarget);
              d += N;
            }
            this.log(`CDN Tune-in age: ${s.ageHeader}s last advanced ${R.toFixed(2)}s goal: ${O} skip sn ${P} to part ${d}`);
          }
          s.tuneInGoal = O;
        }
        if (u = this.getDeliveryDirectives(s, r.deliveryDirectives, c, d), y || !E) {
          this.loadPlaylist(u);
          return;
        }
      } else
        s.canBlockReload && (u = this.getDeliveryDirectives(s, r.deliveryDirectives, c, d));
      const h = this.hls.mainForwardBufferInfo, f = h ? h.end - h.len : 0, p = (s.edge - f) * 1e3, m = hZ(s, p);
      s.updated && o > this.requestScheduled + m && (this.requestScheduled = a.loading.start), c !== void 0 && s.canBlockReload ? this.requestScheduled = a.loading.first + m - (s.partTarget * 1e3 || 1e3) : this.requestScheduled === -1 || this.requestScheduled + m < o ? this.requestScheduled = o : this.requestScheduled - o <= 0 && (this.requestScheduled += m);
      let b = this.requestScheduled - o;
      b = Math.max(0, b), this.log(`reload live playlist ${e} in ${Math.round(b)} ms`), this.timer = self.setTimeout(() => this.loadPlaylist(u), b);
    } else
      this.clearTimer();
  }
  getDeliveryDirectives(e, r, n, s) {
    let a = oZ(e, n);
    return r != null && r.skip && e.deltaUpdateFailed && (n = r.msn, s = r.part, a = Sf.No), new BI(n, s, a);
  }
  checkRetry(e) {
    const r = e.details, n = oy(e), s = e.errorAction, {
      action: a,
      retryCount: o = 0,
      retryConfig: l
    } = s || {}, u = !!s && !!l && (a === Un.RetryRequest || !s.resolved && a === Un.SendAlternateToPenaltyBox);
    if (u) {
      var c;
      if (this.requestScheduled = -1, o >= l.maxNumRetry)
        return !1;
      if (n && (c = e.context) != null && c.deliveryDirectives)
        this.warn(`Retrying playlist loading ${o + 1}/${l.maxNumRetry} after "${r}" without delivery-directives`), this.loadPlaylist();
      else {
        const d = Yk(l, o);
        this.timer = self.setTimeout(() => this.loadPlaylist(), d), this.warn(`Retrying playlist loading ${o + 1}/${l.maxNumRetry} after "${r}" in ${d}ms`);
      }
      e.levelRetry = !0, s.resolved = !0;
    }
    return u;
  }
}
let k_;
class wZ extends Hk {
  constructor(e, r) {
    super(e, "[level-controller]"), this._levels = [], this._firstLevel = -1, this._startLevel = void 0, this.currentLevel = null, this.currentLevelIndex = -1, this.manualLevelIndex = -1, this.steering = void 0, this.onParsedComplete = void 0, this.steering = r, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(D.MANIFEST_LOADING, this.onManifestLoading, this), e.on(D.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(D.LEVEL_LOADED, this.onLevelLoaded, this), e.on(D.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(D.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(D.FRAG_LOADED, this.onFragLoaded, this), e.on(D.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(D.MANIFEST_LOADING, this.onManifestLoading, this), e.off(D.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(D.LEVEL_LOADED, this.onLevelLoaded, this), e.off(D.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(D.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(D.FRAG_LOADED, this.onFragLoaded, this), e.off(D.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners(), this.steering = null, this.resetLevels(), super.destroy();
  }
  startLoad() {
    this._levels.forEach((r) => {
      r.loadError = 0, r.fragmentError = 0;
    }), super.startLoad();
  }
  resetLevels() {
    this._startLevel = void 0, this.manualLevelIndex = -1, this.currentLevelIndex = -1, this.currentLevel = null, this._levels = [];
  }
  onManifestLoading(e, r) {
    this.resetLevels();
  }
  onManifestLoaded(e, r) {
    const n = [], s = {};
    let a;
    r.levels.forEach((o) => {
      var l;
      const u = o.attrs;
      ((l = o.audioCodec) == null ? void 0 : l.indexOf("mp4a.40.34")) !== -1 && (k_ || (k_ = /chrome|firefox/i.test(navigator.userAgent)), k_ && (o.audioCodec = void 0));
      const {
        AUDIO: c,
        CODECS: d,
        "FRAME-RATE": h,
        "PATHWAY-ID": f,
        RESOLUTION: p,
        SUBTITLES: m
      } = u, y = `${`${f || "."}-`}${o.bitrate}-${p}-${h}-${d}`;
      a = s[y], a ? a.addFallback(o) : (a = new Xf(o), s[y] = a, n.push(a)), uy(a, "audio", c), uy(a, "text", m);
    }), this.filterAndSortMediaOptions(n, r);
  }
  filterAndSortMediaOptions(e, r) {
    let n = [], s = [], a = !1, o = !1, l = !1, u = e.filter(({
      audioCodec: p,
      videoCodec: m,
      width: b,
      height: y,
      unknownCodecs: _
    }) => (a || (a = !!(b && y)), o || (o = !!m), l || (l = !!p), !(_ != null && _.length) && (!p || x_(p, "audio")) && (!m || x_(m, "video"))));
    if ((a || o) && l && (u = u.filter(({
      videoCodec: p,
      width: m,
      height: b
    }) => !!p || !!(m && b))), u.length === 0) {
      Promise.resolve().then(() => {
        if (this.hls) {
          const p = new Error("no level with compatible codecs found in manifest");
          this.hls.trigger(D.ERROR, {
            type: it.MEDIA_ERROR,
            details: le.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: !0,
            url: r.url,
            error: p,
            reason: p.message
          });
        }
      });
      return;
    }
    r.audioTracks && (n = r.audioTracks.filter((p) => !p.audioCodec || x_(p.audioCodec, "audio")), HI(n)), r.subtitles && (s = r.subtitles, HI(s));
    const c = u.slice(0);
    u.sort((p, m) => p.attrs["HDCP-LEVEL"] !== m.attrs["HDCP-LEVEL"] ? (p.attrs["HDCP-LEVEL"] || "") > (m.attrs["HDCP-LEVEL"] || "") ? 1 : -1 : p.bitrate !== m.bitrate ? p.bitrate - m.bitrate : p.attrs["FRAME-RATE"] !== m.attrs["FRAME-RATE"] ? p.attrs.decimalFloatingPoint("FRAME-RATE") - m.attrs.decimalFloatingPoint("FRAME-RATE") : p.attrs.SCORE !== m.attrs.SCORE ? p.attrs.decimalFloatingPoint("SCORE") - m.attrs.decimalFloatingPoint("SCORE") : a && p.height !== m.height ? p.height - m.height : 0);
    let d = c[0];
    if (this.steering && (u = this.steering.filterParsedLevels(u), u.length !== c.length)) {
      for (let p = 0; p < c.length; p++)
        if (c[p].pathwayId === u[0].pathwayId) {
          d = c[p];
          break;
        }
    }
    this._levels = u;
    for (let p = 0; p < u.length; p++)
      if (u[p] === d) {
        this._firstLevel = p, this.log(`manifest loaded, ${u.length} level(s) found, first bitrate: ${d.bitrate}`);
        break;
      }
    const h = l && !o, f = {
      levels: u,
      audioTracks: n,
      subtitleTracks: s,
      sessionData: r.sessionData,
      sessionKeys: r.sessionKeys,
      firstLevel: this._firstLevel,
      stats: r.stats,
      audio: l,
      video: o,
      altAudio: !h && n.some((p) => !!p.url)
    };
    this.hls.trigger(D.MANIFEST_PARSED, f), (this.hls.config.autoStartLoad || this.hls.forceStartLoad) && this.hls.startLoad(this.hls.config.startPosition);
  }
  get levels() {
    return this._levels.length === 0 ? null : this._levels;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(e) {
    const r = this._levels;
    if (r.length === 0)
      return;
    if (e < 0 || e >= r.length) {
      const d = new Error("invalid level idx"), h = e < 0;
      if (this.hls.trigger(D.ERROR, {
        type: it.OTHER_ERROR,
        details: le.LEVEL_SWITCH_ERROR,
        level: e,
        fatal: h,
        error: d,
        reason: d.message
      }), h)
        return;
      e = Math.min(e, r.length - 1);
    }
    const n = this.currentLevelIndex, s = this.currentLevel, a = s ? s.attrs["PATHWAY-ID"] : void 0, o = r[e], l = o.attrs["PATHWAY-ID"];
    if (this.currentLevelIndex = e, this.currentLevel = o, n === e && o.details && s && a === l)
      return;
    this.log(`Switching to level ${e}${l ? " with Pathway " + l : ""} from level ${n}${a ? " with Pathway " + a : ""}`);
    const u = hn({}, o, {
      level: e,
      maxBitrate: o.maxBitrate,
      attrs: o.attrs,
      uri: o.uri,
      urlId: o.urlId
    });
    delete u._attrs, delete u._urlId, this.hls.trigger(D.LEVEL_SWITCHING, u);
    const c = o.details;
    if (!c || c.live) {
      const d = this.switchParams(o.uri, s == null ? void 0 : s.details);
      this.loadPlaylist(d);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(e) {
    this.manualLevelIndex = e, this._startLevel === void 0 && (this._startLevel = e), e !== -1 && (this.level = e);
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(e) {
    this._firstLevel = e;
  }
  get startLevel() {
    if (this._startLevel === void 0) {
      const e = this.hls.config.startLevel;
      return e !== void 0 ? e : this._firstLevel;
    } else
      return this._startLevel;
  }
  set startLevel(e) {
    this._startLevel = e;
  }
  onError(e, r) {
    r.fatal || !r.context || r.context.type === Vt.LEVEL && r.context.level === this.level && this.checkRetry(r);
  }
  // reset errors on the successful load of a fragment
  onFragLoaded(e, {
    frag: r
  }) {
    if (r !== void 0 && r.type === at.MAIN) {
      const n = this._levels[r.level];
      n !== void 0 && (n.loadError = 0);
    }
  }
  onLevelLoaded(e, r) {
    var n;
    const {
      level: s,
      details: a
    } = r, o = this._levels[s];
    if (!o) {
      var l;
      this.warn(`Invalid level index ${s}`), (l = r.deliveryDirectives) != null && l.skip && (a.deltaUpdateFailed = !0);
      return;
    }
    s === this.currentLevelIndex ? (o.fragmentError === 0 && (o.loadError = 0), this.playlistLoaded(s, r, o.details)) : (n = r.deliveryDirectives) != null && n.skip && (a.deltaUpdateFailed = !0);
  }
  onAudioTrackSwitched(e, r) {
    const n = this.currentLevel;
    if (!n)
      return;
    const s = this.hls.audioTracks[r.id].groupId;
    if (n.audioGroupIds && n.audioGroupId !== s) {
      let a = -1;
      for (let o = 0; o < n.audioGroupIds.length; o++)
        if (n.audioGroupIds[o] === s) {
          a = o;
          break;
        }
      a !== -1 && a !== n.urlId && (n.urlId = a, this.canLoad && this.startLoad());
    }
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const r = this.currentLevelIndex, n = this.currentLevel;
    if (n && this.shouldLoadPlaylist(n)) {
      const s = n.urlId;
      let a = n.uri;
      if (e)
        try {
          a = e.addDirectives(a);
        } catch (l) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${l}`);
        }
      const o = n.attrs["PATHWAY-ID"];
      this.log(`Loading level index ${r}${(e == null ? void 0 : e.msn) !== void 0 ? " at sn " + e.msn + " part " + e.part : ""} with${o ? " Pathway " + o : ""} URI ${s + 1}/${n.url.length} ${a}`), this.clearTimer(), this.hls.trigger(D.LEVEL_LOADING, {
        url: a,
        level: r,
        id: s,
        deliveryDirectives: e || null
      });
    }
  }
  get nextLoadLevel() {
    return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
  }
  set nextLoadLevel(e) {
    this.level = e, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = e);
  }
  removeLevel(e, r) {
    const n = (a, o) => o !== r, s = this._levels.filter((a, o) => o !== e ? !0 : a.url.length > 1 && r !== void 0 ? (a.url = a.url.filter(n), a.audioGroupIds && (a.audioGroupIds = a.audioGroupIds.filter(n)), a.textGroupIds && (a.textGroupIds = a.textGroupIds.filter(n)), a.urlId = 0, !0) : (this.steering && this.steering.removeLevel(a), !1));
    this.hls.trigger(D.LEVELS_UPDATED, {
      levels: s
    });
  }
  onLevelsUpdated(e, {
    levels: r
  }) {
    r.forEach((n, s) => {
      const {
        details: a
      } = n;
      a != null && a.fragments && a.fragments.forEach((o) => {
        o.level = s;
      });
    }), this._levels = r;
  }
}
function uy(t, e, r) {
  r && (e === "audio" ? (t.audioGroupIds || (t.audioGroupIds = []), t.audioGroupIds[t.url.length - 1] = r) : e === "text" && (t.textGroupIds || (t.textGroupIds = []), t.textGroupIds[t.url.length - 1] = r));
}
function HI(t) {
  const e = {};
  t.forEach((r) => {
    const n = r.groupId || "";
    r.id = e[n] = e[n] || 0, e[n]++;
  });
}
var yn = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class TZ {
  constructor(e) {
    this.activePartLists = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.bufferPadding = 0.2, this.hls = void 0, this.hasGaps = !1, this.hls = e, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(D.BUFFER_APPENDED, this.onBufferAppended, this), e.on(D.FRAG_BUFFERED, this.onFragBuffered, this), e.on(D.FRAG_LOADED, this.onFragLoaded, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(D.BUFFER_APPENDED, this.onBufferAppended, this), e.off(D.FRAG_BUFFERED, this.onFragBuffered, this), e.off(D.FRAG_LOADED, this.onFragLoaded, this);
  }
  destroy() {
    this._unregisterListeners(), this.fragments = // @ts-ignore
    this.activePartLists = // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }
  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(e, r) {
    const n = this.activePartLists[r];
    if (n)
      for (let s = n.length; s--; ) {
        const a = n[s];
        if (!a)
          break;
        const o = a.end;
        if (a.start <= e && o !== null && e <= o)
          return a;
      }
    return this.getBufferedFrag(e, r);
  }
  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(e, r) {
    const {
      fragments: n
    } = this, s = Object.keys(n);
    for (let a = s.length; a--; ) {
      const o = n[s[a]];
      if ((o == null ? void 0 : o.body.type) === r && o.buffered) {
        const l = o.body;
        if (l.start <= e && e <= l.end)
          return l;
      }
    }
    return null;
  }
  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(e, r, n, s) {
    this.timeRanges && (this.timeRanges[e] = r);
    const a = (s == null ? void 0 : s.fragment.sn) || -1;
    Object.keys(this.fragments).forEach((o) => {
      const l = this.fragments[o];
      if (!l || a >= l.body.sn)
        return;
      if (!l.buffered && !l.loaded) {
        l.body.type === n && this.removeFragment(l.body);
        return;
      }
      const u = l.range[e];
      u && u.time.some((c) => {
        const d = !this.isTimeBuffered(c.startPTS, c.endPTS, r);
        return d && this.removeFragment(l.body), d;
      });
    });
  }
  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(e) {
    const r = this.timeRanges, {
      frag: n,
      part: s
    } = e;
    if (!r || n.sn === "initSegment")
      return;
    const a = Oc(n), o = this.fragments[a];
    if (!o || o.buffered && n.gap)
      return;
    const l = !n.relurl;
    Object.keys(r).forEach((u) => {
      const c = n.elementaryStreams[u];
      if (!c)
        return;
      const d = r[u], h = l || c.partial === !0;
      o.range[u] = this.getBufferedTimes(n, s, h, d);
    }), o.loaded = null, Object.keys(o.range).length ? (o.buffered = !0, o.body.endList && (this.endListFragments[o.body.type] = o), ym(o) || this.removeParts(n.sn - 1, n.type)) : this.removeFragment(o.body);
  }
  removeParts(e, r) {
    const n = this.activePartLists[r];
    n && (this.activePartLists[r] = n.filter((s) => s.fragment.sn >= e));
  }
  fragBuffered(e, r) {
    const n = Oc(e);
    let s = this.fragments[n];
    !s && r && (s = this.fragments[n] = {
      body: e,
      appendedPTS: null,
      loaded: null,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    }, e.gap && (this.hasGaps = !0)), s && (s.loaded = null, s.buffered = !0);
  }
  getBufferedTimes(e, r, n, s) {
    const a = {
      time: [],
      partial: n
    }, o = e.start, l = e.end, u = e.minEndPTS || l, c = e.maxStartPTS || o;
    for (let d = 0; d < s.length; d++) {
      const h = s.start(d) - this.bufferPadding, f = s.end(d) + this.bufferPadding;
      if (c >= h && u <= f) {
        a.time.push({
          startPTS: Math.max(o, s.start(d)),
          endPTS: Math.min(l, s.end(d))
        });
        break;
      } else if (o < f && l > h)
        a.partial = !0, a.time.push({
          startPTS: Math.max(o, s.start(d)),
          endPTS: Math.min(l, s.end(d))
        });
      else if (l <= h)
        break;
    }
    return a;
  }
  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(e) {
    let r = null, n, s, a, o = 0;
    const {
      bufferPadding: l,
      fragments: u
    } = this;
    return Object.keys(u).forEach((c) => {
      const d = u[c];
      d && ym(d) && (s = d.body.start - l, a = d.body.end + l, e >= s && e <= a && (n = Math.min(e - s, a - e), o <= n && (r = d.body, o = n)));
    }), r;
  }
  isEndListAppended(e) {
    const r = this.endListFragments[e];
    return r !== void 0 && (r.buffered || ym(r));
  }
  getState(e) {
    const r = Oc(e), n = this.fragments[r];
    return n ? n.buffered ? ym(n) ? yn.PARTIAL : yn.OK : yn.APPENDING : yn.NOT_LOADED;
  }
  isTimeBuffered(e, r, n) {
    let s, a;
    for (let o = 0; o < n.length; o++) {
      if (s = n.start(o) - this.bufferPadding, a = n.end(o) + this.bufferPadding, e >= s && r <= a)
        return !0;
      if (r <= s)
        return !1;
    }
    return !1;
  }
  onFragLoaded(e, r) {
    const {
      frag: n,
      part: s
    } = r;
    if (n.sn === "initSegment" || n.bitrateTest)
      return;
    const a = s ? null : r, o = Oc(n);
    this.fragments[o] = {
      body: n,
      appendedPTS: null,
      loaded: a,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    };
  }
  onBufferAppended(e, r) {
    const {
      frag: n,
      part: s,
      timeRanges: a
    } = r;
    if (n.sn === "initSegment")
      return;
    const o = n.type;
    if (s) {
      let l = this.activePartLists[o];
      l || (this.activePartLists[o] = l = []), l.push(s);
    }
    this.timeRanges = a, Object.keys(a).forEach((l) => {
      const u = a[l];
      this.detectEvictedFragments(l, u, o, s);
    });
  }
  onFragBuffered(e, r) {
    this.detectPartialFragments(r);
  }
  hasFragment(e) {
    const r = Oc(e);
    return !!this.fragments[r];
  }
  hasParts(e) {
    var r;
    return !!((r = this.activePartLists[e]) != null && r.length);
  }
  removeFragmentsInRange(e, r, n, s, a) {
    s && !this.hasGaps || Object.keys(this.fragments).forEach((o) => {
      const l = this.fragments[o];
      if (!l)
        return;
      const u = l.body;
      u.type !== n || s && !u.gap || u.start < r && u.end > e && (l.buffered || a) && this.removeFragment(u);
    });
  }
  removeFragment(e) {
    const r = Oc(e);
    e.stats.loaded = 0, e.clearElementaryStreamInfo();
    const n = this.activePartLists[e.type];
    if (n) {
      const s = e.sn;
      this.activePartLists[e.type] = n.filter((a) => a.fragment.sn !== s);
    }
    delete this.fragments[r], e.endList && delete this.endListFragments[e.type];
  }
  removeAllFragments() {
    this.fragments = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.activePartLists = /* @__PURE__ */ Object.create(null), this.hasGaps = !1;
  }
}
function ym(t) {
  var e, r, n;
  return t.buffered && (t.body.gap || ((e = t.range.video) == null ? void 0 : e.partial) || ((r = t.range.audio) == null ? void 0 : r.partial) || ((n = t.range.audiovideo) == null ? void 0 : n.partial));
}
function Oc(t) {
  return `${t.type}_${t.level}_${t.urlId}_${t.sn}`;
}
const GI = Math.pow(2, 17);
class xZ {
  constructor(e) {
    this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = e;
  }
  destroy() {
    this.loader && (this.loader.destroy(), this.loader = null);
  }
  abort() {
    this.loader && this.loader.abort();
  }
  load(e, r) {
    const n = e.url;
    if (!n)
      return Promise.reject(new eo({
        type: it.NETWORK_ERROR,
        details: le.FRAG_LOAD_ERROR,
        fatal: !1,
        frag: e,
        error: new Error(`Fragment does not have a ${n ? "part list" : "url"}`),
        networkDetails: null
      }));
    this.abort();
    const s = this.config, a = s.fLoader, o = s.loader;
    return new Promise((l, u) => {
      if (this.loader && this.loader.destroy(), e.gap)
        if (e.tagList.some((p) => p[0] === "GAP")) {
          u(jI(e));
          return;
        } else
          e.gap = !1;
      const c = this.loader = e.loader = a ? new a(s) : new o(s), d = WI(e), h = YI(s.fragLoadPolicy.default), f = {
        loadPolicy: h,
        timeout: h.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: e.sn === "initSegment" ? 1 / 0 : GI
      };
      e.stats = c.stats, c.load(d, f, {
        onSuccess: (p, m, b, y) => {
          this.resetLoader(e, c);
          let _ = p.data;
          b.resetIV && e.decryptdata && (e.decryptdata.iv = new Uint8Array(_.slice(0, 16)), _ = _.slice(16)), l({
            frag: e,
            part: null,
            payload: _,
            networkDetails: y
          });
        },
        onError: (p, m, b, y) => {
          this.resetLoader(e, c), u(new eo({
            type: it.NETWORK_ERROR,
            details: le.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            response: Ei({
              url: n,
              data: void 0
            }, p),
            error: new Error(`HTTP Error ${p.code} ${p.text}`),
            networkDetails: b,
            stats: y
          }));
        },
        onAbort: (p, m, b) => {
          this.resetLoader(e, c), u(new eo({
            type: it.NETWORK_ERROR,
            details: le.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            error: new Error("Aborted"),
            networkDetails: b,
            stats: p
          }));
        },
        onTimeout: (p, m, b) => {
          this.resetLoader(e, c), u(new eo({
            type: it.NETWORK_ERROR,
            details: le.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            error: new Error(`Timeout after ${f.timeout}ms`),
            networkDetails: b,
            stats: p
          }));
        },
        onProgress: (p, m, b, y) => {
          r && r({
            frag: e,
            part: null,
            payload: b,
            networkDetails: y
          });
        }
      });
    });
  }
  loadPart(e, r, n) {
    this.abort();
    const s = this.config, a = s.fLoader, o = s.loader;
    return new Promise((l, u) => {
      if (this.loader && this.loader.destroy(), e.gap || r.gap) {
        u(jI(e, r));
        return;
      }
      const c = this.loader = e.loader = a ? new a(s) : new o(s), d = WI(e, r), h = YI(s.fragLoadPolicy.default), f = {
        loadPolicy: h,
        timeout: h.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: GI
      };
      r.stats = c.stats, c.load(d, f, {
        onSuccess: (p, m, b, y) => {
          this.resetLoader(e, c), this.updateStatsFromPart(e, r);
          const _ = {
            frag: e,
            part: r,
            payload: p.data,
            networkDetails: y
          };
          n(_), l(_);
        },
        onError: (p, m, b, y) => {
          this.resetLoader(e, c), u(new eo({
            type: it.NETWORK_ERROR,
            details: le.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            part: r,
            response: Ei({
              url: d.url,
              data: void 0
            }, p),
            error: new Error(`HTTP Error ${p.code} ${p.text}`),
            networkDetails: b,
            stats: y
          }));
        },
        onAbort: (p, m, b) => {
          e.stats.aborted = r.stats.aborted, this.resetLoader(e, c), u(new eo({
            type: it.NETWORK_ERROR,
            details: le.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            part: r,
            error: new Error("Aborted"),
            networkDetails: b,
            stats: p
          }));
        },
        onTimeout: (p, m, b) => {
          this.resetLoader(e, c), u(new eo({
            type: it.NETWORK_ERROR,
            details: le.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            part: r,
            error: new Error(`Timeout after ${f.timeout}ms`),
            networkDetails: b,
            stats: p
          }));
        }
      });
    });
  }
  updateStatsFromPart(e, r) {
    const n = e.stats, s = r.stats, a = s.total;
    if (n.loaded += s.loaded, a) {
      const u = Math.round(e.duration / r.duration), c = Math.min(Math.round(n.loaded / a), u), h = (u - c) * Math.round(n.loaded / c);
      n.total = n.loaded + h;
    } else
      n.total = Math.max(n.loaded, n.total);
    const o = n.loading, l = s.loading;
    o.start ? o.first += l.first - l.start : (o.start = l.start, o.first = l.first), o.end = l.end;
  }
  resetLoader(e, r) {
    e.loader = null, this.loader === r && (self.clearTimeout(this.partLoadTimeout), this.loader = null), r.destroy();
  }
}
function WI(t, e = null) {
  const r = e || t, n = {
    frag: t,
    part: e,
    responseType: "arraybuffer",
    url: r.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  }, s = r.byteRangeStartOffset, a = r.byteRangeEndOffset;
  if (et(s) && et(a)) {
    var o;
    let l = s, u = a;
    if (t.sn === "initSegment" && ((o = t.decryptdata) == null ? void 0 : o.method) === "AES-128") {
      const c = a - s;
      c % 16 && (u = a + (16 - c % 16)), s !== 0 && (n.resetIV = !0, l = s - 16);
    }
    n.rangeStart = l, n.rangeEnd = u;
  }
  return n;
}
function jI(t, e) {
  const r = new Error(`GAP ${t.gap ? "tag" : "attribute"} found`), n = {
    type: it.MEDIA_ERROR,
    details: le.FRAG_GAP,
    fatal: !1,
    frag: t,
    error: r,
    networkDetails: null
  };
  return e && (n.part = e), (e || t).stats.aborted = !0, new eo(n);
}
class eo extends Error {
  constructor(e) {
    super(e.error.message), this.data = void 0, this.data = e;
  }
}
class SZ {
  constructor(e) {
    this.config = void 0, this.keyUriToKeyInfo = {}, this.emeController = null, this.config = e;
  }
  abort(e) {
    for (const r in this.keyUriToKeyInfo) {
      const n = this.keyUriToKeyInfo[r].loader;
      if (n) {
        if (e && e !== n.context.frag.type)
          return;
        n.abort();
      }
    }
  }
  detach() {
    for (const e in this.keyUriToKeyInfo) {
      const r = this.keyUriToKeyInfo[e];
      (r.mediaKeySessionContext || r.decryptdata.isCommonEncryption) && delete this.keyUriToKeyInfo[e];
    }
  }
  destroy() {
    this.detach();
    for (const e in this.keyUriToKeyInfo) {
      const r = this.keyUriToKeyInfo[e].loader;
      r && r.destroy();
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(e, r = le.KEY_LOAD_ERROR, n, s, a) {
    return new eo({
      type: it.NETWORK_ERROR,
      details: r,
      fatal: !1,
      frag: e,
      response: a,
      error: n,
      networkDetails: s
    });
  }
  loadClear(e, r) {
    if (this.emeController && this.config.emeEnabled) {
      const {
        sn: n,
        cc: s
      } = e;
      for (let a = 0; a < r.length; a++) {
        const o = r[a];
        if (s <= o.cc && (n === "initSegment" || o.sn === "initSegment" || n < o.sn)) {
          this.emeController.selectKeySystemFormat(o).then((l) => {
            o.setKeyFormat(l);
          });
          break;
        }
      }
    }
  }
  load(e) {
    return !e.decryptdata && e.encrypted && this.emeController ? this.emeController.selectKeySystemFormat(e).then((r) => this.loadInternal(e, r)) : this.loadInternal(e);
  }
  loadInternal(e, r) {
    var n, s;
    r && e.setKeyFormat(r);
    const a = e.decryptdata;
    if (!a) {
      const c = new Error(r ? `Expected frag.decryptdata to be defined after setting format ${r}` : "Missing decryption data on fragment in onKeyLoading");
      return Promise.reject(this.createKeyLoadError(e, le.KEY_LOAD_ERROR, c));
    }
    const o = a.uri;
    if (!o)
      return Promise.reject(this.createKeyLoadError(e, le.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${o}"`)));
    let l = this.keyUriToKeyInfo[o];
    if ((n = l) != null && n.decryptdata.key)
      return a.key = l.decryptdata.key, Promise.resolve({
        frag: e,
        keyInfo: l
      });
    if ((s = l) != null && s.keyLoadPromise) {
      var u;
      switch ((u = l.mediaKeySessionContext) == null ? void 0 : u.keyStatus) {
        case void 0:
        case "status-pending":
        case "usable":
        case "usable-in-future":
          return l.keyLoadPromise.then((c) => (a.key = c.keyInfo.decryptdata.key, {
            frag: e,
            keyInfo: l
          }));
      }
    }
    switch (l = this.keyUriToKeyInfo[o] = {
      decryptdata: a,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    }, a.method) {
      case "ISO-23001-7":
      case "SAMPLE-AES":
      case "SAMPLE-AES-CENC":
      case "SAMPLE-AES-CTR":
        return a.keyFormat === "identity" ? this.loadKeyHTTP(l, e) : this.loadKeyEME(l, e);
      case "AES-128":
        return this.loadKeyHTTP(l, e);
      default:
        return Promise.reject(this.createKeyLoadError(e, le.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${a.method}"`)));
    }
  }
  loadKeyEME(e, r) {
    const n = {
      frag: r,
      keyInfo: e
    };
    if (this.emeController && this.config.emeEnabled) {
      const s = this.emeController.loadKey(n);
      if (s)
        return (e.keyLoadPromise = s.then((a) => (e.mediaKeySessionContext = a, n))).catch((a) => {
          throw e.keyLoadPromise = null, a;
        });
    }
    return Promise.resolve(n);
  }
  loadKeyHTTP(e, r) {
    const n = this.config, s = n.loader, a = new s(n);
    return r.keyLoader = e.loader = a, e.keyLoadPromise = new Promise((o, l) => {
      const u = {
        keyInfo: e,
        frag: r,
        responseType: "arraybuffer",
        url: e.decryptdata.uri
      }, c = n.keyLoadPolicy.default, d = {
        loadPolicy: c,
        timeout: c.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, h = {
        onSuccess: (f, p, m, b) => {
          const {
            frag: y,
            keyInfo: _,
            url: x
          } = m;
          if (!y.decryptdata || _ !== this.keyUriToKeyInfo[x])
            return l(this.createKeyLoadError(y, le.KEY_LOAD_ERROR, new Error("after key load, decryptdata unset or changed"), b));
          _.decryptdata.key = y.decryptdata.key = new Uint8Array(f.data), y.keyLoader = null, _.loader = null, o({
            frag: y,
            keyInfo: _
          });
        },
        onError: (f, p, m, b) => {
          this.resetLoader(p), l(this.createKeyLoadError(r, le.KEY_LOAD_ERROR, new Error(`HTTP Error ${f.code} loading key ${f.text}`), m, Ei({
            url: u.url,
            data: void 0
          }, f)));
        },
        onTimeout: (f, p, m) => {
          this.resetLoader(p), l(this.createKeyLoadError(r, le.KEY_LOAD_TIMEOUT, new Error("key loading timed out"), m));
        },
        onAbort: (f, p, m) => {
          this.resetLoader(p), l(this.createKeyLoadError(r, le.INTERNAL_ABORTED, new Error("key loading aborted"), m));
        }
      };
      a.load(u, d, h);
    });
  }
  resetLoader(e) {
    const {
      frag: r,
      keyInfo: n,
      url: s
    } = e, a = n.loader;
    r.keyLoader === a && (r.keyLoader = null, n.loader = null), delete this.keyUriToKeyInfo[s], a && a.destroy();
  }
}
class EZ {
  constructor() {
    this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying(), this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    this.clearNextTick(), this.clearInterval();
  }
  onHandlerDestroyed() {
  }
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }
  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(e) {
    return this._tickInterval ? !1 : (this._tickCallCount = 0, this._tickInterval = self.setInterval(this._boundTick, e), !0);
  }
  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
  }
  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
  }
  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
  }
  tickImmediate() {
    this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
  }
  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {
  }
}
const $Z = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class Tr {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(e, r) {
    try {
      if (e) {
        const n = Tr.getBuffered(e);
        for (let s = 0; s < n.length; s++)
          if (r >= n.start(s) && r <= n.end(s))
            return !0;
      }
    } catch {
    }
    return !1;
  }
  static bufferInfo(e, r, n) {
    try {
      if (e) {
        const s = Tr.getBuffered(e), a = [];
        let o;
        for (o = 0; o < s.length; o++)
          a.push({
            start: s.start(o),
            end: s.end(o)
          });
        return this.bufferedInfo(a, r, n);
      }
    } catch {
    }
    return {
      len: 0,
      start: r,
      end: r,
      nextStart: void 0
    };
  }
  static bufferedInfo(e, r, n) {
    r = Math.max(0, r), e.sort(function(c, d) {
      const h = c.start - d.start;
      return h || d.end - c.end;
    });
    let s = [];
    if (n)
      for (let c = 0; c < e.length; c++) {
        const d = s.length;
        if (d) {
          const h = s[d - 1].end;
          e[c].start - h < n ? e[c].end > h && (s[d - 1].end = e[c].end) : s.push(e[c]);
        } else
          s.push(e[c]);
      }
    else
      s = e;
    let a = 0, o, l = r, u = r;
    for (let c = 0; c < s.length; c++) {
      const d = s[c].start, h = s[c].end;
      if (r + n >= d && r < h)
        l = d, u = h, a = u - r;
      else if (r + n < d) {
        o = d;
        break;
      }
    }
    return {
      len: a,
      start: l || 0,
      end: u || 0,
      nextStart: o
    };
  }
  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(e) {
    try {
      return e.buffered;
    } catch (r) {
      return J.log("failed to get media.buffered", r), $Z;
    }
  }
}
class Gk {
  constructor(e, r, n, s = 0, a = -1, o = !1) {
    this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = bm(), this.buffering = {
      audio: bm(),
      video: bm(),
      audiovideo: bm()
    }, this.level = e, this.sn = r, this.id = n, this.size = s, this.part = a, this.partial = o;
  }
}
function bm() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}
function wU(t, e) {
  let r = null;
  for (let n = 0, s = t.length; n < s; n++) {
    const a = t[n];
    if (a && a.cc === e) {
      r = a;
      break;
    }
  }
  return r;
}
function kZ(t, e, r) {
  return !!(e.details && (r.endCC > r.startCC || t && t.cc < r.startCC));
}
function DZ(t, e, r = 0) {
  const n = t.fragments, s = e.fragments;
  if (!s.length || !n.length) {
    J.log("No fragments to align");
    return;
  }
  const a = wU(n, s[0].cc);
  if (!a || a && !a.startPTS) {
    J.log("No frag in previous level to align on");
    return;
  }
  return a;
}
function KI(t, e) {
  if (t) {
    const r = t.start + e;
    t.start = t.startPTS = r, t.endPTS = r + t.duration;
  }
}
function Wk(t, e) {
  const r = e.fragments;
  for (let n = 0, s = r.length; n < s; n++)
    KI(r[n], t);
  e.fragmentHint && KI(e.fragmentHint, t), e.alignedSliding = !0;
}
function OZ(t, e, r) {
  e && (AZ(t, r, e), !r.alignedSliding && e.details && CZ(r, e.details), !r.alignedSliding && e.details && !r.skippedSegments && yU(e.details, r));
}
function AZ(t, e, r) {
  if (kZ(t, r, e)) {
    const n = DZ(r.details, e);
    n && et(n.start) && (J.log(`Adjusting PTS using last level due to CC increase within current level ${e.url}`), Wk(n.start, e));
  }
}
function CZ(t, e) {
  if (!e.fragments.length || !t.hasProgramDateTime || !e.hasProgramDateTime)
    return;
  const r = e.fragments[0].programDateTime, n = t.fragments[0].programDateTime, s = (n - r) / 1e3 + e.fragments[0].start;
  s && et(s) && (J.log(`Adjusting PTS using programDateTime delta ${n - r}ms, sliding:${s.toFixed(3)} ${t.url} `), Wk(s, t));
}
function TU(t, e) {
  if (!t.hasProgramDateTime || !e.hasProgramDateTime)
    return;
  const r = t.fragments, n = e.fragments;
  if (!r.length || !n.length)
    return;
  const s = Math.round(n.length / 2) - 1, a = n[s], o = wU(r, a.cc) || r[Math.round(r.length / 2) - 1], l = a.programDateTime, u = o.programDateTime;
  if (l === null || u === null)
    return;
  const c = (u - l) / 1e3 - (o.start - a.start);
  Wk(c, t);
}
class IZ {
  constructor(e, r) {
    this.subtle = void 0, this.aesIV = void 0, this.subtle = e, this.aesIV = r;
  }
  decrypt(e, r) {
    return this.subtle.decrypt({
      name: "AES-CBC",
      iv: this.aesIV
    }, r, e);
  }
}
class PZ {
  constructor(e, r) {
    this.subtle = void 0, this.key = void 0, this.subtle = e, this.key = r;
  }
  expandKey() {
    return this.subtle.importKey("raw", this.key, {
      name: "AES-CBC"
    }, !1, ["encrypt", "decrypt"]);
  }
}
function RZ(t) {
  const e = t.byteLength, r = e && new DataView(t.buffer).getUint8(e - 1);
  return r ? _u(t, 0, e - r) : t;
}
class MZ {
  constructor() {
    this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
  }
  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(e) {
    const r = new DataView(e), n = new Uint32Array(4);
    for (let s = 0; s < 4; s++)
      n[s] = r.getUint32(s * 4);
    return n;
  }
  initTable() {
    const e = this.sBox, r = this.invSBox, n = this.subMix, s = n[0], a = n[1], o = n[2], l = n[3], u = this.invSubMix, c = u[0], d = u[1], h = u[2], f = u[3], p = new Uint32Array(256);
    let m = 0, b = 0, y = 0;
    for (y = 0; y < 256; y++)
      y < 128 ? p[y] = y << 1 : p[y] = y << 1 ^ 283;
    for (y = 0; y < 256; y++) {
      let _ = b ^ b << 1 ^ b << 2 ^ b << 3 ^ b << 4;
      _ = _ >>> 8 ^ _ & 255 ^ 99, e[m] = _, r[_] = m;
      const x = p[m], T = p[x], k = p[T];
      let E = p[_] * 257 ^ _ * 16843008;
      s[m] = E << 24 | E >>> 8, a[m] = E << 16 | E >>> 16, o[m] = E << 8 | E >>> 24, l[m] = E, E = k * 16843009 ^ T * 65537 ^ x * 257 ^ m * 16843008, c[_] = E << 24 | E >>> 8, d[_] = E << 16 | E >>> 16, h[_] = E << 8 | E >>> 24, f[_] = E, m ? (m = x ^ p[p[p[k ^ x]]], b ^= p[p[b]]) : m = b = 1;
    }
  }
  expandKey(e) {
    const r = this.uint8ArrayToUint32Array_(e);
    let n = !0, s = 0;
    for (; s < r.length && n; )
      n = r[s] === this.key[s], s++;
    if (n)
      return;
    this.key = r;
    const a = this.keySize = r.length;
    if (a !== 4 && a !== 6 && a !== 8)
      throw new Error("Invalid aes key size=" + a);
    const o = this.ksRows = (a + 6 + 1) * 4;
    let l, u;
    const c = this.keySchedule = new Uint32Array(o), d = this.invKeySchedule = new Uint32Array(o), h = this.sBox, f = this.rcon, p = this.invSubMix, m = p[0], b = p[1], y = p[2], _ = p[3];
    let x, T;
    for (l = 0; l < o; l++) {
      if (l < a) {
        x = c[l] = r[l];
        continue;
      }
      T = x, l % a === 0 ? (T = T << 8 | T >>> 24, T = h[T >>> 24] << 24 | h[T >>> 16 & 255] << 16 | h[T >>> 8 & 255] << 8 | h[T & 255], T ^= f[l / a | 0] << 24) : a > 6 && l % a === 4 && (T = h[T >>> 24] << 24 | h[T >>> 16 & 255] << 16 | h[T >>> 8 & 255] << 8 | h[T & 255]), c[l] = x = (c[l - a] ^ T) >>> 0;
    }
    for (u = 0; u < o; u++)
      l = o - u, u & 3 ? T = c[l] : T = c[l - 4], u < 4 || l <= 4 ? d[u] = T : d[u] = m[h[T >>> 24]] ^ b[h[T >>> 16 & 255]] ^ y[h[T >>> 8 & 255]] ^ _[h[T & 255]], d[u] = d[u] >>> 0;
  }
  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(e) {
    return e << 24 | (e & 65280) << 8 | (e & 16711680) >> 8 | e >>> 24;
  }
  decrypt(e, r, n) {
    const s = this.keySize + 6, a = this.invKeySchedule, o = this.invSBox, l = this.invSubMix, u = l[0], c = l[1], d = l[2], h = l[3], f = this.uint8ArrayToUint32Array_(n);
    let p = f[0], m = f[1], b = f[2], y = f[3];
    const _ = new Int32Array(e), x = new Int32Array(_.length);
    let T, k, E, F, R, $, O, P, N, I, B, W, Q, te;
    const H = this.networkToHostOrderSwap;
    for (; r < _.length; ) {
      for (N = H(_[r]), I = H(_[r + 1]), B = H(_[r + 2]), W = H(_[r + 3]), R = N ^ a[0], $ = W ^ a[1], O = B ^ a[2], P = I ^ a[3], Q = 4, te = 1; te < s; te++)
        T = u[R >>> 24] ^ c[$ >> 16 & 255] ^ d[O >> 8 & 255] ^ h[P & 255] ^ a[Q], k = u[$ >>> 24] ^ c[O >> 16 & 255] ^ d[P >> 8 & 255] ^ h[R & 255] ^ a[Q + 1], E = u[O >>> 24] ^ c[P >> 16 & 255] ^ d[R >> 8 & 255] ^ h[$ & 255] ^ a[Q + 2], F = u[P >>> 24] ^ c[R >> 16 & 255] ^ d[$ >> 8 & 255] ^ h[O & 255] ^ a[Q + 3], R = T, $ = k, O = E, P = F, Q = Q + 4;
      T = o[R >>> 24] << 24 ^ o[$ >> 16 & 255] << 16 ^ o[O >> 8 & 255] << 8 ^ o[P & 255] ^ a[Q], k = o[$ >>> 24] << 24 ^ o[O >> 16 & 255] << 16 ^ o[P >> 8 & 255] << 8 ^ o[R & 255] ^ a[Q + 1], E = o[O >>> 24] << 24 ^ o[P >> 16 & 255] << 16 ^ o[R >> 8 & 255] << 8 ^ o[$ & 255] ^ a[Q + 2], F = o[P >>> 24] << 24 ^ o[R >> 16 & 255] << 16 ^ o[$ >> 8 & 255] << 8 ^ o[O & 255] ^ a[Q + 3], x[r] = H(T ^ p), x[r + 1] = H(F ^ m), x[r + 2] = H(E ^ b), x[r + 3] = H(k ^ y), p = N, m = I, b = B, y = W, r = r + 4;
    }
    return x.buffer;
  }
}
const LZ = 16;
class jk {
  constructor(e, {
    removePKCS7Padding: r = !0
  } = {}) {
    if (this.logEnabled = !0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.useSoftware = void 0, this.useSoftware = e.enableSoftwareAES, this.removePKCS7Padding = r, r)
      try {
        const n = self.crypto;
        n && (this.subtle = n.subtle || n.webkitSubtle);
      } catch {
      }
    this.subtle === null && (this.useSoftware = !0);
  }
  destroy() {
    this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult: e,
      remainderData: r
    } = this;
    if (!e || r)
      return this.reset(), null;
    const n = new Uint8Array(e);
    return this.reset(), this.removePKCS7Padding ? RZ(n) : n;
  }
  reset() {
    this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
  }
  decrypt(e, r, n) {
    return this.useSoftware ? new Promise((s, a) => {
      this.softwareDecrypt(new Uint8Array(e), r, n);
      const o = this.flush();
      o ? s(o.buffer) : a(new Error("[softwareDecrypt] Failed to decrypt data"));
    }) : this.webCryptoDecrypt(new Uint8Array(e), r, n);
  }
  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(e, r, n) {
    const {
      currentIV: s,
      currentResult: a,
      remainderData: o
    } = this;
    this.logOnce("JS AES decrypt"), o && (e = Bu(o, e), this.remainderData = null);
    const l = this.getValidChunk(e);
    if (!l.length)
      return null;
    s && (n = s);
    let u = this.softwareDecrypter;
    u || (u = this.softwareDecrypter = new MZ()), u.expandKey(r);
    const c = a;
    return this.currentResult = u.decrypt(l.buffer, 0, n), this.currentIV = _u(l, -16).buffer, c || null;
  }
  webCryptoDecrypt(e, r, n) {
    const s = this.subtle;
    return (this.key !== r || !this.fastAesKey) && (this.key = r, this.fastAesKey = new PZ(s, r)), this.fastAesKey.expandKey().then((a) => s ? (this.logOnce("WebCrypto AES decrypt"), new IZ(s, new Uint8Array(n)).decrypt(e.buffer, a)) : Promise.reject(new Error("web crypto not initialized"))).catch((a) => (J.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${a.name}: ${a.message}`), this.onWebCryptoError(e, r, n)));
  }
  onWebCryptoError(e, r, n) {
    this.useSoftware = !0, this.logEnabled = !0, this.softwareDecrypt(e, r, n);
    const s = this.flush();
    if (s)
      return s.buffer;
    throw new Error("WebCrypto and softwareDecrypt: failed to decrypt data");
  }
  getValidChunk(e) {
    let r = e;
    const n = e.length - e.length % LZ;
    return n !== e.length && (r = _u(e, 0, n), this.remainderData = _u(e, n)), r;
  }
  logOnce(e) {
    this.logEnabled && (J.log(`[decrypter]: ${e}`), this.logEnabled = !1);
  }
}
const NZ = {
  toString: function(t) {
    let e = "";
    const r = t.length;
    for (let n = 0; n < r; n++)
      e += `[${t.start(n).toFixed(3)}-${t.end(n).toFixed(3)}]`;
    return e;
  }
}, _e = {
  STOPPED: "STOPPED",
  IDLE: "IDLE",
  KEY_LOADING: "KEY_LOADING",
  FRAG_LOADING: "FRAG_LOADING",
  FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
  WAITING_TRACK: "WAITING_TRACK",
  PARSING: "PARSING",
  PARSED: "PARSED",
  ENDED: "ENDED",
  ERROR: "ERROR",
  WAITING_INIT_PTS: "WAITING_INIT_PTS",
  WAITING_LEVEL: "WAITING_LEVEL"
};
class Kk extends EZ {
  constructor(e, r, n, s, a) {
    super(), this.hls = void 0, this.fragPrevious = null, this.fragCurrent = null, this.fragmentTracker = void 0, this.transmuxer = null, this._state = _e.STOPPED, this.playlistType = void 0, this.media = null, this.mediaBuffer = null, this.config = void 0, this.bitrateTest = !1, this.lastCurrentTime = 0, this.nextLoadPosition = 0, this.startPosition = 0, this.startTimeOffset = null, this.loadedmetadata = !1, this.retryDate = 0, this.levels = null, this.fragmentLoader = void 0, this.keyLoader = void 0, this.levelLastLoaded = null, this.startFragRequested = !1, this.decrypter = void 0, this.initPTS = [], this.onvseeking = null, this.onvended = null, this.logPrefix = "", this.log = void 0, this.warn = void 0, this.playlistType = a, this.logPrefix = s, this.log = J.log.bind(J, `${s}:`), this.warn = J.warn.bind(J, `${s}:`), this.hls = e, this.fragmentLoader = new xZ(e.config), this.keyLoader = n, this.fragmentTracker = r, this.config = e.config, this.decrypter = new jk(e.config), e.on(D.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  startLoad(e) {
  }
  stopLoad() {
    this.fragmentLoader.abort(), this.keyLoader.abort(this.playlistType);
    const e = this.fragCurrent;
    e != null && e.loader && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = _e.STOPPED;
  }
  _streamEnded(e, r) {
    if (r.live || e.nextStart || !e.end || !this.media)
      return !1;
    const n = r.partList;
    if (n != null && n.length) {
      const a = n[n.length - 1];
      return Tr.isBuffered(this.media, a.start + a.duration / 2);
    }
    const s = r.fragments[r.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(s);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null) {
      var e;
      return (e = this.levels[this.levelLastLoaded]) == null ? void 0 : e.details;
    }
  }
  onMediaAttached(e, r) {
    const n = this.media = this.mediaBuffer = r.media;
    this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), n.addEventListener("seeking", this.onvseeking), n.addEventListener("ended", this.onvended);
    const s = this.config;
    this.levels && s.autoStartLoad && this.state === _e.STOPPED && this.startLoad(s.startPosition);
  }
  onMediaDetaching() {
    const e = this.media;
    e != null && e.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), e && this.onvseeking && this.onvended && (e.removeEventListener("seeking", this.onvseeking), e.removeEventListener("ended", this.onvended), this.onvseeking = this.onvended = null), this.keyLoader && this.keyLoader.detach(), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
  }
  onMediaSeeking() {
    const {
      config: e,
      fragCurrent: r,
      media: n,
      mediaBuffer: s,
      state: a
    } = this, o = n ? n.currentTime : 0, l = Tr.bufferInfo(s || n, o, e.maxBufferHole);
    if (this.log(`media seeking to ${et(o) ? o.toFixed(3) : o}, state: ${a}`), this.state === _e.ENDED)
      this.resetLoadingState();
    else if (r) {
      const u = e.maxFragLookUpTolerance, c = r.start - u, d = r.start + r.duration + u;
      if (!l.len || d < l.start || c > l.end) {
        const h = o > d;
        (o < c || h) && (h && r.loader && (this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), r.abortRequests(), this.resetLoadingState()), this.fragPrevious = null);
      }
    }
    n && (this.fragmentTracker.removeFragmentsInRange(o, 1 / 0, this.playlistType, !0), this.lastCurrentTime = o), !this.loadedmetadata && !l.len && (this.nextLoadPosition = this.startPosition = o), this.tickImmediate();
  }
  onMediaEnded() {
    this.startPosition = this.lastCurrentTime = 0;
  }
  onManifestLoaded(e, r) {
    this.startTimeOffset = r.startTimeOffset, this.initPTS = [];
  }
  onHandlerDestroying() {
    this.stopLoad(), super.onHandlerDestroying();
  }
  onHandlerDestroyed() {
    this.state = _e.STOPPED, this.fragmentLoader && this.fragmentLoader.destroy(), this.keyLoader && this.keyLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null, super.onHandlerDestroyed();
  }
  loadFragment(e, r, n) {
    this._loadFragForPlayback(e, r, n);
  }
  _loadFragForPlayback(e, r, n) {
    const s = (a) => {
      if (this.fragContextChanged(e)) {
        this.warn(`Fragment ${e.sn}${a.part ? " p: " + a.part.index : ""} of level ${e.level} was dropped during download.`), this.fragmentTracker.removeFragment(e);
        return;
      }
      e.stats.chunkCount++, this._handleFragmentLoadProgress(a);
    };
    this._doFragLoad(e, r, n, s).then((a) => {
      if (!a)
        return;
      const o = this.state;
      if (this.fragContextChanged(e)) {
        (o === _e.FRAG_LOADING || !this.fragCurrent && o === _e.PARSING) && (this.fragmentTracker.removeFragment(e), this.state = _e.IDLE);
        return;
      }
      "payload" in a && (this.log(`Loaded fragment ${e.sn} of level ${e.level}`), this.hls.trigger(D.FRAG_LOADED, a)), this._handleFragmentLoadComplete(a);
    }).catch((a) => {
      this.state === _e.STOPPED || this.state === _e.ERROR || (this.warn(a), this.resetFragmentLoading(e));
    });
  }
  clearTrackerIfNeeded(e) {
    var r;
    const {
      fragmentTracker: n
    } = this;
    if (n.getState(e) === yn.APPENDING) {
      const a = e.type, o = this.getFwdBufferInfo(this.mediaBuffer, a), l = Math.max(e.duration, o ? o.len : this.config.maxBufferLength);
      this.reduceMaxBufferLength(l) && n.removeFragment(e);
    } else
      ((r = this.mediaBuffer) == null ? void 0 : r.buffered.length) === 0 ? n.removeAllFragments() : n.hasParts(e.type) && (n.detectPartialFragments({
        frag: e,
        part: null,
        stats: e.stats,
        id: e.type
      }), n.getState(e) === yn.PARTIAL && n.removeFragment(e));
  }
  flushMainBuffer(e, r, n = null) {
    if (!(e - r))
      return;
    const s = {
      startOffset: e,
      endOffset: r,
      type: n
    };
    this.hls.trigger(D.BUFFER_FLUSHING, s);
  }
  _loadInitSegment(e, r) {
    this._doFragLoad(e, r).then((n) => {
      if (!n || this.fragContextChanged(e) || !this.levels)
        throw new Error("init load aborted");
      return n;
    }).then((n) => {
      const {
        hls: s
      } = this, {
        payload: a
      } = n, o = e.decryptdata;
      if (a && a.byteLength > 0 && o && o.key && o.iv && o.method === "AES-128") {
        const l = self.performance.now();
        return this.decrypter.decrypt(new Uint8Array(a), o.key.buffer, o.iv.buffer).catch((u) => {
          throw s.trigger(D.ERROR, {
            type: it.MEDIA_ERROR,
            details: le.FRAG_DECRYPT_ERROR,
            fatal: !1,
            error: u,
            reason: u.message,
            frag: e
          }), u;
        }).then((u) => {
          const c = self.performance.now();
          return s.trigger(D.FRAG_DECRYPTED, {
            frag: e,
            payload: u,
            stats: {
              tstart: l,
              tdecrypt: c
            }
          }), n.payload = u, n;
        });
      }
      return n;
    }).then((n) => {
      const {
        fragCurrent: s,
        hls: a,
        levels: o
      } = this;
      if (!o)
        throw new Error("init load aborted, missing levels");
      const l = e.stats;
      this.state = _e.IDLE, r.fragmentError = 0, e.data = new Uint8Array(n.payload), l.parsing.start = l.buffering.start = self.performance.now(), l.parsing.end = l.buffering.end = self.performance.now(), n.frag === s && a.trigger(D.FRAG_BUFFERED, {
        stats: l,
        frag: s,
        part: null,
        id: e.type
      }), this.tick();
    }).catch((n) => {
      this.state === _e.STOPPED || this.state === _e.ERROR || (this.warn(n), this.resetFragmentLoading(e));
    });
  }
  fragContextChanged(e) {
    const {
      fragCurrent: r
    } = this;
    return !e || !r || e.level !== r.level || e.sn !== r.sn || e.urlId !== r.urlId;
  }
  fragBufferedComplete(e, r) {
    var n, s, a, o;
    const l = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.log(`Buffered ${e.type} sn: ${e.sn}${r ? " part: " + r.index : ""} of ${this.playlistType === at.MAIN ? "level" : "track"} ${e.level} (frag:[${((n = e.startPTS) != null ? n : NaN).toFixed(3)}-${((s = e.endPTS) != null ? s : NaN).toFixed(3)}] > buffer:${l ? NZ.toString(Tr.getBuffered(l)) : "(detached)"})`), this.state = _e.IDLE, l && (!this.loadedmetadata && e.type == at.MAIN && l.buffered.length && ((a = this.fragCurrent) == null ? void 0 : a.sn) === ((o = this.fragPrevious) == null ? void 0 : o.sn) && (this.loadedmetadata = !0, this.seekToStartPos()), this.tick());
  }
  seekToStartPos() {
  }
  _handleFragmentLoadComplete(e) {
    const {
      transmuxer: r
    } = this;
    if (!r)
      return;
    const {
      frag: n,
      part: s,
      partsLoaded: a
    } = e, o = !a || a.length === 0 || a.some((u) => !u), l = new Gk(n.level, n.sn, n.stats.chunkCount + 1, 0, s ? s.index : -1, !o);
    r.flush(l);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _handleFragmentLoadProgress(e) {
  }
  _doFragLoad(e, r, n = null, s) {
    var a;
    const o = r == null ? void 0 : r.details;
    if (!this.levels || !o)
      throw new Error(`frag load aborted, missing level${o ? "" : " detail"}s`);
    let l = null;
    if (e.encrypted && !((a = e.decryptdata) != null && a.key) ? (this.log(`Loading key for ${e.sn} of [${o.startSN}-${o.endSN}], ${this.logPrefix === "[stream-controller]" ? "level" : "track"} ${e.level}`), this.state = _e.KEY_LOADING, this.fragCurrent = e, l = this.keyLoader.load(e).then((d) => {
      if (!this.fragContextChanged(d.frag))
        return this.hls.trigger(D.KEY_LOADED, d), this.state === _e.KEY_LOADING && (this.state = _e.IDLE), d;
    }), this.hls.trigger(D.KEY_LOADING, {
      frag: e
    }), this.fragCurrent === null && (l = Promise.reject(new Error("frag load aborted, context changed in KEY_LOADING")))) : !e.encrypted && o.encryptedFragments.length && this.keyLoader.loadClear(e, o.encryptedFragments), n = Math.max(e.start, n || 0), this.config.lowLatencyMode && e.sn !== "initSegment") {
      const d = o.partList;
      if (d && s) {
        n > e.end && o.fragmentHint && (e = o.fragmentHint);
        const h = this.getNextPart(d, e, n);
        if (h > -1) {
          const f = d[h];
          this.log(`Loading part sn: ${e.sn} p: ${f.index} cc: ${e.cc} of playlist [${o.startSN}-${o.endSN}] parts [0-${h}-${d.length - 1}] ${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${e.level}, target: ${parseFloat(n.toFixed(3))}`), this.nextLoadPosition = f.start + f.duration, this.state = _e.FRAG_LOADING;
          let p;
          return l ? p = l.then((m) => !m || this.fragContextChanged(m.frag) ? null : this.doFragPartsLoad(e, f, r, s)).catch((m) => this.handleFragLoadError(m)) : p = this.doFragPartsLoad(e, f, r, s).catch((m) => this.handleFragLoadError(m)), this.hls.trigger(D.FRAG_LOADING, {
            frag: e,
            part: f,
            targetBufferTime: n
          }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING parts")) : p;
        } else if (!e.url || this.loadedEndOfParts(d, n))
          return Promise.resolve(null);
      }
    }
    this.log(`Loading fragment ${e.sn} cc: ${e.cc} ${o ? "of [" + o.startSN + "-" + o.endSN + "] " : ""}${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${e.level}, target: ${parseFloat(n.toFixed(3))}`), et(e.sn) && !this.bitrateTest && (this.nextLoadPosition = e.start + e.duration), this.state = _e.FRAG_LOADING;
    const u = this.config.progressive;
    let c;
    return u && l ? c = l.then((d) => !d || this.fragContextChanged(d == null ? void 0 : d.frag) ? null : this.fragmentLoader.load(e, s)).catch((d) => this.handleFragLoadError(d)) : c = Promise.all([this.fragmentLoader.load(e, u ? s : void 0), l]).then(([d]) => (!u && d && s && s(d), d)).catch((d) => this.handleFragLoadError(d)), this.hls.trigger(D.FRAG_LOADING, {
      frag: e,
      targetBufferTime: n
    }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING")) : c;
  }
  doFragPartsLoad(e, r, n, s) {
    return new Promise((a, o) => {
      var l;
      const u = [], c = (l = n.details) == null ? void 0 : l.partList, d = (h) => {
        this.fragmentLoader.loadPart(e, h, s).then((f) => {
          u[h.index] = f;
          const p = f.part;
          this.hls.trigger(D.FRAG_LOADED, f);
          const m = UI(n, e.sn, h.index + 1) || bU(c, e.sn, h.index + 1);
          if (m)
            d(m);
          else
            return a({
              frag: e,
              part: p,
              partsLoaded: u
            });
        }).catch(o);
      };
      d(r);
    });
  }
  handleFragLoadError(e) {
    if ("data" in e) {
      const r = e.data;
      e.data && r.details === le.INTERNAL_ABORTED ? this.handleFragLoadAborted(r.frag, r.part) : this.hls.trigger(D.ERROR, r);
    } else
      this.hls.trigger(D.ERROR, {
        type: it.OTHER_ERROR,
        details: le.INTERNAL_EXCEPTION,
        err: e,
        error: e,
        fatal: !0
      });
    return null;
  }
  _handleTransmuxerFlush(e) {
    const r = this.getCurrentContext(e);
    if (!r || this.state !== _e.PARSING) {
      !this.fragCurrent && this.state !== _e.STOPPED && this.state !== _e.ERROR && (this.state = _e.IDLE);
      return;
    }
    const {
      frag: n,
      part: s,
      level: a
    } = r, o = self.performance.now();
    n.stats.parsing.end = o, s && (s.stats.parsing.end = o), this.updateLevelTiming(n, s, a, e.partial);
  }
  getCurrentContext(e) {
    const {
      levels: r,
      fragCurrent: n
    } = this, {
      level: s,
      sn: a,
      part: o
    } = e;
    if (!(r != null && r[s]))
      return this.warn(`Levels object was unset while buffering fragment ${a} of level ${s}. The current chunk will not be buffered.`), null;
    const l = r[s], u = o > -1 ? UI(l, a, o) : null, c = u ? u.fragment : fZ(l, a, n);
    return c ? (n && n !== c && (c.stats = n.stats), {
      frag: c,
      part: u,
      level: l
    }) : null;
  }
  bufferFragmentData(e, r, n, s, a) {
    var o;
    if (!e || this.state !== _e.PARSING)
      return;
    const {
      data1: l,
      data2: u
    } = e;
    let c = l;
    if (l && u && (c = Bu(l, u)), !((o = c) != null && o.length))
      return;
    const d = {
      type: e.type,
      frag: r,
      part: n,
      chunkMeta: s,
      parent: r.type,
      data: c
    };
    if (this.hls.trigger(D.BUFFER_APPENDING, d), e.dropped && e.independent && !n) {
      if (a)
        return;
      this.flushBufferGap(r);
    }
  }
  flushBufferGap(e) {
    const r = this.media;
    if (!r)
      return;
    if (!Tr.isBuffered(r, r.currentTime)) {
      this.flushMainBuffer(0, e.start);
      return;
    }
    const n = r.currentTime, s = Tr.bufferInfo(r, n, 0), a = e.duration, o = Math.min(this.config.maxFragLookUpTolerance * 2, a * 0.25), l = Math.max(Math.min(e.start - o, s.end - o), n + o);
    e.start - l > o && this.flushMainBuffer(l, e.start);
  }
  getFwdBufferInfo(e, r) {
    const n = this.getLoadPosition();
    return et(n) ? this.getFwdBufferInfoAtPos(e, n, r) : null;
  }
  getFwdBufferInfoAtPos(e, r, n) {
    const {
      config: {
        maxBufferHole: s
      }
    } = this, a = Tr.bufferInfo(e, r, s);
    if (a.len === 0 && a.nextStart !== void 0) {
      const o = this.fragmentTracker.getBufferedFrag(r, n);
      if (o && a.nextStart < o.end)
        return Tr.bufferInfo(e, r, Math.max(a.nextStart, s));
    }
    return a;
  }
  getMaxBufferLength(e) {
    const {
      config: r
    } = this;
    let n;
    return e ? n = Math.max(8 * r.maxBufferSize / e, r.maxBufferLength) : n = r.maxBufferLength, Math.min(n, r.maxMaxBufferLength);
  }
  reduceMaxBufferLength(e) {
    const r = this.config, n = e || r.maxBufferLength;
    return r.maxMaxBufferLength >= n ? (r.maxMaxBufferLength /= 2, this.warn(`Reduce max buffer length to ${r.maxMaxBufferLength}s`), !0) : !1;
  }
  getAppendedFrag(e, r = at.MAIN) {
    const n = this.fragmentTracker.getAppendedFrag(e, at.MAIN);
    return n && "fragment" in n ? n.fragment : n;
  }
  getNextFragment(e, r) {
    const n = r.fragments, s = n.length;
    if (!s)
      return null;
    const {
      config: a
    } = this, o = n[0].start;
    let l;
    if (r.live) {
      const u = a.initialLiveManifestSize;
      if (s < u)
        return this.warn(`Not enough fragments to start playback (have: ${s}, need: ${u})`), null;
      !r.PTSKnown && !this.startFragRequested && this.startPosition === -1 && (l = this.getInitialLiveFragment(r, n), this.startPosition = l ? this.hls.liveSyncPosition || l.start : e);
    } else
      e <= o && (l = n[0]);
    if (!l) {
      const u = a.lowLatencyMode ? r.partEnd : r.fragmentEnd;
      l = this.getFragmentAtPosition(e, u, r);
    }
    return this.mapToInitFragWhenRequired(l);
  }
  isLoopLoading(e, r) {
    const n = this.fragmentTracker.getState(e);
    return (n === yn.OK || n === yn.PARTIAL && !!e.gap) && this.nextLoadPosition > r;
  }
  getNextFragmentLoopLoading(e, r, n, s, a) {
    const o = e.gap, l = this.getNextFragment(this.nextLoadPosition, r);
    if (l === null)
      return l;
    if (e = l, o && e && !e.gap && n.nextStart) {
      const u = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, n.nextStart, s);
      if (u !== null && n.len + u.len >= a)
        return this.log(`buffer full after gaps in "${s}" playlist starting at sn: ${e.sn}`), null;
    }
    return e;
  }
  mapToInitFragWhenRequired(e) {
    return e != null && e.initSegment && !(e != null && e.initSegment.data) && !this.bitrateTest ? e.initSegment : e;
  }
  getNextPart(e, r, n) {
    let s = -1, a = !1, o = !0;
    for (let l = 0, u = e.length; l < u; l++) {
      const c = e[l];
      if (o = o && !c.independent, s > -1 && n < c.start)
        break;
      const d = c.loaded;
      d ? s = -1 : (a || c.independent || o) && c.fragment === r && (s = l), a = d;
    }
    return s;
  }
  loadedEndOfParts(e, r) {
    const n = e[e.length - 1];
    return n && r > n.start && n.loaded;
  }
  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(e, r) {
    const n = this.fragPrevious;
    let s = null;
    if (n) {
      if (e.hasProgramDateTime && (this.log(`Live playlist, switching playlist, load frag with same PDT: ${n.programDateTime}`), s = vZ(r, n.endProgramDateTime, this.config.maxFragLookUpTolerance)), !s) {
        const a = n.sn + 1;
        if (a >= e.startSN && a <= e.endSN) {
          const o = r[a - e.startSN];
          n.cc === o.cc && (s = o, this.log(`Live playlist, switching playlist, load frag with next SN: ${s.sn}`));
        }
        s || (s = gZ(r, n.cc), s && this.log(`Live playlist, switching playlist, load frag with same CC: ${s.sn}`));
      }
    } else {
      const a = this.hls.liveSyncPosition;
      a !== null && (s = this.getFragmentAtPosition(a, this.bitrateTest ? e.fragmentEnd : e.edge, e));
    }
    return s;
  }
  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(e, r, n) {
    const {
      config: s
    } = this;
    let {
      fragPrevious: a
    } = this, {
      fragments: o,
      endSN: l
    } = n;
    const {
      fragmentHint: u
    } = n, c = s.maxFragLookUpTolerance, d = n.partList, h = !!(s.lowLatencyMode && d != null && d.length && u);
    h && u && !this.bitrateTest && (o = o.concat(u), l = u.sn);
    let f;
    if (e < r) {
      const p = e > r - c ? 0 : c;
      f = Qf(a, o, e, p);
    } else
      f = o[o.length - 1];
    if (f) {
      const p = f.sn - n.startSN, m = this.fragmentTracker.getState(f);
      if ((m === yn.OK || m === yn.PARTIAL && f.gap) && (a = f), a && f.sn === a.sn && (!h || d[0].fragment.sn > f.sn) && a && f.level === a.level) {
        const y = o[p + 1];
        f.sn < l && this.fragmentTracker.getState(y) !== yn.OK ? f = y : f = null;
      }
    }
    return f;
  }
  synchronizeToLiveEdge(e) {
    const {
      config: r,
      media: n
    } = this;
    if (!n)
      return;
    const s = this.hls.liveSyncPosition, a = n.currentTime, o = e.fragments[0].start, l = e.edge, u = a >= o - r.maxFragLookUpTolerance && a <= l;
    if (s !== null && n.duration > s && (a < s || !u)) {
      const c = r.liveMaxLatencyDuration !== void 0 ? r.liveMaxLatencyDuration : r.liveMaxLatencyDurationCount * e.targetduration;
      (!u && n.readyState < 4 || a < l - c) && (this.loadedmetadata || (this.nextLoadPosition = s), n.readyState && (this.warn(`Playback: ${a.toFixed(3)} is located too far from the end of live sliding playlist: ${l}, reset currentTime to : ${s.toFixed(3)}`), n.currentTime = s));
    }
  }
  alignPlaylists(e, r) {
    const {
      levels: n,
      levelLastLoaded: s,
      fragPrevious: a
    } = this, o = s !== null ? n[s] : null, l = e.fragments.length;
    if (!l)
      return this.warn("No fragments in live playlist"), 0;
    const u = e.fragments[0].start, c = !r, d = e.alignedSliding && et(u);
    if (c || !d && !u) {
      OZ(a, o, e);
      const h = e.fragments[0].start;
      return this.log(`Live playlist sliding: ${h.toFixed(2)} start-sn: ${r ? r.startSN : "na"}->${e.startSN} prev-sn: ${a ? a.sn : "na"} fragments: ${l}`), h;
    }
    return u;
  }
  waitForCdnTuneIn(e) {
    return e.live && e.canBlockReload && e.partTarget && e.tuneInGoal > Math.max(e.partHoldBack, e.partTarget * 3);
  }
  setStartPosition(e, r) {
    let n = this.startPosition;
    if (n < r && (n = -1), n === -1 || this.lastCurrentTime === -1) {
      const s = this.startTimeOffset !== null, a = s ? this.startTimeOffset : e.startTimeOffset;
      a !== null && et(a) ? (n = r + a, a < 0 && (n += e.totalduration), n = Math.min(Math.max(r, n), r + e.totalduration), this.log(`Start time offset ${a} found in ${s ? "multivariant" : "media"} playlist, adjust startPosition to ${n}`), this.startPosition = n) : e.live ? n = this.hls.liveSyncPosition || r : this.startPosition = n = 0, this.lastCurrentTime = n;
    }
    this.nextLoadPosition = n;
  }
  getLoadPosition() {
    const {
      media: e
    } = this;
    let r = 0;
    return this.loadedmetadata && e ? r = e.currentTime : this.nextLoadPosition && (r = this.nextLoadPosition), r;
  }
  handleFragLoadAborted(e, r) {
    this.transmuxer && e.sn !== "initSegment" && e.stats.aborted && (this.warn(`Fragment ${e.sn}${r ? " part " + r.index : ""} of level ${e.level} was aborted`), this.resetFragmentLoading(e));
  }
  resetFragmentLoading(e) {
    (!this.fragCurrent || !this.fragContextChanged(e) && this.state !== _e.FRAG_LOADING_WAITING_RETRY) && (this.state = _e.IDLE);
  }
  onFragmentOrKeyLoadError(e, r) {
    if (r.chunkMeta && !r.frag) {
      const h = this.getCurrentContext(r.chunkMeta);
      h && (r.frag = h.frag);
    }
    const n = r.frag;
    if (!n || n.type !== e || !this.levels)
      return;
    if (this.fragContextChanged(n)) {
      var s;
      this.warn(`Frag load error must match current frag to retry ${n.url} > ${(s = this.fragCurrent) == null ? void 0 : s.url}`);
      return;
    }
    const a = r.details === le.FRAG_GAP;
    a && this.fragmentTracker.fragBuffered(n, !0);
    const o = r.errorAction, {
      action: l,
      retryCount: u = 0,
      retryConfig: c
    } = o || {};
    if (o && l === Un.RetryRequest && c) {
      var d;
      this.resetStartWhenNotLoaded((d = this.levelLastLoaded) != null ? d : n.level);
      const h = Yk(c, u);
      this.warn(`Fragment ${n.sn} of ${e} ${n.level} errored with ${r.details}, retrying loading ${u + 1}/${c.maxNumRetry} in ${h}ms`), o.resolved = !0, this.retryDate = self.performance.now() + h, this.state = _e.FRAG_LOADING_WAITING_RETRY;
    } else
      c && o ? (this.resetFragmentErrors(e), u < c.maxNumRetry ? a || (o.resolved = !0) : J.warn(`${r.details} reached or exceeded max retry (${u})`)) : (o == null ? void 0 : o.action) === Un.SendAlternateToPenaltyBox ? this.state = _e.WAITING_LEVEL : this.state = _e.ERROR;
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(e) {
    if (this.state === _e.PARSING || this.state === _e.PARSED) {
      const r = e.parent, n = this.getFwdBufferInfo(this.mediaBuffer, r), s = n && n.len > 0.5;
      s && this.reduceMaxBufferLength(n.len);
      const a = !s;
      return a && this.warn(`Buffer full error while media.currentTime is not buffered, flush ${r} buffer`), e.frag && (this.fragmentTracker.removeFragment(e.frag), this.nextLoadPosition = e.frag.start), this.resetLoadingState(), a;
    }
    return !1;
  }
  resetFragmentErrors(e) {
    e === at.AUDIO && (this.fragCurrent = null), this.loadedmetadata || (this.startFragRequested = !1), this.state !== _e.STOPPED && (this.state = _e.IDLE);
  }
  afterBufferFlushed(e, r, n) {
    if (!e)
      return;
    const s = Tr.getBuffered(e);
    this.fragmentTracker.detectEvictedFragments(r, s, n), this.state === _e.ENDED && this.resetLoadingState();
  }
  resetLoadingState() {
    this.log("Reset loading state"), this.fragCurrent = null, this.fragPrevious = null, this.state = _e.IDLE;
  }
  resetStartWhenNotLoaded(e) {
    if (!this.loadedmetadata) {
      this.startFragRequested = !1;
      const r = this.levels ? this.levels[e].details : null;
      r != null && r.live ? (this.startPosition = -1, this.setStartPosition(r, 0), this.resetLoadingState()) : this.nextLoadPosition = this.startPosition;
    }
  }
  resetWhenMissingContext(e) {
    var r;
    this.warn(`The loading context changed while buffering fragment ${e.sn} of level ${e.level}. This chunk will not be buffered.`), this.removeUnbufferedFrags(), this.resetStartWhenNotLoaded((r = this.levelLastLoaded) != null ? r : e.level), this.resetLoadingState();
  }
  removeUnbufferedFrags(e = 0) {
    this.fragmentTracker.removeFragmentsInRange(e, 1 / 0, this.playlistType, !1, !0);
  }
  updateLevelTiming(e, r, n, s) {
    var a;
    const o = n.details;
    if (!o) {
      this.warn("level.details undefined");
      return;
    }
    if (Object.keys(e.elementaryStreams).reduce((u, c) => {
      const d = e.elementaryStreams[c];
      if (d) {
        const h = d.endPTS - d.startPTS;
        if (h <= 0)
          return this.warn(`Could not parse fragment ${e.sn} ${c} duration reliably (${h})`), u || !1;
        const f = s ? 0 : gU(o, e, d.startPTS, d.endPTS, d.startDTS, d.endDTS);
        return this.hls.trigger(D.LEVEL_PTS_UPDATED, {
          details: o,
          level: n,
          drift: f,
          type: c,
          frag: e,
          start: d.startPTS,
          end: d.endPTS
        }), !0;
      }
      return u;
    }, !1))
      n.fragmentError = 0;
    else if (((a = this.transmuxer) == null ? void 0 : a.error) === null) {
      const u = new Error(`Found no media in fragment ${e.sn} of level ${e.level} resetting transmuxer to fallback to playlist timing`);
      if (n.fragmentError === 0 && (n.fragmentError++, e.gap = !0, this.fragmentTracker.removeFragment(e), this.fragmentTracker.fragBuffered(e, !0)), this.warn(u.message), this.hls.trigger(D.ERROR, {
        type: it.MEDIA_ERROR,
        details: le.FRAG_PARSING_ERROR,
        fatal: !1,
        error: u,
        frag: e,
        reason: `Found no media in msn ${e.sn} of level "${n.url}"`
      }), !this.hls)
        return;
      this.resetTransmuxer();
    }
    this.state = _e.PARSED, this.hls.trigger(D.FRAG_PARSED, {
      frag: e,
      part: r
    });
  }
  resetTransmuxer() {
    this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null);
  }
  recoverWorkerError(e) {
    if (e.event === "demuxerWorker") {
      var r, n, s;
      this.fragmentTracker.removeAllFragments(), this.resetTransmuxer(), this.resetStartWhenNotLoaded((r = (n = this.levelLastLoaded) != null ? n : (s = this.fragCurrent) == null ? void 0 : s.level) != null ? r : 0), this.resetLoadingState();
    }
  }
  set state(e) {
    const r = this._state;
    r !== e && (this._state = e, this.log(`${r}->${e}`));
  }
  get state() {
    return this._state;
  }
}
function xU() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function FZ() {
  const t = P0();
  if (!t)
    return !1;
  const e = xU(), r = t && typeof t.isTypeSupported == "function" && t.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), n = !e || e.prototype && typeof e.prototype.appendBuffer == "function" && typeof e.prototype.remove == "function";
  return !!r && !!n;
}
function BZ() {
  var t;
  const e = xU();
  return typeof (e == null || (t = e.prototype) == null ? void 0 : t.changeType) == "function";
}
function UZ() {
  return typeof __HLS_WORKER_BUNDLE__ == "function";
}
function VZ() {
  const t = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: "text/javascript"
  }), e = self.URL.createObjectURL(t);
  return {
    worker: new self.Worker(e),
    objectURL: e
  };
}
function YZ(t) {
  const e = new self.URL(t, self.location.href).href;
  return {
    worker: new self.Worker(e),
    scriptURL: e
  };
}
function ha(t = "", e = 9e4) {
  return {
    type: t,
    id: -1,
    pid: -1,
    inputTimeScale: e,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}
class SU {
  constructor() {
    this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.basePTS = null, this.initPTS = null, this.lastPTS = null;
  }
  resetInitSegment(e, r, n, s) {
    this._id3Track = {
      type: "id3",
      id: 3,
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null, this.lastPTS = null, this.frameIndex = 0;
  }
  canParse(e, r) {
    return !1;
  }
  appendFrame(e, r, n) {
  }
  // feed incoming data to the front of the parsing pipeline
  demux(e, r) {
    this.cachedData && (e = Bu(this.cachedData, e), this.cachedData = null);
    let n = sy(e, 0), s = n ? n.length : 0, a;
    const o = this._audioTrack, l = this._id3Track, u = n ? SQ(n) : void 0, c = e.length;
    for ((this.basePTS === null || this.frameIndex === 0 && et(u)) && (this.basePTS = HZ(u, r, this.initPTS), this.lastPTS = this.basePTS), this.lastPTS === null && (this.lastPTS = this.basePTS), n && n.length > 0 && l.samples.push({
      pts: this.lastPTS,
      dts: this.lastPTS,
      data: n,
      type: Is.audioId3,
      duration: Number.POSITIVE_INFINITY
    }); s < c; ) {
      if (this.canParse(e, s)) {
        const d = this.appendFrame(o, e, s);
        d ? (this.frameIndex++, this.lastPTS = d.sample.pts, s += d.length, a = s) : s = c;
      } else
        xQ(e, s) ? (n = sy(e, s), l.samples.push({
          pts: this.lastPTS,
          dts: this.lastPTS,
          data: n,
          type: Is.audioId3,
          duration: Number.POSITIVE_INFINITY
        }), s += n.length, a = s) : s++;
      if (s === c && a !== c) {
        const d = _u(e, a);
        this.cachedData ? this.cachedData = Bu(this.cachedData, d) : this.cachedData = d;
      }
    }
    return {
      audioTrack: o,
      videoTrack: ha(),
      id3Track: l,
      textTrack: ha()
    };
  }
  demuxSampleAes(e, r, n) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(e) {
    const r = this.cachedData;
    return r && (this.cachedData = null, this.demux(r, 0)), {
      audioTrack: this._audioTrack,
      videoTrack: ha(),
      id3Track: this._id3Track,
      textTrack: ha()
    };
  }
  destroy() {
  }
}
const HZ = (t, e, r) => {
  if (et(t))
    return t * 90;
  const n = r ? r.baseTime * 9e4 / r.timescale : 0;
  return e * 9e4 + n;
};
function GZ(t, e, r, n) {
  let s, a, o, l;
  const u = navigator.userAgent.toLowerCase(), c = n, d = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  s = ((e[r + 2] & 192) >>> 6) + 1;
  const h = (e[r + 2] & 60) >>> 2;
  if (h > d.length - 1) {
    t.trigger(D.ERROR, {
      type: it.MEDIA_ERROR,
      details: le.FRAG_PARSING_ERROR,
      fatal: !0,
      reason: `invalid ADTS sampling index:${h}`
    });
    return;
  }
  return o = (e[r + 2] & 1) << 2, o |= (e[r + 3] & 192) >>> 6, J.log(`manifest codec:${n}, ADTS type:${s}, samplingIndex:${h}`), /firefox/i.test(u) ? h >= 6 ? (s = 5, l = new Array(4), a = h - 3) : (s = 2, l = new Array(2), a = h) : u.indexOf("android") !== -1 ? (s = 2, l = new Array(2), a = h) : (s = 5, l = new Array(4), n && (n.indexOf("mp4a.40.29") !== -1 || n.indexOf("mp4a.40.5") !== -1) || !n && h >= 6 ? a = h - 3 : ((n && n.indexOf("mp4a.40.2") !== -1 && (h >= 6 && o === 1 || /vivaldi/i.test(u)) || !n && o === 1) && (s = 2, l = new Array(2)), a = h)), l[0] = s << 3, l[0] |= (h & 14) >> 1, l[1] |= (h & 1) << 7, l[1] |= o << 3, s === 5 && (l[1] |= (a & 14) >> 1, l[2] = (a & 1) << 7, l[2] |= 8, l[3] = 0), {
    config: l,
    samplerate: d[h],
    channelCount: o,
    codec: "mp4a.40." + s,
    manifestCodec: c
  };
}
function EU(t, e) {
  return t[e] === 255 && (t[e + 1] & 246) === 240;
}
function $U(t, e) {
  return t[e + 1] & 1 ? 7 : 9;
}
function zk(t, e) {
  return (t[e + 3] & 3) << 11 | t[e + 4] << 3 | (t[e + 5] & 224) >>> 5;
}
function WZ(t, e) {
  return e + 5 < t.length;
}
function cy(t, e) {
  return e + 1 < t.length && EU(t, e);
}
function jZ(t, e) {
  return WZ(t, e) && EU(t, e) && zk(t, e) <= t.length - e;
}
function KZ(t, e) {
  if (cy(t, e)) {
    const r = $U(t, e);
    if (e + r >= t.length)
      return !1;
    const n = zk(t, e);
    if (n <= r)
      return !1;
    const s = e + n;
    return s === t.length || cy(t, s);
  }
  return !1;
}
function kU(t, e, r, n, s) {
  if (!t.samplerate) {
    const a = GZ(e, r, n, s);
    if (!a)
      return;
    t.config = a.config, t.samplerate = a.samplerate, t.channelCount = a.channelCount, t.codec = a.codec, t.manifestCodec = a.manifestCodec, J.log(`parsed codec:${t.codec}, rate:${a.samplerate}, channels:${a.channelCount}`);
  }
}
function DU(t) {
  return 1024 * 9e4 / t;
}
function zZ(t, e) {
  const r = $U(t, e);
  if (e + r <= t.length) {
    const n = zk(t, e) - r;
    if (n > 0)
      return {
        headerLength: r,
        frameLength: n
      };
  }
}
function OU(t, e, r, n, s) {
  const a = DU(t.samplerate), o = n + s * a, l = zZ(e, r);
  let u;
  if (l) {
    const {
      frameLength: h,
      headerLength: f
    } = l, p = f + h, m = Math.max(0, r + p - e.length);
    m ? (u = new Uint8Array(p - f), u.set(e.subarray(r + f, e.length), 0)) : u = e.subarray(r + f, r + p);
    const b = {
      unit: u,
      pts: o
    };
    return m || t.samples.push(b), {
      sample: b,
      length: p,
      missing: m
    };
  }
  const c = e.length - r;
  return u = new Uint8Array(c), u.set(e.subarray(r, e.length), 0), {
    sample: {
      unit: u,
      pts: o
    },
    length: c,
    missing: -1
  };
}
class qZ extends SU {
  constructor(e, r) {
    super(), this.observer = void 0, this.config = void 0, this.observer = e, this.config = r;
  }
  resetInitSegment(e, r, n, s) {
    super.resetInitSegment(e, r, n, s), this._audioTrack = {
      container: "audio/adts",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "aac",
      samples: [],
      manifestCodec: r,
      duration: s,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(e) {
    if (!e)
      return !1;
    let n = (sy(e, 0) || []).length;
    for (let s = e.length; n < s; n++)
      if (KZ(e, n))
        return J.log("ADTS sync word found !"), !0;
    return !1;
  }
  canParse(e, r) {
    return jZ(e, r);
  }
  appendFrame(e, r, n) {
    kU(e, this.observer, r, n, e.manifestCodec);
    const s = OU(e, r, n, this.basePTS, this.frameIndex);
    if (s && s.missing === 0)
      return s;
  }
}
const XZ = /\/emsg[-/]ID3/i;
class QZ {
  constructor(e, r) {
    this.remainderData = null, this.timeOffset = 0, this.config = void 0, this.videoTrack = void 0, this.audioTrack = void 0, this.id3Track = void 0, this.txtTrack = void 0, this.config = r;
  }
  resetTimeStamp() {
  }
  resetInitSegment(e, r, n, s) {
    const a = this.videoTrack = ha("video", 1), o = this.audioTrack = ha("audio", 1), l = this.txtTrack = ha("text", 1);
    if (this.id3Track = ha("id3", 1), this.timeOffset = 0, !(e != null && e.byteLength))
      return;
    const u = cU(e);
    if (u.video) {
      const {
        id: c,
        timescale: d,
        codec: h
      } = u.video;
      a.id = c, a.timescale = l.timescale = d, a.codec = h;
    }
    if (u.audio) {
      const {
        id: c,
        timescale: d,
        codec: h
      } = u.audio;
      o.id = c, o.timescale = d, o.codec = h;
    }
    l.id = oU.text, a.sampleDuration = 0, a.duration = o.duration = s;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(e) {
    return e = e.length > 16384 ? e.subarray(0, 16384) : e, Nt(e, ["moof"]).length > 0;
  }
  demux(e, r) {
    this.timeOffset = r;
    let n = e;
    const s = this.videoTrack, a = this.txtTrack;
    if (this.config.progressive) {
      this.remainderData && (n = Bu(this.remainderData, e));
      const l = BQ(n);
      this.remainderData = l.remainder, s.samples = l.valid || new Uint8Array();
    } else
      s.samples = n;
    const o = this.extractID3Track(s, r);
    return a.samples = EI(r, s), {
      videoTrack: s,
      audioTrack: this.audioTrack,
      id3Track: o,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const e = this.timeOffset, r = this.videoTrack, n = this.txtTrack;
    r.samples = this.remainderData || new Uint8Array(), this.remainderData = null;
    const s = this.extractID3Track(r, this.timeOffset);
    return n.samples = EI(e, r), {
      videoTrack: r,
      audioTrack: ha(),
      id3Track: s,
      textTrack: ha()
    };
  }
  extractID3Track(e, r) {
    const n = this.id3Track;
    if (e.samples.length) {
      const s = Nt(e.samples, ["emsg"]);
      s && s.forEach((a) => {
        const o = YQ(a);
        if (XZ.test(o.schemeIdUri)) {
          const l = et(o.presentationTime) ? o.presentationTime / o.timeScale : r + o.presentationTimeDelta / o.timeScale;
          let u = o.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : o.eventDuration / o.timeScale;
          u <= 1e-3 && (u = Number.POSITIVE_INFINITY);
          const c = o.payload;
          n.samples.push({
            data: c,
            len: c.byteLength,
            dts: l,
            pts: l,
            type: Is.emsg,
            duration: u
          });
        }
      });
    }
    return n;
  }
  demuxSampleAes(e, r, n) {
    return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
  }
  destroy() {
  }
}
let _m = null;
const ZZ = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], JZ = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3], eJ = [
  // MPEG 2.5
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // Reserved
  [
    0,
    // Reserved
    0,
    // Layer3
    0,
    // Layer2
    0
    // Layer1
  ],
  // MPEG 2
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // MPEG 1
  [
    0,
    // Reserved
    144,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ]
], tJ = [
  0,
  // Reserved
  1,
  // Layer3
  1,
  // Layer2
  4
  // Layer1
];
function AU(t, e, r, n, s) {
  if (r + 24 > e.length)
    return;
  const a = CU(e, r);
  if (a && r + a.frameLength <= e.length) {
    const o = a.samplesPerFrame * 9e4 / a.sampleRate, l = n + s * o, u = {
      unit: e.subarray(r, r + a.frameLength),
      pts: l,
      dts: l
    };
    return t.config = [], t.channelCount = a.channelCount, t.samplerate = a.sampleRate, t.samples.push(u), {
      sample: u,
      length: a.frameLength,
      missing: 0
    };
  }
}
function CU(t, e) {
  const r = t[e + 1] >> 3 & 3, n = t[e + 1] >> 1 & 3, s = t[e + 2] >> 4 & 15, a = t[e + 2] >> 2 & 3;
  if (r !== 1 && s !== 0 && s !== 15 && a !== 3) {
    const o = t[e + 2] >> 1 & 1, l = t[e + 3] >> 6, u = r === 3 ? 3 - n : n === 3 ? 3 : 4, c = ZZ[u * 14 + s - 1] * 1e3, h = JZ[(r === 3 ? 0 : r === 2 ? 1 : 2) * 3 + a], f = l === 3 ? 1 : 2, p = eJ[r][n], m = tJ[n], b = p * 8 * m, y = Math.floor(p * c / h + o) * m;
    if (_m === null) {
      const T = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      _m = T ? parseInt(T[1]) : 0;
    }
    return !!_m && _m <= 87 && n === 2 && c >= 224e3 && l === 0 && (t[e + 3] = t[e + 3] | 128), {
      sampleRate: h,
      channelCount: f,
      frameLength: y,
      samplesPerFrame: b
    };
  }
}
function qk(t, e) {
  return t[e] === 255 && (t[e + 1] & 224) === 224 && (t[e + 1] & 6) !== 0;
}
function IU(t, e) {
  return e + 1 < t.length && qk(t, e);
}
function rJ(t, e) {
  return qk(t, e) && 4 <= t.length - e;
}
function nJ(t, e) {
  if (e + 1 < t.length && qk(t, e)) {
    const n = CU(t, e);
    let s = 4;
    n != null && n.frameLength && (s = n.frameLength);
    const a = e + s;
    return a === t.length || IU(t, a);
  }
  return !1;
}
class zI {
  constructor(e) {
    this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = e, this.bytesAvailable = e.byteLength, this.word = 0, this.bitsAvailable = 0;
  }
  // ():void
  loadWord() {
    const e = this.data, r = this.bytesAvailable, n = e.byteLength - r, s = new Uint8Array(4), a = Math.min(4, r);
    if (a === 0)
      throw new Error("no bytes available");
    s.set(e.subarray(n, n + a)), this.word = new DataView(s.buffer).getUint32(0), this.bitsAvailable = a * 8, this.bytesAvailable -= a;
  }
  // (count:int):void
  skipBits(e) {
    let r;
    e = Math.min(e, this.bytesAvailable * 8 + this.bitsAvailable), this.bitsAvailable > e ? (this.word <<= e, this.bitsAvailable -= e) : (e -= this.bitsAvailable, r = e >> 3, e -= r << 3, this.bytesAvailable -= r, this.loadWord(), this.word <<= e, this.bitsAvailable -= e);
  }
  // (size:int):uint
  readBits(e) {
    let r = Math.min(this.bitsAvailable, e);
    const n = this.word >>> 32 - r;
    if (e > 32 && J.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= r, this.bitsAvailable > 0)
      this.word <<= r;
    else if (this.bytesAvailable > 0)
      this.loadWord();
    else
      throw new Error("no bits available");
    return r = e - r, r > 0 && this.bitsAvailable ? n << r | this.readBits(r) : n;
  }
  // ():uint
  skipLZ() {
    let e;
    for (e = 0; e < this.bitsAvailable; ++e)
      if (this.word & 2147483648 >>> e)
        return this.word <<= e, this.bitsAvailable -= e, e;
    return this.loadWord(), e + this.skipLZ();
  }
  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():uint
  readUEG() {
    const e = this.skipLZ();
    return this.readBits(e + 1) - 1;
  }
  // ():int
  readEG() {
    const e = this.readUEG();
    return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1);
  }
  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }
  // ():int
  readUByte() {
    return this.readBits(8);
  }
  // ():int
  readUShort() {
    return this.readBits(16);
  }
  // ():int
  readUInt() {
    return this.readBits(32);
  }
  /**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(e) {
    let r = 8, n = 8, s;
    for (let a = 0; a < e; a++)
      n !== 0 && (s = this.readEG(), n = (r + s + 256) % 256), r = n === 0 ? r : n;
  }
  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS() {
    let e = 0, r = 0, n = 0, s = 0, a, o, l;
    const u = this.readUByte.bind(this), c = this.readBits.bind(this), d = this.readUEG.bind(this), h = this.readBoolean.bind(this), f = this.skipBits.bind(this), p = this.skipEG.bind(this), m = this.skipUEG.bind(this), b = this.skipScalingList.bind(this);
    u();
    const y = u();
    if (c(5), f(3), u(), m(), y === 100 || y === 110 || y === 122 || y === 244 || y === 44 || y === 83 || y === 86 || y === 118 || y === 128) {
      const F = d();
      if (F === 3 && f(1), m(), m(), f(1), h())
        for (o = F !== 3 ? 8 : 12, l = 0; l < o; l++)
          h() && (l < 6 ? b(16) : b(64));
    }
    m();
    const _ = d();
    if (_ === 0)
      d();
    else if (_ === 1)
      for (f(1), p(), p(), a = d(), l = 0; l < a; l++)
        p();
    m(), f(1);
    const x = d(), T = d(), k = c(1);
    k === 0 && f(1), f(1), h() && (e = d(), r = d(), n = d(), s = d());
    let E = [1, 1];
    if (h() && h())
      switch (u()) {
        case 1:
          E = [1, 1];
          break;
        case 2:
          E = [12, 11];
          break;
        case 3:
          E = [10, 11];
          break;
        case 4:
          E = [16, 11];
          break;
        case 5:
          E = [40, 33];
          break;
        case 6:
          E = [24, 11];
          break;
        case 7:
          E = [20, 11];
          break;
        case 8:
          E = [32, 11];
          break;
        case 9:
          E = [80, 33];
          break;
        case 10:
          E = [18, 11];
          break;
        case 11:
          E = [15, 11];
          break;
        case 12:
          E = [64, 33];
          break;
        case 13:
          E = [160, 99];
          break;
        case 14:
          E = [4, 3];
          break;
        case 15:
          E = [3, 2];
          break;
        case 16:
          E = [2, 1];
          break;
        case 255: {
          E = [u() << 8 | u(), u() << 8 | u()];
          break;
        }
      }
    return {
      width: Math.ceil((x + 1) * 16 - e * 2 - r * 2),
      height: (2 - k) * (T + 1) * 16 - (k ? 2 : 4) * (n + s),
      pixelRatio: E
    };
  }
  readSliceType() {
    return this.readUByte(), this.readUEG(), this.readUEG();
  }
}
class iJ {
  constructor(e, r, n) {
    this.keyData = void 0, this.decrypter = void 0, this.keyData = n, this.decrypter = new jk(r, {
      removePKCS7Padding: !1
    });
  }
  decryptBuffer(e) {
    return this.decrypter.decrypt(e, this.keyData.key.buffer, this.keyData.iv.buffer);
  }
  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(e, r, n) {
    const s = e[r].unit;
    if (s.length <= 16)
      return;
    const a = s.subarray(16, s.length - s.length % 16), o = a.buffer.slice(a.byteOffset, a.byteOffset + a.length);
    this.decryptBuffer(o).then((l) => {
      const u = new Uint8Array(l);
      s.set(u, 16), this.decrypter.isSync() || this.decryptAacSamples(e, r + 1, n);
    });
  }
  decryptAacSamples(e, r, n) {
    for (; ; r++) {
      if (r >= e.length) {
        n();
        return;
      }
      if (!(e[r].unit.length < 32) && (this.decryptAacSample(e, r, n), !this.decrypter.isSync()))
        return;
    }
  }
  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(e) {
    const r = Math.floor((e.length - 48) / 160) * 16 + 16, n = new Int8Array(r);
    let s = 0;
    for (let a = 32; a < e.length - 16; a += 160, s += 16)
      n.set(e.subarray(a, a + 16), s);
    return n;
  }
  getAvcDecryptedUnit(e, r) {
    const n = new Uint8Array(r);
    let s = 0;
    for (let a = 32; a < e.length - 16; a += 160, s += 16)
      e.set(n.subarray(s, s + 16), a);
    return e;
  }
  decryptAvcSample(e, r, n, s, a) {
    const o = fU(a.data), l = this.getAvcEncryptedData(o);
    this.decryptBuffer(l.buffer).then((u) => {
      a.data = this.getAvcDecryptedUnit(o, u), this.decrypter.isSync() || this.decryptAvcSamples(e, r, n + 1, s);
    });
  }
  decryptAvcSamples(e, r, n, s) {
    if (e instanceof Uint8Array)
      throw new Error("Cannot decrypt samples of type Uint8Array");
    for (; ; r++, n = 0) {
      if (r >= e.length) {
        s();
        return;
      }
      const a = e[r].units;
      for (; !(n >= a.length); n++) {
        const o = a[n];
        if (!(o.data.length <= 48 || o.type !== 1 && o.type !== 5) && (this.decryptAvcSample(e, r, n, s, o), !this.decrypter.isSync()))
          return;
      }
    }
  }
}
const Bn = 188;
class il {
  constructor(e, r, n) {
    this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._duration = 0, this._pmtId = -1, this._avcTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.avcSample = null, this.remainderData = null, this.observer = e, this.config = r, this.typeSupported = n;
  }
  static probe(e) {
    const r = il.syncOffset(e);
    return r > 0 && J.warn(`MPEG2-TS detected but first sync word found @ offset ${r}`), r !== -1;
  }
  static syncOffset(e) {
    const r = e.length;
    let n = Math.min(Bn * 5, e.length - Bn) + 1, s = 0;
    for (; s < n; ) {
      let a = !1, o = -1, l = 0;
      for (let u = s; u < r; u += Bn)
        if (e[u] === 71) {
          if (l++, o === -1 && (o = u, o !== 0 && (n = Math.min(o + Bn * 99, e.length - Bn) + 1)), a || (a = nx(e, u) === 0), a && l > 1 && (o === 0 && l > 2 || u + Bn > n))
            return o;
        } else {
          if (l)
            return -1;
          break;
        }
      s++;
    }
    return -1;
  }
  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(e, r) {
    return {
      container: e === "video" || e === "audio" ? "video/mp2t" : void 0,
      type: e,
      id: oU[e],
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: e === "audio" ? r : void 0
    };
  }
  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(e, r, n, s) {
    this.pmtParsed = !1, this._pmtId = -1, this._avcTrack = il.createTrack("video"), this._audioTrack = il.createTrack("audio", s), this._id3Track = il.createTrack("id3"), this._txtTrack = il.createTrack("text"), this._audioTrack.segmentCodec = "aac", this.aacOverFlow = null, this.avcSample = null, this.remainderData = null, this.audioCodec = r, this.videoCodec = n, this._duration = s;
  }
  resetTimeStamp() {
  }
  resetContiguity() {
    const {
      _audioTrack: e,
      _avcTrack: r,
      _id3Track: n
    } = this;
    e && (e.pesData = null), r && (r.pesData = null), n && (n.pesData = null), this.aacOverFlow = null, this.avcSample = null, this.remainderData = null;
  }
  demux(e, r, n = !1, s = !1) {
    n || (this.sampleAes = null);
    let a;
    const o = this._avcTrack, l = this._audioTrack, u = this._id3Track, c = this._txtTrack;
    let d = o.pid, h = o.pesData, f = l.pid, p = u.pid, m = l.pesData, b = u.pesData, y = null, _ = this.pmtParsed, x = this._pmtId, T = e.length;
    if (this.remainderData && (e = Bu(this.remainderData, e), T = e.length, this.remainderData = null), T < Bn && !s)
      return this.remainderData = e, {
        audioTrack: l,
        videoTrack: o,
        id3Track: u,
        textTrack: c
      };
    const k = Math.max(0, il.syncOffset(e));
    T -= (T - k) % Bn, T < e.byteLength && !s && (this.remainderData = new Uint8Array(e.buffer, T, e.buffer.byteLength - T));
    let E = 0;
    for (let R = k; R < T; R += Bn)
      if (e[R] === 71) {
        const $ = !!(e[R + 1] & 64), O = nx(e, R), P = (e[R + 3] & 48) >> 4;
        let N;
        if (P > 1) {
          if (N = R + 5 + e[R + 4], N === R + Bn)
            continue;
        } else
          N = R + 4;
        switch (O) {
          case d:
            $ && (h && (a = Ac(h)) && this.parseAVCPES(o, c, a, !1), h = {
              data: [],
              size: 0
            }), h && (h.data.push(e.subarray(N, R + Bn)), h.size += R + Bn - N);
            break;
          case f:
            if ($) {
              if (m && (a = Ac(m)))
                switch (l.segmentCodec) {
                  case "aac":
                    this.parseAACPES(l, a);
                    break;
                  case "mp3":
                    this.parseMPEGPES(l, a);
                    break;
                }
              m = {
                data: [],
                size: 0
              };
            }
            m && (m.data.push(e.subarray(N, R + Bn)), m.size += R + Bn - N);
            break;
          case p:
            $ && (b && (a = Ac(b)) && this.parseID3PES(u, a), b = {
              data: [],
              size: 0
            }), b && (b.data.push(e.subarray(N, R + Bn)), b.size += R + Bn - N);
            break;
          case 0:
            $ && (N += e[N] + 1), x = this._pmtId = sJ(e, N);
            break;
          case x: {
            $ && (N += e[N] + 1);
            const I = aJ(e, N, this.typeSupported, n);
            d = I.avc, d > 0 && (o.pid = d), f = I.audio, f > 0 && (l.pid = f, l.segmentCodec = I.segmentCodec), p = I.id3, p > 0 && (u.pid = p), y !== null && !_ && (J.warn(`MPEG-TS PMT found at ${R} after unknown PID '${y}'. Backtracking to sync byte @${k} to parse all TS packets.`), y = null, R = k - 188), _ = this.pmtParsed = !0;
            break;
          }
          case 17:
          case 8191:
            break;
          default:
            y = O;
            break;
        }
      } else
        E++;
    if (E > 0) {
      const R = new Error(`Found ${E} TS packet/s that do not start with 0x47`);
      this.observer.emit(D.ERROR, D.ERROR, {
        type: it.MEDIA_ERROR,
        details: le.FRAG_PARSING_ERROR,
        fatal: !1,
        error: R,
        reason: R.message
      });
    }
    o.pesData = h, l.pesData = m, u.pesData = b;
    const F = {
      audioTrack: l,
      videoTrack: o,
      id3Track: u,
      textTrack: c
    };
    return s && this.extractRemainingSamples(F), F;
  }
  flush() {
    const {
      remainderData: e
    } = this;
    this.remainderData = null;
    let r;
    return e ? r = this.demux(e, -1, !1, !0) : r = {
      videoTrack: this._avcTrack,
      audioTrack: this._audioTrack,
      id3Track: this._id3Track,
      textTrack: this._txtTrack
    }, this.extractRemainingSamples(r), this.sampleAes ? this.decrypt(r, this.sampleAes) : r;
  }
  extractRemainingSamples(e) {
    const {
      audioTrack: r,
      videoTrack: n,
      id3Track: s,
      textTrack: a
    } = e, o = n.pesData, l = r.pesData, u = s.pesData;
    let c;
    if (o && (c = Ac(o)) ? (this.parseAVCPES(n, a, c, !0), n.pesData = null) : n.pesData = o, l && (c = Ac(l))) {
      switch (r.segmentCodec) {
        case "aac":
          this.parseAACPES(r, c);
          break;
        case "mp3":
          this.parseMPEGPES(r, c);
          break;
      }
      r.pesData = null;
    } else
      l != null && l.size && J.log("last AAC PES packet truncated,might overlap between fragments"), r.pesData = l;
    u && (c = Ac(u)) ? (this.parseID3PES(s, c), s.pesData = null) : s.pesData = u;
  }
  demuxSampleAes(e, r, n) {
    const s = this.demux(e, n, !0, !this.config.progressive), a = this.sampleAes = new iJ(this.observer, this.config, r);
    return this.decrypt(s, a);
  }
  decrypt(e, r) {
    return new Promise((n) => {
      const {
        audioTrack: s,
        videoTrack: a
      } = e;
      s.samples && s.segmentCodec === "aac" ? r.decryptAacSamples(s.samples, 0, () => {
        a.samples ? r.decryptAvcSamples(a.samples, 0, 0, () => {
          n(e);
        }) : n(e);
      }) : a.samples && r.decryptAvcSamples(a.samples, 0, 0, () => {
        n(e);
      });
    });
  }
  destroy() {
    this._duration = 0;
  }
  parseAVCPES(e, r, n, s) {
    const a = this.parseAVCNALu(e, n.data);
    let o = this.avcSample, l, u = !1;
    n.data = null, o && a.length && !e.audFound && (Kh(o, e), o = this.avcSample = wm(!1, n.pts, n.dts, "")), a.forEach((c) => {
      var d;
      switch (c.type) {
        case 1: {
          let f = !1;
          l = !0;
          const p = c.data;
          if (u && p.length > 4) {
            const m = new zI(p).readSliceType();
            (m === 2 || m === 4 || m === 7 || m === 9) && (f = !0);
          }
          if (f) {
            var h;
            (h = o) != null && h.frame && !o.key && (Kh(o, e), o = this.avcSample = null);
          }
          o || (o = this.avcSample = wm(!0, n.pts, n.dts, "")), o.frame = !0, o.key = f;
          break;
        }
        case 5:
          l = !0, (d = o) != null && d.frame && !o.key && (Kh(o, e), o = this.avcSample = null), o || (o = this.avcSample = wm(!0, n.pts, n.dts, "")), o.key = !0, o.frame = !0;
          break;
        case 6: {
          l = !0, hU(c.data, 1, n.pts, r.samples);
          break;
        }
        case 7:
          if (l = !0, u = !0, !e.sps) {
            const f = c.data, m = new zI(f).readSPS();
            e.width = m.width, e.height = m.height, e.pixelRatio = m.pixelRatio, e.sps = [f], e.duration = this._duration;
            const b = f.subarray(1, 4);
            let y = "avc1.";
            for (let _ = 0; _ < 3; _++) {
              let x = b[_].toString(16);
              x.length < 2 && (x = "0" + x), y += x;
            }
            e.codec = y;
          }
          break;
        case 8:
          l = !0, e.pps || (e.pps = [c.data]);
          break;
        case 9:
          l = !1, e.audFound = !0, o && Kh(o, e), o = this.avcSample = wm(!1, n.pts, n.dts, "");
          break;
        case 12:
          l = !0;
          break;
        default:
          l = !1, o && (o.debug += "unknown NAL " + c.type + " ");
          break;
      }
      o && l && o.units.push(c);
    }), s && o && (Kh(o, e), this.avcSample = null);
  }
  getLastNalUnit(e) {
    var r;
    let n = this.avcSample, s;
    if ((!n || n.units.length === 0) && (n = e[e.length - 1]), (r = n) != null && r.units) {
      const a = n.units;
      s = a[a.length - 1];
    }
    return s;
  }
  parseAVCNALu(e, r) {
    const n = r.byteLength;
    let s = e.naluState || 0;
    const a = s, o = [];
    let l = 0, u, c, d, h = -1, f = 0;
    for (s === -1 && (h = 0, f = r[0] & 31, s = 0, l = 1); l < n; ) {
      if (u = r[l++], !s) {
        s = u ? 0 : 1;
        continue;
      }
      if (s === 1) {
        s = u ? 0 : 2;
        continue;
      }
      if (!u)
        s = 3;
      else if (u === 1) {
        if (h >= 0) {
          const p = {
            data: r.subarray(h, l - s - 1),
            type: f
          };
          o.push(p);
        } else {
          const p = this.getLastNalUnit(e.samples);
          if (p && (a && l <= 4 - a && p.state && (p.data = p.data.subarray(0, p.data.byteLength - a)), c = l - s - 1, c > 0)) {
            const m = new Uint8Array(p.data.byteLength + c);
            m.set(p.data, 0), m.set(r.subarray(0, c), p.data.byteLength), p.data = m, p.state = 0;
          }
        }
        l < n ? (d = r[l] & 31, h = l, f = d, s = 0) : s = -1;
      } else
        s = 0;
    }
    if (h >= 0 && s >= 0) {
      const p = {
        data: r.subarray(h, n),
        type: f,
        state: s
      };
      o.push(p);
    }
    if (o.length === 0) {
      const p = this.getLastNalUnit(e.samples);
      if (p) {
        const m = new Uint8Array(p.data.byteLength + r.byteLength);
        m.set(p.data, 0), m.set(r, p.data.byteLength), p.data = m;
      }
    }
    return e.naluState = s, o;
  }
  parseAACPES(e, r) {
    let n = 0;
    const s = this.aacOverFlow;
    let a = r.data;
    if (s) {
      this.aacOverFlow = null;
      const h = s.missing, f = s.sample.unit.byteLength;
      if (h === -1) {
        const p = new Uint8Array(f + a.byteLength);
        p.set(s.sample.unit, 0), p.set(a, f), a = p;
      } else {
        const p = f - h;
        s.sample.unit.set(a.subarray(0, h), p), e.samples.push(s.sample), n = s.missing;
      }
    }
    let o, l;
    for (o = n, l = a.length; o < l - 1 && !cy(a, o); o++)
      ;
    if (o !== n) {
      let h;
      const f = o < l - 1;
      f ? h = `AAC PES did not start with ADTS header,offset:${o}` : h = "No ADTS header found in AAC PES";
      const p = new Error(h);
      if (J.warn(`parsing error: ${h}`), this.observer.emit(D.ERROR, D.ERROR, {
        type: it.MEDIA_ERROR,
        details: le.FRAG_PARSING_ERROR,
        fatal: !1,
        levelRetry: f,
        error: p,
        reason: h
      }), !f)
        return;
    }
    kU(e, this.observer, a, o, this.audioCodec);
    let u;
    if (r.pts !== void 0)
      u = r.pts;
    else if (s) {
      const h = DU(e.samplerate);
      u = s.sample.pts + h;
    } else {
      J.warn("[tsdemuxer]: AAC PES unknown PTS");
      return;
    }
    let c = 0, d;
    for (; o < l; )
      if (d = OU(e, a, o, u, c), o += d.length, d.missing) {
        this.aacOverFlow = d;
        break;
      } else
        for (c++; o < l - 1 && !cy(a, o); o++)
          ;
  }
  parseMPEGPES(e, r) {
    const n = r.data, s = n.length;
    let a = 0, o = 0;
    const l = r.pts;
    if (l === void 0) {
      J.warn("[tsdemuxer]: MPEG PES unknown PTS");
      return;
    }
    for (; o < s; )
      if (IU(n, o)) {
        const u = AU(e, n, o, l, a);
        if (u)
          o += u.length, a++;
        else
          break;
      } else
        o++;
  }
  parseID3PES(e, r) {
    if (r.pts === void 0) {
      J.warn("[tsdemuxer]: ID3 PES unknown PTS");
      return;
    }
    const n = hn({}, r, {
      type: this._avcTrack ? Is.emsg : Is.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    e.samples.push(n);
  }
}
function wm(t, e, r, n) {
  return {
    key: t,
    frame: !1,
    pts: e,
    dts: r,
    units: [],
    debug: n,
    length: 0
  };
}
function nx(t, e) {
  return ((t[e + 1] & 31) << 8) + t[e + 2];
}
function sJ(t, e) {
  return (t[e + 10] & 31) << 8 | t[e + 11];
}
function aJ(t, e, r, n) {
  const s = {
    audio: -1,
    avc: -1,
    id3: -1,
    segmentCodec: "aac"
  }, a = (t[e + 1] & 15) << 8 | t[e + 2], o = e + 3 + a - 4, l = (t[e + 10] & 15) << 8 | t[e + 11];
  for (e += 12 + l; e < o; ) {
    const u = nx(t, e);
    switch (t[e]) {
      case 207:
        if (!n) {
          J.log("ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream");
          break;
        }
      case 15:
        s.audio === -1 && (s.audio = u);
        break;
      case 21:
        s.id3 === -1 && (s.id3 = u);
        break;
      case 219:
        if (!n) {
          J.log("H.264 with AES-128-CBC slice encryption found in unencrypted stream");
          break;
        }
      case 27:
        s.avc === -1 && (s.avc = u);
        break;
      case 3:
      case 4:
        r.mpeg !== !0 && r.mp3 !== !0 ? J.log("MPEG audio found, not supported in this browser") : s.audio === -1 && (s.audio = u, s.segmentCodec = "mp3");
        break;
      case 36:
        J.warn("Unsupported HEVC stream type found");
        break;
    }
    e += ((t[e + 3] & 15) << 8 | t[e + 4]) + 5;
  }
  return s;
}
function Ac(t) {
  let e = 0, r, n, s, a, o;
  const l = t.data;
  if (!t || t.size === 0)
    return null;
  for (; l[0].length < 19 && l.length > 1; ) {
    const c = new Uint8Array(l[0].length + l[1].length);
    c.set(l[0]), c.set(l[1], l[0].length), l[0] = c, l.splice(1, 1);
  }
  if (r = l[0], (r[0] << 16) + (r[1] << 8) + r[2] === 1) {
    if (n = (r[4] << 8) + r[5], n && n > t.size - 6)
      return null;
    const c = r[7];
    c & 192 && (a = (r[9] & 14) * 536870912 + // 1 << 29
    (r[10] & 255) * 4194304 + // 1 << 22
    (r[11] & 254) * 16384 + // 1 << 14
    (r[12] & 255) * 128 + // 1 << 7
    (r[13] & 254) / 2, c & 64 ? (o = (r[14] & 14) * 536870912 + // 1 << 29
    (r[15] & 255) * 4194304 + // 1 << 22
    (r[16] & 254) * 16384 + // 1 << 14
    (r[17] & 255) * 128 + // 1 << 7
    (r[18] & 254) / 2, a - o > 60 * 9e4 && (J.warn(`${Math.round((a - o) / 9e4)}s delta between PTS and DTS, align them`), a = o)) : o = a), s = r[8];
    let d = s + 9;
    if (t.size <= d)
      return null;
    t.size -= d;
    const h = new Uint8Array(t.size);
    for (let f = 0, p = l.length; f < p; f++) {
      r = l[f];
      let m = r.byteLength;
      if (d)
        if (d > m) {
          d -= m;
          continue;
        } else
          r = r.subarray(d), m -= d, d = 0;
      h.set(r, e), e += m;
    }
    return n && (n -= s + 3), {
      data: h,
      pts: a,
      dts: o,
      len: n
    };
  }
  return null;
}
function Kh(t, e) {
  if (t.units.length && t.frame) {
    if (t.pts === void 0) {
      const r = e.samples, n = r.length;
      if (n) {
        const s = r[n - 1];
        t.pts = s.pts, t.dts = s.dts;
      } else {
        e.dropped++;
        return;
      }
    }
    e.samples.push(t);
  }
  t.debug.length && J.log(t.pts + "/" + t.dts + ":" + t.debug);
}
class oJ extends SU {
  resetInitSegment(e, r, n, s) {
    super.resetInitSegment(e, r, n, s), this._audioTrack = {
      container: "audio/mpeg",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "mp3",
      samples: [],
      manifestCodec: r,
      duration: s,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  static probe(e) {
    if (!e)
      return !1;
    let n = (sy(e, 0) || []).length;
    for (let s = e.length; n < s; n++)
      if (nJ(e, n))
        return J.log("MPEG Audio sync word found !"), !0;
    return !1;
  }
  canParse(e, r) {
    return rJ(e, r);
  }
  appendFrame(e, r, n) {
    if (this.basePTS !== null)
      return AU(e, r, n, this.basePTS, this.frameIndex);
  }
}
class qI {
  static getSilentFrame(e, r) {
    switch (e) {
      case "mp4a.40.2":
        if (r === 1)
          return new Uint8Array([0, 200, 0, 128, 35, 128]);
        if (r === 2)
          return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
        if (r === 3)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
        if (r === 4)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
        if (r === 5)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
        if (r === 6)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
        break;
      default:
        if (r === 1)
          return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (r === 2)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (r === 3)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        break;
    }
  }
}
const Xo = Math.pow(2, 32) - 1;
class ae {
  static init() {
    ae.types = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      ".mp3": [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let e;
    for (e in ae.types)
      ae.types.hasOwnProperty(e) && (ae.types[e] = [e.charCodeAt(0), e.charCodeAt(1), e.charCodeAt(2), e.charCodeAt(3)]);
    const r = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      118,
      105,
      100,
      101,
      // handler_type: 'vide'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      86,
      105,
      100,
      101,
      111,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'VideoHandler'
    ]), n = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      115,
      111,
      117,
      110,
      // handler_type: 'soun'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      83,
      111,
      117,
      110,
      100,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'SoundHandler'
    ]);
    ae.HDLR_TYPES = {
      video: r,
      audio: n
    };
    const s = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // entry_count
      0,
      0,
      0,
      12,
      // entry_size
      117,
      114,
      108,
      32,
      // 'url' type
      0,
      // version 0
      0,
      0,
      1
      // entry_flags
    ]), a = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0
      // entry_count
    ]);
    ae.STTS = ae.STSC = ae.STCO = a, ae.STSZ = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // sample_size
      0,
      0,
      0,
      0
      // sample_count
    ]), ae.VMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      1,
      // flags
      0,
      0,
      // graphicsmode
      0,
      0,
      0,
      0,
      0,
      0
      // opcolor
    ]), ae.SMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      // balance
      0,
      0
      // reserved
    ]), ae.STSD = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1
    ]);
    const o = new Uint8Array([105, 115, 111, 109]), l = new Uint8Array([97, 118, 99, 49]), u = new Uint8Array([0, 0, 0, 1]);
    ae.FTYP = ae.box(ae.types.ftyp, o, u, o, l), ae.DINF = ae.box(ae.types.dinf, ae.box(ae.types.dref, s));
  }
  static box(e, ...r) {
    let n = 8, s = r.length;
    const a = s;
    for (; s--; )
      n += r[s].byteLength;
    const o = new Uint8Array(n);
    for (o[0] = n >> 24 & 255, o[1] = n >> 16 & 255, o[2] = n >> 8 & 255, o[3] = n & 255, o.set(e, 4), s = 0, n = 8; s < a; s++)
      o.set(r[s], n), n += r[s].byteLength;
    return o;
  }
  static hdlr(e) {
    return ae.box(ae.types.hdlr, ae.HDLR_TYPES[e]);
  }
  static mdat(e) {
    return ae.box(ae.types.mdat, e);
  }
  static mdhd(e, r) {
    r *= e;
    const n = Math.floor(r / (Xo + 1)), s = Math.floor(r % (Xo + 1));
    return ae.box(ae.types.mdhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      n >> 24,
      n >> 16 & 255,
      n >> 8 & 255,
      n & 255,
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]));
  }
  static mdia(e) {
    return ae.box(ae.types.mdia, ae.mdhd(e.timescale, e.duration), ae.hdlr(e.type), ae.minf(e));
  }
  static mfhd(e) {
    return ae.box(ae.types.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      e >> 24,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
      // sequence_number
    ]));
  }
  static minf(e) {
    return e.type === "audio" ? ae.box(ae.types.minf, ae.box(ae.types.smhd, ae.SMHD), ae.DINF, ae.stbl(e)) : ae.box(ae.types.minf, ae.box(ae.types.vmhd, ae.VMHD), ae.DINF, ae.stbl(e));
  }
  static moof(e, r, n) {
    return ae.box(ae.types.moof, ae.mfhd(e), ae.traf(n, r));
  }
  static moov(e) {
    let r = e.length;
    const n = [];
    for (; r--; )
      n[r] = ae.trak(e[r]);
    return ae.box.apply(null, [ae.types.moov, ae.mvhd(e[0].timescale, e[0].duration)].concat(n).concat(ae.mvex(e)));
  }
  static mvex(e) {
    let r = e.length;
    const n = [];
    for (; r--; )
      n[r] = ae.trex(e[r]);
    return ae.box.apply(null, [ae.types.mvex, ...n]);
  }
  static mvhd(e, r) {
    r *= e;
    const n = Math.floor(r / (Xo + 1)), s = Math.floor(r % (Xo + 1)), a = new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      n >> 24,
      n >> 16 & 255,
      n >> 8 & 255,
      n & 255,
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return ae.box(ae.types.mvhd, a);
  }
  static sdtp(e) {
    const r = e.samples || [], n = new Uint8Array(4 + r.length);
    let s, a;
    for (s = 0; s < r.length; s++)
      a = r[s].flags, n[s + 4] = a.dependsOn << 4 | a.isDependedOn << 2 | a.hasRedundancy;
    return ae.box(ae.types.sdtp, n);
  }
  static stbl(e) {
    return ae.box(ae.types.stbl, ae.stsd(e), ae.box(ae.types.stts, ae.STTS), ae.box(ae.types.stsc, ae.STSC), ae.box(ae.types.stsz, ae.STSZ), ae.box(ae.types.stco, ae.STCO));
  }
  static avc1(e) {
    let r = [], n = [], s, a, o;
    for (s = 0; s < e.sps.length; s++)
      a = e.sps[s], o = a.byteLength, r.push(o >>> 8 & 255), r.push(o & 255), r = r.concat(Array.prototype.slice.call(a));
    for (s = 0; s < e.pps.length; s++)
      a = e.pps[s], o = a.byteLength, n.push(o >>> 8 & 255), n.push(o & 255), n = n.concat(Array.prototype.slice.call(a));
    const l = ae.box(ae.types.avcC, new Uint8Array([
      1,
      // version
      r[3],
      // profile
      r[4],
      // profile compat
      r[5],
      // level
      255,
      // lengthSizeMinusOne, hard-coded to 4 bytes
      224 | e.sps.length
      // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(r).concat([
      e.pps.length
      // numOfPictureParameterSets
    ]).concat(n))), u = e.width, c = e.height, d = e.pixelRatio[0], h = e.pixelRatio[1];
    return ae.box(
      ae.types.avc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        u >> 8 & 255,
        u & 255,
        // width
        c >> 8 & 255,
        c & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      l,
      ae.box(ae.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      ae.box(ae.types.pasp, new Uint8Array([
        d >> 24,
        // hSpacing
        d >> 16 & 255,
        d >> 8 & 255,
        d & 255,
        h >> 24,
        // vSpacing
        h >> 16 & 255,
        h >> 8 & 255,
        h & 255
      ]))
    );
  }
  static esds(e) {
    const r = e.config.length;
    return new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      3,
      // descriptor_type
      23 + r,
      // length
      0,
      1,
      // es_id
      0,
      // stream_priority
      4,
      // descriptor_type
      15 + r,
      // length
      64,
      // codec : mpeg4_audio
      21,
      // stream_type
      0,
      0,
      0,
      // buffer_size
      0,
      0,
      0,
      0,
      // maxBitrate
      0,
      0,
      0,
      0,
      // avgBitrate
      5
      // descriptor_type
    ].concat([r]).concat(e.config).concat([6, 1, 2]));
  }
  static mp4a(e) {
    const r = e.samplerate;
    return ae.box(ae.types.mp4a, new Uint8Array([
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      // reserved
      0,
      1,
      // data_reference_index
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      e.channelCount,
      // channelcount
      0,
      16,
      // sampleSize:16bits
      0,
      0,
      0,
      0,
      // reserved2
      r >> 8 & 255,
      r & 255,
      //
      0,
      0
    ]), ae.box(ae.types.esds, ae.esds(e)));
  }
  static mp3(e) {
    const r = e.samplerate;
    return ae.box(ae.types[".mp3"], new Uint8Array([
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      // reserved
      0,
      1,
      // data_reference_index
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      e.channelCount,
      // channelcount
      0,
      16,
      // sampleSize:16bits
      0,
      0,
      0,
      0,
      // reserved2
      r >> 8 & 255,
      r & 255,
      //
      0,
      0
    ]));
  }
  static stsd(e) {
    return e.type === "audio" ? e.segmentCodec === "mp3" && e.codec === "mp3" ? ae.box(ae.types.stsd, ae.STSD, ae.mp3(e)) : ae.box(ae.types.stsd, ae.STSD, ae.mp4a(e)) : ae.box(ae.types.stsd, ae.STSD, ae.avc1(e));
  }
  static tkhd(e) {
    const r = e.id, n = e.duration * e.timescale, s = e.width, a = e.height, o = Math.floor(n / (Xo + 1)), l = Math.floor(n % (Xo + 1));
    return ae.box(ae.types.tkhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      r >> 24 & 255,
      r >> 16 & 255,
      r >> 8 & 255,
      r & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      o >> 24,
      o >> 16 & 255,
      o >> 8 & 255,
      o & 255,
      l >> 24,
      l >> 16 & 255,
      l >> 8 & 255,
      l & 255,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      0,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      s >> 8 & 255,
      s & 255,
      0,
      0,
      // width
      a >> 8 & 255,
      a & 255,
      0,
      0
      // height
    ]));
  }
  static traf(e, r) {
    const n = ae.sdtp(e), s = e.id, a = Math.floor(r / (Xo + 1)), o = Math.floor(r % (Xo + 1));
    return ae.box(
      ae.types.traf,
      ae.box(ae.types.tfhd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        s >> 24,
        s >> 16 & 255,
        s >> 8 & 255,
        s & 255
        // track_ID
      ])),
      ae.box(ae.types.tfdt, new Uint8Array([
        1,
        // version 1
        0,
        0,
        0,
        // flags
        a >> 24,
        a >> 16 & 255,
        a >> 8 & 255,
        a & 255,
        o >> 24,
        o >> 16 & 255,
        o >> 8 & 255,
        o & 255
      ])),
      ae.trun(e, n.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8),
      // mdat header
      n
    );
  }
  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(e) {
    return e.duration = e.duration || 4294967295, ae.box(ae.types.trak, ae.tkhd(e), ae.mdia(e));
  }
  static trex(e) {
    const r = e.id;
    return ae.box(ae.types.trex, new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      r >> 24,
      r >> 16 & 255,
      r >> 8 & 255,
      r & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]));
  }
  static trun(e, r) {
    const n = e.samples || [], s = n.length, a = 12 + 16 * s, o = new Uint8Array(a);
    let l, u, c, d, h, f;
    for (r += 8 + a, o.set([
      e.type === "video" ? 1 : 0,
      // version 1 for video with signed-int sample_composition_time_offset
      0,
      15,
      1,
      // flags
      s >>> 24 & 255,
      s >>> 16 & 255,
      s >>> 8 & 255,
      s & 255,
      // sample_count
      r >>> 24 & 255,
      r >>> 16 & 255,
      r >>> 8 & 255,
      r & 255
      // data_offset
    ], 0), l = 0; l < s; l++)
      u = n[l], c = u.duration, d = u.size, h = u.flags, f = u.cts, o.set([
        c >>> 24 & 255,
        c >>> 16 & 255,
        c >>> 8 & 255,
        c & 255,
        // sample_duration
        d >>> 24 & 255,
        d >>> 16 & 255,
        d >>> 8 & 255,
        d & 255,
        // sample_size
        h.isLeading << 2 | h.dependsOn,
        h.isDependedOn << 6 | h.hasRedundancy << 4 | h.paddingValue << 1 | h.isNonSync,
        h.degradPrio & 61440,
        h.degradPrio & 15,
        // sample_flags
        f >>> 24 & 255,
        f >>> 16 & 255,
        f >>> 8 & 255,
        f & 255
        // sample_composition_time_offset
      ], 12 + 16 * l);
    return ae.box(ae.types.trun, o);
  }
  static initSegment(e) {
    ae.types || ae.init();
    const r = ae.moov(e), n = new Uint8Array(ae.FTYP.byteLength + r.byteLength);
    return n.set(ae.FTYP), n.set(r, ae.FTYP.byteLength), n;
  }
}
ae.types = void 0;
ae.HDLR_TYPES = void 0;
ae.STTS = void 0;
ae.STSC = void 0;
ae.STCO = void 0;
ae.STSZ = void 0;
ae.VMHD = void 0;
ae.SMHD = void 0;
ae.STSD = void 0;
ae.FTYP = void 0;
ae.DINF = void 0;
const PU = 9e4;
function Xk(t, e, r = 1, n = !1) {
  const s = t * e * r;
  return n ? Math.round(s) : s;
}
function lJ(t, e, r = 1, n = !1) {
  return Xk(t, e, 1 / r, n);
}
function zh(t, e = !1) {
  return Xk(t, 1e3, 1 / PU, e);
}
function uJ(t, e = 1) {
  return Xk(t, PU, 1 / e);
}
const cJ = 10 * 1e3, XI = 1024, dJ = 1152;
let Tm = null, D_ = null;
class O_ {
  constructor(e, r, n, s = "") {
    if (this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = null, this._initDTS = null, this.nextAvcDts = null, this.nextAudioPts = null, this.videoSampleDuration = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.observer = e, this.config = r, this.typeSupported = n, this.ISGenerated = !1, Tm === null) {
      const o = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      Tm = o ? parseInt(o[1]) : 0;
    }
    if (D_ === null) {
      const a = navigator.userAgent.match(/Safari\/(\d+)/i);
      D_ = a ? parseInt(a[1]) : 0;
    }
  }
  destroy() {
  }
  resetTimeStamp(e) {
    J.log("[mp4-remuxer]: initPTS & initDTS reset"), this._initPTS = this._initDTS = e;
  }
  resetNextTimestamp() {
    J.log("[mp4-remuxer]: reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
  }
  resetInitSegment() {
    J.log("[mp4-remuxer]: ISGenerated flag reset"), this.ISGenerated = !1;
  }
  getVideoStartPts(e) {
    let r = !1;
    const n = e.reduce((s, a) => {
      const o = a.pts - s;
      return o < -4294967296 ? (r = !0, ss(s, a.pts)) : o > 0 ? s : a.pts;
    }, e[0].pts);
    return r && J.debug("PTS rollover detected"), n;
  }
  remux(e, r, n, s, a, o, l, u) {
    let c, d, h, f, p, m, b = a, y = a;
    const _ = e.pid > -1, x = r.pid > -1, T = r.samples.length, k = e.samples.length > 0, E = l && T > 0 || T > 1;
    if ((!_ || k) && (!x || E) || this.ISGenerated || l) {
      this.ISGenerated || (h = this.generateIS(e, r, a, o));
      const R = this.isVideoContiguous;
      let $ = -1, O;
      if (E && ($ = hJ(r.samples), !R && this.config.forceKeyFrameOnDiscontinuity))
        if (m = !0, $ > 0) {
          J.warn(`[mp4-remuxer]: Dropped ${$} out of ${T} video samples due to a missing keyframe`);
          const P = this.getVideoStartPts(r.samples);
          r.samples = r.samples.slice($), r.dropped += $, y += (r.samples[0].pts - P) / r.inputTimeScale, O = y;
        } else
          $ === -1 && (J.warn(`[mp4-remuxer]: No keyframe found out of ${T} video samples`), m = !1);
      if (this.ISGenerated) {
        if (k && E) {
          const P = this.getVideoStartPts(r.samples), I = (ss(e.samples[0].pts, P) - P) / r.inputTimeScale;
          b += Math.max(0, I), y += Math.max(0, -I);
        }
        if (k) {
          if (e.samplerate || (J.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"), h = this.generateIS(e, r, a, o)), d = this.remuxAudio(e, b, this.isAudioContiguous, o, x || E || u === at.AUDIO ? y : void 0), E) {
            const P = d ? d.endPTS - d.startPTS : 0;
            r.inputTimeScale || (J.warn("[mp4-remuxer]: regenerate InitSegment as video detected"), h = this.generateIS(e, r, a, o)), c = this.remuxVideo(r, y, R, P);
          }
        } else
          E && (c = this.remuxVideo(r, y, R, 0));
        c && (c.firstKeyFrame = $, c.independent = $ !== -1, c.firstKeyFramePTS = O);
      }
    }
    return this.ISGenerated && this._initPTS && this._initDTS && (n.samples.length && (p = RU(n, a, this._initPTS, this._initDTS)), s.samples.length && (f = MU(s, a, this._initPTS))), {
      audio: d,
      video: c,
      initSegment: h,
      independent: m,
      text: f,
      id3: p
    };
  }
  generateIS(e, r, n, s) {
    const a = e.samples, o = r.samples, l = this.typeSupported, u = {}, c = this._initPTS;
    let d = !c || s, h = "audio/mp4", f, p, m;
    if (d && (f = p = 1 / 0), e.config && a.length) {
      switch (e.timescale = e.samplerate, e.segmentCodec) {
        case "mp3":
          l.mpeg ? (h = "audio/mpeg", e.codec = "") : l.mp3 && (e.codec = "mp3");
          break;
      }
      u.audio = {
        id: "audio",
        container: h,
        codec: e.codec,
        initSegment: e.segmentCodec === "mp3" && l.mpeg ? new Uint8Array(0) : ae.initSegment([e]),
        metadata: {
          channelCount: e.channelCount
        }
      }, d && (m = e.inputTimeScale, !c || m !== c.timescale ? f = p = a[0].pts - Math.round(m * n) : d = !1);
    }
    if (r.sps && r.pps && o.length && (r.timescale = r.inputTimeScale, u.video = {
      id: "main",
      container: "video/mp4",
      codec: r.codec,
      initSegment: ae.initSegment([r]),
      metadata: {
        width: r.width,
        height: r.height
      }
    }, d))
      if (m = r.inputTimeScale, !c || m !== c.timescale) {
        const b = this.getVideoStartPts(o), y = Math.round(m * n);
        p = Math.min(p, ss(o[0].dts, b) - y), f = Math.min(f, b - y);
      } else
        d = !1;
    if (Object.keys(u).length)
      return this.ISGenerated = !0, d ? (this._initPTS = {
        baseTime: f,
        timescale: m
      }, this._initDTS = {
        baseTime: p,
        timescale: m
      }) : f = m = void 0, {
        tracks: u,
        initPTS: f,
        timescale: m
      };
  }
  remuxVideo(e, r, n, s) {
    const a = e.inputTimeScale, o = e.samples, l = [], u = o.length, c = this._initPTS;
    let d = this.nextAvcDts, h = 8, f = this.videoSampleDuration, p, m, b = Number.POSITIVE_INFINITY, y = Number.NEGATIVE_INFINITY, _ = !1;
    if (!n || d === null) {
      const A = r * a, V = o[0].pts - ss(o[0].dts, o[0].pts);
      d = A - V;
    }
    const x = c.baseTime * a / c.timescale;
    for (let A = 0; A < u; A++) {
      const V = o[A];
      V.pts = ss(V.pts - x, d), V.dts = ss(V.dts - x, d), V.dts < o[A > 0 ? A - 1 : A].dts && (_ = !0);
    }
    _ && o.sort(function(A, V) {
      const M = A.dts - V.dts, Z = A.pts - V.pts;
      return M || Z;
    }), p = o[0].dts, m = o[o.length - 1].dts;
    const T = m - p, k = T ? Math.round(T / (u - 1)) : f || e.inputTimeScale / 30;
    if (n) {
      const A = p - d, V = A > k, M = A < -1;
      if ((V || M) && (V ? J.warn(`AVC: ${zh(A, !0)} ms (${A}dts) hole between fragments detected, filling it`) : J.warn(`AVC: ${zh(-A, !0)} ms (${A}dts) overlapping between fragments detected`), !M || d >= o[0].pts)) {
        p = d;
        const Z = o[0].pts - A;
        o[0].dts = p, o[0].pts = Z, J.log(`Video: First PTS/DTS adjusted: ${zh(Z, !0)}/${zh(p, !0)}, delta: ${zh(A, !0)} ms`);
      }
    }
    p = Math.max(0, p);
    let E = 0, F = 0;
    for (let A = 0; A < u; A++) {
      const V = o[A], M = V.units, Z = M.length;
      let U = 0;
      for (let pe = 0; pe < Z; pe++)
        U += M[pe].data.length;
      F += U, E += Z, V.length = U, V.dts = Math.max(V.dts, p), b = Math.min(V.pts, b), y = Math.max(V.pts, y);
    }
    m = o[u - 1].dts;
    const R = F + 4 * E + 8;
    let $;
    try {
      $ = new Uint8Array(R);
    } catch (A) {
      this.observer.emit(D.ERROR, D.ERROR, {
        type: it.MUX_ERROR,
        details: le.REMUX_ALLOC_ERROR,
        fatal: !1,
        error: A,
        bytes: R,
        reason: `fail allocating video mdat ${R}`
      });
      return;
    }
    const O = new DataView($.buffer);
    O.setUint32(0, R), $.set(ae.types.mdat, 4);
    let P = !1, N = Number.POSITIVE_INFINITY, I = Number.POSITIVE_INFINITY, B = Number.NEGATIVE_INFINITY, W = Number.NEGATIVE_INFINITY;
    for (let A = 0; A < u; A++) {
      const V = o[A], M = V.units;
      let Z = 0;
      for (let q = 0, Y = M.length; q < Y; q++) {
        const se = M[q], he = se.data, fe = se.data.byteLength;
        O.setUint32(h, fe), h += 4, $.set(he, h), h += fe, Z += 4 + fe;
      }
      let U;
      if (A < u - 1)
        f = o[A + 1].dts - V.dts, U = o[A + 1].pts - V.pts;
      else {
        const q = this.config, Y = A > 0 ? V.dts - o[A - 1].dts : k;
        if (U = A > 0 ? V.pts - o[A - 1].pts : k, q.stretchShortVideoTrack && this.nextAudioPts !== null) {
          const se = Math.floor(q.maxBufferHole * a), he = (s ? b + s * a : this.nextAudioPts) - V.pts;
          he > se ? (f = he - Y, f < 0 ? f = Y : P = !0, J.log(`[mp4-remuxer]: It is approximately ${he / 90} ms to the next segment; using duration ${f / 90} ms for the last video frame.`)) : f = Y;
        } else
          f = Y;
      }
      const pe = Math.round(V.pts - V.dts);
      N = Math.min(N, f), B = Math.max(B, f), I = Math.min(I, U), W = Math.max(W, U), l.push(new QI(V.key, f, Z, pe));
    }
    if (l.length) {
      if (Tm) {
        if (Tm < 70) {
          const A = l[0].flags;
          A.dependsOn = 2, A.isNonSync = 0;
        }
      } else if (D_ && W - I < B - N && k / B < 0.025 && l[0].cts === 0) {
        J.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
        let A = p;
        for (let V = 0, M = l.length; V < M; V++) {
          const Z = A + l[V].duration, U = A + l[V].cts;
          if (V < M - 1) {
            const pe = Z + l[V + 1].cts;
            l[V].duration = pe - U;
          } else
            l[V].duration = V ? l[V - 1].duration : k;
          l[V].cts = 0, A = Z;
        }
      }
    }
    f = P || !f ? k : f, this.nextAvcDts = d = m + f, this.videoSampleDuration = f, this.isVideoContiguous = !0;
    const Q = ae.moof(e.sequenceNumber++, p, hn({}, e, {
      samples: l
    })), te = "video", H = {
      data1: Q,
      data2: $,
      startPTS: b / a,
      endPTS: (y + f) / a,
      startDTS: p / a,
      endDTS: d / a,
      type: te,
      hasAudio: !1,
      hasVideo: !0,
      nb: l.length,
      dropped: e.dropped
    };
    return e.samples = [], e.dropped = 0, H;
  }
  remuxAudio(e, r, n, s, a) {
    const o = e.inputTimeScale, l = e.samplerate ? e.samplerate : o, u = o / l, c = e.segmentCodec === "aac" ? XI : dJ, d = c * u, h = this._initPTS, f = e.segmentCodec === "mp3" && this.typeSupported.mpeg, p = [], m = a !== void 0;
    let b = e.samples, y = f ? 0 : 8, _ = this.nextAudioPts || -1;
    const x = r * o, T = h.baseTime * o / h.timescale;
    if (this.isAudioContiguous = n = n || b.length && _ > 0 && (s && Math.abs(x - _) < 9e3 || Math.abs(ss(b[0].pts - T, x) - _) < 20 * d), b.forEach(function(te) {
      te.pts = ss(te.pts - T, x);
    }), !n || _ < 0) {
      if (b = b.filter((te) => te.pts >= 0), !b.length)
        return;
      a === 0 ? _ = 0 : s && !m ? _ = Math.max(0, x) : _ = b[0].pts;
    }
    if (e.segmentCodec === "aac") {
      const te = this.config.maxAudioFramesDrift;
      for (let H = 0, A = _; H < b.length; H++) {
        const V = b[H], M = V.pts, Z = M - A, U = Math.abs(1e3 * Z / o);
        if (Z <= -te * d && m)
          H === 0 && (J.warn(`Audio frame @ ${(M / o).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1e3 * Z / o)} ms.`), this.nextAudioPts = _ = A = M);
        else if (Z >= te * d && U < cJ && m) {
          let pe = Math.round(Z / d);
          A = M - pe * d, A < 0 && (pe--, A += d), H === 0 && (this.nextAudioPts = _ = A), J.warn(`[mp4-remuxer]: Injecting ${pe} audio frame @ ${(A / o).toFixed(3)}s due to ${Math.round(1e3 * Z / o)} ms gap.`);
          for (let q = 0; q < pe; q++) {
            const Y = Math.max(A, 0);
            let se = qI.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
            se || (J.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."), se = V.unit.subarray()), b.splice(H, 0, {
              unit: se,
              pts: Y
            }), A += d, H++;
          }
        }
        V.pts = A, A += d;
      }
    }
    let k = null, E = null, F, R = 0, $ = b.length;
    for (; $--; )
      R += b[$].unit.byteLength;
    for (let te = 0, H = b.length; te < H; te++) {
      const A = b[te], V = A.unit;
      let M = A.pts;
      if (E !== null) {
        const U = p[te - 1];
        U.duration = Math.round((M - E) / u);
      } else if (n && e.segmentCodec === "aac" && (M = _), k = M, R > 0) {
        R += y;
        try {
          F = new Uint8Array(R);
        } catch (U) {
          this.observer.emit(D.ERROR, D.ERROR, {
            type: it.MUX_ERROR,
            details: le.REMUX_ALLOC_ERROR,
            fatal: !1,
            error: U,
            bytes: R,
            reason: `fail allocating audio mdat ${R}`
          });
          return;
        }
        f || (new DataView(F.buffer).setUint32(0, R), F.set(ae.types.mdat, 4));
      } else
        return;
      F.set(V, y);
      const Z = V.byteLength;
      y += Z, p.push(new QI(!0, c, Z, 0)), E = M;
    }
    const O = p.length;
    if (!O)
      return;
    const P = p[p.length - 1];
    this.nextAudioPts = _ = E + u * P.duration;
    const N = f ? new Uint8Array(0) : ae.moof(e.sequenceNumber++, k / u, hn({}, e, {
      samples: p
    }));
    e.samples = [];
    const I = k / o, B = _ / o, Q = {
      data1: N,
      data2: F,
      startPTS: I,
      endPTS: B,
      startDTS: I,
      endDTS: B,
      type: "audio",
      hasAudio: !0,
      hasVideo: !1,
      nb: O
    };
    return this.isAudioContiguous = !0, Q;
  }
  remuxEmptyAudio(e, r, n, s) {
    const a = e.inputTimeScale, o = e.samplerate ? e.samplerate : a, l = a / o, u = this.nextAudioPts, c = this._initDTS, d = c.baseTime * 9e4 / c.timescale, h = (u !== null ? u : s.startDTS * a) + d, f = s.endDTS * a + d, p = l * XI, m = Math.ceil((f - h) / p), b = qI.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
    if (J.warn("[mp4-remuxer]: remux empty Audio"), !b) {
      J.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");
      return;
    }
    const y = [];
    for (let _ = 0; _ < m; _++) {
      const x = h + _ * p;
      y.push({
        unit: b,
        pts: x,
        dts: x
      });
    }
    return e.samples = y, this.remuxAudio(e, r, n, !1);
  }
}
function ss(t, e) {
  let r;
  if (e === null)
    return t;
  for (e < t ? r = -8589934592 : r = 8589934592; Math.abs(t - e) > 4294967296; )
    t += r;
  return t;
}
function hJ(t) {
  for (let e = 0; e < t.length; e++)
    if (t[e].key)
      return e;
  return -1;
}
function RU(t, e, r, n) {
  const s = t.samples.length;
  if (!s)
    return;
  const a = t.inputTimeScale;
  for (let l = 0; l < s; l++) {
    const u = t.samples[l];
    u.pts = ss(u.pts - r.baseTime * a / r.timescale, e * a) / a, u.dts = ss(u.dts - n.baseTime * a / n.timescale, e * a) / a;
  }
  const o = t.samples;
  return t.samples = [], {
    samples: o
  };
}
function MU(t, e, r) {
  const n = t.samples.length;
  if (!n)
    return;
  const s = t.inputTimeScale;
  for (let o = 0; o < n; o++) {
    const l = t.samples[o];
    l.pts = ss(l.pts - r.baseTime * s / r.timescale, e * s) / s;
  }
  t.samples.sort((o, l) => o.pts - l.pts);
  const a = t.samples;
  return t.samples = [], {
    samples: a
  };
}
class QI {
  constructor(e, r, n, s) {
    this.size = void 0, this.duration = void 0, this.cts = void 0, this.flags = void 0, this.duration = r, this.size = n, this.cts = s, this.flags = new fJ(e);
  }
}
class fJ {
  constructor(e) {
    this.isLeading = 0, this.isDependedOn = 0, this.hasRedundancy = 0, this.degradPrio = 0, this.dependsOn = 1, this.isNonSync = 1, this.dependsOn = e ? 2 : 1, this.isNonSync = e ? 0 : 1;
  }
}
class pJ {
  constructor() {
    this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = null, this.initTracks = void 0, this.lastEndTime = null;
  }
  destroy() {
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.lastEndTime = null;
  }
  resetNextTimestamp() {
    this.lastEndTime = null;
  }
  resetInitSegment(e, r, n, s) {
    this.audioCodec = r, this.videoCodec = n, this.generateInitSegment(RQ(e, s)), this.emitInitSegment = !0;
  }
  generateInitSegment(e) {
    let {
      audioCodec: r,
      videoCodec: n
    } = this;
    if (!(e != null && e.byteLength)) {
      this.initTracks = void 0, this.initData = void 0;
      return;
    }
    const s = this.initData = cU(e);
    r || (r = ZI(s.audio, or.AUDIO)), n || (n = ZI(s.video, or.VIDEO));
    const a = {};
    s.audio && s.video ? a.audiovideo = {
      container: "video/mp4",
      codec: r + "," + n,
      initSegment: e,
      id: "main"
    } : s.audio ? a.audio = {
      container: "audio/mp4",
      codec: r,
      initSegment: e,
      id: "audio"
    } : s.video ? a.video = {
      container: "video/mp4",
      codec: n,
      initSegment: e,
      id: "main"
    } : J.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."), this.initTracks = a;
  }
  remux(e, r, n, s, a, o) {
    var l, u;
    let {
      initPTS: c,
      lastEndTime: d
    } = this;
    const h = {
      audio: void 0,
      video: void 0,
      text: s,
      id3: n,
      initSegment: void 0
    };
    et(d) || (d = this.lastEndTime = a || 0);
    const f = r.samples;
    if (!(f != null && f.length))
      return h;
    const p = {
      initPTS: void 0,
      timescale: 1
    };
    let m = this.initData;
    if ((l = m) != null && l.length || (this.generateInitSegment(f), m = this.initData), !((u = m) != null && u.length))
      return J.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."), h;
    this.emitInitSegment && (p.tracks = this.initTracks, this.emitInitSegment = !1);
    const b = LQ(f, m), y = MQ(m, f), _ = y === null ? a : y;
    (vJ(c, _, a, b) || p.timescale !== c.timescale && o) && (p.initPTS = _ - a, c && c.timescale === 1 && J.warn(`Adjusting initPTS by ${p.initPTS - c.baseTime}`), this.initPTS = c = {
      baseTime: p.initPTS,
      timescale: 1
    });
    const x = e ? _ - c.baseTime / c.timescale : d, T = x + b;
    FQ(m, f, c.baseTime / c.timescale), b > 0 ? this.lastEndTime = T : (J.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
    const k = !!m.audio, E = !!m.video;
    let F = "";
    k && (F += "audio"), E && (F += "video");
    const R = {
      data1: f,
      startPTS: x,
      startDTS: x,
      endPTS: T,
      endDTS: T,
      type: F,
      hasAudio: k,
      hasVideo: E,
      nb: 1,
      dropped: 0
    };
    return h.audio = R.type === "audio" ? R : void 0, h.video = R.type !== "audio" ? R : void 0, h.initSegment = p, h.id3 = RU(n, a, c, c), s.samples.length && (h.text = MU(s, a, c)), h;
  }
}
function vJ(t, e, r, n) {
  if (t === null)
    return !0;
  const s = Math.max(n, 1), a = e - t.baseTime / t.timescale;
  return Math.abs(a - r) > s;
}
function ZI(t, e) {
  const r = t == null ? void 0 : t.codec;
  return r && r.length > 4 ? r : r === "hvc1" || r === "hev1" ? "hvc1.1.6.L120.90" : r === "av01" ? "av01.0.04M.08" : r === "avc1" || e === or.VIDEO ? "avc1.42e01e" : "mp4a.40.5";
}
let to;
try {
  to = self.performance.now.bind(self.performance);
} catch {
  J.debug("Unable to use Performance API on this environment"), to = typeof self < "u" && self.Date.now;
}
const A_ = [{
  demux: QZ,
  remux: pJ
}, {
  demux: il,
  remux: O_
}, {
  demux: qZ,
  remux: O_
}, {
  demux: oJ,
  remux: O_
}];
class JI {
  constructor(e, r, n, s, a) {
    this.async = !1, this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.vendor = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.observer = e, this.typeSupported = r, this.config = n, this.vendor = s, this.id = a;
  }
  configure(e) {
    this.transmuxConfig = e, this.decrypter && this.decrypter.reset();
  }
  push(e, r, n, s) {
    const a = n.transmuxing;
    a.executeStart = to();
    let o = new Uint8Array(e);
    const {
      currentTransmuxState: l,
      transmuxConfig: u
    } = this;
    s && (this.currentTransmuxState = s);
    const {
      contiguous: c,
      discontinuity: d,
      trackSwitch: h,
      accurateTimeOffset: f,
      timeOffset: p,
      initSegmentChange: m
    } = s || l, {
      audioCodec: b,
      videoCodec: y,
      defaultInitPts: _,
      duration: x,
      initSegmentData: T
    } = u, k = mJ(o, r);
    if (k && k.method === "AES-128") {
      const $ = this.getDecrypter();
      if ($.isSync()) {
        let O = $.softwareDecrypt(o, k.key.buffer, k.iv.buffer);
        if (n.part > -1 && (O = $.flush()), !O)
          return a.executeEnd = to(), C_(n);
        o = new Uint8Array(O);
      } else
        return this.decryptionPromise = $.webCryptoDecrypt(o, k.key.buffer, k.iv.buffer).then((O) => {
          const P = this.push(O, null, n);
          return this.decryptionPromise = null, P;
        }), this.decryptionPromise;
    }
    const E = this.needsProbing(d, h);
    if (E) {
      const $ = this.configureTransmuxer(o);
      if ($)
        return J.warn(`[transmuxer] ${$.message}`), this.observer.emit(D.ERROR, D.ERROR, {
          type: it.MEDIA_ERROR,
          details: le.FRAG_PARSING_ERROR,
          fatal: !1,
          error: $,
          reason: $.message
        }), a.executeEnd = to(), C_(n);
    }
    (d || h || m || E) && this.resetInitSegment(T, b, y, x, r), (d || m || E) && this.resetInitialTimestamp(_), c || this.resetContiguity();
    const F = this.transmux(o, k, p, f, n), R = this.currentTransmuxState;
    return R.contiguous = !0, R.discontinuity = !1, R.trackSwitch = !1, a.executeEnd = to(), F;
  }
  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(e) {
    const r = e.transmuxing;
    r.executeStart = to();
    const {
      decrypter: n,
      currentTransmuxState: s,
      decryptionPromise: a
    } = this;
    if (a)
      return a.then(() => this.flush(e));
    const o = [], {
      timeOffset: l
    } = s;
    if (n) {
      const h = n.flush();
      h && o.push(this.push(h, null, e));
    }
    const {
      demuxer: u,
      remuxer: c
    } = this;
    if (!u || !c)
      return r.executeEnd = to(), [C_(e)];
    const d = u.flush(l);
    return xg(d) ? d.then((h) => (this.flushRemux(o, h, e), o)) : (this.flushRemux(o, d, e), o);
  }
  flushRemux(e, r, n) {
    const {
      audioTrack: s,
      videoTrack: a,
      id3Track: o,
      textTrack: l
    } = r, {
      accurateTimeOffset: u,
      timeOffset: c
    } = this.currentTransmuxState;
    J.log(`[transmuxer.ts]: Flushed fragment ${n.sn}${n.part > -1 ? " p: " + n.part : ""} of level ${n.level}`);
    const d = this.remuxer.remux(s, a, o, l, c, u, !0, this.id);
    e.push({
      remuxResult: d,
      chunkMeta: n
    }), n.transmuxing.executeEnd = to();
  }
  resetInitialTimestamp(e) {
    const {
      demuxer: r,
      remuxer: n
    } = this;
    !r || !n || (r.resetTimeStamp(e), n.resetTimeStamp(e));
  }
  resetContiguity() {
    const {
      demuxer: e,
      remuxer: r
    } = this;
    !e || !r || (e.resetContiguity(), r.resetNextTimestamp());
  }
  resetInitSegment(e, r, n, s, a) {
    const {
      demuxer: o,
      remuxer: l
    } = this;
    !o || !l || (o.resetInitSegment(e, r, n, s), l.resetInitSegment(e, r, n, a));
  }
  destroy() {
    this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
  }
  transmux(e, r, n, s, a) {
    let o;
    return r && r.method === "SAMPLE-AES" ? o = this.transmuxSampleAes(e, r, n, s, a) : o = this.transmuxUnencrypted(e, n, s, a), o;
  }
  transmuxUnencrypted(e, r, n, s) {
    const {
      audioTrack: a,
      videoTrack: o,
      id3Track: l,
      textTrack: u
    } = this.demuxer.demux(e, r, !1, !this.config.progressive);
    return {
      remuxResult: this.remuxer.remux(a, o, l, u, r, n, !1, this.id),
      chunkMeta: s
    };
  }
  transmuxSampleAes(e, r, n, s, a) {
    return this.demuxer.demuxSampleAes(e, r, n).then((o) => ({
      remuxResult: this.remuxer.remux(o.audioTrack, o.videoTrack, o.id3Track, o.textTrack, n, s, !1, this.id),
      chunkMeta: a
    }));
  }
  configureTransmuxer(e) {
    const {
      config: r,
      observer: n,
      typeSupported: s,
      vendor: a
    } = this;
    let o;
    for (let h = 0, f = A_.length; h < f; h++)
      if (A_[h].demux.probe(e)) {
        o = A_[h];
        break;
      }
    if (!o)
      return new Error("Failed to find demuxer by probing fragment data");
    const l = this.demuxer, u = this.remuxer, c = o.remux, d = o.demux;
    (!u || !(u instanceof c)) && (this.remuxer = new c(n, r, s, a)), (!l || !(l instanceof d)) && (this.demuxer = new d(n, r, s), this.probe = d.probe);
  }
  needsProbing(e, r) {
    return !this.demuxer || !this.remuxer || e || r;
  }
  getDecrypter() {
    let e = this.decrypter;
    return e || (e = this.decrypter = new jk(this.config)), e;
  }
}
function mJ(t, e) {
  let r = null;
  return t.byteLength > 0 && e != null && e.key != null && e.iv !== null && e.method != null && (r = e), r;
}
const C_ = (t) => ({
  remuxResult: {},
  chunkMeta: t
});
function xg(t) {
  return "then" in t && t.then instanceof Function;
}
class gJ {
  constructor(e, r, n, s, a) {
    this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = e, this.videoCodec = r, this.initSegmentData = n, this.duration = s, this.defaultInitPts = a || null;
  }
}
class yJ {
  constructor(e, r, n, s, a, o) {
    this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = e, this.contiguous = r, this.accurateTimeOffset = n, this.trackSwitch = s, this.timeOffset = a, this.initSegmentChange = o;
  }
}
var LU = { exports: {} };
(function(t) {
  var e = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function s(u, c, d) {
    this.fn = u, this.context = c, this.once = d || !1;
  }
  function a(u, c, d, h, f) {
    if (typeof d != "function")
      throw new TypeError("The listener must be a function");
    var p = new s(d, h || u, f), m = r ? r + c : c;
    return u._events[m] ? u._events[m].fn ? u._events[m] = [u._events[m], p] : u._events[m].push(p) : (u._events[m] = p, u._eventsCount++), u;
  }
  function o(u, c) {
    --u._eventsCount === 0 ? u._events = new n() : delete u._events[c];
  }
  function l() {
    this._events = new n(), this._eventsCount = 0;
  }
  l.prototype.eventNames = function() {
    var c = [], d, h;
    if (this._eventsCount === 0)
      return c;
    for (h in d = this._events)
      e.call(d, h) && c.push(r ? h.slice(1) : h);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(d)) : c;
  }, l.prototype.listeners = function(c) {
    var d = r ? r + c : c, h = this._events[d];
    if (!h)
      return [];
    if (h.fn)
      return [h.fn];
    for (var f = 0, p = h.length, m = new Array(p); f < p; f++)
      m[f] = h[f].fn;
    return m;
  }, l.prototype.listenerCount = function(c) {
    var d = r ? r + c : c, h = this._events[d];
    return h ? h.fn ? 1 : h.length : 0;
  }, l.prototype.emit = function(c, d, h, f, p, m) {
    var b = r ? r + c : c;
    if (!this._events[b])
      return !1;
    var y = this._events[b], _ = arguments.length, x, T;
    if (y.fn) {
      switch (y.once && this.removeListener(c, y.fn, void 0, !0), _) {
        case 1:
          return y.fn.call(y.context), !0;
        case 2:
          return y.fn.call(y.context, d), !0;
        case 3:
          return y.fn.call(y.context, d, h), !0;
        case 4:
          return y.fn.call(y.context, d, h, f), !0;
        case 5:
          return y.fn.call(y.context, d, h, f, p), !0;
        case 6:
          return y.fn.call(y.context, d, h, f, p, m), !0;
      }
      for (T = 1, x = new Array(_ - 1); T < _; T++)
        x[T - 1] = arguments[T];
      y.fn.apply(y.context, x);
    } else {
      var k = y.length, E;
      for (T = 0; T < k; T++)
        switch (y[T].once && this.removeListener(c, y[T].fn, void 0, !0), _) {
          case 1:
            y[T].fn.call(y[T].context);
            break;
          case 2:
            y[T].fn.call(y[T].context, d);
            break;
          case 3:
            y[T].fn.call(y[T].context, d, h);
            break;
          case 4:
            y[T].fn.call(y[T].context, d, h, f);
            break;
          default:
            if (!x)
              for (E = 1, x = new Array(_ - 1); E < _; E++)
                x[E - 1] = arguments[E];
            y[T].fn.apply(y[T].context, x);
        }
    }
    return !0;
  }, l.prototype.on = function(c, d, h) {
    return a(this, c, d, h, !1);
  }, l.prototype.once = function(c, d, h) {
    return a(this, c, d, h, !0);
  }, l.prototype.removeListener = function(c, d, h, f) {
    var p = r ? r + c : c;
    if (!this._events[p])
      return this;
    if (!d)
      return o(this, p), this;
    var m = this._events[p];
    if (m.fn)
      m.fn === d && (!f || m.once) && (!h || m.context === h) && o(this, p);
    else {
      for (var b = 0, y = [], _ = m.length; b < _; b++)
        (m[b].fn !== d || f && !m[b].once || h && m[b].context !== h) && y.push(m[b]);
      y.length ? this._events[p] = y.length === 1 ? y[0] : y : o(this, p);
    }
    return this;
  }, l.prototype.removeAllListeners = function(c) {
    var d;
    return c ? (d = r ? r + c : c, this._events[d] && o(this, d)) : (this._events = new n(), this._eventsCount = 0), this;
  }, l.prototype.off = l.prototype.removeListener, l.prototype.addListener = l.prototype.on, l.prefixed = r, l.EventEmitter = l, t.exports = l;
})(LU);
var bJ = LU.exports, Qk = /* @__PURE__ */ iQ(bJ);
const I_ = P0() || {
  isTypeSupported: () => !1
};
class NU {
  constructor(e, r, n, s) {
    this.error = null, this.hls = void 0, this.id = void 0, this.observer = void 0, this.frag = null, this.part = null, this.useWorker = void 0, this.workerContext = null, this.onwmsg = void 0, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0;
    const a = e.config;
    this.hls = e, this.id = r, this.useWorker = !!a.enableWorker, this.onTransmuxComplete = n, this.onFlush = s;
    const o = (c, d) => {
      d = d || {}, d.frag = this.frag, d.id = this.id, c === D.ERROR && (this.error = d.error), this.hls.trigger(c, d);
    };
    this.observer = new Qk(), this.observer.on(D.FRAG_DECRYPTED, o), this.observer.on(D.ERROR, o);
    const l = {
      mp4: I_.isTypeSupported("video/mp4"),
      mpeg: I_.isTypeSupported("audio/mpeg"),
      mp3: I_.isTypeSupported('audio/mp4; codecs="mp3"')
    }, u = navigator.vendor;
    if (this.useWorker && typeof Worker < "u" && (a.workerPath || UZ())) {
      try {
        a.workerPath ? (J.log(`loading Web Worker ${a.workerPath} for "${r}"`), this.workerContext = YZ(a.workerPath)) : (J.log(`injecting Web Worker for "${r}"`), this.workerContext = VZ()), this.onwmsg = (h) => this.onWorkerMessage(h);
        const {
          worker: d
        } = this.workerContext;
        d.addEventListener("message", this.onwmsg), d.onerror = (h) => {
          const f = new Error(`${h.message}  (${h.filename}:${h.lineno})`);
          a.enableWorker = !1, J.warn(`Error in "${r}" Web Worker, fallback to inline`), this.hls.trigger(D.ERROR, {
            type: it.OTHER_ERROR,
            details: le.INTERNAL_EXCEPTION,
            fatal: !1,
            event: "demuxerWorker",
            error: f
          });
        }, d.postMessage({
          cmd: "init",
          typeSupported: l,
          vendor: u,
          id: r,
          config: JSON.stringify(a)
        });
      } catch (d) {
        J.warn(`Error setting up "${r}" Web Worker, fallback to inline`, d), this.resetWorker(), this.error = null, this.transmuxer = new JI(this.observer, l, a, u, r);
      }
      return;
    }
    this.transmuxer = new JI(this.observer, l, a, u, r);
  }
  resetWorker() {
    if (this.workerContext) {
      const {
        worker: e,
        objectURL: r
      } = this.workerContext;
      r && self.URL.revokeObjectURL(r), e.removeEventListener("message", this.onwmsg), e.onerror = null, e.terminate(), this.workerContext = null;
    }
  }
  destroy() {
    if (this.workerContext)
      this.resetWorker(), this.onwmsg = void 0;
    else {
      const r = this.transmuxer;
      r && (r.destroy(), this.transmuxer = null);
    }
    const e = this.observer;
    e && e.removeAllListeners(), this.frag = null, this.observer = null, this.hls = null;
  }
  push(e, r, n, s, a, o, l, u, c, d) {
    var h, f;
    c.transmuxing.start = self.performance.now();
    const {
      transmuxer: p
    } = this, m = o ? o.start : a.start, b = a.decryptdata, y = this.frag, _ = !(y && a.cc === y.cc), x = !(y && c.level === y.level), T = y ? c.sn - y.sn : -1, k = this.part ? c.part - this.part.index : -1, E = T === 0 && c.id > 1 && c.id === (y == null ? void 0 : y.stats.chunkCount), F = !x && (T === 1 || T === 0 && (k === 1 || E && k <= 0)), R = self.performance.now();
    (x || T || a.stats.parsing.start === 0) && (a.stats.parsing.start = R), o && (k || !F) && (o.stats.parsing.start = R);
    const $ = !(y && ((h = a.initSegment) == null ? void 0 : h.url) === ((f = y.initSegment) == null ? void 0 : f.url)), O = new yJ(_, F, u, x, m, $);
    if (!F || _ || $) {
      J.log(`[transmuxer-interface, ${a.type}]: Starting new transmux session for sn: ${c.sn} p: ${c.part} level: ${c.level} id: ${c.id}
        discontinuity: ${_}
        trackSwitch: ${x}
        contiguous: ${F}
        accurateTimeOffset: ${u}
        timeOffset: ${m}
        initSegmentChange: ${$}`);
      const P = new gJ(n, s, r, l, d);
      this.configureTransmuxer(P);
    }
    if (this.frag = a, this.part = o, this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "demux",
        data: e,
        decryptdata: b,
        chunkMeta: c,
        state: O
      }, e instanceof ArrayBuffer ? [e] : []);
    else if (p) {
      const P = p.push(e, b, c, O);
      xg(P) ? (p.async = !0, P.then((N) => {
        this.handleTransmuxComplete(N);
      }).catch((N) => {
        this.transmuxerError(N, c, "transmuxer-interface push error");
      })) : (p.async = !1, this.handleTransmuxComplete(P));
    }
  }
  flush(e) {
    e.transmuxing.start = self.performance.now();
    const {
      transmuxer: r
    } = this;
    if (this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "flush",
        chunkMeta: e
      });
    else if (r) {
      let n = r.flush(e);
      xg(n) || r.async ? (xg(n) || (n = Promise.resolve(n)), n.then((a) => {
        this.handleFlushResult(a, e);
      }).catch((a) => {
        this.transmuxerError(a, e, "transmuxer-interface flush error");
      })) : this.handleFlushResult(n, e);
    }
  }
  transmuxerError(e, r, n) {
    this.hls && (this.error = e, this.hls.trigger(D.ERROR, {
      type: it.MEDIA_ERROR,
      details: le.FRAG_PARSING_ERROR,
      chunkMeta: r,
      fatal: !1,
      error: e,
      err: e,
      reason: n
    }));
  }
  handleFlushResult(e, r) {
    e.forEach((n) => {
      this.handleTransmuxComplete(n);
    }), this.onFlush(r);
  }
  onWorkerMessage(e) {
    const r = e.data, n = this.hls;
    switch (r.event) {
      case "init": {
        var s;
        const a = (s = this.workerContext) == null ? void 0 : s.objectURL;
        a && self.URL.revokeObjectURL(a);
        break;
      }
      case "transmuxComplete": {
        this.handleTransmuxComplete(r.data);
        break;
      }
      case "flush": {
        this.onFlush(r.data);
        break;
      }
      case "workerLog":
        J[r.data.logType] && J[r.data.logType](r.data.message);
        break;
      default: {
        r.data = r.data || {}, r.data.frag = this.frag, r.data.id = this.id, n.trigger(r.event, r.data);
        break;
      }
    }
  }
  configureTransmuxer(e) {
    const {
      transmuxer: r
    } = this;
    this.workerContext ? this.workerContext.worker.postMessage({
      cmd: "configure",
      config: e
    }) : r && r.configure(e);
  }
  handleTransmuxComplete(e) {
    e.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(e);
  }
}
const _J = 250, P_ = 2, wJ = 0.1, TJ = 0.05;
class xJ {
  constructor(e, r, n, s) {
    this.config = void 0, this.media = null, this.fragmentTracker = void 0, this.hls = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.config = e, this.media = r, this.fragmentTracker = n, this.hls = s;
  }
  destroy() {
    this.media = null, this.hls = this.fragmentTracker = null;
  }
  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(e, r) {
    const {
      config: n,
      media: s,
      stalled: a
    } = this;
    if (s === null)
      return;
    const {
      currentTime: o,
      seeking: l
    } = s, u = this.seeking && !l, c = !this.seeking && l;
    if (this.seeking = l, o !== e) {
      if (this.moved = !0, a !== null) {
        if (this.stallReported) {
          const _ = self.performance.now() - a;
          J.warn(`playback not stuck anymore @${o}, after ${Math.round(_)}ms`), this.stallReported = !1;
        }
        this.stalled = null, this.nudgeRetry = 0;
      }
      return;
    }
    if (c || u) {
      this.stalled = null;
      return;
    }
    if (s.paused && !l || s.ended || s.playbackRate === 0 || !Tr.getBuffered(s).length)
      return;
    const d = Tr.bufferInfo(s, o, 0), h = d.len > 0, f = d.nextStart || 0;
    if (!h && !f)
      return;
    if (l) {
      const _ = d.len > P_, x = !f || r && r.start <= o || f - o > P_ && !this.fragmentTracker.getPartialFragment(o);
      if (_ || x)
        return;
      this.moved = !1;
    }
    if (!this.moved && this.stalled !== null) {
      var p;
      const _ = Math.max(f, d.start || 0) - o, x = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null, k = (x == null || (p = x.details) == null ? void 0 : p.live) ? x.details.targetduration * 2 : P_, E = this.fragmentTracker.getPartialFragment(o);
      if (_ > 0 && (_ <= k || E)) {
        this._trySkipBufferHole(E);
        return;
      }
    }
    const m = self.performance.now();
    if (a === null) {
      this.stalled = m;
      return;
    }
    const b = m - a;
    if (!l && b >= _J && (this._reportStall(d), !this.media))
      return;
    const y = Tr.bufferInfo(s, o, n.maxBufferHole);
    this._tryFixBufferStall(y, b);
  }
  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(e, r) {
    const {
      config: n,
      fragmentTracker: s,
      media: a
    } = this;
    if (a === null)
      return;
    const o = a.currentTime, l = s.getPartialFragment(o);
    l && (this._trySkipBufferHole(l) || !this.media) || (e.len > n.maxBufferHole || e.nextStart && e.nextStart - o < n.maxBufferHole) && r > n.highBufferWatchdogPeriod * 1e3 && (J.warn("Trying to nudge playhead over buffer-hole"), this.stalled = null, this._tryNudgeBuffer());
  }
  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(e) {
    const {
      hls: r,
      media: n,
      stallReported: s
    } = this;
    if (!s && n) {
      this.stallReported = !0;
      const a = new Error(`Playback stalling at @${n.currentTime} due to low buffer (${JSON.stringify(e)})`);
      J.warn(a.message), r.trigger(D.ERROR, {
        type: it.MEDIA_ERROR,
        details: le.BUFFER_STALLED_ERROR,
        fatal: !1,
        error: a,
        buffer: e.len
      });
    }
  }
  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(e) {
    const {
      config: r,
      hls: n,
      media: s
    } = this;
    if (s === null)
      return 0;
    const a = s.currentTime, o = Tr.bufferInfo(s, a, 0), l = a < o.start ? o.start : o.nextStart;
    if (l) {
      const u = o.len <= r.maxBufferHole, c = o.len > 0 && o.len < 1 && s.readyState < 3, d = l - a;
      if (d > 0 && (u || c)) {
        if (d > r.maxBufferHole) {
          const {
            fragmentTracker: f
          } = this;
          let p = !1;
          if (a === 0) {
            const m = f.getAppendedFrag(0, at.MAIN);
            m && l < m.end && (p = !0);
          }
          if (!p) {
            const m = e || f.getAppendedFrag(a, at.MAIN);
            if (m) {
              let b = !1, y = m.end;
              for (; y < l; ) {
                const _ = f.getPartialFragment(y);
                if (_)
                  y += _.duration;
                else {
                  b = !0;
                  break;
                }
              }
              if (b)
                return 0;
            }
          }
        }
        const h = Math.max(l + TJ, a + wJ);
        if (J.warn(`skipping hole, adjusting currentTime from ${a} to ${h}`), this.moved = !0, this.stalled = null, s.currentTime = h, e && !e.gap) {
          const f = new Error(`fragment loaded with buffer holes, seeking from ${a} to ${h}`);
          n.trigger(D.ERROR, {
            type: it.MEDIA_ERROR,
            details: le.BUFFER_SEEK_OVER_HOLE,
            fatal: !1,
            error: f,
            reason: f.message,
            frag: e
          });
        }
        return h;
      }
    }
    return 0;
  }
  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer() {
    const {
      config: e,
      hls: r,
      media: n,
      nudgeRetry: s
    } = this;
    if (n === null)
      return;
    const a = n.currentTime;
    if (this.nudgeRetry++, s < e.nudgeMaxRetry) {
      const o = a + (s + 1) * e.nudgeOffset, l = new Error(`Nudging 'currentTime' from ${a} to ${o}`);
      J.warn(l.message), n.currentTime = o, r.trigger(D.ERROR, {
        type: it.MEDIA_ERROR,
        details: le.BUFFER_NUDGE_ON_STALL,
        error: l,
        fatal: !1
      });
    } else {
      const o = new Error(`Playhead still not moving while enough data buffered @${a} after ${e.nudgeMaxRetry} nudges`);
      J.error(o.message), r.trigger(D.ERROR, {
        type: it.MEDIA_ERROR,
        details: le.BUFFER_STALLED_ERROR,
        error: o,
        fatal: !0
      });
    }
  }
}
const SJ = 100;
class EJ extends Kk {
  constructor(e, r, n) {
    super(e, r, n, "[stream-controller]", at.MAIN), this.audioCodecSwap = !1, this.gapController = null, this.level = -1, this._forceStartLoad = !1, this.altAudio = !1, this.audioOnly = !1, this.fragPlaying = null, this.onvplaying = null, this.onvseeked = null, this.fragLastKbps = 0, this.couldBacktrack = !1, this.backtrackFragment = null, this.audioCodecSwitch = !1, this.videoBuffer = null, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(D.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(D.MANIFEST_LOADING, this.onManifestLoading, this), e.on(D.MANIFEST_PARSED, this.onManifestParsed, this), e.on(D.LEVEL_LOADING, this.onLevelLoading, this), e.on(D.LEVEL_LOADED, this.onLevelLoaded, this), e.on(D.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.on(D.ERROR, this.onError, this), e.on(D.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(D.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(D.BUFFER_CREATED, this.onBufferCreated, this), e.on(D.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(D.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(D.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(D.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(D.MANIFEST_LOADING, this.onManifestLoading, this), e.off(D.MANIFEST_PARSED, this.onManifestParsed, this), e.off(D.LEVEL_LOADED, this.onLevelLoaded, this), e.off(D.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.off(D.ERROR, this.onError, this), e.off(D.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(D.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(D.BUFFER_CREATED, this.onBufferCreated, this), e.off(D.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(D.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(D.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this._unregisterListeners(), this.onMediaDetaching();
  }
  startLoad(e) {
    if (this.levels) {
      const {
        lastCurrentTime: r,
        hls: n
      } = this;
      if (this.stopLoad(), this.setInterval(SJ), this.level = -1, !this.startFragRequested) {
        let s = n.startLevel;
        s === -1 && (n.config.testBandwidth && this.levels.length > 1 ? (s = 0, this.bitrateTest = !0) : s = n.nextAutoLevel), this.level = n.nextLoadLevel = s, this.loadedmetadata = !1;
      }
      r > 0 && e === -1 && (this.log(`Override startPosition with lastCurrentTime @${r.toFixed(3)}`), e = r), this.state = _e.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
    } else
      this._forceStartLoad = !0, this.state = _e.STOPPED;
  }
  stopLoad() {
    this._forceStartLoad = !1, super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case _e.WAITING_LEVEL: {
        var e;
        const {
          levels: n,
          level: s
        } = this, a = n == null || (e = n[s]) == null ? void 0 : e.details;
        if (a && (!a.live || this.levelLastLoaded === this.level)) {
          if (this.waitForCdnTuneIn(a))
            break;
          this.state = _e.IDLE;
          break;
        } else if (this.hls.nextLoadLevel !== this.level) {
          this.state = _e.IDLE;
          break;
        }
        break;
      }
      case _e.FRAG_LOADING_WAITING_RETRY:
        {
          var r;
          const n = self.performance.now(), s = this.retryDate;
          (!s || n >= s || (r = this.media) != null && r.seeking) && (this.resetStartWhenNotLoaded(this.level), this.state = _e.IDLE);
        }
        break;
    }
    this.state === _e.IDLE && this.doTickIdle(), this.onTickEnd();
  }
  onTickEnd() {
    super.onTickEnd(), this.checkBuffer(), this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls: e,
      levelLastLoaded: r,
      levels: n,
      media: s
    } = this, {
      config: a,
      nextLoadLevel: o
    } = e;
    if (r === null || !s && (this.startFragRequested || !a.startFragPrefetch) || this.altAudio && this.audioOnly || !(n != null && n[o]))
      return;
    const l = n[o], u = this.getMainFwdBufferInfo();
    if (u === null)
      return;
    const c = this.getLevelDetails();
    if (c && this._streamEnded(u, c)) {
      const y = {};
      this.altAudio && (y.type = "video"), this.hls.trigger(D.BUFFER_EOS, y), this.state = _e.ENDED;
      return;
    }
    e.loadLevel !== o && e.manualLevel === -1 && this.log(`Adapting to level ${o} from level ${this.level}`), this.level = e.nextLoadLevel = o;
    const d = l.details;
    if (!d || this.state === _e.WAITING_LEVEL || d.live && this.levelLastLoaded !== o) {
      this.level = o, this.state = _e.WAITING_LEVEL;
      return;
    }
    const h = u.len, f = this.getMaxBufferLength(l.maxBitrate);
    if (h >= f)
      return;
    this.backtrackFragment && this.backtrackFragment.start > u.end && (this.backtrackFragment = null);
    const p = this.backtrackFragment ? this.backtrackFragment.start : u.end;
    let m = this.getNextFragment(p, d);
    if (this.couldBacktrack && !this.fragPrevious && m && m.sn !== "initSegment" && this.fragmentTracker.getState(m) !== yn.OK) {
      var b;
      const _ = ((b = this.backtrackFragment) != null ? b : m).sn - d.startSN, x = d.fragments[_ - 1];
      x && m.cc === x.cc && (m = x, this.fragmentTracker.removeFragment(x));
    } else
      this.backtrackFragment && u.len && (this.backtrackFragment = null);
    if (m && this.isLoopLoading(m, p)) {
      if (!m.gap) {
        const _ = this.audioOnly && !this.altAudio ? or.AUDIO : or.VIDEO, x = (_ === or.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        x && this.afterBufferFlushed(x, _, at.MAIN);
      }
      m = this.getNextFragmentLoopLoading(m, d, u, at.MAIN, f);
    }
    m && (m.initSegment && !m.initSegment.data && !this.bitrateTest && (m = m.initSegment), this.loadFragment(m, l, p));
  }
  loadFragment(e, r, n) {
    const s = this.fragmentTracker.getState(e);
    this.fragCurrent = e, s === yn.NOT_LOADED || s === yn.PARTIAL ? e.sn === "initSegment" ? this._loadInitSegment(e, r) : this.bitrateTest ? (this.log(`Fragment ${e.sn} of level ${e.level} is being downloaded to test bitrate and will not be buffered`), this._loadBitrateTestFrag(e, r)) : (this.startFragRequested = !0, super.loadFragment(e, r, n)) : this.clearTrackerIfNeeded(e);
  }
  getBufferedFrag(e) {
    return this.fragmentTracker.getBufferedFrag(e, at.MAIN);
  }
  followingBufferedFrag(e) {
    return e ? this.getBufferedFrag(e.end + 0.5) : null;
  }
  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }
  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels: e,
      media: r
    } = this;
    if (r != null && r.readyState) {
      let n;
      const s = this.getAppendedFrag(r.currentTime);
      s && s.start > 1 && this.flushMainBuffer(0, s.start - 1);
      const a = this.getLevelDetails();
      if (a != null && a.live) {
        const l = this.getMainFwdBufferInfo();
        if (!l || l.len < a.targetduration * 2)
          return;
      }
      if (!r.paused && e) {
        const l = this.hls.nextLoadLevel, u = e[l], c = this.fragLastKbps;
        c && this.fragCurrent ? n = this.fragCurrent.duration * u.maxBitrate / (1e3 * c) + 1 : n = 0;
      } else
        n = 0;
      const o = this.getBufferedFrag(r.currentTime + n);
      if (o) {
        const l = this.followingBufferedFrag(o);
        if (l) {
          this.abortCurrentFrag();
          const u = l.maxStartPTS ? l.maxStartPTS : l.start, c = l.duration, d = Math.max(o.end, u + Math.min(Math.max(c - this.config.maxFragLookUpTolerance, c * 0.5), c * 0.75));
          this.flushMainBuffer(d, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const e = this.fragCurrent;
    switch (this.fragCurrent = null, this.backtrackFragment = null, e && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.state) {
      case _e.KEY_LOADING:
      case _e.FRAG_LOADING:
      case _e.FRAG_LOADING_WAITING_RETRY:
      case _e.PARSING:
      case _e.PARSED:
        this.state = _e.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(e, r) {
    super.flushMainBuffer(e, r, this.altAudio ? "video" : null);
  }
  onMediaAttached(e, r) {
    super.onMediaAttached(e, r);
    const n = r.media;
    this.onvplaying = this.onMediaPlaying.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), n.addEventListener("playing", this.onvplaying), n.addEventListener("seeked", this.onvseeked), this.gapController = new xJ(this.config, n, this.fragmentTracker, this.hls);
  }
  onMediaDetaching() {
    const {
      media: e
    } = this;
    e && this.onvplaying && this.onvseeked && (e.removeEventListener("playing", this.onvplaying), e.removeEventListener("seeked", this.onvseeked), this.onvplaying = this.onvseeked = null, this.videoBuffer = null), this.fragPlaying = null, this.gapController && (this.gapController.destroy(), this.gapController = null), super.onMediaDetaching();
  }
  onMediaPlaying() {
    this.tick();
  }
  onMediaSeeked() {
    const e = this.media, r = e ? e.currentTime : null;
    et(r) && this.log(`Media seeked to ${r.toFixed(3)}`);
    const n = this.getMainFwdBufferInfo();
    if (n === null || n.len === 0) {
      this.warn(`Main forward buffer length on "seeked" event ${n ? n.len : "empty"})`);
      return;
    }
    this.tick();
  }
  onManifestLoading() {
    this.log("Trigger BUFFER_RESET"), this.hls.trigger(D.BUFFER_RESET, void 0), this.fragmentTracker.removeAllFragments(), this.couldBacktrack = !1, this.startPosition = this.lastCurrentTime = 0, this.levels = this.fragPlaying = this.backtrackFragment = null, this.altAudio = this.audioOnly = !1;
  }
  onManifestParsed(e, r) {
    let n = !1, s = !1, a;
    r.levels.forEach((o) => {
      a = o.audioCodec, a && (a.indexOf("mp4a.40.2") !== -1 && (n = !0), a.indexOf("mp4a.40.5") !== -1 && (s = !0));
    }), this.audioCodecSwitch = n && s && !BZ(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = r.levels, this.startFragRequested = !1;
  }
  onLevelLoading(e, r) {
    const {
      levels: n
    } = this;
    if (!n || this.state !== _e.IDLE)
      return;
    const s = n[r.level];
    (!s.details || s.details.live && this.levelLastLoaded !== r.level || this.waitForCdnTuneIn(s.details)) && (this.state = _e.WAITING_LEVEL);
  }
  onLevelLoaded(e, r) {
    var n;
    const {
      levels: s
    } = this, a = r.level, o = r.details, l = o.totalduration;
    if (!s) {
      this.warn(`Levels were reset while loading level ${a}`);
      return;
    }
    this.log(`Level ${a} loaded [${o.startSN},${o.endSN}]${o.lastPartSn ? `[part-${o.lastPartSn}-${o.lastPartIndex}]` : ""}, cc [${o.startCC}, ${o.endCC}] duration:${l}`);
    const u = s[a], c = this.fragCurrent;
    c && (this.state === _e.FRAG_LOADING || this.state === _e.FRAG_LOADING_WAITING_RETRY) && (c.level !== r.level || c.urlId !== u.urlId) && c.loader && this.abortCurrentFrag();
    let d = 0;
    if (o.live || (n = u.details) != null && n.live) {
      if (o.fragments[0] || (o.deltaUpdateFailed = !0), o.deltaUpdateFailed)
        return;
      d = this.alignPlaylists(o, u.details);
    }
    if (u.details = o, this.levelLastLoaded = a, this.hls.trigger(D.LEVEL_UPDATED, {
      details: o,
      level: a
    }), this.state === _e.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(o))
        return;
      this.state = _e.IDLE;
    }
    this.startFragRequested ? o.live && this.synchronizeToLiveEdge(o) : this.setStartPosition(o, d), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var r;
    const {
      frag: n,
      part: s,
      payload: a
    } = e, {
      levels: o
    } = this;
    if (!o) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${n.sn} of level ${n.level} will not be buffered`);
      return;
    }
    const l = o[n.level], u = l.details;
    if (!u) {
      this.warn(`Dropping fragment ${n.sn} of level ${n.level} after level details were reset`), this.fragmentTracker.removeFragment(n);
      return;
    }
    const c = l.videoCodec, d = u.PTSKnown || !u.live, h = (r = n.initSegment) == null ? void 0 : r.data, f = this._getAudioCodec(l), p = this.transmuxer = this.transmuxer || new NU(this.hls, at.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)), m = s ? s.index : -1, b = m !== -1, y = new Gk(n.level, n.sn, n.stats.chunkCount, a.byteLength, m, b), _ = this.initPTS[n.cc];
    p.push(a, h, f, c, n, s, u.totalduration, d, y, _);
  }
  onAudioTrackSwitching(e, r) {
    const n = this.altAudio;
    if (!!!r.url) {
      if (this.mediaBuffer !== this.media) {
        this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
        const o = this.fragCurrent;
        o && (this.log("Switching to main audio track, cancel main fragment load"), o.abortRequests(), this.fragmentTracker.removeFragment(o)), this.resetTransmuxer(), this.resetLoadingState();
      } else
        this.audioOnly && this.resetTransmuxer();
      const a = this.hls;
      n && (a.trigger(D.BUFFER_FLUSHING, {
        startOffset: 0,
        endOffset: Number.POSITIVE_INFINITY,
        type: null
      }), this.fragmentTracker.removeAllFragments()), a.trigger(D.AUDIO_TRACK_SWITCHED, r);
    }
  }
  onAudioTrackSwitched(e, r) {
    const n = r.id, s = !!this.hls.audioTracks[n].url;
    if (s) {
      const a = this.videoBuffer;
      a && this.mediaBuffer !== a && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = a);
    }
    this.altAudio = s, this.tick();
  }
  onBufferCreated(e, r) {
    const n = r.tracks;
    let s, a, o = !1;
    for (const l in n) {
      const u = n[l];
      if (u.id === "main") {
        if (a = l, s = u, l === "video") {
          const c = n[l];
          c && (this.videoBuffer = c.buffer);
        }
      } else
        o = !0;
    }
    o && s ? (this.log(`Alternate track found, use ${a}.buffered to schedule main fragment loading`), this.mediaBuffer = s.buffer) : this.mediaBuffer = this.media;
  }
  onFragBuffered(e, r) {
    const {
      frag: n,
      part: s
    } = r;
    if (n && n.type !== at.MAIN)
      return;
    if (this.fragContextChanged(n)) {
      this.warn(`Fragment ${n.sn}${s ? " p: " + s.index : ""} of level ${n.level} finished buffering, but was aborted. state: ${this.state}`), this.state === _e.PARSED && (this.state = _e.IDLE);
      return;
    }
    const a = s ? s.stats : n.stats;
    this.fragLastKbps = Math.round(8 * a.total / (a.buffering.end - a.loading.first)), n.sn !== "initSegment" && (this.fragPrevious = n), this.fragBufferedComplete(n, s);
  }
  onError(e, r) {
    var n;
    if (r.fatal) {
      this.state = _e.ERROR;
      return;
    }
    switch (r.details) {
      case le.FRAG_GAP:
      case le.FRAG_PARSING_ERROR:
      case le.FRAG_DECRYPT_ERROR:
      case le.FRAG_LOAD_ERROR:
      case le.FRAG_LOAD_TIMEOUT:
      case le.KEY_LOAD_ERROR:
      case le.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(at.MAIN, r);
        break;
      case le.LEVEL_LOAD_ERROR:
      case le.LEVEL_LOAD_TIMEOUT:
      case le.LEVEL_PARSING_ERROR:
        !r.levelRetry && this.state === _e.WAITING_LEVEL && ((n = r.context) == null ? void 0 : n.type) === Vt.LEVEL && (this.state = _e.IDLE);
        break;
      case le.BUFFER_FULL_ERROR:
        if (!r.parent || r.parent !== "main")
          return;
        this.reduceLengthAndFlushBuffer(r) && this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
        break;
      case le.INTERNAL_EXCEPTION:
        this.recoverWorkerError(r);
        break;
    }
  }
  // Checks the health of the buffer and attempts to resolve playback stalls.
  checkBuffer() {
    const {
      media: e,
      gapController: r
    } = this;
    if (!(!e || !r || !e.readyState)) {
      if (this.loadedmetadata || !Tr.getBuffered(e).length) {
        const n = this.state !== _e.IDLE ? this.fragCurrent : null;
        r.poll(this.lastCurrentTime, n);
      }
      this.lastCurrentTime = e.currentTime;
    }
  }
  onFragLoadEmergencyAborted() {
    this.state = _e.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tickImmediate();
  }
  onBufferFlushed(e, {
    type: r
  }) {
    if (r !== or.AUDIO || this.audioOnly && !this.altAudio) {
      const n = (r === or.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      this.afterBufferFlushed(n, r, at.MAIN);
    }
  }
  onLevelsUpdated(e, r) {
    this.levels = r.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }
  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const r = e.currentTime;
    let n = this.startPosition;
    if (n >= 0 && r < n) {
      if (e.seeking) {
        this.log(`could not seek to ${n}, already seeking at ${r}`);
        return;
      }
      const s = Tr.getBuffered(e), o = (s.length ? s.start(0) : 0) - n;
      o > 0 && (o < this.config.maxBufferHole || o < this.config.maxFragLookUpTolerance) && (this.log(`adjusting start position by ${o} to match buffer start`), n += o, this.startPosition = n), this.log(`seek to target start position ${n} from current time ${r}`), e.currentTime = n;
    }
  }
  _getAudioCodec(e) {
    let r = this.config.defaultAudioCodec || e.audioCodec;
    return this.audioCodecSwap && r && (this.log("Swapping audio codec"), r.indexOf("mp4a.40.5") !== -1 ? r = "mp4a.40.2" : r = "mp4a.40.5"), r;
  }
  _loadBitrateTestFrag(e, r) {
    e.bitrateTest = !0, this._doFragLoad(e, r).then((n) => {
      const {
        hls: s
      } = this;
      if (!n || this.fragContextChanged(e))
        return;
      r.fragmentError = 0, this.state = _e.IDLE, this.startFragRequested = !1, this.bitrateTest = !1;
      const a = e.stats;
      a.parsing.start = a.parsing.end = a.buffering.start = a.buffering.end = self.performance.now(), s.trigger(D.FRAG_LOADED, n), e.bitrateTest = !1;
    });
  }
  _handleTransmuxComplete(e) {
    var r;
    const n = "main", {
      hls: s
    } = this, {
      remuxResult: a,
      chunkMeta: o
    } = e, l = this.getCurrentContext(o);
    if (!l) {
      this.resetWhenMissingContext(o);
      return;
    }
    const {
      frag: u,
      part: c,
      level: d
    } = l, {
      video: h,
      text: f,
      id3: p,
      initSegment: m
    } = a, {
      details: b
    } = d, y = this.altAudio ? void 0 : a.audio;
    if (this.fragContextChanged(u)) {
      this.fragmentTracker.removeFragment(u);
      return;
    }
    if (this.state = _e.PARSING, m) {
      if (m != null && m.tracks) {
        const T = u.initSegment || u;
        this._bufferInitSegment(d, m.tracks, T, o), s.trigger(D.FRAG_PARSING_INIT_SEGMENT, {
          frag: T,
          id: n,
          tracks: m.tracks
        });
      }
      const _ = m.initPTS, x = m.timescale;
      et(_) && (this.initPTS[u.cc] = {
        baseTime: _,
        timescale: x
      }, s.trigger(D.INIT_PTS_FOUND, {
        frag: u,
        id: n,
        initPTS: _,
        timescale: x
      }));
    }
    if (h && b && u.sn !== "initSegment") {
      const _ = b.fragments[u.sn - 1 - b.startSN], x = u.sn === b.startSN, T = !_ || u.cc > _.cc;
      if (a.independent !== !1) {
        const {
          startPTS: k,
          endPTS: E,
          startDTS: F,
          endDTS: R
        } = h;
        if (c)
          c.elementaryStreams[h.type] = {
            startPTS: k,
            endPTS: E,
            startDTS: F,
            endDTS: R
          };
        else if (h.firstKeyFrame && h.independent && o.id === 1 && !T && (this.couldBacktrack = !0), h.dropped && h.independent) {
          const $ = this.getMainFwdBufferInfo(), O = ($ ? $.end : this.getLoadPosition()) + this.config.maxBufferHole, P = h.firstKeyFramePTS ? h.firstKeyFramePTS : k;
          if (!x && O < P - this.config.maxBufferHole && !T) {
            this.backtrack(u);
            return;
          } else
            T && (u.gap = !0);
          u.setElementaryStreamInfo(h.type, u.start, E, u.start, R, !0);
        }
        u.setElementaryStreamInfo(h.type, k, E, F, R), this.backtrackFragment && (this.backtrackFragment = u), this.bufferFragmentData(h, u, c, o, x || T);
      } else if (x || T)
        u.gap = !0;
      else {
        this.backtrack(u);
        return;
      }
    }
    if (y) {
      const {
        startPTS: _,
        endPTS: x,
        startDTS: T,
        endDTS: k
      } = y;
      c && (c.elementaryStreams[or.AUDIO] = {
        startPTS: _,
        endPTS: x,
        startDTS: T,
        endDTS: k
      }), u.setElementaryStreamInfo(or.AUDIO, _, x, T, k), this.bufferFragmentData(y, u, c, o);
    }
    if (b && p != null && (r = p.samples) != null && r.length) {
      const _ = {
        id: n,
        frag: u,
        details: b,
        samples: p.samples
      };
      s.trigger(D.FRAG_PARSING_METADATA, _);
    }
    if (b && f) {
      const _ = {
        id: n,
        frag: u,
        details: b,
        samples: f.samples
      };
      s.trigger(D.FRAG_PARSING_USERDATA, _);
    }
  }
  _bufferInitSegment(e, r, n, s) {
    if (this.state !== _e.PARSING)
      return;
    this.audioOnly = !!r.audio && !r.video, this.altAudio && !this.audioOnly && delete r.audio;
    const {
      audio: a,
      video: o,
      audiovideo: l
    } = r;
    if (a) {
      let u = e.audioCodec;
      const c = navigator.userAgent.toLowerCase();
      this.audioCodecSwitch && (u && (u.indexOf("mp4a.40.5") !== -1 ? u = "mp4a.40.2" : u = "mp4a.40.5"), a.metadata.channelCount !== 1 && c.indexOf("firefox") === -1 && (u = "mp4a.40.5")), c.indexOf("android") !== -1 && a.container !== "audio/mpeg" && (u = "mp4a.40.2", this.log(`Android: force audio codec to ${u}`)), e.audioCodec && e.audioCodec !== u && this.log(`Swapping manifest audio codec "${e.audioCodec}" for "${u}"`), a.levelCodec = u, a.id = "main", this.log(`Init audio buffer, container:${a.container}, codecs[selected/level/parsed]=[${u || ""}/${e.audioCodec || ""}/${a.codec}]`);
    }
    o && (o.levelCodec = e.videoCodec, o.id = "main", this.log(`Init video buffer, container:${o.container}, codecs[level/parsed]=[${e.videoCodec || ""}/${o.codec}]`)), l && this.log(`Init audiovideo buffer, container:${l.container}, codecs[level/parsed]=[${e.attrs.CODECS || ""}/${l.codec}]`), this.hls.trigger(D.BUFFER_CODECS, r), Object.keys(r).forEach((u) => {
      const d = r[u].initSegment;
      d != null && d.byteLength && this.hls.trigger(D.BUFFER_APPENDING, {
        type: u,
        data: d,
        frag: n,
        part: null,
        chunkMeta: s,
        parent: n.type
      });
    }), this.tick();
  }
  getMainFwdBufferInfo() {
    return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, at.MAIN);
  }
  backtrack(e) {
    this.couldBacktrack = !0, this.backtrackFragment = e, this.resetTransmuxer(), this.flushBufferGap(e), this.fragmentTracker.removeFragment(e), this.fragPrevious = null, this.nextLoadPosition = e.start, this.state = _e.IDLE;
  }
  checkFragmentChanged() {
    const e = this.media;
    let r = null;
    if (e && e.readyState > 1 && e.seeking === !1) {
      const n = e.currentTime;
      if (Tr.isBuffered(e, n) ? r = this.getAppendedFrag(n) : Tr.isBuffered(e, n + 0.1) && (r = this.getAppendedFrag(n + 0.1)), r) {
        this.backtrackFragment = null;
        const s = this.fragPlaying, a = r.level;
        (!s || r.sn !== s.sn || s.level !== a || r.urlId !== s.urlId) && (this.fragPlaying = r, this.hls.trigger(D.FRAG_CHANGED, {
          frag: r
        }), (!s || s.level !== a) && this.hls.trigger(D.LEVEL_SWITCHED, {
          level: a
        }));
      }
    }
  }
  get nextLevel() {
    const e = this.nextBufferedFrag;
    return e ? e.level : -1;
  }
  get currentFrag() {
    const e = this.media;
    return e ? this.fragPlaying || this.getAppendedFrag(e.currentTime) : null;
  }
  get currentProgramDateTime() {
    const e = this.media;
    if (e) {
      const r = e.currentTime, n = this.currentFrag;
      if (n && et(r) && et(n.programDateTime)) {
        const s = n.programDateTime + (r - n.start) * 1e3;
        return new Date(s);
      }
    }
    return null;
  }
  get currentLevel() {
    const e = this.currentFrag;
    return e ? e.level : -1;
  }
  get nextBufferedFrag() {
    const e = this.currentFrag;
    return e ? this.followingBufferedFrag(e) : null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}
class Cc {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(e, r = 0, n = 0) {
    this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = e, this.alpha_ = e ? Math.exp(Math.log(0.5) / e) : 0, this.estimate_ = r, this.totalWeight_ = n;
  }
  sample(e, r) {
    const n = Math.pow(this.alpha_, e);
    this.estimate_ = r * (1 - n) + n * this.estimate_, this.totalWeight_ += e;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const e = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (e)
        return this.estimate_ / e;
    }
    return this.estimate_;
  }
}
class $J {
  constructor(e, r, n, s = 100) {
    this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultTTFB_ = void 0, this.ttfb_ = void 0, this.defaultEstimate_ = n, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new Cc(e), this.fast_ = new Cc(r), this.defaultTTFB_ = s, this.ttfb_ = new Cc(e);
  }
  update(e, r) {
    const {
      slow_: n,
      fast_: s,
      ttfb_: a
    } = this;
    n.halfLife !== e && (this.slow_ = new Cc(e, n.getEstimate(), n.getTotalWeight())), s.halfLife !== r && (this.fast_ = new Cc(r, s.getEstimate(), s.getTotalWeight())), a.halfLife !== e && (this.ttfb_ = new Cc(e, a.getEstimate(), a.getTotalWeight()));
  }
  sample(e, r) {
    e = Math.max(e, this.minDelayMs_);
    const n = 8 * r, s = e / 1e3, a = n / s;
    this.fast_.sample(s, a), this.slow_.sample(s, a);
  }
  sampleTTFB(e) {
    const r = e / 1e3, n = Math.sqrt(2) * Math.exp(-Math.pow(r, 2) / 2);
    this.ttfb_.sample(n, Math.max(e, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
  }
  getEstimateTTFB() {
    return this.ttfb_.getTotalWeight() >= this.minWeight_ ? this.ttfb_.getEstimate() : this.defaultTTFB_;
  }
  destroy() {
  }
}
class kJ {
  constructor(e) {
    this.hls = void 0, this.lastLevelLoadSec = 0, this.lastLoadedFragLevel = 0, this._nextAutoLevel = -1, this.timer = -1, this.onCheck = this._abandonRulesCheck.bind(this), this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.bwEstimator = void 0, this.hls = e;
    const r = e.config;
    this.bwEstimator = new $J(r.abrEwmaSlowVoD, r.abrEwmaFastVoD, r.abrEwmaDefaultEstimate), this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(D.FRAG_LOADING, this.onFragLoading, this), e.on(D.FRAG_LOADED, this.onFragLoaded, this), e.on(D.FRAG_BUFFERED, this.onFragBuffered, this), e.on(D.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(D.LEVEL_LOADED, this.onLevelLoaded, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(D.FRAG_LOADING, this.onFragLoading, this), e.off(D.FRAG_LOADED, this.onFragLoaded, this), e.off(D.FRAG_BUFFERED, this.onFragBuffered, this), e.off(D.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(D.LEVEL_LOADED, this.onLevelLoaded, this);
  }
  destroy() {
    this.unregisterListeners(), this.clearTimer(), this.hls = this.onCheck = null, this.fragCurrent = this.partCurrent = null;
  }
  onFragLoading(e, r) {
    var n;
    const s = r.frag;
    this.ignoreFragment(s) || (this.fragCurrent = s, this.partCurrent = (n = r.part) != null ? n : null, this.clearTimer(), this.timer = self.setInterval(this.onCheck, 100));
  }
  onLevelSwitching(e, r) {
    this.clearTimer();
  }
  getTimeToLoadFrag(e, r, n, s) {
    const a = e + n / r, o = s ? this.lastLevelLoadSec : 0;
    return a + o;
  }
  onLevelLoaded(e, r) {
    const n = this.hls.config, {
      total: s,
      bwEstimate: a
    } = r.stats;
    et(s) && et(a) && (this.lastLevelLoadSec = 8 * s / a), r.details.live ? this.bwEstimator.update(n.abrEwmaSlowLive, n.abrEwmaFastLive) : this.bwEstimator.update(n.abrEwmaSlowVoD, n.abrEwmaFastVoD);
  }
  /*
      This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
      quickly enough to prevent underbuffering
    */
  _abandonRulesCheck() {
    const {
      fragCurrent: e,
      partCurrent: r,
      hls: n
    } = this, {
      autoLevelEnabled: s,
      media: a
    } = n;
    if (!e || !a)
      return;
    const o = performance.now(), l = r ? r.stats : e.stats, u = r ? r.duration : e.duration, c = o - l.loading.start;
    if (l.aborted || l.loaded && l.loaded === l.total || e.level === 0) {
      this.clearTimer(), this._nextAutoLevel = -1;
      return;
    }
    if (!s || a.paused || !a.playbackRate || !a.readyState)
      return;
    const d = n.mainForwardBufferInfo;
    if (d === null)
      return;
    const h = this.bwEstimator.getEstimateTTFB(), f = Math.abs(a.playbackRate);
    if (c <= Math.max(h, 1e3 * (u / (f * 2))))
      return;
    const p = d.len / f;
    if (p >= 2 * u / f)
      return;
    const m = l.loading.first ? l.loading.first - l.loading.start : -1, b = l.loaded && m > -1, y = this.bwEstimator.getEstimate(), {
      levels: _,
      minAutoLevel: x
    } = n, T = _[e.level], k = l.total || Math.max(l.loaded, Math.round(u * T.maxBitrate / 8));
    let E = c - m;
    E < 1 && b && (E = Math.min(c, l.loaded * 8 / y));
    const F = b ? l.loaded * 1e3 / E : 0, R = F ? (k - l.loaded) / F : k * 8 / y + h / 1e3;
    if (R <= p)
      return;
    const $ = F ? F * 8 : y;
    let O = Number.POSITIVE_INFINITY, P;
    for (P = e.level - 1; P > x; P--) {
      const N = _[P].maxBitrate;
      if (O = this.getTimeToLoadFrag(h / 1e3, $, u * N, !_[P].details), O < p)
        break;
    }
    O >= R || O > u * 10 || (n.nextLoadLevel = P, b ? this.bwEstimator.sample(c - Math.min(h, m), l.loaded) : this.bwEstimator.sampleTTFB(c), this.clearTimer(), J.warn(`[abr] Fragment ${e.sn}${r ? " part " + r.index : ""} of level ${e.level} is loading too slowly;
      Time to underbuffer: ${p.toFixed(3)} s
      Estimated load time for current fragment: ${R.toFixed(3)} s
      Estimated load time for down switch fragment: ${O.toFixed(3)} s
      TTFB estimate: ${m}
      Current BW estimate: ${et(y) ? (y / 1024).toFixed(3) : "Unknown"} Kb/s
      New BW estimate: ${(this.bwEstimator.getEstimate() / 1024).toFixed(3)} Kb/s
      Aborting and switching to level ${P}`), e.loader && (this.fragCurrent = this.partCurrent = null, e.abortRequests()), n.trigger(D.FRAG_LOAD_EMERGENCY_ABORTED, {
      frag: e,
      part: r,
      stats: l
    }));
  }
  onFragLoaded(e, {
    frag: r,
    part: n
  }) {
    const s = n ? n.stats : r.stats;
    if (r.type === at.MAIN && this.bwEstimator.sampleTTFB(s.loading.first - s.loading.start), !this.ignoreFragment(r)) {
      if (this.clearTimer(), this.lastLoadedFragLevel = r.level, this._nextAutoLevel = -1, this.hls.config.abrMaxWithRealBitrate) {
        const a = n ? n.duration : r.duration, o = this.hls.levels[r.level], l = (o.loaded ? o.loaded.bytes : 0) + s.loaded, u = (o.loaded ? o.loaded.duration : 0) + a;
        o.loaded = {
          bytes: l,
          duration: u
        }, o.realBitrate = Math.round(8 * l / u);
      }
      if (r.bitrateTest) {
        const a = {
          stats: s,
          frag: r,
          part: n,
          id: r.type
        };
        this.onFragBuffered(D.FRAG_BUFFERED, a), r.bitrateTest = !1;
      }
    }
  }
  onFragBuffered(e, r) {
    const {
      frag: n,
      part: s
    } = r, a = s != null && s.stats.loaded ? s.stats : n.stats;
    if (a.aborted || this.ignoreFragment(n))
      return;
    const o = a.parsing.end - a.loading.start - Math.min(a.loading.first - a.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(o, a.loaded), a.bwEstimate = this.bwEstimator.getEstimate(), n.bitrateTest ? this.bitrateTestDelay = o / 1e3 : this.bitrateTestDelay = 0;
  }
  ignoreFragment(e) {
    return e.type !== at.MAIN || e.sn === "initSegment";
  }
  clearTimer() {
    self.clearInterval(this.timer);
  }
  // return next auto level
  get nextAutoLevel() {
    const e = this._nextAutoLevel, r = this.bwEstimator;
    if (e !== -1 && !r.canEstimate())
      return e;
    let n = this.getNextABRAutoLevel();
    if (e !== -1) {
      const s = this.hls.levels;
      if (s.length > Math.max(e, n) && s[e].loadError <= s[n].loadError)
        return e;
    }
    return e !== -1 && (n = Math.min(e, n)), n;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent: e,
      partCurrent: r,
      hls: n
    } = this, {
      maxAutoLevel: s,
      config: a,
      minAutoLevel: o,
      media: l
    } = n, u = r ? r.duration : e ? e.duration : 0, c = l && l.playbackRate !== 0 ? Math.abs(l.playbackRate) : 1, d = this.bwEstimator ? this.bwEstimator.getEstimate() : a.abrEwmaDefaultEstimate, h = n.mainForwardBufferInfo, f = (h ? h.len : 0) / c;
    let p = this.findBestLevel(d, o, s, f, a.abrBandWidthFactor, a.abrBandWidthUpFactor);
    if (p >= 0)
      return p;
    J.trace(`[abr] ${f ? "rebuffering expected" : "buffer is empty"}, finding optimal quality level`);
    let m = u ? Math.min(u, a.maxStarvationDelay) : a.maxStarvationDelay, b = a.abrBandWidthFactor, y = a.abrBandWidthUpFactor;
    if (!f) {
      const _ = this.bitrateTestDelay;
      _ && (m = (u ? Math.min(u, a.maxLoadingDelay) : a.maxLoadingDelay) - _, J.trace(`[abr] bitrate test took ${Math.round(1e3 * _)}ms, set first fragment max fetchDuration to ${Math.round(1e3 * m)} ms`), b = y = 1);
    }
    return p = this.findBestLevel(d, o, s, f + m, b, y), Math.max(p, 0);
  }
  findBestLevel(e, r, n, s, a, o) {
    var l;
    const {
      fragCurrent: u,
      partCurrent: c,
      lastLoadedFragLevel: d
    } = this, {
      levels: h
    } = this.hls, f = h[d], p = !!(f != null && (l = f.details) != null && l.live), m = f == null ? void 0 : f.codecSet, b = c ? c.duration : u ? u.duration : 0, y = this.bwEstimator.getEstimateTTFB() / 1e3;
    let _ = r, x = -1;
    for (let T = n; T >= r; T--) {
      const k = h[T];
      if (!k || m && k.codecSet !== m) {
        k && (_ = Math.min(T, _), x = Math.max(T, x));
        continue;
      }
      x !== -1 && J.trace(`[abr] Skipped level(s) ${_}-${x} with CODECS:"${h[x].attrs.CODECS}"; not compatible with "${f.attrs.CODECS}"`);
      const E = k.details, F = (c ? E == null ? void 0 : E.partTarget : E == null ? void 0 : E.averagetargetduration) || b;
      let R;
      T <= d ? R = a * e : R = o * e;
      const $ = h[T].maxBitrate, O = this.getTimeToLoadFrag(y, R, $ * F, E === void 0);
      if (J.trace(`[abr] level:${T} adjustedbw-bitrate:${Math.round(R - $)} avgDuration:${F.toFixed(1)} maxFetchDuration:${s.toFixed(1)} fetchDuration:${O.toFixed(1)}`), R > $ && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
      // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
      // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
      (O === 0 || !et(O) || p && !this.bitrateTestDelay || O < s))
        return T;
    }
    return -1;
  }
  set nextAutoLevel(e) {
    this._nextAutoLevel = e;
  }
}
class FU {
  constructor() {
    this.chunks = [], this.dataLength = 0;
  }
  push(e) {
    this.chunks.push(e), this.dataLength += e.length;
  }
  flush() {
    const {
      chunks: e,
      dataLength: r
    } = this;
    let n;
    if (e.length)
      e.length === 1 ? n = e[0] : n = DJ(e, r);
    else
      return new Uint8Array(0);
    return this.reset(), n;
  }
  reset() {
    this.chunks.length = 0, this.dataLength = 0;
  }
}
function DJ(t, e) {
  const r = new Uint8Array(e);
  let n = 0;
  for (let s = 0; s < t.length; s++) {
    const a = t[s];
    r.set(a, n), n += a.length;
  }
  return r;
}
const eP = 100;
class OJ extends Kk {
  constructor(e, r, n) {
    super(e, r, n, "[audio-stream-controller]", at.AUDIO), this.videoBuffer = null, this.videoTrackCC = -1, this.waitingVideoCC = -1, this.bufferedTrack = null, this.switchingTrack = null, this.trackId = -1, this.waitingData = null, this.mainDetails = null, this.bufferFlushed = !1, this.cachedTrackLoadedData = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), this.mainDetails = null, this.bufferedTrack = null, this.switchingTrack = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(D.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(D.MANIFEST_LOADING, this.onManifestLoading, this), e.on(D.LEVEL_LOADED, this.onLevelLoaded, this), e.on(D.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.on(D.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(D.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(D.ERROR, this.onError, this), e.on(D.BUFFER_RESET, this.onBufferReset, this), e.on(D.BUFFER_CREATED, this.onBufferCreated, this), e.on(D.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(D.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(D.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(D.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(D.MANIFEST_LOADING, this.onManifestLoading, this), e.off(D.LEVEL_LOADED, this.onLevelLoaded, this), e.off(D.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.off(D.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(D.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(D.ERROR, this.onError, this), e.off(D.BUFFER_RESET, this.onBufferReset, this), e.off(D.BUFFER_CREATED, this.onBufferCreated, this), e.off(D.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(D.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(D.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(e, {
    frag: r,
    id: n,
    initPTS: s,
    timescale: a
  }) {
    if (n === "main") {
      const o = r.cc;
      this.initPTS[r.cc] = {
        baseTime: s,
        timescale: a
      }, this.log(`InitPTS for cc: ${o} found from main: ${s}`), this.videoTrackCC = o, this.state === _e.WAITING_INIT_PTS && this.tick();
    }
  }
  startLoad(e) {
    if (!this.levels) {
      this.startPosition = e, this.state = _e.STOPPED;
      return;
    }
    const r = this.lastCurrentTime;
    this.stopLoad(), this.setInterval(eP), r > 0 && e === -1 ? (this.log(`Override startPosition with lastCurrentTime @${r.toFixed(3)}`), e = r, this.state = _e.IDLE) : (this.loadedmetadata = !1, this.state = _e.WAITING_TRACK), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
  }
  doTick() {
    switch (this.state) {
      case _e.IDLE:
        this.doTickIdle();
        break;
      case _e.WAITING_TRACK: {
        var e;
        const {
          levels: n,
          trackId: s
        } = this, a = n == null || (e = n[s]) == null ? void 0 : e.details;
        if (a) {
          if (this.waitForCdnTuneIn(a))
            break;
          this.state = _e.WAITING_INIT_PTS;
        }
        break;
      }
      case _e.FRAG_LOADING_WAITING_RETRY: {
        var r;
        const n = performance.now(), s = this.retryDate;
        (!s || n >= s || (r = this.media) != null && r.seeking) && (this.log("RetryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded(this.trackId), this.state = _e.IDLE);
        break;
      }
      case _e.WAITING_INIT_PTS: {
        const n = this.waitingData;
        if (n) {
          const {
            frag: s,
            part: a,
            cache: o,
            complete: l
          } = n;
          if (this.initPTS[s.cc] !== void 0) {
            this.waitingData = null, this.waitingVideoCC = -1, this.state = _e.FRAG_LOADING;
            const u = o.flush(), c = {
              frag: s,
              part: a,
              payload: u,
              networkDetails: null
            };
            this._handleFragmentLoadProgress(c), l && super._handleFragmentLoadComplete(c);
          } else if (this.videoTrackCC !== this.waitingVideoCC)
            this.log(`Waiting fragment cc (${s.cc}) cancelled because video is at cc ${this.videoTrackCC}`), this.clearWaitingFragment();
          else {
            const u = this.getLoadPosition(), c = Tr.bufferInfo(this.mediaBuffer, u, this.config.maxBufferHole);
            rx(c.end, this.config.maxFragLookUpTolerance, s) < 0 && (this.log(`Waiting fragment cc (${s.cc}) @ ${s.start} cancelled because another fragment at ${c.end} is needed`), this.clearWaitingFragment());
          }
        } else
          this.state = _e.IDLE;
      }
    }
    this.onTickEnd();
  }
  clearWaitingFragment() {
    const e = this.waitingData;
    e && (this.fragmentTracker.removeFragment(e.frag), this.waitingData = null, this.waitingVideoCC = -1, this.state = _e.IDLE);
  }
  resetLoadingState() {
    this.clearWaitingFragment(), super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media: e
    } = this;
    e != null && e.readyState && (this.lastCurrentTime = e.currentTime);
  }
  doTickIdle() {
    const {
      hls: e,
      levels: r,
      media: n,
      trackId: s
    } = this, a = e.config;
    if (!(r != null && r[s]) || !n && (this.startFragRequested || !a.startFragPrefetch))
      return;
    const o = r[s], l = o.details;
    if (!l || l.live && this.levelLastLoaded !== s || this.waitForCdnTuneIn(l)) {
      this.state = _e.WAITING_TRACK;
      return;
    }
    const u = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.bufferFlushed && u && (this.bufferFlushed = !1, this.afterBufferFlushed(u, or.AUDIO, at.AUDIO));
    const c = this.getFwdBufferInfo(u, at.AUDIO);
    if (c === null)
      return;
    const {
      bufferedTrack: d,
      switchingTrack: h
    } = this;
    if (!h && this._streamEnded(c, l)) {
      e.trigger(D.BUFFER_EOS, {
        type: "audio"
      }), this.state = _e.ENDED;
      return;
    }
    const f = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, at.MAIN), p = c.len, m = this.getMaxBufferLength(f == null ? void 0 : f.len);
    if (p >= m && !h)
      return;
    const y = l.fragments[0].start;
    let _ = c.end;
    if (h && n) {
      const E = this.getLoadPosition();
      d && h.attrs !== d.attrs && (_ = E), l.PTSKnown && E < y && (c.end > y || c.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), n.currentTime = y + 0.05);
    }
    let x = this.getNextFragment(_, l), T = !1;
    if (x && this.isLoopLoading(x, _) && (T = !!x.gap, x = this.getNextFragmentLoopLoading(x, l, c, at.MAIN, m)), !x) {
      this.bufferFlushed = !0;
      return;
    }
    const k = f && x.start > f.end + l.targetduration;
    if (k || // Or wait for main buffer after buffing some audio
    !(f != null && f.len) && c.len) {
      const E = this.getAppendedFrag(x.start, at.MAIN);
      if (E === null || (T || (T = !!E.gap || !!k && f.len === 0), k && !T || T && c.nextStart && c.nextStart < E.end))
        return;
    }
    this.loadFragment(x, o, _);
  }
  getMaxBufferLength(e) {
    const r = super.getMaxBufferLength();
    return e ? Math.min(Math.max(r, e), this.config.maxMaxBufferLength) : r;
  }
  onMediaDetaching() {
    this.videoBuffer = null, super.onMediaDetaching();
  }
  onAudioTracksUpdated(e, {
    audioTracks: r
  }) {
    this.resetTransmuxer(), this.levels = r.map((n) => new Xf(n));
  }
  onAudioTrackSwitching(e, r) {
    const n = !!r.url;
    this.trackId = r.id;
    const {
      fragCurrent: s
    } = this;
    s && (s.abortRequests(), this.removeUnbufferedFrags(s.start)), this.resetLoadingState(), n ? this.setInterval(eP) : this.resetTransmuxer(), n ? (this.switchingTrack = r, this.state = _e.IDLE) : (this.switchingTrack = null, this.bufferedTrack = r, this.state = _e.STOPPED), this.tick();
  }
  onManifestLoading() {
    this.fragmentTracker.removeAllFragments(), this.startPosition = this.lastCurrentTime = 0, this.bufferFlushed = !1, this.levels = this.mainDetails = this.waitingData = this.bufferedTrack = this.cachedTrackLoadedData = this.switchingTrack = null, this.startFragRequested = !1, this.trackId = this.videoTrackCC = this.waitingVideoCC = -1;
  }
  onLevelLoaded(e, r) {
    this.mainDetails = r.details, this.cachedTrackLoadedData !== null && (this.hls.trigger(D.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData), this.cachedTrackLoadedData = null);
  }
  onAudioTrackLoaded(e, r) {
    var n;
    if (this.mainDetails == null) {
      this.cachedTrackLoadedData = r;
      return;
    }
    const {
      levels: s
    } = this, {
      details: a,
      id: o
    } = r;
    if (!s) {
      this.warn(`Audio tracks were reset while loading level ${o}`);
      return;
    }
    this.log(`Track ${o} loaded [${a.startSN},${a.endSN}]${a.lastPartSn ? `[part-${a.lastPartSn}-${a.lastPartIndex}]` : ""},duration:${a.totalduration}`);
    const l = s[o];
    let u = 0;
    if (a.live || (n = l.details) != null && n.live) {
      const c = this.mainDetails;
      if (a.fragments[0] || (a.deltaUpdateFailed = !0), a.deltaUpdateFailed || !c)
        return;
      !l.details && a.hasProgramDateTime && c.hasProgramDateTime ? (TU(a, c), u = a.fragments[0].start) : u = this.alignPlaylists(a, l.details);
    }
    l.details = a, this.levelLastLoaded = o, !this.startFragRequested && (this.mainDetails || !a.live) && this.setStartPosition(l.details, u), this.state === _e.WAITING_TRACK && !this.waitForCdnTuneIn(a) && (this.state = _e.IDLE), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var r;
    const {
      frag: n,
      part: s,
      payload: a
    } = e, {
      config: o,
      trackId: l,
      levels: u
    } = this;
    if (!u) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${n.sn} of level ${n.level} will not be buffered`);
      return;
    }
    const c = u[l];
    if (!c) {
      this.warn("Audio track is undefined on fragment load progress");
      return;
    }
    const d = c.details;
    if (!d) {
      this.warn("Audio track details undefined on fragment load progress"), this.removeUnbufferedFrags(n.start);
      return;
    }
    const h = o.defaultAudioCodec || c.audioCodec || "mp4a.40.2";
    let f = this.transmuxer;
    f || (f = this.transmuxer = new NU(this.hls, at.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
    const p = this.initPTS[n.cc], m = (r = n.initSegment) == null ? void 0 : r.data;
    if (p !== void 0) {
      const y = s ? s.index : -1, _ = y !== -1, x = new Gk(n.level, n.sn, n.stats.chunkCount, a.byteLength, y, _);
      f.push(a, m, h, "", n, s, d.totalduration, !1, x, p);
    } else {
      this.log(`Unknown video PTS for cc ${n.cc}, waiting for video PTS before demuxing audio frag ${n.sn} of [${d.startSN} ,${d.endSN}],track ${l}`);
      const {
        cache: b
      } = this.waitingData = this.waitingData || {
        frag: n,
        part: s,
        cache: new FU(),
        complete: !1
      };
      b.push(new Uint8Array(a)), this.waitingVideoCC = this.videoTrackCC, this.state = _e.WAITING_INIT_PTS;
    }
  }
  _handleFragmentLoadComplete(e) {
    if (this.waitingData) {
      this.waitingData.complete = !0;
      return;
    }
    super._handleFragmentLoadComplete(e);
  }
  onBufferReset() {
    this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
  }
  onBufferCreated(e, r) {
    const n = r.tracks.audio;
    n && (this.mediaBuffer = n.buffer || null), r.tracks.video && (this.videoBuffer = r.tracks.video.buffer || null);
  }
  onFragBuffered(e, r) {
    const {
      frag: n,
      part: s
    } = r;
    if (n.type !== at.AUDIO) {
      if (!this.loadedmetadata && n.type === at.MAIN) {
        const a = this.videoBuffer || this.media;
        a && Tr.getBuffered(a).length && (this.loadedmetadata = !0);
      }
      return;
    }
    if (this.fragContextChanged(n)) {
      this.warn(`Fragment ${n.sn}${s ? " p: " + s.index : ""} of level ${n.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : "false"}`);
      return;
    }
    if (n.sn !== "initSegment") {
      this.fragPrevious = n;
      const a = this.switchingTrack;
      a && (this.bufferedTrack = a, this.switchingTrack = null, this.hls.trigger(D.AUDIO_TRACK_SWITCHED, Ei({}, a)));
    }
    this.fragBufferedComplete(n, s);
  }
  onError(e, r) {
    var n;
    if (r.fatal) {
      this.state = _e.ERROR;
      return;
    }
    switch (r.details) {
      case le.FRAG_GAP:
      case le.FRAG_PARSING_ERROR:
      case le.FRAG_DECRYPT_ERROR:
      case le.FRAG_LOAD_ERROR:
      case le.FRAG_LOAD_TIMEOUT:
      case le.KEY_LOAD_ERROR:
      case le.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(at.AUDIO, r);
        break;
      case le.AUDIO_TRACK_LOAD_ERROR:
      case le.AUDIO_TRACK_LOAD_TIMEOUT:
      case le.LEVEL_PARSING_ERROR:
        !r.levelRetry && this.state === _e.WAITING_TRACK && ((n = r.context) == null ? void 0 : n.type) === Vt.AUDIO_TRACK && (this.state = _e.IDLE);
        break;
      case le.BUFFER_FULL_ERROR:
        if (!r.parent || r.parent !== "audio")
          return;
        this.reduceLengthAndFlushBuffer(r) && (this.bufferedTrack = null, super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"));
        break;
      case le.INTERNAL_EXCEPTION:
        this.recoverWorkerError(r);
        break;
    }
  }
  onBufferFlushed(e, {
    type: r
  }) {
    r === or.AUDIO && (this.bufferFlushed = !0, this.state === _e.ENDED && (this.state = _e.IDLE));
  }
  _handleTransmuxComplete(e) {
    var r;
    const n = "audio", {
      hls: s
    } = this, {
      remuxResult: a,
      chunkMeta: o
    } = e, l = this.getCurrentContext(o);
    if (!l) {
      this.resetWhenMissingContext(o);
      return;
    }
    const {
      frag: u,
      part: c,
      level: d
    } = l, {
      details: h
    } = d, {
      audio: f,
      text: p,
      id3: m,
      initSegment: b
    } = a;
    if (this.fragContextChanged(u) || !h) {
      this.fragmentTracker.removeFragment(u);
      return;
    }
    if (this.state = _e.PARSING, this.switchingTrack && f && this.completeAudioSwitch(this.switchingTrack), b != null && b.tracks) {
      const y = u.initSegment || u;
      this._bufferInitSegment(b.tracks, y, o), s.trigger(D.FRAG_PARSING_INIT_SEGMENT, {
        frag: y,
        id: n,
        tracks: b.tracks
      });
    }
    if (f) {
      const {
        startPTS: y,
        endPTS: _,
        startDTS: x,
        endDTS: T
      } = f;
      c && (c.elementaryStreams[or.AUDIO] = {
        startPTS: y,
        endPTS: _,
        startDTS: x,
        endDTS: T
      }), u.setElementaryStreamInfo(or.AUDIO, y, _, x, T), this.bufferFragmentData(f, u, c, o);
    }
    if (m != null && (r = m.samples) != null && r.length) {
      const y = hn({
        id: n,
        frag: u,
        details: h
      }, m);
      s.trigger(D.FRAG_PARSING_METADATA, y);
    }
    if (p) {
      const y = hn({
        id: n,
        frag: u,
        details: h
      }, p);
      s.trigger(D.FRAG_PARSING_USERDATA, y);
    }
  }
  _bufferInitSegment(e, r, n) {
    if (this.state !== _e.PARSING)
      return;
    e.video && delete e.video;
    const s = e.audio;
    if (!s)
      return;
    s.levelCodec = s.codec, s.id = "audio", this.log(`Init audio buffer, container:${s.container}, codecs[parsed]=[${s.codec}]`), this.hls.trigger(D.BUFFER_CODECS, e);
    const a = s.initSegment;
    if (a != null && a.byteLength) {
      const o = {
        type: "audio",
        frag: r,
        part: null,
        chunkMeta: n,
        parent: r.type,
        data: a
      };
      this.hls.trigger(D.BUFFER_APPENDING, o);
    }
    this.tick();
  }
  loadFragment(e, r, n) {
    const s = this.fragmentTracker.getState(e);
    if (this.fragCurrent = e, this.switchingTrack || s === yn.NOT_LOADED || s === yn.PARTIAL) {
      var a;
      e.sn === "initSegment" ? this._loadInitSegment(e, r) : (a = r.details) != null && a.live && !this.initPTS[e.cc] ? (this.log(`Waiting for video PTS in continuity counter ${e.cc} of live stream before loading audio fragment ${e.sn} of level ${this.trackId}`), this.state = _e.WAITING_INIT_PTS) : (this.startFragRequested = !0, super.loadFragment(e, r, n));
    } else
      this.clearTrackerIfNeeded(e);
  }
  completeAudioSwitch(e) {
    const {
      hls: r,
      media: n,
      bufferedTrack: s
    } = this, a = s == null ? void 0 : s.attrs, o = e.attrs;
    n && a && (a.CHANNELS !== o.CHANNELS || a.NAME !== o.NAME || a.LANGUAGE !== o.LANGUAGE) && (this.log("Switching audio track : flushing all audio"), super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio")), this.bufferedTrack = e, this.switchingTrack = null, r.trigger(D.AUDIO_TRACK_SWITCHED, Ei({}, e));
  }
}
class AJ extends Hk {
  constructor(e) {
    super(e, "[audio-track-controller]"), this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(D.MANIFEST_LOADING, this.onManifestLoading, this), e.on(D.MANIFEST_PARSED, this.onManifestParsed, this), e.on(D.LEVEL_LOADING, this.onLevelLoading, this), e.on(D.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(D.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(D.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(D.MANIFEST_LOADING, this.onManifestLoading, this), e.off(D.MANIFEST_PARSED, this.onManifestParsed, this), e.off(D.LEVEL_LOADING, this.onLevelLoading, this), e.off(D.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(D.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(D.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, super.destroy();
  }
  onManifestLoading() {
    this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0;
  }
  onManifestParsed(e, r) {
    this.tracks = r.audioTracks || [];
  }
  onAudioTrackLoaded(e, r) {
    const {
      id: n,
      groupId: s,
      details: a
    } = r, o = this.tracksInGroup[n];
    if (!o || o.groupId !== s) {
      this.warn(`Track with id:${n} and group:${s} not found in active group ${o.groupId}`);
      return;
    }
    const l = o.details;
    o.details = r.details, this.log(`audio-track ${n} "${o.name}" lang:${o.lang} group:${s} loaded [${a.startSN}-${a.endSN}]`), n === this.trackId && this.playlistLoaded(n, r, l);
  }
  onLevelLoading(e, r) {
    this.switchLevel(r.level);
  }
  onLevelSwitching(e, r) {
    this.switchLevel(r.level);
  }
  switchLevel(e) {
    const r = this.hls.levels[e];
    if (!(r != null && r.audioGroupIds))
      return;
    const n = r.audioGroupIds[r.urlId];
    if (this.groupId !== n) {
      this.groupId = n || null;
      const s = this.tracks.filter((o) => !n || o.groupId === n);
      this.selectDefaultTrack && !s.some((o) => o.default) && (this.selectDefaultTrack = !1), this.tracksInGroup = s;
      const a = {
        audioTracks: s
      };
      this.log(`Updating audio tracks, ${s.length} track(s) found in group:${n}`), this.hls.trigger(D.AUDIO_TRACKS_UPDATED, a), this.selectInitialTrack();
    } else
      this.shouldReloadPlaylist(this.currentTrack) && this.setAudioTrack(this.trackId);
  }
  onError(e, r) {
    r.fatal || !r.context || r.context.type === Vt.AUDIO_TRACK && r.context.id === this.trackId && r.context.groupId === this.groupId && (this.requestScheduled = -1, this.checkRetry(r));
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(e) {
    this.selectDefaultTrack = !1, this.setAudioTrack(e);
  }
  setAudioTrack(e) {
    const r = this.tracksInGroup;
    if (e < 0 || e >= r.length) {
      this.warn("Invalid id passed to audio-track controller");
      return;
    }
    this.clearTimer();
    const n = this.currentTrack;
    r[this.trackId];
    const s = r[e], {
      groupId: a,
      name: o
    } = s;
    if (this.log(`Switching to audio-track ${e} "${o}" lang:${s.lang} group:${a}`), this.trackId = e, this.currentTrack = s, this.selectDefaultTrack = !1, this.hls.trigger(D.AUDIO_TRACK_SWITCHING, Ei({}, s)), s.details && !s.details.live)
      return;
    const l = this.switchParams(s.url, n == null ? void 0 : n.details);
    this.loadPlaylist(l);
  }
  selectInitialTrack() {
    const e = this.tracksInGroup, r = this.findTrackId(this.currentTrack) | this.findTrackId(null);
    if (r !== -1)
      this.setAudioTrack(r);
    else {
      const n = new Error(`No track found for running audio group-ID: ${this.groupId} track count: ${e.length}`);
      this.warn(n.message), this.hls.trigger(D.ERROR, {
        type: it.MEDIA_ERROR,
        details: le.AUDIO_TRACK_LOAD_ERROR,
        fatal: !0,
        error: n
      });
    }
  }
  findTrackId(e) {
    const r = this.tracksInGroup;
    for (let n = 0; n < r.length; n++) {
      const s = r[n];
      if ((!this.selectDefaultTrack || s.default) && (!e || e.attrs["STABLE-RENDITION-ID"] !== void 0 && e.attrs["STABLE-RENDITION-ID"] === s.attrs["STABLE-RENDITION-ID"] || e.name === s.name && e.lang === s.lang))
        return s.id;
    }
    return -1;
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const r = this.tracksInGroup[this.trackId];
    if (this.shouldLoadPlaylist(r)) {
      const n = r.id, s = r.groupId;
      let a = r.url;
      if (e)
        try {
          a = e.addDirectives(a);
        } catch (o) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${o}`);
        }
      this.log(`loading audio-track playlist ${n} "${r.name}" lang:${r.lang} group:${s}`), this.clearTimer(), this.hls.trigger(D.AUDIO_TRACK_LOADING, {
        url: a,
        id: n,
        groupId: s,
        deliveryDirectives: e || null
      });
    }
  }
}
function BU(t, e) {
  if (t.length !== e.length)
    return !1;
  for (let r = 0; r < t.length; r++)
    if (!CJ(t[r].attrs, e[r].attrs))
      return !1;
  return !0;
}
function CJ(t, e) {
  const r = t["STABLE-RENDITION-ID"];
  return r ? r === e["STABLE-RENDITION-ID"] : !["LANGUAGE", "NAME", "CHARACTERISTICS", "AUTOSELECT", "DEFAULT", "FORCED"].some((n) => t[n] !== e[n]);
}
const tP = 500;
class IJ extends Kk {
  constructor(e, r, n) {
    super(e, r, n, "[subtitle-stream-controller]", at.SUBTITLE), this.levels = [], this.currentTrackId = -1, this.tracksBuffered = [], this.mainDetails = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), this.mainDetails = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(D.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(D.MANIFEST_LOADING, this.onManifestLoading, this), e.on(D.LEVEL_LOADED, this.onLevelLoaded, this), e.on(D.ERROR, this.onError, this), e.on(D.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(D.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(D.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(D.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.on(D.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(D.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(D.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(D.MANIFEST_LOADING, this.onManifestLoading, this), e.off(D.LEVEL_LOADED, this.onLevelLoaded, this), e.off(D.ERROR, this.onError, this), e.off(D.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(D.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(D.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(D.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.off(D.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(D.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  startLoad(e) {
    this.stopLoad(), this.state = _e.IDLE, this.setInterval(tP), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
  }
  onManifestLoading() {
    this.mainDetails = null, this.fragmentTracker.removeAllFragments();
  }
  onMediaDetaching() {
    this.tracksBuffered = [], super.onMediaDetaching();
  }
  onLevelLoaded(e, r) {
    this.mainDetails = r.details;
  }
  onSubtitleFragProcessed(e, r) {
    const {
      frag: n,
      success: s
    } = r;
    if (this.fragPrevious = n, this.state = _e.IDLE, !s)
      return;
    const a = this.tracksBuffered[this.currentTrackId];
    if (!a)
      return;
    let o;
    const l = n.start;
    for (let c = 0; c < a.length; c++)
      if (l >= a[c].start && l <= a[c].end) {
        o = a[c];
        break;
      }
    const u = n.start + n.duration;
    o ? o.end = u : (o = {
      start: l,
      end: u
    }, a.push(o)), this.fragmentTracker.fragBuffered(n);
  }
  onBufferFlushing(e, r) {
    const {
      startOffset: n,
      endOffset: s
    } = r;
    if (n === 0 && s !== Number.POSITIVE_INFINITY) {
      const a = s - 1;
      if (a <= 0)
        return;
      r.endOffsetSubtitles = Math.max(0, a), this.tracksBuffered.forEach((o) => {
        for (let l = 0; l < o.length; ) {
          if (o[l].end <= a) {
            o.shift();
            continue;
          } else if (o[l].start < a)
            o[l].start = a;
          else
            break;
          l++;
        }
      }), this.fragmentTracker.removeFragmentsInRange(n, a, at.SUBTITLE);
    }
  }
  onFragBuffered(e, r) {
    if (!this.loadedmetadata && r.frag.type === at.MAIN) {
      var n;
      (n = this.media) != null && n.buffered.length && (this.loadedmetadata = !0);
    }
  }
  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(e, r) {
    const n = r.frag;
    (n == null ? void 0 : n.type) === at.SUBTITLE && (this.fragCurrent && this.fragCurrent.abortRequests(), this.state !== _e.STOPPED && (this.state = _e.IDLE));
  }
  // Got all new subtitle levels.
  onSubtitleTracksUpdated(e, {
    subtitleTracks: r
  }) {
    if (BU(this.levels, r)) {
      this.levels = r.map((n) => new Xf(n));
      return;
    }
    this.tracksBuffered = [], this.levels = r.map((n) => {
      const s = new Xf(n);
      return this.tracksBuffered[s.id] = [], s;
    }), this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, at.SUBTITLE), this.fragPrevious = null, this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(e, r) {
    if (this.currentTrackId = r.id, !this.levels.length || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }
    const n = this.levels[this.currentTrackId];
    n != null && n.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, n && this.setInterval(tP);
  }
  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(e, r) {
    var n;
    const {
      details: s,
      id: a
    } = r, {
      currentTrackId: o,
      levels: l
    } = this;
    if (!l.length)
      return;
    const u = l[o];
    if (a >= l.length || a !== o || !u)
      return;
    this.mediaBuffer = this.mediaBufferTimeRanges;
    let c = 0;
    if (s.live || (n = u.details) != null && n.live) {
      const d = this.mainDetails;
      if (s.deltaUpdateFailed || !d)
        return;
      const h = d.fragments[0];
      u.details ? (c = this.alignPlaylists(s, u.details), c === 0 && h && (c = h.start, tx(s, c))) : s.hasProgramDateTime && d.hasProgramDateTime ? (TU(s, d), c = s.fragments[0].start) : h && (c = h.start, tx(s, c));
    }
    u.details = s, this.levelLastLoaded = a, !this.startFragRequested && (this.mainDetails || !s.live) && this.setStartPosition(u.details, c), this.tick(), s.live && !this.fragCurrent && this.media && this.state === _e.IDLE && (Qf(null, s.fragments, this.media.currentTime, 0) || (this.warn("Subtitle playlist not aligned with playback"), u.details = void 0));
  }
  _handleFragmentLoadComplete(e) {
    const {
      frag: r,
      payload: n
    } = e, s = r.decryptdata, a = this.hls;
    if (!this.fragContextChanged(r) && n && n.byteLength > 0 && s && s.key && s.iv && s.method === "AES-128") {
      const o = performance.now();
      this.decrypter.decrypt(new Uint8Array(n), s.key.buffer, s.iv.buffer).catch((l) => {
        throw a.trigger(D.ERROR, {
          type: it.MEDIA_ERROR,
          details: le.FRAG_DECRYPT_ERROR,
          fatal: !1,
          error: l,
          reason: l.message,
          frag: r
        }), l;
      }).then((l) => {
        const u = performance.now();
        a.trigger(D.FRAG_DECRYPTED, {
          frag: r,
          payload: l,
          stats: {
            tstart: o,
            tdecrypt: u
          }
        });
      }).catch((l) => {
        this.warn(`${l.name}: ${l.message}`), this.state = _e.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = _e.IDLE;
      return;
    }
    if (this.state === _e.IDLE) {
      const {
        currentTrackId: e,
        levels: r
      } = this, n = r[e];
      if (!r.length || !n || !n.details)
        return;
      const {
        config: s
      } = this, a = this.getLoadPosition(), o = Tr.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], a, s.maxBufferHole), {
        end: l,
        len: u
      } = o, c = this.getFwdBufferInfo(this.media, at.MAIN), d = n.details, h = this.getMaxBufferLength(c == null ? void 0 : c.len) + d.levelTargetDuration;
      if (u > h)
        return;
      const f = d.fragments, p = f.length, m = d.edge;
      let b = null;
      const y = this.fragPrevious;
      if (l < m) {
        const _ = s.maxFragLookUpTolerance, x = l > m - _ ? 0 : _;
        b = Qf(y, f, Math.max(f[0].start, l), x), !b && y && y.start < f[0].start && (b = f[0]);
      } else
        b = f[p - 1];
      if (!b)
        return;
      if (b = this.mapToInitFragWhenRequired(b), b.sn !== "initSegment") {
        const _ = b.sn - d.startSN, x = f[_ - 1];
        x && x.cc === b.cc && this.fragmentTracker.getState(x) === yn.NOT_LOADED && (b = x);
      }
      this.fragmentTracker.getState(b) === yn.NOT_LOADED && this.loadFragment(b, n, l);
    }
  }
  getMaxBufferLength(e) {
    const r = super.getMaxBufferLength();
    return e ? Math.max(r, e) : r;
  }
  loadFragment(e, r, n) {
    this.fragCurrent = e, e.sn === "initSegment" ? this._loadInitSegment(e, r) : (this.startFragRequested = !0, super.loadFragment(e, r, n));
  }
  get mediaBufferTimeRanges() {
    return new PJ(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class PJ {
  constructor(e) {
    this.buffered = void 0;
    const r = (n, s, a) => {
      if (s = s >>> 0, s > a - 1)
        throw new DOMException(`Failed to execute '${n}' on 'TimeRanges': The index provided (${s}) is greater than the maximum bound (${a})`);
      return e[s][n];
    };
    this.buffered = {
      get length() {
        return e.length;
      },
      end(n) {
        return r("end", n, e.length);
      },
      start(n) {
        return r("start", n, e.length);
      }
    };
  }
}
class RJ extends Hk {
  constructor(e) {
    super(e, "[subtitle-track-controller]"), this.media = null, this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.selectDefaultTrack = !0, this.queuedDefaultTrack = -1, this.trackChangeListener = () => this.onTextTracksChanged(), this.asyncPollTrackChange = () => this.pollTrackChange(0), this.useTextTrackPolling = !1, this.subtitlePollingInterval = -1, this._subtitleDisplay = !0, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.trackChangeListener = this.asyncPollTrackChange = null, super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(e) {
    this._subtitleDisplay = e, this.trackId > -1 && this.toggleTrackModes(this.trackId);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(D.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(D.MANIFEST_LOADING, this.onManifestLoading, this), e.on(D.MANIFEST_PARSED, this.onManifestParsed, this), e.on(D.LEVEL_LOADING, this.onLevelLoading, this), e.on(D.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(D.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(D.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(D.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(D.MANIFEST_LOADING, this.onManifestLoading, this), e.off(D.MANIFEST_PARSED, this.onManifestParsed, this), e.off(D.LEVEL_LOADING, this.onLevelLoading, this), e.off(D.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(D.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(D.ERROR, this.onError, this);
  }
  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(e, r) {
    this.media = r.media, this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
  }
  pollTrackChange(e) {
    self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.trackChangeListener, e);
  }
  onMediaDetaching() {
    if (!this.media)
      return;
    self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || this.media.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId), R_(this.media.textTracks).forEach((r) => {
      td(r);
    }), this.subtitleTrack = -1, this.media = null;
  }
  onManifestLoading() {
    this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.selectDefaultTrack = !0;
  }
  // Fired whenever a new manifest is loaded.
  onManifestParsed(e, r) {
    this.tracks = r.subtitleTracks;
  }
  onSubtitleTrackLoaded(e, r) {
    const {
      id: n,
      details: s
    } = r, {
      trackId: a
    } = this, o = this.tracksInGroup[a];
    if (!o) {
      this.warn(`Invalid subtitle track id ${n}`);
      return;
    }
    const l = o.details;
    o.details = r.details, this.log(`subtitle track ${n} loaded [${s.startSN}-${s.endSN}]`), n === this.trackId && this.playlistLoaded(n, r, l);
  }
  onLevelLoading(e, r) {
    this.switchLevel(r.level);
  }
  onLevelSwitching(e, r) {
    this.switchLevel(r.level);
  }
  switchLevel(e) {
    const r = this.hls.levels[e];
    if (!(r != null && r.textGroupIds))
      return;
    const n = r.textGroupIds[r.urlId], s = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0;
    if (this.groupId !== n) {
      const a = this.tracks.filter((u) => !n || u.groupId === n);
      this.tracksInGroup = a;
      const o = this.findTrackId(s == null ? void 0 : s.name) || this.findTrackId();
      this.groupId = n || null;
      const l = {
        subtitleTracks: a
      };
      this.log(`Updating subtitle tracks, ${a.length} track(s) found in "${n}" group-id`), this.hls.trigger(D.SUBTITLE_TRACKS_UPDATED, l), o !== -1 && this.setSubtitleTrack(o, s);
    } else
      this.shouldReloadPlaylist(s) && this.setSubtitleTrack(this.trackId, s);
  }
  findTrackId(e) {
    const r = this.tracksInGroup;
    for (let n = 0; n < r.length; n++) {
      const s = r[n];
      if ((!this.selectDefaultTrack || s.default) && (!e || e === s.name))
        return s.id;
    }
    return -1;
  }
  onError(e, r) {
    r.fatal || !r.context || r.context.type === Vt.SUBTITLE_TRACK && r.context.id === this.trackId && r.context.groupId === this.groupId && this.checkRetry(r);
  }
  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }
  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(e) {
    this.selectDefaultTrack = !1;
    const r = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0;
    this.setSubtitleTrack(e, r);
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const r = this.tracksInGroup[this.trackId];
    if (this.shouldLoadPlaylist(r)) {
      const n = r.id, s = r.groupId;
      let a = r.url;
      if (e)
        try {
          a = e.addDirectives(a);
        } catch (o) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${o}`);
        }
      this.log(`Loading subtitle playlist for id ${n}`), this.hls.trigger(D.SUBTITLE_TRACK_LOADING, {
        url: a,
        id: n,
        groupId: s,
        deliveryDirectives: e || null
      });
    }
  }
  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes(e) {
    const {
      media: r,
      trackId: n
    } = this;
    if (!r)
      return;
    const s = R_(r.textTracks), a = s.filter((l) => l.groupId === this.groupId);
    if (e === -1)
      [].slice.call(s).forEach((l) => {
        l.mode = "disabled";
      });
    else {
      const l = a[n];
      l && (l.mode = "disabled");
    }
    const o = a[e];
    o && (o.mode = this.subtitleDisplay ? "showing" : "hidden");
  }
  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(e, r) {
    var n;
    const s = this.tracksInGroup;
    if (!this.media) {
      this.queuedDefaultTrack = e;
      return;
    }
    if (this.trackId !== e && this.toggleTrackModes(e), this.trackId === e && (e === -1 || (n = s[e]) != null && n.details) || e < -1 || e >= s.length)
      return;
    this.clearTimer();
    const a = s[e];
    if (this.log(`Switching to subtitle-track ${e}` + (a ? ` "${a.name}" lang:${a.lang} group:${a.groupId}` : "")), this.trackId = e, a) {
      const {
        id: o,
        groupId: l = "",
        name: u,
        type: c,
        url: d
      } = a;
      this.hls.trigger(D.SUBTITLE_TRACK_SWITCH, {
        id: o,
        groupId: l,
        name: u,
        type: c,
        url: d
      });
      const h = this.switchParams(a.url, r == null ? void 0 : r.details);
      this.loadPlaylist(h);
    } else
      this.hls.trigger(D.SUBTITLE_TRACK_SWITCH, {
        id: e
      });
  }
  onTextTracksChanged() {
    if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), !this.media || !this.hls.config.renderTextTracksNatively)
      return;
    let e = -1;
    const r = R_(this.media.textTracks);
    for (let n = 0; n < r.length; n++)
      if (r[n].mode === "hidden")
        e = n;
      else if (r[n].mode === "showing") {
        e = n;
        break;
      }
    this.subtitleTrack !== e && (this.subtitleTrack = e);
  }
}
function R_(t) {
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    (n.kind === "subtitles" || n.kind === "captions") && n.label && e.push(t[r]);
  }
  return e;
}
class MJ {
  constructor(e) {
    this.buffers = void 0, this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    }, this.buffers = e;
  }
  append(e, r) {
    const n = this.queues[r];
    n.push(e), n.length === 1 && this.buffers[r] && this.executeNext(r);
  }
  insertAbort(e, r) {
    this.queues[r].unshift(e), this.executeNext(r);
  }
  appendBlocker(e) {
    let r;
    const n = new Promise((a) => {
      r = a;
    }), s = {
      execute: r,
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: () => {
      }
    };
    return this.append(s, e), n;
  }
  executeNext(e) {
    const {
      buffers: r,
      queues: n
    } = this, s = r[e], a = n[e];
    if (a.length) {
      const o = a[0];
      try {
        o.execute();
      } catch (l) {
        J.warn("[buffer-operation-queue]: Unhandled exception executing the current operation"), o.onError(l), s != null && s.updating || (a.shift(), this.executeNext(e));
      }
    }
  }
  shiftAndExecuteNext(e) {
    this.queues[e].shift(), this.executeNext(e);
  }
  current(e) {
    return this.queues[e][0];
  }
}
const rP = P0(), nP = /([ha]vc.)(?:\.[^.,]+)+/;
class LJ {
  // The level details used to determine duration, target-duration and live
  // cache the self generated object url to detect hijack of video tag
  // A queue of buffer operations which require the SourceBuffer to not be updating upon execution
  // References to event listeners for each SourceBuffer, so that they can be referenced for event removal
  // The number of BUFFER_CODEC events received before any sourceBuffers are created
  // The total number of BUFFER_CODEC events received
  // A reference to the attached media element
  // A reference to the active media source
  // Last MP3 audio chunk appended
  // counters
  constructor(e) {
    this.details = null, this._objectUrl = null, this.operationQueue = void 0, this.listeners = void 0, this.hls = void 0, this.bufferCodecEventsExpected = 0, this._bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.lastMpegAudioChunk = null, this.appendError = 0, this.tracks = {}, this.pendingTracks = {}, this.sourceBuffer = void 0, this._onMediaSourceOpen = () => {
      const {
        media: r,
        mediaSource: n
      } = this;
      J.log("[buffer-controller]: Media source opened"), r && (r.removeEventListener("emptied", this._onMediaEmptied), this.updateMediaElementDuration(), this.hls.trigger(D.MEDIA_ATTACHED, {
        media: r
      })), n && n.removeEventListener("sourceopen", this._onMediaSourceOpen), this.checkPendingTracks();
    }, this._onMediaSourceClose = () => {
      J.log("[buffer-controller]: Media source closed");
    }, this._onMediaSourceEnded = () => {
      J.log("[buffer-controller]: Media source ended");
    }, this._onMediaEmptied = () => {
      const {
        media: r,
        _objectUrl: n
      } = this;
      r && r.src !== n && J.error(`Media element src was set while attaching MediaSource (${n} > ${r.src})`);
    }, this.hls = e, this._initSourceBuffer(), this.registerListeners();
  }
  hasSourceTypes() {
    return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
  }
  destroy() {
    this.unregisterListeners(), this.details = null, this.lastMpegAudioChunk = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(D.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(D.MANIFEST_LOADING, this.onManifestLoading, this), e.on(D.MANIFEST_PARSED, this.onManifestParsed, this), e.on(D.BUFFER_RESET, this.onBufferReset, this), e.on(D.BUFFER_APPENDING, this.onBufferAppending, this), e.on(D.BUFFER_CODECS, this.onBufferCodecs, this), e.on(D.BUFFER_EOS, this.onBufferEos, this), e.on(D.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(D.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(D.FRAG_PARSED, this.onFragParsed, this), e.on(D.FRAG_CHANGED, this.onFragChanged, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(D.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(D.MANIFEST_LOADING, this.onManifestLoading, this), e.off(D.MANIFEST_PARSED, this.onManifestParsed, this), e.off(D.BUFFER_RESET, this.onBufferReset, this), e.off(D.BUFFER_APPENDING, this.onBufferAppending, this), e.off(D.BUFFER_CODECS, this.onBufferCodecs, this), e.off(D.BUFFER_EOS, this.onBufferEos, this), e.off(D.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(D.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(D.FRAG_PARSED, this.onFragParsed, this), e.off(D.FRAG_CHANGED, this.onFragChanged, this);
  }
  _initSourceBuffer() {
    this.sourceBuffer = {}, this.operationQueue = new MJ(this.sourceBuffer), this.listeners = {
      audio: [],
      video: [],
      audiovideo: []
    }, this.lastMpegAudioChunk = null;
  }
  onManifestLoading() {
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = 0, this.details = null;
  }
  onManifestParsed(e, r) {
    let n = 2;
    (r.audio && !r.video || !r.altAudio) && (n = 1), this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = n, J.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`);
  }
  onMediaAttaching(e, r) {
    const n = this.media = r.media;
    if (n && rP) {
      const s = this.mediaSource = new rP();
      s.addEventListener("sourceopen", this._onMediaSourceOpen), s.addEventListener("sourceended", this._onMediaSourceEnded), s.addEventListener("sourceclose", this._onMediaSourceClose), n.src = self.URL.createObjectURL(s), this._objectUrl = n.src, n.addEventListener("emptied", this._onMediaEmptied);
    }
  }
  onMediaDetaching() {
    const {
      media: e,
      mediaSource: r,
      _objectUrl: n
    } = this;
    if (r) {
      if (J.log("[buffer-controller]: media source detaching"), r.readyState === "open")
        try {
          r.endOfStream();
        } catch (s) {
          J.warn(`[buffer-controller]: onMediaDetaching: ${s.message} while calling endOfStream`);
        }
      this.onBufferReset(), r.removeEventListener("sourceopen", this._onMediaSourceOpen), r.removeEventListener("sourceended", this._onMediaSourceEnded), r.removeEventListener("sourceclose", this._onMediaSourceClose), e && (e.removeEventListener("emptied", this._onMediaEmptied), n && self.URL.revokeObjectURL(n), e.src === n ? (e.removeAttribute("src"), e.load()) : J.warn("[buffer-controller]: media.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.bufferCodecEventsExpected = this._bufferCodecEventsTotal, this.pendingTracks = {}, this.tracks = {};
    }
    this.hls.trigger(D.MEDIA_DETACHED, void 0);
  }
  onBufferReset() {
    this.getSourceBufferTypes().forEach((e) => {
      const r = this.sourceBuffer[e];
      try {
        r && (this.removeBufferListeners(e), this.mediaSource && this.mediaSource.removeSourceBuffer(r), this.sourceBuffer[e] = void 0);
      } catch (n) {
        J.warn(`[buffer-controller]: Failed to reset the ${e} buffer`, n);
      }
    }), this._initSourceBuffer();
  }
  onBufferCodecs(e, r) {
    const n = this.getSourceBufferTypes().length;
    Object.keys(r).forEach((s) => {
      if (n) {
        const a = this.tracks[s];
        if (a && typeof a.buffer.changeType == "function") {
          const {
            id: o,
            codec: l,
            levelCodec: u,
            container: c,
            metadata: d
          } = r[s], h = (a.levelCodec || a.codec).replace(nP, "$1"), f = (u || l).replace(nP, "$1");
          if (h !== f) {
            const p = `${c};codecs=${u || l}`;
            this.appendChangeType(s, p), J.log(`[buffer-controller]: switching codec ${h} to ${f}`), this.tracks[s] = {
              buffer: a.buffer,
              codec: l,
              container: c,
              levelCodec: u,
              metadata: d,
              id: o
            };
          }
        }
      } else
        this.pendingTracks[s] = r[s];
    }), !n && (this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0), this.mediaSource && this.mediaSource.readyState === "open" && this.checkPendingTracks());
  }
  appendChangeType(e, r) {
    const {
      operationQueue: n
    } = this, s = {
      execute: () => {
        const a = this.sourceBuffer[e];
        a && (J.log(`[buffer-controller]: changing ${e} sourceBuffer type to ${r}`), a.changeType(r)), n.shiftAndExecuteNext(e);
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (a) => {
        J.warn(`[buffer-controller]: Failed to change ${e} SourceBuffer type`, a);
      }
    };
    n.append(s, e);
  }
  onBufferAppending(e, r) {
    const {
      hls: n,
      operationQueue: s,
      tracks: a
    } = this, {
      data: o,
      type: l,
      frag: u,
      part: c,
      chunkMeta: d
    } = r, h = d.buffering[l], f = self.performance.now();
    h.start = f;
    const p = u.stats.buffering, m = c ? c.stats.buffering : null;
    p.start === 0 && (p.start = f), m && m.start === 0 && (m.start = f);
    const b = a.audio;
    let y = !1;
    l === "audio" && (b == null ? void 0 : b.container) === "audio/mpeg" && (y = !this.lastMpegAudioChunk || d.id === 1 || this.lastMpegAudioChunk.sn !== d.sn, this.lastMpegAudioChunk = d);
    const _ = u.start, x = {
      execute: () => {
        if (h.executeStart = self.performance.now(), y) {
          const T = this.sourceBuffer[l];
          if (T) {
            const k = _ - T.timestampOffset;
            Math.abs(k) >= 0.1 && (J.log(`[buffer-controller]: Updating audio SourceBuffer timestampOffset to ${_} (delta: ${k}) sn: ${u.sn})`), T.timestampOffset = _);
          }
        }
        this.appendExecutor(o, l);
      },
      onStart: () => {
      },
      onComplete: () => {
        const T = self.performance.now();
        h.executeEnd = h.end = T, p.first === 0 && (p.first = T), m && m.first === 0 && (m.first = T);
        const {
          sourceBuffer: k
        } = this, E = {};
        for (const F in k)
          E[F] = Tr.getBuffered(k[F]);
        this.appendError = 0, this.hls.trigger(D.BUFFER_APPENDED, {
          type: l,
          frag: u,
          part: c,
          chunkMeta: d,
          parent: u.type,
          timeRanges: E
        });
      },
      onError: (T) => {
        J.error(`[buffer-controller]: Error encountered while trying to append to the ${l} SourceBuffer`, T);
        const k = {
          type: it.MEDIA_ERROR,
          parent: u.type,
          details: le.BUFFER_APPEND_ERROR,
          frag: u,
          part: c,
          chunkMeta: d,
          error: T,
          err: T,
          fatal: !1
        };
        T.code === DOMException.QUOTA_EXCEEDED_ERR ? k.details = le.BUFFER_FULL_ERROR : (this.appendError++, k.details = le.BUFFER_APPEND_ERROR, this.appendError > n.config.appendErrorMaxRetry && (J.error(`[buffer-controller]: Failed ${n.config.appendErrorMaxRetry} times to append segment in sourceBuffer`), k.fatal = !0)), n.trigger(D.ERROR, k);
      }
    };
    s.append(x, l);
  }
  onBufferFlushing(e, r) {
    const {
      operationQueue: n
    } = this, s = (a) => ({
      execute: this.removeExecutor.bind(this, a, r.startOffset, r.endOffset),
      onStart: () => {
      },
      onComplete: () => {
        this.hls.trigger(D.BUFFER_FLUSHED, {
          type: a
        });
      },
      onError: (o) => {
        J.warn(`[buffer-controller]: Failed to remove from ${a} SourceBuffer`, o);
      }
    });
    r.type ? n.append(s(r.type), r.type) : this.getSourceBufferTypes().forEach((a) => {
      n.append(s(a), a);
    });
  }
  onFragParsed(e, r) {
    const {
      frag: n,
      part: s
    } = r, a = [], o = s ? s.elementaryStreams : n.elementaryStreams;
    o[or.AUDIOVIDEO] ? a.push("audiovideo") : (o[or.AUDIO] && a.push("audio"), o[or.VIDEO] && a.push("video"));
    const l = () => {
      const u = self.performance.now();
      n.stats.buffering.end = u, s && (s.stats.buffering.end = u);
      const c = s ? s.stats : n.stats;
      this.hls.trigger(D.FRAG_BUFFERED, {
        frag: n,
        part: s,
        stats: c,
        id: n.type
      });
    };
    a.length === 0 && J.warn(`Fragments must have at least one ElementaryStreamType set. type: ${n.type} level: ${n.level} sn: ${n.sn}`), this.blockBuffers(l, a);
  }
  onFragChanged(e, r) {
    this.flushBackBuffer();
  }
  // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(e, r) {
    this.getSourceBufferTypes().reduce((s, a) => {
      const o = this.sourceBuffer[a];
      return o && (!r.type || r.type === a) && (o.ending = !0, o.ended || (o.ended = !0, J.log(`[buffer-controller]: ${a} sourceBuffer now EOS`))), s && !!(!o || o.ended);
    }, !0) && (J.log("[buffer-controller]: Queueing mediaSource.endOfStream()"), this.blockBuffers(() => {
      this.getSourceBufferTypes().forEach((a) => {
        const o = this.sourceBuffer[a];
        o && (o.ending = !1);
      });
      const {
        mediaSource: s
      } = this;
      if (!s || s.readyState !== "open") {
        s && J.info(`[buffer-controller]: Could not call mediaSource.endOfStream(). mediaSource.readyState: ${s.readyState}`);
        return;
      }
      J.log("[buffer-controller]: Calling mediaSource.endOfStream()"), s.endOfStream();
    }));
  }
  onLevelUpdated(e, {
    details: r
  }) {
    r.fragments.length && (this.details = r, this.getSourceBufferTypes().length ? this.blockBuffers(this.updateMediaElementDuration.bind(this)) : this.updateMediaElementDuration());
  }
  flushBackBuffer() {
    const {
      hls: e,
      details: r,
      media: n,
      sourceBuffer: s
    } = this;
    if (!n || r === null)
      return;
    const a = this.getSourceBufferTypes();
    if (!a.length)
      return;
    const o = r.live && e.config.liveBackBufferLength !== null ? e.config.liveBackBufferLength : e.config.backBufferLength;
    if (!et(o) || o < 0)
      return;
    const l = n.currentTime, u = r.levelTargetDuration, c = Math.max(o, u), d = Math.floor(l / u) * u - c;
    a.forEach((h) => {
      const f = s[h];
      if (f) {
        const p = Tr.getBuffered(f);
        if (p.length > 0 && d > p.start(0)) {
          if (e.trigger(D.BACK_BUFFER_REACHED, {
            bufferEnd: d
          }), r.live)
            e.trigger(D.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: d
            });
          else if (f.ended && p.end(p.length - 1) - l < u * 2) {
            J.info(`[buffer-controller]: Cannot flush ${h} back buffer while SourceBuffer is in ended state`);
            return;
          }
          e.trigger(D.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: d,
            type: h
          });
        }
      }
    });
  }
  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  updateMediaElementDuration() {
    if (!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== "open")
      return;
    const {
      details: e,
      hls: r,
      media: n,
      mediaSource: s
    } = this, a = e.fragments[0].start + e.totalduration, o = n.duration, l = et(s.duration) ? s.duration : 0;
    e.live && r.config.liveDurationInfinity ? (J.log("[buffer-controller]: Media Source duration is set to Infinity"), s.duration = 1 / 0, this.updateSeekableRange(e)) : (a > l && a > o || !et(o)) && (J.log(`[buffer-controller]: Updating Media Source duration to ${a.toFixed(3)}`), s.duration = a);
  }
  updateSeekableRange(e) {
    const r = this.mediaSource, n = e.fragments;
    if (n.length && e.live && r != null && r.setLiveSeekableRange) {
      const a = Math.max(0, n[0].start), o = Math.max(a, a + e.totalduration);
      r.setLiveSeekableRange(a, o);
    }
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsExpected: e,
      operationQueue: r,
      pendingTracks: n
    } = this, s = Object.keys(n).length;
    if (s && !e || s === 2) {
      this.createSourceBuffers(n), this.pendingTracks = {};
      const a = this.getSourceBufferTypes();
      if (a.length)
        this.hls.trigger(D.BUFFER_CREATED, {
          tracks: this.tracks
        }), a.forEach((o) => {
          r.executeNext(o);
        });
      else {
        const o = new Error("could not create source buffer for media codec(s)");
        this.hls.trigger(D.ERROR, {
          type: it.MEDIA_ERROR,
          details: le.BUFFER_INCOMPATIBLE_CODECS_ERROR,
          fatal: !0,
          error: o,
          reason: o.message
        });
      }
    }
  }
  createSourceBuffers(e) {
    const {
      sourceBuffer: r,
      mediaSource: n
    } = this;
    if (!n)
      throw Error("createSourceBuffers called when mediaSource was null");
    for (const s in e)
      if (!r[s]) {
        const a = e[s];
        if (!a)
          throw Error(`source buffer exists for track ${s}, however track does not`);
        const o = a.levelCodec || a.codec, l = `${a.container};codecs=${o}`;
        J.log(`[buffer-controller]: creating sourceBuffer(${l})`);
        try {
          const u = r[s] = n.addSourceBuffer(l), c = s;
          this.addBufferListener(c, "updatestart", this._onSBUpdateStart), this.addBufferListener(c, "updateend", this._onSBUpdateEnd), this.addBufferListener(c, "error", this._onSBUpdateError), this.tracks[s] = {
            buffer: u,
            codec: o,
            container: a.container,
            levelCodec: a.levelCodec,
            metadata: a.metadata,
            id: a.id
          };
        } catch (u) {
          J.error(`[buffer-controller]: error while trying to add sourceBuffer: ${u.message}`), this.hls.trigger(D.ERROR, {
            type: it.MEDIA_ERROR,
            details: le.BUFFER_ADD_CODEC_ERROR,
            fatal: !1,
            error: u,
            mimeType: l
          });
        }
      }
  }
  _onSBUpdateStart(e) {
    const {
      operationQueue: r
    } = this;
    r.current(e).onStart();
  }
  _onSBUpdateEnd(e) {
    const {
      operationQueue: r
    } = this;
    r.current(e).onComplete(), r.shiftAndExecuteNext(e);
  }
  _onSBUpdateError(e, r) {
    const n = new Error(`${e} SourceBuffer error`);
    J.error(`[buffer-controller]: ${n}`, r), this.hls.trigger(D.ERROR, {
      type: it.MEDIA_ERROR,
      details: le.BUFFER_APPENDING_ERROR,
      error: n,
      fatal: !1
    });
    const s = this.operationQueue.current(e);
    s && s.onError(r);
  }
  // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
  removeExecutor(e, r, n) {
    const {
      media: s,
      mediaSource: a,
      operationQueue: o,
      sourceBuffer: l
    } = this, u = l[e];
    if (!s || !a || !u) {
      J.warn(`[buffer-controller]: Attempting to remove from the ${e} SourceBuffer, but it does not exist`), o.shiftAndExecuteNext(e);
      return;
    }
    const c = et(s.duration) ? s.duration : 1 / 0, d = et(a.duration) ? a.duration : 1 / 0, h = Math.max(0, r), f = Math.min(n, c, d);
    f > h && !u.ending ? (u.ended = !1, J.log(`[buffer-controller]: Removing [${h},${f}] from the ${e} SourceBuffer`), u.remove(h, f)) : o.shiftAndExecuteNext(e);
  }
  // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
  appendExecutor(e, r) {
    const {
      operationQueue: n,
      sourceBuffer: s
    } = this, a = s[r];
    if (!a) {
      J.warn(`[buffer-controller]: Attempting to append to the ${r} SourceBuffer, but it does not exist`), n.shiftAndExecuteNext(r);
      return;
    }
    a.ended = !1, a.appendBuffer(e);
  }
  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(e, r = this.getSourceBufferTypes()) {
    if (!r.length) {
      J.log("[buffer-controller]: Blocking operation requested, but no SourceBuffers exist"), Promise.resolve().then(e);
      return;
    }
    const {
      operationQueue: n
    } = this, s = r.map((a) => n.appendBlocker(a));
    Promise.all(s).then(() => {
      e(), r.forEach((a) => {
        const o = this.sourceBuffer[a];
        o != null && o.updating || n.shiftAndExecuteNext(a);
      });
    });
  }
  getSourceBufferTypes() {
    return Object.keys(this.sourceBuffer);
  }
  addBufferListener(e, r, n) {
    const s = this.sourceBuffer[e];
    if (!s)
      return;
    const a = n.bind(this, e);
    this.listeners[e].push({
      event: r,
      listener: a
    }), s.addEventListener(r, a);
  }
  removeBufferListeners(e) {
    const r = this.sourceBuffer[e];
    r && this.listeners[e].forEach((n) => {
      r.removeEventListener(n.event, n.listener);
    });
  }
}
const iP = {
  42: 225,
  // lowercase a, acute accent
  92: 233,
  // lowercase e, acute accent
  94: 237,
  // lowercase i, acute accent
  95: 243,
  // lowercase o, acute accent
  96: 250,
  // lowercase u, acute accent
  123: 231,
  // lowercase c with cedilla
  124: 247,
  // division symbol
  125: 209,
  // uppercase N tilde
  126: 241,
  // lowercase n tilde
  127: 9608,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  128: 174,
  // Registered symbol (R)
  129: 176,
  // degree sign
  130: 189,
  // 1/2 symbol
  131: 191,
  // Inverted (open) question mark
  132: 8482,
  // Trademark symbol (TM)
  133: 162,
  // Cents symbol
  134: 163,
  // Pounds sterling
  135: 9834,
  // Music 8'th note
  136: 224,
  // lowercase a, grave accent
  137: 32,
  // transparent space (regular)
  138: 232,
  // lowercase e, grave accent
  139: 226,
  // lowercase a, circumflex accent
  140: 234,
  // lowercase e, circumflex accent
  141: 238,
  // lowercase i, circumflex accent
  142: 244,
  // lowercase o, circumflex accent
  143: 251,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  144: 193,
  // capital letter A with acute
  145: 201,
  // capital letter E with acute
  146: 211,
  // capital letter O with acute
  147: 218,
  // capital letter U with acute
  148: 220,
  // capital letter U with diaresis
  149: 252,
  // lowercase letter U with diaeresis
  150: 8216,
  // opening single quote
  151: 161,
  // inverted exclamation mark
  152: 42,
  // asterisk
  153: 8217,
  // closing single quote
  154: 9473,
  // box drawings heavy horizontal
  155: 169,
  // copyright sign
  156: 8480,
  // Service mark
  157: 8226,
  // (round) bullet
  158: 8220,
  // Left double quotation mark
  159: 8221,
  // Right double quotation mark
  160: 192,
  // uppercase A, grave accent
  161: 194,
  // uppercase A, circumflex
  162: 199,
  // uppercase C with cedilla
  163: 200,
  // uppercase E, grave accent
  164: 202,
  // uppercase E, circumflex
  165: 203,
  // capital letter E with diaresis
  166: 235,
  // lowercase letter e with diaresis
  167: 206,
  // uppercase I, circumflex
  168: 207,
  // uppercase I, with diaresis
  169: 239,
  // lowercase i, with diaresis
  170: 212,
  // uppercase O, circumflex
  171: 217,
  // uppercase U, grave accent
  172: 249,
  // lowercase u, grave accent
  173: 219,
  // uppercase U, circumflex
  174: 171,
  // left-pointing double angle quotation mark
  175: 187,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  176: 195,
  // Uppercase A, tilde
  177: 227,
  // Lowercase a, tilde
  178: 205,
  // Uppercase I, acute accent
  179: 204,
  // Uppercase I, grave accent
  180: 236,
  // Lowercase i, grave accent
  181: 210,
  // Uppercase O, grave accent
  182: 242,
  // Lowercase o, grave accent
  183: 213,
  // Uppercase O, tilde
  184: 245,
  // Lowercase o, tilde
  185: 123,
  // Open curly brace
  186: 125,
  // Closing curly brace
  187: 92,
  // Backslash
  188: 94,
  // Caret
  189: 95,
  // Underscore
  190: 124,
  // Pipe (vertical line)
  191: 8764,
  // Tilde operator
  192: 196,
  // Uppercase A, umlaut
  193: 228,
  // Lowercase A, umlaut
  194: 214,
  // Uppercase O, umlaut
  195: 246,
  // Lowercase o, umlaut
  196: 223,
  // Esszett (sharp S)
  197: 165,
  // Yen symbol
  198: 164,
  // Generic currency sign
  199: 9475,
  // Box drawings heavy vertical
  200: 197,
  // Uppercase A, ring
  201: 229,
  // Lowercase A, ring
  202: 216,
  // Uppercase O, stroke
  203: 248,
  // Lowercase o, strok
  204: 9487,
  // Box drawings heavy down and right
  205: 9491,
  // Box drawings heavy down and left
  206: 9495,
  // Box drawings heavy up and right
  207: 9499
  // Box drawings heavy up and left
}, UU = function(e) {
  let r = e;
  return iP.hasOwnProperty(e) && (r = iP[e]), String.fromCharCode(r);
}, Os = 15, Xa = 100, NJ = {
  17: 1,
  18: 3,
  21: 5,
  22: 7,
  23: 9,
  16: 11,
  19: 12,
  20: 14
}, FJ = {
  17: 2,
  18: 4,
  21: 6,
  22: 8,
  23: 10,
  19: 13,
  20: 15
}, BJ = {
  25: 1,
  26: 3,
  29: 5,
  30: 7,
  31: 9,
  24: 11,
  27: 12,
  28: 14
}, UJ = {
  25: 2,
  26: 4,
  29: 6,
  30: 8,
  31: 10,
  27: 13,
  28: 15
}, VJ = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"];
class YJ {
  constructor() {
    this.time = null, this.verboseLevel = 0;
  }
  log(e, r) {
    if (this.verboseLevel >= e) {
      const n = typeof r == "function" ? r() : r;
      J.log(`${this.time} [${e}] ${n}`);
    }
  }
}
const zl = function(e) {
  const r = [];
  for (let n = 0; n < e.length; n++)
    r.push(e[n].toString(16));
  return r;
};
class VU {
  constructor(e, r, n, s, a) {
    this.foreground = void 0, this.underline = void 0, this.italics = void 0, this.background = void 0, this.flash = void 0, this.foreground = e || "white", this.underline = r || !1, this.italics = n || !1, this.background = s || "black", this.flash = a || !1;
  }
  reset() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  setStyles(e) {
    const r = ["foreground", "underline", "italics", "background", "flash"];
    for (let n = 0; n < r.length; n++) {
      const s = r[n];
      e.hasOwnProperty(s) && (this[s] = e[s]);
    }
  }
  isDefault() {
    return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
  }
  equals(e) {
    return this.foreground === e.foreground && this.underline === e.underline && this.italics === e.italics && this.background === e.background && this.flash === e.flash;
  }
  copy(e) {
    this.foreground = e.foreground, this.underline = e.underline, this.italics = e.italics, this.background = e.background, this.flash = e.flash;
  }
  toString() {
    return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
  }
}
class HJ {
  constructor(e, r, n, s, a, o) {
    this.uchar = void 0, this.penState = void 0, this.uchar = e || " ", this.penState = new VU(r, n, s, a, o);
  }
  reset() {
    this.uchar = " ", this.penState.reset();
  }
  setChar(e, r) {
    this.uchar = e, this.penState.copy(r);
  }
  setPenState(e) {
    this.penState.copy(e);
  }
  equals(e) {
    return this.uchar === e.uchar && this.penState.equals(e.penState);
  }
  copy(e) {
    this.uchar = e.uchar, this.penState.copy(e.penState);
  }
  isEmpty() {
    return this.uchar === " " && this.penState.isDefault();
  }
}
class GJ {
  constructor(e) {
    this.chars = void 0, this.pos = void 0, this.currPenState = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chars = [];
    for (let r = 0; r < Xa; r++)
      this.chars.push(new HJ());
    this.logger = e, this.pos = 0, this.currPenState = new VU();
  }
  equals(e) {
    let r = !0;
    for (let n = 0; n < Xa; n++)
      if (!this.chars[n].equals(e.chars[n])) {
        r = !1;
        break;
      }
    return r;
  }
  copy(e) {
    for (let r = 0; r < Xa; r++)
      this.chars[r].copy(e.chars[r]);
  }
  isEmpty() {
    let e = !0;
    for (let r = 0; r < Xa; r++)
      if (!this.chars[r].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  /**
   *  Set the cursor to a valid column.
   */
  setCursor(e) {
    this.pos !== e && (this.pos = e), this.pos < 0 ? (this.logger.log(3, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > Xa && (this.logger.log(3, "Too large cursor position " + this.pos), this.pos = Xa);
  }
  /**
   * Move the cursor relative to current position.
   */
  moveCursor(e) {
    const r = this.pos + e;
    if (e > 1)
      for (let n = this.pos + 1; n < r + 1; n++)
        this.chars[n].setPenState(this.currPenState);
    this.setCursor(r);
  }
  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
  }
  insertChar(e) {
    e >= 144 && this.backSpace();
    const r = UU(e);
    if (this.pos >= Xa) {
      this.logger.log(0, () => "Cannot insert " + e.toString(16) + " (" + r + ") at position " + this.pos + ". Skipping it!");
      return;
    }
    this.chars[this.pos].setChar(r, this.currPenState), this.moveCursor(1);
  }
  clearFromPos(e) {
    let r;
    for (r = e; r < Xa; r++)
      this.chars[r].reset();
  }
  clear() {
    this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const e = [];
    let r = !0;
    for (let n = 0; n < Xa; n++) {
      const s = this.chars[n].uchar;
      s !== " " && (r = !1), e.push(s);
    }
    return r ? "" : e.join("");
  }
  setPenStyles(e) {
    this.currPenState.setStyles(e), this.chars[this.pos].setPenState(this.currPenState);
  }
}
class M_ {
  constructor(e) {
    this.rows = void 0, this.currRow = void 0, this.nrRollUpRows = void 0, this.lastOutputScreen = void 0, this.logger = void 0, this.rows = [];
    for (let r = 0; r < Os; r++)
      this.rows.push(new GJ(e));
    this.logger = e, this.currRow = Os - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.reset();
  }
  reset() {
    for (let e = 0; e < Os; e++)
      this.rows[e].clear();
    this.currRow = Os - 1;
  }
  equals(e) {
    let r = !0;
    for (let n = 0; n < Os; n++)
      if (!this.rows[n].equals(e.rows[n])) {
        r = !1;
        break;
      }
    return r;
  }
  copy(e) {
    for (let r = 0; r < Os; r++)
      this.rows[r].copy(e.rows[r]);
  }
  isEmpty() {
    let e = !0;
    for (let r = 0; r < Os; r++)
      if (!this.rows[r].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  backSpace() {
    this.rows[this.currRow].backSpace();
  }
  clearToEndOfRow() {
    this.rows[this.currRow].clearToEndOfRow();
  }
  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(e) {
    this.rows[this.currRow].insertChar(e);
  }
  setPen(e) {
    this.rows[this.currRow].setPenStyles(e);
  }
  moveCursor(e) {
    this.rows[this.currRow].moveCursor(e);
  }
  setCursor(e) {
    this.logger.log(2, "setCursor: " + e), this.rows[this.currRow].setCursor(e);
  }
  setPAC(e) {
    this.logger.log(2, () => "pacData = " + JSON.stringify(e));
    let r = e.row - 1;
    if (this.nrRollUpRows && r < this.nrRollUpRows - 1 && (r = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== r) {
      for (let l = 0; l < Os; l++)
        this.rows[l].clear();
      const a = this.currRow + 1 - this.nrRollUpRows, o = this.lastOutputScreen;
      if (o) {
        const l = o.rows[a].cueStartTime, u = this.logger.time;
        if (l && u !== null && l < u)
          for (let c = 0; c < this.nrRollUpRows; c++)
            this.rows[r - this.nrRollUpRows + c + 1].copy(o.rows[a + c]);
      }
    }
    this.currRow = r;
    const n = this.rows[this.currRow];
    if (e.indent !== null) {
      const a = e.indent, o = Math.max(a - 1, 0);
      n.setCursor(e.indent), e.color = n.chars[o].penState.foreground;
    }
    const s = {
      foreground: e.color,
      underline: e.underline,
      italics: e.italics,
      background: "black",
      flash: !1
    };
    this.setPen(s);
  }
  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(e) {
    this.logger.log(2, () => "bkgData = " + JSON.stringify(e)), this.backSpace(), this.setPen(e), this.insertChar(32);
  }
  setRollUpRows(e) {
    this.nrRollUpRows = e;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, "roll_up but nrRollUpRows not set yet");
      return;
    }
    this.logger.log(1, () => this.getDisplayText());
    const e = this.currRow + 1 - this.nrRollUpRows, r = this.rows.splice(e, 1)[0];
    r.clear(), this.rows.splice(this.currRow, 0, r), this.logger.log(2, "Rolling up");
  }
  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(e) {
    e = e || !1;
    const r = [];
    let n = "", s = -1;
    for (let a = 0; a < Os; a++) {
      const o = this.rows[a].getTextString();
      o && (s = a + 1, e ? r.push("Row " + s + ": '" + o + "'") : r.push(o.trim()));
    }
    return r.length > 0 && (e ? n = "[" + r.join(" | ") + "]" : n = r.join(`
`)), n;
  }
  getTextAndFormat() {
    return this.rows;
  }
}
class sP {
  constructor(e, r, n) {
    this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = e, this.outputFilter = r, this.mode = null, this.verbose = 0, this.displayedMemory = new M_(n), this.nonDisplayedMemory = new M_(n), this.lastOutputScreen = new M_(n), this.currRollUpRow = this.displayedMemory.rows[Os - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = n;
  }
  reset() {
    this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[Os - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(e) {
    this.outputFilter = e;
  }
  setPAC(e) {
    this.writeScreen.setPAC(e);
  }
  setBkgData(e) {
    this.writeScreen.setBkgData(e);
  }
  setMode(e) {
    e !== this.mode && (this.mode = e, this.logger.log(2, () => "MODE=" + e), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = e);
  }
  insertChars(e) {
    for (let n = 0; n < e.length; n++)
      this.writeScreen.insertChar(e[n]);
    const r = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
    this.logger.log(2, () => r + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(1, () => "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
  }
  ccRCL() {
    this.logger.log(2, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
  }
  ccBS() {
    this.logger.log(2, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
  }
  ccAOF() {
  }
  ccAON() {
  }
  ccDER() {
    this.logger.log(2, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
  }
  ccRU(e) {
    this.logger.log(2, "RU(" + e + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(e);
  }
  ccFON() {
    this.logger.log(2, "FON - Flash On"), this.writeScreen.setPen({
      flash: !0
    });
  }
  ccRDC() {
    this.logger.log(2, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
  }
  ccTR() {
    this.logger.log(2, "TR"), this.setMode("MODE_TEXT");
  }
  ccRTD() {
    this.logger.log(2, "RTD"), this.setMode("MODE_TEXT");
  }
  ccEDM() {
    this.logger.log(2, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
  }
  ccCR() {
    this.logger.log(2, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
  }
  ccENM() {
    this.logger.log(2, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    if (this.logger.log(2, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
      const e = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = e, this.writeScreen = this.nonDisplayedMemory, this.logger.log(1, () => "DISP: " + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(!0);
  }
  ccTO(e) {
    this.logger.log(2, "TO(" + e + ") - Tab Offset"), this.writeScreen.moveCursor(e);
  }
  ccMIDROW(e) {
    const r = {
      flash: !1
    };
    if (r.underline = e % 2 === 1, r.italics = e >= 46, r.italics)
      r.foreground = "white";
    else {
      const n = Math.floor(e / 2) - 16, s = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
      r.foreground = s[n];
    }
    this.logger.log(2, "MIDROW: " + JSON.stringify(r)), this.writeScreen.setPen(r);
  }
  outputDataUpdate(e = !1) {
    const r = this.logger.time;
    r !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = r : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, r, this.lastOutputScreen), e && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : r), this.lastOutputScreen.copy(this.displayedMemory));
  }
  cueSplitAtTime(e) {
    this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, e, this.displayedMemory), this.cueStartTime = e));
  }
}
class aP {
  constructor(e, r, n) {
    this.channels = void 0, this.currentChannel = 0, this.cmdHistory = void 0, this.logger = void 0;
    const s = new YJ();
    this.channels = [null, new sP(e, r, s), new sP(e + 1, n, s)], this.cmdHistory = lP(), this.logger = s;
  }
  getHandler(e) {
    return this.channels[e].getHandler();
  }
  setHandler(e, r) {
    this.channels[e].setHandler(r);
  }
  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(e, r) {
    let n, s, a, o = !1;
    this.logger.time = e;
    for (let l = 0; l < r.length; l += 2)
      if (s = r[l] & 127, a = r[l + 1] & 127, !(s === 0 && a === 0)) {
        if (this.logger.log(3, "[" + zl([r[l], r[l + 1]]) + "] -> (" + zl([s, a]) + ")"), n = this.parseCmd(s, a), n || (n = this.parseMidrow(s, a)), n || (n = this.parsePAC(s, a)), n || (n = this.parseBackgroundAttributes(s, a)), !n && (o = this.parseChars(s, a), o)) {
          const u = this.currentChannel;
          u && u > 0 ? this.channels[u].insertChars(o) : this.logger.log(2, "No channel found yet. TEXT-MODE?");
        }
        !n && !o && this.logger.log(2, "Couldn't parse cleaned data " + zl([s, a]) + " orig: " + zl([r[l], r[l + 1]]));
      }
  }
  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(e, r) {
    const {
      cmdHistory: n
    } = this, s = (e === 20 || e === 28 || e === 21 || e === 29) && r >= 32 && r <= 47, a = (e === 23 || e === 31) && r >= 33 && r <= 35;
    if (!(s || a))
      return !1;
    if (oP(e, r, n))
      return Ic(null, null, n), this.logger.log(3, "Repeated command (" + zl([e, r]) + ") is dropped"), !0;
    const o = e === 20 || e === 21 || e === 23 ? 1 : 2, l = this.channels[o];
    return e === 20 || e === 21 || e === 28 || e === 29 ? r === 32 ? l.ccRCL() : r === 33 ? l.ccBS() : r === 34 ? l.ccAOF() : r === 35 ? l.ccAON() : r === 36 ? l.ccDER() : r === 37 ? l.ccRU(2) : r === 38 ? l.ccRU(3) : r === 39 ? l.ccRU(4) : r === 40 ? l.ccFON() : r === 41 ? l.ccRDC() : r === 42 ? l.ccTR() : r === 43 ? l.ccRTD() : r === 44 ? l.ccEDM() : r === 45 ? l.ccCR() : r === 46 ? l.ccENM() : r === 47 && l.ccEOC() : l.ccTO(r - 32), Ic(e, r, n), this.currentChannel = o, !0;
  }
  /**
   * Parse midrow styling command
   */
  parseMidrow(e, r) {
    let n = 0;
    if ((e === 17 || e === 25) && r >= 32 && r <= 47) {
      if (e === 17 ? n = 1 : n = 2, n !== this.currentChannel)
        return this.logger.log(0, "Mismatch channel in midrow parsing"), !1;
      const s = this.channels[n];
      return s ? (s.ccMIDROW(r), this.logger.log(3, "MIDROW (" + zl([e, r]) + ")"), !0) : !1;
    }
    return !1;
  }
  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(e, r) {
    let n;
    const s = this.cmdHistory, a = (e >= 17 && e <= 23 || e >= 25 && e <= 31) && r >= 64 && r <= 127, o = (e === 16 || e === 24) && r >= 64 && r <= 95;
    if (!(a || o))
      return !1;
    if (oP(e, r, s))
      return Ic(null, null, s), !0;
    const l = e <= 23 ? 1 : 2;
    r >= 64 && r <= 95 ? n = l === 1 ? NJ[e] : BJ[e] : n = l === 1 ? FJ[e] : UJ[e];
    const u = this.channels[l];
    return u ? (u.setPAC(this.interpretPAC(n, r)), Ic(e, r, s), this.currentChannel = l, !0) : !1;
  }
  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(e, r) {
    let n;
    const s = {
      color: null,
      italics: !1,
      indent: null,
      underline: !1,
      row: e
    };
    return r > 95 ? n = r - 96 : n = r - 64, s.underline = (n & 1) === 1, n <= 13 ? s.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(n / 2)] : n <= 15 ? (s.italics = !0, s.color = "white") : s.indent = Math.floor((n - 16) / 2) * 4, s;
  }
  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(e, r) {
    let n, s = null, a = null;
    if (e >= 25 ? (n = 2, a = e - 8) : (n = 1, a = e), a >= 17 && a <= 19) {
      let o;
      a === 17 ? o = r + 80 : a === 18 ? o = r + 112 : o = r + 144, this.logger.log(2, "Special char '" + UU(o) + "' in channel " + n), s = [o];
    } else
      e >= 32 && e <= 127 && (s = r === 0 ? [e] : [e, r]);
    if (s) {
      const o = zl(s);
      this.logger.log(3, "Char codes =  " + o.join(",")), Ic(e, r, this.cmdHistory);
    }
    return s;
  }
  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(e, r) {
    const n = (e === 16 || e === 24) && r >= 32 && r <= 47, s = (e === 23 || e === 31) && r >= 45 && r <= 47;
    if (!(n || s))
      return !1;
    let a;
    const o = {};
    e === 16 || e === 24 ? (a = Math.floor((r - 32) / 2), o.background = VJ[a], r % 2 === 1 && (o.background = o.background + "_semi")) : r === 45 ? o.background = "transparent" : (o.foreground = "black", r === 47 && (o.underline = !0));
    const l = e <= 23 ? 1 : 2;
    return this.channels[l].setBkgData(o), Ic(e, r, this.cmdHistory), !0;
  }
  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let e = 0; e < Object.keys(this.channels).length; e++) {
      const r = this.channels[e];
      r && r.reset();
    }
    this.cmdHistory = lP();
  }
  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(e) {
    for (let r = 0; r < this.channels.length; r++) {
      const n = this.channels[r];
      n && n.cueSplitAtTime(e);
    }
  }
}
function Ic(t, e, r) {
  r.a = t, r.b = e;
}
function oP(t, e, r) {
  return r.a === t && r.b === e;
}
function lP() {
  return {
    a: null,
    b: null
  };
}
class xm {
  constructor(e, r) {
    this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = e, this.trackName = r;
  }
  dispatchCue() {
    this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
  }
  newCue(e, r, n) {
    (this.startTime === null || this.startTime > e) && (this.startTime = e), this.endTime = r, this.screen = n, this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [], this.startTime = null;
  }
}
var Zk = function() {
  if (typeof self < "u" && self.VTTCue)
    return self.VTTCue;
  const t = ["", "lr", "rl"], e = ["start", "middle", "end", "left", "right"];
  function r(l, u) {
    if (typeof u != "string" || !Array.isArray(l))
      return !1;
    const c = u.toLowerCase();
    return ~l.indexOf(c) ? c : !1;
  }
  function n(l) {
    return r(t, l);
  }
  function s(l) {
    return r(e, l);
  }
  function a(l, ...u) {
    let c = 1;
    for (; c < arguments.length; c++) {
      const d = arguments[c];
      for (const h in d)
        l[h] = d[h];
    }
    return l;
  }
  function o(l, u, c) {
    const d = this, h = {
      enumerable: !0
    };
    d.hasBeenReset = !1;
    let f = "", p = !1, m = l, b = u, y = c, _ = null, x = "", T = !0, k = "auto", E = "start", F = 50, R = "middle", $ = 50, O = "middle";
    Object.defineProperty(d, "id", a({}, h, {
      get: function() {
        return f;
      },
      set: function(P) {
        f = "" + P;
      }
    })), Object.defineProperty(d, "pauseOnExit", a({}, h, {
      get: function() {
        return p;
      },
      set: function(P) {
        p = !!P;
      }
    })), Object.defineProperty(d, "startTime", a({}, h, {
      get: function() {
        return m;
      },
      set: function(P) {
        if (typeof P != "number")
          throw new TypeError("Start time must be set to a number.");
        m = P, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(d, "endTime", a({}, h, {
      get: function() {
        return b;
      },
      set: function(P) {
        if (typeof P != "number")
          throw new TypeError("End time must be set to a number.");
        b = P, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(d, "text", a({}, h, {
      get: function() {
        return y;
      },
      set: function(P) {
        y = "" + P, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(d, "region", a({}, h, {
      get: function() {
        return _;
      },
      set: function(P) {
        _ = P, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(d, "vertical", a({}, h, {
      get: function() {
        return x;
      },
      set: function(P) {
        const N = n(P);
        if (N === !1)
          throw new SyntaxError("An invalid or illegal string was specified.");
        x = N, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(d, "snapToLines", a({}, h, {
      get: function() {
        return T;
      },
      set: function(P) {
        T = !!P, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(d, "line", a({}, h, {
      get: function() {
        return k;
      },
      set: function(P) {
        if (typeof P != "number" && P !== "auto")
          throw new SyntaxError("An invalid number or illegal string was specified.");
        k = P, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(d, "lineAlign", a({}, h, {
      get: function() {
        return E;
      },
      set: function(P) {
        const N = s(P);
        if (!N)
          throw new SyntaxError("An invalid or illegal string was specified.");
        E = N, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(d, "position", a({}, h, {
      get: function() {
        return F;
      },
      set: function(P) {
        if (P < 0 || P > 100)
          throw new Error("Position must be between 0 and 100.");
        F = P, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(d, "positionAlign", a({}, h, {
      get: function() {
        return R;
      },
      set: function(P) {
        const N = s(P);
        if (!N)
          throw new SyntaxError("An invalid or illegal string was specified.");
        R = N, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(d, "size", a({}, h, {
      get: function() {
        return $;
      },
      set: function(P) {
        if (P < 0 || P > 100)
          throw new Error("Size must be between 0 and 100.");
        $ = P, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(d, "align", a({}, h, {
      get: function() {
        return O;
      },
      set: function(P) {
        const N = s(P);
        if (!N)
          throw new SyntaxError("An invalid or illegal string was specified.");
        O = N, this.hasBeenReset = !0;
      }
    })), d.displayState = void 0;
  }
  return o.prototype.getCueAsHTML = function() {
    return self.WebVTT.convertCueToDOMTree(self, this.text);
  }, o;
}();
class WJ {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  decode(e, r) {
    if (!e)
      return "";
    if (typeof e != "string")
      throw new Error("Error - expected string data.");
    return decodeURIComponent(encodeURIComponent(e));
  }
}
function YU(t) {
  function e(n, s, a, o) {
    return (n | 0) * 3600 + (s | 0) * 60 + (a | 0) + parseFloat(o || 0);
  }
  const r = t.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  return r ? parseFloat(r[2]) > 59 ? e(r[2], r[3], 0, r[4]) : e(r[1], r[2], r[3], r[4]) : null;
}
class jJ {
  constructor() {
    this.values = /* @__PURE__ */ Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(e, r) {
    !this.get(e) && r !== "" && (this.values[e] = r);
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(e, r, n) {
    return n ? this.has(e) ? this.values[e] : r[n] : this.has(e) ? this.values[e] : r;
  }
  // Check whether we have a value for a key.
  has(e) {
    return e in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(e, r, n) {
    for (let s = 0; s < n.length; ++s)
      if (r === n[s]) {
        this.set(e, r);
        break;
      }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(e, r) {
    /^-?\d+$/.test(r) && this.set(e, parseInt(r, 10));
  }
  // Accept a setting if its a valid percentage.
  percent(e, r) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(r)) {
      const n = parseFloat(r);
      if (n >= 0 && n <= 100)
        return this.set(e, n), !0;
    }
    return !1;
  }
}
function HU(t, e, r, n) {
  const s = n ? t.split(n) : [t];
  for (const a in s) {
    if (typeof s[a] != "string")
      continue;
    const o = s[a].split(r);
    if (o.length !== 2)
      continue;
    const l = o[0], u = o[1];
    e(l, u);
  }
}
const ix = new Zk(0, 0, ""), Sm = ix.align === "middle" ? "middle" : "center";
function KJ(t, e, r) {
  const n = t;
  function s() {
    const l = YU(t);
    if (l === null)
      throw new Error("Malformed timestamp: " + n);
    return t = t.replace(/^[^\sa-zA-Z-]+/, ""), l;
  }
  function a(l, u) {
    const c = new jJ();
    HU(l, function(f, p) {
      let m;
      switch (f) {
        case "region":
          for (let b = r.length - 1; b >= 0; b--)
            if (r[b].id === p) {
              c.set(f, r[b].region);
              break;
            }
          break;
        case "vertical":
          c.alt(f, p, ["rl", "lr"]);
          break;
        case "line":
          m = p.split(","), c.integer(f, m[0]), c.percent(f, m[0]) && c.set("snapToLines", !1), c.alt(f, m[0], ["auto"]), m.length === 2 && c.alt("lineAlign", m[1], ["start", Sm, "end"]);
          break;
        case "position":
          m = p.split(","), c.percent(f, m[0]), m.length === 2 && c.alt("positionAlign", m[1], ["start", Sm, "end", "line-left", "line-right", "auto"]);
          break;
        case "size":
          c.percent(f, p);
          break;
        case "align":
          c.alt(f, p, ["start", Sm, "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), u.region = c.get("region", null), u.vertical = c.get("vertical", "");
    let d = c.get("line", "auto");
    d === "auto" && ix.line === -1 && (d = -1), u.line = d, u.lineAlign = c.get("lineAlign", "start"), u.snapToLines = c.get("snapToLines", !0), u.size = c.get("size", 100), u.align = c.get("align", Sm);
    let h = c.get("position", "auto");
    h === "auto" && ix.position === 50 && (h = u.align === "start" || u.align === "left" ? 0 : u.align === "end" || u.align === "right" ? 100 : 50), u.position = h;
  }
  function o() {
    t = t.replace(/^\s+/, "");
  }
  if (o(), e.startTime = s(), o(), t.slice(0, 3) !== "-->")
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + n);
  t = t.slice(3), o(), e.endTime = s(), o(), a(t, e);
}
function GU(t) {
  return t.replace(/<br(?: \/)?>/gi, `
`);
}
class zJ {
  constructor() {
    this.state = "INITIAL", this.buffer = "", this.decoder = new WJ(), this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
  }
  parse(e) {
    const r = this;
    e && (r.buffer += r.decoder.decode(e, {
      stream: !0
    }));
    function n() {
      let a = r.buffer, o = 0;
      for (a = GU(a); o < a.length && a[o] !== "\r" && a[o] !== `
`; )
        ++o;
      const l = a.slice(0, o);
      return a[o] === "\r" && ++o, a[o] === `
` && ++o, r.buffer = a.slice(o), l;
    }
    function s(a) {
      HU(a, function(o, l) {
      }, /:/);
    }
    try {
      let a = "";
      if (r.state === "INITIAL") {
        if (!/\r\n|\n/.test(r.buffer))
          return this;
        a = n();
        const l = a.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(l != null && l[0]))
          throw new Error("Malformed WebVTT signature.");
        r.state = "HEADER";
      }
      let o = !1;
      for (; r.buffer; ) {
        if (!/\r\n|\n/.test(r.buffer))
          return this;
        switch (o ? o = !1 : a = n(), r.state) {
          case "HEADER":
            /:/.test(a) ? s(a) : a || (r.state = "ID");
            continue;
          case "NOTE":
            a || (r.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(a)) {
              r.state = "NOTE";
              break;
            }
            if (!a)
              continue;
            if (r.cue = new Zk(0, 0, ""), r.state = "CUE", a.indexOf("-->") === -1) {
              r.cue.id = a;
              continue;
            }
          case "CUE":
            if (!r.cue) {
              r.state = "BADCUE";
              continue;
            }
            try {
              KJ(a, r.cue, r.regionList);
            } catch {
              r.cue = null, r.state = "BADCUE";
              continue;
            }
            r.state = "CUETEXT";
            continue;
          case "CUETEXT":
            {
              const l = a.indexOf("-->") !== -1;
              if (!a || l && (o = !0)) {
                r.oncue && r.cue && r.oncue(r.cue), r.cue = null, r.state = "ID";
                continue;
              }
              if (r.cue === null)
                continue;
              r.cue.text && (r.cue.text += `
`), r.cue.text += a;
            }
            continue;
          case "BADCUE":
            a || (r.state = "ID");
        }
      }
    } catch {
      r.state === "CUETEXT" && r.cue && r.oncue && r.oncue(r.cue), r.cue = null, r.state = r.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  }
  flush() {
    const e = this;
    try {
      if ((e.cue || e.state === "HEADER") && (e.buffer += `

`, e.parse()), e.state === "INITIAL" || e.state === "BADWEBVTT")
        throw new Error("Malformed WebVTT signature.");
    } catch (r) {
      e.onparsingerror && e.onparsingerror(r);
    }
    return e.onflush && e.onflush(), this;
  }
}
const qJ = /\r\n|\n\r|\n|\r/g, L_ = function(e, r, n = 0) {
  return e.slice(n, n + r.length) === r;
}, XJ = function(e) {
  let r = parseInt(e.slice(-3));
  const n = parseInt(e.slice(-6, -4)), s = parseInt(e.slice(-9, -7)), a = e.length > 9 ? parseInt(e.substring(0, e.indexOf(":"))) : 0;
  if (!et(r) || !et(n) || !et(s) || !et(a))
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${e}`);
  return r += 1e3 * n, r += 60 * 1e3 * s, r += 60 * 60 * 1e3 * a, r;
}, N_ = function(e) {
  let r = 5381, n = e.length;
  for (; n; )
    r = r * 33 ^ e.charCodeAt(--n);
  return (r >>> 0).toString();
};
function Jk(t, e, r) {
  return N_(t.toString()) + N_(e.toString()) + N_(r);
}
const QJ = function(e, r, n) {
  let s = e[r], a = e[s.prevCC];
  if (!a || !a.new && s.new) {
    e.ccOffset = e.presentationOffset = s.start, s.new = !1;
    return;
  }
  for (; (o = a) != null && o.new; ) {
    var o;
    e.ccOffset += s.start - a.start, s.new = !1, s = a, a = e[s.prevCC];
  }
  e.presentationOffset = n;
};
function ZJ(t, e, r, n, s, a, o) {
  const l = new zJ(), u = xa(new Uint8Array(t)).trim().replace(qJ, `
`).split(`
`), c = [], d = e ? uJ(e.baseTime, e.timescale) : 0;
  let h = "00:00.000", f = 0, p = 0, m, b = !0;
  l.oncue = function(y) {
    const _ = r[n];
    let x = r.ccOffset;
    const T = (f - d) / 9e4;
    if (_ != null && _.new && (p !== void 0 ? x = r.ccOffset = _.start : QJ(r, n, T)), T) {
      if (!e) {
        m = new Error("Missing initPTS for VTT MPEGTS");
        return;
      }
      x = T - r.presentationOffset;
    }
    const k = y.endTime - y.startTime, E = ss((y.startTime + x - p) * 9e4, s * 9e4) / 9e4;
    y.startTime = Math.max(E, 0), y.endTime = Math.max(E + k, 0);
    const F = y.text.trim();
    y.text = decodeURIComponent(encodeURIComponent(F)), y.id || (y.id = Jk(y.startTime, y.endTime, F)), y.endTime > 0 && c.push(y);
  }, l.onparsingerror = function(y) {
    m = y;
  }, l.onflush = function() {
    if (m) {
      o(m);
      return;
    }
    a(c);
  }, u.forEach((y) => {
    if (b)
      if (L_(y, "X-TIMESTAMP-MAP=")) {
        b = !1, y.slice(16).split(",").forEach((_) => {
          L_(_, "LOCAL:") ? h = _.slice(6) : L_(_, "MPEGTS:") && (f = parseInt(_.slice(7)));
        });
        try {
          p = XJ(h) / 1e3;
        } catch (_) {
          m = _;
        }
        return;
      } else
        y === "" && (b = !1);
    l.parse(y + `
`);
  }), l.flush();
}
const F_ = "stpp.ttml.im1t", WU = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, jU = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/, JJ = {
  left: "start",
  center: "center",
  right: "end",
  start: "start",
  end: "end"
};
function uP(t, e, r, n) {
  const s = Nt(new Uint8Array(t), ["mdat"]);
  if (s.length === 0) {
    n(new Error("Could not parse IMSC1 mdat"));
    return;
  }
  const a = s.map((l) => xa(l)), o = lJ(e.baseTime, 1, e.timescale);
  try {
    a.forEach((l) => r(eee(l, o)));
  } catch (l) {
    n(l);
  }
}
function eee(t, e) {
  const s = new DOMParser().parseFromString(t, "text/xml").getElementsByTagName("tt")[0];
  if (!s)
    throw new Error("Invalid ttml");
  const a = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  }, o = Object.keys(a).reduce((h, f) => (h[f] = s.getAttribute(`ttp:${f}`) || a[f], h), {}), l = s.getAttribute("xml:space") !== "preserve", u = cP(B_(s, "styling", "style")), c = cP(B_(s, "layout", "region")), d = B_(s, "body", "[begin]");
  return [].map.call(d, (h) => {
    const f = KU(h, l);
    if (!f || !h.hasAttribute("begin"))
      return null;
    const p = V_(h.getAttribute("begin"), o), m = V_(h.getAttribute("dur"), o);
    let b = V_(h.getAttribute("end"), o);
    if (p === null)
      throw dP(h);
    if (b === null) {
      if (m === null)
        throw dP(h);
      b = p + m;
    }
    const y = new Zk(p - e, b - e, f);
    y.id = Jk(y.startTime, y.endTime, y.text);
    const _ = c[h.getAttribute("region")], x = u[h.getAttribute("style")], T = tee(_, x, u), {
      textAlign: k
    } = T;
    if (k) {
      const E = JJ[k];
      E && (y.lineAlign = E), y.align = k;
    }
    return hn(y, T), y;
  }).filter((h) => h !== null);
}
function B_(t, e, r) {
  const n = t.getElementsByTagName(e)[0];
  return n ? [].slice.call(n.querySelectorAll(r)) : [];
}
function cP(t) {
  return t.reduce((e, r) => {
    const n = r.getAttribute("xml:id");
    return n && (e[n] = r), e;
  }, {});
}
function KU(t, e) {
  return [].slice.call(t.childNodes).reduce((r, n, s) => {
    var a;
    return n.nodeName === "br" && s ? r + `
` : (a = n.childNodes) != null && a.length ? KU(n, e) : e ? r + n.textContent.trim().replace(/\s+/g, " ") : r + n.textContent;
  }, "");
}
function tee(t, e, r) {
  const n = "http://www.w3.org/ns/ttml#styling";
  let s = null;
  const a = [
    "displayAlign",
    "textAlign",
    "color",
    "backgroundColor",
    "fontSize",
    "fontFamily"
    // 'fontWeight',
    // 'lineHeight',
    // 'wrapOption',
    // 'fontStyle',
    // 'direction',
    // 'writingMode'
  ], o = t != null && t.hasAttribute("style") ? t.getAttribute("style") : null;
  return o && r.hasOwnProperty(o) && (s = r[o]), a.reduce((l, u) => {
    const c = U_(e, n, u) || U_(t, n, u) || U_(s, n, u);
    return c && (l[u] = c), l;
  }, {});
}
function U_(t, e, r) {
  return t && t.hasAttributeNS(e, r) ? t.getAttributeNS(e, r) : null;
}
function dP(t) {
  return new Error(`Could not parse ttml timestamp ${t}`);
}
function V_(t, e) {
  if (!t)
    return null;
  let r = YU(t);
  return r === null && (WU.test(t) ? r = ree(t, e) : jU.test(t) && (r = nee(t, e))), r;
}
function ree(t, e) {
  const r = WU.exec(t), n = (r[4] | 0) + (r[5] | 0) / e.subFrameRate;
  return (r[1] | 0) * 3600 + (r[2] | 0) * 60 + (r[3] | 0) + n / e.frameRate;
}
function nee(t, e) {
  const r = jU.exec(t), n = Number(r[1]);
  switch (r[2]) {
    case "h":
      return n * 3600;
    case "m":
      return n * 60;
    case "ms":
      return n * 1e3;
    case "f":
      return n / e.frameRate;
    case "t":
      return n / e.tickRate;
  }
  return n;
}
class iee {
  constructor(e) {
    if (this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = hP(), this.captionsProperties = void 0, this.hls = e, this.config = e.config, this.Cues = e.config.cueHandler, this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    }, this.config.enableCEA708Captions) {
      const r = new xm(this, "textTrack1"), n = new xm(this, "textTrack2"), s = new xm(this, "textTrack3"), a = new xm(this, "textTrack4");
      this.cea608Parser1 = new aP(1, r, n), this.cea608Parser2 = new aP(3, s, a);
    }
    e.on(D.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(D.MANIFEST_LOADING, this.onManifestLoading, this), e.on(D.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(D.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(D.FRAG_LOADING, this.onFragLoading, this), e.on(D.FRAG_LOADED, this.onFragLoaded, this), e.on(D.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.on(D.FRAG_DECRYPTED, this.onFragDecrypted, this), e.on(D.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(D.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.on(D.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls: e
    } = this;
    e.off(D.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(D.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(D.MANIFEST_LOADING, this.onManifestLoading, this), e.off(D.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(D.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(D.FRAG_LOADING, this.onFragLoading, this), e.off(D.FRAG_LOADED, this.onFragLoaded, this), e.off(D.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.off(D.FRAG_DECRYPTED, this.onFragDecrypted, this), e.off(D.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(D.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.off(D.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = this.cea608Parser1 = this.cea608Parser2 = null;
  }
  addCues(e, r, n, s, a) {
    let o = !1;
    for (let l = a.length; l--; ) {
      const u = a[l], c = aee(u[0], u[1], r, n);
      if (c >= 0 && (u[0] = Math.min(u[0], r), u[1] = Math.max(u[1], n), o = !0, c / (n - r) > 0.5))
        return;
    }
    if (o || a.push([r, n]), this.config.renderTextTracksNatively) {
      const l = this.captionsTracks[e];
      this.Cues.newCue(l, r, n, s);
    } else {
      const l = this.Cues.newCue(null, r, n, s);
      this.hls.trigger(D.CUES_PARSED, {
        type: "captions",
        cues: l,
        track: e
      });
    }
  }
  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(e, {
    frag: r,
    id: n,
    initPTS: s,
    timescale: a
  }) {
    const {
      unparsedVttFrags: o
    } = this;
    n === "main" && (this.initPTS[r.cc] = {
      baseTime: s,
      timescale: a
    }), o.length && (this.unparsedVttFrags = [], o.forEach((l) => {
      this.onFragLoaded(D.FRAG_LOADED, l);
    }));
  }
  getExistingTrack(e) {
    const {
      media: r
    } = this;
    if (r)
      for (let n = 0; n < r.textTracks.length; n++) {
        const s = r.textTracks[n];
        if (s[e])
          return s;
      }
    return null;
  }
  createCaptionsTrack(e) {
    this.config.renderTextTracksNatively ? this.createNativeTrack(e) : this.createNonNativeTrack(e);
  }
  createNativeTrack(e) {
    if (this.captionsTracks[e])
      return;
    const {
      captionsProperties: r,
      captionsTracks: n,
      media: s
    } = this, {
      label: a,
      languageCode: o
    } = r[e], l = this.getExistingTrack(e);
    if (l)
      n[e] = l, td(n[e]), vU(n[e], s);
    else {
      const u = this.createTextTrack("captions", a, o);
      u && (u[e] = !0, n[e] = u);
    }
  }
  createNonNativeTrack(e) {
    if (this.nonNativeCaptionsTracks[e])
      return;
    const r = this.captionsProperties[e];
    if (!r)
      return;
    const n = r.label, s = {
      _id: e,
      label: n,
      kind: "captions",
      default: r.media ? !!r.media.default : !1,
      closedCaptions: r.media
    };
    this.nonNativeCaptionsTracks[e] = s, this.hls.trigger(D.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [s]
    });
  }
  createTextTrack(e, r, n) {
    const s = this.media;
    if (s)
      return s.addTextTrack(e, r, n);
  }
  onMediaAttaching(e, r) {
    this.media = r.media, this._cleanTracks();
  }
  onMediaDetaching() {
    const {
      captionsTracks: e
    } = this;
    Object.keys(e).forEach((r) => {
      td(e[r]), delete e[r];
    }), this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = hP(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = [], this.initPTS = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
  }
  _cleanTracks() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const r = e.textTracks;
    if (r)
      for (let n = 0; n < r.length; n++)
        td(r[n]);
  }
  onSubtitleTracksUpdated(e, r) {
    const n = r.subtitleTracks || [], s = n.some((a) => a.textCodec === F_);
    if (this.config.enableWebVTT || s && this.config.enableIMSC1) {
      if (BU(this.tracks, n)) {
        this.tracks = n;
        return;
      }
      if (this.textTracks = [], this.tracks = n, this.config.renderTextTracksNatively) {
        const o = this.media ? this.media.textTracks : null;
        this.tracks.forEach((l, u) => {
          let c;
          if (o && u < o.length) {
            let d = null;
            for (let h = 0; h < o.length; h++)
              if (see(o[h], l)) {
                d = o[h];
                break;
              }
            d && (c = d);
          }
          if (c)
            td(c);
          else {
            const d = this._captionsOrSubtitlesFromCharacteristics(l);
            c = this.createTextTrack(d, l.name, l.lang), c && (c.mode = "disabled");
          }
          c && (c.groupId = l.groupId, this.textTracks.push(c));
        });
      } else if (this.tracks.length) {
        const o = this.tracks.map((l) => ({
          label: l.name,
          kind: l.type.toLowerCase(),
          default: l.default,
          subtitleTrack: l
        }));
        this.hls.trigger(D.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: o
        });
      }
    }
  }
  _captionsOrSubtitlesFromCharacteristics(e) {
    if (e.attrs.CHARACTERISTICS) {
      const r = /transcribes-spoken-dialog/gi.test(e.attrs.CHARACTERISTICS), n = /describes-music-and-sound/gi.test(e.attrs.CHARACTERISTICS);
      if (r && n)
        return "captions";
    }
    return "subtitles";
  }
  onManifestLoaded(e, r) {
    this.config.enableCEA708Captions && r.captions && r.captions.forEach((n) => {
      const s = /(?:CC|SERVICE)([1-4])/.exec(n.instreamId);
      if (!s)
        return;
      const a = `textTrack${s[1]}`, o = this.captionsProperties[a];
      o && (o.label = n.name, n.lang && (o.languageCode = n.lang), o.media = n);
    });
  }
  closedCaptionsForLevel(e) {
    const r = this.hls.levels[e.level];
    return r == null ? void 0 : r.attrs["CLOSED-CAPTIONS"];
  }
  onFragLoading(e, r) {
    const {
      cea608Parser1: n,
      cea608Parser2: s,
      lastSn: a,
      lastPartIndex: o
    } = this;
    if (!(!this.enabled || !(n && s)) && r.frag.type === at.MAIN) {
      var l, u;
      const c = r.frag.sn, d = (l = r == null || (u = r.part) == null ? void 0 : u.index) != null ? l : -1;
      c === a + 1 || c === a && d === o + 1 || (n.reset(), s.reset()), this.lastSn = c, this.lastPartIndex = d;
    }
  }
  onFragLoaded(e, r) {
    const {
      frag: n,
      payload: s
    } = r;
    if (n.type === at.SUBTITLE)
      if (s.byteLength) {
        const a = n.decryptdata, o = "stats" in r;
        if (a == null || !a.encrypted || o) {
          const l = this.tracks[n.level], u = this.vttCCs;
          u[n.cc] || (u[n.cc] = {
            start: n.start,
            prevCC: this.prevCC,
            new: !0
          }, this.prevCC = n.cc), l && l.textCodec === F_ ? this._parseIMSC1(n, s) : this._parseVTTs(r);
        }
      } else
        this.hls.trigger(D.SUBTITLE_FRAG_PROCESSED, {
          success: !1,
          frag: n,
          error: new Error("Empty subtitle payload")
        });
  }
  _parseIMSC1(e, r) {
    const n = this.hls;
    uP(r, this.initPTS[e.cc], (s) => {
      this._appendCues(s, e.level), n.trigger(D.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: e
      });
    }, (s) => {
      J.log(`Failed to parse IMSC1: ${s}`), n.trigger(D.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: e,
        error: s
      });
    });
  }
  _parseVTTs(e) {
    var r;
    const {
      frag: n,
      payload: s
    } = e, {
      initPTS: a,
      unparsedVttFrags: o
    } = this, l = a.length - 1;
    if (!a[n.cc] && l === -1) {
      o.push(e);
      return;
    }
    const u = this.hls, c = (r = n.initSegment) != null && r.data ? Bu(n.initSegment.data, new Uint8Array(s)) : s;
    ZJ(c, this.initPTS[n.cc], this.vttCCs, n.cc, n.start, (d) => {
      this._appendCues(d, n.level), u.trigger(D.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: n
      });
    }, (d) => {
      const h = d.message === "Missing initPTS for VTT MPEGTS";
      h ? o.push(e) : this._fallbackToIMSC1(n, s), J.log(`Failed to parse VTT cue: ${d}`), !(h && l > n.cc) && u.trigger(D.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: n,
        error: d
      });
    });
  }
  _fallbackToIMSC1(e, r) {
    const n = this.tracks[e.level];
    n.textCodec || uP(r, this.initPTS[e.cc], () => {
      n.textCodec = F_, this._parseIMSC1(e, r);
    }, () => {
      n.textCodec = "wvtt";
    });
  }
  _appendCues(e, r) {
    const n = this.hls;
    if (this.config.renderTextTracksNatively) {
      const s = this.textTracks[r];
      if (!s || s.mode === "disabled")
        return;
      e.forEach((a) => mU(s, a));
    } else {
      const s = this.tracks[r];
      if (!s)
        return;
      const a = s.default ? "default" : "subtitles" + r;
      n.trigger(D.CUES_PARSED, {
        type: "subtitles",
        cues: e,
        track: a
      });
    }
  }
  onFragDecrypted(e, r) {
    const {
      frag: n
    } = r;
    n.type === at.SUBTITLE && this.onFragLoaded(D.FRAG_LOADED, r);
  }
  onSubtitleTracksCleared() {
    this.tracks = [], this.captionsTracks = {};
  }
  onFragParsingUserdata(e, r) {
    const {
      cea608Parser1: n,
      cea608Parser2: s
    } = this;
    if (!this.enabled || !(n && s))
      return;
    const {
      frag: a,
      samples: o
    } = r;
    if (!(a.type === at.MAIN && this.closedCaptionsForLevel(a) === "NONE"))
      for (let l = 0; l < o.length; l++) {
        const u = o[l].bytes;
        if (u) {
          const c = this.extractCea608Data(u);
          n.addData(o[l].pts, c[0]), s.addData(o[l].pts, c[1]);
        }
      }
  }
  onBufferFlushing(e, {
    startOffset: r,
    endOffset: n,
    endOffsetSubtitles: s,
    type: a
  }) {
    const {
      media: o
    } = this;
    if (!(!o || o.currentTime < n)) {
      if (!a || a === "video") {
        const {
          captionsTracks: l
        } = this;
        Object.keys(l).forEach((u) => ZT(l[u], r, n));
      }
      if (this.config.renderTextTracksNatively && r === 0 && s !== void 0) {
        const {
          textTracks: l
        } = this;
        Object.keys(l).forEach((u) => ZT(l[u], r, s));
      }
    }
  }
  extractCea608Data(e) {
    const r = [[], []], n = e[0] & 31;
    let s = 2;
    for (let a = 0; a < n; a++) {
      const o = e[s++], l = 127 & e[s++], u = 127 & e[s++];
      if (l === 0 && u === 0)
        continue;
      if ((4 & o) !== 0) {
        const d = 3 & o;
        (d === 0 || d === 1) && (r[d].push(l), r[d].push(u));
      }
    }
    return r;
  }
}
function see(t, e) {
  return !!t && t.label === e.name && !(t.textTrack1 || t.textTrack2);
}
function aee(t, e, r, n) {
  return Math.min(e, n) - Math.max(t, r);
}
function hP() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: !0
    }
  };
}
class eD {
  constructor(e) {
    this.hls = void 0, this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.clientRect = void 0, this.streamController = void 0, this.hls = e, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  destroy() {
    this.unregisterListener(), this.hls.config.capLevelToPlayerSize && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(D.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.on(D.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(D.MANIFEST_PARSED, this.onManifestParsed, this), e.on(D.BUFFER_CODECS, this.onBufferCodecs, this), e.on(D.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls: e
    } = this;
    e.off(D.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.off(D.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(D.MANIFEST_PARSED, this.onManifestParsed, this), e.off(D.BUFFER_CODECS, this.onBufferCodecs, this), e.off(D.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(e, r) {
    const n = this.hls.levels[r.droppedLevel];
    this.isLevelAllowed(n) && this.restrictedLevels.push({
      bitrate: n.bitrate,
      height: n.height,
      width: n.width
    });
  }
  onMediaAttaching(e, r) {
    this.media = r.media instanceof HTMLVideoElement ? r.media : null, this.clientRect = null;
  }
  onManifestParsed(e, r) {
    const n = this.hls;
    this.restrictedLevels = [], this.firstLevel = r.firstLevel, n.config.capLevelToPlayerSize && r.video && this.startCapping();
  }
  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(e, r) {
    this.hls.config.capLevelToPlayerSize && r.video && this.startCapping();
  }
  onMediaDetaching() {
    this.stopCapping();
  }
  detectPlayerSize() {
    if (this.media && this.mediaHeight > 0 && this.mediaWidth > 0) {
      const e = this.hls.levels;
      if (e.length) {
        const r = this.hls;
        r.autoLevelCapping = this.getMaxLevel(e.length - 1), r.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = r.autoLevelCapping;
      }
    }
  }
  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(e) {
    const r = this.hls.levels;
    if (!r.length)
      return -1;
    const n = r.filter((s, a) => this.isLevelAllowed(s) && a <= e);
    return this.clientRect = null, eD.getMaxLevelByMediaSize(n, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, this.hls.firstLevel = this.getMaxLevel(this.firstLevel), self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
  }
  stopCapping() {
    this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
  }
  getDimensions() {
    if (this.clientRect)
      return this.clientRect;
    const e = this.media, r = {
      width: 0,
      height: 0
    };
    if (e) {
      const n = e.getBoundingClientRect();
      r.width = n.width, r.height = n.height, !r.width && !r.height && (r.width = n.right - n.left || e.width || 0, r.height = n.bottom - n.top || e.height || 0);
    }
    return this.clientRect = r, r;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let e = 1;
    if (!this.hls.config.ignoreDevicePixelRatio)
      try {
        e = self.devicePixelRatio;
      } catch {
      }
    return e;
  }
  isLevelAllowed(e) {
    return !this.restrictedLevels.some((n) => e.bitrate === n.bitrate && e.width === n.width && e.height === n.height);
  }
  static getMaxLevelByMediaSize(e, r, n) {
    if (!(e != null && e.length))
      return -1;
    const s = (o, l) => l ? o.width !== l.width || o.height !== l.height : !0;
    let a = e.length - 1;
    for (let o = 0; o < e.length; o += 1) {
      const l = e[o];
      if ((l.width >= r || l.height >= n) && s(l, e[o + 1])) {
        a = o;
        break;
      }
    }
    return a;
  }
}
class oee {
  // stream controller must be provided as a dependency!
  constructor(e) {
    this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = e, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  registerListeners() {
    this.hls.on(D.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  unregisterListeners() {
    this.hls.off(D.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  destroy() {
    this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
  }
  onMediaAttaching(e, r) {
    const n = this.hls.config;
    if (n.capLevelOnFPSDrop) {
      const s = r.media instanceof self.HTMLVideoElement ? r.media : null;
      this.media = s, s && typeof s.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), n.fpsDroppedMonitoringPeriod);
    }
  }
  checkFPS(e, r, n) {
    const s = performance.now();
    if (r) {
      if (this.lastTime) {
        const a = s - this.lastTime, o = n - this.lastDroppedFrames, l = r - this.lastDecodedFrames, u = 1e3 * o / a, c = this.hls;
        if (c.trigger(D.FPS_DROP, {
          currentDropped: o,
          currentDecoded: l,
          totalDroppedFrames: n
        }), u > 0 && o > c.config.fpsDroppedMonitoringThreshold * l) {
          let d = c.currentLevel;
          J.warn("drop FPS ratio greater than max allowed value for currentLevel: " + d), d > 0 && (c.autoLevelCapping === -1 || c.autoLevelCapping >= d) && (d = d - 1, c.trigger(D.FPS_DROP_LEVEL_CAPPING, {
            level: d,
            droppedLevel: c.currentLevel
          }), c.autoLevelCapping = d, this.streamController.nextLevelSwitch());
        }
      }
      this.lastTime = s, this.lastDroppedFrames = n, this.lastDecodedFrames = r;
    }
  }
  checkFPSInterval() {
    const e = this.media;
    if (e)
      if (this.isVideoPlaybackQualityAvailable) {
        const r = e.getVideoPlaybackQuality();
        this.checkFPS(e, r.totalVideoFrames, r.droppedVideoFrames);
      } else
        this.checkFPS(e, e.webkitDecodedFrameCount, e.webkitDroppedFrameCount);
  }
}
const Em = "[eme]";
class Td {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.keyFormatPromise = null, this.keySystemAccessPromises = {}, this._requestLicenseFailureCount = 0, this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, this.setMediaKeysQueue = Td.CDMCleanupPromise ? [Td.CDMCleanupPromise] : [], this.onMediaEncrypted = this._onMediaEncrypted.bind(this), this.onWaitingForKey = this._onWaitingForKey.bind(this), this.debug = J.debug.bind(J, Em), this.log = J.log.bind(J, Em), this.warn = J.warn.bind(J, Em), this.error = J.error.bind(J, Em), this.hls = e, this.config = e.config, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached();
    const e = this.config;
    e.requestMediaKeySystemAccessFunc = null, e.licenseXhrSetup = e.licenseResponseCallback = void 0, e.drmSystems = e.drmSystemOptions = {}, this.hls = this.onMediaEncrypted = this.onWaitingForKey = this.keyIdToKeySessionPromise = null, this.config = null;
  }
  registerListeners() {
    this.hls.on(D.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(D.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(D.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(D.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  unregisterListeners() {
    this.hls.off(D.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(D.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(D.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(D.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  getLicenseServerUrl(e) {
    const {
      drmSystems: r,
      widevineLicenseUrl: n
    } = this.config, s = r[e];
    if (s)
      return s.licenseUrl;
    if (e === Pr.WIDEVINE && n)
      return n;
    throw new Error(`no license server URL configured for key-system "${e}"`);
  }
  getServerCertificateUrl(e) {
    const {
      drmSystems: r
    } = this.config, n = r[e];
    if (n)
      return n.serverCertificateUrl;
    this.log(`No Server Certificate in config.drmSystems["${e}"]`);
  }
  attemptKeySystemAccess(e) {
    const r = this.hls.levels, n = (o, l, u) => !!o && u.indexOf(o) === l, s = r.map((o) => o.audioCodec).filter(n), a = r.map((o) => o.videoCodec).filter(n);
    return s.length + a.length === 0 && a.push("avc1.42e01e"), new Promise((o, l) => {
      const u = (c) => {
        const d = c.shift();
        this.getMediaKeysPromise(d, s, a).then((h) => o({
          keySystem: d,
          mediaKeys: h
        })).catch((h) => {
          c.length ? u(c) : h instanceof rs ? l(h) : l(new rs({
            type: it.KEY_SYSTEM_ERROR,
            details: le.KEY_SYSTEM_NO_ACCESS,
            error: h,
            fatal: !0
          }, h.message));
        });
      };
      u(e);
    });
  }
  requestMediaKeySystemAccess(e, r) {
    const {
      requestMediaKeySystemAccessFunc: n
    } = this.config;
    if (typeof n != "function") {
      let s = `Configured requestMediaKeySystemAccess is not a function ${n}`;
      return nU === null && self.location.protocol === "http:" && (s = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`), Promise.reject(new Error(s));
    }
    return n(e, r);
  }
  getMediaKeysPromise(e, r, n) {
    const s = wQ(e, r, n, this.config.drmSystemOptions), a = this.keySystemAccessPromises[e];
    let o = a == null ? void 0 : a.keySystemAccess;
    if (!o) {
      this.log(`Requesting encrypted media "${e}" key-system access with config: ${JSON.stringify(s)}`), o = this.requestMediaKeySystemAccess(e, s);
      const l = this.keySystemAccessPromises[e] = {
        keySystemAccess: o
      };
      return o.catch((u) => {
        this.log(`Failed to obtain access to key-system "${e}": ${u}`);
      }), o.then((u) => {
        this.log(`Access for key-system "${u.keySystem}" obtained`);
        const c = this.fetchServerCertificate(e);
        return this.log(`Create media-keys for "${e}"`), l.mediaKeys = u.createMediaKeys().then((d) => (this.log(`Media-keys created for "${e}"`), c.then((h) => h ? this.setMediaKeysServerCertificate(d, e, h) : d))), l.mediaKeys.catch((d) => {
          this.error(`Failed to create media-keys for "${e}"}: ${d}`);
        }), l.mediaKeys;
      });
    }
    return o.then(() => a.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata: e,
    keySystem: r,
    mediaKeys: n
  }) {
    this.log(`Creating key-system session "${r}" keyId: ${da.hexDump(e.keyId || [])}`);
    const s = n.createSession(), a = {
      decryptdata: e,
      keySystem: r,
      mediaKeys: n,
      mediaKeysSession: s,
      keyStatus: "status-pending"
    };
    return this.mediaKeySessions.push(a), a;
  }
  renewKeySession(e) {
    const r = e.decryptdata;
    if (r.pssh) {
      const n = this.createMediaKeySessionContext(e), s = this.getKeyIdString(r), a = "cenc";
      this.keyIdToKeySessionPromise[s] = this.generateRequestWithPreferredKeySession(n, a, r.pssh, "expired");
    } else
      this.warn("Could not renew expired session. Missing pssh initData.");
    this.removeSession(e);
  }
  getKeyIdString(e) {
    if (!e)
      throw new Error("Could not read keyId of undefined decryptdata");
    if (e.keyId === null)
      throw new Error("keyId is null");
    return da.hexDump(e.keyId);
  }
  updateKeySession(e, r) {
    var n;
    const s = e.mediaKeysSession;
    return this.log(`Updating key-session "${s.sessionId}" for keyID ${da.hexDump(((n = e.decryptdata) == null ? void 0 : n.keyId) || [])}
      } (data length: ${r && r.byteLength})`), s.update(r);
  }
  selectKeySystemFormat(e) {
    const r = Object.keys(e.levelkeys || {});
    return this.keyFormatPromise || (this.log(`Selecting key-system from fragment (sn: ${e.sn} ${e.type}: ${e.level}) key formats ${r.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(r)), this.keyFormatPromise;
  }
  getKeyFormatPromise(e) {
    return new Promise((r, n) => {
      const s = __(this.config), a = e.map(xI).filter((o) => !!o && s.indexOf(o) !== -1);
      return this.getKeySystemSelectionPromise(a).then(({
        keySystem: o
      }) => {
        const l = SI(o);
        l ? r(l) : n(new Error(`Unable to find format for key-system "${o}"`));
      }).catch(n);
    });
  }
  loadKey(e) {
    const r = e.keyInfo.decryptdata, n = this.getKeyIdString(r), s = `(keyId: ${n} format: "${r.keyFormat}" method: ${r.method} uri: ${r.uri})`;
    this.log(`Starting session for key ${s}`);
    let a = this.keyIdToKeySessionPromise[n];
    return a || (a = this.keyIdToKeySessionPromise[n] = this.getKeySystemForKeyPromise(r).then(({
      keySystem: o,
      mediaKeys: l
    }) => (this.throwIfDestroyed(), this.log(`Handle encrypted media sn: ${e.frag.sn} ${e.frag.type}: ${e.frag.level} using key ${s}`), this.attemptSetMediaKeys(o, l).then(() => {
      this.throwIfDestroyed();
      const u = this.createMediaKeySessionContext({
        keySystem: o,
        mediaKeys: l,
        decryptdata: r
      }), c = "cenc";
      return this.generateRequestWithPreferredKeySession(u, c, r.pssh, "playlist-key");
    }))), a.catch((o) => this.handleError(o))), a;
  }
  throwIfDestroyed(e = "Invalid state") {
    if (!this.hls)
      throw new Error("invalid state");
  }
  handleError(e) {
    this.hls && (this.error(e.message), e instanceof rs ? this.hls.trigger(D.ERROR, e.data) : this.hls.trigger(D.ERROR, {
      type: it.KEY_SYSTEM_ERROR,
      details: le.KEY_SYSTEM_NO_KEYS,
      error: e,
      fatal: !0
    }));
  }
  getKeySystemForKeyPromise(e) {
    const r = this.getKeyIdString(e), n = this.keyIdToKeySessionPromise[r];
    if (!n) {
      const s = xI(e.keyFormat), a = s ? [s] : __(this.config);
      return this.attemptKeySystemAccess(a);
    }
    return n;
  }
  getKeySystemSelectionPromise(e) {
    if (e.length || (e = __(this.config)), e.length === 0)
      throw new rs({
        type: it.KEY_SYSTEM_ERROR,
        details: le.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: !0
      }, `Missing key-system license configuration options ${JSON.stringify({
        drmSystems: this.config.drmSystems
      })}`);
    return this.attemptKeySystemAccess(e);
  }
  _onMediaEncrypted(e) {
    const {
      initDataType: r,
      initData: n
    } = e;
    if (this.debug(`"${e.type}" event: init data type: "${r}"`), n === null)
      return;
    let s, a;
    if (r === "sinf" && this.config.drmSystems[Pr.FAIRPLAY]) {
      const d = Cn(new Uint8Array(n));
      try {
        const h = Uk(JSON.parse(d).sinf), f = dU(new Uint8Array(h));
        if (!f)
          return;
        s = f.subarray(8, 24), a = Pr.FAIRPLAY;
      } catch {
        this.warn('Failed to parse sinf "encrypted" event message initData');
        return;
      }
    } else {
      const d = WQ(n);
      if (d === null)
        return;
      d.version === 0 && d.systemId === rU.WIDEVINE && d.data && (s = d.data.subarray(8, 24)), a = _Q(d.systemId);
    }
    if (!a || !s)
      return;
    const o = da.hexDump(s), {
      keyIdToKeySessionPromise: l,
      mediaKeySessions: u
    } = this;
    let c = l[o];
    for (let d = 0; d < u.length; d++) {
      const h = u[d], f = h.decryptdata;
      if (f.pssh || !f.keyId)
        continue;
      const p = da.hexDump(f.keyId);
      if (o === p || f.uri.replace(/-/g, "").indexOf(o) !== -1) {
        c = l[p], delete l[p], f.pssh = new Uint8Array(n), f.keyId = s, c = l[o] = c.then(() => this.generateRequestWithPreferredKeySession(h, r, n, "encrypted-event-key-match"));
        break;
      }
    }
    c || (c = l[o] = this.getKeySystemSelectionPromise([a]).then(({
      keySystem: d,
      mediaKeys: h
    }) => {
      var f;
      this.throwIfDestroyed();
      const p = new qf("ISO-23001-7", o, (f = SI(d)) != null ? f : "");
      return p.pssh = new Uint8Array(n), p.keyId = s, this.attemptSetMediaKeys(d, h).then(() => {
        this.throwIfDestroyed();
        const m = this.createMediaKeySessionContext({
          decryptdata: p,
          keySystem: d,
          mediaKeys: h
        });
        return this.generateRequestWithPreferredKeySession(m, r, n, "encrypted-event-no-match");
      });
    })), c.catch((d) => this.handleError(d));
  }
  _onWaitingForKey(e) {
    this.log(`"${e.type}" event`);
  }
  attemptSetMediaKeys(e, r) {
    const n = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${e}"`);
    const s = Promise.all(n).then(() => {
      if (!this.media)
        throw new Error("Attempted to set mediaKeys without media element attached");
      return this.media.setMediaKeys(r);
    });
    return this.setMediaKeysQueue.push(s), s.then(() => {
      this.log(`Media-keys set for "${e}"`), n.push(s), this.setMediaKeysQueue = this.setMediaKeysQueue.filter((a) => n.indexOf(a) === -1);
    });
  }
  generateRequestWithPreferredKeySession(e, r, n, s) {
    var a, o;
    const l = (a = this.config.drmSystems) == null || (o = a[e.keySystem]) == null ? void 0 : o.generateRequest;
    if (l)
      try {
        const f = l.call(this.hls, r, n, e);
        if (!f)
          throw new Error("Invalid response from configured generateRequest filter");
        r = f.initDataType, n = e.decryptdata.pssh = f.initData ? new Uint8Array(f.initData) : null;
      } catch (f) {
        var u;
        if (this.warn(f.message), (u = this.hls) != null && u.config.debug)
          throw f;
      }
    if (n === null)
      return this.log(`Skipping key-session request for "${s}" (no initData)`), Promise.resolve(e);
    const c = this.getKeyIdString(e.decryptdata);
    this.log(`Generating key-session request for "${s}": ${c} (init data type: ${r} length: ${n ? n.byteLength : null})`);
    const d = new Qk();
    e.mediaKeysSession.onmessage = (f) => {
      const p = e.mediaKeysSession;
      if (!p) {
        d.emit("error", new Error("invalid state"));
        return;
      }
      const {
        messageType: m,
        message: b
      } = f;
      this.log(`"${m}" message event for session "${p.sessionId}" message size: ${b.byteLength}`), m === "license-request" || m === "license-renewal" ? this.renewLicense(e, b).catch((y) => {
        this.handleError(y), d.emit("error", y);
      }) : m === "license-release" ? e.keySystem === Pr.FAIRPLAY && (this.updateKeySession(e, tU("acknowledged")), this.removeSession(e)) : this.warn(`unhandled media key message type "${m}"`);
    }, e.mediaKeysSession.onkeystatuseschange = (f) => {
      if (!e.mediaKeysSession) {
        d.emit("error", new Error("invalid state"));
        return;
      }
      this.onKeyStatusChange(e);
      const m = e.keyStatus;
      d.emit("keyStatus", m), m === "expired" && (this.warn(`${e.keySystem} expired for key ${c}`), this.renewKeySession(e));
    };
    const h = new Promise((f, p) => {
      d.on("error", p), d.on("keyStatus", (m) => {
        m.startsWith("usable") ? f() : m === "output-restricted" ? p(new rs({
          type: it.KEY_SYSTEM_ERROR,
          details: le.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
          fatal: !1
        }, "HDCP level output restricted")) : m === "internal-error" ? p(new rs({
          type: it.KEY_SYSTEM_ERROR,
          details: le.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
          fatal: !0
        }, `key status changed to "${m}"`)) : m === "expired" ? p(new Error("key expired while generating request")) : this.warn(`unhandled key status change "${m}"`);
      });
    });
    return e.mediaKeysSession.generateRequest(r, n).then(() => {
      var f;
      this.log(`Request generated for key-session "${(f = e.mediaKeysSession) == null ? void 0 : f.sessionId}" keyId: ${c}`);
    }).catch((f) => {
      throw new rs({
        type: it.KEY_SYSTEM_ERROR,
        details: le.KEY_SYSTEM_NO_SESSION,
        error: f,
        fatal: !1
      }, `Error generating key-session request: ${f}`);
    }).then(() => h).catch((f) => {
      throw d.removeAllListeners(), this.removeSession(e), f;
    }).then(() => (d.removeAllListeners(), e));
  }
  onKeyStatusChange(e) {
    e.mediaKeysSession.keyStatuses.forEach((r, n) => {
      this.log(`key status change "${r}" for keyStatuses keyId: ${da.hexDump("buffer" in n ? new Uint8Array(n.buffer, n.byteOffset, n.byteLength) : new Uint8Array(n))} session keyId: ${da.hexDump(new Uint8Array(e.decryptdata.keyId || []))} uri: ${e.decryptdata.uri}`), e.keyStatus = r;
    });
  }
  fetchServerCertificate(e) {
    const r = this.config, n = r.loader, s = new n(r), a = this.getServerCertificateUrl(e);
    return a ? (this.log(`Fetching serverCertificate for "${e}"`), new Promise((o, l) => {
      const u = {
        responseType: "arraybuffer",
        url: a
      }, c = r.certLoadPolicy.default, d = {
        loadPolicy: c,
        timeout: c.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, h = {
        onSuccess: (f, p, m, b) => {
          o(f.data);
        },
        onError: (f, p, m, b) => {
          l(new rs({
            type: it.KEY_SYSTEM_ERROR,
            details: le.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: m,
            response: Ei({
              url: u.url,
              data: void 0
            }, f)
          }, `"${e}" certificate request failed (${a}). Status: ${f.code} (${f.text})`));
        },
        onTimeout: (f, p, m) => {
          l(new rs({
            type: it.KEY_SYSTEM_ERROR,
            details: le.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: m,
            response: {
              url: u.url,
              data: void 0
            }
          }, `"${e}" certificate request timed out (${a})`));
        },
        onAbort: (f, p, m) => {
          l(new Error("aborted"));
        }
      };
      s.load(u, d, h);
    })) : Promise.resolve();
  }
  setMediaKeysServerCertificate(e, r, n) {
    return new Promise((s, a) => {
      e.setServerCertificate(n).then((o) => {
        this.log(`setServerCertificate ${o ? "success" : "not supported by CDM"} (${n == null ? void 0 : n.byteLength}) on "${r}"`), s(e);
      }).catch((o) => {
        a(new rs({
          type: it.KEY_SYSTEM_ERROR,
          details: le.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error: o,
          fatal: !0
        }, o.message));
      });
    });
  }
  renewLicense(e, r) {
    return this.requestLicense(e, new Uint8Array(r)).then((n) => this.updateKeySession(e, new Uint8Array(n)).catch((s) => {
      throw new rs({
        type: it.KEY_SYSTEM_ERROR,
        details: le.KEY_SYSTEM_SESSION_UPDATE_FAILED,
        error: s,
        fatal: !0
      }, s.message);
    }));
  }
  setupLicenseXHR(e, r, n, s) {
    const a = this.config.licenseXhrSetup;
    return a ? Promise.resolve().then(() => {
      if (!n.decryptdata)
        throw new Error("Key removed");
      return a.call(this.hls, e, r, n, s);
    }).catch((o) => {
      if (!n.decryptdata)
        throw o;
      return e.open("POST", r, !0), a.call(this.hls, e, r, n, s);
    }).then((o) => (e.readyState || e.open("POST", r, !0), {
      xhr: e,
      licenseChallenge: o || s
    })) : (e.open("POST", r, !0), Promise.resolve({
      xhr: e,
      licenseChallenge: s
    }));
  }
  requestLicense(e, r) {
    const n = this.config.keyLoadPolicy.default;
    return new Promise((s, a) => {
      const o = this.getLicenseServerUrl(e.keySystem);
      this.log(`Sending license request to URL: ${o}`);
      const l = new XMLHttpRequest();
      l.responseType = "arraybuffer", l.onreadystatechange = () => {
        if (!this.hls || !e.mediaKeysSession)
          return a(new Error("invalid state"));
        if (l.readyState === 4)
          if (l.status === 200) {
            this._requestLicenseFailureCount = 0;
            let u = l.response;
            this.log(`License received ${u instanceof ArrayBuffer ? u.byteLength : u}`);
            const c = this.config.licenseResponseCallback;
            if (c)
              try {
                u = c.call(this.hls, l, o, e);
              } catch (d) {
                this.error(d);
              }
            s(u);
          } else {
            const u = n.errorRetry, c = u ? u.maxNumRetry : 0;
            if (this._requestLicenseFailureCount++, this._requestLicenseFailureCount > c || l.status >= 400 && l.status < 500)
              a(new rs({
                type: it.KEY_SYSTEM_ERROR,
                details: le.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: !0,
                networkDetails: l,
                response: {
                  url: o,
                  data: void 0,
                  code: l.status,
                  text: l.statusText
                }
              }, `License Request XHR failed (${o}). Status: ${l.status} (${l.statusText})`));
            else {
              const d = c - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${d} attempts left`), this.requestLicense(e, r).then(s, a);
            }
          }
      }, e.licenseXhr && e.licenseXhr.readyState !== XMLHttpRequest.DONE && e.licenseXhr.abort(), e.licenseXhr = l, this.setupLicenseXHR(l, o, e, r).then(({
        xhr: u,
        licenseChallenge: c
      }) => {
        u.send(c);
      });
    });
  }
  onMediaAttached(e, r) {
    if (!this.config.emeEnabled)
      return;
    const n = r.media;
    this.media = n, n.addEventListener("encrypted", this.onMediaEncrypted), n.addEventListener("waitingforkey", this.onWaitingForKey);
  }
  onMediaDetached() {
    const e = this.media, r = this.mediaKeySessions;
    e && (e.removeEventListener("encrypted", this.onMediaEncrypted), e.removeEventListener("waitingforkey", this.onWaitingForKey), this.media = null), this._requestLicenseFailureCount = 0, this.setMediaKeysQueue = [], this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, qf.clearKeyUriToKeyIdMap();
    const n = r.length;
    Td.CDMCleanupPromise = Promise.all(r.map((s) => this.removeSession(s)).concat(e == null ? void 0 : e.setMediaKeys(null).catch((s) => {
      this.log(`Could not clear media keys: ${s}. media.src: ${e == null ? void 0 : e.src}`);
    }))).then(() => {
      n && (this.log("finished closing key sessions and clearing media keys"), r.length = 0);
    }).catch((s) => {
      this.log(`Could not close sessions and clear media keys: ${s}. media.src: ${e == null ? void 0 : e.src}`);
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(e, {
    sessionKeys: r
  }) {
    if (!(!r || !this.config.emeEnabled) && !this.keyFormatPromise) {
      const n = r.reduce((s, a) => (s.indexOf(a.keyFormat) === -1 && s.push(a.keyFormat), s), []);
      this.log(`Selecting key-system from session-keys ${n.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(n);
    }
  }
  removeSession(e) {
    const {
      mediaKeysSession: r,
      licenseXhr: n
    } = e;
    if (r) {
      this.log(`Remove licenses and keys and close session ${r.sessionId}`), r.onmessage = null, r.onkeystatuseschange = null, n && n.readyState !== XMLHttpRequest.DONE && n.abort(), e.mediaKeysSession = e.decryptdata = e.licenseXhr = void 0;
      const s = this.mediaKeySessions.indexOf(e);
      return s > -1 && this.mediaKeySessions.splice(s, 1), r.remove().catch((a) => {
        this.log(`Could not remove session: ${a}`);
      }).then(() => r.close()).catch((a) => {
        this.log(`Could not close session: ${a}`);
      });
    }
  }
}
Td.CDMCleanupPromise = void 0;
class rs extends Error {
  constructor(e, r) {
    super(r), this.data = void 0, e.error || (e.error = new Error(r)), this.data = e, e.err = e.error;
  }
}
const lee = 1;
var fi = {
  MANIFEST: "m",
  AUDIO: "a",
  VIDEO: "v",
  MUXED: "av",
  INIT: "i",
  CAPTION: "c",
  TIMED_TEXT: "tt",
  KEY: "k",
  OTHER: "o"
};
const uee = "h";
class sl {
  // eslint-disable-line no-restricted-globals
  // eslint-disable-line no-restricted-globals
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = () => {
      this.initialized && (this.starved = !0), this.buffering = !0;
    }, this.onPlaying = () => {
      this.initialized || (this.initialized = !0), this.buffering = !1;
    }, this.applyPlaylistData = (s) => {
      try {
        this.apply(s, {
          ot: fi.MANIFEST,
          su: !this.initialized
        });
      } catch (a) {
        J.warn("Could not generate manifest CMCD data.", a);
      }
    }, this.applyFragmentData = (s) => {
      try {
        const a = s.frag, o = this.hls.levels[a.level], l = this.getObjectType(a), u = {
          d: a.duration * 1e3,
          ot: l
        };
        (l === fi.VIDEO || l === fi.AUDIO || l == fi.MUXED) && (u.br = o.bitrate / 1e3, u.tb = this.getTopBandwidth(l) / 1e3, u.bl = this.getBufferLength(l)), this.apply(s, u);
      } catch (a) {
        J.warn("Could not generate segment CMCD data.", a);
      }
    }, this.hls = e;
    const r = this.config = e.config, {
      cmcd: n
    } = r;
    n != null && (r.pLoader = this.createPlaylistLoader(), r.fLoader = this.createFragmentLoader(), this.sid = n.sessionId || sl.uuid(), this.cid = n.contentId, this.useHeaders = n.useHeaders === !0, this.registerListeners());
  }
  registerListeners() {
    const e = this.hls;
    e.on(D.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(D.MEDIA_DETACHED, this.onMediaDetached, this), e.on(D.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e.off(D.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(D.MEDIA_DETACHED, this.onMediaDetached, this), e.off(D.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
  }
  onMediaAttached(e, r) {
    this.media = r.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
  }
  onMediaDetached() {
    this.media && (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
  }
  onBufferCreated(e, r) {
    var n, s;
    this.audioBuffer = (n = r.tracks.audio) == null ? void 0 : n.buffer, this.videoBuffer = (s = r.tracks.video) == null ? void 0 : s.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var e;
    return {
      v: lee,
      sf: uee,
      sid: this.sid,
      cid: this.cid,
      pr: (e = this.media) == null ? void 0 : e.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1e3
    };
  }
  /**
   * Apply CMCD data to a request.
   */
  apply(e, r = {}) {
    hn(r, this.createData());
    const n = r.ot === fi.INIT || r.ot === fi.VIDEO || r.ot === fi.MUXED;
    if (this.starved && n && (r.bs = !0, r.su = !0, this.starved = !1), r.su == null && (r.su = this.buffering), this.useHeaders) {
      const s = sl.toHeaders(r);
      if (!Object.keys(s).length)
        return;
      e.headers || (e.headers = {}), hn(e.headers, s);
    } else {
      const s = sl.toQuery(r);
      if (!s)
        return;
      e.url = sl.appendQueryToUri(e.url, s);
    }
  }
  /**
   * The CMCD object type.
   */
  getObjectType(e) {
    const {
      type: r
    } = e;
    if (r === "subtitle")
      return fi.TIMED_TEXT;
    if (e.sn === "initSegment")
      return fi.INIT;
    if (r === "audio")
      return fi.AUDIO;
    if (r === "main")
      return this.hls.audioTracks.length ? fi.VIDEO : fi.MUXED;
  }
  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(e) {
    let r = 0, n;
    const s = this.hls;
    if (e === fi.AUDIO)
      n = s.audioTracks;
    else {
      const a = s.maxAutoLevel, o = a > -1 ? a + 1 : s.levels.length;
      n = s.levels.slice(0, o);
    }
    for (const a of n)
      a.bitrate > r && (r = a.bitrate);
    return r > 0 ? r : NaN;
  }
  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(e) {
    const r = this.hls.media, n = e === fi.AUDIO ? this.audioBuffer : this.videoBuffer;
    return !n || !r ? NaN : Tr.bufferInfo(n, r.currentTime, this.config.maxBufferHole).len * 1e3;
  }
  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader: e
    } = this.config, r = this.applyPlaylistData, n = e || this.config.loader;
    return class {
      constructor(a) {
        this.loader = void 0, this.loader = new n(a);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(a, o, l) {
        r(a), this.loader.load(a, o, l);
      }
    };
  }
  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader: e
    } = this.config, r = this.applyFragmentData, n = e || this.config.loader;
    return class {
      constructor(a) {
        this.loader = void 0, this.loader = new n(a);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(a, o, l) {
        r(a), this.loader.load(a, o, l);
      }
    };
  }
  /**
   * Generate a random v4 UUI
   *
   * @returns {string}
   */
  static uuid() {
    const e = URL.createObjectURL(new Blob()), r = e.toString();
    return URL.revokeObjectURL(e), r.slice(r.lastIndexOf("/") + 1);
  }
  /**
   * Serialize a CMCD data object according to the rules defined in the
   * section 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */
  static serialize(e) {
    const r = [], n = (c) => !Number.isNaN(c) && c != null && c !== "" && c !== !1, s = (c) => Math.round(c), a = (c) => s(c / 100) * 100, l = {
      br: s,
      d: s,
      bl: a,
      dl: a,
      mtp: a,
      nor: (c) => encodeURIComponent(c),
      rtp: a,
      tb: s
    }, u = Object.keys(e || {}).sort();
    for (const c of u) {
      let d = e[c];
      if (!n(d) || c === "v" && d === 1 || c == "pr" && d === 1)
        continue;
      const h = l[c];
      h && (d = h(d));
      const f = typeof d;
      let p;
      c === "ot" || c === "sf" || c === "st" ? p = `${c}=${d}` : f === "boolean" ? p = c : f === "number" ? p = `${c}=${d}` : p = `${c}=${JSON.stringify(d)}`, r.push(p);
    }
    return r.join(",");
  }
  /**
   * Convert a CMCD data object to request headers according to the rules
   * defined in the section 2.1 and 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */
  static toHeaders(e) {
    const r = Object.keys(e), n = {}, s = ["Object", "Request", "Session", "Status"], a = [{}, {}, {}, {}], o = {
      br: 0,
      d: 0,
      ot: 0,
      tb: 0,
      bl: 1,
      dl: 1,
      mtp: 1,
      nor: 1,
      nrr: 1,
      su: 1,
      cid: 2,
      pr: 2,
      sf: 2,
      sid: 2,
      st: 2,
      v: 2,
      bs: 3,
      rtp: 3
    };
    for (const l of r) {
      const u = o[l] != null ? o[l] : 1;
      a[u][l] = e[l];
    }
    for (let l = 0; l < a.length; l++) {
      const u = sl.serialize(a[l]);
      u && (n[`CMCD-${s[l]}`] = u);
    }
    return n;
  }
  /**
   * Convert a CMCD data object to query args according to the rules
   * defined in the section 2.2 and 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */
  static toQuery(e) {
    return `CMCD=${encodeURIComponent(sl.serialize(e))}`;
  }
  /**
   * Append query args to a uri.
   */
  static appendQueryToUri(e, r) {
    if (!r)
      return e;
    const n = e.includes("?") ? "&" : "?";
    return `${e}${n}${r}`;
  }
}
const cee = 3e5;
class dee {
  constructor(e) {
    this.hls = void 0, this.log = void 0, this.loader = null, this.uri = null, this.pathwayId = ".", this.pathwayPriority = null, this.timeToLoad = 300, this.reloadTimer = -1, this.updated = 0, this.started = !1, this.enabled = !0, this.levels = null, this.audioTracks = null, this.subtitleTracks = null, this.penalizedPathways = {}, this.hls = e, this.log = J.log.bind(J, "[content-steering]:"), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(D.MANIFEST_LOADING, this.onManifestLoading, this), e.on(D.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(D.MANIFEST_PARSED, this.onManifestParsed, this), e.on(D.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(D.MANIFEST_LOADING, this.onManifestLoading, this), e.off(D.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(D.MANIFEST_PARSED, this.onManifestParsed, this), e.off(D.ERROR, this.onError, this));
  }
  startLoad() {
    if (this.started = !0, self.clearTimeout(this.reloadTimer), this.enabled && this.uri)
      if (this.updated) {
        const e = Math.max(this.timeToLoad * 1e3 - (performance.now() - this.updated), 0);
        this.scheduleRefresh(this.uri, e);
      } else
        this.loadSteeringManifest(this.uri);
  }
  stopLoad() {
    this.started = !1, this.loader && (this.loader.destroy(), this.loader = null), self.clearTimeout(this.reloadTimer);
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.hls = null, this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(e) {
    const r = this.levels;
    r && (this.levels = r.filter((n) => n !== e));
  }
  onManifestLoading() {
    this.stopLoad(), this.enabled = !0, this.timeToLoad = 300, this.updated = 0, this.uri = null, this.pathwayId = ".", this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(e, r) {
    const {
      contentSteering: n
    } = r;
    n !== null && (this.pathwayId = n.pathwayId, this.uri = n.uri, this.started && this.startLoad());
  }
  onManifestParsed(e, r) {
    this.audioTracks = r.audioTracks, this.subtitleTracks = r.subtitleTracks;
  }
  onError(e, r) {
    const {
      errorAction: n
    } = r;
    if ((n == null ? void 0 : n.action) === Un.SendAlternateToPenaltyBox && n.flags === ns.MoveAllAlternatesMatchingHost) {
      let s = this.pathwayPriority;
      const a = this.pathwayId;
      this.penalizedPathways[a] || (this.penalizedPathways[a] = performance.now()), !s && this.levels && (s = this.levels.reduce((o, l) => (o.indexOf(l.pathwayId) === -1 && o.push(l.pathwayId), o), [])), s && s.length > 1 && (this.updatePathwayPriority(s), n.resolved = this.pathwayId !== a);
    }
  }
  filterParsedLevels(e) {
    this.levels = e;
    let r = this.getLevelsForPathway(this.pathwayId);
    if (r.length === 0) {
      const n = e[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${n}"`), r = this.getLevelsForPathway(n), this.pathwayId = n;
    }
    return r.length !== e.length ? (this.log(`Found ${r.length}/${e.length} levels in Pathway "${this.pathwayId}"`), r) : e;
  }
  getLevelsForPathway(e) {
    return this.levels === null ? [] : this.levels.filter((r) => e === r.pathwayId);
  }
  updatePathwayPriority(e) {
    this.pathwayPriority = e;
    let r;
    const n = this.penalizedPathways, s = performance.now();
    Object.keys(n).forEach((a) => {
      s - n[a] > cee && delete n[a];
    });
    for (let a = 0; a < e.length; a++) {
      const o = e[a];
      if (n[o])
        continue;
      if (o === this.pathwayId)
        return;
      const l = this.hls.nextLoadLevel, u = this.hls.levels[l];
      if (r = this.getLevelsForPathway(o), r.length > 0) {
        this.log(`Setting Pathway to "${o}"`), this.pathwayId = o, this.hls.trigger(D.LEVELS_UPDATED, {
          levels: r
        });
        const c = this.hls.levels[l];
        u && c && this.levels && (c.attrs["STABLE-VARIANT-ID"] !== u.attrs["STABLE-VARIANT-ID"] && c.bitrate !== u.bitrate && this.log(`Unstable Pathways change from bitrate ${u.bitrate} to ${c.bitrate}`), this.hls.nextLoadLevel = l);
        break;
      }
    }
  }
  clonePathways(e) {
    const r = this.levels;
    if (!r)
      return;
    const n = {}, s = {};
    e.forEach((a) => {
      const {
        ID: o,
        "BASE-ID": l,
        "URI-REPLACEMENT": u
      } = a;
      if (r.some((d) => d.pathwayId === o))
        return;
      const c = this.getLevelsForPathway(l).map((d) => {
        const h = hn({}, d);
        h.details = void 0, h.url = zU(d.uri, d.attrs["STABLE-VARIANT-ID"], "PER-VARIANT-URIS", u);
        const f = new Ir(d.attrs);
        f["PATHWAY-ID"] = o;
        const p = f.AUDIO && `${f.AUDIO}_clone_${o}`, m = f.SUBTITLES && `${f.SUBTITLES}_clone_${o}`;
        p && (n[f.AUDIO] = p, f.AUDIO = p), m && (s[f.SUBTITLES] = m, f.SUBTITLES = m), h.attrs = f;
        const b = new Xf(h);
        return uy(b, "audio", p), uy(b, "text", m), b;
      });
      r.push(...c), fP(this.audioTracks, n, u, o), fP(this.subtitleTracks, s, u, o);
    });
  }
  loadSteeringManifest(e) {
    const r = this.hls.config, n = r.loader;
    this.loader && this.loader.destroy(), this.loader = new n(r);
    let s;
    try {
      s = new self.URL(e);
    } catch {
      this.enabled = !1, this.log(`Failed to parse Steering Manifest URI: ${e}`);
      return;
    }
    if (s.protocol !== "data:") {
      const d = (this.hls.bandwidthEstimate || r.abrEwmaDefaultEstimate) | 0;
      s.searchParams.set("_HLS_pathway", this.pathwayId), s.searchParams.set("_HLS_throughput", "" + d);
    }
    const a = {
      responseType: "json",
      url: s.href
    }, o = r.steeringManifestLoadPolicy.default, l = o.errorRetry || o.timeoutRetry || {}, u = {
      loadPolicy: o,
      timeout: o.maxLoadTimeMs,
      maxRetry: l.maxNumRetry || 0,
      retryDelay: l.retryDelayMs || 0,
      maxRetryDelay: l.maxRetryDelayMs || 0
    }, c = {
      onSuccess: (d, h, f, p) => {
        this.log(`Loaded steering manifest: "${s}"`);
        const m = d.data;
        if (m.VERSION !== 1) {
          this.log(`Steering VERSION ${m.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now(), this.timeToLoad = m.TTL;
        const {
          "RELOAD-URI": b,
          "PATHWAY-CLONES": y,
          "PATHWAY-PRIORITY": _
        } = m;
        if (b)
          try {
            this.uri = new self.URL(b, s).href;
          } catch {
            this.enabled = !1, this.log(`Failed to parse Steering Manifest RELOAD-URI: ${b}`);
            return;
          }
        this.scheduleRefresh(this.uri || f.url), y && this.clonePathways(y), _ && this.updatePathwayPriority(_);
      },
      onError: (d, h, f, p) => {
        if (this.log(`Error loading steering manifest: ${d.code} ${d.text} (${h.url})`), this.stopLoad(), d.code === 410) {
          this.enabled = !1, this.log(`Steering manifest ${h.url} no longer available`);
          return;
        }
        let m = this.timeToLoad * 1e3;
        if (d.code === 429) {
          const b = this.loader;
          if (typeof (b == null ? void 0 : b.getResponseHeader) == "function") {
            const y = b.getResponseHeader("Retry-After");
            y && (m = parseFloat(y) * 1e3);
          }
          this.log(`Steering manifest ${h.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || h.url, m);
      },
      onTimeout: (d, h, f) => {
        this.log(`Timeout loading steering manifest (${h.url})`), this.scheduleRefresh(this.uri || h.url);
      }
    };
    this.log(`Requesting steering manifest: ${s}`), this.loader.load(a, u, c);
  }
  scheduleRefresh(e, r = this.timeToLoad * 1e3) {
    self.clearTimeout(this.reloadTimer), this.reloadTimer = self.setTimeout(() => {
      this.loadSteeringManifest(e);
    }, r);
  }
}
function fP(t, e, r, n) {
  t && Object.keys(e).forEach((s) => {
    const a = t.filter((o) => o.groupId === s).map((o) => {
      const l = hn({}, o);
      return l.details = void 0, l.attrs = new Ir(l.attrs), l.url = l.attrs.URI = zU(o.url, o.attrs["STABLE-RENDITION-ID"], "PER-RENDITION-URIS", r), l.groupId = l.attrs["GROUP-ID"] = e[s], l.attrs["PATHWAY-ID"] = n, l;
    });
    t.push(...a);
  });
}
function zU(t, e, r, n) {
  const {
    HOST: s,
    PARAMS: a,
    [r]: o
  } = n;
  let l;
  e && (l = o == null ? void 0 : o[e], l && (t = l));
  const u = new self.URL(t);
  return s && !l && (u.host = s), a && Object.keys(a).sort().forEach((c) => {
    c && u.searchParams.set(c, a[c]);
  }), u.href;
}
const hee = /^age:\s*[\d.]+\s*$/im;
class qU {
  constructor(e) {
    this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = void 0, this.loader = null, this.stats = void 0, this.xhrSetup = e && e.xhrSetup || null, this.stats = new C0(), this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null;
  }
  abortInternal() {
    const e = this.loader;
    self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), e && (e.onreadystatechange = null, e.onprogress = null, e.readyState !== 4 && (this.stats.aborted = !0, e.abort()));
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
  }
  load(e, r, n) {
    if (this.stats.loading.start)
      throw new Error("Loader can only be used once.");
    this.stats.loading.start = self.performance.now(), this.context = e, this.config = r, this.callbacks = n, this.loadInternal();
  }
  loadInternal() {
    const {
      config: e,
      context: r
    } = this;
    if (!e)
      return;
    const n = this.loader = new self.XMLHttpRequest(), s = this.stats;
    s.loading.first = 0, s.loaded = 0, s.aborted = !1;
    const a = this.xhrSetup;
    a ? Promise.resolve().then(() => {
      if (!this.stats.aborted)
        return a(n, r.url);
    }).catch((o) => (n.open("GET", r.url, !0), a(n, r.url))).then(() => {
      this.stats.aborted || this.openAndSendXhr(n, r, e);
    }).catch((o) => {
      this.callbacks.onError({
        code: n.status,
        text: o.message
      }, r, n, s);
    }) : this.openAndSendXhr(n, r, e);
  }
  openAndSendXhr(e, r, n) {
    e.readyState || e.open("GET", r.url, !0);
    const s = this.context.headers, {
      maxTimeToFirstByteMs: a,
      maxLoadTimeMs: o
    } = n.loadPolicy;
    if (s)
      for (const l in s)
        e.setRequestHeader(l, s[l]);
    r.rangeEnd && e.setRequestHeader("Range", "bytes=" + r.rangeStart + "-" + (r.rangeEnd - 1)), e.onreadystatechange = this.readystatechange.bind(this), e.onprogress = this.loadprogress.bind(this), e.responseType = r.responseType, self.clearTimeout(this.requestTimeout), n.timeout = a && et(a) ? a : o, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), n.timeout), e.send();
  }
  readystatechange() {
    const {
      context: e,
      loader: r,
      stats: n
    } = this;
    if (!e || !r)
      return;
    const s = r.readyState, a = this.config;
    if (!n.aborted && s >= 2 && (n.loading.first === 0 && (n.loading.first = Math.max(self.performance.now(), n.loading.start), a.timeout !== a.loadPolicy.maxLoadTimeMs && (self.clearTimeout(this.requestTimeout), a.timeout = a.loadPolicy.maxLoadTimeMs, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), a.loadPolicy.maxLoadTimeMs - (n.loading.first - n.loading.start)))), s === 4)) {
      self.clearTimeout(this.requestTimeout), r.onreadystatechange = null, r.onprogress = null;
      const o = r.status, l = r.responseType !== "text";
      if (o >= 200 && o < 300 && (l && r.response || r.responseText !== null)) {
        n.loading.end = Math.max(self.performance.now(), n.loading.first);
        const u = l ? r.response : r.responseText, c = r.responseType === "arraybuffer" ? u.byteLength : u.length;
        if (n.loaded = n.total = c, n.bwEstimate = n.total * 8e3 / (n.loading.end - n.loading.first), !this.callbacks)
          return;
        const d = this.callbacks.onProgress;
        if (d && d(n, e, u, r), !this.callbacks)
          return;
        const h = {
          url: r.responseURL,
          data: u,
          code: o
        };
        this.callbacks.onSuccess(h, n, e, r);
      } else {
        const u = a.loadPolicy.errorRetry, c = n.retry;
        ly(u, c, !1, o) ? this.retry(u) : (J.error(`${o} while loading ${e.url}`), this.callbacks.onError({
          code: o,
          text: r.statusText
        }, e, r, n));
      }
    }
  }
  loadtimeout() {
    var e;
    const r = (e = this.config) == null ? void 0 : e.loadPolicy.timeoutRetry, n = this.stats.retry;
    if (ly(r, n, !0))
      this.retry(r);
    else {
      J.warn(`timeout while loading ${this.context.url}`);
      const s = this.callbacks;
      s && (this.abortInternal(), s.onTimeout(this.stats, this.context, this.loader));
    }
  }
  retry(e) {
    const {
      context: r,
      stats: n
    } = this;
    this.retryDelay = Yk(e, n.retry), n.retry++, J.warn(`${status ? "HTTP Status " + status : "Timeout"} while loading ${r.url}, retrying ${n.retry}/${e.maxNumRetry} in ${this.retryDelay}ms`), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(e) {
    const r = this.stats;
    r.loaded = e.loaded, e.lengthComputable && (r.total = e.total);
  }
  getCacheAge() {
    let e = null;
    if (this.loader && hee.test(this.loader.getAllResponseHeaders())) {
      const r = this.loader.getResponseHeader("age");
      e = r ? parseFloat(r) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.loader && new RegExp(`^${e}:\\s*[\\d.]+\\s*$`, "im").test(this.loader.getAllResponseHeaders()) ? this.loader.getResponseHeader(e) : null;
  }
}
function fee() {
  if (
    // @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request
  )
    try {
      return new self.ReadableStream({}), !0;
    } catch {
    }
  return !1;
}
const pee = /(\d+)-(\d+)\/(\d+)/;
class pP {
  constructor(e) {
    this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = void 0, this.response = void 0, this.controller = void 0, this.context = void 0, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = e.fetchSetup || yee, this.controller = new self.AbortController(), this.stats = new C0();
  }
  destroy() {
    this.loader = this.callbacks = null, this.abortInternal();
  }
  abortInternal() {
    const e = this.response;
    e != null && e.ok || (this.stats.aborted = !0, this.controller.abort());
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
  }
  load(e, r, n) {
    const s = this.stats;
    if (s.loading.start)
      throw new Error("Loader can only be used once.");
    s.loading.start = self.performance.now();
    const a = vee(e, this.controller.signal), o = n.onProgress, l = e.responseType === "arraybuffer", u = l ? "byteLength" : "length", {
      maxTimeToFirstByteMs: c,
      maxLoadTimeMs: d
    } = r.loadPolicy;
    this.context = e, this.config = r, this.callbacks = n, this.request = this.fetchSetup(e, a), self.clearTimeout(this.requestTimeout), r.timeout = c && et(c) ? c : d, this.requestTimeout = self.setTimeout(() => {
      this.abortInternal(), n.onTimeout(s, e, this.response);
    }, r.timeout), self.fetch(this.request).then((h) => {
      this.response = this.loader = h;
      const f = Math.max(self.performance.now(), s.loading.start);
      if (self.clearTimeout(this.requestTimeout), r.timeout = d, this.requestTimeout = self.setTimeout(() => {
        this.abortInternal(), n.onTimeout(s, e, this.response);
      }, d - (f - s.loading.start)), !h.ok) {
        const {
          status: p,
          statusText: m
        } = h;
        throw new bee(m || "fetch, bad network response", p, h);
      }
      return s.loading.first = f, s.total = gee(h.headers) || s.total, o && et(r.highWaterMark) ? this.loadProgressively(h, s, e, r.highWaterMark, o) : l ? h.arrayBuffer() : e.responseType === "json" ? h.json() : h.text();
    }).then((h) => {
      const {
        response: f
      } = this;
      self.clearTimeout(this.requestTimeout), s.loading.end = Math.max(self.performance.now(), s.loading.first);
      const p = h[u];
      p && (s.loaded = s.total = p);
      const m = {
        url: f.url,
        data: h,
        code: f.status
      };
      o && !et(r.highWaterMark) && o(s, e, h, f), n.onSuccess(m, s, e, f);
    }).catch((h) => {
      if (self.clearTimeout(this.requestTimeout), s.aborted)
        return;
      const f = h && h.code || 0, p = h ? h.message : null;
      n.onError({
        code: f,
        text: p
      }, e, h ? h.details : null, s);
    });
  }
  getCacheAge() {
    let e = null;
    if (this.response) {
      const r = this.response.headers.get("age");
      e = r ? parseFloat(r) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.response ? this.response.headers.get(e) : null;
  }
  loadProgressively(e, r, n, s = 0, a) {
    const o = new FU(), l = e.body.getReader(), u = () => l.read().then((c) => {
      if (c.done)
        return o.dataLength && a(r, n, o.flush(), e), Promise.resolve(new ArrayBuffer(0));
      const d = c.value, h = d.length;
      return r.loaded += h, h < s || o.dataLength ? (o.push(d), o.dataLength >= s && a(r, n, o.flush(), e)) : a(r, n, d, e), u();
    }).catch(() => Promise.reject());
    return u();
  }
}
function vee(t, e) {
  const r = {
    method: "GET",
    mode: "cors",
    credentials: "same-origin",
    signal: e,
    headers: new self.Headers(hn({}, t.headers))
  };
  return t.rangeEnd && r.headers.set("Range", "bytes=" + t.rangeStart + "-" + String(t.rangeEnd - 1)), r;
}
function mee(t) {
  const e = pee.exec(t);
  if (e)
    return parseInt(e[2]) - parseInt(e[1]) + 1;
}
function gee(t) {
  const e = t.get("Content-Range");
  if (e) {
    const n = mee(e);
    if (et(n))
      return n;
  }
  const r = t.get("Content-Length");
  if (r)
    return parseInt(r);
}
function yee(t, e) {
  return new self.Request(t.url, e);
}
class bee extends Error {
  constructor(e, r, n) {
    super(e), this.code = void 0, this.details = void 0, this.code = r, this.details = n;
  }
}
const _ee = /\s/, wee = {
  newCue(t, e, r, n) {
    const s = [];
    let a, o, l, u, c;
    const d = self.VTTCue || self.TextTrackCue;
    for (let f = 0; f < n.rows.length; f++)
      if (a = n.rows[f], l = !0, u = 0, c = "", !a.isEmpty()) {
        var h;
        for (let b = 0; b < a.chars.length; b++)
          _ee.test(a.chars[b].uchar) && l ? u++ : (c += a.chars[b].uchar, l = !1);
        a.cueStartTime = e, e === r && (r += 1e-4), u >= 16 ? u-- : u++;
        const p = GU(c.trim()), m = Jk(e, r, p);
        t != null && (h = t.cues) != null && h.getCueById(m) || (o = new d(e, r, p), o.id = m, o.line = f + 1, o.align = "left", o.position = 10 + Math.min(80, Math.floor(u * 8 / 32) * 10), s.push(o));
      }
    return t && s.length && (s.sort((f, p) => f.line === "auto" || p.line === "auto" ? 0 : f.line > 8 && p.line > 8 ? p.line - f.line : f.line - p.line), s.forEach((f) => mU(t, f))), s;
  }
}, Tee = {
  maxTimeToFirstByteMs: 8e3,
  maxLoadTimeMs: 2e4,
  timeoutRetry: null,
  errorRetry: null
}, xee = Ei(Ei({
  autoStartLoad: !0,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: void 0,
  // used by stream-controller
  debug: !1,
  // used by logger
  capLevelOnFPSDrop: !1,
  // used by fps-controller
  capLevelToPlayerSize: !1,
  // used by cap-level-controller
  ignoreDevicePixelRatio: !1,
  // used by cap-level-controller
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: 1 / 0,
  // used by buffer-controller
  maxBufferSize: 60 * 1e3 * 1e3,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller
  highBufferWatchdogPeriod: 2,
  // used by stream-controller
  nudgeOffset: 0.1,
  // used by stream-controller
  nudgeMaxRetry: 3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveMaxLatencyDurationCount: 1 / 0,
  // used by latency-controller
  liveSyncDuration: void 0,
  // used by latency-controller
  liveMaxLatencyDuration: void 0,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: !1,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: !0,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: !0,
  // used by decrypter
  startLevel: void 0,
  // used by level-controller
  startFragPrefetch: !1,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5e3,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  loader: qU,
  // loader: FetchLoader,
  fLoader: void 0,
  // used by fragment-loader
  pLoader: void 0,
  // used by playlist-loader
  xhrSetup: void 0,
  // used by xhr-loader
  licenseXhrSetup: void 0,
  // used by eme-controller
  licenseResponseCallback: void 0,
  // used by eme-controller
  abrController: kJ,
  bufferController: LJ,
  capLevelController: eD,
  errorController: bZ,
  fpsController: oee,
  stretchShortVideoTrack: !1,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: !0,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: !1,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: !1,
  // used by eme-controller
  widevineLicenseUrl: void 0,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: nU,
  // used by eme-controller
  testBandwidth: !0,
  progressive: !1,
  lowLatencyMode: !0,
  cmcd: void 0,
  enableDateRangeMetadataCues: !0,
  enableEmsgMetadataCues: !0,
  enableID3MetadataCues: !0,
  certLoadPolicy: {
    default: Tee
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8e3,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1 / 0,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 12e4,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 1e4,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1e3,
  manifestLoadingMaxRetryTimeout: 64e3,
  levelLoadingTimeOut: 1e4,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1e3,
  levelLoadingMaxRetryTimeout: 64e3,
  fragLoadingTimeOut: 2e4,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1e3,
  fragLoadingMaxRetryTimeout: 64e3
}, See()), {}, {
  subtitleStreamController: IJ,
  subtitleTrackController: RJ,
  timelineController: iee,
  audioStreamController: OJ,
  audioTrackController: AJ,
  emeController: Td,
  cmcdController: sl,
  contentSteeringController: dee
});
function See() {
  return {
    cueHandler: wee,
    // used by timeline-controller
    enableWebVTT: !0,
    // used by timeline-controller
    enableIMSC1: !0,
    // used by timeline-controller
    enableCEA708Captions: !0,
    // used by timeline-controller
    captionsTextTrack1Label: "English",
    // used by timeline-controller
    captionsTextTrack1LanguageCode: "en",
    // used by timeline-controller
    captionsTextTrack2Label: "Spanish",
    // used by timeline-controller
    captionsTextTrack2LanguageCode: "es",
    // used by timeline-controller
    captionsTextTrack3Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack3LanguageCode: "",
    // used by timeline-controller
    captionsTextTrack4Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack4LanguageCode: "",
    // used by timeline-controller
    renderTextTracksNatively: !0
  };
}
function Eee(t, e) {
  if ((e.liveSyncDurationCount || e.liveMaxLatencyDurationCount) && (e.liveSyncDuration || e.liveMaxLatencyDuration))
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  if (e.liveMaxLatencyDurationCount !== void 0 && (e.liveSyncDurationCount === void 0 || e.liveMaxLatencyDurationCount <= e.liveSyncDurationCount))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  if (e.liveMaxLatencyDuration !== void 0 && (e.liveSyncDuration === void 0 || e.liveMaxLatencyDuration <= e.liveSyncDuration))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  const r = sx(t), n = ["manifest", "level", "frag"], s = ["TimeOut", "MaxRetry", "RetryDelay", "MaxRetryTimeout"];
  return n.forEach((a) => {
    const o = `${a === "level" ? "playlist" : a}LoadPolicy`, l = e[o] === void 0, u = [];
    s.forEach((c) => {
      const d = `${a}Loading${c}`, h = e[d];
      if (h !== void 0 && l) {
        u.push(d);
        const f = r[o].default;
        switch (e[o] = {
          default: f
        }, c) {
          case "TimeOut":
            f.maxLoadTimeMs = h, f.maxTimeToFirstByteMs = h;
            break;
          case "MaxRetry":
            f.errorRetry.maxNumRetry = h, f.timeoutRetry.maxNumRetry = h;
            break;
          case "RetryDelay":
            f.errorRetry.retryDelayMs = h, f.timeoutRetry.retryDelayMs = h;
            break;
          case "MaxRetryTimeout":
            f.errorRetry.maxRetryDelayMs = h, f.timeoutRetry.maxRetryDelayMs = h;
            break;
        }
      }
    }), u.length && J.warn(`hls.js config: "${u.join('", "')}" setting(s) are deprecated, use "${o}": ${JSON.stringify(e[o])}`);
  }), Ei(Ei({}, r), e);
}
function sx(t) {
  return t && typeof t == "object" ? Array.isArray(t) ? t.map(sx) : Object.keys(t).reduce((e, r) => (e[r] = sx(t[r]), e), {}) : t;
}
function $ee(t) {
  const e = t.loader;
  e !== pP && e !== qU ? (J.log("[config]: Custom loader detected, cannot enable progressive streaming"), t.progressive = !1) : fee() && (t.loader = pP, t.progressive = !0, t.enableSoftwareAES = !0, J.log("[config]: Progressive streaming enabled, using FetchLoader"));
}
class ya {
  /**
   * The runtime configuration used by the player. At instantiation this is combination of `hls.userConfig` merged over `Hls.DefaultConfig`.
   */
  /**
   * The configuration object provided on player instantiation.
   */
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return "1.4.10";
  }
  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isSupported() {
    return FZ();
  }
  static get Events() {
    return D;
  }
  static get ErrorTypes() {
    return it;
  }
  static get ErrorDetails() {
    return le;
  }
  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    return ya.defaultConfig ? ya.defaultConfig : xee;
  }
  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(e) {
    ya.defaultConfig = e;
  }
  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(e = {}) {
    this.config = void 0, this.userConfig = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this._emitter = new Qk(), this._autoLevelCapping = void 0, this._maxHdcpLevel = null, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this.url = null, cQ(e.debug || !1, "Hls instance");
    const r = this.config = Eee(ya.DefaultConfig, e);
    this.userConfig = e, this._autoLevelCapping = -1, r.progressive && $ee(r);
    const {
      abrController: n,
      bufferController: s,
      capLevelController: a,
      errorController: o,
      fpsController: l
    } = r, u = new o(this), c = this.abrController = new n(this), d = this.bufferController = new s(this), h = this.capLevelController = new a(this), f = new l(this), p = new eZ(this), m = new sZ(this), b = r.contentSteeringController, y = b ? new b(this) : null, _ = this.levelController = new wZ(this, y), x = new TZ(this), T = new SZ(this.config), k = this.streamController = new EJ(this, x, T);
    h.setStreamController(k), f.setStreamController(k);
    const E = [p, _, k];
    y && E.splice(1, 0, y), this.networkControllers = E;
    const F = [c, d, h, f, m, x];
    this.audioTrackController = this.createController(r.audioTrackController, E);
    const R = r.audioStreamController;
    R && E.push(new R(this, x, T)), this.subtitleTrackController = this.createController(r.subtitleTrackController, E);
    const $ = r.subtitleStreamController;
    $ && E.push(new $(this, x, T)), this.createController(r.timelineController, F), T.emeController = this.emeController = this.createController(r.emeController, F), this.cmcdController = this.createController(r.cmcdController, F), this.latencyController = this.createController(aZ, F), this.coreComponents = F, E.push(u);
    const O = u.onErrorOut;
    typeof O == "function" && this.on(D.ERROR, O, u);
  }
  createController(e, r) {
    if (e) {
      const n = new e(this);
      return r && r.push(n), n;
    }
    return null;
  }
  // Delegate the EventEmitter through the public API of Hls.js
  on(e, r, n = this) {
    this._emitter.on(e, r, n);
  }
  once(e, r, n = this) {
    this._emitter.once(e, r, n);
  }
  removeAllListeners(e) {
    this._emitter.removeAllListeners(e);
  }
  off(e, r, n = this, s) {
    this._emitter.off(e, r, n, s);
  }
  listeners(e) {
    return this._emitter.listeners(e);
  }
  emit(e, r, n) {
    return this._emitter.emit(e, r, n);
  }
  trigger(e, r) {
    if (this.config.debug)
      return this.emit(e, e, r);
    try {
      return this.emit(e, e, r);
    } catch (n) {
      J.error("An internal error happened while handling event " + e + '. Error message: "' + n.message + '". Here is a stacktrace:', n), this.trigger(D.ERROR, {
        type: it.OTHER_ERROR,
        details: le.INTERNAL_EXCEPTION,
        fatal: !1,
        event: e,
        error: n
      });
    }
    return !1;
  }
  listenerCount(e) {
    return this._emitter.listenerCount(e);
  }
  /**
   * Dispose of the instance
   */
  destroy() {
    J.log("destroy"), this.trigger(D.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this.url = null, this.networkControllers.forEach((r) => r.destroy()), this.networkControllers.length = 0, this.coreComponents.forEach((r) => r.destroy()), this.coreComponents.length = 0;
    const e = this.config;
    e.xhrSetup = e.fetchSetup = void 0, this.userConfig = null;
  }
  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(e) {
    J.log("attachMedia"), this._media = e, this.trigger(D.MEDIA_ATTACHING, {
      media: e
    });
  }
  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    J.log("detachMedia"), this.trigger(D.MEDIA_DETACHING, void 0), this._media = null;
  }
  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(e) {
    this.stopLoad();
    const r = this.media, n = this.url, s = this.url = Bk.buildAbsoluteURL(self.location.href, e, {
      alwaysNormalize: !0
    });
    J.log(`loadSource:${s}`), r && n && (n !== s || this.bufferController.hasSourceTypes()) && (this.detachMedia(), this.attachMedia(r)), this.trigger(D.MANIFEST_LOADING, {
      url: e
    });
  }
  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(e = -1) {
    J.log(`startLoad(${e})`), this.networkControllers.forEach((r) => {
      r.startLoad(e);
    });
  }
  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    J.log("stopLoad"), this.networkControllers.forEach((e) => {
      e.stopLoad();
    });
  }
  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    J.log("swapAudioCodec"), this.streamController.swapAudioCodec();
  }
  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    J.log("recoverMediaError");
    const e = this._media;
    this.detachMedia(), e && this.attachMedia(e);
  }
  removeLevel(e, r = 0) {
    this.levelController.removeLevel(e, r);
  }
  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, BANDWIDTH, SCORE, and RESOLUTION (height)
   */
  get levels() {
    const e = this.levelController.levels;
    return e || [];
  }
  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }
  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(e) {
    J.log(`set currentLevel:${e}`), this.loadLevel = e, this.abrController.clearTimer(), this.streamController.immediateLevelSwitch();
  }
  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }
  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(e) {
    J.log(`set nextLevel:${e}`), this.levelController.manualLevel = e, this.streamController.nextLevelSwitch();
  }
  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }
  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(e) {
    J.log(`set loadLevel:${e}`), this.levelController.manualLevel = e;
  }
  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }
  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(e) {
    this.levelController.nextLoadLevel = e;
  }
  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }
  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(e) {
    J.log(`set firstLevel:${e}`), this.levelController.firstLevel = e;
  }
  /**
   * Return start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  get startLevel() {
    return this.levelController.startLevel;
  }
  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(e) {
    J.log(`set startLevel:${e}`), e !== -1 && (e = Math.max(e, this.minAutoLevel)), this.levelController.startLevel = e;
  }
  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }
  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(e) {
    const r = !!e;
    r !== this.config.capLevelToPlayerSize && (r ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = r);
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }
  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimate() : NaN;
  }
  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimateTTFB() : NaN;
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(e) {
    this._autoLevelCapping !== e && (J.log(`set autoLevelCapping:${e}`), this._autoLevelCapping = e);
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(e) {
    ex.indexOf(e) > -1 && (this._maxHdcpLevel = e);
  }
  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }
  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }
  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels: e,
      config: {
        minAutoBitrate: r
      }
    } = this;
    if (!e)
      return 0;
    const n = e.length;
    for (let s = 0; s < n; s++)
      if (e[s].maxBitrate >= r)
        return s;
    return 0;
  }
  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels: e,
      autoLevelCapping: r,
      maxHdcpLevel: n
    } = this;
    let s;
    if (r === -1 && e && e.length ? s = e.length - 1 : s = r, n)
      for (let a = s; a--; ) {
        const o = e[a].attrs["HDCP-LEVEL"];
        if (o && o <= n)
          return a;
      }
    return s;
  }
  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return Math.min(Math.max(this.abrController.nextAutoLevel, this.minAutoLevel), this.maxAutoLevel);
  }
  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(e) {
    this.abrController.nextAutoLevel = Math.max(this.minAutoLevel, e);
  }
  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }
  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const e = this.audioTrackController;
    return e ? e.audioTracks : [];
  }
  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const e = this.audioTrackController;
    return e ? e.audioTrack : -1;
  }
  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(e) {
    const r = this.audioTrackController;
    r && (r.audioTrack = e);
  }
  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTracks : [];
  }
  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }
  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(e) {
    const r = this.subtitleTrackController;
    r && (r.subtitleTrack = e);
  }
  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleDisplay : !1;
  }
  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(e) {
    const r = this.subtitleTrackController;
    r && (r.subtitleDisplay = e);
  }
  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }
  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(e) {
    this.config.lowLatencyMode = e;
  }
  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }
  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }
  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }
  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }
  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }
  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
}
ya.defaultConfig = void 0;
const kee = { class: "sp-bar__item" }, Dee = { class: "sp-bar__item" }, Oee = /* @__PURE__ */ Dt({
  __name: "BaseBar",
  props: {
    top: {
      type: Boolean,
      default: !1
    },
    bottom: {
      type: Boolean,
      default: !1
    },
    dynamic: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: !1
    },
    gradient: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    return (e, r) => (re(), ye("div", {
      class: wt([{
        "sp-bar_top": t.top,
        "sp-bar_bottom": t.bottom,
        "sp-bar_gradient": t.gradient,
        "sp-bar_dynamic": t.dynamic,
        "sp-bar_active": t.active
      }, "sp-bar"]),
      onPointerdown: r[0] || (r[0] = kt(() => {
      }, ["stop"]))
    }, [
      ke("div", kee, [
        We(e.$slots, "start", {}, void 0, !0)
      ]),
      ke("div", Dee, [
        We(e.$slots, "end", {}, void 0, !0)
      ])
    ], 34));
  }
});
const Di = (t, e) => {
  const r = t.__vccOpts || t;
  for (const [n, s] of e)
    r[n] = s;
  return r;
}, vP = /* @__PURE__ */ Di(Oee, [["__scopeId", "data-v-ef6ac0da"]]);
function ax(t, e, r) {
  var n, s, a, o, l;
  e == null && (e = 100);
  function u() {
    var d = Date.now() - o;
    d < e && d >= 0 ? n = setTimeout(u, e - d) : (n = null, r || (l = t.apply(a, s), a = s = null));
  }
  var c = function() {
    a = this, s = arguments, o = Date.now();
    var d = r && !n;
    return n || (n = setTimeout(u, e)), d && (l = t.apply(a, s), a = s = null), l;
  };
  return c.clear = function() {
    n && (clearTimeout(n), n = null);
  }, c.flush = function() {
    n && (l = t.apply(a, s), a = s = null, clearTimeout(n), n = null);
  }, c;
}
ax.debounce = ax;
var Y_ = ax;
function Aee(t, e, r) {
  Or(t) ? Lr(t, (n, s) => {
    s == null || s.removeEventListener(e, r), n == null || n.addEventListener(e, r);
  }) : Nr(() => {
    t.addEventListener(e, r);
  }), nh(() => {
    var n;
    (n = X(t)) === null || n === void 0 || n.removeEventListener(e, r);
  });
}
function Cee(t, e) {
  const r = "pointerdown";
  return typeof window > "u" || !window ? void 0 : Aee(window, r, (s) => {
    const a = X(t);
    a && (a === s.target || s.composedPath().includes(a) || e(s));
  });
}
function Iee(t, e, r) {
  let n = null;
  const s = ue(!1);
  Nr(() => {
    (t.content !== void 0 || r.value) && (s.value = !0), n = new MutationObserver(a), n.observe(e.value, {
      childList: !0,
      subtree: !0
    });
  }), nh(() => n.disconnect()), Lr(r, (o) => {
    o ? s.value = !0 : s.value = !1;
  });
  const a = () => {
    t.content ? s.value = !0 : s.value = !1;
  };
  return {
    hasContent: s
  };
}
function Pd(t, e) {
  var r = t.getBoundingClientRect(), n = 1, s = 1;
  return {
    width: r.width / n,
    height: r.height / s,
    top: r.top / s,
    right: r.right / n,
    bottom: r.bottom / s,
    left: r.left / n,
    x: r.left / n,
    y: r.top / s
  };
}
function Xs(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function tD(t) {
  var e = Xs(t), r = e.pageXOffset, n = e.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function Zf(t) {
  var e = Xs(t).Element;
  return t instanceof e || t instanceof Element;
}
function cs(t) {
  var e = Xs(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function XU(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Xs(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function Pee(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function Ree(t) {
  return t === Xs(t) || !cs(t) ? tD(t) : Pee(t);
}
function Ma(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Pl(t) {
  return ((Zf(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function rD(t) {
  return Pd(Pl(t)).left + tD(t).scrollLeft;
}
function So(t) {
  return Xs(t).getComputedStyle(t);
}
function nD(t) {
  var e = So(t), r = e.overflow, n = e.overflowX, s = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + s + n);
}
function Mee(t) {
  var e = t.getBoundingClientRect(), r = e.width / t.offsetWidth || 1, n = e.height / t.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function Lee(t, e, r) {
  r === void 0 && (r = !1);
  var n = cs(e);
  cs(e) && Mee(e);
  var s = Pl(e), a = Pd(t), o = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Ma(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  nD(s)) && (o = Ree(e)), cs(e) ? (l = Pd(e), l.x += e.clientLeft, l.y += e.clientTop) : s && (l.x = rD(s))), {
    x: a.left + o.scrollLeft - l.x,
    y: a.top + o.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function iD(t) {
  var e = Pd(t), r = t.offsetWidth, n = t.offsetHeight;
  return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: r,
    height: n
  };
}
function R0(t) {
  return Ma(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (XU(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Pl(t)
  );
}
function QU(t) {
  return ["html", "body", "#document"].indexOf(Ma(t)) >= 0 ? t.ownerDocument.body : cs(t) && nD(t) ? t : QU(R0(t));
}
function Ef(t, e) {
  var r;
  e === void 0 && (e = []);
  var n = QU(t), s = n === ((r = t.ownerDocument) == null ? void 0 : r.body), a = Xs(n), o = s ? [a].concat(a.visualViewport || [], nD(n) ? n : []) : n, l = e.concat(o);
  return s ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(Ef(R0(o)))
  );
}
function Nee(t) {
  return ["table", "td", "th"].indexOf(Ma(t)) >= 0;
}
function mP(t) {
  return !cs(t) || // https://github.com/popperjs/popper-core/issues/837
  So(t).position === "fixed" ? null : t.offsetParent;
}
function Fee(t) {
  var e = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, r = navigator.userAgent.indexOf("Trident") !== -1;
  if (r && cs(t)) {
    var n = So(t);
    if (n.position === "fixed")
      return null;
  }
  for (var s = R0(t); cs(s) && ["html", "body"].indexOf(Ma(s)) < 0; ) {
    var a = So(s);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || e && a.willChange === "filter" || e && a.filter && a.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function Rp(t) {
  for (var e = Xs(t), r = mP(t); r && Nee(r) && So(r).position === "static"; )
    r = mP(r);
  return r && (Ma(r) === "html" || Ma(r) === "body" && So(r).position === "static") ? e : r || Fee(t) || e;
}
var ds = "top", Gs = "bottom", Ws = "right", hs = "left", sD = "auto", Mp = [ds, Gs, Ws, hs], Rd = "start", Jf = "end", Bee = "clippingParents", ZU = "viewport", qh = "popper", Uee = "reference", gP = /* @__PURE__ */ Mp.reduce(function(t, e) {
  return t.concat([e + "-" + Rd, e + "-" + Jf]);
}, []), JU = /* @__PURE__ */ [].concat(Mp, [sD]).reduce(function(t, e) {
  return t.concat([e, e + "-" + Rd, e + "-" + Jf]);
}, []), Vee = "beforeRead", Yee = "read", Hee = "afterRead", Gee = "beforeMain", Wee = "main", jee = "afterMain", Kee = "beforeWrite", zee = "write", qee = "afterWrite", Xee = [Vee, Yee, Hee, Gee, Wee, jee, Kee, zee, qee];
function Qee(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  t.forEach(function(a) {
    e.set(a.name, a);
  });
  function s(a) {
    r.add(a.name);
    var o = [].concat(a.requires || [], a.requiresIfExists || []);
    o.forEach(function(l) {
      if (!r.has(l)) {
        var u = e.get(l);
        u && s(u);
      }
    }), n.push(a);
  }
  return t.forEach(function(a) {
    r.has(a.name) || s(a);
  }), n;
}
function Zee(t) {
  var e = Qee(t);
  return Xee.reduce(function(r, n) {
    return r.concat(e.filter(function(s) {
      return s.phase === n;
    }));
  }, []);
}
function Jee(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(r) {
      Promise.resolve().then(function() {
        e = void 0, r(t());
      });
    })), e;
  };
}
function Sa(t) {
  return t.split("-")[0];
}
function ete(t) {
  var e = t.reduce(function(r, n) {
    var s = r[n.name];
    return r[n.name] = s ? Object.assign({}, s, n, {
      options: Object.assign({}, s.options, n.options),
      data: Object.assign({}, s.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
function tte(t) {
  var e = Xs(t), r = Pl(t), n = e.visualViewport, s = r.clientWidth, a = r.clientHeight, o = 0, l = 0;
  return n && (s = n.width, a = n.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (o = n.offsetLeft, l = n.offsetTop)), {
    width: s,
    height: a,
    x: o + rD(t),
    y: l
  };
}
var ml = Math.max, ep = Math.min, $m = Math.round;
function rte(t) {
  var e, r = Pl(t), n = tD(t), s = (e = t.ownerDocument) == null ? void 0 : e.body, a = ml(r.scrollWidth, r.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), o = ml(r.scrollHeight, r.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), l = -n.scrollLeft + rD(t), u = -n.scrollTop;
  return So(s || r).direction === "rtl" && (l += ml(r.clientWidth, s ? s.clientWidth : 0) - a), {
    width: a,
    height: o,
    x: l,
    y: u
  };
}
function eV(t, e) {
  var r = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (r && XU(r)) {
    var n = e;
    do {
      if (n && t.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function ox(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function nte(t) {
  var e = Pd(t);
  return e.top = e.top + t.clientTop, e.left = e.left + t.clientLeft, e.bottom = e.top + t.clientHeight, e.right = e.left + t.clientWidth, e.width = t.clientWidth, e.height = t.clientHeight, e.x = e.left, e.y = e.top, e;
}
function yP(t, e) {
  return e === ZU ? ox(tte(t)) : cs(e) ? nte(e) : ox(rte(Pl(t)));
}
function ite(t) {
  var e = Ef(R0(t)), r = ["absolute", "fixed"].indexOf(So(t).position) >= 0, n = r && cs(t) ? Rp(t) : t;
  return Zf(n) ? e.filter(function(s) {
    return Zf(s) && eV(s, n) && Ma(s) !== "body";
  }) : [];
}
function ste(t, e, r) {
  var n = e === "clippingParents" ? ite(t) : [].concat(e), s = [].concat(n, [r]), a = s[0], o = s.reduce(function(l, u) {
    var c = yP(t, u);
    return l.top = ml(c.top, l.top), l.right = ep(c.right, l.right), l.bottom = ep(c.bottom, l.bottom), l.left = ml(c.left, l.left), l;
  }, yP(t, a));
  return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
function Md(t) {
  return t.split("-")[1];
}
function aD(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function tV(t) {
  var e = t.reference, r = t.element, n = t.placement, s = n ? Sa(n) : null, a = n ? Md(n) : null, o = e.x + e.width / 2 - r.width / 2, l = e.y + e.height / 2 - r.height / 2, u;
  switch (s) {
    case ds:
      u = {
        x: o,
        y: e.y - r.height
      };
      break;
    case Gs:
      u = {
        x: o,
        y: e.y + e.height
      };
      break;
    case Ws:
      u = {
        x: e.x + e.width,
        y: l
      };
      break;
    case hs:
      u = {
        x: e.x - r.width,
        y: l
      };
      break;
    default:
      u = {
        x: e.x,
        y: e.y
      };
  }
  var c = s ? aD(s) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (a) {
      case Rd:
        u[c] = u[c] - (e[d] / 2 - r[d] / 2);
        break;
      case Jf:
        u[c] = u[c] + (e[d] / 2 - r[d] / 2);
        break;
    }
  }
  return u;
}
function rV() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function nV(t) {
  return Object.assign({}, rV(), t);
}
function iV(t, e) {
  return e.reduce(function(r, n) {
    return r[n] = t, r;
  }, {});
}
function oD(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.placement, s = n === void 0 ? t.placement : n, a = r.boundary, o = a === void 0 ? Bee : a, l = r.rootBoundary, u = l === void 0 ? ZU : l, c = r.elementContext, d = c === void 0 ? qh : c, h = r.altBoundary, f = h === void 0 ? !1 : h, p = r.padding, m = p === void 0 ? 0 : p, b = nV(typeof m != "number" ? m : iV(m, Mp)), y = d === qh ? Uee : qh, _ = t.rects.popper, x = t.elements[f ? y : d], T = ste(Zf(x) ? x : x.contextElement || Pl(t.elements.popper), o, u), k = Pd(t.elements.reference), E = tV({
    reference: k,
    element: _,
    strategy: "absolute",
    placement: s
  }), F = ox(Object.assign({}, _, E)), R = d === qh ? F : k, $ = {
    top: T.top - R.top + b.top,
    bottom: R.bottom - T.bottom + b.bottom,
    left: T.left - R.left + b.left,
    right: R.right - T.right + b.right
  }, O = t.modifiersData.offset;
  if (d === qh && O) {
    var P = O[s];
    Object.keys($).forEach(function(N) {
      var I = [Ws, Gs].indexOf(N) >= 0 ? 1 : -1, B = [ds, Gs].indexOf(N) >= 0 ? "y" : "x";
      $[N] += P[B] * I;
    });
  }
  return $;
}
var bP = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function _P() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return !e.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function ate(t) {
  t === void 0 && (t = {});
  var e = t, r = e.defaultModifiers, n = r === void 0 ? [] : r, s = e.defaultOptions, a = s === void 0 ? bP : s;
  return function(l, u, c) {
    c === void 0 && (c = a);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, bP, a),
      modifiersData: {},
      elements: {
        reference: l,
        popper: u
      },
      attributes: {},
      styles: {}
    }, h = [], f = !1, p = {
      state: d,
      setOptions: function(_) {
        var x = typeof _ == "function" ? _(d.options) : _;
        b(), d.options = Object.assign({}, a, d.options, x), d.scrollParents = {
          reference: Zf(l) ? Ef(l) : l.contextElement ? Ef(l.contextElement) : [],
          popper: Ef(u)
        };
        var T = Zee(ete([].concat(n, d.options.modifiers)));
        return d.orderedModifiers = T.filter(function(k) {
          return k.enabled;
        }), m(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var _ = d.elements, x = _.reference, T = _.popper;
          if (_P(x, T)) {
            d.rects = {
              reference: Lee(x, Rp(T), d.options.strategy === "fixed"),
              popper: iD(T)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(P) {
              return d.modifiersData[P.name] = Object.assign({}, P.data);
            });
            for (var k = 0; k < d.orderedModifiers.length; k++) {
              if (d.reset === !0) {
                d.reset = !1, k = -1;
                continue;
              }
              var E = d.orderedModifiers[k], F = E.fn, R = E.options, $ = R === void 0 ? {} : R, O = E.name;
              typeof F == "function" && (d = F({
                state: d,
                options: $,
                name: O,
                instance: p
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Jee(function() {
        return new Promise(function(y) {
          p.forceUpdate(), y(d);
        });
      }),
      destroy: function() {
        b(), f = !0;
      }
    };
    if (!_P(l, u))
      return p;
    p.setOptions(c).then(function(y) {
      !f && c.onFirstUpdate && c.onFirstUpdate(y);
    });
    function m() {
      d.orderedModifiers.forEach(function(y) {
        var _ = y.name, x = y.options, T = x === void 0 ? {} : x, k = y.effect;
        if (typeof k == "function") {
          var E = k({
            state: d,
            name: _,
            instance: p,
            options: T
          }), F = function() {
          };
          h.push(E || F);
        }
      });
    }
    function b() {
      h.forEach(function(y) {
        return y();
      }), h = [];
    }
    return p;
  };
}
var km = {
  passive: !0
};
function ote(t) {
  var e = t.state, r = t.instance, n = t.options, s = n.scroll, a = s === void 0 ? !0 : s, o = n.resize, l = o === void 0 ? !0 : o, u = Xs(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return a && c.forEach(function(d) {
    d.addEventListener("scroll", r.update, km);
  }), l && u.addEventListener("resize", r.update, km), function() {
    a && c.forEach(function(d) {
      d.removeEventListener("scroll", r.update, km);
    }), l && u.removeEventListener("resize", r.update, km);
  };
}
var lte = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: ote,
  data: {}
};
function ute(t) {
  var e = t.state, r = t.name;
  e.modifiersData[r] = tV({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
var cte = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: ute,
  data: {}
}, dte = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function hte(t) {
  var e = t.x, r = t.y, n = window, s = n.devicePixelRatio || 1;
  return {
    x: $m($m(e * s) / s) || 0,
    y: $m($m(r * s) / s) || 0
  };
}
function wP(t) {
  var e, r = t.popper, n = t.popperRect, s = t.placement, a = t.variation, o = t.offsets, l = t.position, u = t.gpuAcceleration, c = t.adaptive, d = t.roundOffsets, h = d === !0 ? hte(o) : typeof d == "function" ? d(o) : o, f = h.x, p = f === void 0 ? 0 : f, m = h.y, b = m === void 0 ? 0 : m, y = o.hasOwnProperty("x"), _ = o.hasOwnProperty("y"), x = hs, T = ds, k = window;
  if (c) {
    var E = Rp(r), F = "clientHeight", R = "clientWidth";
    E === Xs(r) && (E = Pl(r), So(E).position !== "static" && l === "absolute" && (F = "scrollHeight", R = "scrollWidth")), E = E, (s === ds || (s === hs || s === Ws) && a === Jf) && (T = Gs, b -= E[F] - n.height, b *= u ? 1 : -1), (s === hs || (s === ds || s === Gs) && a === Jf) && (x = Ws, p -= E[R] - n.width, p *= u ? 1 : -1);
  }
  var $ = Object.assign({
    position: l
  }, c && dte);
  if (u) {
    var O;
    return Object.assign({}, $, (O = {}, O[T] = _ ? "0" : "", O[x] = y ? "0" : "", O.transform = (k.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + b + "px)" : "translate3d(" + p + "px, " + b + "px, 0)", O));
  }
  return Object.assign({}, $, (e = {}, e[T] = _ ? b + "px" : "", e[x] = y ? p + "px" : "", e.transform = "", e));
}
function fte(t) {
  var e = t.state, r = t.options, n = r.gpuAcceleration, s = n === void 0 ? !0 : n, a = r.adaptive, o = a === void 0 ? !0 : a, l = r.roundOffsets, u = l === void 0 ? !0 : l, c = {
    placement: Sa(e.placement),
    variation: Md(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: s
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, wP(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o,
    roundOffsets: u
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, wP(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
var pte = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: fte,
  data: {}
};
function vte(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(r) {
    var n = e.styles[r] || {}, s = e.attributes[r] || {}, a = e.elements[r];
    !cs(a) || !Ma(a) || (Object.assign(a.style, n), Object.keys(s).forEach(function(o) {
      var l = s[o];
      l === !1 ? a.removeAttribute(o) : a.setAttribute(o, l === !0 ? "" : l);
    }));
  });
}
function mte(t) {
  var e = t.state, r = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, r.popper), e.styles = r, e.elements.arrow && Object.assign(e.elements.arrow.style, r.arrow), function() {
    Object.keys(e.elements).forEach(function(n) {
      var s = e.elements[n], a = e.attributes[n] || {}, o = Object.keys(e.styles.hasOwnProperty(n) ? e.styles[n] : r[n]), l = o.reduce(function(u, c) {
        return u[c] = "", u;
      }, {});
      !cs(s) || !Ma(s) || (Object.assign(s.style, l), Object.keys(a).forEach(function(u) {
        s.removeAttribute(u);
      }));
    });
  };
}
var gte = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: vte,
  effect: mte,
  requires: ["computeStyles"]
}, yte = [lte, cte, pte, gte], bte = /* @__PURE__ */ ate({
  defaultModifiers: yte
});
function _te(t) {
  return t === "x" ? "y" : "x";
}
function Sg(t, e, r) {
  return ml(t, ep(e, r));
}
function wte(t) {
  var e = t.state, r = t.options, n = t.name, s = r.mainAxis, a = s === void 0 ? !0 : s, o = r.altAxis, l = o === void 0 ? !1 : o, u = r.boundary, c = r.rootBoundary, d = r.altBoundary, h = r.padding, f = r.tether, p = f === void 0 ? !0 : f, m = r.tetherOffset, b = m === void 0 ? 0 : m, y = oD(e, {
    boundary: u,
    rootBoundary: c,
    padding: h,
    altBoundary: d
  }), _ = Sa(e.placement), x = Md(e.placement), T = !x, k = aD(_), E = _te(k), F = e.modifiersData.popperOffsets, R = e.rects.reference, $ = e.rects.popper, O = typeof b == "function" ? b(Object.assign({}, e.rects, {
    placement: e.placement
  })) : b, P = {
    x: 0,
    y: 0
  };
  if (F) {
    if (a || l) {
      var N = k === "y" ? ds : hs, I = k === "y" ? Gs : Ws, B = k === "y" ? "height" : "width", W = F[k], Q = F[k] + y[N], te = F[k] - y[I], H = p ? -$[B] / 2 : 0, A = x === Rd ? R[B] : $[B], V = x === Rd ? -$[B] : -R[B], M = e.elements.arrow, Z = p && M ? iD(M) : {
        width: 0,
        height: 0
      }, U = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : rV(), pe = U[N], q = U[I], Y = Sg(0, R[B], Z[B]), se = T ? R[B] / 2 - H - Y - pe - O : A - Y - pe - O, he = T ? -R[B] / 2 + H + Y + q + O : V + Y + q + O, fe = e.elements.arrow && Rp(e.elements.arrow), Te = fe ? k === "y" ? fe.clientTop || 0 : fe.clientLeft || 0 : 0, ee = e.modifiersData.offset ? e.modifiersData.offset[e.placement][k] : 0, Oe = F[k] + se - ee - Te, ut = F[k] + he - ee;
      if (a) {
        var L = Sg(p ? ep(Q, Oe) : Q, W, p ? ml(te, ut) : te);
        F[k] = L, P[k] = L - W;
      }
      if (l) {
        var K = k === "x" ? ds : hs, ie = k === "x" ? Gs : Ws, ce = F[E], ve = ce + y[K], De = ce - y[ie], Re = Sg(p ? ep(ve, Oe) : ve, ce, p ? ml(De, ut) : De);
        F[E] = Re, P[E] = Re - ce;
      }
    }
    e.modifiersData[n] = P;
  }
}
var Tte = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: wte,
  requiresIfExists: ["offset"]
}, xte = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Eg(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return xte[e];
  });
}
var Ste = {
  start: "end",
  end: "start"
};
function TP(t) {
  return t.replace(/start|end/g, function(e) {
    return Ste[e];
  });
}
function Ete(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.placement, s = r.boundary, a = r.rootBoundary, o = r.padding, l = r.flipVariations, u = r.allowedAutoPlacements, c = u === void 0 ? JU : u, d = Md(n), h = d ? l ? gP : gP.filter(function(m) {
    return Md(m) === d;
  }) : Mp, f = h.filter(function(m) {
    return c.indexOf(m) >= 0;
  });
  f.length === 0 && (f = h);
  var p = f.reduce(function(m, b) {
    return m[b] = oD(t, {
      placement: b,
      boundary: s,
      rootBoundary: a,
      padding: o
    })[Sa(b)], m;
  }, {});
  return Object.keys(p).sort(function(m, b) {
    return p[m] - p[b];
  });
}
function $te(t) {
  if (Sa(t) === sD)
    return [];
  var e = Eg(t);
  return [TP(t), e, TP(e)];
}
function kte(t) {
  var e = t.state, r = t.options, n = t.name;
  if (!e.modifiersData[n]._skip) {
    for (var s = r.mainAxis, a = s === void 0 ? !0 : s, o = r.altAxis, l = o === void 0 ? !0 : o, u = r.fallbackPlacements, c = r.padding, d = r.boundary, h = r.rootBoundary, f = r.altBoundary, p = r.flipVariations, m = p === void 0 ? !0 : p, b = r.allowedAutoPlacements, y = e.options.placement, _ = Sa(y), x = _ === y, T = u || (x || !m ? [Eg(y)] : $te(y)), k = [y].concat(T).reduce(function(q, Y) {
      return q.concat(Sa(Y) === sD ? Ete(e, {
        placement: Y,
        boundary: d,
        rootBoundary: h,
        padding: c,
        flipVariations: m,
        allowedAutoPlacements: b
      }) : Y);
    }, []), E = e.rects.reference, F = e.rects.popper, R = /* @__PURE__ */ new Map(), $ = !0, O = k[0], P = 0; P < k.length; P++) {
      var N = k[P], I = Sa(N), B = Md(N) === Rd, W = [ds, Gs].indexOf(I) >= 0, Q = W ? "width" : "height", te = oD(e, {
        placement: N,
        boundary: d,
        rootBoundary: h,
        altBoundary: f,
        padding: c
      }), H = W ? B ? Ws : hs : B ? Gs : ds;
      E[Q] > F[Q] && (H = Eg(H));
      var A = Eg(H), V = [];
      if (a && V.push(te[I] <= 0), l && V.push(te[H] <= 0, te[A] <= 0), V.every(function(q) {
        return q;
      })) {
        O = N, $ = !1;
        break;
      }
      R.set(N, V);
    }
    if ($)
      for (var M = m ? 3 : 1, Z = function(Y) {
        var se = k.find(function(he) {
          var fe = R.get(he);
          if (fe)
            return fe.slice(0, Y).every(function(Te) {
              return Te;
            });
        });
        if (se)
          return O = se, "break";
      }, U = M; U > 0; U--) {
        var pe = Z(U);
        if (pe === "break")
          break;
      }
    e.placement !== O && (e.modifiersData[n]._skip = !0, e.placement = O, e.reset = !0);
  }
}
var Dte = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: kte,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ote(t, e, r) {
  var n = Sa(t), s = [hs, ds].indexOf(n) >= 0 ? -1 : 1, a = typeof r == "function" ? r(Object.assign({}, e, {
    placement: t
  })) : r, o = a[0], l = a[1];
  return o = o || 0, l = (l || 0) * s, [hs, Ws].indexOf(n) >= 0 ? {
    x: l,
    y: o
  } : {
    x: o,
    y: l
  };
}
function Ate(t) {
  var e = t.state, r = t.options, n = t.name, s = r.offset, a = s === void 0 ? [0, 0] : s, o = JU.reduce(function(d, h) {
    return d[h] = Ote(h, e.rects, a), d;
  }, {}), l = o[e.placement], u = l.x, c = l.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += u, e.modifiersData.popperOffsets.y += c), e.modifiersData[n] = o;
}
var Cte = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Ate
}, Ite = function(e, r) {
  return e = typeof e == "function" ? e(Object.assign({}, r.rects, {
    placement: r.placement
  })) : e, nV(typeof e != "number" ? e : iV(e, Mp));
};
function Pte(t) {
  var e, r = t.state, n = t.name, s = t.options, a = r.elements.arrow, o = r.modifiersData.popperOffsets, l = Sa(r.placement), u = aD(l), c = [hs, Ws].indexOf(l) >= 0, d = c ? "height" : "width";
  if (!(!a || !o)) {
    var h = Ite(s.padding, r), f = iD(a), p = u === "y" ? ds : hs, m = u === "y" ? Gs : Ws, b = r.rects.reference[d] + r.rects.reference[u] - o[u] - r.rects.popper[d], y = o[u] - r.rects.reference[u], _ = Rp(a), x = _ ? u === "y" ? _.clientHeight || 0 : _.clientWidth || 0 : 0, T = b / 2 - y / 2, k = h[p], E = x - f[d] - h[m], F = x / 2 - f[d] / 2 + T, R = Sg(k, F, E), $ = u;
    r.modifiersData[n] = (e = {}, e[$] = R, e.centerOffset = R - F, e);
  }
}
function Rte(t) {
  var e = t.state, r = t.options, n = r.element, s = n === void 0 ? "[data-popper-arrow]" : n;
  s != null && (typeof s == "string" && (s = e.elements.popper.querySelector(s), !s) || eV(e.elements.popper, s) && (e.elements.arrow = s));
}
var Mte = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Pte,
  effect: Rte,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
const H_ = (t) => parseInt(t, 10);
function Lte({
  arrowPadding: t,
  emit: e,
  locked: r,
  offsetDistance: n,
  offsetSkid: s,
  placement: a,
  popperNode: o,
  triggerNode: l
}) {
  const u = Na({
    isOpen: !1,
    popperInstance: null
  }), c = (b) => {
    var y;
    (y = u.popperInstance) === null || y === void 0 || y.setOptions((_) => ({
      ..._,
      modifiers: [..._.modifiers, {
        name: "eventListeners",
        enabled: b
      }]
    }));
  }, d = () => c(!0), h = () => c(!1), f = () => {
    u.isOpen && (u.isOpen = !1, e("close:popper"));
  }, p = () => {
    u.isOpen || (u.isOpen = !0, e("open:popper"));
  };
  Lr([() => u.isOpen, a], async ([b]) => {
    b ? (await m(), d()) : h();
  });
  const m = async () => {
    await Ia(), u.popperInstance = bte(l.value, o.value, {
      placement: a.value,
      modifiers: [Tte, Dte, {
        name: "flip",
        enabled: !r.value
      }, Mte, {
        name: "arrow",
        options: {
          padding: H_(t.value)
        }
      }, Cte, {
        name: "offset",
        options: {
          offset: [H_(s.value), H_(n.value)]
        }
      }]
    }), u.popperInstance.update();
  };
  return nh(() => {
    var b;
    (b = u.popperInstance) === null || b === void 0 || b.destroy();
  }), {
    ...t3(u),
    open: p,
    close: f
  };
}
const Nte = {
  id: "arrow",
  "data-popper-arrow": ""
};
function Fte(t, e) {
  return re(), ye("div", Nte);
}
function sV(t, e) {
  e === void 0 && (e = {});
  var r = e.insertAt;
  if (!(!t || typeof document > "u")) {
    var n = document.head || document.getElementsByTagName("head")[0], s = document.createElement("style");
    s.type = "text/css", r === "top" && n.firstChild ? n.insertBefore(s, n.firstChild) : n.appendChild(s), s.styleSheet ? s.styleSheet.cssText = t : s.appendChild(document.createTextNode(t));
  }
}
var Bte = `
#arrow[data-v-20b7fd4a],
  #arrow[data-v-20b7fd4a]::before {
    transition: background 250ms ease-in-out;
    position: absolute;
    width: calc(10px - var(--popper-theme-border-width, 0px));
    height: calc(10px - var(--popper-theme-border-width, 0px));
    box-sizing: border-box;
    background: var(--popper-theme-background-color);
}
#arrow[data-v-20b7fd4a] {
    visibility: hidden;
}
#arrow[data-v-20b7fd4a]::before {
    visibility: visible;
    content: "";
    transform: rotate(45deg);
}

  /* Top arrow */
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a] {
    bottom: -5px;
}
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-bottom: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Bottom arrow */
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a] {
    top: -5px;
}
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a]::before {
    border-left: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Left arrow */
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a] {
    right: -5px;
}
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Right arrow */
.popper[data-popper-placement^="right"] > #arrow[data-v-20b7fd4a] {
    left: -5px;
}
`;
sV(Bte);
const lD = {};
lD.render = Fte;
lD.__scopeId = "data-v-20b7fd4a";
var Ute = lD;
const Vte = ["onKeyup"];
var aV = {
  props: {
    /**
     * Preferred placement (the "auto" placements will choose the side with most space.)
     */
    placement: {
      type: String,
      default: "bottom",
      validator: function(t) {
        return ["auto", "auto-start", "auto-end", "top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "right", "right-start", "right-end", "left", "left-start", "left-end"].includes(t);
      }
    },
    /**
     * Disables automatically closing the popover when the user clicks away from it
     */
    disableClickAway: {
      type: Boolean,
      default: !1
    },
    /**
     * Offset in pixels along the trigger element
     */
    offsetSkid: {
      type: String,
      default: "0"
    },
    /**
     * Offset in pixels away from the trigger element
     */
    offsetDistance: {
      type: String,
      default: "12"
    },
    /**
     * Trigger the popper on hover
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually open/close the Popper, other events are ignored if this prop is set
     */
    show: {
      type: Boolean,
      default: null
    },
    /**
     * Disables the Popper. If it was already open, it will be closed.
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Open the Popper after a delay (ms).
     */
    openDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * Close the Popper after a delay (ms).
     */
    closeDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * The z-index of the Popper.
     */
    zIndex: {
      type: [Number, String],
      default: 9999
    },
    /**
     * Display an arrow on the popper
     */
    arrow: {
      type: Boolean,
      default: !1
    },
    /**
     * Stop arrow from reaching the edge of the popper
     */
    arrowPadding: {
      type: String,
      default: "0"
    },
    /**
     * If the Popper should be interactive, it will close when clicked/hovered if false
     */
    interactive: {
      type: Boolean,
      default: !0
    },
    /**
     * Lock the Popper into place, it will not flip dynamically when it runs out of space if true
     */
    locked: {
      type: Boolean,
      default: !1
    },
    /**
     * If the content is just a simple string, it can be passed in as a prop
     */
    content: {
      type: String,
      default: null
    }
  },
  emits: ["open:popper", "close:popper"],
  setup(t, {
    emit: e
  }) {
    const r = t;
    EX((A) => ({
      c81fc0a4: t.zIndex
    }));
    const n = sh(), s = ue(null), a = ue(null), o = ue(null), l = ue(!1);
    Nr(() => {
      const A = n.default();
      if (A && A.length > 1)
        return console.error(`[Popper]: The <Popper> component expects only one child element at its root. You passed ${A.length} child nodes.`);
    });
    const {
      arrowPadding: u,
      closeDelay: c,
      content: d,
      disableClickAway: h,
      disabled: f,
      interactive: p,
      locked: m,
      offsetDistance: b,
      offsetSkid: y,
      openDelay: _,
      placement: x,
      show: T
    } = t3(r), {
      isOpen: k,
      open: E,
      close: F
    } = Lte({
      arrowPadding: u,
      emit: e,
      locked: m,
      offsetDistance: b,
      offsetSkid: y,
      placement: x,
      popperNode: a,
      triggerNode: o
    }), {
      hasContent: R
    } = Iee(n, a, d), $ = Ce(() => T.value !== null), O = Ce(() => f.value || !R.value), P = Ce(() => k.value && !O.value), N = Ce(() => !h.value && !$.value), I = Ce(() => p.value ? `border: ${b.value}px solid transparent; margin: -${b.value}px;` : null), B = Y_.debounce(E, _.value), W = Y_.debounce(F, c.value), Q = async () => {
      O.value || $.value || (W.clear(), B());
    }, te = async () => {
      $.value || (B.clear(), W());
    }, H = () => {
      k.value ? te() : Q();
    };
    return Lr([R, f], ([A, V]) => {
      k.value && (!A || V) && F();
    }), Lr(k, (A) => {
      A ? l.value = !0 : Y_.debounce(() => {
        l.value = !1;
      }, 200);
    }), UC(() => {
      $.value && (T.value ? B() : W());
    }), UC(() => {
      N.value && Cee(s, te);
    }), (A, V) => (re(), ye("div", {
      class: "inline-block",
      style: ri(X(I)),
      onMouseleave: V[2] || (V[2] = (M) => t.hover && te()),
      ref: (M, Z) => {
        Z.popperContainerNode = M, s.value = M;
      }
    }, [ke("div", {
      ref: (M, Z) => {
        Z.triggerNode = M, o.value = M;
      },
      onMouseover: V[0] || (V[0] = (M) => t.hover && Q()),
      onClick: H,
      onFocus: Q,
      onKeyup: pt(te, ["esc"])
    }, [We(A.$slots, "default")], 40, Vte), je(gs, {
      name: "fade"
    }, {
      default: tt(() => [gd(ke("div", {
        onClick: V[1] || (V[1] = (M) => !X(p) && te()),
        class: "popper",
        ref: (M, Z) => {
          Z.popperNode = M, a.value = M;
        }
      }, [We(A.$slots, "content", {
        close: X(F),
        isOpen: l.value
      }, () => [Ra(er(X(d)), 1)]), t.arrow ? (re(), ot(Ute, {
        key: 0
      })) : be("", !0)], 512), [[_d, X(P)]])]),
      _: 3
    })], 36));
  }
}, Yte = `
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.popper[data-v-5784ed69] {
    transition: background 250ms ease-in-out;
    background: var(--popper-theme-background-color);
    padding: var(--popper-theme-padding);
    color: var(--popper-theme-text-color);
    border-radius: var(--popper-theme-border-radius);
    border-width: var(--popper-theme-border-width);
    border-style: var(--popper-theme-border-style);
    border-color: var(--popper-theme-border-color);
    box-shadow: var(--popper-theme-box-shadow);
    z-index: var(--c81fc0a4);
}
.popper[data-v-5784ed69]:hover,
  .popper:hover > #arrow[data-v-5784ed69]::before {
    background: var(--popper-theme-background-color-hover);
}
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.fade-enter-active[data-v-5784ed69],
  .fade-leave-active[data-v-5784ed69] {
    transition: opacity 0.2s ease;
}
.fade-enter-from[data-v-5784ed69],
  .fade-leave-to[data-v-5784ed69] {
    opacity: 0;
}
`;
sV(Yte);
aV.__scopeId = "data-v-5784ed69";
var oV = /* @__PURE__ */ (() => {
  const t = aV;
  return t.install = (e) => {
    e.component("Popper", t);
  }, t;
})();
const Hte = { class: "material-icons" }, Gte = /* @__PURE__ */ Dt({
  __name: "BaseButton",
  props: {
    icon: {
      type: String,
      required: !0
    },
    tooltip: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    invert: {
      type: Boolean,
      default: !1
    },
    invertIcon: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click", "pointerdown"],
  setup(t, { emit: e }) {
    const r = t, n = (l) => {
      r.disabled || e("click", l);
    }, s = ue(), { pressed: a } = Q3({
      target: s
    });
    let o = 0;
    return Lr(a, () => {
      a.value ? o = window.setInterval(() => {
        e("pointerdown");
      }, 500) : clearInterval(o);
    }), (l, u) => (re(), ye("div", null, [
      je(X(oV), {
        content: t.tooltip,
        hover: "",
        "open-delay": "1000",
        placement: "bottom-end"
      }, {
        default: tt(() => [
          ke("a", {
            ref_key: "button",
            ref: s,
            class: wt([{
              "sp-button_disable": t.disabled,
              "sp-button_invert": t.invert,
              "sp-button_invert-icon": t.invertIcon
            }, "sp-button"]),
            onClick: n
          }, [
            ke("span", Hte, er(t.icon), 1)
          ], 2)
        ]),
        _: 1
      }, 8, ["content"])
    ]));
  }
});
const si = /* @__PURE__ */ Di(Gte, [["__scopeId", "data-v-505131dd"]]), Wte = (t) => (rc("data-v-8099f30a"), t = t(), nc(), t), jte = /* @__PURE__ */ Wte(() => /* @__PURE__ */ ke("div", { class: "sp-loader__ring" }, null, -1)), Kte = [
  jte
], zte = /* @__PURE__ */ Dt({
  __name: "BaseLoader",
  props: {
    active: {
      type: Boolean,
      required: !0
    }
  },
  setup(t) {
    return (e, r) => (re(), ye("div", {
      class: wt([{
        "sp-loader_active": t.active
      }, "sp-loader"])
    }, Kte, 2));
  }
});
const qte = /* @__PURE__ */ Di(zte, [["__scopeId", "data-v-8099f30a"]]), Oi = Symbol("options"), lV = Symbol("speed"), M0 = Symbol("destroyer"), Io = Symbol("event"), Xte = (t) => (rc("data-v-cc859b08"), t = t(), nc(), t), Qte = ["onPointerup", "onPointerdown"], Zte = /* @__PURE__ */ Xte(() => /* @__PURE__ */ ke("div", { class: "sp-modal__delimiter" }, null, -1)), Jte = { class: "sp-modal__control" }, ere = /* @__PURE__ */ Dt({
  __name: "BaseModal",
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    control: {
      type: Boolean,
      default: !0
    },
    isCloseAfterConfirm: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:active", "confirm"],
  setup(t, { emit: e }) {
    const r = t, n = tr(Oi), s = ue(!1);
    Nr(() => {
      s.value = !0;
    });
    let a = !1;
    const o = () => {
      e("update:active", !1);
    }, l = (m) => {
      const { target: b } = m;
      if (b instanceof Element && !b.closest(".sp-modal__content")) {
        a = !0;
        return;
      }
      a = !1;
    }, u = (m) => {
      const { target: b } = m;
      b instanceof Element && !b.closest(".sp-modal__content") && a && (o(), a = !1);
    }, c = ue(), d = () => {
      var m;
      return (m = c.value) == null ? void 0 : m.requestSubmit();
    }, h = Vr(c, "submit", (m) => {
      m.preventDefault(), e("confirm"), r.isCloseAfterConfirm && o();
    }), f = Vr(document, "keyup", (m) => {
      r.active && m.code === "Escape" && (m.stopPropagation(), m.preventDefault(), o());
    }), p = tr(M0);
    if (!p)
      throw new Error("DESTROYER_MODULE no module assigned");
    return p.add(() => f()), p.add(() => h()), (m, b) => {
      var y;
      return re(), ot(R3, {
        to: s.value ? `[data-player-uuid='${(y = X(n)) == null ? void 0 : y.uuid}']` : "body"
      }, [
        je(gs, null, {
          default: tt(() => [
            t.active ? (re(), ye("div", {
              key: 0,
              class: "sp-modal",
              onPointerup: kt(u, ["stop"]),
              onPointerdown: kt(l, ["stop"])
            }, [
              ke("form", {
                ref_key: "form",
                ref: c,
                class: "sp-modal__content",
                onPointerup: b[0] || (b[0] = kt(() => {
                }, ["stop"])),
                onPointerdown: b[1] || (b[1] = kt(() => {
                }, ["stop"]))
              }, [
                We(m.$slots, "default", {}, void 0, !0),
                t.control ? (re(), ye(Je, { key: 0 }, [
                  Zte,
                  ke("div", Jte, [
                    je(si, {
                      icon: "check",
                      invert: "",
                      tooltip: "Принять",
                      onClick: d
                    }),
                    je(si, {
                      icon: "close",
                      "invert-icon": "",
                      tooltip: "Закрыть",
                      onClick: o
                    })
                  ])
                ], 64)) : be("", !0)
              ], 544),
              je(si, {
                class: "sp-modal__close",
                icon: "close",
                invert: "",
                tooltip: "Закрыть",
                onClick: o
              })
            ], 40, Qte)) : be("", !0)
          ]),
          _: 3
        })
      ], 8, ["to"]);
    };
  }
});
const uD = /* @__PURE__ */ Di(ere, [["__scopeId", "data-v-cc859b08"]]), Lp = (t) => (rc("data-v-64e96b86"), t = t(), nc(), t), tre = { class: "sp-info" }, rre = /* @__PURE__ */ Lp(() => /* @__PURE__ */ ke("td", null, "Название", -1)), nre = /* @__PURE__ */ Lp(() => /* @__PURE__ */ ke("td", null, "MAC", -1)), ire = /* @__PURE__ */ Lp(() => /* @__PURE__ */ ke("td", null, "IP", -1)), sre = /* @__PURE__ */ Lp(() => /* @__PURE__ */ ke("td", null, "Сервер", -1)), are = /* @__PURE__ */ Lp(() => /* @__PURE__ */ ke("td", null, "Архив", -1)), ore = /* @__PURE__ */ Dt({
  __name: "ButtonInfo",
  setup(t) {
    const e = tr(Oi), r = ue(!1);
    return (n, s) => {
      var a, o;
      return re(), ye(Je, null, [
        (o = (a = X(e)) == null ? void 0 : a.buttons) != null && o.info ? (re(), ot(si, {
          key: 0,
          icon: "info",
          tooltip: "Информация о камере",
          onClick: s[0] || (s[0] = (l) => r.value = !0)
        })) : be("", !0),
        je(uD, {
          active: r.value,
          "onUpdate:active": s[1] || (s[1] = (l) => r.value = l),
          control: !1
        }, {
          default: tt(() => {
            var l, u, c, d, h, f, p, m, b, y;
            return [
              ke("table", tre, [
                ke("tbody", null, [
                  ke("tr", null, [
                    rre,
                    ke("th", null, er((u = (l = X(e)) == null ? void 0 : l.camera) == null ? void 0 : u.name), 1)
                  ]),
                  ke("tr", null, [
                    nre,
                    ke("th", null, er((d = (c = X(e)) == null ? void 0 : c.camera) == null ? void 0 : d.mac), 1)
                  ]),
                  ke("tr", null, [
                    ire,
                    ke("th", null, er((f = (h = X(e)) == null ? void 0 : h.camera) == null ? void 0 : f.ip), 1)
                  ]),
                  ke("tr", null, [
                    sre,
                    ke("th", null, er((m = (p = X(e)) == null ? void 0 : p.camera) == null ? void 0 : m.server), 1)
                  ]),
                  ke("tr", null, [
                    are,
                    ke("th", null, er((y = (b = X(e)) == null ? void 0 : b.camera) == null ? void 0 : y.archive), 1)
                  ])
                ])
              ])
            ];
          }),
          _: 1
        }, 8, ["active"])
      ], 64);
    };
  }
});
const lre = /* @__PURE__ */ Di(ore, [["__scopeId", "data-v-64e96b86"]]), ure = /* @__PURE__ */ Dt({
  __name: "BaseButtonSimple",
  props: {
    label: {
      type: String,
      required: !0
    }
  },
  emits: ["click"],
  setup(t) {
    return (e, r) => (re(), ye("button", {
      class: "sp-button-simple",
      role: "button",
      type: "button",
      onClick: r[0] || (r[0] = (n) => e.$emit("click"))
    }, er(t.label), 1));
  }
});
const cre = /* @__PURE__ */ Di(ure, [["__scopeId", "data-v-c3ff4984"]]), dre = (t) => (rc("data-v-630399b8"), t = t(), nc(), t), hre = ["value"], fre = /* @__PURE__ */ dre(() => /* @__PURE__ */ ke("span", null, null, -1)), pre = /* @__PURE__ */ Dt({
  __name: "BaseInput",
  props: {
    label: {
      type: String,
      required: !0
    },
    modelValue: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(t) {
    return (e, r) => (re(), ye("div", {
      class: wt(["sp-input", { "sp-input_focus": t.modelValue }])
    }, [
      ke("input", {
        value: t.modelValue,
        type: "text",
        onInput: r[0] || (r[0] = (n) => e.$emit("update:modelValue", n.target.value))
      }, null, 40, hre),
      ke("label", null, er(t.label), 1),
      fre
    ], 2));
  }
});
const vre = /* @__PURE__ */ Di(pre, [["__scopeId", "data-v-630399b8"]]), xP = ue([]), uV = () => ({
  list: xP,
  set: (e) => {
    xP.value = e;
  }
}), mre = (t) => (rc("data-v-dd453a61"), t = t(), nc(), t), gre = { class: "sp-modal-playlists" }, yre = /* @__PURE__ */ mre(() => /* @__PURE__ */ ke("p", { class: "sp-modal-playlists__title" }, " Добавить камеру в плейлист ", -1)), bre = { class: "sp-modal-playlists__list" }, _re = { key: 0 }, wre = ["onClick"], Tre = { key: 1 }, xre = /* @__PURE__ */ Dt({
  __name: "ButtonPlaylist",
  setup(t) {
    const e = tr(Oi);
    if (!e)
      throw new Error("OPTIONS no module assigned");
    const r = tr(Io);
    if (!r)
      throw new Error("EVENT_MODULE no module assigned");
    const { list: n } = uV(), s = ue(!1), a = () => {
      var d;
      (d = e.playlist) != null && d.alreadyAdded ? r == null || r.emit("remove-from-playlist") : s.value = !0;
    }, o = ue(""), l = (d) => {
      r.emit("add-to-playlist", d), o.value = "", s.value = !1;
    }, u = () => {
      r.emit("create-playlist", o.value.trim()), o.value = "", s.value = !1;
    }, c = Ce(() => {
      const d = o.value.trim().toLowerCase();
      return (n.value ?? []).filter((h) => h.name.toLowerCase().includes(d));
    });
    return (d, h) => {
      var f, p, m;
      return re(), ye(Je, null, [
        (f = X(e).playlist) != null && f.enable ? (re(), ot(si, {
          key: 0,
          icon: (p = X(e).playlist) != null && p.alreadyAdded ? "delete" : "add",
          tooltip: (m = X(e).playlist) != null && m.alreadyAdded ? "Удалить из плейлиста" : "Добавить в плейлист",
          onClick: a
        }, null, 8, ["icon", "tooltip"])) : be("", !0),
        je(uD, {
          active: s.value,
          "onUpdate:active": h[1] || (h[1] = (b) => s.value = b),
          control: !1
        }, {
          default: tt(() => [
            ke("div", gre, [
              yre,
              je(vre, {
                modelValue: o.value,
                "onUpdate:modelValue": h[0] || (h[0] = (b) => o.value = b),
                label: c.value.length ? "Плейлист" : "Создать плейлист"
              }, null, 8, ["modelValue", "label"]),
              ke("div", bre, [
                je(gs, { mode: "out-in" }, {
                  default: tt(() => [
                    c.value.length ? (re(), ye("div", _re, [
                      (re(!0), ye(Je, null, Mr(c.value, (b) => (re(), ye("div", {
                        key: b.id,
                        class: "sp-modal-playlists__item",
                        onClick: (y) => l(b.id)
                      }, [
                        ke("div", null, er(b.name), 1),
                        ke("div", null, [
                          ke("b", null, er(b.channels_count), 1)
                        ])
                      ], 8, wre))), 128))
                    ])) : (re(), ye("div", Tre, [
                      je(cre, {
                        label: "Добавить",
                        onClick: u
                      })
                    ]))
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["active"])
      ], 64);
    };
  }
});
const Sre = /* @__PURE__ */ Di(xre, [["__scopeId", "data-v-dd453a61"]]), Dm = /* @__PURE__ */ new Map(), ah = (t) => ({
  add: (n) => {
    let s = Dm.get(t);
    s || (s = [], Dm.set(t, s)), s.push(n);
  },
  call: () => {
    (Dm.get(t) ?? []).forEach((s) => s()), Dm.delete(t);
  }
}), Om = /* @__PURE__ */ new Map(), cD = (t) => {
  const e = (s, a) => {
    let o = Om.get(t);
    o || (o = {}, Om.set(t, o)), o[s] || (o[s] = []), o[s].push(a);
  }, r = (s, a) => {
    const o = Om.get(t);
    if (!o)
      return;
    const l = o[s];
    l == null || l.forEach((u) => u(a));
  };
  return ah(t).add(() => Om.delete(t)), {
    on: e,
    emit: r
  };
}, Ere = ["contenteditable", "innerHTML"], $re = /* @__PURE__ */ Dt({
  __name: "TheTitle",
  setup(t) {
    var h;
    const e = ue(!1), r = ue(!1), n = ue(), s = tr(Oi);
    if (!(s != null && s.uuid))
      throw new Error("Invalid uuid");
    const a = cD(s.uuid), o = (h = s == null ? void 0 : s.title) == null ? void 0 : h.editable, { pressed: l, sourceType: u } = Q3({ target: n });
    Lr(l, () => {
      l.value && u.value === "touch" && (e.value = !e.value);
    });
    const { isOutside: c } = X3(n, { touch: !1 });
    Lr(c, () => {
      r.value || (e.value = !c.value);
    }), q3(n, () => {
      var f;
      r.value && e.value && (r.value = !1, e.value = !1, a.emit("rename", (f = n.value) == null ? void 0 : f.innerText.trim()));
    });
    const d = () => {
      o && (r.value = !0);
    };
    return (f, p) => {
      var m, b;
      return (b = (m = X(s)) == null ? void 0 : m.title) != null && b.show ? (re(), ye("div", {
        key: 0,
        ref_key: "title",
        ref: n,
        class: wt([{
          "sp-title_edit": r.value,
          "sp-title_change": X(o),
          "sp-title_active": e.value || r.value
        }, "sp-title"]),
        contenteditable: r.value,
        onDblclick: d,
        innerHTML: X(s).title.value ?? ""
      }, null, 42, Ere)) : be("", !0);
    };
  }
});
const kre = /* @__PURE__ */ Di($re, [["__scopeId", "data-v-683b18f8"]]), Dre = /* @__PURE__ */ Dt({
  __name: "TheContent",
  setup(t) {
    const e = tr(Oi), r = ue(), n = ue(!1), s = Fk(() => n.value = !0, 3e3), { x: a, stop: o } = X3(r);
    Lr(a, () => {
      e != null && e.hideCursor && (n.value = !1, s());
    });
    const l = tr(M0);
    if (!l)
      throw new Error("DESTROYER_MODULE no module assigned");
    return l.add(() => o()), (u, c) => (re(), ye("main", {
      ref_key: "content",
      ref: r,
      class: wt([{
        "sp-content_hidden-cursor": n.value
      }, "sp-content"])
    }, [
      We(u.$slots, "default", {}, void 0, !0)
    ], 2));
  }
});
const Ore = /* @__PURE__ */ Di(Dre, [["__scopeId", "data-v-cdd20df2"]]);
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var cV;
function we() {
  return cV.apply(null, arguments);
}
function Are(t) {
  cV = t;
}
function js(t) {
  return t instanceof Array || Object.prototype.toString.call(t) === "[object Array]";
}
function wu(t) {
  return t != null && Object.prototype.toString.call(t) === "[object Object]";
}
function Ht(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function dD(t) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(t).length === 0;
  var e;
  for (e in t)
    if (Ht(t, e))
      return !1;
  return !0;
}
function yi(t) {
  return t === void 0;
}
function Eo(t) {
  return typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]";
}
function Np(t) {
  return t instanceof Date || Object.prototype.toString.call(t) === "[object Date]";
}
function dV(t, e) {
  var r = [], n, s = t.length;
  for (n = 0; n < s; ++n)
    r.push(e(t[n], n));
  return r;
}
function ul(t, e) {
  for (var r in e)
    Ht(e, r) && (t[r] = e[r]);
  return Ht(e, "toString") && (t.toString = e.toString), Ht(e, "valueOf") && (t.valueOf = e.valueOf), t;
}
function Fa(t, e, r, n) {
  return MV(t, e, r, n, !0).utc();
}
function Cre() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function _t(t) {
  return t._pf == null && (t._pf = Cre()), t._pf;
}
var lx;
Array.prototype.some ? lx = Array.prototype.some : lx = function(t) {
  var e = Object(this), r = e.length >>> 0, n;
  for (n = 0; n < r; n++)
    if (n in e && t.call(this, e[n], n, e))
      return !0;
  return !1;
};
function hD(t) {
  if (t._isValid == null) {
    var e = _t(t), r = lx.call(e.parsedDateParts, function(s) {
      return s != null;
    }), n = !isNaN(t._d.getTime()) && e.overflow < 0 && !e.empty && !e.invalidEra && !e.invalidMonth && !e.invalidWeekday && !e.weekdayMismatch && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && r);
    if (t._strict && (n = n && e.charsLeftOver === 0 && e.unusedTokens.length === 0 && e.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(t))
      t._isValid = n;
    else
      return n;
  }
  return t._isValid;
}
function L0(t) {
  var e = Fa(NaN);
  return t != null ? ul(_t(e), t) : _t(e).userInvalidated = !0, e;
}
var SP = we.momentProperties = [], G_ = !1;
function fD(t, e) {
  var r, n, s, a = SP.length;
  if (yi(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), yi(e._i) || (t._i = e._i), yi(e._f) || (t._f = e._f), yi(e._l) || (t._l = e._l), yi(e._strict) || (t._strict = e._strict), yi(e._tzm) || (t._tzm = e._tzm), yi(e._isUTC) || (t._isUTC = e._isUTC), yi(e._offset) || (t._offset = e._offset), yi(e._pf) || (t._pf = _t(e)), yi(e._locale) || (t._locale = e._locale), a > 0)
    for (r = 0; r < a; r++)
      n = SP[r], s = e[n], yi(s) || (t[n] = s);
  return t;
}
function Fp(t) {
  fD(this, t), this._d = new Date(t._d != null ? t._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), G_ === !1 && (G_ = !0, we.updateOffset(this), G_ = !1);
}
function Ks(t) {
  return t instanceof Fp || t != null && t._isAMomentObject != null;
}
function hV(t) {
  we.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + t);
}
function ys(t, e) {
  var r = !0;
  return ul(function() {
    if (we.deprecationHandler != null && we.deprecationHandler(null, t), r) {
      var n = [], s, a, o, l = arguments.length;
      for (a = 0; a < l; a++) {
        if (s = "", typeof arguments[a] == "object") {
          s += `
[` + a + "] ";
          for (o in arguments[0])
            Ht(arguments[0], o) && (s += o + ": " + arguments[0][o] + ", ");
          s = s.slice(0, -2);
        } else
          s = arguments[a];
        n.push(s);
      }
      hV(
        t + `
Arguments: ` + Array.prototype.slice.call(n).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return e.apply(this, arguments);
  }, e);
}
var EP = {};
function fV(t, e) {
  we.deprecationHandler != null && we.deprecationHandler(t, e), EP[t] || (hV(e), EP[t] = !0);
}
we.suppressDeprecationWarnings = !1;
we.deprecationHandler = null;
function Ba(t) {
  return typeof Function < "u" && t instanceof Function || Object.prototype.toString.call(t) === "[object Function]";
}
function Ire(t) {
  var e, r;
  for (r in t)
    Ht(t, r) && (e = t[r], Ba(e) ? this[r] = e : this["_" + r] = e);
  this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function ux(t, e) {
  var r = ul({}, t), n;
  for (n in e)
    Ht(e, n) && (wu(t[n]) && wu(e[n]) ? (r[n] = {}, ul(r[n], t[n]), ul(r[n], e[n])) : e[n] != null ? r[n] = e[n] : delete r[n]);
  for (n in t)
    Ht(t, n) && !Ht(e, n) && wu(t[n]) && (r[n] = ul({}, r[n]));
  return r;
}
function pD(t) {
  t != null && this.set(t);
}
var cx;
Object.keys ? cx = Object.keys : cx = function(t) {
  var e, r = [];
  for (e in t)
    Ht(t, e) && r.push(e);
  return r;
};
var Pre = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function Rre(t, e, r) {
  var n = this._calendar[t] || this._calendar.sameElse;
  return Ba(n) ? n.call(e, r) : n;
}
function La(t, e, r) {
  var n = "" + Math.abs(t), s = e - n.length, a = t >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, s)).toString().substr(1) + n;
}
var vD = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Am = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, W_ = {}, xd = {};
function Qe(t, e, r, n) {
  var s = n;
  typeof n == "string" && (s = function() {
    return this[n]();
  }), t && (xd[t] = s), e && (xd[e[0]] = function() {
    return La(s.apply(this, arguments), e[1], e[2]);
  }), r && (xd[r] = function() {
    return this.localeData().ordinal(
      s.apply(this, arguments),
      t
    );
  });
}
function Mre(t) {
  return t.match(/\[[\s\S]/) ? t.replace(/^\[|\]$/g, "") : t.replace(/\\/g, "");
}
function Lre(t) {
  var e = t.match(vD), r, n;
  for (r = 0, n = e.length; r < n; r++)
    xd[e[r]] ? e[r] = xd[e[r]] : e[r] = Mre(e[r]);
  return function(s) {
    var a = "", o;
    for (o = 0; o < n; o++)
      a += Ba(e[o]) ? e[o].call(s, t) : e[o];
    return a;
  };
}
function $g(t, e) {
  return t.isValid() ? (e = pV(e, t.localeData()), W_[e] = W_[e] || Lre(e), W_[e](t)) : t.localeData().invalidDate();
}
function pV(t, e) {
  var r = 5;
  function n(s) {
    return e.longDateFormat(s) || s;
  }
  for (Am.lastIndex = 0; r >= 0 && Am.test(t); )
    t = t.replace(
      Am,
      n
    ), Am.lastIndex = 0, r -= 1;
  return t;
}
var Nre = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Fre(t) {
  var e = this._longDateFormat[t], r = this._longDateFormat[t.toUpperCase()];
  return e || !r ? e : (this._longDateFormat[t] = r.match(vD).map(function(n) {
    return n === "MMMM" || n === "MM" || n === "DD" || n === "dddd" ? n.slice(1) : n;
  }).join(""), this._longDateFormat[t]);
}
var Bre = "Invalid date";
function Ure() {
  return this._invalidDate;
}
var Vre = "%d", Yre = /\d{1,2}/;
function Hre(t) {
  return this._ordinal.replace("%d", t);
}
var Gre = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Wre(t, e, r, n) {
  var s = this._relativeTime[r];
  return Ba(s) ? s(t, e, r, n) : s.replace(/%d/i, t);
}
function jre(t, e) {
  var r = this._relativeTime[t > 0 ? "future" : "past"];
  return Ba(r) ? r(e) : r.replace(/%s/i, e);
}
var $f = {};
function jn(t, e) {
  var r = t.toLowerCase();
  $f[r] = $f[r + "s"] = $f[e] = t;
}
function bs(t) {
  return typeof t == "string" ? $f[t] || $f[t.toLowerCase()] : void 0;
}
function mD(t) {
  var e = {}, r, n;
  for (n in t)
    Ht(t, n) && (r = bs(n), r && (e[r] = t[n]));
  return e;
}
var vV = {};
function Kn(t, e) {
  vV[t] = e;
}
function Kre(t) {
  var e = [], r;
  for (r in t)
    Ht(t, r) && e.push({ unit: r, priority: vV[r] });
  return e.sort(function(n, s) {
    return n.priority - s.priority;
  }), e;
}
function N0(t) {
  return t % 4 === 0 && t % 100 !== 0 || t % 400 === 0;
}
function as(t) {
  return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
}
function St(t) {
  var e = +t, r = 0;
  return e !== 0 && isFinite(e) && (r = as(e)), r;
}
function oh(t, e) {
  return function(r) {
    return r != null ? (mV(this, t, r), we.updateOffset(this, e), this) : dy(this, t);
  };
}
function dy(t, e) {
  return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN;
}
function mV(t, e, r) {
  t.isValid() && !isNaN(r) && (e === "FullYear" && N0(t.year()) && t.month() === 1 && t.date() === 29 ? (r = St(r), t._d["set" + (t._isUTC ? "UTC" : "") + e](
    r,
    t.month(),
    H0(r, t.month())
  )) : t._d["set" + (t._isUTC ? "UTC" : "") + e](r));
}
function zre(t) {
  return t = bs(t), Ba(this[t]) ? this[t]() : this;
}
function qre(t, e) {
  if (typeof t == "object") {
    t = mD(t);
    var r = Kre(t), n, s = r.length;
    for (n = 0; n < s; n++)
      this[r[n].unit](t[r[n].unit]);
  } else if (t = bs(t), Ba(this[t]))
    return this[t](e);
  return this;
}
var gV = /\d/, zi = /\d\d/, yV = /\d{3}/, gD = /\d{4}/, F0 = /[+-]?\d{6}/, Sr = /\d\d?/, bV = /\d\d\d\d?/, _V = /\d\d\d\d\d\d?/, B0 = /\d{1,3}/, yD = /\d{1,4}/, U0 = /[+-]?\d{1,6}/, lh = /\d+/, V0 = /[+-]?\d+/, Xre = /Z|[+-]\d\d:?\d\d/gi, Y0 = /Z|[+-]\d\d(?::?\d\d)?/gi, Qre = /[+-]?\d+(\.\d{1,3})?/, Bp = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, hy;
hy = {};
function Ve(t, e, r) {
  hy[t] = Ba(e) ? e : function(n, s) {
    return n && r ? r : e;
  };
}
function Zre(t, e) {
  return Ht(hy, t) ? hy[t](e._strict, e._locale) : new RegExp(Jre(t));
}
function Jre(t) {
  return Li(
    t.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(e, r, n, s, a) {
        return r || n || s || a;
      }
    )
  );
}
function Li(t) {
  return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var dx = {};
function cr(t, e) {
  var r, n = e, s;
  for (typeof t == "string" && (t = [t]), Eo(e) && (n = function(a, o) {
    o[e] = St(a);
  }), s = t.length, r = 0; r < s; r++)
    dx[t[r]] = n;
}
function Up(t, e) {
  cr(t, function(r, n, s, a) {
    s._w = s._w || {}, e(r, s._w, s, a);
  });
}
function ene(t, e, r) {
  e != null && Ht(dx, t) && dx[t](e, r._a, r, t);
}
var Wn = 0, so = 1, va = 2, dn = 3, Fs = 4, ao = 5, cu = 6, tne = 7, rne = 8;
function nne(t, e) {
  return (t % e + e) % e;
}
var qr;
Array.prototype.indexOf ? qr = Array.prototype.indexOf : qr = function(t) {
  var e;
  for (e = 0; e < this.length; ++e)
    if (this[e] === t)
      return e;
  return -1;
};
function H0(t, e) {
  if (isNaN(t) || isNaN(e))
    return NaN;
  var r = nne(e, 12);
  return t += (e - r) / 12, r === 1 ? N0(t) ? 29 : 28 : 31 - r % 7 % 2;
}
Qe("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
Qe("MMM", 0, 0, function(t) {
  return this.localeData().monthsShort(this, t);
});
Qe("MMMM", 0, 0, function(t) {
  return this.localeData().months(this, t);
});
jn("month", "M");
Kn("month", 8);
Ve("M", Sr);
Ve("MM", Sr, zi);
Ve("MMM", function(t, e) {
  return e.monthsShortRegex(t);
});
Ve("MMMM", function(t, e) {
  return e.monthsRegex(t);
});
cr(["M", "MM"], function(t, e) {
  e[so] = St(t) - 1;
});
cr(["MMM", "MMMM"], function(t, e, r, n) {
  var s = r._locale.monthsParse(t, n, r._strict);
  s != null ? e[so] = s : _t(r).invalidMonth = t;
});
var ine = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), wV = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), TV = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, sne = Bp, ane = Bp;
function one(t, e) {
  return t ? js(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || TV).test(e) ? "format" : "standalone"][t.month()] : js(this._months) ? this._months : this._months.standalone;
}
function lne(t, e) {
  return t ? js(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[TV.test(e) ? "format" : "standalone"][t.month()] : js(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function une(t, e, r) {
  var n, s, a, o = t.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n)
      a = Fa([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[n] = this.months(a, "").toLocaleLowerCase();
  return r ? e === "MMM" ? (s = qr.call(this._shortMonthsParse, o), s !== -1 ? s : null) : (s = qr.call(this._longMonthsParse, o), s !== -1 ? s : null) : e === "MMM" ? (s = qr.call(this._shortMonthsParse, o), s !== -1 ? s : (s = qr.call(this._longMonthsParse, o), s !== -1 ? s : null)) : (s = qr.call(this._longMonthsParse, o), s !== -1 ? s : (s = qr.call(this._shortMonthsParse, o), s !== -1 ? s : null));
}
function cne(t, e, r) {
  var n, s, a;
  if (this._monthsParseExact)
    return une.call(this, t, e, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
    if (s = Fa([2e3, n]), r && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp(
      "^" + this.months(s, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[n] = new RegExp(
      "^" + this.monthsShort(s, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[n] && (a = "^" + this.months(s, "") + "|^" + this.monthsShort(s, ""), this._monthsParse[n] = new RegExp(a.replace(".", ""), "i")), r && e === "MMMM" && this._longMonthsParse[n].test(t))
      return n;
    if (r && e === "MMM" && this._shortMonthsParse[n].test(t))
      return n;
    if (!r && this._monthsParse[n].test(t))
      return n;
  }
}
function xV(t, e) {
  var r;
  if (!t.isValid())
    return t;
  if (typeof e == "string") {
    if (/^\d+$/.test(e))
      e = St(e);
    else if (e = t.localeData().monthsParse(e), !Eo(e))
      return t;
  }
  return r = Math.min(t.date(), H0(t.year(), e)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, r), t;
}
function SV(t) {
  return t != null ? (xV(this, t), we.updateOffset(this, !0), this) : dy(this, "Month");
}
function dne() {
  return H0(this.year(), this.month());
}
function hne(t) {
  return this._monthsParseExact ? (Ht(this, "_monthsRegex") || EV.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Ht(this, "_monthsShortRegex") || (this._monthsShortRegex = sne), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function fne(t) {
  return this._monthsParseExact ? (Ht(this, "_monthsRegex") || EV.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (Ht(this, "_monthsRegex") || (this._monthsRegex = ane), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex);
}
function EV() {
  function t(o, l) {
    return l.length - o.length;
  }
  var e = [], r = [], n = [], s, a;
  for (s = 0; s < 12; s++)
    a = Fa([2e3, s]), e.push(this.monthsShort(a, "")), r.push(this.months(a, "")), n.push(this.months(a, "")), n.push(this.monthsShort(a, ""));
  for (e.sort(t), r.sort(t), n.sort(t), s = 0; s < 12; s++)
    e[s] = Li(e[s]), r[s] = Li(r[s]);
  for (s = 0; s < 24; s++)
    n[s] = Li(n[s]);
  this._monthsRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
Qe("Y", 0, 0, function() {
  var t = this.year();
  return t <= 9999 ? La(t, 4) : "+" + t;
});
Qe(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
Qe(0, ["YYYY", 4], 0, "year");
Qe(0, ["YYYYY", 5], 0, "year");
Qe(0, ["YYYYYY", 6, !0], 0, "year");
jn("year", "y");
Kn("year", 1);
Ve("Y", V0);
Ve("YY", Sr, zi);
Ve("YYYY", yD, gD);
Ve("YYYYY", U0, F0);
Ve("YYYYYY", U0, F0);
cr(["YYYYY", "YYYYYY"], Wn);
cr("YYYY", function(t, e) {
  e[Wn] = t.length === 2 ? we.parseTwoDigitYear(t) : St(t);
});
cr("YY", function(t, e) {
  e[Wn] = we.parseTwoDigitYear(t);
});
cr("Y", function(t, e) {
  e[Wn] = parseInt(t, 10);
});
function kf(t) {
  return N0(t) ? 366 : 365;
}
we.parseTwoDigitYear = function(t) {
  return St(t) + (St(t) > 68 ? 1900 : 2e3);
};
var $V = oh("FullYear", !0);
function pne() {
  return N0(this.year());
}
function vne(t, e, r, n, s, a, o) {
  var l;
  return t < 100 && t >= 0 ? (l = new Date(t + 400, e, r, n, s, a, o), isFinite(l.getFullYear()) && l.setFullYear(t)) : l = new Date(t, e, r, n, s, a, o), l;
}
function tp(t) {
  var e, r;
  return t < 100 && t >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = t + 400, e = new Date(Date.UTC.apply(null, r)), isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t)) : e = new Date(Date.UTC.apply(null, arguments)), e;
}
function fy(t, e, r) {
  var n = 7 + e - r, s = (7 + tp(t, 0, n).getUTCDay() - e) % 7;
  return -s + n - 1;
}
function kV(t, e, r, n, s) {
  var a = (7 + r - n) % 7, o = fy(t, n, s), l = 1 + 7 * (e - 1) + a + o, u, c;
  return l <= 0 ? (u = t - 1, c = kf(u) + l) : l > kf(t) ? (u = t + 1, c = l - kf(t)) : (u = t, c = l), {
    year: u,
    dayOfYear: c
  };
}
function rp(t, e, r) {
  var n = fy(t.year(), e, r), s = Math.floor((t.dayOfYear() - n - 1) / 7) + 1, a, o;
  return s < 1 ? (o = t.year() - 1, a = s + ho(o, e, r)) : s > ho(t.year(), e, r) ? (a = s - ho(t.year(), e, r), o = t.year() + 1) : (o = t.year(), a = s), {
    week: a,
    year: o
  };
}
function ho(t, e, r) {
  var n = fy(t, e, r), s = fy(t + 1, e, r);
  return (kf(t) - n + s) / 7;
}
Qe("w", ["ww", 2], "wo", "week");
Qe("W", ["WW", 2], "Wo", "isoWeek");
jn("week", "w");
jn("isoWeek", "W");
Kn("week", 5);
Kn("isoWeek", 5);
Ve("w", Sr);
Ve("ww", Sr, zi);
Ve("W", Sr);
Ve("WW", Sr, zi);
Up(
  ["w", "ww", "W", "WW"],
  function(t, e, r, n) {
    e[n.substr(0, 1)] = St(t);
  }
);
function mne(t) {
  return rp(t, this._week.dow, this._week.doy).week;
}
var gne = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function yne() {
  return this._week.dow;
}
function bne() {
  return this._week.doy;
}
function _ne(t) {
  var e = this.localeData().week(this);
  return t == null ? e : this.add((t - e) * 7, "d");
}
function wne(t) {
  var e = rp(this, 1, 4).week;
  return t == null ? e : this.add((t - e) * 7, "d");
}
Qe("d", 0, "do", "day");
Qe("dd", 0, 0, function(t) {
  return this.localeData().weekdaysMin(this, t);
});
Qe("ddd", 0, 0, function(t) {
  return this.localeData().weekdaysShort(this, t);
});
Qe("dddd", 0, 0, function(t) {
  return this.localeData().weekdays(this, t);
});
Qe("e", 0, 0, "weekday");
Qe("E", 0, 0, "isoWeekday");
jn("day", "d");
jn("weekday", "e");
jn("isoWeekday", "E");
Kn("day", 11);
Kn("weekday", 11);
Kn("isoWeekday", 11);
Ve("d", Sr);
Ve("e", Sr);
Ve("E", Sr);
Ve("dd", function(t, e) {
  return e.weekdaysMinRegex(t);
});
Ve("ddd", function(t, e) {
  return e.weekdaysShortRegex(t);
});
Ve("dddd", function(t, e) {
  return e.weekdaysRegex(t);
});
Up(["dd", "ddd", "dddd"], function(t, e, r, n) {
  var s = r._locale.weekdaysParse(t, n, r._strict);
  s != null ? e.d = s : _t(r).invalidWeekday = t;
});
Up(["d", "e", "E"], function(t, e, r, n) {
  e[n] = St(t);
});
function Tne(t, e) {
  return typeof t != "string" ? t : isNaN(t) ? (t = e.weekdaysParse(t), typeof t == "number" ? t : null) : parseInt(t, 10);
}
function xne(t, e) {
  return typeof t == "string" ? e.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t;
}
function bD(t, e) {
  return t.slice(e, 7).concat(t.slice(0, e));
}
var Sne = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), DV = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Ene = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), $ne = Bp, kne = Bp, Dne = Bp;
function One(t, e) {
  var r = js(this._weekdays) ? this._weekdays : this._weekdays[t && t !== !0 && this._weekdays.isFormat.test(e) ? "format" : "standalone"];
  return t === !0 ? bD(r, this._week.dow) : t ? r[t.day()] : r;
}
function Ane(t) {
  return t === !0 ? bD(this._weekdaysShort, this._week.dow) : t ? this._weekdaysShort[t.day()] : this._weekdaysShort;
}
function Cne(t) {
  return t === !0 ? bD(this._weekdaysMin, this._week.dow) : t ? this._weekdaysMin[t.day()] : this._weekdaysMin;
}
function Ine(t, e, r) {
  var n, s, a, o = t.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n)
      a = Fa([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? e === "dddd" ? (s = qr.call(this._weekdaysParse, o), s !== -1 ? s : null) : e === "ddd" ? (s = qr.call(this._shortWeekdaysParse, o), s !== -1 ? s : null) : (s = qr.call(this._minWeekdaysParse, o), s !== -1 ? s : null) : e === "dddd" ? (s = qr.call(this._weekdaysParse, o), s !== -1 || (s = qr.call(this._shortWeekdaysParse, o), s !== -1) ? s : (s = qr.call(this._minWeekdaysParse, o), s !== -1 ? s : null)) : e === "ddd" ? (s = qr.call(this._shortWeekdaysParse, o), s !== -1 || (s = qr.call(this._weekdaysParse, o), s !== -1) ? s : (s = qr.call(this._minWeekdaysParse, o), s !== -1 ? s : null)) : (s = qr.call(this._minWeekdaysParse, o), s !== -1 || (s = qr.call(this._weekdaysParse, o), s !== -1) ? s : (s = qr.call(this._shortWeekdaysParse, o), s !== -1 ? s : null));
}
function Pne(t, e, r) {
  var n, s, a;
  if (this._weekdaysParseExact)
    return Ine.call(this, t, e, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
    if (s = Fa([2e3, 1]).day(n), r && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp(
      "^" + this.weekdays(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysShort(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysMin(s, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[n] || (a = "^" + this.weekdays(s, "") + "|^" + this.weekdaysShort(s, "") + "|^" + this.weekdaysMin(s, ""), this._weekdaysParse[n] = new RegExp(a.replace(".", ""), "i")), r && e === "dddd" && this._fullWeekdaysParse[n].test(t))
      return n;
    if (r && e === "ddd" && this._shortWeekdaysParse[n].test(t))
      return n;
    if (r && e === "dd" && this._minWeekdaysParse[n].test(t))
      return n;
    if (!r && this._weekdaysParse[n].test(t))
      return n;
  }
}
function Rne(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  var e = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return t != null ? (t = Tne(t, this.localeData()), this.add(t - e, "d")) : e;
}
function Mne(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return t == null ? e : this.add(t - e, "d");
}
function Lne(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  if (t != null) {
    var e = xne(t, this.localeData());
    return this.day(this.day() % 7 ? e : e - 7);
  } else
    return this.day() || 7;
}
function Nne(t) {
  return this._weekdaysParseExact ? (Ht(this, "_weekdaysRegex") || _D.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Ht(this, "_weekdaysRegex") || (this._weekdaysRegex = $ne), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function Fne(t) {
  return this._weekdaysParseExact ? (Ht(this, "_weekdaysRegex") || _D.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Ht(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = kne), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Bne(t) {
  return this._weekdaysParseExact ? (Ht(this, "_weekdaysRegex") || _D.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Ht(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Dne), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function _D() {
  function t(d, h) {
    return h.length - d.length;
  }
  var e = [], r = [], n = [], s = [], a, o, l, u, c;
  for (a = 0; a < 7; a++)
    o = Fa([2e3, 1]).day(a), l = Li(this.weekdaysMin(o, "")), u = Li(this.weekdaysShort(o, "")), c = Li(this.weekdays(o, "")), e.push(l), r.push(u), n.push(c), s.push(l), s.push(u), s.push(c);
  e.sort(t), r.sort(t), n.sort(t), s.sort(t), this._weekdaysRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
function wD() {
  return this.hours() % 12 || 12;
}
function Une() {
  return this.hours() || 24;
}
Qe("H", ["HH", 2], 0, "hour");
Qe("h", ["hh", 2], 0, wD);
Qe("k", ["kk", 2], 0, Une);
Qe("hmm", 0, 0, function() {
  return "" + wD.apply(this) + La(this.minutes(), 2);
});
Qe("hmmss", 0, 0, function() {
  return "" + wD.apply(this) + La(this.minutes(), 2) + La(this.seconds(), 2);
});
Qe("Hmm", 0, 0, function() {
  return "" + this.hours() + La(this.minutes(), 2);
});
Qe("Hmmss", 0, 0, function() {
  return "" + this.hours() + La(this.minutes(), 2) + La(this.seconds(), 2);
});
function OV(t, e) {
  Qe(t, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      e
    );
  });
}
OV("a", !0);
OV("A", !1);
jn("hour", "h");
Kn("hour", 13);
function AV(t, e) {
  return e._meridiemParse;
}
Ve("a", AV);
Ve("A", AV);
Ve("H", Sr);
Ve("h", Sr);
Ve("k", Sr);
Ve("HH", Sr, zi);
Ve("hh", Sr, zi);
Ve("kk", Sr, zi);
Ve("hmm", bV);
Ve("hmmss", _V);
Ve("Hmm", bV);
Ve("Hmmss", _V);
cr(["H", "HH"], dn);
cr(["k", "kk"], function(t, e, r) {
  var n = St(t);
  e[dn] = n === 24 ? 0 : n;
});
cr(["a", "A"], function(t, e, r) {
  r._isPm = r._locale.isPM(t), r._meridiem = t;
});
cr(["h", "hh"], function(t, e, r) {
  e[dn] = St(t), _t(r).bigHour = !0;
});
cr("hmm", function(t, e, r) {
  var n = t.length - 2;
  e[dn] = St(t.substr(0, n)), e[Fs] = St(t.substr(n)), _t(r).bigHour = !0;
});
cr("hmmss", function(t, e, r) {
  var n = t.length - 4, s = t.length - 2;
  e[dn] = St(t.substr(0, n)), e[Fs] = St(t.substr(n, 2)), e[ao] = St(t.substr(s)), _t(r).bigHour = !0;
});
cr("Hmm", function(t, e, r) {
  var n = t.length - 2;
  e[dn] = St(t.substr(0, n)), e[Fs] = St(t.substr(n));
});
cr("Hmmss", function(t, e, r) {
  var n = t.length - 4, s = t.length - 2;
  e[dn] = St(t.substr(0, n)), e[Fs] = St(t.substr(n, 2)), e[ao] = St(t.substr(s));
});
function Vne(t) {
  return (t + "").toLowerCase().charAt(0) === "p";
}
var Yne = /[ap]\.?m?\.?/i, Hne = oh("Hours", !0);
function Gne(t, e, r) {
  return t > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var CV = {
  calendar: Pre,
  longDateFormat: Nre,
  invalidDate: Bre,
  ordinal: Vre,
  dayOfMonthOrdinalParse: Yre,
  relativeTime: Gre,
  months: ine,
  monthsShort: wV,
  week: gne,
  weekdays: Sne,
  weekdaysMin: Ene,
  weekdaysShort: DV,
  meridiemParse: Yne
}, kr = {}, Xh = {}, np;
function Wne(t, e) {
  var r, n = Math.min(t.length, e.length);
  for (r = 0; r < n; r += 1)
    if (t[r] !== e[r])
      return r;
  return n;
}
function $P(t) {
  return t && t.toLowerCase().replace("_", "-");
}
function jne(t) {
  for (var e = 0, r, n, s, a; e < t.length; ) {
    for (a = $P(t[e]).split("-"), r = a.length, n = $P(t[e + 1]), n = n ? n.split("-") : null; r > 0; ) {
      if (s = G0(a.slice(0, r).join("-")), s)
        return s;
      if (n && n.length >= r && Wne(a, n) >= r - 1)
        break;
      r--;
    }
    e++;
  }
  return np;
}
function Kne(t) {
  return t.match("^[^/\\\\]*$") != null;
}
function G0(t) {
  var e = null, r;
  if (kr[t] === void 0 && typeof module < "u" && module && module.exports && Kne(t))
    try {
      e = np._abbr, r = require, r("./locale/" + t), gl(e);
    } catch {
      kr[t] = null;
    }
  return kr[t];
}
function gl(t, e) {
  var r;
  return t && (yi(e) ? r = Po(t) : r = TD(t, e), r ? np = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + t + " not found. Did you forget to load it?"
  )), np._abbr;
}
function TD(t, e) {
  if (e !== null) {
    var r, n = CV;
    if (e.abbr = t, kr[t] != null)
      fV(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), n = kr[t]._config;
    else if (e.parentLocale != null)
      if (kr[e.parentLocale] != null)
        n = kr[e.parentLocale]._config;
      else if (r = G0(e.parentLocale), r != null)
        n = r._config;
      else
        return Xh[e.parentLocale] || (Xh[e.parentLocale] = []), Xh[e.parentLocale].push({
          name: t,
          config: e
        }), null;
    return kr[t] = new pD(ux(n, e)), Xh[t] && Xh[t].forEach(function(s) {
      TD(s.name, s.config);
    }), gl(t), kr[t];
  } else
    return delete kr[t], null;
}
function zne(t, e) {
  if (e != null) {
    var r, n, s = CV;
    kr[t] != null && kr[t].parentLocale != null ? kr[t].set(ux(kr[t]._config, e)) : (n = G0(t), n != null && (s = n._config), e = ux(s, e), n == null && (e.abbr = t), r = new pD(e), r.parentLocale = kr[t], kr[t] = r), gl(t);
  } else
    kr[t] != null && (kr[t].parentLocale != null ? (kr[t] = kr[t].parentLocale, t === gl() && gl(t)) : kr[t] != null && delete kr[t]);
  return kr[t];
}
function Po(t) {
  var e;
  if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t)
    return np;
  if (!js(t)) {
    if (e = G0(t), e)
      return e;
    t = [t];
  }
  return jne(t);
}
function qne() {
  return cx(kr);
}
function xD(t) {
  var e, r = t._a;
  return r && _t(t).overflow === -2 && (e = r[so] < 0 || r[so] > 11 ? so : r[va] < 1 || r[va] > H0(r[Wn], r[so]) ? va : r[dn] < 0 || r[dn] > 24 || r[dn] === 24 && (r[Fs] !== 0 || r[ao] !== 0 || r[cu] !== 0) ? dn : r[Fs] < 0 || r[Fs] > 59 ? Fs : r[ao] < 0 || r[ao] > 59 ? ao : r[cu] < 0 || r[cu] > 999 ? cu : -1, _t(t)._overflowDayOfYear && (e < Wn || e > va) && (e = va), _t(t)._overflowWeeks && e === -1 && (e = tne), _t(t)._overflowWeekday && e === -1 && (e = rne), _t(t).overflow = e), t;
}
var Xne = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Qne = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Zne = /Z|[+-]\d\d(?::?\d\d)?/, Cm = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], j_ = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], Jne = /^\/?Date\((-?\d+)/i, eie = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, tie = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function IV(t) {
  var e, r, n = t._i, s = Xne.exec(n) || Qne.exec(n), a, o, l, u, c = Cm.length, d = j_.length;
  if (s) {
    for (_t(t).iso = !0, e = 0, r = c; e < r; e++)
      if (Cm[e][1].exec(s[1])) {
        o = Cm[e][0], a = Cm[e][2] !== !1;
        break;
      }
    if (o == null) {
      t._isValid = !1;
      return;
    }
    if (s[3]) {
      for (e = 0, r = d; e < r; e++)
        if (j_[e][1].exec(s[3])) {
          l = (s[2] || " ") + j_[e][0];
          break;
        }
      if (l == null) {
        t._isValid = !1;
        return;
      }
    }
    if (!a && l != null) {
      t._isValid = !1;
      return;
    }
    if (s[4])
      if (Zne.exec(s[4]))
        u = "Z";
      else {
        t._isValid = !1;
        return;
      }
    t._f = o + (l || "") + (u || ""), ED(t);
  } else
    t._isValid = !1;
}
function rie(t, e, r, n, s, a) {
  var o = [
    nie(t),
    wV.indexOf(e),
    parseInt(r, 10),
    parseInt(n, 10),
    parseInt(s, 10)
  ];
  return a && o.push(parseInt(a, 10)), o;
}
function nie(t) {
  var e = parseInt(t, 10);
  return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e;
}
function iie(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function sie(t, e, r) {
  if (t) {
    var n = DV.indexOf(t), s = new Date(
      e[0],
      e[1],
      e[2]
    ).getDay();
    if (n !== s)
      return _t(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function aie(t, e, r) {
  if (t)
    return tie[t];
  if (e)
    return 0;
  var n = parseInt(r, 10), s = n % 100, a = (n - s) / 100;
  return a * 60 + s;
}
function PV(t) {
  var e = eie.exec(iie(t._i)), r;
  if (e) {
    if (r = rie(
      e[4],
      e[3],
      e[2],
      e[5],
      e[6],
      e[7]
    ), !sie(e[1], r, t))
      return;
    t._a = r, t._tzm = aie(e[8], e[9], e[10]), t._d = tp.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), _t(t).rfc2822 = !0;
  } else
    t._isValid = !1;
}
function oie(t) {
  var e = Jne.exec(t._i);
  if (e !== null) {
    t._d = /* @__PURE__ */ new Date(+e[1]);
    return;
  }
  if (IV(t), t._isValid === !1)
    delete t._isValid;
  else
    return;
  if (PV(t), t._isValid === !1)
    delete t._isValid;
  else
    return;
  t._strict ? t._isValid = !1 : we.createFromInputFallback(t);
}
we.createFromInputFallback = ys(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(t) {
    t._d = /* @__PURE__ */ new Date(t._i + (t._useUTC ? " UTC" : ""));
  }
);
function Qc(t, e, r) {
  return t ?? e ?? r;
}
function lie(t) {
  var e = new Date(we.now());
  return t._useUTC ? [
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate()
  ] : [e.getFullYear(), e.getMonth(), e.getDate()];
}
function SD(t) {
  var e, r, n = [], s, a, o;
  if (!t._d) {
    for (s = lie(t), t._w && t._a[va] == null && t._a[so] == null && uie(t), t._dayOfYear != null && (o = Qc(t._a[Wn], s[Wn]), (t._dayOfYear > kf(o) || t._dayOfYear === 0) && (_t(t)._overflowDayOfYear = !0), r = tp(o, 0, t._dayOfYear), t._a[so] = r.getUTCMonth(), t._a[va] = r.getUTCDate()), e = 0; e < 3 && t._a[e] == null; ++e)
      t._a[e] = n[e] = s[e];
    for (; e < 7; e++)
      t._a[e] = n[e] = t._a[e] == null ? e === 2 ? 1 : 0 : t._a[e];
    t._a[dn] === 24 && t._a[Fs] === 0 && t._a[ao] === 0 && t._a[cu] === 0 && (t._nextDay = !0, t._a[dn] = 0), t._d = (t._useUTC ? tp : vne).apply(
      null,
      n
    ), a = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), t._tzm != null && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[dn] = 24), t._w && typeof t._w.d < "u" && t._w.d !== a && (_t(t).weekdayMismatch = !0);
  }
}
function uie(t) {
  var e, r, n, s, a, o, l, u, c;
  e = t._w, e.GG != null || e.W != null || e.E != null ? (a = 1, o = 4, r = Qc(
    e.GG,
    t._a[Wn],
    rp(xr(), 1, 4).year
  ), n = Qc(e.W, 1), s = Qc(e.E, 1), (s < 1 || s > 7) && (u = !0)) : (a = t._locale._week.dow, o = t._locale._week.doy, c = rp(xr(), a, o), r = Qc(e.gg, t._a[Wn], c.year), n = Qc(e.w, c.week), e.d != null ? (s = e.d, (s < 0 || s > 6) && (u = !0)) : e.e != null ? (s = e.e + a, (e.e < 0 || e.e > 6) && (u = !0)) : s = a), n < 1 || n > ho(r, a, o) ? _t(t)._overflowWeeks = !0 : u != null ? _t(t)._overflowWeekday = !0 : (l = kV(r, n, s, a, o), t._a[Wn] = l.year, t._dayOfYear = l.dayOfYear);
}
we.ISO_8601 = function() {
};
we.RFC_2822 = function() {
};
function ED(t) {
  if (t._f === we.ISO_8601) {
    IV(t);
    return;
  }
  if (t._f === we.RFC_2822) {
    PV(t);
    return;
  }
  t._a = [], _t(t).empty = !0;
  var e = "" + t._i, r, n, s, a, o, l = e.length, u = 0, c, d;
  for (s = pV(t._f, t._locale).match(vD) || [], d = s.length, r = 0; r < d; r++)
    a = s[r], n = (e.match(Zre(a, t)) || [])[0], n && (o = e.substr(0, e.indexOf(n)), o.length > 0 && _t(t).unusedInput.push(o), e = e.slice(
      e.indexOf(n) + n.length
    ), u += n.length), xd[a] ? (n ? _t(t).empty = !1 : _t(t).unusedTokens.push(a), ene(a, n, t)) : t._strict && !n && _t(t).unusedTokens.push(a);
  _t(t).charsLeftOver = l - u, e.length > 0 && _t(t).unusedInput.push(e), t._a[dn] <= 12 && _t(t).bigHour === !0 && t._a[dn] > 0 && (_t(t).bigHour = void 0), _t(t).parsedDateParts = t._a.slice(0), _t(t).meridiem = t._meridiem, t._a[dn] = cie(
    t._locale,
    t._a[dn],
    t._meridiem
  ), c = _t(t).era, c !== null && (t._a[Wn] = t._locale.erasConvertYear(c, t._a[Wn])), SD(t), xD(t);
}
function cie(t, e, r) {
  var n;
  return r == null ? e : t.meridiemHour != null ? t.meridiemHour(e, r) : (t.isPM != null && (n = t.isPM(r), n && e < 12 && (e += 12), !n && e === 12 && (e = 0)), e);
}
function die(t) {
  var e, r, n, s, a, o, l = !1, u = t._f.length;
  if (u === 0) {
    _t(t).invalidFormat = !0, t._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (s = 0; s < u; s++)
    a = 0, o = !1, e = fD({}, t), t._useUTC != null && (e._useUTC = t._useUTC), e._f = t._f[s], ED(e), hD(e) && (o = !0), a += _t(e).charsLeftOver, a += _t(e).unusedTokens.length * 10, _t(e).score = a, l ? a < n && (n = a, r = e) : (n == null || a < n || o) && (n = a, r = e, o && (l = !0));
  ul(t, r || e);
}
function hie(t) {
  if (!t._d) {
    var e = mD(t._i), r = e.day === void 0 ? e.date : e.day;
    t._a = dV(
      [e.year, e.month, r, e.hour, e.minute, e.second, e.millisecond],
      function(n) {
        return n && parseInt(n, 10);
      }
    ), SD(t);
  }
}
function fie(t) {
  var e = new Fp(xD(RV(t)));
  return e._nextDay && (e.add(1, "d"), e._nextDay = void 0), e;
}
function RV(t) {
  var e = t._i, r = t._f;
  return t._locale = t._locale || Po(t._l), e === null || r === void 0 && e === "" ? L0({ nullInput: !0 }) : (typeof e == "string" && (t._i = e = t._locale.preparse(e)), Ks(e) ? new Fp(xD(e)) : (Np(e) ? t._d = e : js(r) ? die(t) : r ? ED(t) : pie(t), hD(t) || (t._d = null), t));
}
function pie(t) {
  var e = t._i;
  yi(e) ? t._d = new Date(we.now()) : Np(e) ? t._d = new Date(e.valueOf()) : typeof e == "string" ? oie(t) : js(e) ? (t._a = dV(e.slice(0), function(r) {
    return parseInt(r, 10);
  }), SD(t)) : wu(e) ? hie(t) : Eo(e) ? t._d = new Date(e) : we.createFromInputFallback(t);
}
function MV(t, e, r, n, s) {
  var a = {};
  return (e === !0 || e === !1) && (n = e, e = void 0), (r === !0 || r === !1) && (n = r, r = void 0), (wu(t) && dD(t) || js(t) && t.length === 0) && (t = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = s, a._l = r, a._i = t, a._f = e, a._strict = n, fie(a);
}
function xr(t, e, r, n) {
  return MV(t, e, r, n, !1);
}
var vie = ys(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var t = xr.apply(null, arguments);
    return this.isValid() && t.isValid() ? t < this ? this : t : L0();
  }
), mie = ys(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var t = xr.apply(null, arguments);
    return this.isValid() && t.isValid() ? t > this ? this : t : L0();
  }
);
function LV(t, e) {
  var r, n;
  if (e.length === 1 && js(e[0]) && (e = e[0]), !e.length)
    return xr();
  for (r = e[0], n = 1; n < e.length; ++n)
    (!e[n].isValid() || e[n][t](r)) && (r = e[n]);
  return r;
}
function gie() {
  var t = [].slice.call(arguments, 0);
  return LV("isBefore", t);
}
function yie() {
  var t = [].slice.call(arguments, 0);
  return LV("isAfter", t);
}
var bie = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Qh = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function _ie(t) {
  var e, r = !1, n, s = Qh.length;
  for (e in t)
    if (Ht(t, e) && !(qr.call(Qh, e) !== -1 && (t[e] == null || !isNaN(t[e]))))
      return !1;
  for (n = 0; n < s; ++n)
    if (t[Qh[n]]) {
      if (r)
        return !1;
      parseFloat(t[Qh[n]]) !== St(t[Qh[n]]) && (r = !0);
    }
  return !0;
}
function wie() {
  return this._isValid;
}
function Tie() {
  return Qs(NaN);
}
function W0(t) {
  var e = mD(t), r = e.year || 0, n = e.quarter || 0, s = e.month || 0, a = e.week || e.isoWeek || 0, o = e.day || 0, l = e.hour || 0, u = e.minute || 0, c = e.second || 0, d = e.millisecond || 0;
  this._isValid = _ie(e), this._milliseconds = +d + c * 1e3 + // 1000
  u * 6e4 + // 1000 * 60
  l * 1e3 * 60 * 60, this._days = +o + a * 7, this._months = +s + n * 3 + r * 12, this._data = {}, this._locale = Po(), this._bubble();
}
function kg(t) {
  return t instanceof W0;
}
function hx(t) {
  return t < 0 ? Math.round(-1 * t) * -1 : Math.round(t);
}
function xie(t, e, r) {
  var n = Math.min(t.length, e.length), s = Math.abs(t.length - e.length), a = 0, o;
  for (o = 0; o < n; o++)
    (r && t[o] !== e[o] || !r && St(t[o]) !== St(e[o])) && a++;
  return a + s;
}
function NV(t, e) {
  Qe(t, 0, 0, function() {
    var r = this.utcOffset(), n = "+";
    return r < 0 && (r = -r, n = "-"), n + La(~~(r / 60), 2) + e + La(~~r % 60, 2);
  });
}
NV("Z", ":");
NV("ZZ", "");
Ve("Z", Y0);
Ve("ZZ", Y0);
cr(["Z", "ZZ"], function(t, e, r) {
  r._useUTC = !0, r._tzm = $D(Y0, t);
});
var Sie = /([\+\-]|\d\d)/gi;
function $D(t, e) {
  var r = (e || "").match(t), n, s, a;
  return r === null ? null : (n = r[r.length - 1] || [], s = (n + "").match(Sie) || ["-", 0, 0], a = +(s[1] * 60) + St(s[2]), a === 0 ? 0 : s[0] === "+" ? a : -a);
}
function kD(t, e) {
  var r, n;
  return e._isUTC ? (r = e.clone(), n = (Ks(t) || Np(t) ? t.valueOf() : xr(t).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + n), we.updateOffset(r, !1), r) : xr(t).local();
}
function fx(t) {
  return -Math.round(t._d.getTimezoneOffset());
}
we.updateOffset = function() {
};
function Eie(t, e, r) {
  var n = this._offset || 0, s;
  if (!this.isValid())
    return t != null ? this : NaN;
  if (t != null) {
    if (typeof t == "string") {
      if (t = $D(Y0, t), t === null)
        return this;
    } else
      Math.abs(t) < 16 && !r && (t = t * 60);
    return !this._isUTC && e && (s = fx(this)), this._offset = t, this._isUTC = !0, s != null && this.add(s, "m"), n !== t && (!e || this._changeInProgress ? UV(
      this,
      Qs(t - n, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, we.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? n : fx(this);
}
function $ie(t, e) {
  return t != null ? (typeof t != "string" && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset();
}
function kie(t) {
  return this.utcOffset(0, t);
}
function Die(t) {
  return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(fx(this), "m")), this;
}
function Oie() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var t = $D(Xre, this._i);
    t != null ? this.utcOffset(t) : this.utcOffset(0, !0);
  }
  return this;
}
function Aie(t) {
  return this.isValid() ? (t = t ? xr(t).utcOffset() : 0, (this.utcOffset() - t) % 60 === 0) : !1;
}
function Cie() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function Iie() {
  if (!yi(this._isDSTShifted))
    return this._isDSTShifted;
  var t = {}, e;
  return fD(t, this), t = RV(t), t._a ? (e = t._isUTC ? Fa(t._a) : xr(t._a), this._isDSTShifted = this.isValid() && xie(t._a, e.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Pie() {
  return this.isValid() ? !this._isUTC : !1;
}
function Rie() {
  return this.isValid() ? this._isUTC : !1;
}
function FV() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var Mie = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Lie = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function Qs(t, e) {
  var r = t, n = null, s, a, o;
  return kg(t) ? r = {
    ms: t._milliseconds,
    d: t._days,
    M: t._months
  } : Eo(t) || !isNaN(+t) ? (r = {}, e ? r[e] = +t : r.milliseconds = +t) : (n = Mie.exec(t)) ? (s = n[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: St(n[va]) * s,
    h: St(n[dn]) * s,
    m: St(n[Fs]) * s,
    s: St(n[ao]) * s,
    ms: St(hx(n[cu] * 1e3)) * s
    // the millisecond decimal point is included in the match
  }) : (n = Lie.exec(t)) ? (s = n[1] === "-" ? -1 : 1, r = {
    y: ql(n[2], s),
    M: ql(n[3], s),
    w: ql(n[4], s),
    d: ql(n[5], s),
    h: ql(n[6], s),
    m: ql(n[7], s),
    s: ql(n[8], s)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (o = Nie(
    xr(r.from),
    xr(r.to)
  ), r = {}, r.ms = o.milliseconds, r.M = o.months), a = new W0(r), kg(t) && Ht(t, "_locale") && (a._locale = t._locale), kg(t) && Ht(t, "_isValid") && (a._isValid = t._isValid), a;
}
Qs.fn = W0.prototype;
Qs.invalid = Tie;
function ql(t, e) {
  var r = t && parseFloat(t.replace(",", "."));
  return (isNaN(r) ? 0 : r) * e;
}
function kP(t, e) {
  var r = {};
  return r.months = e.month() - t.month() + (e.year() - t.year()) * 12, t.clone().add(r.months, "M").isAfter(e) && --r.months, r.milliseconds = +e - +t.clone().add(r.months, "M"), r;
}
function Nie(t, e) {
  var r;
  return t.isValid() && e.isValid() ? (e = kD(e, t), t.isBefore(e) ? r = kP(t, e) : (r = kP(e, t), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function BV(t, e) {
  return function(r, n) {
    var s, a;
    return n !== null && !isNaN(+n) && (fV(
      e,
      "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = n, n = a), s = Qs(r, n), UV(this, s, t), this;
  };
}
function UV(t, e, r, n) {
  var s = e._milliseconds, a = hx(e._days), o = hx(e._months);
  t.isValid() && (n = n ?? !0, o && xV(t, dy(t, "Month") + o * r), a && mV(t, "Date", dy(t, "Date") + a * r), s && t._d.setTime(t._d.valueOf() + s * r), n && we.updateOffset(t, a || o));
}
var Fie = BV(1, "add"), Bie = BV(-1, "subtract");
function VV(t) {
  return typeof t == "string" || t instanceof String;
}
function Uie(t) {
  return Ks(t) || Np(t) || VV(t) || Eo(t) || Yie(t) || Vie(t) || t === null || t === void 0;
}
function Vie(t) {
  var e = wu(t) && !dD(t), r = !1, n = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], s, a, o = n.length;
  for (s = 0; s < o; s += 1)
    a = n[s], r = r || Ht(t, a);
  return e && r;
}
function Yie(t) {
  var e = js(t), r = !1;
  return e && (r = t.filter(function(n) {
    return !Eo(n) && VV(t);
  }).length === 0), e && r;
}
function Hie(t) {
  var e = wu(t) && !dD(t), r = !1, n = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], s, a;
  for (s = 0; s < n.length; s += 1)
    a = n[s], r = r || Ht(t, a);
  return e && r;
}
function Gie(t, e) {
  var r = t.diff(e, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function Wie(t, e) {
  arguments.length === 1 && (arguments[0] ? Uie(arguments[0]) ? (t = arguments[0], e = void 0) : Hie(arguments[0]) && (e = arguments[0], t = void 0) : (t = void 0, e = void 0));
  var r = t || xr(), n = kD(r, this).startOf("day"), s = we.calendarFormat(this, n) || "sameElse", a = e && (Ba(e[s]) ? e[s].call(this, r) : e[s]);
  return this.format(
    a || this.localeData().calendar(s, this, xr(r))
  );
}
function jie() {
  return new Fp(this);
}
function Kie(t, e) {
  var r = Ks(t) ? t : xr(t);
  return this.isValid() && r.isValid() ? (e = bs(e) || "millisecond", e === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(e).valueOf()) : !1;
}
function zie(t, e) {
  var r = Ks(t) ? t : xr(t);
  return this.isValid() && r.isValid() ? (e = bs(e) || "millisecond", e === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(e).valueOf() < r.valueOf()) : !1;
}
function qie(t, e, r, n) {
  var s = Ks(t) ? t : xr(t), a = Ks(e) ? e : xr(e);
  return this.isValid() && s.isValid() && a.isValid() ? (n = n || "()", (n[0] === "(" ? this.isAfter(s, r) : !this.isBefore(s, r)) && (n[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function Xie(t, e) {
  var r = Ks(t) ? t : xr(t), n;
  return this.isValid() && r.isValid() ? (e = bs(e) || "millisecond", e === "millisecond" ? this.valueOf() === r.valueOf() : (n = r.valueOf(), this.clone().startOf(e).valueOf() <= n && n <= this.clone().endOf(e).valueOf())) : !1;
}
function Qie(t, e) {
  return this.isSame(t, e) || this.isAfter(t, e);
}
function Zie(t, e) {
  return this.isSame(t, e) || this.isBefore(t, e);
}
function Jie(t, e, r) {
  var n, s, a;
  if (!this.isValid())
    return NaN;
  if (n = kD(t, this), !n.isValid())
    return NaN;
  switch (s = (n.utcOffset() - this.utcOffset()) * 6e4, e = bs(e), e) {
    case "year":
      a = Dg(this, n) / 12;
      break;
    case "month":
      a = Dg(this, n);
      break;
    case "quarter":
      a = Dg(this, n) / 3;
      break;
    case "second":
      a = (this - n) / 1e3;
      break;
    case "minute":
      a = (this - n) / 6e4;
      break;
    case "hour":
      a = (this - n) / 36e5;
      break;
    case "day":
      a = (this - n - s) / 864e5;
      break;
    case "week":
      a = (this - n - s) / 6048e5;
      break;
    default:
      a = this - n;
  }
  return r ? a : as(a);
}
function Dg(t, e) {
  if (t.date() < e.date())
    return -Dg(e, t);
  var r = (e.year() - t.year()) * 12 + (e.month() - t.month()), n = t.clone().add(r, "months"), s, a;
  return e - n < 0 ? (s = t.clone().add(r - 1, "months"), a = (e - n) / (n - s)) : (s = t.clone().add(r + 1, "months"), a = (e - n) / (s - n)), -(r + a) || 0;
}
we.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
we.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function ese() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function tse(t) {
  if (!this.isValid())
    return null;
  var e = t !== !0, r = e ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? $g(
    r,
    e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Ba(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", $g(r, "Z")) : $g(
    r,
    e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function rse() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var t = "moment", e = "", r, n, s, a;
  return this.isLocal() || (t = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", e = "Z"), r = "[" + t + '("]', n = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", s = "-MM-DD[T]HH:mm:ss.SSS", a = e + '[")]', this.format(r + n + s + a);
}
function nse(t) {
  t || (t = this.isUtc() ? we.defaultFormatUtc : we.defaultFormat);
  var e = $g(this, t);
  return this.localeData().postformat(e);
}
function ise(t, e) {
  return this.isValid() && (Ks(t) && t.isValid() || xr(t).isValid()) ? Qs({ to: this, from: t }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
}
function sse(t) {
  return this.from(xr(), t);
}
function ase(t, e) {
  return this.isValid() && (Ks(t) && t.isValid() || xr(t).isValid()) ? Qs({ from: this, to: t }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
}
function ose(t) {
  return this.to(xr(), t);
}
function YV(t) {
  var e;
  return t === void 0 ? this._locale._abbr : (e = Po(t), e != null && (this._locale = e), this);
}
var HV = ys(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(t) {
    return t === void 0 ? this.localeData() : this.locale(t);
  }
);
function GV() {
  return this._locale;
}
var py = 1e3, Sd = 60 * py, vy = 60 * Sd, WV = (365 * 400 + 97) * 24 * vy;
function Ed(t, e) {
  return (t % e + e) % e;
}
function jV(t, e, r) {
  return t < 100 && t >= 0 ? new Date(t + 400, e, r) - WV : new Date(t, e, r).valueOf();
}
function KV(t, e, r) {
  return t < 100 && t >= 0 ? Date.UTC(t + 400, e, r) - WV : Date.UTC(t, e, r);
}
function lse(t) {
  var e, r;
  if (t = bs(t), t === void 0 || t === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? KV : jV, t) {
    case "year":
      e = r(this.year(), 0, 1);
      break;
    case "quarter":
      e = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      e = r(this.year(), this.month(), 1);
      break;
    case "week":
      e = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      e = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      e = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      e = this._d.valueOf(), e -= Ed(
        e + (this._isUTC ? 0 : this.utcOffset() * Sd),
        vy
      );
      break;
    case "minute":
      e = this._d.valueOf(), e -= Ed(e, Sd);
      break;
    case "second":
      e = this._d.valueOf(), e -= Ed(e, py);
      break;
  }
  return this._d.setTime(e), we.updateOffset(this, !0), this;
}
function use(t) {
  var e, r;
  if (t = bs(t), t === void 0 || t === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? KV : jV, t) {
    case "year":
      e = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      e = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      e = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      e = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      e = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      e = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      e = this._d.valueOf(), e += vy - Ed(
        e + (this._isUTC ? 0 : this.utcOffset() * Sd),
        vy
      ) - 1;
      break;
    case "minute":
      e = this._d.valueOf(), e += Sd - Ed(e, Sd) - 1;
      break;
    case "second":
      e = this._d.valueOf(), e += py - Ed(e, py) - 1;
      break;
  }
  return this._d.setTime(e), we.updateOffset(this, !0), this;
}
function cse() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function dse() {
  return Math.floor(this.valueOf() / 1e3);
}
function hse() {
  return new Date(this.valueOf());
}
function fse() {
  var t = this;
  return [
    t.year(),
    t.month(),
    t.date(),
    t.hour(),
    t.minute(),
    t.second(),
    t.millisecond()
  ];
}
function pse() {
  var t = this;
  return {
    years: t.year(),
    months: t.month(),
    date: t.date(),
    hours: t.hours(),
    minutes: t.minutes(),
    seconds: t.seconds(),
    milliseconds: t.milliseconds()
  };
}
function vse() {
  return this.isValid() ? this.toISOString() : null;
}
function mse() {
  return hD(this);
}
function gse() {
  return ul({}, _t(this));
}
function yse() {
  return _t(this).overflow;
}
function bse() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
Qe("N", 0, 0, "eraAbbr");
Qe("NN", 0, 0, "eraAbbr");
Qe("NNN", 0, 0, "eraAbbr");
Qe("NNNN", 0, 0, "eraName");
Qe("NNNNN", 0, 0, "eraNarrow");
Qe("y", ["y", 1], "yo", "eraYear");
Qe("y", ["yy", 2], 0, "eraYear");
Qe("y", ["yyy", 3], 0, "eraYear");
Qe("y", ["yyyy", 4], 0, "eraYear");
Ve("N", DD);
Ve("NN", DD);
Ve("NNN", DD);
Ve("NNNN", Ase);
Ve("NNNNN", Cse);
cr(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(t, e, r, n) {
    var s = r._locale.erasParse(t, n, r._strict);
    s ? _t(r).era = s : _t(r).invalidEra = t;
  }
);
Ve("y", lh);
Ve("yy", lh);
Ve("yyy", lh);
Ve("yyyy", lh);
Ve("yo", Ise);
cr(["y", "yy", "yyy", "yyyy"], Wn);
cr(["yo"], function(t, e, r, n) {
  var s;
  r._locale._eraYearOrdinalRegex && (s = t.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? e[Wn] = r._locale.eraYearOrdinalParse(t, s) : e[Wn] = parseInt(t, 10);
});
function _se(t, e) {
  var r, n, s, a = this._eras || Po("en")._eras;
  for (r = 0, n = a.length; r < n; ++r) {
    switch (typeof a[r].since) {
      case "string":
        s = we(a[r].since).startOf("day"), a[r].since = s.valueOf();
        break;
    }
    switch (typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        s = we(a[r].until).startOf("day").valueOf(), a[r].until = s.valueOf();
        break;
    }
  }
  return a;
}
function wse(t, e, r) {
  var n, s, a = this.eras(), o, l, u;
  for (t = t.toUpperCase(), n = 0, s = a.length; n < s; ++n)
    if (o = a[n].name.toUpperCase(), l = a[n].abbr.toUpperCase(), u = a[n].narrow.toUpperCase(), r)
      switch (e) {
        case "N":
        case "NN":
        case "NNN":
          if (l === t)
            return a[n];
          break;
        case "NNNN":
          if (o === t)
            return a[n];
          break;
        case "NNNNN":
          if (u === t)
            return a[n];
          break;
      }
    else if ([o, l, u].indexOf(t) >= 0)
      return a[n];
}
function Tse(t, e) {
  var r = t.since <= t.until ? 1 : -1;
  return e === void 0 ? we(t.since).year() : we(t.since).year() + (e - t.offset) * r;
}
function xse() {
  var t, e, r, n = this.localeData().eras();
  for (t = 0, e = n.length; t < e; ++t)
    if (r = this.clone().startOf("day").valueOf(), n[t].since <= r && r <= n[t].until || n[t].until <= r && r <= n[t].since)
      return n[t].name;
  return "";
}
function Sse() {
  var t, e, r, n = this.localeData().eras();
  for (t = 0, e = n.length; t < e; ++t)
    if (r = this.clone().startOf("day").valueOf(), n[t].since <= r && r <= n[t].until || n[t].until <= r && r <= n[t].since)
      return n[t].narrow;
  return "";
}
function Ese() {
  var t, e, r, n = this.localeData().eras();
  for (t = 0, e = n.length; t < e; ++t)
    if (r = this.clone().startOf("day").valueOf(), n[t].since <= r && r <= n[t].until || n[t].until <= r && r <= n[t].since)
      return n[t].abbr;
  return "";
}
function $se() {
  var t, e, r, n, s = this.localeData().eras();
  for (t = 0, e = s.length; t < e; ++t)
    if (r = s[t].since <= s[t].until ? 1 : -1, n = this.clone().startOf("day").valueOf(), s[t].since <= n && n <= s[t].until || s[t].until <= n && n <= s[t].since)
      return (this.year() - we(s[t].since).year()) * r + s[t].offset;
  return this.year();
}
function kse(t) {
  return Ht(this, "_erasNameRegex") || OD.call(this), t ? this._erasNameRegex : this._erasRegex;
}
function Dse(t) {
  return Ht(this, "_erasAbbrRegex") || OD.call(this), t ? this._erasAbbrRegex : this._erasRegex;
}
function Ose(t) {
  return Ht(this, "_erasNarrowRegex") || OD.call(this), t ? this._erasNarrowRegex : this._erasRegex;
}
function DD(t, e) {
  return e.erasAbbrRegex(t);
}
function Ase(t, e) {
  return e.erasNameRegex(t);
}
function Cse(t, e) {
  return e.erasNarrowRegex(t);
}
function Ise(t, e) {
  return e._eraYearOrdinalRegex || lh;
}
function OD() {
  var t = [], e = [], r = [], n = [], s, a, o = this.eras();
  for (s = 0, a = o.length; s < a; ++s)
    e.push(Li(o[s].name)), t.push(Li(o[s].abbr)), r.push(Li(o[s].narrow)), n.push(Li(o[s].name)), n.push(Li(o[s].abbr)), n.push(Li(o[s].narrow));
  this._erasRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
Qe(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
Qe(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function j0(t, e) {
  Qe(0, [t, t.length], 0, e);
}
j0("gggg", "weekYear");
j0("ggggg", "weekYear");
j0("GGGG", "isoWeekYear");
j0("GGGGG", "isoWeekYear");
jn("weekYear", "gg");
jn("isoWeekYear", "GG");
Kn("weekYear", 1);
Kn("isoWeekYear", 1);
Ve("G", V0);
Ve("g", V0);
Ve("GG", Sr, zi);
Ve("gg", Sr, zi);
Ve("GGGG", yD, gD);
Ve("gggg", yD, gD);
Ve("GGGGG", U0, F0);
Ve("ggggg", U0, F0);
Up(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(t, e, r, n) {
    e[n.substr(0, 2)] = St(t);
  }
);
Up(["gg", "GG"], function(t, e, r, n) {
  e[n] = we.parseTwoDigitYear(t);
});
function Pse(t) {
  return zV.call(
    this,
    t,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function Rse(t) {
  return zV.call(
    this,
    t,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function Mse() {
  return ho(this.year(), 1, 4);
}
function Lse() {
  return ho(this.isoWeekYear(), 1, 4);
}
function Nse() {
  var t = this.localeData()._week;
  return ho(this.year(), t.dow, t.doy);
}
function Fse() {
  var t = this.localeData()._week;
  return ho(this.weekYear(), t.dow, t.doy);
}
function zV(t, e, r, n, s) {
  var a;
  return t == null ? rp(this, n, s).year : (a = ho(t, n, s), e > a && (e = a), Bse.call(this, t, e, r, n, s));
}
function Bse(t, e, r, n, s) {
  var a = kV(t, e, r, n, s), o = tp(a.year, 0, a.dayOfYear);
  return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
}
Qe("Q", 0, "Qo", "quarter");
jn("quarter", "Q");
Kn("quarter", 7);
Ve("Q", gV);
cr("Q", function(t, e) {
  e[so] = (St(t) - 1) * 3;
});
function Use(t) {
  return t == null ? Math.ceil((this.month() + 1) / 3) : this.month((t - 1) * 3 + this.month() % 3);
}
Qe("D", ["DD", 2], "Do", "date");
jn("date", "D");
Kn("date", 9);
Ve("D", Sr);
Ve("DD", Sr, zi);
Ve("Do", function(t, e) {
  return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient;
});
cr(["D", "DD"], va);
cr("Do", function(t, e) {
  e[va] = St(t.match(Sr)[0]);
});
var qV = oh("Date", !0);
Qe("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
jn("dayOfYear", "DDD");
Kn("dayOfYear", 4);
Ve("DDD", B0);
Ve("DDDD", yV);
cr(["DDD", "DDDD"], function(t, e, r) {
  r._dayOfYear = St(t);
});
function Vse(t) {
  var e = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return t == null ? e : this.add(t - e, "d");
}
Qe("m", ["mm", 2], 0, "minute");
jn("minute", "m");
Kn("minute", 14);
Ve("m", Sr);
Ve("mm", Sr, zi);
cr(["m", "mm"], Fs);
var Yse = oh("Minutes", !1);
Qe("s", ["ss", 2], 0, "second");
jn("second", "s");
Kn("second", 15);
Ve("s", Sr);
Ve("ss", Sr, zi);
cr(["s", "ss"], ao);
var Hse = oh("Seconds", !1);
Qe("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
Qe(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
Qe(0, ["SSS", 3], 0, "millisecond");
Qe(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
Qe(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
Qe(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
Qe(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
Qe(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
Qe(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
jn("millisecond", "ms");
Kn("millisecond", 16);
Ve("S", B0, gV);
Ve("SS", B0, zi);
Ve("SSS", B0, yV);
var cl, XV;
for (cl = "SSSS"; cl.length <= 9; cl += "S")
  Ve(cl, lh);
function Gse(t, e) {
  e[cu] = St(("0." + t) * 1e3);
}
for (cl = "S"; cl.length <= 9; cl += "S")
  cr(cl, Gse);
XV = oh("Milliseconds", !1);
Qe("z", 0, 0, "zoneAbbr");
Qe("zz", 0, 0, "zoneName");
function Wse() {
  return this._isUTC ? "UTC" : "";
}
function jse() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var Pe = Fp.prototype;
Pe.add = Fie;
Pe.calendar = Wie;
Pe.clone = jie;
Pe.diff = Jie;
Pe.endOf = use;
Pe.format = nse;
Pe.from = ise;
Pe.fromNow = sse;
Pe.to = ase;
Pe.toNow = ose;
Pe.get = zre;
Pe.invalidAt = yse;
Pe.isAfter = Kie;
Pe.isBefore = zie;
Pe.isBetween = qie;
Pe.isSame = Xie;
Pe.isSameOrAfter = Qie;
Pe.isSameOrBefore = Zie;
Pe.isValid = mse;
Pe.lang = HV;
Pe.locale = YV;
Pe.localeData = GV;
Pe.max = mie;
Pe.min = vie;
Pe.parsingFlags = gse;
Pe.set = qre;
Pe.startOf = lse;
Pe.subtract = Bie;
Pe.toArray = fse;
Pe.toObject = pse;
Pe.toDate = hse;
Pe.toISOString = tse;
Pe.inspect = rse;
typeof Symbol < "u" && Symbol.for != null && (Pe[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
Pe.toJSON = vse;
Pe.toString = ese;
Pe.unix = dse;
Pe.valueOf = cse;
Pe.creationData = bse;
Pe.eraName = xse;
Pe.eraNarrow = Sse;
Pe.eraAbbr = Ese;
Pe.eraYear = $se;
Pe.year = $V;
Pe.isLeapYear = pne;
Pe.weekYear = Pse;
Pe.isoWeekYear = Rse;
Pe.quarter = Pe.quarters = Use;
Pe.month = SV;
Pe.daysInMonth = dne;
Pe.week = Pe.weeks = _ne;
Pe.isoWeek = Pe.isoWeeks = wne;
Pe.weeksInYear = Nse;
Pe.weeksInWeekYear = Fse;
Pe.isoWeeksInYear = Mse;
Pe.isoWeeksInISOWeekYear = Lse;
Pe.date = qV;
Pe.day = Pe.days = Rne;
Pe.weekday = Mne;
Pe.isoWeekday = Lne;
Pe.dayOfYear = Vse;
Pe.hour = Pe.hours = Hne;
Pe.minute = Pe.minutes = Yse;
Pe.second = Pe.seconds = Hse;
Pe.millisecond = Pe.milliseconds = XV;
Pe.utcOffset = Eie;
Pe.utc = kie;
Pe.local = Die;
Pe.parseZone = Oie;
Pe.hasAlignedHourOffset = Aie;
Pe.isDST = Cie;
Pe.isLocal = Pie;
Pe.isUtcOffset = Rie;
Pe.isUtc = FV;
Pe.isUTC = FV;
Pe.zoneAbbr = Wse;
Pe.zoneName = jse;
Pe.dates = ys(
  "dates accessor is deprecated. Use date instead.",
  qV
);
Pe.months = ys(
  "months accessor is deprecated. Use month instead",
  SV
);
Pe.years = ys(
  "years accessor is deprecated. Use year instead",
  $V
);
Pe.zone = ys(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  $ie
);
Pe.isDSTShifted = ys(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  Iie
);
function Kse(t) {
  return xr(t * 1e3);
}
function zse() {
  return xr.apply(null, arguments).parseZone();
}
function QV(t) {
  return t;
}
var Gt = pD.prototype;
Gt.calendar = Rre;
Gt.longDateFormat = Fre;
Gt.invalidDate = Ure;
Gt.ordinal = Hre;
Gt.preparse = QV;
Gt.postformat = QV;
Gt.relativeTime = Wre;
Gt.pastFuture = jre;
Gt.set = Ire;
Gt.eras = _se;
Gt.erasParse = wse;
Gt.erasConvertYear = Tse;
Gt.erasAbbrRegex = Dse;
Gt.erasNameRegex = kse;
Gt.erasNarrowRegex = Ose;
Gt.months = one;
Gt.monthsShort = lne;
Gt.monthsParse = cne;
Gt.monthsRegex = fne;
Gt.monthsShortRegex = hne;
Gt.week = mne;
Gt.firstDayOfYear = bne;
Gt.firstDayOfWeek = yne;
Gt.weekdays = One;
Gt.weekdaysMin = Cne;
Gt.weekdaysShort = Ane;
Gt.weekdaysParse = Pne;
Gt.weekdaysRegex = Nne;
Gt.weekdaysShortRegex = Fne;
Gt.weekdaysMinRegex = Bne;
Gt.isPM = Vne;
Gt.meridiem = Gne;
function my(t, e, r, n) {
  var s = Po(), a = Fa().set(n, e);
  return s[r](a, t);
}
function ZV(t, e, r) {
  if (Eo(t) && (e = t, t = void 0), t = t || "", e != null)
    return my(t, e, r, "month");
  var n, s = [];
  for (n = 0; n < 12; n++)
    s[n] = my(t, n, r, "month");
  return s;
}
function AD(t, e, r, n) {
  typeof t == "boolean" ? (Eo(e) && (r = e, e = void 0), e = e || "") : (e = t, r = e, t = !1, Eo(e) && (r = e, e = void 0), e = e || "");
  var s = Po(), a = t ? s._week.dow : 0, o, l = [];
  if (r != null)
    return my(e, (r + a) % 7, n, "day");
  for (o = 0; o < 7; o++)
    l[o] = my(e, (o + a) % 7, n, "day");
  return l;
}
function qse(t, e) {
  return ZV(t, e, "months");
}
function Xse(t, e) {
  return ZV(t, e, "monthsShort");
}
function Qse(t, e, r) {
  return AD(t, e, r, "weekdays");
}
function Zse(t, e, r) {
  return AD(t, e, r, "weekdaysShort");
}
function Jse(t, e, r) {
  return AD(t, e, r, "weekdaysMin");
}
gl("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(t) {
    var e = t % 10, r = St(t % 100 / 10) === 1 ? "th" : e === 1 ? "st" : e === 2 ? "nd" : e === 3 ? "rd" : "th";
    return t + r;
  }
});
we.lang = ys(
  "moment.lang is deprecated. Use moment.locale instead.",
  gl
);
we.langData = ys(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Po
);
var Qa = Math.abs;
function eae() {
  var t = this._data;
  return this._milliseconds = Qa(this._milliseconds), this._days = Qa(this._days), this._months = Qa(this._months), t.milliseconds = Qa(t.milliseconds), t.seconds = Qa(t.seconds), t.minutes = Qa(t.minutes), t.hours = Qa(t.hours), t.months = Qa(t.months), t.years = Qa(t.years), this;
}
function JV(t, e, r, n) {
  var s = Qs(e, r);
  return t._milliseconds += n * s._milliseconds, t._days += n * s._days, t._months += n * s._months, t._bubble();
}
function tae(t, e) {
  return JV(this, t, e, 1);
}
function rae(t, e) {
  return JV(this, t, e, -1);
}
function DP(t) {
  return t < 0 ? Math.floor(t) : Math.ceil(t);
}
function nae() {
  var t = this._milliseconds, e = this._days, r = this._months, n = this._data, s, a, o, l, u;
  return t >= 0 && e >= 0 && r >= 0 || t <= 0 && e <= 0 && r <= 0 || (t += DP(px(r) + e) * 864e5, e = 0, r = 0), n.milliseconds = t % 1e3, s = as(t / 1e3), n.seconds = s % 60, a = as(s / 60), n.minutes = a % 60, o = as(a / 60), n.hours = o % 24, e += as(o / 24), u = as(eY(e)), r += u, e -= DP(px(u)), l = as(r / 12), r %= 12, n.days = e, n.months = r, n.years = l, this;
}
function eY(t) {
  return t * 4800 / 146097;
}
function px(t) {
  return t * 146097 / 4800;
}
function iae(t) {
  if (!this.isValid())
    return NaN;
  var e, r, n = this._milliseconds;
  if (t = bs(t), t === "month" || t === "quarter" || t === "year")
    switch (e = this._days + n / 864e5, r = this._months + eY(e), t) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (e = this._days + Math.round(px(this._months)), t) {
      case "week":
        return e / 7 + n / 6048e5;
      case "day":
        return e + n / 864e5;
      case "hour":
        return e * 24 + n / 36e5;
      case "minute":
        return e * 1440 + n / 6e4;
      case "second":
        return e * 86400 + n / 1e3;
      case "millisecond":
        return Math.floor(e * 864e5) + n;
      default:
        throw new Error("Unknown unit " + t);
    }
}
function sae() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + St(this._months / 12) * 31536e6 : NaN;
}
function Ro(t) {
  return function() {
    return this.as(t);
  };
}
var aae = Ro("ms"), oae = Ro("s"), lae = Ro("m"), uae = Ro("h"), cae = Ro("d"), dae = Ro("w"), hae = Ro("M"), fae = Ro("Q"), pae = Ro("y");
function vae() {
  return Qs(this);
}
function mae(t) {
  return t = bs(t), this.isValid() ? this[t + "s"]() : NaN;
}
function ic(t) {
  return function() {
    return this.isValid() ? this._data[t] : NaN;
  };
}
var gae = ic("milliseconds"), yae = ic("seconds"), bae = ic("minutes"), _ae = ic("hours"), wae = ic("days"), Tae = ic("months"), xae = ic("years");
function Sae() {
  return as(this.days() / 7);
}
var ro = Math.round, rd = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Eae(t, e, r, n, s) {
  return s.relativeTime(e || 1, !!r, t, n);
}
function $ae(t, e, r, n) {
  var s = Qs(t).abs(), a = ro(s.as("s")), o = ro(s.as("m")), l = ro(s.as("h")), u = ro(s.as("d")), c = ro(s.as("M")), d = ro(s.as("w")), h = ro(s.as("y")), f = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || o <= 1 && ["m"] || o < r.m && ["mm", o] || l <= 1 && ["h"] || l < r.h && ["hh", l] || u <= 1 && ["d"] || u < r.d && ["dd", u];
  return r.w != null && (f = f || d <= 1 && ["w"] || d < r.w && ["ww", d]), f = f || c <= 1 && ["M"] || c < r.M && ["MM", c] || h <= 1 && ["y"] || ["yy", h], f[2] = e, f[3] = +t > 0, f[4] = n, Eae.apply(null, f);
}
function kae(t) {
  return t === void 0 ? ro : typeof t == "function" ? (ro = t, !0) : !1;
}
function Dae(t, e) {
  return rd[t] === void 0 ? !1 : e === void 0 ? rd[t] : (rd[t] = e, t === "s" && (rd.ss = e - 1), !0);
}
function Oae(t, e) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, n = rd, s, a;
  return typeof t == "object" && (e = t, t = !1), typeof t == "boolean" && (r = t), typeof e == "object" && (n = Object.assign({}, rd, e), e.s != null && e.ss == null && (n.ss = e.s - 1)), s = this.localeData(), a = $ae(this, !r, n, s), r && (a = s.pastFuture(+this, a)), s.postformat(a);
}
var K_ = Math.abs;
function Pc(t) {
  return (t > 0) - (t < 0) || +t;
}
function K0() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var t = K_(this._milliseconds) / 1e3, e = K_(this._days), r = K_(this._months), n, s, a, o, l = this.asSeconds(), u, c, d, h;
  return l ? (n = as(t / 60), s = as(n / 60), t %= 60, n %= 60, a = as(r / 12), r %= 12, o = t ? t.toFixed(3).replace(/\.?0+$/, "") : "", u = l < 0 ? "-" : "", c = Pc(this._months) !== Pc(l) ? "-" : "", d = Pc(this._days) !== Pc(l) ? "-" : "", h = Pc(this._milliseconds) !== Pc(l) ? "-" : "", u + "P" + (a ? c + a + "Y" : "") + (r ? c + r + "M" : "") + (e ? d + e + "D" : "") + (s || n || t ? "T" : "") + (s ? h + s + "H" : "") + (n ? h + n + "M" : "") + (t ? h + o + "S" : "")) : "P0D";
}
var Rt = W0.prototype;
Rt.isValid = wie;
Rt.abs = eae;
Rt.add = tae;
Rt.subtract = rae;
Rt.as = iae;
Rt.asMilliseconds = aae;
Rt.asSeconds = oae;
Rt.asMinutes = lae;
Rt.asHours = uae;
Rt.asDays = cae;
Rt.asWeeks = dae;
Rt.asMonths = hae;
Rt.asQuarters = fae;
Rt.asYears = pae;
Rt.valueOf = sae;
Rt._bubble = nae;
Rt.clone = vae;
Rt.get = mae;
Rt.milliseconds = gae;
Rt.seconds = yae;
Rt.minutes = bae;
Rt.hours = _ae;
Rt.days = wae;
Rt.weeks = Sae;
Rt.months = Tae;
Rt.years = xae;
Rt.humanize = Oae;
Rt.toISOString = K0;
Rt.toString = K0;
Rt.toJSON = K0;
Rt.locale = YV;
Rt.localeData = GV;
Rt.toIsoString = ys(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  K0
);
Rt.lang = HV;
Qe("X", 0, 0, "unix");
Qe("x", 0, 0, "valueOf");
Ve("x", V0);
Ve("X", Qre);
cr("X", function(t, e, r) {
  r._d = new Date(parseFloat(t) * 1e3);
});
cr("x", function(t, e, r) {
  r._d = new Date(St(t));
});
//! moment.js
we.version = "2.29.4";
Are(xr);
we.fn = Pe;
we.min = gie;
we.max = yie;
we.now = bie;
we.utc = Fa;
we.unix = Kse;
we.months = qse;
we.isDate = Np;
we.locale = gl;
we.invalid = L0;
we.duration = Qs;
we.isMoment = Ks;
we.weekdays = Qse;
we.parseZone = zse;
we.localeData = Po;
we.isDuration = kg;
we.monthsShort = Xse;
we.weekdaysMin = Jse;
we.defineLocale = TD;
we.updateLocale = zne;
we.locales = qne;
we.weekdaysShort = Zse;
we.normalizeUnits = bs;
we.relativeTimeRounding = kae;
we.relativeTimeThreshold = Dae;
we.calendarFormat = Gie;
we.prototype = Pe;
we.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
/**
 * vis-data
 * http://visjs.org/
 *
 * Manage unstructured data using DataSet. Add, update, and remove data, and listen for changes in the data.
 *
 * @version 7.1.6
 * @date    2023-03-22T11:39:37.256Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */
function sc(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var OP = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ft(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var gy = {}, Aae = {
  get exports() {
    return gy;
  },
  set exports(t) {
    gy = t;
  }
}, vx = {}, Cae = {
  get exports() {
    return vx;
  },
  set exports(t) {
    vx = t;
  }
}, mx = {}, Iae = {
  get exports() {
    return mx;
  },
  set exports(t) {
    mx = t;
  }
}, Im = function(t) {
  return t && t.Math == Math && t;
}, Hr = (
  // eslint-disable-next-line es/no-global-this -- safe
  Im(typeof globalThis == "object" && globalThis) || Im(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Im(typeof self == "object" && self) || Im(typeof OP == "object" && OP) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Function("return this")()
), Wt = function(t) {
  try {
    return !!t();
  } catch {
    return !0;
  }
}, Pae = Wt, Vp = !Pae(function() {
  var t = (function() {
  }).bind();
  return typeof t != "function" || t.hasOwnProperty("prototype");
}), Rae = Vp, tY = Function.prototype, AP = tY.apply, CP = tY.call, uh = typeof Reflect == "object" && Reflect.apply || (Rae ? CP.bind(AP) : function() {
  return CP.apply(AP, arguments);
}), rY = Vp, nY = Function.prototype, gx = nY.call, Mae = rY && nY.bind.bind(gx, gx), zt = rY ? Mae : function(t) {
  return function() {
    return gx.apply(t, arguments);
  };
}, iY = zt, Lae = iY({}.toString), Nae = iY("".slice), Mo = function(t) {
  return Nae(Lae(t), 8, -1);
}, Fae = Mo, Bae = zt, CD = function(t) {
  if (Fae(t) === "Function")
    return Bae(t);
}, yx = typeof document == "object" && document.all, Uae = typeof yx > "u" && yx !== void 0, sY = {
  all: yx,
  IS_HTMLDDA: Uae
}, aY = sY, Vae = aY.all, Gr = aY.IS_HTMLDDA ? function(t) {
  return typeof t == "function" || t === Vae;
} : function(t) {
  return typeof t == "function";
}, ac = {}, Yae = Wt, fn = !Yae(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
}), Hae = Vp, Pm = Function.prototype.call, Sn = Hae ? Pm.bind(Pm) : function() {
  return Pm.apply(Pm, arguments);
}, Yp = {}, oY = {}.propertyIsEnumerable, lY = Object.getOwnPropertyDescriptor, Gae = lY && !oY.call({ 1: 2 }, 1);
Yp.f = Gae ? function(e) {
  var r = lY(this, e);
  return !!r && r.enumerable;
} : oY;
var oc = function(t, e) {
  return {
    enumerable: !(t & 1),
    configurable: !(t & 2),
    writable: !(t & 4),
    value: e
  };
}, Wae = zt, jae = Wt, Kae = Mo, z_ = Object, zae = Wae("".split), z0 = jae(function() {
  return !z_("z").propertyIsEnumerable(0);
}) ? function(t) {
  return Kae(t) == "String" ? zae(t, "") : z_(t);
} : z_, Hp = function(t) {
  return t == null;
}, qae = Hp, Xae = TypeError, Gp = function(t) {
  if (qae(t))
    throw Xae("Can't call method on " + t);
  return t;
}, Qae = z0, Zae = Gp, Zs = function(t) {
  return Qae(Zae(t));
}, IP = Gr, uY = sY, Jae = uY.all, En = uY.IS_HTMLDDA ? function(t) {
  return typeof t == "object" ? t !== null : IP(t) || t === Jae;
} : function(t) {
  return typeof t == "object" ? t !== null : IP(t);
}, vr = {}, q_ = vr, X_ = Hr, eoe = Gr, PP = function(t) {
  return eoe(t) ? t : void 0;
}, ui = function(t, e) {
  return arguments.length < 2 ? PP(q_[t]) || PP(X_[t]) : q_[t] && q_[t][e] || X_[t] && X_[t][e];
}, toe = zt, Ar = toe({}.isPrototypeOf), Rl = typeof navigator < "u" && String(navigator.userAgent) || "", cY = Hr, Q_ = Rl, RP = cY.process, MP = cY.Deno, LP = RP && RP.versions || MP && MP.version, NP = LP && LP.v8, Ps, yy;
NP && (Ps = NP.split("."), yy = Ps[0] > 0 && Ps[0] < 4 ? 1 : +(Ps[0] + Ps[1]));
!yy && Q_ && (Ps = Q_.match(/Edge\/(\d+)/), (!Ps || Ps[1] >= 74) && (Ps = Q_.match(/Chrome\/(\d+)/), Ps && (yy = +Ps[1])));
var ch = yy, FP = ch, roe = Wt, dh = !!Object.getOwnPropertySymbols && !roe(function() {
  var t = Symbol();
  return !String(t) || !(Object(t) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && FP && FP < 41;
}), noe = dh, dY = noe && !Symbol.sham && typeof Symbol.iterator == "symbol", ioe = ui, soe = Gr, aoe = Ar, ooe = dY, loe = Object, Wp = ooe ? function(t) {
  return typeof t == "symbol";
} : function(t) {
  var e = ioe("Symbol");
  return soe(e) && aoe(e.prototype, loe(t));
}, uoe = String, hh = function(t) {
  try {
    return uoe(t);
  } catch {
    return "Object";
  }
}, coe = Gr, doe = hh, hoe = TypeError, Ai = function(t) {
  if (coe(t))
    return t;
  throw hoe(doe(t) + " is not a function");
}, foe = Ai, poe = Hp, ID = function(t, e) {
  var r = t[e];
  return poe(r) ? void 0 : foe(r);
}, Z_ = Sn, J_ = Gr, e1 = En, voe = TypeError, moe = function(t, e) {
  var r, n;
  if (e === "string" && J_(r = t.toString) && !e1(n = Z_(r, t)) || J_(r = t.valueOf) && !e1(n = Z_(r, t)) || e !== "string" && J_(r = t.toString) && !e1(n = Z_(r, t)))
    return n;
  throw voe("Can't convert object to primitive value");
}, kl = {}, goe = {
  get exports() {
    return kl;
  },
  set exports(t) {
    kl = t;
  }
}, yoe = !0, BP = Hr, boe = Object.defineProperty, _oe = function(t, e) {
  try {
    boe(BP, t, { value: e, configurable: !0, writable: !0 });
  } catch {
    BP[t] = e;
  }
  return e;
}, woe = Hr, Toe = _oe, UP = "__core-js_shared__", xoe = woe[UP] || Toe(UP, {}), PD = xoe, VP = PD;
(goe.exports = function(t, e) {
  return VP[t] || (VP[t] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.29.0",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.29.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var Soe = Gp, Eoe = Object, Ci = function(t) {
  return Eoe(Soe(t));
}, $oe = zt, koe = Ci, Doe = $oe({}.hasOwnProperty), rn = Object.hasOwn || function(e, r) {
  return Doe(koe(e), r);
}, Ooe = zt, Aoe = 0, Coe = Math.random(), Ioe = Ooe(1 .toString), q0 = function(t) {
  return "Symbol(" + (t === void 0 ? "" : t) + ")_" + Ioe(++Aoe + Coe, 36);
}, Poe = Hr, Roe = kl, YP = rn, Moe = q0, Loe = dh, Noe = dY, nd = Poe.Symbol, t1 = Roe("wks"), Foe = Noe ? nd.for || nd : nd && nd.withoutSetter || Moe, Cr = function(t) {
  return YP(t1, t) || (t1[t] = Loe && YP(nd, t) ? nd[t] : Foe("Symbol." + t)), t1[t];
}, Boe = Sn, HP = En, GP = Wp, Uoe = ID, Voe = moe, Yoe = Cr, Hoe = TypeError, Goe = Yoe("toPrimitive"), Woe = function(t, e) {
  if (!HP(t) || GP(t))
    return t;
  var r = Uoe(t, Goe), n;
  if (r) {
    if (e === void 0 && (e = "default"), n = Boe(r, t, e), !HP(n) || GP(n))
      return n;
    throw Hoe("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), Voe(t, e);
}, joe = Woe, Koe = Wp, X0 = function(t) {
  var e = joe(t, "string");
  return Koe(e) ? e : e + "";
}, zoe = Hr, WP = En, bx = zoe.document, qoe = WP(bx) && WP(bx.createElement), RD = function(t) {
  return qoe ? bx.createElement(t) : {};
}, Xoe = fn, Qoe = Wt, Zoe = RD, hY = !Xoe && !Qoe(function() {
  return Object.defineProperty(Zoe("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
}), Joe = fn, ele = Sn, tle = Yp, rle = oc, nle = Zs, ile = X0, sle = rn, ale = hY, jP = Object.getOwnPropertyDescriptor;
ac.f = Joe ? jP : function(e, r) {
  if (e = nle(e), r = ile(r), ale)
    try {
      return jP(e, r);
    } catch {
    }
  if (sle(e, r))
    return rle(!ele(tle.f, e, r), e[r]);
};
var ole = Wt, lle = Gr, ule = /#|\.prototype\./, jp = function(t, e) {
  var r = dle[cle(t)];
  return r == fle ? !0 : r == hle ? !1 : lle(e) ? ole(e) : !!e;
}, cle = jp.normalize = function(t) {
  return String(t).replace(ule, ".").toLowerCase();
}, dle = jp.data = {}, hle = jp.NATIVE = "N", fle = jp.POLYFILL = "P", fY = jp, KP = CD, ple = Ai, vle = Vp, mle = KP(KP.bind), Ml = function(t, e) {
  return ple(t), e === void 0 ? t : vle ? mle(t, e) : function() {
    return t.apply(e, arguments);
  };
}, qi = {}, gle = fn, yle = Wt, pY = gle && yle(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype != 42;
}), ble = En, _le = String, wle = TypeError, Xi = function(t) {
  if (ble(t))
    return t;
  throw wle(_le(t) + " is not an object");
}, Tle = fn, xle = hY, Sle = pY, Rm = Xi, zP = X0, Ele = TypeError, r1 = Object.defineProperty, $le = Object.getOwnPropertyDescriptor, n1 = "enumerable", i1 = "configurable", s1 = "writable";
qi.f = Tle ? Sle ? function(e, r, n) {
  if (Rm(e), r = zP(r), Rm(n), typeof e == "function" && r === "prototype" && "value" in n && s1 in n && !n[s1]) {
    var s = $le(e, r);
    s && s[s1] && (e[r] = n.value, n = {
      configurable: i1 in n ? n[i1] : s[i1],
      enumerable: n1 in n ? n[n1] : s[n1],
      writable: !1
    });
  }
  return r1(e, r, n);
} : r1 : function(e, r, n) {
  if (Rm(e), r = zP(r), Rm(n), xle)
    try {
      return r1(e, r, n);
    } catch {
    }
  if ("get" in n || "set" in n)
    throw Ele("Accessors not supported");
  return "value" in n && (e[r] = n.value), e;
};
var kle = fn, Dle = qi, Ole = oc, Lo = kle ? function(t, e, r) {
  return Dle.f(t, e, Ole(1, r));
} : function(t, e, r) {
  return t[e] = r, t;
}, Mm = Hr, Ale = uh, Cle = CD, Ile = Gr, Ple = ac.f, Rle = fY, Rc = vr, Mle = Ml, Mc = Lo, qP = rn, Lle = function(t) {
  var e = function(r, n, s) {
    if (this instanceof e) {
      switch (arguments.length) {
        case 0:
          return new t();
        case 1:
          return new t(r);
        case 2:
          return new t(r, n);
      }
      return new t(r, n, s);
    }
    return Ale(t, this, arguments);
  };
  return e.prototype = t.prototype, e;
}, qe = function(t, e) {
  var r = t.target, n = t.global, s = t.stat, a = t.proto, o = n ? Mm : s ? Mm[r] : (Mm[r] || {}).prototype, l = n ? Rc : Rc[r] || Mc(Rc, r, {})[r], u = l.prototype, c, d, h, f, p, m, b, y, _;
  for (f in e)
    c = Rle(n ? f : r + (s ? "." : "#") + f, t.forced), d = !c && o && qP(o, f), m = l[f], d && (t.dontCallGetSet ? (_ = Ple(o, f), b = _ && _.value) : b = o[f]), p = d && b ? b : e[f], !(d && typeof m == typeof p) && (t.bind && d ? y = Mle(p, Mm) : t.wrap && d ? y = Lle(p) : a && Ile(p) ? y = Cle(p) : y = p, (t.sham || p && p.sham || m && m.sham) && Mc(y, "sham", !0), Mc(l, f, y), a && (h = r + "Prototype", qP(Rc, h) || Mc(Rc, h, {}), Mc(Rc[h], f, p), t.real && u && (c || !u[f]) && Mc(u, f, p)));
}, Nle = qe, Fle = fn, XP = qi.f;
Nle({ target: "Object", stat: !0, forced: Object.defineProperty !== XP, sham: !Fle }, {
  defineProperty: XP
});
var Ble = vr, vY = Ble.Object, Ule = Iae.exports = function(e, r, n) {
  return vY.defineProperty(e, r, n);
};
vY.defineProperty.sham && (Ule.sham = !0);
var Vle = mx, mY = Vle, Yle = mY, Hle = Yle, Gle = Hle, Wle = Gle;
(function(t) {
  t.exports = Wle;
})(Cae);
(function(t) {
  t.exports = vx;
})(Aae);
var Q0 = /* @__PURE__ */ ft(gy), ip = {}, jle = {
  get exports() {
    return ip;
  },
  set exports(t) {
    ip = t;
  }
}, _x = {}, Kle = {
  get exports() {
    return _x;
  },
  set exports(t) {
    _x = t;
  }
}, zle = Mo, Ll = Array.isArray || function(e) {
  return zle(e) == "Array";
}, qle = Math.ceil, Xle = Math.floor, Qle = Math.trunc || function(e) {
  var r = +e;
  return (r > 0 ? Xle : qle)(r);
}, Zle = Qle, Z0 = function(t) {
  var e = +t;
  return e !== e || e === 0 ? 0 : Zle(e);
}, Jle = Z0, eue = Math.min, tue = function(t) {
  return t > 0 ? eue(Jle(t), 9007199254740991) : 0;
}, rue = tue, Qi = function(t) {
  return rue(t.length);
}, nue = TypeError, iue = 9007199254740991, MD = function(t) {
  if (t > iue)
    throw nue("Maximum allowed index exceeded");
  return t;
}, sue = X0, aue = qi, oue = oc, fh = function(t, e, r) {
  var n = sue(e);
  n in t ? aue.f(t, n, oue(0, r)) : t[n] = r;
}, lue = Cr, uue = lue("toStringTag"), gY = {};
gY[uue] = "z";
var LD = String(gY) === "[object z]", cue = LD, due = Gr, Og = Mo, hue = Cr, fue = hue("toStringTag"), pue = Object, vue = Og(function() {
  return arguments;
}()) == "Arguments", mue = function(t, e) {
  try {
    return t[e];
  } catch {
  }
}, No = cue ? Og : function(t) {
  var e, r, n;
  return t === void 0 ? "Undefined" : t === null ? "Null" : typeof (r = mue(e = pue(t), fue)) == "string" ? r : vue ? Og(e) : (n = Og(e)) == "Object" && due(e.callee) ? "Arguments" : n;
}, gue = zt, yue = Gr, wx = PD, bue = gue(Function.toString);
yue(wx.inspectSource) || (wx.inspectSource = function(t) {
  return bue(t);
});
var yY = wx.inspectSource, _ue = zt, wue = Wt, bY = Gr, Tue = No, xue = ui, Sue = yY, _Y = function() {
}, Eue = [], wY = xue("Reflect", "construct"), ND = /^\s*(?:class|function)\b/, $ue = _ue(ND.exec), kue = !ND.exec(_Y), Zh = function(e) {
  if (!bY(e))
    return !1;
  try {
    return wY(_Y, Eue, e), !0;
  } catch {
    return !1;
  }
}, TY = function(e) {
  if (!bY(e))
    return !1;
  switch (Tue(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return kue || !!$ue(ND, Sue(e));
  } catch {
    return !0;
  }
};
TY.sham = !0;
var J0 = !wY || wue(function() {
  var t;
  return Zh(Zh.call) || !Zh(Object) || !Zh(function() {
    t = !0;
  }) || t;
}) ? TY : Zh, QP = Ll, Due = J0, Oue = En, Aue = Cr, Cue = Aue("species"), ZP = Array, Iue = function(t) {
  var e;
  return QP(t) && (e = t.constructor, Due(e) && (e === ZP || QP(e.prototype)) ? e = void 0 : Oue(e) && (e = e[Cue], e === null && (e = void 0))), e === void 0 ? ZP : e;
}, Pue = Iue, eb = function(t, e) {
  return new (Pue(t))(e === 0 ? 0 : e);
}, Rue = Wt, Mue = Cr, Lue = ch, Nue = Mue("species"), Kp = function(t) {
  return Lue >= 51 || !Rue(function() {
    var e = [], r = e.constructor = {};
    return r[Nue] = function() {
      return { foo: 1 };
    }, e[t](Boolean).foo !== 1;
  });
}, Fue = qe, Bue = Wt, Uue = Ll, Vue = En, Yue = Ci, Hue = Qi, JP = MD, eR = fh, Gue = eb, Wue = Kp, jue = Cr, Kue = ch, xY = jue("isConcatSpreadable"), zue = Kue >= 51 || !Bue(function() {
  var t = [];
  return t[xY] = !1, t.concat()[0] !== t;
}), que = function(t) {
  if (!Vue(t))
    return !1;
  var e = t[xY];
  return e !== void 0 ? !!e : Uue(t);
}, Xue = !zue || !Wue("concat");
Fue({ target: "Array", proto: !0, arity: 1, forced: Xue }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(e) {
    var r = Yue(this), n = Gue(r, 0), s = 0, a, o, l, u, c;
    for (a = -1, l = arguments.length; a < l; a++)
      if (c = a === -1 ? r : arguments[a], que(c))
        for (u = Hue(c), JP(s + u), o = 0; o < u; o++, s++)
          o in c && eR(n, s, c[o]);
      else
        JP(s + 1), eR(n, s++, c);
    return n.length = s, n;
  }
});
var Que = No, Zue = String, Ua = function(t) {
  if (Que(t) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return Zue(t);
}, tb = {}, Jue = Z0, ece = Math.max, tce = Math.min, zp = function(t, e) {
  var r = Jue(t);
  return r < 0 ? ece(r + e, 0) : tce(r, e);
}, rce = Zs, nce = zp, ice = Qi, tR = function(t) {
  return function(e, r, n) {
    var s = rce(e), a = ice(s), o = nce(n, a), l;
    if (t && r != r) {
      for (; a > o; )
        if (l = s[o++], l != l)
          return !0;
    } else
      for (; a > o; o++)
        if ((t || o in s) && s[o] === r)
          return t || o || 0;
    return !t && -1;
  };
}, FD = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: tR(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: tR(!1)
}, qp = {}, sce = zt, a1 = rn, ace = Zs, oce = FD.indexOf, lce = qp, rR = sce([].push), SY = function(t, e) {
  var r = ace(t), n = 0, s = [], a;
  for (a in r)
    !a1(lce, a) && a1(r, a) && rR(s, a);
  for (; e.length > n; )
    a1(r, a = e[n++]) && (~oce(s, a) || rR(s, a));
  return s;
}, BD = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], uce = SY, cce = BD, Xp = Object.keys || function(e) {
  return uce(e, cce);
}, dce = fn, hce = pY, fce = qi, pce = Xi, vce = Zs, mce = Xp;
tb.f = dce && !hce ? Object.defineProperties : function(e, r) {
  pce(e);
  for (var n = vce(r), s = mce(r), a = s.length, o = 0, l; a > o; )
    fce.f(e, l = s[o++], n[l]);
  return e;
};
var gce = ui, EY = gce("document", "documentElement"), yce = kl, bce = q0, nR = yce("keys"), rb = function(t) {
  return nR[t] || (nR[t] = bce(t));
}, _ce = Xi, wce = tb, iR = BD, Tce = qp, xce = EY, Sce = RD, Ece = rb, sR = ">", aR = "<", Tx = "prototype", xx = "script", $Y = Ece("IE_PROTO"), o1 = function() {
}, kY = function(t) {
  return aR + xx + sR + t + aR + "/" + xx + sR;
}, oR = function(t) {
  t.write(kY("")), t.close();
  var e = t.parentWindow.Object;
  return t = null, e;
}, $ce = function() {
  var t = Sce("iframe"), e = "java" + xx + ":", r;
  return t.style.display = "none", xce.appendChild(t), t.src = String(e), r = t.contentWindow.document, r.open(), r.write(kY("document.F=Object")), r.close(), r.F;
}, Lm, Ag = function() {
  try {
    Lm = new ActiveXObject("htmlfile");
  } catch {
  }
  Ag = typeof document < "u" ? document.domain && Lm ? oR(Lm) : $ce() : oR(Lm);
  for (var t = iR.length; t--; )
    delete Ag[Tx][iR[t]];
  return Ag();
};
Tce[$Y] = !0;
var lc = Object.create || function(e, r) {
  var n;
  return e !== null ? (o1[Tx] = _ce(e), n = new o1(), o1[Tx] = null, n[$Y] = e) : n = Ag(), r === void 0 ? n : wce.f(n, r);
}, Qp = {}, kce = SY, Dce = BD, Oce = Dce.concat("length", "prototype");
Qp.f = Object.getOwnPropertyNames || function(e) {
  return kce(e, Oce);
};
var UD = {}, lR = zp, Ace = Qi, Cce = fh, Ice = Array, Pce = Math.max, DY = function(t, e, r) {
  for (var n = Ace(t), s = lR(e, n), a = lR(r === void 0 ? n : r, n), o = Ice(Pce(a - s, 0)), l = 0; s < a; s++, l++)
    Cce(o, l, t[s]);
  return o.length = l, o;
}, Rce = Mo, Mce = Zs, OY = Qp.f, Lce = DY, AY = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], Nce = function(t) {
  try {
    return OY(t);
  } catch {
    return Lce(AY);
  }
};
UD.f = function(e) {
  return AY && Rce(e) == "Window" ? Nce(e) : OY(Mce(e));
};
var Zp = {};
Zp.f = Object.getOwnPropertySymbols;
var Fce = Lo, ph = function(t, e, r, n) {
  return n && n.enumerable ? t[e] = r : Fce(t, e, r), t;
}, Bce = qi, VD = function(t, e, r) {
  return Bce.f(t, e, r);
}, Jp = {}, Uce = Cr;
Jp.f = Uce;
var uR = vr, Vce = rn, Yce = Jp, Hce = qi.f, Wr = function(t) {
  var e = uR.Symbol || (uR.Symbol = {});
  Vce(e, t) || Hce(e, t, {
    value: Yce.f(t)
  });
}, Gce = Sn, Wce = ui, jce = Cr, Kce = ph, CY = function() {
  var t = Wce("Symbol"), e = t && t.prototype, r = e && e.valueOf, n = jce("toPrimitive");
  e && !e[n] && Kce(e, n, function(s) {
    return Gce(r, this);
  }, { arity: 1 });
}, zce = LD, qce = No, Xce = zce ? {}.toString : function() {
  return "[object " + qce(this) + "]";
}, Qce = LD, Zce = qi.f, Jce = Lo, ede = rn, tde = Xce, rde = Cr, cR = rde("toStringTag"), uc = function(t, e, r, n) {
  if (t) {
    var s = r ? t : t.prototype;
    ede(s, cR) || Zce(s, cR, { configurable: !0, value: e }), n && !Qce && Jce(s, "toString", tde);
  }
}, nde = Hr, ide = Gr, dR = nde.WeakMap, sde = ide(dR) && /native code/.test(String(dR)), ade = sde, IY = Hr, ode = En, lde = Lo, l1 = rn, u1 = PD, ude = rb, cde = qp, hR = "Object already initialized", Sx = IY.TypeError, dde = IY.WeakMap, by, sp, _y, hde = function(t) {
  return _y(t) ? sp(t) : by(t, {});
}, fde = function(t) {
  return function(e) {
    var r;
    if (!ode(e) || (r = sp(e)).type !== t)
      throw Sx("Incompatible receiver, " + t + " required");
    return r;
  };
};
if (ade || u1.state) {
  var oa = u1.state || (u1.state = new dde());
  oa.get = oa.get, oa.has = oa.has, oa.set = oa.set, by = function(t, e) {
    if (oa.has(t))
      throw Sx(hR);
    return e.facade = t, oa.set(t, e), e;
  }, sp = function(t) {
    return oa.get(t) || {};
  }, _y = function(t) {
    return oa.has(t);
  };
} else {
  var Lc = ude("state");
  cde[Lc] = !0, by = function(t, e) {
    if (l1(t, Lc))
      throw Sx(hR);
    return e.facade = t, lde(t, Lc, e), e;
  }, sp = function(t) {
    return l1(t, Lc) ? t[Lc] : {};
  }, _y = function(t) {
    return l1(t, Lc);
  };
}
var vh = {
  set: by,
  get: sp,
  has: _y,
  enforce: hde,
  getterFor: fde
}, pde = Ml, vde = zt, mde = z0, gde = Ci, yde = Qi, bde = eb, fR = vde([].push), Qo = function(t) {
  var e = t == 1, r = t == 2, n = t == 3, s = t == 4, a = t == 6, o = t == 7, l = t == 5 || a;
  return function(u, c, d, h) {
    for (var f = gde(u), p = mde(f), m = pde(c, d), b = yde(p), y = 0, _ = h || bde, x = e ? _(u, b) : r || o ? _(u, 0) : void 0, T, k; b > y; y++)
      if ((l || y in p) && (T = p[y], k = m(T, y, f), t))
        if (e)
          x[y] = k;
        else if (k)
          switch (t) {
            case 3:
              return !0;
            case 5:
              return T;
            case 6:
              return y;
            case 2:
              fR(x, T);
          }
        else
          switch (t) {
            case 4:
              return !1;
            case 7:
              fR(x, T);
          }
    return a ? -1 : n || s ? s : x;
  };
}, mh = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: Qo(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: Qo(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: Qo(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: Qo(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: Qo(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: Qo(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: Qo(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: Qo(7)
}, nb = qe, YD = Hr, HD = Sn, _de = zt, Ld = fn, Nd = dh, wde = Wt, bn = rn, Tde = Ar, Ex = Xi, ib = Zs, GD = X0, xde = Ua, $x = oc, ap = lc, PY = Xp, Sde = Qp, RY = UD, Ede = Zp, MY = ac, LY = qi, $de = tb, NY = Yp, pR = ph, kde = VD, WD = kl, Dde = rb, FY = qp, vR = q0, Ode = Cr, Ade = Jp, Cde = Wr, Ide = CY, Pde = uc, BY = vh, sb = mh.forEach, _i = Dde("hidden"), ab = "Symbol", op = "prototype", Rde = BY.set, mR = BY.getterFor(ab), Bs = Object[op], Tu = YD.Symbol, mf = Tu && Tu[op], Mde = YD.TypeError, c1 = YD.QObject, UY = MY.f, ou = LY.f, VY = RY.f, Lde = NY.f, YY = _de([].push), $o = WD("symbols"), ev = WD("op-symbols"), Nde = WD("wks"), kx = !c1 || !c1[op] || !c1[op].findChild, Dx = Ld && wde(function() {
  return ap(ou({}, "a", {
    get: function() {
      return ou(this, "a", { value: 7 }).a;
    }
  })).a != 7;
}) ? function(t, e, r) {
  var n = UY(Bs, e);
  n && delete Bs[e], ou(t, e, r), n && t !== Bs && ou(Bs, e, n);
} : ou, d1 = function(t, e) {
  var r = $o[t] = ap(mf);
  return Rde(r, {
    type: ab,
    tag: t,
    description: e
  }), Ld || (r.description = e), r;
}, ob = function(e, r, n) {
  e === Bs && ob(ev, r, n), Ex(e);
  var s = GD(r);
  return Ex(n), bn($o, s) ? (n.enumerable ? (bn(e, _i) && e[_i][s] && (e[_i][s] = !1), n = ap(n, { enumerable: $x(0, !1) })) : (bn(e, _i) || ou(e, _i, $x(1, {})), e[_i][s] = !0), Dx(e, s, n)) : ou(e, s, n);
}, jD = function(e, r) {
  Ex(e);
  var n = ib(r), s = PY(n).concat(jY(n));
  return sb(s, function(a) {
    (!Ld || HD(HY, n, a)) && ob(e, a, n[a]);
  }), e;
}, Fde = function(e, r) {
  return r === void 0 ? ap(e) : jD(ap(e), r);
}, HY = function(e) {
  var r = GD(e), n = HD(Lde, this, r);
  return this === Bs && bn($o, r) && !bn(ev, r) ? !1 : n || !bn(this, r) || !bn($o, r) || bn(this, _i) && this[_i][r] ? n : !0;
}, GY = function(e, r) {
  var n = ib(e), s = GD(r);
  if (!(n === Bs && bn($o, s) && !bn(ev, s))) {
    var a = UY(n, s);
    return a && bn($o, s) && !(bn(n, _i) && n[_i][s]) && (a.enumerable = !0), a;
  }
}, WY = function(e) {
  var r = VY(ib(e)), n = [];
  return sb(r, function(s) {
    !bn($o, s) && !bn(FY, s) && YY(n, s);
  }), n;
}, jY = function(t) {
  var e = t === Bs, r = VY(e ? ev : ib(t)), n = [];
  return sb(r, function(s) {
    bn($o, s) && (!e || bn(Bs, s)) && YY(n, $o[s]);
  }), n;
};
Nd || (Tu = function() {
  if (Tde(mf, this))
    throw Mde("Symbol is not a constructor");
  var e = !arguments.length || arguments[0] === void 0 ? void 0 : xde(arguments[0]), r = vR(e), n = function(s) {
    this === Bs && HD(n, ev, s), bn(this, _i) && bn(this[_i], r) && (this[_i][r] = !1), Dx(this, r, $x(1, s));
  };
  return Ld && kx && Dx(Bs, r, { configurable: !0, set: n }), d1(r, e);
}, mf = Tu[op], pR(mf, "toString", function() {
  return mR(this).tag;
}), pR(Tu, "withoutSetter", function(t) {
  return d1(vR(t), t);
}), NY.f = HY, LY.f = ob, $de.f = jD, MY.f = GY, Sde.f = RY.f = WY, Ede.f = jY, Ade.f = function(t) {
  return d1(Ode(t), t);
}, Ld && kde(mf, "description", {
  configurable: !0,
  get: function() {
    return mR(this).description;
  }
}));
nb({ global: !0, constructor: !0, wrap: !0, forced: !Nd, sham: !Nd }, {
  Symbol: Tu
});
sb(PY(Nde), function(t) {
  Cde(t);
});
nb({ target: ab, stat: !0, forced: !Nd }, {
  useSetter: function() {
    kx = !0;
  },
  useSimple: function() {
    kx = !1;
  }
});
nb({ target: "Object", stat: !0, forced: !Nd, sham: !Ld }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: Fde,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: ob,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: jD,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: GY
});
nb({ target: "Object", stat: !0, forced: !Nd }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: WY
});
Ide();
Pde(Tu, ab);
FY[_i] = !0;
var Bde = dh, KY = Bde && !!Symbol.for && !!Symbol.keyFor, Ude = qe, Vde = ui, Yde = rn, Hde = Ua, zY = kl, Gde = KY, h1 = zY("string-to-symbol-registry"), Wde = zY("symbol-to-string-registry");
Ude({ target: "Symbol", stat: !0, forced: !Gde }, {
  for: function(t) {
    var e = Hde(t);
    if (Yde(h1, e))
      return h1[e];
    var r = Vde("Symbol")(e);
    return h1[e] = r, Wde[r] = e, r;
  }
});
var jde = qe, Kde = rn, zde = Wp, qde = hh, Xde = kl, Qde = KY, gR = Xde("symbol-to-string-registry");
jde({ target: "Symbol", stat: !0, forced: !Qde }, {
  keyFor: function(e) {
    if (!zde(e))
      throw TypeError(qde(e) + " is not a symbol");
    if (Kde(gR, e))
      return gR[e];
  }
});
var Zde = zt, tv = Zde([].slice), Jde = zt, yR = Ll, ehe = Gr, bR = Mo, the = Ua, _R = Jde([].push), rhe = function(t) {
  if (ehe(t))
    return t;
  if (yR(t)) {
    for (var e = t.length, r = [], n = 0; n < e; n++) {
      var s = t[n];
      typeof s == "string" ? _R(r, s) : (typeof s == "number" || bR(s) == "Number" || bR(s) == "String") && _R(r, the(s));
    }
    var a = r.length, o = !0;
    return function(l, u) {
      if (o)
        return o = !1, u;
      if (yR(this))
        return u;
      for (var c = 0; c < a; c++)
        if (r[c] === l)
          return u;
    };
  }
}, nhe = qe, qY = ui, XY = uh, ihe = Sn, rv = zt, QY = Wt, wR = Gr, TR = Wp, ZY = tv, she = rhe, ahe = dh, ohe = String, yl = qY("JSON", "stringify"), Nm = rv(/./.exec), xR = rv("".charAt), lhe = rv("".charCodeAt), uhe = rv("".replace), che = rv(1 .toString), dhe = /[\uD800-\uDFFF]/g, SR = /^[\uD800-\uDBFF]$/, ER = /^[\uDC00-\uDFFF]$/, $R = !ahe || QY(function() {
  var t = qY("Symbol")();
  return yl([t]) != "[null]" || yl({ a: t }) != "{}" || yl(Object(t)) != "{}";
}), kR = QY(function() {
  return yl("\uDF06\uD834") !== '"\\udf06\\ud834"' || yl("\uDEAD") !== '"\\udead"';
}), hhe = function(t, e) {
  var r = ZY(arguments), n = she(e);
  if (!(!wR(n) && (t === void 0 || TR(t))))
    return r[1] = function(s, a) {
      if (wR(n) && (a = ihe(n, this, ohe(s), a)), !TR(a))
        return a;
    }, XY(yl, null, r);
}, fhe = function(t, e, r) {
  var n = xR(r, e - 1), s = xR(r, e + 1);
  return Nm(SR, t) && !Nm(ER, s) || Nm(ER, t) && !Nm(SR, n) ? "\\u" + che(lhe(t, 0), 16) : t;
};
yl && nhe({ target: "JSON", stat: !0, arity: 3, forced: $R || kR }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(e, r, n) {
    var s = ZY(arguments), a = XY($R ? hhe : yl, null, s);
    return kR && typeof a == "string" ? uhe(a, dhe, fhe) : a;
  }
});
var phe = qe, vhe = dh, mhe = Wt, JY = Zp, ghe = Ci, yhe = !vhe || mhe(function() {
  JY.f(1);
});
phe({ target: "Object", stat: !0, forced: yhe }, {
  getOwnPropertySymbols: function(e) {
    var r = JY.f;
    return r ? r(ghe(e)) : [];
  }
});
var bhe = Wr;
bhe("asyncIterator");
var _he = Wr;
_he("hasInstance");
var whe = Wr;
whe("isConcatSpreadable");
var The = Wr;
The("iterator");
var xhe = Wr;
xhe("match");
var She = Wr;
She("matchAll");
var Ehe = Wr;
Ehe("replace");
var $he = Wr;
$he("search");
var khe = Wr;
khe("species");
var Dhe = Wr;
Dhe("split");
var Ohe = Wr, Ahe = CY;
Ohe("toPrimitive");
Ahe();
var Che = ui, Ihe = Wr, Phe = uc;
Ihe("toStringTag");
Phe(Che("Symbol"), "Symbol");
var Rhe = Wr;
Rhe("unscopables");
var Mhe = Hr, Lhe = uc;
Lhe(Mhe.JSON, "JSON", !0);
var Nhe = vr, Fhe = Nhe.Symbol, gh = {}, Ox = fn, Bhe = rn, e4 = Function.prototype, Uhe = Ox && Object.getOwnPropertyDescriptor, KD = Bhe(e4, "name"), Vhe = KD && (function() {
}).name === "something", Yhe = KD && (!Ox || Ox && Uhe(e4, "name").configurable), t4 = {
  EXISTS: KD,
  PROPER: Vhe,
  CONFIGURABLE: Yhe
}, Hhe = Wt, r4 = !Hhe(function() {
  function t() {
  }
  return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
}), Ghe = rn, Whe = Gr, jhe = Ci, Khe = rb, zhe = r4, DR = Khe("IE_PROTO"), Ax = Object, qhe = Ax.prototype, lb = zhe ? Ax.getPrototypeOf : function(t) {
  var e = jhe(t);
  if (Ghe(e, DR))
    return e[DR];
  var r = e.constructor;
  return Whe(r) && e instanceof r ? r.prototype : e instanceof Ax ? qhe : null;
}, Xhe = Wt, Qhe = Gr, Zhe = En, Jhe = lc, OR = lb, efe = ph, tfe = Cr, Cx = tfe("iterator"), n4 = !1, fo, f1, p1;
[].keys && (p1 = [].keys(), "next" in p1 ? (f1 = OR(OR(p1)), f1 !== Object.prototype && (fo = f1)) : n4 = !0);
var rfe = !Zhe(fo) || Xhe(function() {
  var t = {};
  return fo[Cx].call(t) !== t;
});
rfe ? fo = {} : fo = Jhe(fo);
Qhe(fo[Cx]) || efe(fo, Cx, function() {
  return this;
});
var i4 = {
  IteratorPrototype: fo,
  BUGGY_SAFARI_ITERATORS: n4
}, nfe = i4.IteratorPrototype, ife = lc, sfe = oc, afe = uc, ofe = gh, lfe = function() {
  return this;
}, ufe = function(t, e, r, n) {
  var s = e + " Iterator";
  return t.prototype = ife(nfe, { next: sfe(+!n, r) }), afe(t, s, !1, !0), ofe[s] = lfe, t;
}, cfe = zt, dfe = Ai, hfe = function(t, e, r) {
  try {
    return cfe(dfe(Object.getOwnPropertyDescriptor(t, e)[r]));
  } catch {
  }
}, ffe = Gr, pfe = String, vfe = TypeError, mfe = function(t) {
  if (typeof t == "object" || ffe(t))
    return t;
  throw vfe("Can't set " + pfe(t) + " as a prototype");
}, gfe = hfe, yfe = Xi, bfe = mfe, s4 = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var t = !1, e = {}, r;
  try {
    r = gfe(Object.prototype, "__proto__", "set"), r(e, []), t = e instanceof Array;
  } catch {
  }
  return function(s, a) {
    return yfe(s), bfe(a), t ? r(s, a) : s.__proto__ = a, s;
  };
}() : void 0), _fe = qe, wfe = Sn, Tfe = t4, xfe = ufe, Sfe = lb, Efe = uc, AR = ph, $fe = Cr, CR = gh, kfe = i4, Dfe = Tfe.PROPER, Fm = kfe.BUGGY_SAFARI_ITERATORS, v1 = $fe("iterator"), IR = "keys", Bm = "values", PR = "entries", Ofe = function() {
  return this;
}, zD = function(t, e, r, n, s, a, o) {
  xfe(r, e, n);
  var l = function(_) {
    if (_ === s && f)
      return f;
    if (!Fm && _ in d)
      return d[_];
    switch (_) {
      case IR:
        return function() {
          return new r(this, _);
        };
      case Bm:
        return function() {
          return new r(this, _);
        };
      case PR:
        return function() {
          return new r(this, _);
        };
    }
    return function() {
      return new r(this);
    };
  }, u = e + " Iterator", c = !1, d = t.prototype, h = d[v1] || d["@@iterator"] || s && d[s], f = !Fm && h || l(s), p = e == "Array" && d.entries || h, m, b, y;
  if (p && (m = Sfe(p.call(new t())), m !== Object.prototype && m.next && (Efe(m, u, !0, !0), CR[u] = Ofe)), Dfe && s == Bm && h && h.name !== Bm && (c = !0, f = function() {
    return wfe(h, this);
  }), s)
    if (b = {
      values: l(Bm),
      keys: a ? f : l(IR),
      entries: l(PR)
    }, o)
      for (y in b)
        (Fm || c || !(y in d)) && AR(d, y, b[y]);
    else
      _fe({ target: e, proto: !0, forced: Fm || c }, b);
  return o && d[v1] !== f && AR(d, v1, f, { name: s }), CR[e] = f, b;
}, qD = function(t, e) {
  return { value: t, done: e };
}, Afe = Zs, RR = gh, a4 = vh;
qi.f;
var Cfe = zD, Um = qD, o4 = "Array Iterator", Ife = a4.set, Pfe = a4.getterFor(o4);
Cfe(Array, "Array", function(t, e) {
  Ife(this, {
    type: o4,
    target: Afe(t),
    // target
    index: 0,
    // next index
    kind: e
    // kind
  });
}, function() {
  var t = Pfe(this), e = t.target, r = t.kind, n = t.index++;
  return !e || n >= e.length ? (t.target = void 0, Um(void 0, !0)) : r == "keys" ? Um(n, !1) : r == "values" ? Um(e[n], !1) : Um([n, e[n]], !1);
}, "values");
RR.Arguments = RR.Array;
var Rfe = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, Mfe = Rfe, Lfe = Hr, Nfe = No, Ffe = Lo, MR = gh, Bfe = Cr, LR = Bfe("toStringTag");
for (var m1 in Mfe) {
  var NR = Lfe[m1], g1 = NR && NR.prototype;
  g1 && Nfe(g1) !== LR && Ffe(g1, LR, m1), MR[m1] = MR.Array;
}
var Ufe = Fhe, l4 = Ufe, Vfe = Wr;
Vfe("dispose");
var Yfe = l4, Hfe = Yfe, Gfe = Wr;
Gfe("asyncDispose");
var Wfe = qe, jfe = ui, Kfe = zt, u4 = jfe("Symbol"), zfe = u4.keyFor, qfe = Kfe(u4.prototype.valueOf);
Wfe({ target: "Symbol", stat: !0 }, {
  isRegistered: function(e) {
    try {
      return zfe(qfe(e)) !== void 0;
    } catch {
      return !1;
    }
  }
});
var Xfe = qe, Qfe = kl, c4 = ui, Zfe = zt, Jfe = Wp, epe = Cr, wy = c4("Symbol"), FR = wy.isWellKnown, d4 = c4("Object", "getOwnPropertyNames"), tpe = Zfe(wy.prototype.valueOf), BR = Qfe("wks");
for (var y1 = 0, UR = d4(wy), rpe = UR.length; y1 < rpe; y1++)
  try {
    var VR = UR[y1];
    Jfe(wy[VR]) && epe(VR);
  } catch {
  }
Xfe({ target: "Symbol", stat: !0, forced: !0 }, {
  isWellKnown: function(e) {
    if (FR && FR(e))
      return !0;
    try {
      for (var r = tpe(e), n = 0, s = d4(BR), a = s.length; n < a; n++)
        if (BR[s[n]] == r)
          return !0;
    } catch {
    }
    return !1;
  }
});
var npe = Wr;
npe("matcher");
var ipe = Wr;
ipe("metadataKey");
var spe = Wr;
spe("observable");
var ape = Wr;
ape("metadata");
var ope = Wr;
ope("patternMatch");
var lpe = Wr;
lpe("replaceAll");
var upe = Hfe, cpe = upe;
(function(t) {
  t.exports = cpe;
})(Kle);
(function(t) {
  t.exports = _x;
})(jle);
var id = /* @__PURE__ */ ft(ip), Ty = {}, dpe = {
  get exports() {
    return Ty;
  },
  set exports(t) {
    Ty = t;
  }
}, Ix = {}, hpe = {
  get exports() {
    return Ix;
  },
  set exports(t) {
    Ix = t;
  }
}, XD = zt, fpe = Z0, ppe = Ua, vpe = Gp, mpe = XD("".charAt), YR = XD("".charCodeAt), gpe = XD("".slice), HR = function(t) {
  return function(e, r) {
    var n = ppe(vpe(e)), s = fpe(r), a = n.length, o, l;
    return s < 0 || s >= a ? t ? "" : void 0 : (o = YR(n, s), o < 55296 || o > 56319 || s + 1 === a || (l = YR(n, s + 1)) < 56320 || l > 57343 ? t ? mpe(n, s) : o : t ? gpe(n, s, s + 2) : (o - 55296 << 10) + (l - 56320) + 65536);
  };
}, ype = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: HR(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: HR(!0)
}, bpe = ype.charAt, _pe = Ua, h4 = vh, wpe = zD, GR = qD, f4 = "String Iterator", Tpe = h4.set, xpe = h4.getterFor(f4);
wpe(String, "String", function(t) {
  Tpe(this, {
    type: f4,
    string: _pe(t),
    index: 0
  });
}, function() {
  var e = xpe(this), r = e.string, n = e.index, s;
  return n >= r.length ? GR(void 0, !0) : (s = bpe(r, n), e.index += s.length, GR(s, !1));
});
var Spe = Jp, Epe = Spe.f("iterator"), $pe = Epe, p4 = $pe, kpe = p4, Dpe = kpe, Ope = Dpe, Ape = Ope;
(function(t) {
  t.exports = Ape;
})(hpe);
(function(t) {
  t.exports = Ix;
})(dpe);
var Cpe = /* @__PURE__ */ ft(Ty);
function Rn(t) {
  "@babel/helpers - typeof";
  return Rn = typeof id == "function" && typeof Cpe == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof id == "function" && e.constructor === id && e !== id.prototype ? "symbol" : typeof e;
  }, Rn(t);
}
var Px = {}, Ipe = {
  get exports() {
    return Px;
  },
  set exports(t) {
    Px = t;
  }
}, Rx = {}, Ppe = {
  get exports() {
    return Rx;
  },
  set exports(t) {
    Rx = t;
  }
}, Rpe = Jp, Mpe = Rpe.f("toPrimitive"), Lpe = Mpe, Npe = Lpe, Fpe = Npe, Bpe = Fpe, Upe = Bpe, Vpe = Upe;
(function(t) {
  t.exports = Vpe;
})(Ppe);
(function(t) {
  t.exports = Rx;
})(Ipe);
var Ype = /* @__PURE__ */ ft(Px);
function Hpe(t, e) {
  if (Rn(t) !== "object" || t === null)
    return t;
  var r = t[Ype];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (Rn(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function v4(t) {
  var e = Hpe(t, "string");
  return Rn(e) === "symbol" ? e : String(e);
}
function WR(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Q0(t, v4(n.key), n);
  }
}
function cc(t, e, r) {
  return e && WR(t.prototype, e), r && WR(t, r), Q0(t, "prototype", {
    writable: !1
  }), t;
}
function Lt(t, e, r) {
  return e = v4(e), e in t ? Q0(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
var Mx = {}, Gpe = {
  get exports() {
    return Mx;
  },
  set exports(t) {
    Mx = t;
  }
}, m4 = zt, Wpe = Ai, jpe = En, Kpe = rn, jR = tv, zpe = Vp, g4 = Function, qpe = m4([].concat), Xpe = m4([].join), b1 = {}, Qpe = function(t, e, r) {
  if (!Kpe(b1, e)) {
    for (var n = [], s = 0; s < e; s++)
      n[s] = "a[" + s + "]";
    b1[e] = g4("C,a", "return new C(" + Xpe(n, ",") + ")");
  }
  return b1[e](t, r);
}, y4 = zpe ? g4.bind : function(e) {
  var r = Wpe(this), n = r.prototype, s = jR(arguments, 1), a = function() {
    var l = qpe(s, jR(arguments));
    return this instanceof a ? Qpe(r, l.length, l) : r.apply(e, l);
  };
  return jpe(n) && (a.prototype = n), a;
}, Zpe = qe, KR = y4;
Zpe({ target: "Function", proto: !0, forced: Function.bind !== KR }, {
  bind: KR
});
var Jpe = vr, nn = function(t) {
  return Jpe[t + "Prototype"];
}, eve = nn, tve = eve("Function").bind, rve = Ar, nve = tve, _1 = Function.prototype, ive = function(t) {
  var e = t.bind;
  return t === _1 || rve(_1, t) && e === _1.bind ? nve : e;
}, sve = ive, b4 = sve;
(function(t) {
  t.exports = b4;
})(Gpe);
var xu = /* @__PURE__ */ ft(Mx), Lx = {}, ave = {
  get exports() {
    return Lx;
  },
  set exports(t) {
    Lx = t;
  }
}, ove = Ai, lve = Ci, uve = z0, cve = Qi, dve = TypeError, zR = function(t) {
  return function(e, r, n, s) {
    ove(r);
    var a = lve(e), o = uve(a), l = cve(a), u = t ? l - 1 : 0, c = t ? -1 : 1;
    if (n < 2)
      for (; ; ) {
        if (u in o) {
          s = o[u], u += c;
          break;
        }
        if (u += c, t ? u < 0 : l <= u)
          throw dve("Reduce of empty array with no initial value");
      }
    for (; t ? u >= 0 : l > u; u += c)
      u in o && (s = r(s, o[u], u, a));
    return s;
  };
}, hve = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: zR(!1),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: zR(!0)
}, fve = Wt, nv = function(t, e) {
  var r = [][t];
  return !!r && fve(function() {
    r.call(null, e || function() {
      return 1;
    }, 1);
  });
}, pve = Mo, iv = typeof process < "u" && pve(process) == "process", vve = qe, mve = hve.left, gve = nv, qR = ch, yve = iv, bve = !yve && qR > 79 && qR < 83, _ve = bve || !gve("reduce");
vve({ target: "Array", proto: !0, forced: _ve }, {
  reduce: function(e) {
    var r = arguments.length;
    return mve(this, e, r, r > 1 ? arguments[1] : void 0);
  }
});
var wve = nn, Tve = wve("Array").reduce, xve = Ar, Sve = Tve, w1 = Array.prototype, Eve = function(t) {
  var e = t.reduce;
  return t === w1 || xve(w1, t) && e === w1.reduce ? Sve : e;
}, $ve = Eve, kve = $ve;
(function(t) {
  t.exports = kve;
})(ave);
var _4 = /* @__PURE__ */ ft(Lx), Nx = {}, Dve = {
  get exports() {
    return Nx;
  },
  set exports(t) {
    Nx = t;
  }
}, Ove = qe, Ave = mh.filter, Cve = Kp, Ive = Cve("filter");
Ove({ target: "Array", proto: !0, forced: !Ive }, {
  filter: function(e) {
    return Ave(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var Pve = nn, Rve = Pve("Array").filter, Mve = Ar, Lve = Rve, T1 = Array.prototype, Nve = function(t) {
  var e = t.filter;
  return t === T1 || Mve(T1, t) && e === T1.filter ? Lve : e;
}, Fve = Nve, Bve = Fve;
(function(t) {
  t.exports = Bve;
})(Dve);
var gn = /* @__PURE__ */ ft(Nx), Fx = {}, Uve = {
  get exports() {
    return Fx;
  },
  set exports(t) {
    Fx = t;
  }
}, Vve = qe, Yve = mh.map, Hve = Kp, Gve = Hve("map");
Vve({ target: "Array", proto: !0, forced: !Gve }, {
  map: function(e) {
    return Yve(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var Wve = nn, jve = Wve("Array").map, Kve = Ar, zve = jve, x1 = Array.prototype, qve = function(t) {
  var e = t.map;
  return t === x1 || Kve(x1, t) && e === x1.map ? zve : e;
}, Xve = qve, Qve = Xve;
(function(t) {
  t.exports = Qve;
})(Uve);
var Ni = /* @__PURE__ */ ft(Fx), Bx = {}, Zve = {
  get exports() {
    return Bx;
  },
  set exports(t) {
    Bx = t;
  }
}, Jve = Ll, eme = Qi, tme = MD, rme = Ml, w4 = function(t, e, r, n, s, a, o, l) {
  for (var u = s, c = 0, d = o ? rme(o, l) : !1, h, f; c < n; )
    c in r && (h = d ? d(r[c], c, e) : r[c], a > 0 && Jve(h) ? (f = eme(h), u = w4(t, e, h, f, u, a - 1) - 1) : (tme(u + 1), t[u] = h), u++), c++;
  return u;
}, nme = w4, ime = qe, sme = nme, ame = Ai, ome = Ci, lme = Qi, ume = eb;
ime({ target: "Array", proto: !0 }, {
  flatMap: function(e) {
    var r = ome(this), n = lme(r), s;
    return ame(e), s = ume(r, 0), s.length = sme(s, r, r, n, 0, 1, e, arguments.length > 1 ? arguments[1] : void 0), s;
  }
});
var cme = nn, dme = cme("Array").flatMap, hme = Ar, fme = dme, S1 = Array.prototype, pme = function(t) {
  var e = t.flatMap;
  return t === S1 || hme(S1, t) && e === S1.flatMap ? fme : e;
}, vme = pme, mme = vme;
(function(t) {
  t.exports = mme;
})(Zve);
var gme = /* @__PURE__ */ ft(Bx);
function yme(t) {
  return new _me(t);
}
var bme = /* @__PURE__ */ function() {
  function t(e, r, n) {
    var s, a, o;
    sc(this, t), Lt(this, "_source", void 0), Lt(this, "_transformers", void 0), Lt(this, "_target", void 0), Lt(this, "_listeners", {
      add: xu(s = this._add).call(s, this),
      remove: xu(a = this._remove).call(a, this),
      update: xu(o = this._update).call(o, this)
    }), this._source = e, this._transformers = r, this._target = n;
  }
  return cc(t, [{
    key: "all",
    value: function() {
      return this._target.update(this._transformItems(this._source.get())), this;
    }
    /** @inheritDoc */
  }, {
    key: "start",
    value: function() {
      return this._source.on("add", this._listeners.add), this._source.on("remove", this._listeners.remove), this._source.on("update", this._listeners.update), this;
    }
    /** @inheritDoc */
  }, {
    key: "stop",
    value: function() {
      return this._source.off("add", this._listeners.add), this._source.off("remove", this._listeners.remove), this._source.off("update", this._listeners.update), this;
    }
    /**
     * Apply the transformers to the items.
     *
     * @param items - The items to be transformed.
     * @returns The transformed items.
     */
  }, {
    key: "_transformItems",
    value: function(r) {
      var n;
      return _4(n = this._transformers).call(n, function(s, a) {
        return a(s);
      }, r);
    }
    /**
     * Handle an add event.
     *
     * @param _name - Ignored.
     * @param payload - The payload containing the ids of the added items.
     */
  }, {
    key: "_add",
    value: function(r, n) {
      n != null && this._target.add(this._transformItems(this._source.get(n.items)));
    }
    /**
     * Handle an update event.
     *
     * @param _name - Ignored.
     * @param payload - The payload containing the ids of the updated items.
     */
  }, {
    key: "_update",
    value: function(r, n) {
      n != null && this._target.update(this._transformItems(this._source.get(n.items)));
    }
    /**
     * Handle a remove event.
     *
     * @param _name - Ignored.
     * @param payload - The payload containing the data of the removed items.
     */
  }, {
    key: "_remove",
    value: function(r, n) {
      n != null && this._target.remove(this._transformItems(n.oldData));
    }
  }]), t;
}(), _me = /* @__PURE__ */ function() {
  function t(e) {
    sc(this, t), Lt(this, "_source", void 0), Lt(this, "_transformers", []), this._source = e;
  }
  return cc(t, [{
    key: "filter",
    value: function(r) {
      return this._transformers.push(function(n) {
        return gn(n).call(n, r);
      }), this;
    }
    /**
     * Map each source item to a new type.
     *
     * @param callback - A mapping function that takes a source item and returns
     * corresponding mapped item.
     * @typeParam TI - Target item type.
     * @typeParam TP - Target item type's id property name.
     * @returns This factory for further configuration.
     */
  }, {
    key: "map",
    value: function(r) {
      return this._transformers.push(function(n) {
        return Ni(n).call(n, r);
      }), this;
    }
    /**
     * Map each source item to zero or more items of a new type.
     *
     * @param callback - A mapping function that takes a source item and returns
     * an array of corresponding mapped items.
     * @typeParam TI - Target item type.
     * @typeParam TP - Target item type's id property name.
     * @returns This factory for further configuration.
     */
  }, {
    key: "flatMap",
    value: function(r) {
      return this._transformers.push(function(n) {
        return gme(n).call(n, r);
      }), this;
    }
    /**
     * Connect this pipe to given data set.
     *
     * @param target - The data set that will receive the items from this pipe.
     * @returns The pipe connected between given data sets and performing
     * configured transformation on the processed items.
     */
  }, {
    key: "to",
    value: function(r) {
      return new bme(this._source, this._transformers, r);
    }
  }]), t;
}(), Ux = {}, wme = {
  get exports() {
    return Ux;
  },
  set exports(t) {
    Ux = t;
  }
}, Tme = Sn, XR = Xi, xme = ID, T4 = function(t, e, r) {
  var n, s;
  XR(t);
  try {
    if (n = xme(t, "return"), !n) {
      if (e === "throw")
        throw r;
      return r;
    }
    n = Tme(n, t);
  } catch (a) {
    s = !0, n = a;
  }
  if (e === "throw")
    throw r;
  if (s)
    throw n;
  return XR(n), r;
}, Sme = Xi, Eme = T4, $me = function(t, e, r, n) {
  try {
    return n ? e(Sme(r)[0], r[1]) : e(r);
  } catch (s) {
    Eme(t, "throw", s);
  }
}, kme = Cr, Dme = gh, Ome = kme("iterator"), Ame = Array.prototype, x4 = function(t) {
  return t !== void 0 && (Dme.Array === t || Ame[Ome] === t);
}, Cme = No, QR = ID, Ime = Hp, Pme = gh, Rme = Cr, Mme = Rme("iterator"), ub = function(t) {
  if (!Ime(t))
    return QR(t, Mme) || QR(t, "@@iterator") || Pme[Cme(t)];
}, Lme = Sn, Nme = Ai, Fme = Xi, Bme = hh, Ume = ub, Vme = TypeError, QD = function(t, e) {
  var r = arguments.length < 2 ? Ume(t) : e;
  if (Nme(r))
    return Fme(Lme(r, t));
  throw Vme(Bme(t) + " is not iterable");
}, Yme = Ml, Hme = Sn, Gme = Ci, Wme = $me, jme = x4, Kme = J0, zme = Qi, ZR = fh, qme = QD, Xme = ub, JR = Array, Qme = function(e) {
  var r = Gme(e), n = Kme(this), s = arguments.length, a = s > 1 ? arguments[1] : void 0, o = a !== void 0;
  o && (a = Yme(a, s > 2 ? arguments[2] : void 0));
  var l = Xme(r), u = 0, c, d, h, f, p, m;
  if (l && !(this === JR && jme(l)))
    for (f = qme(r, l), p = f.next, d = n ? new this() : []; !(h = Hme(p, f)).done; u++)
      m = o ? Wme(f, a, [h.value, u], !0) : h.value, ZR(d, u, m);
  else
    for (c = zme(r), d = n ? new this(c) : JR(c); c > u; u++)
      m = o ? a(r[u], u) : r[u], ZR(d, u, m);
  return d.length = u, d;
}, Zme = Cr, S4 = Zme("iterator"), E4 = !1;
try {
  var Jme = 0, eM = {
    next: function() {
      return { done: !!Jme++ };
    },
    return: function() {
      E4 = !0;
    }
  };
  eM[S4] = function() {
    return this;
  }, Array.from(eM, function() {
    throw 2;
  });
} catch {
}
var $4 = function(t, e) {
  if (!e && !E4)
    return !1;
  var r = !1;
  try {
    var n = {};
    n[S4] = function() {
      return {
        next: function() {
          return { done: r = !0 };
        }
      };
    }, t(n);
  } catch {
  }
  return r;
}, ege = qe, tge = Qme, rge = $4, nge = !rge(function(t) {
  Array.from(t);
});
ege({ target: "Array", stat: !0, forced: nge }, {
  from: tge
});
var ige = vr, sge = ige.Array.from, age = sge, k4 = age;
(function(t) {
  t.exports = k4;
})(wme);
var cb = /* @__PURE__ */ ft(Ux), Vx = {}, oge = {
  get exports() {
    return Vx;
  },
  set exports(t) {
    Vx = t;
  }
}, Yx = {}, lge = {
  get exports() {
    return Yx;
  },
  set exports(t) {
    Yx = t;
  }
}, uge = ub, cge = uge, dge = cge, hge = dge, fge = hge, pge = fge, vge = pge, mge = vge;
(function(t) {
  t.exports = mge;
})(lge);
(function(t) {
  t.exports = Yx;
})(oge);
var yh = /* @__PURE__ */ ft(Vx), Hx = {}, gge = {
  get exports() {
    return Hx;
  },
  set exports(t) {
    Hx = t;
  }
}, yge = vr, bge = yge.Object.getOwnPropertySymbols, _ge = bge, wge = _ge;
(function(t) {
  t.exports = wge;
})(gge);
var tM = /* @__PURE__ */ ft(Hx), Gx = {}, Tge = {
  get exports() {
    return Gx;
  },
  set exports(t) {
    Gx = t;
  }
}, Wx = {}, xge = {
  get exports() {
    return Wx;
  },
  set exports(t) {
    Wx = t;
  }
}, Sge = qe, Ege = Wt, $ge = Zs, D4 = ac.f, O4 = fn, kge = !O4 || Ege(function() {
  D4(1);
});
Sge({ target: "Object", stat: !0, forced: kge, sham: !O4 }, {
  getOwnPropertyDescriptor: function(e, r) {
    return D4($ge(e), r);
  }
});
var Dge = vr, A4 = Dge.Object, Oge = xge.exports = function(e, r) {
  return A4.getOwnPropertyDescriptor(e, r);
};
A4.getOwnPropertyDescriptor.sham && (Oge.sham = !0);
var Age = Wx, Cge = Age;
(function(t) {
  t.exports = Cge;
})(Tge);
var C4 = /* @__PURE__ */ ft(Gx), jx = {}, Ige = {
  get exports() {
    return jx;
  },
  set exports(t) {
    jx = t;
  }
}, Pge = ui, Rge = zt, Mge = Qp, Lge = Zp, Nge = Xi, Fge = Rge([].concat), ZD = Pge("Reflect", "ownKeys") || function(e) {
  var r = Mge.f(Nge(e)), n = Lge.f;
  return n ? Fge(r, n(e)) : r;
}, Bge = qe, Uge = fn, Vge = ZD, Yge = Zs, Hge = ac, Gge = fh;
Bge({ target: "Object", stat: !0, sham: !Uge }, {
  getOwnPropertyDescriptors: function(e) {
    for (var r = Yge(e), n = Hge.f, s = Vge(r), a = {}, o = 0, l, u; s.length > o; )
      u = n(r, l = s[o++]), u !== void 0 && Gge(a, l, u);
    return a;
  }
});
var Wge = vr, jge = Wge.Object.getOwnPropertyDescriptors, Kge = jge, zge = Kge;
(function(t) {
  t.exports = zge;
})(Ige);
var rM = /* @__PURE__ */ ft(jx), Kx = {}, qge = {
  get exports() {
    return Kx;
  },
  set exports(t) {
    Kx = t;
  }
}, zx = {}, Xge = {
  get exports() {
    return zx;
  },
  set exports(t) {
    zx = t;
  }
}, Qge = qe, Zge = fn, nM = tb.f;
Qge({ target: "Object", stat: !0, forced: Object.defineProperties !== nM, sham: !Zge }, {
  defineProperties: nM
});
var Jge = vr, I4 = Jge.Object, eye = Xge.exports = function(e, r) {
  return I4.defineProperties(e, r);
};
I4.defineProperties.sham && (eye.sham = !0);
var tye = zx, rye = tye;
(function(t) {
  t.exports = rye;
})(qge);
var nye = /* @__PURE__ */ ft(Kx), qx = {}, iye = {
  get exports() {
    return qx;
  },
  set exports(t) {
    qx = t;
  }
};
(function(t) {
  t.exports = mY;
})(iye);
var P4 = /* @__PURE__ */ ft(qx), Xx = {}, sye = {
  get exports() {
    return Xx;
  },
  set exports(t) {
    Xx = t;
  }
}, Qx = {}, aye = {
  get exports() {
    return Qx;
  },
  set exports(t) {
    Qx = t;
  }
}, oye = qe, lye = Ll;
oye({ target: "Array", stat: !0 }, {
  isArray: lye
});
var uye = vr, cye = uye.Array.isArray, dye = cye, R4 = dye, hye = R4, fye = hye, pye = fye, vye = pye;
(function(t) {
  t.exports = vye;
})(aye);
(function(t) {
  t.exports = Qx;
})(sye);
var M4 = /* @__PURE__ */ ft(Xx);
function mye(t) {
  if (M4(t))
    return t;
}
function gye(t, e) {
  var r = t == null ? null : typeof id < "u" && yh(t) || t["@@iterator"];
  if (r != null) {
    var n, s, a, o, l = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e === 0) {
        if (Object(r) !== r)
          return;
        u = !1;
      } else
        for (; !(u = (n = a.call(r)).done) && (l.push(n.value), l.length !== e); u = !0)
          ;
    } catch (d) {
      c = !0, s = d;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw s;
      }
    }
    return l;
  }
}
var xy = {}, yye = {
  get exports() {
    return xy;
  },
  set exports(t) {
    xy = t;
  }
}, Zx = {}, bye = {
  get exports() {
    return Zx;
  },
  set exports(t) {
    Zx = t;
  }
}, _ye = qe, iM = Ll, wye = J0, Tye = En, sM = zp, xye = Qi, Sye = Zs, Eye = fh, $ye = Cr, kye = Kp, Dye = tv, Oye = kye("slice"), Aye = $ye("species"), E1 = Array, Cye = Math.max;
_ye({ target: "Array", proto: !0, forced: !Oye }, {
  slice: function(e, r) {
    var n = Sye(this), s = xye(n), a = sM(e, s), o = sM(r === void 0 ? s : r, s), l, u, c;
    if (iM(n) && (l = n.constructor, wye(l) && (l === E1 || iM(l.prototype)) ? l = void 0 : Tye(l) && (l = l[Aye], l === null && (l = void 0)), l === E1 || l === void 0))
      return Dye(n, a, o);
    for (u = new (l === void 0 ? E1 : l)(Cye(o - a, 0)), c = 0; a < o; a++, c++)
      a in n && Eye(u, c, n[a]);
    return u.length = c, u;
  }
});
var Iye = nn, Pye = Iye("Array").slice, Rye = Ar, Mye = Pye, $1 = Array.prototype, Lye = function(t) {
  var e = t.slice;
  return t === $1 || Rye($1, t) && e === $1.slice ? Mye : e;
}, Nye = Lye, L4 = Nye, Fye = L4, Bye = Fye, Uye = Bye, Vye = Uye;
(function(t) {
  t.exports = Vye;
})(bye);
(function(t) {
  t.exports = Zx;
})(yye);
var Yye = /* @__PURE__ */ ft(xy), Jx = {}, Hye = {
  get exports() {
    return Jx;
  },
  set exports(t) {
    Jx = t;
  }
}, eS = {}, Gye = {
  get exports() {
    return eS;
  },
  set exports(t) {
    eS = t;
  }
}, Wye = k4, jye = Wye, Kye = jye, zye = Kye;
(function(t) {
  t.exports = zye;
})(Gye);
(function(t) {
  t.exports = eS;
})(Hye);
var N4 = /* @__PURE__ */ ft(Jx);
function tS(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function F4(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return tS(t, e);
    var n = Yye(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return N4(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return tS(t, e);
  }
}
function qye() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pi(t, e) {
  return mye(t) || gye(t, e) || F4(t, e) || qye();
}
function Xye(t) {
  if (M4(t))
    return tS(t);
}
function Qye(t) {
  if (typeof id < "u" && yh(t) != null || t["@@iterator"] != null)
    return N4(t);
}
function Zye() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Jn(t) {
  return Xye(t) || Qye(t) || F4(t) || Zye();
}
var rS = {}, Jye = {
  get exports() {
    return rS;
  },
  set exports(t) {
    rS = t;
  }
};
(function(t) {
  t.exports = l4;
})(Jye);
var sv = /* @__PURE__ */ ft(rS), nS = {}, e0e = {
  get exports() {
    return nS;
  },
  set exports(t) {
    nS = t;
  }
}, t0e = nn, r0e = t0e("Array").concat, n0e = Ar, i0e = r0e, k1 = Array.prototype, s0e = function(t) {
  var e = t.concat;
  return t === k1 || n0e(k1, t) && e === k1.concat ? i0e : e;
}, a0e = s0e, o0e = a0e;
(function(t) {
  t.exports = o0e;
})(e0e);
var db = /* @__PURE__ */ ft(nS), iS = {}, l0e = {
  get exports() {
    return iS;
  },
  set exports(t) {
    iS = t;
  }
};
(function(t) {
  t.exports = L4;
})(l0e);
var av = /* @__PURE__ */ ft(iS), sS = {}, u0e = {
  get exports() {
    return sS;
  },
  set exports(t) {
    sS = t;
  }
}, c0e = qe, d0e = ZD;
c0e({ target: "Reflect", stat: !0 }, {
  ownKeys: d0e
});
var h0e = vr, f0e = h0e.Reflect.ownKeys, p0e = f0e, v0e = p0e;
(function(t) {
  t.exports = v0e;
})(u0e);
var B4 = /* @__PURE__ */ ft(sS), aS = {}, m0e = {
  get exports() {
    return aS;
  },
  set exports(t) {
    aS = t;
  }
};
(function(t) {
  t.exports = R4;
})(m0e);
var Qn = /* @__PURE__ */ ft(aS), oS = {}, g0e = {
  get exports() {
    return oS;
  },
  set exports(t) {
    oS = t;
  }
}, y0e = qe, b0e = Ci, U4 = Xp, _0e = Wt, w0e = _0e(function() {
  U4(1);
});
y0e({ target: "Object", stat: !0, forced: w0e }, {
  keys: function(e) {
    return U4(b0e(e));
  }
});
var T0e = vr, x0e = T0e.Object.keys, S0e = x0e, E0e = S0e;
(function(t) {
  t.exports = E0e;
})(g0e);
var JD = /* @__PURE__ */ ft(oS), aM = {}, $0e = {
  get exports() {
    return aM;
  },
  set exports(t) {
    aM = t;
  }
}, k0e = qe, D0e = zt, V4 = Date, O0e = D0e(V4.prototype.getTime);
k0e({ target: "Date", stat: !0 }, {
  now: function() {
    return O0e(new V4());
  }
});
var A0e = vr, C0e = A0e.Date.now, I0e = C0e, P0e = I0e;
(function(t) {
  t.exports = P0e;
})($0e);
var lS = {}, R0e = {
  get exports() {
    return lS;
  },
  set exports(t) {
    lS = t;
  }
}, M0e = mh.forEach, L0e = nv, N0e = L0e("forEach"), F0e = N0e ? [].forEach : function(e) {
  return M0e(this, e, arguments.length > 1 ? arguments[1] : void 0);
}, B0e = qe, oM = F0e;
B0e({ target: "Array", proto: !0, forced: [].forEach != oM }, {
  forEach: oM
});
var U0e = nn, V0e = U0e("Array").forEach, Y0e = V0e, H0e = Y0e, G0e = No, W0e = rn, j0e = Ar, K0e = H0e, D1 = Array.prototype, z0e = {
  DOMTokenList: !0,
  NodeList: !0
}, Y4 = function(t) {
  var e = t.forEach;
  return t === D1 || j0e(D1, t) && e === D1.forEach || W0e(z0e, G0e(t)) ? K0e : e;
};
(function(t) {
  t.exports = Y4;
})(R0e);
var Dl = /* @__PURE__ */ ft(lS), uS = {}, q0e = {
  get exports() {
    return uS;
  },
  set exports(t) {
    uS = t;
  }
}, X0e = qe, Q0e = zt, Z0e = Ll, J0e = Q0e([].reverse), lM = [1, 2];
X0e({ target: "Array", proto: !0, forced: String(lM) === String(lM.reverse()) }, {
  reverse: function() {
    return Z0e(this) && (this.length = this.length), J0e(this);
  }
});
var ebe = nn, tbe = ebe("Array").reverse, rbe = Ar, nbe = tbe, O1 = Array.prototype, ibe = function(t) {
  var e = t.reverse;
  return t === O1 || rbe(O1, t) && e === O1.reverse ? nbe : e;
}, sbe = ibe, H4 = sbe;
(function(t) {
  t.exports = H4;
})(q0e);
var abe = /* @__PURE__ */ ft(uS), cS = {}, obe = {
  get exports() {
    return cS;
  },
  set exports(t) {
    cS = t;
  }
}, lbe = fn, ube = Ll, cbe = TypeError, dbe = Object.getOwnPropertyDescriptor, hbe = lbe && !function() {
  if (this !== void 0)
    return !0;
  try {
    Object.defineProperty([], "length", { writable: !1 }).length = 1;
  } catch (t) {
    return t instanceof TypeError;
  }
}(), fbe = hbe ? function(t, e) {
  if (ube(t) && !dbe(t, "length").writable)
    throw cbe("Cannot set read only .length");
  return t.length = e;
} : function(t, e) {
  return t.length = e;
}, uM = hh, pbe = TypeError, G4 = function(t, e) {
  if (!delete t[e])
    throw pbe("Cannot delete property " + uM(e) + " of " + uM(t));
}, vbe = qe, mbe = Ci, gbe = zp, ybe = Z0, bbe = Qi, _be = fbe, wbe = MD, Tbe = eb, xbe = fh, A1 = G4, Sbe = Kp, Ebe = Sbe("splice"), $be = Math.max, kbe = Math.min;
vbe({ target: "Array", proto: !0, forced: !Ebe }, {
  splice: function(e, r) {
    var n = mbe(this), s = bbe(n), a = gbe(e, s), o = arguments.length, l, u, c, d, h, f;
    for (o === 0 ? l = u = 0 : o === 1 ? (l = 0, u = s - a) : (l = o - 2, u = kbe($be(ybe(r), 0), s - a)), wbe(s + l - u), c = Tbe(n, u), d = 0; d < u; d++)
      h = a + d, h in n && xbe(c, d, n[h]);
    if (c.length = u, l < u) {
      for (d = a; d < s - u; d++)
        h = d + u, f = d + l, h in n ? n[f] = n[h] : A1(n, f);
      for (d = s; d > s - u + l; d--)
        A1(n, d - 1);
    } else if (l > u)
      for (d = s - u; d > a; d--)
        h = d + u - 1, f = d + l - 1, h in n ? n[f] = n[h] : A1(n, f);
    for (d = 0; d < l; d++)
      n[d + a] = arguments[d + 2];
    return _be(n, s - u + l), c;
  }
});
var Dbe = nn, Obe = Dbe("Array").splice, Abe = Ar, Cbe = Obe, C1 = Array.prototype, Ibe = function(t) {
  var e = t.splice;
  return t === C1 || Abe(C1, t) && e === C1.splice ? Cbe : e;
}, Pbe = Ibe, Rbe = Pbe;
(function(t) {
  t.exports = Rbe;
})(obe);
var W4 = /* @__PURE__ */ ft(cS), dS = {}, Mbe = {
  get exports() {
    return dS;
  },
  set exports(t) {
    dS = t;
  }
}, cM = fn, Lbe = zt, Nbe = Sn, Fbe = Wt, I1 = Xp, Bbe = Zp, Ube = Yp, Vbe = Ci, Ybe = z0, Nc = Object.assign, dM = Object.defineProperty, Hbe = Lbe([].concat), Gbe = !Nc || Fbe(function() {
  if (cM && Nc({ b: 1 }, Nc(dM({}, "a", {
    enumerable: !0,
    get: function() {
      dM(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1)
    return !0;
  var t = {}, e = {}, r = Symbol(), n = "abcdefghijklmnopqrst";
  return t[r] = 7, n.split("").forEach(function(s) {
    e[s] = s;
  }), Nc({}, t)[r] != 7 || I1(Nc({}, e)).join("") != n;
}) ? function(e, r) {
  for (var n = Vbe(e), s = arguments.length, a = 1, o = Bbe.f, l = Ube.f; s > a; )
    for (var u = Ybe(arguments[a++]), c = o ? Hbe(I1(u), o(u)) : I1(u), d = c.length, h = 0, f; d > h; )
      f = c[h++], (!cM || Nbe(l, u, f)) && (n[f] = u[f]);
  return n;
} : Nc, Wbe = qe, hM = Gbe;
Wbe({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== hM }, {
  assign: hM
});
var jbe = vr, Kbe = jbe.Object.assign, zbe = Kbe, qbe = zbe;
(function(t) {
  t.exports = qbe;
})(Mbe);
var j4 = /* @__PURE__ */ ft(dS), fM = {}, Xbe = {
  get exports() {
    return fM;
  },
  set exports(t) {
    fM = t;
  }
}, Qbe = qe, Zbe = FD.includes, Jbe = Wt, e_e = Jbe(function() {
  return !Array(1).includes();
});
Qbe({ target: "Array", proto: !0, forced: e_e }, {
  includes: function(e) {
    return Zbe(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var t_e = nn, r_e = t_e("Array").includes, n_e = En, i_e = Mo, s_e = Cr, a_e = s_e("match"), o_e = function(t) {
  var e;
  return n_e(t) && ((e = t[a_e]) !== void 0 ? !!e : i_e(t) == "RegExp");
}, l_e = o_e, u_e = TypeError, c_e = function(t) {
  if (l_e(t))
    throw u_e("The method doesn't accept regular expressions");
  return t;
}, d_e = Cr, h_e = d_e("match"), f_e = function(t) {
  var e = /./;
  try {
    "/./"[t](e);
  } catch {
    try {
      return e[h_e] = !1, "/./"[t](e);
    } catch {
    }
  }
  return !1;
}, p_e = qe, v_e = zt, m_e = c_e, g_e = Gp, pM = Ua, y_e = f_e, b_e = v_e("".indexOf);
p_e({ target: "String", proto: !0, forced: !y_e("includes") }, {
  includes: function(e) {
    return !!~b_e(
      pM(g_e(this)),
      pM(m_e(e)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var __e = nn, w_e = __e("String").includes, vM = Ar, T_e = r_e, x_e = w_e, P1 = Array.prototype, R1 = String.prototype, S_e = function(t) {
  var e = t.includes;
  return t === P1 || vM(P1, t) && e === P1.includes ? T_e : typeof t == "string" || t === R1 || vM(R1, t) && e === R1.includes ? x_e : e;
}, E_e = S_e, $_e = E_e;
(function(t) {
  t.exports = $_e;
})(Xbe);
var mM = {}, k_e = {
  get exports() {
    return mM;
  },
  set exports(t) {
    mM = t;
  }
}, D_e = qe, O_e = Wt, A_e = Ci, K4 = lb, C_e = r4, I_e = O_e(function() {
  K4(1);
});
D_e({ target: "Object", stat: !0, forced: I_e, sham: !C_e }, {
  getPrototypeOf: function(e) {
    return K4(A_e(e));
  }
});
var P_e = vr, R_e = P_e.Object.getPrototypeOf, M_e = R_e, z4 = M_e;
(function(t) {
  t.exports = z4;
})(k_e);
var gM = {}, L_e = {
  get exports() {
    return gM;
  },
  set exports(t) {
    gM = t;
  }
}, N_e = fn, q4 = zt, F_e = Xp, B_e = Zs, U_e = Yp.f, V_e = q4(U_e), Y_e = q4([].push), yM = function(t) {
  return function(e) {
    for (var r = B_e(e), n = F_e(r), s = n.length, a = 0, o = [], l; s > a; )
      l = n[a++], (!N_e || V_e(r, l)) && Y_e(o, t ? [l, r[l]] : r[l]);
    return o;
  };
}, H_e = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: yM(!0),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: yM(!1)
}, G_e = qe, W_e = H_e.values;
G_e({ target: "Object", stat: !0 }, {
  values: function(e) {
    return W_e(e);
  }
});
var j_e = vr, K_e = j_e.Object.values, z_e = K_e, q_e = z_e;
(function(t) {
  t.exports = q_e;
})(L_e);
var bM = {}, X_e = {
  get exports() {
    return bM;
  },
  set exports(t) {
    bM = t;
  }
}, eO = `	
\v\f\r                　\u2028\u2029\uFEFF`, Q_e = zt, Z_e = Gp, J_e = Ua, hS = eO, _M = Q_e("".replace), e1e = RegExp("^[" + hS + "]+"), t1e = RegExp("(^|[^" + hS + "])[" + hS + "]+$"), M1 = function(t) {
  return function(e) {
    var r = J_e(Z_e(e));
    return t & 1 && (r = _M(r, e1e, "")), t & 2 && (r = _M(r, t1e, "$1")), r;
  };
}, X4 = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: M1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: M1(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: M1(3)
}, Q4 = Hr, r1e = Wt, n1e = zt, i1e = Ua, s1e = X4.trim, wM = eO, Df = Q4.parseInt, TM = Q4.Symbol, xM = TM && TM.iterator, Z4 = /^[+-]?0x/i, a1e = n1e(Z4.exec), o1e = Df(wM + "08") !== 8 || Df(wM + "0x16") !== 22 || xM && !r1e(function() {
  Df(Object(xM));
}), l1e = o1e ? function(e, r) {
  var n = s1e(i1e(e));
  return Df(n, r >>> 0 || (a1e(Z4, n) ? 16 : 10));
} : Df, u1e = qe, SM = l1e;
u1e({ global: !0, forced: parseInt != SM }, {
  parseInt: SM
});
var c1e = vr, d1e = c1e.parseInt, h1e = d1e, f1e = h1e;
(function(t) {
  t.exports = f1e;
})(X_e);
var EM = {}, p1e = {
  get exports() {
    return EM;
  },
  set exports(t) {
    EM = t;
  }
}, v1e = qe, m1e = CD, g1e = FD.indexOf, y1e = nv, fS = m1e([].indexOf), J4 = !!fS && 1 / fS([1], 1, -0) < 0, b1e = J4 || !y1e("indexOf");
v1e({ target: "Array", proto: !0, forced: b1e }, {
  indexOf: function(e) {
    var r = arguments.length > 1 ? arguments[1] : void 0;
    return J4 ? fS(this, e, r) || 0 : g1e(this, e, r);
  }
});
var _1e = nn, w1e = _1e("Array").indexOf, T1e = Ar, x1e = w1e, L1 = Array.prototype, S1e = function(t) {
  var e = t.indexOf;
  return t === L1 || T1e(L1, t) && e === L1.indexOf ? x1e : e;
}, E1e = S1e, $1e = E1e;
(function(t) {
  t.exports = $1e;
})(p1e);
var $M = {}, k1e = {
  get exports() {
    return $M;
  },
  set exports(t) {
    $M = t;
  }
}, D1e = t4.PROPER, O1e = Wt, kM = eO, DM = "​᠎", A1e = function(t) {
  return O1e(function() {
    return !!kM[t]() || DM[t]() !== DM || D1e && kM[t].name !== t;
  });
}, C1e = qe, I1e = X4.trim, P1e = A1e;
C1e({ target: "String", proto: !0, forced: P1e("trim") }, {
  trim: function() {
    return I1e(this);
  }
});
var R1e = nn, M1e = R1e("String").trim, L1e = Ar, N1e = M1e, N1 = String.prototype, F1e = function(t) {
  var e = t.trim;
  return typeof t == "string" || t === N1 || L1e(N1, t) && e === N1.trim ? N1e : e;
}, B1e = F1e, U1e = B1e;
(function(t) {
  t.exports = U1e;
})(k1e);
var pS = {}, V1e = {
  get exports() {
    return pS;
  },
  set exports(t) {
    pS = t;
  }
}, Y1e = qe, H1e = fn, G1e = lc;
Y1e({ target: "Object", stat: !0, sham: !H1e }, {
  create: G1e
});
var W1e = vr, j1e = W1e.Object, K1e = function(e, r) {
  return j1e.create(e, r);
}, z1e = K1e, eH = z1e;
(function(t) {
  t.exports = eH;
})(V1e);
var q1e = /* @__PURE__ */ ft(pS), vS = {}, X1e = {
  get exports() {
    return vS;
  },
  set exports(t) {
    vS = t;
  }
}, mS = vr, Q1e = uh;
mS.JSON || (mS.JSON = { stringify: JSON.stringify });
var Z1e = function(e, r, n) {
  return Q1e(mS.JSON.stringify, null, arguments);
}, J1e = Z1e, ewe = J1e;
(function(t) {
  t.exports = ewe;
})(X1e);
var twe = /* @__PURE__ */ ft(vS), gS = {}, rwe = {
  get exports() {
    return gS;
  },
  set exports(t) {
    gS = t;
  }
}, nwe = typeof Bun == "function" && Bun && typeof Bun.version == "string", iwe = TypeError, tH = function(t, e) {
  if (t < e)
    throw iwe("Not enough arguments");
  return t;
}, rH = Hr, swe = uh, awe = Gr, owe = nwe, lwe = Rl, uwe = tv, cwe = tH, dwe = rH.Function, hwe = /MSIE .\./.test(lwe) || owe && function() {
  var t = rH.Bun.version.split(".");
  return t.length < 3 || t[0] == 0 && (t[1] < 3 || t[1] == 3 && t[2] == 0);
}(), nH = function(t, e) {
  var r = e ? 2 : 1;
  return hwe ? function(n, s) {
    var a = cwe(arguments.length, 1) > r, o = awe(n) ? n : dwe(n), l = a ? uwe(arguments, r) : [], u = a ? function() {
      swe(o, this, l);
    } : o;
    return e ? t(u, s) : t(u);
  } : t;
}, fwe = qe, iH = Hr, pwe = nH, OM = pwe(iH.setInterval, !0);
fwe({ global: !0, bind: !0, forced: iH.setInterval !== OM }, {
  setInterval: OM
});
var vwe = qe, sH = Hr, mwe = nH, AM = mwe(sH.setTimeout, !0);
vwe({ global: !0, bind: !0, forced: sH.setTimeout !== AM }, {
  setTimeout: AM
});
var gwe = vr, ywe = gwe.setTimeout;
(function(t) {
  t.exports = ywe;
})(rwe);
var bwe = /* @__PURE__ */ ft(gS), CM = {}, _we = {
  get exports() {
    return CM;
  },
  set exports(t) {
    CM = t;
  }
}, wwe = Ci, IM = zp, Twe = Qi, xwe = function(e) {
  for (var r = wwe(this), n = Twe(r), s = arguments.length, a = IM(s > 1 ? arguments[1] : void 0, n), o = s > 2 ? arguments[2] : void 0, l = o === void 0 ? n : IM(o, n); l > a; )
    r[a++] = e;
  return r;
}, Swe = qe, Ewe = xwe;
Swe({ target: "Array", proto: !0 }, {
  fill: Ewe
});
var $we = nn, kwe = $we("Array").fill, Dwe = Ar, Owe = kwe, F1 = Array.prototype, Awe = function(t) {
  var e = t.fill;
  return t === F1 || Dwe(F1, t) && e === F1.fill ? Owe : e;
}, Cwe = Awe, Iwe = Cwe;
(function(t) {
  t.exports = Iwe;
})(_we);
var yS = {}, Pwe = {
  get exports() {
    return yS;
  },
  set exports(t) {
    yS = t;
  }
};
(function(t) {
  t.exports = e;
  function e(n) {
    if (n)
      return r(n);
  }
  function r(n) {
    for (var s in e.prototype)
      n[s] = e.prototype[s];
    return n;
  }
  e.prototype.on = e.prototype.addEventListener = function(n, s) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + n] = this._callbacks["$" + n] || []).push(s), this;
  }, e.prototype.once = function(n, s) {
    function a() {
      this.off(n, a), s.apply(this, arguments);
    }
    return a.fn = s, this.on(n, a), this;
  }, e.prototype.off = e.prototype.removeListener = e.prototype.removeAllListeners = e.prototype.removeEventListener = function(n, s) {
    if (this._callbacks = this._callbacks || {}, arguments.length == 0)
      return this._callbacks = {}, this;
    var a = this._callbacks["$" + n];
    if (!a)
      return this;
    if (arguments.length == 1)
      return delete this._callbacks["$" + n], this;
    for (var o, l = 0; l < a.length; l++)
      if (o = a[l], o === s || o.fn === s) {
        a.splice(l, 1);
        break;
      }
    return a.length === 0 && delete this._callbacks["$" + n], this;
  }, e.prototype.emit = function(n) {
    this._callbacks = this._callbacks || {};
    for (var s = new Array(arguments.length - 1), a = this._callbacks["$" + n], o = 1; o < arguments.length; o++)
      s[o - 1] = arguments[o];
    if (a) {
      a = a.slice(0);
      for (var o = 0, l = a.length; o < l; ++o)
        a[o].apply(this, s);
    }
    return this;
  }, e.prototype.listeners = function(n) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + n] || [];
  }, e.prototype.hasListeners = function(n) {
    return !!this.listeners(n).length;
  };
})(Pwe);
var Rwe = yS;
/*! Hammer.JS - v2.0.17-rc - 2019-12-16
 * http://naver.github.io/egjs
 *
 * Forked By Naver egjs
 * Copyright (c) hammerjs
 * Licensed under the MIT license */
function zs() {
  return zs = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, zs.apply(this, arguments);
}
function _s(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
function Vm(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
var bS;
typeof Object.assign != "function" ? bS = function(e) {
  if (e == null)
    throw new TypeError("Cannot convert undefined or null to object");
  for (var r = Object(e), n = 1; n < arguments.length; n++) {
    var s = arguments[n];
    if (s != null)
      for (var a in s)
        s.hasOwnProperty(a) && (r[a] = s[a]);
  }
  return r;
} : bS = Object.assign;
var Uu = bS, PM = ["", "webkit", "Moz", "MS", "ms", "o"], Mwe = typeof document > "u" ? {
  style: {}
} : document.createElement("div"), Lwe = "function", sd = Math.round, Vu = Math.abs, tO = Date.now;
function hb(t, e) {
  for (var r, n, s = e[0].toUpperCase() + e.slice(1), a = 0; a < PM.length; ) {
    if (r = PM[a], n = r ? r + s : e, n in t)
      return n;
    a++;
  }
}
var po;
typeof window > "u" ? po = {} : po = window;
var aH = hb(Mwe.style, "touchAction"), oH = aH !== void 0;
function Nwe() {
  if (!oH)
    return !1;
  var t = {}, e = po.CSS && po.CSS.supports;
  return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(r) {
    return t[r] = e ? po.CSS.supports("touch-action", r) : !0;
  }), t;
}
var lH = "compute", uH = "auto", _S = "manipulation", Su = "none", lp = "pan-x", up = "pan-y", Ym = Nwe(), Fwe = /mobile|tablet|ip(ad|hone|od)|android/i, cH = "ontouchstart" in po, Bwe = hb(po, "PointerEvent") !== void 0, Uwe = cH && Fwe.test(navigator.userAgent), ov = "touch", Vwe = "pen", rO = "mouse", Ywe = "kinect", Hwe = 25, oi = 1, dc = 2, en = 4, $i = 8, Sy = 1, lv = 2, uv = 4, cv = 8, Fd = 16, Ea = lv | uv, Eu = cv | Fd, dH = Ea | Eu, hH = ["x", "y"], Ey = ["clientX", "clientY"];
function vo(t, e, r) {
  var n;
  if (t)
    if (t.forEach)
      t.forEach(e, r);
    else if (t.length !== void 0)
      for (n = 0; n < t.length; )
        e.call(r, t[n], n, t), n++;
    else
      for (n in t)
        t.hasOwnProperty(n) && e.call(r, t[n], n, t);
}
function fb(t, e) {
  return typeof t === Lwe ? t.apply(e && e[0] || void 0, e) : t;
}
function du(t, e) {
  return t.indexOf(e) > -1;
}
function Gwe(t) {
  if (du(t, Su))
    return Su;
  var e = du(t, lp), r = du(t, up);
  return e && r ? Su : e || r ? e ? lp : up : du(t, _S) ? _S : uH;
}
var fH = /* @__PURE__ */ function() {
  function t(r, n) {
    this.manager = r, this.set(n);
  }
  var e = t.prototype;
  return e.set = function(n) {
    n === lH && (n = this.compute()), oH && this.manager.element.style && Ym[n] && (this.manager.element.style[aH] = n), this.actions = n.toLowerCase().trim();
  }, e.update = function() {
    this.set(this.manager.options.touchAction);
  }, e.compute = function() {
    var n = [];
    return vo(this.manager.recognizers, function(s) {
      fb(s.options.enable, [s]) && (n = n.concat(s.getTouchAction()));
    }), Gwe(n.join(" "));
  }, e.preventDefaults = function(n) {
    var s = n.srcEvent, a = n.offsetDirection;
    if (this.manager.session.prevented) {
      s.preventDefault();
      return;
    }
    var o = this.actions, l = du(o, Su) && !Ym[Su], u = du(o, up) && !Ym[up], c = du(o, lp) && !Ym[lp];
    if (l) {
      var d = n.pointers.length === 1, h = n.distance < 2, f = n.deltaTime < 250;
      if (d && h && f)
        return;
    }
    if (!(c && u) && (l || u && a & Ea || c && a & Eu))
      return this.preventSrc(s);
  }, e.preventSrc = function(n) {
    this.manager.session.prevented = !0, n.preventDefault();
  }, t;
}();
function nO(t, e) {
  for (; t; ) {
    if (t === e)
      return !0;
    t = t.parentNode;
  }
  return !1;
}
function pH(t) {
  var e = t.length;
  if (e === 1)
    return {
      x: sd(t[0].clientX),
      y: sd(t[0].clientY)
    };
  for (var r = 0, n = 0, s = 0; s < e; )
    r += t[s].clientX, n += t[s].clientY, s++;
  return {
    x: sd(r / e),
    y: sd(n / e)
  };
}
function RM(t) {
  for (var e = [], r = 0; r < t.pointers.length; )
    e[r] = {
      clientX: sd(t.pointers[r].clientX),
      clientY: sd(t.pointers[r].clientY)
    }, r++;
  return {
    timeStamp: tO(),
    pointers: e,
    center: pH(e),
    deltaX: t.deltaX,
    deltaY: t.deltaY
  };
}
function $y(t, e, r) {
  r || (r = hH);
  var n = e[r[0]] - t[r[0]], s = e[r[1]] - t[r[1]];
  return Math.sqrt(n * n + s * s);
}
function wS(t, e, r) {
  r || (r = hH);
  var n = e[r[0]] - t[r[0]], s = e[r[1]] - t[r[1]];
  return Math.atan2(s, n) * 180 / Math.PI;
}
function vH(t, e) {
  return t === e ? Sy : Vu(t) >= Vu(e) ? t < 0 ? lv : uv : e < 0 ? cv : Fd;
}
function Wwe(t, e) {
  var r = e.center, n = t.offsetDelta || {}, s = t.prevDelta || {}, a = t.prevInput || {};
  (e.eventType === oi || a.eventType === en) && (s = t.prevDelta = {
    x: a.deltaX || 0,
    y: a.deltaY || 0
  }, n = t.offsetDelta = {
    x: r.x,
    y: r.y
  }), e.deltaX = s.x + (r.x - n.x), e.deltaY = s.y + (r.y - n.y);
}
function mH(t, e, r) {
  return {
    x: e / t || 0,
    y: r / t || 0
  };
}
function jwe(t, e) {
  return $y(e[0], e[1], Ey) / $y(t[0], t[1], Ey);
}
function Kwe(t, e) {
  return wS(e[1], e[0], Ey) + wS(t[1], t[0], Ey);
}
function zwe(t, e) {
  var r = t.lastInterval || e, n = e.timeStamp - r.timeStamp, s, a, o, l;
  if (e.eventType !== $i && (n > Hwe || r.velocity === void 0)) {
    var u = e.deltaX - r.deltaX, c = e.deltaY - r.deltaY, d = mH(n, u, c);
    a = d.x, o = d.y, s = Vu(d.x) > Vu(d.y) ? d.x : d.y, l = vH(u, c), t.lastInterval = e;
  } else
    s = r.velocity, a = r.velocityX, o = r.velocityY, l = r.direction;
  e.velocity = s, e.velocityX = a, e.velocityY = o, e.direction = l;
}
function qwe(t, e) {
  var r = t.session, n = e.pointers, s = n.length;
  r.firstInput || (r.firstInput = RM(e)), s > 1 && !r.firstMultiple ? r.firstMultiple = RM(e) : s === 1 && (r.firstMultiple = !1);
  var a = r.firstInput, o = r.firstMultiple, l = o ? o.center : a.center, u = e.center = pH(n);
  e.timeStamp = tO(), e.deltaTime = e.timeStamp - a.timeStamp, e.angle = wS(l, u), e.distance = $y(l, u), Wwe(r, e), e.offsetDirection = vH(e.deltaX, e.deltaY);
  var c = mH(e.deltaTime, e.deltaX, e.deltaY);
  e.overallVelocityX = c.x, e.overallVelocityY = c.y, e.overallVelocity = Vu(c.x) > Vu(c.y) ? c.x : c.y, e.scale = o ? jwe(o.pointers, n) : 1, e.rotation = o ? Kwe(o.pointers, n) : 0, e.maxPointers = r.prevInput ? e.pointers.length > r.prevInput.maxPointers ? e.pointers.length : r.prevInput.maxPointers : e.pointers.length, zwe(r, e);
  var d = t.element, h = e.srcEvent, f;
  h.composedPath ? f = h.composedPath()[0] : h.path ? f = h.path[0] : f = h.target, nO(f, d) && (d = f), e.target = d;
}
function Xwe(t, e, r) {
  var n = r.pointers.length, s = r.changedPointers.length, a = e & oi && n - s === 0, o = e & (en | $i) && n - s === 0;
  r.isFirst = !!a, r.isFinal = !!o, a && (t.session = {}), r.eventType = e, qwe(t, r), t.emit("hammer.input", r), t.recognize(r), t.session.prevInput = r;
}
function cp(t) {
  return t.trim().split(/\s+/g);
}
function Of(t, e, r) {
  vo(cp(e), function(n) {
    t.addEventListener(n, r, !1);
  });
}
function Af(t, e, r) {
  vo(cp(e), function(n) {
    t.removeEventListener(n, r, !1);
  });
}
function MM(t) {
  var e = t.ownerDocument || t;
  return e.defaultView || e.parentWindow || window;
}
var bh = /* @__PURE__ */ function() {
  function t(r, n) {
    var s = this;
    this.manager = r, this.callback = n, this.element = r.element, this.target = r.options.inputTarget, this.domHandler = function(a) {
      fb(r.options.enable, [r]) && s.handler(a);
    }, this.init();
  }
  var e = t.prototype;
  return e.handler = function() {
  }, e.init = function() {
    this.evEl && Of(this.element, this.evEl, this.domHandler), this.evTarget && Of(this.target, this.evTarget, this.domHandler), this.evWin && Of(MM(this.element), this.evWin, this.domHandler);
  }, e.destroy = function() {
    this.evEl && Af(this.element, this.evEl, this.domHandler), this.evTarget && Af(this.target, this.evTarget, this.domHandler), this.evWin && Af(MM(this.element), this.evWin, this.domHandler);
  }, t;
}();
function Yu(t, e, r) {
  if (t.indexOf && !r)
    return t.indexOf(e);
  for (var n = 0; n < t.length; ) {
    if (r && t[n][r] == e || !r && t[n] === e)
      return n;
    n++;
  }
  return -1;
}
var Qwe = {
  pointerdown: oi,
  pointermove: dc,
  pointerup: en,
  pointercancel: $i,
  pointerout: $i
}, Zwe = {
  2: ov,
  3: Vwe,
  4: rO,
  5: Ywe
  // see https://twitter.com/jacobrossi/status/480596438489890816
}, gH = "pointerdown", yH = "pointermove pointerup pointercancel";
po.MSPointerEvent && !po.PointerEvent && (gH = "MSPointerDown", yH = "MSPointerMove MSPointerUp MSPointerCancel");
var bH = /* @__PURE__ */ function(t) {
  _s(e, t);
  function e() {
    var n, s = e.prototype;
    return s.evEl = gH, s.evWin = yH, n = t.apply(this, arguments) || this, n.store = n.manager.session.pointerEvents = [], n;
  }
  var r = e.prototype;
  return r.handler = function(s) {
    var a = this.store, o = !1, l = s.type.toLowerCase().replace("ms", ""), u = Qwe[l], c = Zwe[s.pointerType] || s.pointerType, d = c === ov, h = Yu(a, s.pointerId, "pointerId");
    u & oi && (s.button === 0 || d) ? h < 0 && (a.push(s), h = a.length - 1) : u & (en | $i) && (o = !0), !(h < 0) && (a[h] = s, this.callback(this.manager, u, {
      pointers: a,
      changedPointers: [s],
      pointerType: c,
      srcEvent: s
    }), o && a.splice(h, 1));
  }, e;
}(bh);
function dp(t) {
  return Array.prototype.slice.call(t, 0);
}
function iO(t, e, r) {
  for (var n = [], s = [], a = 0; a < t.length; ) {
    var o = e ? t[a][e] : t[a];
    Yu(s, o) < 0 && n.push(t[a]), s[a] = o, a++;
  }
  return r && (e ? n = n.sort(function(l, u) {
    return l[e] > u[e];
  }) : n = n.sort()), n;
}
var Jwe = {
  touchstart: oi,
  touchmove: dc,
  touchend: en,
  touchcancel: $i
}, eTe = "touchstart touchmove touchend touchcancel", sO = /* @__PURE__ */ function(t) {
  _s(e, t);
  function e() {
    var n;
    return e.prototype.evTarget = eTe, n = t.apply(this, arguments) || this, n.targetIds = {}, n;
  }
  var r = e.prototype;
  return r.handler = function(s) {
    var a = Jwe[s.type], o = tTe.call(this, s, a);
    o && this.callback(this.manager, a, {
      pointers: o[0],
      changedPointers: o[1],
      pointerType: ov,
      srcEvent: s
    });
  }, e;
}(bh);
function tTe(t, e) {
  var r = dp(t.touches), n = this.targetIds;
  if (e & (oi | dc) && r.length === 1)
    return n[r[0].identifier] = !0, [r, r];
  var s, a, o = dp(t.changedTouches), l = [], u = this.target;
  if (a = r.filter(function(c) {
    return nO(c.target, u);
  }), e === oi)
    for (s = 0; s < a.length; )
      n[a[s].identifier] = !0, s++;
  for (s = 0; s < o.length; )
    n[o[s].identifier] && l.push(o[s]), e & (en | $i) && delete n[o[s].identifier], s++;
  if (l.length)
    return [
      // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
      iO(a.concat(l), "identifier", !0),
      l
    ];
}
var rTe = {
  mousedown: oi,
  mousemove: dc,
  mouseup: en
}, nTe = "mousedown", iTe = "mousemove mouseup", aO = /* @__PURE__ */ function(t) {
  _s(e, t);
  function e() {
    var n, s = e.prototype;
    return s.evEl = nTe, s.evWin = iTe, n = t.apply(this, arguments) || this, n.pressed = !1, n;
  }
  var r = e.prototype;
  return r.handler = function(s) {
    var a = rTe[s.type];
    a & oi && s.button === 0 && (this.pressed = !0), a & dc && s.which !== 1 && (a = en), this.pressed && (a & en && (this.pressed = !1), this.callback(this.manager, a, {
      pointers: [s],
      changedPointers: [s],
      pointerType: rO,
      srcEvent: s
    }));
  }, e;
}(bh), sTe = 2500, LM = 25;
function NM(t) {
  var e = t.changedPointers, r = e[0];
  if (r.identifier === this.primaryTouch) {
    var n = {
      x: r.clientX,
      y: r.clientY
    }, s = this.lastTouches;
    this.lastTouches.push(n);
    var a = function() {
      var l = s.indexOf(n);
      l > -1 && s.splice(l, 1);
    };
    setTimeout(a, sTe);
  }
}
function aTe(t, e) {
  t & oi ? (this.primaryTouch = e.changedPointers[0].identifier, NM.call(this, e)) : t & (en | $i) && NM.call(this, e);
}
function oTe(t) {
  for (var e = t.srcEvent.clientX, r = t.srcEvent.clientY, n = 0; n < this.lastTouches.length; n++) {
    var s = this.lastTouches[n], a = Math.abs(e - s.x), o = Math.abs(r - s.y);
    if (a <= LM && o <= LM)
      return !0;
  }
  return !1;
}
var _H = /* @__PURE__ */ function() {
  var t = /* @__PURE__ */ function(e) {
    _s(r, e);
    function r(s, a) {
      var o;
      return o = e.call(this, s, a) || this, o.handler = function(l, u, c) {
        var d = c.pointerType === ov, h = c.pointerType === rO;
        if (!(h && c.sourceCapabilities && c.sourceCapabilities.firesTouchEvents)) {
          if (d)
            aTe.call(Vm(Vm(o)), u, c);
          else if (h && oTe.call(Vm(Vm(o)), c))
            return;
          o.callback(l, u, c);
        }
      }, o.touch = new sO(o.manager, o.handler), o.mouse = new aO(o.manager, o.handler), o.primaryTouch = null, o.lastTouches = [], o;
    }
    var n = r.prototype;
    return n.destroy = function() {
      this.touch.destroy(), this.mouse.destroy();
    }, r;
  }(bh);
  return t;
}();
function lTe(t) {
  var e, r = t.options.inputClass;
  return r ? e = r : Bwe ? e = bH : Uwe ? e = sO : cH ? e = _H : e = aO, new e(t, Xwe);
}
function ad(t, e, r) {
  return Array.isArray(t) ? (vo(t, r[e], r), !0) : !1;
}
var Cg = 1, fs = 2, Bd = 4, bl = 8, mo = bl, hp = 16, ba = 32, uTe = 1;
function cTe() {
  return uTe++;
}
function Hm(t, e) {
  var r = e.manager;
  return r ? r.get(t) : t;
}
function FM(t) {
  return t & hp ? "cancel" : t & bl ? "end" : t & Bd ? "move" : t & fs ? "start" : "";
}
var dv = /* @__PURE__ */ function() {
  function t(r) {
    r === void 0 && (r = {}), this.options = zs({
      enable: !0
    }, r), this.id = cTe(), this.manager = null, this.state = Cg, this.simultaneous = {}, this.requireFail = [];
  }
  var e = t.prototype;
  return e.set = function(n) {
    return Uu(this.options, n), this.manager && this.manager.touchAction.update(), this;
  }, e.recognizeWith = function(n) {
    if (ad(n, "recognizeWith", this))
      return this;
    var s = this.simultaneous;
    return n = Hm(n, this), s[n.id] || (s[n.id] = n, n.recognizeWith(this)), this;
  }, e.dropRecognizeWith = function(n) {
    return ad(n, "dropRecognizeWith", this) ? this : (n = Hm(n, this), delete this.simultaneous[n.id], this);
  }, e.requireFailure = function(n) {
    if (ad(n, "requireFailure", this))
      return this;
    var s = this.requireFail;
    return n = Hm(n, this), Yu(s, n) === -1 && (s.push(n), n.requireFailure(this)), this;
  }, e.dropRequireFailure = function(n) {
    if (ad(n, "dropRequireFailure", this))
      return this;
    n = Hm(n, this);
    var s = Yu(this.requireFail, n);
    return s > -1 && this.requireFail.splice(s, 1), this;
  }, e.hasRequireFailures = function() {
    return this.requireFail.length > 0;
  }, e.canRecognizeWith = function(n) {
    return !!this.simultaneous[n.id];
  }, e.emit = function(n) {
    var s = this, a = this.state;
    function o(l) {
      s.manager.emit(l, n);
    }
    a < bl && o(s.options.event + FM(a)), o(s.options.event), n.additionalEvent && o(n.additionalEvent), a >= bl && o(s.options.event + FM(a));
  }, e.tryEmit = function(n) {
    if (this.canEmit())
      return this.emit(n);
    this.state = ba;
  }, e.canEmit = function() {
    for (var n = 0; n < this.requireFail.length; ) {
      if (!(this.requireFail[n].state & (ba | Cg)))
        return !1;
      n++;
    }
    return !0;
  }, e.recognize = function(n) {
    var s = Uu({}, n);
    if (!fb(this.options.enable, [this, s])) {
      this.reset(), this.state = ba;
      return;
    }
    this.state & (mo | hp | ba) && (this.state = Cg), this.state = this.process(s), this.state & (fs | Bd | bl | hp) && this.tryEmit(s);
  }, e.process = function(n) {
  }, e.getTouchAction = function() {
  }, e.reset = function() {
  }, t;
}(), TS = /* @__PURE__ */ function(t) {
  _s(e, t);
  function e(n) {
    var s;
    return n === void 0 && (n = {}), s = t.call(this, zs({
      event: "tap",
      pointers: 1,
      taps: 1,
      interval: 300,
      // max time between the multi-tap taps
      time: 250,
      // max time of the pointer to be down (like finger on the screen)
      threshold: 9,
      // a minimal movement is ok, but keep it low
      posThreshold: 10
    }, n)) || this, s.pTime = !1, s.pCenter = !1, s._timer = null, s._input = null, s.count = 0, s;
  }
  var r = e.prototype;
  return r.getTouchAction = function() {
    return [_S];
  }, r.process = function(s) {
    var a = this, o = this.options, l = s.pointers.length === o.pointers, u = s.distance < o.threshold, c = s.deltaTime < o.time;
    if (this.reset(), s.eventType & oi && this.count === 0)
      return this.failTimeout();
    if (u && c && l) {
      if (s.eventType !== en)
        return this.failTimeout();
      var d = this.pTime ? s.timeStamp - this.pTime < o.interval : !0, h = !this.pCenter || $y(this.pCenter, s.center) < o.posThreshold;
      this.pTime = s.timeStamp, this.pCenter = s.center, !h || !d ? this.count = 1 : this.count += 1, this._input = s;
      var f = this.count % o.taps;
      if (f === 0)
        return this.hasRequireFailures() ? (this._timer = setTimeout(function() {
          a.state = mo, a.tryEmit();
        }, o.interval), fs) : mo;
    }
    return ba;
  }, r.failTimeout = function() {
    var s = this;
    return this._timer = setTimeout(function() {
      s.state = ba;
    }, this.options.interval), ba;
  }, r.reset = function() {
    clearTimeout(this._timer);
  }, r.emit = function() {
    this.state === mo && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
  }, e;
}(dv), Ud = /* @__PURE__ */ function(t) {
  _s(e, t);
  function e(n) {
    return n === void 0 && (n = {}), t.call(this, zs({
      pointers: 1
    }, n)) || this;
  }
  var r = e.prototype;
  return r.attrTest = function(s) {
    var a = this.options.pointers;
    return a === 0 || s.pointers.length === a;
  }, r.process = function(s) {
    var a = this.state, o = s.eventType, l = a & (fs | Bd), u = this.attrTest(s);
    return l && (o & $i || !u) ? a | hp : l || u ? o & en ? a | bl : a & fs ? a | Bd : fs : ba;
  }, e;
}(dv);
function wH(t) {
  return t === Fd ? "down" : t === cv ? "up" : t === lv ? "left" : t === uv ? "right" : "";
}
var oO = /* @__PURE__ */ function(t) {
  _s(e, t);
  function e(n) {
    var s;
    return n === void 0 && (n = {}), s = t.call(this, zs({
      event: "pan",
      threshold: 10,
      pointers: 1,
      direction: dH
    }, n)) || this, s.pX = null, s.pY = null, s;
  }
  var r = e.prototype;
  return r.getTouchAction = function() {
    var s = this.options.direction, a = [];
    return s & Ea && a.push(up), s & Eu && a.push(lp), a;
  }, r.directionTest = function(s) {
    var a = this.options, o = !0, l = s.distance, u = s.direction, c = s.deltaX, d = s.deltaY;
    return u & a.direction || (a.direction & Ea ? (u = c === 0 ? Sy : c < 0 ? lv : uv, o = c !== this.pX, l = Math.abs(s.deltaX)) : (u = d === 0 ? Sy : d < 0 ? cv : Fd, o = d !== this.pY, l = Math.abs(s.deltaY))), s.direction = u, o && l > a.threshold && u & a.direction;
  }, r.attrTest = function(s) {
    return Ud.prototype.attrTest.call(this, s) && // replace with a super call
    (this.state & fs || !(this.state & fs) && this.directionTest(s));
  }, r.emit = function(s) {
    this.pX = s.deltaX, this.pY = s.deltaY;
    var a = wH(s.direction);
    a && (s.additionalEvent = this.options.event + a), t.prototype.emit.call(this, s);
  }, e;
}(Ud), TH = /* @__PURE__ */ function(t) {
  _s(e, t);
  function e(n) {
    return n === void 0 && (n = {}), t.call(this, zs({
      event: "swipe",
      threshold: 10,
      velocity: 0.3,
      direction: Ea | Eu,
      pointers: 1
    }, n)) || this;
  }
  var r = e.prototype;
  return r.getTouchAction = function() {
    return oO.prototype.getTouchAction.call(this);
  }, r.attrTest = function(s) {
    var a = this.options.direction, o;
    return a & (Ea | Eu) ? o = s.overallVelocity : a & Ea ? o = s.overallVelocityX : a & Eu && (o = s.overallVelocityY), t.prototype.attrTest.call(this, s) && a & s.offsetDirection && s.distance > this.options.threshold && s.maxPointers === this.options.pointers && Vu(o) > this.options.velocity && s.eventType & en;
  }, r.emit = function(s) {
    var a = wH(s.offsetDirection);
    a && this.manager.emit(this.options.event + a, s), this.manager.emit(this.options.event, s);
  }, e;
}(Ud), xH = /* @__PURE__ */ function(t) {
  _s(e, t);
  function e(n) {
    return n === void 0 && (n = {}), t.call(this, zs({
      event: "pinch",
      threshold: 0,
      pointers: 2
    }, n)) || this;
  }
  var r = e.prototype;
  return r.getTouchAction = function() {
    return [Su];
  }, r.attrTest = function(s) {
    return t.prototype.attrTest.call(this, s) && (Math.abs(s.scale - 1) > this.options.threshold || this.state & fs);
  }, r.emit = function(s) {
    if (s.scale !== 1) {
      var a = s.scale < 1 ? "in" : "out";
      s.additionalEvent = this.options.event + a;
    }
    t.prototype.emit.call(this, s);
  }, e;
}(Ud), SH = /* @__PURE__ */ function(t) {
  _s(e, t);
  function e(n) {
    return n === void 0 && (n = {}), t.call(this, zs({
      event: "rotate",
      threshold: 0,
      pointers: 2
    }, n)) || this;
  }
  var r = e.prototype;
  return r.getTouchAction = function() {
    return [Su];
  }, r.attrTest = function(s) {
    return t.prototype.attrTest.call(this, s) && (Math.abs(s.rotation) > this.options.threshold || this.state & fs);
  }, e;
}(Ud), EH = /* @__PURE__ */ function(t) {
  _s(e, t);
  function e(n) {
    var s;
    return n === void 0 && (n = {}), s = t.call(this, zs({
      event: "press",
      pointers: 1,
      time: 251,
      // minimal time of the pointer to be pressed
      threshold: 9
    }, n)) || this, s._timer = null, s._input = null, s;
  }
  var r = e.prototype;
  return r.getTouchAction = function() {
    return [uH];
  }, r.process = function(s) {
    var a = this, o = this.options, l = s.pointers.length === o.pointers, u = s.distance < o.threshold, c = s.deltaTime > o.time;
    if (this._input = s, !u || !l || s.eventType & (en | $i) && !c)
      this.reset();
    else if (s.eventType & oi)
      this.reset(), this._timer = setTimeout(function() {
        a.state = mo, a.tryEmit();
      }, o.time);
    else if (s.eventType & en)
      return mo;
    return ba;
  }, r.reset = function() {
    clearTimeout(this._timer);
  }, r.emit = function(s) {
    this.state === mo && (s && s.eventType & en ? this.manager.emit(this.options.event + "up", s) : (this._input.timeStamp = tO(), this.manager.emit(this.options.event, this._input)));
  }, e;
}(dv), $H = {
  /**
   * @private
   * set if DOM events are being triggered.
   * But this is slower and unused by simple implementations, so disabled by default.
   * @type {Boolean}
   * @default false
   */
  domEvents: !1,
  /**
   * @private
   * The value for the touchAction property/fallback.
   * When set to `compute` it will magically set the correct value based on the added recognizers.
   * @type {String}
   * @default compute
   */
  touchAction: lH,
  /**
   * @private
   * @type {Boolean}
   * @default true
   */
  enable: !0,
  /**
   * @private
   * EXPERIMENTAL FEATURE -- can be removed/changed
   * Change the parent input target element.
   * If Null, then it is being set the to main element.
   * @type {Null|EventTarget}
   * @default null
   */
  inputTarget: null,
  /**
   * @private
   * force an input class
   * @type {Null|Function}
   * @default null
   */
  inputClass: null,
  /**
   * @private
   * Some CSS properties can be used to improve the working of Hammer.
   * Add them to this method and they will be set when creating a new Manager.
   * @namespace
   */
  cssProps: {
    /**
     * @private
     * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */
    userSelect: "none",
    /**
     * @private
     * Disable the Windows Phone grippers when pressing an element.
     * @type {String}
     * @default 'none'
     */
    touchSelect: "none",
    /**
     * @private
     * Disables the default callout shown when you touch and hold a touch target.
     * On iOS, when you touch and hold a touch target such as a link, Safari displays
     * a callout containing information about the link. This property allows you to disable that callout.
     * @type {String}
     * @default 'none'
     */
    touchCallout: "none",
    /**
     * @private
     * Specifies whether zooming is enabled. Used by IE10>
     * @type {String}
     * @default 'none'
     */
    contentZooming: "none",
    /**
     * @private
     * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */
    userDrag: "none",
    /**
     * @private
     * Overrides the highlight color shown when the user taps a link or a JavaScript
     * clickable element in iOS. This property obeys the alpha value, if specified.
     * @type {String}
     * @default 'rgba(0,0,0,0)'
     */
    tapHighlightColor: "rgba(0,0,0,0)"
  }
}, BM = [[SH, {
  enable: !1
}], [xH, {
  enable: !1
}, ["rotate"]], [TH, {
  direction: Ea
}], [oO, {
  direction: Ea
}, ["swipe"]], [TS], [TS, {
  event: "doubletap",
  taps: 2
}, ["tap"]], [EH]], dTe = 1, UM = 2;
function VM(t, e) {
  var r = t.element;
  if (r.style) {
    var n;
    vo(t.options.cssProps, function(s, a) {
      n = hb(r.style, a), e ? (t.oldCssProps[n] = r.style[n], r.style[n] = s) : r.style[n] = t.oldCssProps[n] || "";
    }), e || (t.oldCssProps = {});
  }
}
function hTe(t, e) {
  var r = document.createEvent("Event");
  r.initEvent(t, !0, !0), r.gesture = e, e.target.dispatchEvent(r);
}
var YM = /* @__PURE__ */ function() {
  function t(r, n) {
    var s = this;
    this.options = Uu({}, $H, n || {}), this.options.inputTarget = this.options.inputTarget || r, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = r, this.input = lTe(this), this.touchAction = new fH(this, this.options.touchAction), VM(this, !0), vo(this.options.recognizers, function(a) {
      var o = s.add(new a[0](a[1]));
      a[2] && o.recognizeWith(a[2]), a[3] && o.requireFailure(a[3]);
    }, this);
  }
  var e = t.prototype;
  return e.set = function(n) {
    return Uu(this.options, n), n.touchAction && this.touchAction.update(), n.inputTarget && (this.input.destroy(), this.input.target = n.inputTarget, this.input.init()), this;
  }, e.stop = function(n) {
    this.session.stopped = n ? UM : dTe;
  }, e.recognize = function(n) {
    var s = this.session;
    if (!s.stopped) {
      this.touchAction.preventDefaults(n);
      var a, o = this.recognizers, l = s.curRecognizer;
      (!l || l && l.state & mo) && (s.curRecognizer = null, l = null);
      for (var u = 0; u < o.length; )
        a = o[u], s.stopped !== UM && // 1
        (!l || a === l || // 2
        a.canRecognizeWith(l)) ? a.recognize(n) : a.reset(), !l && a.state & (fs | Bd | bl) && (s.curRecognizer = a, l = a), u++;
    }
  }, e.get = function(n) {
    if (n instanceof dv)
      return n;
    for (var s = this.recognizers, a = 0; a < s.length; a++)
      if (s[a].options.event === n)
        return s[a];
    return null;
  }, e.add = function(n) {
    if (ad(n, "add", this))
      return this;
    var s = this.get(n.options.event);
    return s && this.remove(s), this.recognizers.push(n), n.manager = this, this.touchAction.update(), n;
  }, e.remove = function(n) {
    if (ad(n, "remove", this))
      return this;
    var s = this.get(n);
    if (n) {
      var a = this.recognizers, o = Yu(a, s);
      o !== -1 && (a.splice(o, 1), this.touchAction.update());
    }
    return this;
  }, e.on = function(n, s) {
    if (n === void 0 || s === void 0)
      return this;
    var a = this.handlers;
    return vo(cp(n), function(o) {
      a[o] = a[o] || [], a[o].push(s);
    }), this;
  }, e.off = function(n, s) {
    if (n === void 0)
      return this;
    var a = this.handlers;
    return vo(cp(n), function(o) {
      s ? a[o] && a[o].splice(Yu(a[o], s), 1) : delete a[o];
    }), this;
  }, e.emit = function(n, s) {
    this.options.domEvents && hTe(n, s);
    var a = this.handlers[n] && this.handlers[n].slice();
    if (!(!a || !a.length)) {
      s.type = n, s.preventDefault = function() {
        s.srcEvent.preventDefault();
      };
      for (var o = 0; o < a.length; )
        a[o](s), o++;
    }
  }, e.destroy = function() {
    this.element && VM(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
  }, t;
}(), fTe = {
  touchstart: oi,
  touchmove: dc,
  touchend: en,
  touchcancel: $i
}, pTe = "touchstart", vTe = "touchstart touchmove touchend touchcancel", mTe = /* @__PURE__ */ function(t) {
  _s(e, t);
  function e() {
    var n, s = e.prototype;
    return s.evTarget = pTe, s.evWin = vTe, n = t.apply(this, arguments) || this, n.started = !1, n;
  }
  var r = e.prototype;
  return r.handler = function(s) {
    var a = fTe[s.type];
    if (a === oi && (this.started = !0), !!this.started) {
      var o = gTe.call(this, s, a);
      a & (en | $i) && o[0].length - o[1].length === 0 && (this.started = !1), this.callback(this.manager, a, {
        pointers: o[0],
        changedPointers: o[1],
        pointerType: ov,
        srcEvent: s
      });
    }
  }, e;
}(bh);
function gTe(t, e) {
  var r = dp(t.touches), n = dp(t.changedTouches);
  return e & (en | $i) && (r = iO(r.concat(n), "identifier", !0)), [r, n];
}
function kH(t, e, r) {
  var n = "DEPRECATED METHOD: " + e + `
` + r + ` AT 
`;
  return function() {
    var s = new Error("get-stack-trace"), a = s && s.stack ? s.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace", o = window.console && (window.console.warn || window.console.log);
    return o && o.call(window.console, n, a), t.apply(this, arguments);
  };
}
var DH = kH(function(t, e, r) {
  for (var n = Object.keys(e), s = 0; s < n.length; )
    (!r || r && t[n[s]] === void 0) && (t[n[s]] = e[n[s]]), s++;
  return t;
}, "extend", "Use `assign`."), yTe = kH(function(t, e) {
  return DH(t, e, !0);
}, "merge", "Use `assign`.");
function bTe(t, e, r) {
  var n = e.prototype, s;
  s = t.prototype = Object.create(n), s.constructor = t, s._super = n, r && Uu(s, r);
}
function HM(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
var _Te = /* @__PURE__ */ function() {
  var t = (
    /**
      * @private
      * @const {string}
      */
    function(r, n) {
      return n === void 0 && (n = {}), new YM(r, zs({
        recognizers: BM.concat()
      }, n));
    }
  );
  return t.VERSION = "2.0.17-rc", t.DIRECTION_ALL = dH, t.DIRECTION_DOWN = Fd, t.DIRECTION_LEFT = lv, t.DIRECTION_RIGHT = uv, t.DIRECTION_UP = cv, t.DIRECTION_HORIZONTAL = Ea, t.DIRECTION_VERTICAL = Eu, t.DIRECTION_NONE = Sy, t.DIRECTION_DOWN = Fd, t.INPUT_START = oi, t.INPUT_MOVE = dc, t.INPUT_END = en, t.INPUT_CANCEL = $i, t.STATE_POSSIBLE = Cg, t.STATE_BEGAN = fs, t.STATE_CHANGED = Bd, t.STATE_ENDED = bl, t.STATE_RECOGNIZED = mo, t.STATE_CANCELLED = hp, t.STATE_FAILED = ba, t.Manager = YM, t.Input = bh, t.TouchAction = fH, t.TouchInput = sO, t.MouseInput = aO, t.PointerEventInput = bH, t.TouchMouseInput = _H, t.SingleTouchInput = mTe, t.Recognizer = dv, t.AttrRecognizer = Ud, t.Tap = TS, t.Pan = oO, t.Swipe = TH, t.Pinch = xH, t.Rotate = SH, t.Press = EH, t.on = Of, t.off = Af, t.each = vo, t.merge = yTe, t.extend = DH, t.bindFn = HM, t.assign = Uu, t.inherit = bTe, t.bindFn = HM, t.prefixed = hb, t.toArray = dp, t.inArray = Yu, t.uniqueArray = iO, t.splitStr = cp, t.boolOrFn = fb, t.hasParent = nO, t.addEventListeners = Of, t.removeEventListeners = Af, t.defaults = Uu({}, $H, {
    preset: BM
  }), t;
}(), wTe = _Te;
function OH(t, e) {
  var r = typeof sv < "u" && yh(t) || t["@@iterator"];
  if (!r) {
    if (Qn(t) || (r = TTe(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, s = function() {
      };
      return { s, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(c) {
        throw c;
      }, f: s };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return { s: function() {
    r = r.call(t);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    o = !0, l = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (o)
        throw l;
    }
  } };
}
function TTe(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return GM(t, e);
    var n = av(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return cb(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return GM(t, e);
  }
}
function GM(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
var AH = sv("DELETE");
function xTe(t) {
  for (var e, r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
    n[s - 1] = arguments[s];
  return CH.apply(void 0, db(e = [{}, t]).call(e, n));
}
function CH() {
  var t = ky.apply(void 0, arguments);
  return PH(t), t;
}
function ky() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  if (e.length < 2)
    return e[0];
  if (e.length > 2) {
    var n;
    return ky.apply(void 0, db(n = [CH(e[0], e[1])]).call(n, Jn(av(e).call(e, 2))));
  }
  var s = e[0], a = e[1], o = OH(B4(a)), l;
  try {
    for (o.s(); !(l = o.n()).done; ) {
      var u = l.value;
      Object.prototype.propertyIsEnumerable.call(a, u) && (a[u] === AH ? delete s[u] : s[u] !== null && a[u] !== null && Rn(s[u]) === "object" && Rn(a[u]) === "object" && !Qn(s[u]) && !Qn(a[u]) ? s[u] = ky(s[u], a[u]) : s[u] = IH(a[u]));
    }
  } catch (c) {
    o.e(c);
  } finally {
    o.f();
  }
  return s;
}
function IH(t) {
  return Qn(t) ? Ni(t).call(t, function(e) {
    return IH(e);
  }) : Rn(t) === "object" && t !== null ? ky({}, t) : t;
}
function PH(t) {
  for (var e = 0, r = JD(t); e < r.length; e++) {
    var n = r[e];
    t[n] === AH ? delete t[n] : Rn(t[n]) === "object" && t[n] !== null && PH(t[n]);
  }
}
function STe() {
  var t = function() {
  };
  return {
    on: t,
    off: t,
    destroy: t,
    emit: t,
    get: function() {
      return {
        set: t
      };
    }
  };
}
var ETe = typeof window < "u" ? window.Hammer || wTe : function() {
  return STe();
};
function oo(t) {
  var e = this, r;
  this._cleanupQueue = [], this.active = !1, this._dom = {
    container: t,
    overlay: document.createElement("div")
  }, this._dom.overlay.classList.add("vis-overlay"), this._dom.container.appendChild(this._dom.overlay), this._cleanupQueue.push(function() {
    e._dom.overlay.parentNode.removeChild(e._dom.overlay);
  });
  var n = ETe(this._dom.overlay);
  n.on("tap", xu(r = this._onTapOverlay).call(r, this)), this._cleanupQueue.push(function() {
    n.destroy();
  });
  var s = ["tap", "doubletap", "press", "pinch", "pan", "panstart", "panmove", "panend"];
  Dl(s).call(s, function(a) {
    n.on(a, function(o) {
      o.srcEvent.stopPropagation();
    });
  }), document && document.body && (this._onClick = function(a) {
    $Te(a.target, t) || e.deactivate();
  }, document.body.addEventListener("click", this._onClick), this._cleanupQueue.push(function() {
    document.body.removeEventListener("click", e._onClick);
  })), this._escListener = function(a) {
    ("key" in a ? a.key === "Escape" : a.keyCode === 27) && e.deactivate();
  };
}
Rwe(oo.prototype);
oo.current = null;
oo.prototype.destroy = function() {
  var t, e;
  this.deactivate();
  var r = OH(abe(t = W4(e = this._cleanupQueue).call(e, 0)).call(t)), n;
  try {
    for (r.s(); !(n = r.n()).done; ) {
      var s = n.value;
      s();
    }
  } catch (a) {
    r.e(a);
  } finally {
    r.f();
  }
};
oo.prototype.activate = function() {
  oo.current && oo.current.deactivate(), oo.current = this, this.active = !0, this._dom.overlay.style.display = "none", this._dom.container.classList.add("vis-active"), this.emit("change"), this.emit("activate"), document.body.addEventListener("keydown", this._escListener);
};
oo.prototype.deactivate = function() {
  this.active = !1, this._dom.overlay.style.display = "block", this._dom.container.classList.remove("vis-active"), document.body.removeEventListener("keydown", this._escListener), this.emit("change"), this.emit("deactivate");
};
oo.prototype._onTapOverlay = function(t) {
  this.activate(), t.srcEvent.stopPropagation();
};
function $Te(t, e) {
  for (; t; ) {
    if (t === e)
      return !0;
    t = t.parentNode;
  }
  return !1;
}
var xS = {}, kTe = {
  get exports() {
    return xS;
  },
  set exports(t) {
    xS = t;
  }
}, DTe = J0, OTe = hh, ATe = TypeError, RH = function(t) {
  if (DTe(t))
    return t;
  throw ATe(OTe(t) + " is not a constructor");
}, CTe = qe, ITe = ui, B1 = uh, PTe = y4, WM = RH, RTe = Xi, jM = En, MTe = lc, MH = Wt, lO = ITe("Reflect", "construct"), LTe = Object.prototype, NTe = [].push, LH = MH(function() {
  function t() {
  }
  return !(lO(function() {
  }, [], t) instanceof t);
}), NH = !MH(function() {
  lO(function() {
  });
}), KM = LH || NH;
CTe({ target: "Reflect", stat: !0, forced: KM, sham: KM }, {
  construct: function(e, r) {
    WM(e), RTe(r);
    var n = arguments.length < 3 ? e : WM(arguments[2]);
    if (NH && !LH)
      return lO(e, r, n);
    if (e == n) {
      switch (r.length) {
        case 0:
          return new e();
        case 1:
          return new e(r[0]);
        case 2:
          return new e(r[0], r[1]);
        case 3:
          return new e(r[0], r[1], r[2]);
        case 4:
          return new e(r[0], r[1], r[2], r[3]);
      }
      var s = [null];
      return B1(NTe, s, r), new (B1(PTe, e, s))();
    }
    var a = n.prototype, o = MTe(jM(a) ? a : LTe), l = B1(e, o, r);
    return jM(l) ? l : o;
  }
});
var FTe = vr, BTe = FTe.Reflect.construct, UTe = BTe, VTe = UTe;
(function(t) {
  t.exports = VTe;
})(kTe);
var _l = /* @__PURE__ */ ft(xS);
function Fi(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
var Dy = {}, YTe = {
  get exports() {
    return Dy;
  },
  set exports(t) {
    Dy = t;
  }
}, SS = {}, HTe = {
  get exports() {
    return SS;
  },
  set exports(t) {
    SS = t;
  }
}, GTe = eH, WTe = GTe, jTe = WTe, KTe = jTe;
(function(t) {
  t.exports = KTe;
})(HTe);
(function(t) {
  t.exports = SS;
})(YTe);
var zTe = /* @__PURE__ */ ft(Dy), Oy = {}, qTe = {
  get exports() {
    return Oy;
  },
  set exports(t) {
    Oy = t;
  }
}, ES = {}, XTe = {
  get exports() {
    return ES;
  },
  set exports(t) {
    ES = t;
  }
}, QTe = qe, ZTe = s4;
QTe({ target: "Object", stat: !0 }, {
  setPrototypeOf: ZTe
});
var JTe = vr, exe = JTe.Object.setPrototypeOf, txe = exe, rxe = txe, nxe = rxe, ixe = nxe, sxe = ixe, axe = sxe;
(function(t) {
  t.exports = axe;
})(XTe);
(function(t) {
  t.exports = ES;
})(qTe);
var $S = /* @__PURE__ */ ft(Oy), kS = {}, oxe = {
  get exports() {
    return kS;
  },
  set exports(t) {
    kS = t;
  }
}, DS = {}, lxe = {
  get exports() {
    return DS;
  },
  set exports(t) {
    DS = t;
  }
}, uxe = b4, cxe = uxe, dxe = cxe, hxe = dxe;
(function(t) {
  t.exports = hxe;
})(lxe);
(function(t) {
  t.exports = DS;
})(oxe);
var FH = /* @__PURE__ */ ft(kS);
function OS(t, e) {
  var r;
  return OS = $S ? FH(r = $S).call(r) : function(s, a) {
    return s.__proto__ = a, s;
  }, OS(t, e);
}
function BH(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = zTe(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Q0(t, "prototype", {
    writable: !1
  }), e && OS(t, e);
}
function UH(t, e) {
  if (e && (Rn(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Fi(t);
}
var Ay = {}, fxe = {
  get exports() {
    return Ay;
  },
  set exports(t) {
    Ay = t;
  }
}, AS = {}, pxe = {
  get exports() {
    return AS;
  },
  set exports(t) {
    AS = t;
  }
}, vxe = z4, mxe = vxe, gxe = mxe, yxe = gxe;
(function(t) {
  t.exports = yxe;
})(pxe);
(function(t) {
  t.exports = AS;
})(fxe);
var zM = /* @__PURE__ */ ft(Ay);
function Vd(t) {
  var e;
  return Vd = $S ? FH(e = zM).call(e) : function(n) {
    return n.__proto__ || zM(n);
  }, Vd(t);
}
var CS = {}, bxe = {
  get exports() {
    return CS;
  },
  set exports(t) {
    CS = t;
  }
}, IS = {}, _xe = {
  get exports() {
    return IS;
  },
  set exports(t) {
    IS = t;
  }
};
(function(t) {
  var e = ip, r = Ty;
  function n(s) {
    "@babel/helpers - typeof";
    return t.exports = n = typeof e == "function" && typeof r == "symbol" ? function(a) {
      return typeof a;
    } : function(a) {
      return a && typeof e == "function" && a.constructor === e && a !== e.prototype ? "symbol" : typeof a;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, n(s);
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})(_xe);
var PS = {}, wxe = {
  get exports() {
    return PS;
  },
  set exports(t) {
    PS = t;
  }
}, RS = {}, Txe = {
  get exports() {
    return RS;
  },
  set exports(t) {
    RS = t;
  }
}, xxe = Y4, Sxe = xxe, Exe = Sxe, $xe = Exe;
(function(t) {
  t.exports = $xe;
})(Txe);
(function(t) {
  t.exports = RS;
})(wxe);
var MS = {}, kxe = {
  get exports() {
    return MS;
  },
  set exports(t) {
    MS = t;
  }
}, LS = {}, Dxe = {
  get exports() {
    return LS;
  },
  set exports(t) {
    LS = t;
  }
}, qM = rn, Oxe = ZD, Axe = ac, Cxe = qi, Ixe = function(t, e, r) {
  for (var n = Oxe(e), s = Cxe.f, a = Axe.f, o = 0; o < n.length; o++) {
    var l = n[o];
    !qM(t, l) && !(r && qM(r, l)) && s(t, l, a(e, l));
  }
}, Pxe = En, Rxe = Lo, Mxe = function(t, e) {
  Pxe(e) && "cause" in e && Rxe(t, "cause", e.cause);
}, Lxe = zt, VH = Error, Nxe = Lxe("".replace), Fxe = function(t) {
  return String(VH(t).stack);
}("zxcasd"), YH = /\n\s*at [^:]*:[^\n]*/, Bxe = YH.test(Fxe), Uxe = function(t, e) {
  if (Bxe && typeof t == "string" && !VH.prepareStackTrace)
    for (; e--; )
      t = Nxe(t, YH, "");
  return t;
}, Vxe = Wt, Yxe = oc, Hxe = !Vxe(function() {
  var t = Error("a");
  return "stack" in t ? (Object.defineProperty(t, "stack", Yxe(1, 7)), t.stack !== 7) : !0;
}), Gxe = Lo, Wxe = Uxe, jxe = Hxe, XM = Error.captureStackTrace, Kxe = function(t, e, r, n) {
  jxe && (XM ? XM(t, e) : Gxe(t, "stack", Wxe(r, n)));
}, zxe = Ml, qxe = Sn, Xxe = Xi, Qxe = hh, Zxe = x4, Jxe = Qi, QM = Ar, eSe = QD, tSe = ub, ZM = T4, rSe = TypeError, Ig = function(t, e) {
  this.stopped = t, this.result = e;
}, JM = Ig.prototype, hc = function(t, e, r) {
  var n = r && r.that, s = !!(r && r.AS_ENTRIES), a = !!(r && r.IS_RECORD), o = !!(r && r.IS_ITERATOR), l = !!(r && r.INTERRUPTED), u = zxe(e, n), c, d, h, f, p, m, b, y = function(x) {
    return c && ZM(c, "normal", x), new Ig(!0, x);
  }, _ = function(x) {
    return s ? (Xxe(x), l ? u(x[0], x[1], y) : u(x[0], x[1])) : l ? u(x, y) : u(x);
  };
  if (a)
    c = t.iterator;
  else if (o)
    c = t;
  else {
    if (d = tSe(t), !d)
      throw rSe(Qxe(t) + " is not iterable");
    if (Zxe(d)) {
      for (h = 0, f = Jxe(t); f > h; h++)
        if (p = _(t[h]), p && QM(JM, p))
          return p;
      return new Ig(!1);
    }
    c = eSe(t, d);
  }
  for (m = a ? t.next : c.next; !(b = qxe(m, c)).done; ) {
    try {
      p = _(b.value);
    } catch (x) {
      ZM(c, "throw", x);
    }
    if (typeof p == "object" && p && QM(JM, p))
      return p;
  }
  return new Ig(!1);
}, nSe = Ua, iSe = function(t, e) {
  return t === void 0 ? arguments.length < 2 ? "" : e : nSe(t);
}, sSe = qe, aSe = Ar, oSe = lb, Cy = s4, lSe = Ixe, HH = lc, U1 = Lo, V1 = oc, uSe = Mxe, cSe = Kxe, dSe = hc, hSe = iSe, fSe = Cr, pSe = fSe("toStringTag"), Iy = Error, vSe = [].push, Yd = function(e, r) {
  var n = aSe(Y1, this), s;
  Cy ? s = Cy(Iy(), n ? oSe(this) : Y1) : (s = n ? this : HH(Y1), U1(s, pSe, "Error")), r !== void 0 && U1(s, "message", hSe(r)), cSe(s, Yd, s.stack, 1), arguments.length > 2 && uSe(s, arguments[2]);
  var a = [];
  return dSe(e, vSe, { that: a }), U1(s, "errors", a), s;
};
Cy ? Cy(Yd, Iy) : lSe(Yd, Iy, { name: !0 });
var Y1 = Yd.prototype = HH(Iy.prototype, {
  constructor: V1(1, Yd),
  message: V1(1, ""),
  name: V1(1, "AggregateError")
});
sSe({ global: !0, constructor: !0, arity: 2 }, {
  AggregateError: Yd
});
var mSe = ui, gSe = VD, ySe = Cr, bSe = fn, eL = ySe("species"), GH = function(t) {
  var e = mSe(t);
  bSe && e && !e[eL] && gSe(e, eL, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, _Se = Ar, wSe = TypeError, uO = function(t, e) {
  if (_Se(e, t))
    return t;
  throw wSe("Incorrect invocation");
}, tL = Xi, TSe = RH, xSe = Hp, SSe = Cr, ESe = SSe("species"), WH = function(t, e) {
  var r = tL(t).constructor, n;
  return r === void 0 || xSe(n = tL(r)[ESe]) ? e : TSe(n);
}, $Se = Rl, jH = /(?:ipad|iphone|ipod).*applewebkit/i.test($Se), Gi = Hr, kSe = uh, DSe = Ml, rL = Gr, OSe = rn, KH = Wt, nL = EY, ASe = tv, iL = RD, CSe = tH, ISe = jH, PSe = iv, NS = Gi.setImmediate, FS = Gi.clearImmediate, RSe = Gi.process, H1 = Gi.Dispatch, MSe = Gi.Function, sL = Gi.MessageChannel, LSe = Gi.String, G1 = 0, Cf = {}, aL = "onreadystatechange", fp, Xl, W1, j1;
KH(function() {
  fp = Gi.location;
});
var cO = function(t) {
  if (OSe(Cf, t)) {
    var e = Cf[t];
    delete Cf[t], e();
  }
}, K1 = function(t) {
  return function() {
    cO(t);
  };
}, oL = function(t) {
  cO(t.data);
}, lL = function(t) {
  Gi.postMessage(LSe(t), fp.protocol + "//" + fp.host);
};
(!NS || !FS) && (NS = function(e) {
  CSe(arguments.length, 1);
  var r = rL(e) ? e : MSe(e), n = ASe(arguments, 1);
  return Cf[++G1] = function() {
    kSe(r, void 0, n);
  }, Xl(G1), G1;
}, FS = function(e) {
  delete Cf[e];
}, PSe ? Xl = function(t) {
  RSe.nextTick(K1(t));
} : H1 && H1.now ? Xl = function(t) {
  H1.now(K1(t));
} : sL && !ISe ? (W1 = new sL(), j1 = W1.port2, W1.port1.onmessage = oL, Xl = DSe(j1.postMessage, j1)) : Gi.addEventListener && rL(Gi.postMessage) && !Gi.importScripts && fp && fp.protocol !== "file:" && !KH(lL) ? (Xl = lL, Gi.addEventListener("message", oL, !1)) : aL in iL("script") ? Xl = function(t) {
  nL.appendChild(iL("script"))[aL] = function() {
    nL.removeChild(this), cO(t);
  };
} : Xl = function(t) {
  setTimeout(K1(t), 0);
});
var zH = {
  set: NS,
  clear: FS
}, qH = function() {
  this.head = null, this.tail = null;
};
qH.prototype = {
  add: function(t) {
    var e = { item: t, next: null }, r = this.tail;
    r ? r.next = e : this.head = e, this.tail = e;
  },
  get: function() {
    var t = this.head;
    if (t) {
      var e = this.head = t.next;
      return e === null && (this.tail = null), t.item;
    }
  }
};
var XH = qH, NSe = Rl, FSe = /ipad|iphone|ipod/i.test(NSe) && typeof Pebble < "u", BSe = Rl, USe = /web0s(?!.*chrome)/i.test(BSe), Hu = Hr, uL = Ml, VSe = ac.f, z1 = zH.set, YSe = XH, HSe = jH, GSe = FSe, WSe = USe, q1 = iv, cL = Hu.MutationObserver || Hu.WebKitMutationObserver, dL = Hu.document, hL = Hu.process, Gm = Hu.Promise, fL = VSe(Hu, "queueMicrotask"), BS = fL && fL.value, Fc, X1, Q1, Wm, pL;
if (!BS) {
  var jm = new YSe(), Km = function() {
    var t, e;
    for (q1 && (t = hL.domain) && t.exit(); e = jm.get(); )
      try {
        e();
      } catch (r) {
        throw jm.head && Fc(), r;
      }
    t && t.enter();
  };
  !HSe && !q1 && !WSe && cL && dL ? (X1 = !0, Q1 = dL.createTextNode(""), new cL(Km).observe(Q1, { characterData: !0 }), Fc = function() {
    Q1.data = X1 = !X1;
  }) : !GSe && Gm && Gm.resolve ? (Wm = Gm.resolve(void 0), Wm.constructor = Gm, pL = uL(Wm.then, Wm), Fc = function() {
    pL(Km);
  }) : q1 ? Fc = function() {
    hL.nextTick(Km);
  } : (z1 = uL(z1, Hu), Fc = function() {
    z1(Km);
  }), BS = function(t) {
    jm.head || Fc(), jm.add(t);
  };
}
var jSe = BS, KSe = function(t, e) {
  try {
    arguments.length == 1 ? console.error(t) : console.error(t, e);
  } catch {
  }
}, _h = function(t) {
  try {
    return { error: !1, value: t() };
  } catch (e) {
    return { error: !0, value: e };
  }
}, zSe = Hr, wh = zSe.Promise, QH = typeof Deno == "object" && Deno && typeof Deno.version == "object", qSe = QH, XSe = iv, QSe = !qSe && !XSe && typeof window == "object" && typeof document == "object", ZSe = Hr, If = wh, JSe = Gr, eEe = fY, tEe = yY, rEe = Cr, nEe = QSe, iEe = QH, Z1 = ch, vL = If && If.prototype, sEe = rEe("species"), US = !1, ZH = JSe(ZSe.PromiseRejectionEvent), aEe = eEe("Promise", function() {
  var t = tEe(If), e = t !== String(If);
  if (!e && Z1 === 66 || !(vL.catch && vL.finally))
    return !0;
  if (!Z1 || Z1 < 51 || !/native code/.test(t)) {
    var r = new If(function(a) {
      a(1);
    }), n = function(a) {
      a(function() {
      }, function() {
      });
    }, s = r.constructor = {};
    if (s[sEe] = n, US = r.then(function() {
    }) instanceof n, !US)
      return !0;
  }
  return !e && (nEe || iEe) && !ZH;
}), hv = {
  CONSTRUCTOR: aEe,
  REJECTION_EVENT: ZH,
  SUBCLASSING: US
}, Fo = {}, mL = Ai, oEe = TypeError, lEe = function(t) {
  var e, r;
  this.promise = new t(function(n, s) {
    if (e !== void 0 || r !== void 0)
      throw oEe("Bad Promise constructor");
    e = n, r = s;
  }), this.resolve = mL(e), this.reject = mL(r);
};
Fo.f = function(t) {
  return new lEe(t);
};
var uEe = qe, Py = iv, Ol = Hr, fv = Sn, cEe = ph, dEe = uc, hEe = GH, fEe = Ai, VS = Gr, pEe = En, vEe = uO, mEe = WH, JH = zH.set, dO = jSe, gEe = KSe, yEe = _h, bEe = XH, e6 = vh, YS = wh, t6 = hv, r6 = Fo, pb = "Promise", n6 = t6.CONSTRUCTOR, _Ee = t6.REJECTION_EVENT, J1 = e6.getterFor(pb), wEe = e6.set, TEe = YS && YS.prototype, od = YS, ew = TEe, i6 = Ol.TypeError, HS = Ol.document, hO = Ol.process, GS = r6.f, xEe = GS, SEe = !!(HS && HS.createEvent && Ol.dispatchEvent), s6 = "unhandledrejection", EEe = "rejectionhandled", gL = 0, a6 = 1, $Ee = 2, fO = 1, o6 = 2, zm, yL, kEe, l6 = function(t) {
  var e;
  return pEe(t) && VS(e = t.then) ? e : !1;
}, u6 = function(t, e) {
  var r = e.value, n = e.state == a6, s = n ? t.ok : t.fail, a = t.resolve, o = t.reject, l = t.domain, u, c, d;
  try {
    s ? (n || (e.rejection === o6 && OEe(e), e.rejection = fO), s === !0 ? u = r : (l && l.enter(), u = s(r), l && (l.exit(), d = !0)), u === t.promise ? o(i6("Promise-chain cycle")) : (c = l6(u)) ? fv(c, u, a, o) : a(u)) : o(r);
  } catch (h) {
    l && !d && l.exit(), o(h);
  }
}, c6 = function(t, e) {
  t.notified || (t.notified = !0, dO(function() {
    for (var r = t.reactions, n; n = r.get(); )
      u6(n, t);
    t.notified = !1, e && !t.rejection && DEe(t);
  }));
}, d6 = function(t, e, r) {
  var n, s;
  SEe ? (n = HS.createEvent("Event"), n.promise = e, n.reason = r, n.initEvent(t, !1, !0), Ol.dispatchEvent(n)) : n = { promise: e, reason: r }, !_Ee && (s = Ol["on" + t]) ? s(n) : t === s6 && gEe("Unhandled promise rejection", r);
}, DEe = function(t) {
  fv(JH, Ol, function() {
    var e = t.facade, r = t.value, n = bL(t), s;
    if (n && (s = yEe(function() {
      Py ? hO.emit("unhandledRejection", r, e) : d6(s6, e, r);
    }), t.rejection = Py || bL(t) ? o6 : fO, s.error))
      throw s.value;
  });
}, bL = function(t) {
  return t.rejection !== fO && !t.parent;
}, OEe = function(t) {
  fv(JH, Ol, function() {
    var e = t.facade;
    Py ? hO.emit("rejectionHandled", e) : d6(EEe, e, t.value);
  });
}, ld = function(t, e, r) {
  return function(n) {
    t(e, n, r);
  };
}, $d = function(t, e, r) {
  t.done || (t.done = !0, r && (t = r), t.value = e, t.state = $Ee, c6(t, !0));
}, WS = function(t, e, r) {
  if (!t.done) {
    t.done = !0, r && (t = r);
    try {
      if (t.facade === e)
        throw i6("Promise can't be resolved itself");
      var n = l6(e);
      n ? dO(function() {
        var s = { done: !1 };
        try {
          fv(
            n,
            e,
            ld(WS, s, t),
            ld($d, s, t)
          );
        } catch (a) {
          $d(s, a, t);
        }
      }) : (t.value = e, t.state = a6, c6(t, !1));
    } catch (s) {
      $d({ done: !1 }, s, t);
    }
  }
};
n6 && (od = function(e) {
  vEe(this, ew), fEe(e), fv(zm, this);
  var r = J1(this);
  try {
    e(ld(WS, r), ld($d, r));
  } catch (n) {
    $d(r, n);
  }
}, ew = od.prototype, zm = function(e) {
  wEe(this, {
    type: pb,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new bEe(),
    rejection: !1,
    state: gL,
    value: void 0
  });
}, zm.prototype = cEe(ew, "then", function(e, r) {
  var n = J1(this), s = GS(mEe(this, od));
  return n.parent = !0, s.ok = VS(e) ? e : !0, s.fail = VS(r) && r, s.domain = Py ? hO.domain : void 0, n.state == gL ? n.reactions.add(s) : dO(function() {
    u6(s, n);
  }), s.promise;
}), yL = function() {
  var t = new zm(), e = J1(t);
  this.promise = t, this.resolve = ld(WS, e), this.reject = ld($d, e);
}, r6.f = GS = function(t) {
  return t === od || t === kEe ? new yL(t) : xEe(t);
});
uEe({ global: !0, constructor: !0, wrap: !0, forced: n6 }, {
  Promise: od
});
dEe(od, pb, !1, !0);
hEe(pb);
var AEe = wh, CEe = $4, IEe = hv.CONSTRUCTOR, vb = IEe || !CEe(function(t) {
  AEe.all(t).then(void 0, function() {
  });
}), PEe = qe, REe = Sn, MEe = Ai, LEe = Fo, NEe = _h, FEe = hc, BEe = vb;
PEe({ target: "Promise", stat: !0, forced: BEe }, {
  all: function(e) {
    var r = this, n = LEe.f(r), s = n.resolve, a = n.reject, o = NEe(function() {
      var l = MEe(r.resolve), u = [], c = 0, d = 1;
      FEe(e, function(h) {
        var f = c++, p = !1;
        d++, REe(l, r, h).then(function(m) {
          p || (p = !0, u[f] = m, --d || s(u));
        }, a);
      }), --d || s(u);
    });
    return o.error && a(o.value), n.promise;
  }
});
var UEe = qe, VEe = hv.CONSTRUCTOR, _L = wh;
_L && _L.prototype;
UEe({ target: "Promise", proto: !0, forced: VEe, real: !0 }, {
  catch: function(t) {
    return this.then(void 0, t);
  }
});
var YEe = qe, HEe = Sn, GEe = Ai, WEe = Fo, jEe = _h, KEe = hc, zEe = vb;
YEe({ target: "Promise", stat: !0, forced: zEe }, {
  race: function(e) {
    var r = this, n = WEe.f(r), s = n.reject, a = jEe(function() {
      var o = GEe(r.resolve);
      KEe(e, function(l) {
        HEe(o, r, l).then(n.resolve, s);
      });
    });
    return a.error && s(a.value), n.promise;
  }
});
var qEe = qe, XEe = Sn, QEe = Fo, ZEe = hv.CONSTRUCTOR;
qEe({ target: "Promise", stat: !0, forced: ZEe }, {
  reject: function(e) {
    var r = QEe.f(this);
    return XEe(r.reject, void 0, e), r.promise;
  }
});
var JEe = Xi, e$e = En, t$e = Fo, h6 = function(t, e) {
  if (JEe(t), e$e(e) && e.constructor === t)
    return e;
  var r = t$e.f(t), n = r.resolve;
  return n(e), r.promise;
}, r$e = qe, n$e = ui, i$e = yoe, s$e = wh, a$e = hv.CONSTRUCTOR, o$e = h6, l$e = n$e("Promise"), u$e = !a$e;
r$e({ target: "Promise", stat: !0, forced: i$e }, {
  resolve: function(e) {
    return o$e(u$e && this === l$e ? s$e : this, e);
  }
});
var c$e = qe, d$e = Sn, h$e = Ai, f$e = Fo, p$e = _h, v$e = hc, m$e = vb;
c$e({ target: "Promise", stat: !0, forced: m$e }, {
  allSettled: function(e) {
    var r = this, n = f$e.f(r), s = n.resolve, a = n.reject, o = p$e(function() {
      var l = h$e(r.resolve), u = [], c = 0, d = 1;
      v$e(e, function(h) {
        var f = c++, p = !1;
        d++, d$e(l, r, h).then(function(m) {
          p || (p = !0, u[f] = { status: "fulfilled", value: m }, --d || s(u));
        }, function(m) {
          p || (p = !0, u[f] = { status: "rejected", reason: m }, --d || s(u));
        });
      }), --d || s(u);
    });
    return o.error && a(o.value), n.promise;
  }
});
var g$e = qe, y$e = Sn, b$e = Ai, _$e = ui, w$e = Fo, T$e = _h, x$e = hc, S$e = vb, wL = "No one promise resolved";
g$e({ target: "Promise", stat: !0, forced: S$e }, {
  any: function(e) {
    var r = this, n = _$e("AggregateError"), s = w$e.f(r), a = s.resolve, o = s.reject, l = T$e(function() {
      var u = b$e(r.resolve), c = [], d = 0, h = 1, f = !1;
      x$e(e, function(p) {
        var m = d++, b = !1;
        h++, y$e(u, r, p).then(function(y) {
          b || f || (f = !0, a(y));
        }, function(y) {
          b || f || (b = !0, c[m] = y, --h || o(new n(c, wL)));
        });
      }), --h || o(new n(c, wL));
    });
    return l.error && o(l.value), s.promise;
  }
});
var E$e = qe, jS = wh, $$e = Wt, k$e = ui, D$e = Gr, O$e = WH, TL = h6, A$e = jS && jS.prototype, C$e = !!jS && $$e(function() {
  A$e.finally.call({ then: function() {
  } }, function() {
  });
});
E$e({ target: "Promise", proto: !0, real: !0, forced: C$e }, {
  finally: function(t) {
    var e = O$e(this, k$e("Promise")), r = D$e(t);
    return this.then(
      r ? function(n) {
        return TL(e, t()).then(function() {
          return n;
        });
      } : t,
      r ? function(n) {
        return TL(e, t()).then(function() {
          throw n;
        });
      } : t
    );
  }
});
var I$e = vr, P$e = I$e.Promise, R$e = P$e, M$e = R$e, L$e = M$e, N$e = L$e, F$e = qe, B$e = Fo, U$e = _h;
F$e({ target: "Promise", stat: !0, forced: !0 }, {
  try: function(t) {
    var e = B$e.f(this), r = U$e(t);
    return (r.error ? e.reject : e.resolve)(r.value), e.promise;
  }
});
var V$e = N$e, Y$e = V$e;
(function(t) {
  t.exports = Y$e;
})(Dxe);
(function(t) {
  t.exports = LS;
})(kxe);
var KS = {}, H$e = {
  get exports() {
    return KS;
  },
  set exports(t) {
    KS = t;
  }
}, zS = {}, G$e = {
  get exports() {
    return zS;
  },
  set exports(t) {
    zS = t;
  }
}, W$e = H4, j$e = W$e, K$e = j$e, z$e = K$e;
(function(t) {
  t.exports = z$e;
})(G$e);
(function(t) {
  t.exports = zS;
})(H$e);
(function(t) {
  var e = IS.default, r = gy, n = ip, s = Dy, a = Ay, o = PS, l = Oy, u = MS, c = KS, d = xy;
  function h() {
    t.exports = h = function() {
      return f;
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
    var f = {}, p = Object.prototype, m = p.hasOwnProperty, b = r || function(q, Y, se) {
      q[Y] = se.value;
    }, y = typeof n == "function" ? n : {}, _ = y.iterator || "@@iterator", x = y.asyncIterator || "@@asyncIterator", T = y.toStringTag || "@@toStringTag";
    function k(q, Y, se) {
      return r(q, Y, {
        value: se,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), q[Y];
    }
    try {
      k({}, "");
    } catch {
      k = function(se, he, fe) {
        return se[he] = fe;
      };
    }
    function E(q, Y, se, he) {
      var fe = Y && Y.prototype instanceof $ ? Y : $, Te = s(fe.prototype), ee = new Z(he || []);
      return b(Te, "_invoke", {
        value: H(q, se, ee)
      }), Te;
    }
    function F(q, Y, se) {
      try {
        return {
          type: "normal",
          arg: q.call(Y, se)
        };
      } catch (he) {
        return {
          type: "throw",
          arg: he
        };
      }
    }
    f.wrap = E;
    var R = {};
    function $() {
    }
    function O() {
    }
    function P() {
    }
    var N = {};
    k(N, _, function() {
      return this;
    });
    var I = a, B = I && I(I(U([])));
    B && B !== p && m.call(B, _) && (N = B);
    var W = P.prototype = $.prototype = s(N);
    function Q(q) {
      var Y;
      o(Y = ["next", "throw", "return"]).call(Y, function(se) {
        k(q, se, function(he) {
          return this._invoke(se, he);
        });
      });
    }
    function te(q, Y) {
      function se(fe, Te, ee, Oe) {
        var ut = F(q[fe], q, Te);
        if (ut.type !== "throw") {
          var L = ut.arg, K = L.value;
          return K && e(K) == "object" && m.call(K, "__await") ? Y.resolve(K.__await).then(function(ie) {
            se("next", ie, ee, Oe);
          }, function(ie) {
            se("throw", ie, ee, Oe);
          }) : Y.resolve(K).then(function(ie) {
            L.value = ie, ee(L);
          }, function(ie) {
            return se("throw", ie, ee, Oe);
          });
        }
        Oe(ut.arg);
      }
      var he;
      b(this, "_invoke", {
        value: function(Te, ee) {
          function Oe() {
            return new Y(function(ut, L) {
              se(Te, ee, ut, L);
            });
          }
          return he = he ? he.then(Oe, Oe) : Oe();
        }
      });
    }
    function H(q, Y, se) {
      var he = "suspendedStart";
      return function(fe, Te) {
        if (he === "executing")
          throw new Error("Generator is already running");
        if (he === "completed") {
          if (fe === "throw")
            throw Te;
          return pe();
        }
        for (se.method = fe, se.arg = Te; ; ) {
          var ee = se.delegate;
          if (ee) {
            var Oe = A(ee, se);
            if (Oe) {
              if (Oe === R)
                continue;
              return Oe;
            }
          }
          if (se.method === "next")
            se.sent = se._sent = se.arg;
          else if (se.method === "throw") {
            if (he === "suspendedStart")
              throw he = "completed", se.arg;
            se.dispatchException(se.arg);
          } else
            se.method === "return" && se.abrupt("return", se.arg);
          he = "executing";
          var ut = F(q, Y, se);
          if (ut.type === "normal") {
            if (he = se.done ? "completed" : "suspendedYield", ut.arg === R)
              continue;
            return {
              value: ut.arg,
              done: se.done
            };
          }
          ut.type === "throw" && (he = "completed", se.method = "throw", se.arg = ut.arg);
        }
      };
    }
    function A(q, Y) {
      var se = Y.method, he = q.iterator[se];
      if (he === void 0)
        return Y.delegate = null, se === "throw" && q.iterator.return && (Y.method = "return", Y.arg = void 0, A(q, Y), Y.method === "throw") || se !== "return" && (Y.method = "throw", Y.arg = new TypeError("The iterator does not provide a '" + se + "' method")), R;
      var fe = F(he, q.iterator, Y.arg);
      if (fe.type === "throw")
        return Y.method = "throw", Y.arg = fe.arg, Y.delegate = null, R;
      var Te = fe.arg;
      return Te ? Te.done ? (Y[q.resultName] = Te.value, Y.next = q.nextLoc, Y.method !== "return" && (Y.method = "next", Y.arg = void 0), Y.delegate = null, R) : Te : (Y.method = "throw", Y.arg = new TypeError("iterator result is not an object"), Y.delegate = null, R);
    }
    function V(q) {
      var Y = {
        tryLoc: q[0]
      };
      1 in q && (Y.catchLoc = q[1]), 2 in q && (Y.finallyLoc = q[2], Y.afterLoc = q[3]), this.tryEntries.push(Y);
    }
    function M(q) {
      var Y = q.completion || {};
      Y.type = "normal", delete Y.arg, q.completion = Y;
    }
    function Z(q) {
      this.tryEntries = [{
        tryLoc: "root"
      }], o(q).call(q, V, this), this.reset(!0);
    }
    function U(q) {
      if (q) {
        var Y = q[_];
        if (Y)
          return Y.call(q);
        if (typeof q.next == "function")
          return q;
        if (!isNaN(q.length)) {
          var se = -1, he = function fe() {
            for (; ++se < q.length; )
              if (m.call(q, se))
                return fe.value = q[se], fe.done = !1, fe;
            return fe.value = void 0, fe.done = !0, fe;
          };
          return he.next = he;
        }
      }
      return {
        next: pe
      };
    }
    function pe() {
      return {
        value: void 0,
        done: !0
      };
    }
    return O.prototype = P, b(W, "constructor", {
      value: P,
      configurable: !0
    }), b(P, "constructor", {
      value: O,
      configurable: !0
    }), O.displayName = k(P, T, "GeneratorFunction"), f.isGeneratorFunction = function(q) {
      var Y = typeof q == "function" && q.constructor;
      return !!Y && (Y === O || (Y.displayName || Y.name) === "GeneratorFunction");
    }, f.mark = function(q) {
      return l ? l(q, P) : (q.__proto__ = P, k(q, T, "GeneratorFunction")), q.prototype = s(W), q;
    }, f.awrap = function(q) {
      return {
        __await: q
      };
    }, Q(te.prototype), k(te.prototype, x, function() {
      return this;
    }), f.AsyncIterator = te, f.async = function(q, Y, se, he, fe) {
      fe === void 0 && (fe = u);
      var Te = new te(E(q, Y, se, he), fe);
      return f.isGeneratorFunction(Y) ? Te : Te.next().then(function(ee) {
        return ee.done ? ee.value : Te.next();
      });
    }, Q(W), k(W, T, "Generator"), k(W, _, function() {
      return this;
    }), k(W, "toString", function() {
      return "[object Generator]";
    }), f.keys = function(q) {
      var Y = Object(q), se = [];
      for (var he in Y)
        se.push(he);
      return c(se).call(se), function fe() {
        for (; se.length; ) {
          var Te = se.pop();
          if (Te in Y)
            return fe.value = Te, fe.done = !1, fe;
        }
        return fe.done = !0, fe;
      };
    }, f.values = U, Z.prototype = {
      constructor: Z,
      reset: function(Y) {
        var se;
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, o(se = this.tryEntries).call(se, M), !Y)
          for (var he in this)
            he.charAt(0) === "t" && m.call(this, he) && !isNaN(+d(he).call(he, 1)) && (this[he] = void 0);
      },
      stop: function() {
        this.done = !0;
        var Y = this.tryEntries[0].completion;
        if (Y.type === "throw")
          throw Y.arg;
        return this.rval;
      },
      dispatchException: function(Y) {
        if (this.done)
          throw Y;
        var se = this;
        function he(L, K) {
          return ee.type = "throw", ee.arg = Y, se.next = L, K && (se.method = "next", se.arg = void 0), !!K;
        }
        for (var fe = this.tryEntries.length - 1; fe >= 0; --fe) {
          var Te = this.tryEntries[fe], ee = Te.completion;
          if (Te.tryLoc === "root")
            return he("end");
          if (Te.tryLoc <= this.prev) {
            var Oe = m.call(Te, "catchLoc"), ut = m.call(Te, "finallyLoc");
            if (Oe && ut) {
              if (this.prev < Te.catchLoc)
                return he(Te.catchLoc, !0);
              if (this.prev < Te.finallyLoc)
                return he(Te.finallyLoc);
            } else if (Oe) {
              if (this.prev < Te.catchLoc)
                return he(Te.catchLoc, !0);
            } else {
              if (!ut)
                throw new Error("try statement without catch or finally");
              if (this.prev < Te.finallyLoc)
                return he(Te.finallyLoc);
            }
          }
        }
      },
      abrupt: function(Y, se) {
        for (var he = this.tryEntries.length - 1; he >= 0; --he) {
          var fe = this.tryEntries[he];
          if (fe.tryLoc <= this.prev && m.call(fe, "finallyLoc") && this.prev < fe.finallyLoc) {
            var Te = fe;
            break;
          }
        }
        Te && (Y === "break" || Y === "continue") && Te.tryLoc <= se && se <= Te.finallyLoc && (Te = null);
        var ee = Te ? Te.completion : {};
        return ee.type = Y, ee.arg = se, Te ? (this.method = "next", this.next = Te.finallyLoc, R) : this.complete(ee);
      },
      complete: function(Y, se) {
        if (Y.type === "throw")
          throw Y.arg;
        return Y.type === "break" || Y.type === "continue" ? this.next = Y.arg : Y.type === "return" ? (this.rval = this.arg = Y.arg, this.method = "return", this.next = "end") : Y.type === "normal" && se && (this.next = se), R;
      },
      finish: function(Y) {
        for (var se = this.tryEntries.length - 1; se >= 0; --se) {
          var he = this.tryEntries[se];
          if (he.finallyLoc === Y)
            return this.complete(he.completion, he.afterLoc), M(he), R;
        }
      },
      catch: function(Y) {
        for (var se = this.tryEntries.length - 1; se >= 0; --se) {
          var he = this.tryEntries[se];
          if (he.tryLoc === Y) {
            var fe = he.completion;
            if (fe.type === "throw") {
              var Te = fe.arg;
              M(he);
            }
            return Te;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function(Y, se, he) {
        return this.delegate = {
          iterator: U(Y),
          resultName: se,
          nextLoc: he
        }, this.method === "next" && (this.arg = void 0), R;
      }
    }, f;
  }
  t.exports = h, t.exports.__esModule = !0, t.exports.default = t.exports;
})(bxe);
var Pg = CS(), mi = Pg;
try {
  regeneratorRuntime = Pg;
} catch {
  typeof globalThis == "object" ? globalThis.regeneratorRuntime = Pg : Function("r", "regeneratorRuntime = r")(Pg);
}
var qS = {}, q$e = {
  get exports() {
    return qS;
  },
  set exports(t) {
    qS = t;
  }
}, Ry = {}, X$e = {
  get exports() {
    return Ry;
  },
  set exports(t) {
    Ry = t;
  }
}, Q$e = Wt, Z$e = Q$e(function() {
  if (typeof ArrayBuffer == "function") {
    var t = new ArrayBuffer(8);
    Object.isExtensible(t) && Object.defineProperty(t, "a", { value: 8 });
  }
}), J$e = Wt, eke = En, tke = Mo, xL = Z$e, Rg = Object.isExtensible, rke = J$e(function() {
  Rg(1);
}), nke = rke || xL ? function(e) {
  return !eke(e) || xL && tke(e) == "ArrayBuffer" ? !1 : Rg ? Rg(e) : !0;
} : Rg, ike = Wt, ske = !ike(function() {
  return Object.isExtensible(Object.preventExtensions({}));
}), ake = qe, oke = zt, lke = qp, uke = En, pO = rn, cke = qi.f, SL = Qp, dke = UD, vO = nke, hke = q0, fke = ske, f6 = !1, ko = hke("meta"), pke = 0, mO = function(t) {
  cke(t, ko, { value: {
    objectID: "O" + pke++,
    // object ID
    weakData: {}
    // weak collections IDs
  } });
}, vke = function(t, e) {
  if (!uke(t))
    return typeof t == "symbol" ? t : (typeof t == "string" ? "S" : "P") + t;
  if (!pO(t, ko)) {
    if (!vO(t))
      return "F";
    if (!e)
      return "E";
    mO(t);
  }
  return t[ko].objectID;
}, mke = function(t, e) {
  if (!pO(t, ko)) {
    if (!vO(t))
      return !0;
    if (!e)
      return !1;
    mO(t);
  }
  return t[ko].weakData;
}, gke = function(t) {
  return fke && f6 && vO(t) && !pO(t, ko) && mO(t), t;
}, yke = function() {
  bke.enable = function() {
  }, f6 = !0;
  var t = SL.f, e = oke([].splice), r = {};
  r[ko] = 1, t(r).length && (SL.f = function(n) {
    for (var s = t(n), a = 0, o = s.length; a < o; a++)
      if (s[a] === ko) {
        e(s, a, 1);
        break;
      }
    return s;
  }, ake({ target: "Object", stat: !0, forced: !0 }, {
    getOwnPropertyNames: dke.f
  }));
}, bke = X$e.exports = {
  enable: yke,
  fastKey: vke,
  getWeakData: mke,
  onFreeze: gke
};
lke[ko] = !0;
var _ke = qe, wke = Hr, Tke = Ry, xke = Wt, Ske = Lo, Eke = hc, $ke = uO, kke = Gr, Dke = En, Oke = uc, Ake = qi.f, Cke = mh.forEach, Ike = fn, p6 = vh, Pke = p6.set, Rke = p6.getterFor, v6 = function(t, e, r) {
  var n = t.indexOf("Map") !== -1, s = t.indexOf("Weak") !== -1, a = n ? "set" : "add", o = wke[t], l = o && o.prototype, u = {}, c;
  if (!Ike || !kke(o) || !(s || l.forEach && !xke(function() {
    new o().entries().next();
  })))
    c = r.getConstructor(e, t, n, a), Tke.enable();
  else {
    c = e(function(f, p) {
      Pke($ke(f, d), {
        type: t,
        collection: new o()
      }), p != null && Eke(p, f[a], { that: f, AS_ENTRIES: n });
    });
    var d = c.prototype, h = Rke(t);
    Cke(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function(f) {
      var p = f == "add" || f == "set";
      f in l && !(s && f == "clear") && Ske(d, f, function(m, b) {
        var y = h(this).collection;
        if (!p && s && !Dke(m))
          return f == "get" ? void 0 : !1;
        var _ = y[f](m === 0 ? 0 : m, b);
        return p ? this : _;
      });
    }), s || Ake(d, "size", {
      configurable: !0,
      get: function() {
        return h(this).collection.size;
      }
    });
  }
  return Oke(c, t, !1, !0), u[t] = c, _ke({ global: !0, forced: !0 }, u), s || r.setStrong(c, t, n), c;
}, Mke = ph, Lke = function(t, e, r) {
  for (var n in e)
    r && r.unsafe && t[n] ? t[n] = e[n] : Mke(t, n, e[n], r);
  return t;
}, Nke = lc, Fke = VD, EL = Lke, Bke = Ml, Uke = uO, Vke = Hp, Yke = hc, Hke = zD, qm = qD, Gke = GH, Jh = fn, $L = Ry.fastKey, m6 = vh, kL = m6.set, tw = m6.getterFor, g6 = {
  getConstructor: function(t, e, r, n) {
    var s = t(function(c, d) {
      Uke(c, a), kL(c, {
        type: e,
        index: Nke(null),
        first: void 0,
        last: void 0,
        size: 0
      }), Jh || (c.size = 0), Vke(d) || Yke(d, c[n], { that: c, AS_ENTRIES: r });
    }), a = s.prototype, o = tw(e), l = function(c, d, h) {
      var f = o(c), p = u(c, d), m, b;
      return p ? p.value = h : (f.last = p = {
        index: b = $L(d, !0),
        key: d,
        value: h,
        previous: m = f.last,
        next: void 0,
        removed: !1
      }, f.first || (f.first = p), m && (m.next = p), Jh ? f.size++ : c.size++, b !== "F" && (f.index[b] = p)), c;
    }, u = function(c, d) {
      var h = o(c), f = $L(d), p;
      if (f !== "F")
        return h.index[f];
      for (p = h.first; p; p = p.next)
        if (p.key == d)
          return p;
    };
    return EL(a, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function() {
        for (var d = this, h = o(d), f = h.index, p = h.first; p; )
          p.removed = !0, p.previous && (p.previous = p.previous.next = void 0), delete f[p.index], p = p.next;
        h.first = h.last = void 0, Jh ? h.size = 0 : d.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      delete: function(c) {
        var d = this, h = o(d), f = u(d, c);
        if (f) {
          var p = f.next, m = f.previous;
          delete h.index[f.index], f.removed = !0, m && (m.next = p), p && (p.previous = m), h.first == f && (h.first = p), h.last == f && (h.last = m), Jh ? h.size-- : d.size--;
        }
        return !!f;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function(d) {
        for (var h = o(this), f = Bke(d, arguments.length > 1 ? arguments[1] : void 0), p; p = p ? p.next : h.first; )
          for (f(p.value, p.key, this); p && p.removed; )
            p = p.previous;
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function(d) {
        return !!u(this, d);
      }
    }), EL(a, r ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function(d) {
        var h = u(this, d);
        return h && h.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function(d, h) {
        return l(this, d === 0 ? 0 : d, h);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function(d) {
        return l(this, d = d === 0 ? 0 : d, d);
      }
    }), Jh && Fke(a, "size", {
      configurable: !0,
      get: function() {
        return o(this).size;
      }
    }), s;
  },
  setStrong: function(t, e, r) {
    var n = e + " Iterator", s = tw(e), a = tw(n);
    Hke(t, e, function(o, l) {
      kL(this, {
        type: n,
        target: o,
        state: s(o),
        kind: l,
        last: void 0
      });
    }, function() {
      for (var o = a(this), l = o.kind, u = o.last; u && u.removed; )
        u = u.previous;
      return !o.target || !(o.last = u = u ? u.next : o.state.first) ? (o.target = void 0, qm(void 0, !0)) : l == "keys" ? qm(u.key, !1) : l == "values" ? qm(u.value, !1) : qm([u.key, u.value], !1);
    }, r ? "entries" : "values", !r, !0), Gke(e);
  }
}, Wke = v6, jke = g6;
Wke("Map", function(t) {
  return function() {
    return t(this, arguments.length ? arguments[0] : void 0);
  };
}, jke);
var Kke = vr, zke = Kke.Map, qke = zke, Xke = qke;
(function(t) {
  t.exports = Xke;
})(q$e);
var y6 = /* @__PURE__ */ ft(qS), XS = {}, Qke = {
  get exports() {
    return XS;
  },
  set exports(t) {
    XS = t;
  }
}, Zke = qe, Jke = mh.some, eDe = nv, tDe = eDe("some");
Zke({ target: "Array", proto: !0, forced: !tDe }, {
  some: function(e) {
    return Jke(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var rDe = nn, nDe = rDe("Array").some, iDe = Ar, sDe = nDe, rw = Array.prototype, aDe = function(t) {
  var e = t.some;
  return t === rw || iDe(rw, t) && e === rw.some ? sDe : e;
}, oDe = aDe, lDe = oDe;
(function(t) {
  t.exports = lDe;
})(Qke);
var uDe = /* @__PURE__ */ ft(XS), QS = {}, cDe = {
  get exports() {
    return QS;
  },
  set exports(t) {
    QS = t;
  }
}, dDe = nn, hDe = dDe("Array").keys, fDe = hDe, pDe = fDe, vDe = No, mDe = rn, gDe = Ar, yDe = pDe, nw = Array.prototype, bDe = {
  DOMTokenList: !0,
  NodeList: !0
}, _De = function(t) {
  var e = t.keys;
  return t === nw || gDe(nw, t) && e === nw.keys || mDe(bDe, vDe(t)) ? yDe : e;
};
(function(t) {
  t.exports = _De;
})(cDe);
var tu = /* @__PURE__ */ ft(QS), ZS = {}, wDe = {
  get exports() {
    return ZS;
  },
  set exports(t) {
    ZS = t;
  }
}, DL = DY, TDe = Math.floor, JS = function(t, e) {
  var r = t.length, n = TDe(r / 2);
  return r < 8 ? xDe(t, e) : SDe(
    t,
    JS(DL(t, 0, n), e),
    JS(DL(t, n), e),
    e
  );
}, xDe = function(t, e) {
  for (var r = t.length, n = 1, s, a; n < r; ) {
    for (a = n, s = t[n]; a && e(t[a - 1], s) > 0; )
      t[a] = t[--a];
    a !== n++ && (t[a] = s);
  }
  return t;
}, SDe = function(t, e, r, n) {
  for (var s = e.length, a = r.length, o = 0, l = 0; o < s || l < a; )
    t[o + l] = o < s && l < a ? n(e[o], r[l]) <= 0 ? e[o++] : r[l++] : o < s ? e[o++] : r[l++];
  return t;
}, EDe = JS, $De = Rl, OL = $De.match(/firefox\/(\d+)/i), kDe = !!OL && +OL[1], DDe = Rl, ODe = /MSIE|Trident/.test(DDe), ADe = Rl, AL = ADe.match(/AppleWebKit\/(\d+)\./), CDe = !!AL && +AL[1], IDe = qe, b6 = zt, PDe = Ai, RDe = Ci, CL = Qi, MDe = G4, IL = Ua, gO = Wt, LDe = EDe, NDe = nv, PL = kDe, FDe = ODe, RL = ch, ML = CDe, dl = [], LL = b6(dl.sort), BDe = b6(dl.push), UDe = gO(function() {
  dl.sort(void 0);
}), VDe = gO(function() {
  dl.sort(null);
}), YDe = NDe("sort"), _6 = !gO(function() {
  if (RL)
    return RL < 70;
  if (!(PL && PL > 3)) {
    if (FDe)
      return !0;
    if (ML)
      return ML < 603;
    var t = "", e, r, n, s;
    for (e = 65; e < 76; e++) {
      switch (r = String.fromCharCode(e), e) {
        case 66:
        case 69:
        case 70:
        case 72:
          n = 3;
          break;
        case 68:
        case 71:
          n = 4;
          break;
        default:
          n = 2;
      }
      for (s = 0; s < 47; s++)
        dl.push({ k: r + s, v: n });
    }
    for (dl.sort(function(a, o) {
      return o.v - a.v;
    }), s = 0; s < dl.length; s++)
      r = dl[s].k.charAt(0), t.charAt(t.length - 1) !== r && (t += r);
    return t !== "DGBEFHACIJK";
  }
}), HDe = UDe || !VDe || !YDe || !_6, GDe = function(t) {
  return function(e, r) {
    return r === void 0 ? -1 : e === void 0 ? 1 : t !== void 0 ? +t(e, r) || 0 : IL(e) > IL(r) ? 1 : -1;
  };
};
IDe({ target: "Array", proto: !0, forced: HDe }, {
  sort: function(e) {
    e !== void 0 && PDe(e);
    var r = RDe(this);
    if (_6)
      return e === void 0 ? LL(r) : LL(r, e);
    var n = [], s = CL(r), a, o;
    for (o = 0; o < s; o++)
      o in r && BDe(n, r[o]);
    for (LDe(n, GDe(e)), a = CL(n), o = 0; o < a; )
      r[o] = n[o++];
    for (; o < s; )
      MDe(r, o++);
    return r;
  }
});
var WDe = nn, jDe = WDe("Array").sort, KDe = Ar, zDe = jDe, iw = Array.prototype, qDe = function(t) {
  var e = t.sort;
  return t === iw || KDe(iw, t) && e === iw.sort ? zDe : e;
}, XDe = qDe, QDe = XDe;
(function(t) {
  t.exports = QDe;
})(wDe);
var eE = /* @__PURE__ */ ft(ZS), tE = {}, ZDe = {
  get exports() {
    return tE;
  },
  set exports(t) {
    tE = t;
  }
}, JDe = nn, eOe = JDe("Array").values, tOe = eOe, rOe = tOe, nOe = No, iOe = rn, sOe = Ar, aOe = rOe, sw = Array.prototype, oOe = {
  DOMTokenList: !0,
  NodeList: !0
}, lOe = function(t) {
  var e = t.values;
  return t === sw || sOe(sw, t) && e === sw.values || iOe(oOe, nOe(t)) ? aOe : e;
};
(function(t) {
  t.exports = lOe;
})(ZDe);
var NL = /* @__PURE__ */ ft(tE), rE = {}, uOe = {
  get exports() {
    return rE;
  },
  set exports(t) {
    rE = t;
  }
};
(function(t) {
  t.exports = p4;
})(uOe);
var $u = /* @__PURE__ */ ft(rE), nE = {}, cOe = {
  get exports() {
    return nE;
  },
  set exports(t) {
    nE = t;
  }
}, dOe = nn, hOe = dOe("Array").entries, fOe = hOe, pOe = fOe, vOe = No, mOe = rn, gOe = Ar, yOe = pOe, aw = Array.prototype, bOe = {
  DOMTokenList: !0,
  NodeList: !0
}, _Oe = function(t) {
  var e = t.entries;
  return t === aw || gOe(aw, t) && e === aw.entries || mOe(bOe, vOe(t)) ? yOe : e;
};
(function(t) {
  t.exports = _Oe;
})(cOe);
var wOe = /* @__PURE__ */ ft(nE);
let Xm;
const TOe = new Uint8Array(16);
function xOe() {
  if (!Xm && (Xm = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Xm))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Xm(TOe);
}
const On = [];
for (let t = 0; t < 256; ++t)
  On.push((t + 256).toString(16).slice(1));
function SOe(t, e = 0) {
  return (On[t[e + 0]] + On[t[e + 1]] + On[t[e + 2]] + On[t[e + 3]] + "-" + On[t[e + 4]] + On[t[e + 5]] + "-" + On[t[e + 6]] + On[t[e + 7]] + "-" + On[t[e + 8]] + On[t[e + 9]] + "-" + On[t[e + 10]] + On[t[e + 11]] + On[t[e + 12]] + On[t[e + 13]] + On[t[e + 14]] + On[t[e + 15]]).toLowerCase();
}
const EOe = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var FL = {
  randomUUID: EOe
};
function $Oe(t, e, r) {
  if (FL.randomUUID && !e && !t)
    return FL.randomUUID();
  t = t || {};
  const n = t.random || (t.rng || xOe)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, e) {
    r = r || 0;
    for (let s = 0; s < 16; ++s)
      e[r + s] = n[s];
    return e;
  }
  return SOe(n);
}
function iE(t) {
  return typeof t == "string" || typeof t == "number";
}
var kOe = /* @__PURE__ */ function() {
  function t(e) {
    sc(this, t), Lt(this, "delay", void 0), Lt(this, "max", void 0), Lt(this, "_queue", []), Lt(this, "_timeout", null), Lt(this, "_extended", null), this.delay = null, this.max = 1 / 0, this.setOptions(e);
  }
  return cc(t, [{
    key: "setOptions",
    value: function(r) {
      r && typeof r.delay < "u" && (this.delay = r.delay), r && typeof r.max < "u" && (this.max = r.max), this._flushIfNeeded();
    }
    /**
     * Extend an object with queuing functionality.
     * The object will be extended with a function flush, and the methods provided in options.replace will be replaced with queued ones.
     *
     * @param object - The object to be extended.
     * @param options - Additional options.
     * @returns The created queue.
     */
  }, {
    key: "destroy",
    value: (
      /**
       * Destroy the queue. The queue will first flush all queued actions, and in case it has extended an object, will restore the original object.
       */
      function() {
        if (this.flush(), this._extended) {
          for (var r = this._extended.object, n = this._extended.methods, s = 0; s < n.length; s++) {
            var a = n[s];
            a.original ? r[a.name] = a.original : delete r[a.name];
          }
          this._extended = null;
        }
      }
    )
    /**
     * Replace a method on an object with a queued version.
     *
     * @param object - Object having the method.
     * @param method - The method name.
     */
  }, {
    key: "replace",
    value: function(r, n) {
      var s = this, a = r[n];
      if (!a)
        throw new Error("Method " + n + " undefined");
      r[n] = function() {
        for (var o = arguments.length, l = new Array(o), u = 0; u < o; u++)
          l[u] = arguments[u];
        s.queue({
          args: l,
          fn: a,
          context: this
        });
      };
    }
    /**
     * Queue a call.
     *
     * @param entry - The function or entry to be queued.
     */
  }, {
    key: "queue",
    value: function(r) {
      typeof r == "function" ? this._queue.push({
        fn: r
      }) : this._queue.push(r), this._flushIfNeeded();
    }
    /**
     * Check whether the queue needs to be flushed.
     */
  }, {
    key: "_flushIfNeeded",
    value: function() {
      var r = this;
      this._queue.length > this.max && this.flush(), this._timeout != null && (clearTimeout(this._timeout), this._timeout = null), this.queue.length > 0 && typeof this.delay == "number" && (this._timeout = bwe(function() {
        r.flush();
      }, this.delay));
    }
    /**
     * Flush all queued calls
     */
  }, {
    key: "flush",
    value: function() {
      var r, n;
      Dl(r = W4(n = this._queue).call(n, 0)).call(r, function(s) {
        s.fn.apply(s.context || s.fn, s.args || []);
      });
    }
  }], [{
    key: "extend",
    value: function(r, n) {
      var s = new t(n);
      if (r.flush !== void 0)
        throw new Error("Target object already has a property flush");
      r.flush = function() {
        s.flush();
      };
      var a = [{
        name: "flush",
        original: void 0
      }];
      if (n && n.replace)
        for (var o = 0; o < n.replace.length; o++) {
          var l = n.replace[o];
          a.push({
            name: l,
            // @TODO: better solution?
            original: r[l]
          }), s.replace(r, l);
        }
      return s._extended = {
        object: r,
        methods: a
      }, s;
    }
  }]), t;
}(), w6 = /* @__PURE__ */ function() {
  function t() {
    sc(this, t), Lt(this, "_subscribers", {
      "*": [],
      add: [],
      remove: [],
      update: []
    }), Lt(this, "subscribe", t.prototype.on), Lt(this, "unsubscribe", t.prototype.off);
  }
  return cc(t, [{
    key: "_trigger",
    value: (
      /**
       * Trigger an event
       *
       * @param event - Event name.
       * @param payload - Event payload.
       * @param senderId - Id of the sender.
       */
      function(r, n, s) {
        var a, o;
        if (r === "*")
          throw new Error("Cannot trigger event *");
        Dl(a = db(o = []).call(o, Jn(this._subscribers[r]), Jn(this._subscribers["*"]))).call(a, function(l) {
          l(r, n, s ?? null);
        });
      }
    )
    /**
     * Subscribe to an event, add an event listener.
     *
     * @remarks Non-function callbacks are ignored.
     * @param event - Event name.
     * @param callback - Callback method.
     */
  }, {
    key: "on",
    value: function(r, n) {
      typeof n == "function" && this._subscribers[r].push(n);
    }
    /**
     * Unsubscribe from an event, remove an event listener.
     *
     * @remarks If the same callback was subscribed more than once **all** occurences will be removed.
     * @param event - Event name.
     * @param callback - Callback method.
     */
  }, {
    key: "off",
    value: function(r, n) {
      var s;
      this._subscribers[r] = gn(s = this._subscribers[r]).call(s, function(a) {
        return a !== n;
      });
    }
  }]), t;
}(), sE = {}, DOe = {
  get exports() {
    return sE;
  },
  set exports(t) {
    sE = t;
  }
}, OOe = v6, AOe = g6;
OOe("Set", function(t) {
  return function() {
    return t(this, arguments.length ? arguments[0] : void 0);
  };
}, AOe);
var COe = vr, IOe = COe.Set, POe = IOe, ROe = POe;
(function(t) {
  t.exports = ROe;
})(DOe);
var Mg = /* @__PURE__ */ ft(sE), aE = {}, MOe = {
  get exports() {
    return aE;
  },
  set exports(t) {
    aE = t;
  }
}, oE = {}, LOe = {
  get exports() {
    return oE;
  },
  set exports(t) {
    oE = t;
  }
}, NOe = QD, FOe = NOe, BOe = FOe, UOe = BOe, VOe = UOe, YOe = VOe, HOe = YOe, GOe = HOe;
(function(t) {
  t.exports = GOe;
})(LOe);
(function(t) {
  t.exports = oE;
})(MOe);
var ow = /* @__PURE__ */ ft(aE), T6;
function la(t, e) {
  var r = typeof sv < "u" && yh(t) || t["@@iterator"];
  if (!r) {
    if (Qn(t) || (r = WOe(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, s = function() {
      };
      return { s, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(c) {
        throw c;
      }, f: s };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return { s: function() {
    r = r.call(t);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    o = !0, l = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (o)
        throw l;
    }
  } };
}
function WOe(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return BL(t, e);
    var n = av(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return cb(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return BL(t, e);
  }
}
function BL(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
T6 = $u;
var UL = /* @__PURE__ */ function() {
  function t(e) {
    sc(this, t), Lt(this, "_pairs", void 0), this._pairs = e;
  }
  return cc(t, [{
    key: T6,
    value: /* @__PURE__ */ mi.mark(function e() {
      var r, n, s, a, o;
      return mi.wrap(function(u) {
        for (; ; )
          switch (u.prev = u.next) {
            case 0:
              r = la(this._pairs), u.prev = 1, r.s();
            case 3:
              if ((n = r.n()).done) {
                u.next = 9;
                break;
              }
              return s = pi(n.value, 2), a = s[0], o = s[1], u.next = 7, [a, o];
            case 7:
              u.next = 3;
              break;
            case 9:
              u.next = 14;
              break;
            case 11:
              u.prev = 11, u.t0 = u.catch(1), r.e(u.t0);
            case 14:
              return u.prev = 14, r.f(), u.finish(14);
            case 17:
            case "end":
              return u.stop();
          }
      }, e, this, [[1, 11, 14, 17]]);
    })
    /**
     * Return an iterable of key, value pairs for every entry in the stream.
     */
  }, {
    key: "entries",
    value: /* @__PURE__ */ mi.mark(function e() {
      var r, n, s, a, o;
      return mi.wrap(function(u) {
        for (; ; )
          switch (u.prev = u.next) {
            case 0:
              r = la(this._pairs), u.prev = 1, r.s();
            case 3:
              if ((n = r.n()).done) {
                u.next = 9;
                break;
              }
              return s = pi(n.value, 2), a = s[0], o = s[1], u.next = 7, [a, o];
            case 7:
              u.next = 3;
              break;
            case 9:
              u.next = 14;
              break;
            case 11:
              u.prev = 11, u.t0 = u.catch(1), r.e(u.t0);
            case 14:
              return u.prev = 14, r.f(), u.finish(14);
            case 17:
            case "end":
              return u.stop();
          }
      }, e, this, [[1, 11, 14, 17]]);
    })
    /**
     * Return an iterable of keys in the stream.
     */
  }, {
    key: "keys",
    value: /* @__PURE__ */ mi.mark(function e() {
      var r, n, s, a;
      return mi.wrap(function(l) {
        for (; ; )
          switch (l.prev = l.next) {
            case 0:
              r = la(this._pairs), l.prev = 1, r.s();
            case 3:
              if ((n = r.n()).done) {
                l.next = 9;
                break;
              }
              return s = pi(n.value, 1), a = s[0], l.next = 7, a;
            case 7:
              l.next = 3;
              break;
            case 9:
              l.next = 14;
              break;
            case 11:
              l.prev = 11, l.t0 = l.catch(1), r.e(l.t0);
            case 14:
              return l.prev = 14, r.f(), l.finish(14);
            case 17:
            case "end":
              return l.stop();
          }
      }, e, this, [[1, 11, 14, 17]]);
    })
    /**
     * Return an iterable of values in the stream.
     */
  }, {
    key: "values",
    value: /* @__PURE__ */ mi.mark(function e() {
      var r, n, s, a;
      return mi.wrap(function(l) {
        for (; ; )
          switch (l.prev = l.next) {
            case 0:
              r = la(this._pairs), l.prev = 1, r.s();
            case 3:
              if ((n = r.n()).done) {
                l.next = 9;
                break;
              }
              return s = pi(n.value, 2), a = s[1], l.next = 7, a;
            case 7:
              l.next = 3;
              break;
            case 9:
              l.next = 14;
              break;
            case 11:
              l.prev = 11, l.t0 = l.catch(1), r.e(l.t0);
            case 14:
              return l.prev = 14, r.f(), l.finish(14);
            case 17:
            case "end":
              return l.stop();
          }
      }, e, this, [[1, 11, 14, 17]]);
    })
    /**
     * Return an array containing all the ids in this stream.
     *
     * @remarks
     * The array may contain duplicities.
     * @returns The array with all ids from this stream.
     */
  }, {
    key: "toIdArray",
    value: function() {
      var r;
      return Ni(r = Jn(this._pairs)).call(r, function(n) {
        return n[0];
      });
    }
    /**
     * Return an array containing all the items in this stream.
     *
     * @remarks
     * The array may contain duplicities.
     * @returns The array with all items from this stream.
     */
  }, {
    key: "toItemArray",
    value: function() {
      var r;
      return Ni(r = Jn(this._pairs)).call(r, function(n) {
        return n[1];
      });
    }
    /**
     * Return an array containing all the entries in this stream.
     *
     * @remarks
     * The array may contain duplicities.
     * @returns The array with all entries from this stream.
     */
  }, {
    key: "toEntryArray",
    value: function() {
      return Jn(this._pairs);
    }
    /**
     * Return an object map containing all the items in this stream accessible by ids.
     *
     * @remarks
     * In case of duplicate ids (coerced to string so `7 == '7'`) the last encoutered appears in the returned object.
     * @returns The object map of all id → item pairs from this stream.
     */
  }, {
    key: "toObjectMap",
    value: function() {
      var r = q1e(null), n = la(this._pairs), s;
      try {
        for (n.s(); !(s = n.n()).done; ) {
          var a = pi(s.value, 2), o = a[0], l = a[1];
          r[o] = l;
        }
      } catch (u) {
        n.e(u);
      } finally {
        n.f();
      }
      return r;
    }
    /**
     * Return a map containing all the items in this stream accessible by ids.
     *
     * @returns The map of all id → item pairs from this stream.
     */
  }, {
    key: "toMap",
    value: function() {
      return new y6(this._pairs);
    }
    /**
     * Return a set containing all the (unique) ids in this stream.
     *
     * @returns The set of all ids from this stream.
     */
  }, {
    key: "toIdSet",
    value: function() {
      return new Mg(this.toIdArray());
    }
    /**
     * Return a set containing all the (unique) items in this stream.
     *
     * @returns The set of all items from this stream.
     */
  }, {
    key: "toItemSet",
    value: function() {
      return new Mg(this.toItemArray());
    }
    /**
     * Cache the items from this stream.
     *
     * @remarks
     * This method allows for items to be fetched immediatelly and used (possibly multiple times) later.
     * It can also be used to optimize performance as {@link DataStream} would otherwise reevaluate everything upon each iteration.
     *
     * ## Example
     * ```javascript
     * const ds = new DataSet([…])
     *
     * const cachedStream = ds.stream()
     *   .filter(…)
     *   .sort(…)
     *   .map(…)
     *   .cached(…) // Data are fetched, processed and cached here.
     *
     * ds.clear()
     * chachedStream // Still has all the items.
     * ```
     * @returns A new {@link DataStream} with cached items (detached from the original {@link DataSet}).
     */
  }, {
    key: "cache",
    value: function() {
      return new t(Jn(this._pairs));
    }
    /**
     * Get the distinct values of given property.
     *
     * @param callback - The function that picks and possibly converts the property.
     * @typeParam T - The type of the distinct value.
     * @returns A set of all distinct properties.
     */
  }, {
    key: "distinct",
    value: function(r) {
      var n = new Mg(), s = la(this._pairs), a;
      try {
        for (s.s(); !(a = s.n()).done; ) {
          var o = pi(a.value, 2), l = o[0], u = o[1];
          n.add(r(u, l));
        }
      } catch (c) {
        s.e(c);
      } finally {
        s.f();
      }
      return n;
    }
    /**
     * Filter the items of the stream.
     *
     * @param callback - The function that decides whether an item will be included.
     * @returns A new data stream with the filtered items.
     */
  }, {
    key: "filter",
    value: function(r) {
      var n = this._pairs;
      return new t(Lt({}, $u, /* @__PURE__ */ mi.mark(function s() {
        var a, o, l, u, c;
        return mi.wrap(function(h) {
          for (; ; )
            switch (h.prev = h.next) {
              case 0:
                a = la(n), h.prev = 1, a.s();
              case 3:
                if ((o = a.n()).done) {
                  h.next = 10;
                  break;
                }
                if (l = pi(o.value, 2), u = l[0], c = l[1], !r(c, u)) {
                  h.next = 8;
                  break;
                }
                return h.next = 8, [u, c];
              case 8:
                h.next = 3;
                break;
              case 10:
                h.next = 15;
                break;
              case 12:
                h.prev = 12, h.t0 = h.catch(1), a.e(h.t0);
              case 15:
                return h.prev = 15, a.f(), h.finish(15);
              case 18:
              case "end":
                return h.stop();
            }
        }, s, null, [[1, 12, 15, 18]]);
      })));
    }
    /**
     * Execute a callback for each item of the stream.
     *
     * @param callback - The function that will be invoked for each item.
     */
  }, {
    key: "forEach",
    value: function(r) {
      var n = la(this._pairs), s;
      try {
        for (n.s(); !(s = n.n()).done; ) {
          var a = pi(s.value, 2), o = a[0], l = a[1];
          r(l, o);
        }
      } catch (u) {
        n.e(u);
      } finally {
        n.f();
      }
    }
    /**
     * Map the items into a different type.
     *
     * @param callback - The function that does the conversion.
     * @typeParam Mapped - The type of the item after mapping.
     * @returns A new data stream with the mapped items.
     */
  }, {
    key: "map",
    value: function(r) {
      var n = this._pairs;
      return new t(Lt({}, $u, /* @__PURE__ */ mi.mark(function s() {
        var a, o, l, u, c;
        return mi.wrap(function(h) {
          for (; ; )
            switch (h.prev = h.next) {
              case 0:
                a = la(n), h.prev = 1, a.s();
              case 3:
                if ((o = a.n()).done) {
                  h.next = 9;
                  break;
                }
                return l = pi(o.value, 2), u = l[0], c = l[1], h.next = 7, [u, r(c, u)];
              case 7:
                h.next = 3;
                break;
              case 9:
                h.next = 14;
                break;
              case 11:
                h.prev = 11, h.t0 = h.catch(1), a.e(h.t0);
              case 14:
                return h.prev = 14, a.f(), h.finish(14);
              case 17:
              case "end":
                return h.stop();
            }
        }, s, null, [[1, 11, 14, 17]]);
      })));
    }
    /**
     * Get the item with the maximum value of given property.
     *
     * @param callback - The function that picks and possibly converts the property.
     * @returns The item with the maximum if found otherwise null.
     */
  }, {
    key: "max",
    value: function(r) {
      var n = ow(this._pairs), s = n.next();
      if (s.done)
        return null;
      for (var a = s.value[1], o = r(s.value[1], s.value[0]); !(s = n.next()).done; ) {
        var l = pi(s.value, 2), u = l[0], c = l[1], d = r(c, u);
        d > o && (o = d, a = c);
      }
      return a;
    }
    /**
     * Get the item with the minimum value of given property.
     *
     * @param callback - The function that picks and possibly converts the property.
     * @returns The item with the minimum if found otherwise null.
     */
  }, {
    key: "min",
    value: function(r) {
      var n = ow(this._pairs), s = n.next();
      if (s.done)
        return null;
      for (var a = s.value[1], o = r(s.value[1], s.value[0]); !(s = n.next()).done; ) {
        var l = pi(s.value, 2), u = l[0], c = l[1], d = r(c, u);
        d < o && (o = d, a = c);
      }
      return a;
    }
    /**
     * Reduce the items into a single value.
     *
     * @param callback - The function that does the reduction.
     * @param accumulator - The initial value of the accumulator.
     * @typeParam T - The type of the accumulated value.
     * @returns The reduced value.
     */
  }, {
    key: "reduce",
    value: function(r, n) {
      var s = la(this._pairs), a;
      try {
        for (s.s(); !(a = s.n()).done; ) {
          var o = pi(a.value, 2), l = o[0], u = o[1];
          n = r(n, u, l);
        }
      } catch (c) {
        s.e(c);
      } finally {
        s.f();
      }
      return n;
    }
    /**
     * Sort the items.
     *
     * @param callback - Item comparator.
     * @returns A new stream with sorted items.
     */
  }, {
    key: "sort",
    value: function(r) {
      var n = this;
      return new t(Lt({}, $u, function() {
        var s;
        return ow(eE(s = Jn(n._pairs)).call(s, function(a, o) {
          var l = pi(a, 2), u = l[0], c = l[1], d = pi(o, 2), h = d[0], f = d[1];
          return r(c, f, u, h);
        }));
      }));
    }
  }]), t;
}();
function VL(t, e) {
  var r = JD(t);
  if (tM) {
    var n = tM(t);
    e && (n = gn(n).call(n, function(s) {
      return C4(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function YL(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r, n, s = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Dl(r = VL(Object(s), !0)).call(r, function(a) {
      Lt(t, a, s[a]);
    }) : rM ? nye(t, rM(s)) : Dl(n = VL(Object(s))).call(n, function(a) {
      P4(t, a, C4(s, a));
    });
  }
  return t;
}
function lw(t, e) {
  var r = typeof sv < "u" && yh(t) || t["@@iterator"];
  if (!r) {
    if (Qn(t) || (r = jOe(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, s = function() {
      };
      return { s, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(c) {
        throw c;
      }, f: s };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return { s: function() {
    r = r.call(t);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    o = !0, l = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (o)
        throw l;
    }
  } };
}
function jOe(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return HL(t, e);
    var n = av(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return cb(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return HL(t, e);
  }
}
function HL(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function KOe(t) {
  var e = zOe();
  return function() {
    var n = Vd(t), s;
    if (e) {
      var a = Vd(this).constructor;
      s = _l(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return UH(this, s);
  };
}
function zOe() {
  if (typeof Reflect > "u" || !_l || _l.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(_l(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function qOe(t, e) {
  return t[e] == null && (t[e] = $Oe()), t;
}
var Gu = /* @__PURE__ */ function(t) {
  BH(r, t);
  var e = KOe(r);
  function r(n, s) {
    var a;
    return sc(this, r), a = e.call(this), Lt(Fi(a), "flush", void 0), Lt(Fi(a), "length", void 0), Lt(Fi(a), "_options", void 0), Lt(Fi(a), "_data", void 0), Lt(Fi(a), "_idProp", void 0), Lt(Fi(a), "_queue", null), n && !Qn(n) && (s = n, n = []), a._options = s || {}, a._data = new y6(), a.length = 0, a._idProp = a._options.fieldId || "id", n && n.length && a.add(n), a.setOptions(s), a;
  }
  return cc(r, [{
    key: "idProp",
    get: (
      /** @inheritDoc */
      function() {
        return this._idProp;
      }
    )
  }, {
    key: "setOptions",
    value: function(s) {
      s && s.queue !== void 0 && (s.queue === !1 ? this._queue && (this._queue.destroy(), this._queue = null) : (this._queue || (this._queue = kOe.extend(this, {
        replace: ["add", "update", "remove"]
      })), s.queue && Rn(s.queue) === "object" && this._queue.setOptions(s.queue)));
    }
    /**
     * Add a data item or an array with items.
     *
     * After the items are added to the DataSet, the DataSet will trigger an event `add`. When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
     *
     * ## Example
     *
     * ```javascript
     * // create a DataSet
     * const data = new vis.DataSet()
     *
     * // add items
     * const ids = data.add([
     *   { id: 1, text: 'item 1' },
     *   { id: 2, text: 'item 2' },
     *   { text: 'item without an id' }
     * ])
     *
     * console.log(ids) // [1, 2, '<UUIDv4>']
     * ```
     *
     * @param data - Items to be added (ids will be generated if missing).
     * @param senderId - Sender id.
     * @returns addedIds - Array with the ids (generated if not present) of the added items.
     * @throws When an item with the same id as any of the added items already exists.
     */
  }, {
    key: "add",
    value: function(s, a) {
      var o = this, l = [], u;
      if (Qn(s)) {
        var c = Ni(s).call(s, function(f) {
          return f[o._idProp];
        });
        if (uDe(c).call(c, function(f) {
          return o._data.has(f);
        }))
          throw new Error("A duplicate id was found in the parameter array.");
        for (var d = 0, h = s.length; d < h; d++)
          u = this._addItem(s[d]), l.push(u);
      } else if (s && Rn(s) === "object")
        u = this._addItem(s), l.push(u);
      else
        throw new Error("Unknown dataType");
      return l.length && this._trigger("add", {
        items: l
      }, a), l;
    }
    /**
     * Update existing items. When an item does not exist, it will be created.
     *
     * @remarks
     * The provided properties will be merged in the existing item. When an item does not exist, it will be created.
     *
     * After the items are updated, the DataSet will trigger an event `add` for the added items, and an event `update`. When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
     *
     * ## Example
     *
     * ```javascript
     * // create a DataSet
     * const data = new vis.DataSet([
     *   { id: 1, text: 'item 1' },
     *   { id: 2, text: 'item 2' },
     *   { id: 3, text: 'item 3' }
     * ])
     *
     * // update items
     * const ids = data.update([
     *   { id: 2, text: 'item 2 (updated)' },
     *   { id: 4, text: 'item 4 (new)' }
     * ])
     *
     * console.log(ids) // [2, 4]
     * ```
     *
     * ## Warning for TypeScript users
     * This method may introduce partial items into the data set. Use add or updateOnly instead for better type safety.
     * @param data - Items to be updated (if the id is already present) or added (if the id is missing).
     * @param senderId - Sender id.
     * @returns updatedIds - The ids of the added (these may be newly generated if there was no id in the item from the data) or updated items.
     * @throws When the supplied data is neither an item nor an array of items.
     */
  }, {
    key: "update",
    value: function(s, a) {
      var o = this, l = [], u = [], c = [], d = [], h = this._idProp, f = function(_) {
        var x = _[h];
        if (x != null && o._data.has(x)) {
          var T = _, k = j4({}, o._data.get(x)), E = o._updateItem(T);
          u.push(E), d.push(T), c.push(k);
        } else {
          var F = o._addItem(_);
          l.push(F);
        }
      };
      if (Qn(s))
        for (var p = 0, m = s.length; p < m; p++)
          s[p] && Rn(s[p]) === "object" ? f(s[p]) : console.warn("Ignoring input item, which is not an object at index " + p);
      else if (s && Rn(s) === "object")
        f(s);
      else
        throw new Error("Unknown dataType");
      if (l.length && this._trigger("add", {
        items: l
      }, a), u.length) {
        var b = {
          items: u,
          oldData: c,
          data: d
        };
        this._trigger("update", b, a);
      }
      return db(l).call(l, u);
    }
    /**
     * Update existing items. When an item does not exist, an error will be thrown.
     *
     * @remarks
     * The provided properties will be deeply merged into the existing item.
     * When an item does not exist (id not present in the data set or absent), an error will be thrown and nothing will be changed.
     *
     * After the items are updated, the DataSet will trigger an event `update`.
     * When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
     *
     * ## Example
     *
     * ```javascript
     * // create a DataSet
     * const data = new vis.DataSet([
     *   { id: 1, text: 'item 1' },
     *   { id: 2, text: 'item 2' },
     *   { id: 3, text: 'item 3' },
     * ])
     *
     * // update items
     * const ids = data.update([
     *   { id: 2, text: 'item 2 (updated)' }, // works
     *   // { id: 4, text: 'item 4 (new)' }, // would throw
     *   // { text: 'item 4 (new)' }, // would also throw
     * ])
     *
     * console.log(ids) // [2]
     * ```
     * @param data - Updates (the id and optionally other props) to the items in this data set.
     * @param senderId - Sender id.
     * @returns updatedIds - The ids of the updated items.
     * @throws When the supplied data is neither an item nor an array of items, when the ids are missing.
     */
  }, {
    key: "updateOnly",
    value: function(s, a) {
      var o, l = this;
      Qn(s) || (s = [s]);
      var u = Ni(o = Ni(s).call(s, function(d) {
        var h = l._data.get(d[l._idProp]);
        if (h == null)
          throw new Error("Updating non-existent items is not allowed.");
        return {
          oldData: h,
          update: d
        };
      })).call(o, function(d) {
        var h = d.oldData, f = d.update, p = h[l._idProp], m = xTe(h, f);
        return l._data.set(p, m), {
          id: p,
          oldData: h,
          updatedData: m
        };
      });
      if (u.length) {
        var c = {
          items: Ni(u).call(u, function(d) {
            return d.id;
          }),
          oldData: Ni(u).call(u, function(d) {
            return d.oldData;
          }),
          data: Ni(u).call(u, function(d) {
            return d.updatedData;
          })
        };
        return this._trigger("update", c, a), c.items;
      } else
        return [];
    }
    /** @inheritDoc */
  }, {
    key: "get",
    value: function(s, a) {
      var o = void 0, l = void 0, u = void 0;
      iE(s) ? (o = s, u = a) : Qn(s) ? (l = s, u = a) : u = s;
      var c = u && u.returnType === "Object" ? "Object" : "Array", d = u && gn(u), h = [], f = void 0, p = void 0, m = void 0;
      if (o != null)
        f = this._data.get(o), f && d && !d(f) && (f = void 0);
      else if (l != null)
        for (var b = 0, y = l.length; b < y; b++)
          f = this._data.get(l[b]), f != null && (!d || d(f)) && h.push(f);
      else {
        var _;
        p = Jn(tu(_ = this._data).call(_));
        for (var x = 0, T = p.length; x < T; x++)
          m = p[x], f = this._data.get(m), f != null && (!d || d(f)) && h.push(f);
      }
      if (u && u.order && o == null && this._sort(h, u.order), u && u.fields) {
        var k = u.fields;
        if (o != null && f != null)
          f = this._filterFields(f, k);
        else
          for (var E = 0, F = h.length; E < F; E++)
            h[E] = this._filterFields(h[E], k);
      }
      if (c == "Object") {
        for (var R = {}, $ = 0, O = h.length; $ < O; $++) {
          var P = h[$], N = P[this._idProp];
          R[N] = P;
        }
        return R;
      } else if (o != null) {
        var I;
        return (I = f) !== null && I !== void 0 ? I : null;
      } else
        return h;
    }
    /** @inheritDoc */
  }, {
    key: "getIds",
    value: function(s) {
      var a = this._data, o = s && gn(s), l = s && s.order, u = Jn(tu(a).call(a)), c = [];
      if (o)
        if (l) {
          for (var d = [], h = 0, f = u.length; h < f; h++) {
            var p = u[h], m = this._data.get(p);
            m != null && o(m) && d.push(m);
          }
          this._sort(d, l);
          for (var b = 0, y = d.length; b < y; b++)
            c.push(d[b][this._idProp]);
        } else
          for (var _ = 0, x = u.length; _ < x; _++) {
            var T = u[_], k = this._data.get(T);
            k != null && o(k) && c.push(k[this._idProp]);
          }
      else if (l) {
        for (var E = [], F = 0, R = u.length; F < R; F++) {
          var $ = u[F];
          E.push(a.get($));
        }
        this._sort(E, l);
        for (var O = 0, P = E.length; O < P; O++)
          c.push(E[O][this._idProp]);
      } else
        for (var N = 0, I = u.length; N < I; N++) {
          var B = u[N], W = a.get(B);
          W != null && c.push(W[this._idProp]);
        }
      return c;
    }
    /** @inheritDoc */
  }, {
    key: "getDataSet",
    value: function() {
      return this;
    }
    /** @inheritDoc */
  }, {
    key: "forEach",
    value: function(s, a) {
      var o = a && gn(a), l = this._data, u = Jn(tu(l).call(l));
      if (a && a.order)
        for (var c = this.get(a), d = 0, h = c.length; d < h; d++) {
          var f = c[d], p = f[this._idProp];
          s(f, p);
        }
      else
        for (var m = 0, b = u.length; m < b; m++) {
          var y = u[m], _ = this._data.get(y);
          _ != null && (!o || o(_)) && s(_, y);
        }
    }
    /** @inheritDoc */
  }, {
    key: "map",
    value: function(s, a) {
      for (var o = a && gn(a), l = [], u = this._data, c = Jn(tu(u).call(u)), d = 0, h = c.length; d < h; d++) {
        var f = c[d], p = this._data.get(f);
        p != null && (!o || o(p)) && l.push(s(p, f));
      }
      return a && a.order && this._sort(l, a.order), l;
    }
    /**
     * Filter the fields of an item.
     *
     * @param item - The item whose fields should be filtered.
     * @param fields - The names of the fields that will be kept.
     * @typeParam K - Field name type.
     * @returns The item without any additional fields.
     */
  }, {
    key: "_filterFields",
    value: function(s, a) {
      var o;
      return s && _4(o = Qn(a) ? (
        // Use the supplied array
        a
      ) : (
        // Use the keys of the supplied object
        JD(a)
      )).call(o, function(l, u) {
        return l[u] = s[u], l;
      }, {});
    }
    /**
     * Sort the provided array with items.
     *
     * @param items - Items to be sorted in place.
     * @param order - A field name or custom sort function.
     * @typeParam T - The type of the items in the items array.
     */
  }, {
    key: "_sort",
    value: function(s, a) {
      if (typeof a == "string") {
        var o = a;
        eE(s).call(s, function(l, u) {
          var c = l[o], d = u[o];
          return c > d ? 1 : c < d ? -1 : 0;
        });
      } else if (typeof a == "function")
        eE(s).call(s, a);
      else
        throw new TypeError("Order must be a function or a string");
    }
    /**
     * Remove an item or multiple items by “reference” (only the id is used) or by id.
     *
     * The method ignores removal of non-existing items, and returns an array containing the ids of the items which are actually removed from the DataSet.
     *
     * After the items are removed, the DataSet will trigger an event `remove` for the removed items. When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
     *
     * ## Example
     * ```javascript
     * // create a DataSet
     * const data = new vis.DataSet([
     *   { id: 1, text: 'item 1' },
     *   { id: 2, text: 'item 2' },
     *   { id: 3, text: 'item 3' }
     * ])
     *
     * // remove items
     * const ids = data.remove([2, { id: 3 }, 4])
     *
     * console.log(ids) // [2, 3]
     * ```
     *
     * @param id - One or more items or ids of items to be removed.
     * @param senderId - Sender id.
     * @returns The ids of the removed items.
     */
  }, {
    key: "remove",
    value: function(s, a) {
      for (var o = [], l = [], u = Qn(s) ? s : [s], c = 0, d = u.length; c < d; c++) {
        var h = this._remove(u[c]);
        if (h) {
          var f = h[this._idProp];
          f != null && (o.push(f), l.push(h));
        }
      }
      return o.length && this._trigger("remove", {
        items: o,
        oldData: l
      }, a), o;
    }
    /**
     * Remove an item by its id or reference.
     *
     * @param id - Id of an item or the item itself.
     * @returns The removed item if removed, null otherwise.
     */
  }, {
    key: "_remove",
    value: function(s) {
      var a;
      if (iE(s) ? a = s : s && Rn(s) === "object" && (a = s[this._idProp]), a != null && this._data.has(a)) {
        var o = this._data.get(a) || null;
        return this._data.delete(a), --this.length, o;
      }
      return null;
    }
    /**
     * Clear the entire data set.
     *
     * After the items are removed, the {@link DataSet} will trigger an event `remove` for all removed items. When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
     *
     * @param senderId - Sender id.
     * @returns removedIds - The ids of all removed items.
     */
  }, {
    key: "clear",
    value: function(s) {
      for (var a, o = Jn(tu(a = this._data).call(a)), l = [], u = 0, c = o.length; u < c; u++)
        l.push(this._data.get(o[u]));
      return this._data.clear(), this.length = 0, this._trigger("remove", {
        items: o,
        oldData: l
      }, s), o;
    }
    /**
     * Find the item with maximum value of a specified field.
     *
     * @param field - Name of the property that should be searched for max value.
     * @returns Item containing max value, or null if no items.
     */
  }, {
    key: "max",
    value: function(s) {
      var a, o = null, l = null, u = lw(NL(a = this._data).call(a)), c;
      try {
        for (u.s(); !(c = u.n()).done; ) {
          var d = c.value, h = d[s];
          typeof h == "number" && (l == null || h > l) && (o = d, l = h);
        }
      } catch (f) {
        u.e(f);
      } finally {
        u.f();
      }
      return o || null;
    }
    /**
     * Find the item with minimum value of a specified field.
     *
     * @param field - Name of the property that should be searched for min value.
     * @returns Item containing min value, or null if no items.
     */
  }, {
    key: "min",
    value: function(s) {
      var a, o = null, l = null, u = lw(NL(a = this._data).call(a)), c;
      try {
        for (u.s(); !(c = u.n()).done; ) {
          var d = c.value, h = d[s];
          typeof h == "number" && (l == null || h < l) && (o = d, l = h);
        }
      } catch (f) {
        u.e(f);
      } finally {
        u.f();
      }
      return o || null;
    }
    /**
     * Find all distinct values of a specified field
     *
     * @param prop - The property name whose distinct values should be returned.
     * @returns Unordered array containing all distinct values. Items without specified property are ignored.
     */
  }, {
    key: "distinct",
    value: function(s) {
      for (var a = this._data, o = Jn(tu(a).call(a)), l = [], u = 0, c = 0, d = o.length; c < d; c++) {
        for (var h = o[c], f = a.get(h), p = f[s], m = !1, b = 0; b < u; b++)
          if (l[b] == p) {
            m = !0;
            break;
          }
        !m && p !== void 0 && (l[u] = p, u++);
      }
      return l;
    }
    /**
     * Add a single item. Will fail when an item with the same id already exists.
     *
     * @param item - A new item to be added.
     * @returns Added item's id. An id is generated when it is not present in the item.
     */
  }, {
    key: "_addItem",
    value: function(s) {
      var a = qOe(s, this._idProp), o = a[this._idProp];
      if (this._data.has(o))
        throw new Error("Cannot add item: item with id " + o + " already exists");
      return this._data.set(o, a), ++this.length, o;
    }
    /**
     * Update a single item: merge with existing item.
     * Will fail when the item has no id, or when there does not exist an item with the same id.
     *
     * @param update - The new item
     * @returns The id of the updated item.
     */
  }, {
    key: "_updateItem",
    value: function(s) {
      var a = s[this._idProp];
      if (a == null)
        throw new Error("Cannot update item: item has no id (item: " + twe(s) + ")");
      var o = this._data.get(a);
      if (!o)
        throw new Error("Cannot update item: no item with id " + a + " found");
      return this._data.set(a, YL(YL({}, o), s)), a;
    }
    /** @inheritDoc */
  }, {
    key: "stream",
    value: function(s) {
      if (s) {
        var a = this._data;
        return new UL(Lt({}, $u, /* @__PURE__ */ mi.mark(function l() {
          var u, c, d, h;
          return mi.wrap(function(p) {
            for (; ; )
              switch (p.prev = p.next) {
                case 0:
                  u = lw(s), p.prev = 1, u.s();
                case 3:
                  if ((c = u.n()).done) {
                    p.next = 11;
                    break;
                  }
                  if (d = c.value, h = a.get(d), h == null) {
                    p.next = 9;
                    break;
                  }
                  return p.next = 9, [d, h];
                case 9:
                  p.next = 3;
                  break;
                case 11:
                  p.next = 16;
                  break;
                case 13:
                  p.prev = 13, p.t0 = p.catch(1), u.e(p.t0);
                case 16:
                  return p.prev = 16, u.f(), p.finish(16);
                case 19:
                case "end":
                  return p.stop();
              }
          }, l, null, [[1, 13, 16, 19]]);
        })));
      } else {
        var o;
        return new UL(Lt({}, $u, xu(o = wOe(this._data)).call(o, this._data)));
      }
    }
  }]), r;
}(w6);
function XOe(t, e) {
  var r = typeof sv < "u" && yh(t) || t["@@iterator"];
  if (!r) {
    if (Qn(t) || (r = QOe(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, s = function() {
      };
      return { s, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(c) {
        throw c;
      }, f: s };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return { s: function() {
    r = r.call(t);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    o = !0, l = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (o)
        throw l;
    }
  } };
}
function QOe(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return GL(t, e);
    var n = av(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return cb(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return GL(t, e);
  }
}
function GL(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function ZOe(t) {
  var e = JOe();
  return function() {
    var n = Vd(t), s;
    if (e) {
      var a = Vd(this).constructor;
      s = _l(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return UH(this, s);
  };
}
function JOe() {
  if (typeof Reflect > "u" || !_l || _l.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(_l(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var eAe = /* @__PURE__ */ function(t) {
  BH(r, t);
  var e = ZOe(r);
  function r(n, s) {
    var a, o;
    return sc(this, r), o = e.call(this), Lt(Fi(o), "length", 0), Lt(Fi(o), "_listener", void 0), Lt(Fi(o), "_data", void 0), Lt(Fi(o), "_ids", new Mg()), Lt(Fi(o), "_options", void 0), o._options = s || {}, o._listener = xu(a = o._onEvent).call(a, Fi(o)), o.setData(n), o;
  }
  return cc(r, [{
    key: "idProp",
    get: (
      /** @inheritDoc */
      function() {
        return this.getDataSet().idProp;
      }
    )
  }, {
    key: "setData",
    value: function(s) {
      if (this._data) {
        this._data.off && this._data.off("*", this._listener);
        var a = this._data.getIds({
          filter: gn(this._options)
        }), o = this._data.get(a);
        this._ids.clear(), this.length = 0, this._trigger("remove", {
          items: a,
          oldData: o
        });
      }
      if (s != null) {
        this._data = s;
        for (var l = this._data.getIds({
          filter: gn(this._options)
        }), u = 0, c = l.length; u < c; u++) {
          var d = l[u];
          this._ids.add(d);
        }
        this.length = l.length, this._trigger("add", {
          items: l
        });
      } else
        this._data = new Gu();
      this._data.on && this._data.on("*", this._listener);
    }
    /**
     * Refresh the DataView.
     * Useful when the DataView has a filter function containing a variable parameter.
     */
  }, {
    key: "refresh",
    value: function() {
      for (var s = this._data.getIds({
        filter: gn(this._options)
      }), a = Jn(this._ids), o = {}, l = [], u = [], c = [], d = 0, h = s.length; d < h; d++) {
        var f = s[d];
        o[f] = !0, this._ids.has(f) || (l.push(f), this._ids.add(f));
      }
      for (var p = 0, m = a.length; p < m; p++) {
        var b = a[p], y = this._data.get(b);
        y == null ? console.error("If you see this, report it please.") : o[b] || (u.push(b), c.push(y), this._ids.delete(b));
      }
      this.length += l.length - u.length, l.length && this._trigger("add", {
        items: l
      }), u.length && this._trigger("remove", {
        items: u,
        oldData: c
      });
    }
    /** @inheritDoc */
  }, {
    key: "get",
    value: function(s, a) {
      if (this._data == null)
        return null;
      var o = null, l;
      iE(s) || Qn(s) ? (o = s, l = a) : l = s;
      var u = j4({}, this._options, l), c = gn(this._options), d = l && gn(l);
      return c && d && (u.filter = function(h) {
        return c(h) && d(h);
      }), o == null ? this._data.get(u) : this._data.get(o, u);
    }
    /** @inheritDoc */
  }, {
    key: "getIds",
    value: function(s) {
      if (this._data.length) {
        var a = gn(this._options), o = s != null ? gn(s) : null, l;
        return o ? a ? l = function(c) {
          return a(c) && o(c);
        } : l = o : l = a, this._data.getIds({
          filter: l,
          order: s && s.order
        });
      } else
        return [];
    }
    /** @inheritDoc */
  }, {
    key: "forEach",
    value: function(s, a) {
      if (this._data) {
        var o, l = gn(this._options), u = a && gn(a), c;
        u ? l ? c = function(h) {
          return l(h) && u(h);
        } : c = u : c = l, Dl(o = this._data).call(o, s, {
          filter: c,
          order: a && a.order
        });
      }
    }
    /** @inheritDoc */
  }, {
    key: "map",
    value: function(s, a) {
      if (this._data) {
        var o, l = gn(this._options), u = a && gn(a), c;
        return u ? l ? c = function(h) {
          return l(h) && u(h);
        } : c = u : c = l, Ni(o = this._data).call(o, s, {
          filter: c,
          order: a && a.order
        });
      } else
        return [];
    }
    /** @inheritDoc */
  }, {
    key: "getDataSet",
    value: function() {
      return this._data.getDataSet();
    }
    /** @inheritDoc */
  }, {
    key: "stream",
    value: function(s) {
      var a;
      return this._data.stream(s || Lt({}, $u, xu(a = tu(this._ids)).call(a, this._ids)));
    }
    /**
     * Render the instance unusable prior to garbage collection.
     *
     * @remarks
     * The intention of this method is to help discover scenarios where the data
     * view is being used when the programmer thinks it has been garbage collected
     * already. It's stricter version of `dataView.setData(null)`.
     */
  }, {
    key: "dispose",
    value: function() {
      var s;
      (s = this._data) !== null && s !== void 0 && s.off && this._data.off("*", this._listener);
      var a = "This data view has already been disposed of.", o = {
        get: function() {
          throw new Error(a);
        },
        set: function() {
          throw new Error(a);
        },
        configurable: !1
      }, l = XOe(B4(r.prototype)), u;
      try {
        for (l.s(); !(u = l.n()).done; ) {
          var c = u.value;
          P4(this, c, o);
        }
      } catch (d) {
        l.e(d);
      } finally {
        l.f();
      }
    }
    /**
     * Event listener. Will propagate all events from the connected data set to the subscribers of the DataView, but will filter the items and only trigger when there are changes in the filtered data set.
     *
     * @param event - The name of the event.
     * @param params - Parameters of the event.
     * @param senderId - Id supplied by the sender.
     */
  }, {
    key: "_onEvent",
    value: function(s, a, o) {
      if (!(!a || !a.items || !this._data)) {
        var l = a.items, u = [], c = [], d = [], h = [], f = [], p = [];
        switch (s) {
          case "add":
            for (var m = 0, b = l.length; m < b; m++) {
              var y = l[m], _ = this.get(y);
              _ && (this._ids.add(y), u.push(y));
            }
            break;
          case "update":
            for (var x = 0, T = l.length; x < T; x++) {
              var k = l[x], E = this.get(k);
              E ? this._ids.has(k) ? (c.push(k), f.push(a.data[x]), h.push(a.oldData[x])) : (this._ids.add(k), u.push(k)) : this._ids.has(k) && (this._ids.delete(k), d.push(k), p.push(a.oldData[x]));
            }
            break;
          case "remove":
            for (var F = 0, R = l.length; F < R; F++) {
              var $ = l[F];
              this._ids.has($) && (this._ids.delete($), d.push($), p.push(a.oldData[F]));
            }
            break;
        }
        this.length += u.length - d.length, u.length && this._trigger("add", {
          items: u
        }, o), c.length && this._trigger("update", {
          items: c,
          oldData: h,
          data: f
        }, o), d.length && this._trigger("remove", {
          items: d,
          oldData: p
        }, o);
      }
    }
  }]), r;
}(w6);
function tAe(t, e) {
  return Rn(e) === "object" && e !== null && t === e.idProp && typeof e.add == "function" && typeof e.clear == "function" && typeof e.distinct == "function" && typeof Dl(e) == "function" && typeof e.get == "function" && typeof e.getDataSet == "function" && typeof e.getIds == "function" && typeof e.length == "number" && typeof Ni(e) == "function" && typeof e.max == "function" && typeof e.min == "function" && typeof e.off == "function" && typeof e.on == "function" && typeof e.remove == "function" && typeof e.setOptions == "function" && typeof e.stream == "function" && typeof e.update == "function" && typeof e.updateOnly == "function";
}
function rAe(t, e) {
  return Rn(e) === "object" && e !== null && t === e.idProp && typeof Dl(e) == "function" && typeof e.get == "function" && typeof e.getDataSet == "function" && typeof e.getIds == "function" && typeof e.length == "number" && typeof Ni(e) == "function" && typeof e.off == "function" && typeof e.on == "function" && typeof e.stream == "function" && tAe(t, e.getDataSet());
}
/**
 * vis-timeline and vis-graph2d
 * https://visjs.github.io/vis-timeline/
 *
 * Create a fully customizable, interactive timeline with items and ranges.
 *
 * @version 7.7.2
 * @date    2023-03-22T11:14:31.874Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */
var WL = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function rt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var lE = {}, nAe = {
  get exports() {
    return lE;
  },
  set exports(t) {
    lE = t;
  }
}, Qm = function(t) {
  return t && t.Math == Math && t;
}, $n = (
  // eslint-disable-next-line es/no-global-this -- safe
  Qm(typeof globalThis == "object" && globalThis) || Qm(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Qm(typeof self == "object" && self) || Qm(typeof WL == "object" && WL) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Function("return this")()
), qt = function(t) {
  try {
    return !!t();
  } catch {
    return !0;
  }
}, iAe = qt, pv = !iAe(function() {
  var t = (function() {
  }).bind();
  return typeof t != "function" || t.hasOwnProperty("prototype");
}), sAe = pv, x6 = Function.prototype, jL = x6.apply, KL = x6.call, vv = typeof Reflect == "object" && Reflect.apply || (sAe ? KL.bind(jL) : function() {
  return KL.apply(jL, arguments);
}), S6 = pv, E6 = Function.prototype, uE = E6.call, aAe = S6 && E6.bind.bind(uE, uE), Xt = S6 ? aAe : function(t) {
  return function() {
    return uE.apply(t, arguments);
  };
}, $6 = Xt, oAe = $6({}.toString), lAe = $6("".slice), Bo = function(t) {
  return lAe(oAe(t), 8, -1);
}, uAe = Bo, cAe = Xt, yO = function(t) {
  if (uAe(t) === "Function")
    return cAe(t);
}, cE = typeof document == "object" && document.all, dAe = typeof cE > "u" && cE !== void 0, k6 = {
  all: cE,
  IS_HTMLDDA: dAe
}, D6 = k6, hAe = D6.all, kn = D6.IS_HTMLDDA ? function(t) {
  return typeof t == "function" || t === hAe;
} : function(t) {
  return typeof t == "function";
}, mv = {}, fAe = qt, pn = !fAe(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
}), pAe = pv, Zm = Function.prototype.call, ws = pAe ? Zm.bind(Zm) : function() {
  return Zm.apply(Zm, arguments);
}, gv = {}, O6 = {}.propertyIsEnumerable, A6 = Object.getOwnPropertyDescriptor, vAe = A6 && !O6.call({ 1: 2 }, 1);
gv.f = vAe ? function(e) {
  var r = A6(this, e);
  return !!r && r.enumerable;
} : O6;
var yv = function(t, e) {
  return {
    enumerable: !(t & 1),
    configurable: !(t & 2),
    writable: !(t & 4),
    value: e
  };
}, mAe = Xt, gAe = qt, yAe = Bo, uw = Object, bAe = mAe("".split), mb = gAe(function() {
  return !uw("z").propertyIsEnumerable(0);
}) ? function(t) {
  return yAe(t) == "String" ? bAe(t, "") : uw(t);
} : uw, gb = function(t) {
  return t == null;
}, _Ae = gb, wAe = TypeError, Th = function(t) {
  if (_Ae(t))
    throw wAe("Can't call method on " + t);
  return t;
}, TAe = mb, xAe = Th, Js = function(t) {
  return TAe(xAe(t));
}, zL = kn, C6 = k6, SAe = C6.all, ci = C6.IS_HTMLDDA ? function(t) {
  return typeof t == "object" ? t !== null : zL(t) || t === SAe;
} : function(t) {
  return typeof t == "object" ? t !== null : zL(t);
}, mr = {}, cw = mr, dw = $n, EAe = kn, qL = function(t) {
  return EAe(t) ? t : void 0;
}, Ts = function(t, e) {
  return arguments.length < 2 ? qL(cw[t]) || qL(dw[t]) : cw[t] && cw[t][e] || dw[t] && dw[t][e];
}, $Ae = Xt, Fr = $Ae({}.isPrototypeOf), bv = typeof navigator < "u" && String(navigator.userAgent) || "", I6 = $n, hw = bv, XL = I6.process, QL = I6.Deno, ZL = XL && XL.versions || QL && QL.version, JL = ZL && ZL.v8, Rs, My;
JL && (Rs = JL.split("."), My = Rs[0] > 0 && Rs[0] < 4 ? 1 : +(Rs[0] + Rs[1]));
!My && hw && (Rs = hw.match(/Edge\/(\d+)/), (!Rs || Rs[1] >= 74) && (Rs = hw.match(/Chrome\/(\d+)/), Rs && (My = +Rs[1])));
var _v = My, eN = _v, kAe = qt, xh = !!Object.getOwnPropertySymbols && !kAe(function() {
  var t = Symbol();
  return !String(t) || !(Object(t) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && eN && eN < 41;
}), DAe = xh, P6 = DAe && !Symbol.sham && typeof Symbol.iterator == "symbol", OAe = Ts, AAe = kn, CAe = Fr, IAe = P6, PAe = Object, wv = IAe ? function(t) {
  return typeof t == "symbol";
} : function(t) {
  var e = OAe("Symbol");
  return AAe(e) && CAe(e.prototype, PAe(t));
}, RAe = String, Sh = function(t) {
  try {
    return RAe(t);
  } catch {
    return "Object";
  }
}, MAe = kn, LAe = Sh, NAe = TypeError, fc = function(t) {
  if (MAe(t))
    return t;
  throw NAe(LAe(t) + " is not a function");
}, FAe = fc, BAe = gb, bO = function(t, e) {
  var r = t[e];
  return BAe(r) ? void 0 : FAe(r);
}, fw = ws, pw = kn, vw = ci, UAe = TypeError, VAe = function(t, e) {
  var r, n;
  if (e === "string" && pw(r = t.toString) && !vw(n = fw(r, t)) || pw(r = t.valueOf) && !vw(n = fw(r, t)) || e !== "string" && pw(r = t.toString) && !vw(n = fw(r, t)))
    return n;
  throw UAe("Can't convert object to primitive value");
}, Al = {}, YAe = {
  get exports() {
    return Al;
  },
  set exports(t) {
    Al = t;
  }
}, tN = $n, HAe = Object.defineProperty, GAe = function(t, e) {
  try {
    HAe(tN, t, { value: e, configurable: !0, writable: !0 });
  } catch {
    tN[t] = e;
  }
  return e;
}, WAe = $n, jAe = GAe, rN = "__core-js_shared__", KAe = WAe[rN] || jAe(rN, {}), _O = KAe, nN = _O;
(YAe.exports = function(t, e) {
  return nN[t] || (nN[t] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.29.0",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.29.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var zAe = Th, qAe = Object, Zi = function(t) {
  return qAe(zAe(t));
}, XAe = Xt, QAe = Zi, ZAe = XAe({}.hasOwnProperty), di = Object.hasOwn || function(e, r) {
  return ZAe(QAe(e), r);
}, JAe = Xt, eCe = 0, tCe = Math.random(), rCe = JAe(1 .toString), yb = function(t) {
  return "Symbol(" + (t === void 0 ? "" : t) + ")_" + rCe(++eCe + tCe, 36);
}, nCe = $n, iCe = Al, iN = di, sCe = yb, aCe = xh, oCe = P6, ud = nCe.Symbol, mw = iCe("wks"), lCe = oCe ? ud.for || ud : ud && ud.withoutSetter || sCe, Jr = function(t) {
  return iN(mw, t) || (mw[t] = aCe && iN(ud, t) ? ud[t] : lCe("Symbol." + t)), mw[t];
}, uCe = ws, sN = ci, aN = wv, cCe = bO, dCe = VAe, hCe = Jr, fCe = TypeError, pCe = hCe("toPrimitive"), vCe = function(t, e) {
  if (!sN(t) || aN(t))
    return t;
  var r = cCe(t, pCe), n;
  if (r) {
    if (e === void 0 && (e = "default"), n = uCe(r, t, e), !sN(n) || aN(n))
      return n;
    throw fCe("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), dCe(t, e);
}, mCe = vCe, gCe = wv, bb = function(t) {
  var e = mCe(t, "string");
  return gCe(e) ? e : e + "";
}, yCe = $n, oN = ci, dE = yCe.document, bCe = oN(dE) && oN(dE.createElement), R6 = function(t) {
  return bCe ? dE.createElement(t) : {};
}, _Ce = pn, wCe = qt, TCe = R6, M6 = !_Ce && !wCe(function() {
  return Object.defineProperty(TCe("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
}), xCe = pn, SCe = ws, ECe = gv, $Ce = yv, kCe = Js, DCe = bb, OCe = di, ACe = M6, lN = Object.getOwnPropertyDescriptor;
mv.f = xCe ? lN : function(e, r) {
  if (e = kCe(e), r = DCe(r), ACe)
    try {
      return lN(e, r);
    } catch {
    }
  if (OCe(e, r))
    return $Ce(!SCe(ECe.f, e, r), e[r]);
};
var CCe = qt, ICe = kn, PCe = /#|\.prototype\./, Tv = function(t, e) {
  var r = MCe[RCe(t)];
  return r == NCe ? !0 : r == LCe ? !1 : ICe(e) ? CCe(e) : !!e;
}, RCe = Tv.normalize = function(t) {
  return String(t).replace(PCe, ".").toLowerCase();
}, MCe = Tv.data = {}, LCe = Tv.NATIVE = "N", NCe = Tv.POLYFILL = "P", FCe = Tv, uN = yO, BCe = fc, UCe = pv, VCe = uN(uN.bind), xv = function(t, e) {
  return BCe(t), e === void 0 ? t : UCe ? VCe(t, e) : function() {
    return t.apply(e, arguments);
  };
}, xs = {}, YCe = pn, HCe = qt, L6 = YCe && HCe(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype != 42;
}), GCe = ci, WCe = String, jCe = TypeError, ea = function(t) {
  if (GCe(t))
    return t;
  throw jCe(WCe(t) + " is not an object");
}, KCe = pn, zCe = M6, qCe = L6, Jm = ea, cN = bb, XCe = TypeError, gw = Object.defineProperty, QCe = Object.getOwnPropertyDescriptor, yw = "enumerable", bw = "configurable", _w = "writable";
xs.f = KCe ? qCe ? function(e, r, n) {
  if (Jm(e), r = cN(r), Jm(n), typeof e == "function" && r === "prototype" && "value" in n && _w in n && !n[_w]) {
    var s = QCe(e, r);
    s && s[_w] && (e[r] = n.value, n = {
      configurable: bw in n ? n[bw] : s[bw],
      enumerable: yw in n ? n[yw] : s[yw],
      writable: !1
    });
  }
  return gw(e, r, n);
} : gw : function(e, r, n) {
  if (Jm(e), r = cN(r), Jm(n), zCe)
    try {
      return gw(e, r, n);
    } catch {
    }
  if ("get" in n || "set" in n)
    throw XCe("Accessors not supported");
  return "value" in n && (e[r] = n.value), e;
};
var ZCe = pn, JCe = xs, eIe = yv, Eh = ZCe ? function(t, e, r) {
  return JCe.f(t, e, eIe(1, r));
} : function(t, e, r) {
  return t[e] = r, t;
}, eg = $n, tIe = vv, rIe = yO, nIe = kn, iIe = mv.f, sIe = FCe, Bc = mr, aIe = xv, Uc = Eh, dN = di, oIe = function(t) {
  var e = function(r, n, s) {
    if (this instanceof e) {
      switch (arguments.length) {
        case 0:
          return new t();
        case 1:
          return new t(r);
        case 2:
          return new t(r, n);
      }
      return new t(r, n, s);
    }
    return tIe(t, this, arguments);
  };
  return e.prototype = t.prototype, e;
}, lt = function(t, e) {
  var r = t.target, n = t.global, s = t.stat, a = t.proto, o = n ? eg : s ? eg[r] : (eg[r] || {}).prototype, l = n ? Bc : Bc[r] || Uc(Bc, r, {})[r], u = l.prototype, c, d, h, f, p, m, b, y, _;
  for (f in e)
    c = sIe(n ? f : r + (s ? "." : "#") + f, t.forced), d = !c && o && dN(o, f), m = l[f], d && (t.dontCallGetSet ? (_ = iIe(o, f), b = _ && _.value) : b = o[f]), p = d && b ? b : e[f], !(d && typeof m == typeof p) && (t.bind && d ? y = aIe(p, eg) : t.wrap && d ? y = oIe(p) : a && nIe(p) ? y = rIe(p) : y = p, (t.sham || p && p.sham || m && m.sham) && Uc(y, "sham", !0), Uc(l, f, y), a && (h = r + "Prototype", dN(Bc, h) || Uc(Bc, h, {}), Uc(Bc[h], f, p), t.real && u && (c || !u[f]) && Uc(u, f, p)));
}, lIe = Xt, _b = lIe([].slice), N6 = Xt, uIe = fc, cIe = ci, dIe = di, hN = _b, hIe = pv, F6 = Function, fIe = N6([].concat), pIe = N6([].join), ww = {}, vIe = function(t, e, r) {
  if (!dIe(ww, e)) {
    for (var n = [], s = 0; s < e; s++)
      n[s] = "a[" + s + "]";
    ww[e] = F6("C,a", "return new C(" + pIe(n, ",") + ")");
  }
  return ww[e](t, r);
}, B6 = hIe ? F6.bind : function(e) {
  var r = uIe(this), n = r.prototype, s = hN(arguments, 1), a = function() {
    var l = fIe(s, hN(arguments));
    return this instanceof a ? vIe(r, l.length, l) : r.apply(e, l);
  };
  return cIe(n) && (a.prototype = n), a;
}, mIe = Jr, gIe = mIe("toStringTag"), U6 = {};
U6[gIe] = "z";
var wO = String(U6) === "[object z]", yIe = wO, bIe = kn, Lg = Bo, _Ie = Jr, wIe = _Ie("toStringTag"), TIe = Object, xIe = Lg(function() {
  return arguments;
}()) == "Arguments", SIe = function(t, e) {
  try {
    return t[e];
  } catch {
  }
}, $h = yIe ? Lg : function(t) {
  var e, r, n;
  return t === void 0 ? "Undefined" : t === null ? "Null" : typeof (r = SIe(e = TIe(t), wIe)) == "string" ? r : xIe ? Lg(e) : (n = Lg(e)) == "Object" && bIe(e.callee) ? "Arguments" : n;
}, EIe = Xt, $Ie = kn, hE = _O, kIe = EIe(Function.toString);
$Ie(hE.inspectSource) || (hE.inspectSource = function(t) {
  return kIe(t);
});
var DIe = hE.inspectSource, OIe = Xt, AIe = qt, V6 = kn, CIe = $h, IIe = Ts, PIe = DIe, Y6 = function() {
}, RIe = [], H6 = IIe("Reflect", "construct"), TO = /^\s*(?:class|function)\b/, MIe = OIe(TO.exec), LIe = !TO.exec(Y6), ef = function(e) {
  if (!V6(e))
    return !1;
  try {
    return H6(Y6, RIe, e), !0;
  } catch {
    return !1;
  }
}, G6 = function(e) {
  if (!V6(e))
    return !1;
  switch (CIe(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return LIe || !!MIe(TO, PIe(e));
  } catch {
    return !0;
  }
};
G6.sham = !0;
var wb = !H6 || AIe(function() {
  var t;
  return ef(ef.call) || !ef(Object) || !ef(function() {
    t = !0;
  }) || t;
}) ? G6 : ef, NIe = wb, FIe = Sh, BIe = TypeError, UIe = function(t) {
  if (NIe(t))
    return t;
  throw BIe(FIe(t) + " is not a constructor");
}, Tb = {}, VIe = Math.ceil, YIe = Math.floor, HIe = Math.trunc || function(e) {
  var r = +e;
  return (r > 0 ? YIe : VIe)(r);
}, GIe = HIe, Sv = function(t) {
  var e = +t;
  return e !== e || e === 0 ? 0 : GIe(e);
}, WIe = Sv, jIe = Math.max, KIe = Math.min, Ev = function(t, e) {
  var r = WIe(t);
  return r < 0 ? jIe(r + e, 0) : KIe(r, e);
}, zIe = Sv, qIe = Math.min, XIe = function(t) {
  return t > 0 ? qIe(zIe(t), 9007199254740991) : 0;
}, QIe = XIe, ta = function(t) {
  return QIe(t.length);
}, ZIe = Js, JIe = Ev, ePe = ta, fN = function(t) {
  return function(e, r, n) {
    var s = ZIe(e), a = ePe(s), o = JIe(n, a), l;
    if (t && r != r) {
      for (; a > o; )
        if (l = s[o++], l != l)
          return !0;
    } else
      for (; a > o; o++)
        if ((t || o in s) && s[o] === r)
          return t || o || 0;
    return !t && -1;
  };
}, xO = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: fN(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: fN(!1)
}, $v = {}, tPe = Xt, Tw = di, rPe = Js, nPe = xO.indexOf, iPe = $v, pN = tPe([].push), W6 = function(t, e) {
  var r = rPe(t), n = 0, s = [], a;
  for (a in r)
    !Tw(iPe, a) && Tw(r, a) && pN(s, a);
  for (; e.length > n; )
    Tw(r, a = e[n++]) && (~nPe(s, a) || pN(s, a));
  return s;
}, SO = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], sPe = W6, aPe = SO, kv = Object.keys || function(e) {
  return sPe(e, aPe);
}, oPe = pn, lPe = L6, uPe = xs, cPe = ea, dPe = Js, hPe = kv;
Tb.f = oPe && !lPe ? Object.defineProperties : function(e, r) {
  cPe(e);
  for (var n = dPe(r), s = hPe(r), a = s.length, o = 0, l; a > o; )
    uPe.f(e, l = s[o++], n[l]);
  return e;
};
var fPe = Ts, pPe = fPe("document", "documentElement"), vPe = Al, mPe = yb, vN = vPe("keys"), xb = function(t) {
  return vN[t] || (vN[t] = mPe(t));
}, gPe = ea, yPe = Tb, mN = SO, bPe = $v, _Pe = pPe, wPe = R6, TPe = xb, gN = ">", yN = "<", fE = "prototype", pE = "script", j6 = TPe("IE_PROTO"), xw = function() {
}, K6 = function(t) {
  return yN + pE + gN + t + yN + "/" + pE + gN;
}, bN = function(t) {
  t.write(K6("")), t.close();
  var e = t.parentWindow.Object;
  return t = null, e;
}, xPe = function() {
  var t = wPe("iframe"), e = "java" + pE + ":", r;
  return t.style.display = "none", _Pe.appendChild(t), t.src = String(e), r = t.contentWindow.document, r.open(), r.write(K6("document.F=Object")), r.close(), r.F;
}, tg, Ng = function() {
  try {
    tg = new ActiveXObject("htmlfile");
  } catch {
  }
  Ng = typeof document < "u" ? document.domain && tg ? bN(tg) : xPe() : bN(tg);
  for (var t = mN.length; t--; )
    delete Ng[fE][mN[t]];
  return Ng();
};
bPe[j6] = !0;
var kh = Object.create || function(e, r) {
  var n;
  return e !== null ? (xw[fE] = gPe(e), n = new xw(), xw[fE] = null, n[j6] = e) : n = Ng(), r === void 0 ? n : yPe.f(n, r);
}, SPe = lt, EPe = Ts, Sw = vv, $Pe = B6, _N = UIe, kPe = ea, wN = ci, DPe = kh, z6 = qt, EO = EPe("Reflect", "construct"), OPe = Object.prototype, APe = [].push, q6 = z6(function() {
  function t() {
  }
  return !(EO(function() {
  }, [], t) instanceof t);
}), X6 = !z6(function() {
  EO(function() {
  });
}), TN = q6 || X6;
SPe({ target: "Reflect", stat: !0, forced: TN, sham: TN }, {
  construct: function(e, r) {
    _N(e), kPe(r);
    var n = arguments.length < 3 ? e : _N(arguments[2]);
    if (X6 && !q6)
      return EO(e, r, n);
    if (e == n) {
      switch (r.length) {
        case 0:
          return new e();
        case 1:
          return new e(r[0]);
        case 2:
          return new e(r[0], r[1]);
        case 3:
          return new e(r[0], r[1], r[2]);
        case 4:
          return new e(r[0], r[1], r[2], r[3]);
      }
      var s = [null];
      return Sw(APe, s, r), new (Sw($Pe, e, s))();
    }
    var a = n.prototype, o = DPe(wN(a) ? a : OPe), l = Sw(e, o, r);
    return wN(l) ? l : o;
  }
});
var CPe = mr, IPe = CPe.Reflect.construct, PPe = IPe, RPe = PPe;
(function(t) {
  t.exports = RPe;
})(nAe);
var nt = /* @__PURE__ */ rt(lE);
function dr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var vE = {}, MPe = {
  get exports() {
    return vE;
  },
  set exports(t) {
    vE = t;
  }
}, mE = {}, LPe = {
  get exports() {
    return mE;
  },
  set exports(t) {
    mE = t;
  }
}, gE = {}, NPe = {
  get exports() {
    return gE;
  },
  set exports(t) {
    gE = t;
  }
}, FPe = lt, BPe = pn, xN = xs.f;
FPe({ target: "Object", stat: !0, forced: Object.defineProperty !== xN, sham: !BPe }, {
  defineProperty: xN
});
var UPe = mr, Q6 = UPe.Object, VPe = NPe.exports = function(e, r, n) {
  return Q6.defineProperty(e, r, n);
};
Q6.defineProperty.sham && (VPe.sham = !0);
var YPe = gE, Z6 = YPe, HPe = Z6, GPe = HPe, WPe = GPe, jPe = WPe;
(function(t) {
  t.exports = jPe;
})(LPe);
(function(t) {
  t.exports = mE;
})(MPe);
var Sb = /* @__PURE__ */ rt(vE), yE = {}, KPe = {
  get exports() {
    return yE;
  },
  set exports(t) {
    yE = t;
  }
}, bE = {}, zPe = {
  get exports() {
    return bE;
  },
  set exports(t) {
    bE = t;
  }
}, qPe = Bo, pc = Array.isArray || function(e) {
  return qPe(e) == "Array";
}, XPe = TypeError, QPe = 9007199254740991, J6 = function(t) {
  if (t > QPe)
    throw XPe("Maximum allowed index exceeded");
  return t;
}, ZPe = bb, JPe = xs, eRe = yv, Dh = function(t, e, r) {
  var n = ZPe(e);
  n in t ? JPe.f(t, n, eRe(0, r)) : t[n] = r;
}, SN = pc, tRe = wb, rRe = ci, nRe = Jr, iRe = nRe("species"), EN = Array, sRe = function(t) {
  var e;
  return SN(t) && (e = t.constructor, tRe(e) && (e === EN || SN(e.prototype)) ? e = void 0 : rRe(e) && (e = e[iRe], e === null && (e = void 0))), e === void 0 ? EN : e;
}, aRe = sRe, $O = function(t, e) {
  return new (aRe(t))(e === 0 ? 0 : e);
}, oRe = qt, lRe = Jr, uRe = _v, cRe = lRe("species"), Dv = function(t) {
  return uRe >= 51 || !oRe(function() {
    var e = [], r = e.constructor = {};
    return r[cRe] = function() {
      return { foo: 1 };
    }, e[t](Boolean).foo !== 1;
  });
}, dRe = lt, hRe = qt, fRe = pc, pRe = ci, vRe = Zi, mRe = ta, $N = J6, kN = Dh, gRe = $O, yRe = Dv, bRe = Jr, _Re = _v, eG = bRe("isConcatSpreadable"), wRe = _Re >= 51 || !hRe(function() {
  var t = [];
  return t[eG] = !1, t.concat()[0] !== t;
}), TRe = function(t) {
  if (!pRe(t))
    return !1;
  var e = t[eG];
  return e !== void 0 ? !!e : fRe(t);
}, xRe = !wRe || !yRe("concat");
dRe({ target: "Array", proto: !0, arity: 1, forced: xRe }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(e) {
    var r = vRe(this), n = gRe(r, 0), s = 0, a, o, l, u, c;
    for (a = -1, l = arguments.length; a < l; a++)
      if (c = a === -1 ? r : arguments[a], TRe(c))
        for (u = mRe(c), $N(s + u), o = 0; o < u; o++, s++)
          o in c && kN(n, s, c[o]);
      else
        $N(s + 1), kN(n, s++, c);
    return n.length = s, n;
  }
});
var SRe = $h, ERe = String, ra = function(t) {
  if (SRe(t) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return ERe(t);
}, Ov = {}, $Re = W6, kRe = SO, DRe = kRe.concat("length", "prototype");
Ov.f = Object.getOwnPropertyNames || function(e) {
  return $Re(e, DRe);
};
var kO = {}, DN = Ev, ORe = ta, ARe = Dh, CRe = Array, IRe = Math.max, tG = function(t, e, r) {
  for (var n = ORe(t), s = DN(e, n), a = DN(r === void 0 ? n : r, n), o = CRe(IRe(a - s, 0)), l = 0; s < a; s++, l++)
    ARe(o, l, t[s]);
  return o.length = l, o;
}, PRe = Bo, RRe = Js, rG = Ov.f, MRe = tG, nG = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], LRe = function(t) {
  try {
    return rG(t);
  } catch {
    return MRe(nG);
  }
};
kO.f = function(e) {
  return nG && PRe(e) == "Window" ? LRe(e) : rG(RRe(e));
};
var Av = {};
Av.f = Object.getOwnPropertySymbols;
var NRe = Eh, Cv = function(t, e, r, n) {
  return n && n.enumerable ? t[e] = r : NRe(t, e, r), t;
}, FRe = xs, DO = function(t, e, r) {
  return FRe.f(t, e, r);
}, Iv = {}, BRe = Jr;
Iv.f = BRe;
var ON = mr, URe = di, VRe = Iv, YRe = xs.f, jr = function(t) {
  var e = ON.Symbol || (ON.Symbol = {});
  URe(e, t) || YRe(e, t, {
    value: VRe.f(t)
  });
}, HRe = ws, GRe = Ts, WRe = Jr, jRe = Cv, iG = function() {
  var t = GRe("Symbol"), e = t && t.prototype, r = e && e.valueOf, n = WRe("toPrimitive");
  e && !e[n] && jRe(e, n, function(s) {
    return HRe(r, this);
  }, { arity: 1 });
}, KRe = wO, zRe = $h, qRe = KRe ? {}.toString : function() {
  return "[object " + zRe(this) + "]";
}, XRe = wO, QRe = xs.f, ZRe = Eh, JRe = di, eMe = qRe, tMe = Jr, AN = tMe("toStringTag"), Oh = function(t, e, r, n) {
  if (t) {
    var s = r ? t : t.prototype;
    JRe(s, AN) || QRe(s, AN, { configurable: !0, value: e }), n && !XRe && ZRe(s, "toString", eMe);
  }
}, rMe = $n, nMe = kn, CN = rMe.WeakMap, iMe = nMe(CN) && /native code/.test(String(CN)), sMe = iMe, sG = $n, aMe = ci, oMe = Eh, Ew = di, $w = _O, lMe = xb, uMe = $v, IN = "Object already initialized", _E = sG.TypeError, cMe = sG.WeakMap, Ly, pp, Ny, dMe = function(t) {
  return Ny(t) ? pp(t) : Ly(t, {});
}, hMe = function(t) {
  return function(e) {
    var r;
    if (!aMe(e) || (r = pp(e)).type !== t)
      throw _E("Incompatible receiver, " + t + " required");
    return r;
  };
};
if (sMe || $w.state) {
  var ua = $w.state || ($w.state = new cMe());
  ua.get = ua.get, ua.has = ua.has, ua.set = ua.set, Ly = function(t, e) {
    if (ua.has(t))
      throw _E(IN);
    return e.facade = t, ua.set(t, e), e;
  }, pp = function(t) {
    return ua.get(t) || {};
  }, Ny = function(t) {
    return ua.has(t);
  };
} else {
  var Vc = lMe("state");
  uMe[Vc] = !0, Ly = function(t, e) {
    if (Ew(t, Vc))
      throw _E(IN);
    return e.facade = t, oMe(t, Vc, e), e;
  }, pp = function(t) {
    return Ew(t, Vc) ? t[Vc] : {};
  }, Ny = function(t) {
    return Ew(t, Vc);
  };
}
var Pv = {
  set: Ly,
  get: pp,
  has: Ny,
  enforce: dMe,
  getterFor: hMe
}, fMe = xv, pMe = Xt, vMe = mb, mMe = Zi, gMe = ta, yMe = $O, PN = pMe([].push), Zo = function(t) {
  var e = t == 1, r = t == 2, n = t == 3, s = t == 4, a = t == 6, o = t == 7, l = t == 5 || a;
  return function(u, c, d, h) {
    for (var f = mMe(u), p = vMe(f), m = fMe(c, d), b = gMe(p), y = 0, _ = h || yMe, x = e ? _(u, b) : r || o ? _(u, 0) : void 0, T, k; b > y; y++)
      if ((l || y in p) && (T = p[y], k = m(T, y, f), t))
        if (e)
          x[y] = k;
        else if (k)
          switch (t) {
            case 3:
              return !0;
            case 5:
              return T;
            case 6:
              return y;
            case 2:
              PN(x, T);
          }
        else
          switch (t) {
            case 4:
              return !1;
            case 7:
              PN(x, T);
          }
    return a ? -1 : n || s ? s : x;
  };
}, Uo = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: Zo(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: Zo(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: Zo(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: Zo(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: Zo(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: Zo(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: Zo(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: Zo(7)
}, Eb = lt, OO = $n, AO = ws, bMe = Xt, Hd = pn, Gd = xh, _Me = qt, _n = di, wMe = Fr, wE = ea, $b = Js, CO = bb, TMe = ra, TE = yv, vp = kh, aG = kv, xMe = Ov, oG = kO, SMe = Av, lG = mv, uG = xs, EMe = Tb, cG = gv, RN = Cv, $Me = DO, IO = Al, kMe = xb, dG = $v, MN = yb, DMe = Jr, OMe = Iv, AMe = jr, CMe = iG, IMe = Oh, hG = Pv, kb = Uo.forEach, wi = kMe("hidden"), Db = "Symbol", mp = "prototype", PMe = hG.set, LN = hG.getterFor(Db), Us = Object[mp], ku = OO.Symbol, gf = ku && ku[mp], RMe = OO.TypeError, kw = OO.QObject, fG = lG.f, lu = uG.f, pG = oG.f, MMe = cG.f, vG = bMe([].push), Do = IO("symbols"), Rv = IO("op-symbols"), LMe = IO("wks"), xE = !kw || !kw[mp] || !kw[mp].findChild, SE = Hd && _Me(function() {
  return vp(lu({}, "a", {
    get: function() {
      return lu(this, "a", { value: 7 }).a;
    }
  })).a != 7;
}) ? function(t, e, r) {
  var n = fG(Us, e);
  n && delete Us[e], lu(t, e, r), n && t !== Us && lu(Us, e, n);
} : lu, Dw = function(t, e) {
  var r = Do[t] = vp(gf);
  return PMe(r, {
    type: Db,
    tag: t,
    description: e
  }), Hd || (r.description = e), r;
}, Ob = function(e, r, n) {
  e === Us && Ob(Rv, r, n), wE(e);
  var s = CO(r);
  return wE(n), _n(Do, s) ? (n.enumerable ? (_n(e, wi) && e[wi][s] && (e[wi][s] = !1), n = vp(n, { enumerable: TE(0, !1) })) : (_n(e, wi) || lu(e, wi, TE(1, {})), e[wi][s] = !0), SE(e, s, n)) : lu(e, s, n);
}, PO = function(e, r) {
  wE(e);
  var n = $b(r), s = aG(n).concat(bG(n));
  return kb(s, function(a) {
    (!Hd || AO(mG, n, a)) && Ob(e, a, n[a]);
  }), e;
}, NMe = function(e, r) {
  return r === void 0 ? vp(e) : PO(vp(e), r);
}, mG = function(e) {
  var r = CO(e), n = AO(MMe, this, r);
  return this === Us && _n(Do, r) && !_n(Rv, r) ? !1 : n || !_n(this, r) || !_n(Do, r) || _n(this, wi) && this[wi][r] ? n : !0;
}, gG = function(e, r) {
  var n = $b(e), s = CO(r);
  if (!(n === Us && _n(Do, s) && !_n(Rv, s))) {
    var a = fG(n, s);
    return a && _n(Do, s) && !(_n(n, wi) && n[wi][s]) && (a.enumerable = !0), a;
  }
}, yG = function(e) {
  var r = pG($b(e)), n = [];
  return kb(r, function(s) {
    !_n(Do, s) && !_n(dG, s) && vG(n, s);
  }), n;
}, bG = function(t) {
  var e = t === Us, r = pG(e ? Rv : $b(t)), n = [];
  return kb(r, function(s) {
    _n(Do, s) && (!e || _n(Us, s)) && vG(n, Do[s]);
  }), n;
};
Gd || (ku = function() {
  if (wMe(gf, this))
    throw RMe("Symbol is not a constructor");
  var e = !arguments.length || arguments[0] === void 0 ? void 0 : TMe(arguments[0]), r = MN(e), n = function(s) {
    this === Us && AO(n, Rv, s), _n(this, wi) && _n(this[wi], r) && (this[wi][r] = !1), SE(this, r, TE(1, s));
  };
  return Hd && xE && SE(Us, r, { configurable: !0, set: n }), Dw(r, e);
}, gf = ku[mp], RN(gf, "toString", function() {
  return LN(this).tag;
}), RN(ku, "withoutSetter", function(t) {
  return Dw(MN(t), t);
}), cG.f = mG, uG.f = Ob, EMe.f = PO, lG.f = gG, xMe.f = oG.f = yG, SMe.f = bG, OMe.f = function(t) {
  return Dw(DMe(t), t);
}, Hd && $Me(gf, "description", {
  configurable: !0,
  get: function() {
    return LN(this).description;
  }
}));
Eb({ global: !0, constructor: !0, wrap: !0, forced: !Gd, sham: !Gd }, {
  Symbol: ku
});
kb(aG(LMe), function(t) {
  AMe(t);
});
Eb({ target: Db, stat: !0, forced: !Gd }, {
  useSetter: function() {
    xE = !0;
  },
  useSimple: function() {
    xE = !1;
  }
});
Eb({ target: "Object", stat: !0, forced: !Gd, sham: !Hd }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: NMe,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: Ob,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: PO,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: gG
});
Eb({ target: "Object", stat: !0, forced: !Gd }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: yG
});
CMe();
IMe(ku, Db);
dG[wi] = !0;
var FMe = xh, _G = FMe && !!Symbol.for && !!Symbol.keyFor, BMe = lt, UMe = Ts, VMe = di, YMe = ra, wG = Al, HMe = _G, Ow = wG("string-to-symbol-registry"), GMe = wG("symbol-to-string-registry");
BMe({ target: "Symbol", stat: !0, forced: !HMe }, {
  for: function(t) {
    var e = YMe(t);
    if (VMe(Ow, e))
      return Ow[e];
    var r = UMe("Symbol")(e);
    return Ow[e] = r, GMe[r] = e, r;
  }
});
var WMe = lt, jMe = di, KMe = wv, zMe = Sh, qMe = Al, XMe = _G, NN = qMe("symbol-to-string-registry");
WMe({ target: "Symbol", stat: !0, forced: !XMe }, {
  keyFor: function(e) {
    if (!KMe(e))
      throw TypeError(zMe(e) + " is not a symbol");
    if (jMe(NN, e))
      return NN[e];
  }
});
var QMe = Xt, FN = pc, ZMe = kn, BN = Bo, JMe = ra, UN = QMe([].push), eLe = function(t) {
  if (ZMe(t))
    return t;
  if (FN(t)) {
    for (var e = t.length, r = [], n = 0; n < e; n++) {
      var s = t[n];
      typeof s == "string" ? UN(r, s) : (typeof s == "number" || BN(s) == "Number" || BN(s) == "String") && UN(r, JMe(s));
    }
    var a = r.length, o = !0;
    return function(l, u) {
      if (o)
        return o = !1, u;
      if (FN(this))
        return u;
      for (var c = 0; c < a; c++)
        if (r[c] === l)
          return u;
    };
  }
}, tLe = lt, TG = Ts, xG = vv, rLe = ws, Mv = Xt, SG = qt, VN = kn, YN = wv, EG = _b, nLe = eLe, iLe = xh, sLe = String, wl = TG("JSON", "stringify"), rg = Mv(/./.exec), HN = Mv("".charAt), aLe = Mv("".charCodeAt), oLe = Mv("".replace), lLe = Mv(1 .toString), uLe = /[\uD800-\uDFFF]/g, GN = /^[\uD800-\uDBFF]$/, WN = /^[\uDC00-\uDFFF]$/, jN = !iLe || SG(function() {
  var t = TG("Symbol")();
  return wl([t]) != "[null]" || wl({ a: t }) != "{}" || wl(Object(t)) != "{}";
}), KN = SG(function() {
  return wl("\uDF06\uD834") !== '"\\udf06\\ud834"' || wl("\uDEAD") !== '"\\udead"';
}), cLe = function(t, e) {
  var r = EG(arguments), n = nLe(e);
  if (!(!VN(n) && (t === void 0 || YN(t))))
    return r[1] = function(s, a) {
      if (VN(n) && (a = rLe(n, this, sLe(s), a)), !YN(a))
        return a;
    }, xG(wl, null, r);
}, dLe = function(t, e, r) {
  var n = HN(r, e - 1), s = HN(r, e + 1);
  return rg(GN, t) && !rg(WN, s) || rg(WN, t) && !rg(GN, n) ? "\\u" + lLe(aLe(t, 0), 16) : t;
};
wl && tLe({ target: "JSON", stat: !0, arity: 3, forced: jN || KN }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(e, r, n) {
    var s = EG(arguments), a = xG(jN ? cLe : wl, null, s);
    return KN && typeof a == "string" ? oLe(a, uLe, dLe) : a;
  }
});
var hLe = lt, fLe = xh, pLe = qt, $G = Av, vLe = Zi, mLe = !fLe || pLe(function() {
  $G.f(1);
});
hLe({ target: "Object", stat: !0, forced: mLe }, {
  getOwnPropertySymbols: function(e) {
    var r = $G.f;
    return r ? r(vLe(e)) : [];
  }
});
var gLe = jr;
gLe("asyncIterator");
var yLe = jr;
yLe("hasInstance");
var bLe = jr;
bLe("isConcatSpreadable");
var _Le = jr;
_Le("iterator");
var wLe = jr;
wLe("match");
var TLe = jr;
TLe("matchAll");
var xLe = jr;
xLe("replace");
var SLe = jr;
SLe("search");
var ELe = jr;
ELe("species");
var $Le = jr;
$Le("split");
var kLe = jr, DLe = iG;
kLe("toPrimitive");
DLe();
var OLe = Ts, ALe = jr, CLe = Oh;
ALe("toStringTag");
CLe(OLe("Symbol"), "Symbol");
var ILe = jr;
ILe("unscopables");
var PLe = $n, RLe = Oh;
RLe(PLe.JSON, "JSON", !0);
var MLe = mr, LLe = MLe.Symbol, Ah = {}, EE = pn, NLe = di, kG = Function.prototype, FLe = EE && Object.getOwnPropertyDescriptor, RO = NLe(kG, "name"), BLe = RO && (function() {
}).name === "something", ULe = RO && (!EE || EE && FLe(kG, "name").configurable), DG = {
  EXISTS: RO,
  PROPER: BLe,
  CONFIGURABLE: ULe
}, VLe = qt, OG = !VLe(function() {
  function t() {
  }
  return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
}), YLe = di, HLe = kn, GLe = Zi, WLe = xb, jLe = OG, zN = WLe("IE_PROTO"), $E = Object, KLe = $E.prototype, MO = jLe ? $E.getPrototypeOf : function(t) {
  var e = GLe(t);
  if (YLe(e, zN))
    return e[zN];
  var r = e.constructor;
  return HLe(r) && e instanceof r ? r.prototype : e instanceof $E ? KLe : null;
}, zLe = qt, qLe = kn, XLe = ci, QLe = kh, qN = MO, ZLe = Cv, JLe = Jr, kE = JLe("iterator"), AG = !1, go, Aw, Cw;
[].keys && (Cw = [].keys(), "next" in Cw ? (Aw = qN(qN(Cw)), Aw !== Object.prototype && (go = Aw)) : AG = !0);
var eNe = !XLe(go) || zLe(function() {
  var t = {};
  return go[kE].call(t) !== t;
});
eNe ? go = {} : go = QLe(go);
qLe(go[kE]) || ZLe(go, kE, function() {
  return this;
});
var CG = {
  IteratorPrototype: go,
  BUGGY_SAFARI_ITERATORS: AG
}, tNe = CG.IteratorPrototype, rNe = kh, nNe = yv, iNe = Oh, sNe = Ah, aNe = function() {
  return this;
}, oNe = function(t, e, r, n) {
  var s = e + " Iterator";
  return t.prototype = rNe(tNe, { next: nNe(+!n, r) }), iNe(t, s, !1, !0), sNe[s] = aNe, t;
}, lNe = Xt, uNe = fc, cNe = function(t, e, r) {
  try {
    return lNe(uNe(Object.getOwnPropertyDescriptor(t, e)[r]));
  } catch {
  }
}, dNe = kn, hNe = String, fNe = TypeError, pNe = function(t) {
  if (typeof t == "object" || dNe(t))
    return t;
  throw fNe("Can't set " + hNe(t) + " as a prototype");
}, vNe = cNe, mNe = ea, gNe = pNe, yNe = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var t = !1, e = {}, r;
  try {
    r = vNe(Object.prototype, "__proto__", "set"), r(e, []), t = e instanceof Array;
  } catch {
  }
  return function(s, a) {
    return mNe(s), gNe(a), t ? r(s, a) : s.__proto__ = a, s;
  };
}() : void 0), bNe = lt, _Ne = ws, wNe = DG, TNe = oNe, xNe = MO, SNe = Oh, XN = Cv, ENe = Jr, QN = Ah, $Ne = CG, kNe = wNe.PROPER, ng = $Ne.BUGGY_SAFARI_ITERATORS, Iw = ENe("iterator"), ZN = "keys", ig = "values", JN = "entries", DNe = function() {
  return this;
}, LO = function(t, e, r, n, s, a, o) {
  TNe(r, e, n);
  var l = function(_) {
    if (_ === s && f)
      return f;
    if (!ng && _ in d)
      return d[_];
    switch (_) {
      case ZN:
        return function() {
          return new r(this, _);
        };
      case ig:
        return function() {
          return new r(this, _);
        };
      case JN:
        return function() {
          return new r(this, _);
        };
    }
    return function() {
      return new r(this);
    };
  }, u = e + " Iterator", c = !1, d = t.prototype, h = d[Iw] || d["@@iterator"] || s && d[s], f = !ng && h || l(s), p = e == "Array" && d.entries || h, m, b, y;
  if (p && (m = xNe(p.call(new t())), m !== Object.prototype && m.next && (SNe(m, u, !0, !0), QN[u] = DNe)), kNe && s == ig && h && h.name !== ig && (c = !0, f = function() {
    return _Ne(h, this);
  }), s)
    if (b = {
      values: l(ig),
      keys: a ? f : l(ZN),
      entries: l(JN)
    }, o)
      for (y in b)
        (ng || c || !(y in d)) && XN(d, y, b[y]);
    else
      bNe({ target: e, proto: !0, forced: ng || c }, b);
  return o && d[Iw] !== f && XN(d, Iw, f, { name: s }), QN[e] = f, b;
}, NO = function(t, e) {
  return { value: t, done: e };
}, ONe = Js, eF = Ah, IG = Pv;
xs.f;
var ANe = LO, sg = NO, PG = "Array Iterator", CNe = IG.set, INe = IG.getterFor(PG);
ANe(Array, "Array", function(t, e) {
  CNe(this, {
    type: PG,
    target: ONe(t),
    // target
    index: 0,
    // next index
    kind: e
    // kind
  });
}, function() {
  var t = INe(this), e = t.target, r = t.kind, n = t.index++;
  return !e || n >= e.length ? (t.target = void 0, sg(void 0, !0)) : r == "keys" ? sg(n, !1) : r == "values" ? sg(e[n], !1) : sg([n, e[n]], !1);
}, "values");
eF.Arguments = eF.Array;
var PNe = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, RNe = PNe, MNe = $n, LNe = $h, NNe = Eh, tF = Ah, FNe = Jr, rF = FNe("toStringTag");
for (var Pw in RNe) {
  var nF = MNe[Pw], Rw = nF && nF.prototype;
  Rw && LNe(Rw) !== rF && NNe(Rw, rF, Pw), tF[Pw] = tF.Array;
}
var BNe = LLe, RG = BNe, UNe = jr;
UNe("dispose");
var VNe = RG, YNe = VNe, HNe = jr;
HNe("asyncDispose");
var GNe = lt, WNe = Ts, jNe = Xt, MG = WNe("Symbol"), KNe = MG.keyFor, zNe = jNe(MG.prototype.valueOf);
GNe({ target: "Symbol", stat: !0 }, {
  isRegistered: function(e) {
    try {
      return KNe(zNe(e)) !== void 0;
    } catch {
      return !1;
    }
  }
});
var qNe = lt, XNe = Al, LG = Ts, QNe = Xt, ZNe = wv, JNe = Jr, Fy = LG("Symbol"), iF = Fy.isWellKnown, NG = LG("Object", "getOwnPropertyNames"), eFe = QNe(Fy.prototype.valueOf), sF = XNe("wks");
for (var Mw = 0, aF = NG(Fy), tFe = aF.length; Mw < tFe; Mw++)
  try {
    var oF = aF[Mw];
    ZNe(Fy[oF]) && JNe(oF);
  } catch {
  }
qNe({ target: "Symbol", stat: !0, forced: !0 }, {
  isWellKnown: function(e) {
    if (iF && iF(e))
      return !0;
    try {
      for (var r = eFe(e), n = 0, s = NG(sF), a = s.length; n < a; n++)
        if (sF[s[n]] == r)
          return !0;
    } catch {
    }
    return !1;
  }
});
var rFe = jr;
rFe("matcher");
var nFe = jr;
nFe("metadataKey");
var iFe = jr;
iFe("observable");
var sFe = jr;
sFe("metadata");
var aFe = jr;
aFe("patternMatch");
var oFe = jr;
oFe("replaceAll");
var lFe = YNe, uFe = lFe;
(function(t) {
  t.exports = uFe;
})(zPe);
(function(t) {
  t.exports = bE;
})(KPe);
var cd = /* @__PURE__ */ rt(yE), DE = {}, cFe = {
  get exports() {
    return DE;
  },
  set exports(t) {
    DE = t;
  }
}, OE = {}, dFe = {
  get exports() {
    return OE;
  },
  set exports(t) {
    OE = t;
  }
}, FO = Xt, hFe = Sv, fFe = ra, pFe = Th, vFe = FO("".charAt), lF = FO("".charCodeAt), mFe = FO("".slice), uF = function(t) {
  return function(e, r) {
    var n = fFe(pFe(e)), s = hFe(r), a = n.length, o, l;
    return s < 0 || s >= a ? t ? "" : void 0 : (o = lF(n, s), o < 55296 || o > 56319 || s + 1 === a || (l = lF(n, s + 1)) < 56320 || l > 57343 ? t ? vFe(n, s) : o : t ? mFe(n, s, s + 2) : (o - 55296 << 10) + (l - 56320) + 65536);
  };
}, gFe = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: uF(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: uF(!0)
}, yFe = gFe.charAt, bFe = ra, FG = Pv, _Fe = LO, cF = NO, BG = "String Iterator", wFe = FG.set, TFe = FG.getterFor(BG);
_Fe(String, "String", function(t) {
  wFe(this, {
    type: BG,
    string: bFe(t),
    index: 0
  });
}, function() {
  var e = TFe(this), r = e.string, n = e.index, s;
  return n >= r.length ? cF(void 0, !0) : (s = yFe(r, n), e.index += s.length, cF(s, !1));
});
var xFe = Iv, SFe = xFe.f("iterator"), EFe = SFe, $Fe = EFe, kFe = $Fe, DFe = kFe, OFe = DFe, AFe = OFe;
(function(t) {
  t.exports = AFe;
})(dFe);
(function(t) {
  t.exports = OE;
})(cFe);
var CFe = /* @__PURE__ */ rt(DE);
function mt(t) {
  "@babel/helpers - typeof";
  return mt = typeof cd == "function" && typeof CFe == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof cd == "function" && e.constructor === cd && e !== cd.prototype ? "symbol" : typeof e;
  }, mt(t);
}
var AE = {}, IFe = {
  get exports() {
    return AE;
  },
  set exports(t) {
    AE = t;
  }
}, CE = {}, PFe = {
  get exports() {
    return CE;
  },
  set exports(t) {
    CE = t;
  }
}, RFe = Iv, MFe = RFe.f("toPrimitive"), LFe = MFe, NFe = LFe, FFe = NFe, BFe = FFe, UFe = BFe, VFe = UFe;
(function(t) {
  t.exports = VFe;
})(PFe);
(function(t) {
  t.exports = CE;
})(IFe);
var YFe = /* @__PURE__ */ rt(AE);
function HFe(t, e) {
  if (mt(t) !== "object" || t === null)
    return t;
  var r = t[YFe];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (mt(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function UG(t) {
  var e = HFe(t, "string");
  return mt(e) === "symbol" ? e : String(e);
}
function dF(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Sb(t, UG(n.key), n);
  }
}
function hr(t, e, r) {
  return e && dF(t.prototype, e), r && dF(t, r), Sb(t, "prototype", {
    writable: !1
  }), t;
}
function Vn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
var IE = {}, GFe = {
  get exports() {
    return IE;
  },
  set exports(t) {
    IE = t;
  }
}, PE = {}, WFe = {
  get exports() {
    return PE;
  },
  set exports(t) {
    PE = t;
  }
}, jFe = lt, KFe = pn, zFe = kh;
jFe({ target: "Object", stat: !0, sham: !KFe }, {
  create: zFe
});
var qFe = mr, XFe = qFe.Object, QFe = function(e, r) {
  return XFe.create(e, r);
}, ZFe = QFe, VG = ZFe, JFe = VG, e2e = JFe, t2e = e2e, r2e = t2e;
(function(t) {
  t.exports = r2e;
})(WFe);
(function(t) {
  t.exports = PE;
})(GFe);
var n2e = /* @__PURE__ */ rt(IE), RE = {}, i2e = {
  get exports() {
    return RE;
  },
  set exports(t) {
    RE = t;
  }
}, ME = {}, s2e = {
  get exports() {
    return ME;
  },
  set exports(t) {
    ME = t;
  }
}, a2e = lt, o2e = yNe;
a2e({ target: "Object", stat: !0 }, {
  setPrototypeOf: o2e
});
var l2e = mr, u2e = l2e.Object.setPrototypeOf, c2e = u2e, d2e = c2e, h2e = d2e, f2e = h2e, p2e = f2e, v2e = p2e;
(function(t) {
  t.exports = v2e;
})(s2e);
(function(t) {
  t.exports = ME;
})(i2e);
var LE = /* @__PURE__ */ rt(RE), NE = {}, m2e = {
  get exports() {
    return NE;
  },
  set exports(t) {
    NE = t;
  }
}, FE = {}, g2e = {
  get exports() {
    return FE;
  },
  set exports(t) {
    FE = t;
  }
}, y2e = lt, hF = B6;
y2e({ target: "Function", proto: !0, forced: Function.bind !== hF }, {
  bind: hF
});
var b2e = mr, sn = function(t) {
  return b2e[t + "Prototype"];
}, _2e = sn, w2e = _2e("Function").bind, T2e = Fr, x2e = w2e, Lw = Function.prototype, S2e = function(t) {
  var e = t.bind;
  return t === Lw || T2e(Lw, t) && e === Lw.bind ? x2e : e;
}, E2e = S2e, YG = E2e, $2e = YG, k2e = $2e, D2e = k2e, O2e = D2e;
(function(t) {
  t.exports = O2e;
})(g2e);
(function(t) {
  t.exports = FE;
})(m2e);
var HG = /* @__PURE__ */ rt(NE);
function BE(t, e) {
  var r;
  return BE = LE ? HG(r = LE).call(r) : function(s, a) {
    return s.__proto__ = a, s;
  }, BE(t, e);
}
function Ji(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = n2e(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Sb(t, "prototype", {
    writable: !1
  }), e && BE(t, e);
}
function es(t, e) {
  if (e && (mt(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Vn(t);
}
var UE = {}, A2e = {
  get exports() {
    return UE;
  },
  set exports(t) {
    UE = t;
  }
}, VE = {}, C2e = {
  get exports() {
    return VE;
  },
  set exports(t) {
    VE = t;
  }
}, I2e = lt, P2e = qt, R2e = Zi, GG = MO, M2e = OG, L2e = P2e(function() {
  GG(1);
});
I2e({ target: "Object", stat: !0, forced: L2e, sham: !M2e }, {
  getPrototypeOf: function(e) {
    return GG(R2e(e));
  }
});
var N2e = mr, F2e = N2e.Object.getPrototypeOf, B2e = F2e, WG = B2e, U2e = WG, V2e = U2e, Y2e = V2e, H2e = Y2e;
(function(t) {
  t.exports = H2e;
})(C2e);
(function(t) {
  t.exports = VE;
})(A2e);
var fF = /* @__PURE__ */ rt(UE);
function ur(t) {
  var e;
  return ur = LE ? HG(e = fF).call(e) : function(n) {
    return n.__proto__ || fF(n);
  }, ur(t);
}
var YE = {}, G2e = {
  get exports() {
    return YE;
  },
  set exports(t) {
    YE = t;
  }
}, W2e = lt, j2e = pc;
W2e({ target: "Array", stat: !0 }, {
  isArray: j2e
});
var K2e = mr, z2e = K2e.Array.isArray, q2e = z2e, jG = q2e;
(function(t) {
  t.exports = jG;
})(G2e);
var $t = /* @__PURE__ */ rt(YE), HE = {}, X2e = {
  get exports() {
    return HE;
  },
  set exports(t) {
    HE = t;
  }
};
(function(t) {
  t.exports = YG;
})(X2e);
var de = /* @__PURE__ */ rt(HE), GE = {}, Q2e = {
  get exports() {
    return GE;
  },
  set exports(t) {
    GE = t;
  }
}, Z2e = typeof Bun == "function" && Bun && typeof Bun.version == "string", J2e = TypeError, eBe = function(t, e) {
  if (t < e)
    throw J2e("Not enough arguments");
  return t;
}, KG = $n, tBe = vv, rBe = kn, nBe = Z2e, iBe = bv, sBe = _b, aBe = eBe, oBe = KG.Function, lBe = /MSIE .\./.test(iBe) || nBe && function() {
  var t = KG.Bun.version.split(".");
  return t.length < 3 || t[0] == 0 && (t[1] < 3 || t[1] == 3 && t[2] == 0);
}(), zG = function(t, e) {
  var r = e ? 2 : 1;
  return lBe ? function(n, s) {
    var a = aBe(arguments.length, 1) > r, o = rBe(n) ? n : oBe(n), l = a ? sBe(arguments, r) : [], u = a ? function() {
      tBe(o, this, l);
    } : o;
    return e ? t(u, s) : t(u);
  } : t;
}, uBe = lt, qG = $n, cBe = zG, pF = cBe(qG.setInterval, !0);
uBe({ global: !0, bind: !0, forced: qG.setInterval !== pF }, {
  setInterval: pF
});
var dBe = lt, XG = $n, hBe = zG, vF = hBe(XG.setTimeout, !0);
dBe({ global: !0, bind: !0, forced: XG.setTimeout !== vF }, {
  setTimeout: vF
});
var fBe = mr, pBe = fBe.setTimeout;
(function(t) {
  t.exports = pBe;
})(Q2e);
var ai = /* @__PURE__ */ rt(GE), WE = {}, vBe = {
  get exports() {
    return WE;
  },
  set exports(t) {
    WE = t;
  }
}, mBe = qt, Ch = function(t, e) {
  var r = [][t];
  return !!r && mBe(function() {
    r.call(null, e || function() {
      return 1;
    }, 1);
  });
}, gBe = Uo.forEach, yBe = Ch, bBe = yBe("forEach"), _Be = bBe ? [].forEach : function(e) {
  return gBe(this, e, arguments.length > 1 ? arguments[1] : void 0);
}, wBe = lt, mF = _Be;
wBe({ target: "Array", proto: !0, forced: [].forEach != mF }, {
  forEach: mF
});
var TBe = sn, xBe = TBe("Array").forEach, SBe = xBe, EBe = SBe, $Be = $h, kBe = di, DBe = Fr, OBe = EBe, Nw = Array.prototype, ABe = {
  DOMTokenList: !0,
  NodeList: !0
}, CBe = function(t) {
  var e = t.forEach;
  return t === Nw || DBe(Nw, t) && e === Nw.forEach || kBe(ABe, $Be(t)) ? OBe : e;
};
(function(t) {
  t.exports = CBe;
})(vBe);
var Le = /* @__PURE__ */ rt(WE), Ti = typeof window < "u" && window.moment || we, jE = {}, IBe = {
  get exports() {
    return jE;
  },
  set exports(t) {
    jE = t;
  }
}, PBe = mr, RBe = PBe.Object.getOwnPropertySymbols, MBe = RBe, LBe = MBe;
(function(t) {
  t.exports = LBe;
})(IBe);
var By = /* @__PURE__ */ rt(jE), KE = {}, NBe = {
  get exports() {
    return KE;
  },
  set exports(t) {
    KE = t;
  }
}, FBe = lt, BBe = Uo.filter, UBe = Dv, VBe = UBe("filter");
FBe({ target: "Array", proto: !0, forced: !VBe }, {
  filter: function(e) {
    return BBe(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var YBe = sn, HBe = YBe("Array").filter, GBe = Fr, WBe = HBe, Fw = Array.prototype, jBe = function(t) {
  var e = t.filter;
  return t === Fw || GBe(Fw, t) && e === Fw.filter ? WBe : e;
}, KBe = jBe, zBe = KBe;
(function(t) {
  t.exports = zBe;
})(NBe);
var At = /* @__PURE__ */ rt(KE), zE = {}, qBe = {
  get exports() {
    return zE;
  },
  set exports(t) {
    zE = t;
  }
}, qE = {}, XBe = {
  get exports() {
    return qE;
  },
  set exports(t) {
    qE = t;
  }
}, QBe = lt, ZBe = qt, JBe = Js, QG = mv.f, ZG = pn, e3e = !ZG || ZBe(function() {
  QG(1);
});
QBe({ target: "Object", stat: !0, forced: e3e, sham: !ZG }, {
  getOwnPropertyDescriptor: function(e, r) {
    return QG(JBe(e), r);
  }
});
var t3e = mr, JG = t3e.Object, r3e = XBe.exports = function(e, r) {
  return JG.getOwnPropertyDescriptor(e, r);
};
JG.getOwnPropertyDescriptor.sham && (r3e.sham = !0);
var n3e = qE, i3e = n3e;
(function(t) {
  t.exports = i3e;
})(qBe);
var Ab = /* @__PURE__ */ rt(zE), XE = {}, s3e = {
  get exports() {
    return XE;
  },
  set exports(t) {
    XE = t;
  }
}, a3e = Ts, o3e = Xt, l3e = Ov, u3e = Av, c3e = ea, d3e = o3e([].concat), e5 = a3e("Reflect", "ownKeys") || function(e) {
  var r = l3e.f(c3e(e)), n = u3e.f;
  return n ? d3e(r, n(e)) : r;
}, h3e = lt, f3e = pn, p3e = e5, v3e = Js, m3e = mv, g3e = Dh;
h3e({ target: "Object", stat: !0, sham: !f3e }, {
  getOwnPropertyDescriptors: function(e) {
    for (var r = v3e(e), n = m3e.f, s = p3e(r), a = {}, o = 0, l, u; s.length > o; )
      u = n(r, l = s[o++]), u !== void 0 && g3e(a, l, u);
    return a;
  }
});
var y3e = mr, b3e = y3e.Object.getOwnPropertyDescriptors, _3e = b3e, w3e = _3e;
(function(t) {
  t.exports = w3e;
})(s3e);
var Uy = /* @__PURE__ */ rt(XE), QE = {}, T3e = {
  get exports() {
    return QE;
  },
  set exports(t) {
    QE = t;
  }
}, ZE = {}, x3e = {
  get exports() {
    return ZE;
  },
  set exports(t) {
    ZE = t;
  }
}, S3e = lt, E3e = pn, gF = Tb.f;
S3e({ target: "Object", stat: !0, forced: Object.defineProperties !== gF, sham: !E3e }, {
  defineProperties: gF
});
var $3e = mr, t5 = $3e.Object, k3e = x3e.exports = function(e, r) {
  return t5.defineProperties(e, r);
};
t5.defineProperties.sham && (k3e.sham = !0);
var D3e = ZE, O3e = D3e;
(function(t) {
  t.exports = O3e;
})(T3e);
var r5 = /* @__PURE__ */ rt(QE);
function n5(t, e, r) {
  return e = UG(e), e in t ? Sb(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
var JE = {}, A3e = {
  get exports() {
    return JE;
  },
  set exports(t) {
    JE = t;
  }
}, C3e = lt, I3e = Uo.map, P3e = Dv, R3e = P3e("map");
C3e({ target: "Array", proto: !0, forced: !R3e }, {
  map: function(e) {
    return I3e(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var M3e = sn, L3e = M3e("Array").map, N3e = Fr, F3e = L3e, Bw = Array.prototype, B3e = function(t) {
  var e = t.map;
  return t === Bw || N3e(Bw, t) && e === Bw.map ? F3e : e;
}, U3e = B3e, V3e = U3e;
(function(t) {
  t.exports = V3e;
})(A3e);
var ln = /* @__PURE__ */ rt(JE), e$ = {}, Y3e = {
  get exports() {
    return e$;
  },
  set exports(t) {
    e$ = t;
  }
}, H3e = fc, G3e = Zi, W3e = mb, j3e = ta, K3e = TypeError, yF = function(t) {
  return function(e, r, n, s) {
    H3e(r);
    var a = G3e(e), o = W3e(a), l = j3e(a), u = t ? l - 1 : 0, c = t ? -1 : 1;
    if (n < 2)
      for (; ; ) {
        if (u in o) {
          s = o[u], u += c;
          break;
        }
        if (u += c, t ? u < 0 : l <= u)
          throw K3e("Reduce of empty array with no initial value");
      }
    for (; t ? u >= 0 : l > u; u += c)
      u in o && (s = r(s, o[u], u, a));
    return s;
  };
}, z3e = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: yF(!1),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: yF(!0)
}, q3e = Bo, X3e = typeof process < "u" && q3e(process) == "process", Q3e = lt, Z3e = z3e.left, J3e = Ch, bF = _v, eUe = X3e, tUe = !eUe && bF > 79 && bF < 83, rUe = tUe || !J3e("reduce");
Q3e({ target: "Array", proto: !0, forced: rUe }, {
  reduce: function(e) {
    var r = arguments.length;
    return Z3e(this, e, r, r > 1 ? arguments[1] : void 0);
  }
});
var nUe = sn, iUe = nUe("Array").reduce, sUe = Fr, aUe = iUe, Uw = Array.prototype, oUe = function(t) {
  var e = t.reduce;
  return t === Uw || sUe(Uw, t) && e === Uw.reduce ? aUe : e;
}, lUe = oUe, uUe = lUe;
(function(t) {
  t.exports = uUe;
})(Y3e);
var i5 = /* @__PURE__ */ rt(e$), t$ = {}, cUe = {
  get exports() {
    return t$;
  },
  set exports(t) {
    t$ = t;
  }
}, dUe = lt, hUe = Zi, s5 = kv, fUe = qt, pUe = fUe(function() {
  s5(1);
});
dUe({ target: "Object", stat: !0, forced: pUe }, {
  keys: function(e) {
    return s5(hUe(e));
  }
});
var vUe = mr, mUe = vUe.Object.keys, gUe = mUe, yUe = gUe;
(function(t) {
  t.exports = yUe;
})(cUe);
var xn = /* @__PURE__ */ rt(t$), r$ = {}, bUe = {
  get exports() {
    return r$;
  },
  set exports(t) {
    r$ = t;
  }
};
(function(t) {
  t.exports = Z6;
})(bUe);
var BO = /* @__PURE__ */ rt(r$), n$ = {}, _Ue = {
  get exports() {
    return n$;
  },
  set exports(t) {
    n$ = t;
  }
}, wUe = ws, _F = ea, TUe = bO, a5 = function(t, e, r) {
  var n, s;
  _F(t);
  try {
    if (n = TUe(t, "return"), !n) {
      if (e === "throw")
        throw r;
      return r;
    }
    n = wUe(n, t);
  } catch (a) {
    s = !0, n = a;
  }
  if (e === "throw")
    throw r;
  if (s)
    throw n;
  return _F(n), r;
}, xUe = ea, SUe = a5, EUe = function(t, e, r, n) {
  try {
    return n ? e(xUe(r)[0], r[1]) : e(r);
  } catch (s) {
    SUe(t, "throw", s);
  }
}, $Ue = Jr, kUe = Ah, DUe = $Ue("iterator"), OUe = Array.prototype, o5 = function(t) {
  return t !== void 0 && (kUe.Array === t || OUe[DUe] === t);
}, AUe = $h, wF = bO, CUe = gb, IUe = Ah, PUe = Jr, RUe = PUe("iterator"), Cb = function(t) {
  if (!CUe(t))
    return wF(t, RUe) || wF(t, "@@iterator") || IUe[AUe(t)];
}, MUe = ws, LUe = fc, NUe = ea, FUe = Sh, BUe = Cb, UUe = TypeError, l5 = function(t, e) {
  var r = arguments.length < 2 ? BUe(t) : e;
  if (LUe(r))
    return NUe(MUe(r, t));
  throw UUe(FUe(t) + " is not iterable");
}, VUe = xv, YUe = ws, HUe = Zi, GUe = EUe, WUe = o5, jUe = wb, KUe = ta, TF = Dh, zUe = l5, qUe = Cb, xF = Array, XUe = function(e) {
  var r = HUe(e), n = jUe(this), s = arguments.length, a = s > 1 ? arguments[1] : void 0, o = a !== void 0;
  o && (a = VUe(a, s > 2 ? arguments[2] : void 0));
  var l = qUe(r), u = 0, c, d, h, f, p, m;
  if (l && !(this === xF && WUe(l)))
    for (f = zUe(r, l), p = f.next, d = n ? new this() : []; !(h = YUe(p, f)).done; u++)
      m = o ? GUe(f, a, [h.value, u], !0) : h.value, TF(d, u, m);
  else
    for (c = KUe(r), d = n ? new this(c) : xF(c); c > u; u++)
      m = o ? a(r[u], u) : r[u], TF(d, u, m);
  return d.length = u, d;
}, QUe = Jr, u5 = QUe("iterator"), c5 = !1;
try {
  var ZUe = 0, SF = {
    next: function() {
      return { done: !!ZUe++ };
    },
    return: function() {
      c5 = !0;
    }
  };
  SF[u5] = function() {
    return this;
  }, Array.from(SF, function() {
    throw 2;
  });
} catch {
}
var JUe = function(t, e) {
  if (!e && !c5)
    return !1;
  var r = !1;
  try {
    var n = {};
    n[u5] = function() {
      return {
        next: function() {
          return { done: r = !0 };
        }
      };
    }, t(n);
  } catch {
  }
  return r;
}, eVe = lt, tVe = XUe, rVe = JUe, nVe = !rVe(function(t) {
  Array.from(t);
});
eVe({ target: "Array", stat: !0, forced: nVe }, {
  from: tVe
});
var iVe = mr, sVe = iVe.Array.from, aVe = sVe, d5 = aVe;
(function(t) {
  t.exports = d5;
})(_Ue);
var vc = /* @__PURE__ */ rt(n$), i$ = {}, oVe = {
  get exports() {
    return i$;
  },
  set exports(t) {
    i$ = t;
  }
}, s$ = {}, lVe = {
  get exports() {
    return s$;
  },
  set exports(t) {
    s$ = t;
  }
}, uVe = Cb, cVe = uVe, dVe = cVe, hVe = dVe, fVe = hVe, pVe = fVe, vVe = pVe, mVe = vVe;
(function(t) {
  t.exports = mVe;
})(lVe);
(function(t) {
  t.exports = s$;
})(oVe);
var Vo = /* @__PURE__ */ rt(i$), a$ = {}, gVe = {
  get exports() {
    return a$;
  },
  set exports(t) {
    a$ = t;
  }
}, o$ = {}, yVe = {
  get exports() {
    return o$;
  },
  set exports(t) {
    o$ = t;
  }
}, bVe = jG, _Ve = bVe, wVe = _Ve, TVe = wVe;
(function(t) {
  t.exports = TVe;
})(yVe);
(function(t) {
  t.exports = o$;
})(gVe);
var h5 = /* @__PURE__ */ rt(a$);
function xVe(t) {
  if (h5(t))
    return t;
}
function SVe(t, e) {
  var r = t == null ? null : typeof cd < "u" && Vo(t) || t["@@iterator"];
  if (r != null) {
    var n, s, a, o, l = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e === 0) {
        if (Object(r) !== r)
          return;
        u = !1;
      } else
        for (; !(u = (n = a.call(r)).done) && (l.push(n.value), l.length !== e); u = !0)
          ;
    } catch (d) {
      c = !0, s = d;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw s;
      }
    }
    return l;
  }
}
var l$ = {}, EVe = {
  get exports() {
    return l$;
  },
  set exports(t) {
    l$ = t;
  }
}, u$ = {}, $Ve = {
  get exports() {
    return u$;
  },
  set exports(t) {
    u$ = t;
  }
}, kVe = lt, EF = pc, DVe = wb, OVe = ci, $F = Ev, AVe = ta, CVe = Js, IVe = Dh, PVe = Jr, RVe = Dv, MVe = _b, LVe = RVe("slice"), NVe = PVe("species"), Vw = Array, FVe = Math.max;
kVe({ target: "Array", proto: !0, forced: !LVe }, {
  slice: function(e, r) {
    var n = CVe(this), s = AVe(n), a = $F(e, s), o = $F(r === void 0 ? s : r, s), l, u, c;
    if (EF(n) && (l = n.constructor, DVe(l) && (l === Vw || EF(l.prototype)) ? l = void 0 : OVe(l) && (l = l[NVe], l === null && (l = void 0)), l === Vw || l === void 0))
      return MVe(n, a, o);
    for (u = new (l === void 0 ? Vw : l)(FVe(o - a, 0)), c = 0; a < o; a++, c++)
      a in n && IVe(u, c, n[a]);
    return u.length = c, u;
  }
});
var BVe = sn, UVe = BVe("Array").slice, VVe = Fr, YVe = UVe, Yw = Array.prototype, HVe = function(t) {
  var e = t.slice;
  return t === Yw || VVe(Yw, t) && e === Yw.slice ? YVe : e;
}, GVe = HVe, f5 = GVe, WVe = f5, jVe = WVe, KVe = jVe, zVe = KVe;
(function(t) {
  t.exports = zVe;
})($Ve);
(function(t) {
  t.exports = u$;
})(EVe);
var qVe = /* @__PURE__ */ rt(l$), c$ = {}, XVe = {
  get exports() {
    return c$;
  },
  set exports(t) {
    c$ = t;
  }
}, d$ = {}, QVe = {
  get exports() {
    return d$;
  },
  set exports(t) {
    d$ = t;
  }
}, ZVe = d5, JVe = ZVe, eYe = JVe, tYe = eYe;
(function(t) {
  t.exports = tYe;
})(QVe);
(function(t) {
  t.exports = d$;
})(XVe);
var p5 = /* @__PURE__ */ rt(c$);
function h$(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function v5(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return h$(t, e);
    var n = qVe(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return p5(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return h$(t, e);
  }
}
function rYe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nYe(t, e) {
  return xVe(t) || SVe(t, e) || v5(t, e) || rYe();
}
function iYe(t) {
  if (h5(t))
    return h$(t);
}
function sYe(t) {
  if (typeof cd < "u" && Vo(t) != null || t["@@iterator"] != null)
    return p5(t);
}
function aYe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vs(t) {
  return iYe(t) || sYe(t) || v5(t) || aYe();
}
var f$ = {}, oYe = {
  get exports() {
    return f$;
  },
  set exports(t) {
    f$ = t;
  }
};
(function(t) {
  t.exports = RG;
})(oYe);
var Nl = /* @__PURE__ */ rt(f$), p$ = {}, lYe = {
  get exports() {
    return p$;
  },
  set exports(t) {
    p$ = t;
  }
}, uYe = sn, cYe = uYe("Array").concat, dYe = Fr, hYe = cYe, Hw = Array.prototype, fYe = function(t) {
  var e = t.concat;
  return t === Hw || dYe(Hw, t) && e === Hw.concat ? hYe : e;
}, pYe = fYe, vYe = pYe;
(function(t) {
  t.exports = vYe;
})(lYe);
var Dr = /* @__PURE__ */ rt(p$), v$ = {}, mYe = {
  get exports() {
    return v$;
  },
  set exports(t) {
    v$ = t;
  }
};
(function(t) {
  t.exports = f5;
})(mYe);
var hi = /* @__PURE__ */ rt(v$), m$ = {}, gYe = {
  get exports() {
    return m$;
  },
  set exports(t) {
    m$ = t;
  }
}, yYe = lt, bYe = e5;
yYe({ target: "Reflect", stat: !0 }, {
  ownKeys: bYe
});
var _Ye = mr, wYe = _Ye.Reflect.ownKeys, TYe = wYe, xYe = TYe;
(function(t) {
  t.exports = xYe;
})(gYe);
var SYe = /* @__PURE__ */ rt(m$), g$ = {}, EYe = {
  get exports() {
    return g$;
  },
  set exports(t) {
    g$ = t;
  }
}, $Ye = lt, kYe = Xt, m5 = Date, DYe = kYe(m5.prototype.getTime);
$Ye({ target: "Date", stat: !0 }, {
  now: function() {
    return DYe(new m5());
  }
});
var OYe = mr, AYe = OYe.Date.now, CYe = AYe, IYe = CYe;
(function(t) {
  t.exports = IYe;
})(EYe);
var Bi = /* @__PURE__ */ rt(g$), y$ = {}, PYe = {
  get exports() {
    return y$;
  },
  set exports(t) {
    y$ = t;
  }
}, RYe = lt, MYe = Xt, LYe = pc, NYe = MYe([].reverse), kF = [1, 2];
RYe({ target: "Array", proto: !0, forced: String(kF) === String(kF.reverse()) }, {
  reverse: function() {
    return LYe(this) && (this.length = this.length), NYe(this);
  }
});
var FYe = sn, BYe = FYe("Array").reverse, UYe = Fr, VYe = BYe, Gw = Array.prototype, YYe = function(t) {
  var e = t.reverse;
  return t === Gw || UYe(Gw, t) && e === Gw.reverse ? VYe : e;
}, HYe = YYe, GYe = HYe;
(function(t) {
  t.exports = GYe;
})(PYe);
var WYe = /* @__PURE__ */ rt(y$), b$ = {}, jYe = {
  get exports() {
    return b$;
  },
  set exports(t) {
    b$ = t;
  }
}, KYe = pn, zYe = pc, qYe = TypeError, XYe = Object.getOwnPropertyDescriptor, QYe = KYe && !function() {
  if (this !== void 0)
    return !0;
  try {
    Object.defineProperty([], "length", { writable: !1 }).length = 1;
  } catch (t) {
    return t instanceof TypeError;
  }
}(), ZYe = QYe ? function(t, e) {
  if (zYe(t) && !XYe(t, "length").writable)
    throw qYe("Cannot set read only .length");
  return t.length = e;
} : function(t, e) {
  return t.length = e;
}, DF = Sh, JYe = TypeError, g5 = function(t, e) {
  if (!delete t[e])
    throw JYe("Cannot delete property " + DF(e) + " of " + DF(t));
}, e4e = lt, t4e = Zi, r4e = Ev, n4e = Sv, i4e = ta, s4e = ZYe, a4e = J6, o4e = $O, l4e = Dh, Ww = g5, u4e = Dv, c4e = u4e("splice"), d4e = Math.max, h4e = Math.min;
e4e({ target: "Array", proto: !0, forced: !c4e }, {
  splice: function(e, r) {
    var n = t4e(this), s = i4e(n), a = r4e(e, s), o = arguments.length, l, u, c, d, h, f;
    for (o === 0 ? l = u = 0 : o === 1 ? (l = 0, u = s - a) : (l = o - 2, u = h4e(d4e(n4e(r), 0), s - a)), a4e(s + l - u), c = o4e(n, u), d = 0; d < u; d++)
      h = a + d, h in n && l4e(c, d, n[h]);
    if (c.length = u, l < u) {
      for (d = a; d < s - u; d++)
        h = d + u, f = d + l, h in n ? n[f] = n[h] : Ww(n, f);
      for (d = s; d > s - u + l; d--)
        Ww(n, d - 1);
    } else if (l > u)
      for (d = s - u; d > a; d--)
        h = d + u - 1, f = d + l - 1, h in n ? n[f] = n[h] : Ww(n, f);
    for (d = 0; d < l; d++)
      n[d + a] = arguments[d + 2];
    return s4e(n, s - u + l), c;
  }
});
var f4e = sn, p4e = f4e("Array").splice, v4e = Fr, m4e = p4e, jw = Array.prototype, g4e = function(t) {
  var e = t.splice;
  return t === jw || v4e(jw, t) && e === jw.splice ? m4e : e;
}, y4e = g4e, b4e = y4e;
(function(t) {
  t.exports = b4e;
})(jYe);
var xi = /* @__PURE__ */ rt(b$), _$ = {}, _4e = {
  get exports() {
    return _$;
  },
  set exports(t) {
    _$ = t;
  }
}, OF = pn, w4e = Xt, T4e = ws, x4e = qt, Kw = kv, S4e = Av, E4e = gv, $4e = Zi, k4e = mb, Yc = Object.assign, AF = Object.defineProperty, D4e = w4e([].concat), O4e = !Yc || x4e(function() {
  if (OF && Yc({ b: 1 }, Yc(AF({}, "a", {
    enumerable: !0,
    get: function() {
      AF(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1)
    return !0;
  var t = {}, e = {}, r = Symbol(), n = "abcdefghijklmnopqrst";
  return t[r] = 7, n.split("").forEach(function(s) {
    e[s] = s;
  }), Yc({}, t)[r] != 7 || Kw(Yc({}, e)).join("") != n;
}) ? function(e, r) {
  for (var n = $4e(e), s = arguments.length, a = 1, o = S4e.f, l = E4e.f; s > a; )
    for (var u = k4e(arguments[a++]), c = o ? D4e(Kw(u), o(u)) : Kw(u), d = c.length, h = 0, f; d > h; )
      f = c[h++], (!OF || T4e(l, u, f)) && (n[f] = u[f]);
  return n;
} : Yc, A4e = lt, CF = O4e;
A4e({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== CF }, {
  assign: CF
});
var C4e = mr, I4e = C4e.Object.assign, P4e = I4e, R4e = P4e;
(function(t) {
  t.exports = R4e;
})(_4e);
var Wu = /* @__PURE__ */ rt(_$), w$ = {}, M4e = {
  get exports() {
    return w$;
  },
  set exports(t) {
    w$ = t;
  }
}, L4e = lt, N4e = xO.includes, F4e = qt, B4e = F4e(function() {
  return !Array(1).includes();
});
L4e({ target: "Array", proto: !0, forced: B4e }, {
  includes: function(e) {
    return N4e(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var U4e = sn, V4e = U4e("Array").includes, Y4e = ci, H4e = Bo, G4e = Jr, W4e = G4e("match"), j4e = function(t) {
  var e;
  return Y4e(t) && ((e = t[W4e]) !== void 0 ? !!e : H4e(t) == "RegExp");
}, K4e = j4e, z4e = TypeError, q4e = function(t) {
  if (K4e(t))
    throw z4e("The method doesn't accept regular expressions");
  return t;
}, X4e = Jr, Q4e = X4e("match"), Z4e = function(t) {
  var e = /./;
  try {
    "/./"[t](e);
  } catch {
    try {
      return e[Q4e] = !1, "/./"[t](e);
    } catch {
    }
  }
  return !1;
}, J4e = lt, eHe = Xt, tHe = q4e, rHe = Th, IF = ra, nHe = Z4e, iHe = eHe("".indexOf);
J4e({ target: "String", proto: !0, forced: !nHe("includes") }, {
  includes: function(e) {
    return !!~iHe(
      IF(rHe(this)),
      IF(tHe(e)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var sHe = sn, aHe = sHe("String").includes, PF = Fr, oHe = V4e, lHe = aHe, zw = Array.prototype, qw = String.prototype, uHe = function(t) {
  var e = t.includes;
  return t === zw || PF(zw, t) && e === zw.includes ? oHe : typeof t == "string" || t === qw || PF(qw, t) && e === qw.includes ? lHe : e;
}, cHe = uHe, dHe = cHe;
(function(t) {
  t.exports = dHe;
})(M4e);
var Cl = /* @__PURE__ */ rt(w$), T$ = {}, hHe = {
  get exports() {
    return T$;
  },
  set exports(t) {
    T$ = t;
  }
};
(function(t) {
  t.exports = WG;
})(hHe);
var RF = /* @__PURE__ */ rt(T$), x$ = {}, fHe = {
  get exports() {
    return x$;
  },
  set exports(t) {
    x$ = t;
  }
}, pHe = pn, y5 = Xt, vHe = kv, mHe = Js, gHe = gv.f, yHe = y5(gHe), bHe = y5([].push), MF = function(t) {
  return function(e) {
    for (var r = mHe(e), n = vHe(r), s = n.length, a = 0, o = [], l; s > a; )
      l = n[a++], (!pHe || yHe(r, l)) && bHe(o, t ? [l, r[l]] : r[l]);
    return o;
  };
}, _He = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: MF(!0),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: MF(!1)
}, wHe = lt, THe = _He.values;
wHe({ target: "Object", stat: !0 }, {
  values: function(e) {
    return THe(e);
  }
});
var xHe = mr, SHe = xHe.Object.values, EHe = SHe, $He = EHe;
(function(t) {
  t.exports = $He;
})(fHe);
var UO = /* @__PURE__ */ rt(x$), S$ = {}, kHe = {
  get exports() {
    return S$;
  },
  set exports(t) {
    S$ = t;
  }
}, Ib = `	
\v\f\r                　\u2028\u2029\uFEFF`, DHe = Xt, OHe = Th, AHe = ra, E$ = Ib, LF = DHe("".replace), CHe = RegExp("^[" + E$ + "]+"), IHe = RegExp("(^|[^" + E$ + "])[" + E$ + "]+$"), Xw = function(t) {
  return function(e) {
    var r = AHe(OHe(e));
    return t & 1 && (r = LF(r, CHe, "")), t & 2 && (r = LF(r, IHe, "$1")), r;
  };
}, VO = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: Xw(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: Xw(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: Xw(3)
}, b5 = $n, PHe = qt, RHe = Xt, MHe = ra, LHe = VO.trim, NF = Ib, Pf = b5.parseInt, FF = b5.Symbol, BF = FF && FF.iterator, _5 = /^[+-]?0x/i, NHe = RHe(_5.exec), FHe = Pf(NF + "08") !== 8 || Pf(NF + "0x16") !== 22 || BF && !PHe(function() {
  Pf(Object(BF));
}), BHe = FHe ? function(e, r) {
  var n = LHe(MHe(e));
  return Pf(n, r >>> 0 || (NHe(_5, n) ? 16 : 10));
} : Pf, UHe = lt, UF = BHe;
UHe({ global: !0, forced: parseInt != UF }, {
  parseInt: UF
});
var VHe = mr, YHe = VHe.parseInt, HHe = YHe, GHe = HHe;
(function(t) {
  t.exports = GHe;
})(kHe);
var Ui = /* @__PURE__ */ rt(S$), $$ = {}, WHe = {
  get exports() {
    return $$;
  },
  set exports(t) {
    $$ = t;
  }
}, jHe = lt, KHe = yO, zHe = xO.indexOf, qHe = Ch, k$ = KHe([].indexOf), w5 = !!k$ && 1 / k$([1], 1, -0) < 0, XHe = w5 || !qHe("indexOf");
jHe({ target: "Array", proto: !0, forced: XHe }, {
  indexOf: function(e) {
    var r = arguments.length > 1 ? arguments[1] : void 0;
    return w5 ? k$(this, e, r) || 0 : zHe(this, e, r);
  }
});
var QHe = sn, ZHe = QHe("Array").indexOf, JHe = Fr, e6e = ZHe, Qw = Array.prototype, t6e = function(t) {
  var e = t.indexOf;
  return t === Qw || JHe(Qw, t) && e === Qw.indexOf ? e6e : e;
}, r6e = t6e, n6e = r6e;
(function(t) {
  t.exports = n6e;
})(WHe);
var lr = /* @__PURE__ */ rt($$), D$ = {}, i6e = {
  get exports() {
    return D$;
  },
  set exports(t) {
    D$ = t;
  }
}, s6e = DG.PROPER, a6e = qt, VF = Ib, YF = "​᠎", o6e = function(t) {
  return a6e(function() {
    return !!VF[t]() || YF[t]() !== YF || s6e && VF[t].name !== t;
  });
}, l6e = lt, u6e = VO.trim, c6e = o6e;
l6e({ target: "String", proto: !0, forced: c6e("trim") }, {
  trim: function() {
    return u6e(this);
  }
});
var d6e = sn, h6e = d6e("String").trim, f6e = Fr, p6e = h6e, Zw = String.prototype, v6e = function(t) {
  var e = t.trim;
  return typeof t == "string" || t === Zw || f6e(Zw, t) && e === Zw.trim ? p6e : e;
}, m6e = v6e, g6e = m6e;
(function(t) {
  t.exports = g6e;
})(i6e);
var Jw = /* @__PURE__ */ rt(D$), O$ = {}, y6e = {
  get exports() {
    return O$;
  },
  set exports(t) {
    O$ = t;
  }
};
(function(t) {
  t.exports = VG;
})(y6e);
var Pb = /* @__PURE__ */ rt(O$), A$ = {}, b6e = {
  get exports() {
    return A$;
  },
  set exports(t) {
    A$ = t;
  }
}, C$ = mr, _6e = vv;
C$.JSON || (C$.JSON = { stringify: JSON.stringify });
var w6e = function(e, r, n) {
  return _6e(C$.JSON.stringify, null, arguments);
}, T6e = w6e, x6e = T6e;
(function(t) {
  t.exports = x6e;
})(b6e);
var Vi = /* @__PURE__ */ rt(A$), I$ = {}, S6e = {
  get exports() {
    return I$;
  },
  set exports(t) {
    I$ = t;
  }
}, E6e = Zi, HF = Ev, $6e = ta, k6e = function(e) {
  for (var r = E6e(this), n = $6e(r), s = arguments.length, a = HF(s > 1 ? arguments[1] : void 0, n), o = s > 2 ? arguments[2] : void 0, l = o === void 0 ? n : HF(o, n); l > a; )
    r[a++] = e;
  return r;
}, D6e = lt, O6e = k6e;
D6e({ target: "Array", proto: !0 }, {
  fill: O6e
});
var A6e = sn, C6e = A6e("Array").fill, I6e = Fr, P6e = C6e, eT = Array.prototype, R6e = function(t) {
  var e = t.fill;
  return t === eT || I6e(eT, t) && e === eT.fill ? P6e : e;
}, M6e = R6e, L6e = M6e;
(function(t) {
  t.exports = L6e;
})(S6e);
var T5 = /* @__PURE__ */ rt(I$), P$ = {}, N6e = {
  get exports() {
    return P$;
  },
  set exports(t) {
    P$ = t;
  }
};
(function(t) {
  t.exports = e;
  function e(n) {
    if (n)
      return r(n);
  }
  function r(n) {
    for (var s in e.prototype)
      n[s] = e.prototype[s];
    return n;
  }
  e.prototype.on = e.prototype.addEventListener = function(n, s) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + n] = this._callbacks["$" + n] || []).push(s), this;
  }, e.prototype.once = function(n, s) {
    function a() {
      this.off(n, a), s.apply(this, arguments);
    }
    return a.fn = s, this.on(n, a), this;
  }, e.prototype.off = e.prototype.removeListener = e.prototype.removeAllListeners = e.prototype.removeEventListener = function(n, s) {
    if (this._callbacks = this._callbacks || {}, arguments.length == 0)
      return this._callbacks = {}, this;
    var a = this._callbacks["$" + n];
    if (!a)
      return this;
    if (arguments.length == 1)
      return delete this._callbacks["$" + n], this;
    for (var o, l = 0; l < a.length; l++)
      if (o = a[l], o === s || o.fn === s) {
        a.splice(l, 1);
        break;
      }
    return a.length === 0 && delete this._callbacks["$" + n], this;
  }, e.prototype.emit = function(n) {
    this._callbacks = this._callbacks || {};
    for (var s = new Array(arguments.length - 1), a = this._callbacks["$" + n], o = 1; o < arguments.length; o++)
      s[o - 1] = arguments[o];
    if (a) {
      a = a.slice(0);
      for (var o = 0, l = a.length; o < l; ++o)
        a[o].apply(this, s);
    }
    return this;
  }, e.prototype.listeners = function(n) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + n] || [];
  }, e.prototype.hasListeners = function(n) {
    return !!this.listeners(n).length;
  };
})(N6e);
var YO = P$;
/*! Hammer.JS - v2.0.17-rc - 2019-12-16
 * http://naver.github.io/egjs
 *
 * Forked By Naver egjs
 * Copyright (c) hammerjs
 * Licensed under the MIT license */
function qs() {
  return qs = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, qs.apply(this, arguments);
}
function Ss(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
function ag(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
var R$;
typeof Object.assign != "function" ? R$ = function(e) {
  if (e == null)
    throw new TypeError("Cannot convert undefined or null to object");
  for (var r = Object(e), n = 1; n < arguments.length; n++) {
    var s = arguments[n];
    if (s != null)
      for (var a in s)
        s.hasOwnProperty(a) && (r[a] = s[a]);
  }
  return r;
} : R$ = Object.assign;
var ju = R$, GF = ["", "webkit", "Moz", "MS", "ms", "o"], F6e = typeof document > "u" ? {
  style: {}
} : document.createElement("div"), B6e = "function", dd = Math.round, Ku = Math.abs, HO = Date.now;
function Rb(t, e) {
  for (var r, n, s = e[0].toUpperCase() + e.slice(1), a = 0; a < GF.length; ) {
    if (r = GF[a], n = r ? r + s : e, n in t)
      return n;
    a++;
  }
}
var yo;
typeof window > "u" ? yo = {} : yo = window;
var x5 = Rb(F6e.style, "touchAction"), S5 = x5 !== void 0;
function U6e() {
  if (!S5)
    return !1;
  var t = {}, e = yo.CSS && yo.CSS.supports;
  return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(r) {
    return t[r] = e ? yo.CSS.supports("touch-action", r) : !0;
  }), t;
}
var E5 = "compute", $5 = "auto", M$ = "manipulation", Du = "none", gp = "pan-x", yp = "pan-y", og = U6e(), V6e = /mobile|tablet|ip(ad|hone|od)|android/i, k5 = "ontouchstart" in yo, Y6e = Rb(yo, "PointerEvent") !== void 0, H6e = k5 && V6e.test(navigator.userAgent), Lv = "touch", G6e = "pen", GO = "mouse", W6e = "kinect", j6e = 25, li = 1, mc = 2, tn = 4, ki = 8, Vy = 1, Nv = 2, Fv = 4, Bv = 8, Wd = 16, $a = Nv | Fv, Ou = Bv | Wd, D5 = $a | Ou, O5 = ["x", "y"], Yy = ["clientX", "clientY"];
function bo(t, e, r) {
  var n;
  if (t)
    if (t.forEach)
      t.forEach(e, r);
    else if (t.length !== void 0)
      for (n = 0; n < t.length; )
        e.call(r, t[n], n, t), n++;
    else
      for (n in t)
        t.hasOwnProperty(n) && e.call(r, t[n], n, t);
}
function Mb(t, e) {
  return typeof t === B6e ? t.apply(e && e[0] || void 0, e) : t;
}
function hu(t, e) {
  return t.indexOf(e) > -1;
}
function K6e(t) {
  if (hu(t, Du))
    return Du;
  var e = hu(t, gp), r = hu(t, yp);
  return e && r ? Du : e || r ? e ? gp : yp : hu(t, M$) ? M$ : $5;
}
var A5 = /* @__PURE__ */ function() {
  function t(r, n) {
    this.manager = r, this.set(n);
  }
  var e = t.prototype;
  return e.set = function(n) {
    n === E5 && (n = this.compute()), S5 && this.manager.element.style && og[n] && (this.manager.element.style[x5] = n), this.actions = n.toLowerCase().trim();
  }, e.update = function() {
    this.set(this.manager.options.touchAction);
  }, e.compute = function() {
    var n = [];
    return bo(this.manager.recognizers, function(s) {
      Mb(s.options.enable, [s]) && (n = n.concat(s.getTouchAction()));
    }), K6e(n.join(" "));
  }, e.preventDefaults = function(n) {
    var s = n.srcEvent, a = n.offsetDirection;
    if (this.manager.session.prevented) {
      s.preventDefault();
      return;
    }
    var o = this.actions, l = hu(o, Du) && !og[Du], u = hu(o, yp) && !og[yp], c = hu(o, gp) && !og[gp];
    if (l) {
      var d = n.pointers.length === 1, h = n.distance < 2, f = n.deltaTime < 250;
      if (d && h && f)
        return;
    }
    if (!(c && u) && (l || u && a & $a || c && a & Ou))
      return this.preventSrc(s);
  }, e.preventSrc = function(n) {
    this.manager.session.prevented = !0, n.preventDefault();
  }, t;
}();
function WO(t, e) {
  for (; t; ) {
    if (t === e)
      return !0;
    t = t.parentNode;
  }
  return !1;
}
function C5(t) {
  var e = t.length;
  if (e === 1)
    return {
      x: dd(t[0].clientX),
      y: dd(t[0].clientY)
    };
  for (var r = 0, n = 0, s = 0; s < e; )
    r += t[s].clientX, n += t[s].clientY, s++;
  return {
    x: dd(r / e),
    y: dd(n / e)
  };
}
function WF(t) {
  for (var e = [], r = 0; r < t.pointers.length; )
    e[r] = {
      clientX: dd(t.pointers[r].clientX),
      clientY: dd(t.pointers[r].clientY)
    }, r++;
  return {
    timeStamp: HO(),
    pointers: e,
    center: C5(e),
    deltaX: t.deltaX,
    deltaY: t.deltaY
  };
}
function Hy(t, e, r) {
  r || (r = O5);
  var n = e[r[0]] - t[r[0]], s = e[r[1]] - t[r[1]];
  return Math.sqrt(n * n + s * s);
}
function L$(t, e, r) {
  r || (r = O5);
  var n = e[r[0]] - t[r[0]], s = e[r[1]] - t[r[1]];
  return Math.atan2(s, n) * 180 / Math.PI;
}
function I5(t, e) {
  return t === e ? Vy : Ku(t) >= Ku(e) ? t < 0 ? Nv : Fv : e < 0 ? Bv : Wd;
}
function z6e(t, e) {
  var r = e.center, n = t.offsetDelta || {}, s = t.prevDelta || {}, a = t.prevInput || {};
  (e.eventType === li || a.eventType === tn) && (s = t.prevDelta = {
    x: a.deltaX || 0,
    y: a.deltaY || 0
  }, n = t.offsetDelta = {
    x: r.x,
    y: r.y
  }), e.deltaX = s.x + (r.x - n.x), e.deltaY = s.y + (r.y - n.y);
}
function P5(t, e, r) {
  return {
    x: e / t || 0,
    y: r / t || 0
  };
}
function q6e(t, e) {
  return Hy(e[0], e[1], Yy) / Hy(t[0], t[1], Yy);
}
function X6e(t, e) {
  return L$(e[1], e[0], Yy) + L$(t[1], t[0], Yy);
}
function Q6e(t, e) {
  var r = t.lastInterval || e, n = e.timeStamp - r.timeStamp, s, a, o, l;
  if (e.eventType !== ki && (n > j6e || r.velocity === void 0)) {
    var u = e.deltaX - r.deltaX, c = e.deltaY - r.deltaY, d = P5(n, u, c);
    a = d.x, o = d.y, s = Ku(d.x) > Ku(d.y) ? d.x : d.y, l = I5(u, c), t.lastInterval = e;
  } else
    s = r.velocity, a = r.velocityX, o = r.velocityY, l = r.direction;
  e.velocity = s, e.velocityX = a, e.velocityY = o, e.direction = l;
}
function Z6e(t, e) {
  var r = t.session, n = e.pointers, s = n.length;
  r.firstInput || (r.firstInput = WF(e)), s > 1 && !r.firstMultiple ? r.firstMultiple = WF(e) : s === 1 && (r.firstMultiple = !1);
  var a = r.firstInput, o = r.firstMultiple, l = o ? o.center : a.center, u = e.center = C5(n);
  e.timeStamp = HO(), e.deltaTime = e.timeStamp - a.timeStamp, e.angle = L$(l, u), e.distance = Hy(l, u), z6e(r, e), e.offsetDirection = I5(e.deltaX, e.deltaY);
  var c = P5(e.deltaTime, e.deltaX, e.deltaY);
  e.overallVelocityX = c.x, e.overallVelocityY = c.y, e.overallVelocity = Ku(c.x) > Ku(c.y) ? c.x : c.y, e.scale = o ? q6e(o.pointers, n) : 1, e.rotation = o ? X6e(o.pointers, n) : 0, e.maxPointers = r.prevInput ? e.pointers.length > r.prevInput.maxPointers ? e.pointers.length : r.prevInput.maxPointers : e.pointers.length, Q6e(r, e);
  var d = t.element, h = e.srcEvent, f;
  h.composedPath ? f = h.composedPath()[0] : h.path ? f = h.path[0] : f = h.target, WO(f, d) && (d = f), e.target = d;
}
function J6e(t, e, r) {
  var n = r.pointers.length, s = r.changedPointers.length, a = e & li && n - s === 0, o = e & (tn | ki) && n - s === 0;
  r.isFirst = !!a, r.isFinal = !!o, a && (t.session = {}), r.eventType = e, Z6e(t, r), t.emit("hammer.input", r), t.recognize(r), t.session.prevInput = r;
}
function bp(t) {
  return t.trim().split(/\s+/g);
}
function Rf(t, e, r) {
  bo(bp(e), function(n) {
    t.addEventListener(n, r, !1);
  });
}
function Mf(t, e, r) {
  bo(bp(e), function(n) {
    t.removeEventListener(n, r, !1);
  });
}
function jF(t) {
  var e = t.ownerDocument || t;
  return e.defaultView || e.parentWindow || window;
}
var Ih = /* @__PURE__ */ function() {
  function t(r, n) {
    var s = this;
    this.manager = r, this.callback = n, this.element = r.element, this.target = r.options.inputTarget, this.domHandler = function(a) {
      Mb(r.options.enable, [r]) && s.handler(a);
    }, this.init();
  }
  var e = t.prototype;
  return e.handler = function() {
  }, e.init = function() {
    this.evEl && Rf(this.element, this.evEl, this.domHandler), this.evTarget && Rf(this.target, this.evTarget, this.domHandler), this.evWin && Rf(jF(this.element), this.evWin, this.domHandler);
  }, e.destroy = function() {
    this.evEl && Mf(this.element, this.evEl, this.domHandler), this.evTarget && Mf(this.target, this.evTarget, this.domHandler), this.evWin && Mf(jF(this.element), this.evWin, this.domHandler);
  }, t;
}();
function zu(t, e, r) {
  if (t.indexOf && !r)
    return t.indexOf(e);
  for (var n = 0; n < t.length; ) {
    if (r && t[n][r] == e || !r && t[n] === e)
      return n;
    n++;
  }
  return -1;
}
var eGe = {
  pointerdown: li,
  pointermove: mc,
  pointerup: tn,
  pointercancel: ki,
  pointerout: ki
}, tGe = {
  2: Lv,
  3: G6e,
  4: GO,
  5: W6e
  // see https://twitter.com/jacobrossi/status/480596438489890816
}, R5 = "pointerdown", M5 = "pointermove pointerup pointercancel";
yo.MSPointerEvent && !yo.PointerEvent && (R5 = "MSPointerDown", M5 = "MSPointerMove MSPointerUp MSPointerCancel");
var L5 = /* @__PURE__ */ function(t) {
  Ss(e, t);
  function e() {
    var n, s = e.prototype;
    return s.evEl = R5, s.evWin = M5, n = t.apply(this, arguments) || this, n.store = n.manager.session.pointerEvents = [], n;
  }
  var r = e.prototype;
  return r.handler = function(s) {
    var a = this.store, o = !1, l = s.type.toLowerCase().replace("ms", ""), u = eGe[l], c = tGe[s.pointerType] || s.pointerType, d = c === Lv, h = zu(a, s.pointerId, "pointerId");
    u & li && (s.button === 0 || d) ? h < 0 && (a.push(s), h = a.length - 1) : u & (tn | ki) && (o = !0), !(h < 0) && (a[h] = s, this.callback(this.manager, u, {
      pointers: a,
      changedPointers: [s],
      pointerType: c,
      srcEvent: s
    }), o && a.splice(h, 1));
  }, e;
}(Ih);
function _p(t) {
  return Array.prototype.slice.call(t, 0);
}
function jO(t, e, r) {
  for (var n = [], s = [], a = 0; a < t.length; ) {
    var o = e ? t[a][e] : t[a];
    zu(s, o) < 0 && n.push(t[a]), s[a] = o, a++;
  }
  return r && (e ? n = n.sort(function(l, u) {
    return l[e] > u[e];
  }) : n = n.sort()), n;
}
var rGe = {
  touchstart: li,
  touchmove: mc,
  touchend: tn,
  touchcancel: ki
}, nGe = "touchstart touchmove touchend touchcancel", KO = /* @__PURE__ */ function(t) {
  Ss(e, t);
  function e() {
    var n;
    return e.prototype.evTarget = nGe, n = t.apply(this, arguments) || this, n.targetIds = {}, n;
  }
  var r = e.prototype;
  return r.handler = function(s) {
    var a = rGe[s.type], o = iGe.call(this, s, a);
    o && this.callback(this.manager, a, {
      pointers: o[0],
      changedPointers: o[1],
      pointerType: Lv,
      srcEvent: s
    });
  }, e;
}(Ih);
function iGe(t, e) {
  var r = _p(t.touches), n = this.targetIds;
  if (e & (li | mc) && r.length === 1)
    return n[r[0].identifier] = !0, [r, r];
  var s, a, o = _p(t.changedTouches), l = [], u = this.target;
  if (a = r.filter(function(c) {
    return WO(c.target, u);
  }), e === li)
    for (s = 0; s < a.length; )
      n[a[s].identifier] = !0, s++;
  for (s = 0; s < o.length; )
    n[o[s].identifier] && l.push(o[s]), e & (tn | ki) && delete n[o[s].identifier], s++;
  if (l.length)
    return [
      // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
      jO(a.concat(l), "identifier", !0),
      l
    ];
}
var sGe = {
  mousedown: li,
  mousemove: mc,
  mouseup: tn
}, aGe = "mousedown", oGe = "mousemove mouseup", zO = /* @__PURE__ */ function(t) {
  Ss(e, t);
  function e() {
    var n, s = e.prototype;
    return s.evEl = aGe, s.evWin = oGe, n = t.apply(this, arguments) || this, n.pressed = !1, n;
  }
  var r = e.prototype;
  return r.handler = function(s) {
    var a = sGe[s.type];
    a & li && s.button === 0 && (this.pressed = !0), a & mc && s.which !== 1 && (a = tn), this.pressed && (a & tn && (this.pressed = !1), this.callback(this.manager, a, {
      pointers: [s],
      changedPointers: [s],
      pointerType: GO,
      srcEvent: s
    }));
  }, e;
}(Ih), lGe = 2500, KF = 25;
function zF(t) {
  var e = t.changedPointers, r = e[0];
  if (r.identifier === this.primaryTouch) {
    var n = {
      x: r.clientX,
      y: r.clientY
    }, s = this.lastTouches;
    this.lastTouches.push(n);
    var a = function() {
      var l = s.indexOf(n);
      l > -1 && s.splice(l, 1);
    };
    setTimeout(a, lGe);
  }
}
function uGe(t, e) {
  t & li ? (this.primaryTouch = e.changedPointers[0].identifier, zF.call(this, e)) : t & (tn | ki) && zF.call(this, e);
}
function cGe(t) {
  for (var e = t.srcEvent.clientX, r = t.srcEvent.clientY, n = 0; n < this.lastTouches.length; n++) {
    var s = this.lastTouches[n], a = Math.abs(e - s.x), o = Math.abs(r - s.y);
    if (a <= KF && o <= KF)
      return !0;
  }
  return !1;
}
var N5 = /* @__PURE__ */ function() {
  var t = /* @__PURE__ */ function(e) {
    Ss(r, e);
    function r(s, a) {
      var o;
      return o = e.call(this, s, a) || this, o.handler = function(l, u, c) {
        var d = c.pointerType === Lv, h = c.pointerType === GO;
        if (!(h && c.sourceCapabilities && c.sourceCapabilities.firesTouchEvents)) {
          if (d)
            uGe.call(ag(ag(o)), u, c);
          else if (h && cGe.call(ag(ag(o)), c))
            return;
          o.callback(l, u, c);
        }
      }, o.touch = new KO(o.manager, o.handler), o.mouse = new zO(o.manager, o.handler), o.primaryTouch = null, o.lastTouches = [], o;
    }
    var n = r.prototype;
    return n.destroy = function() {
      this.touch.destroy(), this.mouse.destroy();
    }, r;
  }(Ih);
  return t;
}();
function dGe(t) {
  var e, r = t.options.inputClass;
  return r ? e = r : Y6e ? e = L5 : H6e ? e = KO : k5 ? e = N5 : e = zO, new e(t, J6e);
}
function hd(t, e, r) {
  return Array.isArray(t) ? (bo(t, r[e], r), !0) : !1;
}
var Fg = 1, ps = 2, jd = 4, Tl = 8, _o = Tl, wp = 16, _a = 32, hGe = 1;
function fGe() {
  return hGe++;
}
function lg(t, e) {
  var r = e.manager;
  return r ? r.get(t) : t;
}
function qF(t) {
  return t & wp ? "cancel" : t & Tl ? "end" : t & jd ? "move" : t & ps ? "start" : "";
}
var Uv = /* @__PURE__ */ function() {
  function t(r) {
    r === void 0 && (r = {}), this.options = qs({
      enable: !0
    }, r), this.id = fGe(), this.manager = null, this.state = Fg, this.simultaneous = {}, this.requireFail = [];
  }
  var e = t.prototype;
  return e.set = function(n) {
    return ju(this.options, n), this.manager && this.manager.touchAction.update(), this;
  }, e.recognizeWith = function(n) {
    if (hd(n, "recognizeWith", this))
      return this;
    var s = this.simultaneous;
    return n = lg(n, this), s[n.id] || (s[n.id] = n, n.recognizeWith(this)), this;
  }, e.dropRecognizeWith = function(n) {
    return hd(n, "dropRecognizeWith", this) ? this : (n = lg(n, this), delete this.simultaneous[n.id], this);
  }, e.requireFailure = function(n) {
    if (hd(n, "requireFailure", this))
      return this;
    var s = this.requireFail;
    return n = lg(n, this), zu(s, n) === -1 && (s.push(n), n.requireFailure(this)), this;
  }, e.dropRequireFailure = function(n) {
    if (hd(n, "dropRequireFailure", this))
      return this;
    n = lg(n, this);
    var s = zu(this.requireFail, n);
    return s > -1 && this.requireFail.splice(s, 1), this;
  }, e.hasRequireFailures = function() {
    return this.requireFail.length > 0;
  }, e.canRecognizeWith = function(n) {
    return !!this.simultaneous[n.id];
  }, e.emit = function(n) {
    var s = this, a = this.state;
    function o(l) {
      s.manager.emit(l, n);
    }
    a < Tl && o(s.options.event + qF(a)), o(s.options.event), n.additionalEvent && o(n.additionalEvent), a >= Tl && o(s.options.event + qF(a));
  }, e.tryEmit = function(n) {
    if (this.canEmit())
      return this.emit(n);
    this.state = _a;
  }, e.canEmit = function() {
    for (var n = 0; n < this.requireFail.length; ) {
      if (!(this.requireFail[n].state & (_a | Fg)))
        return !1;
      n++;
    }
    return !0;
  }, e.recognize = function(n) {
    var s = ju({}, n);
    if (!Mb(this.options.enable, [this, s])) {
      this.reset(), this.state = _a;
      return;
    }
    this.state & (_o | wp | _a) && (this.state = Fg), this.state = this.process(s), this.state & (ps | jd | Tl | wp) && this.tryEmit(s);
  }, e.process = function(n) {
  }, e.getTouchAction = function() {
  }, e.reset = function() {
  }, t;
}(), N$ = /* @__PURE__ */ function(t) {
  Ss(e, t);
  function e(n) {
    var s;
    return n === void 0 && (n = {}), s = t.call(this, qs({
      event: "tap",
      pointers: 1,
      taps: 1,
      interval: 300,
      // max time between the multi-tap taps
      time: 250,
      // max time of the pointer to be down (like finger on the screen)
      threshold: 9,
      // a minimal movement is ok, but keep it low
      posThreshold: 10
    }, n)) || this, s.pTime = !1, s.pCenter = !1, s._timer = null, s._input = null, s.count = 0, s;
  }
  var r = e.prototype;
  return r.getTouchAction = function() {
    return [M$];
  }, r.process = function(s) {
    var a = this, o = this.options, l = s.pointers.length === o.pointers, u = s.distance < o.threshold, c = s.deltaTime < o.time;
    if (this.reset(), s.eventType & li && this.count === 0)
      return this.failTimeout();
    if (u && c && l) {
      if (s.eventType !== tn)
        return this.failTimeout();
      var d = this.pTime ? s.timeStamp - this.pTime < o.interval : !0, h = !this.pCenter || Hy(this.pCenter, s.center) < o.posThreshold;
      this.pTime = s.timeStamp, this.pCenter = s.center, !h || !d ? this.count = 1 : this.count += 1, this._input = s;
      var f = this.count % o.taps;
      if (f === 0)
        return this.hasRequireFailures() ? (this._timer = setTimeout(function() {
          a.state = _o, a.tryEmit();
        }, o.interval), ps) : _o;
    }
    return _a;
  }, r.failTimeout = function() {
    var s = this;
    return this._timer = setTimeout(function() {
      s.state = _a;
    }, this.options.interval), _a;
  }, r.reset = function() {
    clearTimeout(this._timer);
  }, r.emit = function() {
    this.state === _o && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
  }, e;
}(Uv), Kd = /* @__PURE__ */ function(t) {
  Ss(e, t);
  function e(n) {
    return n === void 0 && (n = {}), t.call(this, qs({
      pointers: 1
    }, n)) || this;
  }
  var r = e.prototype;
  return r.attrTest = function(s) {
    var a = this.options.pointers;
    return a === 0 || s.pointers.length === a;
  }, r.process = function(s) {
    var a = this.state, o = s.eventType, l = a & (ps | jd), u = this.attrTest(s);
    return l && (o & ki || !u) ? a | wp : l || u ? o & tn ? a | Tl : a & ps ? a | jd : ps : _a;
  }, e;
}(Uv);
function F5(t) {
  return t === Wd ? "down" : t === Bv ? "up" : t === Nv ? "left" : t === Fv ? "right" : "";
}
var qO = /* @__PURE__ */ function(t) {
  Ss(e, t);
  function e(n) {
    var s;
    return n === void 0 && (n = {}), s = t.call(this, qs({
      event: "pan",
      threshold: 10,
      pointers: 1,
      direction: D5
    }, n)) || this, s.pX = null, s.pY = null, s;
  }
  var r = e.prototype;
  return r.getTouchAction = function() {
    var s = this.options.direction, a = [];
    return s & $a && a.push(yp), s & Ou && a.push(gp), a;
  }, r.directionTest = function(s) {
    var a = this.options, o = !0, l = s.distance, u = s.direction, c = s.deltaX, d = s.deltaY;
    return u & a.direction || (a.direction & $a ? (u = c === 0 ? Vy : c < 0 ? Nv : Fv, o = c !== this.pX, l = Math.abs(s.deltaX)) : (u = d === 0 ? Vy : d < 0 ? Bv : Wd, o = d !== this.pY, l = Math.abs(s.deltaY))), s.direction = u, o && l > a.threshold && u & a.direction;
  }, r.attrTest = function(s) {
    return Kd.prototype.attrTest.call(this, s) && // replace with a super call
    (this.state & ps || !(this.state & ps) && this.directionTest(s));
  }, r.emit = function(s) {
    this.pX = s.deltaX, this.pY = s.deltaY;
    var a = F5(s.direction);
    a && (s.additionalEvent = this.options.event + a), t.prototype.emit.call(this, s);
  }, e;
}(Kd), B5 = /* @__PURE__ */ function(t) {
  Ss(e, t);
  function e(n) {
    return n === void 0 && (n = {}), t.call(this, qs({
      event: "swipe",
      threshold: 10,
      velocity: 0.3,
      direction: $a | Ou,
      pointers: 1
    }, n)) || this;
  }
  var r = e.prototype;
  return r.getTouchAction = function() {
    return qO.prototype.getTouchAction.call(this);
  }, r.attrTest = function(s) {
    var a = this.options.direction, o;
    return a & ($a | Ou) ? o = s.overallVelocity : a & $a ? o = s.overallVelocityX : a & Ou && (o = s.overallVelocityY), t.prototype.attrTest.call(this, s) && a & s.offsetDirection && s.distance > this.options.threshold && s.maxPointers === this.options.pointers && Ku(o) > this.options.velocity && s.eventType & tn;
  }, r.emit = function(s) {
    var a = F5(s.offsetDirection);
    a && this.manager.emit(this.options.event + a, s), this.manager.emit(this.options.event, s);
  }, e;
}(Kd), U5 = /* @__PURE__ */ function(t) {
  Ss(e, t);
  function e(n) {
    return n === void 0 && (n = {}), t.call(this, qs({
      event: "pinch",
      threshold: 0,
      pointers: 2
    }, n)) || this;
  }
  var r = e.prototype;
  return r.getTouchAction = function() {
    return [Du];
  }, r.attrTest = function(s) {
    return t.prototype.attrTest.call(this, s) && (Math.abs(s.scale - 1) > this.options.threshold || this.state & ps);
  }, r.emit = function(s) {
    if (s.scale !== 1) {
      var a = s.scale < 1 ? "in" : "out";
      s.additionalEvent = this.options.event + a;
    }
    t.prototype.emit.call(this, s);
  }, e;
}(Kd), V5 = /* @__PURE__ */ function(t) {
  Ss(e, t);
  function e(n) {
    return n === void 0 && (n = {}), t.call(this, qs({
      event: "rotate",
      threshold: 0,
      pointers: 2
    }, n)) || this;
  }
  var r = e.prototype;
  return r.getTouchAction = function() {
    return [Du];
  }, r.attrTest = function(s) {
    return t.prototype.attrTest.call(this, s) && (Math.abs(s.rotation) > this.options.threshold || this.state & ps);
  }, e;
}(Kd), Y5 = /* @__PURE__ */ function(t) {
  Ss(e, t);
  function e(n) {
    var s;
    return n === void 0 && (n = {}), s = t.call(this, qs({
      event: "press",
      pointers: 1,
      time: 251,
      // minimal time of the pointer to be pressed
      threshold: 9
    }, n)) || this, s._timer = null, s._input = null, s;
  }
  var r = e.prototype;
  return r.getTouchAction = function() {
    return [$5];
  }, r.process = function(s) {
    var a = this, o = this.options, l = s.pointers.length === o.pointers, u = s.distance < o.threshold, c = s.deltaTime > o.time;
    if (this._input = s, !u || !l || s.eventType & (tn | ki) && !c)
      this.reset();
    else if (s.eventType & li)
      this.reset(), this._timer = setTimeout(function() {
        a.state = _o, a.tryEmit();
      }, o.time);
    else if (s.eventType & tn)
      return _o;
    return _a;
  }, r.reset = function() {
    clearTimeout(this._timer);
  }, r.emit = function(s) {
    this.state === _o && (s && s.eventType & tn ? this.manager.emit(this.options.event + "up", s) : (this._input.timeStamp = HO(), this.manager.emit(this.options.event, this._input)));
  }, e;
}(Uv), H5 = {
  /**
   * @private
   * set if DOM events are being triggered.
   * But this is slower and unused by simple implementations, so disabled by default.
   * @type {Boolean}
   * @default false
   */
  domEvents: !1,
  /**
   * @private
   * The value for the touchAction property/fallback.
   * When set to `compute` it will magically set the correct value based on the added recognizers.
   * @type {String}
   * @default compute
   */
  touchAction: E5,
  /**
   * @private
   * @type {Boolean}
   * @default true
   */
  enable: !0,
  /**
   * @private
   * EXPERIMENTAL FEATURE -- can be removed/changed
   * Change the parent input target element.
   * If Null, then it is being set the to main element.
   * @type {Null|EventTarget}
   * @default null
   */
  inputTarget: null,
  /**
   * @private
   * force an input class
   * @type {Null|Function}
   * @default null
   */
  inputClass: null,
  /**
   * @private
   * Some CSS properties can be used to improve the working of Hammer.
   * Add them to this method and they will be set when creating a new Manager.
   * @namespace
   */
  cssProps: {
    /**
     * @private
     * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */
    userSelect: "none",
    /**
     * @private
     * Disable the Windows Phone grippers when pressing an element.
     * @type {String}
     * @default 'none'
     */
    touchSelect: "none",
    /**
     * @private
     * Disables the default callout shown when you touch and hold a touch target.
     * On iOS, when you touch and hold a touch target such as a link, Safari displays
     * a callout containing information about the link. This property allows you to disable that callout.
     * @type {String}
     * @default 'none'
     */
    touchCallout: "none",
    /**
     * @private
     * Specifies whether zooming is enabled. Used by IE10>
     * @type {String}
     * @default 'none'
     */
    contentZooming: "none",
    /**
     * @private
     * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */
    userDrag: "none",
    /**
     * @private
     * Overrides the highlight color shown when the user taps a link or a JavaScript
     * clickable element in iOS. This property obeys the alpha value, if specified.
     * @type {String}
     * @default 'rgba(0,0,0,0)'
     */
    tapHighlightColor: "rgba(0,0,0,0)"
  }
}, XF = [[V5, {
  enable: !1
}], [U5, {
  enable: !1
}, ["rotate"]], [B5, {
  direction: $a
}], [qO, {
  direction: $a
}, ["swipe"]], [N$], [N$, {
  event: "doubletap",
  taps: 2
}, ["tap"]], [Y5]], pGe = 1, QF = 2;
function ZF(t, e) {
  var r = t.element;
  if (r.style) {
    var n;
    bo(t.options.cssProps, function(s, a) {
      n = Rb(r.style, a), e ? (t.oldCssProps[n] = r.style[n], r.style[n] = s) : r.style[n] = t.oldCssProps[n] || "";
    }), e || (t.oldCssProps = {});
  }
}
function vGe(t, e) {
  var r = document.createEvent("Event");
  r.initEvent(t, !0, !0), r.gesture = e, e.target.dispatchEvent(r);
}
var JF = /* @__PURE__ */ function() {
  function t(r, n) {
    var s = this;
    this.options = ju({}, H5, n || {}), this.options.inputTarget = this.options.inputTarget || r, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = r, this.input = dGe(this), this.touchAction = new A5(this, this.options.touchAction), ZF(this, !0), bo(this.options.recognizers, function(a) {
      var o = s.add(new a[0](a[1]));
      a[2] && o.recognizeWith(a[2]), a[3] && o.requireFailure(a[3]);
    }, this);
  }
  var e = t.prototype;
  return e.set = function(n) {
    return ju(this.options, n), n.touchAction && this.touchAction.update(), n.inputTarget && (this.input.destroy(), this.input.target = n.inputTarget, this.input.init()), this;
  }, e.stop = function(n) {
    this.session.stopped = n ? QF : pGe;
  }, e.recognize = function(n) {
    var s = this.session;
    if (!s.stopped) {
      this.touchAction.preventDefaults(n);
      var a, o = this.recognizers, l = s.curRecognizer;
      (!l || l && l.state & _o) && (s.curRecognizer = null, l = null);
      for (var u = 0; u < o.length; )
        a = o[u], s.stopped !== QF && // 1
        (!l || a === l || // 2
        a.canRecognizeWith(l)) ? a.recognize(n) : a.reset(), !l && a.state & (ps | jd | Tl) && (s.curRecognizer = a, l = a), u++;
    }
  }, e.get = function(n) {
    if (n instanceof Uv)
      return n;
    for (var s = this.recognizers, a = 0; a < s.length; a++)
      if (s[a].options.event === n)
        return s[a];
    return null;
  }, e.add = function(n) {
    if (hd(n, "add", this))
      return this;
    var s = this.get(n.options.event);
    return s && this.remove(s), this.recognizers.push(n), n.manager = this, this.touchAction.update(), n;
  }, e.remove = function(n) {
    if (hd(n, "remove", this))
      return this;
    var s = this.get(n);
    if (n) {
      var a = this.recognizers, o = zu(a, s);
      o !== -1 && (a.splice(o, 1), this.touchAction.update());
    }
    return this;
  }, e.on = function(n, s) {
    if (n === void 0 || s === void 0)
      return this;
    var a = this.handlers;
    return bo(bp(n), function(o) {
      a[o] = a[o] || [], a[o].push(s);
    }), this;
  }, e.off = function(n, s) {
    if (n === void 0)
      return this;
    var a = this.handlers;
    return bo(bp(n), function(o) {
      s ? a[o] && a[o].splice(zu(a[o], s), 1) : delete a[o];
    }), this;
  }, e.emit = function(n, s) {
    this.options.domEvents && vGe(n, s);
    var a = this.handlers[n] && this.handlers[n].slice();
    if (!(!a || !a.length)) {
      s.type = n, s.preventDefault = function() {
        s.srcEvent.preventDefault();
      };
      for (var o = 0; o < a.length; )
        a[o](s), o++;
    }
  }, e.destroy = function() {
    this.element && ZF(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
  }, t;
}(), mGe = {
  touchstart: li,
  touchmove: mc,
  touchend: tn,
  touchcancel: ki
}, gGe = "touchstart", yGe = "touchstart touchmove touchend touchcancel", bGe = /* @__PURE__ */ function(t) {
  Ss(e, t);
  function e() {
    var n, s = e.prototype;
    return s.evTarget = gGe, s.evWin = yGe, n = t.apply(this, arguments) || this, n.started = !1, n;
  }
  var r = e.prototype;
  return r.handler = function(s) {
    var a = mGe[s.type];
    if (a === li && (this.started = !0), !!this.started) {
      var o = _Ge.call(this, s, a);
      a & (tn | ki) && o[0].length - o[1].length === 0 && (this.started = !1), this.callback(this.manager, a, {
        pointers: o[0],
        changedPointers: o[1],
        pointerType: Lv,
        srcEvent: s
      });
    }
  }, e;
}(Ih);
function _Ge(t, e) {
  var r = _p(t.touches), n = _p(t.changedTouches);
  return e & (tn | ki) && (r = jO(r.concat(n), "identifier", !0)), [r, n];
}
function G5(t, e, r) {
  var n = "DEPRECATED METHOD: " + e + `
` + r + ` AT 
`;
  return function() {
    var s = new Error("get-stack-trace"), a = s && s.stack ? s.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace", o = window.console && (window.console.warn || window.console.log);
    return o && o.call(window.console, n, a), t.apply(this, arguments);
  };
}
var W5 = G5(function(t, e, r) {
  for (var n = Object.keys(e), s = 0; s < n.length; )
    (!r || r && t[n[s]] === void 0) && (t[n[s]] = e[n[s]]), s++;
  return t;
}, "extend", "Use `assign`."), wGe = G5(function(t, e) {
  return W5(t, e, !0);
}, "merge", "Use `assign`.");
function TGe(t, e, r) {
  var n = e.prototype, s;
  s = t.prototype = Object.create(n), s.constructor = t, s._super = n, r && ju(s, r);
}
function e2(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
var j5 = /* @__PURE__ */ function() {
  var t = (
    /**
      * @private
      * @const {string}
      */
    function(r, n) {
      return n === void 0 && (n = {}), new JF(r, qs({
        recognizers: XF.concat()
      }, n));
    }
  );
  return t.VERSION = "2.0.17-rc", t.DIRECTION_ALL = D5, t.DIRECTION_DOWN = Wd, t.DIRECTION_LEFT = Nv, t.DIRECTION_RIGHT = Fv, t.DIRECTION_UP = Bv, t.DIRECTION_HORIZONTAL = $a, t.DIRECTION_VERTICAL = Ou, t.DIRECTION_NONE = Vy, t.DIRECTION_DOWN = Wd, t.INPUT_START = li, t.INPUT_MOVE = mc, t.INPUT_END = tn, t.INPUT_CANCEL = ki, t.STATE_POSSIBLE = Fg, t.STATE_BEGAN = ps, t.STATE_CHANGED = jd, t.STATE_ENDED = Tl, t.STATE_RECOGNIZED = _o, t.STATE_CANCELLED = wp, t.STATE_FAILED = _a, t.Manager = JF, t.Input = Ih, t.TouchAction = A5, t.TouchInput = KO, t.MouseInput = zO, t.PointerEventInput = L5, t.TouchMouseInput = N5, t.SingleTouchInput = bGe, t.Recognizer = Uv, t.AttrRecognizer = Kd, t.Tap = N$, t.Pan = qO, t.Swipe = B5, t.Pinch = U5, t.Rotate = V5, t.Press = Y5, t.on = Rf, t.off = Mf, t.each = bo, t.merge = wGe, t.extend = W5, t.bindFn = e2, t.assign = ju, t.inherit = TGe, t.bindFn = e2, t.prefixed = Rb, t.toArray = _p, t.inArray = zu, t.uniqueArray = jO, t.splitStr = bp, t.boolOrFn = Mb, t.hasParent = WO, t.addEventListeners = Rf, t.removeEventListeners = Mf, t.defaults = ju({}, H5, {
    preset: XF
  }), t;
}();
j5.defaults;
var K5 = j5;
function t2(t, e) {
  var r = xn(t);
  if (By) {
    var n = By(t);
    e && (n = At(n).call(n, function(s) {
      return Ab(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function r2(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r, n, s = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Le(r = t2(Object(s), !0)).call(r, function(a) {
      n5(t, a, s[a]);
    }) : Uy ? r5(t, Uy(s)) : Le(n = t2(Object(s))).call(n, function(a) {
      BO(t, a, Ab(s, a));
    });
  }
  return t;
}
function XO(t, e) {
  var r = typeof Nl < "u" && Vo(t) || t["@@iterator"];
  if (!r) {
    if ($t(t) || (r = xGe(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, s = function() {
      };
      return { s, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(c) {
        throw c;
      }, f: s };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return { s: function() {
    r = r.call(t);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    o = !0, l = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (o)
        throw l;
    }
  } };
}
function xGe(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return n2(t, e);
    var n = hi(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return vc(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return n2(t, e);
  }
}
function n2(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
var QO = Nl("DELETE");
function SGe(t) {
  for (var e, r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
    n[s - 1] = arguments[s];
  return ZO.apply(void 0, Dr(e = [{}, t]).call(e, n));
}
function ZO() {
  var t = Gy.apply(void 0, arguments);
  return q5(t), t;
}
function Gy() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  if (e.length < 2)
    return e[0];
  if (e.length > 2) {
    var n;
    return Gy.apply(void 0, Dr(n = [ZO(e[0], e[1])]).call(n, Vs(hi(e).call(e, 2))));
  }
  var s = e[0], a = e[1], o = XO(SYe(a)), l;
  try {
    for (o.s(); !(l = o.n()).done; ) {
      var u = l.value;
      Object.prototype.propertyIsEnumerable.call(a, u) && (a[u] === QO ? delete s[u] : s[u] !== null && a[u] !== null && mt(s[u]) === "object" && mt(a[u]) === "object" && !$t(s[u]) && !$t(a[u]) ? s[u] = Gy(s[u], a[u]) : s[u] = z5(a[u]));
    }
  } catch (c) {
    o.e(c);
  } finally {
    o.f();
  }
  return s;
}
function z5(t) {
  return $t(t) ? ln(t).call(t, function(e) {
    return z5(e);
  }) : mt(t) === "object" && t !== null ? Gy({}, t) : t;
}
function q5(t) {
  for (var e = 0, r = xn(t); e < r.length; e++) {
    var n = r[e];
    t[n] === QO ? delete t[n] : mt(t[n]) === "object" && t[n] !== null && q5(t[n]);
  }
}
function EGe() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return $Ge(e.length ? e : [Bi()]);
}
function $Ge(t) {
  var e = kGe(t), r = nYe(e, 3), n = r[0], s = r[1], a = r[2], o = 1, l = function() {
    var c = 2091639 * n + o * 23283064365386963e-26;
    return n = s, s = a, a = c - (o = c | 0);
  };
  return l.uint32 = function() {
    return l() * 4294967296;
  }, l.fract53 = function() {
    return l() + (l() * 2097152 | 0) * 11102230246251565e-32;
  }, l.algorithm = "Alea", l.seed = t, l.version = "0.9", l;
}
function kGe() {
  for (var t = DGe(), e = t(" "), r = t(" "), n = t(" "), s = 0; s < arguments.length; s++)
    e -= t(s < 0 || arguments.length <= s ? void 0 : arguments[s]), e < 0 && (e += 1), r -= t(s < 0 || arguments.length <= s ? void 0 : arguments[s]), r < 0 && (r += 1), n -= t(s < 0 || arguments.length <= s ? void 0 : arguments[s]), n < 0 && (n += 1);
  return [e, r, n];
}
function DGe() {
  var t = 4022871197;
  return function(e) {
    for (var r = e.toString(), n = 0; n < r.length; n++) {
      t += r.charCodeAt(n);
      var s = 0.02519603282416938 * t;
      t = s >>> 0, s -= t, s *= t, t = s >>> 0, s -= t, t += s * 4294967296;
    }
    return (t >>> 0) * 23283064365386963e-26;
  };
}
function OGe() {
  var t = function() {
  };
  return {
    on: t,
    off: t,
    destroy: t,
    emit: t,
    get: function() {
      return {
        set: t
      };
    }
  };
}
var JO = typeof window < "u" ? window.Hammer || K5 : function() {
  return OGe();
};
function wa(t) {
  var e = this, r;
  this._cleanupQueue = [], this.active = !1, this._dom = {
    container: t,
    overlay: document.createElement("div")
  }, this._dom.overlay.classList.add("vis-overlay"), this._dom.container.appendChild(this._dom.overlay), this._cleanupQueue.push(function() {
    e._dom.overlay.parentNode.removeChild(e._dom.overlay);
  });
  var n = JO(this._dom.overlay);
  n.on("tap", de(r = this._onTapOverlay).call(r, this)), this._cleanupQueue.push(function() {
    n.destroy();
  });
  var s = ["tap", "doubletap", "press", "pinch", "pan", "panstart", "panmove", "panend"];
  Le(s).call(s, function(a) {
    n.on(a, function(o) {
      o.srcEvent.stopPropagation();
    });
  }), document && document.body && (this._onClick = function(a) {
    AGe(a.target, t) || e.deactivate();
  }, document.body.addEventListener("click", this._onClick), this._cleanupQueue.push(function() {
    document.body.removeEventListener("click", e._onClick);
  })), this._escListener = function(a) {
    ("key" in a ? a.key === "Escape" : a.keyCode === 27) && e.deactivate();
  };
}
YO(wa.prototype);
wa.current = null;
wa.prototype.destroy = function() {
  var t, e;
  this.deactivate();
  var r = XO(WYe(t = xi(e = this._cleanupQueue).call(e, 0)).call(t)), n;
  try {
    for (r.s(); !(n = r.n()).done; ) {
      var s = n.value;
      s();
    }
  } catch (a) {
    r.e(a);
  } finally {
    r.f();
  }
};
wa.prototype.activate = function() {
  wa.current && wa.current.deactivate(), wa.current = this, this.active = !0, this._dom.overlay.style.display = "none", this._dom.container.classList.add("vis-active"), this.emit("change"), this.emit("activate"), document.body.addEventListener("keydown", this._escListener);
};
wa.prototype.deactivate = function() {
  this.active = !1, this._dom.overlay.style.display = "block", this._dom.container.classList.remove("vis-active"), document.body.removeEventListener("keydown", this._escListener), this.emit("change"), this.emit("deactivate");
};
wa.prototype._onTapOverlay = function(t) {
  this.activate(), t.srcEvent.stopPropagation();
};
function AGe(t, e) {
  for (; t; ) {
    if (t === e)
      return !0;
    t = t.parentNode;
  }
  return !1;
}
var CGe = /^\/?Date\((-?\d+)/i, IGe = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, PGe = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, RGe = /^rgb\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *\)$/i, MGe = /^rgba\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *([01]|0?\.\d+) *\)$/i;
function Lf(t) {
  return t instanceof Number || typeof t == "number";
}
function X5(t) {
  if (t)
    for (; t.hasChildNodes() === !0; ) {
      var e = t.firstChild;
      e && (X5(e), t.removeChild(e));
    }
}
function Yi(t) {
  return t instanceof String || typeof t == "string";
}
function F$(t) {
  return mt(t) === "object" && t !== null;
}
function LGe(t) {
  if (t instanceof Date)
    return !0;
  if (Yi(t)) {
    var e = CGe.exec(t);
    if (e)
      return !0;
    if (!isNaN(Date.parse(t)))
      return !0;
  }
  return !1;
}
function qu(t, e, r, n) {
  var s = !1;
  n === !0 && (s = e[r] === null && t[r] !== void 0), s ? delete t[r] : t[r] = e[r];
}
function Q5(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  for (var n in t)
    if (e[n] !== void 0)
      if (e[n] === null || mt(e[n]) !== "object")
        qu(t, e, n, r);
      else {
        var s = t[n], a = e[n];
        F$(s) && F$(a) && Q5(s, a, r);
      }
}
var NGe = Wu;
function FGe(t, e) {
  if (!$t(t))
    throw new Error("Array with property names expected as first argument");
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), s = 2; s < r; s++)
    n[s - 2] = arguments[s];
  for (var a = 0, o = n; a < o.length; a++)
    for (var l = o[a], u = 0; u < t.length; u++) {
      var c = t[u];
      l && Object.prototype.hasOwnProperty.call(l, c) && (e[c] = l[c]);
    }
  return e;
}
function BGe(t, e, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if ($t(r))
    throw new TypeError("Arrays are not supported by deepExtend");
  for (var s = 0; s < t.length; s++) {
    var a = t[s];
    if (Object.prototype.hasOwnProperty.call(r, a))
      if (r[a] && r[a].constructor === Object)
        e[a] === void 0 && (e[a] = {}), e[a].constructor === Object ? Tp(e[a], r[a], !1, n) : qu(e, r, a, n);
      else {
        if ($t(r[a]))
          throw new TypeError("Arrays are not supported by deepExtend");
        qu(e, r, a, n);
      }
  }
  return e;
}
function UGe(t, e, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if ($t(r))
    throw new TypeError("Arrays are not supported by deepExtend");
  for (var s in r)
    if (Object.prototype.hasOwnProperty.call(r, s) && !Cl(t).call(t, s))
      if (r[s] && r[s].constructor === Object)
        e[s] === void 0 && (e[s] = {}), e[s].constructor === Object ? Tp(e[s], r[s]) : qu(e, r, s, n);
      else if ($t(r[s])) {
        e[s] = [];
        for (var a = 0; a < r[s].length; a++)
          e[s].push(r[s][a]);
      } else
        qu(e, r, s, n);
  return e;
}
function Tp(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  for (var s in e)
    if (Object.prototype.hasOwnProperty.call(e, s) || r === !0)
      if (mt(e[s]) === "object" && e[s] !== null && RF(e[s]) === Object.prototype)
        t[s] === void 0 ? t[s] = Tp({}, e[s], r) : mt(t[s]) === "object" && t[s] !== null && RF(t[s]) === Object.prototype ? Tp(t[s], e[s], r) : qu(t, e, s, n);
      else if ($t(e[s])) {
        var a;
        t[s] = hi(a = e[s]).call(a);
      } else
        qu(t, e, s, n);
  return t;
}
function VGe(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var r = 0, n = t.length; r < n; r++)
    if (t[r] != e[r])
      return !1;
  return !0;
}
function yf(t) {
  var e = mt(t);
  return e === "object" ? t === null ? "null" : t instanceof Boolean ? "Boolean" : t instanceof Number ? "Number" : t instanceof String ? "String" : $t(t) ? "Array" : t instanceof Date ? "Date" : "Object" : e === "number" ? "Number" : e === "boolean" ? "Boolean" : e === "string" ? "String" : e === void 0 ? "undefined" : e;
}
function xp(t, e) {
  var r;
  return Dr(r = []).call(r, Vs(t), [e]);
}
function Z5(t) {
  return hi(t).call(t);
}
function YGe(t) {
  return t.getBoundingClientRect().left;
}
function HGe(t) {
  return t.getBoundingClientRect().right;
}
function GGe(t) {
  return t.getBoundingClientRect().top;
}
function WGe(t, e) {
  var r = t.className.split(" "), n = e.split(" ");
  r = Dr(r).call(r, At(n).call(n, function(s) {
    return !Cl(r).call(r, s);
  })), t.className = r.join(" ");
}
function jGe(t, e) {
  var r = t.className.split(" "), n = e.split(" ");
  r = At(r).call(r, function(s) {
    return !Cl(n).call(n, s);
  }), t.className = r.join(" ");
}
function KGe(t, e) {
  if ($t(t))
    for (var r = t.length, n = 0; n < r; n++)
      e(t[n], n, t);
  else
    for (var s in t)
      Object.prototype.hasOwnProperty.call(t, s) && e(t[s], s, t);
}
var zGe = UO;
function qGe(t, e, r) {
  return t[e] !== r ? (t[e] = r, !0) : !1;
}
function XGe(t) {
  var e = !1;
  return function() {
    e || (e = !0, requestAnimationFrame(function() {
      e = !1, t();
    }));
  };
}
function QGe(t, e, r, n) {
  if (t.addEventListener) {
    var s;
    n === void 0 && (n = !1), e === "mousewheel" && Cl(s = navigator.userAgent).call(s, "Firefox") && (e = "DOMMouseScroll"), t.addEventListener(e, r, n);
  } else
    t.attachEvent("on" + e, r);
}
function ZGe(t, e, r, n) {
  if (t.removeEventListener) {
    var s;
    n === void 0 && (n = !1), e === "mousewheel" && Cl(s = navigator.userAgent).call(s, "Firefox") && (e = "DOMMouseScroll"), t.removeEventListener(e, r, n);
  } else
    t.detachEvent("on" + e, r);
}
function JGe(t) {
  t || (t = window.event), t && (t.preventDefault ? t.preventDefault() : t.returnValue = !1);
}
function e5e() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event, e = null;
  return t && (t.target ? e = t.target : t.srcElement && (e = t.srcElement)), !(e instanceof Element) || e.nodeType != null && e.nodeType == 3 && (e = e.parentNode, !(e instanceof Element)) ? null : e;
}
function t5e(t, e) {
  for (var r = t; r; ) {
    if (r === e)
      return !0;
    if (r.parentNode)
      r = r.parentNode;
    else
      return !1;
  }
  return !1;
}
var r5e = {
  /**
   * Convert a value into a boolean.
   *
   * @param value - Value to be converted intoboolean, a function will be executed as `(() => unknown)`.
   * @param defaultValue - If the value or the return value of the function == null then this will be returned.
   * @returns Corresponding boolean value, if none then the default value, if none then null.
   */
  asBoolean: function(e, r) {
    return typeof e == "function" && (e = e()), e != null ? e != !1 : r || null;
  },
  /**
   * Convert a value into a number.
   *
   * @param value - Value to be converted intonumber, a function will be executed as `(() => unknown)`.
   * @param defaultValue - If the value or the return value of the function == null then this will be returned.
   * @returns Corresponding **boxed** number value, if none then the default value, if none then null.
   */
  asNumber: function(e, r) {
    return typeof e == "function" && (e = e()), e != null ? Number(e) || r || null : r || null;
  },
  /**
   * Convert a value into a string.
   *
   * @param value - Value to be converted intostring, a function will be executed as `(() => unknown)`.
   * @param defaultValue - If the value or the return value of the function == null then this will be returned.
   * @returns Corresponding **boxed** string value, if none then the default value, if none then null.
   */
  asString: function(e, r) {
    return typeof e == "function" && (e = e()), e != null ? String(e) : r || null;
  },
  /**
   * Convert a value into a size.
   *
   * @param value - Value to be converted intosize, a function will be executed as `(() => unknown)`.
   * @param defaultValue - If the value or the return value of the function == null then this will be returned.
   * @returns Corresponding string value (number + 'px'), if none then the default value, if none then null.
   */
  asSize: function(e, r) {
    return typeof e == "function" && (e = e()), Yi(e) ? e : Lf(e) ? e + "px" : r || null;
  },
  /**
   * Convert a value into a DOM Element.
   *
   * @param value - Value to be converted into DOM Element, a function will be executed as `(() => unknown)`.
   * @param defaultValue - If the value or the return value of the function == null then this will be returned.
   * @returns The DOM Element, if none then the default value, if none then null.
   */
  asElement: function(e, r) {
    return typeof e == "function" && (e = e()), e || r || null;
  }
};
function Lb(t) {
  var e;
  switch (t.length) {
    case 3:
    case 4:
      return e = PGe.exec(t), e ? {
        r: Ui(e[1] + e[1], 16),
        g: Ui(e[2] + e[2], 16),
        b: Ui(e[3] + e[3], 16)
      } : null;
    case 6:
    case 7:
      return e = IGe.exec(t), e ? {
        r: Ui(e[1], 16),
        g: Ui(e[2], 16),
        b: Ui(e[3], 16)
      } : null;
    default:
      return null;
  }
}
function n5e(t, e) {
  if (Cl(t).call(t, "rgba"))
    return t;
  if (Cl(t).call(t, "rgb")) {
    var r = t.substr(lr(t).call(t, "(") + 1).replace(")", "").split(",");
    return "rgba(" + r[0] + "," + r[1] + "," + r[2] + "," + e + ")";
  } else {
    var n = Lb(t);
    return n == null ? t : "rgba(" + n.r + "," + n.g + "," + n.b + "," + e + ")";
  }
}
function eA(t, e, r) {
  var n;
  return "#" + hi(n = ((1 << 24) + (t << 16) + (e << 8) + r).toString(16)).call(n, 1);
}
function i5e(t, e) {
  if (Yi(t)) {
    var r = t;
    if (rA(r)) {
      var n, s = ln(n = r.substr(4).substr(0, r.length - 5).split(",")).call(n, function(f) {
        return Ui(f);
      });
      r = eA(s[0], s[1], s[2]);
    }
    if (tA(r) === !0) {
      var a = J5(r), o = {
        h: a.h,
        s: a.s * 0.8,
        v: Math.min(1, a.v * 1.02)
      }, l = {
        h: a.h,
        s: Math.min(1, a.s * 1.25),
        v: a.v * 0.8
      }, u = B$(l.h, l.s, l.v), c = B$(o.h, o.s, o.v);
      return {
        background: r,
        border: u,
        highlight: {
          background: c,
          border: u
        },
        hover: {
          background: c,
          border: u
        }
      };
    } else
      return {
        background: r,
        border: r,
        highlight: {
          background: r,
          border: r
        },
        hover: {
          background: r,
          border: r
        }
      };
  } else if (e) {
    var d = {
      background: t.background || e.background,
      border: t.border || e.border,
      highlight: Yi(t.highlight) ? {
        border: t.highlight,
        background: t.highlight
      } : {
        background: t.highlight && t.highlight.background || e.highlight.background,
        border: t.highlight && t.highlight.border || e.highlight.border
      },
      hover: Yi(t.hover) ? {
        border: t.hover,
        background: t.hover
      } : {
        border: t.hover && t.hover.border || e.hover.border,
        background: t.hover && t.hover.background || e.hover.background
      }
    };
    return d;
  } else {
    var h = {
      background: t.background || void 0,
      border: t.border || void 0,
      highlight: Yi(t.highlight) ? {
        border: t.highlight,
        background: t.highlight
      } : {
        background: t.highlight && t.highlight.background || void 0,
        border: t.highlight && t.highlight.border || void 0
      },
      hover: Yi(t.hover) ? {
        border: t.hover,
        background: t.hover
      } : {
        border: t.hover && t.hover.border || void 0,
        background: t.hover && t.hover.background || void 0
      }
    };
    return h;
  }
}
function fd(t, e, r) {
  t = t / 255, e = e / 255, r = r / 255;
  var n = Math.min(t, Math.min(e, r)), s = Math.max(t, Math.max(e, r));
  if (n === s)
    return {
      h: 0,
      s: 0,
      v: n
    };
  var a = t === n ? e - r : r === n ? t - e : r - t, o = t === n ? 3 : r === n ? 1 : 5, l = 60 * (o - a / (s - n)) / 360, u = (s - n) / s, c = s;
  return {
    h: l,
    s: u,
    v: c
  };
}
var kd = {
  // split a string with css styles into an object with key/values
  split: function(e) {
    var r, n = {};
    return Le(r = e.split(";")).call(r, function(s) {
      if (Jw(s).call(s) != "") {
        var a, o, l = s.split(":"), u = Jw(a = l[0]).call(a), c = Jw(o = l[1]).call(o);
        n[u] = c;
      }
    }), n;
  },
  // build a css text string from an object with key/values
  join: function(e) {
    var r;
    return ln(r = xn(e)).call(r, function(n) {
      return n + ": " + e[n];
    }).join("; ");
  }
};
function s5e(t, e) {
  var r = kd.split(t.style.cssText), n = kd.split(e), s = r2(r2({}, r), n);
  t.style.cssText = kd.join(s);
}
function a5e(t, e) {
  var r = kd.split(t.style.cssText), n = kd.split(e);
  for (var s in n)
    Object.prototype.hasOwnProperty.call(n, s) && delete r[s];
  t.style.cssText = kd.join(r);
}
function Nf(t, e, r) {
  var n, s, a, o = Math.floor(t * 6), l = t * 6 - o, u = r * (1 - e), c = r * (1 - l * e), d = r * (1 - (1 - l) * e);
  switch (o % 6) {
    case 0:
      n = r, s = d, a = u;
      break;
    case 1:
      n = c, s = r, a = u;
      break;
    case 2:
      n = u, s = r, a = d;
      break;
    case 3:
      n = u, s = c, a = r;
      break;
    case 4:
      n = d, s = u, a = r;
      break;
    case 5:
      n = r, s = u, a = c;
      break;
  }
  return {
    r: Math.floor(n * 255),
    g: Math.floor(s * 255),
    b: Math.floor(a * 255)
  };
}
function B$(t, e, r) {
  var n = Nf(t, e, r);
  return eA(n.r, n.g, n.b);
}
function J5(t) {
  var e = Lb(t);
  if (!e)
    throw new TypeError("'".concat(t, "' is not a valid color."));
  return fd(e.r, e.g, e.b);
}
function tA(t) {
  var e = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t);
  return e;
}
function rA(t) {
  return RGe.test(t);
}
function eW(t) {
  return MGe.test(t);
}
function o5e(t, e) {
  if (e !== null && mt(e) === "object") {
    for (var r = Pb(e), n = 0; n < t.length; n++)
      Object.prototype.hasOwnProperty.call(e, t[n]) && mt(e[t[n]]) == "object" && (r[t[n]] = nA(e[t[n]]));
    return r;
  } else
    return null;
}
function nA(t) {
  if (t === null || mt(t) !== "object")
    return null;
  if (t instanceof Element)
    return t;
  var e = Pb(t);
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && mt(t[r]) == "object" && (e[r] = nA(t[r]));
  return e;
}
function l5e(t, e) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r], s = void 0;
    for (s = r; s > 0 && e(n, t[s - 1]) < 0; s--)
      t[s] = t[s - 1];
    t[s] = n;
  }
  return t;
}
function u5e(t, e, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = function(m) {
    return m != null;
  }, a = function(m) {
    return m !== null && mt(m) === "object";
  }, o = function(m) {
    for (var b in m)
      if (Object.prototype.hasOwnProperty.call(m, b))
        return !1;
    return !0;
  };
  if (!a(t))
    throw new Error("Parameter mergeTarget must be an object");
  if (!a(e))
    throw new Error("Parameter options must be an object");
  if (!s(r))
    throw new Error("Parameter option must have a value");
  if (!a(n))
    throw new Error("Parameter globalOptions must be an object");
  var l = function(m, b, y) {
    a(m[y]) || (m[y] = {});
    var _ = b[y], x = m[y];
    for (var T in _)
      Object.prototype.hasOwnProperty.call(_, T) && (x[T] = _[T]);
  }, u = e[r], c = a(n) && !o(n), d = c ? n[r] : void 0, h = d ? d.enabled : void 0;
  if (u !== void 0) {
    if (typeof u == "boolean") {
      a(t[r]) || (t[r] = {}), t[r].enabled = u;
      return;
    }
    if (u === null && !a(t[r]))
      if (s(d))
        t[r] = Pb(d);
      else
        return;
    if (a(u)) {
      var f = !0;
      u.enabled !== void 0 ? f = u.enabled : h !== void 0 && (f = d.enabled), l(t, e, r), t[r].enabled = f;
    }
  }
}
function c5e(t, e, r, n) {
  for (var s = 1e4, a = 0, o = 0, l = t.length - 1; o <= l && a < s; ) {
    var u = Math.floor((o + l) / 2), c = t[u], d = n === void 0 ? c[r] : c[r][n], h = e(d);
    if (h == 0)
      return u;
    h == -1 ? o = u + 1 : l = u - 1, a++;
  }
  return -1;
}
function d5e(t, e, r, n, s) {
  var a = 1e4, o = 0, l = 0, u = t.length - 1, c, d, h, f;
  for (s = s ?? function(p, m) {
    return p == m ? 0 : p < m ? -1 : 1;
  }; l <= u && o < a; ) {
    if (f = Math.floor(0.5 * (u + l)), c = t[Math.max(0, f - 1)][r], d = t[f][r], h = t[Math.min(t.length - 1, f + 1)][r], s(d, e) == 0)
      return f;
    if (s(c, e) < 0 && s(d, e) > 0)
      return n == "before" ? Math.max(0, f - 1) : f;
    if (s(d, e) < 0 && s(h, e) > 0)
      return n == "before" ? f : Math.min(t.length - 1, f + 1);
    s(d, e) < 0 ? l = f + 1 : u = f - 1, o++;
  }
  return -1;
}
var h5e = {
  /**
   * Provides no easing and no acceleration.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  linear: function(e) {
    return e;
  },
  /**
   * Accelerate from zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  easeInQuad: function(e) {
    return e * e;
  },
  /**
   * Decelerate to zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  easeOutQuad: function(e) {
    return e * (2 - e);
  },
  /**
   * Accelerate until halfway, then decelerate.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  easeInOutQuad: function(e) {
    return e < 0.5 ? 2 * e * e : -1 + (4 - 2 * e) * e;
  },
  /**
   * Accelerate from zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  easeInCubic: function(e) {
    return e * e * e;
  },
  /**
   * Decelerate to zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  easeOutCubic: function(e) {
    return --e * e * e + 1;
  },
  /**
   * Accelerate until halfway, then decelerate.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  easeInOutCubic: function(e) {
    return e < 0.5 ? 4 * e * e * e : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1;
  },
  /**
   * Accelerate from zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  easeInQuart: function(e) {
    return e * e * e * e;
  },
  /**
   * Decelerate to zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  easeOutQuart: function(e) {
    return 1 - --e * e * e * e;
  },
  /**
   * Accelerate until halfway, then decelerate.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  easeInOutQuart: function(e) {
    return e < 0.5 ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e;
  },
  /**
   * Accelerate from zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  easeInQuint: function(e) {
    return e * e * e * e * e;
  },
  /**
   * Decelerate to zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  easeOutQuint: function(e) {
    return 1 + --e * e * e * e * e;
  },
  /**
   * Accelerate until halfway, then decelerate.
   *
   * @param t - Time.
   * @returns Value at time t.
   */
  easeInOutQuint: function(e) {
    return e < 0.5 ? 16 * e * e * e * e * e : 1 + 16 * --e * e * e * e * e;
  }
};
function f5e() {
  var t = document.createElement("p");
  t.style.width = "100%", t.style.height = "200px";
  var e = document.createElement("div");
  e.style.position = "absolute", e.style.top = "0px", e.style.left = "0px", e.style.visibility = "hidden", e.style.width = "200px", e.style.height = "150px", e.style.overflow = "hidden", e.appendChild(t), document.body.appendChild(e);
  var r = t.offsetWidth;
  e.style.overflow = "scroll";
  var n = t.offsetWidth;
  return r == n && (n = e.clientWidth), document.body.removeChild(e), r - n;
}
function p5e(t, e) {
  var r;
  $t(e) || (e = [e]);
  var n = XO(t), s;
  try {
    for (n.s(); !(s = n.n()).done; ) {
      var a = s.value;
      if (a) {
        r = a[e[0]];
        for (var o = 1; o < e.length; o++)
          r && (r = r[e[o]]);
        if (typeof r < "u")
          break;
      }
    }
  } catch (l) {
    n.e(l);
  } finally {
    n.f();
  }
  return r;
}
var v5e = {
  black: "#000000",
  navy: "#000080",
  darkblue: "#00008B",
  mediumblue: "#0000CD",
  blue: "#0000FF",
  darkgreen: "#006400",
  green: "#008000",
  teal: "#008080",
  darkcyan: "#008B8B",
  deepskyblue: "#00BFFF",
  darkturquoise: "#00CED1",
  mediumspringgreen: "#00FA9A",
  lime: "#00FF00",
  springgreen: "#00FF7F",
  aqua: "#00FFFF",
  cyan: "#00FFFF",
  midnightblue: "#191970",
  dodgerblue: "#1E90FF",
  lightseagreen: "#20B2AA",
  forestgreen: "#228B22",
  seagreen: "#2E8B57",
  darkslategray: "#2F4F4F",
  limegreen: "#32CD32",
  mediumseagreen: "#3CB371",
  turquoise: "#40E0D0",
  royalblue: "#4169E1",
  steelblue: "#4682B4",
  darkslateblue: "#483D8B",
  mediumturquoise: "#48D1CC",
  indigo: "#4B0082",
  darkolivegreen: "#556B2F",
  cadetblue: "#5F9EA0",
  cornflowerblue: "#6495ED",
  mediumaquamarine: "#66CDAA",
  dimgray: "#696969",
  slateblue: "#6A5ACD",
  olivedrab: "#6B8E23",
  slategray: "#708090",
  lightslategray: "#778899",
  mediumslateblue: "#7B68EE",
  lawngreen: "#7CFC00",
  chartreuse: "#7FFF00",
  aquamarine: "#7FFFD4",
  maroon: "#800000",
  purple: "#800080",
  olive: "#808000",
  gray: "#808080",
  skyblue: "#87CEEB",
  lightskyblue: "#87CEFA",
  blueviolet: "#8A2BE2",
  darkred: "#8B0000",
  darkmagenta: "#8B008B",
  saddlebrown: "#8B4513",
  darkseagreen: "#8FBC8F",
  lightgreen: "#90EE90",
  mediumpurple: "#9370D8",
  darkviolet: "#9400D3",
  palegreen: "#98FB98",
  darkorchid: "#9932CC",
  yellowgreen: "#9ACD32",
  sienna: "#A0522D",
  brown: "#A52A2A",
  darkgray: "#A9A9A9",
  lightblue: "#ADD8E6",
  greenyellow: "#ADFF2F",
  paleturquoise: "#AFEEEE",
  lightsteelblue: "#B0C4DE",
  powderblue: "#B0E0E6",
  firebrick: "#B22222",
  darkgoldenrod: "#B8860B",
  mediumorchid: "#BA55D3",
  rosybrown: "#BC8F8F",
  darkkhaki: "#BDB76B",
  silver: "#C0C0C0",
  mediumvioletred: "#C71585",
  indianred: "#CD5C5C",
  peru: "#CD853F",
  chocolate: "#D2691E",
  tan: "#D2B48C",
  lightgrey: "#D3D3D3",
  palevioletred: "#D87093",
  thistle: "#D8BFD8",
  orchid: "#DA70D6",
  goldenrod: "#DAA520",
  crimson: "#DC143C",
  gainsboro: "#DCDCDC",
  plum: "#DDA0DD",
  burlywood: "#DEB887",
  lightcyan: "#E0FFFF",
  lavender: "#E6E6FA",
  darksalmon: "#E9967A",
  violet: "#EE82EE",
  palegoldenrod: "#EEE8AA",
  lightcoral: "#F08080",
  khaki: "#F0E68C",
  aliceblue: "#F0F8FF",
  honeydew: "#F0FFF0",
  azure: "#F0FFFF",
  sandybrown: "#F4A460",
  wheat: "#F5DEB3",
  beige: "#F5F5DC",
  whitesmoke: "#F5F5F5",
  mintcream: "#F5FFFA",
  ghostwhite: "#F8F8FF",
  salmon: "#FA8072",
  antiquewhite: "#FAEBD7",
  linen: "#FAF0E6",
  lightgoldenrodyellow: "#FAFAD2",
  oldlace: "#FDF5E6",
  red: "#FF0000",
  fuchsia: "#FF00FF",
  magenta: "#FF00FF",
  deeppink: "#FF1493",
  orangered: "#FF4500",
  tomato: "#FF6347",
  hotpink: "#FF69B4",
  coral: "#FF7F50",
  darkorange: "#FF8C00",
  lightsalmon: "#FFA07A",
  orange: "#FFA500",
  lightpink: "#FFB6C1",
  pink: "#FFC0CB",
  gold: "#FFD700",
  peachpuff: "#FFDAB9",
  navajowhite: "#FFDEAD",
  moccasin: "#FFE4B5",
  bisque: "#FFE4C4",
  mistyrose: "#FFE4E1",
  blanchedalmond: "#FFEBCD",
  papayawhip: "#FFEFD5",
  lavenderblush: "#FFF0F5",
  seashell: "#FFF5EE",
  cornsilk: "#FFF8DC",
  lemonchiffon: "#FFFACD",
  floralwhite: "#FFFAF0",
  snow: "#FFFAFA",
  yellow: "#FFFF00",
  lightyellow: "#FFFFE0",
  ivory: "#FFFFF0",
  white: "#FFFFFF"
}, tW = /* @__PURE__ */ function() {
  function t() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    dr(this, t), this.pixelRatio = e, this.generated = !1, this.centerCoordinates = {
      x: 289 / 2,
      y: 289 / 2
    }, this.r = 289 * 0.49, this.color = {
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, this.hueCircle = void 0, this.initialColor = {
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, this.previousColor = void 0, this.applied = !1, this.updateCallback = function() {
    }, this.closeCallback = function() {
    }, this._create();
  }
  return hr(t, [{
    key: "insertTo",
    value: function(r) {
      this.hammer !== void 0 && (this.hammer.destroy(), this.hammer = void 0), this.container = r, this.container.appendChild(this.frame), this._bindHammer(), this._setSize();
    }
    /**
     * the callback is executed on apply and save. Bind it to the application
     *
     * @param {Function} callback
     */
  }, {
    key: "setUpdateCallback",
    value: function(r) {
      if (typeof r == "function")
        this.updateCallback = r;
      else
        throw new Error("Function attempted to set as colorPicker update callback is not a function.");
    }
    /**
     * the callback is executed on apply and save. Bind it to the application
     *
     * @param {Function} callback
     */
  }, {
    key: "setCloseCallback",
    value: function(r) {
      if (typeof r == "function")
        this.closeCallback = r;
      else
        throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
    }
    /**
     *
     * @param {string} color
     * @returns {string}
     * @private
     */
  }, {
    key: "_isColorString",
    value: function(r) {
      if (typeof r == "string")
        return v5e[r];
    }
    /**
     * Set the color of the colorPicker
     * Supported formats:
     * 'red'                   --> HTML color string
     * '#ffffff'               --> hex string
     * 'rgb(255,255,255)'      --> rgb string
     * 'rgba(255,255,255,1.0)' --> rgba string
     * {r:255,g:255,b:255}     --> rgb object
     * {r:255,g:255,b:255,a:1.0} --> rgba object
     *
     * @param {string | object} color
     * @param {boolean} [setInitial=true]
     */
  }, {
    key: "setColor",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (r !== "none") {
        var s, a = this._isColorString(r);
        if (a !== void 0 && (r = a), Yi(r) === !0) {
          if (rA(r) === !0) {
            var o = r.substr(4).substr(0, r.length - 5).split(",");
            s = {
              r: o[0],
              g: o[1],
              b: o[2],
              a: 1
            };
          } else if (eW(r) === !0) {
            var l = r.substr(5).substr(0, r.length - 6).split(",");
            s = {
              r: l[0],
              g: l[1],
              b: l[2],
              a: l[3]
            };
          } else if (tA(r) === !0) {
            var u = Lb(r);
            s = {
              r: u.r,
              g: u.g,
              b: u.b,
              a: 1
            };
          }
        } else if (r instanceof Object && r.r !== void 0 && r.g !== void 0 && r.b !== void 0) {
          var c = r.a !== void 0 ? r.a : "1.0";
          s = {
            r: r.r,
            g: r.g,
            b: r.b,
            a: c
          };
        }
        if (s === void 0)
          throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + Vi(r));
        this._setColor(s, n);
      }
    }
    /**
     * this shows the color picker.
     * The hue circle is constructed once and stored.
     */
  }, {
    key: "show",
    value: function() {
      this.closeCallback !== void 0 && (this.closeCallback(), this.closeCallback = void 0), this.applied = !1, this.frame.style.display = "block", this._generateHueCircle();
    }
    // ------------------------------------------ PRIVATE ----------------------------- //
    /**
     * Hide the picker. Is called by the cancel button.
     * Optional boolean to store the previous color for easy access later on.
     *
     * @param {boolean} [storePrevious=true]
     * @private
     */
  }, {
    key: "_hide",
    value: function() {
      var r = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      n === !0 && (this.previousColor = Wu({}, this.color)), this.applied === !0 && this.updateCallback(this.initialColor), this.frame.style.display = "none", ai(function() {
        r.closeCallback !== void 0 && (r.closeCallback(), r.closeCallback = void 0);
      }, 0);
    }
    /**
     * bound to the save button. Saves and hides.
     *
     * @private
     */
  }, {
    key: "_save",
    value: function() {
      this.updateCallback(this.color), this.applied = !1, this._hide();
    }
    /**
     * Bound to apply button. Saves but does not close. Is undone by the cancel button.
     *
     * @private
     */
  }, {
    key: "_apply",
    value: function() {
      this.applied = !0, this.updateCallback(this.color), this._updatePicker(this.color);
    }
    /**
     * load the color from the previous session.
     *
     * @private
     */
  }, {
    key: "_loadLast",
    value: function() {
      this.previousColor !== void 0 ? this.setColor(this.previousColor, !1) : alert("There is no last color to load...");
    }
    /**
     * set the color, place the picker
     *
     * @param {object} rgba
     * @param {boolean} [setInitial=true]
     * @private
     */
  }, {
    key: "_setColor",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      n === !0 && (this.initialColor = Wu({}, r)), this.color = r;
      var s = fd(r.r, r.g, r.b), a = 2 * Math.PI, o = this.r * s.s, l = this.centerCoordinates.x + o * Math.sin(a * s.h), u = this.centerCoordinates.y + o * Math.cos(a * s.h);
      this.colorPickerSelector.style.left = l - 0.5 * this.colorPickerSelector.clientWidth + "px", this.colorPickerSelector.style.top = u - 0.5 * this.colorPickerSelector.clientHeight + "px", this._updatePicker(r);
    }
    /**
     * bound to opacity control
     *
     * @param {number} value
     * @private
     */
  }, {
    key: "_setOpacity",
    value: function(r) {
      this.color.a = r / 100, this._updatePicker(this.color);
    }
    /**
     * bound to brightness control
     *
     * @param {number} value
     * @private
     */
  }, {
    key: "_setBrightness",
    value: function(r) {
      var n = fd(this.color.r, this.color.g, this.color.b);
      n.v = r / 100;
      var s = Nf(n.h, n.s, n.v);
      s.a = this.color.a, this.color = s, this._updatePicker();
    }
    /**
     * update the color picker. A black circle overlays the hue circle to mimic the brightness decreasing.
     *
     * @param {object} rgba
     * @private
     */
  }, {
    key: "_updatePicker",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.color, n = fd(r.r, r.g, r.b), s = this.colorPickerCanvas.getContext("2d");
      this.pixelRation === void 0 && (this.pixelRatio = (window.devicePixelRatio || 1) / (s.webkitBackingStorePixelRatio || s.mozBackingStorePixelRatio || s.msBackingStorePixelRatio || s.oBackingStorePixelRatio || s.backingStorePixelRatio || 1)), s.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
      var a = this.colorPickerCanvas.clientWidth, o = this.colorPickerCanvas.clientHeight;
      s.clearRect(0, 0, a, o), s.putImageData(this.hueCircle, 0, 0), s.fillStyle = "rgba(0,0,0," + (1 - n.v) + ")", s.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), T5(s).call(s), this.brightnessRange.value = 100 * n.v, this.opacityRange.value = 100 * r.a, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
    }
    /**
     * used by create to set the size of the canvas.
     *
     * @private
     */
  }, {
    key: "_setSize",
    value: function() {
      this.colorPickerCanvas.style.width = "100%", this.colorPickerCanvas.style.height = "100%", this.colorPickerCanvas.width = 289 * this.pixelRatio, this.colorPickerCanvas.height = 289 * this.pixelRatio;
    }
    /**
     * create all dom elements
     * TODO: cleanup, lots of similar dom elements
     *
     * @private
     */
  }, {
    key: "_create",
    value: function() {
      var r, n, s, a;
      if (this.frame = document.createElement("div"), this.frame.className = "vis-color-picker", this.colorPickerDiv = document.createElement("div"), this.colorPickerSelector = document.createElement("div"), this.colorPickerSelector.className = "vis-selector", this.colorPickerDiv.appendChild(this.colorPickerSelector), this.colorPickerCanvas = document.createElement("canvas"), this.colorPickerDiv.appendChild(this.colorPickerCanvas), this.colorPickerCanvas.getContext) {
        var l = this.colorPickerCanvas.getContext("2d");
        this.pixelRatio = (window.devicePixelRatio || 1) / (l.webkitBackingStorePixelRatio || l.mozBackingStorePixelRatio || l.msBackingStorePixelRatio || l.oBackingStorePixelRatio || l.backingStorePixelRatio || 1), this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
      } else {
        var o = document.createElement("DIV");
        o.style.color = "red", o.style.fontWeight = "bold", o.style.padding = "10px", o.innerText = "Error: your browser does not support HTML canvas", this.colorPickerCanvas.appendChild(o);
      }
      this.colorPickerDiv.className = "vis-color", this.opacityDiv = document.createElement("div"), this.opacityDiv.className = "vis-opacity", this.brightnessDiv = document.createElement("div"), this.brightnessDiv.className = "vis-brightness", this.arrowDiv = document.createElement("div"), this.arrowDiv.className = "vis-arrow", this.opacityRange = document.createElement("input");
      try {
        this.opacityRange.type = "range", this.opacityRange.min = "0", this.opacityRange.max = "100";
      } catch {
      }
      this.opacityRange.value = "100", this.opacityRange.className = "vis-range", this.brightnessRange = document.createElement("input");
      try {
        this.brightnessRange.type = "range", this.brightnessRange.min = "0", this.brightnessRange.max = "100";
      } catch {
      }
      this.brightnessRange.value = "100", this.brightnessRange.className = "vis-range", this.opacityDiv.appendChild(this.opacityRange), this.brightnessDiv.appendChild(this.brightnessRange);
      var u = this;
      this.opacityRange.onchange = function() {
        u._setOpacity(this.value);
      }, this.opacityRange.oninput = function() {
        u._setOpacity(this.value);
      }, this.brightnessRange.onchange = function() {
        u._setBrightness(this.value);
      }, this.brightnessRange.oninput = function() {
        u._setBrightness(this.value);
      }, this.brightnessLabel = document.createElement("div"), this.brightnessLabel.className = "vis-label vis-brightness", this.brightnessLabel.innerText = "brightness:", this.opacityLabel = document.createElement("div"), this.opacityLabel.className = "vis-label vis-opacity", this.opacityLabel.innerText = "opacity:", this.newColorDiv = document.createElement("div"), this.newColorDiv.className = "vis-new-color", this.newColorDiv.innerText = "new", this.initialColorDiv = document.createElement("div"), this.initialColorDiv.className = "vis-initial-color", this.initialColorDiv.innerText = "initial", this.cancelButton = document.createElement("div"), this.cancelButton.className = "vis-button vis-cancel", this.cancelButton.innerText = "cancel", this.cancelButton.onclick = de(r = this._hide).call(r, this, !1), this.applyButton = document.createElement("div"), this.applyButton.className = "vis-button vis-apply", this.applyButton.innerText = "apply", this.applyButton.onclick = de(n = this._apply).call(n, this), this.saveButton = document.createElement("div"), this.saveButton.className = "vis-button vis-save", this.saveButton.innerText = "save", this.saveButton.onclick = de(s = this._save).call(s, this), this.loadButton = document.createElement("div"), this.loadButton.className = "vis-button vis-load", this.loadButton.innerText = "load last", this.loadButton.onclick = de(a = this._loadLast).call(a, this), this.frame.appendChild(this.colorPickerDiv), this.frame.appendChild(this.arrowDiv), this.frame.appendChild(this.brightnessLabel), this.frame.appendChild(this.brightnessDiv), this.frame.appendChild(this.opacityLabel), this.frame.appendChild(this.opacityDiv), this.frame.appendChild(this.newColorDiv), this.frame.appendChild(this.initialColorDiv), this.frame.appendChild(this.cancelButton), this.frame.appendChild(this.applyButton), this.frame.appendChild(this.saveButton), this.frame.appendChild(this.loadButton);
    }
    /**
     * bind hammer to the color picker
     *
     * @private
     */
  }, {
    key: "_bindHammer",
    value: function() {
      var r = this;
      this.drag = {}, this.pinch = {}, this.hammer = new JO(this.colorPickerCanvas), this.hammer.get("pinch").set({
        enable: !0
      }), this.hammer.on("hammer.input", function(n) {
        n.isFirst && r._moveSelector(n);
      }), this.hammer.on("tap", function(n) {
        r._moveSelector(n);
      }), this.hammer.on("panstart", function(n) {
        r._moveSelector(n);
      }), this.hammer.on("panmove", function(n) {
        r._moveSelector(n);
      }), this.hammer.on("panend", function(n) {
        r._moveSelector(n);
      });
    }
    /**
     * generate the hue circle. This is relatively heavy (200ms) and is done only once on the first time it is shown.
     *
     * @private
     */
  }, {
    key: "_generateHueCircle",
    value: function() {
      if (this.generated === !1) {
        var r = this.colorPickerCanvas.getContext("2d");
        this.pixelRation === void 0 && (this.pixelRatio = (window.devicePixelRatio || 1) / (r.webkitBackingStorePixelRatio || r.mozBackingStorePixelRatio || r.msBackingStorePixelRatio || r.oBackingStorePixelRatio || r.backingStorePixelRatio || 1)), r.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
        var n = this.colorPickerCanvas.clientWidth, s = this.colorPickerCanvas.clientHeight;
        r.clearRect(0, 0, n, s);
        var a, o, l, u;
        this.centerCoordinates = {
          x: n * 0.5,
          y: s * 0.5
        }, this.r = 0.49 * n;
        var c = 2 * Math.PI / 360, d = 1 / 360, h = 1 / this.r, f;
        for (l = 0; l < 360; l++)
          for (u = 0; u < this.r; u++)
            a = this.centerCoordinates.x + u * Math.sin(c * l), o = this.centerCoordinates.y + u * Math.cos(c * l), f = Nf(l * d, u * h, 1), r.fillStyle = "rgb(" + f.r + "," + f.g + "," + f.b + ")", r.fillRect(a - 0.5, o - 0.5, 2, 2);
        r.strokeStyle = "rgba(0,0,0,1)", r.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), r.stroke(), this.hueCircle = r.getImageData(0, 0, n, s);
      }
      this.generated = !0;
    }
    /**
     * move the selector. This is called by hammer functions.
     *
     * @param {Event}  event   The event
     * @private
     */
  }, {
    key: "_moveSelector",
    value: function(r) {
      var n = this.colorPickerDiv.getBoundingClientRect(), s = r.center.x - n.left, a = r.center.y - n.top, o = 0.5 * this.colorPickerDiv.clientHeight, l = 0.5 * this.colorPickerDiv.clientWidth, u = s - l, c = a - o, d = Math.atan2(u, c), h = 0.98 * Math.min(Math.sqrt(u * u + c * c), l), f = Math.cos(d) * h + o, p = Math.sin(d) * h + l;
      this.colorPickerSelector.style.top = f - 0.5 * this.colorPickerSelector.clientHeight + "px", this.colorPickerSelector.style.left = p - 0.5 * this.colorPickerSelector.clientWidth + "px";
      var m = d / (2 * Math.PI);
      m = m < 0 ? m + 1 : m;
      var b = h / this.r, y = fd(this.color.r, this.color.g, this.color.b);
      y.h = m, y.s = b;
      var _ = Nf(y.h, y.s, y.v);
      _.a = this.color.a, this.color = _, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
    }
  }]), t;
}();
function U$() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  if (e.length < 1)
    throw new TypeError("Invalid arguments.");
  if (e.length === 1)
    return document.createTextNode(e[0]);
  var n = document.createElement(e[0]);
  return n.appendChild(U$.apply(void 0, Vs(hi(e).call(e, 1)))), n;
}
var m5e = /* @__PURE__ */ function() {
  function t(e, r, n) {
    var s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {
      return !1;
    };
    dr(this, t), this.parent = e, this.changedOptions = [], this.container = r, this.allowCreation = !1, this.hideOption = a, this.options = {}, this.initialized = !1, this.popupCounter = 0, this.defaultOptions = {
      enabled: !1,
      filter: !0,
      container: void 0,
      showButton: !0
    }, Wu(this.options, this.defaultOptions), this.configureOptions = n, this.moduleOptions = {}, this.domElements = [], this.popupDiv = {}, this.popupLimit = 5, this.popupHistory = {}, this.colorPicker = new tW(s), this.wrapper = void 0;
  }
  return hr(t, [{
    key: "setOptions",
    value: function(r) {
      if (r !== void 0) {
        this.popupHistory = {}, this._removePopup();
        var n = !0;
        if (typeof r == "string")
          this.options.filter = r;
        else if ($t(r))
          this.options.filter = r.join();
        else if (mt(r) === "object") {
          if (r == null)
            throw new TypeError("options cannot be null");
          r.container !== void 0 && (this.options.container = r.container), At(r) !== void 0 && (this.options.filter = At(r)), r.showButton !== void 0 && (this.options.showButton = r.showButton), r.enabled !== void 0 && (n = r.enabled);
        } else
          typeof r == "boolean" ? (this.options.filter = !0, n = r) : typeof r == "function" && (this.options.filter = r, n = !0);
        At(this.options) === !1 && (n = !1), this.options.enabled = n;
      }
      this._clean();
    }
    /**
     *
     * @param {object} moduleOptions
     */
  }, {
    key: "setModuleOptions",
    value: function(r) {
      this.moduleOptions = r, this.options.enabled === !0 && (this._clean(), this.options.container !== void 0 && (this.container = this.options.container), this._create());
    }
    /**
     * Create all DOM elements
     *
     * @private
     */
  }, {
    key: "_create",
    value: function() {
      this._clean(), this.changedOptions = [];
      var r = At(this.options), n = 0, s = !1;
      for (var a in this.configureOptions)
        Object.prototype.hasOwnProperty.call(this.configureOptions, a) && (this.allowCreation = !1, s = !1, typeof r == "function" ? (s = r(a, []), s = s || this._handleObject(this.configureOptions[a], [a], !0)) : (r === !0 || lr(r).call(r, a) !== -1) && (s = !0), s !== !1 && (this.allowCreation = !0, n > 0 && this._makeItem([]), this._makeHeader(a), this._handleObject(this.configureOptions[a], [a])), n++);
      this._makeButton(), this._push();
    }
    /**
     * draw all DOM elements on the screen
     *
     * @private
     */
  }, {
    key: "_push",
    value: function() {
      this.wrapper = document.createElement("div"), this.wrapper.className = "vis-configuration-wrapper", this.container.appendChild(this.wrapper);
      for (var r = 0; r < this.domElements.length; r++)
        this.wrapper.appendChild(this.domElements[r]);
      this._showPopupIfNeeded();
    }
    /**
     * delete all DOM elements
     *
     * @private
     */
  }, {
    key: "_clean",
    value: function() {
      for (var r = 0; r < this.domElements.length; r++)
        this.wrapper.removeChild(this.domElements[r]);
      this.wrapper !== void 0 && (this.container.removeChild(this.wrapper), this.wrapper = void 0), this.domElements = [], this._removePopup();
    }
    /**
     * get the value from the actualOptions if it exists
     *
     * @param {Array} path    | where to look for the actual option
     * @returns {*}
     * @private
     */
  }, {
    key: "_getValue",
    value: function(r) {
      for (var n = this.moduleOptions, s = 0; s < r.length; s++)
        if (n[r[s]] !== void 0)
          n = n[r[s]];
        else {
          n = void 0;
          break;
        }
      return n;
    }
    /**
     * all option elements are wrapped in an item
     *
     * @param {Array} path    | where to look for the actual option
     * @param {Array.<Element>} domElements
     * @returns {number}
     * @private
     */
  }, {
    key: "_makeItem",
    value: function(r) {
      if (this.allowCreation === !0) {
        var n = document.createElement("div");
        n.className = "vis-configuration vis-config-item vis-config-s" + r.length;
        for (var s = arguments.length, a = new Array(s > 1 ? s - 1 : 0), o = 1; o < s; o++)
          a[o - 1] = arguments[o];
        return Le(a).call(a, function(l) {
          n.appendChild(l);
        }), this.domElements.push(n), this.domElements.length;
      }
      return 0;
    }
    /**
     * header for major subjects
     *
     * @param {string} name
     * @private
     */
  }, {
    key: "_makeHeader",
    value: function(r) {
      var n = document.createElement("div");
      n.className = "vis-configuration vis-config-header", n.innerText = r, this._makeItem([], n);
    }
    /**
     * make a label, if it is an object label, it gets different styling.
     *
     * @param {string} name
     * @param {Array} path    | where to look for the actual option
     * @param {string} objectLabel
     * @returns {HTMLElement}
     * @private
     */
  }, {
    key: "_makeLabel",
    value: function(r, n) {
      var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = document.createElement("div");
      if (a.className = "vis-configuration vis-config-label vis-config-s" + n.length, s === !0) {
        for (; a.firstChild; )
          a.removeChild(a.firstChild);
        a.appendChild(U$("i", "b", r));
      } else
        a.innerText = r + ":";
      return a;
    }
    /**
     * make a dropdown list for multiple possible string optoins
     *
     * @param {Array.<number>} arr
     * @param {number} value
     * @param {Array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_makeDropdown",
    value: function(r, n, s) {
      var a = document.createElement("select");
      a.className = "vis-configuration vis-config-select";
      var o = 0;
      n !== void 0 && lr(r).call(r, n) !== -1 && (o = lr(r).call(r, n));
      for (var l = 0; l < r.length; l++) {
        var u = document.createElement("option");
        u.value = r[l], l === o && (u.selected = "selected"), u.innerText = r[l], a.appendChild(u);
      }
      var c = this;
      a.onchange = function() {
        c._update(this.value, s);
      };
      var d = this._makeLabel(s[s.length - 1], s);
      this._makeItem(s, d, a);
    }
    /**
     * make a range object for numeric options
     *
     * @param {Array.<number>} arr
     * @param {number} value
     * @param {Array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_makeRange",
    value: function(r, n, s) {
      var a = r[0], o = r[1], l = r[2], u = r[3], c = document.createElement("input");
      c.className = "vis-configuration vis-config-range";
      try {
        c.type = "range", c.min = o, c.max = l;
      } catch {
      }
      c.step = u;
      var d = "", h = 0;
      if (n !== void 0) {
        var f = 1.2;
        n < 0 && n * f < o ? (c.min = Math.ceil(n * f), h = c.min, d = "range increased") : n / f < o && (c.min = Math.ceil(n / f), h = c.min, d = "range increased"), n * f > l && l !== 1 && (c.max = Math.ceil(n * f), h = c.max, d = "range increased"), c.value = n;
      } else
        c.value = a;
      var p = document.createElement("input");
      p.className = "vis-configuration vis-config-rangeinput", p.value = c.value;
      var m = this;
      c.onchange = function() {
        p.value = this.value, m._update(Number(this.value), s);
      }, c.oninput = function() {
        p.value = this.value;
      };
      var b = this._makeLabel(s[s.length - 1], s), y = this._makeItem(s, b, c, p);
      d !== "" && this.popupHistory[y] !== h && (this.popupHistory[y] = h, this._setupPopup(d, y));
    }
    /**
     * make a button object
     *
     * @private
     */
  }, {
    key: "_makeButton",
    value: function() {
      var r = this;
      if (this.options.showButton === !0) {
        var n = document.createElement("div");
        n.className = "vis-configuration vis-config-button", n.innerText = "generate options", n.onclick = function() {
          r._printOptions();
        }, n.onmouseover = function() {
          n.className = "vis-configuration vis-config-button hover";
        }, n.onmouseout = function() {
          n.className = "vis-configuration vis-config-button";
        }, this.optionsContainer = document.createElement("div"), this.optionsContainer.className = "vis-configuration vis-config-option-container", this.domElements.push(this.optionsContainer), this.domElements.push(n);
      }
    }
    /**
     * prepare the popup
     *
     * @param {string} string
     * @param {number} index
     * @private
     */
  }, {
    key: "_setupPopup",
    value: function(r, n) {
      var s = this;
      if (this.initialized === !0 && this.allowCreation === !0 && this.popupCounter < this.popupLimit) {
        var a = document.createElement("div");
        a.id = "vis-configuration-popup", a.className = "vis-configuration-popup", a.innerText = r, a.onclick = function() {
          s._removePopup();
        }, this.popupCounter += 1, this.popupDiv = {
          html: a,
          index: n
        };
      }
    }
    /**
     * remove the popup from the dom
     *
     * @private
     */
  }, {
    key: "_removePopup",
    value: function() {
      this.popupDiv.html !== void 0 && (this.popupDiv.html.parentNode.removeChild(this.popupDiv.html), clearTimeout(this.popupDiv.hideTimeout), clearTimeout(this.popupDiv.deleteTimeout), this.popupDiv = {});
    }
    /**
     * Show the popup if it is needed.
     *
     * @private
     */
  }, {
    key: "_showPopupIfNeeded",
    value: function() {
      var r = this;
      if (this.popupDiv.html !== void 0) {
        var n = this.domElements[this.popupDiv.index], s = n.getBoundingClientRect();
        this.popupDiv.html.style.left = s.left + "px", this.popupDiv.html.style.top = s.top - 30 + "px", document.body.appendChild(this.popupDiv.html), this.popupDiv.hideTimeout = ai(function() {
          r.popupDiv.html.style.opacity = 0;
        }, 1500), this.popupDiv.deleteTimeout = ai(function() {
          r._removePopup();
        }, 1800);
      }
    }
    /**
     * make a checkbox for boolean options.
     *
     * @param {number} defaultValue
     * @param {number} value
     * @param {Array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_makeCheckbox",
    value: function(r, n, s) {
      var a = document.createElement("input");
      a.type = "checkbox", a.className = "vis-configuration vis-config-checkbox", a.checked = r, n !== void 0 && (a.checked = n, n !== r && (mt(r) === "object" ? n !== r.enabled && this.changedOptions.push({
        path: s,
        value: n
      }) : this.changedOptions.push({
        path: s,
        value: n
      })));
      var o = this;
      a.onchange = function() {
        o._update(this.checked, s);
      };
      var l = this._makeLabel(s[s.length - 1], s);
      this._makeItem(s, l, a);
    }
    /**
     * make a text input field for string options.
     *
     * @param {number} defaultValue
     * @param {number} value
     * @param {Array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_makeTextInput",
    value: function(r, n, s) {
      var a = document.createElement("input");
      a.type = "text", a.className = "vis-configuration vis-config-text", a.value = n, n !== r && this.changedOptions.push({
        path: s,
        value: n
      });
      var o = this;
      a.onchange = function() {
        o._update(this.value, s);
      };
      var l = this._makeLabel(s[s.length - 1], s);
      this._makeItem(s, l, a);
    }
    /**
     * make a color field with a color picker for color fields
     *
     * @param {Array.<number>} arr
     * @param {number} value
     * @param {Array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_makeColorField",
    value: function(r, n, s) {
      var a = this, o = r[1], l = document.createElement("div");
      n = n === void 0 ? o : n, n !== "none" ? (l.className = "vis-configuration vis-config-colorBlock", l.style.backgroundColor = n) : l.className = "vis-configuration vis-config-colorBlock none", n = n === void 0 ? o : n, l.onclick = function() {
        a._showColorPicker(n, l, s);
      };
      var u = this._makeLabel(s[s.length - 1], s);
      this._makeItem(s, u, l);
    }
    /**
     * used by the color buttons to call the color picker.
     *
     * @param {number} value
     * @param {HTMLElement} div
     * @param {Array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_showColorPicker",
    value: function(r, n, s) {
      var a = this;
      n.onclick = function() {
      }, this.colorPicker.insertTo(n), this.colorPicker.show(), this.colorPicker.setColor(r), this.colorPicker.setUpdateCallback(function(o) {
        var l = "rgba(" + o.r + "," + o.g + "," + o.b + "," + o.a + ")";
        n.style.backgroundColor = l, a._update(l, s);
      }), this.colorPicker.setCloseCallback(function() {
        n.onclick = function() {
          a._showColorPicker(r, n, s);
        };
      });
    }
    /**
     * parse an object and draw the correct items
     *
     * @param {object} obj
     * @param {Array} [path=[]]    | where to look for the actual option
     * @param {boolean} [checkOnly=false]
     * @returns {boolean}
     * @private
     */
  }, {
    key: "_handleObject",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = !1, o = At(this.options), l = !1;
      for (var u in r)
        if (Object.prototype.hasOwnProperty.call(r, u)) {
          a = !0;
          var c = r[u], d = xp(n, u);
          if (typeof o == "function" && (a = o(u, n), a === !1 && !$t(c) && typeof c != "string" && typeof c != "boolean" && c instanceof Object && (this.allowCreation = !1, a = this._handleObject(c, d, !0), this.allowCreation = s === !1)), a !== !1) {
            l = !0;
            var h = this._getValue(d);
            if ($t(c))
              this._handleArray(c, h, d);
            else if (typeof c == "string")
              this._makeTextInput(c, h, d);
            else if (typeof c == "boolean")
              this._makeCheckbox(c, h, d);
            else if (c instanceof Object) {
              if (!this.hideOption(n, u, this.moduleOptions))
                if (c.enabled !== void 0) {
                  var f = xp(d, "enabled"), p = this._getValue(f);
                  if (p === !0) {
                    var m = this._makeLabel(u, d, !0);
                    this._makeItem(d, m), l = this._handleObject(c, d) || l;
                  } else
                    this._makeCheckbox(c, p, d);
                } else {
                  var b = this._makeLabel(u, d, !0);
                  this._makeItem(d, b), l = this._handleObject(c, d) || l;
                }
            } else
              console.error("dont know how to handle", c, u, d);
          }
        }
      return l;
    }
    /**
     * handle the array type of option
     *
     * @param {Array.<number>} arr
     * @param {number} value
     * @param {Array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_handleArray",
    value: function(r, n, s) {
      typeof r[0] == "string" && r[0] === "color" ? (this._makeColorField(r, n, s), r[1] !== n && this.changedOptions.push({
        path: s,
        value: n
      })) : typeof r[0] == "string" ? (this._makeDropdown(r, n, s), r[0] !== n && this.changedOptions.push({
        path: s,
        value: n
      })) : typeof r[0] == "number" && (this._makeRange(r, n, s), r[0] !== n && this.changedOptions.push({
        path: s,
        value: Number(n)
      }));
    }
    /**
     * called to update the network with the new settings.
     *
     * @param {number} value
     * @param {Array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_update",
    value: function(r, n) {
      var s = this._constructOptions(r, n);
      this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit && this.parent.body.emitter.emit("configChange", s), this.initialized = !0, this.parent.setOptions(s);
    }
    /**
     *
     * @param {string | boolean} value
     * @param {Array.<string>} path
     * @param {{}} optionsObj
     * @returns {{}}
     * @private
     */
  }, {
    key: "_constructOptions",
    value: function(r, n) {
      var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = s;
      r = r === "true" ? !0 : r, r = r === "false" ? !1 : r;
      for (var o = 0; o < n.length; o++)
        n[o] !== "global" && (a[n[o]] === void 0 && (a[n[o]] = {}), o !== n.length - 1 ? a = a[n[o]] : a[n[o]] = r);
      return s;
    }
    /**
     * @private
     */
  }, {
    key: "_printOptions",
    value: function() {
      for (var r = this.getOptions(); this.optionsContainer.firstChild; )
        this.optionsContainer.removeChild(this.optionsContainer.firstChild);
      this.optionsContainer.appendChild(U$("pre", "const options = " + Vi(r, null, 2)));
    }
    /**
     *
     * @returns {{}} options
     */
  }, {
    key: "getOptions",
    value: function() {
      for (var r = {}, n = 0; n < this.changedOptions.length; n++)
        this._constructOptions(this.changedOptions[n].value, this.changedOptions[n].path, r);
      return r;
    }
  }]), t;
}(), g5e = /* @__PURE__ */ function() {
  function t(e, r) {
    dr(this, t), this.container = e, this.overflowMethod = r || "cap", this.x = 0, this.y = 0, this.padding = 5, this.hidden = !1, this.frame = document.createElement("div"), this.frame.className = "vis-tooltip", this.container.appendChild(this.frame);
  }
  return hr(t, [{
    key: "setPosition",
    value: function(r, n) {
      this.x = Ui(r), this.y = Ui(n);
    }
    /**
     * Set the content for the popup window. This can be HTML code or text.
     *
     * @param {string | Element} content
     */
  }, {
    key: "setText",
    value: function(r) {
      if (r instanceof Element) {
        for (; this.frame.firstChild; )
          this.frame.removeChild(this.frame.firstChild);
        this.frame.appendChild(r);
      } else
        this.frame.innerText = r;
    }
    /**
     * Show the popup window
     *
     * @param {boolean} [doShow]    Show or hide the window
     */
  }, {
    key: "show",
    value: function(r) {
      if (r === void 0 && (r = !0), r === !0) {
        var n = this.frame.clientHeight, s = this.frame.clientWidth, a = this.frame.parentNode.clientHeight, o = this.frame.parentNode.clientWidth, l = 0, u = 0;
        if (this.overflowMethod == "flip") {
          var c = !1, d = !0;
          this.y - n < this.padding && (d = !1), this.x + s > o - this.padding && (c = !0), c ? l = this.x - s : l = this.x, d ? u = this.y - n : u = this.y;
        } else
          u = this.y - n, u + n + this.padding > a && (u = a - n - this.padding), u < this.padding && (u = this.padding), l = this.x, l + s + this.padding > o && (l = o - s - this.padding), l < this.padding && (l = this.padding);
        this.frame.style.left = l + "px", this.frame.style.top = u + "px", this.frame.style.visibility = "visible", this.hidden = !1;
      } else
        this.hide();
    }
    /**
     * Hide the popup window
     */
  }, {
    key: "hide",
    value: function() {
      this.hidden = !0, this.frame.style.left = "0", this.frame.style.top = "0", this.frame.style.visibility = "hidden";
    }
    /**
     * Remove the popup window
     */
  }, {
    key: "destroy",
    value: function() {
      this.frame.parentNode.removeChild(this.frame);
    }
  }]), t;
}(), tf = !1, i2, V$ = "background: #FFeeee; color: #dd0000", y5e = /* @__PURE__ */ function() {
  function t() {
    dr(this, t);
  }
  return hr(t, null, [{
    key: "validate",
    value: (
      /**
       * Main function to be called
       *
       * @param {object} options
       * @param {object} referenceOptions
       * @param {object} subObject
       * @returns {boolean}
       * @static
       */
      function(r, n, s) {
        tf = !1, i2 = n;
        var a = n;
        return s !== void 0 && (a = n[s]), t.parse(r, a, []), tf;
      }
    )
    /**
     * Will traverse an object recursively and check every value
     *
     * @param {object} options
     * @param {object} referenceOptions
     * @param {Array} path    | where to look for the actual option
     * @static
     */
  }, {
    key: "parse",
    value: function(r, n, s) {
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && t.check(a, r, n, s);
    }
    /**
     * Check every value. If the value is an object, call the parse function on that object.
     *
     * @param {string} option
     * @param {object} options
     * @param {object} referenceOptions
     * @param {Array} path    | where to look for the actual option
     * @static
     */
  }, {
    key: "check",
    value: function(r, n, s, a) {
      if (s[r] === void 0 && s.__any__ === void 0) {
        t.getSuggestion(r, s, a);
        return;
      }
      var o = r, l = !0;
      s[r] === void 0 && s.__any__ !== void 0 && (o = "__any__", l = t.getType(n[r]) === "object");
      var u = s[o];
      l && u.__type__ !== void 0 && (u = u.__type__), t.checkFields(r, n, s, o, u, a);
    }
    /**
     *
     * @param {string}  option           | the option property
     * @param {object}  options          | The supplied options object
     * @param {object}  referenceOptions | The reference options containing all options and their allowed formats
     * @param {string}  referenceOption  | Usually this is the same as option, except when handling an __any__ tag.
     * @param {string}  refOptionObj     | This is the type object from the reference options
     * @param {Array}   path             | where in the object is the option
     * @static
     */
  }, {
    key: "checkFields",
    value: function(r, n, s, a, o, l) {
      var u = function(f) {
        console.error("%c" + f + t.printLocation(l, r), V$);
      }, c = t.getType(n[r]), d = o[c];
      d !== void 0 ? t.getType(d) === "array" && lr(d).call(d, n[r]) === -1 ? (u('Invalid option detected in "' + r + '". Allowed values are:' + t.print(d) + ' not "' + n[r] + '". '), tf = !0) : c === "object" && a !== "__any__" && (l = xp(l, r), t.parse(n[r], s[a], l)) : o.any === void 0 && (u('Invalid type received for "' + r + '". Expected: ' + t.print(xn(o)) + ". Received [" + c + '] "' + n[r] + '"'), tf = !0);
    }
    /**
     *
     * @param {object | boolean | number | string | Array.<number> | Date | Node | Moment | undefined | null} object
     * @returns {string}
     * @static
     */
  }, {
    key: "getType",
    value: function(r) {
      var n = mt(r);
      return n === "object" ? r === null ? "null" : r instanceof Boolean ? "boolean" : r instanceof Number ? "number" : r instanceof String ? "string" : $t(r) ? "array" : r instanceof Date ? "date" : r.nodeType !== void 0 ? "dom" : r._isAMomentObject === !0 ? "moment" : "object" : n === "number" ? "number" : n === "boolean" ? "boolean" : n === "string" ? "string" : n === void 0 ? "undefined" : n;
    }
    /**
     * @param {string} option
     * @param {object} options
     * @param {Array.<string>} path
     * @static
     */
  }, {
    key: "getSuggestion",
    value: function(r, n, s) {
      var a = t.findInOptions(r, n, s, !1), o = t.findInOptions(r, i2, [], !0), l = 8, u = 4, c;
      a.indexMatch !== void 0 ? c = " in " + t.printLocation(a.path, r, "") + 'Perhaps it was incomplete? Did you mean: "' + a.indexMatch + `"?

` : o.distance <= u && a.distance > o.distance ? c = " in " + t.printLocation(a.path, r, "") + "Perhaps it was misplaced? Matching option found at: " + t.printLocation(o.path, o.closestMatch, "") : a.distance <= l ? c = '. Did you mean "' + a.closestMatch + '"?' + t.printLocation(a.path, r) : c = ". Did you mean one of these: " + t.print(xn(n)) + t.printLocation(s, r), console.error('%cUnknown option detected: "' + r + '"' + c, V$), tf = !0;
    }
    /**
     * traverse the options in search for a match.
     *
     * @param {string} option
     * @param {object} options
     * @param {Array} path    | where to look for the actual option
     * @param {boolean} [recursive=false]
     * @returns {{closestMatch: string, path: Array, distance: number}}
     * @static
     */
  }, {
    key: "findInOptions",
    value: function(r, n, s) {
      var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, o = 1e9, l = "", u = [], c = r.toLowerCase(), d = void 0;
      for (var h in n) {
        var f = void 0;
        if (n[h].__type__ !== void 0 && a === !0) {
          var p = t.findInOptions(r, n[h], xp(s, h));
          o > p.distance && (l = p.closestMatch, u = p.path, o = p.distance, d = p.indexMatch);
        } else {
          var m;
          lr(m = h.toLowerCase()).call(m, c) !== -1 && (d = h), f = t.levenshteinDistance(r, h), o > f && (l = h, u = Z5(s), o = f);
        }
      }
      return {
        closestMatch: l,
        path: u,
        distance: o,
        indexMatch: d
      };
    }
    /**
     * @param {Array.<string>} path
     * @param {object} option
     * @param {string} prefix
     * @returns {string}
     * @static
     */
  }, {
    key: "printLocation",
    value: function(r, n) {
      for (var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : `Problem value found at: 
`, a = `

` + s + `options = {
`, o = 0; o < r.length; o++) {
        for (var l = 0; l < o + 1; l++)
          a += "  ";
        a += r[o] + `: {
`;
      }
      for (var u = 0; u < r.length + 1; u++)
        a += "  ";
      a += n + `
`;
      for (var c = 0; c < r.length + 1; c++) {
        for (var d = 0; d < r.length - c; d++)
          a += "  ";
        a += `}
`;
      }
      return a + `

`;
    }
    /**
     * @param {object} options
     * @returns {string}
     * @static
     */
  }, {
    key: "print",
    value: function(r) {
      return Vi(r).replace(/(")|(\[)|(\])|(,"__type__")/g, "").replace(/(,)/g, ", ");
    }
    /**
     *  Compute the edit distance between the two given strings
     * http://en.wikibooks.org/wiki/Algorithm_Implementation/Strings/Levenshtein_distance#JavaScript
     *
     * Copyright (c) 2011 Andrei Mackenzie
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     *
     * @param {string} a
     * @param {string} b
     * @returns {Array.<Array.<number>>}}
     * @static
     */
  }, {
    key: "levenshteinDistance",
    value: function(r, n) {
      if (r.length === 0)
        return n.length;
      if (n.length === 0)
        return r.length;
      var s = [], a;
      for (a = 0; a <= n.length; a++)
        s[a] = [a];
      var o;
      for (o = 0; o <= r.length; o++)
        s[0][o] = o;
      for (a = 1; a <= n.length; a++)
        for (o = 1; o <= r.length; o++)
          n.charAt(a - 1) == r.charAt(o - 1) ? s[a][o] = s[a - 1][o - 1] : s[a][o] = Math.min(
            s[a - 1][o - 1] + 1,
            // substitution
            Math.min(
              s[a][o - 1] + 1,
              // insertion
              s[a - 1][o] + 1
            )
          );
      return s[n.length][r.length];
    }
  }]), t;
}(), b5e = wa, _5e = tW, w5e = m5e, T5e = JO, x5e = g5e, S5e = V$, E5e = y5e, $5e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Activator: b5e,
  Alea: EGe,
  ColorPicker: _5e,
  Configurator: w5e,
  DELETE: QO,
  HSVToHex: B$,
  HSVToRGB: Nf,
  Hammer: T5e,
  Popup: x5e,
  RGBToHSV: fd,
  RGBToHex: eA,
  VALIDATOR_PRINT_STYLE: S5e,
  Validator: E5e,
  addClassName: WGe,
  addCssText: s5e,
  addEventListener: QGe,
  binarySearchCustom: c5e,
  binarySearchValue: d5e,
  bridgeObject: nA,
  copyAndExtendArray: xp,
  copyArray: Z5,
  deepExtend: Tp,
  deepObjectAssign: ZO,
  easingFunctions: h5e,
  equalArray: VGe,
  extend: NGe,
  fillIfDefined: Q5,
  forEach: KGe,
  getAbsoluteLeft: YGe,
  getAbsoluteRight: HGe,
  getAbsoluteTop: GGe,
  getScrollBarWidth: f5e,
  getTarget: e5e,
  getType: yf,
  hasParent: t5e,
  hexToHSV: J5,
  hexToRGB: Lb,
  insertSort: l5e,
  isDate: LGe,
  isNumber: Lf,
  isObject: F$,
  isString: Yi,
  isValidHex: tA,
  isValidRGB: rA,
  isValidRGBA: eW,
  mergeOptions: u5e,
  option: r5e,
  overrideOpacity: n5e,
  parseColor: i5e,
  preventDefault: JGe,
  pureDeepObjectAssign: SGe,
  recursiveDOMDelete: X5,
  removeClassName: jGe,
  removeCssText: a5e,
  removeEventListener: ZGe,
  selectiveBridgeObject: o5e,
  selectiveDeepExtend: BGe,
  selectiveExtend: FGe,
  selectiveNotDeepExtend: UGe,
  throttle: XGe,
  toArray: zGe,
  topMost: p5e,
  updateProperty: qGe
}), Wy = {}, k5e = {
  get exports() {
    return Wy;
  },
  set exports(t) {
    Wy = t;
  }
}, Br = {}, zd = {}, D5e = {
  get exports() {
    return zd;
  },
  set exports(t) {
    zd = t;
  }
}, gc = {};
function rW() {
  var t = {};
  return t["align-content"] = !1, t["align-items"] = !1, t["align-self"] = !1, t["alignment-adjust"] = !1, t["alignment-baseline"] = !1, t.all = !1, t["anchor-point"] = !1, t.animation = !1, t["animation-delay"] = !1, t["animation-direction"] = !1, t["animation-duration"] = !1, t["animation-fill-mode"] = !1, t["animation-iteration-count"] = !1, t["animation-name"] = !1, t["animation-play-state"] = !1, t["animation-timing-function"] = !1, t.azimuth = !1, t["backface-visibility"] = !1, t.background = !0, t["background-attachment"] = !0, t["background-clip"] = !0, t["background-color"] = !0, t["background-image"] = !0, t["background-origin"] = !0, t["background-position"] = !0, t["background-repeat"] = !0, t["background-size"] = !0, t["baseline-shift"] = !1, t.binding = !1, t.bleed = !1, t["bookmark-label"] = !1, t["bookmark-level"] = !1, t["bookmark-state"] = !1, t.border = !0, t["border-bottom"] = !0, t["border-bottom-color"] = !0, t["border-bottom-left-radius"] = !0, t["border-bottom-right-radius"] = !0, t["border-bottom-style"] = !0, t["border-bottom-width"] = !0, t["border-collapse"] = !0, t["border-color"] = !0, t["border-image"] = !0, t["border-image-outset"] = !0, t["border-image-repeat"] = !0, t["border-image-slice"] = !0, t["border-image-source"] = !0, t["border-image-width"] = !0, t["border-left"] = !0, t["border-left-color"] = !0, t["border-left-style"] = !0, t["border-left-width"] = !0, t["border-radius"] = !0, t["border-right"] = !0, t["border-right-color"] = !0, t["border-right-style"] = !0, t["border-right-width"] = !0, t["border-spacing"] = !0, t["border-style"] = !0, t["border-top"] = !0, t["border-top-color"] = !0, t["border-top-left-radius"] = !0, t["border-top-right-radius"] = !0, t["border-top-style"] = !0, t["border-top-width"] = !0, t["border-width"] = !0, t.bottom = !1, t["box-decoration-break"] = !0, t["box-shadow"] = !0, t["box-sizing"] = !0, t["box-snap"] = !0, t["box-suppress"] = !0, t["break-after"] = !0, t["break-before"] = !0, t["break-inside"] = !0, t["caption-side"] = !1, t.chains = !1, t.clear = !0, t.clip = !1, t["clip-path"] = !1, t["clip-rule"] = !1, t.color = !0, t["color-interpolation-filters"] = !0, t["column-count"] = !1, t["column-fill"] = !1, t["column-gap"] = !1, t["column-rule"] = !1, t["column-rule-color"] = !1, t["column-rule-style"] = !1, t["column-rule-width"] = !1, t["column-span"] = !1, t["column-width"] = !1, t.columns = !1, t.contain = !1, t.content = !1, t["counter-increment"] = !1, t["counter-reset"] = !1, t["counter-set"] = !1, t.crop = !1, t.cue = !1, t["cue-after"] = !1, t["cue-before"] = !1, t.cursor = !1, t.direction = !1, t.display = !0, t["display-inside"] = !0, t["display-list"] = !0, t["display-outside"] = !0, t["dominant-baseline"] = !1, t.elevation = !1, t["empty-cells"] = !1, t.filter = !1, t.flex = !1, t["flex-basis"] = !1, t["flex-direction"] = !1, t["flex-flow"] = !1, t["flex-grow"] = !1, t["flex-shrink"] = !1, t["flex-wrap"] = !1, t.float = !1, t["float-offset"] = !1, t["flood-color"] = !1, t["flood-opacity"] = !1, t["flow-from"] = !1, t["flow-into"] = !1, t.font = !0, t["font-family"] = !0, t["font-feature-settings"] = !0, t["font-kerning"] = !0, t["font-language-override"] = !0, t["font-size"] = !0, t["font-size-adjust"] = !0, t["font-stretch"] = !0, t["font-style"] = !0, t["font-synthesis"] = !0, t["font-variant"] = !0, t["font-variant-alternates"] = !0, t["font-variant-caps"] = !0, t["font-variant-east-asian"] = !0, t["font-variant-ligatures"] = !0, t["font-variant-numeric"] = !0, t["font-variant-position"] = !0, t["font-weight"] = !0, t.grid = !1, t["grid-area"] = !1, t["grid-auto-columns"] = !1, t["grid-auto-flow"] = !1, t["grid-auto-rows"] = !1, t["grid-column"] = !1, t["grid-column-end"] = !1, t["grid-column-start"] = !1, t["grid-row"] = !1, t["grid-row-end"] = !1, t["grid-row-start"] = !1, t["grid-template"] = !1, t["grid-template-areas"] = !1, t["grid-template-columns"] = !1, t["grid-template-rows"] = !1, t["hanging-punctuation"] = !1, t.height = !0, t.hyphens = !1, t.icon = !1, t["image-orientation"] = !1, t["image-resolution"] = !1, t["ime-mode"] = !1, t["initial-letters"] = !1, t["inline-box-align"] = !1, t["justify-content"] = !1, t["justify-items"] = !1, t["justify-self"] = !1, t.left = !1, t["letter-spacing"] = !0, t["lighting-color"] = !0, t["line-box-contain"] = !1, t["line-break"] = !1, t["line-grid"] = !1, t["line-height"] = !1, t["line-snap"] = !1, t["line-stacking"] = !1, t["line-stacking-ruby"] = !1, t["line-stacking-shift"] = !1, t["line-stacking-strategy"] = !1, t["list-style"] = !0, t["list-style-image"] = !0, t["list-style-position"] = !0, t["list-style-type"] = !0, t.margin = !0, t["margin-bottom"] = !0, t["margin-left"] = !0, t["margin-right"] = !0, t["margin-top"] = !0, t["marker-offset"] = !1, t["marker-side"] = !1, t.marks = !1, t.mask = !1, t["mask-box"] = !1, t["mask-box-outset"] = !1, t["mask-box-repeat"] = !1, t["mask-box-slice"] = !1, t["mask-box-source"] = !1, t["mask-box-width"] = !1, t["mask-clip"] = !1, t["mask-image"] = !1, t["mask-origin"] = !1, t["mask-position"] = !1, t["mask-repeat"] = !1, t["mask-size"] = !1, t["mask-source-type"] = !1, t["mask-type"] = !1, t["max-height"] = !0, t["max-lines"] = !1, t["max-width"] = !0, t["min-height"] = !0, t["min-width"] = !0, t["move-to"] = !1, t["nav-down"] = !1, t["nav-index"] = !1, t["nav-left"] = !1, t["nav-right"] = !1, t["nav-up"] = !1, t["object-fit"] = !1, t["object-position"] = !1, t.opacity = !1, t.order = !1, t.orphans = !1, t.outline = !1, t["outline-color"] = !1, t["outline-offset"] = !1, t["outline-style"] = !1, t["outline-width"] = !1, t.overflow = !1, t["overflow-wrap"] = !1, t["overflow-x"] = !1, t["overflow-y"] = !1, t.padding = !0, t["padding-bottom"] = !0, t["padding-left"] = !0, t["padding-right"] = !0, t["padding-top"] = !0, t.page = !1, t["page-break-after"] = !1, t["page-break-before"] = !1, t["page-break-inside"] = !1, t["page-policy"] = !1, t.pause = !1, t["pause-after"] = !1, t["pause-before"] = !1, t.perspective = !1, t["perspective-origin"] = !1, t.pitch = !1, t["pitch-range"] = !1, t["play-during"] = !1, t.position = !1, t["presentation-level"] = !1, t.quotes = !1, t["region-fragment"] = !1, t.resize = !1, t.rest = !1, t["rest-after"] = !1, t["rest-before"] = !1, t.richness = !1, t.right = !1, t.rotation = !1, t["rotation-point"] = !1, t["ruby-align"] = !1, t["ruby-merge"] = !1, t["ruby-position"] = !1, t["shape-image-threshold"] = !1, t["shape-outside"] = !1, t["shape-margin"] = !1, t.size = !1, t.speak = !1, t["speak-as"] = !1, t["speak-header"] = !1, t["speak-numeral"] = !1, t["speak-punctuation"] = !1, t["speech-rate"] = !1, t.stress = !1, t["string-set"] = !1, t["tab-size"] = !1, t["table-layout"] = !1, t["text-align"] = !0, t["text-align-last"] = !0, t["text-combine-upright"] = !0, t["text-decoration"] = !0, t["text-decoration-color"] = !0, t["text-decoration-line"] = !0, t["text-decoration-skip"] = !0, t["text-decoration-style"] = !0, t["text-emphasis"] = !0, t["text-emphasis-color"] = !0, t["text-emphasis-position"] = !0, t["text-emphasis-style"] = !0, t["text-height"] = !0, t["text-indent"] = !0, t["text-justify"] = !0, t["text-orientation"] = !0, t["text-overflow"] = !0, t["text-shadow"] = !0, t["text-space-collapse"] = !0, t["text-transform"] = !0, t["text-underline-position"] = !0, t["text-wrap"] = !0, t.top = !1, t.transform = !1, t["transform-origin"] = !1, t["transform-style"] = !1, t.transition = !1, t["transition-delay"] = !1, t["transition-duration"] = !1, t["transition-property"] = !1, t["transition-timing-function"] = !1, t["unicode-bidi"] = !1, t["vertical-align"] = !1, t.visibility = !1, t["voice-balance"] = !1, t["voice-duration"] = !1, t["voice-family"] = !1, t["voice-pitch"] = !1, t["voice-range"] = !1, t["voice-rate"] = !1, t["voice-stress"] = !1, t["voice-volume"] = !1, t.volume = !1, t["white-space"] = !1, t.widows = !1, t.width = !0, t["will-change"] = !1, t["word-break"] = !0, t["word-spacing"] = !0, t["word-wrap"] = !0, t["wrap-flow"] = !1, t["wrap-through"] = !1, t["writing-mode"] = !1, t["z-index"] = !1, t;
}
function O5e(t, e, r) {
}
function A5e(t, e, r) {
}
var C5e = /javascript\s*\:/img;
function I5e(t, e) {
  return C5e.test(e) ? "" : e;
}
gc.whiteList = rW();
gc.getDefaultWhiteList = rW;
gc.onAttr = O5e;
gc.onIgnoreAttr = A5e;
gc.safeAttrValue = I5e;
var P5e = {
  indexOf: function(t, e) {
    var r, n;
    if (Array.prototype.indexOf)
      return t.indexOf(e);
    for (r = 0, n = t.length; r < n; r++)
      if (t[r] === e)
        return r;
    return -1;
  },
  forEach: function(t, e, r) {
    var n, s;
    if (Array.prototype.forEach)
      return t.forEach(e, r);
    for (n = 0, s = t.length; n < s; n++)
      e.call(r, t[n], n, t);
  },
  trim: function(t) {
    return String.prototype.trim ? t.trim() : t.replace(/(^\s*)|(\s*$)/g, "");
  },
  trimRight: function(t) {
    return String.prototype.trimRight ? t.trimRight() : t.replace(/(\s*$)/g, "");
  }
}, rf = P5e;
function R5e(t, e) {
  t = rf.trimRight(t), t[t.length - 1] !== ";" && (t += ";");
  var r = t.length, n = !1, s = 0, a = 0, o = "";
  function l() {
    if (!n) {
      var d = rf.trim(t.slice(s, a)), h = d.indexOf(":");
      if (h !== -1) {
        var f = rf.trim(d.slice(0, h)), p = rf.trim(d.slice(h + 1));
        if (f) {
          var m = e(s, o.length, f, p, d);
          m && (o += m + "; ");
        }
      }
    }
    s = a + 1;
  }
  for (; a < r; a++) {
    var u = t[a];
    if (u === "/" && t[a + 1] === "*") {
      var c = t.indexOf("*/", a + 2);
      if (c === -1)
        break;
      a = c + 1, s = a + 1, n = !1;
    } else
      u === "(" ? n = !0 : u === ")" ? n = !1 : u === ";" ? n || l() : u === `
` && l();
  }
  return rf.trim(o);
}
var M5e = R5e, ug = gc, L5e = M5e;
function s2(t) {
  return t == null;
}
function N5e(t) {
  var e = {};
  for (var r in t)
    e[r] = t[r];
  return e;
}
function nW(t) {
  t = N5e(t || {}), t.whiteList = t.whiteList || ug.whiteList, t.onAttr = t.onAttr || ug.onAttr, t.onIgnoreAttr = t.onIgnoreAttr || ug.onIgnoreAttr, t.safeAttrValue = t.safeAttrValue || ug.safeAttrValue, this.options = t;
}
nW.prototype.process = function(t) {
  if (t = t || "", t = t.toString(), !t)
    return "";
  var e = this, r = e.options, n = r.whiteList, s = r.onAttr, a = r.onIgnoreAttr, o = r.safeAttrValue, l = L5e(t, function(u, c, d, h, f) {
    var p = n[d], m = !1;
    if (p === !0 ? m = p : typeof p == "function" ? m = p(h) : p instanceof RegExp && (m = p.test(h)), m !== !0 && (m = !1), h = o(d, h), !!h) {
      var b = {
        position: c,
        sourcePosition: u,
        source: f,
        isWhite: m
      };
      if (m) {
        var y = s(d, h, b);
        return s2(y) ? d + ":" + h : y;
      } else {
        var y = a(d, h, b);
        if (!s2(y))
          return y;
      }
    }
  });
  return l;
};
var F5e = nW;
(function(t, e) {
  var r = gc, n = F5e;
  function s(o, l) {
    var u = new n(l);
    return u.process(o);
  }
  e = t.exports = s, e.FilterCSS = n;
  for (var a in r)
    e[a] = r[a];
  typeof window < "u" && (window.filterCSS = t.exports);
})(D5e, zd);
var iA = {
  indexOf: function(t, e) {
    var r, n;
    if (Array.prototype.indexOf)
      return t.indexOf(e);
    for (r = 0, n = t.length; r < n; r++)
      if (t[r] === e)
        return r;
    return -1;
  },
  forEach: function(t, e, r) {
    var n, s;
    if (Array.prototype.forEach)
      return t.forEach(e, r);
    for (n = 0, s = t.length; n < s; n++)
      e.call(r, t[n], n, t);
  },
  trim: function(t) {
    return String.prototype.trim ? t.trim() : t.replace(/(^\s*)|(\s*$)/g, "");
  },
  spaceIndex: function(t) {
    var e = /\s|\n|\t/, r = e.exec(t);
    return r ? r.index : -1;
  }
}, B5e = zd.FilterCSS, U5e = zd.getDefaultWhiteList, jy = iA;
function iW() {
  return {
    a: ["target", "href", "title"],
    abbr: ["title"],
    address: [],
    area: ["shape", "coords", "href", "alt"],
    article: [],
    aside: [],
    audio: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "preload",
      "src"
    ],
    b: [],
    bdi: ["dir"],
    bdo: ["dir"],
    big: [],
    blockquote: ["cite"],
    br: [],
    caption: [],
    center: [],
    cite: [],
    code: [],
    col: ["align", "valign", "span", "width"],
    colgroup: ["align", "valign", "span", "width"],
    dd: [],
    del: ["datetime"],
    details: ["open"],
    div: [],
    dl: [],
    dt: [],
    em: [],
    figcaption: [],
    figure: [],
    font: ["color", "size", "face"],
    footer: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    header: [],
    hr: [],
    i: [],
    img: ["src", "alt", "title", "width", "height"],
    ins: ["datetime"],
    li: [],
    mark: [],
    nav: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    section: [],
    small: [],
    span: [],
    sub: [],
    summary: [],
    sup: [],
    strong: [],
    strike: [],
    table: ["width", "border", "align", "valign"],
    tbody: ["align", "valign"],
    td: ["width", "rowspan", "colspan", "align", "valign"],
    tfoot: ["align", "valign"],
    th: ["width", "rowspan", "colspan", "align", "valign"],
    thead: ["align", "valign"],
    tr: ["rowspan", "align", "valign"],
    tt: [],
    u: [],
    ul: [],
    video: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "playsinline",
      "poster",
      "preload",
      "src",
      "height",
      "width"
    ]
  };
}
var sW = new B5e();
function V5e(t, e, r) {
}
function Y5e(t, e, r) {
}
function H5e(t, e, r) {
}
function G5e(t, e, r) {
}
function aW(t) {
  return t.replace(j5e, "&lt;").replace(K5e, "&gt;");
}
function W5e(t, e, r, n) {
  if (r = hW(r), e === "href" || e === "src") {
    if (r = jy.trim(r), r === "#")
      return "#";
    if (!(r.substr(0, 7) === "http://" || r.substr(0, 8) === "https://" || r.substr(0, 7) === "mailto:" || r.substr(0, 4) === "tel:" || r.substr(0, 11) === "data:image/" || r.substr(0, 6) === "ftp://" || r.substr(0, 2) === "./" || r.substr(0, 3) === "../" || r[0] === "#" || r[0] === "/"))
      return "";
  } else if (e === "background") {
    if (cg.lastIndex = 0, cg.test(r))
      return "";
  } else if (e === "style") {
    if (a2.lastIndex = 0, a2.test(r) || (o2.lastIndex = 0, o2.test(r) && (cg.lastIndex = 0, cg.test(r))))
      return "";
    n !== !1 && (n = n || sW, r = n.process(r));
  }
  return r = fW(r), r;
}
var j5e = /</g, K5e = />/g, z5e = /"/g, q5e = /&quot;/g, X5e = /&#([a-zA-Z0-9]*);?/gim, Q5e = /&colon;?/gim, Z5e = /&newline;?/gim, cg = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi, a2 = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi, o2 = /u\s*r\s*l\s*\(.*/gi;
function oW(t) {
  return t.replace(z5e, "&quot;");
}
function lW(t) {
  return t.replace(q5e, '"');
}
function uW(t) {
  return t.replace(X5e, function(r, n) {
    return n[0] === "x" || n[0] === "X" ? String.fromCharCode(parseInt(n.substr(1), 16)) : String.fromCharCode(parseInt(n, 10));
  });
}
function cW(t) {
  return t.replace(Q5e, ":").replace(Z5e, " ");
}
function dW(t) {
  for (var e = "", r = 0, n = t.length; r < n; r++)
    e += t.charCodeAt(r) < 32 ? " " : t.charAt(r);
  return jy.trim(e);
}
function hW(t) {
  return t = lW(t), t = uW(t), t = cW(t), t = dW(t), t;
}
function fW(t) {
  return t = oW(t), t = aW(t), t;
}
function J5e() {
  return "";
}
function eWe(t, e) {
  typeof e != "function" && (e = function() {
  });
  var r = !Array.isArray(t);
  function n(o) {
    return r ? !0 : jy.indexOf(t, o) !== -1;
  }
  var s = [], a = !1;
  return {
    onIgnoreTag: function(o, l, u) {
      if (n(o))
        if (u.isClosing) {
          var c = "[/removed]", d = u.position + c.length;
          return s.push([
            a !== !1 ? a : u.position,
            d
          ]), a = !1, c;
        } else
          return a || (a = u.position), "[removed]";
      else
        return e(o, l, u);
    },
    remove: function(o) {
      var l = "", u = 0;
      return jy.forEach(s, function(c) {
        l += o.slice(u, c[0]), u = c[1];
      }), l += o.slice(u), l;
    }
  };
}
function tWe(t) {
  for (var e = "", r = 0; r < t.length; ) {
    var n = t.indexOf("<!--", r);
    if (n === -1) {
      e += t.slice(r);
      break;
    }
    e += t.slice(r, n);
    var s = t.indexOf("-->", n);
    if (s === -1)
      break;
    r = s + 3;
  }
  return e;
}
function rWe(t) {
  var e = t.split("");
  return e = e.filter(function(r) {
    var n = r.charCodeAt(0);
    return n === 127 ? !1 : n <= 31 ? n === 10 || n === 13 : !0;
  }), e.join("");
}
Br.whiteList = iW();
Br.getDefaultWhiteList = iW;
Br.onTag = V5e;
Br.onIgnoreTag = Y5e;
Br.onTagAttr = H5e;
Br.onIgnoreTagAttr = G5e;
Br.safeAttrValue = W5e;
Br.escapeHtml = aW;
Br.escapeQuote = oW;
Br.unescapeQuote = lW;
Br.escapeHtmlEntities = uW;
Br.escapeDangerHtml5Entities = cW;
Br.clearNonPrintableCharacter = dW;
Br.friendlyAttrValue = hW;
Br.escapeAttrValue = fW;
Br.onIgnoreTagStripAll = J5e;
Br.StripTagBody = eWe;
Br.stripCommentTag = tWe;
Br.stripBlankChar = rWe;
Br.cssFilter = sW;
Br.getDefaultCSSWhiteList = U5e;
var Nb = {}, al = iA;
function nWe(t) {
  var e = al.spaceIndex(t), r;
  return e === -1 ? r = t.slice(1, -1) : r = t.slice(1, e + 1), r = al.trim(r).toLowerCase(), r.slice(0, 1) === "/" && (r = r.slice(1)), r.slice(-1) === "/" && (r = r.slice(0, -1)), r;
}
function iWe(t) {
  return t.slice(0, 2) === "</";
}
function sWe(t, e, r) {
  var n = "", s = 0, a = !1, o = !1, l = 0, u = t.length, c = "", d = "";
  e:
    for (l = 0; l < u; l++) {
      var h = t.charAt(l);
      if (a === !1) {
        if (h === "<") {
          a = l;
          continue;
        }
      } else if (o === !1) {
        if (h === "<") {
          n += r(t.slice(s, l)), a = l, s = l;
          continue;
        }
        if (h === ">" || l === u - 1) {
          n += r(t.slice(s, a)), d = t.slice(a, l + 1), c = nWe(d), n += e(
            a,
            n.length,
            c,
            d,
            iWe(d)
          ), s = l + 1, a = !1;
          continue;
        }
        if (h === '"' || h === "'")
          for (var f = 1, p = t.charAt(l - f); p.trim() === "" || p === "="; ) {
            if (p === "=") {
              o = h;
              continue e;
            }
            p = t.charAt(l - ++f);
          }
      } else if (h === o) {
        o = !1;
        continue;
      }
    }
  return s < u && (n += r(t.substr(s))), n;
}
var aWe = /[^a-zA-Z0-9\\_:.-]/gim;
function oWe(t, e) {
  var r = 0, n = 0, s = [], a = !1, o = t.length;
  function l(f, p) {
    if (f = al.trim(f), f = f.replace(aWe, "").toLowerCase(), !(f.length < 1)) {
      var m = e(f, p || "");
      m && s.push(m);
    }
  }
  for (var u = 0; u < o; u++) {
    var c = t.charAt(u), d, h;
    if (a === !1 && c === "=") {
      a = t.slice(r, u), r = u + 1, n = t.charAt(r) === '"' || t.charAt(r) === "'" ? r : uWe(t, u + 1);
      continue;
    }
    if (a !== !1 && u === n) {
      if (h = t.indexOf(c, u + 1), h === -1)
        break;
      d = al.trim(t.slice(n + 1, h)), l(a, d), a = !1, u = h, r = u + 1;
      continue;
    }
    if (/\s|\n|\t/.test(c))
      if (t = t.replace(/\s|\n|\t/g, " "), a === !1)
        if (h = lWe(t, u), h === -1) {
          d = al.trim(t.slice(r, u)), l(d), a = !1, r = u + 1;
          continue;
        } else {
          u = h - 1;
          continue;
        }
      else if (h = cWe(t, u - 1), h === -1) {
        d = al.trim(t.slice(r, u)), d = l2(d), l(a, d), a = !1, r = u + 1;
        continue;
      } else
        continue;
  }
  return r < t.length && (a === !1 ? l(t.slice(r)) : l(a, l2(al.trim(t.slice(r))))), al.trim(s.join(" "));
}
function lWe(t, e) {
  for (; e < t.length; e++) {
    var r = t[e];
    if (r !== " ")
      return r === "=" ? e : -1;
  }
}
function uWe(t, e) {
  for (; e < t.length; e++) {
    var r = t[e];
    if (r !== " ")
      return r === "'" || r === '"' ? e : -1;
  }
}
function cWe(t, e) {
  for (; e > 0; e--) {
    var r = t[e];
    if (r !== " ")
      return r === "=" ? e : -1;
  }
}
function dWe(t) {
  return t[0] === '"' && t[t.length - 1] === '"' || t[0] === "'" && t[t.length - 1] === "'";
}
function l2(t) {
  return dWe(t) ? t.substr(1, t.length - 2) : t;
}
Nb.parseTag = sWe;
Nb.parseAttr = oWe;
var hWe = zd.FilterCSS, As = Br, pW = Nb, fWe = pW.parseTag, pWe = pW.parseAttr, Bg = iA;
function dg(t) {
  return t == null;
}
function vWe(t) {
  var e = Bg.spaceIndex(t);
  if (e === -1)
    return {
      html: "",
      closing: t[t.length - 2] === "/"
    };
  t = Bg.trim(t.slice(e + 1, -1));
  var r = t[t.length - 1] === "/";
  return r && (t = Bg.trim(t.slice(0, -1))), {
    html: t,
    closing: r
  };
}
function mWe(t) {
  var e = {};
  for (var r in t)
    e[r] = t[r];
  return e;
}
function gWe(t) {
  var e = {};
  for (var r in t)
    Array.isArray(t[r]) ? e[r.toLowerCase()] = t[r].map(function(n) {
      return n.toLowerCase();
    }) : e[r.toLowerCase()] = t[r];
  return e;
}
function vW(t) {
  t = mWe(t || {}), t.stripIgnoreTag && (t.onIgnoreTag && console.error(
    'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
  ), t.onIgnoreTag = As.onIgnoreTagStripAll), t.whiteList || t.allowList ? t.whiteList = gWe(t.whiteList || t.allowList) : t.whiteList = As.whiteList, t.onTag = t.onTag || As.onTag, t.onTagAttr = t.onTagAttr || As.onTagAttr, t.onIgnoreTag = t.onIgnoreTag || As.onIgnoreTag, t.onIgnoreTagAttr = t.onIgnoreTagAttr || As.onIgnoreTagAttr, t.safeAttrValue = t.safeAttrValue || As.safeAttrValue, t.escapeHtml = t.escapeHtml || As.escapeHtml, this.options = t, t.css === !1 ? this.cssFilter = !1 : (t.css = t.css || {}, this.cssFilter = new hWe(t.css));
}
vW.prototype.process = function(t) {
  if (t = t || "", t = t.toString(), !t)
    return "";
  var e = this, r = e.options, n = r.whiteList, s = r.onTag, a = r.onIgnoreTag, o = r.onTagAttr, l = r.onIgnoreTagAttr, u = r.safeAttrValue, c = r.escapeHtml, d = e.cssFilter;
  r.stripBlankChar && (t = As.stripBlankChar(t)), r.allowCommentTag || (t = As.stripCommentTag(t));
  var h = !1;
  r.stripIgnoreTagBody && (h = As.StripTagBody(
    r.stripIgnoreTagBody,
    a
  ), a = h.onIgnoreTag);
  var f = fWe(
    t,
    function(p, m, b, y, _) {
      var x = {
        sourcePosition: p,
        position: m,
        isClosing: _,
        isWhite: Object.prototype.hasOwnProperty.call(n, b)
      }, T = s(b, y, x);
      if (!dg(T))
        return T;
      if (x.isWhite) {
        if (x.isClosing)
          return "</" + b + ">";
        var k = vWe(y), E = n[b], F = pWe(k.html, function(R, $) {
          var O = Bg.indexOf(E, R) !== -1, P = o(b, R, $, O);
          return dg(P) ? O ? ($ = u(b, R, $, d), $ ? R + '="' + $ + '"' : R) : (P = l(b, R, $, O), dg(P) ? void 0 : P) : P;
        });
        return y = "<" + b, F && (y += " " + F), k.closing && (y += " /"), y += ">", y;
      } else
        return T = a(b, y, x), dg(T) ? c(y) : T;
    },
    c
  );
  return h && (f = h.remove(f)), f;
};
var yWe = vW;
(function(t, e) {
  var r = Br, n = Nb, s = yWe;
  function a(l, u) {
    var c = new s(u);
    return c.process(l);
  }
  e = t.exports = a, e.filterXSS = a, e.FilterXSS = s, function() {
    for (var l in r)
      e[l] = r[l];
    for (var u in n)
      e[u] = n[u];
  }(), typeof window < "u" && (window.filterXSS = t.exports);
  function o() {
    return typeof self < "u" && typeof DedicatedWorkerGlobalScope < "u" && self instanceof DedicatedWorkerGlobalScope;
  }
  o() && (self.filterXSS = t.exports);
})(k5e, Wy);
var bWe = Wy;
let hg;
const _We = new Uint8Array(16);
function wWe() {
  if (!hg && (hg = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !hg))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return hg(_We);
}
const An = [];
for (let t = 0; t < 256; ++t)
  An.push((t + 256).toString(16).slice(1));
function TWe(t, e = 0) {
  return (An[t[e + 0]] + An[t[e + 1]] + An[t[e + 2]] + An[t[e + 3]] + "-" + An[t[e + 4]] + An[t[e + 5]] + "-" + An[t[e + 6]] + An[t[e + 7]] + "-" + An[t[e + 8]] + An[t[e + 9]] + "-" + An[t[e + 10]] + An[t[e + 11]] + An[t[e + 12]] + An[t[e + 13]] + An[t[e + 14]] + An[t[e + 15]]).toLowerCase();
}
const xWe = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var u2 = {
  randomUUID: xWe
};
function Dd(t, e, r) {
  if (u2.randomUUID && !e && !t)
    return u2.randomUUID();
  t = t || {};
  const n = t.random || (t.rng || wWe)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, e) {
    r = r || 0;
    for (let s = 0; s < 16; ++s)
      e[r + s] = n[s];
    return e;
  }
  return TWe(n);
}
function c2(t, e) {
  var r = xn(t);
  if (By) {
    var n = By(t);
    e && (n = At(n).call(n, function(s) {
      return Ab(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function d2(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r, n, s = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Le(r = c2(Object(s), !0)).call(r, function(a) {
      n5(t, a, s[a]);
    }) : Uy ? r5(t, Uy(s)) : Le(n = c2(Object(s))).call(n, function(a) {
      BO(t, a, Ab(s, a));
    });
  }
  return t;
}
function Oo(t) {
  var e;
  if (!t)
    return !1;
  var r = (e = t.idProp) !== null && e !== void 0 ? e : t._idProp;
  return r ? rAe(r, t) : !1;
}
var tT = /^\/?Date\((-?\d+)/i, SWe = /^\d+$/;
function sA(t, e) {
  var r;
  if (t !== void 0) {
    if (t === null)
      return null;
    if (!e)
      return t;
    if (typeof e != "string" && !(e instanceof String))
      throw new Error("Type must be a string");
    switch (e) {
      case "boolean":
      case "Boolean":
        return !!t;
      case "number":
      case "Number":
        return Yi(t) && !isNaN(Date.parse(t)) ? we(t).valueOf() : Number(t.valueOf());
      case "string":
      case "String":
        return String(t);
      case "Date":
        try {
          return sA(t, "Moment").toDate();
        } catch (s) {
          throw s instanceof TypeError ? new TypeError("Cannot convert object of type " + yf(t) + " to type " + e) : s;
        }
      case "Moment":
        if (Lf(t))
          return we(t);
        if (t instanceof Date)
          return we(t.valueOf());
        if (we.isMoment(t))
          return we(t);
        if (Yi(t))
          return r = tT.exec(t), r ? we(Number(r[1])) : (r = SWe.exec(t), we(r ? Number(t) : t));
        throw new TypeError("Cannot convert object of type " + yf(t) + " to type " + e);
      case "ISODate":
        if (Lf(t))
          return new Date(t);
        if (t instanceof Date)
          return t.toISOString();
        if (we.isMoment(t))
          return t.toDate().toISOString();
        if (Yi(t))
          return r = tT.exec(t), r ? new Date(Number(r[1])).toISOString() : we(t).format();
        throw new Error("Cannot convert object of type " + yf(t) + " to type ISODate");
      case "ASPDate":
        if (Lf(t))
          return "/Date(" + t + ")/";
        if (t instanceof Date || we.isMoment(t))
          return "/Date(" + t.valueOf() + ")/";
        if (Yi(t)) {
          r = tT.exec(t);
          var n;
          return r ? n = new Date(Number(r[1])).valueOf() : n = new Date(t).valueOf(), "/Date(" + n + ")/";
        } else
          throw new Error("Cannot convert object of type " + yf(t) + " to type ASPDate");
      default:
        throw new Error("Unknown type ".concat(e));
    }
  }
}
function qd(t) {
  var e, r, n, s, a, o, l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    start: "Date",
    end: "Date"
  }, u = t._idProp, c = new Gu({
    fieldId: u
  }), d = ln(e = yme(t)).call(e, function(h) {
    var f;
    return i5(f = xn(h)).call(f, function(p, m) {
      return p[m] = sA(h[m], l[m]), p;
    }, {});
  }).to(c);
  return d.all().start(), {
    // Write only.
    add: function() {
      var f;
      return (f = t.getDataSet()).add.apply(f, arguments);
    },
    remove: function() {
      var f;
      return (f = t.getDataSet()).remove.apply(f, arguments);
    },
    update: function() {
      var f;
      return (f = t.getDataSet()).update.apply(f, arguments);
    },
    updateOnly: function() {
      var f;
      return (f = t.getDataSet()).updateOnly.apply(f, arguments);
    },
    clear: function() {
      var f;
      return (f = t.getDataSet()).clear.apply(f, arguments);
    },
    // Read only.
    forEach: de(r = Le(c)).call(r, c),
    get: de(n = c.get).call(n, c),
    getIds: de(s = c.getIds).call(s, c),
    off: de(a = c.off).call(a, c),
    on: de(o = c.on).call(o, c),
    get length() {
      return c.length;
    },
    // Non standard.
    idProp: u,
    type: l,
    rawDS: t,
    coercedDS: c,
    dispose: function() {
      return d.stop();
    }
  };
}
var mW = function(e) {
  var r = new bWe.FilterXSS(e);
  return function(n) {
    return r.process(n);
  };
}, EWe = function(e) {
  return e;
}, Y$ = mW(), $We = function(e) {
  e && (e.disabled === !0 ? (Y$ = EWe, console.warn("You disabled XSS protection for vis-Timeline. I sure hope you know what you're doing!")) : e.filterOptions && (Y$ = mW(e.filterOptions)));
}, G = d2(d2({}, $5e), {}, {
  convert: sA,
  setupXSSProtection: $We
});
BO(G, "xss", {
  get: function() {
    return Y$;
  }
});
var H$ = {}, kWe = {
  get exports() {
    return H$;
  },
  set exports(t) {
    H$ = t;
  }
}, gW = $n, DWe = qt, OWe = Xt, AWe = ra, CWe = VO.trim, IWe = Ib, PWe = OWe("".charAt), Ky = gW.parseFloat, h2 = gW.Symbol, f2 = h2 && h2.iterator, RWe = 1 / Ky(IWe + "-0") !== -1 / 0 || f2 && !DWe(function() {
  Ky(Object(f2));
}), MWe = RWe ? function(e) {
  var r = CWe(AWe(e)), n = Ky(r);
  return n === 0 && PWe(r, 0) == "-" ? -0 : n;
} : Ky, LWe = lt, p2 = MWe;
LWe({ global: !0, forced: parseFloat != p2 }, {
  parseFloat: p2
});
var NWe = mr, FWe = NWe.parseFloat, BWe = FWe, UWe = BWe;
(function(t) {
  t.exports = UWe;
})(kWe);
var zy = /* @__PURE__ */ rt(H$), Fl = /* @__PURE__ */ function() {
  function t(e, r) {
    dr(this, t), this.options = null, this.props = null;
  }
  return hr(t, [{
    key: "setOptions",
    value: function(r) {
      r && G.extend(this.options, r);
    }
    /**
     * Repaint the component
     * @return {boolean} Returns true if the component is resized
     */
  }, {
    key: "redraw",
    value: function() {
      return !1;
    }
    /**
     * Destroy the component. Cleanup DOM and event listeners
     */
  }, {
    key: "destroy",
    value: function() {
    }
    /**
     * Test whether the component is resized since the last time _isResized() was
     * called.
     * @return {Boolean} Returns true if the component is resized
     * @protected
     */
  }, {
    key: "_isResized",
    value: function() {
      var r = this.props._previousWidth !== this.props.width || this.props._previousHeight !== this.props.height;
      return this.props._previousWidth = this.props.width, this.props._previousHeight = this.props.height, r;
    }
  }]), t;
}(), G$ = {}, VWe = {
  get exports() {
    return G$;
  },
  set exports(t) {
    G$ = t;
  }
}, YWe = Sv, HWe = ra, GWe = Th, WWe = RangeError, jWe = function(e) {
  var r = HWe(GWe(this)), n = "", s = YWe(e);
  if (s < 0 || s == 1 / 0)
    throw WWe("Wrong number of repetitions");
  for (; s > 0; (s >>>= 1) && (r += r))
    s & 1 && (n += r);
  return n;
}, KWe = lt, zWe = jWe;
KWe({ target: "String", proto: !0 }, {
  repeat: zWe
});
var qWe = sn, XWe = qWe("String").repeat, QWe = Fr, ZWe = XWe, rT = String.prototype, JWe = function(t) {
  var e = t.repeat;
  return typeof t == "string" || t === rT || QWe(rT, t) && e === rT.repeat ? ZWe : e;
}, eje = JWe, tje = eje;
(function(t) {
  t.exports = tje;
})(VWe);
var Zc = /* @__PURE__ */ rt(G$), W$ = {}, rje = {
  get exports() {
    return W$;
  },
  set exports(t) {
    W$ = t;
  }
}, v2 = tG, nje = Math.floor, j$ = function(t, e) {
  var r = t.length, n = nje(r / 2);
  return r < 8 ? ije(t, e) : sje(
    t,
    j$(v2(t, 0, n), e),
    j$(v2(t, n), e),
    e
  );
}, ije = function(t, e) {
  for (var r = t.length, n = 1, s, a; n < r; ) {
    for (a = n, s = t[n]; a && e(t[a - 1], s) > 0; )
      t[a] = t[--a];
    a !== n++ && (t[a] = s);
  }
  return t;
}, sje = function(t, e, r, n) {
  for (var s = e.length, a = r.length, o = 0, l = 0; o < s || l < a; )
    t[o + l] = o < s && l < a ? n(e[o], r[l]) <= 0 ? e[o++] : r[l++] : o < s ? e[o++] : r[l++];
  return t;
}, aje = j$, oje = bv, m2 = oje.match(/firefox\/(\d+)/i), lje = !!m2 && +m2[1], uje = bv, cje = /MSIE|Trident/.test(uje), dje = bv, g2 = dje.match(/AppleWebKit\/(\d+)\./), hje = !!g2 && +g2[1], fje = lt, yW = Xt, pje = fc, vje = Zi, y2 = ta, mje = g5, b2 = ra, aA = qt, gje = aje, yje = Ch, _2 = lje, bje = cje, w2 = _v, T2 = hje, hl = [], x2 = yW(hl.sort), _je = yW(hl.push), wje = aA(function() {
  hl.sort(void 0);
}), Tje = aA(function() {
  hl.sort(null);
}), xje = yje("sort"), bW = !aA(function() {
  if (w2)
    return w2 < 70;
  if (!(_2 && _2 > 3)) {
    if (bje)
      return !0;
    if (T2)
      return T2 < 603;
    var t = "", e, r, n, s;
    for (e = 65; e < 76; e++) {
      switch (r = String.fromCharCode(e), e) {
        case 66:
        case 69:
        case 70:
        case 72:
          n = 3;
          break;
        case 68:
        case 71:
          n = 4;
          break;
        default:
          n = 2;
      }
      for (s = 0; s < 47; s++)
        hl.push({ k: r + s, v: n });
    }
    for (hl.sort(function(a, o) {
      return o.v - a.v;
    }), s = 0; s < hl.length; s++)
      r = hl[s].k.charAt(0), t.charAt(t.length - 1) !== r && (t += r);
    return t !== "DGBEFHACIJK";
  }
}), Sje = wje || !Tje || !xje || !bW, Eje = function(t) {
  return function(e, r) {
    return r === void 0 ? -1 : e === void 0 ? 1 : t !== void 0 ? +t(e, r) || 0 : b2(e) > b2(r) ? 1 : -1;
  };
};
fje({ target: "Array", proto: !0, forced: Sje }, {
  sort: function(e) {
    e !== void 0 && pje(e);
    var r = vje(this);
    if (bW)
      return e === void 0 ? x2(r) : x2(r, e);
    var n = [], s = y2(r), a, o;
    for (o = 0; o < s; o++)
      o in r && _je(n, r[o]);
    for (gje(n, Eje(e)), a = y2(n), o = 0; o < a; )
      r[o] = n[o++];
    for (; o < s; )
      mje(r, o++);
    return r;
  }
});
var $je = sn, kje = $je("Array").sort, Dje = Fr, Oje = kje, nT = Array.prototype, Aje = function(t) {
  var e = t.sort;
  return t === nT || Dje(nT, t) && e === nT.sort ? Oje : e;
}, Cje = Aje, Ije = Cje;
(function(t) {
  t.exports = Ije;
})(rje);
var wn = /* @__PURE__ */ rt(W$);
function oA(t, e, r) {
  if (r && !$t(r))
    return oA(t, e, [r]);
  if (e.hiddenDates = [], r && $t(r) == !0) {
    for (var n, s = 0; s < r.length; s++)
      if (Zc(r[s]) === void 0) {
        var a = {};
        a.start = t(r[s].start).toDate().valueOf(), a.end = t(r[s].end).toDate().valueOf(), e.hiddenDates.push(a);
      }
    wn(n = e.hiddenDates).call(n, function(o, l) {
      return o.start - l.start;
    });
  }
}
function qy(t, e, r) {
  if (r && !$t(r))
    return qy(t, e, [r]);
  if (r && e.domProps.centerContainer.width !== void 0) {
    oA(t, e, r);
    for (var n = t(e.range.start), s = t(e.range.end), a = e.range.end - e.range.start, o = a / e.domProps.centerContainer.width, l = 0; l < r.length; l++)
      if (Zc(r[l]) !== void 0) {
        var u = t(r[l].start), c = t(r[l].end);
        if (u._d == "Invalid Date")
          throw new Error("Supplied start date is not valid: ".concat(r[l].start));
        if (c._d == "Invalid Date")
          throw new Error("Supplied end date is not valid: ".concat(r[l].end));
        var d = c - u;
        if (d >= 4 * o) {
          var h = 0, f = s.clone();
          switch (Zc(r[l])) {
            case "daily":
              u.day() != c.day() && (h = 1), u.dayOfYear(n.dayOfYear()), u.year(n.year()), u.subtract(7, "days"), c.dayOfYear(n.dayOfYear()), c.year(n.year()), c.subtract(7 - h, "days"), f.add(1, "weeks");
              break;
            case "weekly": {
              var p = c.diff(u, "days"), m = u.day();
              u.date(n.date()), u.month(n.month()), u.year(n.year()), c = u.clone(), u.day(m), c.day(m), c.add(p, "days"), u.subtract(1, "weeks"), c.subtract(1, "weeks"), f.add(1, "weeks");
              break;
            }
            case "monthly":
              u.month() != c.month() && (h = 1), u.month(n.month()), u.year(n.year()), u.subtract(1, "months"), c.month(n.month()), c.year(n.year()), c.subtract(1, "months"), c.add(h, "months"), f.add(1, "months");
              break;
            case "yearly":
              u.year() != c.year() && (h = 1), u.year(n.year()), u.subtract(1, "years"), c.year(n.year()), c.subtract(1, "years"), c.add(h, "years"), f.add(1, "years");
              break;
            default:
              console.log("Wrong repeat format, allowed are: daily, weekly, monthly, yearly. Given:", Zc(r[l]));
              return;
          }
          for (; u < f; )
            switch (e.hiddenDates.push({
              start: u.valueOf(),
              end: c.valueOf()
            }), Zc(r[l])) {
              case "daily":
                u.add(1, "days"), c.add(1, "days");
                break;
              case "weekly":
                u.add(1, "weeks"), c.add(1, "weeks");
                break;
              case "monthly":
                u.add(1, "months"), c.add(1, "months");
                break;
              case "yearly":
                u.add(1, "y"), c.add(1, "y");
                break;
              default:
                console.log("Wrong repeat format, allowed are: daily, weekly, monthly, yearly. Given:", Zc(r[l]));
                return;
            }
          e.hiddenDates.push({
            start: u.valueOf(),
            end: c.valueOf()
          });
        }
      }
    Pje(e);
    var b = Qy(e.range.start, e.hiddenDates), y = Qy(e.range.end, e.hiddenDates), _ = e.range.start, x = e.range.end;
    b.hidden == !0 && (_ = e.range.startToFront == !0 ? b.startDate - 1 : b.endDate + 1), y.hidden == !0 && (x = e.range.endToFront == !0 ? y.startDate - 1 : y.endDate + 1), (b.hidden == !0 || y.hidden == !0) && e.range._applyRange(_, x);
  }
}
function Pje(t) {
  for (var e, r = t.hiddenDates, n = [], s = 0; s < r.length; s++)
    for (var a = 0; a < r.length; a++)
      s != a && r[a].remove != !0 && r[s].remove != !0 && (r[a].start >= r[s].start && r[a].end <= r[s].end ? r[a].remove = !0 : r[a].start >= r[s].start && r[a].start <= r[s].end ? (r[s].end = r[a].end, r[a].remove = !0) : r[a].end >= r[s].start && r[a].end <= r[s].end && (r[s].start = r[a].start, r[a].remove = !0));
  for (s = 0; s < r.length; s++)
    r[s].remove !== !0 && n.push(r[s]);
  t.hiddenDates = n, wn(e = t.hiddenDates).call(e, function(o, l) {
    return o.start - l.start;
  });
}
function Rje(t, e, r) {
  for (var n = !1, s = e.current.valueOf(), a = 0; a < e.hiddenDates.length; a++) {
    var o = e.hiddenDates[a].start, l = e.hiddenDates[a].end;
    if (s >= o && s < l) {
      n = !0;
      break;
    }
  }
  if (n == !0 && s < e._end.valueOf() && s != r) {
    var u = t(r), c = t(l);
    u.year() != c.year() ? e.switchedYear = !0 : u.month() != c.month() ? e.switchedMonth = !0 : u.dayOfYear() != c.dayOfYear() && (e.switchedDay = !0), e.current = c;
  }
}
function S2(t, e, r) {
  var n;
  if (t.body.hiddenDates.length == 0)
    return n = t.range.conversion(r), (e.valueOf() - n.offset) * n.scale;
  var s = Qy(e, t.body.hiddenDates);
  s.hidden == !0 && (e = s.startDate);
  var a = Ff(t.body.hiddenDates, t.range.start, t.range.end);
  if (e < t.range.start) {
    n = t.range.conversion(r, a);
    var o = Mje(t.body.hiddenDates, e, n.offset);
    return e = t.options.moment(e).toDate().valueOf(), e = e + o, -(n.offset - e.valueOf()) * n.scale;
  } else if (e > t.range.end) {
    var l = {
      start: t.range.start,
      end: e
    };
    return e = $2(t.options.moment, t.body.hiddenDates, l, e), n = t.range.conversion(r, a), (e.valueOf() - n.offset) * n.scale;
  } else
    return e = $2(t.options.moment, t.body.hiddenDates, t.range, e), n = t.range.conversion(r, a), (e.valueOf() - n.offset) * n.scale;
}
function E2(t, e, r) {
  if (t.body.hiddenDates.length == 0) {
    var n = t.range.conversion(r);
    return new Date(e / n.scale + n.offset);
  } else {
    var s = Ff(t.body.hiddenDates, t.range.start, t.range.end), a = t.range.end - t.range.start - s, o = a * e / r, l = Lje(t.body.hiddenDates, t.range, o);
    return new Date(l + o + t.range.start);
  }
}
function Ff(t, e, r) {
  for (var n = 0, s = 0; s < t.length; s++) {
    var a = t[s].start, o = t[s].end;
    a >= e && o < r && (n += o - a);
  }
  return n;
}
function Mje(t, e, r) {
  for (var n = 0, s = 0; s < t.length; s++) {
    var a = t[s].start, o = t[s].end;
    a >= e && o <= r && (n += o - a);
  }
  return n;
}
function $2(t, e, r, n) {
  return n = t(n).toDate().valueOf(), n -= Xy(t, e, r, n), n;
}
function Xy(t, e, r, n) {
  var s = 0;
  n = t(n).toDate().valueOf();
  for (var a = 0; a < e.length; a++) {
    var o = e[a].start, l = e[a].end;
    o >= r.start && l < r.end && n >= l && (s += l - o);
  }
  return s;
}
function Lje(t, e, r) {
  for (var n = 0, s = 0, a = e.start, o = 0; o < t.length; o++) {
    var l = t[o].start, u = t[o].end;
    if (l >= e.start && u < e.end) {
      if (s += l - a, a = u, s >= r)
        break;
      n += u - l;
    }
  }
  return n;
}
function ru(t, e, r, n) {
  var s = Qy(e, t);
  return s.hidden == !0 ? r < 0 ? n == !0 ? s.startDate - (s.endDate - e) - 1 : s.startDate - 1 : n == !0 ? s.endDate + (e - s.startDate) + 1 : s.endDate + 1 : e;
}
function Qy(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r].start, s = e[r].end;
    if (t >= n && t < s)
      return {
        hidden: !0,
        startDate: n,
        endDate: s
      };
  }
  return {
    hidden: !1,
    startDate: n,
    endDate: s
  };
}
function Nje(t) {
  var e = Fje();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function Fje() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var _W = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = Nje(r);
  function r(n, s) {
    var a, o, l, u, c, d, h, f;
    dr(this, r), f = e.call(this);
    var p = Ti().hours(0).minutes(0).seconds(0).milliseconds(0), m = p.clone().add(-3, "days").valueOf(), b = p.clone().add(3, "days").valueOf();
    return f.millisecondsPerPixelCache = void 0, s === void 0 ? (f.start = m, f.end = b) : (f.start = s.start || m, f.end = s.end || b), f.rolling = !1, f.body = n, f.deltaDifference = 0, f.scaleOffset = 0, f.startToFront = !1, f.endToFront = !0, f.defaultOptions = {
      rtl: !1,
      start: null,
      end: null,
      moment: Ti,
      direction: "horizontal",
      // 'horizontal' or 'vertical'
      moveable: !0,
      zoomable: !0,
      min: null,
      max: null,
      zoomMin: 10,
      // milliseconds
      zoomMax: 1e3 * 60 * 60 * 24 * 365 * 1e4,
      // milliseconds
      rollingMode: {
        follow: !1,
        offset: 0.5
      }
    }, f.options = G.extend({}, f.defaultOptions), f.props = {
      touch: {}
    }, f.animationTimer = null, f.body.emitter.on("panstart", de(a = f._onDragStart).call(a, Vn(f))), f.body.emitter.on("panmove", de(o = f._onDrag).call(o, Vn(f))), f.body.emitter.on("panend", de(l = f._onDragEnd).call(l, Vn(f))), f.body.emitter.on("mousewheel", de(u = f._onMouseWheel).call(u, Vn(f))), f.body.emitter.on("touch", de(c = f._onTouch).call(c, Vn(f))), f.body.emitter.on("pinch", de(d = f._onPinch).call(d, Vn(f))), f.body.dom.rollingModeBtn.addEventListener("click", de(h = f.startRolling).call(h, Vn(f))), f.setOptions(s), f;
  }
  return hr(r, [{
    key: "setOptions",
    value: function(s) {
      if (s) {
        var a = ["animation", "direction", "min", "max", "zoomMin", "zoomMax", "moveable", "zoomable", "moment", "activate", "hiddenDates", "zoomKey", "zoomFriction", "rtl", "showCurrentTime", "rollingMode", "horizontalScroll"];
        G.selectiveExtend(a, this.options, s), s.rollingMode && s.rollingMode.follow && this.startRolling(), ("start" in s || "end" in s) && this.setRange(s.start, s.end);
      }
    }
    /**
     * Start auto refreshing the current time bar
     */
  }, {
    key: "startRolling",
    value: function() {
      var s = this;
      function a() {
        s.stopRolling(), s.rolling = !0;
        var o = s.end - s.start, l = G.convert(/* @__PURE__ */ new Date(), "Date").valueOf(), u = s.options.rollingMode && s.options.rollingMode.offset || 0.5, c = l - o * u, d = l + o * (1 - u), h = {
          animation: !1
        };
        s.setRange(c, d, h);
        var f = s.conversion(s.body.domProps.center.width).scale;
        o = 1 / f / 10, o < 30 && (o = 30), o > 1e3 && (o = 1e3), s.body.dom.rollingModeBtn.style.visibility = "hidden", s.currentTimeTimer = ai(a, o);
      }
      a();
    }
    /**
     * Stop auto refreshing the current time bar
     */
  }, {
    key: "stopRolling",
    value: function() {
      this.currentTimeTimer !== void 0 && (clearTimeout(this.currentTimeTimer), this.rolling = !1, this.body.dom.rollingModeBtn.style.visibility = "visible");
    }
    /**
     * Set a new start and end range
     * @param {Date | number | string} start
     * @param {Date | number | string} end
     * @param {Object} options      Available options:
     *                              {boolean | {duration: number, easingFunction: string}} [animation=false]
     *                                    If true, the range is animated
     *                                    smoothly to the new window. An object can be
     *                                    provided to specify duration and easing function.
     *                                    Default duration is 500 ms, and default easing
     *                                    function is 'easeInOutQuad'.
     *                              {boolean} [byUser=false]
     *                              {Event}  event  Mouse event
     * @param {Function} callback     a callback function to be executed at the end of this function  
     * @param {Function} frameCallback    a callback function executed each frame of the range animation.
     *                                    The callback will be passed three parameters:
     *                                    {number} easeCoefficient    an easing coefficent
     *                                    {boolean} willDraw          If true the caller will redraw after the callback completes
     *                                    {boolean} done              If true then animation is ending after the current frame
     * @return {void}
     */
  }, {
    key: "setRange",
    value: function(s, a, o, l, u) {
      o || (o = {}), o.byUser !== !0 && (o.byUser = !1);
      var c = this, d = s != null ? G.convert(s, "Date").valueOf() : null, h = a != null ? G.convert(a, "Date").valueOf() : null;
      if (this._cancelAnimation(), this.millisecondsPerPixelCache = void 0, o.animation) {
        var f = this.start, p = this.end, m = mt(o.animation) === "object" && "duration" in o.animation ? o.animation.duration : 500, b = mt(o.animation) === "object" && "easingFunction" in o.animation ? o.animation.easingFunction : "easeInOutQuad", y = G.easingFunctions[b];
        if (!y) {
          var _;
          throw new Error(Dr(_ = "Unknown easing function ".concat(Vi(b), ". Choose from: ")).call(_, xn(G.easingFunctions).join(", ")));
        }
        var x = Bi(), T = !1, k = function R() {
          if (!c.props.touch.dragging) {
            var $ = Bi(), O = $ - x, P = y(O / m), N = O > m, I = N || d === null ? d : f + (d - f) * P, B = N || h === null ? h : p + (h - p) * P;
            E = c._applyRange(I, B), qy(c.options.moment, c.body, c.options.hiddenDates), T = T || E;
            var W = {
              start: new Date(c.start),
              end: new Date(c.end),
              byUser: o.byUser,
              event: o.event
            };
            if (u && u(P, E, N), E && c.body.emitter.emit("rangechange", W), N) {
              if (T && (c.body.emitter.emit("rangechanged", W), l))
                return l();
            } else
              c.animationTimer = ai(R, 20);
          }
        };
        return k();
      } else {
        var E = this._applyRange(d, h);
        if (qy(this.options.moment, this.body, this.options.hiddenDates), E) {
          var F = {
            start: new Date(this.start),
            end: new Date(this.end),
            byUser: o.byUser,
            event: o.event
          };
          if (this.body.emitter.emit("rangechange", F), clearTimeout(c.timeoutID), c.timeoutID = ai(function() {
            c.body.emitter.emit("rangechanged", F);
          }, 200), l)
            return l();
        }
      }
    }
    /**
     * Get the number of milliseconds per pixel.
     *
     * @returns {undefined|number}
     */
  }, {
    key: "getMillisecondsPerPixel",
    value: function() {
      return this.millisecondsPerPixelCache === void 0 && (this.millisecondsPerPixelCache = (this.end - this.start) / this.body.dom.center.clientWidth), this.millisecondsPerPixelCache;
    }
    /**
     * Stop an animation
     * @private
     */
  }, {
    key: "_cancelAnimation",
    value: function() {
      this.animationTimer && (clearTimeout(this.animationTimer), this.animationTimer = null);
    }
    /**
     * Set a new start and end range. This method is the same as setRange, but
     * does not trigger a range change and range changed event, and it returns
     * true when the range is changed
     * @param {number} [start]
     * @param {number} [end]
     * @return {boolean} changed
     * @private
     */
  }, {
    key: "_applyRange",
    value: function(s, a) {
      var o = s != null ? G.convert(s, "Date").valueOf() : this.start, l = a != null ? G.convert(a, "Date").valueOf() : this.end, u = this.options.max != null ? G.convert(this.options.max, "Date").valueOf() : null, c = this.options.min != null ? G.convert(this.options.min, "Date").valueOf() : null, d;
      if (isNaN(o) || o === null)
        throw new Error('Invalid start "'.concat(s, '"'));
      if (isNaN(l) || l === null)
        throw new Error('Invalid end "'.concat(a, '"'));
      if (l < o && (l = o), c !== null && o < c && (d = c - o, o += d, l += d, u != null && l > u && (l = u)), u !== null && l > u && (d = l - u, o -= d, l -= d, c != null && o < c && (o = c)), this.options.zoomMin !== null) {
        var h = zy(this.options.zoomMin);
        if (h < 0 && (h = 0), l - o < h) {
          var f = 0.5;
          this.end - this.start === h && o >= this.start - f && l <= this.end ? (o = this.start, l = this.end) : (d = h - (l - o), o -= d / 2, l += d / 2);
        }
      }
      if (this.options.zoomMax !== null) {
        var p = zy(this.options.zoomMax);
        p < 0 && (p = 0), l - o > p && (this.end - this.start === p && o < this.start && l > this.end ? (o = this.start, l = this.end) : (d = l - o - p, o += d / 2, l -= d / 2));
      }
      var m = this.start != o || this.end != l;
      return !(o >= this.start && o <= this.end || l >= this.start && l <= this.end) && !(this.start >= o && this.start <= l || this.end >= o && this.end <= l) && this.body.emitter.emit("checkRangedItems"), this.start = o, this.end = l, m;
    }
    /**
     * Retrieve the current range.
     * @return {Object} An object with start and end properties
     */
  }, {
    key: "getRange",
    value: function() {
      return {
        start: this.start,
        end: this.end
      };
    }
    /**
     * Calculate the conversion offset and scale for current range, based on
     * the provided width
     * @param {number} width
     * @param {number} [totalHidden=0]
     * @returns {{offset: number, scale: number}} conversion
     */
  }, {
    key: "conversion",
    value: function(s, a) {
      return r.conversion(this.start, this.end, s, a);
    }
    /**
     * Static method to calculate the conversion offset and scale for a range,
     * based on the provided start, end, and width
     * @param {number} start
     * @param {number} end
     * @param {number} width
     * @param {number} [totalHidden=0]
     * @returns {{offset: number, scale: number}} conversion
     */
  }, {
    key: "_onDragStart",
    value: (
      /**
       * Start dragging horizontally or vertically
       * @param {Event} event
       * @private
       */
      function(s) {
        this.deltaDifference = 0, this.previousDelta = 0, this.options.moveable && this._isInsideRange(s) && this.props.touch.allowDragging && (this.stopRolling(), this.props.touch.start = this.start, this.props.touch.end = this.end, this.props.touch.dragging = !0, this.body.dom.root && (this.body.dom.root.style.cursor = "move"));
      }
    )
    /**
     * Perform dragging operation
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onDrag",
    value: function(s) {
      if (s && this.props.touch.dragging && this.options.moveable && this.props.touch.allowDragging) {
        var a = this.options.direction;
        k2(a);
        var o = a == "horizontal" ? s.deltaX : s.deltaY;
        o -= this.deltaDifference;
        var l = this.props.touch.end - this.props.touch.start, u = Ff(this.body.hiddenDates, this.start, this.end);
        l -= u;
        var c = a == "horizontal" ? this.body.domProps.center.width : this.body.domProps.center.height, d;
        this.options.rtl ? d = o / c * l : d = -o / c * l;
        var h = this.props.touch.start + d, f = this.props.touch.end + d, p = ru(this.body.hiddenDates, h, this.previousDelta - o, !0), m = ru(this.body.hiddenDates, f, this.previousDelta - o, !0);
        if (p != h || m != f) {
          this.deltaDifference += o, this.props.touch.start = p, this.props.touch.end = m, this._onDrag(s);
          return;
        }
        this.previousDelta = o, this._applyRange(h, f);
        var b = new Date(this.start), y = new Date(this.end);
        this.body.emitter.emit("rangechange", {
          start: b,
          end: y,
          byUser: !0,
          event: s
        }), this.body.emitter.emit("panmove");
      }
    }
    /**
     * Stop dragging operation
     * @param {event} event
     * @private
     */
  }, {
    key: "_onDragEnd",
    value: function(s) {
      this.props.touch.dragging && this.options.moveable && this.props.touch.allowDragging && (this.props.touch.dragging = !1, this.body.dom.root && (this.body.dom.root.style.cursor = "auto"), this.body.emitter.emit("rangechanged", {
        start: new Date(this.start),
        end: new Date(this.end),
        byUser: !0,
        event: s
      }));
    }
    /**
     * Event handler for mouse wheel event, used to zoom
     * Code from http://adomas.org/javascript-mouse-wheel/
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onMouseWheel",
    value: function(s) {
      var a = 0;
      if (s.wheelDelta ? a = s.wheelDelta / 120 : s.detail ? a = -s.detail / 3 : s.deltaY && (a = -s.deltaY / 3), !(this.options.zoomKey && !s[this.options.zoomKey] && this.options.zoomable || !this.options.zoomable && this.options.moveable) && this.options.zoomable && this.options.moveable && this._isInsideRange(s) && a) {
        var o = this.options.zoomFriction || 5, l;
        a < 0 ? l = 1 - a / o : l = 1 / (1 + a / o);
        var u;
        if (this.rolling) {
          var c = this.options.rollingMode && this.options.rollingMode.offset || 0.5;
          u = this.start + (this.end - this.start) * c;
        } else {
          var d = this.getPointer({
            x: s.clientX,
            y: s.clientY
          }, this.body.dom.center);
          u = this._pointerToDate(d);
        }
        this.zoom(l, u, a, s), s.preventDefault();
      }
    }
    /**
     * Start of a touch gesture
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onTouch",
    value: function(s) {
      this.props.touch.start = this.start, this.props.touch.end = this.end, this.props.touch.allowDragging = !0, this.props.touch.center = null, this.props.touch.centerDate = null, this.scaleOffset = 0, this.deltaDifference = 0, G.preventDefault(s);
    }
    /**
     * Handle pinch event
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onPinch",
    value: function(s) {
      if (this.options.zoomable && this.options.moveable) {
        G.preventDefault(s), this.props.touch.allowDragging = !1, this.props.touch.center || (this.props.touch.center = this.getPointer(s.center, this.body.dom.center), this.props.touch.centerDate = this._pointerToDate(this.props.touch.center)), this.stopRolling();
        var a = 1 / (s.scale + this.scaleOffset), o = this.props.touch.centerDate, l = Ff(this.body.hiddenDates, this.start, this.end), u = Xy(this.options.moment, this.body.hiddenDates, this, o), c = l - u, d = o - u + (this.props.touch.start - (o - u)) * a, h = o + c + (this.props.touch.end - (o + c)) * a;
        this.startToFront = 1 - a <= 0, this.endToFront = a - 1 <= 0;
        var f = ru(this.body.hiddenDates, d, 1 - a, !0), p = ru(this.body.hiddenDates, h, a - 1, !0);
        (f != d || p != h) && (this.props.touch.start = f, this.props.touch.end = p, this.scaleOffset = 1 - s.scale, d = f, h = p);
        var m = {
          animation: !1,
          byUser: !0,
          event: s
        };
        this.setRange(d, h, m), this.startToFront = !1, this.endToFront = !0;
      }
    }
    /**
     * Test whether the mouse from a mouse event is inside the visible window,
     * between the current start and end date
     * @param {Object} event
     * @return {boolean} Returns true when inside the visible window
     * @private
     */
  }, {
    key: "_isInsideRange",
    value: function(s) {
      var a = s.center ? s.center.x : s.clientX, o = this.body.dom.centerContainer.getBoundingClientRect(), l = this.options.rtl ? a - o.left : o.right - a, u = this.body.util.toTime(l);
      return u >= this.start && u <= this.end;
    }
    /**
     * Helper function to calculate the center date for zooming
     * @param {{x: number, y: number}} pointer
     * @return {number} date
     * @private
     */
  }, {
    key: "_pointerToDate",
    value: function(s) {
      var a, o = this.options.direction;
      if (k2(o), o == "horizontal")
        return this.body.util.toTime(s.x).valueOf();
      var l = this.body.domProps.center.height;
      return a = this.conversion(l), s.y / a.scale + a.offset;
    }
    /**
     * Get the pointer location relative to the location of the dom element
     * @param {{x: number, y: number}} touch
     * @param {Element} element   HTML DOM element
     * @return {{x: number, y: number}} pointer
     * @private
     */
  }, {
    key: "getPointer",
    value: function(s, a) {
      var o = a.getBoundingClientRect();
      return this.options.rtl ? {
        x: o.right - s.x,
        y: s.y - o.top
      } : {
        x: s.x - o.left,
        y: s.y - o.top
      };
    }
    /**
     * Zoom the range the given scale in or out. Start and end date will
     * be adjusted, and the timeline will be redrawn. You can optionally give a
     * date around which to zoom.
     * For example, try scale = 0.9 or 1.1
     * @param {number} scale      Scaling factor. Values above 1 will zoom out,
     *                            values below 1 will zoom in.
     * @param {number} [center]   Value representing a date around which will
     *                            be zoomed.
     * @param {number} delta
     * @param {Event} event
     */
  }, {
    key: "zoom",
    value: function(s, a, o, l) {
      a == null && (a = (this.start + this.end) / 2);
      var u = Ff(this.body.hiddenDates, this.start, this.end), c = Xy(this.options.moment, this.body.hiddenDates, this, a), d = u - c, h = a - c + (this.start - (a - c)) * s, f = a + d + (this.end - (a + d)) * s;
      this.startToFront = !(o > 0), this.endToFront = !(-o > 0);
      var p = ru(this.body.hiddenDates, h, o, !0), m = ru(this.body.hiddenDates, f, -o, !0);
      (p != h || m != f) && (h = p, f = m);
      var b = {
        animation: !1,
        byUser: !0,
        event: l
      };
      this.setRange(h, f, b), this.startToFront = !1, this.endToFront = !0;
    }
    /**
     * Move the range with a given delta to the left or right. Start and end
     * value will be adjusted. For example, try delta = 0.1 or -0.1
     * @param {number}  delta     Moving amount. Positive value will move right,
     *                            negative value will move left
     */
  }, {
    key: "move",
    value: function(s) {
      var a = this.end - this.start, o = this.start + a * s, l = this.end + a * s;
      this.start = o, this.end = l;
    }
    /**
     * Move the range to a new center point
     * @param {number} moveTo      New center point of the range
     */
  }, {
    key: "moveTo",
    value: function(s) {
      var a = (this.start + this.end) / 2, o = a - s, l = this.start - o, u = this.end - o, c = {
        animation: !1,
        byUser: !0,
        event: null
      };
      this.setRange(l, u, c);
    }
  }], [{
    key: "conversion",
    value: function(s, a, o, l) {
      return l === void 0 && (l = 0), o != 0 && a - s != 0 ? {
        offset: s,
        scale: o / (a - s - l)
      } : {
        offset: 0,
        scale: 1
      };
    }
  }]), r;
}(Fl);
function k2(t) {
  if (t != "horizontal" && t != "vertical")
    throw new TypeError('Unknown direction "'.concat(t, '". Choose "horizontal" or "vertical".'));
}
var K$ = {}, Bje = {
  get exports() {
    return K$;
  },
  set exports(t) {
    K$ = t;
  }
}, Uje = lt, Vje = Uo.some, Yje = Ch, Hje = Yje("some");
Uje({ target: "Array", proto: !0, forced: !Hje }, {
  some: function(e) {
    return Vje(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var Gje = sn, Wje = Gje("Array").some, jje = Fr, Kje = Wje, iT = Array.prototype, zje = function(t) {
  var e = t.some;
  return t === iT || jje(iT, t) && e === iT.some ? Kje : e;
}, qje = zje, Xje = qje;
(function(t) {
  t.exports = Xje;
})(Bje);
var wW = /* @__PURE__ */ rt(K$), z$ = {}, Qje = {
  get exports() {
    return z$;
  },
  set exports(t) {
    z$ = t;
  }
}, Zje = mr, Jje = Zje.setInterval;
(function(t) {
  t.exports = Jje;
})(Qje);
var e8e = /* @__PURE__ */ rt(z$), fg = null;
function q$(t, e) {
  var r = e || {
    preventDefault: !1
  };
  if (t.Manager) {
    var n = t, s = function(c, d) {
      var h = Object.create(r);
      return d && n.assign(h, d), q$(new n(c, h), h);
    };
    return n.assign(s, n), s.Manager = function(c, d) {
      var h = Object.create(r);
      return d && n.assign(h, d), q$(new n.Manager(c, h), h);
    }, s;
  }
  var a = Object.create(t), o = t.element;
  o.hammer || (o.hammer = []), o.hammer.push(a), t.on("hammer.input", function(c) {
    (r.preventDefault === !0 || r.preventDefault === c.pointerType) && c.preventDefault(), c.isFirst && (fg = c.target);
  }), a._handlers = {}, a.on = function(c, d) {
    return l(c).forEach(function(h) {
      var f = a._handlers[h];
      f || (a._handlers[h] = f = [], t.on(h, u)), f.push(d);
    }), a;
  }, a.off = function(c, d) {
    return l(c).forEach(function(h) {
      var f = a._handlers[h];
      f && (f = d ? f.filter(function(p) {
        return p !== d;
      }) : [], f.length > 0 ? a._handlers[h] = f : (t.off(h, u), delete a._handlers[h]));
    }), a;
  }, a.emit = function(c, d) {
    fg = d.target, t.emit(c, d);
  }, a.destroy = function() {
    var c = t.element.hammer, d = c.indexOf(a);
    d !== -1 && c.splice(d, 1), c.length || delete t.element.hammer, a._handlers = {}, t.destroy();
  };
  function l(c) {
    return c.match(/[^ ]+/g);
  }
  function u(c) {
    if (c.type !== "hammer.input") {
      if (c.srcEvent._handled || (c.srcEvent._handled = {}), c.srcEvent._handled[c.type])
        return;
      c.srcEvent._handled[c.type] = !0;
    }
    var d = !1;
    c.stopPropagation = function() {
      d = !0;
    };
    var h = c.srcEvent.stopPropagation.bind(c.srcEvent);
    typeof h == "function" && (c.srcEvent.stopPropagation = function() {
      h(), c.stopPropagation();
    }), c.firstTarget = fg;
    for (var f = fg; f && !d; ) {
      var p = f.hammer;
      if (p) {
        for (var m, b = 0; b < p.length; b++)
          if (m = p[b]._handlers[c.type], m)
            for (var y = 0; y < m.length && !d; y++)
              m[y](c);
      }
      f = f.parentNode;
    }
  }
  return a;
}
function t8e() {
  var t = function() {
  };
  return {
    on: t,
    off: t,
    destroy: t,
    emit: t,
    get: function(r) {
      return {
        set: t
      };
    }
  };
}
var X$;
if (typeof window < "u") {
  var r8e = window.Hammer || K5;
  X$ = q$(r8e, {
    preventDefault: "mouse"
  });
} else
  X$ = function() {
    return (
      // hammer.js is only available in a browser, not in node.js. Replacing it with a mock object.
      t8e()
    );
  };
var ei = X$;
function TW(t, e) {
  e.inputHandler = function(r) {
    r.isFirst && e(r);
  }, t.on("hammer.input", e.inputHandler);
}
function n8e(t, e) {
  return e.inputHandler = function(r) {
    r.isFinal && e(r);
  }, t.on("hammer.input", e.inputHandler);
}
function i8e(t) {
  var e = "pan-y";
  return t.getTouchAction = function() {
    return [e];
  }, t;
}
var Zy = /* @__PURE__ */ function() {
  function t(e, r, n, s, a) {
    dr(this, t), this.moment = a && a.moment || Ti, this.options = a || {}, this.current = this.moment(), this._start = this.moment(), this._end = this.moment(), this.autoScale = !0, this.scale = "day", this.step = 1, this.setRange(e, r, n), this.switchedDay = !1, this.switchedMonth = !1, this.switchedYear = !1, $t(s) ? this.hiddenDates = s : s != null ? this.hiddenDates = [s] : this.hiddenDates = [], this.format = t.FORMAT;
  }
  return hr(t, [{
    key: "setMoment",
    value: function(r) {
      this.moment = r, this.current = this.moment(this.current.valueOf()), this._start = this.moment(this._start.valueOf()), this._end = this.moment(this._end.valueOf());
    }
    /**
     * Set custom formatting for the minor an major labels of the TimeStep.
     * Both `minorLabels` and `majorLabels` are an Object with properties:
     * 'millisecond', 'second', 'minute', 'hour', 'weekday', 'day', 'week', 'month', 'year'.
     * @param {{minorLabels: Object, majorLabels: Object}} format
     */
  }, {
    key: "setFormat",
    value: function(r) {
      var n = G.deepExtend({}, t.FORMAT);
      this.format = G.deepExtend(n, r);
    }
    /**
     * Set a new range
     * If minimumStep is provided, the step size is chosen as close as possible
     * to the minimumStep but larger than minimumStep. If minimumStep is not
     * provided, the scale is set to 1 DAY.
     * The minimumStep should correspond with the onscreen size of about 6 characters
     * @param {Date} [start]      The start date and time.
     * @param {Date} [end]        The end date and time.
     * @param {int} [minimumStep] Optional. Minimum step size in milliseconds
     */
  }, {
    key: "setRange",
    value: function(r, n, s) {
      if (!(r instanceof Date) || !(n instanceof Date))
        throw "No legal start or end date in method setRange";
      this._start = r != null ? this.moment(r.valueOf()) : Bi(), this._end = n != null ? this.moment(n.valueOf()) : Bi(), this.autoScale && this.setMinimumStep(s);
    }
    /**
     * Set the range iterator to the start date.
     */
  }, {
    key: "start",
    value: function() {
      this.current = this._start.clone(), this.roundToMinor();
    }
    /**
     * Round the current date to the first minor date value
     * This must be executed once when the current date is set to start Date
     */
  }, {
    key: "roundToMinor",
    value: function() {
      switch (this.scale == "week" && this.current.weekday(0), this.scale) {
        case "year":
          this.current.year(this.step * Math.floor(this.current.year() / this.step)), this.current.month(0);
        case "month":
          this.current.date(1);
        case "week":
        case "day":
        case "weekday":
          this.current.hours(0);
        case "hour":
          this.current.minutes(0);
        case "minute":
          this.current.seconds(0);
        case "second":
          this.current.milliseconds(0);
      }
      if (this.step != 1) {
        var r = this.current.clone();
        switch (this.scale) {
          case "millisecond":
            this.current.subtract(this.current.milliseconds() % this.step, "milliseconds");
            break;
          case "second":
            this.current.subtract(this.current.seconds() % this.step, "seconds");
            break;
          case "minute":
            this.current.subtract(this.current.minutes() % this.step, "minutes");
            break;
          case "hour":
            this.current.subtract(this.current.hours() % this.step, "hours");
            break;
          case "weekday":
          case "day":
            this.current.subtract((this.current.date() - 1) % this.step, "day");
            break;
          case "week":
            this.current.subtract(this.current.week() % this.step, "week");
            break;
          case "month":
            this.current.subtract(this.current.month() % this.step, "month");
            break;
          case "year":
            this.current.subtract(this.current.year() % this.step, "year");
            break;
        }
        r.isSame(this.current) || (this.current = this.moment(ru(this.hiddenDates, this.current.valueOf(), -1, !0)));
      }
    }
    /**
     * Check if the there is a next step
     * @return {boolean}  true if the current date has not passed the end date
     */
  }, {
    key: "hasNext",
    value: function() {
      return this.current.valueOf() <= this._end.valueOf();
    }
    /**
     * Do the next step
     */
  }, {
    key: "next",
    value: function() {
      var r = this.current.valueOf();
      switch (this.scale) {
        case "millisecond":
          this.current.add(this.step, "millisecond");
          break;
        case "second":
          this.current.add(this.step, "second");
          break;
        case "minute":
          this.current.add(this.step, "minute");
          break;
        case "hour":
          this.current.add(this.step, "hour"), this.current.month() < 6 ? this.current.subtract(this.current.hours() % this.step, "hour") : this.current.hours() % this.step !== 0 && this.current.add(this.step - this.current.hours() % this.step, "hour");
          break;
        case "weekday":
        case "day":
          this.current.add(this.step, "day");
          break;
        case "week":
          if (this.current.weekday() !== 0)
            this.current.weekday(0), this.current.add(this.step, "week");
          else if (this.options.showMajorLabels === !1)
            this.current.add(this.step, "week");
          else {
            var n = this.current.clone();
            n.add(1, "week"), n.isSame(this.current, "month") ? this.current.add(this.step, "week") : (this.current.add(this.step, "week"), this.current.date(1));
          }
          break;
        case "month":
          this.current.add(this.step, "month");
          break;
        case "year":
          this.current.add(this.step, "year");
          break;
      }
      if (this.step != 1)
        switch (this.scale) {
          case "millisecond":
            this.current.milliseconds() > 0 && this.current.milliseconds() < this.step && this.current.milliseconds(0);
            break;
          case "second":
            this.current.seconds() > 0 && this.current.seconds() < this.step && this.current.seconds(0);
            break;
          case "minute":
            this.current.minutes() > 0 && this.current.minutes() < this.step && this.current.minutes(0);
            break;
          case "hour":
            this.current.hours() > 0 && this.current.hours() < this.step && this.current.hours(0);
            break;
          case "weekday":
          case "day":
            this.current.date() < this.step + 1 && this.current.date(1);
            break;
          case "week":
            this.current.week() < this.step && this.current.week(1);
            break;
          case "month":
            this.current.month() < this.step && this.current.month(0);
            break;
        }
      this.current.valueOf() == r && (this.current = this._end.clone()), this.switchedDay = !1, this.switchedMonth = !1, this.switchedYear = !1, Rje(this.moment, this, r);
    }
    /**
     * Get the current datetime
     * @return {Moment}  current The current date
     */
  }, {
    key: "getCurrent",
    value: function() {
      return this.current.clone();
    }
    /**
     * Set a custom scale. Autoscaling will be disabled.
     * For example setScale('minute', 5) will result
     * in minor steps of 5 minutes, and major steps of an hour.
     *
     * @param {{scale: string, step: number}} params
     *                               An object containing two properties:
     *                               - A string 'scale'. Choose from 'millisecond', 'second',
     *                                 'minute', 'hour', 'weekday', 'day', 'week', 'month', 'year'.
     *                               - A number 'step'. A step size, by default 1.
     *                                 Choose for example 1, 2, 5, or 10.
     */
  }, {
    key: "setScale",
    value: function(r) {
      r && typeof r.scale == "string" && (this.scale = r.scale, this.step = r.step > 0 ? r.step : 1, this.autoScale = !1);
    }
    /**
     * Enable or disable autoscaling
     * @param {boolean} enable  If true, autoascaling is set true
     */
  }, {
    key: "setAutoScale",
    value: function(r) {
      this.autoScale = r;
    }
    /**
     * Automatically determine the scale that bests fits the provided minimum step
     * @param {number} [minimumStep]  The minimum step size in milliseconds
     */
  }, {
    key: "setMinimumStep",
    value: function(r) {
      if (r != null) {
        var n = 1e3 * 60 * 60 * 24 * 30 * 12, s = 1e3 * 60 * 60 * 24 * 30, a = 1e3 * 60 * 60 * 24, o = 1e3 * 60 * 60, l = 1e3 * 60, u = 1e3, c = 1;
        n * 1e3 > r && (this.scale = "year", this.step = 1e3), n * 500 > r && (this.scale = "year", this.step = 500), n * 100 > r && (this.scale = "year", this.step = 100), n * 50 > r && (this.scale = "year", this.step = 50), n * 10 > r && (this.scale = "year", this.step = 10), n * 5 > r && (this.scale = "year", this.step = 5), n > r && (this.scale = "year", this.step = 1), s * 3 > r && (this.scale = "month", this.step = 3), s > r && (this.scale = "month", this.step = 1), a * 7 > r && this.options.showWeekScale && (this.scale = "week", this.step = 1), a * 2 > r && (this.scale = "day", this.step = 2), a > r && (this.scale = "day", this.step = 1), a / 2 > r && (this.scale = "weekday", this.step = 1), o * 4 > r && (this.scale = "hour", this.step = 4), o > r && (this.scale = "hour", this.step = 1), l * 15 > r && (this.scale = "minute", this.step = 15), l * 10 > r && (this.scale = "minute", this.step = 10), l * 5 > r && (this.scale = "minute", this.step = 5), l > r && (this.scale = "minute", this.step = 1), u * 15 > r && (this.scale = "second", this.step = 15), u * 10 > r && (this.scale = "second", this.step = 10), u * 5 > r && (this.scale = "second", this.step = 5), u > r && (this.scale = "second", this.step = 1), c * 200 > r && (this.scale = "millisecond", this.step = 200), c * 100 > r && (this.scale = "millisecond", this.step = 100), c * 50 > r && (this.scale = "millisecond", this.step = 50), c * 10 > r && (this.scale = "millisecond", this.step = 10), c * 5 > r && (this.scale = "millisecond", this.step = 5), c > r && (this.scale = "millisecond", this.step = 1);
      }
    }
    /**
     * Snap a date to a rounded value.
     * The snap intervals are dependent on the current scale and step.
     * Static function
     * @param {Date} date    the date to be snapped.
     * @param {string} scale Current scale, can be 'millisecond', 'second',
     *                       'minute', 'hour', 'weekday, 'day', 'week', 'month', 'year'.
     * @param {number} step  Current step (1, 2, 4, 5, ...
     * @return {Date} snappedDate
     */
  }, {
    key: "isMajor",
    value: (
      /**
       * Check if the current value is a major value (for example when the step
       * is DAY, a major value is each first day of the MONTH)
       * @return {boolean} true if current date is major, else false.
       */
      function() {
        if (this.switchedYear == !0)
          switch (this.scale) {
            case "year":
            case "month":
            case "week":
            case "weekday":
            case "day":
            case "hour":
            case "minute":
            case "second":
            case "millisecond":
              return !0;
            default:
              return !1;
          }
        else if (this.switchedMonth == !0)
          switch (this.scale) {
            case "week":
            case "weekday":
            case "day":
            case "hour":
            case "minute":
            case "second":
            case "millisecond":
              return !0;
            default:
              return !1;
          }
        else if (this.switchedDay == !0)
          switch (this.scale) {
            case "millisecond":
            case "second":
            case "minute":
            case "hour":
              return !0;
            default:
              return !1;
          }
        var r = this.moment(this.current);
        switch (this.scale) {
          case "millisecond":
            return r.milliseconds() == 0;
          case "second":
            return r.seconds() == 0;
          case "minute":
            return r.hours() == 0 && r.minutes() == 0;
          case "hour":
            return r.hours() == 0;
          case "weekday":
          case "day":
            return this.options.showWeekScale ? r.isoWeekday() == 1 : r.date() == 1;
          case "week":
            return r.date() == 1;
          case "month":
            return r.month() == 0;
          case "year":
            return !1;
          default:
            return !1;
        }
      }
    )
    /**
     * Returns formatted text for the minor axislabel, depending on the current
     * date and the scale. For example when scale is MINUTE, the current time is
     * formatted as "hh:mm".
     * @param {Date} [date=this.current] custom date. if not provided, current date is taken
     * @returns {String}
     */
  }, {
    key: "getLabelMinor",
    value: function(r) {
      if (r == null && (r = this.current), r instanceof Date && (r = this.moment(r)), typeof this.format.minorLabels == "function")
        return this.format.minorLabels(r, this.scale, this.step);
      var n = this.format.minorLabels[this.scale];
      switch (this.scale) {
        case "week":
          if (r.date() === 1 && r.weekday() !== 0)
            return "";
        default:
          return n && n.length > 0 ? this.moment(r).format(n) : "";
      }
    }
    /**
     * Returns formatted text for the major axis label, depending on the current
     * date and the scale. For example when scale is MINUTE, the major scale is
     * hours, and the hour will be formatted as "hh".
     * @param {Date} [date=this.current] custom date. if not provided, current date is taken
     * @returns {String}
     */
  }, {
    key: "getLabelMajor",
    value: function(r) {
      if (r == null && (r = this.current), r instanceof Date && (r = this.moment(r)), typeof this.format.majorLabels == "function")
        return this.format.majorLabels(r, this.scale, this.step);
      var n = this.format.majorLabels[this.scale];
      return n && n.length > 0 ? this.moment(r).format(n) : "";
    }
    /**
     * get class name
     * @return {string} class name
     */
  }, {
    key: "getClassName",
    value: function() {
      var r, n = this.moment, s = this.moment(this.current), a = s.locale ? s.locale("en") : s.lang("en"), o = this.step, l = [];
      function u(p) {
        return p / o % 2 == 0 ? " vis-even" : " vis-odd";
      }
      function c(p) {
        return p.isSame(Bi(), "day") ? " vis-today" : p.isSame(n().add(1, "day"), "day") ? " vis-tomorrow" : p.isSame(n().add(-1, "day"), "day") ? " vis-yesterday" : "";
      }
      function d(p) {
        return p.isSame(Bi(), "week") ? " vis-current-week" : "";
      }
      function h(p) {
        return p.isSame(Bi(), "month") ? " vis-current-month" : "";
      }
      function f(p) {
        return p.isSame(Bi(), "year") ? " vis-current-year" : "";
      }
      switch (this.scale) {
        case "millisecond":
          l.push(c(a)), l.push(u(a.milliseconds()));
          break;
        case "second":
          l.push(c(a)), l.push(u(a.seconds()));
          break;
        case "minute":
          l.push(c(a)), l.push(u(a.minutes()));
          break;
        case "hour":
          l.push(Dr(r = "vis-h".concat(a.hours())).call(r, this.step == 4 ? "-h" + (a.hours() + 4) : "")), l.push(c(a)), l.push(u(a.hours()));
          break;
        case "weekday":
          l.push("vis-".concat(a.format("dddd").toLowerCase())), l.push(c(a)), l.push(d(a)), l.push(u(a.date()));
          break;
        case "day":
          l.push("vis-day".concat(a.date())), l.push("vis-".concat(a.format("MMMM").toLowerCase())), l.push(c(a)), l.push(h(a)), l.push(this.step <= 2 ? c(a) : ""), l.push(this.step <= 2 ? "vis-".concat(a.format("dddd").toLowerCase()) : ""), l.push(u(a.date() - 1));
          break;
        case "week":
          l.push("vis-week".concat(a.format("w"))), l.push(d(a)), l.push(u(a.week()));
          break;
        case "month":
          l.push("vis-".concat(a.format("MMMM").toLowerCase())), l.push(h(a)), l.push(u(a.month()));
          break;
        case "year":
          l.push("vis-year".concat(a.year())), l.push(f(a)), l.push(u(a.year()));
          break;
      }
      return At(l).call(l, String).join(" ");
    }
  }], [{
    key: "snap",
    value: function(r, n, s) {
      var a = Ti(r);
      if (n == "year") {
        var o = a.year() + Math.round(a.month() / 12);
        a.year(Math.round(o / s) * s), a.month(0), a.date(0), a.hours(0), a.minutes(0), a.seconds(0), a.milliseconds(0);
      } else if (n == "month")
        a.date() > 15 ? (a.date(1), a.add(1, "month")) : a.date(1), a.hours(0), a.minutes(0), a.seconds(0), a.milliseconds(0);
      else if (n == "week")
        a.weekday() > 2 ? (a.weekday(0), a.add(1, "week")) : a.weekday(0), a.hours(0), a.minutes(0), a.seconds(0), a.milliseconds(0);
      else if (n == "day") {
        switch (s) {
          case 5:
          case 2:
            a.hours(Math.round(a.hours() / 24) * 24);
            break;
          default:
            a.hours(Math.round(a.hours() / 12) * 12);
            break;
        }
        a.minutes(0), a.seconds(0), a.milliseconds(0);
      } else if (n == "weekday") {
        switch (s) {
          case 5:
          case 2:
            a.hours(Math.round(a.hours() / 12) * 12);
            break;
          default:
            a.hours(Math.round(a.hours() / 6) * 6);
            break;
        }
        a.minutes(0), a.seconds(0), a.milliseconds(0);
      } else if (n == "hour") {
        switch (s) {
          case 4:
            a.minutes(Math.round(a.minutes() / 60) * 60);
            break;
          default:
            a.minutes(Math.round(a.minutes() / 30) * 30);
            break;
        }
        a.seconds(0), a.milliseconds(0);
      } else if (n == "minute") {
        switch (s) {
          case 15:
          case 10:
            a.minutes(Math.round(a.minutes() / 5) * 5), a.seconds(0);
            break;
          case 5:
            a.seconds(Math.round(a.seconds() / 60) * 60);
            break;
          default:
            a.seconds(Math.round(a.seconds() / 30) * 30);
            break;
        }
        a.milliseconds(0);
      } else if (n == "second")
        switch (s) {
          case 15:
          case 10:
            a.seconds(Math.round(a.seconds() / 5) * 5), a.milliseconds(0);
            break;
          case 5:
            a.milliseconds(Math.round(a.milliseconds() / 1e3) * 1e3);
            break;
          default:
            a.milliseconds(Math.round(a.milliseconds() / 500) * 500);
            break;
        }
      else if (n == "millisecond") {
        var l = s > 5 ? s / 2 : 1;
        a.milliseconds(Math.round(a.milliseconds() / l) * l);
      }
      return a;
    }
  }]), t;
}();
Zy.FORMAT = {
  minorLabels: {
    millisecond: "SSS",
    second: "s",
    minute: "HH:mm",
    hour: "HH:mm",
    weekday: "ddd D",
    day: "D",
    week: "w",
    month: "MMM",
    year: "YYYY"
  },
  majorLabels: {
    millisecond: "HH:mm:ss",
    second: "D MMMM HH:mm",
    minute: "ddd D MMMM",
    hour: "ddd D MMMM",
    weekday: "MMMM YYYY",
    day: "MMMM YYYY",
    week: "MMMM YYYY",
    month: "YYYY",
    year: ""
  }
};
function s8e(t) {
  var e = a8e();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function a8e() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var Jy = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = s8e(r);
  function r(n, s) {
    var a;
    return dr(this, r), a = e.call(this), a.dom = {
      foreground: null,
      lines: [],
      majorTexts: [],
      minorTexts: [],
      redundant: {
        lines: [],
        majorTexts: [],
        minorTexts: []
      }
    }, a.props = {
      range: {
        start: 0,
        end: 0,
        minimumStep: 0
      },
      lineTop: 0
    }, a.defaultOptions = {
      orientation: {
        axis: "bottom"
      },
      // axis orientation: 'top' or 'bottom'
      showMinorLabels: !0,
      showMajorLabels: !0,
      showWeekScale: !1,
      maxMinorChars: 7,
      format: G.extend({}, Zy.FORMAT),
      moment: Ti,
      timeAxis: null
    }, a.options = G.extend({}, a.defaultOptions), a.body = n, a._create(), a.setOptions(s), a;
  }
  return hr(r, [{
    key: "setOptions",
    value: function(s) {
      s && (G.selectiveExtend(["showMinorLabels", "showMajorLabels", "showWeekScale", "maxMinorChars", "hiddenDates", "timeAxis", "moment", "rtl"], this.options, s), G.selectiveDeepExtend(["format"], this.options, s), "orientation" in s && (typeof s.orientation == "string" ? this.options.orientation.axis = s.orientation : mt(s.orientation) === "object" && "axis" in s.orientation && (this.options.orientation.axis = s.orientation.axis)), "locale" in s && (typeof Ti.locale == "function" ? Ti.locale(s.locale) : Ti.lang(s.locale)));
    }
    /**
     * Create the HTML DOM for the TimeAxis
     */
  }, {
    key: "_create",
    value: function() {
      this.dom.foreground = document.createElement("div"), this.dom.background = document.createElement("div"), this.dom.foreground.className = "vis-time-axis vis-foreground", this.dom.background.className = "vis-time-axis vis-background";
    }
    /**
     * Destroy the TimeAxis
     */
  }, {
    key: "destroy",
    value: function() {
      this.dom.foreground.parentNode && this.dom.foreground.parentNode.removeChild(this.dom.foreground), this.dom.background.parentNode && this.dom.background.parentNode.removeChild(this.dom.background), this.body = null;
    }
    /**
     * Repaint the component
     * @return {boolean} Returns true if the component is resized
     */
  }, {
    key: "redraw",
    value: function() {
      var s = this.props, a = this.dom.foreground, o = this.dom.background, l = this.options.orientation.axis == "top" ? this.body.dom.top : this.body.dom.bottom, u = a.parentNode !== l;
      this._calculateCharSize();
      var c = this.options.showMinorLabels && this.options.orientation.axis !== "none", d = this.options.showMajorLabels && this.options.orientation.axis !== "none";
      s.minorLabelHeight = c ? s.minorCharHeight : 0, s.majorLabelHeight = d ? s.majorCharHeight : 0, s.height = s.minorLabelHeight + s.majorLabelHeight, s.width = a.offsetWidth, s.minorLineHeight = this.body.domProps.root.height - s.majorLabelHeight - (this.options.orientation.axis == "top" ? this.body.domProps.bottom.height : this.body.domProps.top.height), s.minorLineWidth = 1, s.majorLineHeight = s.minorLineHeight + s.majorLabelHeight, s.majorLineWidth = 1;
      var h = a.nextSibling, f = o.nextSibling;
      return a.parentNode && a.parentNode.removeChild(a), o.parentNode && o.parentNode.removeChild(o), a.style.height = "".concat(this.props.height, "px"), this._repaintLabels(), h ? l.insertBefore(a, h) : l.appendChild(a), f ? this.body.dom.backgroundVertical.insertBefore(o, f) : this.body.dom.backgroundVertical.appendChild(o), this._isResized() || u;
    }
    /**
     * Repaint major and minor text labels and vertical grid lines
     * @private
     */
  }, {
    key: "_repaintLabels",
    value: function() {
      var s = this.options.orientation.axis, a = G.convert(this.body.range.start, "Number"), o = G.convert(this.body.range.end, "Number"), l = this.body.util.toTime((this.props.minorCharWidth || 10) * this.options.maxMinorChars).valueOf(), u = l - Xy(this.options.moment, this.body.hiddenDates, this.body.range, l);
      u -= this.body.util.toTime(0).valueOf();
      var c = new Zy(new Date(a), new Date(o), u, this.body.hiddenDates, this.options);
      c.setMoment(this.options.moment), this.options.format && c.setFormat(this.options.format), this.options.timeAxis && c.setScale(this.options.timeAxis), this.step = c;
      var d = this.dom;
      d.redundant.lines = d.lines, d.redundant.majorTexts = d.majorTexts, d.redundant.minorTexts = d.minorTexts, d.lines = [], d.majorTexts = [], d.minorTexts = [];
      var h, f, p, m, b, y, _ = 0, x, T, k = void 0, E = 0, F = 1e3, R;
      for (c.start(), f = c.getCurrent(), m = this.body.util.toScreen(f); c.hasNext() && E < F; ) {
        switch (E++, b = c.isMajor(), R = c.getClassName(), h = f, p = m, c.next(), f = c.getCurrent(), m = this.body.util.toScreen(f), x = _, _ = m - p, c.scale) {
          case "week":
            y = !0;
            break;
          default:
            y = _ >= x * 0.4;
            break;
        }
        if (this.options.showMinorLabels && y) {
          var $ = this._repaintMinorText(p, c.getLabelMinor(h), s, R);
          $.style.width = "".concat(_, "px");
        }
        b && this.options.showMajorLabels ? (p > 0 && (k == null && (k = p), $ = this._repaintMajorText(p, c.getLabelMajor(h), s, R)), T = this._repaintMajorLine(p, _, s, R)) : y ? T = this._repaintMinorLine(p, _, s, R) : T && (T.style.width = "".concat(Ui(T.style.width) + _, "px"));
      }
      if (E === F && !D2 && (console.warn("Something is wrong with the Timeline scale. Limited drawing of grid lines to ".concat(F, " lines.")), D2 = !0), this.options.showMajorLabels) {
        var O = this.body.util.toTime(0), P = c.getLabelMajor(O), N = P.length * (this.props.majorCharWidth || 10) + 10;
        (k == null || N < k) && this._repaintMajorText(0, P, s, R);
      }
      Le(G).call(G, this.dom.redundant, function(I) {
        for (; I.length; ) {
          var B = I.pop();
          B && B.parentNode && B.parentNode.removeChild(B);
        }
      });
    }
    /**
     * Create a minor label for the axis at position x
     * @param {number} x
     * @param {string} text
     * @param {string} orientation   "top" or "bottom" (default)
     * @param {string} className
     * @return {Element} Returns the HTML element of the created label
     * @private
     */
  }, {
    key: "_repaintMinorText",
    value: function(s, a, o, l) {
      var u = this.dom.redundant.minorTexts.shift();
      if (!u) {
        var c = document.createTextNode("");
        u = document.createElement("div"), u.appendChild(c), this.dom.foreground.appendChild(u);
      }
      this.dom.minorTexts.push(u), u.innerHTML = G.xss(a);
      var d = o == "top" ? this.props.majorLabelHeight : 0;
      return this._setXY(u, s, d), u.className = "vis-text vis-minor ".concat(l), u;
    }
    /**
     * Create a Major label for the axis at position x
     * @param {number} x
     * @param {string} text
     * @param {string} orientation   "top" or "bottom" (default)
     * @param {string} className
     * @return {Element} Returns the HTML element of the created label
     * @private
     */
  }, {
    key: "_repaintMajorText",
    value: function(s, a, o, l) {
      var u = this.dom.redundant.majorTexts.shift();
      if (!u) {
        var c = document.createElement("div");
        u = document.createElement("div"), u.appendChild(c), this.dom.foreground.appendChild(u);
      }
      u.childNodes[0].innerHTML = G.xss(a), u.className = "vis-text vis-major ".concat(l);
      var d = o == "top" ? 0 : this.props.minorLabelHeight;
      return this._setXY(u, s, d), this.dom.majorTexts.push(u), u;
    }
    /**
     * sets xy
     * @param {string} label
     * @param {number} x
     * @param {number} y
     * @private
     */
  }, {
    key: "_setXY",
    value: function(s, a, o) {
      var l, u = this.options.rtl ? a * -1 : a;
      s.style.transform = Dr(l = "translate(".concat(u, "px, ")).call(l, o, "px)");
    }
    /**
     * Create a minor line for the axis at position x
     * @param {number} left
     * @param {number} width
     * @param {string} orientation   "top" or "bottom" (default)
     * @param {string} className
     * @return {Element} Returns the created line
     * @private
     */
  }, {
    key: "_repaintMinorLine",
    value: function(s, a, o, l) {
      var u, c = this.dom.redundant.lines.shift();
      c || (c = document.createElement("div"), this.dom.background.appendChild(c)), this.dom.lines.push(c);
      var d = this.props;
      c.style.width = "".concat(a, "px"), c.style.height = "".concat(d.minorLineHeight, "px");
      var h = o == "top" ? d.majorLabelHeight : this.body.domProps.top.height, f = s - d.minorLineWidth / 2;
      return this._setXY(c, f, h), c.className = Dr(u = "vis-grid ".concat(this.options.rtl ? "vis-vertical-rtl" : "vis-vertical", " vis-minor ")).call(u, l), c;
    }
    /**
     * Create a Major line for the axis at position x
     * @param {number} left
     * @param {number} width
     * @param {string} orientation   "top" or "bottom" (default)
     * @param {string} className
     * @return {Element} Returns the created line
     * @private
     */
  }, {
    key: "_repaintMajorLine",
    value: function(s, a, o, l) {
      var u, c = this.dom.redundant.lines.shift();
      c || (c = document.createElement("div"), this.dom.background.appendChild(c)), this.dom.lines.push(c);
      var d = this.props;
      c.style.width = "".concat(a, "px"), c.style.height = "".concat(d.majorLineHeight, "px");
      var h = o == "top" ? 0 : this.body.domProps.top.height, f = s - d.majorLineWidth / 2;
      return this._setXY(c, f, h), c.className = Dr(u = "vis-grid ".concat(this.options.rtl ? "vis-vertical-rtl" : "vis-vertical", " vis-major ")).call(u, l), c;
    }
    /**
     * Determine the size of text on the axis (both major and minor axis).
     * The size is calculated only once and then cached in this.props.
     * @private
     */
  }, {
    key: "_calculateCharSize",
    value: function() {
      this.dom.measureCharMinor || (this.dom.measureCharMinor = document.createElement("DIV"), this.dom.measureCharMinor.className = "vis-text vis-minor vis-measure", this.dom.measureCharMinor.style.position = "absolute", this.dom.measureCharMinor.appendChild(document.createTextNode("0")), this.dom.foreground.appendChild(this.dom.measureCharMinor)), this.props.minorCharHeight = this.dom.measureCharMinor.clientHeight, this.props.minorCharWidth = this.dom.measureCharMinor.clientWidth, this.dom.measureCharMajor || (this.dom.measureCharMajor = document.createElement("DIV"), this.dom.measureCharMajor.className = "vis-text vis-major vis-measure", this.dom.measureCharMajor.style.position = "absolute", this.dom.measureCharMajor.appendChild(document.createTextNode("0")), this.dom.foreground.appendChild(this.dom.measureCharMajor)), this.props.majorCharHeight = this.dom.measureCharMajor.clientHeight, this.props.majorCharWidth = this.dom.measureCharMajor.clientWidth;
    }
  }]), r;
}(Fl), D2 = !1;
function o8e(t) {
  var e = t && t.preventDefault || !1, r = t && t.container || window, n = {}, s = { keydown: {}, keyup: {} }, a = {}, o;
  for (o = 97; o <= 122; o++)
    a[String.fromCharCode(o)] = { code: 65 + (o - 97), shift: !1 };
  for (o = 65; o <= 90; o++)
    a[String.fromCharCode(o)] = { code: o, shift: !0 };
  for (o = 0; o <= 9; o++)
    a["" + o] = { code: 48 + o, shift: !1 };
  for (o = 1; o <= 12; o++)
    a["F" + o] = { code: 111 + o, shift: !1 };
  for (o = 0; o <= 9; o++)
    a["num" + o] = { code: 96 + o, shift: !1 };
  a["num*"] = { code: 106, shift: !1 }, a["num+"] = { code: 107, shift: !1 }, a["num-"] = { code: 109, shift: !1 }, a["num/"] = { code: 111, shift: !1 }, a["num."] = { code: 110, shift: !1 }, a.left = { code: 37, shift: !1 }, a.up = { code: 38, shift: !1 }, a.right = { code: 39, shift: !1 }, a.down = { code: 40, shift: !1 }, a.space = { code: 32, shift: !1 }, a.enter = { code: 13, shift: !1 }, a.shift = { code: 16, shift: void 0 }, a.esc = { code: 27, shift: !1 }, a.backspace = { code: 8, shift: !1 }, a.tab = { code: 9, shift: !1 }, a.ctrl = { code: 17, shift: !1 }, a.alt = { code: 18, shift: !1 }, a.delete = { code: 46, shift: !1 }, a.pageup = { code: 33, shift: !1 }, a.pagedown = { code: 34, shift: !1 }, a["="] = { code: 187, shift: !1 }, a["-"] = { code: 189, shift: !1 }, a["]"] = { code: 221, shift: !1 }, a["["] = { code: 219, shift: !1 };
  var l = function(d) {
    c(d, "keydown");
  }, u = function(d) {
    c(d, "keyup");
  }, c = function(d, h) {
    if (s[h][d.keyCode] !== void 0) {
      for (var f = s[h][d.keyCode], p = 0; p < f.length; p++)
        (f[p].shift === void 0 || f[p].shift == !0 && d.shiftKey == !0 || f[p].shift == !1 && d.shiftKey == !1) && f[p].fn(d);
      e == !0 && d.preventDefault();
    }
  };
  return n.bind = function(d, h, f) {
    if (f === void 0 && (f = "keydown"), a[d] === void 0)
      throw new Error("unsupported key: " + d);
    s[f][a[d].code] === void 0 && (s[f][a[d].code] = []), s[f][a[d].code].push({ fn: h, shift: a[d].shift });
  }, n.bindAll = function(d, h) {
    h === void 0 && (h = "keydown");
    for (var f in a)
      a.hasOwnProperty(f) && n.bind(f, d, h);
  }, n.getKey = function(d) {
    for (var h in a)
      if (a.hasOwnProperty(h)) {
        if (d.shiftKey == !0 && a[h].shift == !0 && d.keyCode == a[h].code)
          return h;
        if (d.shiftKey == !1 && a[h].shift == !1 && d.keyCode == a[h].code)
          return h;
        if (d.keyCode == a[h].code && h == "shift")
          return h;
      }
    return "unknown key, currently not supported";
  }, n.unbind = function(d, h, f) {
    if (f === void 0 && (f = "keydown"), a[d] === void 0)
      throw new Error("unsupported key: " + d);
    if (h !== void 0) {
      var p = [], m = s[f][a[d].code];
      if (m !== void 0)
        for (var b = 0; b < m.length; b++)
          m[b].fn == h && m[b].shift == a[d].shift || p.push(s[f][a[d].code][b]);
      s[f][a[d].code] = p;
    } else
      s[f][a[d].code] = [];
  }, n.reset = function() {
    s = { keydown: {}, keyup: {} };
  }, n.destroy = function() {
    s = { keydown: {}, keyup: {} }, r.removeEventListener("keydown", l, !0), r.removeEventListener("keyup", u, !0);
  }, r.addEventListener("keydown", l, !0), r.addEventListener("keyup", u, !0), n;
}
function ls(t) {
  var e, r;
  this.active = !1, this.dom = {
    container: t
  }, this.dom.overlay = document.createElement("div"), this.dom.overlay.className = "vis-overlay", this.dom.container.appendChild(this.dom.overlay), this.hammer = ei(this.dom.overlay), this.hammer.on("tap", de(e = this._onTapOverlay).call(e, this));
  var n = this, s = ["tap", "doubletap", "press", "pinch", "pan", "panstart", "panmove", "panend"];
  Le(s).call(s, function(a) {
    n.hammer.on(a, function(o) {
      o.stopPropagation();
    });
  }), document && document.body && (this.onClick = function(a) {
    l8e(a.target, t) || n.deactivate();
  }, document.body.addEventListener("click", this.onClick)), this.keycharm !== void 0 && this.keycharm.destroy(), this.keycharm = o8e(), this.escListener = de(r = this.deactivate).call(r, this);
}
YO(ls.prototype);
ls.current = null;
ls.prototype.destroy = function() {
  this.deactivate(), this.dom.overlay.parentNode.removeChild(this.dom.overlay), this.onClick && document.body.removeEventListener("click", this.onClick), this.keycharm !== void 0 && this.keycharm.destroy(), this.keycharm = null, this.hammer.destroy(), this.hammer = null;
};
ls.prototype.activate = function() {
  var t;
  ls.current && ls.current.deactivate(), ls.current = this, this.active = !0, this.dom.overlay.style.display = "none", G.addClassName(this.dom.container, "vis-active"), this.emit("change"), this.emit("activate"), de(t = this.keycharm).call(t, "esc", this.escListener);
};
ls.prototype.deactivate = function() {
  ls.current === this && (ls.current = null), this.active = !1, this.dom.overlay.style.display = "", G.removeClassName(this.dom.container, "vis-active"), this.keycharm.unbind("esc", this.escListener), this.emit("change"), this.emit("deactivate");
};
ls.prototype._onTapOverlay = function(t) {
  this.activate(), t.stopPropagation();
};
function l8e(t, e) {
  for (; t; ) {
    if (t === e)
      return !0;
    t = t.parentNode;
  }
  return !1;
}
var lA = {
  current: "current",
  time: "time",
  deleteSelected: "Delete selected"
}, u8e = lA, c8e = lA, uA = {
  current: "attuale",
  time: "tempo",
  deleteSelected: "Cancella la selezione"
}, d8e = uA, h8e = uA, cA = {
  current: "huidige",
  time: "tijd",
  deleteSelected: "Selectie verwijderen"
}, f8e = cA, p8e = cA, xW = {
  current: "Aktuelle",
  time: "Zeit",
  deleteSelected: "Lösche Auswahl"
}, v8e = xW, Fb = {
  current: "actuel",
  time: "heure",
  deleteSelected: "Effacer la selection"
}, m8e = Fb, g8e = Fb, y8e = Fb, SW = {
  current: "corriente",
  time: "hora",
  deleteSelected: "Eliminar selección"
}, b8e = SW, EW = {
  current: "поточний",
  time: "час",
  deleteSelected: "Видалити обране"
}, _8e = EW, $W = {
  current: "текущее",
  time: "время",
  deleteSelected: "Удалить выбранное"
}, w8e = $W, kW = {
  current: "aktualny",
  time: "czas",
  deleteSelected: "Usuń wybrane"
}, T8e = kW, dA = {
  current: "atual",
  time: "data",
  deleteSelected: "Apagar selecionado"
}, x8e = dA, S8e = dA, DW = {
  current: "現在",
  time: "時刻",
  deleteSelected: "選択されたものを削除"
}, E8e = DW, OW = {
  current: "nuvarande",
  time: "tid",
  deleteSelected: "Radera valda"
}, $8e = OW, Bb = {
  current: "nåværende",
  time: "tid",
  deleteSelected: "Slett valgte"
}, k8e = Bb, D8e = Bb, O8e = Bb, AW = {
  current: "einamas",
  time: "laikas",
  deleteSelected: "Pašalinti pasirinktą"
}, A8e = AW, Xd = {
  en: lA,
  en_EN: u8e,
  en_US: c8e,
  it: uA,
  it_IT: d8e,
  it_CH: h8e,
  nl: cA,
  nl_NL: f8e,
  nl_BE: p8e,
  de: xW,
  de_DE: v8e,
  fr: Fb,
  fr_FR: m8e,
  fr_CA: g8e,
  fr_BE: y8e,
  es: SW,
  es_ES: b8e,
  uk: EW,
  uk_UA: _8e,
  ru: $W,
  ru_RU: w8e,
  pl: kW,
  pl_PL: T8e,
  pt: dA,
  pt_BR: x8e,
  pt_PT: S8e,
  ja: DW,
  ja_JP: E8e,
  lt: AW,
  lt_LT: A8e,
  sv: OW,
  sv_SE: $8e,
  nb: Bb,
  nn: D8e,
  nb_NO: k8e,
  nn_NO: O8e
};
function C8e(t) {
  var e = I8e();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function I8e() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var hA = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = C8e(r);
  function r(n, s) {
    var a, o;
    dr(this, r), o = e.call(this), o.body = n, o.defaultOptions = {
      moment: Ti,
      locales: Xd,
      locale: "en",
      id: void 0,
      title: void 0
    }, o.options = G.extend({}, o.defaultOptions), o.setOptions(s), o.options.locales = G.extend({}, Xd, o.options.locales);
    var l = o.defaultOptions.locales[o.defaultOptions.locale];
    return Le(a = xn(o.options.locales)).call(a, function(u) {
      o.options.locales[u] = G.extend({}, l, o.options.locales[u]);
    }), s && s.time != null ? o.customTime = s.time : o.customTime = /* @__PURE__ */ new Date(), o.eventParams = {}, o._create(), o;
  }
  return hr(r, [{
    key: "setOptions",
    value: function(s) {
      s && G.selectiveExtend(["moment", "locale", "locales", "id", "title", "rtl", "snap"], this.options, s);
    }
    /**
     * Create the DOM for the custom time
     * @private
     */
  }, {
    key: "_create",
    value: function() {
      var s, a, o, l = document.createElement("div");
      l["custom-time"] = this, l.className = "vis-custom-time ".concat(this.options.id || ""), l.style.position = "absolute", l.style.top = "0px", l.style.height = "100%", this.bar = l;
      var u = document.createElement("div");
      u.style.position = "relative", u.style.top = "0px", this.options.rtl ? u.style.right = "-10px" : u.style.left = "-10px", u.style.height = "100%", u.style.width = "20px";
      function c(d) {
        this.body.range._onMouseWheel(d);
      }
      u.addEventListener ? (u.addEventListener("mousewheel", de(c).call(c, this), !1), u.addEventListener("DOMMouseScroll", de(c).call(c, this), !1)) : u.attachEvent("onmousewheel", de(c).call(c, this)), l.appendChild(u), this.hammer = new ei(u), this.hammer.on("panstart", de(s = this._onDragStart).call(s, this)), this.hammer.on("panmove", de(a = this._onDrag).call(a, this)), this.hammer.on("panend", de(o = this._onDragEnd).call(o, this)), this.hammer.get("pan").set({
        threshold: 5,
        direction: ei.DIRECTION_ALL
      }), this.hammer.get("press").set({
        time: 1e4
      });
    }
    /**
     * Destroy the CustomTime bar
     */
  }, {
    key: "destroy",
    value: function() {
      this.hide(), this.hammer.destroy(), this.hammer = null, this.body = null;
    }
    /**
     * Repaint the component
     * @return {boolean} Returns true if the component is resized
     */
  }, {
    key: "redraw",
    value: function() {
      var s = this.body.dom.backgroundVertical;
      this.bar.parentNode != s && (this.bar.parentNode && this.bar.parentNode.removeChild(this.bar), s.appendChild(this.bar));
      var a = this.body.util.toScreen(this.customTime), o = this.options.locales[this.options.locale];
      o || (this.warned || (console.warn("WARNING: options.locales['".concat(this.options.locale, "'] not found. See https://visjs.github.io/vis-timeline/docs/timeline/#Localization")), this.warned = !0), o = this.options.locales.en);
      var l = this.options.title;
      if (l === void 0) {
        var u;
        l = Dr(u = "".concat(o.time, ": ")).call(u, this.options.moment(this.customTime).format("dddd, MMMM Do YYYY, H:mm:ss")), l = l.charAt(0).toUpperCase() + l.substring(1);
      } else
        typeof l == "function" && (l = l.call(this, this.customTime));
      return this.options.rtl ? this.bar.style.right = "".concat(a, "px") : this.bar.style.left = "".concat(a, "px"), this.bar.title = l, !1;
    }
    /**
     * Remove the CustomTime from the DOM
     */
  }, {
    key: "hide",
    value: function() {
      this.bar.parentNode && this.bar.parentNode.removeChild(this.bar);
    }
    /**
     * Set custom time.
     * @param {Date | number | string} time
     */
  }, {
    key: "setCustomTime",
    value: function(s) {
      this.customTime = G.convert(s, "Date"), this.redraw();
    }
    /**
     * Retrieve the current custom time.
     * @return {Date} customTime
     */
  }, {
    key: "getCustomTime",
    value: function() {
      return new Date(this.customTime.valueOf());
    }
    /**
     * Set custom marker.
     * @param {string} [title] Title of the custom marker
     * @param {boolean} [editable] Make the custom marker editable.
     */
  }, {
    key: "setCustomMarker",
    value: function(s, a) {
      var o = document.createElement("div");
      if (o.className = "vis-custom-time-marker", o.innerHTML = G.xss(s), o.style.position = "absolute", a) {
        var l, u;
        o.setAttribute("contenteditable", "true"), o.addEventListener("pointerdown", function() {
          o.focus();
        }), o.addEventListener("input", de(l = this._onMarkerChange).call(l, this)), o.title = s, o.addEventListener("blur", de(u = function(d) {
          this.title != d.target.innerHTML && (this._onMarkerChanged(d), this.title = d.target.innerHTML);
        }).call(u, this));
      }
      this.bar.appendChild(o);
    }
    /**
      * Set custom title.
      * @param {Date | number | string} title
      */
  }, {
    key: "setCustomTitle",
    value: function(s) {
      this.options.title = s;
    }
    /**
     * Start moving horizontally
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onDragStart",
    value: function(s) {
      this.eventParams.dragging = !0, this.eventParams.customTime = this.customTime, s.stopPropagation();
    }
    /**
     * Perform moving operating.
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onDrag",
    value: function(s) {
      if (this.eventParams.dragging) {
        var a = this.options.rtl ? -1 * s.deltaX : s.deltaX, o = this.body.util.toScreen(this.eventParams.customTime) + a, l = this.body.util.toTime(o), u = this.body.util.getScale(), c = this.body.util.getStep(), d = this.options.snap, h = d ? d(l, u, c) : l;
        this.setCustomTime(h), this.body.emitter.emit("timechange", {
          id: this.options.id,
          time: new Date(this.customTime.valueOf()),
          event: s
        }), s.stopPropagation();
      }
    }
    /**
     * Stop moving operating.
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onDragEnd",
    value: function(s) {
      this.eventParams.dragging && (this.body.emitter.emit("timechanged", {
        id: this.options.id,
        time: new Date(this.customTime.valueOf()),
        event: s
      }), s.stopPropagation());
    }
    /**
     * Perform input operating.
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onMarkerChange",
    value: function(s) {
      this.body.emitter.emit("markerchange", {
        id: this.options.id,
        title: s.target.innerHTML,
        event: s
      }), s.stopPropagation();
    }
    /**
     * Perform change operating.
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onMarkerChanged",
    value: function(s) {
      this.body.emitter.emit("markerchanged", {
        id: this.options.id,
        title: s.target.innerHTML,
        event: s
      }), s.stopPropagation();
    }
    /**
     * Find a custom time from an event target:
     * searches for the attribute 'custom-time' in the event target's element tree
     * @param {Event} event
     * @return {CustomTime | null} customTime
     */
  }], [{
    key: "customTimeFromTarget",
    value: function(s) {
      for (var a = s.target; a; ) {
        if (a.hasOwnProperty("custom-time"))
          return a["custom-time"];
        a = a.parentNode;
      }
      return null;
    }
  }]), r;
}(Fl), Od = /* @__PURE__ */ function() {
  function t() {
    dr(this, t);
  }
  return hr(t, [{
    key: "_create",
    value: (
      /**
       * Create the main DOM for the Core: a root panel containing left, right,
       * top, bottom, content, and background panel.
       * @param {Element} container  The container element where the Core will
       *                             be attached.
       * @protected
       */
      function(r) {
        var n = this, s, a, o;
        this.dom = {}, this.dom.container = r, this.dom.container.style.position = "relative", this.dom.root = document.createElement("div"), this.dom.background = document.createElement("div"), this.dom.backgroundVertical = document.createElement("div"), this.dom.backgroundHorizontal = document.createElement("div"), this.dom.centerContainer = document.createElement("div"), this.dom.leftContainer = document.createElement("div"), this.dom.rightContainer = document.createElement("div"), this.dom.center = document.createElement("div"), this.dom.left = document.createElement("div"), this.dom.right = document.createElement("div"), this.dom.top = document.createElement("div"), this.dom.bottom = document.createElement("div"), this.dom.shadowTop = document.createElement("div"), this.dom.shadowBottom = document.createElement("div"), this.dom.shadowTopLeft = document.createElement("div"), this.dom.shadowBottomLeft = document.createElement("div"), this.dom.shadowTopRight = document.createElement("div"), this.dom.shadowBottomRight = document.createElement("div"), this.dom.rollingModeBtn = document.createElement("div"), this.dom.loadingScreen = document.createElement("div"), this.dom.root.className = "vis-timeline", this.dom.background.className = "vis-panel vis-background", this.dom.backgroundVertical.className = "vis-panel vis-background vis-vertical", this.dom.backgroundHorizontal.className = "vis-panel vis-background vis-horizontal", this.dom.centerContainer.className = "vis-panel vis-center", this.dom.leftContainer.className = "vis-panel vis-left", this.dom.rightContainer.className = "vis-panel vis-right", this.dom.top.className = "vis-panel vis-top", this.dom.bottom.className = "vis-panel vis-bottom", this.dom.left.className = "vis-content", this.dom.center.className = "vis-content", this.dom.right.className = "vis-content", this.dom.shadowTop.className = "vis-shadow vis-top", this.dom.shadowBottom.className = "vis-shadow vis-bottom", this.dom.shadowTopLeft.className = "vis-shadow vis-top", this.dom.shadowBottomLeft.className = "vis-shadow vis-bottom", this.dom.shadowTopRight.className = "vis-shadow vis-top", this.dom.shadowBottomRight.className = "vis-shadow vis-bottom", this.dom.rollingModeBtn.className = "vis-rolling-mode-btn", this.dom.loadingScreen.className = "vis-loading-screen", this.dom.root.appendChild(this.dom.background), this.dom.root.appendChild(this.dom.backgroundVertical), this.dom.root.appendChild(this.dom.backgroundHorizontal), this.dom.root.appendChild(this.dom.centerContainer), this.dom.root.appendChild(this.dom.leftContainer), this.dom.root.appendChild(this.dom.rightContainer), this.dom.root.appendChild(this.dom.top), this.dom.root.appendChild(this.dom.bottom), this.dom.root.appendChild(this.dom.rollingModeBtn), this.dom.centerContainer.appendChild(this.dom.center), this.dom.leftContainer.appendChild(this.dom.left), this.dom.rightContainer.appendChild(this.dom.right), this.dom.centerContainer.appendChild(this.dom.shadowTop), this.dom.centerContainer.appendChild(this.dom.shadowBottom), this.dom.leftContainer.appendChild(this.dom.shadowTopLeft), this.dom.leftContainer.appendChild(this.dom.shadowBottomLeft), this.dom.rightContainer.appendChild(this.dom.shadowTopRight), this.dom.rightContainer.appendChild(this.dom.shadowBottomRight), this.props = {
          root: {},
          background: {},
          centerContainer: {},
          leftContainer: {},
          rightContainer: {},
          center: {},
          left: {},
          right: {},
          top: {},
          bottom: {},
          border: {},
          scrollTop: 0,
          scrollTopMin: 0
        }, this.on("rangechange", function() {
          n.initialDrawDone === !0 && n._redraw();
        }), this.on("rangechanged", function() {
          n.initialRangeChangeDone || (n.initialRangeChangeDone = !0);
        }), this.on("touch", de(s = this._onTouch).call(s, this)), this.on("panmove", de(a = this._onDrag).call(a, this));
        var l = this;
        this._origRedraw = de(o = this._redraw).call(o, this), this._redraw = G.throttle(this._origRedraw), this.on("_change", function(y) {
          l.itemSet && l.itemSet.initialItemSetDrawn && y && y.queue == !0 ? l._redraw() : l._origRedraw();
        }), this.hammer = new ei(this.dom.root);
        var u = this.hammer.get("pinch").set({
          enable: !0
        });
        u && i8e(u), this.hammer.get("pan").set({
          threshold: 5,
          direction: ei.DIRECTION_ALL
        }), this.timelineListeners = {};
        var c = [
          "tap",
          "doubletap",
          "press",
          "pinch",
          "pan",
          "panstart",
          "panmove",
          "panend"
          // TODO: cleanup
          //'touch', 'pinch',
          //'tap', 'doubletap', 'hold',
          //'dragstart', 'drag', 'dragend',
          //'mousewheel', 'DOMMouseScroll' // DOMMouseScroll is needed for Firefox
        ];
        Le(c).call(c, function(y) {
          var _ = function(T) {
            l.isActive() && l.emit(y, T);
          };
          l.hammer.on(y, _), l.timelineListeners[y] = _;
        }), TW(this.hammer, function(y) {
          l.emit("touch", y);
        }), n8e(this.hammer, function(y) {
          l.emit("release", y);
        });
        function d(y) {
          var _ = 40, x = 800;
          this.isActive() && this.emit("mousewheel", y);
          var T = 0, k = 0;
          if ("detail" in y && (k = y.detail * -1), "wheelDelta" in y && (k = y.wheelDelta), "wheelDeltaY" in y && (k = y.wheelDeltaY), "wheelDeltaX" in y && (T = y.wheelDeltaX * -1), "axis" in y && y.axis === y.HORIZONTAL_AXIS && (T = k * -1, k = 0), "deltaY" in y && (k = y.deltaY * -1), "deltaX" in y && (T = y.deltaX), y.deltaMode && (y.deltaMode === 1 ? (T *= _, k *= _) : (T *= _, k *= x)), this.options.preferZoom) {
            if (!this.options.zoomKey || y[this.options.zoomKey])
              return;
          } else if (this.options.zoomKey && y[this.options.zoomKey])
            return;
          if (!(!this.options.verticalScroll && !this.options.horizontalScroll)) {
            if (this.options.verticalScroll && Math.abs(k) >= Math.abs(T)) {
              var E = this.props.scrollTop, F = E + k;
              if (this.isActive()) {
                var R = this._setScrollTop(F);
                R !== E && (this._redraw(), this.emit("scroll", y), y.preventDefault());
              }
            } else if (this.options.horizontalScroll) {
              var $ = Math.abs(T) >= Math.abs(k) ? T : k, O = $ / 120 * (this.range.end - this.range.start) / 20, P = this.range.start + O, N = this.range.end + O, I = {
                animation: !1,
                byUser: !0,
                event: y
              };
              this.range.setRange(P, N, I), y.preventDefault();
            }
          }
        }
        var h = "onwheel" in document.createElement("div") ? "wheel" : (
          // Modern browsers support "wheel"
          document.onmousewheel !== void 0 ? "mousewheel" : (
            // Webkit and IE support at least "mousewheel"
            // DOMMouseScroll - Older Firefox versions use "DOMMouseScroll"
            // onmousewheel - All the use "onmousewheel"
            this.dom.centerContainer.addEventListener ? "DOMMouseScroll" : "onmousewheel"
          )
        );
        this.dom.top.addEventListener, this.dom.bottom.addEventListener, this.dom.centerContainer.addEventListener(h, de(d).call(d, this), !1), this.dom.top.addEventListener(h, de(d).call(d, this), !1), this.dom.bottom.addEventListener(h, de(d).call(d, this), !1);
        function f(y) {
          if (l.options.verticalScroll && (y.preventDefault(), l.isActive())) {
            var _ = -y.target.scrollTop;
            l._setScrollTop(_), l._redraw(), l.emit("scrollSide", y);
          }
        }
        this.dom.left.parentNode.addEventListener("scroll", de(f).call(f, this)), this.dom.right.parentNode.addEventListener("scroll", de(f).call(f, this));
        var p = !1;
        function m(y) {
          var _;
          if (y.preventDefault && (l.emit("dragover", l.getEventProperties(y)), y.preventDefault()), lr(_ = y.target.className).call(_, "timeline") > -1 && !p)
            return y.dataTransfer.dropEffect = "move", p = !0, !1;
        }
        function b(y) {
          y.preventDefault && y.preventDefault(), y.stopPropagation && y.stopPropagation();
          try {
            var _ = JSON.parse(y.dataTransfer.getData("text"));
            if (!_ || !_.content)
              return;
          } catch {
            return !1;
          }
          return p = !1, y.center = {
            x: y.clientX,
            y: y.clientY
          }, _.target !== "item" ? l.itemSet._onAddItem(y) : l.itemSet._onDropObjectOnItem(y), l.emit("drop", l.getEventProperties(y)), !1;
        }
        if (this.dom.center.addEventListener("dragover", de(m).call(m, this), !1), this.dom.center.addEventListener("drop", de(b).call(b, this), !1), this.customTimes = [], this.touch = {}, this.redrawCount = 0, this.initialDrawDone = !1, this.initialRangeChangeDone = !1, !r)
          throw new Error("No container provided");
        r.appendChild(this.dom.root), r.appendChild(this.dom.loadingScreen);
      }
    )
    /**
     * Set options. Options will be passed to all components loaded in the Timeline.
     * @param {Object} [options]
     *                           {String} orientation
     *                              Vertical orientation for the Timeline,
     *                              can be 'bottom' (default) or 'top'.
     *                           {string | number} width
     *                              Width for the timeline, a number in pixels or
     *                              a css string like '1000px' or '75%'. '100%' by default.
     *                           {string | number} height
     *                              Fixed height for the Timeline, a number in pixels or
     *                              a css string like '400px' or '75%'. If undefined,
     *                              The Timeline will automatically size such that
     *                              its contents fit.
     *                           {string | number} minHeight
     *                              Minimum height for the Timeline, a number in pixels or
     *                              a css string like '400px' or '75%'.
     *                           {string | number} maxHeight
     *                              Maximum height for the Timeline, a number in pixels or
     *                              a css string like '400px' or '75%'.
     *                           {number | Date | string} start
     *                              Start date for the visible window
     *                           {number | Date | string} end
     *                              End date for the visible window
     */
  }, {
    key: "setOptions",
    value: function(r) {
      var n;
      if (r) {
        var s = ["width", "height", "minHeight", "maxHeight", "autoResize", "start", "end", "clickToUse", "dataAttributes", "hiddenDates", "locale", "locales", "moment", "preferZoom", "rtl", "zoomKey", "horizontalScroll", "verticalScroll", "longSelectPressTime", "snap"];
        if (G.selectiveExtend(s, this.options, r), this.dom.rollingModeBtn.style.visibility = "hidden", this.options.rtl && (this.dom.container.style.direction = "rtl", this.dom.backgroundVertical.className = "vis-panel vis-background vis-vertical-rtl"), this.options.verticalScroll && (this.options.rtl ? this.dom.rightContainer.className = "vis-panel vis-right vis-vertical-scroll" : this.dom.leftContainer.className = "vis-panel vis-left vis-vertical-scroll"), mt(this.options.orientation) !== "object" && (this.options.orientation = {
          item: void 0,
          axis: void 0
        }), "orientation" in r && (typeof r.orientation == "string" ? this.options.orientation = {
          item: r.orientation,
          axis: r.orientation
        } : mt(r.orientation) === "object" && ("item" in r.orientation && (this.options.orientation.item = r.orientation.item), "axis" in r.orientation && (this.options.orientation.axis = r.orientation.axis))), this.options.orientation.axis === "both") {
          if (!this.timeAxis2) {
            var a = this.timeAxis2 = new Jy(this.body);
            a.setOptions = function(h) {
              var f = h ? G.extend({}, h) : {};
              f.orientation = "top", Jy.prototype.setOptions.call(a, f);
            }, this.components.push(a);
          }
        } else if (this.timeAxis2) {
          var o, l = lr(o = this.components).call(o, this.timeAxis2);
          if (l !== -1) {
            var u;
            xi(u = this.components).call(u, l, 1);
          }
          this.timeAxis2.destroy(), this.timeAxis2 = null;
        }
        typeof r.drawPoints == "function" && (r.drawPoints = {
          onRender: r.drawPoints
        }), "hiddenDates" in this.options && oA(this.options.moment, this.body, this.options.hiddenDates), "clickToUse" in r && (r.clickToUse ? this.activator || (this.activator = new ls(this.dom.root)) : this.activator && (this.activator.destroy(), delete this.activator)), this._initAutoResize();
      }
      if (Le(n = this.components).call(n, function(h) {
        return h.setOptions(r);
      }), "configure" in r) {
        var c;
        this.configurator || (this.configurator = this._createConfigurator()), this.configurator.setOptions(r.configure);
        var d = G.deepExtend({}, this.options);
        Le(c = this.components).call(c, function(h) {
          G.deepExtend(d, h.options);
        }), this.configurator.setModuleOptions({
          global: d
        });
      }
      this._redraw();
    }
    /**
     * Returns true when the Timeline is active.
     * @returns {boolean}
     */
  }, {
    key: "isActive",
    value: function() {
      return !this.activator || this.activator.active;
    }
    /**
     * Destroy the Core, clean up all DOM elements and event listeners.
     */
  }, {
    key: "destroy",
    value: function() {
      var r;
      this.setItems(null), this.setGroups(null), this.off(), this._stopAutoResize(), this.dom.root.parentNode && this.dom.root.parentNode.removeChild(this.dom.root), this.dom = null, this.activator && (this.activator.destroy(), delete this.activator);
      for (var n in this.timelineListeners)
        this.timelineListeners.hasOwnProperty(n) && delete this.timelineListeners[n];
      this.timelineListeners = null, this.hammer && this.hammer.destroy(), this.hammer = null, Le(r = this.components).call(r, function(s) {
        return s.destroy();
      }), this.body = null;
    }
    /**
     * Set a custom time bar
     * @param {Date} time
     * @param {number} [id=undefined] Optional id of the custom time bar to be adjusted.
     */
  }, {
    key: "setCustomTime",
    value: function(r, n) {
      var s, a = At(s = this.customTimes).call(s, function(o) {
        return n === o.options.id;
      });
      if (a.length === 0)
        throw new Error("No custom time bar found with id ".concat(Vi(n)));
      a.length > 0 && a[0].setCustomTime(r);
    }
    /**
     * Retrieve the current custom time.
     * @param {number} [id=undefined]    Id of the custom time bar.
     * @return {Date | undefined} customTime
     */
  }, {
    key: "getCustomTime",
    value: function(r) {
      var n, s = At(n = this.customTimes).call(n, function(a) {
        return a.options.id === r;
      });
      if (s.length === 0)
        throw new Error("No custom time bar found with id ".concat(Vi(r)));
      return s[0].getCustomTime();
    }
    /**
     * Set a custom marker for the custom time bar.
     * @param {string} [title] Title of the custom marker.
     * @param {number} [id=undefined] Id of the custom marker.
     * @param {boolean} [editable=false] Make the custom marker editable.
     */
  }, {
    key: "setCustomTimeMarker",
    value: function(r, n, s) {
      var a, o = At(a = this.customTimes).call(a, function(l) {
        return l.options.id === n;
      });
      if (o.length === 0)
        throw new Error("No custom time bar found with id ".concat(Vi(n)));
      o.length > 0 && o[0].setCustomMarker(r, s);
    }
    /**
     * Set a custom title for the custom time bar.
     * @param {string} [title] Custom title
     * @param {number} [id=undefined]    Id of the custom time bar.
     * @returns {*}
     */
  }, {
    key: "setCustomTimeTitle",
    value: function(r, n) {
      var s, a = At(s = this.customTimes).call(s, function(o) {
        return o.options.id === n;
      });
      if (a.length === 0)
        throw new Error("No custom time bar found with id ".concat(Vi(n)));
      if (a.length > 0)
        return a[0].setCustomTitle(r);
    }
    /**
     * Retrieve meta information from an event.
     * Should be overridden by classes extending Core
     * @param {Event} event
     * @return {Object} An object with related information.
     */
  }, {
    key: "getEventProperties",
    value: function(r) {
      return {
        event: r
      };
    }
    /**
     * Add custom vertical bar
     * @param {Date | string | number} [time]  A Date, unix timestamp, or
     *                                         ISO date string. Time point where
     *                                         the new bar should be placed.
     *                                         If not provided, `new Date()` will
     *                                         be used.
     * @param {number | string} [id=undefined] Id of the new bar. Optional
     * @return {number | string}               Returns the id of the new bar
     */
  }, {
    key: "addCustomTime",
    value: function(r, n) {
      var s, a = r !== void 0 ? G.convert(r, "Date") : /* @__PURE__ */ new Date(), o = wW(s = this.customTimes).call(s, function(u) {
        return u.options.id === n;
      });
      if (o)
        throw new Error("A custom time with id ".concat(Vi(n), " already exists"));
      var l = new hA(this.body, G.extend({}, this.options, {
        time: a,
        id: n,
        snap: this.itemSet ? this.itemSet.options.snap : this.options.snap
      }));
      return this.customTimes.push(l), this.components.push(l), this._redraw(), n;
    }
    /**
     * Remove previously added custom bar
     * @param {int} id ID of the custom bar to be removed
     * [at]returns {boolean} True if the bar exists and is removed, false otherwise
     */
  }, {
    key: "removeCustomTime",
    value: function(r) {
      var n, s = this, a = At(n = this.customTimes).call(n, function(o) {
        return o.options.id === r;
      });
      if (a.length === 0)
        throw new Error("No custom time bar found with id ".concat(Vi(r)));
      Le(a).call(a, function(o) {
        var l, u, c, d;
        xi(l = s.customTimes).call(l, lr(u = s.customTimes).call(u, o), 1), xi(c = s.components).call(c, lr(d = s.components).call(d, o), 1), o.destroy();
      });
    }
    /**
     * Get the id's of the currently visible items.
     * @returns {Array} The ids of the visible items
     */
  }, {
    key: "getVisibleItems",
    value: function() {
      return this.itemSet && this.itemSet.getVisibleItems() || [];
    }
    /**
     * Get the id's of the items at specific time, where a click takes place on the timeline.
     * @returns {Array} The ids of all items in existence at the time of event.
     */
  }, {
    key: "getItemsAtCurrentTime",
    value: function(r) {
      return this.time = r, this.itemSet && this.itemSet.getItemsAtCurrentTime(this.time) || [];
    }
    /**
     * Get the id's of the currently visible groups.
     * @returns {Array} The ids of the visible groups
     */
  }, {
    key: "getVisibleGroups",
    value: function() {
      return this.itemSet && this.itemSet.getVisibleGroups() || [];
    }
    /**
     * Set Core window such that it fits all items
     * @param {Object} [options]  Available options:
     *                                `animation: boolean | {duration: number, easingFunction: string}`
     *                                    If true (default), the range is animated
     *                                    smoothly to the new window. An object can be
     *                                    provided to specify duration and easing function.
     *                                    Default duration is 500 ms, and default easing
     *                                    function is 'easeInOutQuad'.
     * @param {function} [callback] a callback funtion to be executed at the end of this function
     */
  }, {
    key: "fit",
    value: function(r, n) {
      var s = this.getDataRange();
      if (!(s.min === null && s.max === null)) {
        var a = s.max - s.min, o = new Date(s.min.valueOf() - a * 0.01), l = new Date(s.max.valueOf() + a * 0.01), u = r && r.animation !== void 0 ? r.animation : !0;
        this.range.setRange(o, l, {
          animation: u
        }, n);
      }
    }
    /**
     * Calculate the data range of the items start and end dates
     * [at]returns {{min: [Date], max: [Date]}}
     * @protected
     */
  }, {
    key: "getDataRange",
    value: function() {
      throw new Error("Cannot invoke abstract method getDataRange");
    }
    /**
     * Set the visible window. Both parameters are optional, you can change only
     * start or only end. Syntax:
     *
     *     TimeLine.setWindow(start, end)
     *     TimeLine.setWindow(start, end, options)
     *     TimeLine.setWindow(range)
     *
     * Where start and end can be a Date, number, or string, and range is an
     * object with properties start and end.
     *
     * @param {Date | number | string | Object} [start] Start date of visible window
     * @param {Date | number | string} [end]            End date of visible window
     * @param {Object} [options]  Available options:
     *                                `animation: boolean | {duration: number, easingFunction: string}`
     *                                    If true (default), the range is animated
     *                                    smoothly to the new window. An object can be
     *                                    provided to specify duration and easing function.
     *                                    Default duration is 500 ms, and default easing
     *                                    function is 'easeInOutQuad'.
     * @param {function} [callback] a callback funtion to be executed at the end of this function
     */
  }, {
    key: "setWindow",
    value: function(r, n, s, a) {
      typeof arguments[2] == "function" && (a = arguments[2], s = {});
      var o, l;
      arguments.length == 1 ? (l = arguments[0], o = l.animation !== void 0 ? l.animation : !0, this.range.setRange(l.start, l.end, {
        animation: o
      })) : arguments.length == 2 && typeof arguments[1] == "function" ? (l = arguments[0], a = arguments[1], o = l.animation !== void 0 ? l.animation : !0, this.range.setRange(l.start, l.end, {
        animation: o
      }, a)) : (o = s && s.animation !== void 0 ? s.animation : !0, this.range.setRange(r, n, {
        animation: o
      }, a));
    }
    /**
     * Move the window such that given time is centered on screen.
     * @param {Date | number | string} time
     * @param {Object} [options]  Available options:
     *                                `animation: boolean | {duration: number, easingFunction: string}`
     *                                    If true (default), the range is animated
     *                                    smoothly to the new window. An object can be
     *                                    provided to specify duration and easing function.
     *                                    Default duration is 500 ms, and default easing
     *                                    function is 'easeInOutQuad'.
     * @param {function} [callback] a callback funtion to be executed at the end of this function
     */
  }, {
    key: "moveTo",
    value: function(r, n, s) {
      typeof arguments[1] == "function" && (s = arguments[1], n = {});
      var a = this.range.end - this.range.start, o = G.convert(r, "Date").valueOf(), l = o - a / 2, u = o + a / 2, c = n && n.animation !== void 0 ? n.animation : !0;
      this.range.setRange(l, u, {
        animation: c
      }, s);
    }
    /**
     * Get the visible window
     * @return {{start: Date, end: Date}}   Visible range
     */
  }, {
    key: "getWindow",
    value: function() {
      var r = this.range.getRange();
      return {
        start: new Date(r.start),
        end: new Date(r.end)
      };
    }
    /**
     * Zoom in the window such that given time is centered on screen.
     * @param {number} percentage - must be between [0..1]
     * @param {Object} [options]  Available options:
     *                                `animation: boolean | {duration: number, easingFunction: string}`
     *                                    If true (default), the range is animated
     *                                    smoothly to the new window. An object can be
     *                                    provided to specify duration and easing function.
     *                                    Default duration is 500 ms, and default easing
     *                                    function is 'easeInOutQuad'.
     * @param {function} [callback] a callback funtion to be executed at the end of this function
     */
  }, {
    key: "zoomIn",
    value: function(r, n, s) {
      if (!(!r || r < 0 || r > 1)) {
        typeof arguments[1] == "function" && (s = arguments[1], n = {});
        var a = this.getWindow(), o = a.start.valueOf(), l = a.end.valueOf(), u = l - o, c = u / (1 + r), d = (u - c) / 2, h = o + d, f = l - d;
        this.setWindow(h, f, n, s);
      }
    }
    /**
     * Zoom out the window such that given time is centered on screen.
     * @param {number} percentage - must be between [0..1]
     * @param {Object} [options]  Available options:
     *                                `animation: boolean | {duration: number, easingFunction: string}`
     *                                    If true (default), the range is animated
     *                                    smoothly to the new window. An object can be
     *                                    provided to specify duration and easing function.
     *                                    Default duration is 500 ms, and default easing
     *                                    function is 'easeInOutQuad'.
     * @param {function} [callback] a callback funtion to be executed at the end of this function
     */
  }, {
    key: "zoomOut",
    value: function(r, n, s) {
      if (!(!r || r < 0 || r > 1)) {
        typeof arguments[1] == "function" && (s = arguments[1], n = {});
        var a = this.getWindow(), o = a.start.valueOf(), l = a.end.valueOf(), u = l - o, c = o - u * r / 2, d = l + u * r / 2;
        this.setWindow(c, d, n, s);
      }
    }
    /**
     * Force a redraw. Can be overridden by implementations of Core
     *
     * Note: this function will be overridden on construction with a trottled version
     */
  }, {
    key: "redraw",
    value: function() {
      this._redraw();
    }
    /**
     * Redraw for internal use. Redraws all components. See also the public
     * method redraw.
     * @protected
     */
  }, {
    key: "_redraw",
    value: function() {
      var r;
      this.redrawCount++;
      var n = this.dom;
      if (!(!n || !n.container || n.root.offsetWidth == 0)) {
        var s = !1, a = this.options, o = this.props;
        qy(this.options.moment, this.body, this.options.hiddenDates), a.orientation == "top" ? (G.addClassName(n.root, "vis-top"), G.removeClassName(n.root, "vis-bottom")) : (G.removeClassName(n.root, "vis-top"), G.addClassName(n.root, "vis-bottom")), a.rtl ? (G.addClassName(n.root, "vis-rtl"), G.removeClassName(n.root, "vis-ltr")) : (G.addClassName(n.root, "vis-ltr"), G.removeClassName(n.root, "vis-rtl")), n.root.style.maxHeight = G.option.asSize(a.maxHeight, ""), n.root.style.minHeight = G.option.asSize(a.minHeight, ""), n.root.style.width = G.option.asSize(a.width, "");
        var l = n.root.offsetWidth;
        o.border.left = 1, o.border.right = 1, o.border.top = 1, o.border.bottom = 1, o.center.height = n.center.offsetHeight, o.left.height = n.left.offsetHeight, o.right.height = n.right.offsetHeight, o.top.height = n.top.clientHeight || -o.border.top, o.bottom.height = Math.round(n.bottom.getBoundingClientRect().height) || n.bottom.clientHeight || -o.border.bottom;
        var u = Math.max(o.left.height, o.center.height, o.right.height), c = o.top.height + u + o.bottom.height + o.border.top + o.border.bottom;
        n.root.style.height = G.option.asSize(a.height, "".concat(c, "px")), o.root.height = n.root.offsetHeight, o.background.height = o.root.height;
        var d = o.root.height - o.top.height - o.bottom.height;
        o.centerContainer.height = d, o.leftContainer.height = d, o.rightContainer.height = o.leftContainer.height, o.root.width = l, o.background.width = o.root.width, this.initialDrawDone || (o.scrollbarWidth = G.getScrollBarWidth());
        var h = n.leftContainer.clientWidth, f = n.rightContainer.clientWidth;
        a.verticalScroll ? a.rtl ? (o.left.width = h || -o.border.left, o.right.width = f + o.scrollbarWidth || -o.border.right) : (o.left.width = h + o.scrollbarWidth || -o.border.left, o.right.width = f || -o.border.right) : (o.left.width = h || -o.border.left, o.right.width = f || -o.border.right), this._setDOM();
        var p = this._updateScrollTop();
        a.orientation.item != "top" && (p += Math.max(o.centerContainer.height - o.center.height - o.border.top - o.border.bottom, 0)), n.center.style.transform = "translateY(".concat(p, "px)");
        var m = o.scrollTop == 0 ? "hidden" : "", b = o.scrollTop == o.scrollTopMin ? "hidden" : "";
        n.shadowTop.style.visibility = m, n.shadowBottom.style.visibility = b, n.shadowTopLeft.style.visibility = m, n.shadowBottomLeft.style.visibility = b, n.shadowTopRight.style.visibility = m, n.shadowBottomRight.style.visibility = b, a.verticalScroll && (n.rightContainer.className = "vis-panel vis-right vis-vertical-scroll", n.leftContainer.className = "vis-panel vis-left vis-vertical-scroll", n.shadowTopRight.style.visibility = "hidden", n.shadowBottomRight.style.visibility = "hidden", n.shadowTopLeft.style.visibility = "hidden", n.shadowBottomLeft.style.visibility = "hidden", n.left.style.top = "0px", n.right.style.top = "0px"), (!a.verticalScroll || o.center.height < o.centerContainer.height) && (n.left.style.top = "".concat(p, "px"), n.right.style.top = "".concat(p, "px"), n.rightContainer.className = n.rightContainer.className.replace(new RegExp("(?:^|\\s)vis-vertical-scroll(?:\\s|$)"), " "), n.leftContainer.className = n.leftContainer.className.replace(new RegExp("(?:^|\\s)vis-vertical-scroll(?:\\s|$)"), " "), o.left.width = h || -o.border.left, o.right.width = f || -o.border.right, this._setDOM());
        var y = o.center.height > o.centerContainer.height;
        this.hammer.get("pan").set({
          direction: y ? ei.DIRECTION_ALL : ei.DIRECTION_HORIZONTAL
        }), this.hammer.get("press").set({
          time: this.options.longSelectPressTime
        }), Le(r = this.components).call(r, function(x) {
          s = x.redraw() || s;
        });
        var _ = 5;
        if (s)
          if (this.redrawCount < _) {
            this.body.emitter.emit("_change");
            return;
          } else
            console.log("WARNING: infinite loop in redraw?");
        else
          this.redrawCount = 0;
        this.body.emitter.emit("changed");
      }
    }
    /**
     * sets the basic DOM components needed for the timeline\graph2d
     */
  }, {
    key: "_setDOM",
    value: function() {
      var r = this.props, n = this.dom;
      r.leftContainer.width = r.left.width, r.rightContainer.width = r.right.width;
      var s = r.root.width - r.left.width - r.right.width;
      r.center.width = s, r.centerContainer.width = s, r.top.width = s, r.bottom.width = s, n.background.style.height = "".concat(r.background.height, "px"), n.backgroundVertical.style.height = "".concat(r.background.height, "px"), n.backgroundHorizontal.style.height = "".concat(r.centerContainer.height, "px"), n.centerContainer.style.height = "".concat(r.centerContainer.height, "px"), n.leftContainer.style.height = "".concat(r.leftContainer.height, "px"), n.rightContainer.style.height = "".concat(r.rightContainer.height, "px"), n.background.style.width = "".concat(r.background.width, "px"), n.backgroundVertical.style.width = "".concat(r.centerContainer.width, "px"), n.backgroundHorizontal.style.width = "".concat(r.background.width, "px"), n.centerContainer.style.width = "".concat(r.center.width, "px"), n.top.style.width = "".concat(r.top.width, "px"), n.bottom.style.width = "".concat(r.bottom.width, "px"), n.background.style.left = "0", n.background.style.top = "0", n.backgroundVertical.style.left = "".concat(r.left.width + r.border.left, "px"), n.backgroundVertical.style.top = "0", n.backgroundHorizontal.style.left = "0", n.backgroundHorizontal.style.top = "".concat(r.top.height, "px"), n.centerContainer.style.left = "".concat(r.left.width, "px"), n.centerContainer.style.top = "".concat(r.top.height, "px"), n.leftContainer.style.left = "0", n.leftContainer.style.top = "".concat(r.top.height, "px"), n.rightContainer.style.left = "".concat(r.left.width + r.center.width, "px"), n.rightContainer.style.top = "".concat(r.top.height, "px"), n.top.style.left = "".concat(r.left.width, "px"), n.top.style.top = "0", n.bottom.style.left = "".concat(r.left.width, "px"), n.bottom.style.top = "".concat(r.top.height + r.centerContainer.height, "px"), n.center.style.left = "0", n.left.style.left = "0", n.right.style.left = "0";
    }
    /**
     * Set a current time. This can be used for example to ensure that a client's
     * time is synchronized with a shared server time.
     * Only applicable when option `showCurrentTime` is true.
     * @param {Date | string | number} time     A Date, unix timestamp, or
     *                                          ISO date string.
     */
  }, {
    key: "setCurrentTime",
    value: function(r) {
      if (!this.currentTime)
        throw new Error("Option showCurrentTime must be true");
      this.currentTime.setCurrentTime(r);
    }
    /**
     * Get the current time.
     * Only applicable when option `showCurrentTime` is true.
     * @return {Date} Returns the current time.
     */
  }, {
    key: "getCurrentTime",
    value: function() {
      if (!this.currentTime)
        throw new Error("Option showCurrentTime must be true");
      return this.currentTime.getCurrentTime();
    }
    /**
     * Convert a position on screen (pixels) to a datetime
     * @param {int}     x    Position on the screen in pixels
     * @return {Date}   time The datetime the corresponds with given position x
     * @protected
     * TODO: move this function to Range
     */
  }, {
    key: "_toTime",
    value: function(r) {
      return E2(this, r, this.props.center.width);
    }
    /**
     * Convert a position on the global screen (pixels) to a datetime
     * @param {int}     x    Position on the screen in pixels
     * @return {Date}   time The datetime the corresponds with given position x
     * @protected
     * TODO: move this function to Range
     */
  }, {
    key: "_toGlobalTime",
    value: function(r) {
      return E2(this, r, this.props.root.width);
    }
    /**
     * Convert a datetime (Date object) into a position on the screen
     * @param {Date}   time A date
     * @return {int}   x    The position on the screen in pixels which corresponds
     *                      with the given date.
     * @protected
     * TODO: move this function to Range
     */
  }, {
    key: "_toScreen",
    value: function(r) {
      return S2(this, r, this.props.center.width);
    }
    /**
     * Convert a datetime (Date object) into a position on the root
     * This is used to get the pixel density estimate for the screen, not the center panel
     * @param {Date}   time A date
     * @return {int}   x    The position on root in pixels which corresponds
     *                      with the given date.
     * @protected
     * TODO: move this function to Range
     */
  }, {
    key: "_toGlobalScreen",
    value: function(r) {
      return S2(this, r, this.props.root.width);
    }
    /**
     * Initialize watching when option autoResize is true
     * @private
     */
  }, {
    key: "_initAutoResize",
    value: function() {
      this.options.autoResize == !0 ? this._startAutoResize() : this._stopAutoResize();
    }
    /**
     * Watch for changes in the size of the container. On resize, the Panel will
     * automatically redraw itself.
     * @private
     */
  }, {
    key: "_startAutoResize",
    value: function() {
      var r = this;
      this._stopAutoResize(), this._onResize = function() {
        if (r.options.autoResize != !0) {
          r._stopAutoResize();
          return;
        }
        if (r.dom.root) {
          var n = r.dom.root.offsetHeight, s = r.dom.root.offsetWidth;
          (s != r.props.lastWidth || n != r.props.lastHeight) && (r.props.lastWidth = s, r.props.lastHeight = n, r.props.scrollbarWidth = G.getScrollBarWidth(), r.body.emitter.emit("_change"));
        }
      }, G.addEventListener(window, "resize", this._onResize), r.dom.root && (r.props.lastWidth = r.dom.root.offsetWidth, r.props.lastHeight = r.dom.root.offsetHeight), this.watchTimer = e8e(this._onResize, 1e3);
    }
    /**
     * Stop watching for a resize of the frame.
     * @private
     */
  }, {
    key: "_stopAutoResize",
    value: function() {
      this.watchTimer && (clearInterval(this.watchTimer), this.watchTimer = void 0), this._onResize && (G.removeEventListener(window, "resize", this._onResize), this._onResize = null);
    }
    /**
     * Start moving the timeline vertically
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onTouch",
    value: function(r) {
      this.touch.allowDragging = !0, this.touch.initialScrollTop = this.props.scrollTop;
    }
    /**
     * Start moving the timeline vertically
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onPinch",
    value: function(r) {
      this.touch.allowDragging = !1;
    }
    /**
     * Move the timeline vertically
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onDrag",
    value: function(r) {
      if (r && this.touch.allowDragging) {
        var n = r.deltaY, s = this._getScrollTop(), a = this._setScrollTop(this.touch.initialScrollTop + n);
        this.options.verticalScroll && (this.dom.left.parentNode.scrollTop = -this.props.scrollTop, this.dom.right.parentNode.scrollTop = -this.props.scrollTop), a != s && this.emit("verticalDrag");
      }
    }
    /**
     * Apply a scrollTop
     * @param {number} scrollTop
     * @returns {number} scrollTop  Returns the applied scrollTop
     * @private
     */
  }, {
    key: "_setScrollTop",
    value: function(r) {
      return this.props.scrollTop = r, this._updateScrollTop(), this.props.scrollTop;
    }
    /**
     * Update the current scrollTop when the height of  the containers has been changed
     * @returns {number} scrollTop  Returns the applied scrollTop
     * @private
     */
  }, {
    key: "_updateScrollTop",
    value: function() {
      var r = Math.min(this.props.centerContainer.height - this.props.border.top - this.props.border.bottom - this.props.center.height, 0);
      return r != this.props.scrollTopMin && (this.options.orientation.item != "top" && (this.props.scrollTop += r - this.props.scrollTopMin), this.props.scrollTopMin = r), this.props.scrollTop > 0 && (this.props.scrollTop = 0), this.props.scrollTop < r && (this.props.scrollTop = r), this.options.verticalScroll && (this.dom.left.parentNode.scrollTop = -this.props.scrollTop, this.dom.right.parentNode.scrollTop = -this.props.scrollTop), this.props.scrollTop;
    }
    /**
     * Get the current scrollTop
     * @returns {number} scrollTop
     * @private
     */
  }, {
    key: "_getScrollTop",
    value: function() {
      return this.props.scrollTop;
    }
    /**
     * Load a configurator
     * [at]returns {Object}
     * @private
     */
  }, {
    key: "_createConfigurator",
    value: function() {
      throw new Error("Cannot invoke abstract method _createConfigurator");
    }
  }]), t;
}();
YO(Od.prototype);
function P8e(t) {
  var e = R8e();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function R8e() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var CW = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = P8e(r);
  function r(n, s) {
    var a, o;
    dr(this, r), o = e.call(this), o.body = n, o.defaultOptions = {
      rtl: !1,
      showCurrentTime: !0,
      alignCurrentTime: void 0,
      moment: Ti,
      locales: Xd,
      locale: "en"
    }, o.options = G.extend({}, o.defaultOptions), o.setOptions(s), o.options.locales = G.extend({}, Xd, o.options.locales);
    var l = o.defaultOptions.locales[o.defaultOptions.locale];
    return Le(a = xn(o.options.locales)).call(a, function(u) {
      o.options.locales[u] = G.extend({}, l, o.options.locales[u]);
    }), o.offset = 0, o._create(), o;
  }
  return hr(r, [{
    key: "_create",
    value: function() {
      var s = document.createElement("div");
      s.className = "vis-current-time", s.style.position = "absolute", s.style.top = "0px", s.style.height = "100%", this.bar = s;
    }
    /**
     * Destroy the CurrentTime bar
     */
  }, {
    key: "destroy",
    value: function() {
      this.options.showCurrentTime = !1, this.redraw(), this.body = null;
    }
    /**
     * Set options for the component. Options will be merged in current options.
     * @param {Object} options  Available parameters:
     *                          {boolean} [showCurrentTime]
     *                          {String}  [alignCurrentTime]
     */
  }, {
    key: "setOptions",
    value: function(s) {
      s && G.selectiveExtend(["rtl", "showCurrentTime", "alignCurrentTime", "moment", "locale", "locales"], this.options, s);
    }
    /**
     * Repaint the component
     * @return {boolean} Returns true if the component is resized
     */
  }, {
    key: "redraw",
    value: function() {
      if (this.options.showCurrentTime) {
        var s, a, o = this.body.dom.backgroundVertical;
        this.bar.parentNode != o && (this.bar.parentNode && this.bar.parentNode.removeChild(this.bar), o.appendChild(this.bar), this.start());
        var l = this.options.moment(Bi() + this.offset);
        this.options.alignCurrentTime && (l = l.startOf(this.options.alignCurrentTime));
        var u = this.body.util.toScreen(l), c = this.options.locales[this.options.locale];
        c || (this.warned || (console.warn("WARNING: options.locales['".concat(this.options.locale, "'] not found. See https://visjs.github.io/vis-timeline/docs/timeline/#Localization")), this.warned = !0), c = this.options.locales.en);
        var d = Dr(s = Dr(a = "".concat(c.current, " ")).call(a, c.time, ": ")).call(s, l.format("dddd, MMMM Do YYYY, H:mm:ss"));
        d = d.charAt(0).toUpperCase() + d.substring(1), this.options.rtl ? this.bar.style.transform = "translateX(".concat(u * -1, "px)") : this.bar.style.transform = "translateX(".concat(u, "px)"), this.bar.title = d;
      } else
        this.bar.parentNode && this.bar.parentNode.removeChild(this.bar), this.stop();
      return !1;
    }
    /**
     * Start auto refreshing the current time bar
     */
  }, {
    key: "start",
    value: function() {
      var s = this;
      function a() {
        s.stop();
        var o = s.body.range.conversion(s.body.domProps.center.width).scale, l = 1 / o / 10;
        l < 30 && (l = 30), l > 1e3 && (l = 1e3), s.redraw(), s.body.emitter.emit("currentTimeTick"), s.currentTimeTimer = ai(a, l);
      }
      a();
    }
    /**
     * Stop auto refreshing the current time bar
     */
  }, {
    key: "stop",
    value: function() {
      this.currentTimeTimer !== void 0 && (clearTimeout(this.currentTimeTimer), delete this.currentTimeTimer);
    }
    /**
     * Set a current time. This can be used for example to ensure that a client's
     * time is synchronized with a shared server time.
     * @param {Date | string | number} time     A Date, unix timestamp, or
     *                                          ISO date string.
     */
  }, {
    key: "setCurrentTime",
    value: function(s) {
      var a = G.convert(s, "Date").valueOf(), o = Bi();
      this.offset = a - o, this.redraw();
    }
    /**
     * Get the current time.
     * @return {Date} Returns the current time.
     */
  }, {
    key: "getCurrentTime",
    value: function() {
      return new Date(Bi() + this.offset);
    }
  }]), r;
}(Fl), Q$ = {}, M8e = {
  get exports() {
    return Q$;
  },
  set exports(t) {
    Q$ = t;
  }
}, L8e = lt, N8e = Uo.find, O2 = "find", IW = !0;
O2 in [] && Array(1)[O2](function() {
  IW = !1;
});
L8e({ target: "Array", proto: !0, forced: IW }, {
  find: function(e) {
    return N8e(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var F8e = sn, B8e = F8e("Array").find, U8e = Fr, V8e = B8e, sT = Array.prototype, Y8e = function(t) {
  var e = t.find;
  return t === sT || U8e(sT, t) && e === sT.find ? V8e : e;
}, H8e = Y8e, G8e = H8e;
(function(t) {
  t.exports = G8e;
})(M8e);
var W8e = /* @__PURE__ */ rt(Q$), Z$ = {}, j8e = {
  get exports() {
    return Z$;
  },
  set exports(t) {
    Z$ = t;
  }
}, e0 = {}, K8e = {
  get exports() {
    return e0;
  },
  set exports(t) {
    e0 = t;
  }
}, z8e = qt, q8e = z8e(function() {
  if (typeof ArrayBuffer == "function") {
    var t = new ArrayBuffer(8);
    Object.isExtensible(t) && Object.defineProperty(t, "a", { value: 8 });
  }
}), X8e = qt, Q8e = ci, Z8e = Bo, A2 = q8e, Ug = Object.isExtensible, J8e = X8e(function() {
  Ug(1);
}), eKe = J8e || A2 ? function(e) {
  return !Q8e(e) || A2 && Z8e(e) == "ArrayBuffer" ? !1 : Ug ? Ug(e) : !0;
} : Ug, tKe = qt, rKe = !tKe(function() {
  return Object.isExtensible(Object.preventExtensions({}));
}), nKe = lt, iKe = Xt, sKe = $v, aKe = ci, fA = di, oKe = xs.f, C2 = Ov, lKe = kO, pA = eKe, uKe = yb, cKe = rKe, PW = !1, Ao = uKe("meta"), dKe = 0, vA = function(t) {
  oKe(t, Ao, { value: {
    objectID: "O" + dKe++,
    // object ID
    weakData: {}
    // weak collections IDs
  } });
}, hKe = function(t, e) {
  if (!aKe(t))
    return typeof t == "symbol" ? t : (typeof t == "string" ? "S" : "P") + t;
  if (!fA(t, Ao)) {
    if (!pA(t))
      return "F";
    if (!e)
      return "E";
    vA(t);
  }
  return t[Ao].objectID;
}, fKe = function(t, e) {
  if (!fA(t, Ao)) {
    if (!pA(t))
      return !0;
    if (!e)
      return !1;
    vA(t);
  }
  return t[Ao].weakData;
}, pKe = function(t) {
  return cKe && PW && pA(t) && !fA(t, Ao) && vA(t), t;
}, vKe = function() {
  mKe.enable = function() {
  }, PW = !0;
  var t = C2.f, e = iKe([].splice), r = {};
  r[Ao] = 1, t(r).length && (C2.f = function(n) {
    for (var s = t(n), a = 0, o = s.length; a < o; a++)
      if (s[a] === Ao) {
        e(s, a, 1);
        break;
      }
    return s;
  }, nKe({ target: "Object", stat: !0, forced: !0 }, {
    getOwnPropertyNames: lKe.f
  }));
}, mKe = K8e.exports = {
  enable: vKe,
  fastKey: hKe,
  getWeakData: fKe,
  onFreeze: pKe
};
sKe[Ao] = !0;
var gKe = xv, yKe = ws, bKe = ea, _Ke = Sh, wKe = o5, TKe = ta, I2 = Fr, xKe = l5, SKe = Cb, P2 = a5, EKe = TypeError, Vg = function(t, e) {
  this.stopped = t, this.result = e;
}, R2 = Vg.prototype, RW = function(t, e, r) {
  var n = r && r.that, s = !!(r && r.AS_ENTRIES), a = !!(r && r.IS_RECORD), o = !!(r && r.IS_ITERATOR), l = !!(r && r.INTERRUPTED), u = gKe(e, n), c, d, h, f, p, m, b, y = function(x) {
    return c && P2(c, "normal", x), new Vg(!0, x);
  }, _ = function(x) {
    return s ? (bKe(x), l ? u(x[0], x[1], y) : u(x[0], x[1])) : l ? u(x, y) : u(x);
  };
  if (a)
    c = t.iterator;
  else if (o)
    c = t;
  else {
    if (d = SKe(t), !d)
      throw EKe(_Ke(t) + " is not iterable");
    if (wKe(d)) {
      for (h = 0, f = TKe(t); f > h; h++)
        if (p = _(t[h]), p && I2(R2, p))
          return p;
      return new Vg(!1);
    }
    c = xKe(t, d);
  }
  for (m = a ? t.next : c.next; !(b = yKe(m, c)).done; ) {
    try {
      p = _(b.value);
    } catch (x) {
      P2(c, "throw", x);
    }
    if (typeof p == "object" && p && I2(R2, p))
      return p;
  }
  return new Vg(!1);
}, $Ke = Fr, kKe = TypeError, MW = function(t, e) {
  if ($Ke(e, t))
    return t;
  throw kKe("Incorrect invocation");
}, DKe = lt, OKe = $n, AKe = e0, CKe = qt, IKe = Eh, PKe = RW, RKe = MW, MKe = kn, LKe = ci, NKe = Oh, FKe = xs.f, BKe = Uo.forEach, UKe = pn, LW = Pv, VKe = LW.set, YKe = LW.getterFor, HKe = function(t, e, r) {
  var n = t.indexOf("Map") !== -1, s = t.indexOf("Weak") !== -1, a = n ? "set" : "add", o = OKe[t], l = o && o.prototype, u = {}, c;
  if (!UKe || !MKe(o) || !(s || l.forEach && !CKe(function() {
    new o().entries().next();
  })))
    c = r.getConstructor(e, t, n, a), AKe.enable();
  else {
    c = e(function(f, p) {
      VKe(RKe(f, d), {
        type: t,
        collection: new o()
      }), p != null && PKe(p, f[a], { that: f, AS_ENTRIES: n });
    });
    var d = c.prototype, h = YKe(t);
    BKe(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function(f) {
      var p = f == "add" || f == "set";
      f in l && !(s && f == "clear") && IKe(d, f, function(m, b) {
        var y = h(this).collection;
        if (!p && s && !LKe(m))
          return f == "get" ? void 0 : !1;
        var _ = y[f](m === 0 ? 0 : m, b);
        return p ? this : _;
      });
    }), s || FKe(d, "size", {
      configurable: !0,
      get: function() {
        return h(this).collection.size;
      }
    });
  }
  return NKe(c, t, !1, !0), u[t] = c, DKe({ global: !0, forced: !0 }, u), s || r.setStrong(c, t, n), c;
}, GKe = Cv, WKe = function(t, e, r) {
  for (var n in e)
    r && r.unsafe && t[n] ? t[n] = e[n] : GKe(t, n, e[n], r);
  return t;
}, jKe = Ts, KKe = DO, zKe = Jr, qKe = pn, M2 = zKe("species"), XKe = function(t) {
  var e = jKe(t);
  qKe && e && !e[M2] && KKe(e, M2, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, QKe = kh, ZKe = DO, L2 = WKe, JKe = xv, e7e = MW, t7e = gb, r7e = RW, n7e = LO, pg = NO, i7e = XKe, nf = pn, N2 = e0.fastKey, NW = Pv, F2 = NW.set, aT = NW.getterFor, s7e = {
  getConstructor: function(t, e, r, n) {
    var s = t(function(c, d) {
      e7e(c, a), F2(c, {
        type: e,
        index: QKe(null),
        first: void 0,
        last: void 0,
        size: 0
      }), nf || (c.size = 0), t7e(d) || r7e(d, c[n], { that: c, AS_ENTRIES: r });
    }), a = s.prototype, o = aT(e), l = function(c, d, h) {
      var f = o(c), p = u(c, d), m, b;
      return p ? p.value = h : (f.last = p = {
        index: b = N2(d, !0),
        key: d,
        value: h,
        previous: m = f.last,
        next: void 0,
        removed: !1
      }, f.first || (f.first = p), m && (m.next = p), nf ? f.size++ : c.size++, b !== "F" && (f.index[b] = p)), c;
    }, u = function(c, d) {
      var h = o(c), f = N2(d), p;
      if (f !== "F")
        return h.index[f];
      for (p = h.first; p; p = p.next)
        if (p.key == d)
          return p;
    };
    return L2(a, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function() {
        for (var d = this, h = o(d), f = h.index, p = h.first; p; )
          p.removed = !0, p.previous && (p.previous = p.previous.next = void 0), delete f[p.index], p = p.next;
        h.first = h.last = void 0, nf ? h.size = 0 : d.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      delete: function(c) {
        var d = this, h = o(d), f = u(d, c);
        if (f) {
          var p = f.next, m = f.previous;
          delete h.index[f.index], f.removed = !0, m && (m.next = p), p && (p.previous = m), h.first == f && (h.first = p), h.last == f && (h.last = m), nf ? h.size-- : d.size--;
        }
        return !!f;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function(d) {
        for (var h = o(this), f = JKe(d, arguments.length > 1 ? arguments[1] : void 0), p; p = p ? p.next : h.first; )
          for (f(p.value, p.key, this); p && p.removed; )
            p = p.previous;
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function(d) {
        return !!u(this, d);
      }
    }), L2(a, r ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function(d) {
        var h = u(this, d);
        return h && h.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function(d, h) {
        return l(this, d === 0 ? 0 : d, h);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function(d) {
        return l(this, d = d === 0 ? 0 : d, d);
      }
    }), nf && ZKe(a, "size", {
      configurable: !0,
      get: function() {
        return o(this).size;
      }
    }), s;
  },
  setStrong: function(t, e, r) {
    var n = e + " Iterator", s = aT(e), a = aT(n);
    n7e(t, e, function(o, l) {
      F2(this, {
        type: n,
        target: o,
        state: s(o),
        kind: l,
        last: void 0
      });
    }, function() {
      for (var o = a(this), l = o.kind, u = o.last; u && u.removed; )
        u = u.previous;
      return !o.target || !(o.last = u = u ? u.next : o.state.first) ? (o.target = void 0, pg(void 0, !0)) : l == "keys" ? pg(u.key, !1) : l == "values" ? pg(u.value, !1) : pg([u.key, u.value], !1);
    }, r ? "entries" : "values", !r, !0), i7e(e);
  }
}, a7e = HKe, o7e = s7e;
a7e("Set", function(t) {
  return function() {
    return t(this, arguments.length ? arguments[0] : void 0);
  };
}, o7e);
var l7e = mr, u7e = l7e.Set, c7e = u7e, d7e = c7e;
(function(t) {
  t.exports = d7e;
})(j8e);
var t0 = /* @__PURE__ */ rt(Z$), J$ = {}, h7e = {
  get exports() {
    return J$;
  },
  set exports(t) {
    J$ = t;
  }
}, f7e = lt, p7e = Uo.findIndex, B2 = "findIndex", FW = !0;
B2 in [] && Array(1)[B2](function() {
  FW = !1;
});
f7e({ target: "Array", proto: !0, forced: FW }, {
  findIndex: function(e) {
    return p7e(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var v7e = sn, m7e = v7e("Array").findIndex, g7e = Fr, y7e = m7e, oT = Array.prototype, b7e = function(t) {
  var e = t.findIndex;
  return t === oT || g7e(oT, t) && e === oT.findIndex ? y7e : e;
}, _7e = b7e, w7e = _7e;
(function(t) {
  t.exports = w7e;
})(h7e);
var T7e = /* @__PURE__ */ rt(J$);
function x7e(t, e) {
  var r = typeof Nl < "u" && Vo(t) || t["@@iterator"];
  if (!r) {
    if ($t(t) || (r = S7e(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, s = function() {
      };
      return { s, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(c) {
        throw c;
      }, f: s };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return { s: function() {
    r = r.call(t);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    o = !0, l = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (o)
        throw l;
    }
  } };
}
function S7e(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return U2(t, e);
    var n = hi(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return vc(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return U2(t, e);
  }
}
function U2(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
var Ri = 1e-3;
function E7e(t) {
  wn(t).call(t, function(e, r) {
    return e.data.start - r.data.start;
  });
}
function $7e(t) {
  wn(t).call(t, function(e, r) {
    var n = "end" in e.data ? e.data.end : e.data.start, s = "end" in r.data ? r.data.end : r.data.start;
    return n - s;
  });
}
function V2(t, e, r, n) {
  var s = mA(t, e.item, !1, function(a) {
    return a.stack && (r || a.top === null);
  }, function(a) {
    return a.stack;
  }, function(a) {
    return e.axis;
  }, n);
  return s === null;
}
function k7e(t, e, r) {
  var n = mA(t, e.item, !1, function(s) {
    return s.stack;
  }, function(s) {
    return !0;
  }, function(s) {
    return s.baseTop;
  });
  r.height = n - r.top + 0.5 * e.item.vertical;
}
function D7e(t, e, r, n) {
  for (var s = 0; s < t.length; s++)
    if (t[s].data.subgroup == null)
      t[s].top = e.item.vertical;
    else if (t[s].data.subgroup !== void 0 && n) {
      var a = 0;
      for (var o in r)
        r.hasOwnProperty(o) && r[o].visible == !0 && r[o].index < r[t[s].data.subgroup].index && (a += r[o].height, r[t[s].data.subgroup].top = a);
      t[s].top = a + 0.5 * e.item.vertical;
    }
  n || O7e(t, e, r);
}
function O7e(t, e, r) {
  var n;
  mA(wn(n = UO(r)).call(n, function(a, o) {
    return a.index > o.index ? 1 : a.index < o.index ? -1 : 0;
  }), {
    vertical: 0
  }, !0, function(a) {
    return !0;
  }, function(a) {
    return !0;
  }, function(a) {
    return 0;
  });
  for (var s = 0; s < t.length; s++)
    t[s].data.subgroup !== void 0 && (t[s].top = r[t[s].data.subgroup].top + 0.5 * e.item.vertical);
}
function Y2(t, e, r) {
  var n = !1, s = [];
  for (var a in r)
    r[a].hasOwnProperty("index") ? s[r[a].index] = a : s.push(a);
  for (var o = 0; o < s.length; o++)
    if (a = s[o], r.hasOwnProperty(a)) {
      n = n || r[a].stack, r[a].top = 0;
      for (var l in r)
        r[l].visible && r[a].index > r[l].index && (r[a].top += r[l].height);
      for (var u = t[a], c = 0; c < u.length; c++)
        u[c].data.subgroup !== void 0 && (u[c].top = r[u[c].data.subgroup].top + 0.5 * e.item.vertical, r[a].stack && (u[c].baseTop = u[c].top));
      n && r[a].stack && k7e(t[a], e, r[a]);
    }
}
function mA(t, e, r, n, s, a, o) {
  var l = function($) {
    return $.start;
  }, u = function($) {
    return $.end;
  };
  if (!r) {
    var c = !!(t[0] && t[0].options.rtl);
    c ? l = function($) {
      return $.right;
    } : l = function($) {
      return $.left;
    }, u = function($) {
      return l($) + $.width + e.horizontal;
    };
  }
  var d = [], h = [], f = null, p = 0, m = x7e(t), b;
  try {
    var y = function() {
      var $ = b.value;
      if (n($))
        d.push($);
      else if (s($)) {
        var O = l($);
        f !== null && O < f - Ri && (p = 0), f = O, p = vg(h, function(P) {
          return l(P) - Ri > O;
        }, p), xi(h).call(h, p, 0, $), p++;
      }
    };
    for (m.s(); !(b = m.n()).done; )
      y();
  } catch (R) {
    m.e(R);
  } finally {
    m.f();
  }
  f = null;
  var _ = null;
  p = 0;
  for (var x = 0, T = 0, k = 0, E = function() {
    var $, O, P = d.shift();
    P.top = a(P);
    var N = l(P), I = u(P);
    f !== null && N < f - Ri && (x = 0, T = 0, p = 0, _ = null), f = N, x = vg(h, function(H) {
      return N < u(H) - Ri;
    }, x), (_ === null || _ < I - Ri) && (T = vg(h, function(H) {
      return I < l(H) - Ri;
    }, Math.max(x, T))), _ !== null && _ - Ri > I && (T = C7e(h, function(H) {
      return I + Ri >= l(H);
    }, x, horizontalOVerlapEndIndex) + 1);
    for (var B = wn($ = At(O = hi(h).call(h, x, T)).call(O, function(H) {
      return N < u(H) - Ri && I - Ri > l(H);
    })).call($, function(H, A) {
      return H.top - A.top;
    }), W = 0; W < B.length; W++) {
      var Q = B[W];
      A7e(P, Q, e) && (P.top = Q.top + Q.height + e.vertical);
    }
    s(P) && (p = vg(h, function(H) {
      return l(H) - Ri > N;
    }, p), xi(h).call(h, p, 0, P), p++);
    var te = P.top + P.height;
    if (te > k && (k = te), o && o())
      return {
        v: null
      };
  }; d.length > 0; ) {
    var F = E();
    if (mt(F) === "object")
      return F.v;
  }
  return k;
}
function A7e(t, e, r) {
  return t.top - r.vertical + Ri < e.top + e.height && t.top + t.height + r.vertical - Ri > e.top;
}
function vg(t, e, r) {
  var n;
  r || (r = 0);
  var s = T7e(n = hi(t).call(t, r)).call(n, e);
  return s === -1 ? t.length : s + r;
}
function C7e(t, e, r, n) {
  for (r || (r = 0), n || (n = t.length), i = n - 1; i >= r; i--)
    if (e(t[i]))
      return i;
  return r - 1;
}
var I7e = "__ungrouped__", P7e = "__background__", H2 = {
  UNGROUPED: I7e,
  BACKGROUND: P7e
}, ek = /* @__PURE__ */ function() {
  function t(e, r, n) {
    var s = this;
    if (dr(this, t), this.groupId = e, this.subgroups = {}, this.subgroupStack = {}, this.subgroupStackAll = !1, this.subgroupVisibility = {}, this.doInnerStack = !1, this.shouldBailStackItems = !1, this.subgroupIndex = 0, this.subgroupOrderer = r && r.subgroupOrder, this.itemSet = n, this.isVisible = null, this.stackDirty = !0, this._disposeCallbacks = [], r && r.nestedGroups && (this.nestedGroups = r.nestedGroups, r.showNested == !1 ? this.showNested = !1 : this.showNested = !0), r && r.subgroupStack)
      if (typeof r.subgroupStack == "boolean")
        this.doInnerStack = r.subgroupStack, this.subgroupStackAll = r.subgroupStack;
      else
        for (var a in r.subgroupStack)
          this.subgroupStack[a] = r.subgroupStack[a], this.doInnerStack = this.doInnerStack || r.subgroupStack[a];
    r && r.heightMode ? this.heightMode = r.heightMode : this.heightMode = n.options.groupHeightMode, this.nestedInGroup = null, this.dom = {}, this.props = {
      label: {
        width: 0,
        height: 0
      }
    }, this.className = null, this.items = {}, this.visibleItems = [], this.itemsInRange = [], this.orderedItems = {
      byStart: [],
      byEnd: []
    }, this.checkRangedItems = !1;
    var o = function() {
      s.checkRangedItems = !0;
    };
    this.itemSet.body.emitter.on("checkRangedItems", o), this._disposeCallbacks.push(function() {
      s.itemSet.body.emitter.off("checkRangedItems", o);
    }), this._create(), this.setData(r);
  }
  return hr(t, [{
    key: "_create",
    value: function() {
      var r = document.createElement("div");
      this.itemSet.options.groupEditable.order ? r.className = "vis-label draggable" : r.className = "vis-label", this.dom.label = r;
      var n = document.createElement("div");
      n.className = "vis-inner", r.appendChild(n), this.dom.inner = n;
      var s = document.createElement("div");
      s.className = "vis-group", s["vis-group"] = this, this.dom.foreground = s, this.dom.background = document.createElement("div"), this.dom.background.className = "vis-group", this.dom.axis = document.createElement("div"), this.dom.axis.className = "vis-group", this.dom.marker = document.createElement("div"), this.dom.marker.style.visibility = "hidden", this.dom.marker.style.position = "absolute", this.dom.marker.innerHTML = "", this.dom.background.appendChild(this.dom.marker);
    }
    /**
     * Set the group data for this group
     * @param {Object} data   Group data, can contain properties content and className
     */
  }, {
    key: "setData",
    value: function(r) {
      if (!this.itemSet.groupTouchParams.isDragging) {
        var n, s;
        if (r && r.subgroupVisibility)
          for (var a in r.subgroupVisibility)
            this.subgroupVisibility[a] = r.subgroupVisibility[a];
        if (this.itemSet.options && this.itemSet.options.groupTemplate) {
          var o;
          s = de(o = this.itemSet.options.groupTemplate).call(o, this), n = s(r, this.dom.inner);
        } else
          n = r && r.content;
        if (n instanceof Element) {
          for (; this.dom.inner.firstChild; )
            this.dom.inner.removeChild(this.dom.inner.firstChild);
          this.dom.inner.appendChild(n);
        } else
          n instanceof Object && n.isReactComponent || (n instanceof Object ? s(r, this.dom.inner) : n != null ? this.dom.inner.innerHTML = G.xss(n) : this.dom.inner.innerHTML = G.xss(this.groupId || ""));
        this.dom.label.title = r && r.title || "", this.dom.inner.firstChild ? G.removeClassName(this.dom.inner, "vis-hidden") : G.addClassName(this.dom.inner, "vis-hidden"), r && r.nestedGroups ? ((!this.nestedGroups || this.nestedGroups != r.nestedGroups) && (this.nestedGroups = r.nestedGroups), (r.showNested !== void 0 || this.showNested === void 0) && (r.showNested == !1 ? this.showNested = !1 : this.showNested = !0), G.addClassName(this.dom.label, "vis-nesting-group"), this.showNested ? (G.removeClassName(this.dom.label, "collapsed"), G.addClassName(this.dom.label, "expanded")) : (G.removeClassName(this.dom.label, "expanded"), G.addClassName(this.dom.label, "collapsed"))) : this.nestedGroups && (this.nestedGroups = null, G.removeClassName(this.dom.label, "collapsed"), G.removeClassName(this.dom.label, "expanded"), G.removeClassName(this.dom.label, "vis-nesting-group")), r && (r.treeLevel || r.nestedInGroup) ? (G.addClassName(this.dom.label, "vis-nested-group"), r.treeLevel ? G.addClassName(this.dom.label, "vis-group-level-" + r.treeLevel) : G.addClassName(this.dom.label, "vis-group-level-unknown-but-gte1")) : G.addClassName(this.dom.label, "vis-group-level-0");
        var l = r && r.className || null;
        l != this.className && (this.className && (G.removeClassName(this.dom.label, this.className), G.removeClassName(this.dom.foreground, this.className), G.removeClassName(this.dom.background, this.className), G.removeClassName(this.dom.axis, this.className)), G.addClassName(this.dom.label, l), G.addClassName(this.dom.foreground, l), G.addClassName(this.dom.background, l), G.addClassName(this.dom.axis, l), this.className = l), this.style && (G.removeCssText(this.dom.label, this.style), this.style = null), r && r.style && (G.addCssText(this.dom.label, r.style), this.style = r.style);
      }
    }
    /**
     * Get the width of the group label
     * @return {number} width
     */
  }, {
    key: "getLabelWidth",
    value: function() {
      return this.props.label.width;
    }
    /**
     * check if group has had an initial height hange
     * @returns {boolean} 
     */
  }, {
    key: "_didMarkerHeightChange",
    value: function() {
      var r = this.dom.marker.clientHeight;
      if (r != this.lastMarkerHeight) {
        this.lastMarkerHeight = r;
        var n = {}, s = 0;
        Le(G).call(G, this.items, function(u, c) {
          if (u.dirty = !0, u.displayed) {
            var d = !0;
            n[c] = u.redraw(d), s = n[c].length;
          }
        });
        var a = s > 0;
        if (a)
          for (var o = function(c) {
            Le(G).call(G, n, function(d) {
              d[c]();
            });
          }, l = 0; l < s; l++)
            o(l);
        return !0;
      } else
        return !1;
    }
    /**
     * calculate group dimentions and position
     * @param {number} pixels
     */
  }, {
    key: "_calculateGroupSizeAndPosition",
    value: function() {
      var r = this.dom.foreground, n = r.offsetTop, s = r.offsetLeft, a = r.offsetWidth;
      this.top = n, this.right = s, this.width = a;
    }
    /**
     * checks if should bail redraw of items
     * @returns {boolean} should bail 
     */
  }, {
    key: "_shouldBailItemsRedraw",
    value: function() {
      var r = this, n = this.itemSet.options.onTimeout, s = {
        relativeBailingTime: this.itemSet.itemsSettingTime,
        bailTimeMs: n && n.timeoutMs,
        userBailFunction: n && n.callback,
        shouldBailStackItems: this.shouldBailStackItems
      }, a = null;
      if (!this.itemSet.initialDrawDone) {
        if (s.shouldBailStackItems)
          return !0;
        Math.abs(Bi() - new Date(s.relativeBailingTime)) > s.bailTimeMs && (s.userBailFunction && this.itemSet.userContinueNotBail == null ? s.userBailFunction(function(o) {
          r.itemSet.userContinueNotBail = o, a = !o;
        }) : r.itemSet.userContinueNotBail == !1 ? a = !0 : a = !1);
      }
      return a;
    }
    /**
     * redraws items
     * @param {boolean} forceRestack
     * @param {boolean} lastIsVisible
     * @param {number} margin
     * @param {object} range
     * @private
     */
  }, {
    key: "_redrawItems",
    value: function(r, n, s, a) {
      var o = this, l = r || this.stackDirty || this.isVisible && !n;
      if (l) {
        var u, c, d, h, f, p, m = {
          byEnd: At(u = this.orderedItems.byEnd).call(u, function(I) {
            return !I.isCluster;
          }),
          byStart: At(c = this.orderedItems.byStart).call(c, function(I) {
            return !I.isCluster;
          })
        }, b = {
          byEnd: Vs(new t0(At(d = ln(h = this.orderedItems.byEnd).call(h, function(I) {
            return I.cluster;
          })).call(d, function(I) {
            return !!I;
          }))),
          byStart: Vs(new t0(At(f = ln(p = this.orderedItems.byStart).call(p, function(I) {
            return I.cluster;
          })).call(f, function(I) {
            return !!I;
          })))
        }, y = function() {
          var B, W, Q, te = o._updateItemsInRange(m, At(B = o.visibleItems).call(B, function(A) {
            return !A.isCluster;
          }), a), H = o._updateClustersInRange(b, At(W = o.visibleItems).call(W, function(A) {
            return A.isCluster;
          }), a);
          return Dr(Q = []).call(Q, Vs(te), Vs(H));
        }, _ = function(B) {
          var W = {}, Q = function(A) {
            var V, M = At(V = o.visibleItems).call(V, function(Z) {
              return Z.data.subgroup === A;
            });
            W[A] = B ? wn(M).call(M, function(Z, U) {
              return B(Z.data, U.data);
            }) : M;
          };
          for (var te in o.subgroups)
            Q(te);
          return W;
        };
        if (typeof this.itemSet.options.order == "function") {
          var x = this;
          if (this.doInnerStack && this.itemSet.options.stackSubgroups) {
            var T = _(this.itemSet.options.order);
            Y2(T, s, this.subgroups), this.visibleItems = y(), this._updateSubGroupHeights(s);
          } else {
            var k, E, F, R;
            this.visibleItems = y(), this._updateSubGroupHeights(s);
            var $ = wn(k = At(E = hi(F = this.visibleItems).call(F)).call(E, function(I) {
              return I.isCluster || !I.isCluster && !I.cluster;
            })).call(k, function(I, B) {
              return x.itemSet.options.order(I.data, B.data);
            });
            this.shouldBailStackItems = V2($, s, !0, de(R = this._shouldBailItemsRedraw).call(R, this));
          }
        } else if (this.visibleItems = y(), this._updateSubGroupHeights(s), this.itemSet.options.stack)
          if (this.doInnerStack && this.itemSet.options.stackSubgroups) {
            var O = _();
            Y2(O, s, this.subgroups);
          } else {
            var P;
            this.shouldBailStackItems = V2(this.visibleItems, s, !0, de(P = this._shouldBailItemsRedraw).call(P, this));
          }
        else
          D7e(this.visibleItems, s, this.subgroups, this.itemSet.options.stackSubgroups);
        for (var N = 0; N < this.visibleItems.length; N++)
          this.visibleItems[N].repositionX(), this.subgroupVisibility[this.visibleItems[N].data.subgroup] !== void 0 && (this.subgroupVisibility[this.visibleItems[N].data.subgroup] || this.visibleItems[N].hide());
        this.itemSet.options.cluster && Le(G).call(G, this.items, function(I) {
          I.cluster && I.displayed && I.hide();
        }), this.shouldBailStackItems && this.itemSet.body.emitter.emit("destroyTimeline"), this.stackDirty = !1;
      }
    }
    /**
     * check if group resized
     * @param {boolean} resized
     * @param {number} height
     * @return {boolean} did resize
     */
  }, {
    key: "_didResize",
    value: function(r, n) {
      r = G.updateProperty(this, "height", n) || r;
      var s = this.dom.inner.clientWidth, a = this.dom.inner.clientHeight;
      return r = G.updateProperty(this.props.label, "width", s) || r, r = G.updateProperty(this.props.label, "height", a) || r, r;
    }
    /**
     * apply group height
     * @param {number} height
     */
  }, {
    key: "_applyGroupHeight",
    value: function(r) {
      this.dom.background.style.height = "".concat(r, "px"), this.dom.foreground.style.height = "".concat(r, "px"), this.dom.label.style.height = "".concat(r, "px");
    }
    /**
     * update vertical position of items after they are re-stacked and the height of the group is calculated
     * @param {number} margin
     */
  }, {
    key: "_updateItemsVerticalPosition",
    value: function(r) {
      for (var n = 0, s = this.visibleItems.length; n < s; n++) {
        var a = this.visibleItems[n];
        a.repositionY(r), !this.isVisible && this.groupId != H2.BACKGROUND && a.displayed && a.hide();
      }
    }
    /**
     * Repaint this group
     * @param {{start: number, end: number}} range
     * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
     * @param {boolean} [forceRestack=false]  Force restacking of all items
     * @param {boolean} [returnQueue=false]  return the queue or if the group resized
     * @return {boolean} Returns true if the group is resized or the redraw queue if returnQueue=true
     */
  }, {
    key: "redraw",
    value: function(r, n, s, a) {
      var o = this, l, u, c, d, h, f = !1, p = this.isVisible, m, b = [
        function() {
          s = o._didMarkerHeightChange.call(o) || s;
        },
        // recalculate the height of the subgroups
        de(l = this._updateSubGroupHeights).call(l, this, n),
        // calculate actual size and position
        de(u = this._calculateGroupSizeAndPosition).call(u, this),
        function() {
          var _;
          o.isVisible = de(_ = o._isGroupVisible).call(_, o)(r, n);
        },
        function() {
          var _;
          de(_ = o._redrawItems).call(_, o)(s, p, n, r);
        },
        // update subgroups
        de(c = this._updateSubgroupsSizes).call(c, this),
        function() {
          var _;
          m = de(_ = o._calculateHeight).call(_, o)(n);
        },
        // calculate actual size and position again
        de(d = this._calculateGroupSizeAndPosition).call(d, this),
        function() {
          var _;
          f = de(_ = o._didResize).call(_, o)(f, m);
        },
        function() {
          var _;
          de(_ = o._applyGroupHeight).call(_, o)(m);
        },
        function() {
          var _;
          de(_ = o._updateItemsVerticalPosition).call(_, o)(n);
        },
        de(h = function() {
          return !o.isVisible && o.height && (f = !1), f;
        }).call(h, this)
      ];
      if (a)
        return b;
      var y;
      return Le(b).call(b, function(_) {
        y = _();
      }), y;
    }
    /**
     * recalculate the height of the subgroups
     *
     * @param {{item: timeline.Item}} margin
     * @private
     */
  }, {
    key: "_updateSubGroupHeights",
    value: function(r) {
      var n = this;
      if (xn(this.subgroups).length > 0) {
        var s = this;
        this._resetSubgroups(), Le(G).call(G, this.visibleItems, function(a) {
          a.data.subgroup !== void 0 && (s.subgroups[a.data.subgroup].height = Math.max(s.subgroups[a.data.subgroup].height, a.height + r.item.vertical), s.subgroups[a.data.subgroup].visible = typeof n.subgroupVisibility[a.data.subgroup] > "u" ? !0 : !!n.subgroupVisibility[a.data.subgroup]);
        });
      }
    }
    /**
     * check if group is visible
     *
     * @param {timeline.Range} range
     * @param {{axis: timeline.DataAxis}} margin
     * @returns {boolean} is visible
     * @private
     */
  }, {
    key: "_isGroupVisible",
    value: function(r, n) {
      return this.top <= r.body.domProps.centerContainer.height - r.body.domProps.scrollTop + n.axis && this.top + this.height + n.axis >= -r.body.domProps.scrollTop;
    }
    /**
     * recalculate the height of the group
     * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
     * @returns {number} Returns the height
     * @private
     */
  }, {
    key: "_calculateHeight",
    value: function(r) {
      var n, s;
      if (this.heightMode === "fixed" ? s = G.toArray(this.items) : s = this.visibleItems, s.length > 0) {
        var a = s[0].top, o = s[0].top + s[0].height;
        if (Le(G).call(G, s, function(u) {
          a = Math.min(a, u.top), o = Math.max(o, u.top + u.height);
        }), a > r.axis) {
          var l = a - r.axis;
          o -= l, Le(G).call(G, s, function(u) {
            u.top -= l;
          });
        }
        n = Math.ceil(o + r.item.vertical / 2), this.heightMode !== "fitItems" && (n = Math.max(n, this.props.label.height));
      } else
        n = this.props.label.height;
      return n;
    }
    /**
     * Show this group: attach to the DOM
     */
  }, {
    key: "show",
    value: function() {
      this.dom.label.parentNode || this.itemSet.dom.labelSet.appendChild(this.dom.label), this.dom.foreground.parentNode || this.itemSet.dom.foreground.appendChild(this.dom.foreground), this.dom.background.parentNode || this.itemSet.dom.background.appendChild(this.dom.background), this.dom.axis.parentNode || this.itemSet.dom.axis.appendChild(this.dom.axis);
    }
    /**
     * Hide this group: remove from the DOM
     */
  }, {
    key: "hide",
    value: function() {
      var r = this.dom.label;
      r.parentNode && r.parentNode.removeChild(r);
      var n = this.dom.foreground;
      n.parentNode && n.parentNode.removeChild(n);
      var s = this.dom.background;
      s.parentNode && s.parentNode.removeChild(s);
      var a = this.dom.axis;
      a.parentNode && a.parentNode.removeChild(a);
    }
    /**
     * Add an item to the group
     * @param {Item} item
     */
  }, {
    key: "add",
    value: function(r) {
      var n;
      if (this.items[r.id] = r, r.setParent(this), this.stackDirty = !0, r.data.subgroup !== void 0 && (this._addToSubgroup(r), this.orderSubgroups()), !Cl(n = this.visibleItems).call(n, r)) {
        var s = this.itemSet.body.range;
        this._checkIfVisible(r, this.visibleItems, s);
      }
    }
    /**
     * add item to subgroup
     * @param {object} item
     * @param {string} subgroupId
     */
  }, {
    key: "_addToSubgroup",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r.data.subgroup;
      n != null && this.subgroups[n] === void 0 && (this.subgroups[n] = {
        height: 0,
        top: 0,
        start: r.data.start,
        end: r.data.end || r.data.start,
        visible: !1,
        index: this.subgroupIndex,
        items: [],
        stack: this.subgroupStackAll || this.subgroupStack[n] || !1
      }, this.subgroupIndex++), new Date(r.data.start) < new Date(this.subgroups[n].start) && (this.subgroups[n].start = r.data.start);
      var s = r.data.end || r.data.start;
      new Date(s) > new Date(this.subgroups[n].end) && (this.subgroups[n].end = s), this.subgroups[n].items.push(r);
    }
    /**
     * update subgroup sizes
     */
  }, {
    key: "_updateSubgroupsSizes",
    value: function() {
      var r = this;
      if (r.subgroups) {
        var n = function() {
          var o, l = r.subgroups[s].items[0].data.end || r.subgroups[s].items[0].data.start, u = r.subgroups[s].items[0].data.start, c = l - 1;
          Le(o = r.subgroups[s].items).call(o, function(d) {
            new Date(d.data.start) < new Date(u) && (u = d.data.start);
            var h = d.data.end || d.data.start;
            new Date(h) > new Date(c) && (c = h);
          }), r.subgroups[s].start = u, r.subgroups[s].end = new Date(c - 1);
        };
        for (var s in r.subgroups)
          n();
      }
    }
    /**
     * order subgroups
     */
  }, {
    key: "orderSubgroups",
    value: function() {
      if (this.subgroupOrderer !== void 0) {
        var r = [];
        if (typeof this.subgroupOrderer == "string") {
          for (var n in this.subgroups)
            r.push({
              subgroup: n,
              sortField: this.subgroups[n].items[0].data[this.subgroupOrderer]
            });
          wn(r).call(r, function(o, l) {
            return o.sortField - l.sortField;
          });
        } else if (typeof this.subgroupOrderer == "function") {
          for (var s in this.subgroups)
            r.push(this.subgroups[s].items[0].data);
          wn(r).call(r, this.subgroupOrderer);
        }
        if (r.length > 0)
          for (var a = 0; a < r.length; a++)
            this.subgroups[r[a].subgroup].index = a;
      }
    }
    /**
     * add item to subgroup
     */
  }, {
    key: "_resetSubgroups",
    value: function() {
      for (var r in this.subgroups)
        this.subgroups.hasOwnProperty(r) && (this.subgroups[r].visible = !1, this.subgroups[r].height = 0);
    }
    /**
     * Remove an item from the group
     * @param {Item} item
     */
  }, {
    key: "remove",
    value: function(r) {
      var n, s;
      delete this.items[r.id], r.setParent(null), this.stackDirty = !0;
      var a = lr(n = this.visibleItems).call(n, r);
      a != -1 && xi(s = this.visibleItems).call(s, a, 1), r.data.subgroup !== void 0 && (this._removeFromSubgroup(r), this.orderSubgroups());
    }
    /**
     * remove item from subgroup
     * @param {object} item
     * @param {string} subgroupId
     */
  }, {
    key: "_removeFromSubgroup",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r.data.subgroup;
      if (n != null) {
        var s = this.subgroups[n];
        if (s) {
          var a, o = lr(a = s.items).call(a, r);
          if (o >= 0) {
            var l;
            xi(l = s.items).call(l, o, 1), s.items.length ? this._updateSubgroupsSizes() : delete this.subgroups[n];
          }
        }
      }
    }
    /**
     * Remove an item from the corresponding DataSet
     * @param {Item} item
     */
  }, {
    key: "removeFromDataSet",
    value: function(r) {
      this.itemSet.removeItem(r.id);
    }
    /**
     * Reorder the items
     */
  }, {
    key: "order",
    value: function() {
      for (var r = G.toArray(this.items), n = [], s = [], a = 0; a < r.length; a++)
        r[a].data.end !== void 0 && s.push(r[a]), n.push(r[a]);
      this.orderedItems = {
        byStart: n,
        byEnd: s
      }, E7e(this.orderedItems.byStart), $7e(this.orderedItems.byEnd);
    }
    /**
     * Update the visible items
     * @param {{byStart: Item[], byEnd: Item[]}} orderedItems   All items ordered by start date and by end date
     * @param {Item[]} oldVisibleItems                          The previously visible items.
     * @param {{start: number, end: number}} range              Visible range
     * @return {Item[]} visibleItems                            The new visible items.
     * @private
     */
  }, {
    key: "_updateItemsInRange",
    value: function(r, n, s) {
      var a = [], o = {};
      if (!this.isVisible && this.groupId != H2.BACKGROUND) {
        for (var l = 0; l < n.length; l++) {
          var u = n[l];
          u.displayed && u.hide();
        }
        return a;
      }
      var c = (s.end - s.start) / 4, d = s.start - c, h = s.end + c, f = function(I) {
        return I < d ? -1 : I <= h ? 0 : 1;
      }, p = function(I) {
        var B = I.start, W = I.end;
        return W < d ? -1 : B <= h ? 0 : 1;
      };
      if (n.length > 0)
        for (var m = 0; m < n.length; m++)
          this._checkIfVisibleWithReference(n[m], a, o, s);
      var b = G.binarySearchCustom(r.byStart, f, "data", "start");
      if (this._traceVisible(b, r.byStart, a, o, function(N) {
        return N.data.start < d || N.data.start > h;
      }), this.checkRangedItems == !0) {
        this.checkRangedItems = !1;
        for (var y = 0; y < r.byEnd.length; y++)
          this._checkIfVisibleWithReference(r.byEnd[y], a, o, s);
      } else {
        var _ = G.binarySearchCustom(r.byEnd, p, "data");
        this._traceVisible(_, r.byEnd, a, o, function(N) {
          return N.data.end < d || N.data.start > h;
        });
      }
      for (var x = {}, T = 0, k = 0; k < a.length; k++) {
        var E = a[k];
        if (!E.displayed) {
          var F = !0;
          x[k] = E.redraw(F), T = x[k].length;
        }
      }
      var R = T > 0;
      if (R)
        for (var $ = function(I) {
          Le(G).call(G, x, function(B) {
            B[I]();
          });
        }, O = 0; O < T; O++)
          $(O);
      for (var P = 0; P < a.length; P++)
        a[P].repositionX();
      return a;
    }
    /**
     * trace visible items in group
     * @param {number} initialPos
     * @param {array} items
     * @param {aray} visibleItems
     * @param {object} visibleItemsLookup
     * @param {function} breakCondition
     */
  }, {
    key: "_traceVisible",
    value: function(r, n, s, a, o) {
      if (r != -1) {
        for (var l = r; l >= 0; l--) {
          var u = n[l];
          if (o(u))
            break;
          !(u.isCluster && !u.hasItems()) && !u.cluster && a[u.id] === void 0 && (a[u.id] = !0, s.push(u));
        }
        for (var c = r + 1; c < n.length; c++) {
          var d = n[c];
          if (o(d))
            break;
          !(d.isCluster && !d.hasItems()) && !d.cluster && a[d.id] === void 0 && (a[d.id] = !0, s.push(d));
        }
      }
    }
    /**
     * this function is very similar to the _checkIfInvisible() but it does not
     * return booleans, hides the item if it should not be seen and always adds to
     * the visibleItems.
     * this one is for brute forcing and hiding.
     *
     * @param {Item} item
     * @param {Array} visibleItems
     * @param {{start:number, end:number}} range
     * @private
     */
  }, {
    key: "_checkIfVisible",
    value: function(r, n, s) {
      r.isVisible(s) ? (r.displayed || r.show(), r.repositionX(), n.push(r)) : r.displayed && r.hide();
    }
    /**
     * this function is very similar to the _checkIfInvisible() but it does not
     * return booleans, hides the item if it should not be seen and always adds to
     * the visibleItems.
     * this one is for brute forcing and hiding.
     *
     * @param {Item} item
     * @param {Array.<timeline.Item>} visibleItems
     * @param {Object<number, boolean>} visibleItemsLookup
     * @param {{start:number, end:number}} range
     * @private
     */
  }, {
    key: "_checkIfVisibleWithReference",
    value: function(r, n, s, a) {
      r.isVisible(a) ? s[r.id] === void 0 && (s[r.id] = !0, n.push(r)) : r.displayed && r.hide();
    }
    /**
     * Update the visible items
     * @param {array} orderedClusters 
     * @param {array} oldVisibleClusters                         
     * @param {{start: number, end: number}} range             
     * @return {Item[]} visibleItems                            
     * @private
     */
  }, {
    key: "_updateClustersInRange",
    value: function(r, n, s) {
      var a = [], o = {};
      if (n.length > 0)
        for (var l = 0; l < n.length; l++)
          this._checkIfVisibleWithReference(n[l], a, o, s);
      for (var u = 0; u < r.byStart.length; u++)
        this._checkIfVisibleWithReference(r.byStart[u], a, o, s);
      for (var c = 0; c < r.byEnd.length; c++)
        this._checkIfVisibleWithReference(r.byEnd[c], a, o, s);
      for (var d = {}, h = 0, f = 0; f < a.length; f++) {
        var p = a[f];
        if (!p.displayed) {
          var m = !0;
          d[f] = p.redraw(m), h = d[f].length;
        }
      }
      var b = h > 0;
      if (b)
        for (var y = 0; y < h; y++)
          Le(G).call(G, d, function(x) {
            x[y]();
          });
      for (var _ = 0; _ < a.length; _++)
        a[_].repositionX();
      return a;
    }
    /**
     * change item subgroup
     * @param {object} item
     * @param {string} oldSubgroup
     * @param {string} newSubgroup
     */
  }, {
    key: "changeSubgroup",
    value: function(r, n, s) {
      this._removeFromSubgroup(r, n), this._addToSubgroup(r, s), this.orderSubgroups();
    }
    /**
     * Call this method before you lose the last reference to an instance of this.
     * It will remove listeners etc.
     */
  }, {
    key: "dispose",
    value: function() {
      this.hide();
      for (var r; r = this._disposeCallbacks.pop(); )
        r();
    }
  }]), t;
}();
function R7e(t) {
  var e = M7e();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function M7e() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var BW = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = R7e(r);
  function r(n, s, a) {
    var o;
    return dr(this, r), o = e.call(this, n, s, a), o.width = 0, o.height = 0, o.top = 0, o.left = 0, o;
  }
  return hr(r, [{
    key: "redraw",
    value: function(s, a, o) {
      var l = !1;
      this.visibleItems = this._updateItemsInRange(this.orderedItems, this.visibleItems, s), this.width = this.dom.background.offsetWidth, this.dom.background.style.height = "0";
      for (var u = 0, c = this.visibleItems.length; u < c; u++) {
        var d = this.visibleItems[u];
        d.repositionY(a);
      }
      return l;
    }
    /**
     * Show this group: attach to the DOM
     */
  }, {
    key: "show",
    value: function() {
      this.dom.background.parentNode || this.itemSet.dom.background.appendChild(this.dom.background);
    }
  }]), r;
}(ek);
function L7e(t, e) {
  var r = typeof Nl < "u" && Vo(t) || t["@@iterator"];
  if (!r) {
    if ($t(t) || (r = N7e(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, s = function() {
      };
      return { s, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(c) {
        throw c;
      }, f: s };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return { s: function() {
    r = r.call(t);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    o = !0, l = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (o)
        throw l;
    }
  } };
}
function N7e(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return G2(t, e);
    var n = hi(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return vc(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return G2(t, e);
  }
}
function G2(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
var Ph = /* @__PURE__ */ function() {
  function t(e, r, n) {
    var s, a = this;
    dr(this, t), this.id = null, this.parent = null, this.data = e, this.dom = null, this.conversion = r || {}, this.defaultOptions = {
      locales: Xd,
      locale: "en"
    }, this.options = G.extend({}, this.defaultOptions, n), this.options.locales = G.extend({}, Xd, this.options.locales);
    var o = this.defaultOptions.locales[this.defaultOptions.locale];
    Le(s = xn(this.options.locales)).call(s, function(l) {
      a.options.locales[l] = G.extend({}, o, a.options.locales[l]);
    }), this.selected = !1, this.displayed = !1, this.groupShowing = !0, this.selectable = n && n.selectable || !1, this.dirty = !0, this.top = null, this.right = null, this.left = null, this.width = null, this.height = null, this.setSelectability(e), this.editable = null, this._updateEditStatus();
  }
  return hr(t, [{
    key: "select",
    value: function() {
      this.selectable && (this.selected = !0, this.dirty = !0, this.displayed && this.redraw());
    }
    /**
     * Unselect current item
     */
  }, {
    key: "unselect",
    value: function() {
      this.selected = !1, this.dirty = !0, this.displayed && this.redraw();
    }
    /**
     * Set data for the item. Existing data will be updated. The id should not
     * be changed. When the item is displayed, it will be redrawn immediately.
     * @param {Object} data
     */
  }, {
    key: "setData",
    value: function(r) {
      var n = r.group != null && this.data.group != r.group;
      n && this.parent != null && this.parent.itemSet._moveToGroup(this, r.group), this.setSelectability(r), this.parent && (this.parent.stackDirty = !0);
      var s = r.subgroup != null && this.data.subgroup != r.subgroup;
      s && this.parent != null && this.parent.changeSubgroup(this, this.data.subgroup, r.subgroup), this.data = r, this._updateEditStatus(), this.dirty = !0, this.displayed && this.redraw();
    }
    /**
     * Set whether the item can be selected.
     * Can only be set/unset if the timeline's `selectable` configuration option is `true`.
     * @param {Object} data `data` from `constructor` and `setData`
     */
  }, {
    key: "setSelectability",
    value: function(r) {
      r && (this.selectable = typeof r.selectable > "u" ? !0 : !!r.selectable);
    }
    /**
     * Set a parent for the item
     * @param {Group} parent
     */
  }, {
    key: "setParent",
    value: function(r) {
      this.displayed ? (this.hide(), this.parent = r, this.parent && this.show()) : this.parent = r;
    }
    /**
     * Check whether this item is visible inside given range
     * @param {timeline.Range} range with a timestamp for start and end
     * @returns {boolean} True if visible
     */
  }, {
    key: "isVisible",
    value: function(r) {
      return !1;
    }
    /**
     * Show the Item in the DOM (when not already visible)
     * @return {Boolean} changed
     */
  }, {
    key: "show",
    value: function() {
      return !1;
    }
    /**
     * Hide the Item from the DOM (when visible)
     * @return {Boolean} changed
     */
  }, {
    key: "hide",
    value: function() {
      return !1;
    }
    /**
     * Repaint the item
     */
  }, {
    key: "redraw",
    value: function() {
    }
    /**
     * Reposition the Item horizontally
     */
  }, {
    key: "repositionX",
    value: function() {
    }
    /**
     * Reposition the Item vertically
     */
  }, {
    key: "repositionY",
    value: function() {
    }
    /**
     * Repaint a drag area on the center of the item when the item is selected
     * @protected
     */
  }, {
    key: "_repaintDragCenter",
    value: function() {
      if (this.selected && this.editable.updateTime && !this.dom.dragCenter) {
        var r, n, s = this, a = document.createElement("div");
        a.className = "vis-drag-center", a.dragCenterItem = this, this.hammerDragCenter = new ei(a), this.hammerDragCenter.on("tap", function(o) {
          s.parent.itemSet.body.emitter.emit("click", {
            event: o,
            item: s.id
          });
        }), this.hammerDragCenter.on("doubletap", function(o) {
          o.stopPropagation(), s.parent.itemSet._onUpdateItem(s), s.parent.itemSet.body.emitter.emit("doubleClick", {
            event: o,
            item: s.id
          });
        }), this.hammerDragCenter.on("panstart", function(o) {
          o.stopPropagation(), s.parent.itemSet._onDragStart(o);
        }), this.hammerDragCenter.on("panmove", de(r = s.parent.itemSet._onDrag).call(r, s.parent.itemSet)), this.hammerDragCenter.on("panend", de(n = s.parent.itemSet._onDragEnd).call(n, s.parent.itemSet)), this.hammerDragCenter.get("press").set({
          time: 1e4
        }), this.dom.box ? this.dom.dragLeft ? this.dom.box.insertBefore(a, this.dom.dragLeft) : this.dom.box.appendChild(a) : this.dom.point && this.dom.point.appendChild(a), this.dom.dragCenter = a;
      } else
        !this.selected && this.dom.dragCenter && (this.dom.dragCenter.parentNode && this.dom.dragCenter.parentNode.removeChild(this.dom.dragCenter), this.dom.dragCenter = null, this.hammerDragCenter && (this.hammerDragCenter.destroy(), this.hammerDragCenter = null));
    }
    /**
     * Repaint a delete button on the top right of the item when the item is selected
     * @param {HTMLElement} anchor
     * @protected
     */
  }, {
    key: "_repaintDeleteButton",
    value: function(r) {
      var n = (this.options.editable.overrideItems || this.editable == null) && this.options.editable.remove || !this.options.editable.overrideItems && this.editable != null && this.editable.remove;
      if (this.selected && n && !this.dom.deleteButton) {
        var s = this, a = document.createElement("div");
        this.options.rtl ? a.className = "vis-delete-rtl" : a.className = "vis-delete";
        var o = this.options.locales[this.options.locale];
        o || (this.warned || (console.warn("WARNING: options.locales['".concat(this.options.locale, "'] not found. See https://visjs.github.io/vis-timeline/docs/timeline/#Localization")), this.warned = !0), o = this.options.locales.en), a.title = o.deleteSelected, this.hammerDeleteButton = new ei(a).on("tap", function(l) {
          l.stopPropagation(), s.parent.removeFromDataSet(s);
        }), r.appendChild(a), this.dom.deleteButton = a;
      } else
        (!this.selected || !n) && this.dom.deleteButton && (this.dom.deleteButton.parentNode && this.dom.deleteButton.parentNode.removeChild(this.dom.deleteButton), this.dom.deleteButton = null, this.hammerDeleteButton && (this.hammerDeleteButton.destroy(), this.hammerDeleteButton = null));
    }
    /**
     * Repaint a onChange tooltip on the top right of the item when the item is selected
     * @param {HTMLElement} anchor
     * @protected
     */
  }, {
    key: "_repaintOnItemUpdateTimeTooltip",
    value: function(r) {
      if (this.options.tooltipOnItemUpdateTime) {
        var n = (this.options.editable.updateTime || this.data.editable === !0) && this.data.editable !== !1;
        if (this.selected && n && !this.dom.onItemUpdateTimeTooltip) {
          var s = document.createElement("div");
          s.className = "vis-onUpdateTime-tooltip", r.appendChild(s), this.dom.onItemUpdateTimeTooltip = s;
        } else
          !this.selected && this.dom.onItemUpdateTimeTooltip && (this.dom.onItemUpdateTimeTooltip.parentNode && this.dom.onItemUpdateTimeTooltip.parentNode.removeChild(this.dom.onItemUpdateTimeTooltip), this.dom.onItemUpdateTimeTooltip = null);
        if (this.dom.onItemUpdateTimeTooltip) {
          this.dom.onItemUpdateTimeTooltip.style.visibility = this.parent.itemSet.touchParams.itemIsDragging ? "visible" : "hidden", this.dom.onItemUpdateTimeTooltip.style.transform = "translateX(-50%)", this.dom.onItemUpdateTimeTooltip.style.left = "50%";
          var a = 50, o = this.parent.itemSet.body.domProps.scrollTop, l;
          this.options.orientation.item == "top" ? l = this.top : l = this.parent.height - this.top - this.height;
          var u = l + this.parent.top - a < -o;
          u ? (this.dom.onItemUpdateTimeTooltip.style.bottom = "", this.dom.onItemUpdateTimeTooltip.style.top = "".concat(this.height + 2, "px")) : (this.dom.onItemUpdateTimeTooltip.style.top = "", this.dom.onItemUpdateTimeTooltip.style.bottom = "".concat(this.height + 2, "px"));
          var c, d;
          if (this.options.tooltipOnItemUpdateTime && this.options.tooltipOnItemUpdateTime.template) {
            var h;
            d = de(h = this.options.tooltipOnItemUpdateTime.template).call(h, this), c = d(this.data);
          } else
            c = "start: ".concat(Ti(this.data.start).format("MM/DD/YYYY hh:mm")), this.data.end && (c += "<br> end: ".concat(Ti(this.data.end).format("MM/DD/YYYY hh:mm")));
          this.dom.onItemUpdateTimeTooltip.innerHTML = G.xss(c);
        }
      }
    }
    /**
    * get item data
    * @return {object}
    * @private
    */
  }, {
    key: "_getItemData",
    value: function() {
      return this.parent.itemSet.itemsData.get(this.id);
    }
    /**
     * Set HTML contents for the item
     * @param {Element} element   HTML element to fill with the contents
     * @private
     */
  }, {
    key: "_updateContents",
    value: function(r) {
      var n, s, a, o, l, u = this._getItemData(), c = this.dom.box || this.dom.point, d = c.getElementsByClassName("vis-item-visible-frame")[0];
      if (this.options.visibleFrameTemplate) {
        var h;
        l = de(h = this.options.visibleFrameTemplate).call(h, this), o = G.xss(l(u, d));
      } else
        o = "";
      if (d) {
        if (o instanceof Object && !(o instanceof Element))
          l(u, d);
        else if (s = this._contentToString(this.itemVisibleFrameContent) !== this._contentToString(o), s) {
          if (o instanceof Element)
            d.innerHTML = "", d.appendChild(o);
          else if (o != null)
            d.innerHTML = G.xss(o);
          else if (!(this.data.type == "background" && this.data.content === void 0))
            throw new Error('Property "content" missing in item '.concat(this.id));
          this.itemVisibleFrameContent = o;
        }
      }
      if (this.options.template) {
        var f;
        a = de(f = this.options.template).call(f, this), n = a(u, r, this.data);
      } else
        n = this.data.content;
      if (n instanceof Object && !(n instanceof Element))
        a(u, r);
      else if (s = this._contentToString(this.content) !== this._contentToString(n), s) {
        if (n instanceof Element)
          r.innerHTML = "", r.appendChild(n);
        else if (n != null)
          r.innerHTML = G.xss(n);
        else if (!(this.data.type == "background" && this.data.content === void 0))
          throw new Error('Property "content" missing in item '.concat(this.id));
        this.content = n;
      }
    }
    /**
     * Process dataAttributes timeline option and set as data- attributes on dom.content
     * @param {Element} element   HTML element to which the attributes will be attached
     * @private
     */
  }, {
    key: "_updateDataAttributes",
    value: function(r) {
      if (this.options.dataAttributes && this.options.dataAttributes.length > 0) {
        var n = [];
        if ($t(this.options.dataAttributes))
          n = this.options.dataAttributes;
        else if (this.options.dataAttributes == "all")
          n = xn(this.data);
        else
          return;
        var s = L7e(n), a;
        try {
          for (s.s(); !(a = s.n()).done; ) {
            var o = a.value, l = this.data[o];
            l != null ? r.setAttribute("data-".concat(o), l) : r.removeAttribute("data-".concat(o));
          }
        } catch (u) {
          s.e(u);
        } finally {
          s.f();
        }
      }
    }
    /**
     * Update custom styles of the element
     * @param {Element} element
     * @private
     */
  }, {
    key: "_updateStyle",
    value: function(r) {
      this.style && (G.removeCssText(r, this.style), this.style = null), this.data.style && (G.addCssText(r, this.data.style), this.style = this.data.style);
    }
    /**
     * Stringify the items contents
     * @param {string | Element | undefined} content
     * @returns {string | undefined}
     * @private
     */
  }, {
    key: "_contentToString",
    value: function(r) {
      return typeof r == "string" ? r : r && "outerHTML" in r ? r.outerHTML : r;
    }
    /**
     * Update the editability of this item.
     */
  }, {
    key: "_updateEditStatus",
    value: function() {
      this.options && (typeof this.options.editable == "boolean" ? this.editable = {
        updateTime: this.options.editable,
        updateGroup: this.options.editable,
        remove: this.options.editable
      } : mt(this.options.editable) === "object" && (this.editable = {}, G.selectiveExtend(["updateTime", "updateGroup", "remove"], this.editable, this.options.editable))), (!this.options || !this.options.editable || this.options.editable.overrideItems !== !0) && this.data && (typeof this.data.editable == "boolean" ? this.editable = {
        updateTime: this.data.editable,
        updateGroup: this.data.editable,
        remove: this.data.editable
      } : mt(this.data.editable) === "object" && (this.editable = {}, G.selectiveExtend(["updateTime", "updateGroup", "remove"], this.editable, this.data.editable)));
    }
    /**
     * Return the width of the item left from its start date
     * @return {number}
     */
  }, {
    key: "getWidthLeft",
    value: function() {
      return 0;
    }
    /**
     * Return the width of the item right from the max of its start and end date
     * @return {number}
     */
  }, {
    key: "getWidthRight",
    value: function() {
      return 0;
    }
    /**
     * Return the title of the item
     * @return {string | undefined}
     */
  }, {
    key: "getTitle",
    value: function() {
      if (this.options.tooltip && this.options.tooltip.template) {
        var r, n = de(r = this.options.tooltip.template).call(r, this);
        return n(this._getItemData(), this.data);
      }
      return this.data.title;
    }
  }]), t;
}();
Ph.prototype.stack = !0;
function F7e(t) {
  var e = B7e();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function B7e() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var U7e = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = F7e(r);
  function r(n, s, a) {
    var o;
    if (dr(this, r), o = e.call(this, n, s, a), o.props = {
      dot: {
        width: 0,
        height: 0
      },
      line: {
        width: 0,
        height: 0
      }
    }, n && n.start == null)
      throw new Error('Property "start" missing in item '.concat(n));
    return o;
  }
  return hr(r, [{
    key: "isVisible",
    value: function(s) {
      if (this.cluster)
        return !1;
      var a, o = this.data.align || this.options.align, l = this.width * s.getMillisecondsPerPixel();
      return o == "right" ? a = this.data.start.getTime() > s.start && this.data.start.getTime() - l < s.end : o == "left" ? a = this.data.start.getTime() + l > s.start && this.data.start.getTime() < s.end : a = this.data.start.getTime() + l / 2 > s.start && this.data.start.getTime() - l / 2 < s.end, a;
    }
    /**
    * create DOM element
    * @private
    */
  }, {
    key: "_createDomElement",
    value: function() {
      this.dom || (this.dom = {}, this.dom.box = document.createElement("DIV"), this.dom.content = document.createElement("DIV"), this.dom.content.className = "vis-item-content", this.dom.box.appendChild(this.dom.content), this.dom.line = document.createElement("DIV"), this.dom.line.className = "vis-line", this.dom.dot = document.createElement("DIV"), this.dom.dot.className = "vis-dot", this.dom.box["vis-item"] = this, this.dirty = !0);
    }
    /**
     * append DOM element
     * @private
     */
  }, {
    key: "_appendDomElement",
    value: function() {
      if (!this.parent)
        throw new Error("Cannot redraw item: no parent attached");
      if (!this.dom.box.parentNode) {
        var s = this.parent.dom.foreground;
        if (!s)
          throw new Error("Cannot redraw item: parent has no foreground container element");
        s.appendChild(this.dom.box);
      }
      if (!this.dom.line.parentNode) {
        var a = this.parent.dom.background;
        if (!a)
          throw new Error("Cannot redraw item: parent has no background container element");
        a.appendChild(this.dom.line);
      }
      if (!this.dom.dot.parentNode) {
        var o = this.parent.dom.axis;
        if (!a)
          throw new Error("Cannot redraw item: parent has no axis container element");
        o.appendChild(this.dom.dot);
      }
      this.displayed = !0;
    }
    /**
     * update dirty DOM element
     * @private
     */
  }, {
    key: "_updateDirtyDomComponents",
    value: function() {
      if (this.dirty) {
        this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.box), this._updateStyle(this.dom.box);
        var s = this.editable.updateTime || this.editable.updateGroup, a = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + (s ? " vis-editable" : " vis-readonly");
        this.dom.box.className = "vis-item vis-box".concat(a), this.dom.line.className = "vis-item vis-line".concat(a), this.dom.dot.className = "vis-item vis-dot".concat(a);
      }
    }
    /**
     * get DOM components sizes
     * @return {object}
     * @private
     */
  }, {
    key: "_getDomComponentsSizes",
    value: function() {
      return {
        previous: {
          right: this.dom.box.style.right,
          left: this.dom.box.style.left
        },
        dot: {
          height: this.dom.dot.offsetHeight,
          width: this.dom.dot.offsetWidth
        },
        line: {
          width: this.dom.line.offsetWidth
        },
        box: {
          width: this.dom.box.offsetWidth,
          height: this.dom.box.offsetHeight
        }
      };
    }
    /**
     * update DOM components sizes
     * @param {object} sizes
     * @private
     */
  }, {
    key: "_updateDomComponentsSizes",
    value: function(s) {
      this.options.rtl ? this.dom.box.style.right = "0px" : this.dom.box.style.left = "0px", this.props.dot.height = s.dot.height, this.props.dot.width = s.dot.width, this.props.line.width = s.line.width, this.width = s.box.width, this.height = s.box.height, this.options.rtl ? this.dom.box.style.right = s.previous.right : this.dom.box.style.left = s.previous.left, this.dirty = !1;
    }
    /**
     * repaint DOM additionals
     * @private
     */
  }, {
    key: "_repaintDomAdditionals",
    value: function() {
      this._repaintOnItemUpdateTimeTooltip(this.dom.box), this._repaintDragCenter(), this._repaintDeleteButton(this.dom.box);
    }
    /**
     * Repaint the item
     * @param {boolean} [returnQueue=false]  return the queue
     * @return {boolean} the redraw queue if returnQueue=true
     */
  }, {
    key: "redraw",
    value: function(s) {
      var a, o, l, u = this, c, d, h = [
        // create item DOM
        de(a = this._createDomElement).call(a, this),
        // append DOM to parent DOM
        de(o = this._appendDomElement).call(o, this),
        // update dirty DOM
        de(l = this._updateDirtyDomComponents).call(l, this),
        function() {
          u.dirty && (d = u._getDomComponentsSizes());
        },
        function() {
          if (u.dirty) {
            var p;
            de(p = u._updateDomComponentsSizes).call(p, u)(d);
          }
        },
        // repaint DOM additionals
        de(c = this._repaintDomAdditionals).call(c, this)
      ];
      if (s)
        return h;
      var f;
      return Le(h).call(h, function(p) {
        f = p();
      }), f;
    }
    /**
     * Show the item in the DOM (when not already visible). The items DOM will
     * be created when needed.
     * @param {boolean} [returnQueue=false]  whether to return a queue of functions to execute instead of just executing them
     * @return {boolean} the redraw queue if returnQueue=true
     */
  }, {
    key: "show",
    value: function(s) {
      if (!this.displayed)
        return this.redraw(s);
    }
    /**
     * Hide the item from the DOM (when visible)
     */
  }, {
    key: "hide",
    value: function() {
      if (this.displayed) {
        var s = this.dom;
        s.box.remove ? s.box.remove() : s.box.parentNode && s.box.parentNode.removeChild(s.box), s.line.remove ? s.line.remove() : s.line.parentNode && s.line.parentNode.removeChild(s.line), s.dot.remove ? s.dot.remove() : s.dot.parentNode && s.dot.parentNode.removeChild(s.dot), this.displayed = !1;
      }
    }
    /**
     * Reposition the item XY
     */
  }, {
    key: "repositionXY",
    value: function() {
      var s = this.options.rtl, a = function(l, u, c) {
        var d, h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
        if (!(u === void 0 && c === void 0)) {
          var f = h ? u * -1 : u;
          if (c === void 0) {
            l.style.transform = "translateX(".concat(f, "px)");
            return;
          }
          if (u === void 0) {
            l.style.transform = "translateY(".concat(c, "px)");
            return;
          }
          l.style.transform = Dr(d = "translate(".concat(f, "px, ")).call(d, c, "px)");
        }
      };
      a(this.dom.box, this.boxX, this.boxY, s), a(this.dom.dot, this.dotX, this.dotY, s), a(this.dom.line, this.lineX, this.lineY, s);
    }
    /**
     * Reposition the item horizontally
     * @Override
     */
  }, {
    key: "repositionX",
    value: function() {
      var s = this.conversion.toScreen(this.data.start), a = this.data.align === void 0 ? this.options.align : this.data.align, o = this.props.line.width, l = this.props.dot.width;
      a == "right" ? (this.boxX = s - this.width, this.lineX = s - o, this.dotX = s - o / 2 - l / 2) : a == "left" ? (this.boxX = s, this.lineX = s, this.dotX = s + o / 2 - l / 2) : (this.boxX = s - this.width / 2, this.lineX = this.options.rtl ? s - o : s - o / 2, this.dotX = s - l / 2), this.options.rtl ? this.right = this.boxX : this.left = this.boxX, this.repositionXY();
    }
    /**
     * Reposition the item vertically
     * @Override
     */
  }, {
    key: "repositionY",
    value: function() {
      var s = this.options.orientation.item, a = this.dom.line.style;
      if (s == "top") {
        var o = this.parent.top + this.top + 1;
        this.boxY = this.top || 0, a.height = "".concat(o, "px"), a.bottom = "", a.top = "0";
      } else {
        var l = this.parent.itemSet.props.height, u = l - this.parent.top - this.parent.height + this.top;
        this.boxY = this.parent.height - this.top - (this.height || 0), a.height = "".concat(u, "px"), a.top = "", a.bottom = "0";
      }
      this.dotY = -this.props.dot.height / 2, this.repositionXY();
    }
    /**
     * Return the width of the item left from its start date
     * @return {number}
     */
  }, {
    key: "getWidthLeft",
    value: function() {
      return this.width / 2;
    }
    /**
     * Return the width of the item right from its start date
     * @return {number}
     */
  }, {
    key: "getWidthRight",
    value: function() {
      return this.width / 2;
    }
  }]), r;
}(Ph);
function V7e(t) {
  var e = Y7e();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function Y7e() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var H7e = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = V7e(r);
  function r(n, s, a) {
    var o;
    if (dr(this, r), o = e.call(this, n, s, a), o.props = {
      dot: {
        top: 0,
        width: 0,
        height: 0
      },
      content: {
        height: 0,
        marginLeft: 0,
        marginRight: 0
      }
    }, n && n.start == null)
      throw new Error('Property "start" missing in item '.concat(n));
    return o;
  }
  return hr(r, [{
    key: "isVisible",
    value: function(s) {
      if (this.cluster)
        return !1;
      var a = this.width * s.getMillisecondsPerPixel();
      return this.data.start.getTime() + a > s.start && this.data.start < s.end;
    }
    /**
     * create DOM element
     * @private
     */
  }, {
    key: "_createDomElement",
    value: function() {
      this.dom || (this.dom = {}, this.dom.point = document.createElement("div"), this.dom.content = document.createElement("div"), this.dom.content.className = "vis-item-content", this.dom.point.appendChild(this.dom.content), this.dom.dot = document.createElement("div"), this.dom.point.appendChild(this.dom.dot), this.dom.point["vis-item"] = this, this.dirty = !0);
    }
    /**
     * append DOM element
     * @private
     */
  }, {
    key: "_appendDomElement",
    value: function() {
      if (!this.parent)
        throw new Error("Cannot redraw item: no parent attached");
      if (!this.dom.point.parentNode) {
        var s = this.parent.dom.foreground;
        if (!s)
          throw new Error("Cannot redraw item: parent has no foreground container element");
        s.appendChild(this.dom.point);
      }
      this.displayed = !0;
    }
    /**
     * update dirty DOM components
     * @private
     */
  }, {
    key: "_updateDirtyDomComponents",
    value: function() {
      if (this.dirty) {
        this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.point), this._updateStyle(this.dom.point);
        var s = this.editable.updateTime || this.editable.updateGroup, a = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + (s ? " vis-editable" : " vis-readonly");
        this.dom.point.className = "vis-item vis-point".concat(a), this.dom.dot.className = "vis-item vis-dot".concat(a);
      }
    }
    /**
     * get DOM component sizes
     * @return {object}
     * @private
     */
  }, {
    key: "_getDomComponentsSizes",
    value: function() {
      return {
        dot: {
          width: this.dom.dot.offsetWidth,
          height: this.dom.dot.offsetHeight
        },
        content: {
          width: this.dom.content.offsetWidth,
          height: this.dom.content.offsetHeight
        },
        point: {
          width: this.dom.point.offsetWidth,
          height: this.dom.point.offsetHeight
        }
      };
    }
    /**
     * update DOM components sizes
     * @param {array} sizes
     * @private
     */
  }, {
    key: "_updateDomComponentsSizes",
    value: function(s) {
      this.props.dot.width = s.dot.width, this.props.dot.height = s.dot.height, this.props.content.height = s.content.height, this.options.rtl ? this.dom.content.style.marginRight = "".concat(this.props.dot.width / 2, "px") : this.dom.content.style.marginLeft = "".concat(this.props.dot.width / 2, "px"), this.width = s.point.width, this.height = s.point.height, this.dom.dot.style.top = "".concat((this.height - this.props.dot.height) / 2, "px");
      var a = this.props.dot.width, o = this.options.rtl ? a / 2 : a / 2 * -1;
      this.dom.dot.style.transform = "translateX(".concat(o, "px"), this.dirty = !1;
    }
    /**
     * Repain DOM additionals
     * @private
     */
  }, {
    key: "_repaintDomAdditionals",
    value: function() {
      this._repaintOnItemUpdateTimeTooltip(this.dom.point), this._repaintDragCenter(), this._repaintDeleteButton(this.dom.point);
    }
    /**
     * Repaint the item
     * @param {boolean} [returnQueue=false]  return the queue
     * @return {boolean} the redraw queue if returnQueue=true
     */
  }, {
    key: "redraw",
    value: function(s) {
      var a, o, l, u = this, c, d, h = [
        // create item DOM
        de(a = this._createDomElement).call(a, this),
        // append DOM to parent DOM
        de(o = this._appendDomElement).call(o, this),
        // update dirty DOM
        de(l = this._updateDirtyDomComponents).call(l, this),
        function() {
          u.dirty && (d = u._getDomComponentsSizes());
        },
        function() {
          if (u.dirty) {
            var p;
            de(p = u._updateDomComponentsSizes).call(p, u)(d);
          }
        },
        // repaint DOM additionals
        de(c = this._repaintDomAdditionals).call(c, this)
      ];
      if (s)
        return h;
      var f;
      return Le(h).call(h, function(p) {
        f = p();
      }), f;
    }
    /**
     * Reposition XY
     */
  }, {
    key: "repositionXY",
    value: function() {
      var s = this.options.rtl, a = function(l, u, c) {
        var d, h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
        if (!(u === void 0 && c === void 0)) {
          var f = h ? u * -1 : u;
          if (c === void 0) {
            l.style.transform = "translateX(".concat(f, "px)");
            return;
          }
          if (u === void 0) {
            l.style.transform = "translateY(".concat(c, "px)");
            return;
          }
          l.style.transform = Dr(d = "translate(".concat(f, "px, ")).call(d, c, "px)");
        }
      };
      a(this.dom.point, this.pointX, this.pointY, s);
    }
    /**
     * Show the item in the DOM (when not already visible). The items DOM will
     * be created when needed.
     * @param {boolean} [returnQueue=false]  whether to return a queue of functions to execute instead of just executing them
     * @return {boolean} the redraw queue if returnQueue=true
     */
  }, {
    key: "show",
    value: function(s) {
      if (!this.displayed)
        return this.redraw(s);
    }
    /**
     * Hide the item from the DOM (when visible)
     */
  }, {
    key: "hide",
    value: function() {
      this.displayed && (this.dom.point.parentNode && this.dom.point.parentNode.removeChild(this.dom.point), this.displayed = !1);
    }
    /**
     * Reposition the item horizontally
     * @Override
     */
  }, {
    key: "repositionX",
    value: function() {
      var s = this.conversion.toScreen(this.data.start);
      this.pointX = s, this.options.rtl ? this.right = s - this.props.dot.width : this.left = s - this.props.dot.width, this.repositionXY();
    }
    /**
     * Reposition the item vertically
     * @Override
     */
  }, {
    key: "repositionY",
    value: function() {
      var s = this.options.orientation.item;
      s == "top" ? this.pointY = this.top : this.pointY = this.parent.height - this.top - this.height, this.repositionXY();
    }
    /**
     * Return the width of the item left from its start date
     * @return {number}
     */
  }, {
    key: "getWidthLeft",
    value: function() {
      return this.props.dot.width;
    }
    /**
     * Return the width of the item right from  its start date
     * @return {number}
     */
  }, {
    key: "getWidthRight",
    value: function() {
      return this.props.dot.width;
    }
  }]), r;
}(Ph);
function G7e(t) {
  var e = W7e();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function W7e() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var Xu = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = G7e(r);
  function r(n, s, a) {
    var o;
    if (dr(this, r), o = e.call(this, n, s, a), o.props = {
      content: {
        width: 0
      }
    }, o.overflow = !1, n) {
      if (n.start == null)
        throw new Error('Property "start" missing in item '.concat(n.id));
      if (n.end == null)
        throw new Error('Property "end" missing in item '.concat(n.id));
    }
    return o;
  }
  return hr(r, [{
    key: "isVisible",
    value: function(s) {
      return this.cluster ? !1 : this.data.start < s.end && this.data.end > s.start;
    }
    /**
     * create DOM elements
     * @private
     */
  }, {
    key: "_createDomElement",
    value: function() {
      this.dom || (this.dom = {}, this.dom.box = document.createElement("div"), this.dom.frame = document.createElement("div"), this.dom.frame.className = "vis-item-overflow", this.dom.box.appendChild(this.dom.frame), this.dom.visibleFrame = document.createElement("div"), this.dom.visibleFrame.className = "vis-item-visible-frame", this.dom.box.appendChild(this.dom.visibleFrame), this.dom.content = document.createElement("div"), this.dom.content.className = "vis-item-content", this.dom.frame.appendChild(this.dom.content), this.dom.box["vis-item"] = this, this.dirty = !0);
    }
    /**
     * append element to DOM
     * @private
     */
  }, {
    key: "_appendDomElement",
    value: function() {
      if (!this.parent)
        throw new Error("Cannot redraw item: no parent attached");
      if (!this.dom.box.parentNode) {
        var s = this.parent.dom.foreground;
        if (!s)
          throw new Error("Cannot redraw item: parent has no foreground container element");
        s.appendChild(this.dom.box);
      }
      this.displayed = !0;
    }
    /**
     * update dirty DOM components
     * @private
     */
  }, {
    key: "_updateDirtyDomComponents",
    value: function() {
      if (this.dirty) {
        this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.box), this._updateStyle(this.dom.box);
        var s = this.editable.updateTime || this.editable.updateGroup, a = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + (s ? " vis-editable" : " vis-readonly");
        this.dom.box.className = this.baseClassName + a, this.dom.content.style.maxWidth = "none";
      }
    }
    /**
     * get DOM component sizes
     * @return {object}
     * @private
     */
  }, {
    key: "_getDomComponentsSizes",
    value: function() {
      return this.overflow = window.getComputedStyle(this.dom.frame).overflow !== "hidden", this.whiteSpace = window.getComputedStyle(this.dom.content).whiteSpace !== "nowrap", {
        content: {
          width: this.dom.content.offsetWidth
        },
        box: {
          height: this.dom.box.offsetHeight
        }
      };
    }
    /**
     * update DOM component sizes
     * @param {array} sizes
     * @private
     */
  }, {
    key: "_updateDomComponentsSizes",
    value: function(s) {
      this.props.content.width = s.content.width, this.height = s.box.height, this.dom.content.style.maxWidth = "", this.dirty = !1;
    }
    /**
     * repaint DOM additional components
     * @private
     */
  }, {
    key: "_repaintDomAdditionals",
    value: function() {
      this._repaintOnItemUpdateTimeTooltip(this.dom.box), this._repaintDeleteButton(this.dom.box), this._repaintDragCenter(), this._repaintDragLeft(), this._repaintDragRight();
    }
    /**
     * Repaint the item
     * @param {boolean} [returnQueue=false]  return the queue
     * @return {boolean} the redraw queue if returnQueue=true
     */
  }, {
    key: "redraw",
    value: function(s) {
      var a, o, l, u = this, c, d, h = [
        // create item DOM
        de(a = this._createDomElement).call(a, this),
        // append DOM to parent DOM
        de(o = this._appendDomElement).call(o, this),
        // update dirty DOM 
        de(l = this._updateDirtyDomComponents).call(l, this),
        function() {
          if (u.dirty) {
            var p;
            d = de(p = u._getDomComponentsSizes).call(p, u)();
          }
        },
        function() {
          if (u.dirty) {
            var p;
            de(p = u._updateDomComponentsSizes).call(p, u)(d);
          }
        },
        // repaint DOM additionals
        de(c = this._repaintDomAdditionals).call(c, this)
      ];
      if (s)
        return h;
      var f;
      return Le(h).call(h, function(p) {
        f = p();
      }), f;
    }
    /**
     * Show the item in the DOM (when not already visible). The items DOM will
     * be created when needed.
     * @param {boolean} [returnQueue=false]  whether to return a queue of functions to execute instead of just executing them
     * @return {boolean} the redraw queue if returnQueue=true
     */
  }, {
    key: "show",
    value: function(s) {
      if (!this.displayed)
        return this.redraw(s);
    }
    /**
     * Hide the item from the DOM (when visible)
     */
  }, {
    key: "hide",
    value: function() {
      if (this.displayed) {
        var s = this.dom.box;
        s.parentNode && s.parentNode.removeChild(s), this.displayed = !1;
      }
    }
    /**
     * Reposition the item horizontally
     * @param {boolean} [limitSize=true] If true (default), the width of the range
     *                                   item will be limited, as the browser cannot
     *                                   display very wide divs. This means though
     *                                   that the applied left and width may
     *                                   not correspond to the ranges start and end
     * @Override
     */
  }, {
    key: "repositionX",
    value: function(s) {
      var a = this.parent.width, o = this.conversion.toScreen(this.data.start), l = this.conversion.toScreen(this.data.end), u = this.data.align === void 0 ? this.options.align : this.data.align, c, d;
      this.data.limitSize !== !1 && (s === void 0 || s === !0) && (o < -a && (o = -a), l > 2 * a && (l = 2 * a));
      var h = Math.max(Math.round((l - o) * 1e3) / 1e3, 1);
      switch (this.overflow ? (this.options.rtl ? this.right = o : this.left = o, this.width = h + this.props.content.width, d = this.props.content.width) : (this.options.rtl ? this.right = o : this.left = o, this.width = h, d = Math.min(l - o, this.props.content.width)), this.options.rtl ? this.dom.box.style.transform = "translateX(".concat(this.right * -1, "px)") : this.dom.box.style.transform = "translateX(".concat(this.left, "px)"), this.dom.box.style.width = "".concat(h, "px"), this.whiteSpace && (this.height = this.dom.box.offsetHeight), u) {
        case "left":
          this.dom.content.style.transform = "translateX(0)";
          break;
        case "right":
          if (this.options.rtl) {
            var f = Math.max(h - d, 0) * -1;
            this.dom.content.style.transform = "translateX(".concat(f, "px)");
          } else
            this.dom.content.style.transform = "translateX(".concat(Math.max(h - d, 0), "px)");
          break;
        case "center":
          if (this.options.rtl) {
            var p = Math.max((h - d) / 2, 0) * -1;
            this.dom.content.style.transform = "translateX(".concat(p, "px)");
          } else
            this.dom.content.style.transform = "translateX(".concat(Math.max((h - d) / 2, 0), "px)");
          break;
        default:
          if (this.overflow ? l > 0 ? c = Math.max(-o, 0) : c = -d : o < 0 ? c = -o : c = 0, this.options.rtl) {
            var m = c * -1;
            this.dom.content.style.transform = "translateX(".concat(m, "px)");
          } else
            this.dom.content.style.transform = "translateX(".concat(c, "px)");
      }
    }
    /**
     * Reposition the item vertically
     * @Override
     */
  }, {
    key: "repositionY",
    value: function() {
      var s = this.options.orientation.item, a = this.dom.box;
      s == "top" ? a.style.top = "".concat(this.top, "px") : a.style.top = "".concat(this.parent.height - this.top - this.height, "px");
    }
    /**
     * Repaint a drag area on the left side of the range when the range is selected
     * @protected
     */
  }, {
    key: "_repaintDragLeft",
    value: function() {
      if ((this.selected || this.options.itemsAlwaysDraggable.range) && this.editable.updateTime && !this.dom.dragLeft) {
        var s = document.createElement("div");
        s.className = "vis-drag-left", s.dragLeftItem = this, this.dom.box.appendChild(s), this.dom.dragLeft = s;
      } else
        !this.selected && !this.options.itemsAlwaysDraggable.range && this.dom.dragLeft && (this.dom.dragLeft.parentNode && this.dom.dragLeft.parentNode.removeChild(this.dom.dragLeft), this.dom.dragLeft = null);
    }
    /**
     * Repaint a drag area on the right side of the range when the range is selected
     * @protected
     */
  }, {
    key: "_repaintDragRight",
    value: function() {
      if ((this.selected || this.options.itemsAlwaysDraggable.range) && this.editable.updateTime && !this.dom.dragRight) {
        var s = document.createElement("div");
        s.className = "vis-drag-right", s.dragRightItem = this, this.dom.box.appendChild(s), this.dom.dragRight = s;
      } else
        !this.selected && !this.options.itemsAlwaysDraggable.range && this.dom.dragRight && (this.dom.dragRight.parentNode && this.dom.dragRight.parentNode.removeChild(this.dom.dragRight), this.dom.dragRight = null);
    }
  }]), r;
}(Ph);
Xu.prototype.baseClassName = "vis-item vis-range";
function j7e(t) {
  var e = K7e();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function K7e() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var yc = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = j7e(r);
  function r(n, s, a) {
    var o;
    if (dr(this, r), o = e.call(this, n, s, a), o.props = {
      content: {
        width: 0
      }
    }, o.overflow = !1, n) {
      if (n.start == null)
        throw new Error('Property "start" missing in item '.concat(n.id));
      if (n.end == null)
        throw new Error('Property "end" missing in item '.concat(n.id));
    }
    return o;
  }
  return hr(r, [{
    key: "isVisible",
    value: function(s) {
      return this.data.start < s.end && this.data.end > s.start;
    }
    /**
     * create DOM element
     * @private
     */
  }, {
    key: "_createDomElement",
    value: function() {
      this.dom || (this.dom = {}, this.dom.box = document.createElement("div"), this.dom.frame = document.createElement("div"), this.dom.frame.className = "vis-item-overflow", this.dom.box.appendChild(this.dom.frame), this.dom.content = document.createElement("div"), this.dom.content.className = "vis-item-content", this.dom.frame.appendChild(this.dom.content), this.dirty = !0);
    }
    /**
     * append DOM element
     * @private
     */
  }, {
    key: "_appendDomElement",
    value: function() {
      if (!this.parent)
        throw new Error("Cannot redraw item: no parent attached");
      if (!this.dom.box.parentNode) {
        var s = this.parent.dom.background;
        if (!s)
          throw new Error("Cannot redraw item: parent has no background container element");
        s.appendChild(this.dom.box);
      }
      this.displayed = !0;
    }
    /**
     * update DOM Dirty components
     * @private
     */
  }, {
    key: "_updateDirtyDomComponents",
    value: function() {
      if (this.dirty) {
        this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.content), this._updateStyle(this.dom.box);
        var s = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "");
        this.dom.box.className = this.baseClassName + s;
      }
    }
    /**
     * get DOM components sizes
     * @return {object}
     * @private
     */
  }, {
    key: "_getDomComponentsSizes",
    value: function() {
      return this.overflow = window.getComputedStyle(this.dom.content).overflow !== "hidden", {
        content: {
          width: this.dom.content.offsetWidth
        }
      };
    }
    /**
     * update DOM components sizes
     * @param {object} sizes
     * @private
     */
  }, {
    key: "_updateDomComponentsSizes",
    value: function(s) {
      this.props.content.width = s.content.width, this.height = 0, this.dirty = !1;
    }
    /**
     * repaint DOM additionals
     * @private
     */
  }, {
    key: "_repaintDomAdditionals",
    value: function() {
    }
    /**
     * Repaint the item
     * @param {boolean} [returnQueue=false]  return the queue
     * @return {boolean} the redraw result or the redraw queue if returnQueue=true
     */
  }, {
    key: "redraw",
    value: function(s) {
      var a, o, l, u = this, c, d, h = [
        // create item DOM
        de(a = this._createDomElement).call(a, this),
        // append DOM to parent DOM
        de(o = this._appendDomElement).call(o, this),
        de(l = this._updateDirtyDomComponents).call(l, this),
        function() {
          if (u.dirty) {
            var p;
            d = de(p = u._getDomComponentsSizes).call(p, u)();
          }
        },
        function() {
          if (u.dirty) {
            var p;
            de(p = u._updateDomComponentsSizes).call(p, u)(d);
          }
        },
        // repaint DOM additionals
        de(c = this._repaintDomAdditionals).call(c, this)
      ];
      if (s)
        return h;
      var f;
      return Le(h).call(h, function(p) {
        f = p();
      }), f;
    }
    /**
     * Reposition the item vertically
     * @Override
     */
  }, {
    key: "repositionY",
    value: function(s) {
      var a, o = this.options.orientation.item;
      if (this.data.subgroup !== void 0) {
        var l = this.data.subgroup;
        this.dom.box.style.height = "".concat(this.parent.subgroups[l].height, "px"), o == "top" ? this.dom.box.style.top = "".concat(this.parent.top + this.parent.subgroups[l].top, "px") : this.dom.box.style.top = "".concat(this.parent.top + this.parent.height - this.parent.subgroups[l].top - this.parent.subgroups[l].height, "px"), this.dom.box.style.bottom = "";
      } else
        this.parent instanceof BW ? (a = Math.max(this.parent.height, this.parent.itemSet.body.domProps.center.height, this.parent.itemSet.body.domProps.centerContainer.height), this.dom.box.style.bottom = o == "bottom" ? "0" : "", this.dom.box.style.top = o == "top" ? "0" : "") : (a = this.parent.height, this.dom.box.style.top = "".concat(this.parent.top, "px"), this.dom.box.style.bottom = "");
      this.dom.box.style.height = "".concat(a, "px");
    }
  }]), r;
}(Ph);
yc.prototype.baseClassName = "vis-item vis-background";
yc.prototype.stack = !1;
yc.prototype.show = Xu.prototype.show;
yc.prototype.hide = Xu.prototype.hide;
yc.prototype.repositionX = Xu.prototype.repositionX;
var z7e = /* @__PURE__ */ function() {
  function t(e, r) {
    dr(this, t), this.container = e, this.overflowMethod = r || "cap", this.x = 0, this.y = 0, this.padding = 5, this.hidden = !1, this.frame = document.createElement("div"), this.frame.className = "vis-tooltip", this.container.appendChild(this.frame);
  }
  return hr(t, [{
    key: "setPosition",
    value: function(r, n) {
      this.x = Ui(r), this.y = Ui(n);
    }
    /**
     * Set the content for the popup window. This can be HTML code or text.
     * @param {string | Element} content
     */
  }, {
    key: "setText",
    value: function(r) {
      r instanceof Element ? (this.frame.innerHTML = "", this.frame.appendChild(r)) : this.frame.innerHTML = G.xss(r);
    }
    /**
     * Show the popup window
     * @param {boolean} [doShow]    Show or hide the window
     */
  }, {
    key: "show",
    value: function(r) {
      if (r === void 0 && (r = !0), r === !0) {
        var n = this.frame.clientHeight, s = this.frame.clientWidth, a = this.frame.parentNode.clientHeight, o = this.frame.parentNode.clientWidth, l = 0, u = 0;
        if (this.overflowMethod == "flip" || this.overflowMethod == "none") {
          var c = !1, d = !0;
          this.overflowMethod == "flip" && (this.y - n < this.padding && (d = !1), this.x + s > o - this.padding && (c = !0)), c ? l = this.x - s : l = this.x, d ? u = this.y - n : u = this.y;
        } else
          u = this.y - n, u + n + this.padding > a && (u = a - n - this.padding), u < this.padding && (u = this.padding), l = this.x, l + s + this.padding > o && (l = o - s - this.padding), l < this.padding && (l = this.padding);
        this.frame.style.left = l + "px", this.frame.style.top = u + "px", this.frame.style.visibility = "visible", this.hidden = !1;
      } else
        this.hide();
    }
    /**
     * Hide the popup window
     */
  }, {
    key: "hide",
    value: function() {
      this.hidden = !0, this.frame.style.left = "0", this.frame.style.top = "0", this.frame.style.visibility = "hidden";
    }
    /**
     * Remove the popup window
     */
  }, {
    key: "destroy",
    value: function() {
      this.frame.parentNode.removeChild(this.frame);
    }
  }]), t;
}(), tk = {}, q7e = {
  get exports() {
    return tk;
  },
  set exports(t) {
    tk = t;
  }
}, X7e = lt, Q7e = Uo.every, Z7e = Ch, J7e = Z7e("every");
X7e({ target: "Array", proto: !0, forced: !J7e }, {
  every: function(e) {
    return Q7e(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var eze = sn, tze = eze("Array").every, rze = Fr, nze = tze, lT = Array.prototype, ize = function(t) {
  var e = t.every;
  return t === lT || rze(lT, t) && e === lT.every ? nze : e;
}, sze = ize, aze = sze;
(function(t) {
  t.exports = aze;
})(q7e);
var oze = /* @__PURE__ */ rt(tk);
function W2(t, e) {
  var r = typeof Nl < "u" && Vo(t) || t["@@iterator"];
  if (!r) {
    if ($t(t) || (r = lze(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, s = function() {
      };
      return { s, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(c) {
        throw c;
      }, f: s };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return { s: function() {
    r = r.call(t);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    o = !0, l = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (o)
        throw l;
    }
  } };
}
function lze(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return j2(t, e);
    var n = hi(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return vc(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return j2(t, e);
  }
}
function j2(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function uze(t) {
  var e = cze();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function cze() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var UW = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = uze(r);
  function r(n, s, a) {
    var o;
    dr(this, r);
    var l = Wu({}, {
      fitOnDoubleClick: !0
    }, a, {
      editable: !1
    });
    if (o = e.call(this, n, s, l), o.props = {
      content: {
        width: 0,
        height: 0
      }
    }, !n || n.uiItems == null)
      throw new Error('Property "uiItems" missing in item ' + n.id);
    return o.id = Dd(), o.group = n.group, o._setupRange(), o.emitter = o.data.eventEmitter, o.range = o.data.range, o.attached = !1, o.isCluster = !0, o.data.isCluster = !0, o;
  }
  return hr(r, [{
    key: "hasItems",
    value: function() {
      return this.data.uiItems && this.data.uiItems.length && this.attached;
    }
    /**
     * set UI items
     * @param {array} items
     */
  }, {
    key: "setUiItems",
    value: function(s) {
      this.detach(), this.data.uiItems = s, this._setupRange(), this.attach();
    }
    /**
     * check is visible
     * @param {object} range
     * @return {boolean}
     */
  }, {
    key: "isVisible",
    value: function(s) {
      var a = this.data.end ? this.data.end - this.data.start : 0, o = this.width * s.getMillisecondsPerPixel(), l = Math.max(this.data.start.getTime() + a, this.data.start.getTime() + o);
      return this.data.start < s.end && l > s.start && this.hasItems();
    }
    /**
     * get cluster data
     * @return {object}
     */
  }, {
    key: "getData",
    value: function() {
      return {
        isCluster: !0,
        id: this.id,
        items: this.data.items || [],
        data: this.data
      };
    }
    /**
     * redraw cluster item
     * @param {boolean} returnQueue
     * @return {boolean}
     */
  }, {
    key: "redraw",
    value: function(s) {
      var a, o, l, u, c, d, h, f = [
        // create item DOM
        de(a = this._createDomElement).call(a, this),
        // append DOM to parent DOM
        de(o = this._appendDomElement).call(o, this),
        // update dirty DOM
        de(l = this._updateDirtyDomComponents).call(l, this),
        de(u = function() {
          this.dirty && (h = this._getDomComponentsSizes());
        }).call(u, this),
        de(c = function() {
          if (this.dirty) {
            var b;
            de(b = this._updateDomComponentsSizes).call(b, this)(h);
          }
        }).call(c, this),
        // repaint DOM additionals
        de(d = this._repaintDomAdditionals).call(d, this)
      ];
      if (s)
        return f;
      var p;
      return Le(f).call(f, function(m) {
        p = m();
      }), p;
    }
    /**
     * show cluster item
     */
  }, {
    key: "show",
    value: function() {
      this.displayed || this.redraw();
    }
    /**
     * Hide the item from the DOM (when visible)
     */
  }, {
    key: "hide",
    value: function() {
      if (this.displayed) {
        var s = this.dom;
        s.box.parentNode && s.box.parentNode.removeChild(s.box), this.options.showStipes && (s.line.parentNode && s.line.parentNode.removeChild(s.line), s.dot.parentNode && s.dot.parentNode.removeChild(s.dot)), this.displayed = !1;
      }
    }
    /**
     * reposition item x axis
     */
  }, {
    key: "repositionX",
    value: function() {
      var s = this.conversion.toScreen(this.data.start), a = this.data.end ? this.conversion.toScreen(this.data.end) : 0;
      if (a)
        this.repositionXWithRanges(s, a);
      else {
        var o = this.data.align === void 0 ? this.options.align : this.data.align;
        this.repositionXWithoutRanges(s, o);
      }
      this.options.showStipes && (this.dom.line.style.display = this._isStipeVisible() ? "block" : "none", this.dom.dot.style.display = this._isStipeVisible() ? "block" : "none", this._isStipeVisible() && this.repositionStype(s, a));
    }
    /**
     * reposition item stype
     * @param {date} start
     * @param {date} end
     */
  }, {
    key: "repositionStype",
    value: function(s, a) {
      this.dom.line.style.display = "block", this.dom.dot.style.display = "block";
      var o = this.dom.line.offsetWidth, l = this.dom.dot.offsetWidth;
      if (a) {
        var u = o + s + (a - s) / 2, c = u - l / 2, d = this.options.rtl ? u * -1 : u, h = this.options.rtl ? c * -1 : c;
        this.dom.line.style.transform = "translateX(".concat(d, "px)"), this.dom.dot.style.transform = "translateX(".concat(h, "px)");
      } else {
        var f = this.options.rtl ? s * -1 : s, p = this.options.rtl ? (s - l / 2) * -1 : s - l / 2;
        this.dom.line.style.transform = "translateX(".concat(f, "px)"), this.dom.dot.style.transform = "translateX(".concat(p, "px)");
      }
    }
    /**
     * reposition x without ranges
     * @param {date} start
     * @param {string} align
     */
  }, {
    key: "repositionXWithoutRanges",
    value: function(s, a) {
      a == "right" ? this.options.rtl ? (this.right = s - this.width, this.dom.box.style.right = this.right + "px") : (this.left = s - this.width, this.dom.box.style.left = this.left + "px") : a == "left" ? this.options.rtl ? (this.right = s, this.dom.box.style.right = this.right + "px") : (this.left = s, this.dom.box.style.left = this.left + "px") : this.options.rtl ? (this.right = s - this.width / 2, this.dom.box.style.right = this.right + "px") : (this.left = s - this.width / 2, this.dom.box.style.left = this.left + "px");
    }
    /**
     * reposition x with ranges
     * @param {date} start
     * @param {date} end
     */
  }, {
    key: "repositionXWithRanges",
    value: function(s, a) {
      var o = Math.round(Math.max(a - s + 0.5, 1));
      this.options.rtl ? this.right = s : this.left = s, this.width = Math.max(o, this.minWidth || 0), this.options.rtl ? this.dom.box.style.right = this.right + "px" : this.dom.box.style.left = this.left + "px", this.dom.box.style.width = o + "px";
    }
    /**
     * reposition item y axis
     */
  }, {
    key: "repositionY",
    value: function() {
      var s = this.options.orientation.item, a = this.dom.box;
      if (s == "top" ? a.style.top = (this.top || 0) + "px" : a.style.top = (this.parent.height - this.top - this.height || 0) + "px", this.options.showStipes) {
        if (s == "top")
          this.dom.line.style.top = "0", this.dom.line.style.height = this.parent.top + this.top + 1 + "px", this.dom.line.style.bottom = "";
        else {
          var o = this.parent.itemSet.props.height, l = o - this.parent.top - this.parent.height + this.top;
          this.dom.line.style.top = o - l + "px", this.dom.line.style.bottom = "0";
        }
        this.dom.dot.style.top = -this.dom.dot.offsetHeight / 2 + "px";
      }
    }
    /**
     * get width left
     * @return {number}
     */
  }, {
    key: "getWidthLeft",
    value: function() {
      return this.width / 2;
    }
    /**
     * get width right
     * @return {number}
     */
  }, {
    key: "getWidthRight",
    value: function() {
      return this.width / 2;
    }
    /**
     * move cluster item
     */
  }, {
    key: "move",
    value: function() {
      this.repositionX(), this.repositionY();
    }
    /**
     * attach
     */
  }, {
    key: "attach",
    value: function() {
      var s, a = W2(this.data.uiItems), o;
      try {
        for (a.s(); !(o = a.n()).done; ) {
          var l = o.value;
          l.cluster = this;
        }
      } catch (u) {
        a.e(u);
      } finally {
        a.f();
      }
      this.data.items = ln(s = this.data.uiItems).call(s, function(u) {
        return u.data;
      }), this.attached = !0, this.dirty = !0;
    }
    /**
     * detach
     * @param {boolean} detachFromParent
     * @return {void}
     */
  }, {
    key: "detach",
    value: function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      if (this.hasItems()) {
        var a = W2(this.data.uiItems), o;
        try {
          for (a.s(); !(o = a.n()).done; ) {
            var l = o.value;
            delete l.cluster;
          }
        } catch (u) {
          a.e(u);
        } finally {
          a.f();
        }
        this.attached = !1, s && this.group && (this.group.remove(this), this.group = null), this.data.items = [], this.dirty = !0;
      }
    }
    /**
     * handle on double click
     */
  }, {
    key: "_onDoubleClick",
    value: function() {
      this._fit();
    }
    /**
     * set range
     */
  }, {
    key: "_setupRange",
    value: function() {
      var s, a, o, l = ln(s = this.data.uiItems).call(s, function(d) {
        return {
          start: d.data.start.valueOf(),
          end: d.data.end ? d.data.end.valueOf() : d.data.start.valueOf()
        };
      });
      this.data.min = Math.min.apply(Math, Vs(ln(l).call(l, function(d) {
        return Math.min(d.start, d.end || d.start);
      }))), this.data.max = Math.max.apply(Math, Vs(ln(l).call(l, function(d) {
        return Math.max(d.start, d.end || d.start);
      })));
      var u = ln(a = this.data.uiItems).call(a, function(d) {
        return d.center;
      }), c = i5(u).call(u, function(d, h) {
        return d + h;
      }, 0) / this.data.uiItems.length;
      wW(o = this.data.uiItems).call(o, function(d) {
        return d.data.end;
      }) ? (this.data.start = new Date(this.data.min), this.data.end = new Date(this.data.max)) : (this.data.start = new Date(c), this.data.end = null);
    }
    /**
     * get UI items
     * @return {array}
     */
  }, {
    key: "_getUiItems",
    value: function() {
      var s = this;
      if (this.data.uiItems && this.data.uiItems.length) {
        var a;
        return At(a = this.data.uiItems).call(a, function(o) {
          return o.cluster === s;
        });
      }
      return [];
    }
    /**
     * create DOM element
     */
  }, {
    key: "_createDomElement",
    value: function() {
      if (!this.dom) {
        if (this.dom = {}, this.dom.box = document.createElement("DIV"), this.dom.content = document.createElement("DIV"), this.dom.content.className = "vis-item-content", this.dom.box.appendChild(this.dom.content), this.options.showStipes && (this.dom.line = document.createElement("DIV"), this.dom.line.className = "vis-cluster-line", this.dom.line.style.display = "none", this.dom.dot = document.createElement("DIV"), this.dom.dot.className = "vis-cluster-dot", this.dom.dot.style.display = "none"), this.options.fitOnDoubleClick) {
          var s;
          this.dom.box.ondblclick = de(s = r.prototype._onDoubleClick).call(s, this);
        }
        this.dom.box["vis-item"] = this, this.dirty = !0;
      }
    }
    /**
     * append element to DOM
     */
  }, {
    key: "_appendDomElement",
    value: function() {
      if (!this.parent)
        throw new Error("Cannot redraw item: no parent attached");
      if (!this.dom.box.parentNode) {
        var s = this.parent.dom.foreground;
        if (!s)
          throw new Error("Cannot redraw item: parent has no foreground container element");
        s.appendChild(this.dom.box);
      }
      var a = this.parent.dom.background;
      if (this.options.showStipes) {
        if (!this.dom.line.parentNode) {
          if (!a)
            throw new Error("Cannot redraw item: parent has no background container element");
          a.appendChild(this.dom.line);
        }
        if (!this.dom.dot.parentNode) {
          var o = this.parent.dom.axis;
          if (!a)
            throw new Error("Cannot redraw item: parent has no axis container element");
          o.appendChild(this.dom.dot);
        }
      }
      this.displayed = !0;
    }
    /**
     * update dirty DOM components
     */
  }, {
    key: "_updateDirtyDomComponents",
    value: function() {
      if (this.dirty) {
        this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.box), this._updateStyle(this.dom.box);
        var s = this.baseClassName + " " + (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + " vis-readonly";
        this.dom.box.className = "vis-item " + s, this.options.showStipes && (this.dom.line.className = "vis-item vis-cluster-line " + (this.selected ? " vis-selected" : ""), this.dom.dot.className = "vis-item vis-cluster-dot " + (this.selected ? " vis-selected" : "")), this.data.end && (this.dom.content.style.maxWidth = "none");
      }
    }
    /**
     * get DOM components sizes
     * @return {object}
     */
  }, {
    key: "_getDomComponentsSizes",
    value: function() {
      var s = {
        previous: {
          right: this.dom.box.style.right,
          left: this.dom.box.style.left
        },
        box: {
          width: this.dom.box.offsetWidth,
          height: this.dom.box.offsetHeight
        }
      };
      return this.options.showStipes && (s.dot = {
        height: this.dom.dot.offsetHeight,
        width: this.dom.dot.offsetWidth
      }, s.line = {
        width: this.dom.line.offsetWidth
      }), s;
    }
    /**
     * update DOM components sizes
     * @param {object} sizes
     */
  }, {
    key: "_updateDomComponentsSizes",
    value: function(s) {
      this.options.rtl ? this.dom.box.style.right = "0px" : this.dom.box.style.left = "0px", this.data.end ? this.minWidth = s.box.width : this.width = s.box.width, this.height = s.box.height, this.options.rtl ? this.dom.box.style.right = s.previous.right : this.dom.box.style.left = s.previous.left, this.dirty = !1;
    }
    /**
     * repaint DOM additional components
     */
  }, {
    key: "_repaintDomAdditionals",
    value: function() {
      this._repaintOnItemUpdateTimeTooltip(this.dom.box);
    }
    /**
     * check is stripe visible
     * @return {number}
     * @private
     */
  }, {
    key: "_isStipeVisible",
    value: function() {
      return this.minWidth >= this.width || !this.data.end;
    }
    /**
     * get fit range
     * @return {object}
     * @private
     */
  }, {
    key: "_getFitRange",
    value: function() {
      var s = 0.05 * (this.data.max - this.data.min) / 2;
      return {
        fitStart: this.data.min - s,
        fitEnd: this.data.max + s
      };
    }
    /**
    * fit
    * @private
    */
  }, {
    key: "_fit",
    value: function() {
      if (this.emitter) {
        var s = this._getFitRange(), a = s.fitStart, o = s.fitEnd, l = {
          start: new Date(a),
          end: new Date(o),
          animation: !0
        };
        this.emitter.emit("fit", l);
      }
    }
    /**
    * get item data
    * @return {object}
    * @private
    */
  }, {
    key: "_getItemData",
    value: function() {
      return this.data;
    }
  }]), r;
}(Ph);
UW.prototype.baseClassName = "vis-item vis-range vis-cluster";
function dze(t, e) {
  var r = typeof Nl < "u" && Vo(t) || t["@@iterator"];
  if (!r) {
    if ($t(t) || (r = hze(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, s = function() {
      };
      return { s, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(c) {
        throw c;
      }, f: s };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return { s: function() {
    r = r.call(t);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    o = !0, l = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (o)
        throw l;
    }
  } };
}
function hze(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return K2(t, e);
    var n = hi(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return vc(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return K2(t, e);
  }
}
function K2(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
var fze = "__ungrouped__", pze = "__background__", vze = {
  UNGROUPED: fze,
  BACKGROUND: pze
}, mze = /* @__PURE__ */ function() {
  function t(e) {
    dr(this, t), this.itemSet = e, this.groups = {}, this.cache = {}, this.cache[-1] = [];
  }
  return hr(t, [{
    key: "createClusterItem",
    value: function(r, n, s) {
      var a = new UW(r, n, s);
      return a;
    }
    /**
     * Set the items to be clustered.
     * This will clear cached clusters.
     * @param {Item[]} items
     * @param {Object} [options]  Available options:
     *                            {boolean} applyOnChangedLevel
     *                                If true (default), the changed data is applied
     *                                as soon the cluster level changes. If false,
     *                                The changed data is applied immediately
     */
  }, {
    key: "setItems",
    value: function(r, n) {
      this.items = r || [], this.dataChanged = !0, this.applyOnChangedLevel = !1, n && n.applyOnChangedLevel && (this.applyOnChangedLevel = n.applyOnChangedLevel);
    }
    /**
     * Update the current data set: clear cache, and recalculate the clustering for
     * the current level
     */
  }, {
    key: "updateData",
    value: function() {
      this.dataChanged = !0, this.applyOnChangedLevel = !1;
    }
    /**
     * Cluster the items which are too close together
     * @param {array} oldClusters 
     * @param {number} scale      The scale of the current window : (windowWidth / (endDate - startDate)) 
     * @param {{maxItems: number, clusterCriteria: function, titleTemplate: string}} options             
     * @return {array} clusters
    */
  }, {
    key: "getClusters",
    value: function(r, n, s) {
      var a = typeof s == "boolean" ? {} : s, o = a.maxItems, l = a.clusterCriteria;
      l || (l = function() {
        return !0;
      }), o = o || 1;
      var u = -1, c = 2, d = 0;
      if (n > 0) {
        if (n >= 1)
          return [];
        u = Math.abs(Math.round(Math.log(100 / n) / Math.log(c))), d = Math.abs(Math.pow(c, u));
      }
      if (this.dataChanged) {
        var h = u != this.cacheLevel, f = this.applyOnChangedLevel ? h : !0;
        f && (this._dropLevelsCache(), this._filterData());
      }
      this.cacheLevel = u;
      var p = this.cache[u];
      if (!p) {
        p = [];
        for (var m in this.groups)
          if (this.groups.hasOwnProperty(m))
            for (var b = this.groups[m], y = b.length, _ = 0; _ < y; ) {
              for (var x = b[_], T = 1, k = _ - 1; k >= 0 && x.center - b[k].center < d / 2; )
                !b[k].cluster && l(x.data, b[k].data) && T++, k--;
              for (var E = _ + 1; E < b.length && b[E].center - x.center < d / 2; )
                l(x.data, b[E].data) && T++, E++;
              for (var F = p.length - 1; F >= 0 && x.center - p[F].center < d; )
                x.group == p[F].group && l(x.data, p[F].data) && T++, F--;
              if (T > o) {
                for (var R = T - o + 1, $ = [], O = _; $.length < R && O < b.length; )
                  l(b[_].data, b[O].data) && $.push(b[O]), O++;
                var P = this.itemSet.getGroupId(x.data), N = this.itemSet.groups[P] || this.itemSet.groups[vze.UNGROUPED], I = this._getClusterForItems($, N, r, s);
                p.push(I), _ += R;
              } else
                delete x.cluster, _ += 1;
            }
        this.cache[u] = p;
      }
      return p;
    }
    /**
     * Filter the items per group.
     * @private
     */
  }, {
    key: "_filterData",
    value: function() {
      var r = {};
      this.groups = r;
      for (var n = 0, s = UO(this.items); n < s.length; n++) {
        var a = s[n], o = a.parent ? a.parent.groupId : "", l = r[o];
        l || (l = [], r[o] = l), l.push(a), a.data.start && (a.data.end ? a.center = (a.data.start.valueOf() + a.data.end.valueOf()) / 2 : a.center = a.data.start.valueOf());
      }
      for (var u in r)
        if (r.hasOwnProperty(u)) {
          var c;
          wn(c = r[u]).call(c, function(d, h) {
            return d.center - h.center;
          });
        }
      this.dataChanged = !1;
    }
    /**
     * Create new cluster or return existing
     * @private
     * @param {array} clusterItems    
     * @param {object} group 
     * @param {array} oldClusters 
     * @param {object} options 
     * @returns {object} cluster
     */
  }, {
    key: "_getClusterForItems",
    value: function(r, n, s, a) {
      var o, l = ln(o = s || []).call(o, function(T) {
        var k;
        return {
          cluster: T,
          itemsIds: new t0(ln(k = T.data.uiItems).call(k, function(E) {
            return E.id;
          }))
        };
      }), u;
      if (l.length) {
        var c = dze(l), d;
        try {
          var h = function() {
            var k = d.value;
            if (k.itemsIds.size === r.length && oze(r).call(r, function(E) {
              return k.itemsIds.has(E.id);
            }))
              return u = k.cluster, "break";
          };
          for (c.s(); !(d = c.n()).done; ) {
            var f = h();
            if (f === "break")
              break;
          }
        } catch (T) {
          c.e(T);
        } finally {
          c.f();
        }
      }
      if (u)
        return u.setUiItems(r), u.group !== n && (u.group && u.group.remove(u), n && (n.add(u), u.group = n)), u;
      var p = a.titleTemplate || "", m = {
        toScreen: this.itemSet.body.util.toScreen,
        toTime: this.itemSet.body.util.toTime
      }, b = p.replace(/{count}/, r.length), y = '<div title="' + b + '">' + r.length + "</div>", _ = Wu({}, a, this.itemSet.options), x = {
        content: y,
        title: b,
        group: n,
        uiItems: r,
        eventEmitter: this.itemSet.body.emitter,
        range: this.itemSet.body.range
      };
      return u = this.createClusterItem(x, m, _), n && (n.add(u), u.group = n), u.attach(), u;
    }
    /**
     * Drop cache
     * @private
     */
  }, {
    key: "_dropLevelsCache",
    value: function() {
      this.cache = {}, this.cacheLevel = -1, this.cache[this.cacheLevel] = [];
    }
  }]), t;
}();
function Ql(t, e) {
  var r = typeof Nl < "u" && Vo(t) || t["@@iterator"];
  if (!r) {
    if ($t(t) || (r = gze(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, s = function() {
      };
      return { s, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(c) {
        throw c;
      }, f: s };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return { s: function() {
    r = r.call(t);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    o = !0, l = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (o)
        throw l;
    }
  } };
}
function gze(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return z2(t, e);
    var n = hi(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return vc(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return z2(t, e);
  }
}
function z2(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function yze(t) {
  var e = bze();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function bze() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var Hc = "__ungrouped__", Jo = "__background__", r0 = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = yze(r);
  function r(n, s) {
    var a;
    dr(this, r), a = e.call(this), a.body = n, a.defaultOptions = {
      type: null,
      // 'box', 'point', 'range', 'background'
      orientation: {
        item: "bottom"
        // item orientation: 'top' or 'bottom'
      },
      align: "auto",
      // alignment of box items
      stack: !0,
      stackSubgroups: !0,
      groupOrderSwap: function(u, c, d) {
        var h = c.order;
        c.order = u.order, u.order = h;
      },
      groupOrder: "order",
      selectable: !0,
      multiselect: !1,
      longSelectPressTime: 251,
      itemsAlwaysDraggable: {
        item: !1,
        range: !1
      },
      editable: {
        updateTime: !1,
        updateGroup: !1,
        add: !1,
        remove: !1,
        overrideItems: !1
      },
      groupEditable: {
        order: !1,
        add: !1,
        remove: !1
      },
      snap: Zy.snap,
      // Only called when `objectData.target === 'item'.
      onDropObjectOnItem: function(u, c, d) {
        d(c);
      },
      onAdd: function(u, c) {
        c(u);
      },
      onUpdate: function(u, c) {
        c(u);
      },
      onMove: function(u, c) {
        c(u);
      },
      onRemove: function(u, c) {
        c(u);
      },
      onMoving: function(u, c) {
        c(u);
      },
      onAddGroup: function(u, c) {
        c(u);
      },
      onMoveGroup: function(u, c) {
        c(u);
      },
      onRemoveGroup: function(u, c) {
        c(u);
      },
      margin: {
        item: {
          horizontal: 10,
          vertical: 10
        },
        axis: 20
      },
      showTooltips: !0,
      tooltip: {
        followMouse: !1,
        overflowMethod: "flip",
        delay: 500
      },
      tooltipOnItemUpdateTime: !1
    }, a.options = G.extend({}, a.defaultOptions), a.options.rtl = s.rtl, a.options.onTimeout = s.onTimeout, a.conversion = {
      toScreen: n.util.toScreen,
      toTime: n.util.toTime
    }, a.dom = {}, a.props = {}, a.hammer = null;
    var o = Vn(a);
    return a.itemsData = null, a.groupsData = null, a.itemsSettingTime = null, a.initialItemSetDrawn = !1, a.userContinueNotBail = null, a.sequentialSelection = !1, a.itemListeners = {
      add: function(u, c, d) {
        o._onAdd(c.items), o.options.cluster && o.clusterGenerator.setItems(o.items, {
          applyOnChangedLevel: !1
        }), o.redraw();
      },
      update: function(u, c, d) {
        o._onUpdate(c.items), o.options.cluster && o.clusterGenerator.setItems(o.items, {
          applyOnChangedLevel: !1
        }), o.redraw();
      },
      remove: function(u, c, d) {
        o._onRemove(c.items), o.options.cluster && o.clusterGenerator.setItems(o.items, {
          applyOnChangedLevel: !1
        }), o.redraw();
      }
    }, a.groupListeners = {
      add: function(u, c, d) {
        if (o._onAddGroups(c.items), o.groupsData && o.groupsData.length > 0) {
          var h, f = o.groupsData.getDataSet();
          Le(h = f.get()).call(h, function(p) {
            if (p.nestedGroups) {
              var m;
              p.showNested != !1 && (p.showNested = !0);
              var b = [];
              Le(m = p.nestedGroups).call(m, function(y) {
                var _ = f.get(y);
                _ && (_.nestedInGroup = p.id, p.showNested == !1 && (_.visible = !1), b = Dr(b).call(b, _));
              }), f.update(b, d);
            }
          });
        }
      },
      update: function(u, c, d) {
        o._onUpdateGroups(c.items);
      },
      remove: function(u, c, d) {
        o._onRemoveGroups(c.items);
      }
    }, a.items = {}, a.groups = {}, a.groupIds = [], a.selection = [], a.popup = null, a.popupTimer = null, a.touchParams = {}, a.groupTouchParams = {
      group: null,
      isDragging: !1
    }, a._create(), a.setOptions(s), a.clusters = [], a;
  }
  return hr(r, [{
    key: "_create",
    value: function() {
      var s = this, a, o, l, u, c, d, h, f, p, m, b, y, _, x, T, k = document.createElement("div");
      k.className = "vis-itemset", k["vis-itemset"] = this, this.dom.frame = k;
      var E = document.createElement("div");
      E.className = "vis-background", k.appendChild(E), this.dom.background = E;
      var F = document.createElement("div");
      F.className = "vis-foreground", k.appendChild(F), this.dom.foreground = F;
      var R = document.createElement("div");
      R.className = "vis-axis", this.dom.axis = R;
      var $ = document.createElement("div");
      $.className = "vis-labelset", this.dom.labelSet = $, this._updateUngrouped();
      var O = new BW(Jo, null, this);
      O.show(), this.groups[Jo] = O, this.hammer = new ei(this.body.dom.centerContainer), this.hammer.on("hammer.input", function(P) {
        P.isFirst && s._onTouch(P);
      }), this.hammer.on("panstart", de(a = this._onDragStart).call(a, this)), this.hammer.on("panmove", de(o = this._onDrag).call(o, this)), this.hammer.on("panend", de(l = this._onDragEnd).call(l, this)), this.hammer.get("pan").set({
        threshold: 5,
        direction: ei.ALL
      }), this.hammer.get("press").set({
        time: 1e4
      }), this.hammer.on("tap", de(u = this._onSelectItem).call(u, this)), this.hammer.on("press", de(c = this._onMultiSelectItem).call(c, this)), this.hammer.get("press").set({
        time: 1e4
      }), this.hammer.on("doubletap", de(d = this._onAddItem).call(d, this)), this.options.rtl ? this.groupHammer = new ei(this.body.dom.rightContainer) : this.groupHammer = new ei(this.body.dom.leftContainer), this.groupHammer.on("tap", de(h = this._onGroupClick).call(h, this)), this.groupHammer.on("panstart", de(f = this._onGroupDragStart).call(f, this)), this.groupHammer.on("panmove", de(p = this._onGroupDrag).call(p, this)), this.groupHammer.on("panend", de(m = this._onGroupDragEnd).call(m, this)), this.groupHammer.get("pan").set({
        threshold: 5,
        direction: ei.DIRECTION_VERTICAL
      }), this.body.dom.centerContainer.addEventListener("mouseover", de(b = this._onMouseOver).call(b, this)), this.body.dom.centerContainer.addEventListener("mouseout", de(y = this._onMouseOut).call(y, this)), this.body.dom.centerContainer.addEventListener("mousemove", de(_ = this._onMouseMove).call(_, this)), this.body.dom.centerContainer.addEventListener("contextmenu", de(x = this._onDragEnd).call(x, this)), this.body.dom.centerContainer.addEventListener("mousewheel", de(T = this._onMouseWheel).call(T, this)), this.show();
    }
    /**
     * Set options for the ItemSet. Existing options will be extended/overwritten.
     * @param {Object} [options] The following options are available:
     *                           {string} type
     *                              Default type for the items. Choose from 'box'
     *                              (default), 'point', 'range', or 'background'.
     *                              The default style can be overwritten by
     *                              individual items.
     *                           {string} align
     *                              Alignment for the items, only applicable for
     *                              BoxItem. Choose 'center' (default), 'left', or
     *                              'right'.
     *                           {string} orientation.item
     *                              Orientation of the item set. Choose 'top' or
     *                              'bottom' (default).
     *                           {Function} groupOrder
     *                              A sorting function for ordering groups
     *                           {boolean} stack
     *                              If true (default), items will be stacked on
     *                              top of each other.
     *                           {number} margin.axis
     *                              Margin between the axis and the items in pixels.
     *                              Default is 20.
     *                           {number} margin.item.horizontal
     *                              Horizontal margin between items in pixels.
     *                              Default is 10.
     *                           {number} margin.item.vertical
     *                              Vertical Margin between items in pixels.
     *                              Default is 10.
     *                           {number} margin.item
     *                              Margin between items in pixels in both horizontal
     *                              and vertical direction. Default is 10.
     *                           {number} margin
     *                              Set margin for both axis and items in pixels.
     *                           {boolean} selectable
     *                              If true (default), items can be selected.
     *                           {boolean} multiselect
     *                              If true, multiple items can be selected.
     *                              False by default.
     *                           {boolean} editable
     *                              Set all editable options to true or false
     *                           {boolean} editable.updateTime
     *                              Allow dragging an item to an other moment in time
     *                           {boolean} editable.updateGroup
     *                              Allow dragging an item to an other group
     *                           {boolean} editable.add
     *                              Allow creating new items on double tap
     *                           {boolean} editable.remove
     *                              Allow removing items by clicking the delete button
     *                              top right of a selected item.
     *                           {Function(item: Item, callback: Function)} onAdd
     *                              Callback function triggered when an item is about to be added:
     *                              when the user double taps an empty space in the Timeline.
     *                           {Function(item: Item, callback: Function)} onUpdate
     *                              Callback function fired when an item is about to be updated.
     *                              This function typically has to show a dialog where the user
     *                              change the item. If not implemented, nothing happens.
     *                           {Function(item: Item, callback: Function)} onMove
     *                              Fired when an item has been moved. If not implemented,
     *                              the move action will be accepted.
     *                           {Function(item: Item, callback: Function)} onRemove
     *                              Fired when an item is about to be deleted.
     *                              If not implemented, the item will be always removed.
     */
  }, {
    key: "setOptions",
    value: function(s) {
      var a = this;
      if (s) {
        var o, l, u = ["type", "rtl", "align", "order", "stack", "stackSubgroups", "selectable", "multiselect", "sequentialSelection", "multiselectPerGroup", "longSelectPressTime", "groupOrder", "dataAttributes", "template", "groupTemplate", "visibleFrameTemplate", "hide", "snap", "groupOrderSwap", "showTooltips", "tooltip", "tooltipOnItemUpdateTime", "groupHeightMode", "onTimeout"];
        G.selectiveExtend(u, this.options, s), "itemsAlwaysDraggable" in s && (typeof s.itemsAlwaysDraggable == "boolean" ? (this.options.itemsAlwaysDraggable.item = s.itemsAlwaysDraggable, this.options.itemsAlwaysDraggable.range = !1) : mt(s.itemsAlwaysDraggable) === "object" && (G.selectiveExtend(["item", "range"], this.options.itemsAlwaysDraggable, s.itemsAlwaysDraggable), this.options.itemsAlwaysDraggable.item || (this.options.itemsAlwaysDraggable.range = !1))), "sequentialSelection" in s && typeof s.sequentialSelection == "boolean" && (this.options.sequentialSelection = s.sequentialSelection), "orientation" in s && (typeof s.orientation == "string" ? this.options.orientation.item = s.orientation === "top" ? "top" : "bottom" : mt(s.orientation) === "object" && "item" in s.orientation && (this.options.orientation.item = s.orientation.item)), "margin" in s && (typeof s.margin == "number" ? (this.options.margin.axis = s.margin, this.options.margin.item.horizontal = s.margin, this.options.margin.item.vertical = s.margin) : mt(s.margin) === "object" && (G.selectiveExtend(["axis"], this.options.margin, s.margin), "item" in s.margin && (typeof s.margin.item == "number" ? (this.options.margin.item.horizontal = s.margin.item, this.options.margin.item.vertical = s.margin.item) : mt(s.margin.item) === "object" && G.selectiveExtend(["horizontal", "vertical"], this.options.margin.item, s.margin.item)))), Le(o = ["locale", "locales"]).call(o, function(d) {
          d in s && (a.options[d] = s[d]);
        }), "editable" in s && (typeof s.editable == "boolean" ? (this.options.editable.updateTime = s.editable, this.options.editable.updateGroup = s.editable, this.options.editable.add = s.editable, this.options.editable.remove = s.editable, this.options.editable.overrideItems = !1) : mt(s.editable) === "object" && G.selectiveExtend(["updateTime", "updateGroup", "add", "remove", "overrideItems"], this.options.editable, s.editable)), "groupEditable" in s && (typeof s.groupEditable == "boolean" ? (this.options.groupEditable.order = s.groupEditable, this.options.groupEditable.add = s.groupEditable, this.options.groupEditable.remove = s.groupEditable) : mt(s.groupEditable) === "object" && G.selectiveExtend(["order", "add", "remove"], this.options.groupEditable, s.groupEditable));
        var c = function(h) {
          var f = s[h];
          if (f) {
            if (typeof f != "function") {
              var p;
              throw new Error(Dr(p = "option ".concat(h, " must be a function ")).call(p, h, "(item, callback)"));
            }
            a.options[h] = f;
          }
        };
        Le(l = ["onDropObjectOnItem", "onAdd", "onUpdate", "onRemove", "onMove", "onMoving", "onAddGroup", "onMoveGroup", "onRemoveGroup"]).call(l, c), s.cluster ? (Wu(this.options, {
          cluster: s.cluster
        }), this.clusterGenerator || (this.clusterGenerator = new mze(this)), this.clusterGenerator.setItems(this.items, {
          applyOnChangedLevel: !1
        }), this.markDirty({
          refreshItems: !0,
          restackGroups: !0
        }), this.redraw()) : this.clusterGenerator ? (this._detachAllClusters(), this.clusters = [], this.clusterGenerator = null, this.options.cluster = void 0, this.markDirty({
          refreshItems: !0,
          restackGroups: !0
        }), this.redraw()) : this.markDirty();
      }
    }
    /**
     * Mark the ItemSet dirty so it will refresh everything with next redraw.
     * Optionally, all items can be marked as dirty and be refreshed.
     * @param {{refreshItems: boolean}} [options]
     */
  }, {
    key: "markDirty",
    value: function(s) {
      this.groupIds = [], s && (s.refreshItems && Le(G).call(G, this.items, function(a) {
        a.dirty = !0, a.displayed && a.redraw();
      }), s.restackGroups && Le(G).call(G, this.groups, function(a, o) {
        o !== Jo && (a.stackDirty = !0);
      }));
    }
    /**
     * Destroy the ItemSet
     */
  }, {
    key: "destroy",
    value: function() {
      this.clearPopupTimer(), this.hide(), this.setItems(null), this.setGroups(null), this.hammer && this.hammer.destroy(), this.groupHammer && this.groupHammer.destroy(), this.hammer = null, this.body = null, this.conversion = null;
    }
    /**
     * Hide the component from the DOM
     */
  }, {
    key: "hide",
    value: function() {
      this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame), this.dom.axis.parentNode && this.dom.axis.parentNode.removeChild(this.dom.axis), this.dom.labelSet.parentNode && this.dom.labelSet.parentNode.removeChild(this.dom.labelSet);
    }
    /**
     * Show the component in the DOM (when not already visible).
     */
  }, {
    key: "show",
    value: function() {
      this.dom.frame.parentNode || this.body.dom.center.appendChild(this.dom.frame), this.dom.axis.parentNode || this.body.dom.backgroundVertical.appendChild(this.dom.axis), this.dom.labelSet.parentNode || (this.options.rtl ? this.body.dom.right.appendChild(this.dom.labelSet) : this.body.dom.left.appendChild(this.dom.labelSet));
    }
    /**
     * Activates the popup timer to show the given popup after a fixed time.
     * @param {Popup} popup
     */
  }, {
    key: "setPopupTimer",
    value: function(s) {
      if (this.clearPopupTimer(), s) {
        var a = this.options.tooltip.delay || typeof this.options.tooltip.delay == "number" ? this.options.tooltip.delay : 500;
        this.popupTimer = ai(function() {
          s.show();
        }, a);
      }
    }
    /**
     * Clears the popup timer for the tooltip.
     */
  }, {
    key: "clearPopupTimer",
    value: function() {
      this.popupTimer != null && (clearTimeout(this.popupTimer), this.popupTimer = null);
    }
    /**
     * Set selected items by their id. Replaces the current selection
     * Unknown id's are silently ignored.
     * @param {string[] | string} [ids] An array with zero or more id's of the items to be
     *                                  selected, or a single item id. If ids is undefined
     *                                  or an empty array, all items will be unselected.
     */
  }, {
    key: "setSelection",
    value: function(s) {
      var a;
      s == null && (s = []), $t(s) || (s = [s]);
      var o = At(a = this.selection).call(a, function(b) {
        return lr(s).call(s, b) === -1;
      }), l = Ql(o), u;
      try {
        for (l.s(); !(u = l.n()).done; ) {
          var c = u.value, d = this.getItemById(c);
          d && d.unselect();
        }
      } catch (b) {
        l.e(b);
      } finally {
        l.f();
      }
      this.selection = Vs(s);
      var h = Ql(s), f;
      try {
        for (h.s(); !(f = h.n()).done; ) {
          var p = f.value, m = this.getItemById(p);
          m && m.select();
        }
      } catch (b) {
        h.e(b);
      } finally {
        h.f();
      }
    }
    /**
     * Get the selected items by their id
     * @return {Array} ids  The ids of the selected items
     */
  }, {
    key: "getSelection",
    value: function() {
      var s;
      return Dr(s = this.selection).call(s, []);
    }
    /**
     * Get the id's of the currently visible items.
     * @returns {Array} The ids of the visible items
     */
  }, {
    key: "getVisibleItems",
    value: function() {
      var s = this.body.range.getRange(), a, o;
      this.options.rtl ? (a = this.body.util.toScreen(s.start), o = this.body.util.toScreen(s.end)) : (o = this.body.util.toScreen(s.start), a = this.body.util.toScreen(s.end));
      var l = [];
      for (var u in this.groups)
        if (this.groups.hasOwnProperty(u)) {
          var c = this.groups[u], d = c.isVisible ? c.visibleItems : [], h = Ql(d), f;
          try {
            for (h.s(); !(f = h.n()).done; ) {
              var p = f.value;
              this.options.rtl ? p.right < o && p.right + p.width > a && l.push(p.id) : p.left < a && p.left + p.width > o && l.push(p.id);
            }
          } catch (m) {
            h.e(m);
          } finally {
            h.f();
          }
        }
      return l;
    }
    /**
    * Get the id's of the items at specific time, where a click takes place on the timeline.
    * @returns {Array} The ids of all items in existence at the time of click event on the timeline.
    */
  }, {
    key: "getItemsAtCurrentTime",
    value: function(s) {
      var a, o;
      this.options.rtl ? (a = this.body.util.toScreen(s), o = this.body.util.toScreen(s)) : (o = this.body.util.toScreen(s), a = this.body.util.toScreen(s));
      var l = [];
      for (var u in this.groups)
        if (this.groups.hasOwnProperty(u)) {
          var c = this.groups[u], d = c.isVisible ? c.visibleItems : [], h = Ql(d), f;
          try {
            for (h.s(); !(f = h.n()).done; ) {
              var p = f.value;
              this.options.rtl ? p.right < o && p.right + p.width > a && l.push(p.id) : p.left < a && p.left + p.width > o && l.push(p.id);
            }
          } catch (m) {
            h.e(m);
          } finally {
            h.f();
          }
        }
      return l;
    }
    /**
     * Get the id's of the currently visible groups.
     * @returns {Array} The ids of the visible groups
     */
  }, {
    key: "getVisibleGroups",
    value: function() {
      var s = [];
      for (var a in this.groups)
        if (this.groups.hasOwnProperty(a)) {
          var o = this.groups[a];
          o.isVisible && s.push(a);
        }
      return s;
    }
    /**
     * get item by id
     * @param {string} id
     * @return {object} item
     */
  }, {
    key: "getItemById",
    value: function(s) {
      var a;
      return this.items[s] || W8e(a = this.clusters).call(a, function(o) {
        return o.id === s;
      });
    }
    /**
     * Deselect a selected item
     * @param {string | number} id
     * @private
     */
  }, {
    key: "_deselect",
    value: function(s) {
      for (var a = this.selection, o = 0, l = a.length; o < l; o++)
        if (a[o] == s) {
          xi(a).call(a, o, 1);
          break;
        }
    }
    /**
     * Repaint the component
     * @return {boolean} Returns true if the component is resized
     */
  }, {
    key: "redraw",
    value: function() {
      var s = this.options.margin, a = this.body.range, o = G.option.asSize, l = this.options, u = l.orientation.item, c = !1, d = this.dom.frame;
      this.props.top = this.body.domProps.top.height + this.body.domProps.border.top, this.options.rtl ? this.props.right = this.body.domProps.right.width + this.body.domProps.border.right : this.props.left = this.body.domProps.left.width + this.body.domProps.border.left, d.className = "vis-itemset", this.options.cluster && this._clusterItems(), c = this._orderGroups() || c;
      var h = a.end - a.start, f = h != this.lastVisibleInterval || this.props.width != this.props.lastWidth, p = a.start != this.lastRangeStart, m = l.stack != this.lastStack, b = l.stackSubgroups != this.lastStackSubgroups, y = f || p || m || b;
      this.lastVisibleInterval = h, this.lastRangeStart = a.start, this.lastStack = l.stack, this.lastStackSubgroups = l.stackSubgroups, this.props.lastWidth = this.props.width;
      var _ = this._firstGroup(), x = {
        item: s.item,
        axis: s.axis
      }, T = {
        item: s.item,
        axis: s.item.vertical / 2
      }, k = 0, E = s.axis + s.item.vertical;
      this.groups[Jo].redraw(a, T, y);
      var F = {}, R = 0;
      Le(G).call(G, this.groups, function(I, B) {
        if (B !== Jo) {
          var W = I == _ ? x : T, Q = !0;
          F[B] = I.redraw(a, W, y, Q), R = F[B].length;
        }
      });
      var $ = R > 0;
      if ($) {
        for (var O = {}, P = function(B) {
          Le(G).call(G, F, function(W, Q) {
            O[Q] = W[B]();
          });
        }, N = 0; N < R; N++)
          P(N);
        Le(G).call(G, this.groups, function(I, B) {
          if (B !== Jo) {
            var W = O[B];
            c = W || c, k += I.height;
          }
        }), k = Math.max(k, E);
      }
      return k = Math.max(k, E), d.style.height = o(k), this.props.width = d.offsetWidth, this.props.height = k, this.dom.axis.style.top = o(u == "top" ? this.body.domProps.top.height + this.body.domProps.border.top : this.body.domProps.top.height + this.body.domProps.centerContainer.height), this.options.rtl ? this.dom.axis.style.right = "0" : this.dom.axis.style.left = "0", this.hammer.get("press").set({
        time: this.options.longSelectPressTime
      }), this.initialItemSetDrawn = !0, c = this._isResized() || c, c;
    }
    /**
     * Get the first group, aligned with the axis
     * @return {Group | null} firstGroup
     * @private
     */
  }, {
    key: "_firstGroup",
    value: function() {
      var s = this.options.orientation.item == "top" ? 0 : this.groupIds.length - 1, a = this.groupIds[s], o = this.groups[a] || this.groups[Hc];
      return o || null;
    }
    /**
     * Create or delete the group holding all ungrouped items. This group is used when
     * there are no groups specified.
     * @protected
     */
  }, {
    key: "_updateUngrouped",
    value: function() {
      var s = this.groups[Hc], a, o;
      if (this.groupsData) {
        if (s) {
          s.dispose(), delete this.groups[Hc];
          for (o in this.items)
            if (this.items.hasOwnProperty(o)) {
              a = this.items[o], a.parent && a.parent.remove(a);
              var l = this.getGroupId(a.data), u = this.groups[l];
              u && u.add(a) || a.hide();
            }
        }
      } else if (!s) {
        var c = null, d = null;
        s = new ek(c, d, this), this.groups[Hc] = s;
        for (o in this.items)
          this.items.hasOwnProperty(o) && (a = this.items[o], s.add(a));
        s.show();
      }
    }
    /**
     * Get the element for the labelset
     * @return {HTMLElement} labelSet
     */
  }, {
    key: "getLabelSet",
    value: function() {
      return this.dom.labelSet;
    }
    /**
     * Set items
     * @param {vis.DataSet | null} items
     */
  }, {
    key: "setItems",
    value: function(s) {
      this.itemsSettingTime = /* @__PURE__ */ new Date();
      var a = this, o, l = this.itemsData;
      if (!s)
        this.itemsData = null;
      else if (Oo(s))
        this.itemsData = qd(s);
      else
        throw new TypeError("Data must implement the interface of DataSet or DataView");
      if (l && (Le(G).call(G, this.itemListeners, function(c, d) {
        l.off(d, c);
      }), l.dispose(), o = l.getIds(), this._onRemove(o)), this.itemsData) {
        var u = this.id;
        Le(G).call(G, this.itemListeners, function(c, d) {
          a.itemsData.on(d, c, u);
        }), o = this.itemsData.getIds(), this._onAdd(o), this._updateUngrouped();
      }
      this.body.emitter.emit("_change", {
        queue: !0
      });
    }
    /**
     * Get the current items
     * @returns {vis.DataSet | null}
     */
  }, {
    key: "getItems",
    value: function() {
      return this.itemsData != null ? this.itemsData.rawDS : null;
    }
    /**
     * Set groups
     * @param {vis.DataSet} groups
     */
  }, {
    key: "setGroups",
    value: function(s) {
      var a = this, o;
      if (this.groupsData && (Le(G).call(G, this.groupListeners, function(d, h) {
        a.groupsData.off(h, d);
      }), o = this.groupsData.getIds(), this.groupsData = null, this._onRemoveGroups(o)), !s)
        this.groupsData = null;
      else if (Oo(s))
        this.groupsData = s;
      else
        throw new TypeError("Data must implement the interface of DataSet or DataView");
      if (this.groupsData) {
        var l, u = this.groupsData.getDataSet();
        Le(l = u.get()).call(l, function(d) {
          if (d.nestedGroups) {
            var h;
            Le(h = d.nestedGroups).call(h, function(f) {
              var p = u.get(f);
              p.nestedInGroup = d.id, d.showNested == !1 && (p.visible = !1), u.update(p);
            });
          }
        });
        var c = this.id;
        Le(G).call(G, this.groupListeners, function(d, h) {
          a.groupsData.on(h, d, c);
        }), o = this.groupsData.getIds(), this._onAddGroups(o);
      }
      this._updateUngrouped(), this._order(), this.options.cluster && (this.clusterGenerator.updateData(), this._clusterItems(), this.markDirty({
        refreshItems: !0,
        restackGroups: !0
      })), this.body.emitter.emit("_change", {
        queue: !0
      });
    }
    /**
     * Get the current groups
     * @returns {vis.DataSet | null} groups
     */
  }, {
    key: "getGroups",
    value: function() {
      return this.groupsData;
    }
    /**
     * Remove an item by its id
     * @param {string | number} id
     */
  }, {
    key: "removeItem",
    value: function(s) {
      var a = this, o = this.itemsData.get(s);
      o && this.options.onRemove(o, function(l) {
        l && a.itemsData.remove(s);
      });
    }
    /**
     * Get the time of an item based on it's data and options.type
     * @param {Object} itemData
     * @returns {string} Returns the type
     * @private
     */
  }, {
    key: "_getType",
    value: function(s) {
      return s.type || this.options.type || (s.end ? "range" : "box");
    }
    /**
     * Get the group id for an item
     * @param {Object} itemData
     * @returns {string} Returns the groupId
     * @private
     */
  }, {
    key: "getGroupId",
    value: function(s) {
      var a = this._getType(s);
      return a == "background" && s.group == null ? Jo : this.groupsData ? s.group : Hc;
    }
    /**
     * Handle updated items
     * @param {number[]} ids
     * @protected
     */
  }, {
    key: "_onUpdate",
    value: function(s) {
      var a = this, o = this;
      Le(s).call(s, function(l) {
        var u = o.itemsData.get(l), c = o.items[l], d = u ? o._getType(u) : null, h = r.types[d], f;
        if (c && (!h || !(c instanceof h) ? (f = c.selected, o._removeItem(c), c = null) : o._updateItem(c, u)), !c && u)
          if (h)
            c = new h(u, o.conversion, o.options), c.id = l, o._addItem(c), f && (a.selection.push(l), c.select());
          else
            throw new TypeError('Unknown item type "'.concat(d, '"'));
      }), this._order(), this.options.cluster && (this.clusterGenerator.setItems(this.items, {
        applyOnChangedLevel: !1
      }), this._clusterItems()), this.body.emitter.emit("_change", {
        queue: !0
      });
    }
    /**
     * Handle removed items
     * @param {number[]} ids
     * @protected
     */
  }, {
    key: "_onRemove",
    value: function(s) {
      var a = 0, o = this;
      Le(s).call(s, function(l) {
        var u = o.items[l];
        u && (a++, o._removeItem(u));
      }), a && (this._order(), this.body.emitter.emit("_change", {
        queue: !0
      }));
    }
    /**
     * Update the order of item in all groups
     * @private
     */
  }, {
    key: "_order",
    value: function() {
      Le(G).call(G, this.groups, function(s) {
        s.order();
      });
    }
    /**
     * Handle updated groups
     * @param {number[]} ids
     * @private
     */
  }, {
    key: "_onUpdateGroups",
    value: function(s) {
      this._onAddGroups(s);
    }
    /**
     * Handle changed groups (added or updated)
     * @param {number[]} ids
     * @private
     */
  }, {
    key: "_onAddGroups",
    value: function(s) {
      var a = this;
      Le(s).call(s, function(o) {
        var l = a.groupsData.get(o), u = a.groups[o];
        if (u)
          u.setData(l);
        else {
          if (o == Hc || o == Jo)
            throw new Error("Illegal group id. ".concat(o, " is a reserved id."));
          var c = Pb(a.options);
          G.extend(c, {
            height: null
          }), u = new ek(o, l, a), a.groups[o] = u;
          for (var d in a.items)
            if (a.items.hasOwnProperty(d)) {
              var h = a.items[d];
              h.data.group == o && u.add(h);
            }
          u.order(), u.show();
        }
      }), this.body.emitter.emit("_change", {
        queue: !0
      });
    }
    /**
     * Handle removed groups
     * @param {number[]} ids
     * @private
     */
  }, {
    key: "_onRemoveGroups",
    value: function(s) {
      var a = this;
      Le(s).call(s, function(o) {
        var l = a.groups[o];
        l && (l.dispose(), delete a.groups[o]);
      }), this.options.cluster && (this.clusterGenerator.updateData(), this._clusterItems()), this.markDirty({
        restackGroups: !!this.options.cluster
      }), this.body.emitter.emit("_change", {
        queue: !0
      });
    }
    /**
     * Reorder the groups if needed
     * @return {boolean} changed
     * @private
     */
  }, {
    key: "_orderGroups",
    value: function() {
      if (this.groupsData) {
        var s = this.groupsData.getIds({
          order: this.options.groupOrder
        });
        s = this._orderNestedGroups(s);
        var a = !G.equalArray(s, this.groupIds);
        if (a) {
          var o = this.groups;
          Le(s).call(s, function(l) {
            o[l].hide();
          }), Le(s).call(s, function(l) {
            o[l].show();
          }), this.groupIds = s;
        }
        return a;
      } else
        return !1;
    }
    /**
     * Reorder the nested groups
     *
     * @param {Array.<number>} groupIds
     * @returns {Array.<number>}
     * @private
     */
  }, {
    key: "_orderNestedGroups",
    value: function(s) {
      var a = this;
      function o(u, c) {
        var d = [];
        return Le(c).call(c, function(h) {
          d.push(h);
          var f = u.groupsData.get(h);
          if (f.nestedGroups) {
            var p, m = ln(p = u.groupsData.get({
              filter: function(y) {
                return y.nestedInGroup == h;
              },
              order: u.options.groupOrder
            })).call(p, function(b) {
              return b.id;
            });
            d = Dr(d).call(d, o(u, m));
          }
        }), d;
      }
      var l = At(s).call(s, function(u) {
        return !a.groupsData.get(u).nestedInGroup;
      });
      return o(this, l);
    }
    /**
     * Add a new item
     * @param {Item} item
     * @private
     */
  }, {
    key: "_addItem",
    value: function(s) {
      this.items[s.id] = s;
      var a = this.getGroupId(s.data), o = this.groups[a];
      o ? o && o.data && o.data.showNested && (s.groupShowing = !0) : s.groupShowing = !1, o && o.add(s);
    }
    /**
     * Update an existing item
     * @param {Item} item
     * @param {Object} itemData
     * @private
     */
  }, {
    key: "_updateItem",
    value: function(s, a) {
      s.setData(a);
      var o = this.getGroupId(s.data), l = this.groups[o];
      l ? l && l.data && l.data.showNested && (s.groupShowing = !0) : s.groupShowing = !1;
    }
    /**
     * Delete an item from the ItemSet: remove it from the DOM, from the map
     * with items, and from the map with visible items, and from the selection
     * @param {Item} item
     * @private
     */
  }, {
    key: "_removeItem",
    value: function(s) {
      var a, o;
      s.hide(), delete this.items[s.id];
      var l = lr(a = this.selection).call(a, s.id);
      l != -1 && xi(o = this.selection).call(o, l, 1), s.parent && s.parent.remove(s), this.popup != null && this.popup.hide();
    }
    /**
     * Create an array containing all items being a range (having an end date)
     * @param {Array.<Object>} array
     * @returns {Array}
     * @private
     */
  }, {
    key: "_constructByEndArray",
    value: function(s) {
      for (var a = [], o = 0; o < s.length; o++)
        s[o] instanceof Xu && a.push(s[o]);
      return a;
    }
    /**
     * Register the clicked item on touch, before dragStart is initiated.
     *
     * dragStart is initiated from a mousemove event, AFTER the mouse/touch is
     * already moving. Therefore, the mouse/touch can sometimes be above an other
     * DOM element than the item itself.
     *
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onTouch",
    value: function(s) {
      this.touchParams.item = this.itemFromTarget(s), this.touchParams.dragLeftItem = s.target.dragLeftItem || !1, this.touchParams.dragRightItem = s.target.dragRightItem || !1, this.touchParams.itemProps = null;
    }
    /**
     * Given an group id, returns the index it has.
     *
     * @param {number} groupId
     * @returns {number} index / groupId
     * @private
     */
  }, {
    key: "_getGroupIndex",
    value: function(s) {
      for (var a = 0; a < this.groupIds.length; a++)
        if (s == this.groupIds[a])
          return a;
    }
    /**
     * Start dragging the selected events
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onDragStart",
    value: function(s) {
      var a = this;
      if (!this.touchParams.itemIsDragging) {
        var o = this.touchParams.item || null, l = this, u;
        if (o && (o.selected || this.options.itemsAlwaysDraggable.item)) {
          if (this.options.editable.overrideItems && !this.options.editable.updateTime && !this.options.editable.updateGroup || o.editable != null && !o.editable.updateTime && !o.editable.updateGroup && !this.options.editable.overrideItems)
            return;
          var c = this.touchParams.dragLeftItem, d = this.touchParams.dragRightItem;
          if (this.touchParams.itemIsDragging = !0, this.touchParams.selectedItem = o, c)
            u = {
              item: c,
              initialX: s.center.x,
              dragLeft: !0,
              data: this._cloneItemData(o.data)
            }, this.touchParams.itemProps = [u];
          else if (d)
            u = {
              item: d,
              initialX: s.center.x,
              dragRight: !0,
              data: this._cloneItemData(o.data)
            }, this.touchParams.itemProps = [u];
          else if (this.options.editable.add && (s.srcEvent.ctrlKey || s.srcEvent.metaKey))
            this._onDragStartAddItem(s);
          else {
            this.groupIds.length < 1 && this.redraw();
            var h = this._getGroupIndex(o.data.group), f = this.options.itemsAlwaysDraggable.item && !o.selected ? [o.id] : this.getSelection();
            this.touchParams.itemProps = ln(f).call(f, function(p) {
              var m = l.items[p], b = l._getGroupIndex(m.data.group);
              return {
                item: m,
                initialX: s.center.x,
                groupOffset: h - b,
                data: a._cloneItemData(m.data)
              };
            });
          }
          s.stopPropagation();
        } else
          this.options.editable.add && (s.srcEvent.ctrlKey || s.srcEvent.metaKey) && this._onDragStartAddItem(s);
      }
    }
    /**
     * Start creating a new range item by dragging.
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onDragStartAddItem",
    value: function(s) {
      var a = this.options.snap || null, o = this.dom.frame.getBoundingClientRect(), l = this.options.rtl ? o.right - s.center.x + 10 : s.center.x - o.left - 10, u = this.body.util.toTime(l), c = this.body.util.getScale(), d = this.body.util.getStep(), h = a ? a(u, c, d) : u, f = h, p = {
        type: "range",
        start: h,
        end: f,
        content: "new item"
      }, m = Dd();
      p[this.itemsData.idProp] = m;
      var b = this.groupFromTarget(s);
      b && (p.group = b.groupId);
      var y = new Xu(p, this.conversion, this.options);
      y.id = m, y.data = this._cloneItemData(p), this._addItem(y), this.touchParams.selectedItem = y;
      var _ = {
        item: y,
        initialX: s.center.x,
        data: y.data
      };
      this.options.rtl ? _.dragLeft = !0 : _.dragRight = !0, this.touchParams.itemProps = [_], s.stopPropagation();
    }
    /**
     * Drag selected items
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onDrag",
    value: function(s) {
      var a = this;
      if (this.popup != null && this.options.showTooltips && !this.popup.hidden) {
        var o = this.body.dom.centerContainer, l = o.getBoundingClientRect();
        this.popup.setPosition(s.center.x - l.left + o.offsetLeft, s.center.y - l.top + o.offsetTop), this.popup.show();
      }
      if (this.touchParams.itemProps) {
        var u;
        s.stopPropagation();
        var c = this, d = this.options.snap || null, h = this.body.dom.root.offsetLeft, f = this.options.rtl ? h + this.body.domProps.right.width : h + this.body.domProps.left.width, p = this.body.util.getScale(), m = this.body.util.getStep(), b = this.touchParams.selectedItem, y = (this.options.editable.overrideItems || b.editable == null) && this.options.editable.updateGroup || !this.options.editable.overrideItems && b.editable != null && b.editable.updateGroup, _ = null;
        if (y && b && b.data.group != null) {
          var x = c.groupFromTarget(s);
          x && (_ = this._getGroupIndex(x.groupId));
        }
        Le(u = this.touchParams.itemProps).call(u, function(T) {
          var k = c.body.util.toTime(s.center.x - f), E = c.body.util.toTime(T.initialX - f), F, R, $, O, P;
          a.options.rtl ? F = -(k - E) : F = k - E;
          var N = a._cloneItemData(T.item.data);
          if (!(T.item.editable != null && !T.item.editable.updateTime && !T.item.editable.updateGroup && !c.options.editable.overrideItems)) {
            var I = (a.options.editable.overrideItems || b.editable == null) && a.options.editable.updateTime || !a.options.editable.overrideItems && b.editable != null && b.editable.updateTime;
            if (I) {
              if (T.dragLeft)
                a.options.rtl ? N.end != null && ($ = G.convert(T.data.end, "Date"), P = new Date($.valueOf() + F), N.end = d ? d(P, p, m) : P) : N.start != null && (R = G.convert(T.data.start, "Date"), O = new Date(R.valueOf() + F), N.start = d ? d(O, p, m) : O);
              else if (T.dragRight)
                a.options.rtl ? N.start != null && (R = G.convert(T.data.start, "Date"), O = new Date(R.valueOf() + F), N.start = d ? d(O, p, m) : O) : N.end != null && ($ = G.convert(T.data.end, "Date"), P = new Date($.valueOf() + F), N.end = d ? d(P, p, m) : P);
              else if (N.start != null)
                if (R = G.convert(T.data.start, "Date").valueOf(), O = new Date(R + F), N.end != null) {
                  $ = G.convert(T.data.end, "Date");
                  var B = $.valueOf() - R.valueOf();
                  N.start = d ? d(O, p, m) : O, N.end = new Date(N.start.valueOf() + B);
                } else
                  N.start = d ? d(O, p, m) : O;
            }
            if (y && !T.dragLeft && !T.dragRight && _ != null && N.group != null) {
              var W = _ - T.groupOffset;
              W = Math.max(0, W), W = Math.min(c.groupIds.length - 1, W), N.group = c.groupIds[W];
            }
            N = a._cloneItemData(N), c.options.onMoving(N, function(Q) {
              Q && T.item.setData(a._cloneItemData(Q, "Date"));
            });
          }
        }), this.body.emitter.emit("_change");
      }
    }
    /**
     * Move an item to another group
     * @param {Item} item
     * @param {string | number} groupId
     * @private
     */
  }, {
    key: "_moveToGroup",
    value: function(s, a) {
      var o = this.groups[a];
      if (o && o.groupId != s.data.group) {
        var l = s.parent;
        l.remove(s), l.order(), s.data.group = o.groupId, o.add(s), o.order();
      }
    }
    /**
     * End of dragging selected items
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onDragEnd",
    value: function(s) {
      var a = this;
      if (this.touchParams.itemIsDragging = !1, this.touchParams.itemProps) {
        s.stopPropagation();
        var o = this, l = this.touchParams.itemProps;
        this.touchParams.itemProps = null, Le(l).call(l, function(u) {
          var c = u.item.id, d = o.itemsData.get(c) != null;
          if (!d)
            o.options.onAdd(u.item.data, function(f) {
              o._removeItem(u.item), f && o.itemsData.add(f), o.body.emitter.emit("_change");
            });
          else {
            var h = a._cloneItemData(u.item.data);
            o.options.onMove(h, function(f) {
              f ? (f[a.itemsData.idProp] = c, a.itemsData.update(f)) : (u.item.setData(u.data), o.body.emitter.emit("_change"));
            });
          }
        });
      }
    }
    /**
     * On group click
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onGroupClick",
    value: function(s) {
      var a = this, o = this.groupFromTarget(s);
      ai(function() {
        a.toggleGroupShowNested(o);
      }, 1);
    }
    /**
     * Toggle show nested
     * @param {object} group
     * @param {boolean} force
     */
  }, {
    key: "toggleGroupShowNested",
    value: function(s) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
      if (!(!s || !s.nestedGroups)) {
        var o = this.groupsData.getDataSet();
        a != null ? s.showNested = !!a : s.showNested = !s.showNested;
        var l = o.get(s.groupId);
        l.showNested = s.showNested;
        for (var u = s.nestedGroups, c = u; c.length > 0; ) {
          var d = c;
          c = [];
          for (var h = 0; h < d.length; h++) {
            var f = o.get(d[h]);
            f.nestedGroups && (c = Dr(c).call(c, f.nestedGroups));
          }
          c.length > 0 && (u = Dr(u).call(u, c));
        }
        var p;
        if (l.showNested) {
          for (var m = o.get(l.nestedGroups), b = 0; b < m.length; b++) {
            var y = m[b];
            y.nestedGroups && y.nestedGroups.length > 0 && (y.showNested == null || y.showNested == !0) && m.push.apply(m, Vs(o.get(y.nestedGroups)));
          }
          p = ln(m).call(m, function(x) {
            return x.visible == null && (x.visible = !0), x.visible = !!l.showNested, x;
          });
        } else {
          var _;
          p = ln(_ = o.get(u)).call(_, function(x) {
            return x.visible == null && (x.visible = !0), x.visible = !!l.showNested, x;
          });
        }
        o.update(Dr(p).call(p, l)), l.showNested ? (G.removeClassName(s.dom.label, "collapsed"), G.addClassName(s.dom.label, "expanded")) : (G.removeClassName(s.dom.label, "expanded"), G.addClassName(s.dom.label, "collapsed"));
      }
    }
    /**
     * Toggle group drag classname
     * @param {object} group
     */
  }, {
    key: "toggleGroupDragClassName",
    value: function(s) {
      s.dom.label.classList.toggle("vis-group-is-dragging"), s.dom.foreground.classList.toggle("vis-group-is-dragging");
    }
    /**
     * on drag start
     * @param {Event} event
     * @return {void}   
     * @private
     */
  }, {
    key: "_onGroupDragStart",
    value: function(s) {
      this.groupTouchParams.isDragging || this.options.groupEditable.order && (this.groupTouchParams.group = this.groupFromTarget(s), this.groupTouchParams.group && (s.stopPropagation(), this.groupTouchParams.isDragging = !0, this.toggleGroupDragClassName(this.groupTouchParams.group), this.groupTouchParams.originalOrder = this.groupsData.getIds({
        order: this.options.groupOrder
      })));
    }
    /**
     * on drag
     * @param {Event} event
     * @return {void}
     * @private
     */
  }, {
    key: "_onGroupDrag",
    value: function(s) {
      if (this.options.groupEditable.order && this.groupTouchParams.group) {
        s.stopPropagation();
        var a = this.groupsData.getDataSet(), o = this.groupFromTarget(s);
        if (o && o.height != this.groupTouchParams.group.height) {
          var l = o.top < this.groupTouchParams.group.top, u = s.center ? s.center.y : s.clientY, c = o.dom.foreground.getBoundingClientRect(), d = this.groupTouchParams.group.height;
          if (l) {
            if (c.top + d < u)
              return;
          } else {
            var h = o.height;
            if (c.top + h - d > u)
              return;
          }
        }
        if (o && o != this.groupTouchParams.group) {
          var f = a.get(o.groupId), p = a.get(this.groupTouchParams.group.groupId);
          p && f && (this.options.groupOrderSwap(p, f, a), a.update(p), a.update(f));
          var m = a.getIds({
            order: this.options.groupOrder
          });
          if (!G.equalArray(m, this.groupTouchParams.originalOrder))
            for (var b = this.groupTouchParams.originalOrder, y = this.groupTouchParams.group.groupId, _ = Math.min(b.length, m.length), x = 0, T = 0, k = 0; x < _; ) {
              for (; x + T < _ && x + k < _ && m[x + T] == b[x + k]; )
                x++;
              if (x + T >= _)
                break;
              if (m[x + T] == y)
                T = 1;
              else if (b[x + k] == y)
                k = 1;
              else {
                var E = lr(m).call(m, b[x + k]), F = a.get(m[x + T]), R = a.get(b[x + k]);
                this.options.groupOrderSwap(F, R, a), a.update(F), a.update(R);
                var $ = m[x + T];
                m[x + T] = b[x + k], m[E] = $, x++;
              }
            }
        }
      }
    }
    /**
     * on drag end
     * @param {Event} event
     * @return {void}
     * @private
     */
  }, {
    key: "_onGroupDragEnd",
    value: function(s) {
      if (this.groupTouchParams.isDragging = !1, this.options.groupEditable.order && this.groupTouchParams.group) {
        s.stopPropagation();
        var a = this, o = a.groupTouchParams.group.groupId, l = a.groupsData.getDataSet(), u = G.extend({}, l.get(o));
        a.options.onMoveGroup(u, function(c) {
          if (c)
            c[l._idProp] = o, l.update(c);
          else {
            var d = l.getIds({
              order: a.options.groupOrder
            });
            if (!G.equalArray(d, a.groupTouchParams.originalOrder))
              for (var h = a.groupTouchParams.originalOrder, f = Math.min(h.length, d.length), p = 0; p < f; ) {
                for (; p < f && d[p] == h[p]; )
                  p++;
                if (p >= f)
                  break;
                var m = lr(d).call(d, h[p]), b = l.get(d[p]), y = l.get(h[p]);
                a.options.groupOrderSwap(b, y, l), l.update(b), l.update(y);
                var _ = d[p];
                d[p] = h[p], d[m] = _, p++;
              }
          }
        }), a.body.emitter.emit("groupDragged", {
          groupId: o
        }), this.toggleGroupDragClassName(this.groupTouchParams.group), this.groupTouchParams.group = null;
      }
    }
    /**
     * Handle selecting/deselecting an item when tapping it
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onSelectItem",
    value: function(s) {
      if (this.options.selectable) {
        var a = s.srcEvent && (s.srcEvent.ctrlKey || s.srcEvent.metaKey), o = s.srcEvent && s.srcEvent.shiftKey;
        if (a || o) {
          this._onMultiSelectItem(s);
          return;
        }
        var l = this.getSelection(), u = this.itemFromTarget(s), c = u && u.selectable ? [u.id] : [];
        this.setSelection(c);
        var d = this.getSelection();
        (d.length > 0 || l.length > 0) && this.body.emitter.emit("select", {
          items: d,
          event: s
        });
      }
    }
    /**
     * Handle hovering an item
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onMouseOver",
    value: function(s) {
      var a = this.itemFromTarget(s);
      if (a) {
        var o = this.itemFromRelatedTarget(s);
        if (a !== o) {
          var l = a.getTitle();
          if (this.options.showTooltips && l) {
            this.popup == null && (this.popup = new z7e(this.body.dom.root, this.options.tooltip.overflowMethod || "flip")), this.popup.setText(l);
            var u = this.body.dom.centerContainer, c = u.getBoundingClientRect();
            this.popup.setPosition(s.clientX - c.left + u.offsetLeft, s.clientY - c.top + u.offsetTop), this.setPopupTimer(this.popup);
          } else
            this.clearPopupTimer(), this.popup != null && this.popup.hide();
          this.body.emitter.emit("itemover", {
            item: a.id,
            event: s
          });
        }
      }
    }
    /**
     * on mouse start
     * @param {Event} event
     * @return {void}   
     * @private
     */
  }, {
    key: "_onMouseOut",
    value: function(s) {
      var a = this.itemFromTarget(s);
      if (a) {
        var o = this.itemFromRelatedTarget(s);
        a !== o && (this.clearPopupTimer(), this.popup != null && this.popup.hide(), this.body.emitter.emit("itemout", {
          item: a.id,
          event: s
        }));
      }
    }
    /**
     * on mouse move
     * @param {Event} event
     * @return {void}   
     * @private
     */
  }, {
    key: "_onMouseMove",
    value: function(s) {
      var a = this.itemFromTarget(s);
      if (a && (this.popupTimer != null && this.setPopupTimer(this.popup), this.options.showTooltips && this.options.tooltip.followMouse && this.popup && !this.popup.hidden)) {
        var o = this.body.dom.centerContainer, l = o.getBoundingClientRect();
        this.popup.setPosition(s.clientX - l.left + o.offsetLeft, s.clientY - l.top + o.offsetTop), this.popup.show();
      }
    }
    /**
     * Handle mousewheel
     * @param {Event}  event   The event
     * @private
     */
  }, {
    key: "_onMouseWheel",
    value: function(s) {
      this.touchParams.itemIsDragging && this._onDragEnd(s);
    }
    /**
     * Handle updates of an item on double tap
     * @param {timeline.Item}  item   The item
     * @private
     */
  }, {
    key: "_onUpdateItem",
    value: function(s) {
      if (this.options.selectable && !(!this.options.editable.updateTime && !this.options.editable.updateGroup)) {
        var a = this;
        if (s) {
          var o = a.itemsData.get(s.id);
          this.options.onUpdate(o, function(l) {
            l && a.itemsData.update(l);
          });
        }
      }
    }
    /**
     * Handle drop event of data on item
     * Only called when `objectData.target === 'item'.
     * @param {Event} event The event 
     * @private
     */
  }, {
    key: "_onDropObjectOnItem",
    value: function(s) {
      var a = this.itemFromTarget(s), o = JSON.parse(s.dataTransfer.getData("text"));
      this.options.onDropObjectOnItem(o, a);
    }
    /**
     * Handle creation of an item on double tap or drop of a drag event
     * @param {Event} event   The event
     * @private
     */
  }, {
    key: "_onAddItem",
    value: function(s) {
      if (this.options.selectable && this.options.editable.add) {
        var a = this, o = this.options.snap || null, l = this.dom.frame.getBoundingClientRect(), u = this.options.rtl ? l.right - s.center.x : s.center.x - l.left, c = this.body.util.toTime(u), d = this.body.util.getScale(), h = this.body.util.getStep(), f, p;
        s.type == "drop" ? (p = JSON.parse(s.dataTransfer.getData("text")), p.content = p.content ? p.content : "new item", p.start = p.start ? p.start : o ? o(c, d, h) : c, p.type = p.type || "box", p[this.itemsData.idProp] = p.id || Dd(), p.type == "range" && !p.end && (f = this.body.util.toTime(u + this.props.width / 5), p.end = o ? o(f, d, h) : f)) : (p = {
          start: o ? o(c, d, h) : c,
          content: "new item"
        }, p[this.itemsData.idProp] = Dd(), this.options.type === "range" && (f = this.body.util.toTime(u + this.props.width / 5), p.end = o ? o(f, d, h) : f));
        var m = this.groupFromTarget(s);
        m && (p.group = m.groupId), p = this._cloneItemData(p), this.options.onAdd(p, function(b) {
          b && (a.itemsData.add(b), s.type == "drop" && a.setSelection([b.id]));
        });
      }
    }
    /**
     * Handle selecting/deselecting multiple items when holding an item
     * @param {Event} event
     * @private
     */
  }, {
    key: "_onMultiSelectItem",
    value: function(s) {
      var a = this;
      if (this.options.selectable) {
        var o = this.itemFromTarget(s);
        if (o) {
          var l = this.options.multiselect ? this.getSelection() : [], u = s.srcEvent && s.srcEvent.shiftKey || !1;
          if ((u || this.options.sequentialSelection) && this.options.multiselect) {
            var c = this.itemsData.get(o.id).group, d = void 0;
            this.options.multiselectPerGroup && l.length > 0 && (d = this.itemsData.get(l[0]).group), (!this.options.multiselectPerGroup || d == null || d == c) && l.push(o.id);
            var h = r._getItemRange(this.itemsData.get(l));
            if (!this.options.multiselectPerGroup || d == c) {
              l = [];
              for (var f in this.items)
                if (this.items.hasOwnProperty(f)) {
                  var p = this.items[f], m = p.data.start, b = p.data.end !== void 0 ? p.data.end : m;
                  m >= h.min && b <= h.max && (!this.options.multiselectPerGroup || d == this.itemsData.get(p.id).group) && !(p instanceof yc) && l.push(p.id);
                }
            }
          } else {
            var y = lr(l).call(l, o.id);
            y == -1 ? l.push(o.id) : xi(l).call(l, y, 1);
          }
          var _ = At(l).call(l, function(x) {
            return a.getItemById(x).selectable;
          });
          this.setSelection(_), this.body.emitter.emit("select", {
            items: this.getSelection(),
            event: s
          });
        }
      }
    }
    /**
     * Calculate the time range of a list of items
     * @param {Array.<Object>} itemsData
     * @return {{min: Date, max: Date}} Returns the range of the provided items
     * @private
     */
  }, {
    key: "itemFromElement",
    value: (
      /**
       * Find an item from an element:
       * searches for the attribute 'vis-item' in the element's tree
       * @param {HTMLElement} element
       * @return {Item | null} item
       */
      function(s) {
        for (var a = s; a; ) {
          if (a.hasOwnProperty("vis-item"))
            return a["vis-item"];
          a = a.parentNode;
        }
        return null;
      }
    )
    /**
     * Find an item from an event target:
     * searches for the attribute 'vis-item' in the event target's element tree
     * @param {Event} event
     * @return {Item | null} item
     */
  }, {
    key: "itemFromTarget",
    value: function(s) {
      return this.itemFromElement(s.target);
    }
    /**
     * Find an item from an event's related target:
     * searches for the attribute 'vis-item' in the related target's element tree
     * @param {Event} event
     * @return {Item | null} item
     */
  }, {
    key: "itemFromRelatedTarget",
    value: function(s) {
      return this.itemFromElement(s.relatedTarget);
    }
    /**
     * Find the Group from an event target:
     * searches for the attribute 'vis-group' in the event target's element tree
     * @param {Event} event
     * @return {Group | null} group
     */
  }, {
    key: "groupFromTarget",
    value: function(s) {
      var a = s.center ? s.center.y : s.clientY, o = this.groupIds;
      o.length <= 0 && this.groupsData && (o = this.groupsData.getIds({
        order: this.options.groupOrder
      }));
      for (var l = 0; l < o.length; l++) {
        var u = o[l], c = this.groups[u], d = c.dom.foreground, h = d.getBoundingClientRect();
        if (a >= h.top && a < h.top + d.offsetHeight)
          return c;
        if (this.options.orientation.item === "top") {
          if (l === this.groupIds.length - 1 && a > h.top)
            return c;
        } else if (l === 0 && a < h.top + d.offset)
          return c;
      }
      return null;
    }
    /**
     * Find the ItemSet from an event target:
     * searches for the attribute 'vis-itemset' in the event target's element tree
     * @param {Event} event
     * @return {ItemSet | null} item
     */
  }, {
    key: "_cloneItemData",
    value: (
      /**
       * Clone the data of an item, and "normalize" it: convert the start and end date
       * to the type (Date, Moment, ...) configured in the DataSet. If not configured,
       * start and end are converted to Date.
       * @param {Object} itemData, typically `item.data`
       * @param {string} [type]  Optional Date type. If not provided, the type from the DataSet is taken
       * @return {Object} The cloned object
       * @private
       */
      function(s, a) {
        var o = G.extend({}, s);
        return a || (a = this.itemsData.type), o.start != null && (o.start = G.convert(o.start, a && a.start || "Date")), o.end != null && (o.end = G.convert(o.end, a && a.end || "Date")), o;
      }
    )
    /**
     * cluster items
     * @return {void}   
     * @private
     */
  }, {
    key: "_clusterItems",
    value: function() {
      if (this.options.cluster) {
        var s = this.body.range.conversion(this.body.domProps.center.width), a = s.scale, o = this.clusterGenerator.getClusters(this.clusters, a, this.options.cluster);
        if (this.clusters != o) {
          if (this._detachAllClusters(), o) {
            var l = Ql(o), u;
            try {
              for (l.s(); !(u = l.n()).done; ) {
                var c = u.value;
                c.attach();
              }
            } catch (d) {
              l.e(d);
            } finally {
              l.f();
            }
            this.clusters = o;
          }
          this._updateClusters(o);
        }
      }
    }
    /**
     * detach all cluster items
     * @private
     */
  }, {
    key: "_detachAllClusters",
    value: function() {
      if (this.options.cluster && this.clusters && this.clusters.length) {
        var s = Ql(this.clusters), a;
        try {
          for (s.s(); !(a = s.n()).done; ) {
            var o = a.value;
            o.detach();
          }
        } catch (l) {
          s.e(l);
        } finally {
          s.f();
        }
      }
    }
    /**
     * update clusters
     * @param {array} clusters
     * @private
     */
  }, {
    key: "_updateClusters",
    value: function(s) {
      if (this.clusters && this.clusters.length) {
        var a, o = new t0(ln(s).call(s, function(y) {
          return y.id;
        })), l = At(a = this.clusters).call(a, function(y) {
          return !o.has(y.id);
        }), u = !1, c = Ql(l), d;
        try {
          for (c.s(); !(d = c.n()).done; ) {
            var h, f = d.value, p = lr(h = this.selection).call(h, f.id);
            if (p !== -1) {
              var m;
              f.unselect(), xi(m = this.selection).call(m, p, 1), u = !0;
            }
          }
        } catch (y) {
          c.e(y);
        } finally {
          c.f();
        }
        if (u) {
          var b = this.getSelection();
          this.body.emitter.emit("select", {
            items: b,
            event
          });
        }
      }
      this.clusters = s || [];
    }
  }], [{
    key: "_getItemRange",
    value: function(s) {
      var a = null, o = null;
      return Le(s).call(s, function(l) {
        (o == null || l.start < o) && (o = l.start), l.end != null ? (a == null || l.end > a) && (a = l.end) : (a == null || l.start > a) && (a = l.start);
      }), {
        min: o,
        max: a
      };
    }
  }, {
    key: "itemSetFromTarget",
    value: function(s) {
      for (var a = s.target; a; ) {
        if (a.hasOwnProperty("vis-itemset"))
          return a["vis-itemset"];
        a = a.parentNode;
      }
      return null;
    }
  }]), r;
}(Fl);
r0.types = {
  background: yc,
  box: U7e,
  range: Xu,
  point: H7e
};
r0.prototype._onAdd = r0.prototype._onUpdate;
var sf = !1, q2, n0 = "background: #FFeeee; color: #dd0000", VW = /* @__PURE__ */ function() {
  function t() {
    dr(this, t);
  }
  return hr(t, null, [{
    key: "validate",
    value: function(r, n, s) {
      sf = !1, q2 = n;
      var a = n;
      return s !== void 0 && (a = n[s]), t.parse(r, a, []), sf;
    }
    /**
     * Will traverse an object recursively and check every value
     * @param {Object} options
     * @param {Object} referenceOptions
     * @param {array} path    | where to look for the actual option
     * @static
     */
  }, {
    key: "parse",
    value: function(r, n, s) {
      for (var a in r)
        r.hasOwnProperty(a) && t.check(a, r, n, s);
    }
    /**
     * Check every value. If the value is an object, call the parse function on that object.
     * @param {string} option
     * @param {Object} options
     * @param {Object} referenceOptions
     * @param {array} path    | where to look for the actual option
     * @static
     */
  }, {
    key: "check",
    value: function(r, n, s, a) {
      if (s[r] === void 0 && s.__any__ === void 0) {
        t.getSuggestion(r, s, a);
        return;
      }
      var o = r, l = !0;
      s[r] === void 0 && s.__any__ !== void 0 && (o = "__any__", l = t.getType(n[r]) === "object");
      var u = s[o];
      l && u.__type__ !== void 0 && (u = u.__type__), t.checkFields(r, n, s, o, u, a);
    }
    /**
     *
     * @param {string}  option           | the option property
     * @param {Object}  options          | The supplied options object
     * @param {Object}  referenceOptions | The reference options containing all options and their allowed formats
     * @param {string}  referenceOption  | Usually this is the same as option, except when handling an __any__ tag.
     * @param {string}  refOptionObj     | This is the type object from the reference options
     * @param {Array}   path             | where in the object is the option
     * @static
     */
  }, {
    key: "checkFields",
    value: function(r, n, s, a, o, l) {
      var u = function(f) {
        console.log("%c" + f + t.printLocation(l, r), n0);
      }, c = t.getType(n[r]), d = o[c];
      d !== void 0 ? t.getType(d) === "array" && lr(d).call(d, n[r]) === -1 ? (u('Invalid option detected in "' + r + '". Allowed values are:' + t.print(d) + ' not "' + n[r] + '". '), sf = !0) : c === "object" && a !== "__any__" && (l = G.copyAndExtendArray(l, r), t.parse(n[r], s[a], l)) : o.any === void 0 && (u('Invalid type received for "' + r + '". Expected: ' + t.print(xn(o)) + ". Received [" + c + '] "' + n[r] + '"'), sf = !0);
    }
    /**
     *
     * @param {Object|boolean|number|string|Array.<number>|Date|Node|Moment|undefined|null} object
     * @returns {string}
     * @static
     */
  }, {
    key: "getType",
    value: function(r) {
      var n = mt(r);
      return n === "object" ? r === null ? "null" : r instanceof Boolean ? "boolean" : r instanceof Number ? "number" : r instanceof String ? "string" : $t(r) ? "array" : r instanceof Date ? "date" : r.nodeType !== void 0 ? "dom" : r._isAMomentObject === !0 ? "moment" : "object" : n === "number" ? "number" : n === "boolean" ? "boolean" : n === "string" ? "string" : n === void 0 ? "undefined" : n;
    }
    /**
     * @param {string} option
     * @param {Object} options
     * @param {Array.<string>} path
     * @static
     */
  }, {
    key: "getSuggestion",
    value: function(r, n, s) {
      var a = t.findInOptions(r, n, s, !1), o = t.findInOptions(r, q2, [], !0), l = 8, u = 4, c;
      a.indexMatch !== void 0 ? c = " in " + t.printLocation(a.path, r, "") + 'Perhaps it was incomplete? Did you mean: "' + a.indexMatch + `"?

` : o.distance <= u && a.distance > o.distance ? c = " in " + t.printLocation(a.path, r, "") + "Perhaps it was misplaced? Matching option found at: " + t.printLocation(o.path, o.closestMatch, "") : a.distance <= l ? c = '. Did you mean "' + a.closestMatch + '"?' + t.printLocation(a.path, r) : c = ". Did you mean one of these: " + t.print(xn(n)) + t.printLocation(s, r), console.log('%cUnknown option detected: "' + r + '"' + c, n0), sf = !0;
    }
    /**
     * traverse the options in search for a match.
     * @param {string} option
     * @param {Object} options
     * @param {Array} path    | where to look for the actual option
     * @param {boolean} [recursive=false]
     * @returns {{closestMatch: string, path: Array, distance: number}}
     * @static
     */
  }, {
    key: "findInOptions",
    value: function(r, n, s) {
      var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, o = 1e9, l = "", u = [], c = r.toLowerCase(), d = void 0;
      for (var h in n) {
        var f = void 0;
        if (n[h].__type__ !== void 0 && a === !0) {
          var p = t.findInOptions(r, n[h], G.copyAndExtendArray(s, h));
          o > p.distance && (l = p.closestMatch, u = p.path, o = p.distance, d = p.indexMatch);
        } else {
          var m;
          lr(m = h.toLowerCase()).call(m, c) !== -1 && (d = h), f = t.levenshteinDistance(r, h), o > f && (l = h, u = G.copyArray(s), o = f);
        }
      }
      return {
        closestMatch: l,
        path: u,
        distance: o,
        indexMatch: d
      };
    }
    /**
     * @param {Array.<string>} path
     * @param {Object} option
     * @param {string} prefix
     * @returns {String}
     * @static
     */
  }, {
    key: "printLocation",
    value: function(r, n) {
      for (var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : `Problem value found at: 
`, a = `

` + s + `options = {
`, o = 0; o < r.length; o++) {
        for (var l = 0; l < o + 1; l++)
          a += "  ";
        a += r[o] + `: {
`;
      }
      for (var u = 0; u < r.length + 1; u++)
        a += "  ";
      a += n + `
`;
      for (var c = 0; c < r.length + 1; c++) {
        for (var d = 0; d < r.length - c; d++)
          a += "  ";
        a += `}
`;
      }
      return a + `

`;
    }
    /**
     * @param {Object} options
     * @returns {String}
     * @static
     */
  }, {
    key: "print",
    value: function(r) {
      return Vi(r).replace(/(\")|(\[)|(\])|(,"__type__")/g, "").replace(/(\,)/g, ", ");
    }
    /**
     *  Compute the edit distance between the two given strings
     * http://en.wikibooks.org/wiki/Algorithm_Implementation/Strings/Levenshtein_distance#JavaScript
     *
     * Copyright (c) 2011 Andrei Mackenzie
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     *
     * @param {string} a
     * @param {string} b
     * @returns {Array.<Array.<number>>}}
     * @static
     */
  }, {
    key: "levenshteinDistance",
    value: function(r, n) {
      if (r.length === 0)
        return n.length;
      if (n.length === 0)
        return r.length;
      var s = [], a;
      for (a = 0; a <= n.length; a++)
        s[a] = [a];
      var o;
      for (o = 0; o <= r.length; o++)
        s[0][o] = o;
      for (a = 1; a <= n.length; a++)
        for (o = 1; o <= r.length; o++)
          n.charAt(a - 1) == r.charAt(o - 1) ? s[a][o] = s[a - 1][o - 1] : s[a][o] = Math.min(
            s[a - 1][o - 1] + 1,
            // substitution
            Math.min(
              s[a][o - 1] + 1,
              // insertion
              s[a - 1][o] + 1
            )
          );
      return s[n.length][r.length];
    }
  }]), t;
}(), yt = "string", vt = "boolean", gr = "number", X2 = "array", Gc = "date", zr = "object", _ze = "dom", Wc = "moment", Q2 = "any", wze = {
  configure: {
    enabled: {
      boolean: vt
    },
    filter: {
      boolean: vt,
      function: "function"
    },
    container: {
      dom: _ze
    },
    __type__: {
      object: zr,
      boolean: vt,
      function: "function"
    }
  },
  //globals :
  align: {
    string: yt
  },
  alignCurrentTime: {
    string: yt,
    undefined: "undefined"
  },
  rtl: {
    boolean: vt,
    undefined: "undefined"
  },
  rollingMode: {
    follow: {
      boolean: vt
    },
    offset: {
      number: gr,
      undefined: "undefined"
    },
    __type__: {
      object: zr
    }
  },
  onTimeout: {
    timeoutMs: {
      number: gr
    },
    callback: {
      function: "function"
    },
    __type__: {
      object: zr
    }
  },
  verticalScroll: {
    boolean: vt,
    undefined: "undefined"
  },
  horizontalScroll: {
    boolean: vt,
    undefined: "undefined"
  },
  autoResize: {
    boolean: vt
  },
  throttleRedraw: {
    number: gr
  },
  // TODO: DEPRICATED see https://github.com/almende/vis/issues/2511
  clickToUse: {
    boolean: vt
  },
  dataAttributes: {
    string: yt,
    array: X2
  },
  editable: {
    add: {
      boolean: vt,
      undefined: "undefined"
    },
    remove: {
      boolean: vt,
      undefined: "undefined"
    },
    updateGroup: {
      boolean: vt,
      undefined: "undefined"
    },
    updateTime: {
      boolean: vt,
      undefined: "undefined"
    },
    overrideItems: {
      boolean: vt,
      undefined: "undefined"
    },
    __type__: {
      boolean: vt,
      object: zr
    }
  },
  end: {
    number: gr,
    date: Gc,
    string: yt,
    moment: Wc
  },
  format: {
    minorLabels: {
      millisecond: {
        string: yt,
        undefined: "undefined"
      },
      second: {
        string: yt,
        undefined: "undefined"
      },
      minute: {
        string: yt,
        undefined: "undefined"
      },
      hour: {
        string: yt,
        undefined: "undefined"
      },
      weekday: {
        string: yt,
        undefined: "undefined"
      },
      day: {
        string: yt,
        undefined: "undefined"
      },
      week: {
        string: yt,
        undefined: "undefined"
      },
      month: {
        string: yt,
        undefined: "undefined"
      },
      year: {
        string: yt,
        undefined: "undefined"
      },
      __type__: {
        object: zr,
        function: "function"
      }
    },
    majorLabels: {
      millisecond: {
        string: yt,
        undefined: "undefined"
      },
      second: {
        string: yt,
        undefined: "undefined"
      },
      minute: {
        string: yt,
        undefined: "undefined"
      },
      hour: {
        string: yt,
        undefined: "undefined"
      },
      weekday: {
        string: yt,
        undefined: "undefined"
      },
      day: {
        string: yt,
        undefined: "undefined"
      },
      week: {
        string: yt,
        undefined: "undefined"
      },
      month: {
        string: yt,
        undefined: "undefined"
      },
      year: {
        string: yt,
        undefined: "undefined"
      },
      __type__: {
        object: zr,
        function: "function"
      }
    },
    __type__: {
      object: zr
    }
  },
  moment: {
    function: "function"
  },
  groupHeightMode: {
    string: yt
  },
  groupOrder: {
    string: yt,
    function: "function"
  },
  groupEditable: {
    add: {
      boolean: vt,
      undefined: "undefined"
    },
    remove: {
      boolean: vt,
      undefined: "undefined"
    },
    order: {
      boolean: vt,
      undefined: "undefined"
    },
    __type__: {
      boolean: vt,
      object: zr
    }
  },
  groupOrderSwap: {
    function: "function"
  },
  height: {
    string: yt,
    number: gr
  },
  hiddenDates: {
    start: {
      date: Gc,
      number: gr,
      string: yt,
      moment: Wc
    },
    end: {
      date: Gc,
      number: gr,
      string: yt,
      moment: Wc
    },
    repeat: {
      string: yt
    },
    __type__: {
      object: zr,
      array: X2
    }
  },
  itemsAlwaysDraggable: {
    item: {
      boolean: vt,
      undefined: "undefined"
    },
    range: {
      boolean: vt,
      undefined: "undefined"
    },
    __type__: {
      boolean: vt,
      object: zr
    }
  },
  limitSize: {
    boolean: vt
  },
  locale: {
    string: yt
  },
  locales: {
    __any__: {
      any: Q2
    },
    __type__: {
      object: zr
    }
  },
  longSelectPressTime: {
    number: gr
  },
  margin: {
    axis: {
      number: gr
    },
    item: {
      horizontal: {
        number: gr,
        undefined: "undefined"
      },
      vertical: {
        number: gr,
        undefined: "undefined"
      },
      __type__: {
        object: zr,
        number: gr
      }
    },
    __type__: {
      object: zr,
      number: gr
    }
  },
  max: {
    date: Gc,
    number: gr,
    string: yt,
    moment: Wc
  },
  maxHeight: {
    number: gr,
    string: yt
  },
  maxMinorChars: {
    number: gr
  },
  min: {
    date: Gc,
    number: gr,
    string: yt,
    moment: Wc
  },
  minHeight: {
    number: gr,
    string: yt
  },
  moveable: {
    boolean: vt
  },
  multiselect: {
    boolean: vt
  },
  multiselectPerGroup: {
    boolean: vt
  },
  onAdd: {
    function: "function"
  },
  onDropObjectOnItem: {
    function: "function"
  },
  onUpdate: {
    function: "function"
  },
  onMove: {
    function: "function"
  },
  onMoving: {
    function: "function"
  },
  onRemove: {
    function: "function"
  },
  onAddGroup: {
    function: "function"
  },
  onMoveGroup: {
    function: "function"
  },
  onRemoveGroup: {
    function: "function"
  },
  onInitialDrawComplete: {
    function: "function"
  },
  order: {
    function: "function"
  },
  orientation: {
    axis: {
      string: yt,
      undefined: "undefined"
    },
    item: {
      string: yt,
      undefined: "undefined"
    },
    __type__: {
      string: yt,
      object: zr
    }
  },
  selectable: {
    boolean: vt
  },
  sequentialSelection: {
    boolean: vt
  },
  showCurrentTime: {
    boolean: vt
  },
  showMajorLabels: {
    boolean: vt
  },
  showMinorLabels: {
    boolean: vt
  },
  showWeekScale: {
    boolean: vt
  },
  stack: {
    boolean: vt
  },
  stackSubgroups: {
    boolean: vt
  },
  cluster: {
    maxItems: {
      number: gr,
      undefined: "undefined"
    },
    titleTemplate: {
      string: yt,
      undefined: "undefined"
    },
    clusterCriteria: {
      function: "function",
      undefined: "undefined"
    },
    showStipes: {
      boolean: vt,
      undefined: "undefined"
    },
    fitOnDoubleClick: {
      boolean: vt,
      undefined: "undefined"
    },
    __type__: {
      boolean: vt,
      object: zr
    }
  },
  snap: {
    function: "function",
    null: "null"
  },
  start: {
    date: Gc,
    number: gr,
    string: yt,
    moment: Wc
  },
  template: {
    function: "function"
  },
  loadingScreenTemplate: {
    function: "function"
  },
  groupTemplate: {
    function: "function"
  },
  visibleFrameTemplate: {
    string: yt,
    function: "function"
  },
  showTooltips: {
    boolean: vt
  },
  tooltip: {
    followMouse: {
      boolean: vt
    },
    overflowMethod: {
      string: ["cap", "flip", "none"]
    },
    delay: {
      number: gr
    },
    template: {
      function: "function"
    },
    __type__: {
      object: zr
    }
  },
  tooltipOnItemUpdateTime: {
    template: {
      function: "function"
    },
    __type__: {
      boolean: vt,
      object: zr
    }
  },
  timeAxis: {
    scale: {
      string: yt,
      undefined: "undefined"
    },
    step: {
      number: gr,
      undefined: "undefined"
    },
    __type__: {
      object: zr
    }
  },
  type: {
    string: yt
  },
  width: {
    string: yt,
    number: gr
  },
  preferZoom: {
    boolean: vt
  },
  zoomable: {
    boolean: vt
  },
  zoomKey: {
    string: ["ctrlKey", "altKey", "shiftKey", "metaKey", ""]
  },
  zoomFriction: {
    number: gr
  },
  zoomMax: {
    number: gr
  },
  zoomMin: {
    number: gr
  },
  xss: {
    disabled: {
      boolean: vt
    },
    filterOptions: {
      __any__: {
        any: Q2
      },
      __type__: {
        object: zr
      }
    },
    __type__: {
      object: zr
    }
  },
  __type__: {
    object: zr
  }
}, Tze = {
  global: {
    align: ["center", "left", "right"],
    alignCurrentTime: ["none", "year", "month", "quarter", "week", "isoWeek", "day", "date", "hour", "minute", "second"],
    direction: !1,
    autoResize: !0,
    clickToUse: !1,
    // dataAttributes: ['all'], // FIXME: can be 'all' or string[]
    editable: {
      add: !1,
      remove: !1,
      updateGroup: !1,
      updateTime: !1
    },
    end: "",
    format: {
      minorLabels: {
        millisecond: "SSS",
        second: "s",
        minute: "HH:mm",
        hour: "HH:mm",
        weekday: "ddd D",
        day: "D",
        week: "w",
        month: "MMM",
        year: "YYYY"
      },
      majorLabels: {
        millisecond: "HH:mm:ss",
        second: "D MMMM HH:mm",
        minute: "ddd D MMMM",
        hour: "ddd D MMMM",
        weekday: "MMMM YYYY",
        day: "MMMM YYYY",
        week: "MMMM YYYY",
        month: "YYYY",
        year: ""
      }
    },
    groupHeightMode: ["auto", "fixed", "fitItems"],
    //groupOrder: {string, 'function': 'function'},
    groupsDraggable: !1,
    height: "",
    //hiddenDates: {object, array},
    locale: "",
    longSelectPressTime: 251,
    margin: {
      axis: [20, 0, 100, 1],
      item: {
        horizontal: [10, 0, 100, 1],
        vertical: [10, 0, 100, 1]
      }
    },
    max: "",
    maxHeight: "",
    maxMinorChars: [7, 0, 20, 1],
    min: "",
    minHeight: "",
    moveable: !1,
    multiselect: !1,
    multiselectPerGroup: !1,
    //onAdd: {'function': 'function'},
    //onUpdate: {'function': 'function'},
    //onMove: {'function': 'function'},
    //onMoving: {'function': 'function'},
    //onRename: {'function': 'function'},
    //order: {'function': 'function'},
    orientation: {
      axis: ["both", "bottom", "top"],
      item: ["bottom", "top"]
    },
    preferZoom: !1,
    selectable: !0,
    showCurrentTime: !1,
    showMajorLabels: !0,
    showMinorLabels: !0,
    stack: !0,
    stackSubgroups: !0,
    cluster: !1,
    //snap: {'function': 'function', nada},
    start: "",
    //template: {'function': 'function'},
    //timeAxis: {
    //  scale: ['millisecond', 'second', 'minute', 'hour', 'weekday', 'day', 'week', 'month', 'year'],
    //  step: [1, 1, 10, 1]
    //},
    showTooltips: !0,
    tooltip: {
      followMouse: !1,
      overflowMethod: "flip",
      delay: [500, 0, 99999, 100]
    },
    tooltipOnItemUpdateTime: !1,
    type: ["box", "point", "range", "background"],
    width: "100%",
    zoomable: !0,
    zoomKey: ["ctrlKey", "altKey", "shiftKey", "metaKey", ""],
    zoomMax: [31536e10, 10, 31536e10, 1],
    zoomMin: [10, 10, 31536e10, 1],
    xss: {
      disabled: !1
    }
  }
}, xze = {
  black: "#000000",
  navy: "#000080",
  darkblue: "#00008B",
  mediumblue: "#0000CD",
  blue: "#0000FF",
  darkgreen: "#006400",
  green: "#008000",
  teal: "#008080",
  darkcyan: "#008B8B",
  deepskyblue: "#00BFFF",
  darkturquoise: "#00CED1",
  mediumspringgreen: "#00FA9A",
  lime: "#00FF00",
  springgreen: "#00FF7F",
  aqua: "#00FFFF",
  cyan: "#00FFFF",
  midnightblue: "#191970",
  dodgerblue: "#1E90FF",
  lightseagreen: "#20B2AA",
  forestgreen: "#228B22",
  seagreen: "#2E8B57",
  darkslategray: "#2F4F4F",
  limegreen: "#32CD32",
  mediumseagreen: "#3CB371",
  turquoise: "#40E0D0",
  royalblue: "#4169E1",
  steelblue: "#4682B4",
  darkslateblue: "#483D8B",
  mediumturquoise: "#48D1CC",
  indigo: "#4B0082",
  darkolivegreen: "#556B2F",
  cadetblue: "#5F9EA0",
  cornflowerblue: "#6495ED",
  mediumaquamarine: "#66CDAA",
  dimgray: "#696969",
  slateblue: "#6A5ACD",
  olivedrab: "#6B8E23",
  slategray: "#708090",
  lightslategray: "#778899",
  mediumslateblue: "#7B68EE",
  lawngreen: "#7CFC00",
  chartreuse: "#7FFF00",
  aquamarine: "#7FFFD4",
  maroon: "#800000",
  purple: "#800080",
  olive: "#808000",
  gray: "#808080",
  skyblue: "#87CEEB",
  lightskyblue: "#87CEFA",
  blueviolet: "#8A2BE2",
  darkred: "#8B0000",
  darkmagenta: "#8B008B",
  saddlebrown: "#8B4513",
  darkseagreen: "#8FBC8F",
  lightgreen: "#90EE90",
  mediumpurple: "#9370D8",
  darkviolet: "#9400D3",
  palegreen: "#98FB98",
  darkorchid: "#9932CC",
  yellowgreen: "#9ACD32",
  sienna: "#A0522D",
  brown: "#A52A2A",
  darkgray: "#A9A9A9",
  lightblue: "#ADD8E6",
  greenyellow: "#ADFF2F",
  paleturquoise: "#AFEEEE",
  lightsteelblue: "#B0C4DE",
  powderblue: "#B0E0E6",
  firebrick: "#B22222",
  darkgoldenrod: "#B8860B",
  mediumorchid: "#BA55D3",
  rosybrown: "#BC8F8F",
  darkkhaki: "#BDB76B",
  silver: "#C0C0C0",
  mediumvioletred: "#C71585",
  indianred: "#CD5C5C",
  peru: "#CD853F",
  chocolate: "#D2691E",
  tan: "#D2B48C",
  lightgrey: "#D3D3D3",
  palevioletred: "#D87093",
  thistle: "#D8BFD8",
  orchid: "#DA70D6",
  goldenrod: "#DAA520",
  crimson: "#DC143C",
  gainsboro: "#DCDCDC",
  plum: "#DDA0DD",
  burlywood: "#DEB887",
  lightcyan: "#E0FFFF",
  lavender: "#E6E6FA",
  darksalmon: "#E9967A",
  violet: "#EE82EE",
  palegoldenrod: "#EEE8AA",
  lightcoral: "#F08080",
  khaki: "#F0E68C",
  aliceblue: "#F0F8FF",
  honeydew: "#F0FFF0",
  azure: "#F0FFFF",
  sandybrown: "#F4A460",
  wheat: "#F5DEB3",
  beige: "#F5F5DC",
  whitesmoke: "#F5F5F5",
  mintcream: "#F5FFFA",
  ghostwhite: "#F8F8FF",
  salmon: "#FA8072",
  antiquewhite: "#FAEBD7",
  linen: "#FAF0E6",
  lightgoldenrodyellow: "#FAFAD2",
  oldlace: "#FDF5E6",
  red: "#FF0000",
  fuchsia: "#FF00FF",
  magenta: "#FF00FF",
  deeppink: "#FF1493",
  orangered: "#FF4500",
  tomato: "#FF6347",
  hotpink: "#FF69B4",
  coral: "#FF7F50",
  darkorange: "#FF8C00",
  lightsalmon: "#FFA07A",
  orange: "#FFA500",
  lightpink: "#FFB6C1",
  pink: "#FFC0CB",
  gold: "#FFD700",
  peachpuff: "#FFDAB9",
  navajowhite: "#FFDEAD",
  moccasin: "#FFE4B5",
  bisque: "#FFE4C4",
  mistyrose: "#FFE4E1",
  blanchedalmond: "#FFEBCD",
  papayawhip: "#FFEFD5",
  lavenderblush: "#FFF0F5",
  seashell: "#FFF5EE",
  cornsilk: "#FFF8DC",
  lemonchiffon: "#FFFACD",
  floralwhite: "#FFFAF0",
  snow: "#FFFAFA",
  yellow: "#FFFF00",
  lightyellow: "#FFFFE0",
  ivory: "#FFFFF0",
  white: "#FFFFFF"
}, Sze = /* @__PURE__ */ function() {
  function t() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    dr(this, t), this.pixelRatio = e, this.generated = !1, this.centerCoordinates = {
      x: 289 / 2,
      y: 289 / 2
    }, this.r = 289 * 0.49, this.color = {
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, this.hueCircle = void 0, this.initialColor = {
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, this.previousColor = void 0, this.applied = !1, this.updateCallback = function() {
    }, this.closeCallback = function() {
    }, this._create();
  }
  return hr(t, [{
    key: "insertTo",
    value: function(r) {
      this.hammer !== void 0 && (this.hammer.destroy(), this.hammer = void 0), this.container = r, this.container.appendChild(this.frame), this._bindHammer(), this._setSize();
    }
    /**
     * the callback is executed on apply and save. Bind it to the application
     * @param {function} callback
     */
  }, {
    key: "setUpdateCallback",
    value: function(r) {
      if (typeof r == "function")
        this.updateCallback = r;
      else
        throw new Error("Function attempted to set as colorPicker update callback is not a function.");
    }
    /**
     * the callback is executed on apply and save. Bind it to the application
     * @param {function} callback
     */
  }, {
    key: "setCloseCallback",
    value: function(r) {
      if (typeof r == "function")
        this.closeCallback = r;
      else
        throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
    }
    /**
     *
     * @param {string} color
     * @returns {String}
     * @private
     */
  }, {
    key: "_isColorString",
    value: function(r) {
      if (typeof r == "string")
        return xze[r];
    }
    /**
     * Set the color of the colorPicker
     * Supported formats:
     * 'red'                   --> HTML color string
     * '#ffffff'               --> hex string
     * 'rgb(255,255,255)'      --> rgb string
     * 'rgba(255,255,255,1.0)' --> rgba string
     * {r:255,g:255,b:255}     --> rgb object
     * {r:255,g:255,b:255,a:1.0} --> rgba object
     * @param {string|Object} color
     * @param {boolean} [setInitial=true]
     */
  }, {
    key: "setColor",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (r !== "none") {
        var s, a = this._isColorString(r);
        if (a !== void 0 && (r = a), G.isString(r) === !0) {
          if (G.isValidRGB(r) === !0) {
            var o = r.substr(4).substr(0, r.length - 5).split(",");
            s = {
              r: o[0],
              g: o[1],
              b: o[2],
              a: 1
            };
          } else if (G.isValidRGBA(r) === !0) {
            var l = r.substr(5).substr(0, r.length - 6).split(",");
            s = {
              r: l[0],
              g: l[1],
              b: l[2],
              a: l[3]
            };
          } else if (G.isValidHex(r) === !0) {
            var u = G.hexToRGB(r);
            s = {
              r: u.r,
              g: u.g,
              b: u.b,
              a: 1
            };
          }
        } else if (r instanceof Object && r.r !== void 0 && r.g !== void 0 && r.b !== void 0) {
          var c = r.a !== void 0 ? r.a : "1.0";
          s = {
            r: r.r,
            g: r.g,
            b: r.b,
            a: c
          };
        }
        if (s === void 0)
          throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + Vi(r));
        this._setColor(s, n);
      }
    }
    /**
     * this shows the color picker.
     * The hue circle is constructed once and stored.
     */
  }, {
    key: "show",
    value: function() {
      this.closeCallback !== void 0 && (this.closeCallback(), this.closeCallback = void 0), this.applied = !1, this.frame.style.display = "block", this._generateHueCircle();
    }
    // ------------------------------------------ PRIVATE ----------------------------- //
    /**
     * Hide the picker. Is called by the cancel button.
     * Optional boolean to store the previous color for easy access later on.
     * @param {boolean} [storePrevious=true]
     * @private
     */
  }, {
    key: "_hide",
    value: function() {
      var r = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      n === !0 && (this.previousColor = G.extend({}, this.color)), this.applied === !0 && this.updateCallback(this.initialColor), this.frame.style.display = "none", ai(function() {
        r.closeCallback !== void 0 && (r.closeCallback(), r.closeCallback = void 0);
      }, 0);
    }
    /**
     * bound to the save button. Saves and hides.
     * @private
     */
  }, {
    key: "_save",
    value: function() {
      this.updateCallback(this.color), this.applied = !1, this._hide();
    }
    /**
     * Bound to apply button. Saves but does not close. Is undone by the cancel button.
     * @private
     */
  }, {
    key: "_apply",
    value: function() {
      this.applied = !0, this.updateCallback(this.color), this._updatePicker(this.color);
    }
    /**
     * load the color from the previous session.
     * @private
     */
  }, {
    key: "_loadLast",
    value: function() {
      this.previousColor !== void 0 ? this.setColor(this.previousColor, !1) : alert("There is no last color to load...");
    }
    /**
     * set the color, place the picker
     * @param {Object} rgba
     * @param {boolean} [setInitial=true]
     * @private
     */
  }, {
    key: "_setColor",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      n === !0 && (this.initialColor = G.extend({}, r)), this.color = r;
      var s = G.RGBToHSV(r.r, r.g, r.b), a = 2 * Math.PI, o = this.r * s.s, l = this.centerCoordinates.x + o * Math.sin(a * s.h), u = this.centerCoordinates.y + o * Math.cos(a * s.h);
      this.colorPickerSelector.style.left = l - 0.5 * this.colorPickerSelector.clientWidth + "px", this.colorPickerSelector.style.top = u - 0.5 * this.colorPickerSelector.clientHeight + "px", this._updatePicker(r);
    }
    /**
     * bound to opacity control
     * @param {number} value
     * @private
     */
  }, {
    key: "_setOpacity",
    value: function(r) {
      this.color.a = r / 100, this._updatePicker(this.color);
    }
    /**
     * bound to brightness control
     * @param {number} value
     * @private
     */
  }, {
    key: "_setBrightness",
    value: function(r) {
      var n = G.RGBToHSV(this.color.r, this.color.g, this.color.b);
      n.v = r / 100;
      var s = G.HSVToRGB(n.h, n.s, n.v);
      s.a = this.color.a, this.color = s, this._updatePicker();
    }
    /**
     * update the color picker. A black circle overlays the hue circle to mimic the brightness decreasing.
     * @param {Object} rgba
     * @private
     */
  }, {
    key: "_updatePicker",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.color, n = G.RGBToHSV(r.r, r.g, r.b), s = this.colorPickerCanvas.getContext("2d");
      this.pixelRation === void 0 && (this.pixelRatio = (window.devicePixelRatio || 1) / (s.webkitBackingStorePixelRatio || s.mozBackingStorePixelRatio || s.msBackingStorePixelRatio || s.oBackingStorePixelRatio || s.backingStorePixelRatio || 1)), s.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
      var a = this.colorPickerCanvas.clientWidth, o = this.colorPickerCanvas.clientHeight;
      s.clearRect(0, 0, a, o), s.putImageData(this.hueCircle, 0, 0), s.fillStyle = "rgba(0,0,0," + (1 - n.v) + ")", s.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), T5(s).call(s), this.brightnessRange.value = 100 * n.v, this.opacityRange.value = 100 * r.a, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
    }
    /**
     * used by create to set the size of the canvas.
     * @private
     */
  }, {
    key: "_setSize",
    value: function() {
      this.colorPickerCanvas.style.width = "100%", this.colorPickerCanvas.style.height = "100%", this.colorPickerCanvas.width = 289 * this.pixelRatio, this.colorPickerCanvas.height = 289 * this.pixelRatio;
    }
    /**
     * create all dom elements
     * TODO: cleanup, lots of similar dom elements
     * @private
     */
  }, {
    key: "_create",
    value: function() {
      var r, n, s, a;
      if (this.frame = document.createElement("div"), this.frame.className = "vis-color-picker", this.colorPickerDiv = document.createElement("div"), this.colorPickerSelector = document.createElement("div"), this.colorPickerSelector.className = "vis-selector", this.colorPickerDiv.appendChild(this.colorPickerSelector), this.colorPickerCanvas = document.createElement("canvas"), this.colorPickerDiv.appendChild(this.colorPickerCanvas), this.colorPickerCanvas.getContext) {
        var l = this.colorPickerCanvas.getContext("2d");
        this.pixelRatio = (window.devicePixelRatio || 1) / (l.webkitBackingStorePixelRatio || l.mozBackingStorePixelRatio || l.msBackingStorePixelRatio || l.oBackingStorePixelRatio || l.backingStorePixelRatio || 1), this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
      } else {
        var o = document.createElement("DIV");
        o.style.color = "red", o.style.fontWeight = "bold", o.style.padding = "10px", o.innerHTML = "Error: your browser does not support HTML canvas", this.colorPickerCanvas.appendChild(o);
      }
      this.colorPickerDiv.className = "vis-color", this.opacityDiv = document.createElement("div"), this.opacityDiv.className = "vis-opacity", this.brightnessDiv = document.createElement("div"), this.brightnessDiv.className = "vis-brightness", this.arrowDiv = document.createElement("div"), this.arrowDiv.className = "vis-arrow", this.opacityRange = document.createElement("input");
      try {
        this.opacityRange.type = "range", this.opacityRange.min = "0", this.opacityRange.max = "100";
      } catch {
      }
      this.opacityRange.value = "100", this.opacityRange.className = "vis-range", this.brightnessRange = document.createElement("input");
      try {
        this.brightnessRange.type = "range", this.brightnessRange.min = "0", this.brightnessRange.max = "100";
      } catch {
      }
      this.brightnessRange.value = "100", this.brightnessRange.className = "vis-range", this.opacityDiv.appendChild(this.opacityRange), this.brightnessDiv.appendChild(this.brightnessRange);
      var u = this;
      this.opacityRange.onchange = function() {
        u._setOpacity(this.value);
      }, this.opacityRange.oninput = function() {
        u._setOpacity(this.value);
      }, this.brightnessRange.onchange = function() {
        u._setBrightness(this.value);
      }, this.brightnessRange.oninput = function() {
        u._setBrightness(this.value);
      }, this.brightnessLabel = document.createElement("div"), this.brightnessLabel.className = "vis-label vis-brightness", this.brightnessLabel.innerHTML = "brightness:", this.opacityLabel = document.createElement("div"), this.opacityLabel.className = "vis-label vis-opacity", this.opacityLabel.innerHTML = "opacity:", this.newColorDiv = document.createElement("div"), this.newColorDiv.className = "vis-new-color", this.newColorDiv.innerHTML = "new", this.initialColorDiv = document.createElement("div"), this.initialColorDiv.className = "vis-initial-color", this.initialColorDiv.innerHTML = "initial", this.cancelButton = document.createElement("div"), this.cancelButton.className = "vis-button vis-cancel", this.cancelButton.innerHTML = "cancel", this.cancelButton.onclick = de(r = this._hide).call(r, this, !1), this.applyButton = document.createElement("div"), this.applyButton.className = "vis-button vis-apply", this.applyButton.innerHTML = "apply", this.applyButton.onclick = de(n = this._apply).call(n, this), this.saveButton = document.createElement("div"), this.saveButton.className = "vis-button vis-save", this.saveButton.innerHTML = "save", this.saveButton.onclick = de(s = this._save).call(s, this), this.loadButton = document.createElement("div"), this.loadButton.className = "vis-button vis-load", this.loadButton.innerHTML = "load last", this.loadButton.onclick = de(a = this._loadLast).call(a, this), this.frame.appendChild(this.colorPickerDiv), this.frame.appendChild(this.arrowDiv), this.frame.appendChild(this.brightnessLabel), this.frame.appendChild(this.brightnessDiv), this.frame.appendChild(this.opacityLabel), this.frame.appendChild(this.opacityDiv), this.frame.appendChild(this.newColorDiv), this.frame.appendChild(this.initialColorDiv), this.frame.appendChild(this.cancelButton), this.frame.appendChild(this.applyButton), this.frame.appendChild(this.saveButton), this.frame.appendChild(this.loadButton);
    }
    /**
     * bind hammer to the color picker
     * @private
     */
  }, {
    key: "_bindHammer",
    value: function() {
      var r = this;
      this.drag = {}, this.pinch = {}, this.hammer = new ei(this.colorPickerCanvas), this.hammer.get("pinch").set({
        enable: !0
      }), TW(this.hammer, function(n) {
        r._moveSelector(n);
      }), this.hammer.on("tap", function(n) {
        r._moveSelector(n);
      }), this.hammer.on("panstart", function(n) {
        r._moveSelector(n);
      }), this.hammer.on("panmove", function(n) {
        r._moveSelector(n);
      }), this.hammer.on("panend", function(n) {
        r._moveSelector(n);
      });
    }
    /**
     * generate the hue circle. This is relatively heavy (200ms) and is done only once on the first time it is shown.
     * @private
     */
  }, {
    key: "_generateHueCircle",
    value: function() {
      if (this.generated === !1) {
        var r = this.colorPickerCanvas.getContext("2d");
        this.pixelRation === void 0 && (this.pixelRatio = (window.devicePixelRatio || 1) / (r.webkitBackingStorePixelRatio || r.mozBackingStorePixelRatio || r.msBackingStorePixelRatio || r.oBackingStorePixelRatio || r.backingStorePixelRatio || 1)), r.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
        var n = this.colorPickerCanvas.clientWidth, s = this.colorPickerCanvas.clientHeight;
        r.clearRect(0, 0, n, s);
        var a, o, l, u;
        this.centerCoordinates = {
          x: n * 0.5,
          y: s * 0.5
        }, this.r = 0.49 * n;
        var c = 2 * Math.PI / 360, d = 1 / 360, h = 1 / this.r, f;
        for (l = 0; l < 360; l++)
          for (u = 0; u < this.r; u++)
            a = this.centerCoordinates.x + u * Math.sin(c * l), o = this.centerCoordinates.y + u * Math.cos(c * l), f = G.HSVToRGB(l * d, u * h, 1), r.fillStyle = "rgb(" + f.r + "," + f.g + "," + f.b + ")", r.fillRect(a - 0.5, o - 0.5, 2, 2);
        r.strokeStyle = "rgba(0,0,0,1)", r.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), r.stroke(), this.hueCircle = r.getImageData(0, 0, n, s);
      }
      this.generated = !0;
    }
    /**
     * move the selector. This is called by hammer functions.
     *
     * @param {Event}  event   The event
     * @private
     */
  }, {
    key: "_moveSelector",
    value: function(r) {
      var n = this.colorPickerDiv.getBoundingClientRect(), s = r.center.x - n.left, a = r.center.y - n.top, o = 0.5 * this.colorPickerDiv.clientHeight, l = 0.5 * this.colorPickerDiv.clientWidth, u = s - l, c = a - o, d = Math.atan2(u, c), h = 0.98 * Math.min(Math.sqrt(u * u + c * c), l), f = Math.cos(d) * h + o, p = Math.sin(d) * h + l;
      this.colorPickerSelector.style.top = f - 0.5 * this.colorPickerSelector.clientHeight + "px", this.colorPickerSelector.style.left = p - 0.5 * this.colorPickerSelector.clientWidth + "px";
      var m = d / (2 * Math.PI);
      m = m < 0 ? m + 1 : m;
      var b = h / this.r, y = G.RGBToHSV(this.color.r, this.color.g, this.color.b);
      y.h = m, y.s = b;
      var _ = G.HSVToRGB(y.h, y.s, y.v);
      _.a = this.color.a, this.color = _, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
    }
  }]), t;
}(), YW = /* @__PURE__ */ function() {
  function t(e, r, n) {
    var s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    dr(this, t), this.parent = e, this.changedOptions = [], this.container = r, this.allowCreation = !1, this.options = {}, this.initialized = !1, this.popupCounter = 0, this.defaultOptions = {
      enabled: !1,
      filter: !0,
      container: void 0,
      showButton: !0
    }, G.extend(this.options, this.defaultOptions), this.configureOptions = n, this.moduleOptions = {}, this.domElements = [], this.popupDiv = {}, this.popupLimit = 5, this.popupHistory = {}, this.colorPicker = new Sze(s), this.wrapper = void 0;
  }
  return hr(t, [{
    key: "setOptions",
    value: function(r) {
      if (r !== void 0) {
        this.popupHistory = {}, this._removePopup();
        var n = !0;
        if (typeof r == "string")
          this.options.filter = r;
        else if ($t(r))
          this.options.filter = r.join();
        else if (mt(r) === "object") {
          if (r == null)
            throw new TypeError("options cannot be null");
          r.container !== void 0 && (this.options.container = r.container), At(r) !== void 0 && (this.options.filter = At(r)), r.showButton !== void 0 && (this.options.showButton = r.showButton), r.enabled !== void 0 && (n = r.enabled);
        } else
          typeof r == "boolean" ? (this.options.filter = !0, n = r) : typeof r == "function" && (this.options.filter = r, n = !0);
        At(this.options) === !1 && (n = !1), this.options.enabled = n;
      }
      this._clean();
    }
    /**
     *
     * @param {Object} moduleOptions
     */
  }, {
    key: "setModuleOptions",
    value: function(r) {
      this.moduleOptions = r, this.options.enabled === !0 && (this._clean(), this.options.container !== void 0 && (this.container = this.options.container), this._create());
    }
    /**
     * Create all DOM elements
     * @private
     */
  }, {
    key: "_create",
    value: function() {
      this._clean(), this.changedOptions = [];
      var r = At(this.options), n = 0, s = !1;
      for (var a in this.configureOptions)
        this.configureOptions.hasOwnProperty(a) && (this.allowCreation = !1, s = !1, typeof r == "function" ? (s = r(a, []), s = s || this._handleObject(this.configureOptions[a], [a], !0)) : (r === !0 || lr(r).call(r, a) !== -1) && (s = !0), s !== !1 && (this.allowCreation = !0, n > 0 && this._makeItem([]), this._makeHeader(a), this._handleObject(this.configureOptions[a], [a])), n++);
      this._makeButton(), this._push();
    }
    /**
     * draw all DOM elements on the screen
     * @private
     */
  }, {
    key: "_push",
    value: function() {
      this.wrapper = document.createElement("div"), this.wrapper.className = "vis-configuration-wrapper", this.container.appendChild(this.wrapper);
      for (var r = 0; r < this.domElements.length; r++)
        this.wrapper.appendChild(this.domElements[r]);
      this._showPopupIfNeeded();
    }
    /**
     * delete all DOM elements
     * @private
     */
  }, {
    key: "_clean",
    value: function() {
      for (var r = 0; r < this.domElements.length; r++)
        this.wrapper.removeChild(this.domElements[r]);
      this.wrapper !== void 0 && (this.container.removeChild(this.wrapper), this.wrapper = void 0), this.domElements = [], this._removePopup();
    }
    /**
     * get the value from the actualOptions if it exists
     * @param {array} path    | where to look for the actual option
     * @returns {*}
     * @private
     */
  }, {
    key: "_getValue",
    value: function(r) {
      for (var n = this.moduleOptions, s = 0; s < r.length; s++)
        if (n[r[s]] !== void 0)
          n = n[r[s]];
        else {
          n = void 0;
          break;
        }
      return n;
    }
    /**
     * all option elements are wrapped in an item
     * @param {Array} path    | where to look for the actual option
     * @param {Array.<Element>} domElements
     * @returns {number}
     * @private
     */
  }, {
    key: "_makeItem",
    value: function(r) {
      if (this.allowCreation === !0) {
        var n = document.createElement("div");
        n.className = "vis-configuration vis-config-item vis-config-s" + r.length;
        for (var s = arguments.length, a = new Array(s > 1 ? s - 1 : 0), o = 1; o < s; o++)
          a[o - 1] = arguments[o];
        return Le(a).call(a, function(l) {
          n.appendChild(l);
        }), this.domElements.push(n), this.domElements.length;
      }
      return 0;
    }
    /**
     * header for major subjects
     * @param {string} name
     * @private
     */
  }, {
    key: "_makeHeader",
    value: function(r) {
      var n = document.createElement("div");
      n.className = "vis-configuration vis-config-header", n.innerHTML = G.xss(r), this._makeItem([], n);
    }
    /**
     * make a label, if it is an object label, it gets different styling.
     * @param {string} name
     * @param {array} path    | where to look for the actual option
     * @param {string} objectLabel
     * @returns {HTMLElement}
     * @private
     */
  }, {
    key: "_makeLabel",
    value: function(r, n) {
      var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = document.createElement("div");
      return a.className = "vis-configuration vis-config-label vis-config-s" + n.length, s === !0 ? a.innerHTML = G.xss("<i><b>" + r + ":</b></i>") : a.innerHTML = G.xss(r + ":"), a;
    }
    /**
     * make a dropdown list for multiple possible string optoins
     * @param {Array.<number>} arr
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_makeDropdown",
    value: function(r, n, s) {
      var a = document.createElement("select");
      a.className = "vis-configuration vis-config-select";
      var o = 0;
      n !== void 0 && lr(r).call(r, n) !== -1 && (o = lr(r).call(r, n));
      for (var l = 0; l < r.length; l++) {
        var u = document.createElement("option");
        u.value = r[l], l === o && (u.selected = "selected"), u.innerHTML = r[l], a.appendChild(u);
      }
      var c = this;
      a.onchange = function() {
        c._update(this.value, s);
      };
      var d = this._makeLabel(s[s.length - 1], s);
      this._makeItem(s, d, a);
    }
    /**
     * make a range object for numeric options
     * @param {Array.<number>} arr
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_makeRange",
    value: function(r, n, s) {
      var a = r[0], o = r[1], l = r[2], u = r[3], c = document.createElement("input");
      c.className = "vis-configuration vis-config-range";
      try {
        c.type = "range", c.min = o, c.max = l;
      } catch {
      }
      c.step = u;
      var d = "", h = 0;
      if (n !== void 0) {
        var f = 1.2;
        n < 0 && n * f < o ? (c.min = Math.ceil(n * f), h = c.min, d = "range increased") : n / f < o && (c.min = Math.ceil(n / f), h = c.min, d = "range increased"), n * f > l && l !== 1 && (c.max = Math.ceil(n * f), h = c.max, d = "range increased"), c.value = n;
      } else
        c.value = a;
      var p = document.createElement("input");
      p.className = "vis-configuration vis-config-rangeinput", p.value = Number(c.value);
      var m = this;
      c.onchange = function() {
        p.value = this.value, m._update(Number(this.value), s);
      }, c.oninput = function() {
        p.value = this.value;
      };
      var b = this._makeLabel(s[s.length - 1], s), y = this._makeItem(s, b, c, p);
      d !== "" && this.popupHistory[y] !== h && (this.popupHistory[y] = h, this._setupPopup(d, y));
    }
    /**
     * make a button object
     * @private
     */
  }, {
    key: "_makeButton",
    value: function() {
      var r = this;
      if (this.options.showButton === !0) {
        var n = document.createElement("div");
        n.className = "vis-configuration vis-config-button", n.innerHTML = "generate options", n.onclick = function() {
          r._printOptions();
        }, n.onmouseover = function() {
          n.className = "vis-configuration vis-config-button hover";
        }, n.onmouseout = function() {
          n.className = "vis-configuration vis-config-button";
        }, this.optionsContainer = document.createElement("div"), this.optionsContainer.className = "vis-configuration vis-config-option-container", this.domElements.push(this.optionsContainer), this.domElements.push(n);
      }
    }
    /**
     * prepare the popup
     * @param {string} string
     * @param {number} index
     * @private
     */
  }, {
    key: "_setupPopup",
    value: function(r, n) {
      var s = this;
      if (this.initialized === !0 && this.allowCreation === !0 && this.popupCounter < this.popupLimit) {
        var a = document.createElement("div");
        a.id = "vis-configuration-popup", a.className = "vis-configuration-popup", a.innerHTML = G.xss(r), a.onclick = function() {
          s._removePopup();
        }, this.popupCounter += 1, this.popupDiv = {
          html: a,
          index: n
        };
      }
    }
    /**
     * remove the popup from the dom
     * @private
     */
  }, {
    key: "_removePopup",
    value: function() {
      this.popupDiv.html !== void 0 && (this.popupDiv.html.parentNode.removeChild(this.popupDiv.html), clearTimeout(this.popupDiv.hideTimeout), clearTimeout(this.popupDiv.deleteTimeout), this.popupDiv = {});
    }
    /**
     * Show the popup if it is needed.
     * @private
     */
  }, {
    key: "_showPopupIfNeeded",
    value: function() {
      var r = this;
      if (this.popupDiv.html !== void 0) {
        var n = this.domElements[this.popupDiv.index], s = n.getBoundingClientRect();
        this.popupDiv.html.style.left = s.left + "px", this.popupDiv.html.style.top = s.top - 30 + "px", document.body.appendChild(this.popupDiv.html), this.popupDiv.hideTimeout = ai(function() {
          r.popupDiv.html.style.opacity = 0;
        }, 1500), this.popupDiv.deleteTimeout = ai(function() {
          r._removePopup();
        }, 1800);
      }
    }
    /**
     * make a checkbox for boolean options.
     * @param {number} defaultValue
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_makeCheckbox",
    value: function(r, n, s) {
      var a = document.createElement("input");
      a.type = "checkbox", a.className = "vis-configuration vis-config-checkbox", a.checked = r, n !== void 0 && (a.checked = n, n !== r && (mt(r) === "object" ? n !== r.enabled && this.changedOptions.push({
        path: s,
        value: n
      }) : this.changedOptions.push({
        path: s,
        value: n
      })));
      var o = this;
      a.onchange = function() {
        o._update(this.checked, s);
      };
      var l = this._makeLabel(s[s.length - 1], s);
      this._makeItem(s, l, a);
    }
    /**
     * make a text input field for string options.
     * @param {number} defaultValue
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_makeTextInput",
    value: function(r, n, s) {
      var a = document.createElement("input");
      a.type = "text", a.className = "vis-configuration vis-config-text", a.value = n, n !== r && this.changedOptions.push({
        path: s,
        value: n
      });
      var o = this;
      a.onchange = function() {
        o._update(this.value, s);
      };
      var l = this._makeLabel(s[s.length - 1], s);
      this._makeItem(s, l, a);
    }
    /**
     * make a color field with a color picker for color fields
     * @param {Array.<number>} arr
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_makeColorField",
    value: function(r, n, s) {
      var a = this, o = r[1], l = document.createElement("div");
      n = n === void 0 ? o : n, n !== "none" ? (l.className = "vis-configuration vis-config-colorBlock", l.style.backgroundColor = n) : l.className = "vis-configuration vis-config-colorBlock none", n = n === void 0 ? o : n, l.onclick = function() {
        a._showColorPicker(n, l, s);
      };
      var u = this._makeLabel(s[s.length - 1], s);
      this._makeItem(s, u, l);
    }
    /**
     * used by the color buttons to call the color picker.
     * @param {number} value
     * @param {HTMLElement} div
     * @param {array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_showColorPicker",
    value: function(r, n, s) {
      var a = this;
      n.onclick = function() {
      }, this.colorPicker.insertTo(n), this.colorPicker.show(), this.colorPicker.setColor(r), this.colorPicker.setUpdateCallback(function(o) {
        var l = "rgba(" + o.r + "," + o.g + "," + o.b + "," + o.a + ")";
        n.style.backgroundColor = l, a._update(l, s);
      }), this.colorPicker.setCloseCallback(function() {
        n.onclick = function() {
          a._showColorPicker(r, n, s);
        };
      });
    }
    /**
     * parse an object and draw the correct items
     * @param {Object} obj
     * @param {array} [path=[]]    | where to look for the actual option
     * @param {boolean} [checkOnly=false]
     * @returns {boolean}
     * @private
     */
  }, {
    key: "_handleObject",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = !1, o = At(this.options), l = !1;
      for (var u in r)
        if (r.hasOwnProperty(u)) {
          a = !0;
          var c = r[u], d = G.copyAndExtendArray(n, u);
          if (typeof o == "function" && (a = o(u, n), a === !1 && !$t(c) && typeof c != "string" && typeof c != "boolean" && c instanceof Object && (this.allowCreation = !1, a = this._handleObject(c, d, !0), this.allowCreation = s === !1)), a !== !1) {
            l = !0;
            var h = this._getValue(d);
            if ($t(c))
              this._handleArray(c, h, d);
            else if (typeof c == "string")
              this._makeTextInput(c, h, d);
            else if (typeof c == "boolean")
              this._makeCheckbox(c, h, d);
            else if (c instanceof Object) {
              var f = !0;
              if (lr(n).call(n, "physics") !== -1 && this.moduleOptions.physics.solver !== u && (f = !1), f === !0)
                if (c.enabled !== void 0) {
                  var p = G.copyAndExtendArray(d, "enabled"), m = this._getValue(p);
                  if (m === !0) {
                    var b = this._makeLabel(u, d, !0);
                    this._makeItem(d, b), l = this._handleObject(c, d) || l;
                  } else
                    this._makeCheckbox(c, m, d);
                } else {
                  var y = this._makeLabel(u, d, !0);
                  this._makeItem(d, y), l = this._handleObject(c, d) || l;
                }
            } else
              console.error("dont know how to handle", c, u, d);
          }
        }
      return l;
    }
    /**
     * handle the array type of option
     * @param {Array.<number>} arr
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_handleArray",
    value: function(r, n, s) {
      typeof r[0] == "string" && r[0] === "color" ? (this._makeColorField(r, n, s), r[1] !== n && this.changedOptions.push({
        path: s,
        value: n
      })) : typeof r[0] == "string" ? (this._makeDropdown(r, n, s), r[0] !== n && this.changedOptions.push({
        path: s,
        value: n
      })) : typeof r[0] == "number" && (this._makeRange(r, n, s), r[0] !== n && this.changedOptions.push({
        path: s,
        value: Number(n)
      }));
    }
    /**
     * called to update the network with the new settings.
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */
  }, {
    key: "_update",
    value: function(r, n) {
      var s = this._constructOptions(r, n);
      this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit && this.parent.body.emitter.emit("configChange", s), this.initialized = !0, this.parent.setOptions(s);
    }
    /**
     *
     * @param {string|Boolean} value
     * @param {Array.<string>} path
     * @param {{}} optionsObj
     * @returns {{}}
     * @private
     */
  }, {
    key: "_constructOptions",
    value: function(r, n) {
      var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = s;
      r = r === "true" ? !0 : r, r = r === "false" ? !1 : r;
      for (var o = 0; o < n.length; o++)
        n[o] !== "global" && (a[n[o]] === void 0 && (a[n[o]] = {}), o !== n.length - 1 ? a = a[n[o]] : a[n[o]] = r);
      return s;
    }
    /**
     * @private
     */
  }, {
    key: "_printOptions",
    value: function() {
      var r = this.getOptions();
      this.optionsContainer.innerHTML = "<pre>var options = " + Vi(r, null, 2) + "</pre>";
    }
    /**
     *
     * @returns {{}} options
     */
  }, {
    key: "getOptions",
    value: function() {
      for (var r = {}, n = 0; n < this.changedOptions.length; n++)
        this._constructOptions(this.changedOptions[n].value, this.changedOptions[n].path, r);
      return r;
    }
  }]), t;
}();
function Eze(t) {
  var e = $ze();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function $ze() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var kze = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = Eze(r);
  function r(n, s, a, o) {
    var l, u, c, d, h, f, p, m;
    if (dr(this, r), m = e.call(this), m.initTime = /* @__PURE__ */ new Date(), m.itemsDone = !1, !(Vn(m) instanceof r))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (!($t(a) || Oo(a)) && a instanceof Object) {
      var b = o;
      o = a, a = b;
    }
    o && o.throttleRedraw && console.warn('Timeline option "throttleRedraw" is DEPRICATED and no longer supported. It will be removed in the next MAJOR release.');
    var y = Vn(m);
    if (m.defaultOptions = {
      autoResize: !0,
      longSelectPressTime: 251,
      orientation: {
        axis: "bottom",
        // axis orientation: 'bottom', 'top', or 'both'
        item: "bottom"
        // not relevant
      },
      moment: Ti
    }, m.options = G.deepExtend({}, m.defaultOptions), o && G.setupXSSProtection(o.xss), m._create(n), !o || o && typeof o.rtl > "u") {
      m.dom.root.style.visibility = "hidden";
      for (var _, x = m.dom.root; !_ && x; )
        _ = window.getComputedStyle(x, null).direction, x = x.parentElement;
      m.options.rtl = _ && _.toLowerCase() == "rtl";
    } else
      m.options.rtl = o.rtl;
    o && (o.rollingMode && (m.options.rollingMode = o.rollingMode), o.onInitialDrawComplete && (m.options.onInitialDrawComplete = o.onInitialDrawComplete), o.onTimeout && (m.options.onTimeout = o.onTimeout), o.loadingScreenTemplate && (m.options.loadingScreenTemplate = o.loadingScreenTemplate));
    var T = document.createElement("div");
    if (m.options.loadingScreenTemplate) {
      var k, E = de(k = m.options.loadingScreenTemplate).call(k, Vn(m)), F = E(m.dom.loadingScreen);
      F instanceof Object && !(F instanceof Element) ? E(T) : F instanceof Element ? (T.innerHTML = "", T.appendChild(F)) : F != null && (T.innerHTML = G.xss(F));
    }
    m.dom.loadingScreen.appendChild(T), m.components = [], m.body = {
      dom: m.dom,
      domProps: m.props,
      emitter: {
        on: de(l = m.on).call(l, Vn(m)),
        off: de(u = m.off).call(u, Vn(m)),
        emit: de(c = m.emit).call(c, Vn(m))
      },
      hiddenDates: [],
      util: {
        getScale: function() {
          return y.timeAxis.step.scale;
        },
        getStep: function() {
          return y.timeAxis.step.step;
        },
        toScreen: de(d = y._toScreen).call(d, y),
        toGlobalScreen: de(h = y._toGlobalScreen).call(h, y),
        // this refers to the root.width
        toTime: de(f = y._toTime).call(f, y),
        toGlobalTime: de(p = y._toGlobalTime).call(p, y)
      }
    }, m.range = new _W(m.body, m.options), m.components.push(m.range), m.body.range = m.range, m.timeAxis = new Jy(m.body, m.options), m.timeAxis2 = null, m.components.push(m.timeAxis), m.currentTime = new CW(m.body, m.options), m.components.push(m.currentTime), m.itemSet = new r0(m.body, m.options), m.components.push(m.itemSet), m.itemsData = null, m.groupsData = null;
    function R($, O) {
      y.hasListeners($) && y.emit($, y.getEventProperties(O));
    }
    return m.dom.root.onclick = function($) {
      R("click", $);
    }, m.dom.root.ondblclick = function($) {
      R("doubleClick", $);
    }, m.dom.root.oncontextmenu = function($) {
      R("contextmenu", $);
    }, m.dom.root.onmouseover = function($) {
      R("mouseOver", $);
    }, window.PointerEvent ? (m.dom.root.onpointerdown = function($) {
      R("mouseDown", $);
    }, m.dom.root.onpointermove = function($) {
      R("mouseMove", $);
    }, m.dom.root.onpointerup = function($) {
      R("mouseUp", $);
    }) : (m.dom.root.onmousemove = function($) {
      R("mouseMove", $);
    }, m.dom.root.onmousedown = function($) {
      R("mouseDown", $);
    }, m.dom.root.onmouseup = function($) {
      R("mouseUp", $);
    }), m.initialFitDone = !1, m.on("changed", function() {
      if (y.itemsData != null) {
        if (!y.initialFitDone && !y.options.rollingMode)
          if (y.initialFitDone = !0, y.options.start != null || y.options.end != null) {
            if (y.options.start == null || y.options.end == null)
              var $ = y.getItemRange();
            var O = y.options.start != null ? y.options.start : $.min, P = y.options.end != null ? y.options.end : $.max;
            y.setWindow(O, P, {
              animation: !1
            });
          } else
            y.fit({
              animation: !1
            });
        !y.initialDrawDone && (y.initialRangeChangeDone || !y.options.start && !y.options.end || y.options.rollingMode) && (y.initialDrawDone = !0, y.itemSet.initialDrawDone = !0, y.dom.root.style.visibility = "visible", y.dom.loadingScreen.parentNode.removeChild(y.dom.loadingScreen), y.options.onInitialDrawComplete && ai(function() {
          return y.options.onInitialDrawComplete();
        }, 0));
      }
    }), m.on("destroyTimeline", function() {
      y.destroy();
    }), o && m.setOptions(o), m.body.emitter.on("fit", function($) {
      m._onFit($), m.redraw();
    }), a && m.setGroups(a), s && m.setItems(s), m._redraw(), m;
  }
  return hr(r, [{
    key: "_createConfigurator",
    value: function() {
      return new YW(this, this.dom.container, Tze);
    }
    /**
     * Force a redraw. The size of all items will be recalculated.
     * Can be useful to manually redraw when option autoResize=false and the window
     * has been resized, or when the items CSS has been changed.
     *
     * Note: this function will be overridden on construction with a trottled version
     */
  }, {
    key: "redraw",
    value: function() {
      this.itemSet && this.itemSet.markDirty({
        refreshItems: !0
      }), this._redraw();
    }
    /**
     * Remove an item from the group
     * @param {object} options
     */
  }, {
    key: "setOptions",
    value: function(s) {
      var a = VW.validate(s, wze);
      if (a === !0 && console.log("%cErrors have been found in the supplied options object.", n0), Od.prototype.setOptions.call(this, s), "type" in s && s.type !== this.options.type) {
        this.options.type = s.type;
        var o = this.itemsData;
        if (o) {
          var l = this.getSelection();
          this.setItems(null), this.setItems(o.rawDS), this.setSelection(l);
        }
      }
    }
    /**
     * Set items
     * @param {vis.DataSet | Array | null} items
     */
  }, {
    key: "setItems",
    value: function(s) {
      this.itemsDone = !1;
      var a;
      s ? Oo(s) ? a = qd(s) : a = qd(new Gu(s)) : a = null, this.itemsData && this.itemsData.dispose(), this.itemsData = a, this.itemSet && this.itemSet.setItems(a != null ? a.rawDS : null);
    }
    /**
     * Set groups
     * @param {vis.DataSet | Array} groups
     */
  }, {
    key: "setGroups",
    value: function(s) {
      var a, o = function(u) {
        return u.visible !== !1;
      };
      s ? ($t(s) && (s = new Gu(s)), a = new eAe(s, {
        filter: o
      })) : a = null, this.groupsData != null && typeof this.groupsData.setData == "function" && this.groupsData.setData(null), this.groupsData = a, this.itemSet.setGroups(a);
    }
    /**
     * Set both items and groups in one go
     * @param {{items: (Array | vis.DataSet), groups: (Array | vis.DataSet)}} data
     */
  }, {
    key: "setData",
    value: function(s) {
      s && s.groups && this.setGroups(s.groups), s && s.items && this.setItems(s.items);
    }
    /**
     * Set selected items by their id. Replaces the current selection
     * Unknown id's are silently ignored.
     * @param {string[] | string} [ids]  An array with zero or more id's of the items to be
     *                                selected. If ids is an empty array, all items will be
     *                                unselected.
     * @param {Object} [options]      Available options:
     *                                `focus: boolean`
     *                                    If true, focus will be set to the selected item(s)
     *                                `animation: boolean | {duration: number, easingFunction: string}`
     *                                    If true (default), the range is animated
     *                                    smoothly to the new window. An object can be
     *                                    provided to specify duration and easing function.
     *                                    Default duration is 500 ms, and default easing
     *                                    function is 'easeInOutQuad'.
     *                                    Only applicable when option focus is true.
     */
  }, {
    key: "setSelection",
    value: function(s, a) {
      this.itemSet && this.itemSet.setSelection(s), a && a.focus && this.focus(s, a);
    }
    /**
     * Get the selected items by their id
     * @return {Array} ids  The ids of the selected items
     */
  }, {
    key: "getSelection",
    value: function() {
      return this.itemSet && this.itemSet.getSelection() || [];
    }
    /**
     * Adjust the visible window such that the selected item (or multiple items)
     * are centered on screen.
     * @param {string | String[]} id     An item id or array with item ids
     * @param {Object} [options]      Available options:
     *                                `animation: boolean | {duration: number, easingFunction: string}`
     *                                    If true (default), the range is animated
     *                                    smoothly to the new window. An object can be
     *                                    provided to specify duration and easing function.
     *                                    Default duration is 500 ms, and default easing
     *                                    function is 'easeInOutQuad'.
     *                                `zoom: boolean`
     *                                    If true (default), the timeline will
     *                                    zoom on the element after focus it.
     */
  }, {
    key: "focus",
    value: function(s, a) {
      if (!(!this.itemsData || s == null)) {
        var o = $t(s) ? s : [s], l = this.itemsData.get(o), u = null, c = null;
        if (Le(l).call(l, function(E) {
          var F = E.start.valueOf(), R = "end" in E ? E.end.valueOf() : E.start.valueOf();
          (u === null || F < u) && (u = F), (c === null || R > c) && (c = R);
        }), u !== null && c !== null) {
          var d = this, h = this.itemSet.items[o[0]], f = this._getScrollTop() * -1, p = null, m = function(F, R, $) {
            var O = Z2(d, h);
            if (O !== !1 && (p || (p = O), !(p.itemTop == O.itemTop && !p.shouldScroll))) {
              p.itemTop != O.itemTop && O.shouldScroll && (p = O, f = d._getScrollTop() * -1);
              var P = f, N = p.scrollOffset, I = $ ? N : P + (N - P) * F;
              d._setScrollTop(-I), R || d._redraw();
            }
          }, b = function() {
            var F = Z2(d, h);
            F.shouldScroll && F.itemTop != p.itemTop && (d._setScrollTop(-F.scrollOffset), d._redraw());
          }, y = function() {
            b(), ai(b, 100);
          }, _ = a && a.zoom !== void 0 ? a.zoom : !0, x = (u + c) / 2, T = _ ? (c - u) * 1.1 : Math.max(this.range.end - this.range.start, (c - u) * 1.1), k = a && a.animation !== void 0 ? a.animation : !0;
          k || (p = {
            shouldScroll: !1,
            scrollOffset: -1,
            itemTop: -1
          }), this.range.setRange(x - T / 2, x + T / 2, {
            animation: k
          }, y, m);
        }
      }
    }
    /**
     * Set Timeline window such that it fits all items
     * @param {Object} [options]  Available options:
     *                                `animation: boolean | {duration: number, easingFunction: string}`
     *                                    If true (default), the range is animated
     *                                    smoothly to the new window. An object can be
     *                                    provided to specify duration and easing function.
     *                                    Default duration is 500 ms, and default easing
     *                                    function is 'easeInOutQuad'.
     * @param {function} [callback]
     */
  }, {
    key: "fit",
    value: function(s, a) {
      var o = s && s.animation !== void 0 ? s.animation : !0, l;
      this.itemsData.length === 1 && this.itemsData.get()[0].end === void 0 ? (l = this.getDataRange(), this.moveTo(l.min.valueOf(), {
        animation: o
      }, a)) : (l = this.getItemRange(), this.range.setRange(l.min, l.max, {
        animation: o
      }, a));
    }
    /**
     * Determine the range of the items, taking into account their actual width
     * and a margin of 10 pixels on both sides.
     *
     * @returns {{min: Date, max: Date}}
     */
  }, {
    key: "getItemRange",
    value: function() {
      var s = this, a = this.getDataRange(), o = a.min !== null ? a.min.valueOf() : null, l = a.max !== null ? a.max.valueOf() : null, u = null, c = null;
      if (o != null && l != null) {
        var d = l - o;
        d <= 0 && (d = 10);
        var h = d / this.props.center.width, f = {}, p = 0;
        Le(G).call(G, this.itemSet.items, function(k, E) {
          if (k.groupShowing) {
            var F = !0;
            f[E] = k.redraw(F), p = f[E].length;
          }
        });
        var m = p > 0;
        if (m)
          for (var b = function(E) {
            Le(G).call(G, f, function(F) {
              F[E]();
            });
          }, y = 0; y < p; y++)
            b(y);
        if (Le(G).call(G, this.itemSet.items, function(k) {
          var E = uT(k), F = cT(k), R, $;
          s.options.rtl ? (R = E - (k.getWidthRight() + 10) * h, $ = F + (k.getWidthLeft() + 10) * h) : (R = E - (k.getWidthLeft() + 10) * h, $ = F + (k.getWidthRight() + 10) * h), R < o && (o = R, u = k), $ > l && (l = $, c = k);
        }), u && c) {
          var _ = u.getWidthLeft() + 10, x = c.getWidthRight() + 10, T = this.props.center.width - _ - x;
          T > 0 && (this.options.rtl ? (o = uT(u) - x * d / T, l = cT(c) + _ * d / T) : (o = uT(u) - _ * d / T, l = cT(c) + x * d / T));
        }
      }
      return {
        min: o != null ? new Date(o) : null,
        max: l != null ? new Date(l) : null
      };
    }
    /**
     * Calculate the data range of the items start and end dates
     * @returns {{min: Date, max: Date}}
     */
  }, {
    key: "getDataRange",
    value: function() {
      var s = null, a = null;
      if (this.itemsData) {
        var o;
        Le(o = this.itemsData).call(o, function(l) {
          var u = G.convert(l.start, "Date").valueOf(), c = G.convert(l.end != null ? l.end : l.start, "Date").valueOf();
          (s === null || u < s) && (s = u), (a === null || c > a) && (a = c);
        });
      }
      return {
        min: s != null ? new Date(s) : null,
        max: a != null ? new Date(a) : null
      };
    }
    /**
     * Generate Timeline related information from an event
     * @param {Event} event
     * @return {Object} An object with related information, like on which area
     *                  The event happened, whether clicked on an item, etc.
     */
  }, {
    key: "getEventProperties",
    value: function(s) {
      var a = s.center ? s.center.x : s.clientX, o = s.center ? s.center.y : s.clientY, l = this.dom.centerContainer.getBoundingClientRect(), u = this.options.rtl ? l.right - a : a - l.left, c = o - l.top, d = this.itemSet.itemFromTarget(s), h = this.itemSet.groupFromTarget(s), f = hA.customTimeFromTarget(s), p = this.itemSet.options.snap || null, m = this.body.util.getScale(), b = this.body.util.getStep(), y = this._toTime(u), _ = p ? p(y, m, b) : y, x = G.getTarget(s), T = null;
      return d != null ? T = "item" : f != null ? T = "custom-time" : G.hasParent(x, this.timeAxis.dom.foreground) || this.timeAxis2 && G.hasParent(x, this.timeAxis2.dom.foreground) ? T = "axis" : G.hasParent(x, this.itemSet.dom.labelSet) ? T = "group-label" : G.hasParent(x, this.currentTime.bar) ? T = "current-time" : G.hasParent(x, this.dom.center) && (T = "background"), {
        event: s,
        item: d ? d.id : null,
        isCluster: d ? !!d.isCluster : !1,
        items: d ? d.items || [] : null,
        group: h ? h.groupId : null,
        customTime: f ? f.options.id : null,
        what: T,
        pageX: s.srcEvent ? s.srcEvent.pageX : s.pageX,
        pageY: s.srcEvent ? s.srcEvent.pageY : s.pageY,
        x: u,
        y: c,
        time: y,
        snappedTime: _
      };
    }
    /**
     * Toggle Timeline rolling mode
     */
  }, {
    key: "toggleRollingMode",
    value: function() {
      this.range.rolling ? this.range.stopRolling() : (this.options.rollingMode == null && this.setOptions(this.options), this.range.startRolling());
    }
    /**
     * redraw
     * @private
     */
  }, {
    key: "_redraw",
    value: function() {
      Od.prototype._redraw.call(this);
    }
    /**
     * on fit callback
     * @param {object} args
     * @private
     */
  }, {
    key: "_onFit",
    value: function(s) {
      var a = s.start, o = s.end, l = s.animation;
      o ? this.range.setRange(a, o, {
        animation: l
      }) : this.moveTo(a.valueOf(), {
        animation: l
      });
    }
  }]), r;
}(Od);
function uT(t) {
  return G.convert(t.data.start, "Date").valueOf();
}
function cT(t) {
  var e = t.data.end != null ? t.data.end : t.data.start;
  return G.convert(e, "Date").valueOf();
}
function Z2(t, e) {
  if (!e.parent)
    return !1;
  var r = t.options.rtl ? t.props.rightContainer.height : t.props.leftContainer.height, n = t.props.center.height, s = e.parent, a = s.top, o = !0, l = t.timeAxis.options.orientation.axis, u = function() {
    return l == "bottom" ? s.height - e.top - e.height : e.top;
  }, c = t._getScrollTop() * -1, d = a + u(), h = e.height;
  return d < c ? a + r <= a + u() + h && (a += u() - t.itemSet.options.margin.item.vertical) : d + h > c + r ? a += u() + h - r + t.itemSet.options.margin.item.vertical : o = !1, a = Math.min(a, n - r), {
    shouldScroll: o,
    scrollOffset: a,
    itemTop: d
  };
}
function ll(t) {
  for (var e in t)
    t.hasOwnProperty(e) && (t[e].redundant = t[e].used, t[e].used = []);
}
function is(t) {
  for (var e in t)
    if (t.hasOwnProperty(e) && t[e].redundant) {
      for (var r = 0; r < t[e].redundant.length; r++)
        t[e].redundant[r].parentNode.removeChild(t[e].redundant[r]);
      t[e].redundant = [];
    }
}
function Dze(t) {
  ll(t), is(t), ll(t);
}
function Hs(t, e, r) {
  var n;
  return e.hasOwnProperty(t) ? e[t].redundant.length > 0 ? (n = e[t].redundant[0], e[t].redundant.shift()) : (n = document.createElementNS("http://www.w3.org/2000/svg", t), r.appendChild(n)) : (n = document.createElementNS("http://www.w3.org/2000/svg", t), e[t] = {
    used: [],
    redundant: []
  }, r.appendChild(n)), e[t].used.push(n), n;
}
function dT(t, e, r, n) {
  var s;
  return e.hasOwnProperty(t) ? e[t].redundant.length > 0 ? (s = e[t].redundant[0], e[t].redundant.shift()) : (s = document.createElement(t), n !== void 0 ? r.insertBefore(s, n) : r.appendChild(s)) : (s = document.createElement(t), e[t] = {
    used: [],
    redundant: []
  }, n !== void 0 ? r.insertBefore(s, n) : r.appendChild(s)), e[t].used.push(s), s;
}
function Qd(t, e, r, n, s, a) {
  var o;
  if (r.style == "circle" ? (o = Hs("circle", n, s), o.setAttributeNS(null, "cx", t), o.setAttributeNS(null, "cy", e), o.setAttributeNS(null, "r", 0.5 * r.size)) : (o = Hs("rect", n, s), o.setAttributeNS(null, "x", t - 0.5 * r.size), o.setAttributeNS(null, "y", e - 0.5 * r.size), o.setAttributeNS(null, "width", r.size), o.setAttributeNS(null, "height", r.size)), r.styles !== void 0 && o.setAttributeNS(null, "style", r.styles), o.setAttributeNS(null, "class", r.className + " vis-point"), a) {
    var l = Hs("text", n, s);
    a.xOffset && (t = t + a.xOffset), a.yOffset && (e = e + a.yOffset), a.content && (l.textContent = a.content), a.className && l.setAttributeNS(null, "class", a.className + " vis-label"), l.setAttributeNS(null, "x", t), l.setAttributeNS(null, "y", e);
  }
  return o;
}
function rk(t, e, r, n, s, a, o, l) {
  if (n != 0) {
    n < 0 && (n *= -1, e -= n);
    var u = Hs("rect", a, o);
    u.setAttributeNS(null, "x", t - 0.5 * r), u.setAttributeNS(null, "y", e), u.setAttributeNS(null, "width", r), u.setAttributeNS(null, "height", n), u.setAttributeNS(null, "class", s), l && u.setAttributeNS(null, "style", l);
  }
}
function Oze() {
  try {
    return navigator ? navigator.languages && navigator.languages.length ? navigator.languages : navigator.userLanguage || navigator.language || navigator.browserLanguage || "en" : "en";
  } catch {
    return "en";
  }
}
var Aze = /* @__PURE__ */ function() {
  function t(e, r, n, s, a, o) {
    var l = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !1, u = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : !1;
    if (dr(this, t), this.majorSteps = [1, 2, 5, 10], this.minorSteps = [0.25, 0.5, 1, 2], this.customLines = null, this.containerHeight = a, this.majorCharHeight = o, this._start = e, this._end = r, this.scale = 1, this.minorStepIdx = -1, this.magnitudefactor = 1, this.determineScale(), this.zeroAlign = l, this.autoScaleStart = n, this.autoScaleEnd = s, this.formattingFunction = u, n || s) {
      var c = this, d = function(f) {
        var p = f - f % (c.magnitudefactor * c.minorSteps[c.minorStepIdx]);
        return f % (c.magnitudefactor * c.minorSteps[c.minorStepIdx]) > 0.5 * (c.magnitudefactor * c.minorSteps[c.minorStepIdx]) ? p + c.magnitudefactor * c.minorSteps[c.minorStepIdx] : p;
      };
      n && (this._start -= this.magnitudefactor * 2 * this.minorSteps[this.minorStepIdx], this._start = d(this._start)), s && (this._end += this.magnitudefactor * this.minorSteps[this.minorStepIdx], this._end = d(this._end)), this.determineScale();
    }
  }
  return hr(t, [{
    key: "setCharHeight",
    value: function(r) {
      this.majorCharHeight = r;
    }
    /**
     * set height
     * @param {number} containerHeight 
     */
  }, {
    key: "setHeight",
    value: function(r) {
      this.containerHeight = r;
    }
    /**
     * determine scale
     */
  }, {
    key: "determineScale",
    value: function() {
      var r = this._end - this._start;
      this.scale = this.containerHeight / r;
      var n = this.majorCharHeight / this.scale, s = r > 0 ? Math.round(Math.log(r) / Math.LN10) : 0;
      this.minorStepIdx = -1, this.magnitudefactor = Math.pow(10, s);
      var a = 0;
      s < 0 && (a = s);
      for (var o = !1, l = a; Math.abs(l) <= Math.abs(s); l++) {
        this.magnitudefactor = Math.pow(10, l);
        for (var u = 0; u < this.minorSteps.length; u++) {
          var c = this.magnitudefactor * this.minorSteps[u];
          if (c >= n) {
            o = !0, this.minorStepIdx = u;
            break;
          }
        }
        if (o === !0)
          break;
      }
    }
    /**
     * returns if value is major
     * @param {number} value
     * @returns {boolean} 
     */
  }, {
    key: "is_major",
    value: function(r) {
      return r % (this.magnitudefactor * this.majorSteps[this.minorStepIdx]) === 0;
    }
    /**
     * returns step size
     * @returns {number} 
     */
  }, {
    key: "getStep",
    value: function() {
      return this.magnitudefactor * this.minorSteps[this.minorStepIdx];
    }
    /**
     * returns first major
     * @returns {number} 
     */
  }, {
    key: "getFirstMajor",
    value: function() {
      var r = this.magnitudefactor * this.majorSteps[this.minorStepIdx];
      return this.convertValue(this._start + (r - this._start % r) % r);
    }
    /**
     * returns first major
     * @param {date} current
     * @returns {date} formatted date
     */
  }, {
    key: "formatValue",
    value: function(r) {
      var n = r.toPrecision(5);
      return typeof this.formattingFunction == "function" && (n = this.formattingFunction(r)), typeof n == "number" ? "".concat(n) : typeof n == "string" ? n : r.toPrecision(5);
    }
    /**
     * returns lines
     * @returns {object} lines
     */
  }, {
    key: "getLines",
    value: function() {
      for (var r = [], n = this.getStep(), s = (n - this._start % n) % n, a = this._start + s; this._end - a > 1e-5; a += n)
        a != this._start && r.push({
          major: this.is_major(a),
          y: this.convertValue(a),
          val: this.formatValue(a)
        });
      return r;
    }
    /**
     * follow scale
     * @param {object} other
     */
  }, {
    key: "followScale",
    value: function(r) {
      var n = this.minorStepIdx, s = this._start, a = this._end, o = this, l = function() {
        o.magnitudefactor *= 2;
      }, u = function() {
        o.magnitudefactor /= 2;
      };
      r.minorStepIdx <= 1 && this.minorStepIdx <= 1 || r.minorStepIdx > 1 && this.minorStepIdx > 1 || (r.minorStepIdx < this.minorStepIdx ? (this.minorStepIdx = 1, n == 2 || l(), l()) : (this.minorStepIdx = 2, n == 1 || u(), u()));
      for (var c = r.convertValue(0), d = r.getStep() * r.scale, h = !1, f = 0; !h && f++ < 5; ) {
        this.scale = d / (this.minorSteps[this.minorStepIdx] * this.magnitudefactor);
        var p = this.containerHeight / this.scale;
        this._start = s, this._end = this._start + p;
        var m = this._end * this.scale, b = this.magnitudefactor * this.majorSteps[this.minorStepIdx], y = this.getFirstMajor() - r.getFirstMajor();
        if (this.zeroAlign) {
          var _ = c - m;
          this._end += _ / this.scale, this._start = this._end - p;
        } else
          this.autoScaleStart ? (this._start -= y / this.scale, this._end = this._start + p) : (this._start += b - y / this.scale, this._end = this._start + p);
        if (!this.autoScaleEnd && this._end > a + 1e-5) {
          u(), h = !1;
          continue;
        }
        if (!this.autoScaleStart && this._start < s - 1e-5)
          if (this.zeroAlign && s >= 0)
            console.warn("Can't adhere to given 'min' range, due to zeroalign");
          else {
            u(), h = !1;
            continue;
          }
        if (this.autoScaleStart && this.autoScaleEnd && p < a - s) {
          l(), h = !1;
          continue;
        }
        h = !0;
      }
    }
    /**
     * convert value
     * @param {number} value
     * @returns {number} 
     */
  }, {
    key: "convertValue",
    value: function(r) {
      return this.containerHeight - (r - this._start) * this.scale;
    }
    /**
     * returns screen to value
     * @param {number} pixels
     * @returns {number} 
     */
  }, {
    key: "screenToValue",
    value: function(r) {
      return (this.containerHeight - r) / this.scale + this._start;
    }
  }]), t;
}();
function Cze(t, e) {
  var r = typeof Nl < "u" && Vo(t) || t["@@iterator"];
  if (!r) {
    if ($t(t) || (r = Ize(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, s = function() {
      };
      return { s, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(c) {
        throw c;
      }, f: s };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return { s: function() {
    r = r.call(t);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    o = !0, l = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (o)
        throw l;
    }
  } };
}
function Ize(t, e) {
  var r;
  if (t) {
    if (typeof t == "string")
      return J2(t, e);
    var n = hi(r = Object.prototype.toString.call(t)).call(r, 8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return vc(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return J2(t, e);
  }
}
function J2(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function Pze(t) {
  var e = Rze();
  return function() {
    var n = ur(t), s;
    if (e) {
      var a = ur(this).constructor;
      s = nt(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return es(this, s);
  };
}
function Rze() {
  if (typeof Reflect > "u" || !nt || nt.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(nt(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var eB = /* @__PURE__ */ function(t) {
  Ji(r, t);
  var e = Pze(r);
  function r(n, s, a, o) {
    var l;
    dr(this, r), l = e.call(this), l.id = Dd(), l.body = n, l.defaultOptions = {
      orientation: "left",
      // supported: 'left', 'right'
      showMinorLabels: !0,
      showMajorLabels: !0,
      showWeekScale: !1,
      icons: !1,
      majorLinesOffset: 7,
      minorLinesOffset: 4,
      labelOffsetX: 10,
      labelOffsetY: 2,
      iconWidth: 20,
      width: "40px",
      visible: !0,
      alignZeros: !0,
      left: {
        range: {
          min: void 0,
          max: void 0
        },
        format: function(d) {
          return "".concat(zy(d.toPrecision(3)));
        },
        title: {
          text: void 0,
          style: void 0
        }
      },
      right: {
        range: {
          min: void 0,
          max: void 0
        },
        format: function(d) {
          return "".concat(zy(d.toPrecision(3)));
        },
        title: {
          text: void 0,
          style: void 0
        }
      }
    }, l.linegraphOptions = o, l.linegraphSVG = a, l.props = {}, l.DOMelements = {
      // dynamic elements
      lines: {},
      labels: {},
      title: {}
    }, l.dom = {}, l.scale = void 0, l.range = {
      start: 0,
      end: 0
    }, l.options = G.extend({}, l.defaultOptions), l.conversionFactor = 1, l.setOptions(s), l.width = Number("".concat(l.options.width).replace("px", "")), l.minWidth = l.width, l.height = l.linegraphSVG.getBoundingClientRect().height, l.hidden = !1, l.stepPixels = 25, l.zeroCrossing = -1, l.amountOfSteps = -1, l.lineOffset = 0, l.master = !0, l.masterAxis = null, l.svgElements = {}, l.iconsRemoved = !1, l.groups = {}, l.amountOfGroups = 0, l._create(), l.scale == null && l._redrawLabels(), l.framework = {
      svg: l.svg,
      svgElements: l.svgElements,
      options: l.options,
      groups: l.groups
    };
    var u = Vn(l);
    return l.body.emitter.on("verticalDrag", function() {
      u.dom.lineContainer.style.top = "".concat(u.body.domProps.scrollTop, "px");
    }), l;
  }
  return hr(r, [{
    key: "addGroup",
    value: function(s, a) {
      this.groups.hasOwnProperty(s) || (this.groups[s] = a), this.amountOfGroups += 1;
    }
    /**
     * updates group of data axis
     * @param {string} label 
     * @param {object} graphOptions
     */
  }, {
    key: "updateGroup",
    value: function(s, a) {
      this.groups.hasOwnProperty(s) || (this.amountOfGroups += 1), this.groups[s] = a;
    }
    /**
     * removes group of data axis
     * @param {string} label 
     */
  }, {
    key: "removeGroup",
    value: function(s) {
      this.groups.hasOwnProperty(s) && (delete this.groups[s], this.amountOfGroups -= 1);
    }
    /**
     * sets options
     * @param {object} options
     */
  }, {
    key: "setOptions",
    value: function(s) {
      if (s) {
        var a = !1;
        this.options.orientation != s.orientation && s.orientation !== void 0 && (a = !0);
        var o = ["orientation", "showMinorLabels", "showMajorLabels", "icons", "majorLinesOffset", "minorLinesOffset", "labelOffsetX", "labelOffsetY", "iconWidth", "width", "visible", "left", "right", "alignZeros"];
        G.selectiveDeepExtend(o, this.options, s), this.minWidth = Number("".concat(this.options.width).replace("px", "")), a === !0 && this.dom.frame && (this.hide(), this.show());
      }
    }
    /**
     * Create the HTML DOM for the DataAxis
     */
  }, {
    key: "_create",
    value: function() {
      this.dom.frame = document.createElement("div"), this.dom.frame.style.width = this.options.width, this.dom.frame.style.height = this.height, this.dom.lineContainer = document.createElement("div"), this.dom.lineContainer.style.width = "100%", this.dom.lineContainer.style.height = this.height, this.dom.lineContainer.style.position = "relative", this.dom.lineContainer.style.visibility = "visible", this.dom.lineContainer.style.display = "block", this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.svg.style.position = "absolute", this.svg.style.top = "0px", this.svg.style.height = "100%", this.svg.style.width = "100%", this.svg.style.display = "block", this.dom.frame.appendChild(this.svg);
    }
    /**
     * redraws groups icons
     */
  }, {
    key: "_redrawGroupIcons",
    value: function() {
      ll(this.svgElements);
      var s, a = this.options.iconWidth, o = 15, l = 4, u = l + 0.5 * o;
      this.options.orientation === "left" ? s = l : s = this.width - a - l;
      var c = xn(this.groups);
      wn(c).call(c, function(p, m) {
        return p < m ? -1 : 1;
      });
      var d = Cze(c), h;
      try {
        for (d.s(); !(h = d.n()).done; ) {
          var f = h.value;
          this.groups[f].visible === !0 && (this.linegraphOptions.visibility[f] === void 0 || this.linegraphOptions.visibility[f] === !0) && (this.groups[f].getLegend(a, o, this.framework, s, u), u += o + l);
        }
      } catch (p) {
        d.e(p);
      } finally {
        d.f();
      }
      is(this.svgElements), this.iconsRemoved = !1;
    }
    /**
     * Cleans up icons
     */
  }, {
    key: "_cleanupIcons",
    value: function() {
      this.iconsRemoved === !1 && (ll(this.svgElements), is(this.svgElements), this.iconsRemoved = !0);
    }
    /**
     * Create the HTML DOM for the DataAxis
     */
  }, {
    key: "show",
    value: function() {
      this.hidden = !1, this.dom.frame.parentNode || (this.options.orientation === "left" ? this.body.dom.left.appendChild(this.dom.frame) : this.body.dom.right.appendChild(this.dom.frame)), this.dom.lineContainer.parentNode || this.body.dom.backgroundHorizontal.appendChild(this.dom.lineContainer), this.dom.lineContainer.style.display = "block";
    }
    /**
     * Create the HTML DOM for the DataAxis
     */
  }, {
    key: "hide",
    value: function() {
      this.hidden = !0, this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame), this.dom.lineContainer.style.display = "none";
    }
    /**
     * Set a range (start and end)
     * @param {number} start
     * @param {number} end
     */
  }, {
    key: "setRange",
    value: function(s, a) {
      this.range.start = s, this.range.end = a;
    }
    /**
     * Repaint the component
     * @return {boolean} Returns true if the component is resized
     */
  }, {
    key: "redraw",
    value: function() {
      var s = !1, a = 0;
      this.dom.lineContainer.style.top = "".concat(this.body.domProps.scrollTop, "px");
      for (var o in this.groups)
        this.groups.hasOwnProperty(o) && this.groups[o].visible === !0 && (this.linegraphOptions.visibility[o] === void 0 || this.linegraphOptions.visibility[o] === !0) && a++;
      if (this.amountOfGroups === 0 || a === 0)
        this.hide();
      else {
        this.show(), this.height = Number(this.linegraphSVG.style.height.replace("px", "")), this.dom.lineContainer.style.height = "".concat(this.height, "px"), this.width = this.options.visible === !0 ? Number("".concat(this.options.width).replace("px", "")) : 0;
        var l = this.props, u = this.dom.frame;
        u.className = "vis-data-axis", this._calculateCharSize();
        var c = this.options.orientation, d = this.options.showMinorLabels, h = this.options.showMajorLabels, f = this.body.dom.backgroundHorizontal.offsetWidth;
        l.minorLabelHeight = d ? l.minorCharHeight : 0, l.majorLabelHeight = h ? l.majorCharHeight : 0, l.minorLineWidth = f - this.lineOffset - this.width + 2 * this.options.minorLinesOffset, l.minorLineHeight = 1, l.majorLineWidth = f - this.lineOffset - this.width + 2 * this.options.majorLinesOffset, l.majorLineHeight = 1, c === "left" ? (u.style.top = "0", u.style.left = "0", u.style.bottom = "", u.style.width = "".concat(this.width, "px"), u.style.height = "".concat(this.height, "px"), this.props.width = this.body.domProps.left.width, this.props.height = this.body.domProps.left.height) : (u.style.top = "", u.style.bottom = "0", u.style.left = "0", u.style.width = "".concat(this.width, "px"), u.style.height = "".concat(this.height, "px"), this.props.width = this.body.domProps.right.width, this.props.height = this.body.domProps.right.height), s = this._redrawLabels(), s = this._isResized() || s, this.options.icons === !0 ? this._redrawGroupIcons() : this._cleanupIcons(), this._redrawTitle(c);
      }
      return s;
    }
    /**
     * Repaint major and minor text labels and vertical grid lines
     *
     * @returns {boolean}
     * @private
     */
  }, {
    key: "_redrawLabels",
    value: function() {
      var s = this, a = !1;
      ll(this.DOMelements.lines), ll(this.DOMelements.labels);
      var o = this.options.orientation, l = this.options[o].range != null ? this.options[o].range : {}, u = !0;
      l.max != null && (this.range.end = l.max, u = !1);
      var c = !0;
      l.min != null && (this.range.start = l.min, c = !1), this.scale = new Aze(this.range.start, this.range.end, c, u, this.dom.frame.offsetHeight, this.props.majorCharHeight, this.options.alignZeros, this.options[o].format), this.master === !1 && this.masterAxis != null ? (this.scale.followScale(this.masterAxis.scale), this.dom.lineContainer.style.display = "none") : this.dom.lineContainer.style.display = "block", this.maxLabelSize = 0;
      var d = this.scale.getLines();
      Le(d).call(d, function(p) {
        var m = p.y, b = p.major;
        s.options.showMinorLabels && b === !1 && s._redrawLabel(m - 2, p.val, o, "vis-y-axis vis-minor", s.props.minorCharHeight), b && m >= 0 && s._redrawLabel(m - 2, p.val, o, "vis-y-axis vis-major", s.props.majorCharHeight), s.master === !0 && (b ? s._redrawLine(m, o, "vis-grid vis-horizontal vis-major", s.options.majorLinesOffset, s.props.majorLineWidth) : s._redrawLine(m, o, "vis-grid vis-horizontal vis-minor", s.options.minorLinesOffset, s.props.minorLineWidth));
      });
      var h = 0;
      this.options[o].title !== void 0 && this.options[o].title.text !== void 0 && (h = this.props.titleCharHeight);
      var f = this.options.icons === !0 ? Math.max(this.options.iconWidth, h) + this.options.labelOffsetX + 15 : h + this.options.labelOffsetX + 15;
      return this.maxLabelSize > this.width - f && this.options.visible === !0 ? (this.width = this.maxLabelSize + f, this.options.width = "".concat(this.width, "px"), is(this.DOMelements.lines), is(this.DOMelements.labels), this.redraw(), a = !0) : this.maxLabelSize < this.width - f && this.options.visible === !0 && this.width > this.minWidth ? (this.width = Math.max(this.minWidth, this.maxLabelSize + f), this.options.width = "".concat(this.width, "px"), is(this.DOMelements.lines), is(this.DOMelements.labels), this.redraw(), a = !0) : (is(this.DOMelements.lines), is(this.DOMelements.labels), a = !1), a;
    }
    /**
     * converts value
     * @param {number} value
     * @returns {number} converted number
     */
  }, {
    key: "convertValue",
    value: function(s) {
      return this.scale.convertValue(s);
    }
    /**
     * converts value
     * @param {number} x
     * @returns {number} screen value
     */
  }, {
    key: "screenToValue",
    value: function(s) {
      return this.scale.screenToValue(s);
    }
    /**
     * Create a label for the axis at position x
     *
     * @param {number} y
     * @param {string} text
     * @param {'top'|'right'|'bottom'|'left'} orientation
     * @param {string} className
     * @param {number} characterHeight
     * @private
     */
  }, {
    key: "_redrawLabel",
    value: function(s, a, o, l, u) {
      var c = dT("div", this.DOMelements.labels, this.dom.frame);
      c.className = l, c.innerHTML = G.xss(a), o === "left" ? (c.style.left = "-".concat(this.options.labelOffsetX, "px"), c.style.textAlign = "right") : (c.style.right = "-".concat(this.options.labelOffsetX, "px"), c.style.textAlign = "left"), c.style.top = "".concat(s - 0.5 * u + this.options.labelOffsetY, "px"), a += "";
      var d = Math.max(this.props.majorCharWidth, this.props.minorCharWidth);
      this.maxLabelSize < a.length * d && (this.maxLabelSize = a.length * d);
    }
    /**
     * Create a minor line for the axis at position y
     * @param {number} y
     * @param {'top'|'right'|'bottom'|'left'} orientation
     * @param {string} className
     * @param {number} offset
     * @param {number} width
     */
  }, {
    key: "_redrawLine",
    value: function(s, a, o, l, u) {
      if (this.master === !0) {
        var c = dT("div", this.DOMelements.lines, this.dom.lineContainer);
        c.className = o, c.innerHTML = "", a === "left" ? c.style.left = "".concat(this.width - l, "px") : c.style.right = "".concat(this.width - l, "px"), c.style.width = "".concat(u, "px"), c.style.top = "".concat(s, "px");
      }
    }
    /**
     * Create a title for the axis
     * @private
     * @param {'top'|'right'|'bottom'|'left'} orientation
     */
  }, {
    key: "_redrawTitle",
    value: function(s) {
      if (ll(this.DOMelements.title), this.options[s].title !== void 0 && this.options[s].title.text !== void 0) {
        var a = dT("div", this.DOMelements.title, this.dom.frame);
        a.className = "vis-y-axis vis-title vis-".concat(s), a.innerHTML = G.xss(this.options[s].title.text), this.options[s].title.style !== void 0 && G.addCssText(a, this.options[s].title.style), s === "left" ? a.style.left = "".concat(this.props.titleCharHeight, "px") : a.style.right = "".concat(this.props.titleCharHeight, "px"), a.style.width = "".concat(this.height, "px");
      }
      is(this.DOMelements.title);
    }
    /**
     * Determine the size of text on the axis (both major and minor axis).
     * The size is calculated only once and then cached in this.props.
     * @private
     */
  }, {
    key: "_calculateCharSize",
    value: function() {
      if (!("minorCharHeight" in this.props)) {
        var s = document.createTextNode("0"), a = document.createElement("div");
        a.className = "vis-y-axis vis-minor vis-measure", a.appendChild(s), this.dom.frame.appendChild(a), this.props.minorCharHeight = a.clientHeight, this.props.minorCharWidth = a.clientWidth, this.dom.frame.removeChild(a);
      }
      if (!("majorCharHeight" in this.props)) {
        var o = document.createTextNode("0"), l = document.createElement("div");
        l.className = "vis-y-axis vis-major vis-measure", l.appendChild(o), this.dom.frame.appendChild(l), this.props.majorCharHeight = l.clientHeight, this.props.majorCharWidth = l.clientWidth, this.dom.frame.removeChild(l);
      }
      if (!("titleCharHeight" in this.props)) {
        var u = document.createTextNode("0"), c = document.createElement("div");
        c.className = "vis-y-axis vis-title vis-measure", c.appendChild(u), this.dom.frame.appendChild(c), this.props.titleCharHeight = c.clientHeight, this.props.titleCharWidth = c.clientWidth, this.dom.frame.removeChild(c);
      }
    }
  }]), r;
}(Fl);
function Vv(t, e) {
}
Vv.draw = function(t, e, r, n) {
  n = n || 0;
  for (var s = Mze(r, e), a = 0; a < t.length; a++)
    if (!s)
      Qd(t[a].screen_x + n, t[a].screen_y, nk(e), r.svgElements, r.svg, t[a].label);
    else {
      var o = s(t[a], e);
      (o === !0 || mt(o) === "object") && Qd(t[a].screen_x + n, t[a].screen_y, nk(e, o), r.svgElements, r.svg, t[a].label);
    }
};
Vv.drawIcon = function(t, e, r, n, s, a) {
  var o = s * 0.5, l = Hs("rect", a.svgElements, a.svg);
  l.setAttributeNS(null, "x", e), l.setAttributeNS(null, "y", r - o), l.setAttributeNS(null, "width", n), l.setAttributeNS(null, "height", 2 * o), l.setAttributeNS(null, "class", "vis-outline"), Qd(e + 0.5 * n, r, nk(t), a.svgElements, a.svg);
};
function nk(t, e) {
  return e = typeof e > "u" ? {} : e, {
    style: e.style || t.options.drawPoints.style,
    styles: e.styles || t.options.drawPoints.styles,
    size: e.size || t.options.drawPoints.size,
    className: e.className || t.className
  };
}
function Mze(t, e) {
  var r = void 0;
  return t.options && t.options.drawPoints && t.options.drawPoints.onRender && typeof t.options.drawPoints.onRender == "function" && (r = t.options.drawPoints.onRender), e.group.options && e.group.options.drawPoints && e.group.options.drawPoints.onRender && typeof e.group.options.drawPoints.onRender == "function" && (r = e.group.options.drawPoints.onRender), r;
}
function ii(t, e) {
}
ii.drawIcon = function(t, e, r, n, s, a) {
  var o = s * 0.5, l = Hs("rect", a.svgElements, a.svg);
  l.setAttributeNS(null, "x", e), l.setAttributeNS(null, "y", r - o), l.setAttributeNS(null, "width", n), l.setAttributeNS(null, "height", 2 * o), l.setAttributeNS(null, "class", "vis-outline");
  var u = Math.round(0.3 * n), c = t.options.barChart.width, d = c / u, h = Math.round(0.4 * s), f = Math.round(0.75 * s), p = Math.round((n - 2 * u) / 3);
  if (rk(e + 0.5 * u + p, r + o - h - 1, u, h, t.className + " vis-bar", a.svgElements, a.svg, t.style), rk(e + 1.5 * u + p + 2, r + o - f - 1, u, f, t.className + " vis-bar", a.svgElements, a.svg, t.style), t.options.drawPoints.enabled == !0) {
    var m = {
      style: t.options.drawPoints.style,
      styles: t.options.drawPoints.styles,
      size: t.options.drawPoints.size / d,
      className: t.className
    };
    Qd(e + 0.5 * u + p, r + o - h - 1, m, a.svgElements, a.svg), Qd(e + 1.5 * u + p + 2, r + o - f - 1, m, a.svgElements, a.svg);
  }
};
ii.draw = function(t, e, r) {
  var n = [], s = {}, a, o, l, u, c, d, h = 0;
  for (c = 0; c < t.length; c++)
    if (u = r.groups[t[c]], u.options.style === "bar" && u.visible === !0 && (r.options.groups.visibility[t[c]] === void 0 || r.options.groups.visibility[t[c]] === !0))
      for (d = 0; d < e[t[c]].length; d++)
        n.push({
          screen_x: e[t[c]][d].screen_x,
          screen_end: e[t[c]][d].screen_end,
          screen_y: e[t[c]][d].screen_y,
          x: e[t[c]][d].x,
          end: e[t[c]][d].end,
          y: e[t[c]][d].y,
          groupId: t[c],
          label: e[t[c]][d].label
        }), h += 1;
  if (h !== 0)
    for (wn(n).call(n, function(x, T) {
      return x.screen_x === T.screen_x ? x.groupId < T.groupId ? -1 : 1 : x.screen_x - T.screen_x;
    }), ii._getDataIntersections(s, n), c = 0; c < n.length; c++) {
      u = r.groups[n[c].groupId];
      var f = u.options.barChart.minWidth != null ? u.options.barChart.minWidth : 0.1 * u.options.barChart.width;
      o = n[c].screen_x;
      var p = 0;
      if (s[o] === void 0)
        c + 1 < n.length && (a = Math.abs(n[c + 1].screen_x - o)), l = ii._getSafeDrawData(a, u, f);
      else {
        var m = c + (s[o].amount - s[o].resolved);
        m < n.length && (a = Math.abs(n[m].screen_x - o)), l = ii._getSafeDrawData(a, u, f), s[o].resolved += 1, u.options.stack === !0 && u.options.excludeFromStacking !== !0 ? n[c].screen_y < u.zeroPosition ? (p = s[o].accumulatedNegative, s[o].accumulatedNegative += u.zeroPosition - n[c].screen_y) : (p = s[o].accumulatedPositive, s[o].accumulatedPositive += u.zeroPosition - n[c].screen_y) : u.options.barChart.sideBySide === !0 && (l.width = l.width / s[o].amount, l.offset += s[o].resolved * l.width - 0.5 * l.width * (s[o].amount + 1));
      }
      var b = l.width, y = n[c].screen_x;
      if (n[c].screen_end != null ? (b = n[c].screen_end - n[c].screen_x, y += b * 0.5) : y += l.offset, rk(y, n[c].screen_y - p, b, u.zeroPosition - n[c].screen_y, u.className + " vis-bar", r.svgElements, r.svg, u.style), u.options.drawPoints.enabled === !0) {
        var _ = {
          screen_x: n[c].screen_x,
          screen_y: n[c].screen_y - p,
          x: n[c].x,
          y: n[c].y,
          groupId: n[c].groupId,
          label: n[c].label
        };
        Vv.draw([_], u, r, l.offset);
      }
    }
};
ii._getDataIntersections = function(t, e) {
  for (var r, n = 0; n < e.length; n++)
    n + 1 < e.length && (r = Math.abs(e[n + 1].screen_x - e[n].screen_x)), n > 0 && (r = Math.min(r, Math.abs(e[n - 1].screen_x - e[n].screen_x))), r === 0 && (t[e[n].screen_x] === void 0 && (t[e[n].screen_x] = {
      amount: 0,
      resolved: 0,
      accumulatedPositive: 0,
      accumulatedNegative: 0
    }), t[e[n].screen_x].amount += 1);
};
ii._getSafeDrawData = function(t, e, r) {
  var n, s;
  return t < e.options.barChart.width && t > 0 ? (n = t < r ? r : t, s = 0, e.options.barChart.align === "left" ? s -= 0.5 * t : e.options.barChart.align === "right" && (s += 0.5 * t)) : (n = e.options.barChart.width, s = 0, e.options.barChart.align === "left" ? s -= 0.5 * e.options.barChart.width : e.options.barChart.align === "right" && (s += 0.5 * e.options.barChart.width)), {
    width: n,
    offset: s
  };
};
ii.getStackedYRange = function(t, e, r, n, s) {
  if (t.length > 0) {
    wn(t).call(t, function(o, l) {
      return o.screen_x === l.screen_x ? o.groupId < l.groupId ? -1 : 1 : o.screen_x - l.screen_x;
    });
    var a = {};
    ii._getDataIntersections(a, t), e[n] = ii._getStackedYRange(a, t), e[n].yAxisOrientation = s, r.push(n);
  }
};
ii._getStackedYRange = function(t, e) {
  for (var r, n = e[0].screen_y, s = e[0].screen_y, a = 0; a < e.length; a++)
    r = e[a].screen_x, t[r] === void 0 ? (n = n > e[a].screen_y ? e[a].screen_y : n, s = s < e[a].screen_y ? e[a].screen_y : s) : e[a].screen_y < 0 ? t[r].accumulatedNegative += e[a].screen_y : t[r].accumulatedPositive += e[a].screen_y;
  for (var o in t)
    t.hasOwnProperty(o) && (n = n > t[o].accumulatedNegative ? t[o].accumulatedNegative : n, n = n > t[o].accumulatedPositive ? t[o].accumulatedPositive : n, s = s < t[o].accumulatedNegative ? t[o].accumulatedNegative : s, s = s < t[o].accumulatedPositive ? t[o].accumulatedPositive : s);
  return {
    min: n,
    max: s
  };
};
function In(t, e) {
}
In.calcPath = function(t, e) {
  if (t != null && t.length > 0) {
    var r = [];
    return e.options.interpolation.enabled == !0 ? r = In._catmullRom(t, e) : r = In._linear(t), r;
  }
};
In.drawIcon = function(t, e, r, n, s, a) {
  var o = s * 0.5, l, u, c = Hs("rect", a.svgElements, a.svg);
  if (c.setAttributeNS(null, "x", e), c.setAttributeNS(null, "y", r - o), c.setAttributeNS(null, "width", n), c.setAttributeNS(null, "height", 2 * o), c.setAttributeNS(null, "class", "vis-outline"), l = Hs("path", a.svgElements, a.svg), l.setAttributeNS(null, "class", t.className), t.style !== void 0 && l.setAttributeNS(null, "style", t.style), l.setAttributeNS(null, "d", "M" + e + "," + r + " L" + (e + n) + "," + r), t.options.shaded.enabled == !0 && (u = Hs("path", a.svgElements, a.svg), t.options.shaded.orientation == "top" ? u.setAttributeNS(null, "d", "M" + e + ", " + (r - o) + "L" + e + "," + r + " L" + (e + n) + "," + r + " L" + (e + n) + "," + (r - o)) : u.setAttributeNS(null, "d", "M" + e + "," + r + " L" + e + "," + (r + o) + " L" + (e + n) + "," + (r + o) + "L" + (e + n) + "," + r), u.setAttributeNS(null, "class", t.className + " vis-icon-fill"), t.options.shaded.style !== void 0 && t.options.shaded.style !== "" && u.setAttributeNS(null, "style", t.options.shaded.style)), t.options.drawPoints.enabled == !0) {
    var d = {
      style: t.options.drawPoints.style,
      styles: t.options.drawPoints.styles,
      size: t.options.drawPoints.size,
      className: t.className
    };
    Qd(e + 0.5 * n, r, d, a.svgElements, a.svg);
  }
};
In.drawShading = function(t, e, r, n) {
  if (e.options.shaded.enabled == !0) {
    var s = Number(n.svg.style.height.replace("px", "")), a = Hs("path", n.svgElements, n.svg), o = "L";
    e.options.interpolation.enabled == !0 && (o = "C");
    var l, u = 0;
    e.options.shaded.orientation == "top" ? u = 0 : e.options.shaded.orientation == "bottom" ? u = s : u = Math.min(Math.max(0, e.zeroPosition), s), e.options.shaded.orientation == "group" && r != null && r != null ? l = "M" + t[0][0] + "," + t[0][1] + " " + this.serializePath(t, o, !1) + " L" + r[r.length - 1][0] + "," + r[r.length - 1][1] + " " + this.serializePath(r, o, !0) + r[0][0] + "," + r[0][1] + " Z" : l = "M" + t[0][0] + "," + t[0][1] + " " + this.serializePath(t, o, !1) + " V" + u + " H" + t[0][0] + " Z", a.setAttributeNS(null, "class", e.className + " vis-fill"), e.options.shaded.style !== void 0 && a.setAttributeNS(null, "style", e.options.shaded.style), a.setAttributeNS(null, "d", l);
  }
};
In.draw = function(t, e, r) {
  if (t != null && t != null) {
    var n = Hs("path", r.svgElements, r.svg);
    n.setAttributeNS(null, "class", e.className), e.style !== void 0 && n.setAttributeNS(null, "style", e.style);
    var s = "L";
    e.options.interpolation.enabled == !0 && (s = "C"), n.setAttributeNS(null, "d", "M" + t[0][0] + "," + t[0][1] + " " + this.serializePath(t, s, !1));
  }
};
In.serializePath = function(t, e, r) {
  if (t.length < 2)
    return "";
  var n = e, s;
  if (r)
    for (s = t.length - 2; s > 0; s--)
      n += t[s][0] + "," + t[s][1] + " ";
  else
    for (s = 1; s < t.length; s++)
      n += t[s][0] + "," + t[s][1] + " ";
  return n;
};
In._catmullRomUniform = function(t) {
  var e, r, n, s, a, o, l = [];
  l.push([Math.round(t[0].screen_x), Math.round(t[0].screen_y)]);
  for (var u = 1 / 6, c = t.length, d = 0; d < c - 1; d++)
    e = d == 0 ? t[0] : t[d - 1], r = t[d], n = t[d + 1], s = d + 2 < c ? t[d + 2] : n, a = {
      screen_x: (-e.screen_x + 6 * r.screen_x + n.screen_x) * u,
      screen_y: (-e.screen_y + 6 * r.screen_y + n.screen_y) * u
    }, o = {
      screen_x: (r.screen_x + 6 * n.screen_x - s.screen_x) * u,
      screen_y: (r.screen_y + 6 * n.screen_y - s.screen_y) * u
    }, l.push([a.screen_x, a.screen_y]), l.push([o.screen_x, o.screen_y]), l.push([n.screen_x, n.screen_y]);
  return l;
};
In._catmullRom = function(t, e) {
  var r = e.options.interpolation.alpha;
  if (r == 0 || r === void 0)
    return this._catmullRomUniform(t);
  var n, s, a, o, l, u, c, d, h, f, p, m, b, y, _, x, T, k, E, F = [];
  F.push([Math.round(t[0].screen_x), Math.round(t[0].screen_y)]);
  for (var R = t.length, $ = 0; $ < R - 1; $++)
    n = $ == 0 ? t[0] : t[$ - 1], s = t[$], a = t[$ + 1], o = $ + 2 < R ? t[$ + 2] : a, c = Math.sqrt(Math.pow(n.screen_x - s.screen_x, 2) + Math.pow(n.screen_y - s.screen_y, 2)), d = Math.sqrt(Math.pow(s.screen_x - a.screen_x, 2) + Math.pow(s.screen_y - a.screen_y, 2)), h = Math.sqrt(Math.pow(a.screen_x - o.screen_x, 2) + Math.pow(a.screen_y - o.screen_y, 2)), y = Math.pow(h, r), x = Math.pow(h, 2 * r), _ = Math.pow(d, r), T = Math.pow(d, 2 * r), E = Math.pow(c, r), k = Math.pow(c, 2 * r), f = 2 * k + 3 * E * _ + T, p = 2 * x + 3 * y * _ + T, m = 3 * E * (E + _), m > 0 && (m = 1 / m), b = 3 * y * (y + _), b > 0 && (b = 1 / b), l = {
      screen_x: (-T * n.screen_x + f * s.screen_x + k * a.screen_x) * m,
      screen_y: (-T * n.screen_y + f * s.screen_y + k * a.screen_y) * m
    }, u = {
      screen_x: (x * s.screen_x + p * a.screen_x - T * o.screen_x) * b,
      screen_y: (x * s.screen_y + p * a.screen_y - T * o.screen_y) * b
    }, l.screen_x == 0 && l.screen_y == 0 && (l = s), u.screen_x == 0 && u.screen_y == 0 && (u = a), F.push([l.screen_x, l.screen_y]), F.push([u.screen_x, u.screen_y]), F.push([a.screen_x, a.screen_y]);
  return F;
};
In._linear = function(t) {
  for (var e = [], r = 0; r < t.length; r++)
    e.push([t[r].screen_x, t[r].screen_y]);
  return e;
};
function Bl(t, e, r, n) {
  this.id = e;
  var s = ["sampling", "style", "sort", "yAxisOrientation", "barChart", "drawPoints", "shaded", "interpolation", "zIndex", "excludeFromStacking", "excludeFromLegend"];
  this.options = G.selectiveBridgeObject(s, r), this.usingDefaultStyle = t.className === void 0, this.groupsUsingDefaultStyles = n, this.zeroPosition = 0, this.update(t), this.usingDefaultStyle == !0 && (this.groupsUsingDefaultStyles[0] += 1), this.itemsData = [], this.visible = t.visible === void 0 ? !0 : t.visible;
}
Bl.prototype.setItems = function(t) {
  t != null ? (this.itemsData = t, wn(this.options) == !0 && G.insertSort(this.itemsData, function(e, r) {
    return e.x > r.x ? 1 : -1;
  })) : this.itemsData = [];
};
Bl.prototype.getItems = function() {
  return this.itemsData;
};
Bl.prototype.setZeroPosition = function(t) {
  this.zeroPosition = t;
};
Bl.prototype.setOptions = function(t) {
  if (t !== void 0) {
    var e = ["sampling", "style", "sort", "yAxisOrientation", "barChart", "zIndex", "excludeFromStacking", "excludeFromLegend"];
    G.selectiveDeepExtend(e, this.options, t), typeof t.drawPoints == "function" && (t.drawPoints = {
      onRender: t.drawPoints
    }), G.mergeOptions(this.options, t, "interpolation"), G.mergeOptions(this.options, t, "drawPoints"), G.mergeOptions(this.options, t, "shaded"), t.interpolation && mt(t.interpolation) == "object" && t.interpolation.parametrization && (t.interpolation.parametrization == "uniform" ? this.options.interpolation.alpha = 0 : t.interpolation.parametrization == "chordal" ? this.options.interpolation.alpha = 1 : (this.options.interpolation.parametrization = "centripetal", this.options.interpolation.alpha = 0.5));
  }
};
Bl.prototype.update = function(t) {
  this.group = t, this.content = t.content || "graph", this.className = t.className || this.className || "vis-graph-group" + this.groupsUsingDefaultStyles[0] % 10, this.visible = t.visible === void 0 ? !0 : t.visible, this.style = t.style, this.setOptions(t.options);
};
Bl.prototype.getLegend = function(t, e, r, n, s) {
  if (r == null || r == null) {
    var a = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    r = {
      svg: a,
      svgElements: {},
      options: this.options,
      groups: [this]
    };
  }
  switch ((n == null || n == null) && (n = 0), (s == null || s == null) && (s = 0.5 * e), this.options.style) {
    case "line":
      In.drawIcon(this, n, s, t, e, r);
      break;
    case "points":
    case "point":
      Vv.drawIcon(this, n, s, t, e, r);
      break;
    case "bar":
      ii.drawIcon(this, n, s, t, e, r);
      break;
  }
  return {
    icon: r.svg,
    label: this.content,
    orientation: this.options.yAxisOrientation
  };
};
Bl.prototype.getYRange = function(t) {
  for (var e = t[0].y, r = t[0].y, n = 0; n < t.length; n++)
    e = e > t[n].y ? t[n].y : e, r = r < t[n].y ? t[n].y : r;
  return {
    min: e,
    max: r,
    yAxisOrientation: this.options.yAxisOrientation
  };
};
function Ki(t, e, r, n) {
  this.body = t, this.defaultOptions = {
    enabled: !1,
    icons: !0,
    iconSize: 20,
    iconSpacing: 6,
    left: {
      visible: !0,
      position: "top-left"
      // top/bottom - left,center,right
    },
    right: {
      visible: !0,
      position: "top-right"
      // top/bottom - left,center,right
    }
  }, this.side = r, this.options = G.extend({}, this.defaultOptions), this.linegraphOptions = n, this.svgElements = {}, this.dom = {}, this.groups = {}, this.amountOfGroups = 0, this._create(), this.framework = {
    svg: this.svg,
    svgElements: this.svgElements,
    options: this.options,
    groups: this.groups
  }, this.setOptions(e);
}
Ki.prototype = new Fl();
Ki.prototype.clear = function() {
  this.groups = {}, this.amountOfGroups = 0;
};
Ki.prototype.addGroup = function(t, e) {
  e.options.excludeFromLegend != !0 && (this.groups.hasOwnProperty(t) || (this.groups[t] = e), this.amountOfGroups += 1);
};
Ki.prototype.updateGroup = function(t, e) {
  this.groups[t] = e;
};
Ki.prototype.removeGroup = function(t) {
  this.groups.hasOwnProperty(t) && (delete this.groups[t], this.amountOfGroups -= 1);
};
Ki.prototype._create = function() {
  this.dom.frame = document.createElement("div"), this.dom.frame.className = "vis-legend", this.dom.frame.style.position = "absolute", this.dom.frame.style.top = "10px", this.dom.frame.style.display = "block", this.dom.textArea = document.createElement("div"), this.dom.textArea.className = "vis-legend-text", this.dom.textArea.style.position = "relative", this.dom.textArea.style.top = "0px", this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.svg.style.position = "absolute", this.svg.style.top = "0px", this.svg.style.width = this.options.iconSize + 5 + "px", this.svg.style.height = "100%", this.dom.frame.appendChild(this.svg), this.dom.frame.appendChild(this.dom.textArea);
};
Ki.prototype.hide = function() {
  this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame);
};
Ki.prototype.show = function() {
  this.dom.frame.parentNode || this.body.dom.center.appendChild(this.dom.frame);
};
Ki.prototype.setOptions = function(t) {
  var e = ["enabled", "orientation", "icons", "left", "right"];
  G.selectiveDeepExtend(e, this.options, t);
};
Ki.prototype.redraw = function() {
  var t = 0, e = xn(this.groups);
  wn(e).call(e, function(o, l) {
    return o < l ? -1 : 1;
  });
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    this.groups[n].visible == !0 && (this.linegraphOptions.visibility[n] === void 0 || this.linegraphOptions.visibility[n] == !0) && t++;
  }
  if (this.options[this.side].visible == !1 || this.amountOfGroups == 0 || this.options.enabled == !1 || t == 0)
    this.hide();
  else {
    if (this.show(), this.options[this.side].position == "top-left" || this.options[this.side].position == "bottom-left" ? (this.dom.frame.style.left = "4px", this.dom.frame.style.textAlign = "left", this.dom.textArea.style.textAlign = "left", this.dom.textArea.style.left = this.options.iconSize + 15 + "px", this.dom.textArea.style.right = "", this.svg.style.left = "0px", this.svg.style.right = "") : (this.dom.frame.style.right = "4px", this.dom.frame.style.textAlign = "right", this.dom.textArea.style.textAlign = "right", this.dom.textArea.style.right = this.options.iconSize + 15 + "px", this.dom.textArea.style.left = "", this.svg.style.right = "0px", this.svg.style.left = ""), this.options[this.side].position == "top-left" || this.options[this.side].position == "top-right")
      this.dom.frame.style.top = 4 - Number(this.body.dom.center.style.top.replace("px", "")) + "px", this.dom.frame.style.bottom = "";
    else {
      var s = this.body.domProps.center.height - this.body.domProps.centerContainer.height;
      this.dom.frame.style.bottom = 4 + s + Number(this.body.dom.center.style.top.replace("px", "")) + "px", this.dom.frame.style.top = "";
    }
    this.options.icons == !1 ? (this.dom.frame.style.width = this.dom.textArea.offsetWidth + 10 + "px", this.dom.textArea.style.right = "", this.dom.textArea.style.left = "", this.svg.style.width = "0px") : (this.dom.frame.style.width = this.options.iconSize + 15 + this.dom.textArea.offsetWidth + 10 + "px", this.drawLegendIcons());
    var a = "";
    for (r = 0; r < e.length; r++)
      n = e[r], this.groups[n].visible == !0 && (this.linegraphOptions.visibility[n] === void 0 || this.linegraphOptions.visibility[n] == !0) && (a += this.groups[n].content + "<br />");
    this.dom.textArea.innerHTML = G.xss(a), this.dom.textArea.style.lineHeight = 0.75 * this.options.iconSize + this.options.iconSpacing + "px";
  }
};
Ki.prototype.drawLegendIcons = function() {
  if (this.dom.frame.parentNode) {
    var t = xn(this.groups);
    wn(t).call(t, function(c, d) {
      return c < d ? -1 : 1;
    }), Dze(this.svgElements);
    var e = window.getComputedStyle(this.dom.frame).paddingTop, r = Number(e.replace("px", "")), n = r, s = this.options.iconSize, a = 0.75 * this.options.iconSize, o = r + 0.5 * a + 3;
    this.svg.style.width = s + 5 + r + "px";
    for (var l = 0; l < t.length; l++) {
      var u = t[l];
      this.groups[u].visible == !0 && (this.linegraphOptions.visibility[u] === void 0 || this.linegraphOptions.visibility[u] == !0) && (this.groups[u].getLegend(s, a, this.framework, n, o), o += a + this.options.iconSpacing);
    }
  }
};
var i0 = "__ungrouped__";
function fr(t, e) {
  this.id = Dd(), this.body = t, this.defaultOptions = {
    yAxisOrientation: "left",
    defaultGroup: "default",
    sort: !0,
    sampling: !0,
    stack: !1,
    graphHeight: "400px",
    shaded: {
      enabled: !1,
      orientation: "bottom"
      // top, bottom, zero
    },
    style: "line",
    // line, bar
    barChart: {
      width: 50,
      sideBySide: !1,
      align: "center"
      // left, center, right
    },
    interpolation: {
      enabled: !0,
      parametrization: "centripetal",
      // uniform (alpha = 0.0), chordal (alpha = 1.0), centripetal (alpha = 0.5)
      alpha: 0.5
    },
    drawPoints: {
      enabled: !0,
      size: 6,
      style: "square"
      // square, circle
    },
    dataAxis: {},
    //Defaults are done on DataAxis level
    legend: {},
    //Defaults are done on Legend level
    groups: {
      visibility: {}
    }
  }, this.options = G.extend({}, this.defaultOptions), this.dom = {}, this.props = {}, this.hammer = null, this.groups = {}, this.abortedGraphUpdate = !1, this.updateSVGheight = !1, this.updateSVGheightOnResize = !1, this.forceGraphUpdate = !0;
  var r = this;
  this.itemsData = null, this.groupsData = null, this.itemListeners = {
    add: function(s, a, o) {
      r._onAdd(a.items);
    },
    update: function(s, a, o) {
      r._onUpdate(a.items);
    },
    remove: function(s, a, o) {
      r._onRemove(a.items);
    }
  }, this.groupListeners = {
    add: function(s, a, o) {
      r._onAddGroups(a.items);
    },
    update: function(s, a, o) {
      r._onUpdateGroups(a.items);
    },
    remove: function(s, a, o) {
      r._onRemoveGroups(a.items);
    }
  }, this.items = {}, this.selection = [], this.lastStart = this.body.range.start, this.touchParams = {}, this.svgElements = {}, this.setOptions(e), this.groupsUsingDefaultStyles = [0], this.body.emitter.on("rangechanged", function() {
    r.svg.style.left = G.option.asSize(-r.props.width), r.forceGraphUpdate = !0, r.redraw.call(r);
  }), this._create(), this.framework = {
    svg: this.svg,
    svgElements: this.svgElements,
    options: this.options,
    groups: this.groups
  };
}
fr.prototype = new Fl();
fr.prototype._create = function() {
  var t = document.createElement("div");
  t.className = "vis-line-graph", this.dom.frame = t, this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.svg.style.position = "relative", this.svg.style.height = ("" + this.options.graphHeight).replace("px", "") + "px", this.svg.style.display = "block", t.appendChild(this.svg), this.options.dataAxis.orientation = "left", this.yAxisLeft = new eB(this.body, this.options.dataAxis, this.svg, this.options.groups), this.options.dataAxis.orientation = "right", this.yAxisRight = new eB(this.body, this.options.dataAxis, this.svg, this.options.groups), delete this.options.dataAxis.orientation, this.legendLeft = new Ki(this.body, this.options.legend, "left", this.options.groups), this.legendRight = new Ki(this.body, this.options.legend, "right", this.options.groups), this.show();
};
fr.prototype.setOptions = function(t) {
  if (t) {
    var e = ["sampling", "defaultGroup", "stack", "height", "graphHeight", "yAxisOrientation", "style", "barChart", "dataAxis", "sort", "groups"];
    t.graphHeight === void 0 && t.height !== void 0 ? (this.updateSVGheight = !0, this.updateSVGheightOnResize = !0) : this.body.domProps.centerContainer.height !== void 0 && t.graphHeight !== void 0 && Ui((t.graphHeight + "").replace("px", "")) < this.body.domProps.centerContainer.height && (this.updateSVGheight = !0), G.selectiveDeepExtend(e, this.options, t), G.mergeOptions(this.options, t, "interpolation"), G.mergeOptions(this.options, t, "drawPoints"), G.mergeOptions(this.options, t, "shaded"), G.mergeOptions(this.options, t, "legend"), t.interpolation && mt(t.interpolation) == "object" && t.interpolation.parametrization && (t.interpolation.parametrization == "uniform" ? this.options.interpolation.alpha = 0 : t.interpolation.parametrization == "chordal" ? this.options.interpolation.alpha = 1 : (this.options.interpolation.parametrization = "centripetal", this.options.interpolation.alpha = 0.5)), this.yAxisLeft && t.dataAxis !== void 0 && (this.yAxisLeft.setOptions(this.options.dataAxis), this.yAxisRight.setOptions(this.options.dataAxis)), this.legendLeft && t.legend !== void 0 && (this.legendLeft.setOptions(this.options.legend), this.legendRight.setOptions(this.options.legend)), this.groups.hasOwnProperty(i0) && this.groups[i0].setOptions(t);
  }
  this.dom.frame && (this.forceGraphUpdate = !0, this.body.emitter.emit("_change", {
    queue: !0
  }));
};
fr.prototype.hide = function() {
  this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame);
};
fr.prototype.show = function() {
  this.dom.frame.parentNode || this.body.dom.center.appendChild(this.dom.frame);
};
fr.prototype.setItems = function(t) {
  var e = this, r, n = this.itemsData;
  if (!t)
    this.itemsData = null;
  else if (Oo(t))
    this.itemsData = qd(t);
  else
    throw new TypeError("Data must implement the interface of DataSet or DataView");
  if (n && (Le(G).call(G, this.itemListeners, function(a, o) {
    n.off(o, a);
  }), n.dispose(), r = n.getIds(), this._onRemove(r)), this.itemsData) {
    var s = this.id;
    Le(G).call(G, this.itemListeners, function(a, o) {
      e.itemsData.on(o, a, s);
    }), r = this.itemsData.getIds(), this._onAdd(r);
  }
};
fr.prototype.setGroups = function(t) {
  var e = this, r;
  if (this.groupsData) {
    Le(G).call(G, this.groupListeners, function(a, o) {
      e.groupsData.off(o, a);
    }), r = this.groupsData.getIds(), this.groupsData = null;
    for (var n = 0; n < r.length; n++)
      this._removeGroup(r[n]);
  }
  if (!t)
    this.groupsData = null;
  else if (Oo(t))
    this.groupsData = t;
  else
    throw new TypeError("Data must implement the interface of DataSet or DataView");
  if (this.groupsData) {
    var s = this.id;
    Le(G).call(G, this.groupListeners, function(a, o) {
      e.groupsData.on(o, a, s);
    }), r = this.groupsData.getIds(), this._onAddGroups(r);
  }
};
fr.prototype._onUpdate = function(t) {
  this._updateAllGroupData(t);
};
fr.prototype._onAdd = function(t) {
  this._onUpdate(t);
};
fr.prototype._onRemove = function(t) {
  this._onUpdate(t);
};
fr.prototype._onUpdateGroups = function(t) {
  this._updateAllGroupData(null, t);
};
fr.prototype._onAddGroups = function(t) {
  this._onUpdateGroups(t);
};
fr.prototype._onRemoveGroups = function(t) {
  for (var e = 0; e < t.length; e++)
    this._removeGroup(t[e]);
  this.forceGraphUpdate = !0, this.body.emitter.emit("_change", {
    queue: !0
  });
};
fr.prototype._removeGroup = function(t) {
  this.groups.hasOwnProperty(t) && (this.groups[t].options.yAxisOrientation == "right" ? (this.yAxisRight.removeGroup(t), this.legendRight.removeGroup(t), this.legendRight.redraw()) : (this.yAxisLeft.removeGroup(t), this.legendLeft.removeGroup(t), this.legendLeft.redraw()), delete this.groups[t]);
};
fr.prototype._updateGroup = function(t, e) {
  this.groups.hasOwnProperty(e) ? (this.groups[e].update(t), this.groups[e].options.yAxisOrientation == "right" ? (this.yAxisRight.updateGroup(e, this.groups[e]), this.legendRight.updateGroup(e, this.groups[e]), this.yAxisLeft.removeGroup(e), this.legendLeft.removeGroup(e)) : (this.yAxisLeft.updateGroup(e, this.groups[e]), this.legendLeft.updateGroup(e, this.groups[e]), this.yAxisRight.removeGroup(e), this.legendRight.removeGroup(e))) : (this.groups[e] = new Bl(t, e, this.options, this.groupsUsingDefaultStyles), this.groups[e].options.yAxisOrientation == "right" ? (this.yAxisRight.addGroup(e, this.groups[e]), this.legendRight.addGroup(e, this.groups[e])) : (this.yAxisLeft.addGroup(e, this.groups[e]), this.legendLeft.addGroup(e, this.groups[e]))), this.legendLeft.redraw(), this.legendRight.redraw();
};
fr.prototype._updateAllGroupData = function(t, e) {
  if (this.itemsData != null) {
    var r = {}, n = this.itemsData.get(), s = this.itemsData.idProp, a = {};
    t && ln(t).call(t, function(y) {
      a[y] = y;
    });
    for (var o = {}, l = 0; l < n.length; l++) {
      var u = n[l], c = u.group;
      c == null && (c = i0), o.hasOwnProperty(c) ? o[c]++ : o[c] = 1;
    }
    var d = {};
    if (!e && t) {
      for (c in this.groups)
        if (this.groups.hasOwnProperty(c)) {
          b = this.groups[c];
          var h = b.getItems();
          r[c] = At(h).call(h, function(y) {
            return d[y[s]] = y[s], y[s] !== a[y[s]];
          });
          var f = o[c];
          o[c] -= r[c].length, r[c].length < f && (r[c][f - 1] = {});
        }
    }
    for (l = 0; l < n.length; l++)
      if (u = n[l], c = u.group, c == null && (c = i0), !(!e && t && u[s] !== a[u[s]] && d.hasOwnProperty(u[s]))) {
        r.hasOwnProperty(c) || (r[c] = new Array(o[c]));
        var p = G.bridgeObject(u);
        p.x = G.convert(u.x, "Date"), p.end = G.convert(u.end, "Date"), p.orginalY = u.y, p.y = Number(u.y), p[s] = u[s];
        var m = r[c].length - o[c]--;
        r[c][m] = p;
      }
    for (c in this.groups)
      this.groups.hasOwnProperty(c) && (r.hasOwnProperty(c) || (r[c] = new Array(0)));
    for (c in r)
      if (r.hasOwnProperty(c))
        if (r[c].length == 0)
          this.groups.hasOwnProperty(c) && this._removeGroup(c);
        else {
          var b = void 0;
          this.groupsData != null && (b = this.groupsData.get(c)), b == null && (b = {
            id: c,
            content: this.options.defaultGroup + c
          }), this._updateGroup(b, c), this.groups[c].setItems(r[c]);
        }
    this.forceGraphUpdate = !0, this.body.emitter.emit("_change", {
      queue: !0
    });
  }
};
fr.prototype.redraw = function() {
  var t = !1;
  this.props.width = this.dom.frame.offsetWidth, this.props.height = this.body.domProps.centerContainer.height - this.body.domProps.border.top - this.body.domProps.border.bottom, t = this._isResized() || t;
  var e = this.body.range.end - this.body.range.start, r = e != this.lastVisibleInterval;
  if (this.lastVisibleInterval = e, t == !0) {
    var n;
    this.svg.style.width = G.option.asSize(3 * this.props.width), this.svg.style.left = G.option.asSize(-this.props.width), (lr(n = this.options.height + "").call(n, "%") != -1 || this.updateSVGheightOnResize == !0) && (this.updateSVGheight = !0);
  }
  if (this.updateSVGheight == !0 ? (this.options.graphHeight != this.props.height + "px" && (this.options.graphHeight = this.props.height + "px", this.svg.style.height = this.props.height + "px"), this.updateSVGheight = !1) : this.svg.style.height = ("" + this.options.graphHeight).replace("px", "") + "px", t == !0 || r == !0 || this.abortedGraphUpdate == !0 || this.forceGraphUpdate == !0)
    t = this._updateGraph() || t, this.forceGraphUpdate = !1, this.lastStart = this.body.range.start, this.svg.style.left = -this.props.width + "px";
  else if (this.lastStart != 0) {
    var s = this.body.range.start - this.lastStart, a = this.body.range.end - this.body.range.start;
    if (this.props.width != 0) {
      var o = this.props.width / a, l = s * o;
      this.svg.style.left = -this.props.width - l + "px";
    }
  }
  return this.legendLeft.redraw(), this.legendRight.redraw(), t;
};
fr.prototype._getSortedGroupIds = function() {
  var t = [];
  for (var e in this.groups)
    if (this.groups.hasOwnProperty(e)) {
      var r = this.groups[e];
      r.visible == !0 && (this.options.groups.visibility[e] === void 0 || this.options.groups.visibility[e] == !0) && t.push({
        id: e,
        zIndex: r.options.zIndex
      });
    }
  G.insertSort(t, function(a, o) {
    var l = a.zIndex, u = o.zIndex;
    return l === void 0 && (l = 0), u === void 0 && (u = 0), l == u ? 0 : l < u ? -1 : 1;
  });
  for (var n = new Array(t.length), s = 0; s < t.length; s++)
    n[s] = t[s].id;
  return n;
};
fr.prototype._updateGraph = function() {
  if (ll(this.svgElements), this.props.width != 0 && this.itemsData != null) {
    var t, e, r = {}, n = !1, s = this.body.util.toGlobalTime(-this.body.domProps.root.width), a = this.body.util.toGlobalTime(2 * this.body.domProps.root.width), o = this._getSortedGroupIds();
    if (o.length > 0) {
      var l = {};
      for (this._getRelevantData(o, l, s, a), this._applySampling(o, l), e = 0; e < o.length; e++)
        this._convertXcoordinates(l[o[e]]);
      if (this._getYRanges(o, l, r), n = this._updateYAxis(o, r), n == !0)
        return is(this.svgElements), this.abortedGraphUpdate = !0, !0;
      this.abortedGraphUpdate = !1;
      var u = void 0;
      for (e = 0; e < o.length; e++)
        t = this.groups[o[e]], this.options.stack === !0 && this.options.style === "line" && (t.options.excludeFromStacking == null || !t.options.excludeFromStacking) && (u != null && (this._stack(l[t.id], l[u.id]), t.options.shaded.enabled == !0 && t.options.shaded.orientation !== "group" && (t.options.shaded.orientation == "top" && u.options.shaded.orientation !== "group" ? (u.options.shaded.orientation = "group", u.options.shaded.groupId = t.id) : (t.options.shaded.orientation = "group", t.options.shaded.groupId = u.id))), u = t), this._convertYcoordinates(l[o[e]], t);
      var c = {};
      for (e = 0; e < o.length; e++)
        if (t = this.groups[o[e]], t.options.style === "line" && t.options.shaded.enabled == !0) {
          var d = l[o[e]];
          if (d == null || d.length == 0)
            continue;
          if (c.hasOwnProperty(o[e]) || (c[o[e]] = In.calcPath(d, t)), t.options.shaded.orientation === "group") {
            var h = t.options.shaded.groupId;
            if (lr(o).call(o, h) === -1) {
              console.log(t.id + ": Unknown shading group target given:" + h);
              continue;
            }
            c.hasOwnProperty(h) || (c[h] = In.calcPath(l[h], this.groups[h])), In.drawShading(c[o[e]], t, c[h], this.framework);
          } else
            In.drawShading(c[o[e]], t, void 0, this.framework);
        }
      for (ii.draw(o, l, this.framework), e = 0; e < o.length; e++)
        if (t = this.groups[o[e]], l[o[e]].length > 0)
          switch (t.options.style) {
            case "line":
              c.hasOwnProperty(o[e]) || (c[o[e]] = In.calcPath(l[o[e]], t)), In.draw(c[o[e]], t, this.framework);
            case "point":
            case "points":
              (t.options.style == "point" || t.options.style == "points" || t.options.drawPoints.enabled == !0) && Vv.draw(l[o[e]], t, this.framework);
              break;
          }
    }
  }
  return is(this.svgElements), !1;
};
fr.prototype._stack = function(t, e) {
  var r, n, s, a, o;
  r = 0;
  for (var l = 0; l < t.length; l++) {
    a = void 0, o = void 0;
    for (var u = r; u < e.length; u++)
      if (e[u].x === t[l].x) {
        a = e[u], o = e[u], r = u;
        break;
      } else if (e[u].x > t[l].x) {
        o = e[u], u == 0 ? a = o : a = e[u - 1], r = u;
        break;
      }
    o === void 0 && (a = e[e.length - 1], o = e[e.length - 1]), n = o.x - a.x, s = o.y - a.y, n == 0 ? t[l].y = t[l].orginalY + o.y : t[l].y = t[l].orginalY + s / n * (t[l].x - a.x) + a.y;
  }
};
fr.prototype._getRelevantData = function(t, e, r, n) {
  var s, a, o, l;
  if (t.length > 0)
    for (a = 0; a < t.length; a++) {
      s = this.groups[t[a]];
      var u = s.getItems();
      if (wn(s.options) == !0) {
        var c = function(m, b) {
          return m.getTime() == b.getTime() ? 0 : m < b ? -1 : 1;
        }, d = Math.max(0, G.binarySearchValue(u, r, "x", "before", c)), h = Math.min(u.length, G.binarySearchValue(u, n, "x", "after", c) + 1);
        h <= 0 && (h = u.length);
        var f = new Array(h - d);
        for (o = d; o < h; o++)
          l = s.itemsData[o], f[o - d] = l;
        e[t[a]] = f;
      } else
        e[t[a]] = s.itemsData;
    }
};
fr.prototype._applySampling = function(t, e) {
  var r;
  if (t.length > 0) {
    for (var n = 0; n < t.length; n++)
      if (r = this.groups[t[n]], r.options.sampling == !0) {
        var s = e[t[n]];
        if (s.length > 0) {
          var a = 1, o = s.length, l = this.body.util.toGlobalScreen(s[s.length - 1].x) - this.body.util.toGlobalScreen(s[0].x), u = o / l;
          a = Math.min(Math.ceil(0.2 * o), Math.max(1, Math.round(u)));
          for (var c = new Array(o), d = 0; d < o; d += a) {
            var h = Math.round(d / a);
            c[h] = s[d];
          }
          e[t[n]] = xi(c).call(c, 0, Math.round(o / a));
        }
      }
  }
};
fr.prototype._getYRanges = function(t, e, r) {
  var n, s, a, o = [], l = [], u;
  if (t.length > 0) {
    for (a = 0; a < t.length; a++)
      n = e[t[a]], u = this.groups[t[a]].options, n.length > 0 && (s = this.groups[t[a]], u.stack === !0 && u.style === "bar" ? u.yAxisOrientation === "left" ? o = Dr(o).call(o, n) : l = Dr(l).call(l, n) : r[t[a]] = s.getYRange(n, t[a]));
    ii.getStackedYRange(o, r, t, "__barStackLeft", "left"), ii.getStackedYRange(l, r, t, "__barStackRight", "right");
  }
};
fr.prototype._updateYAxis = function(t, e) {
  var r = !1, n = !1, s = !1, a = 1e9, o = 1e9, l = -1e9, u = -1e9, c, d;
  if (t.length > 0) {
    for (var h = 0; h < t.length; h++) {
      var f = this.groups[t[h]];
      f && f.options.yAxisOrientation != "right" ? (n = !0, a = 1e9, l = -1e9) : f && f.options.yAxisOrientation && (s = !0, o = 1e9, u = -1e9);
    }
    for (h = 0; h < t.length; h++)
      e.hasOwnProperty(t[h]) && e[t[h]].ignore !== !0 && (c = e[t[h]].min, d = e[t[h]].max, e[t[h]].yAxisOrientation != "right" ? (n = !0, a = a > c ? c : a, l = l < d ? d : l) : (s = !0, o = o > c ? c : o, u = u < d ? d : u));
    n == !0 && this.yAxisLeft.setRange(a, l), s == !0 && this.yAxisRight.setRange(o, u);
  }
  r = this._toggleAxisVisiblity(n, this.yAxisLeft) || r, r = this._toggleAxisVisiblity(s, this.yAxisRight) || r, s == !0 && n == !0 ? (this.yAxisLeft.drawIcons = !0, this.yAxisRight.drawIcons = !0) : (this.yAxisLeft.drawIcons = !1, this.yAxisRight.drawIcons = !1), this.yAxisRight.master = !n, this.yAxisRight.masterAxis = this.yAxisLeft, this.yAxisRight.master == !1 ? (s == !0 ? this.yAxisLeft.lineOffset = this.yAxisRight.width : this.yAxisLeft.lineOffset = 0, r = this.yAxisLeft.redraw() || r, r = this.yAxisRight.redraw() || r) : r = this.yAxisRight.redraw() || r;
  var p = ["__barStackLeft", "__barStackRight", "__lineStackLeft", "__lineStackRight"];
  for (h = 0; h < p.length; h++)
    lr(t).call(t, p[h]) != -1 && xi(t).call(t, lr(t).call(t, p[h]), 1);
  return r;
};
fr.prototype._toggleAxisVisiblity = function(t, e) {
  var r = !1;
  return t == !1 ? e.dom.frame.parentNode && e.hidden == !1 && (e.hide(), r = !0) : !e.dom.frame.parentNode && e.hidden == !0 && (e.show(), r = !0), r;
};
fr.prototype._convertXcoordinates = function(t) {
  for (var e = this.body.util.toScreen, r = 0; r < t.length; r++)
    t[r].screen_x = e(t[r].x) + this.props.width, t[r].screen_y = t[r].y, t[r].end != null ? t[r].screen_end = e(t[r].end) + this.props.width : t[r].screen_end = void 0;
};
fr.prototype._convertYcoordinates = function(t, e) {
  var r = this.yAxisLeft, n = Number(this.svg.style.height.replace("px", ""));
  e.options.yAxisOrientation == "right" && (r = this.yAxisRight);
  for (var s = 0; s < t.length; s++)
    t[s].screen_y = Math.round(r.convertValue(t[s].y));
  e.setZeroPosition(Math.min(n, r.convertValue(0)));
};
var bt = "string", Mt = "boolean", ir = "number", Lze = "array", jc = "date", $r = "object", Nze = "dom", Kc = "moment", tB = "any", Fze = {
  configure: {
    enabled: {
      boolean: Mt
    },
    filter: {
      boolean: Mt,
      function: "function"
    },
    container: {
      dom: Nze
    },
    __type__: {
      object: $r,
      boolean: Mt,
      function: "function"
    }
  },
  //globals :
  alignCurrentTime: {
    string: bt,
    undefined: "undefined"
  },
  yAxisOrientation: {
    string: ["left", "right"]
  },
  defaultGroup: {
    string: bt
  },
  sort: {
    boolean: Mt
  },
  sampling: {
    boolean: Mt
  },
  stack: {
    boolean: Mt
  },
  graphHeight: {
    string: bt,
    number: ir
  },
  shaded: {
    enabled: {
      boolean: Mt
    },
    orientation: {
      string: ["bottom", "top", "zero", "group"]
    },
    // top, bottom, zero, group
    groupId: {
      object: $r
    },
    __type__: {
      boolean: Mt,
      object: $r
    }
  },
  style: {
    string: ["line", "bar", "points"]
  },
  // line, bar
  barChart: {
    width: {
      number: ir
    },
    minWidth: {
      number: ir
    },
    sideBySide: {
      boolean: Mt
    },
    align: {
      string: ["left", "center", "right"]
    },
    __type__: {
      object: $r
    }
  },
  interpolation: {
    enabled: {
      boolean: Mt
    },
    parametrization: {
      string: ["centripetal", "chordal", "uniform"]
    },
    // uniform (alpha = 0.0), chordal (alpha = 1.0), centripetal (alpha = 0.5)
    alpha: {
      number: ir
    },
    __type__: {
      object: $r,
      boolean: Mt
    }
  },
  drawPoints: {
    enabled: {
      boolean: Mt
    },
    onRender: {
      function: "function"
    },
    size: {
      number: ir
    },
    style: {
      string: ["square", "circle"]
    },
    // square, circle
    __type__: {
      object: $r,
      boolean: Mt,
      function: "function"
    }
  },
  dataAxis: {
    showMinorLabels: {
      boolean: Mt
    },
    showMajorLabels: {
      boolean: Mt
    },
    showWeekScale: {
      boolean: Mt
    },
    icons: {
      boolean: Mt
    },
    width: {
      string: bt,
      number: ir
    },
    visible: {
      boolean: Mt
    },
    alignZeros: {
      boolean: Mt
    },
    left: {
      range: {
        min: {
          number: ir,
          undefined: "undefined"
        },
        max: {
          number: ir,
          undefined: "undefined"
        },
        __type__: {
          object: $r
        }
      },
      format: {
        function: "function"
      },
      title: {
        text: {
          string: bt,
          number: ir,
          undefined: "undefined"
        },
        style: {
          string: bt,
          undefined: "undefined"
        },
        __type__: {
          object: $r
        }
      },
      __type__: {
        object: $r
      }
    },
    right: {
      range: {
        min: {
          number: ir,
          undefined: "undefined"
        },
        max: {
          number: ir,
          undefined: "undefined"
        },
        __type__: {
          object: $r
        }
      },
      format: {
        function: "function"
      },
      title: {
        text: {
          string: bt,
          number: ir,
          undefined: "undefined"
        },
        style: {
          string: bt,
          undefined: "undefined"
        },
        __type__: {
          object: $r
        }
      },
      __type__: {
        object: $r
      }
    },
    __type__: {
      object: $r
    }
  },
  legend: {
    enabled: {
      boolean: Mt
    },
    icons: {
      boolean: Mt
    },
    left: {
      visible: {
        boolean: Mt
      },
      position: {
        string: ["top-right", "bottom-right", "top-left", "bottom-left"]
      },
      __type__: {
        object: $r
      }
    },
    right: {
      visible: {
        boolean: Mt
      },
      position: {
        string: ["top-right", "bottom-right", "top-left", "bottom-left"]
      },
      __type__: {
        object: $r
      }
    },
    __type__: {
      object: $r,
      boolean: Mt
    }
  },
  groups: {
    visibility: {
      any: tB
    },
    __type__: {
      object: $r
    }
  },
  autoResize: {
    boolean: Mt
  },
  throttleRedraw: {
    number: ir
  },
  // TODO: DEPRICATED see https://github.com/almende/vis/issues/2511
  clickToUse: {
    boolean: Mt
  },
  end: {
    number: ir,
    date: jc,
    string: bt,
    moment: Kc
  },
  format: {
    minorLabels: {
      millisecond: {
        string: bt,
        undefined: "undefined"
      },
      second: {
        string: bt,
        undefined: "undefined"
      },
      minute: {
        string: bt,
        undefined: "undefined"
      },
      hour: {
        string: bt,
        undefined: "undefined"
      },
      weekday: {
        string: bt,
        undefined: "undefined"
      },
      day: {
        string: bt,
        undefined: "undefined"
      },
      week: {
        string: bt,
        undefined: "undefined"
      },
      month: {
        string: bt,
        undefined: "undefined"
      },
      quarter: {
        string: bt,
        undefined: "undefined"
      },
      year: {
        string: bt,
        undefined: "undefined"
      },
      __type__: {
        object: $r
      }
    },
    majorLabels: {
      millisecond: {
        string: bt,
        undefined: "undefined"
      },
      second: {
        string: bt,
        undefined: "undefined"
      },
      minute: {
        string: bt,
        undefined: "undefined"
      },
      hour: {
        string: bt,
        undefined: "undefined"
      },
      weekday: {
        string: bt,
        undefined: "undefined"
      },
      day: {
        string: bt,
        undefined: "undefined"
      },
      week: {
        string: bt,
        undefined: "undefined"
      },
      month: {
        string: bt,
        undefined: "undefined"
      },
      quarter: {
        string: bt,
        undefined: "undefined"
      },
      year: {
        string: bt,
        undefined: "undefined"
      },
      __type__: {
        object: $r
      }
    },
    __type__: {
      object: $r
    }
  },
  moment: {
    function: "function"
  },
  height: {
    string: bt,
    number: ir
  },
  hiddenDates: {
    start: {
      date: jc,
      number: ir,
      string: bt,
      moment: Kc
    },
    end: {
      date: jc,
      number: ir,
      string: bt,
      moment: Kc
    },
    repeat: {
      string: bt
    },
    __type__: {
      object: $r,
      array: Lze
    }
  },
  locale: {
    string: bt
  },
  locales: {
    __any__: {
      any: tB
    },
    __type__: {
      object: $r
    }
  },
  max: {
    date: jc,
    number: ir,
    string: bt,
    moment: Kc
  },
  maxHeight: {
    number: ir,
    string: bt
  },
  maxMinorChars: {
    number: ir
  },
  min: {
    date: jc,
    number: ir,
    string: bt,
    moment: Kc
  },
  minHeight: {
    number: ir,
    string: bt
  },
  moveable: {
    boolean: Mt
  },
  multiselect: {
    boolean: Mt
  },
  orientation: {
    string: bt
  },
  showCurrentTime: {
    boolean: Mt
  },
  showMajorLabels: {
    boolean: Mt
  },
  showMinorLabels: {
    boolean: Mt
  },
  showWeekScale: {
    boolean: Mt
  },
  snap: {
    function: "function",
    null: "null"
  },
  start: {
    date: jc,
    number: ir,
    string: bt,
    moment: Kc
  },
  timeAxis: {
    scale: {
      string: bt,
      undefined: "undefined"
    },
    step: {
      number: ir,
      undefined: "undefined"
    },
    __type__: {
      object: $r
    }
  },
  width: {
    string: bt,
    number: ir
  },
  zoomable: {
    boolean: Mt
  },
  zoomKey: {
    string: ["ctrlKey", "altKey", "metaKey", ""]
  },
  zoomMax: {
    number: ir
  },
  zoomMin: {
    number: ir
  },
  zIndex: {
    number: ir
  },
  __type__: {
    object: $r
  }
}, Bze = {
  global: {
    alignCurrentTime: ["none", "year", "month", "quarter", "week", "isoWeek", "day", "date", "hour", "minute", "second"],
    //yAxisOrientation: ['left','right'], // TDOO: enable as soon as Grahp2d doesn't crash when changing this on the fly
    sort: !0,
    sampling: !0,
    stack: !1,
    shaded: {
      enabled: !1,
      orientation: ["zero", "top", "bottom", "group"]
      // zero, top, bottom
    },
    style: ["line", "bar", "points"],
    // line, bar
    barChart: {
      width: [50, 5, 100, 5],
      minWidth: [50, 5, 100, 5],
      sideBySide: !1,
      align: ["left", "center", "right"]
      // left, center, right
    },
    interpolation: {
      enabled: !0,
      parametrization: ["centripetal", "chordal", "uniform"]
      // uniform (alpha = 0.0), chordal (alpha = 1.0), centripetal (alpha = 0.5)
    },
    drawPoints: {
      enabled: !0,
      size: [6, 2, 30, 1],
      style: ["square", "circle"]
      // square, circle
    },
    dataAxis: {
      showMinorLabels: !0,
      showMajorLabels: !0,
      showWeekScale: !1,
      icons: !1,
      width: [40, 0, 200, 1],
      visible: !0,
      alignZeros: !0,
      left: {
        //range: {min:'undefined': 'undefined'ined,max:'undefined': 'undefined'ined},
        //format: function (value) {return value;},
        title: {
          text: "",
          style: ""
        }
      },
      right: {
        //range: {min:'undefined': 'undefined'ined,max:'undefined': 'undefined'ined},
        //format: function (value) {return value;},
        title: {
          text: "",
          style: ""
        }
      }
    },
    legend: {
      enabled: !1,
      icons: !0,
      left: {
        visible: !0,
        position: ["top-right", "bottom-right", "top-left", "bottom-left"]
        // top/bottom - left,right
      },
      right: {
        visible: !0,
        position: ["top-right", "bottom-right", "top-left", "bottom-left"]
        // top/bottom - left,right
      }
    },
    autoResize: !0,
    clickToUse: !1,
    end: "",
    format: {
      minorLabels: {
        millisecond: "SSS",
        second: "s",
        minute: "HH:mm",
        hour: "HH:mm",
        weekday: "ddd D",
        day: "D",
        week: "w",
        month: "MMM",
        quarter: "[Q]Q",
        year: "YYYY"
      },
      majorLabels: {
        millisecond: "HH:mm:ss",
        second: "D MMMM HH:mm",
        minute: "ddd D MMMM",
        hour: "ddd D MMMM",
        weekday: "MMMM YYYY",
        day: "MMMM YYYY",
        week: "MMMM YYYY",
        month: "YYYY",
        quarter: "YYYY",
        year: ""
      }
    },
    height: "",
    locale: "",
    max: "",
    maxHeight: "",
    maxMinorChars: [7, 0, 20, 1],
    min: "",
    minHeight: "",
    moveable: !0,
    orientation: ["both", "bottom", "top"],
    showCurrentTime: !1,
    showMajorLabels: !0,
    showMinorLabels: !0,
    showWeekScale: !1,
    start: "",
    width: "100%",
    zoomable: !0,
    zoomKey: ["ctrlKey", "altKey", "metaKey", ""],
    zoomMax: [31536e10, 10, 31536e10, 1],
    zoomMin: [10, 10, 31536e10, 1],
    zIndex: 0
  }
};
function Yo(t, e, r, n) {
  var s, a, o, l, u, c, d;
  if (!($t(r) || Oo(r)) && r instanceof Object) {
    var h = n;
    n = r, r = h;
  }
  n && n.throttleRedraw && console.warn('Graph2d option "throttleRedraw" is DEPRICATED and no longer supported. It will be removed in the next MAJOR release.');
  var f = this;
  this.defaultOptions = {
    start: null,
    end: null,
    autoResize: !0,
    orientation: {
      axis: "bottom",
      // axis orientation: 'bottom', 'top', or 'both'
      item: "bottom"
      // not relevant for Graph2d
    },
    moment: Ti,
    width: null,
    height: null,
    maxHeight: null,
    minHeight: null
  }, this.options = G.deepExtend({}, this.defaultOptions), this._create(t), this.components = [], this.body = {
    dom: this.dom,
    domProps: this.props,
    emitter: {
      on: de(s = this.on).call(s, this),
      off: de(a = this.off).call(a, this),
      emit: de(o = this.emit).call(o, this)
    },
    hiddenDates: [],
    util: {
      getScale: function() {
        return f.timeAxis.step.scale;
      },
      getStep: function() {
        return f.timeAxis.step.step;
      },
      toScreen: de(l = f._toScreen).call(l, f),
      toGlobalScreen: de(u = f._toGlobalScreen).call(u, f),
      // this refers to the root.width
      toTime: de(c = f._toTime).call(c, f),
      toGlobalTime: de(d = f._toGlobalTime).call(d, f)
    }
  }, this.range = new _W(this.body), this.components.push(this.range), this.body.range = this.range, this.timeAxis = new Jy(this.body), this.components.push(this.timeAxis), this.currentTime = new CW(this.body), this.components.push(this.currentTime), this.linegraph = new fr(this.body), this.components.push(this.linegraph), this.itemsData = null, this.groupsData = null, this.on("tap", function(p) {
    f.emit("click", f.getEventProperties(p));
  }), this.on("doubletap", function(p) {
    f.emit("doubleClick", f.getEventProperties(p));
  }), this.dom.root.oncontextmenu = function(p) {
    f.emit("contextmenu", f.getEventProperties(p));
  }, this.initialFitDone = !1, this.on("changed", function() {
    if (f.itemsData != null) {
      if (!f.initialFitDone && !f.options.rollingMode)
        if (f.initialFitDone = !0, f.options.start != null || f.options.end != null) {
          if (f.options.start == null || f.options.end == null)
            var p = f.getItemRange();
          var m = f.options.start != null ? f.options.start : p.min, b = f.options.end != null ? f.options.end : p.max;
          f.setWindow(m, b, {
            animation: !1
          });
        } else
          f.fit({
            animation: !1
          });
      !f.initialDrawDone && (f.initialRangeChangeDone || !f.options.start && !f.options.end || f.options.rollingMode) && (f.initialDrawDone = !0, f.dom.root.style.visibility = "visible", f.dom.loadingScreen.parentNode.removeChild(f.dom.loadingScreen), f.options.onInitialDrawComplete && ai(function() {
        return f.options.onInitialDrawComplete();
      }, 0));
    }
  }), n && this.setOptions(n), r && this.setGroups(r), e && this.setItems(e), this._redraw();
}
Yo.prototype = new Od();
Yo.prototype.setOptions = function(t) {
  var e = VW.validate(t, Fze);
  e === !0 && console.log("%cErrors have been found in the supplied options object.", n0), Od.prototype.setOptions.call(this, t);
};
Yo.prototype.setItems = function(t) {
  var e = this.itemsData == null, r;
  if (t ? Oo(t) ? r = qd(t) : r = qd(new Gu(t)) : r = null, this.itemsData && this.itemsData.dispose(), this.itemsData = r, this.linegraph && this.linegraph.setItems(r != null ? r.rawDS : null), e)
    if (this.options.start != null || this.options.end != null) {
      var n = this.options.start != null ? this.options.start : null, s = this.options.end != null ? this.options.end : null;
      this.setWindow(n, s, {
        animation: !1
      });
    } else
      this.fit({
        animation: !1
      });
};
Yo.prototype.setGroups = function(t) {
  var e;
  t ? Oo(t) ? e = t : e = new Gu(t) : e = null, this.groupsData = e, this.linegraph.setGroups(e);
};
Yo.prototype.getLegend = function(t, e, r) {
  return e === void 0 && (e = 15), r === void 0 && (r = 15), this.linegraph.groups[t] !== void 0 ? this.linegraph.groups[t].getLegend(e, r) : "cannot find group:'" + t + "'";
};
Yo.prototype.isGroupVisible = function(t) {
  return this.linegraph.groups[t] !== void 0 ? this.linegraph.groups[t].visible && (this.linegraph.options.groups.visibility[t] === void 0 || this.linegraph.options.groups.visibility[t] == !0) : !1;
};
Yo.prototype.getDataRange = function() {
  var t = null, e = null;
  for (var r in this.linegraph.groups)
    if (this.linegraph.groups.hasOwnProperty(r) && this.linegraph.groups[r].visible == !0)
      for (var n = 0; n < this.linegraph.groups[r].itemsData.length; n++) {
        var s = this.linegraph.groups[r].itemsData[n], a = G.convert(s.x, "Date").valueOf();
        t = t == null || t > a ? a : t, e = e == null || e < a ? a : e;
      }
  return {
    min: t != null ? new Date(t) : null,
    max: e != null ? new Date(e) : null
  };
};
Yo.prototype.getEventProperties = function(t) {
  var e = t.center ? t.center.x : t.clientX, r = t.center ? t.center.y : t.clientY, n = e - G.getAbsoluteLeft(this.dom.centerContainer), s = r - G.getAbsoluteTop(this.dom.centerContainer), a = this._toTime(n), o = hA.customTimeFromTarget(t), l = G.getTarget(t), u = null;
  G.hasParent(l, this.timeAxis.dom.foreground) || this.timeAxis2 && G.hasParent(l, this.timeAxis2.dom.foreground) ? u = "axis" : G.hasParent(l, this.linegraph.yAxisLeft.dom.frame) || G.hasParent(l, this.linegraph.yAxisRight.dom.frame) ? u = "data-axis" : G.hasParent(l, this.linegraph.legendLeft.dom.frame) || G.hasParent(l, this.linegraph.legendRight.dom.frame) ? u = "legend" : o != null ? u = "custom-time" : G.hasParent(l, this.currentTime.bar) ? u = "current-time" : G.hasParent(l, this.dom.center) && (u = "background");
  var c = [], d = this.linegraph.yAxisLeft, h = this.linegraph.yAxisRight;
  return !d.hidden && this.itemsData.length > 0 && c.push(d.screenToValue(s)), !h.hidden && this.itemsData.length > 0 && c.push(h.screenToValue(s)), {
    event: t,
    customTime: o ? o.options.id : null,
    what: u,
    pageX: t.srcEvent ? t.srcEvent.pageX : t.pageX,
    pageY: t.srcEvent ? t.srcEvent.pageY : t.pageY,
    x: n,
    y: s,
    time: a,
    value: c
  };
};
Yo.prototype._createConfigurator = function() {
  return new YW(this, this.dom.container, Bze);
};
var Uze = Oze();
we.locale(Uze);
function vs(t) {
  "@babel/helpers - typeof";
  return vs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, vs(t);
}
function st(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function He(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function Ke(t) {
  He(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || vs(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function no(t, e) {
  He(2, arguments);
  var r = Ke(t), n = st(e);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && r.setDate(r.getDate() + n), r);
}
function ka(t, e) {
  He(2, arguments);
  var r = Ke(t), n = st(e);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return r;
  var s = r.getDate(), a = new Date(r.getTime());
  a.setMonth(r.getMonth() + n + 1, 0);
  var o = a.getDate();
  return s >= o ? a : (r.setFullYear(a.getFullYear(), a.getMonth(), s), r);
}
function HW(t, e) {
  if (He(2, arguments), !e || vs(e) !== "object")
    return /* @__PURE__ */ new Date(NaN);
  var r = e.years ? st(e.years) : 0, n = e.months ? st(e.months) : 0, s = e.weeks ? st(e.weeks) : 0, a = e.days ? st(e.days) : 0, o = e.hours ? st(e.hours) : 0, l = e.minutes ? st(e.minutes) : 0, u = e.seconds ? st(e.seconds) : 0, c = Ke(t), d = n || r ? ka(c, n + r * 12) : c, h = a || s ? no(d, a + s * 7) : d, f = l + o * 60, p = u + f * 60, m = p * 1e3, b = new Date(h.getTime() + m);
  return b;
}
function Vze(t, e) {
  He(2, arguments);
  var r = Ke(t).getTime(), n = st(e);
  return new Date(r + n);
}
var Yze = {};
function Va() {
  return Yze;
}
function Qu(t, e) {
  var r, n, s, a, o, l, u, c;
  He(1, arguments);
  var d = Va(), h = st((r = (n = (s = (a = e == null ? void 0 : e.weekStartsOn) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && s !== void 0 ? s : d.weekStartsOn) !== null && n !== void 0 ? n : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Ke(t), p = f.getDay(), m = (p < h ? 7 : 0) + p - h;
  return f.setDate(f.getDate() - m), f.setHours(0, 0, 0, 0), f;
}
function s0(t) {
  return He(1, arguments), Qu(t, {
    weekStartsOn: 1
  });
}
function Hze(t) {
  He(1, arguments);
  var e = Ke(t), r = e.getFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  var s = s0(n), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  var o = s0(a);
  return e.getTime() >= s.getTime() ? r + 1 : e.getTime() >= o.getTime() ? r : r - 1;
}
function Gze(t) {
  He(1, arguments);
  var e = Hze(t), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(e, 0, 4), r.setHours(0, 0, 0, 0);
  var n = s0(r);
  return n;
}
function a0(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
function rB(t) {
  He(1, arguments);
  var e = Ke(t);
  return e.setHours(0, 0, 0, 0), e;
}
var Wze = 864e5;
function jze(t, e) {
  He(2, arguments);
  var r = rB(t), n = rB(e), s = r.getTime() - a0(r), a = n.getTime() - a0(n);
  return Math.round((s - a) / Wze);
}
function gA(t, e) {
  He(2, arguments);
  var r = st(e);
  return ka(t, r * 12);
}
function hT(t, e) {
  He(2, arguments);
  var r = Ke(t), n = Ke(e), s = r.getTime() - n.getTime();
  return s < 0 ? -1 : s > 0 ? 1 : s;
}
var yA = 6e4, bA = 36e5, Kze = 1e3;
function GW(t) {
  return He(1, arguments), t instanceof Date || vs(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Bf(t) {
  if (He(1, arguments), !GW(t) && typeof t != "number")
    return !1;
  var e = Ke(t);
  return !isNaN(Number(e));
}
function zze(t, e) {
  He(2, arguments);
  var r = Ke(t), n = Ke(e), s = r.getFullYear() - n.getFullYear(), a = r.getMonth() - n.getMonth();
  return s * 12 + a;
}
function qze(t) {
  He(1, arguments);
  var e = Ke(t);
  return e.setHours(23, 59, 59, 999), e;
}
function Xze(t) {
  He(1, arguments);
  var e = Ke(t), r = e.getMonth();
  return e.setFullYear(e.getFullYear(), r + 1, 0), e.setHours(23, 59, 59, 999), e;
}
function Qze(t) {
  He(1, arguments);
  var e = Ke(t);
  return qze(e).getTime() === Xze(e).getTime();
}
function Zze(t, e) {
  He(2, arguments);
  var r = Ke(t), n = Ke(e), s = hT(r, n), a = Math.abs(zze(r, n)), o;
  if (a < 1)
    o = 0;
  else {
    r.getMonth() === 1 && r.getDate() > 27 && r.setDate(30), r.setMonth(r.getMonth() - s * a);
    var l = hT(r, n) === -s;
    Qze(Ke(t)) && a === 1 && hT(t, n) === 1 && (l = !1), o = s * (a - Number(l));
  }
  return o === 0 ? 0 : o;
}
function WW(t, e) {
  var r;
  He(1, arguments);
  var n = t || {}, s = Ke(n.start), a = Ke(n.end), o = a.getTime();
  if (!(s.getTime() <= o))
    throw new RangeError("Invalid interval");
  var l = [], u = s;
  u.setHours(0, 0, 0, 0);
  var c = Number((r = e == null ? void 0 : e.step) !== null && r !== void 0 ? r : 1);
  if (c < 1 || isNaN(c))
    throw new RangeError("`options.step` must be a number greater than 1");
  for (; u.getTime() <= o; )
    l.push(Ke(u)), u.setDate(u.getDate() + c), u.setHours(0, 0, 0, 0);
  return l;
}
function Jze(t, e) {
  var r, n, s, a, o, l, u, c;
  He(1, arguments);
  var d = Va(), h = st((r = (n = (s = (a = e == null ? void 0 : e.weekStartsOn) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && s !== void 0 ? s : d.weekStartsOn) !== null && n !== void 0 ? n : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Ke(t), p = f.getDay(), m = (p < h ? -7 : 0) + 6 - (p - h);
  return f.setDate(f.getDate() + m), f.setHours(23, 59, 59, 999), f;
}
function jW(t, e) {
  He(2, arguments);
  var r = st(e);
  return Vze(t, -r);
}
var e9e = 864e5;
function t9e(t) {
  He(1, arguments);
  var e = Ke(t), r = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var n = e.getTime(), s = r - n;
  return Math.floor(s / e9e) + 1;
}
function Zd(t) {
  He(1, arguments);
  var e = 1, r = Ke(t), n = r.getUTCDay(), s = (n < e ? 7 : 0) + n - e;
  return r.setUTCDate(r.getUTCDate() - s), r.setUTCHours(0, 0, 0, 0), r;
}
function KW(t) {
  He(1, arguments);
  var e = Ke(t), r = e.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var s = Zd(n), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(r, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = Zd(a);
  return e.getTime() >= s.getTime() ? r + 1 : e.getTime() >= o.getTime() ? r : r - 1;
}
function r9e(t) {
  He(1, arguments);
  var e = KW(t), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = Zd(r);
  return n;
}
var n9e = 6048e5;
function zW(t) {
  He(1, arguments);
  var e = Ke(t), r = Zd(e).getTime() - r9e(e).getTime();
  return Math.round(r / n9e) + 1;
}
function Zu(t, e) {
  var r, n, s, a, o, l, u, c;
  He(1, arguments);
  var d = Va(), h = st((r = (n = (s = (a = e == null ? void 0 : e.weekStartsOn) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && s !== void 0 ? s : d.weekStartsOn) !== null && n !== void 0 ? n : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Ke(t), p = f.getUTCDay(), m = (p < h ? 7 : 0) + p - h;
  return f.setUTCDate(f.getUTCDate() - m), f.setUTCHours(0, 0, 0, 0), f;
}
function _A(t, e) {
  var r, n, s, a, o, l, u, c;
  He(1, arguments);
  var d = Ke(t), h = d.getUTCFullYear(), f = Va(), p = st((r = (n = (s = (a = e == null ? void 0 : e.firstWeekContainsDate) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && s !== void 0 ? s : f.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = f.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(p >= 1 && p <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(h + 1, 0, p), m.setUTCHours(0, 0, 0, 0);
  var b = Zu(m, e), y = /* @__PURE__ */ new Date(0);
  y.setUTCFullYear(h, 0, p), y.setUTCHours(0, 0, 0, 0);
  var _ = Zu(y, e);
  return d.getTime() >= b.getTime() ? h + 1 : d.getTime() >= _.getTime() ? h : h - 1;
}
function i9e(t, e) {
  var r, n, s, a, o, l, u, c;
  He(1, arguments);
  var d = Va(), h = st((r = (n = (s = (a = e == null ? void 0 : e.firstWeekContainsDate) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && s !== void 0 ? s : d.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), f = _A(t, e), p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(f, 0, h), p.setUTCHours(0, 0, 0, 0);
  var m = Zu(p, e);
  return m;
}
var s9e = 6048e5;
function qW(t, e) {
  He(1, arguments);
  var r = Ke(t), n = Zu(r, e).getTime() - i9e(r, e).getTime();
  return Math.round(n / s9e) + 1;
}
function Qt(t, e) {
  for (var r = t < 0 ? "-" : "", n = Math.abs(t).toString(); n.length < e; )
    n = "0" + n;
  return r + n;
}
var a9e = {
  // Year
  y: function(e, r) {
    var n = e.getUTCFullYear(), s = n > 0 ? n : 1 - n;
    return Qt(r === "yy" ? s % 100 : s, r.length);
  },
  // Month
  M: function(e, r) {
    var n = e.getUTCMonth();
    return r === "M" ? String(n + 1) : Qt(n + 1, 2);
  },
  // Day of the month
  d: function(e, r) {
    return Qt(e.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(e, r) {
    var n = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, r) {
    return Qt(e.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(e, r) {
    return Qt(e.getUTCHours(), r.length);
  },
  // Minute
  m: function(e, r) {
    return Qt(e.getUTCMinutes(), r.length);
  },
  // Second
  s: function(e, r) {
    return Qt(e.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(e, r) {
    var n = r.length, s = e.getUTCMilliseconds(), a = Math.floor(s * Math.pow(10, n - 3));
    return Qt(a, r.length);
  }
};
const el = a9e;
var zc = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, o9e = {
  // Era
  G: function(e, r, n) {
    var s = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(s, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(s, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(s, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, r, n) {
    if (r === "yo") {
      var s = e.getUTCFullYear(), a = s > 0 ? s : 1 - s;
      return n.ordinalNumber(a, {
        unit: "year"
      });
    }
    return el.y(e, r);
  },
  // Local week-numbering year
  Y: function(e, r, n, s) {
    var a = _A(e, s), o = a > 0 ? a : 1 - a;
    if (r === "YY") {
      var l = o % 100;
      return Qt(l, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : Qt(o, r.length);
  },
  // ISO week-numbering year
  R: function(e, r) {
    var n = KW(e);
    return Qt(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, r) {
    var n = e.getUTCFullYear();
    return Qt(n, r.length);
  },
  // Quarter
  Q: function(e, r, n) {
    var s = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(s);
      case "QQ":
        return Qt(s, 2);
      case "Qo":
        return n.ordinalNumber(s, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(s, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, r, n) {
    var s = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(s);
      case "qq":
        return Qt(s, 2);
      case "qo":
        return n.ordinalNumber(s, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(s, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, r, n) {
    var s = e.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return el.M(e, r);
      case "Mo":
        return n.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(s, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, r, n) {
    var s = e.getUTCMonth();
    switch (r) {
      case "L":
        return String(s + 1);
      case "LL":
        return Qt(s + 1, 2);
      case "Lo":
        return n.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(s, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, r, n, s) {
    var a = qW(e, s);
    return r === "wo" ? n.ordinalNumber(a, {
      unit: "week"
    }) : Qt(a, r.length);
  },
  // ISO week of year
  I: function(e, r, n) {
    var s = zW(e);
    return r === "Io" ? n.ordinalNumber(s, {
      unit: "week"
    }) : Qt(s, r.length);
  },
  // Day of the month
  d: function(e, r, n) {
    return r === "do" ? n.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : el.d(e, r);
  },
  // Day of year
  D: function(e, r, n) {
    var s = t9e(e);
    return r === "Do" ? n.ordinalNumber(s, {
      unit: "dayOfYear"
    }) : Qt(s, r.length);
  },
  // Day of week
  E: function(e, r, n) {
    var s = e.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, r, n, s) {
    var a = e.getUTCDay(), o = (a - s.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return Qt(o, 2);
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, r, n, s) {
    var a = e.getUTCDay(), o = (a - s.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return Qt(o, r.length);
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, r, n) {
    var s = e.getUTCDay(), a = s === 0 ? 7 : s;
    switch (r) {
      case "i":
        return String(a);
      case "ii":
        return Qt(a, r.length);
      case "io":
        return n.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, r, n) {
    var s = e.getUTCHours(), a = s / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, r, n) {
    var s = e.getUTCHours(), a;
    switch (s === 12 ? a = zc.noon : s === 0 ? a = zc.midnight : a = s / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, r, n) {
    var s = e.getUTCHours(), a;
    switch (s >= 17 ? a = zc.evening : s >= 12 ? a = zc.afternoon : s >= 4 ? a = zc.morning : a = zc.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, r, n) {
    if (r === "ho") {
      var s = e.getUTCHours() % 12;
      return s === 0 && (s = 12), n.ordinalNumber(s, {
        unit: "hour"
      });
    }
    return el.h(e, r);
  },
  // Hour [0-23]
  H: function(e, r, n) {
    return r === "Ho" ? n.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : el.H(e, r);
  },
  // Hour [0-11]
  K: function(e, r, n) {
    var s = e.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(s, {
      unit: "hour"
    }) : Qt(s, r.length);
  },
  // Hour [1-24]
  k: function(e, r, n) {
    var s = e.getUTCHours();
    return s === 0 && (s = 24), r === "ko" ? n.ordinalNumber(s, {
      unit: "hour"
    }) : Qt(s, r.length);
  },
  // Minute
  m: function(e, r, n) {
    return r === "mo" ? n.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : el.m(e, r);
  },
  // Second
  s: function(e, r, n) {
    return r === "so" ? n.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : el.s(e, r);
  },
  // Fraction of second
  S: function(e, r) {
    return el.S(e, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, r, n, s) {
    var a = s._originalDate || e, o = a.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      case "X":
        return iB(o);
      case "XXXX":
      case "XX":
        return nu(o);
      case "XXXXX":
      case "XXX":
      default:
        return nu(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, r, n, s) {
    var a = s._originalDate || e, o = a.getTimezoneOffset();
    switch (r) {
      case "x":
        return iB(o);
      case "xxxx":
      case "xx":
        return nu(o);
      case "xxxxx":
      case "xxx":
      default:
        return nu(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, r, n, s) {
    var a = s._originalDate || e, o = a.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + nB(o, ":");
      case "OOOO":
      default:
        return "GMT" + nu(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, r, n, s) {
    var a = s._originalDate || e, o = a.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + nB(o, ":");
      case "zzzz":
      default:
        return "GMT" + nu(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, r, n, s) {
    var a = s._originalDate || e, o = Math.floor(a.getTime() / 1e3);
    return Qt(o, r.length);
  },
  // Milliseconds timestamp
  T: function(e, r, n, s) {
    var a = s._originalDate || e, o = a.getTime();
    return Qt(o, r.length);
  }
};
function nB(t, e) {
  var r = t > 0 ? "-" : "+", n = Math.abs(t), s = Math.floor(n / 60), a = n % 60;
  if (a === 0)
    return r + String(s);
  var o = e || "";
  return r + String(s) + o + Qt(a, 2);
}
function iB(t, e) {
  if (t % 60 === 0) {
    var r = t > 0 ? "-" : "+";
    return r + Qt(Math.abs(t) / 60, 2);
  }
  return nu(t, e);
}
function nu(t, e) {
  var r = e || "", n = t > 0 ? "-" : "+", s = Math.abs(t), a = Qt(Math.floor(s / 60), 2), o = Qt(s % 60, 2);
  return n + a + r + o;
}
const l9e = o9e;
var sB = function(e, r) {
  switch (e) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, XW = function(e, r) {
  switch (e) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, u9e = function(e, r) {
  var n = e.match(/(P+)(p+)?/) || [], s = n[1], a = n[2];
  if (!a)
    return sB(e, r);
  var o;
  switch (s) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", sB(s, r)).replace("{{time}}", XW(a, r));
}, c9e = {
  p: XW,
  P: u9e
};
const ik = c9e;
var d9e = ["D", "DD"], h9e = ["YY", "YYYY"];
function QW(t) {
  return d9e.indexOf(t) !== -1;
}
function ZW(t) {
  return h9e.indexOf(t) !== -1;
}
function o0(t, e, r) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var f9e = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, p9e = function(e, r, n) {
  var s, a = f9e[e];
  return typeof a == "string" ? s = a : r === 1 ? s = a.one : s = a.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + s : s + " ago" : s;
};
const v9e = p9e;
function fT(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.width ? String(e.width) : t.defaultWidth, n = t.formats[r] || t.formats[t.defaultWidth];
    return n;
  };
}
var m9e = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, g9e = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, y9e = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, b9e = {
  date: fT({
    formats: m9e,
    defaultWidth: "full"
  }),
  time: fT({
    formats: g9e,
    defaultWidth: "full"
  }),
  dateTime: fT({
    formats: y9e,
    defaultWidth: "full"
  })
};
const _9e = b9e;
var w9e = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, T9e = function(e, r, n, s) {
  return w9e[e];
};
const x9e = T9e;
function af(t) {
  return function(e, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", s;
    if (n === "formatting" && t.formattingValues) {
      var a = t.defaultFormattingWidth || t.defaultWidth, o = r != null && r.width ? String(r.width) : a;
      s = t.formattingValues[o] || t.formattingValues[a];
    } else {
      var l = t.defaultWidth, u = r != null && r.width ? String(r.width) : t.defaultWidth;
      s = t.values[u] || t.values[l];
    }
    var c = t.argumentCallback ? t.argumentCallback(e) : e;
    return s[c];
  };
}
var S9e = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, E9e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, $9e = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, k9e = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, D9e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, O9e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, A9e = function(e, r) {
  var n = Number(e), s = n % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, C9e = {
  ordinalNumber: A9e,
  era: af({
    values: S9e,
    defaultWidth: "wide"
  }),
  quarter: af({
    values: E9e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: af({
    values: $9e,
    defaultWidth: "wide"
  }),
  day: af({
    values: k9e,
    defaultWidth: "wide"
  }),
  dayPeriod: af({
    values: D9e,
    defaultWidth: "wide",
    formattingValues: O9e,
    defaultFormattingWidth: "wide"
  })
};
const I9e = C9e;
function of(t) {
  return function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, s = n && t.matchPatterns[n] || t.matchPatterns[t.defaultMatchWidth], a = e.match(s);
    if (!a)
      return null;
    var o = a[0], l = n && t.parsePatterns[n] || t.parsePatterns[t.defaultParseWidth], u = Array.isArray(l) ? R9e(l, function(h) {
      return h.test(o);
    }) : P9e(l, function(h) {
      return h.test(o);
    }), c;
    c = t.valueCallback ? t.valueCallback(u) : u, c = r.valueCallback ? r.valueCallback(c) : c;
    var d = e.slice(o.length);
    return {
      value: c,
      rest: d
    };
  };
}
function P9e(t, e) {
  for (var r in t)
    if (t.hasOwnProperty(r) && e(t[r]))
      return r;
}
function R9e(t, e) {
  for (var r = 0; r < t.length; r++)
    if (e(t[r]))
      return r;
}
function M9e(t) {
  return function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.match(t.matchPattern);
    if (!n)
      return null;
    var s = n[0], a = e.match(t.parsePattern);
    if (!a)
      return null;
    var o = t.valueCallback ? t.valueCallback(a[0]) : a[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var l = e.slice(s.length);
    return {
      value: o,
      rest: l
    };
  };
}
var L9e = /^(\d+)(th|st|nd|rd)?/i, N9e = /\d+/i, F9e = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, B9e = {
  any: [/^b/i, /^(a|c)/i]
}, U9e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, V9e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Y9e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, H9e = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, G9e = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, W9e = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, j9e = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, K9e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, z9e = {
  ordinalNumber: M9e({
    matchPattern: L9e,
    parsePattern: N9e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: of({
    matchPatterns: F9e,
    defaultMatchWidth: "wide",
    parsePatterns: B9e,
    defaultParseWidth: "any"
  }),
  quarter: of({
    matchPatterns: U9e,
    defaultMatchWidth: "wide",
    parsePatterns: V9e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: of({
    matchPatterns: Y9e,
    defaultMatchWidth: "wide",
    parsePatterns: H9e,
    defaultParseWidth: "any"
  }),
  day: of({
    matchPatterns: G9e,
    defaultMatchWidth: "wide",
    parsePatterns: W9e,
    defaultParseWidth: "any"
  }),
  dayPeriod: of({
    matchPatterns: j9e,
    defaultMatchWidth: "any",
    parsePatterns: K9e,
    defaultParseWidth: "any"
  })
};
const q9e = z9e;
var X9e = {
  code: "en-US",
  formatDistance: v9e,
  formatLong: _9e,
  formatRelative: x9e,
  localize: I9e,
  match: q9e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const JW = X9e;
var Q9e = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Z9e = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, J9e = /^'([^]*?)'?$/, eqe = /''/g, tqe = /[a-zA-Z]/;
function Au(t, e, r) {
  var n, s, a, o, l, u, c, d, h, f, p, m, b, y, _, x, T, k;
  He(2, arguments);
  var E = String(e), F = Va(), R = (n = (s = r == null ? void 0 : r.locale) !== null && s !== void 0 ? s : F.locale) !== null && n !== void 0 ? n : JW, $ = st((a = (o = (l = (u = r == null ? void 0 : r.firstWeekContainsDate) !== null && u !== void 0 ? u : r == null || (c = r.locale) === null || c === void 0 || (d = c.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : F.firstWeekContainsDate) !== null && o !== void 0 ? o : (h = F.locale) === null || h === void 0 || (f = h.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!($ >= 1 && $ <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var O = st((p = (m = (b = (y = r == null ? void 0 : r.weekStartsOn) !== null && y !== void 0 ? y : r == null || (_ = r.locale) === null || _ === void 0 || (x = _.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && b !== void 0 ? b : F.weekStartsOn) !== null && m !== void 0 ? m : (T = F.locale) === null || T === void 0 || (k = T.options) === null || k === void 0 ? void 0 : k.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(O >= 0 && O <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!R.localize)
    throw new RangeError("locale must contain localize property");
  if (!R.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var P = Ke(t);
  if (!Bf(P))
    throw new RangeError("Invalid time value");
  var N = a0(P), I = jW(P, N), B = {
    firstWeekContainsDate: $,
    weekStartsOn: O,
    locale: R,
    _originalDate: P
  }, W = E.match(Z9e).map(function(Q) {
    var te = Q[0];
    if (te === "p" || te === "P") {
      var H = ik[te];
      return H(Q, R.formatLong);
    }
    return Q;
  }).join("").match(Q9e).map(function(Q) {
    if (Q === "''")
      return "'";
    var te = Q[0];
    if (te === "'")
      return rqe(Q);
    var H = l9e[te];
    if (H)
      return !(r != null && r.useAdditionalWeekYearTokens) && ZW(Q) && o0(Q, e, String(t)), !(r != null && r.useAdditionalDayOfYearTokens) && QW(Q) && o0(Q, e, String(t)), H(I, Q, R.localize, B);
    if (te.match(tqe))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + te + "`");
    return Q;
  }).join("");
  return W;
}
function rqe(t) {
  var e = t.match(J9e);
  return e ? e[1].replace(eqe, "'") : t;
}
function nqe(t, e) {
  if (t == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
  return t;
}
function iqe(t) {
  He(1, arguments);
  var e = Ke(t), r = e.getDay();
  return r;
}
function sqe(t) {
  He(1, arguments);
  var e = Ke(t), r = e.getFullYear(), n = e.getMonth(), s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(r, n + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function Da(t) {
  He(1, arguments);
  var e = Ke(t), r = e.getHours();
  return r;
}
var aqe = 6048e5;
function oqe(t) {
  He(1, arguments);
  var e = Ke(t), r = s0(e).getTime() - Gze(e).getTime();
  return Math.round(r / aqe) + 1;
}
function Oa(t) {
  He(1, arguments);
  var e = Ke(t), r = e.getMinutes();
  return r;
}
function Zt(t) {
  He(1, arguments);
  var e = Ke(t), r = e.getMonth();
  return r;
}
function Jd(t) {
  He(1, arguments);
  var e = Ke(t), r = e.getSeconds();
  return r;
}
function lqe(t, e) {
  var r, n, s, a, o, l, u, c;
  He(1, arguments);
  var d = Ke(t), h = d.getFullYear(), f = Va(), p = st((r = (n = (s = (a = e == null ? void 0 : e.firstWeekContainsDate) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && s !== void 0 ? s : f.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = f.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(p >= 1 && p <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = /* @__PURE__ */ new Date(0);
  m.setFullYear(h + 1, 0, p), m.setHours(0, 0, 0, 0);
  var b = Qu(m, e), y = /* @__PURE__ */ new Date(0);
  y.setFullYear(h, 0, p), y.setHours(0, 0, 0, 0);
  var _ = Qu(y, e);
  return d.getTime() >= b.getTime() ? h + 1 : d.getTime() >= _.getTime() ? h : h - 1;
}
function uqe(t, e) {
  var r, n, s, a, o, l, u, c;
  He(1, arguments);
  var d = Va(), h = st((r = (n = (s = (a = e == null ? void 0 : e.firstWeekContainsDate) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && s !== void 0 ? s : d.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), f = lqe(t, e), p = /* @__PURE__ */ new Date(0);
  p.setFullYear(f, 0, h), p.setHours(0, 0, 0, 0);
  var m = Qu(p, e);
  return m;
}
var cqe = 6048e5;
function dqe(t, e) {
  He(1, arguments);
  var r = Ke(t), n = Qu(r, e).getTime() - uqe(r, e).getTime();
  return Math.round(n / cqe) + 1;
}
function Yt(t) {
  return He(1, arguments), Ke(t).getFullYear();
}
function Sp(t, e) {
  He(2, arguments);
  var r = Ke(t), n = Ke(e);
  return r.getTime() > n.getTime();
}
function Ep(t, e) {
  He(2, arguments);
  var r = Ke(t), n = Ke(e);
  return r.getTime() < n.getTime();
}
function pd(t, e) {
  He(2, arguments);
  var r = Ke(t), n = Ke(e);
  return r.getTime() === n.getTime();
}
function aB(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function hqe(t, e) {
  if (t) {
    if (typeof t == "string")
      return aB(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return aB(t, e);
  }
}
function oB(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!r) {
    if (Array.isArray(t) || (r = hqe(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, s = function() {
      };
      return {
        s,
        n: function() {
          return n >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[n++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: s
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return {
    s: function() {
      r = r.call(t);
    },
    n: function() {
      var c = r.next();
      return a = c.done, c;
    },
    e: function(c) {
      o = !0, l = c;
    },
    f: function() {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (o)
          throw l;
      }
    }
  };
}
function Ue(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function sk(t, e) {
  return sk = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, s) {
    return n.__proto__ = s, n;
  }, sk(t, e);
}
function Ft(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && sk(t, e);
}
function l0(t) {
  return l0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, l0(t);
}
function fqe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function pqe(t, e) {
  if (e && (vs(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ue(t);
}
function Bt(t) {
  var e = fqe();
  return function() {
    var n = l0(t), s;
    if (e) {
      var a = l0(this).constructor;
      s = Reflect.construct(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return pqe(this, s);
  };
}
function Ct(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function vqe(t, e) {
  if (vs(t) !== "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (vs(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function ej(t) {
  var e = vqe(t, "string");
  return vs(e) === "symbol" ? e : String(e);
}
function lB(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, ej(n.key), n);
  }
}
function It(t, e, r) {
  return e && lB(t.prototype, e), r && lB(t, r), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function Ne(t, e, r) {
  return e = ej(e), e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
var mqe = 10, tj = /* @__PURE__ */ function() {
  function t() {
    Ct(this, t), Ne(this, "priority", void 0), Ne(this, "subPriority", 0);
  }
  return It(t, [{
    key: "validate",
    value: function(r, n) {
      return !0;
    }
  }]), t;
}(), gqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r(n, s, a, o, l) {
    var u;
    return Ct(this, r), u = e.call(this), u.value = n, u.validateValue = s, u.setValue = a, u.priority = o, l && (u.subPriority = l), u;
  }
  return It(r, [{
    key: "validate",
    value: function(s, a) {
      return this.validateValue(s, this.value, a);
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return this.setValue(s, a, this.value, o);
    }
  }]), r;
}(tj), yqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", mqe), Ne(Ue(n), "subPriority", -1), n;
  }
  return It(r, [{
    key: "set",
    value: function(s, a) {
      if (a.timestampIsSet)
        return s;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate()), o.setHours(s.getUTCHours(), s.getUTCMinutes(), s.getUTCSeconds(), s.getUTCMilliseconds()), o;
    }
  }]), r;
}(tj), Kt = /* @__PURE__ */ function() {
  function t() {
    Ct(this, t), Ne(this, "incompatibleTokens", void 0), Ne(this, "priority", void 0), Ne(this, "subPriority", void 0);
  }
  return It(t, [{
    key: "run",
    value: function(r, n, s, a) {
      var o = this.parse(r, n, s, a);
      return o ? {
        setter: new gqe(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, n, s) {
      return !0;
    }
  }]), t;
}(), bqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 140), Ne(Ue(n), "incompatibleTokens", ["R", "u", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "G":
        case "GG":
        case "GGG":
          return o.era(s, {
            width: "abbreviated"
          }) || o.era(s, {
            width: "narrow"
          });
        case "GGGGG":
          return o.era(s, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return o.era(s, {
            width: "wide"
          }) || o.era(s, {
            width: "abbreviated"
          }) || o.era(s, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return a.era = o, s.setUTCFullYear(o, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt), Qr = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, ma = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Zr(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function Rr(t, e) {
  var r = e.match(t);
  return r ? {
    value: parseInt(r[0], 10),
    rest: e.slice(r[0].length)
  } : null;
}
function ga(t, e) {
  var r = e.match(t);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  var n = r[1] === "+" ? 1 : -1, s = r[2] ? parseInt(r[2], 10) : 0, a = r[3] ? parseInt(r[3], 10) : 0, o = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: n * (s * bA + a * yA + o * Kze),
    rest: e.slice(r[0].length)
  };
}
function rj(t) {
  return Rr(Qr.anyDigitsSigned, t);
}
function Yr(t, e) {
  switch (t) {
    case 1:
      return Rr(Qr.singleDigit, e);
    case 2:
      return Rr(Qr.twoDigits, e);
    case 3:
      return Rr(Qr.threeDigits, e);
    case 4:
      return Rr(Qr.fourDigits, e);
    default:
      return Rr(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function u0(t, e) {
  switch (t) {
    case 1:
      return Rr(Qr.singleDigitSigned, e);
    case 2:
      return Rr(Qr.twoDigitsSigned, e);
    case 3:
      return Rr(Qr.threeDigitsSigned, e);
    case 4:
      return Rr(Qr.fourDigitsSigned, e);
    default:
      return Rr(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function wA(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function nj(t, e) {
  var r = e > 0, n = r ? e : 1 - e, s;
  if (n <= 50)
    s = t || 100;
  else {
    var a = n + 50, o = Math.floor(a / 100) * 100, l = t >= a % 100;
    s = t + o - (l ? 100 : 0);
  }
  return r ? s : 1 - s;
}
function ij(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
var _qe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 130), Ne(Ue(n), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      var l = function(c) {
        return {
          year: c,
          isTwoDigitYear: a === "yy"
        };
      };
      switch (a) {
        case "y":
          return Zr(Yr(4, s), l);
        case "yo":
          return Zr(o.ordinalNumber(s, {
            unit: "year"
          }), l);
        default:
          return Zr(Yr(a.length, s), l);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      var l = s.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var u = nj(o.year, l);
        return s.setUTCFullYear(u, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
      }
      var c = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return s.setUTCFullYear(c, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt), wqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 130), Ne(Ue(n), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      var l = function(c) {
        return {
          year: c,
          isTwoDigitYear: a === "YY"
        };
      };
      switch (a) {
        case "Y":
          return Zr(Yr(4, s), l);
        case "Yo":
          return Zr(o.ordinalNumber(s, {
            unit: "year"
          }), l);
        default:
          return Zr(Yr(a.length, s), l);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(s, a, o, l) {
      var u = _A(s, l);
      if (o.isTwoDigitYear) {
        var c = nj(o.year, u);
        return s.setUTCFullYear(c, 0, l.firstWeekContainsDate), s.setUTCHours(0, 0, 0, 0), Zu(s, l);
      }
      var d = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return s.setUTCFullYear(d, 0, l.firstWeekContainsDate), s.setUTCHours(0, 0, 0, 0), Zu(s, l);
    }
  }]), r;
}(Kt), Tqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 130), Ne(Ue(n), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a) {
      return u0(a === "R" ? 4 : a.length, s);
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      var l = /* @__PURE__ */ new Date(0);
      return l.setUTCFullYear(o, 0, 4), l.setUTCHours(0, 0, 0, 0), Zd(l);
    }
  }]), r;
}(Kt), xqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 130), Ne(Ue(n), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a) {
      return u0(a === "u" ? 4 : a.length, s);
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCFullYear(o, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt), Sqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 120), Ne(Ue(n), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "Q":
        case "QQ":
          return Yr(a.length, s);
        case "Qo":
          return o.ordinalNumber(s, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(s, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCMonth((o - 1) * 3, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt), Eqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 120), Ne(Ue(n), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "q":
        case "qq":
          return Yr(a.length, s);
        case "qo":
          return o.ordinalNumber(s, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(s, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(s, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(s, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCMonth((o - 1) * 3, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt), $qe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), Ne(Ue(n), "priority", 110), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      var l = function(c) {
        return c - 1;
      };
      switch (a) {
        case "M":
          return Zr(Rr(Qr.month, s), l);
        case "MM":
          return Zr(Yr(2, s), l);
        case "Mo":
          return Zr(o.ordinalNumber(s, {
            unit: "month"
          }), l);
        case "MMM":
          return o.month(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(s, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(s, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(s, {
            width: "wide",
            context: "formatting"
          }) || o.month(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCMonth(o, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt), kqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 110), Ne(Ue(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      var l = function(c) {
        return c - 1;
      };
      switch (a) {
        case "L":
          return Zr(Rr(Qr.month, s), l);
        case "LL":
          return Zr(Yr(2, s), l);
        case "Lo":
          return Zr(o.ordinalNumber(s, {
            unit: "month"
          }), l);
        case "LLL":
          return o.month(s, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(s, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(s, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(s, {
            width: "wide",
            context: "standalone"
          }) || o.month(s, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCMonth(o, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt);
function Dqe(t, e, r) {
  He(2, arguments);
  var n = Ke(t), s = st(e), a = qW(n, r) - s;
  return n.setUTCDate(n.getUTCDate() - a * 7), n;
}
var Oqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 100), Ne(Ue(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "w":
          return Rr(Qr.week, s);
        case "wo":
          return o.ordinalNumber(s, {
            unit: "week"
          });
        default:
          return Yr(a.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(s, a, o, l) {
      return Zu(Dqe(s, o, l), l);
    }
  }]), r;
}(Kt);
function Aqe(t, e) {
  He(2, arguments);
  var r = Ke(t), n = st(e), s = zW(r) - n;
  return r.setUTCDate(r.getUTCDate() - s * 7), r;
}
var Cqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 100), Ne(Ue(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "I":
          return Rr(Qr.week, s);
        case "Io":
          return o.ordinalNumber(s, {
            unit: "week"
          });
        default:
          return Yr(a.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return Zd(Aqe(s, o));
    }
  }]), r;
}(Kt), Iqe = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Pqe = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Rqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 90), Ne(Ue(n), "subPriority", 1), Ne(Ue(n), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "d":
          return Rr(Qr.date, s);
        case "do":
          return o.ordinalNumber(s, {
            unit: "date"
          });
        default:
          return Yr(a.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      var o = s.getUTCFullYear(), l = ij(o), u = s.getUTCMonth();
      return l ? a >= 1 && a <= Pqe[u] : a >= 1 && a <= Iqe[u];
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCDate(o), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt), Mqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 90), Ne(Ue(n), "subpriority", 1), Ne(Ue(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "D":
        case "DD":
          return Rr(Qr.dayOfYear, s);
        case "Do":
          return o.ordinalNumber(s, {
            unit: "date"
          });
        default:
          return Yr(a.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      var o = s.getUTCFullYear(), l = ij(o);
      return l ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCMonth(0, o), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt);
function TA(t, e, r) {
  var n, s, a, o, l, u, c, d;
  He(2, arguments);
  var h = Va(), f = st((n = (s = (a = (o = r == null ? void 0 : r.weekStartsOn) !== null && o !== void 0 ? o : r == null || (l = r.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && a !== void 0 ? a : h.weekStartsOn) !== null && s !== void 0 ? s : (c = h.locale) === null || c === void 0 || (d = c.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = Ke(t), m = st(e), b = p.getUTCDay(), y = m % 7, _ = (y + 7) % 7, x = (_ < f ? 7 : 0) + m - b;
  return p.setUTCDate(p.getUTCDate() + x), p;
}
var Lqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 90), Ne(Ue(n), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(s, {
            width: "wide",
            context: "formatting"
          }) || o.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(s, a, o, l) {
      return s = TA(s, o, l), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt), Nqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 90), Ne(Ue(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o, l) {
      var u = function(d) {
        var h = Math.floor((d - 1) / 7) * 7;
        return (d + l.weekStartsOn + 6) % 7 + h;
      };
      switch (a) {
        case "e":
        case "ee":
          return Zr(Yr(a.length, s), u);
        case "eo":
          return Zr(o.ordinalNumber(s, {
            unit: "day"
          }), u);
        case "eee":
          return o.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(s, {
            width: "wide",
            context: "formatting"
          }) || o.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(s, a, o, l) {
      return s = TA(s, o, l), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt), Fqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 90), Ne(Ue(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o, l) {
      var u = function(d) {
        var h = Math.floor((d - 1) / 7) * 7;
        return (d + l.weekStartsOn + 6) % 7 + h;
      };
      switch (a) {
        case "c":
        case "cc":
          return Zr(Yr(a.length, s), u);
        case "co":
          return Zr(o.ordinalNumber(s, {
            unit: "day"
          }), u);
        case "ccc":
          return o.day(s, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(s, {
            width: "short",
            context: "standalone"
          }) || o.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(s, {
            width: "short",
            context: "standalone"
          }) || o.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(s, {
            width: "wide",
            context: "standalone"
          }) || o.day(s, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(s, {
            width: "short",
            context: "standalone"
          }) || o.day(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(s, a, o, l) {
      return s = TA(s, o, l), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt);
function Bqe(t, e) {
  He(2, arguments);
  var r = st(e);
  r % 7 === 0 && (r = r - 7);
  var n = 1, s = Ke(t), a = s.getUTCDay(), o = r % 7, l = (o + 7) % 7, u = (l < n ? 7 : 0) + r - a;
  return s.setUTCDate(s.getUTCDate() + u), s;
}
var Uqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 90), Ne(Ue(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      var l = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (a) {
        case "i":
        case "ii":
          return Yr(a.length, s);
        case "io":
          return o.ordinalNumber(s, {
            unit: "day"
          });
        case "iii":
          return Zr(o.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          }), l);
        case "iiiii":
          return Zr(o.day(s, {
            width: "narrow",
            context: "formatting"
          }), l);
        case "iiiiii":
          return Zr(o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          }), l);
        case "iiii":
        default:
          return Zr(o.day(s, {
            width: "wide",
            context: "formatting"
          }) || o.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          }), l);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 1 && a <= 7;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s = Bqe(s, o), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), r;
}(Kt), Vqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 80), Ne(Ue(n), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCHours(wA(o), 0, 0, 0), s;
    }
  }]), r;
}(Kt), Yqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 80), Ne(Ue(n), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCHours(wA(o), 0, 0, 0), s;
    }
  }]), r;
}(Kt), Hqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 80), Ne(Ue(n), "incompatibleTokens", ["a", "b", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCHours(wA(o), 0, 0, 0), s;
    }
  }]), r;
}(Kt), Gqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 70), Ne(Ue(n), "incompatibleTokens", ["H", "K", "k", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "h":
          return Rr(Qr.hour12h, s);
        case "ho":
          return o.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return Yr(a.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 1 && a <= 12;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      var l = s.getUTCHours() >= 12;
      return l && o < 12 ? s.setUTCHours(o + 12, 0, 0, 0) : !l && o === 12 ? s.setUTCHours(0, 0, 0, 0) : s.setUTCHours(o, 0, 0, 0), s;
    }
  }]), r;
}(Kt), Wqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 70), Ne(Ue(n), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "H":
          return Rr(Qr.hour23h, s);
        case "Ho":
          return o.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return Yr(a.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 0 && a <= 23;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCHours(o, 0, 0, 0), s;
    }
  }]), r;
}(Kt), jqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 70), Ne(Ue(n), "incompatibleTokens", ["h", "H", "k", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "K":
          return Rr(Qr.hour11h, s);
        case "Ko":
          return o.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return Yr(a.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      var l = s.getUTCHours() >= 12;
      return l && o < 12 ? s.setUTCHours(o + 12, 0, 0, 0) : s.setUTCHours(o, 0, 0, 0), s;
    }
  }]), r;
}(Kt), Kqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 70), Ne(Ue(n), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "k":
          return Rr(Qr.hour24h, s);
        case "ko":
          return o.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return Yr(a.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 1 && a <= 24;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      var l = o <= 24 ? o % 24 : o;
      return s.setUTCHours(l, 0, 0, 0), s;
    }
  }]), r;
}(Kt), zqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 60), Ne(Ue(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "m":
          return Rr(Qr.minute, s);
        case "mo":
          return o.ordinalNumber(s, {
            unit: "minute"
          });
        default:
          return Yr(a.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCMinutes(o, 0, 0), s;
    }
  }]), r;
}(Kt), qqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 50), Ne(Ue(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a, o) {
      switch (a) {
        case "s":
          return Rr(Qr.second, s);
        case "so":
          return o.ordinalNumber(s, {
            unit: "second"
          });
        default:
          return Yr(a.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCSeconds(o, 0), s;
    }
  }]), r;
}(Kt), Xqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 30), Ne(Ue(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a) {
      var o = function(u) {
        return Math.floor(u * Math.pow(10, -a.length + 3));
      };
      return Zr(Yr(a.length, s), o);
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return s.setUTCMilliseconds(o), s;
    }
  }]), r;
}(Kt), Qqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 10), Ne(Ue(n), "incompatibleTokens", ["t", "T", "x"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a) {
      switch (a) {
        case "X":
          return ga(ma.basicOptionalMinutes, s);
        case "XX":
          return ga(ma.basic, s);
        case "XXXX":
          return ga(ma.basicOptionalSeconds, s);
        case "XXXXX":
          return ga(ma.extendedOptionalSeconds, s);
        case "XXX":
        default:
          return ga(ma.extended, s);
      }
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return a.timestampIsSet ? s : new Date(s.getTime() - o);
    }
  }]), r;
}(Kt), Zqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 10), Ne(Ue(n), "incompatibleTokens", ["t", "T", "X"]), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s, a) {
      switch (a) {
        case "x":
          return ga(ma.basicOptionalMinutes, s);
        case "xx":
          return ga(ma.basic, s);
        case "xxxx":
          return ga(ma.basicOptionalSeconds, s);
        case "xxxxx":
          return ga(ma.extendedOptionalSeconds, s);
        case "xxx":
        default:
          return ga(ma.extended, s);
      }
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return a.timestampIsSet ? s : new Date(s.getTime() - o);
    }
  }]), r;
}(Kt), Jqe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 40), Ne(Ue(n), "incompatibleTokens", "*"), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s) {
      return rj(s);
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(Kt), eXe = /* @__PURE__ */ function(t) {
  Ft(r, t);
  var e = Bt(r);
  function r() {
    var n;
    Ct(this, r);
    for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
      a[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(a)), Ne(Ue(n), "priority", 20), Ne(Ue(n), "incompatibleTokens", "*"), n;
  }
  return It(r, [{
    key: "parse",
    value: function(s) {
      return rj(s);
    }
  }, {
    key: "set",
    value: function(s, a, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(Kt), tXe = {
  G: new bqe(),
  y: new _qe(),
  Y: new wqe(),
  R: new Tqe(),
  u: new xqe(),
  Q: new Sqe(),
  q: new Eqe(),
  M: new $qe(),
  L: new kqe(),
  w: new Oqe(),
  I: new Cqe(),
  d: new Rqe(),
  D: new Mqe(),
  E: new Lqe(),
  e: new Nqe(),
  c: new Fqe(),
  i: new Uqe(),
  a: new Vqe(),
  b: new Yqe(),
  B: new Hqe(),
  h: new Gqe(),
  H: new Wqe(),
  K: new jqe(),
  k: new Kqe(),
  m: new zqe(),
  s: new qqe(),
  S: new Xqe(),
  X: new Qqe(),
  x: new Zqe(),
  t: new Jqe(),
  T: new eXe()
}, rXe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, nXe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, iXe = /^'([^]*?)'?$/, sXe = /''/g, aXe = /\S/, oXe = /[a-zA-Z]/;
function ak(t, e, r, n) {
  var s, a, o, l, u, c, d, h, f, p, m, b, y, _, x, T, k, E;
  He(3, arguments);
  var F = String(t), R = String(e), $ = Va(), O = (s = (a = n == null ? void 0 : n.locale) !== null && a !== void 0 ? a : $.locale) !== null && s !== void 0 ? s : JW;
  if (!O.match)
    throw new RangeError("locale must contain match property");
  var P = st((o = (l = (u = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (d = n.locale) === null || d === void 0 || (h = d.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && u !== void 0 ? u : $.firstWeekContainsDate) !== null && l !== void 0 ? l : (f = $.locale) === null || f === void 0 || (p = f.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(P >= 1 && P <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var N = st((m = (b = (y = (_ = n == null ? void 0 : n.weekStartsOn) !== null && _ !== void 0 ? _ : n == null || (x = n.locale) === null || x === void 0 || (T = x.options) === null || T === void 0 ? void 0 : T.weekStartsOn) !== null && y !== void 0 ? y : $.weekStartsOn) !== null && b !== void 0 ? b : (k = $.locale) === null || k === void 0 || (E = k.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(N >= 0 && N <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (R === "")
    return F === "" ? Ke(r) : /* @__PURE__ */ new Date(NaN);
  var I = {
    firstWeekContainsDate: P,
    weekStartsOn: N,
    locale: O
  }, B = [new yqe()], W = R.match(nXe).map(function(fe) {
    var Te = fe[0];
    if (Te in ik) {
      var ee = ik[Te];
      return ee(fe, O.formatLong);
    }
    return fe;
  }).join("").match(rXe), Q = [], te = oB(W), H;
  try {
    var A = function() {
      var Te = H.value;
      !(n != null && n.useAdditionalWeekYearTokens) && ZW(Te) && o0(Te, R, t), !(n != null && n.useAdditionalDayOfYearTokens) && QW(Te) && o0(Te, R, t);
      var ee = Te[0], Oe = tXe[ee];
      if (Oe) {
        var ut = Oe.incompatibleTokens;
        if (Array.isArray(ut)) {
          var L = Q.find(function(ie) {
            return ut.includes(ie.token) || ie.token === ee;
          });
          if (L)
            throw new RangeError("The format string mustn't contain `".concat(L.fullToken, "` and `").concat(Te, "` at the same time"));
        } else if (Oe.incompatibleTokens === "*" && Q.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(Te, "` and any other token at the same time"));
        Q.push({
          token: ee,
          fullToken: Te
        });
        var K = Oe.run(F, Te, O.match, I);
        if (!K)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        B.push(K.setter), F = K.rest;
      } else {
        if (ee.match(oXe))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + ee + "`");
        if (Te === "''" ? Te = "'" : ee === "'" && (Te = lXe(Te)), F.indexOf(Te) === 0)
          F = F.slice(Te.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (te.s(); !(H = te.n()).done; ) {
      var V = A();
      if (vs(V) === "object")
        return V.v;
    }
  } catch (fe) {
    te.e(fe);
  } finally {
    te.f();
  }
  if (F.length > 0 && aXe.test(F))
    return /* @__PURE__ */ new Date(NaN);
  var M = B.map(function(fe) {
    return fe.priority;
  }).sort(function(fe, Te) {
    return Te - fe;
  }).filter(function(fe, Te, ee) {
    return ee.indexOf(fe) === Te;
  }).map(function(fe) {
    return B.filter(function(Te) {
      return Te.priority === fe;
    }).sort(function(Te, ee) {
      return ee.subPriority - Te.subPriority;
    });
  }).map(function(fe) {
    return fe[0];
  }), Z = Ke(r);
  if (isNaN(Z.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var U = jW(Z, a0(Z)), pe = {}, q = oB(M), Y;
  try {
    for (q.s(); !(Y = q.n()).done; ) {
      var se = Y.value;
      if (!se.validate(U, I))
        return /* @__PURE__ */ new Date(NaN);
      var he = se.set(U, pe, I);
      Array.isArray(he) ? (U = he[0], nqe(pe, he[1])) : U = he;
    }
  } catch (fe) {
    q.e(fe);
  } finally {
    q.f();
  }
  return U;
}
function lXe(t) {
  return t.match(iXe)[1].replace(sXe, "'");
}
function uXe(t, e) {
  He(2, arguments);
  var r = st(e);
  return no(t, -r);
}
function cXe(t, e) {
  var r;
  He(1, arguments);
  var n = st((r = e == null ? void 0 : e.additionalDigits) !== null && r !== void 0 ? r : 2);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var s = pXe(t), a;
  if (s.date) {
    var o = vXe(s.date, n);
    a = mXe(o.restDateString, o.year);
  }
  if (!a || isNaN(a.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var l = a.getTime(), u = 0, c;
  if (s.time && (u = gXe(s.time), isNaN(u)))
    return /* @__PURE__ */ new Date(NaN);
  if (s.timezone) {
    if (c = yXe(s.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var d = new Date(l + u), h = /* @__PURE__ */ new Date(0);
    return h.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), h.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()), h;
  }
  return new Date(l + u + c);
}
var mg = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, dXe = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, hXe = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, fXe = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function pXe(t) {
  var e = {}, r = t.split(mg.dateTimeDelimiter), n;
  if (r.length > 2)
    return e;
  if (/:/.test(r[0]) ? n = r[0] : (e.date = r[0], n = r[1], mg.timeZoneDelimiter.test(e.date) && (e.date = t.split(mg.timeZoneDelimiter)[0], n = t.substr(e.date.length, t.length))), n) {
    var s = mg.timezone.exec(n);
    s ? (e.time = n.replace(s[1], ""), e.timezone = s[1]) : e.time = n;
  }
  return e;
}
function vXe(t, e) {
  var r = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"), n = t.match(r);
  if (!n)
    return {
      year: NaN,
      restDateString: ""
    };
  var s = n[1] ? parseInt(n[1]) : null, a = n[2] ? parseInt(n[2]) : null;
  return {
    year: a === null ? s : a * 100,
    restDateString: t.slice((n[1] || n[2]).length)
  };
}
function mXe(t, e) {
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var r = t.match(dXe);
  if (!r)
    return /* @__PURE__ */ new Date(NaN);
  var n = !!r[4], s = lf(r[1]), a = lf(r[2]) - 1, o = lf(r[3]), l = lf(r[4]), u = lf(r[5]) - 1;
  if (n)
    return xXe(e, l, u) ? bXe(e, l, u) : /* @__PURE__ */ new Date(NaN);
  var c = /* @__PURE__ */ new Date(0);
  return !wXe(e, a, o) || !TXe(e, s) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(e, a, Math.max(s, o)), c);
}
function lf(t) {
  return t ? parseInt(t) : 1;
}
function gXe(t) {
  var e = t.match(hXe);
  if (!e)
    return NaN;
  var r = pT(e[1]), n = pT(e[2]), s = pT(e[3]);
  return SXe(r, n, s) ? r * bA + n * yA + s * 1e3 : NaN;
}
function pT(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function yXe(t) {
  if (t === "Z")
    return 0;
  var e = t.match(fXe);
  if (!e)
    return 0;
  var r = e[1] === "+" ? -1 : 1, n = parseInt(e[2]), s = e[3] && parseInt(e[3]) || 0;
  return EXe(n, s) ? r * (n * bA + s * yA) : NaN;
}
function bXe(t, e, r) {
  var n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4);
  var s = n.getUTCDay() || 7, a = (e - 1) * 7 + r + 1 - s;
  return n.setUTCDate(n.getUTCDate() + a), n;
}
var _Xe = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function sj(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function wXe(t, e, r) {
  return e >= 0 && e <= 11 && r >= 1 && r <= (_Xe[e] || (sj(t) ? 29 : 28));
}
function TXe(t, e) {
  return e >= 1 && e <= (sj(t) ? 366 : 365);
}
function xXe(t, e, r) {
  return e >= 1 && e <= 53 && r >= 0 && r <= 6;
}
function SXe(t, e, r) {
  return t === 24 ? e === 0 && r === 0 : r >= 0 && r < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function EXe(t, e) {
  return e >= 0 && e <= 59;
}
function aj(t, e) {
  He(2, arguments);
  var r = Ke(t), n = st(e), s = r.getFullYear(), a = r.getDate(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(s, n, 15), o.setHours(0, 0, 0, 0);
  var l = sqe(o);
  return r.setMonth(n, Math.min(a, l)), r;
}
function Xr(t, e) {
  if (He(2, arguments), vs(e) !== "object" || e === null)
    throw new RangeError("values parameter must be an object");
  var r = Ke(t);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (e.year != null && r.setFullYear(e.year), e.month != null && (r = aj(r, e.month)), e.date != null && r.setDate(st(e.date)), e.hours != null && r.setHours(st(e.hours)), e.minutes != null && r.setMinutes(st(e.minutes)), e.seconds != null && r.setSeconds(st(e.seconds)), e.milliseconds != null && r.setMilliseconds(st(e.milliseconds)), r);
}
function oj(t, e) {
  He(2, arguments);
  var r = Ke(t), n = st(e);
  return r.setHours(n), r;
}
function xA(t, e) {
  He(2, arguments);
  var r = Ke(t), n = st(e);
  return r.setMilliseconds(n), r;
}
function lj(t, e) {
  He(2, arguments);
  var r = Ke(t), n = st(e);
  return r.setMinutes(n), r;
}
function uj(t, e) {
  He(2, arguments);
  var r = Ke(t), n = st(e);
  return r.setSeconds(n), r;
}
function Cu(t, e) {
  He(2, arguments);
  var r = Ke(t), n = st(e);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (r.setFullYear(n), r);
}
function eh(t, e) {
  He(2, arguments);
  var r = st(e);
  return ka(t, -r);
}
function $Xe(t, e) {
  if (He(2, arguments), !e || vs(e) !== "object")
    return /* @__PURE__ */ new Date(NaN);
  var r = e.years ? st(e.years) : 0, n = e.months ? st(e.months) : 0, s = e.weeks ? st(e.weeks) : 0, a = e.days ? st(e.days) : 0, o = e.hours ? st(e.hours) : 0, l = e.minutes ? st(e.minutes) : 0, u = e.seconds ? st(e.seconds) : 0, c = eh(t, n + r * 12), d = uXe(c, a + s * 7), h = l + o * 60, f = u + h * 60, p = f * 1e3, m = new Date(d.getTime() - p);
  return m;
}
function cj(t, e) {
  He(2, arguments);
  var r = st(e);
  return gA(t, -r);
}
function Yv() {
  return re(), ye(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ke("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      ke("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      ke("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      ke("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
Yv.compatConfig = {
  MODE: 3
};
function dj() {
  return re(), ye(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ke("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      ke("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
dj.compatConfig = {
  MODE: 3
};
function SA() {
  return re(), ye(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ke("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
SA.compatConfig = {
  MODE: 3
};
function EA() {
  return re(), ye(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ke("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
EA.compatConfig = {
  MODE: 3
};
function $A() {
  return re(), ye(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ke("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      ke("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
$A.compatConfig = {
  MODE: 3
};
function kA() {
  return re(), ye(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ke("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
kA.compatConfig = {
  MODE: 3
};
function DA() {
  return re(), ye(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ke("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
DA.compatConfig = {
  MODE: 3
};
function OA(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var hj = { exports: {} };
(function(t) {
  function e(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(hj);
var kXe = hj.exports, ok = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(n) {
    if (n === null || n === !0 || n === !1)
      return NaN;
    var s = Number(n);
    return isNaN(s) ? s : s < 0 ? Math.ceil(s) : Math.floor(s);
  }
  t.exports = e.default;
})(ok, ok.exports);
var DXe = ok.exports;
const OXe = /* @__PURE__ */ OA(DXe);
var lk = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(n) {
    var s = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
    return s.setUTCFullYear(n.getFullYear()), n.getTime() - s.getTime();
  }
  t.exports = e.default;
})(lk, lk.exports);
var AXe = lk.exports;
const uB = /* @__PURE__ */ OA(AXe);
function CXe(t, e) {
  var r = MXe(e);
  return r.formatToParts ? PXe(r, t) : RXe(r, t);
}
var IXe = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function PXe(t, e) {
  try {
    for (var r = t.formatToParts(e), n = [], s = 0; s < r.length; s++) {
      var a = IXe[r[s].type];
      a >= 0 && (n[a] = parseInt(r[s].value, 10));
    }
    return n;
  } catch (o) {
    if (o instanceof RangeError)
      return [NaN];
    throw o;
  }
}
function RXe(t, e) {
  var r = t.format(e).replace(/\u200E/g, ""), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [n[3], n[1], n[2], n[4], n[5], n[6]];
}
var vT = {};
function MXe(t) {
  if (!vT[t]) {
    var e = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), r = e === "06/25/2014, 00:00:00" || e === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    vT[t] = r ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return vT[t];
}
function AA(t, e, r, n, s, a, o) {
  var l = /* @__PURE__ */ new Date(0);
  return l.setUTCFullYear(t, e, r), l.setUTCHours(n, s, a, o), l;
}
var cB = 36e5, LXe = 6e4, mT = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function CA(t, e, r) {
  var n, s;
  if (!t || (n = mT.timezoneZ.exec(t), n))
    return 0;
  var a;
  if (n = mT.timezoneHH.exec(t), n)
    return a = parseInt(n[1], 10), dB(a) ? -(a * cB) : NaN;
  if (n = mT.timezoneHHMM.exec(t), n) {
    a = parseInt(n[1], 10);
    var o = parseInt(n[2], 10);
    return dB(a, o) ? (s = Math.abs(a) * cB + o * LXe, a > 0 ? -s : s) : NaN;
  }
  if (BXe(t)) {
    e = new Date(e || Date.now());
    var l = r ? e : NXe(e), u = uk(l, t), c = r ? u : FXe(e, u, t);
    return -c;
  }
  return NaN;
}
function NXe(t) {
  return AA(
    t.getFullYear(),
    t.getMonth(),
    t.getDate(),
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  );
}
function uk(t, e) {
  var r = CXe(t, e), n = AA(
    r[0],
    r[1] - 1,
    r[2],
    r[3] % 24,
    r[4],
    r[5],
    0
  ).getTime(), s = t.getTime(), a = s % 1e3;
  return s -= a >= 0 ? a : 1e3 + a, n - s;
}
function FXe(t, e, r) {
  var n = t.getTime(), s = n - e, a = uk(new Date(s), r);
  if (e === a)
    return e;
  s -= a - e;
  var o = uk(new Date(s), r);
  return a === o ? a : Math.max(a, o);
}
function dB(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
var hB = {};
function BXe(t) {
  if (hB[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), hB[t] = !0, !0;
  } catch {
    return !1;
  }
}
var fj = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, gT = 36e5, fB = 6e4, UXe = 2, ti = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: fj
};
function ck(t, e) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var r = e || {}, n = r.additionalDigits == null ? UXe : OXe(r.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var s = VXe(t), a = YXe(s.date, n), o = a.year, l = a.restDateString, u = HXe(l, o);
  if (isNaN(u))
    return /* @__PURE__ */ new Date(NaN);
  if (u) {
    var c = u.getTime(), d = 0, h;
    if (s.time && (d = GXe(s.time), isNaN(d)))
      return /* @__PURE__ */ new Date(NaN);
    if (s.timeZone || r.timeZone) {
      if (h = CA(s.timeZone || r.timeZone, new Date(c + d)), isNaN(h))
        return /* @__PURE__ */ new Date(NaN);
    } else
      h = uB(new Date(c + d)), h = uB(new Date(c + d + h));
    return new Date(c + d + h);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function VXe(t) {
  var e = {}, r = ti.dateTimePattern.exec(t), n;
  if (r ? (e.date = r[1], n = r[3]) : (r = ti.datePattern.exec(t), r ? (e.date = r[1], n = r[2]) : (e.date = null, n = t)), n) {
    var s = ti.timeZone.exec(n);
    s ? (e.time = n.replace(s[1], ""), e.timeZone = s[1].trim()) : e.time = n;
  }
  return e;
}
function YXe(t, e) {
  var r = ti.YYY[e], n = ti.YYYYY[e], s;
  if (s = ti.YYYY.exec(t) || n.exec(t), s) {
    var a = s[1];
    return {
      year: parseInt(a, 10),
      restDateString: t.slice(a.length)
    };
  }
  if (s = ti.YY.exec(t) || r.exec(t), s) {
    var o = s[1];
    return {
      year: parseInt(o, 10) * 100,
      restDateString: t.slice(o.length)
    };
  }
  return {
    year: null
  };
}
function HXe(t, e) {
  if (e === null)
    return null;
  var r, n, s, a;
  if (t.length === 0)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(e), n;
  if (r = ti.MM.exec(t), r)
    return n = /* @__PURE__ */ new Date(0), s = parseInt(r[1], 10) - 1, vB(e, s) ? (n.setUTCFullYear(e, s), n) : /* @__PURE__ */ new Date(NaN);
  if (r = ti.DDD.exec(t), r) {
    n = /* @__PURE__ */ new Date(0);
    var o = parseInt(r[1], 10);
    return KXe(e, o) ? (n.setUTCFullYear(e, 0, o), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = ti.MMDD.exec(t), r) {
    n = /* @__PURE__ */ new Date(0), s = parseInt(r[1], 10) - 1;
    var l = parseInt(r[2], 10);
    return vB(e, s, l) ? (n.setUTCFullYear(e, s, l), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = ti.Www.exec(t), r)
    return a = parseInt(r[1], 10) - 1, mB(e, a) ? pB(e, a) : /* @__PURE__ */ new Date(NaN);
  if (r = ti.WwwD.exec(t), r) {
    a = parseInt(r[1], 10) - 1;
    var u = parseInt(r[2], 10) - 1;
    return mB(e, a, u) ? pB(e, a, u) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function GXe(t) {
  var e, r, n;
  if (e = ti.HH.exec(t), e)
    return r = parseFloat(e[1].replace(",", ".")), yT(r) ? r % 24 * gT : NaN;
  if (e = ti.HHMM.exec(t), e)
    return r = parseInt(e[1], 10), n = parseFloat(e[2].replace(",", ".")), yT(r, n) ? r % 24 * gT + n * fB : NaN;
  if (e = ti.HHMMSS.exec(t), e) {
    r = parseInt(e[1], 10), n = parseInt(e[2], 10);
    var s = parseFloat(e[3].replace(",", "."));
    return yT(r, n, s) ? r % 24 * gT + n * fB + s * 1e3 : NaN;
  }
  return null;
}
function pB(t, e, r) {
  e = e || 0, r = r || 0;
  var n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4);
  var s = n.getUTCDay() || 7, a = e * 7 + r + 1 - s;
  return n.setUTCDate(n.getUTCDate() + a), n;
}
var WXe = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], jXe = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function pj(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function vB(t, e, r) {
  if (e < 0 || e > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    var n = pj(t);
    if (n && r > jXe[e] || !n && r > WXe[e])
      return !1;
  }
  return !0;
}
function KXe(t, e) {
  if (e < 1)
    return !1;
  var r = pj(t);
  return !(r && e > 366 || !r && e > 365);
}
function mB(t, e, r) {
  return !(e < 0 || e > 52 || r != null && (r < 0 || r > 6));
}
function yT(t, e, r) {
  return !(t != null && (t < 0 || t >= 25) || e != null && (e < 0 || e >= 60) || r != null && (r < 0 || r >= 60));
}
var dk = { exports: {} }, hk = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(n, s) {
    if (n == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var a in s)
      Object.prototype.hasOwnProperty.call(s, a) && (n[a] = s[a]);
    return n;
  }
  t.exports = e.default;
})(hk, hk.exports);
var zXe = hk.exports;
(function(t, e) {
  var r = kXe.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = s;
  var n = r(zXe);
  function s(a) {
    return (0, n.default)({}, a);
  }
  t.exports = e.default;
})(dk, dk.exports);
var qXe = dk.exports;
const XXe = /* @__PURE__ */ OA(qXe);
function QXe(t, e, r) {
  var n = ck(t, r), s = CA(e, n, !0), a = new Date(n.getTime() - s), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), o.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), o;
}
function ZXe(t, e, r) {
  if (typeof t == "string" && !t.match(fj)) {
    var n = XXe(r);
    return n.timeZone = e, ck(t, n);
  }
  var s = ck(t, r), a = AA(
    s.getFullYear(),
    s.getMonth(),
    s.getDate(),
    s.getHours(),
    s.getMinutes(),
    s.getSeconds(),
    s.getMilliseconds()
  ).getTime(), o = CA(e, new Date(a));
  return new Date(a + o);
}
function gB(t) {
  return (e) => new Intl.DateTimeFormat(t, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`)).slice(0, 2);
}
function JXe(t) {
  return (e) => Au(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`), "EEEEEE", { locale: t });
}
const eQe = (t, e, r) => {
  const n = [1, 2, 3, 4, 5, 6, 7];
  let s;
  if (t !== null)
    try {
      s = n.map(JXe(t));
    } catch {
      s = n.map(gB(e));
    }
  else
    s = n.map(gB(e));
  const a = s.slice(0, r), o = s.slice(r + 1, s.length);
  return [s[r]].concat(...o).concat(...a);
}, IA = (t, e) => {
  const r = [];
  for (let n = +t[0]; n <= +t[1]; n++)
    r.push({ value: +n, text: `${n}` });
  return e ? r.reverse() : r;
}, vj = (t, e, r) => {
  const n = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((a) => {
    const o = a < 10 ? `0${a}` : a;
    return /* @__PURE__ */ new Date(`2017-${o}-01T00:00:00+00:00`);
  });
  if (t !== null)
    try {
      const a = r === "long" ? "MMMM" : "MMM";
      return n.map((o, l) => {
        const u = Au(o, a, { locale: t });
        return {
          text: u.charAt(0).toUpperCase() + u.substring(1),
          value: l
        };
      });
    } catch {
    }
  const s = new Intl.DateTimeFormat(e, { month: r, timeZone: "UTC" });
  return n.map((a, o) => {
    const l = s.format(a);
    return {
      text: l.charAt(0).toUpperCase() + l.substring(1),
      value: o
    };
  });
}, tQe = (t) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][t], un = (t) => {
  const e = X(t);
  return e != null && e.$el ? e == null ? void 0 : e.$el : e;
}, rQe = (t) => Object.assign({ type: "dot" }, t), mj = (t) => Array.isArray(t) ? !!t[0] && !!t[1] : !1, c0 = {
  prop: (t) => `"${t}" prop must be enabled!`,
  dateArr: (t) => `You need to use array as "model-value" binding in order to support "${t}"`
}, mn = (t) => t, yB = (t) => t === 0 ? t : !t || isNaN(+t) ? null : +t, bB = (t) => t === null, nQe = (t) => {
  if (t)
    return [...t.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, iQe = (t) => {
  const e = [], r = (n) => n.filter((s) => s);
  for (let n = 0; n < t.length; n += 3) {
    const s = [t[n], t[n + 1], t[n + 2]];
    e.push(r(s));
  }
  return e;
}, $p = (t, e, r) => {
  const n = r ?? r === 0, s = e ?? e === 0;
  if (!n && !s)
    return !1;
  const a = +r, o = +e;
  return n && s ? +t > a || +t < o : n ? +t > a : s ? +t < o : !1;
}, th = (t, e) => iQe(t).map((r) => r.map((n) => {
  const { active: s, disabled: a, isBetween: o } = e(n);
  return {
    ...n,
    active: s,
    disabled: a,
    className: {
      dp__overlay_cell_active: s,
      dp__overlay_cell: !s,
      dp__overlay_cell_disabled: a,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: a && s,
      dp__cell_in_between: o
    }
  };
})), _B = (t, e, r, n, s) => {
  const a = ak(t, e.slice(0, t.length), /* @__PURE__ */ new Date());
  return Bf(a) && GW(a) ? n || s ? a : Xr(a, {
    hours: +r.hours,
    minutes: +(r == null ? void 0 : r.minutes),
    seconds: +(r == null ? void 0 : r.seconds),
    milliseconds: 0
  }) : null;
}, sQe = (t, e, r, n, s) => {
  const a = Array.isArray(r) ? r[0] : r;
  if (typeof e == "string")
    return _B(t, e, a, n, s);
  if (Array.isArray(e)) {
    let o = null;
    for (const l of e)
      if (o = _B(t, l, a, n, s), o)
        break;
    return o;
  }
  return typeof e == "function" ? e(t) : null;
}, $e = (t) => t ? new Date(t) : /* @__PURE__ */ new Date(), aQe = (t, e, r) => {
  if (e) {
    const s = (t.getMonth() + 1).toString().padStart(2, "0"), a = t.getDate().toString().padStart(2, "0"), o = t.getHours().toString().padStart(2, "0"), l = t.getMinutes().toString().padStart(2, "0"), u = r ? t.getSeconds().toString().padStart(2, "0") : "00";
    return `${t.getFullYear()}-${s}-${a}T${o}:${l}:${u}.000Z`;
  }
  const n = Date.UTC(
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate(),
    t.getUTCHours(),
    t.getUTCMinutes(),
    t.getUTCSeconds()
  );
  return new Date(n).toISOString();
}, ms = (t) => {
  let e = $e(JSON.parse(JSON.stringify(t)));
  return e = oj(e, 0), e = lj(e, 0), e = uj(e, 0), e = xA(e, 0), e;
}, xl = (t, e, r, n) => {
  let s = t ? $e(t) : $e();
  return (e || e === 0) && (s = oj(s, +e)), (r || r === 0) && (s = lj(s, +r)), (n || n === 0) && (s = uj(s, +n)), xA(s, 0);
}, Mn = (t, e) => !t || !e ? !1 : Ep(ms(t), ms(e)), Jt = (t, e) => !t || !e ? !1 : pd(ms(t), ms(e)), Gn = (t, e) => !t || !e ? !1 : Sp(ms(t), ms(e)), PA = (t, e, r) => t != null && t[0] && t != null && t[1] ? Gn(r, t[0]) && Mn(r, t[1]) : t != null && t[0] && e ? Gn(r, t[0]) && Mn(r, e) || Mn(r, t[0]) && Gn(r, e) : !1, Ls = (t) => {
  const e = Xr(new Date(t), { date: 1 });
  return ms(e);
}, bT = (t, e, r) => e && (r || r === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((n) => n === e ? [n, r] : [n, isNaN(+t[n]) ? void 0 : +t[n]])
) : {
  hours: isNaN(+t.hours) ? void 0 : +t.hours,
  minutes: isNaN(+t.minutes) ? void 0 : +t.minutes,
  seconds: isNaN(+t.seconds) ? void 0 : +t.seconds
}, Iu = (t) => ({
  hours: Da(t),
  minutes: Oa(t),
  seconds: Jd(t)
}), gj = (t, e) => {
  if (e) {
    const r = Yt($e(e));
    if (r > t)
      return 12;
    if (r === t)
      return Zt($e(e));
  }
}, yj = (t, e) => {
  if (e) {
    const r = Yt($e(e));
    return r < t ? -1 : r === t ? Zt($e(e)) : void 0;
  }
}, rh = (t) => {
  if (t)
    return Yt($e(t));
}, Ta = (t, e) => e ? QXe(t, e) : t, oQe = (t, e) => e ? ZXe(t, e) : t, wB = (t) => t instanceof Date ? t : cXe(t), bj = (t, e) => {
  const r = Gn(t, e) ? e : t, n = Gn(e, t) ? e : t;
  return WW({ start: r, end: n });
}, lQe = (t) => {
  const e = ka(t, 1);
  return { month: Zt(e), year: Yt(e) };
}, Yg = (t, e, r) => {
  const n = Qu(Ta(t, e), { weekStartsOn: +r }), s = Jze(Ta(t, e), { weekStartsOn: +r });
  return [n, s];
}, _j = (t, e) => {
  const r = {
    hours: Da($e()),
    minutes: Oa($e()),
    seconds: e ? Jd($e()) : 0
  };
  return Object.assign(r, t);
}, fl = (t, e, r) => [Xr($e(t), { date: 1 }), Xr($e(), { month: e, year: r, date: 1 })], lo = (t, e, r) => {
  let n = t ? $e(t) : $e();
  return (e || e === 0) && (n = aj(n, e)), r && (n = Cu(n, r)), n;
}, wj = (t, e, r, n, s) => {
  if (!n || s && !e || !s && !r)
    return !1;
  const a = s ? ka(t, 1) : eh(t, 1), o = [Zt(a), Yt(a)];
  return s ? !cQe(...o, e) : !uQe(...o, r);
}, uQe = (t, e, r) => Mn(...fl(r, t, e)) || Jt(...fl(r, t, e)), cQe = (t, e, r) => Gn(...fl(r, t, e)) || Jt(...fl(r, t, e)), Tj = (t, e, r, n, s, a) => {
  if (typeof e == "function")
    return e(t);
  const o = r ? { locale: r } : void 0;
  return Array.isArray(t) ? `${Au(t[0], a, o)}${s && !t[1] ? "" : n}${t[1] ? Au(t[1], a, o) : ""}` : Au(t, a, o);
}, qc = (t) => {
  if (t)
    return null;
  throw new Error(c0.prop("partial-range"));
}, gg = (t, e) => {
  if (e)
    return t();
  throw new Error(c0.prop("range"));
}, fk = (t) => Array.isArray(t) ? Bf(t[0]) && (t[1] ? Bf(t[1]) : !0) : t ? Bf(t) : !1, dQe = (t) => Xr($e(), {
  hours: +t.hours || 0,
  minutes: +t.minutes || 0,
  seconds: +t.seconds || 0
}), _T = (t, e, r, n) => {
  if (!t)
    return !0;
  if (n) {
    const s = r === "max" ? Ep(t, e) : Sp(t, e), a = { seconds: 0, milliseconds: 0 };
    return s || pd(Xr(t, a), Xr(e, a));
  }
  return r === "max" ? t.getTime() <= e.getTime() : t.getTime() >= e.getTime();
}, TB = (t, e, r, n, s) => {
  const a = t ? dQe(t) : $e(e);
  return Array.isArray(n) ? _T(n[0], a, r, !!e) && _T(n[1], a, r, !!e) && s : _T(n, a, r, !!e) && s;
}, wT = (t) => Xr($e(), Iu(t)), hQe = (t, e) => Array.isArray(t) ? t.map((r) => $e(r)).filter((r) => Yt($e(r)) === e).map((r) => Zt(r)) : [], uf = Na({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), xj = () => {
  const t = (r) => {
    uf.menuFocused = r;
  }, e = (r) => {
    uf.shiftKeyInMenu !== r && (uf.shiftKeyInMenu = r);
  };
  return {
    control: Ce(() => ({ shiftKeyInMenu: uf.shiftKeyInMenu, menuFocused: uf.menuFocused })),
    setMenuFocused: t,
    setShiftKey: e
  };
}, wr = Na({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), TT = ue(null), yg = ue(!1), xT = ue(!1), ST = ue(!1), ET = ue(!1), qn = ue(0), Dn = ue(0), Ul = () => {
  const t = Ce(() => yg.value ? [...wr.selectionGrid, wr.actionRow].filter((h) => h.length) : xT.value ? [
    ...wr.timePicker[0],
    ...wr.timePicker[1],
    ET.value ? [] : [TT.value],
    wr.actionRow
  ].filter((h) => h.length) : ST.value ? [...wr.monthPicker, wr.actionRow] : [wr.monthYear, ...wr.calendar, wr.time, wr.actionRow].filter((h) => h.length)), e = (h) => {
    qn.value = h ? qn.value + 1 : qn.value - 1;
    let f = null;
    t.value[Dn.value] && (f = t.value[Dn.value][qn.value]), f || (qn.value = h ? qn.value - 1 : qn.value + 1);
  }, r = (h) => {
    Dn.value === 0 && !h || Dn.value === t.value.length && h || (Dn.value = h ? Dn.value + 1 : Dn.value - 1, t.value[Dn.value] ? t.value[Dn.value] && !t.value[Dn.value][qn.value] && qn.value !== 0 && (qn.value = t.value[Dn.value].length - 1) : Dn.value = h ? Dn.value - 1 : Dn.value + 1);
  }, n = (h) => {
    let f = null;
    t.value[Dn.value] && (f = t.value[Dn.value][qn.value]), f ? f.focus({ preventScroll: !yg.value }) : qn.value = h ? qn.value - 1 : qn.value + 1;
  }, s = () => {
    e(!0), n(!0);
  }, a = () => {
    e(!1), n(!1);
  }, o = () => {
    r(!1), n(!0);
  }, l = () => {
    r(!0), n(!0);
  }, u = (h, f) => {
    wr[f] = h;
  }, c = (h, f) => {
    wr[f] = h;
  }, d = () => {
    qn.value = 0, Dn.value = 0;
  };
  return {
    buildMatrix: u,
    buildMultiLevelMatrix: c,
    setTimePickerBackRef: (h) => {
      TT.value = h;
    },
    setSelectionGrid: (h) => {
      yg.value = h, d(), h || (wr.selectionGrid = []);
    },
    setTimePicker: (h, f = !1) => {
      xT.value = h, ET.value = f, d(), h || (wr.timePicker[0] = [], wr.timePicker[1] = []);
    },
    setTimePickerElements: (h, f = 0) => {
      wr.timePicker[f] = h;
    },
    arrowRight: s,
    arrowLeft: a,
    arrowUp: o,
    arrowDown: l,
    clearArrowNav: () => {
      wr.monthYear = [], wr.calendar = [], wr.time = [], wr.actionRow = [], wr.selectionGrid = [], wr.timePicker[0] = [], wr.timePicker[1] = [], yg.value = !1, xT.value = !1, ET.value = !1, ST.value = !1, d(), TT.value = null;
    },
    setMonthPicker: (h) => {
      ST.value = h, d();
    },
    refSets: wr
    // exposed for testing
  };
}, xB = (t) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...t ?? {}
}), fQe = (t) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  calendarWrap: "Calendar wrapper",
  calendarDays: "Calendar days",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: () => "",
  ...t ?? {}
}), SB = (t) => t ? typeof t == "boolean" ? t ? 2 : 0 : +t >= 2 ? +t : 2 : 0, pQe = (t) => {
  const e = typeof t == "object" && t, r = {
    static: !0,
    solo: !1
  };
  if (!t)
    return { ...r, count: SB(!1) };
  const n = e ? t : {}, s = e ? n.count ?? !0 : t, a = SB(s);
  return Object.assign(r, n, { count: a });
}, vQe = (t, e, r) => t || (typeof r == "string" ? r : e), mQe = (t) => typeof t == "boolean" ? t ? xB({}) : !1 : xB(t), gQe = (t) => {
  const e = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: !0,
    rangeSeparator: " - "
  };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : { ...e, enabled: t };
}, yQe = (t) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...t ?? {}
}), bQe = (t) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...t ?? {}
}), _Qe = (t) => {
  const e = { input: !1 };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : {
    enabled: t,
    ...e
  };
}, Nn = (t) => {
  const e = () => {
    const m = t.enableSeconds ? ":ss" : "";
    return t.is24 ? `HH:mm${m}` : `hh:mm${m} aa`;
  }, r = () => t.format ? t.format : t.monthPicker ? "MM/yyyy" : t.timePicker ? e() : t.weekPicker ? "MM/dd/yyyy" : t.yearPicker ? "yyyy" : t.enableTimePicker ? `MM/dd/yyyy, ${e()}` : "MM/dd/yyyy", n = (m) => _j(m, t.enableSeconds), s = () => t.range ? t.startTime && Array.isArray(t.startTime) ? [n(t.startTime[0]), n(t.startTime[1])] : null : t.startTime && !Array.isArray(t.startTime) ? n(t.startTime) : null, a = Ce(() => pQe(t.multiCalendars)), o = Ce(() => s()), l = Ce(() => fQe(t.ariaLabels)), u = Ce(() => yQe(t.filters)), c = Ce(() => mQe(t.transitions)), d = Ce(() => bQe(t.actionRow)), h = Ce(
    () => vQe(t.previewFormat, t.format, r())
  ), f = Ce(() => gQe(t.textInput)), p = Ce(() => _Qe(t.inline));
  return {
    defaultedTransitions: c,
    defaultedMultiCalendars: a,
    defaultedStartTime: o,
    defaultedAriaLabels: l,
    defaultedFilters: u,
    defaultedActionRow: d,
    defaultedPreviewFormat: h,
    defaultedTextInput: f,
    defaultedInline: p,
    getDefaultPattern: r,
    getDefaultStartTime: s
  };
}, wQe = (t, e, r) => {
  const n = ue(), { defaultedTextInput: s, getDefaultPattern: a } = Nn(e), o = ue(""), l = Zg(e, "format");
  Lr(n, () => {
    t("internal-model-change", n.value);
  }), Lr(l, () => {
    W();
  });
  const u = (M) => oQe(M, e.timezone), c = (M) => Ta(M, e.timezone), d = (M, Z) => Tj(
    M,
    e.format,
    e.formatLocale,
    s.value.rangeSeparator,
    e.modelAuto,
    Z ?? a()
  ), h = (M) => {
    const Z = M ?? $e();
    return e.modelType ? te(Z) : {
      hours: Da(Z),
      minutes: Oa(Z),
      seconds: e.enableSeconds ? Jd(Z) : 0
    };
  }, f = (M) => e.modelType ? te(M) : { month: Zt(M), year: Yt(M) }, p = (M) => Array.isArray(M) ? gg(
    () => [
      Cu($e(), M[0]),
      M[1] ? Cu($e(), M[1]) : qc(e.partialRange)
    ],
    e.range
  ) : Cu($e(), +M), m = (M, Z) => (typeof M == "string" || typeof M == "number") && e.modelType ? Q(M) : Z, b = (M) => Array.isArray(M) ? [
    m(
      M[0],
      xl(null, +M[0].hours, +M[0].minutes, M[0].seconds)
    ),
    m(
      M[1],
      xl(null, +M[1].hours, +M[1].minutes, M[1].seconds)
    )
  ] : m(M, xl(null, M.hours, M.minutes, M.seconds)), y = (M) => Array.isArray(M) ? e.multiDates ? M.map((Z) => m(Z, lo(null, +Z.month, +Z.year))) : gg(
    () => [
      m(M[0], lo(null, +M[0].month, +M[0].year)),
      m(
        M[1],
        M[1] ? lo(null, +M[1].month, +M[1].year) : qc(e.partialRange)
      )
    ],
    e.range
  ) : m(M, lo(null, +M.month, +M.year)), _ = (M) => {
    if (Array.isArray(M))
      return M.map((Z) => Q(Z));
    throw new Error(c0.dateArr("multi-dates"));
  }, x = (M) => {
    if (Array.isArray(M))
      return [$e(M[0]), $e(M[1])];
    throw new Error(c0.dateArr("week-picker"));
  }, T = (M) => e.modelAuto ? Array.isArray(M) ? [Q(M[0]), Q(M[1])] : e.autoApply ? [Q(M)] : [Q(M), null] : Array.isArray(M) ? gg(
    () => [
      Q(M[0]),
      M[1] ? Q(M[1]) : qc(e.partialRange)
    ],
    e.range
  ) : Q(M), k = () => {
    Array.isArray(n.value) && e.range && n.value.length === 1 && n.value.push(qc(e.partialRange));
  }, E = () => {
    const M = n.value;
    return [
      te(M[0]),
      M[1] ? te(M[1]) : qc(e.partialRange)
    ];
  }, F = () => n.value[1] ? E() : te(mn(n.value[0])), R = () => (n.value || []).map((M) => te(M)), $ = () => (k(), e.modelAuto ? F() : e.multiDates ? R() : Array.isArray(n.value) ? gg(() => E(), e.range) : te(mn(n.value))), O = (M) => !M || Array.isArray(M) && !M.length ? null : e.timePicker ? b(mn(M)) : e.monthPicker ? y(mn(M)) : e.yearPicker ? p(mn(M)) : e.multiDates ? _(mn(M)) : e.weekPicker ? x(mn(M)) : T(mn(M)), P = (M) => {
    const Z = O(M);
    fk(mn(Z)) ? (n.value = mn(Z), W()) : (n.value = null, o.value = "");
  }, N = () => {
    const M = (Z) => Au(Z, s.value.format);
    return `${M(n.value[0])} ${s.value.rangeSeparator} ${n.value[1] ? M(n.value[1]) : ""}`;
  }, I = () => r.value && n.value ? Array.isArray(n.value) ? N() : Au(n.value, s.value.format) : d(n.value), B = () => n.value ? e.multiDates ? n.value.map((M) => d(M)).join("; ") : s.value.enabled && typeof s.value.format == "string" ? I() : d(n.value) : "", W = () => {
    !e.format || typeof e.format == "string" || s.value.enabled && typeof s.value.format == "string" ? o.value = B() : o.value = e.format(n.value);
  }, Q = (M) => {
    if (e.utc) {
      const Z = new Date(M);
      return e.utc === "preserve" ? new Date(Z.getTime() + Z.getTimezoneOffset() * 6e4) : Z;
    }
    return e.modelType ? e.modelType === "date" || e.modelType === "timestamp" ? c(new Date(M)) : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? ak(M, a(), /* @__PURE__ */ new Date()) : c(ak(M, e.modelType, /* @__PURE__ */ new Date())) : c(new Date(M));
  }, te = (M) => M ? e.utc ? aQe(M, e.utc === "preserve", e.enableSeconds) : e.modelType ? e.modelType === "timestamp" ? +u(M) : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? d(u(M)) : d(u(M), e.modelType) : u(M) : "", H = (M, Z = !1) => {
    if (t("update:model-value", M), e.emitTimezone && Z) {
      const U = Array.isArray(M) ? M.map((pe) => Ta(mn(pe)), e.emitTimezone) : Ta(mn(M), e.emitTimezone);
      t("update:model-timezone-value", U);
    }
  }, A = (M) => Array.isArray(n.value) ? e.multiDates ? n.value.map((Z) => M(Z)) : [
    M(n.value[0]),
    n.value[1] ? M(n.value[1]) : qc(e.partialRange)
  ] : M(mn(n.value)), V = (M) => H(mn(A(M)));
  return {
    inputValue: o,
    internalModelValue: n,
    checkBeforeEmit: () => n.value ? e.range ? e.partialRange ? n.value.length >= 1 : n.value.length === 2 : !!n.value : !1,
    parseExternalModelValue: P,
    formatInputValue: W,
    emitModelValue: () => (W(), e.monthPicker ? V(f) : e.timePicker ? V(h) : e.yearPicker ? V(Yt) : e.weekPicker ? H(n.value, !0) : H($(), !0))
  };
}, TQe = (t, e) => {
  const { defaultedFilters: r } = Nn(t), { validateMonthYearInRange: n } = Gv(t), s = (c, d) => {
    let h = c;
    return r.value.months.includes(Zt(h)) ? (h = d ? ka(c, 1) : eh(c, 1), s(h, d)) : h;
  }, a = (c, d) => {
    let h = c;
    return r.value.years.includes(Yt(h)) ? (h = d ? gA(c, 1) : cj(c, 1), a(h, d)) : h;
  }, o = (c) => {
    const d = Xr(/* @__PURE__ */ new Date(), { month: t.month, year: t.year });
    let h = c ? ka(d, 1) : eh(d, 1);
    t.disableYearSelect && (h = Cu(h, t.year));
    let f = Zt(h), p = Yt(h);
    r.value.months.includes(f) && (h = s(h, c), f = Zt(h), p = Yt(h)), r.value.years.includes(p) && (h = a(h, c), p = Yt(h)), n(f, p, c, t.preventMinMaxNavigation) && l(f, p);
  }, l = (c, d) => {
    e("update-month-year", { month: c, year: d });
  }, u = Ce(() => (c) => wj(
    Xr(/* @__PURE__ */ new Date(), { month: t.month, year: t.year }),
    t.maxDate,
    t.minDate,
    t.preventMinMaxNavigation,
    c
  ));
  return { handleMonthYearChange: o, isDisabled: u, updateMonthYear: l };
};
var Jc = /* @__PURE__ */ ((t) => (t.center = "center", t.left = "left", t.right = "right", t))(Jc || {}), Ds = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t))(Ds || {}), iu = /* @__PURE__ */ ((t) => (t.top = "top", t.bottom = "bottom", t))(iu || {}), Pu = /* @__PURE__ */ ((t) => (t.header = "header", t.calendar = "calendar", t.timePicker = "timePicker", t))(Pu || {});
const xQe = (t, e, r, n, s, a, o) => {
  const l = ue({}), u = ue(!1), c = ue({
    top: "0",
    left: "0"
  }), d = ue(!1), h = Zg(o, "teleportCenter");
  Lr(h, () => {
    c.value = JSON.parse(JSON.stringify({})), T();
  });
  const f = (W) => {
    if (o.teleport) {
      const Q = W.getBoundingClientRect();
      return {
        left: Q.left + window.scrollX,
        top: Q.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, p = (W, Q) => {
    c.value.left = `${W + Q - l.value.width}px`;
  }, m = (W) => {
    c.value.left = `${W}px`;
  }, b = (W, Q) => {
    o.position === Jc.left && m(W), o.position === Jc.right && p(W, Q), o.position === Jc.center && (c.value.left = `${W + Q / 2 - l.value.width / 2}px`);
  }, y = (W) => {
    const { width: Q, height: te } = W.getBoundingClientRect(), { top: H, left: A } = o.altPosition ? o.altPosition(W) : f(W);
    return { top: +H, left: +A, width: Q, height: te };
  }, _ = () => {
    c.value.left = "50%", c.value.top = "50%", c.value.transform = "translate(-50%, -50%)", c.value.position = "fixed", delete c.value.opacity;
  }, x = () => {
    const W = un(r), { top: Q, left: te, transform: H } = o.altPosition(W);
    c.value = { top: `${Q}px`, left: `${te}px`, transform: H ?? "" };
  }, T = (W = !0) => {
    var Q;
    if (!s.value.enabled) {
      if (h.value)
        return _();
      if (o.altPosition !== null)
        return x();
      if (W) {
        const te = o.teleport ? (Q = e.value) == null ? void 0 : Q.$el : t.value;
        te && (l.value = te.getBoundingClientRect()), a("recalculate-position");
      }
      return P();
    }
  }, k = ({ inputEl: W, left: Q, width: te }) => {
    window.screen.width > 768 && !u.value && b(Q, te), R(W);
  }, E = (W) => {
    const { top: Q, left: te, height: H, width: A } = y(W);
    c.value.top = `${H + Q + +o.offset}px`, d.value = !1, u.value || (c.value.left = `${te + A / 2 - l.value.width / 2}px`), k({ inputEl: W, left: te, width: A });
  }, F = (W) => {
    const { top: Q, left: te, width: H } = y(W);
    c.value.top = `${Q - +o.offset - l.value.height}px`, d.value = !0, k({ inputEl: W, left: te, width: H });
  }, R = (W) => {
    if (o.autoPosition) {
      const { left: Q, width: te } = y(W), { left: H, right: A } = l.value;
      if (!u.value) {
        if (Math.abs(H) !== Math.abs(A)) {
          if (H <= 0)
            return u.value = !0, m(Q);
          if (A >= document.documentElement.clientWidth)
            return u.value = !0, p(Q, te);
        }
        return b(Q, te);
      }
    }
  }, $ = () => {
    const W = un(r);
    if (W) {
      const { height: Q } = l.value, { top: te, height: H } = W.getBoundingClientRect(), A = window.innerHeight - te - H, V = te;
      return Q <= A ? iu.bottom : Q > A && Q <= V ? iu.top : A >= V ? iu.bottom : iu.top;
    }
    return iu.bottom;
  }, O = (W) => $() === iu.bottom ? E(W) : F(W), P = () => {
    const W = un(r);
    if (W)
      return o.autoPosition ? O(W) : E(W);
  }, N = function(W) {
    if (W) {
      const Q = W.scrollHeight > W.clientHeight, te = window.getComputedStyle(W).overflowY.indexOf("hidden") !== -1;
      return Q && !te;
    }
    return !0;
  }, I = function(W) {
    return !W || W === document.body || W.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : N(W) ? W : I(W.parentNode);
  }, B = (W) => {
    if (W)
      switch (o.position) {
        case Jc.left:
          return { left: 0, transform: "translateX(0)" };
        case Jc.right:
          return { left: `${W.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${W.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: d,
    menuStyle: c,
    xCorrect: u,
    setMenuPosition: T,
    getScrollableParent: I,
    shadowRender: (W, Q) => {
      var te, H, A;
      const V = document.createElement("div"), M = (te = un(r)) == null ? void 0 : te.getBoundingClientRect();
      V.setAttribute("id", "dp--temp-container");
      const Z = (H = n.value) != null && H.clientWidth ? n.value : document.body;
      Z.append(V);
      const U = document.getElementById("dp--temp-container"), pe = B(M), q = G3(W, {
        ...Q,
        shadow: !0,
        style: { opacity: 0, position: "absolute", ...pe }
      });
      mI(q, U), l.value = (A = q.el) == null ? void 0 : A.getBoundingClientRect(), mI(null, U), Z.removeChild(U);
    }
  };
}, Zl = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] }
], SQe = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], EQe = {
  all: () => Zl,
  monthYear: () => Zl.filter((t) => t.use.includes("month-year")),
  input: () => SQe,
  timePicker: () => Zl.filter((t) => t.use.includes("time")),
  action: () => Zl.filter((t) => t.use.includes("action")),
  calendar: () => Zl.filter((t) => t.use.includes("calendar")),
  menu: () => Zl.filter((t) => t.use.includes("menu")),
  shared: () => Zl.filter((t) => t.use.includes("shared"))
}, Ys = (t, e, r) => {
  const n = [];
  return EQe[e]().forEach((s) => {
    t[s.name] && n.push(s.name);
  }), r != null && r.length && r.forEach((s) => {
    s.slot && n.push(s.slot);
  }), n;
}, Hv = (t) => {
  const e = Ce(() => (n) => t.value ? n ? t.value.open : t.value.close : ""), r = Ce(() => (n) => t.value ? n ? t.value.menuAppearTop : t.value.menuAppearBottom : "");
  return { transitionName: e, showTransition: !!t.value, menuTransition: r };
}, Ub = (t, e) => {
  const r = ue([{ month: Zt($e()), year: Yt($e()) }]), n = Na({
    hours: t.range ? [Da($e()), Da($e())] : Da($e()),
    minutes: t.range ? [Oa($e()), Oa($e())] : Oa($e()),
    seconds: t.range ? [0, 0] : 0
  }), s = Ce({
    get: () => t.internalModelValue,
    set: (l) => {
      !t.readonly && !t.disabled && e("update:internal-model-value", l);
    }
  }), a = Ce(
    () => (l) => r.value[l] ? r.value[l].month : 0
  ), o = Ce(
    () => (l) => r.value[l] ? r.value[l].year : 0
  );
  return {
    calendars: r,
    time: n,
    modelValue: s,
    month: a,
    year: o
  };
}, $Qe = (t, e) => {
  const { defaultedMultiCalendars: r } = Nn(e), { isDisabled: n, matchDate: s } = Gv(e), a = ue(null), o = ue($e()), l = (A) => {
    !A.current && e.hideOffsetDates || (a.value = A.value);
  }, u = () => {
    a.value = null;
  }, c = (A) => Array.isArray(t.value) && e.range && t.value[0] && a.value ? A ? Gn(a.value, t.value[0]) : Mn(a.value, t.value[0]) : !0, d = (A, V) => {
    const M = () => t.value ? V ? t.value[0] || null : t.value[1] : null, Z = t.value && Array.isArray(t.value) ? M() : null;
    return Jt($e(A.value), Z);
  }, h = (A) => {
    const V = Array.isArray(t.value) ? t.value[0] : null;
    return A ? !Mn(a.value ?? null, V) : !0;
  }, f = (A, V = !0) => (e.range || e.weekPicker) && Array.isArray(t.value) && t.value.length === 2 ? e.hideOffsetDates && !A.current ? !1 : Jt($e(A.value), t.value[V ? 0 : 1]) : e.range ? d(A, V) && h(V) || Jt(A.value, Array.isArray(t.value) ? t.value[0] : null) && c(V) : !1, p = (A, V, M) => Array.isArray(t.value) && t.value[0] && t.value.length === 1 ? A ? !1 : M ? Gn(t.value[0], V.value) : Mn(t.value[0], V.value) : !1, m = (A) => !t.value || e.hideOffsetDates && !A.current ? !1 : e.range ? e.modelAuto && Array.isArray(t.value) ? Jt(A.value, t.value[0] ? t.value[0] : o.value) : !1 : e.multiDates && Array.isArray(t.value) ? t.value.some((V) => Jt(V, A.value)) : Jt(A.value, t.value ? t.value : o.value), b = (A) => {
    if (e.autoRange || e.weekPicker) {
      if (a.value) {
        if (e.hideOffsetDates && !A.current)
          return !1;
        const V = no(a.value, +e.autoRange), M = Yg($e(a.value), e.timezone, e.weekStart);
        return e.weekPicker ? Jt(M[1], $e(A.value)) : Jt(V, $e(A.value));
      }
      return !1;
    }
    return !1;
  }, y = (A) => {
    if (e.autoRange || e.weekPicker) {
      if (a.value) {
        const V = no(a.value, +e.autoRange);
        if (e.hideOffsetDates && !A.current)
          return !1;
        const M = Yg($e(a.value), e.timezone, e.weekStart);
        return e.weekPicker ? Gn(A.value, M[0]) && Mn(A.value, M[1]) : Gn(A.value, a.value) && Mn(A.value, V);
      }
      return !1;
    }
    return !1;
  }, _ = (A) => {
    if (e.autoRange || e.weekPicker) {
      if (a.value) {
        if (e.hideOffsetDates && !A.current)
          return !1;
        const V = Yg($e(a.value), e.timezone, e.weekStart);
        return e.weekPicker ? Jt(V[0], A.value) : Jt(a.value, A.value);
      }
      return !1;
    }
    return !1;
  }, x = (A) => PA(t.value, a.value, A.value), T = () => e.modelAuto && Array.isArray(e.internalModelValue) ? !!e.internalModelValue[0] : !1, k = () => e.modelAuto ? mj(e.internalModelValue) : !0, E = (A) => {
    if (Array.isArray(t.value) && t.value.length || e.weekPicker)
      return !1;
    const V = e.range ? !f(A) && !f(A, !1) : !0;
    return !n(A.value) && !m(A) && !(!A.current && e.hideOffsetDates) && V;
  }, F = (A) => e.range ? e.modelAuto ? T() && m(A) : !1 : m(A), R = (A) => {
    var V;
    return e.highlight ? s(
      A.value,
      (V = e.arrMapValues) != null && V.highlightedDates ? e.arrMapValues.highlightedDates : e.highlight
    ) : !1;
  }, $ = (A) => n(A.value) && e.highlightDisabledDays === !1, O = (A) => {
    var V;
    return (V = e.highlightWeekDays) == null ? void 0 : V.includes(A.value.getDay());
  }, P = (A) => (e.range || e.weekPicker) && (!(r.value.count > 0) || A.current) && k() && !(!A.current && e.hideOffsetDates) && !m(A) ? x(A) : !1, N = (A) => {
    const { isRangeStart: V, isRangeEnd: M } = W(A), Z = e.range ? V || M : !1;
    return {
      dp__cell_offset: !A.current,
      dp__pointer: !e.disabled && !(!A.current && e.hideOffsetDates) && !n(A.value),
      dp__cell_disabled: n(A.value),
      dp__cell_highlight: !$(A) && (R(A) || O(A)) && !F(A) && !Z,
      dp__cell_highlight_active: !$(A) && (R(A) || O(A)) && F(A),
      dp__today: !e.noToday && Jt(A.value, o.value) && A.current
    };
  }, I = (A) => ({
    dp__active_date: F(A),
    dp__date_hover: E(A)
  }), B = (A) => ({
    ...Q(A),
    ...te(A),
    dp__range_between_week: P(A) && e.weekPicker
  }), W = (A) => {
    const V = r.value.count > 0 ? A.current && f(A) && k() : f(A) && k(), M = r.value.count > 0 ? A.current && f(A, !1) && k() : f(A, !1) && k();
    return { isRangeStart: V, isRangeEnd: M };
  }, Q = (A) => {
    const { isRangeStart: V, isRangeEnd: M } = W(A);
    return {
      dp__range_start: V,
      dp__range_end: M,
      dp__range_between: P(A) && !e.weekPicker,
      dp__date_hover_start: p(E(A), A, !0),
      dp__date_hover_end: p(E(A), A, !1)
    };
  }, te = (A) => ({
    ...Q(A),
    dp__cell_auto_range: y(A),
    dp__cell_auto_range_start: _(A),
    dp__cell_auto_range_end: b(A)
  }), H = (A) => e.range ? e.autoRange ? te(A) : e.modelAuto ? { ...I(A), ...Q(A) } : Q(A) : e.weekPicker ? B(A) : I(A);
  return {
    setHoverDate: l,
    clearHoverDate: u,
    getDayClassData: (A) => e.hideOffsetDates && !A.current ? {} : {
      ...N(A),
      ...H(A),
      [e.dayClass ? e.dayClass(A.value) : ""]: !0,
      [e.calendarCellClassName]: !!e.calendarCellClassName
    }
  };
}, Gv = (t) => {
  const { defaultedFilters: e } = Nn(t), r = ($) => {
    const O = ms(n($e($))).toISOString(), [P] = O.split("T");
    return P;
  }, n = ($) => Ta($, t.timezone), s = ($) => {
    var O;
    const P = t.maxDate ? Gn(n($), n($e(t.maxDate))) : !1, N = t.minDate ? Mn(n($), n($e(t.minDate))) : !1, I = u(
      $,
      (O = t.arrMapValues) != null && O.disabledDates ? t.arrMapValues.disabledDates : t.disabledDates
    ), B = e.value.months.map((A) => +A).includes(Zt($)), W = t.disabledWeekDays.length ? t.disabledWeekDays.some((A) => +A === iqe($)) : !1, Q = d($), te = Yt($), H = te < +t.yearRange[0] || te > +t.yearRange[1];
    return !(P || N || I || B || H || W || Q);
  }, a = ($, O) => Mn(...fl(t.minDate, $, O)) || Jt(...fl(t.minDate, $, O)), o = ($, O) => Gn(...fl(t.maxDate, $, O)) || Jt(...fl(t.maxDate, $, O)), l = ($, O, P) => {
    let N = !1;
    return t.maxDate && P && o($, O) && (N = !0), t.minDate && !P && a($, O) && (N = !0), N;
  }, u = ($, O) => $ ? O instanceof Map ? !!O.get(r($)) : Array.isArray(O) ? O.some((P) => Jt(n($e(P)), n($))) : O ? O($e(JSON.parse(JSON.stringify($)))) : !1 : !0, c = ($, O, P, N) => {
    let I = !1;
    return N ? t.minDate && t.maxDate ? I = l($, O, P) : (t.minDate && a($, O) || t.maxDate && o($, O)) && (I = !0) : I = !0, I;
  }, d = ($) => {
    var O, P, N, I, B;
    return Array.isArray(t.allowedDates) && !((O = t.allowedDates) != null && O.length) ? !0 : (P = t.arrMapValues) != null && P.allowedDates ? !u($, (N = t.arrMapValues) == null ? void 0 : N.allowedDates) : (I = t.allowedDates) != null && I.length ? !((B = t.allowedDates) != null && B.some((W) => Jt(n($e(W)), n($)))) : !1;
  }, h = ($) => !s($), f = ($) => !WW({ start: $[0], end: $[1] }).some((O) => h(O)), p = ($, O, P = 0) => {
    if (Array.isArray(O) && O[P]) {
      const N = jze($, O[P]), I = bj(O[P], $), B = I.length === 1 ? 0 : I.filter((Q) => h(Q)).length, W = Math.abs(N) - B;
      if (t.minRange && t.maxRange)
        return W >= +t.minRange && W <= +t.maxRange;
      if (t.minRange)
        return W >= +t.minRange;
      if (t.maxRange)
        return W <= +t.maxRange;
    }
    return !0;
  }, m = ($) => new Map($.map((O) => [r(O), !0])), b = ($) => Array.isArray($) && $.length > 0, y = () => {
    const $ = {
      disabledDates: null,
      allowedDates: null,
      highlightedDates: null
    };
    return b(t.allowedDates) && ($.allowedDates = m(t.allowedDates)), b(t.highlight) && ($.highlightedDates = m(t.highlight)), b(t.disabledDates) && ($.disabledDates = m(t.disabledDates)), $;
  }, _ = () => !t.enableTimePicker || t.monthPicker || t.yearPicker || t.ignoreTimeValidation, x = ($) => Array.isArray($) ? [$[0] ? wT($[0]) : null, $[1] ? wT($[1]) : null] : wT($), T = ($, O, P) => $.find(
    (N) => +N.hours === Da(O) && N.minutes === "*" ? !0 : +N.minutes === Oa(O)
  ) && P, k = ($, O, P) => {
    const [N, I] = $, [B, W] = O;
    return !T(N, B, P) && !T(I, W, P) && P;
  }, E = ($, O) => {
    const P = Array.isArray(O) ? O : [O];
    return Array.isArray(t.disabledTimes) ? Array.isArray(t.disabledTimes[0]) ? k(t.disabledTimes, P, $) : !P.some((N) => T(t.disabledTimes, N, $)) : $;
  }, F = ($, O) => {
    const P = Array.isArray(O) ? [Iu(O[0]), O[1] ? Iu(O[1]) : void 0] : Iu(O), N = !t.disabledTimes(P);
    return $ && N;
  }, R = ($, O) => t.disabledTimes ? Array.isArray(t.disabledTimes) ? E(O, $) : F(O, $) : O;
  return {
    isDisabled: h,
    validateDate: s,
    validateMonthYearInRange: c,
    isDateRangeAllowed: f,
    checkMinMaxRange: p,
    matchDate: u,
    mapDatesArrToMap: y,
    isValidTime: ($) => {
      let O = !0;
      if (!$ || _())
        return !0;
      const P = !t.minDate && !t.maxDate ? x($) : $;
      return (t.maxTime || t.maxDate) && (O = TB(t.maxTime, t.maxDate, "max", mn(P), O)), (t.minTime || t.minDate) && (O = TB(t.minTime, t.minDate, "min", mn(P), O)), R($, O);
    }
  };
}, Vb = () => {
  const t = Ce(() => (n, s) => n == null ? void 0 : n.includes(s)), e = Ce(() => (n, s) => n.count ? n.solo ? !0 : s === 0 : !0), r = Ce(() => (n, s) => n.count ? n.solo ? !0 : s === n.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: e, showRightIcon: r };
}, kQe = (t, e, r) => {
  const n = ue(0), s = Na({
    // monthYearInput: !!props.timePicker,
    [Pu.timePicker]: !t.enableTimePicker || t.timePicker || t.monthPicker,
    [Pu.calendar]: !1,
    [Pu.header]: !1
  }), a = (d) => {
    var h;
    (h = t.flow) != null && h.length && (s[d] = !0, Object.keys(s).filter((f) => !s[f]).length || c());
  }, o = () => {
    var d;
    (d = t.flow) != null && d.length && n.value !== -1 && (n.value += 1, e("flow-step", n.value), c());
  }, l = () => {
    n.value = -1;
  }, u = (d, h, ...f) => {
    t.flow[n.value] === d && r.value && r.value[h](...f);
  }, c = () => {
    u("month", "toggleMonthPicker", !0), u("year", "toggleYearPicker", !0), u("calendar", "toggleTimePicker", !1, !0), u("time", "toggleTimePicker", !0, !0);
    const d = t.flow[n.value];
    (d === "hours" || d === "minutes" || d === "seconds") && u(d, "toggleTimePicker", !0, !0, d);
  };
  return { childMount: a, updateFlowStep: o, resetFlow: l, flowStep: n };
}, Yb = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  closeOnScroll: { type: Boolean, default: !1 },
  autoPosition: { type: Boolean, default: !0 },
  closeOnAutoApply: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: String, default: null },
  emitTimezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: { type: Function, default: null },
  yearRange: { type: Array, default: () => [1900, 2100] },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  modeHeight: { type: [Number, String], default: 255 },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  keepActionRow: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Array, Function],
    default: null
  },
  highlightWeekDays: {
    type: Array,
    default: null
  },
  highlightDisabledDays: { type: Boolean, default: !1 },
  teleport: { type: [String, Boolean], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function],
    default: null
  },
  calendarClassName: { type: String, default: null },
  noSwipe: { type: Boolean, default: !1 },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: Boolean, default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: Boolean, default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  onClickOutside: { type: Function, default: null },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  allowPreventDefault: { type: Boolean, default: !1 },
  closeOnClearValue: { type: Boolean, default: !0 },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  showLastInRange: { type: Boolean, default: !0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null }
}, Ho = {
  ...Yb,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  arrMapValues: { type: Object, default: () => ({}) }
}, DQe = {
  key: 1,
  class: "dp__input_wrap"
}, OQe = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "onKeydown"], AQe = {
  key: 2,
  class: "dp__clear_icon"
}, CQe = /* @__PURE__ */ Dt({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...Yb
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur"
  ],
  setup(t, { expose: e, emit: r }) {
    const n = t, { defaultedTextInput: s, defaultedAriaLabels: a, defaultedInline: o, getDefaultPattern: l, getDefaultStartTime: u } = Nn(n), c = ue(), d = ue(null), h = ue(!1), f = ue(!1), p = Ce(
      () => ({
        dp__pointer: !n.disabled && !n.readonly && !s.value.enabled,
        dp__disabled: n.disabled,
        dp__input_readonly: !s.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !n.hideInputIcon,
        dp__input_valid: n.state,
        dp__input_invalid: n.state === !1,
        dp__input_focus: h.value || n.isMenuOpen,
        dp__input_reg: !s.value.enabled,
        [n.inputClassName]: !!n.inputClassName
      })
    ), m = () => {
      r("set-input-date", null), n.autoApply && (r("set-empty-date"), c.value = null);
    }, b = (N) => {
      const I = u();
      return sQe(
        N,
        s.value.format ?? l(),
        I ?? _j({}, n.enableSeconds),
        n.inputValue,
        f.value
      );
    }, y = (N) => {
      const { rangeSeparator: I } = s.value, [B, W] = N.split(`${I}`);
      if (B) {
        const Q = b(B.trim()), te = W ? b(W.trim()) : null, H = Q && te ? [Q, te] : [Q];
        c.value = Q ? H : null;
      }
    }, _ = () => {
      f.value = !0;
    }, x = (N) => {
      if (n.range)
        y(N);
      else if (n.multiDates) {
        const I = N.split(";");
        c.value = I.map((B) => b(B.trim())).filter((B) => B);
      } else
        c.value = b(N);
    }, T = (N) => {
      var I;
      const B = typeof N == "string" ? N : (I = N.target) == null ? void 0 : I.value;
      B !== "" ? (s.value.openMenu && !n.isMenuOpen && r("open"), x(B), r("set-input-date", c.value)) : m(), f.value = !1, r("update:input-value", B);
    }, k = (N) => {
      s.value.enabled ? (x(N.target.value), s.value.enterSubmit && fk(c.value) && n.inputValue !== "" ? (r("set-input-date", c.value, !0), c.value = null) : s.value.enterSubmit && n.inputValue === "" && (c.value = null, r("clear"))) : R(N);
    }, E = (N) => {
      s.value.enabled && s.value.tabSubmit && x(N.target.value), s.value.tabSubmit && fk(c.value) && n.inputValue !== "" ? (r("set-input-date", c.value, !0), c.value = null) : s.value.tabSubmit && n.inputValue === "" && (c.value = null, r("clear"));
    }, F = () => {
      h.value = !0, r("focus");
    }, R = (N) => {
      N.preventDefault(), N.stopImmediatePropagation(), N.stopPropagation(), s.value.enabled && s.value.openMenu && !o.value.input && !n.isMenuOpen ? r("open") : s.value.enabled || r("toggle");
    }, $ = () => {
      r("real-blur"), h.value = !1, (!n.isMenuOpen || o.value.enabled && o.value.input) && r("blur"), n.autoApply && s.value.enabled && c.value && !n.isMenuOpen && (r("set-input-date", c.value), r("select-date"), c.value = null);
    }, O = () => {
      r("clear");
    }, P = (N) => {
      if (!s.value.enabled) {
        if (N.code === "Tab")
          return;
        N.preventDefault();
      }
    };
    return e({
      focusInput: () => {
        var N;
        (N = d.value) == null || N.focus({ preventScroll: !0 });
      },
      setParsedDate: (N) => {
        c.value = N;
      }
    }), (N, I) => {
      var B;
      return re(), ye("div", { onClick: R }, [
        N.$slots.trigger && !N.$slots["dp-input"] && !X(o).enabled ? We(N.$slots, "trigger", { key: 0 }) : be("", !0),
        !N.$slots.trigger && (!X(o).enabled || X(o).input) ? (re(), ye("div", DQe, [
          N.$slots["dp-input"] && !N.$slots.trigger && !X(o).enabled ? We(N.$slots, "dp-input", {
            key: 0,
            value: t.inputValue,
            isMenuOpen: t.isMenuOpen,
            onInput: T,
            onEnter: k,
            onTab: E,
            onClear: O,
            onBlur: $,
            onKeypress: P,
            onPaste: _
          }) : be("", !0),
          N.$slots["dp-input"] ? be("", !0) : (re(), ye("input", {
            key: 1,
            ref_key: "inputRef",
            ref: d,
            id: N.uid ? `dp-input-${N.uid}` : void 0,
            name: N.name,
            class: wt(p.value),
            inputmode: X(s).enabled ? "text" : "none",
            placeholder: N.placeholder,
            disabled: N.disabled,
            readonly: N.readonly,
            required: N.required,
            value: t.inputValue,
            autocomplete: N.autocomplete,
            "aria-label": (B = X(a)) == null ? void 0 : B.input,
            onInput: T,
            onKeydown: [
              pt(k, ["enter"]),
              pt(E, ["tab"]),
              P
            ],
            onBlur: $,
            onFocus: F,
            onKeypress: P,
            onPaste: _
          }, null, 42, OQe)),
          ke("div", {
            onClick: I[2] || (I[2] = (W) => r("toggle"))
          }, [
            N.$slots["input-icon"] && !N.hideInputIcon ? (re(), ye("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: I[0] || (I[0] = (W) => r("toggle"))
            }, [
              We(N.$slots, "input-icon")
            ])) : be("", !0),
            !N.$slots["input-icon"] && !N.hideInputIcon && !N.$slots["dp-input"] ? (re(), ot(X(Yv), {
              key: 1,
              onClick: I[1] || (I[1] = (W) => r("toggle")),
              class: "dp__input_icon dp__input_icons"
            })) : be("", !0)
          ]),
          N.$slots["clear-icon"] && t.inputValue && N.clearable && !N.disabled && !N.readonly ? (re(), ye("span", AQe, [
            We(N.$slots, "clear-icon", { clear: O })
          ])) : be("", !0),
          N.clearable && !N.$slots["clear-icon"] && t.inputValue && !N.disabled && !N.readonly ? (re(), ot(X(dj), {
            key: 3,
            class: "dp__clear_icon dp__input_icons",
            onClick: kt(O, ["stop", "prevent"])
          }, null, 8, ["onClick"])) : be("", !0)
        ])) : be("", !0)
      ]);
    };
  }
}), IQe = ["title"], PQe = { class: "dp__action_buttons" }, RQe = ["onKeydown", "disabled"], MQe = /* @__PURE__ */ Dt({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...Ho
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(t, { emit: e }) {
    const r = t, {
      defaultedActionRow: n,
      defaultedPreviewFormat: s,
      defaultedMultiCalendars: a,
      defaultedTextInput: o,
      defaultedInline: l,
      getDefaultPattern: u
    } = Nn(r), { isValidTime: c } = Gv(r), { buildMatrix: d } = Ul(), h = ue(null), f = ue(null);
    Nr(() => {
      r.arrowNavigation && d([un(h), un(f)], "actionRow");
    });
    const p = Ce(() => r.range && !r.partialRange && r.internalModelValue ? r.internalModelValue.length === 2 : !0), m = Ce(() => !b.value || !y.value || !p.value), b = Ce(() => !r.enableTimePicker || r.ignoreTimeValidation ? !0 : c(r.internalModelValue)), y = Ce(() => r.monthPicker ? r.range && Array.isArray(r.internalModelValue) ? !r.internalModelValue.filter((O) => !R(O)).length : R(r.internalModelValue) : !0), _ = () => {
      const O = s.value;
      return r.timePicker || r.monthPicker, O(mn(r.internalModelValue));
    }, x = () => {
      const O = r.internalModelValue;
      return a.value.count > 0 ? `${T(O[0])} - ${T(O[1])}` : [T(O[0]), T(O[1])];
    }, T = (O) => Tj(
      O,
      s.value,
      r.formatLocale,
      o.value.rangeSeparator,
      r.modelAuto,
      u()
    ), k = Ce(() => !r.internalModelValue || !r.menuMount ? "" : typeof s.value == "string" ? Array.isArray(r.internalModelValue) ? r.internalModelValue.length === 2 && r.internalModelValue[1] ? x() : r.multiDates ? r.internalModelValue.map((O) => `${T(O)}`) : r.modelAuto ? `${T(r.internalModelValue[0])}` : `${T(r.internalModelValue[0])} -` : T(r.internalModelValue) : _()), E = () => r.multiDates ? "; " : " - ", F = Ce(
      () => Array.isArray(k.value) ? k.value.join(E()) : k.value
    ), R = (O) => {
      if (!r.monthPicker)
        return !0;
      let P = !0;
      const N = $e(Ls(O));
      if (r.minDate && r.maxDate) {
        const I = $e(Ls(r.minDate)), B = $e(Ls(r.maxDate));
        return Gn(N, I) && Mn(N, B) || Jt(N, I) || Jt(N, B);
      }
      if (r.minDate) {
        const I = $e(Ls(r.minDate));
        P = Gn(N, I) || Jt(N, I);
      }
      if (r.maxDate) {
        const I = $e(Ls(r.maxDate));
        P = Mn(N, I) || Jt(N, I);
      }
      return P;
    }, $ = () => {
      b.value && y.value && p.value ? e("select-date") : e("invalid-select");
    };
    return (O, P) => (re(), ye("div", {
      class: "dp__action_row",
      style: ri(t.calendarWidth ? { width: `${t.calendarWidth}px` } : {})
    }, [
      O.$slots["action-row"] ? We(O.$slots, "action-row", Hn(ni({ key: 0 }, {
        internalModelValue: O.internalModelValue,
        disabled: m.value,
        selectDate: () => O.$emit("select-date"),
        closePicker: () => O.$emit("close-picker")
      }))) : (re(), ye(Je, { key: 1 }, [
        X(n).showPreview ? (re(), ye("div", {
          key: 0,
          class: "dp__selection_preview",
          title: F.value
        }, [
          O.$slots["action-preview"] ? We(O.$slots, "action-preview", {
            key: 0,
            value: O.internalModelValue
          }) : be("", !0),
          O.$slots["action-preview"] ? be("", !0) : (re(), ye(Je, { key: 1 }, [
            Ra(er(F.value), 1)
          ], 64))
        ], 8, IQe)) : be("", !0),
        ke("div", PQe, [
          O.$slots["action-buttons"] ? We(O.$slots, "action-buttons", {
            key: 0,
            value: O.internalModelValue
          }) : be("", !0),
          O.$slots["action-buttons"] ? be("", !0) : (re(), ye(Je, { key: 1 }, [
            !X(l).enabled && X(n).showCancel ? (re(), ye("button", {
              key: 0,
              type: "button",
              ref_key: "cancelButtonRef",
              ref: h,
              class: "dp__action_button dp__action_cancel",
              onClick: P[0] || (P[0] = (N) => O.$emit("close-picker")),
              onKeydown: [
                P[1] || (P[1] = pt((N) => O.$emit("close-picker"), ["enter"])),
                P[2] || (P[2] = pt((N) => O.$emit("close-picker"), ["space"]))
              ]
            }, er(O.cancelText), 545)) : be("", !0),
            X(n).showNow ? (re(), ye("button", {
              key: 1,
              type: "button",
              ref_key: "cancelButtonRef",
              ref: h,
              class: "dp__action_button dp__action_cancel",
              onClick: P[3] || (P[3] = (N) => O.$emit("select-now")),
              onKeydown: [
                P[4] || (P[4] = pt((N) => O.$emit("select-now"), ["enter"])),
                P[5] || (P[5] = pt((N) => O.$emit("select-now"), ["space"]))
              ]
            }, er(O.nowButtonLabel), 545)) : be("", !0),
            X(n).showSelect ? (re(), ye("button", {
              key: 2,
              type: "button",
              class: "dp__action_button dp__action_select",
              onKeydown: [
                pt($, ["enter"]),
                pt($, ["space"])
              ],
              onClick: $,
              disabled: m.value,
              ref_key: "selectButtonRef",
              ref: f
            }, er(O.selectText), 41, RQe)) : be("", !0)
          ], 64))
        ])
      ], 64))
    ], 4));
  }
}), LQe = ["onKeydown"], NQe = { class: "dp__selection_grid_header" }, FQe = ["aria-selected", "aria-disabled", "onClick", "onKeydown", "onMouseover"], BQe = ["aria-label", "onKeydown"], kp = /* @__PURE__ */ Dt({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] }
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(t, { expose: e, emit: r }) {
    const n = t, { setSelectionGrid: s, buildMultiLevelMatrix: a, setMonthPicker: o } = Ul(), { defaultedAriaLabels: l, defaultedTextInput: u } = Nn(n), { hideNavigationButtons: c } = Vb(), d = ue(!1), h = ue(null), f = ue(null), p = ue([]), m = ue(), b = ue(null), y = ue(0), _ = ue(null);
    w3(() => {
      h.value = null;
    }), Nr(() => {
      Ia().then(() => O()), T(), x(!0);
    }), ih(() => x(!1));
    const x = (H) => {
      var A;
      n.arrowNavigation && ((A = n.headerRefs) != null && A.length ? o(H) : s(H));
    }, T = () => {
      var H;
      const A = un(f);
      A && (u.value.enabled || (h.value ? (H = h.value) == null || H.focus({ preventScroll: !0 }) : A.focus({ preventScroll: !0 })), d.value = A.clientHeight < A.scrollHeight);
    }, k = Ce(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !n.useRelative,
        "dp--overlay-relative": n.useRelative
      })
    ), E = Ce(
      () => n.useRelative ? { height: `${n.height}px`, width: "260px" } : void 0
    ), F = Ce(() => ({
      dp__overlay_col: !0
    })), R = Ce(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: d.value,
        dp__button_bottom: n.isLast
      })
    ), $ = Ce(() => {
      var H, A;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((H = n.items) == null ? void 0 : H.length) <= 6,
        dp__container_block: ((A = n.items) == null ? void 0 : A.length) > 6
      };
    }), O = () => {
      Ia().then(() => {
        const H = un(h), A = un(f), V = un(b), M = un(_), Z = V ? V.getBoundingClientRect().height : 0;
        A && (y.value = A.getBoundingClientRect().height - Z), H && M && (M.scrollTop = H.offsetTop - M.offsetTop - (y.value / 2 - H.getBoundingClientRect().height) - Z);
      });
    }, P = (H) => {
      H.disabled || r("selected", H.value);
    }, N = () => {
      r("toggle"), r("reset-flow");
    }, I = () => {
      n.escClose && N();
    }, B = (H, A, V, M) => {
      H && (A.active && (h.value = H), n.arrowNavigation && (Array.isArray(p.value[V]) ? p.value[V][M] = H : p.value[V] = [H], W()));
    }, W = () => {
      var H, A;
      const V = (H = n.headerRefs) != null && H.length ? [n.headerRefs].concat(p.value) : p.value.concat([n.skipButtonRef ? [] : [b.value]]);
      a(mn(V), (A = n.headerRefs) != null && A.length ? "monthPicker" : "selectionGrid");
    }, Q = (H) => {
      n.arrowNavigation || H.stopImmediatePropagation();
    }, te = (H) => {
      m.value = H, r("hover-value", H);
    };
    return e({ focusGrid: T }), (H, A) => {
      var V;
      return re(), ye("div", {
        ref_key: "gridWrapRef",
        ref: f,
        class: wt(k.value),
        style: ri(E.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: [
          pt(kt(I, ["prevent"]), ["esc"]),
          A[0] || (A[0] = pt(kt((M) => Q(M), ["prevent"]), ["left"])),
          A[1] || (A[1] = pt(kt((M) => Q(M), ["prevent"]), ["up"])),
          A[2] || (A[2] = pt(kt((M) => Q(M), ["prevent"]), ["down"])),
          A[3] || (A[3] = pt(kt((M) => Q(M), ["prevent"]), ["right"]))
        ]
      }, [
        ke("div", {
          class: wt($.value),
          ref_key: "containerRef",
          ref: _,
          role: "grid",
          style: ri({ height: `${y.value}px` })
        }, [
          ke("div", NQe, [
            We(H.$slots, "header")
          ]),
          H.$slots.overlay ? We(H.$slots, "overlay", { key: 0 }) : (re(!0), ye(Je, { key: 1 }, Mr(H.items, (M, Z) => (re(), ye("div", {
            class: wt(["dp__overlay_row", { dp__flex_row: H.items.length >= 3 }]),
            key: Z,
            role: "row"
          }, [
            (re(!0), ye(Je, null, Mr(M, (U, pe) => (re(), ye("div", {
              role: "gridcell",
              class: wt(F.value),
              key: U.value,
              "aria-selected": U.active,
              "aria-disabled": U.disabled || void 0,
              ref_for: !0,
              ref: (q) => B(q, U, Z, pe),
              tabindex: "0",
              onClick: (q) => P(U),
              onKeydown: [
                pt(kt((q) => P(U), ["prevent"]), ["enter"]),
                pt(kt((q) => P(U), ["prevent"]), ["space"])
              ],
              onMouseover: (q) => te(U.value)
            }, [
              ke("div", {
                class: wt(U.className)
              }, [
                H.$slots.item ? We(H.$slots, "item", {
                  key: 0,
                  item: U
                }) : be("", !0),
                H.$slots.item ? be("", !0) : (re(), ye(Je, { key: 1 }, [
                  Ra(er(U.text), 1)
                ], 64))
              ], 2)
            ], 42, FQe))), 128))
          ], 2))), 128))
        ], 6),
        H.$slots["button-icon"] ? gd((re(), ye("button", {
          key: 0,
          role: "button",
          "aria-label": (V = X(l)) == null ? void 0 : V.toggleOverlay,
          class: wt(R.value),
          tabindex: "0",
          ref_key: "toggleButton",
          ref: b,
          onClick: N,
          onKeydown: [
            pt(N, ["enter"]),
            pt(N, ["tab"])
          ]
        }, [
          We(H.$slots, "button-icon")
        ], 42, BQe)), [
          [_d, !X(c)(H.hideNavigation, H.type)]
        ]) : be("", !0)
      ], 46, LQe);
    };
  }
}), RA = /* @__PURE__ */ Dt({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean }
  },
  setup(t) {
    const e = t, r = Ce(
      () => e.multiCalendars > 0 ? [...Array(e.multiCalendars).keys()] : [0]
    ), n = Ce(() => ({
      dp__instance_calendar: e.multiCalendars > 0
    }));
    return (s, a) => (re(), ye("div", {
      class: wt({
        dp__menu_inner: !s.stretch,
        "dp--menu--inner-stretched": s.stretch,
        dp__flex_display: s.multiCalendars > 0
      })
    }, [
      (re(!0), ye(Je, null, Mr(r.value, (o, l) => (re(), ye("div", {
        key: o,
        class: wt(n.value)
      }, [
        We(s.$slots, "default", {
          instance: o,
          index: l
        })
      ], 2))), 128))
    ], 2));
  }
}), UQe = ["aria-label", "aria-disabled"], Uf = /* @__PURE__ */ Dt({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(t, { emit: e }) {
    const r = ue(null);
    return Nr(() => e("set-ref", r)), (n, s) => (re(), ye("button", {
      type: "button",
      class: "dp__btn dp--arrow-btn-nav",
      onClick: s[0] || (s[0] = (a) => n.$emit("activate")),
      onKeydown: [
        s[1] || (s[1] = pt(kt((a) => n.$emit("activate"), ["prevent"]), ["enter"])),
        s[2] || (s[2] = pt(kt((a) => n.$emit("activate"), ["prevent"]), ["space"]))
      ],
      tabindex: "0",
      "aria-label": n.ariaLabel,
      "aria-disabled": n.disabled || void 0,
      ref_key: "elRef",
      ref: r
    }, [
      ke("span", {
        class: wt(["dp__inner_nav", { dp__inner_nav_disabled: n.disabled }])
      }, [
        We(n.$slots, "default")
      ], 2)
    ], 40, UQe));
  }
}), MA = (t, e, r) => {
  if (e.value && Array.isArray(e.value))
    if (e.value.some((n) => Jt(t, n))) {
      const n = e.value.filter((s) => !Jt(s, t));
      e.value = n.length ? n : null;
    } else
      (r && +r > e.value.length || !r) && e.value.push(t);
  else
    e.value = [t];
}, Sj = (t, e, r) => {
  let n = t.value ? t.value.slice() : [];
  return n.length === 2 && n[1] !== null && (n = []), n.length ? Mn(e, n[0]) ? (n.unshift(e), r("range-start", n[0]), r("range-start", n[1])) : (n[1] = e, r("range-end", e)) : (n = [e], r("range-start", e)), t.value = n, n;
}, LA = (t, e, r, n) => {
  t[0] && t[1] && r && e("auto-apply"), t[0] && !t[1] && n && r && e("auto-apply");
}, VQe = (t, e) => {
  const { defaultedMultiCalendars: r, defaultedAriaLabels: n, defaultedTransitions: s } = Nn(t), { modelValue: a, year: o, month: l, calendars: u } = Ub(t, e), c = Ce(() => vj(t.formatLocale, t.locale, t.monthNameFormat)), d = Ce(() => IA(t.yearRange, t.reverseYears)), h = ue(null), f = () => {
    for (let I = 0; I < r.value.count; I++)
      if (I === 0)
        u.value[I] = u.value[0];
      else {
        const B = Xr($e(), u.value[I - 1]);
        u.value[I] = { month: Zt(B), year: Yt(gA(B, I)) };
      }
  }, p = (I) => {
    if (!I)
      return f();
    const B = Xr($e(), u.value[I]);
    return u.value[0].year = Yt(cj(B, r.value.count - 1)), f();
  }, m = (I) => t.focusStartDate ? I[0] : I[1] ? I[1] : I[0], b = () => {
    if (a.value) {
      const I = Array.isArray(a.value) ? m(a.value) : a.value;
      u.value[0] = { month: Zt(I), year: Yt(I) };
    }
  };
  Nr(() => {
    b(), r.value.count && f();
  });
  const y = Ce(() => (I, B) => {
    const W = Xr(Ls(/* @__PURE__ */ new Date()), {
      month: l.value(I),
      year: o.value(I)
    });
    return wj(W, t.maxDate, t.minDate, t.preventMinMaxNavigation, B);
  }), _ = (I) => I ? { month: Zt(I), year: Yt(I) } : { month: null, year: null }, x = () => a.value ? Array.isArray(a.value) ? a.value.map((I) => _(I)) : _(a.value) : _(), T = (I, B) => {
    const W = u.value[I], Q = x();
    return Array.isArray(Q) ? Q.some((te) => te.year === (W == null ? void 0 : W.year) && te.month === B) : (W == null ? void 0 : W.year) === Q.year && B === Q.month;
  }, k = (I, B, W) => {
    var Q, te;
    const H = x();
    return Array.isArray(H) ? o.value(B) === ((Q = H[W]) == null ? void 0 : Q.year) && I === ((te = H[W]) == null ? void 0 : te.month) : !1;
  }, E = (I, B) => {
    if (t.range) {
      const W = x();
      if (Array.isArray(a.value) && Array.isArray(W)) {
        const Q = k(I, B, 0) || k(I, B, 1), te = lo(Ls($e()), I, o.value(B));
        return PA(a.value, h.value, te) && !Q;
      }
      return !1;
    }
    return !1;
  }, F = Ce(() => (I) => th(c.value, (B) => {
    const W = T(I, B.value), Q = $p(
      B.value,
      gj(o.value(I), t.minDate),
      yj(o.value(I), t.maxDate)
    ) || hQe(t.disabledDates, o.value(I)).includes(B.value), te = E(B.value, I);
    return { active: W, disabled: Q, isBetween: te };
  })), R = Ce(() => (I) => th(d.value, (B) => {
    const W = o.value(I) === B.value, Q = $p(B.value, rh(t.minDate), rh(t.maxDate));
    return { active: W, disabled: Q };
  })), $ = (I, B) => lo(Ls($e()), I, o.value(B)), O = (I, B) => {
    const W = a.value ? a.value : Ls(/* @__PURE__ */ new Date());
    a.value = lo(W, I, o.value(B)), e("auto-apply");
  }, P = (I, B) => {
    const W = Sj(a, $(I, B), e);
    LA(W, e, t.autoApply, t.modelAuto);
  }, N = (I, B) => {
    MA($(I, B), a, t.multiDatesLimit), e("auto-apply", !0);
  };
  return {
    groupedMonths: F,
    groupedYears: R,
    year: o,
    isDisabled: y,
    defaultedMultiCalendars: r,
    defaultedAriaLabels: n,
    defaultedTransitions: s,
    setHoverDate: (I, B) => {
      h.value = $(I, B);
    },
    selectMonth: (I, B) => (u.value[B].month = I, t.multiDates ? N(I, B) : t.range ? P(I, B) : O(I, B)),
    selectYear: (I, B) => {
      u.value[B].year = I, r.value.count && !r.value.solo && p(B);
    }
  };
}, YQe = { class: "dp__month_picker_header" }, HQe = ["aria-label", "onClick", "onKeydown"], GQe = /* @__PURE__ */ Dt({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...Ho
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply"
  ],
  setup(t, { emit: e }) {
    const r = t, {
      groupedMonths: n,
      groupedYears: s,
      year: a,
      isDisabled: o,
      defaultedMultiCalendars: l,
      defaultedAriaLabels: u,
      defaultedTransitions: c,
      setHoverDate: d,
      selectMonth: h,
      selectYear: f
    } = VQe(r, e), { transitionName: p, showTransition: m } = Hv(c), { showRightIcon: b, showLeftIcon: y } = Vb(), _ = ue([!1]), x = (E, F) => {
      f(E, F), k(F);
    }, T = (E, F = !1) => {
      if (!o.value(E, F)) {
        const R = F ? a.value(E) + 1 : a.value(E) - 1;
        f(R, E);
      }
    }, k = (E, F = !1, R) => {
      F || e("reset-flow"), R !== void 0 ? _.value[E] = R : _.value[E] = !_.value[E], _.value || e("overlay-closed");
    };
    return (E, F) => (re(), ot(RA, {
      "multi-calendars": X(l).count,
      stretch: ""
    }, {
      default: tt(({ instance: R }) => [
        je(kp, {
          items: X(n)(R),
          "arrow-navigation": E.arrowNavigation,
          "is-last": E.autoApply && !E.keepActionRow,
          "esc-close": E.escClose,
          height: E.modeHeight,
          onSelected: ($) => X(h)($, R),
          onHoverValue: ($) => X(d)($, R),
          "use-relative": "",
          type: "month"
        }, {
          header: tt(() => {
            var $, O, P;
            return [
              ke("div", YQe, [
                X(y)(X(l), R) ? (re(), ot(Uf, {
                  key: 0,
                  ref: "mpPrevIconRef",
                  "aria-label": ($ = X(u)) == null ? void 0 : $.prevYear,
                  disabled: X(o)(R, !1),
                  onActivate: (N) => T(R, !1)
                }, {
                  default: tt(() => [
                    E.$slots["arrow-left"] ? We(E.$slots, "arrow-left", { key: 0 }) : be("", !0),
                    E.$slots["arrow-left"] ? be("", !0) : (re(), ot(X(SA), { key: 1 }))
                  ]),
                  _: 2
                }, 1032, ["aria-label", "disabled", "onActivate"])) : be("", !0),
                ke("div", {
                  class: "dp--year-select",
                  role: "button",
                  ref: "mpYearButtonRef",
                  "aria-label": (O = X(u)) == null ? void 0 : O.openYearsOverlay,
                  tabindex: "0",
                  onClick: () => k(R, !1),
                  onKeydown: pt(() => k(R, !1), ["enter"])
                }, [
                  E.$slots.year ? We(E.$slots, "year", {
                    key: 0,
                    year: X(a)(R)
                  }) : be("", !0),
                  E.$slots.year ? be("", !0) : (re(), ye(Je, { key: 1 }, [
                    Ra(er(X(a)(R)), 1)
                  ], 64))
                ], 40, HQe),
                X(b)(X(l), R) ? (re(), ot(Uf, {
                  key: 1,
                  ref: "mpNextIconRef",
                  "aria-label": (P = X(u)) == null ? void 0 : P.nextYear,
                  disabled: X(o)(R, !1),
                  onActivate: (N) => T(R, !0)
                }, {
                  default: tt(() => [
                    E.$slots["arrow-right"] ? We(E.$slots, "arrow-right", { key: 0 }) : be("", !0),
                    E.$slots["arrow-right"] ? be("", !0) : (re(), ot(X(EA), { key: 1 }))
                  ]),
                  _: 2
                }, 1032, ["aria-label", "disabled", "onActivate"])) : be("", !0),
                je(gs, {
                  name: X(p)(_.value[R]),
                  css: X(m)
                }, {
                  default: tt(() => [
                    _.value[R] ? (re(), ot(kp, {
                      key: 0,
                      items: X(s)(R),
                      "text-input": E.textInput,
                      "esc-close": E.escClose,
                      onToggle: (N) => k(R),
                      onSelected: (N) => x(N, R),
                      "is-last": E.autoApply && !E.keepActionRow,
                      type: "year"
                    }, Si({
                      "button-icon": tt(() => [
                        E.$slots["calendar-icon"] ? We(E.$slots, "calendar-icon", { key: 0 }) : be("", !0),
                        E.$slots["calendar-icon"] ? be("", !0) : (re(), ot(X(Yv), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      E.$slots["year-overlay-value"] ? {
                        name: "item",
                        fn: tt(({ item: N }) => [
                          We(E.$slots, "year-overlay-value", {
                            text: N.text,
                            value: N.value
                          })
                        ]),
                        key: "0"
                      } : void 0
                    ]), 1032, ["items", "text-input", "esc-close", "onToggle", "onSelected", "is-last"])) : be("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ])
            ];
          }),
          _: 2
        }, 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "onSelected", "onHoverValue"])
      ]),
      _: 3
    }, 8, ["multi-calendars"]));
  }
}), WQe = (t, e) => {
  const { modelValue: r } = Ub(t, e), n = ue(null), s = (u) => Array.isArray(r.value) ? r.value.some((c) => Yt(c) === u) : r.value ? Yt(r.value) === u : !1, a = (u) => t.range && Array.isArray(r.value) ? PA(r.value, n.value, l(u)) : !1, o = Ce(() => th(IA(t.yearRange, t.reverseYears), (u) => {
    const c = s(u.value), d = $p(u.value, rh(t.minDate), rh(t.maxDate)), h = a(u.value);
    return { active: c, disabled: d, isBetween: h };
  })), l = (u) => Cu(Ls(/* @__PURE__ */ new Date()), u);
  return {
    groupedYears: o,
    setHoverValue: (u) => {
      n.value = Cu(Ls(/* @__PURE__ */ new Date()), u);
    },
    selectYear: (u) => {
      if (t.multiDates)
        return MA(l(u), r, t.multiDatesLimit), e("auto-apply", !0);
      if (t.range) {
        const c = Sj(r, l(u), e);
        return LA(c, e, t.autoApply, t.modelAuto);
      }
      r.value = l(u), e("auto-apply");
    }
  };
}, jQe = /* @__PURE__ */ Dt({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...Ho
  },
  emits: ["update:internal-model-value", "reset-flow", "range-start", "range-end", "auto-apply"],
  setup(t, { emit: e }) {
    const r = t, { groupedYears: n, selectYear: s, setHoverValue: a } = WQe(r, e);
    return (o, l) => (re(), ot(kp, {
      items: X(n),
      "is-last": o.autoApply && !o.keepActionRow,
      height: o.modeHeight,
      type: "year",
      "use-relative": "",
      onSelected: X(s),
      onHoverValue: X(a)
    }, Si({ _: 2 }, [
      o.$slots["year-overlay-value"] ? {
        name: "item",
        fn: tt(({ item: u }) => [
          We(o.$slots, "year-overlay-value", {
            text: u.text,
            value: u.value
          })
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["items", "is-last", "height", "onSelected", "onHoverValue"]));
  }
}), KQe = {
  key: 0,
  class: "dp__time_input"
}, zQe = ["aria-label", "onKeydown", "onClick"], qQe = /* @__PURE__ */ ke("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), XQe = /* @__PURE__ */ ke("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), QQe = ["aria-label", "disabled", "onKeydown", "onClick"], ZQe = ["aria-label", "onKeydown", "onClick"], JQe = /* @__PURE__ */ ke("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), eZe = /* @__PURE__ */ ke("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), tZe = { key: 0 }, rZe = ["aria-label", "onKeydown"], nZe = /* @__PURE__ */ Dt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    ...Ho
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: r }) {
    const n = t, { setTimePickerElements: s, setTimePickerBackRef: a } = Ul(), { defaultedAriaLabels: o, defaultedTransitions: l, defaultedFilters: u } = Nn(n), { transitionName: c, showTransition: d } = Hv(l), h = Na({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), f = ue("AM"), p = ue(null), m = ue([]);
    Nr(() => {
      r("mounted");
    });
    const b = (U) => Xr(/* @__PURE__ */ new Date(), {
      hours: U.hours,
      minutes: U.minutes,
      seconds: n.enableSeconds ? U.seconds : 0,
      milliseconds: 0
    }), y = Ce(() => (U) => P(U, n[U])), _ = Ce(() => ({ hours: n.hours, minutes: n.minutes, seconds: n.seconds })), x = Ce(() => (U) => !I(+n[U] + +n[`${U}Increment`], U)), T = Ce(() => (U) => !I(+n[U] - +n[`${U}Increment`], U)), k = (U, pe) => HW(Xr($e(), U), pe), E = (U, pe) => $Xe(Xr($e(), U), pe), F = Ce(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !n.timePickerInline,
        dp__time_col_reg_block: !n.enableSeconds && n.is24 && !n.timePickerInline,
        dp__time_col_reg_inline: !n.enableSeconds && n.is24 && n.timePickerInline,
        dp__time_col_reg_with_button: !n.enableSeconds && !n.is24,
        dp__time_col_sec: n.enableSeconds && n.is24,
        dp__time_col_sec_with_button: n.enableSeconds && !n.is24
      })
    ), R = Ce(() => {
      const U = [{ type: "hours" }, { type: "", separator: !0 }, { type: "minutes" }];
      return n.enableSeconds ? U.concat([{ type: "", separator: !0 }, { type: "seconds" }]) : U;
    }), $ = Ce(() => R.value.filter((U) => !U.separator)), O = Ce(() => (U) => {
      if (U === "hours") {
        const pe = H(+n.hours);
        return { text: pe < 10 ? `0${pe}` : `${pe}`, value: pe };
      }
      return { text: n[U] < 10 ? `0${n[U]}` : `${n[U]}`, value: n[U] };
    }), P = (U, pe) => {
      var q;
      if (!n.disabledTimesConfig)
        return !1;
      const Y = n.disabledTimesConfig(n.order, U === "hours" ? pe : void 0);
      return Y[U] ? !!((q = Y[U]) != null && q.includes(pe)) : !0;
    }, N = (U) => {
      const pe = n.is24 ? 24 : 12, q = U === "hours" ? pe : 60, Y = +n[`${U}GridIncrement`], se = U === "hours" && !n.is24 ? Y : 0, he = [];
      for (let fe = se; fe < q; fe += Y)
        he.push({ value: fe, text: fe < 10 ? `0${fe}` : `${fe}` });
      return U === "hours" && !n.is24 && he.push({ value: 0, text: "12" }), th(he, (fe) => ({ active: !1, disabled: u.value.times[U].includes(fe.value) || !I(fe.value, U) || P(U, fe.value) }));
    }, I = (U, pe) => {
      const q = n.minTime ? b(bT(n.minTime)) : null, Y = n.maxTime ? b(bT(n.maxTime)) : null, se = b(bT(_.value, pe, U));
      return q && Y ? (Ep(se, Y) || pd(se, Y)) && (Sp(se, q) || pd(se, q)) : q ? Sp(se, q) || pd(se, q) : Y ? Ep(se, Y) || pd(se, Y) : !0;
    }, B = (U) => n[`no${U[0].toUpperCase() + U.slice(1)}Overlay`], W = (U) => {
      B(U) || (h[U] = !h[U], h[U] || r("overlay-closed"));
    }, Q = (U) => U === "hours" ? Da : U === "minutes" ? Oa : Jd, te = (U, pe = !0) => {
      const q = pe ? k : E, Y = pe ? +n[`${U}Increment`] : -+n[`${U}Increment`];
      I(+n[U] + Y, U) && r(
        `update:${U}`,
        Q(U)(q({ [U]: +n[U] }, { [U]: +n[`${U}Increment`] }))
      );
    }, H = (U) => n.is24 ? U : (U >= 12 ? f.value = "PM" : f.value = "AM", tQe(U)), A = () => {
      f.value === "PM" ? (f.value = "AM", r("update:hours", n.hours - 12)) : (f.value = "PM", r("update:hours", n.hours + 12)), r("am-pm-change", f.value);
    }, V = (U) => {
      h[U] = !0;
    }, M = (U, pe, q) => {
      if (U && n.arrowNavigation) {
        Array.isArray(m.value[pe]) ? m.value[pe][q] = U : m.value[pe] = [U];
        const Y = m.value.reduce(
          (se, he) => he.map((fe, Te) => [...se[Te] || [], he[Te]]),
          []
        );
        a(n.closeTimePickerBtn), p.value && (Y[1] = Y[1].concat(p.value)), s(Y, n.order);
      }
    }, Z = (U, pe) => (W(U), U === "hours" && !n.is24 ? r(`update:${U}`, f.value === "PM" ? pe + 12 : pe) : r(`update:${U}`, pe));
    return e({ openChildCmp: V }), (U, pe) => {
      var q;
      return U.disabled ? be("", !0) : (re(), ye("div", KQe, [
        (re(!0), ye(Je, null, Mr(R.value, (Y, se) => {
          var he, fe, Te;
          return re(), ye("div", {
            key: se,
            class: wt(F.value)
          }, [
            Y.separator ? (re(), ye(Je, { key: 0 }, [
              Ra(" : ")
            ], 64)) : (re(), ye(Je, { key: 1 }, [
              ke("button", {
                type: "button",
                class: wt({
                  dp__btn: !0,
                  dp__inc_dec_button: !n.timePickerInline,
                  dp__inc_dec_button_inline: n.timePickerInline,
                  dp__tp_inline_btn_top: n.timePickerInline,
                  dp__inc_dec_button_disabled: x.value(Y.type)
                }),
                "aria-label": (he = X(o)) == null ? void 0 : he.incrementValue(Y.type),
                tabindex: "0",
                onKeydown: [
                  pt(kt((ee) => te(Y.type), ["prevent"]), ["enter"]),
                  pt(kt((ee) => te(Y.type), ["prevent"]), ["space"])
                ],
                onClick: (ee) => te(Y.type),
                ref_for: !0,
                ref: (ee) => M(ee, se, 0)
              }, [
                n.timePickerInline ? (re(), ye(Je, { key: 1 }, [
                  qQe,
                  XQe
                ], 64)) : (re(), ye(Je, { key: 0 }, [
                  U.$slots["arrow-up"] ? We(U.$slots, "arrow-up", { key: 0 }) : be("", !0),
                  U.$slots["arrow-up"] ? be("", !0) : (re(), ot(X(kA), { key: 1 }))
                ], 64))
              ], 42, zQe),
              ke("button", {
                type: "button",
                "aria-label": (fe = X(o)) == null ? void 0 : fe.openTpOverlay(Y.type),
                class: wt({
                  dp__time_display: !0,
                  dp__time_display_block: !n.timePickerInline,
                  dp__time_display_inline: n.timePickerInline,
                  "dp--time-invalid": y.value(Y.type),
                  "dp--time-overlay-btn": !y.value(Y.type)
                }),
                disabled: B(Y.type),
                tabindex: "0",
                onKeydown: [
                  pt(kt((ee) => W(Y.type), ["prevent"]), ["enter"]),
                  pt(kt((ee) => W(Y.type), ["prevent"]), ["space"])
                ],
                onClick: (ee) => W(Y.type),
                ref_for: !0,
                ref: (ee) => M(ee, se, 1)
              }, [
                U.$slots[Y.type] ? We(U.$slots, Y.type, {
                  key: 0,
                  text: O.value(Y.type).text,
                  value: O.value(Y.type).value
                }) : be("", !0),
                U.$slots[Y.type] ? be("", !0) : (re(), ye(Je, { key: 1 }, [
                  Ra(er(O.value(Y.type).text), 1)
                ], 64))
              ], 42, QQe),
              ke("button", {
                type: "button",
                class: wt({
                  dp__btn: !0,
                  dp__inc_dec_button: !n.timePickerInline,
                  dp__inc_dec_button_inline: n.timePickerInline,
                  dp__tp_inline_btn_bottom: n.timePickerInline,
                  dp__inc_dec_button_disabled: T.value(Y.type)
                }),
                "aria-label": (Te = X(o)) == null ? void 0 : Te.decrementValue(Y.type),
                tabindex: "0",
                onKeydown: [
                  pt(kt((ee) => te(Y.type, !1), ["prevent"]), ["enter"]),
                  pt(kt((ee) => te(Y.type, !1), ["prevent"]), ["space"])
                ],
                onClick: (ee) => te(Y.type, !1),
                ref_for: !0,
                ref: (ee) => M(ee, se, 2)
              }, [
                n.timePickerInline ? (re(), ye(Je, { key: 1 }, [
                  JQe,
                  eZe
                ], 64)) : (re(), ye(Je, { key: 0 }, [
                  U.$slots["arrow-down"] ? We(U.$slots, "arrow-down", { key: 0 }) : be("", !0),
                  U.$slots["arrow-down"] ? be("", !0) : (re(), ot(X(DA), { key: 1 }))
                ], 64))
              ], 42, ZQe)
            ], 64))
          ], 2);
        }), 128)),
        U.is24 ? be("", !0) : (re(), ye("div", tZe, [
          U.$slots["am-pm-button"] ? We(U.$slots, "am-pm-button", {
            key: 0,
            toggle: A,
            value: f.value
          }) : be("", !0),
          U.$slots["am-pm-button"] ? be("", !0) : (re(), ye("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: p,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (q = X(o)) == null ? void 0 : q.amPmButton,
            tabindex: "0",
            onClick: A,
            onKeydown: [
              pt(kt(A, ["prevent"]), ["enter"]),
              pt(kt(A, ["prevent"]), ["space"])
            ]
          }, er(f.value), 41, rZe))
        ])),
        (re(!0), ye(Je, null, Mr($.value, (Y, se) => (re(), ot(gs, {
          key: se,
          name: X(c)(h[Y.type]),
          css: X(d)
        }, {
          default: tt(() => [
            h[Y.type] ? (re(), ot(kp, {
              key: 0,
              items: N(Y.type),
              "is-last": U.autoApply && !U.keepActionRow,
              "esc-close": U.escClose,
              type: Y.type,
              "text-input": U.textInput,
              "arrow-navigation": U.arrowNavigation,
              onSelected: (he) => Z(Y.type, he),
              onToggle: (he) => W(Y.type),
              onResetFlow: pe[0] || (pe[0] = (he) => U.$emit("reset-flow"))
            }, Si({
              "button-icon": tt(() => [
                U.$slots["clock-icon"] ? We(U.$slots, "clock-icon", { key: 0 }) : be("", !0),
                U.$slots["clock-icon"] ? be("", !0) : (re(), ot(X($A), { key: 1 }))
              ]),
              _: 2
            }, [
              U.$slots[`${Y.type}-overlay-value`] ? {
                name: "item",
                fn: tt(({ item: he }) => [
                  We(U.$slots, `${Y.type}-overlay-value`, {
                    text: he.text,
                    value: he.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "arrow-navigation", "onSelected", "onToggle"])) : be("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), iZe = ["aria-label"], sZe = ["tabindex"], aZe = ["aria-label"], Ej = /* @__PURE__ */ Dt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    ...Ho
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: r }) {
    const n = t, { buildMatrix: s, setTimePicker: a } = Ul(), o = sh(), { defaultedTransitions: l, defaultedAriaLabels: u, defaultedTextInput: c } = Nn(n), { transitionName: d, showTransition: h } = Hv(l), { hideNavigationButtons: f } = Vb(), p = ue(null), m = ue(null), b = ue([]), y = ue(null);
    Nr(() => {
      r("mount"), !n.timePicker && n.arrowNavigation ? s([un(p.value)], "time") : a(!0, n.timePicker);
    });
    const _ = Ce(() => n.range && n.modelAuto ? mj(n.internalModelValue) : !0), x = ue(!1), T = (B) => ({
      hours: Array.isArray(n.hours) ? n.hours[B] : n.hours,
      minutes: Array.isArray(n.minutes) ? n.minutes[B] : n.minutes,
      seconds: Array.isArray(n.seconds) ? n.seconds[B] : n.seconds
    }), k = Ce(() => {
      const B = [];
      if (n.range)
        for (let W = 0; W < 2; W++)
          B.push(T(W));
      else
        B.push(T(0));
      return B;
    }), E = (B, W = !1, Q = "") => {
      W || r("reset-flow"), x.value = B, r(B ? "overlay-opened" : "overlay-closed"), n.arrowNavigation && a(B), Ia(() => {
        Q !== "" && b.value[0] && b.value[0].openChildCmp(Q);
      });
    }, F = Ce(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: n.autoApply && !n.keepActionRow
    })), R = Ys(o, "timePicker"), $ = (B, W, Q) => n.range ? W === 0 ? [B, k.value[1][Q]] : [k.value[0][Q], B] : B, O = (B) => {
      r("update:hours", B);
    }, P = (B) => {
      r("update:minutes", B);
    }, N = (B) => {
      r("update:seconds", B);
    }, I = () => {
      if (y.value && !c.value.enabled) {
        const B = nQe(y.value);
        B && B.focus({ preventScroll: !0 });
      }
    };
    return e({ toggleTimePicker: E }), (B, W) => {
      var Q;
      return re(), ye("div", null, [
        !B.timePicker && !B.timePickerInline ? gd((re(), ye("button", {
          key: 0,
          type: "button",
          class: wt(F.value),
          "aria-label": (Q = X(u)) == null ? void 0 : Q.openTimePicker,
          tabindex: "0",
          ref_key: "openTimePickerBtn",
          ref: p,
          onKeydown: [
            W[0] || (W[0] = pt((te) => E(!0), ["enter"])),
            W[1] || (W[1] = pt((te) => E(!0), ["space"]))
          ],
          onClick: W[2] || (W[2] = (te) => E(!0))
        }, [
          B.$slots["clock-icon"] ? We(B.$slots, "clock-icon", { key: 0 }) : be("", !0),
          B.$slots["clock-icon"] ? be("", !0) : (re(), ot(X($A), { key: 1 }))
        ], 42, iZe)), [
          [_d, !X(f)(B.hideNavigation, "time")]
        ]) : be("", !0),
        je(gs, {
          name: X(d)(x.value),
          css: X(h) && !B.timePickerInline
        }, {
          default: tt(() => {
            var te;
            return [
              x.value || B.timePicker || B.timePickerInline ? (re(), ye("div", {
                key: 0,
                class: wt({
                  dp__overlay: !B.timePickerInline,
                  "dp--overlay-absolute": !n.timePicker && !B.timePickerInline,
                  "dp--overlay-relative": n.timePicker
                }),
                style: ri(B.timePicker ? { height: `${B.modeHeight}px` } : void 0),
                ref_key: "overlayRef",
                ref: y,
                tabindex: B.timePickerInline ? void 0 : 0
              }, [
                ke("div", {
                  class: wt(
                    B.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  B.$slots["time-picker-overlay"] ? We(B.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: t.hours,
                    minutes: t.minutes,
                    seconds: t.seconds,
                    setHours: O,
                    setMinutes: P,
                    setSeconds: N
                  }) : be("", !0),
                  B.$slots["time-picker-overlay"] ? be("", !0) : (re(), ye("div", {
                    key: 1,
                    class: wt(B.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (re(!0), ye(Je, null, Mr(k.value, (H, A) => gd((re(), ot(nZe, ni({ key: A }, {
                      ...B.$props,
                      order: A,
                      hours: H.hours,
                      minutes: H.minutes,
                      seconds: H.seconds,
                      closeTimePickerBtn: m.value,
                      disabledTimesConfig: t.disabledTimesConfig,
                      disabled: A === 0 ? B.fixedStart : B.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: b,
                      "onUpdate:hours": (V) => O($(V, A, "hours")),
                      "onUpdate:minutes": (V) => P($(V, A, "minutes")),
                      "onUpdate:seconds": (V) => N($(V, A, "seconds")),
                      onMounted: I,
                      onOverlayClosed: I,
                      onAmPmChange: W[3] || (W[3] = (V) => B.$emit("am-pm-change", V))
                    }), Si({ _: 2 }, [
                      Mr(X(R), (V, M) => ({
                        name: V,
                        fn: tt((Z) => [
                          We(B.$slots, V, Hn(Hi(Z)))
                        ])
                      }))
                    ]), 1040, ["onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [_d, A === 0 ? !0 : _.value]
                    ])), 128))
                  ], 2)),
                  !B.timePicker && !B.timePickerInline ? gd((re(), ye("button", {
                    key: 2,
                    type: "button",
                    ref_key: "closeTimePickerBtn",
                    ref: m,
                    class: wt(F.value),
                    "aria-label": (te = X(u)) == null ? void 0 : te.closeTimePicker,
                    tabindex: "0",
                    onKeydown: [
                      W[4] || (W[4] = pt((H) => E(!1), ["enter"])),
                      W[5] || (W[5] = pt((H) => E(!1), ["space"]))
                    ],
                    onClick: W[6] || (W[6] = (H) => E(!1))
                  }, [
                    B.$slots["calendar-icon"] ? We(B.$slots, "calendar-icon", { key: 0 }) : be("", !0),
                    B.$slots["calendar-icon"] ? be("", !0) : (re(), ot(X(Yv), { key: 1 }))
                  ], 42, aZe)), [
                    [_d, !X(f)(B.hideNavigation, "time")]
                  ]) : be("", !0)
                ], 2)
              ], 14, sZe)) : be("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), $j = (t, e, r, n) => {
  const s = (_, x) => Array.isArray(e[_]) ? e[_][x] : e[_], a = (_) => t.enableSeconds ? Array.isArray(e.seconds) ? e.seconds[_] : e.seconds : 0, o = (_, x) => _ ? x !== void 0 ? xl(_, s("hours", x), s("minutes", x), a(x)) : xl(_, e.hours, e.minutes, a()) : $e(), l = (_, x) => {
    e[_] = x;
  }, u = (_, x) => {
    const T = Object.fromEntries(
      Object.keys(e).map((k) => k === _ ? [k, x] : [k, e[k]].slice())
    );
    if (t.range && !t.disableTimeRangeValidation) {
      const k = (F) => r.value ? xl(
        r.value[F],
        T.hours[F],
        T.minutes[F],
        T.seconds[F]
      ) : null, E = (F) => xA(r.value[F], 0);
      return !(Jt(k(0), k(1)) && (Sp(k(0), E(1)) || Ep(k(1), E(0))));
    }
    return !0;
  }, c = (_, x) => {
    u(_, x) && (l(_, x), n && n());
  }, d = (_) => {
    c("hours", _);
  }, h = (_) => {
    c("minutes", _);
  }, f = (_) => {
    c("seconds", _);
  }, p = (_, x, T, k) => {
    x && d(_), !x && !T && h(_), T && f(_), r.value && k(r.value);
  }, m = (_) => {
    if (_) {
      const x = Array.isArray(_), T = x ? [+_[0].hours, +_[1].hours] : +_.hours, k = x ? [+_[0].minutes, +_[1].minutes] : +_.minutes, E = x ? [+_[0].seconds, +_[1].seconds] : +_.seconds;
      l("hours", T), l("minutes", k), t.enableSeconds && l("seconds", E);
    }
  }, b = (_, x) => {
    const T = {
      hours: Array.isArray(e.hours) ? e.hours[_] : e.hours,
      disabledArr: []
    };
    return (x || x === 0) && (T.hours = x), Array.isArray(t.disabledTimes) && (T.disabledArr = t.range && Array.isArray(t.disabledTimes[_]) ? t.disabledTimes[_] : t.disabledTimes), T;
  }, y = Ce(() => (_, x) => {
    var T;
    if (Array.isArray(t.disabledTimes)) {
      const { disabledArr: k, hours: E } = b(_, x), F = k.filter((R) => +R.hours === E);
      return ((T = F[0]) == null ? void 0 : T.minutes) === "*" ? { hours: [E], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (F == null ? void 0 : F.map((R) => +R.minutes)) ?? [],
        seconds: (F == null ? void 0 : F.map((R) => R.seconds ? +R.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: l,
    updateHours: d,
    updateMinutes: h,
    updateSeconds: f,
    getSetDateTime: o,
    updateTimeValues: p,
    getSecondsValue: a,
    assignStartTime: m,
    disabledTimesConfig: y
  };
}, oZe = (t, e) => {
  const { modelValue: r, time: n } = Ub(t, e), { defaultedStartTime: s } = Nn(t), { updateTimeValues: a, getSetDateTime: o, setTime: l, assignStartTime: u, disabledTimesConfig: c } = $j(
    t,
    n,
    r
  ), d = () => {
    t.range ? r.value = [o(null, 0), o(null, 1)] : r.value = o(null);
  }, h = (b) => Array.isArray(b) ? [Iu($e(b[0])), Iu($e(b[1]))] : [Iu(b ?? $e())], f = (b, y, _) => {
    l("hours", b), l("minutes", y), t.enableSeconds && l("seconds", _);
  }, p = () => {
    const [b, y] = h(r.value);
    return t.range ? f(
      [b.hours, y.hours],
      [b.minutes, y.minutes],
      [b.seconds, y.minutes]
    ) : f(b.hours, b.minutes, b.seconds);
  };
  Nr(() => {
    if (!t.shadow)
      return u(s.value), r.value ? p() : d();
  });
  const m = () => {
    Array.isArray(r.value) ? r.value = r.value.map((b, y) => b && o(b, y)) : r.value = o(r.value), e("time-update");
  };
  return {
    time: n,
    disabledTimesConfig: c,
    updateTime: (b, y = !0, _ = !1) => {
      a(b, y, _, m);
    }
  };
}, lZe = /* @__PURE__ */ Dt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...Ho
  },
  emits: ["update:internal-model-value", "time-update", "am-pm-change"],
  setup(t, { emit: e }) {
    const r = t, n = sh(), s = Ys(n, "timePicker"), { time: a, disabledTimesConfig: o, updateTime: l } = oZe(r, e);
    return (u, c) => (re(), ot(RA, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: tt(() => [
        je(Ej, ni(u.$props, {
          hours: X(a).hours,
          minutes: X(a).minutes,
          seconds: X(a).seconds,
          "internal-model-value": u.internalModelValue,
          "disabled-times-config": X(o),
          "onUpdate:hours": c[0] || (c[0] = (d) => X(l)(d)),
          "onUpdate:minutes": c[1] || (c[1] = (d) => X(l)(d, !1)),
          "onUpdate:seconds": c[2] || (c[2] = (d) => X(l)(d, !1, !0)),
          onAmPmChange: c[3] || (c[3] = (d) => u.$emit("am-pm-change", d))
        }), Si({ _: 2 }, [
          Mr(X(s), (d, h) => ({
            name: d,
            fn: tt((f) => [
              We(u.$slots, d, Hn(Hi(f)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config"])
      ]),
      _: 3
    }));
  }
}), uZe = { class: "dp__month_year_row" }, cZe = ["onClick", "onKeydown", "aria-label"], dZe = /* @__PURE__ */ Dt({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...Ho
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed"],
  setup(t, { expose: e, emit: r }) {
    const n = t, { defaultedTransitions: s, defaultedAriaLabels: a, defaultedMultiCalendars: o, defaultedFilters: l } = Nn(n), { transitionName: u, showTransition: c } = Hv(s), { buildMatrix: d } = Ul(), { handleMonthYearChange: h, isDisabled: f, updateMonthYear: p } = TQe(n, r), { showLeftIcon: m, showRightIcon: b } = Vb(), y = ue(!1), _ = ue(!1), x = ue([null, null, null, null]);
    Nr(() => {
      r("mount");
    });
    const T = (H) => ({
      get: () => n[H],
      set: (A) => {
        const V = H === Ds.month ? Ds.year : Ds.month;
        r("update-month-year", { [H]: A, [V]: n[V] }), H === Ds.month ? N(!0) : I(!0);
      }
    }), k = Ce(T(Ds.month)), E = Ce(T(Ds.year)), F = Ce(() => (H) => ({
      month: n.month,
      year: n.year,
      items: H === Ds.month ? n.months : n.years,
      instance: n.instance,
      updateMonthYear: p,
      toggle: H === Ds.month ? N : I
    })), R = Ce(() => n.months.find((A) => A.value === n.month) || { text: "", value: 0 }), $ = Ce(() => th(n.months, (H) => {
      const A = n.month === H.value, V = $p(
        H.value,
        gj(n.year, n.minDate),
        yj(n.year, n.maxDate)
      ) || l.value.months.includes(H.value);
      return { active: A, disabled: V };
    })), O = Ce(() => th(n.years, (H) => {
      const A = n.year === H.value, V = $p(H.value, rh(n.minDate), rh(n.maxDate)) || l.value.years.includes(H.value);
      return { active: A, disabled: V };
    })), P = (H, A) => {
      A !== void 0 ? H.value = A : H.value = !H.value, H.value || r("overlay-closed");
    }, N = (H = !1, A) => {
      B(H), P(y, A);
    }, I = (H = !1, A) => {
      B(H), P(_, A);
    }, B = (H) => {
      H || r("reset-flow");
    }, W = (H, A) => {
      n.arrowNavigation && (x.value[A] = un(H), d(x.value, "monthYear"));
    }, Q = Ce(() => {
      var H, A;
      return [
        {
          type: Ds.month,
          index: 1,
          toggle: N,
          modelValue: k.value,
          updateModelValue: (V) => k.value = V,
          text: R.value.text,
          showSelectionGrid: y.value,
          items: $.value,
          ariaLabel: (H = a.value) == null ? void 0 : H.openMonthsOverlay
        },
        {
          type: Ds.year,
          index: 2,
          toggle: I,
          modelValue: E.value,
          updateModelValue: (V) => E.value = V,
          text: n.year,
          showSelectionGrid: _.value,
          items: O.value,
          ariaLabel: (A = a.value) == null ? void 0 : A.openYearsOverlay
        }
      ];
    }), te = Ce(
      () => n.disableYearSelect ? [Q.value[0]] : Q.value
    );
    return e({
      toggleMonthPicker: N,
      toggleYearPicker: I,
      handleMonthYearChange: h
    }), (H, A) => {
      var V, M, Z;
      return re(), ye("div", uZe, [
        H.$slots["month-year"] ? We(H.$slots, "month-year", Hn(ni({ key: 0 }, { month: t.month, year: t.year, months: t.months, years: t.years, updateMonthYear: X(p), handleMonthYearChange: X(h), instance: t.instance }))) : (re(), ye(Je, { key: 1 }, [
          X(m)(X(o), t.instance) && !H.vertical ? (re(), ot(Uf, {
            key: 0,
            "aria-label": (V = X(a)) == null ? void 0 : V.prevMonth,
            disabled: X(f)(!1),
            onActivate: A[0] || (A[0] = (U) => X(h)(!1)),
            onSetRef: A[1] || (A[1] = (U) => W(U, 0))
          }, {
            default: tt(() => [
              H.$slots["arrow-left"] ? We(H.$slots, "arrow-left", { key: 0 }) : be("", !0),
              H.$slots["arrow-left"] ? be("", !0) : (re(), ot(X(SA), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled"])) : be("", !0),
          ke("div", {
            class: wt(["dp__month_year_wrap", {
              dp__year_disable_select: H.disableYearSelect
            }])
          }, [
            (re(!0), ye(Je, null, Mr(te.value, (U, pe) => (re(), ye(Je, {
              key: U.type
            }, [
              ke("button", {
                type: "button",
                class: "dp__btn dp__month_year_select",
                onClick: U.toggle,
                onKeydown: [
                  pt(kt(U.toggle, ["prevent"]), ["enter"]),
                  pt(kt(U.toggle, ["prevent"]), ["space"])
                ],
                "aria-label": U.ariaLabel,
                tabindex: "0",
                ref_for: !0,
                ref: (q) => W(q, pe + 1)
              }, [
                H.$slots[U.type] ? We(H.$slots, U.type, Hn(ni({ key: 0 }, { text: U.text }))) : be("", !0),
                H.$slots[U.type] ? be("", !0) : (re(), ye(Je, { key: 1 }, [
                  Ra(er(U.text), 1)
                ], 64))
              ], 40, cZe),
              je(gs, {
                name: X(u)(U.showSelectionGrid),
                css: X(c)
              }, {
                default: tt(() => [
                  U.showSelectionGrid ? (re(), ot(kp, {
                    key: 0,
                    items: U.items,
                    "arrow-navigation": H.arrowNavigation,
                    "hide-navigation": H.hideNavigation,
                    "is-last": H.autoApply && !H.keepActionRow,
                    "skip-button-ref": !1,
                    type: U.type,
                    "header-refs": [],
                    "esc-close": H.escClose,
                    "text-input": H.textInput,
                    onSelected: U.updateModelValue,
                    onToggle: U.toggle
                  }, Si({
                    "button-icon": tt(() => [
                      H.$slots["calendar-icon"] ? We(H.$slots, "calendar-icon", { key: 0 }) : be("", !0),
                      H.$slots["calendar-icon"] ? be("", !0) : (re(), ot(X(Yv), { key: 1 }))
                    ]),
                    _: 2
                  }, [
                    H.$slots[`${U.type}-overlay-val`] ? {
                      name: "item",
                      fn: tt(({ item: q }) => [
                        We(H.$slots, `${U.type}-overlay-val`, {
                          text: q.text,
                          value: q.value
                        })
                      ]),
                      key: "0"
                    } : void 0,
                    H.$slots[`${U.type}-overlay`] ? {
                      name: "overlay",
                      fn: tt(() => [
                        We(H.$slots, `${U.type}-overlay`, Hn(Hi(F.value(U.type))))
                      ]),
                      key: "1"
                    } : void 0,
                    H.$slots[`${U.type}-overlay-header`] ? {
                      name: "header",
                      fn: tt(() => [
                        We(H.$slots, `${U.type}-overlay-header`, {
                          toggle: U.toggle
                        })
                      ]),
                      key: "2"
                    } : void 0
                  ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "type", "esc-close", "text-input", "onSelected", "onToggle"])) : be("", !0)
                ]),
                _: 2
              }, 1032, ["name", "css"])
            ], 64))), 128))
          ], 2),
          X(m)(X(o), t.instance) && H.vertical ? (re(), ot(Uf, {
            key: 1,
            "aria-label": (M = X(a)) == null ? void 0 : M.prevMonth,
            disabled: X(f)(!1),
            onActivate: A[2] || (A[2] = (U) => X(h)(!1))
          }, {
            default: tt(() => [
              H.$slots["arrow-up"] ? We(H.$slots, "arrow-up", { key: 0 }) : be("", !0),
              H.$slots["arrow-up"] ? be("", !0) : (re(), ot(X(kA), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled"])) : be("", !0),
          X(b)(X(o), t.instance) ? (re(), ot(Uf, {
            key: 2,
            ref: "rightIcon",
            disabled: X(f)(!0),
            "aria-label": (Z = X(a)) == null ? void 0 : Z.nextMonth,
            onActivate: A[3] || (A[3] = (U) => X(h)(!0)),
            onSetRef: A[4] || (A[4] = (U) => W(U, H.disableYearSelect ? 2 : 3))
          }, {
            default: tt(() => [
              H.$slots[H.vertical ? "arrow-down" : "arrow-right"] ? We(H.$slots, H.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : be("", !0),
              H.$slots[H.vertical ? "arrow-down" : "arrow-right"] ? be("", !0) : (re(), ot(Ak(H.vertical ? X(DA) : X(EA)), { key: 1 }))
            ]),
            _: 3
          }, 8, ["disabled", "aria-label"])) : be("", !0)
        ], 64))
      ]);
    };
  }
}), hZe = ["aria-label"], fZe = {
  class: "dp__calendar_header",
  role: "row"
}, pZe = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, vZe = /* @__PURE__ */ ke("div", { class: "dp__calendar_header_separator" }, null, -1), mZe = ["aria-label"], gZe = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, yZe = { class: "dp__cell_inner" }, bZe = ["aria-selected", "aria-disabled", "aria-label", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], _Ze = /* @__PURE__ */ Dt({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...Ho
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(t, { expose: e, emit: r }) {
    const n = t, { buildMultiLevelMatrix: s } = Ul(), { defaultedTransitions: a, defaultedAriaLabels: o, defaultedMultiCalendars: l } = Nn(n), u = ue(null), c = ue({
      bottom: "",
      left: "",
      transform: ""
    }), d = ue([]), h = ue(null), f = ue(!0), p = ue(""), m = ue({ startX: 0, endX: 0, startY: 0, endY: 0 }), b = ue([]), y = ue({ left: "50%" }), _ = Ce(() => n.calendar ? n.calendar(n.mappedDates) : n.mappedDates), x = Ce(() => n.dayNames ? Array.isArray(n.dayNames) ? n.dayNames : n.dayNames(n.locale, +n.weekStart) : eQe(n.formatLocale, n.locale, +n.weekStart));
    Nr(() => {
      r("mount", { cmp: "calendar", refs: d }), n.noSwipe || h.value && (h.value.addEventListener("touchstart", I, { passive: !1 }), h.value.addEventListener("touchend", B, { passive: !1 }), h.value.addEventListener("touchmove", W, { passive: !1 })), n.monthChangeOnScroll && h.value && h.value.addEventListener("wheel", H, { passive: !1 });
    });
    const T = (V) => V ? n.vertical ? "vNext" : "next" : n.vertical ? "vPrevious" : "previous", k = (V, M) => {
      if (n.transitions) {
        const Z = ms(lo($e(), n.month, n.year));
        p.value = Gn(ms(lo($e(), V, M)), Z) ? a.value[T(!0)] : a.value[T(!1)], f.value = !1, Ia(() => {
          f.value = !0;
        });
      }
    }, E = Ce(
      () => ({
        [n.calendarClassName]: !!n.calendarClassName
      })
    ), F = Ce(() => (V) => {
      const M = rQe(V);
      return {
        dp__marker_dot: M.type === "dot",
        dp__marker_line: M.type === "line"
      };
    }), R = Ce(() => (V) => Jt(V, u.value)), $ = Ce(() => ({
      dp__calendar: !0,
      dp__calendar_next: l.value.count > 0 && n.instance !== 0
    })), O = Ce(() => (V) => n.hideOffsetDates ? V.current : !0), P = async (V, M, Z) => {
      var U, pe;
      if (r("set-hover-date", V), (pe = (U = V.marker) == null ? void 0 : U.tooltip) != null && pe.length) {
        const q = un(d.value[M][Z]);
        if (q) {
          const { width: Y, height: se } = q.getBoundingClientRect();
          u.value = V.value;
          let he = { left: `${Y / 2}px` }, fe = -50;
          if (await Ia(), b.value[0]) {
            const { left: Te, width: ee } = b.value[0].getBoundingClientRect();
            Te < 0 && (he = { left: "0" }, fe = 0, y.value.left = `${Y / 2}px`), window.innerWidth < Te + ee && (he = { right: "0" }, fe = 0, y.value.left = `${ee - Y / 2}px`);
          }
          c.value = {
            bottom: `${se}px`,
            ...he,
            transform: `translateX(${fe}%)`
          }, r("tooltip-open", V.marker);
        }
      }
    }, N = (V) => {
      u.value && (u.value = null, c.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), r("tooltip-close", V.marker));
    }, I = (V) => {
      m.value.startX = V.changedTouches[0].screenX, m.value.startY = V.changedTouches[0].screenY;
    }, B = (V) => {
      m.value.endX = V.changedTouches[0].screenX, m.value.endY = V.changedTouches[0].screenY, Q();
    }, W = (V) => {
      n.vertical && !n.inline && V.preventDefault();
    }, Q = () => {
      const V = n.vertical ? "Y" : "X";
      Math.abs(m.value[`start${V}`] - m.value[`end${V}`]) > 10 && r("handle-swipe", m.value[`start${V}`] > m.value[`end${V}`] ? "right" : "left");
    }, te = (V, M, Z) => {
      V && (Array.isArray(d.value[M]) ? d.value[M][Z] = V : d.value[M] = [V]), n.arrowNavigation && s(d.value, "calendar");
    }, H = (V) => {
      n.monthChangeOnScroll && (V.preventDefault(), r("handle-scroll", V));
    }, A = (V) => {
      const M = V[0];
      return n.weekNumbers === "local" ? dqe(M.value, { weekStartsOn: +n.weekStart }) : n.weekNumbers === "iso" ? oqe(M.value) : typeof n.weekNumbers == "function" ? n.weekNumbers(M.value) : "";
    };
    return e({ triggerTransition: k }), (V, M) => {
      var Z;
      return re(), ye("div", {
        class: wt($.value)
      }, [
        ke("div", {
          ref_key: "calendarWrapRef",
          ref: h,
          role: "grid",
          class: wt(E.value),
          "aria-label": (Z = X(o)) == null ? void 0 : Z.calendarWrap
        }, [
          (re(), ye(Je, { key: 0 }, [
            ke("div", fZe, [
              V.weekNumbers ? (re(), ye("div", pZe, er(V.weekNumName), 1)) : be("", !0),
              (re(!0), ye(Je, null, Mr(x.value, (U, pe) => (re(), ye("div", {
                class: "dp__calendar_header_item",
                role: "gridcell",
                key: pe
              }, [
                V.$slots["calendar-header"] ? We(V.$slots, "calendar-header", {
                  key: 0,
                  day: U,
                  index: pe
                }) : be("", !0),
                V.$slots["calendar-header"] ? be("", !0) : (re(), ye(Je, { key: 1 }, [
                  Ra(er(U), 1)
                ], 64))
              ]))), 128))
            ]),
            vZe,
            je(gs, {
              name: p.value,
              css: !!V.transitions
            }, {
              default: tt(() => {
                var U;
                return [
                  f.value ? (re(), ye("div", {
                    key: 0,
                    class: "dp__calendar",
                    role: "grid",
                    "aria-label": ((U = X(o)) == null ? void 0 : U.calendarDays) || void 0
                  }, [
                    (re(!0), ye(Je, null, Mr(_.value, (pe, q) => (re(), ye("div", {
                      class: "dp__calendar_row",
                      role: "row",
                      key: q
                    }, [
                      V.weekNumbers ? (re(), ye("div", gZe, [
                        ke("div", yZe, er(A(pe.days)), 1)
                      ])) : be("", !0),
                      (re(!0), ye(Je, null, Mr(pe.days, (Y, se) => {
                        var he, fe, Te;
                        return re(), ye("div", {
                          role: "gridcell",
                          class: "dp__calendar_item",
                          ref_for: !0,
                          ref: (ee) => te(ee, q, se),
                          key: se + q,
                          "aria-selected": Y.classData.dp__active_date || Y.classData.dp__range_start || Y.classData.dp__range_start,
                          "aria-disabled": Y.classData.dp__cell_disabled || void 0,
                          "aria-label": (fe = (he = X(o)) == null ? void 0 : he.day) == null ? void 0 : fe.call(he, Y),
                          tabindex: "0",
                          onClick: kt((ee) => V.$emit("select-date", Y), ["stop", "prevent"]),
                          onKeydown: [
                            pt((ee) => V.$emit("select-date", Y), ["enter"]),
                            pt((ee) => V.$emit("handle-space", Y), ["space"])
                          ],
                          onMouseenter: (ee) => P(Y, q, se),
                          onMouseleave: (ee) => N(Y)
                        }, [
                          ke("div", {
                            class: wt(["dp__cell_inner", Y.classData])
                          }, [
                            V.$slots.day && O.value(Y) ? We(V.$slots, "day", {
                              key: 0,
                              day: +Y.text,
                              date: Y.value
                            }) : be("", !0),
                            V.$slots.day ? be("", !0) : (re(), ye(Je, { key: 1 }, [
                              Ra(er(Y.text), 1)
                            ], 64)),
                            Y.marker && O.value(Y) ? (re(), ye(Je, { key: 2 }, [
                              V.$slots.marker ? We(V.$slots, "marker", {
                                key: 0,
                                marker: Y.marker,
                                day: +Y.text,
                                date: Y.value
                              }) : (re(), ye("div", {
                                key: 1,
                                class: wt(F.value(Y.marker)),
                                style: ri(Y.marker.color ? { backgroundColor: Y.marker.color } : {})
                              }, null, 6))
                            ], 64)) : be("", !0),
                            R.value(Y.value) ? (re(), ye("div", {
                              key: 3,
                              class: "dp__marker_tooltip",
                              ref_for: !0,
                              ref_key: "activeTooltip",
                              ref: b,
                              style: ri(c.value)
                            }, [
                              (Te = Y.marker) != null && Te.tooltip ? (re(), ye("div", {
                                key: 0,
                                class: "dp__tooltip_content",
                                onClick: M[0] || (M[0] = kt(() => {
                                }, ["stop"]))
                              }, [
                                (re(!0), ye(Je, null, Mr(Y.marker.tooltip, (ee, Oe) => (re(), ye("div", {
                                  key: Oe,
                                  class: "dp__tooltip_text"
                                }, [
                                  V.$slots["marker-tooltip"] ? We(V.$slots, "marker-tooltip", {
                                    key: 0,
                                    tooltip: ee,
                                    day: Y.value
                                  }) : be("", !0),
                                  V.$slots["marker-tooltip"] ? be("", !0) : (re(), ye(Je, { key: 1 }, [
                                    ke("div", {
                                      class: "dp__tooltip_mark",
                                      style: ri(ee.color ? { backgroundColor: ee.color } : {})
                                    }, null, 4),
                                    ke("div", null, er(ee.text), 1)
                                  ], 64))
                                ]))), 128)),
                                ke("div", {
                                  class: "dp__arrow_bottom_tp",
                                  style: ri(y.value)
                                }, null, 4)
                              ])) : be("", !0)
                            ], 4)) : be("", !0)
                          ], 2)
                        ], 40, bZe);
                      }), 128))
                    ]))), 128))
                  ], 8, mZe)) : be("", !0)
                ];
              }),
              _: 3
            }, 8, ["name", "css"])
          ], 64))
        ], 10, hZe)
      ], 2);
    };
  }
}), EB = (t) => Array.isArray(t), wZe = (t, e, r, n) => {
  const s = ue([]), { modelValue: a, calendars: o, time: l } = Ub(t, e), { defaultedMultiCalendars: u, defaultedStartTime: c } = Nn(t), { validateMonthYearInRange: d, isDisabled: h, isDateRangeAllowed: f, checkMinMaxRange: p } = Gv(t), { updateTimeValues: m, getSetDateTime: b, setTime: y, assignStartTime: _, disabledTimesConfig: x } = $j(
    t,
    l,
    a,
    n
  ), T = Ce(
    () => (j) => o.value[j] ? o.value[j].month : 0
  ), k = Ce(
    () => (j) => o.value[j] ? o.value[j].year : 0
  ), E = (j, ne, ge) => {
    var Ge, xt;
    o.value[j] || (o.value[j] = { month: 0, year: 0 }), o.value[j].month = bB(ne) ? (Ge = o.value[j]) == null ? void 0 : Ge.month : ne, o.value[j].year = bB(ge) ? (xt = o.value[j]) == null ? void 0 : xt.year : ge;
  }, F = () => {
    t.autoApply && e("select-date");
  };
  Lr(a, (j, ne) => {
    JSON.stringify(j) !== JSON.stringify(ne) && O();
  }), Nr(() => {
    t.shadow || (a.value || (V(), c.value && _(c.value)), O(!0), t.focusStartDate && t.startDate && V());
  });
  const R = Ce(() => {
    var j;
    return (j = t.flow) != null && j.length && !t.partialFlow ? t.flowStep === t.flow.length : !0;
  }), $ = () => {
    t.autoApply && R.value && e("auto-apply", t.partialFlow);
  }, O = (j = !1) => {
    if (a.value)
      return Array.isArray(a.value) ? (s.value = a.value, Q(j)) : N(a.value, j);
    if (u.value.count && j && !t.startDate)
      return P($e(), j);
  }, P = (j, ne = !1) => {
    if ((!u.value.count || !u.value.static || ne) && E(0, Zt(j), Yt(j)), u.value.count)
      for (let ge = 1; ge < u.value.count; ge++) {
        const Ge = Xr($e(), { month: T.value(ge - 1), year: k.value(ge - 1) }), xt = HW(Ge, { months: 1 });
        o.value[ge] = { month: Zt(xt), year: Yt(xt) };
      }
  }, N = (j, ne) => {
    P(j), y("hours", Da(j)), y("minutes", Oa(j)), y("seconds", Jd(j)), u.value.count && ne && A();
  }, I = (j) => u.value.count ? Math.abs(Zze(j[0], j[1])) >= u.value.count ? 1 : 0 : 1, B = (j, ne) => {
    j[1] && t.showLastInRange ? P(j[I(j)], ne) : P(j[0], ne);
    const ge = (Ge, xt) => [
      Ge(j[0]),
      j[1] ? Ge(j[1]) : l[xt][1]
    ];
    y("hours", ge(Da, "hours")), y("minutes", ge(Oa, "minutes")), y("seconds", ge(Jd, "seconds"));
  }, W = (j, ne) => {
    if ((t.range || t.weekPicker) && !t.multiDates)
      return B(j, ne);
    if (t.multiDates) {
      const ge = j[j.length - 1];
      return N(ge, ne);
    }
  }, Q = (j) => {
    const ne = a.value;
    W(ne, j), u.value.count && u.value.solo && A();
  }, te = (j, ne) => {
    const ge = Xr($e(), { month: T.value(ne), year: k.value(ne) }), Ge = j < 0 ? ka(ge, 1) : eh(ge, 1);
    d(Zt(Ge), Yt(Ge), j < 0, t.preventMinMaxNavigation) && (E(ne, Zt(Ge), Yt(Ge)), u.value.count && !u.value.solo && H(ne), r());
  }, H = (j) => {
    for (let ne = j - 1; ne >= 0; ne--) {
      const ge = eh(Xr($e(), { month: T.value(ne + 1), year: k.value(ne + 1) }), 1);
      E(ne, Zt(ge), Yt(ge));
    }
    for (let ne = j + 1; ne <= u.value.count - 1; ne++) {
      const ge = ka(Xr($e(), { month: T.value(ne - 1), year: k.value(ne - 1) }), 1);
      E(ne, Zt(ge), Yt(ge));
    }
  }, A = () => {
    if (Array.isArray(a.value) && a.value.length === 2) {
      const j = $e(
        $e(a.value[1] ? a.value[1] : ka(a.value[0], 1))
      ), [ne, ge] = [Zt(a.value[0]), Yt(a.value[0])], [Ge, xt] = [Zt(a.value[1]), Yt(a.value[1])];
      (ne !== Ge || ne === Ge && ge !== xt) && u.value.solo && E(1, Zt(j), Yt(j));
    } else
      a.value && !Array.isArray(a.value) && (E(0, Zt(a.value), Yt(a.value)), P($e()));
  }, V = () => {
    t.startDate && (E(0, Zt($e(t.startDate)), Yt($e(t.startDate))), u.value.count && H(0));
  }, M = (j, ne) => {
    t.monthChangeOnScroll && te(t.monthChangeOnScroll !== "inverse" ? -j.deltaY : j.deltaY, ne);
  }, Z = (j, ne, ge = !1) => {
    t.monthChangeOnArrows && t.vertical === ge && U(j, ne);
  }, U = (j, ne) => {
    te(j === "right" ? -1 : 1, ne);
  }, pe = (j) => t.markers.find((ne) => Jt(wB(j.value), wB(ne.date))), q = (j, ne) => {
    switch (t.sixWeeks === !0 ? "append" : t.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [j == 0, !0];
      case "fair":
        return [j == 0 || ne > j, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, Y = (j, ne, ge, Ge) => {
    if (t.sixWeeks && j.length < 6) {
      const xt = 6 - j.length, vn = (ne.getDay() + 7 - Ge) % 7, Es = 6 - (ge.getDay() + 7 - Ge) % 7, [Ii, na] = q(vn, Es);
      for (let Ot = 1; Ot <= xt; Ot++)
        if (na ? !!(Ot % 2) == Ii : Ii) {
          const Ur = j[0].days[0], ia = se(no(Ur.value, -7), Zt(ne));
          j.unshift({ days: ia });
        } else {
          const Ur = j[j.length - 1], ia = Ur.days[Ur.days.length - 1], _c = se(no(ia.value, 1), Zt(ne));
          j.push({ days: _c });
        }
    }
    return j;
  }, se = (j, ne) => {
    const ge = $e(JSON.parse(JSON.stringify(j))), Ge = [];
    for (let xt = 0; xt < 7; xt++) {
      const vn = no(ge, xt), Es = Zt(vn) !== ne;
      Ge.push({
        text: t.hideOffsetDates && Es ? "" : vn.getDate(),
        value: vn,
        current: !Es,
        classData: {}
      });
    }
    return Ge;
  }, he = (j, ne) => {
    const ge = [], Ge = $e(Ta(new Date(ne, j), t.timezone)), xt = $e(Ta(new Date(ne, j + 1, 0), t.timezone)), vn = t.weekStart, Es = Qu(Ge, { weekStartsOn: vn }), Ii = (na) => {
      const Ot = se(na, j);
      if (ge.push({ days: Ot }), !ge[ge.length - 1].days.some(
        (Ur) => Jt(ms(Ur.value), ms(xt))
      )) {
        const Ur = no(na, 7);
        Ii(Ur);
      }
    };
    return Ii(Es), Y(ge, Ge, xt, vn);
  }, fe = (j) => (a.value = Yg($e(j.value), t.timezone, t.weekStart), $()), Te = (j) => {
    const ne = xl($e(j.value), l.hours, l.minutes, ve());
    t.multiDates ? MA(ne, a, t.multiDatesLimit) : a.value = ne, n(), Ia().then(() => {
      $();
    });
  }, ee = (j) => t.noDisabledRange ? bj(s.value[0], j).some((ne) => h(ne)) : !1, Oe = () => {
    s.value = a.value ? a.value.slice() : [], s.value.length === 2 && !(t.fixedStart || t.fixedEnd) && (s.value = []);
  }, ut = (j, ne) => {
    const ge = [$e(j.value), no($e(j.value), +t.autoRange)];
    f(ge) && (ne && L(j.value), s.value = ge);
  }, L = (j) => {
    const ne = Zt($e(j)), ge = Yt($e(j));
    if (E(0, ne, ge), u.value.count > 0)
      for (let Ge = 1; Ge < u.value.count; Ge++) {
        const xt = lQe(
          Xr($e(j), { year: T.value(Ge - 1), month: k.value(Ge - 1) })
        );
        E(Ge, xt.month, xt.year);
      }
  }, K = (j) => Array.isArray(a.value) && a.value.length === 2 ? t.fixedStart && (Gn(j, a.value[0]) || Jt(j, a.value[0])) ? [a.value[0], j] : t.fixedEnd && (Mn(j, a.value[1]) || Jt(j, a.value[1])) ? [j, a.value[1]] : (e("invalid-fixed-range", j), a.value) : [], ie = (j) => {
    ee(j.value) || !p(j.value, a.value, t.fixedStart ? 0 : 1) || (s.value = K($e(j.value)));
  }, ce = (j, ne) => {
    if (Oe(), t.autoRange)
      return ut(j, ne);
    if (t.fixedStart || t.fixedEnd)
      return ie(j);
    s.value[0] ? p($e(j.value), a.value) && !ee(j.value) && (Mn($e(j.value), $e(s.value[0])) ? (s.value.unshift($e(j.value)), e("range-end", s.value[0])) : (s.value[1] = $e(j.value), e("range-end", s.value[1]))) : (s.value[0] = $e(j.value), e("range-start", s.value[0]));
  }, ve = (j = !0) => t.enableSeconds ? Array.isArray(l.seconds) ? j ? l.seconds[0] : l.seconds[1] : l.seconds : 0, De = (j) => {
    s.value[j] = xl(
      s.value[j],
      l.hours[j],
      l.minutes[j],
      ve(j !== 1)
    );
  }, Re = () => {
    var j, ne;
    s.value[0] && s.value[1] && +((j = s.value) == null ? void 0 : j[0]) > +((ne = s.value) == null ? void 0 : ne[1]) && (s.value.reverse(), e("range-start", s.value[0]), e("range-end", s.value[1]));
  }, Se = () => {
    s.value.length && (s.value[0] && !s.value[1] ? De(0) : (De(0), De(1), n()), Re(), a.value = s.value.slice(), LA(s.value, e, t.autoApply, t.modelAuto));
  }, xe = (j, ne = !1) => {
    if (!(h(j.value) || !j.current && t.hideOffsetDates)) {
      if (t.weekPicker)
        return fe(j);
      if (!t.range)
        return Te(j);
      EB(l.hours) && EB(l.minutes) && !t.multiDates && (ce(j, ne), Se());
    }
  }, me = (j, ne) => {
    E(j, ne.month, ne.year), u.value.count && !u.value.solo && H(j), r(u.value.solo ? j : void 0), n();
  }, Ye = (j, ne) => {
    Array.isArray(j) && j.length <= 2 && t.range ? a.value = j.map((ge) => Ta($e(ge), ne ? void 0 : t.timezone)) : Array.isArray(j) || (a.value = Ta($e(j), ne ? void 0 : t.timezone)), F(), t.multiCalendars && Ia().then(() => O(!0));
  }, Fe = () => {
    t.range ? a.value && Array.isArray(a.value) && a.value[0] ? a.value = Mn($e(), a.value[0]) ? [$e(), a.value[0]] : [a.value[0], $e()] : a.value = [$e()] : a.value = $e(), F();
  }, Me = () => {
    if (Array.isArray(a.value))
      if (t.multiDates) {
        const j = Ae();
        a.value[a.value.length - 1] = b(j);
      } else
        a.value = a.value.map((j, ne) => j && b(j, ne));
    else
      a.value = b(a.value);
    e("time-update");
  }, Ae = () => Array.isArray(a.value) && a.value.length ? a.value[a.value.length - 1] : null;
  return {
    calendars: o,
    modelValue: a,
    month: T,
    year: k,
    time: l,
    disabledTimesConfig: x,
    getCalendarDays: he,
    getMarker: pe,
    handleScroll: M,
    handleSwipe: U,
    handleArrow: Z,
    selectDate: xe,
    updateMonthYear: me,
    presetDate: Ye,
    selectCurrentDate: Fe,
    updateTime: (j, ne = !0, ge = !1) => {
      m(j, ne, ge, Me);
    }
  };
}, TZe = { key: 0 }, xZe = /* @__PURE__ */ Dt({
  __name: "DatePicker",
  props: {
    ...Ho
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position"
  ],
  setup(t, { expose: e, emit: r }) {
    const n = t, {
      calendars: s,
      month: a,
      year: o,
      modelValue: l,
      time: u,
      disabledTimesConfig: c,
      getCalendarDays: d,
      getMarker: h,
      handleArrow: f,
      handleScroll: p,
      handleSwipe: m,
      selectDate: b,
      updateMonthYear: y,
      presetDate: _,
      selectCurrentDate: x,
      updateTime: T
    } = wZe(n, r, H, A), k = sh(), { setHoverDate: E, getDayClassData: F, clearHoverDate: R } = $Qe(l, n), { defaultedMultiCalendars: $ } = Nn(n), O = ue([]), P = ue([]), N = ue(null), I = Ys(k, "calendar"), B = Ys(k, "monthYear"), W = Ys(k, "timePicker"), Q = (M) => {
      n.shadow || r("mount", M);
    };
    Lr(
      s,
      () => {
        n.shadow || setTimeout(() => {
          r("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    );
    const te = Ce(() => (M) => d(a.value(M), o.value(M)).map((Z) => ({
      ...Z,
      days: Z.days.map((U) => (U.marker = h(U), U.classData = F(U), U))
    })));
    function H(M) {
      var Z;
      M || M === 0 ? (Z = P.value[M]) == null || Z.triggerTransition(a.value(M), o.value(M)) : P.value.forEach((U, pe) => U.triggerTransition(a.value(pe), o.value(pe)));
    }
    function A() {
      r("update-flow-step");
    }
    const V = (M, Z = !1) => {
      b(M, Z), n.spaceConfirm && r("select-date");
    };
    return e({
      clearHoverDate: R,
      presetDate: _,
      selectCurrentDate: x,
      toggleMonthPicker: (M, Z, U = 0) => {
        var pe;
        (pe = O.value[U]) == null || pe.toggleMonthPicker(M, Z);
      },
      toggleYearPicker: (M, Z, U = 0) => {
        var pe;
        (pe = O.value[U]) == null || pe.toggleYearPicker(M, Z);
      },
      toggleTimePicker: (M, Z, U) => {
        var pe;
        (pe = N.value) == null || pe.toggleTimePicker(M, Z, U);
      },
      handleArrow: f,
      updateMonthYear: y,
      getSidebarProps: () => ({
        modelValue: l,
        month: a,
        year: o,
        time: u,
        updateTime: T,
        updateMonthYear: y,
        selectDate: b,
        presetDate: _
      })
    }), (M, Z) => (re(), ye(Je, null, [
      je(RA, {
        "multi-calendars": X($).count
      }, {
        default: tt(({ instance: U, index: pe }) => [
          M.disableMonthYearSelect ? be("", !0) : (re(), ot(dZe, ni({
            key: 0,
            ref: (q) => {
              q && (O.value[pe] = q);
            },
            months: X(vj)(M.formatLocale, M.locale, M.monthNameFormat),
            years: X(IA)(M.yearRange, M.reverseYears),
            month: X(a)(U),
            year: X(o)(U),
            instance: U
          }, M.$props, {
            onMount: Z[0] || (Z[0] = (q) => Q(X(Pu).header)),
            onResetFlow: Z[1] || (Z[1] = (q) => M.$emit("reset-flow")),
            onUpdateMonthYear: (q) => X(y)(U, q),
            onOverlayClosed: Z[2] || (Z[2] = (q) => M.$emit("focus-menu"))
          }), Si({ _: 2 }, [
            Mr(X(B), (q, Y) => ({
              name: q,
              fn: tt((se) => [
                We(M.$slots, q, Hn(Hi(se)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          je(_Ze, ni({
            ref: (q) => {
              q && (P.value[pe] = q);
            },
            "mapped-dates": te.value(U),
            month: X(a)(U),
            year: X(o)(U)
          }, M.$props, {
            onSelectDate: (q) => X(b)(q, U !== 1),
            onHandleSpace: (q) => V(q, U !== 1),
            onSetHoverDate: Z[3] || (Z[3] = (q) => X(E)(q)),
            onHandleScroll: (q) => X(p)(q, U),
            onHandleSwipe: (q) => X(m)(q, U),
            onMount: Z[4] || (Z[4] = (q) => Q(X(Pu).calendar)),
            onResetFlow: Z[5] || (Z[5] = (q) => M.$emit("reset-flow")),
            onTooltipOpen: Z[6] || (Z[6] = (q) => M.$emit("tooltip-open", q)),
            onTooltipClose: Z[7] || (Z[7] = (q) => M.$emit("tooltip-close", q))
          }), Si({ _: 2 }, [
            Mr(X(I), (q, Y) => ({
              name: q,
              fn: tt((se) => [
                We(M.$slots, q, Hn(Hi({ ...se })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars"]),
      M.enableTimePicker ? (re(), ye("div", TZe, [
        M.$slots["time-picker"] ? We(M.$slots, "time-picker", Hn(ni({ key: 0 }, { time: X(u), updateTime: X(T) }))) : (re(), ot(Ej, ni({
          key: 1,
          ref_key: "timePickerRef",
          ref: N
        }, M.$props, {
          hours: X(u).hours,
          minutes: X(u).minutes,
          seconds: X(u).seconds,
          "internal-model-value": M.internalModelValue,
          "disabled-times-config": X(c),
          onMount: Z[8] || (Z[8] = (U) => Q(X(Pu).timePicker)),
          "onUpdate:hours": Z[9] || (Z[9] = (U) => X(T)(U)),
          "onUpdate:minutes": Z[10] || (Z[10] = (U) => X(T)(U, !1)),
          "onUpdate:seconds": Z[11] || (Z[11] = (U) => X(T)(U, !1, !0)),
          onResetFlow: Z[12] || (Z[12] = (U) => M.$emit("reset-flow")),
          onOverlayClosed: Z[13] || (Z[13] = (U) => M.$emit("time-picker-close")),
          onOverlayOpened: Z[14] || (Z[14] = (U) => M.$emit("time-picker-open", U)),
          onAmPmChange: Z[15] || (Z[15] = (U) => M.$emit("am-pm-change", U))
        }), Si({ _: 2 }, [
          Mr(X(W), (U, pe) => ({
            name: U,
            fn: tt((q) => [
              We(M.$slots, U, Hn(Hi(q)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config"]))
      ])) : be("", !0)
    ], 64));
  }
}), SZe = ["id", "onKeydown"], EZe = {
  key: 0,
  class: "dp__sidebar_left"
}, $Ze = {
  key: 1,
  class: "dp--preset-dates"
}, kZe = ["onClick", "onKeydown"], DZe = {
  key: 2,
  class: "dp__sidebar_right"
}, OZe = {
  key: 3,
  class: "dp__action_extra"
}, $B = /* @__PURE__ */ Dt({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...Yb,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    arrMapValues: { type: Object, default: () => ({}) }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end"
  ],
  setup(t, { expose: e, emit: r }) {
    const n = t, s = Ce(() => {
      const { openOnTop: ee, ...Oe } = n;
      return {
        ...Oe,
        flowStep: F.value
      };
    }), { setMenuFocused: a, setShiftKey: o, control: l } = xj(), u = sh(), { defaultedTextInput: c, defaultedInline: d } = Nn(n), h = ue(null), f = ue(0), p = ue(null), m = ue(null), b = ue(!1), y = ue(null);
    Nr(() => {
      if (!n.shadow) {
        b.value = !0, _(), window.addEventListener("resize", _);
        const ee = un(p);
        if (ee && !c.value.enabled && !d.value.enabled && (a(!0), N()), ee) {
          const Oe = (ut) => {
            n.allowPreventDefault && ut.preventDefault(), ut.stopImmediatePropagation(), ut.stopPropagation();
          };
          ee.addEventListener("pointerdown", Oe), ee.addEventListener("mousedown", Oe);
        }
      }
    }), ih(() => {
      window.removeEventListener("resize", _);
    });
    const _ = () => {
      const ee = un(m);
      ee && (f.value = ee.getBoundingClientRect().width);
    }, { arrowRight: x, arrowLeft: T, arrowDown: k, arrowUp: E } = Ul(), { flowStep: F, updateFlowStep: R, childMount: $, resetFlow: O } = kQe(n, r, y), P = Ce(() => n.monthPicker ? GQe : n.yearPicker ? jQe : n.timePicker ? lZe : xZe), N = () => {
      const ee = un(p);
      ee && ee.focus({ preventScroll: !0 });
    }, I = () => Ce(() => {
      var ee;
      return (ee = y.value) == null ? void 0 : ee.getSidebarProps();
    }), B = () => {
      n.openOnTop && r("recalculate-position");
    }, W = Ys(u, "action"), Q = Ce(() => n.monthPicker || n.yearPicker ? Ys(u, "monthYear") : n.timePicker ? Ys(u, "timePicker") : Ys(u, "shared")), te = Ce(() => n.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), H = Ce(() => ({
      dp__menu_disabled: n.disabled,
      dp__menu_readonly: n.readonly
    })), A = Ce(
      () => ({
        dp__menu: !0,
        dp__menu_index: !d.value.enabled,
        dp__relative: d.value.enabled,
        [n.menuClassName]: !!n.menuClassName
      })
    ), V = (ee) => {
      ee.stopPropagation(), ee.stopImmediatePropagation();
    }, M = () => {
      n.escClose && r("close-picker");
    }, Z = (ee) => {
      if (n.arrowNavigation) {
        if (ee === "up")
          return E();
        if (ee === "down")
          return k();
        if (ee === "left")
          return T();
        if (ee === "right")
          return x();
      } else
        ee === "left" || ee === "up" ? se("handleArrow", "left", 0, ee === "up") : se("handleArrow", "right", 0, ee === "down");
    }, U = (ee) => {
      o(ee.shiftKey), !n.disableMonthYearSelect && ee.code === "Tab" && ee.target.classList.contains("dp__menu") && l.value.shiftKeyInMenu && (ee.preventDefault(), ee.stopImmediatePropagation(), r("close-picker"));
    }, pe = () => {
      N(), r("time-picker-close");
    }, q = (ee) => {
      var Oe, ut, L;
      (Oe = y.value) == null || Oe.toggleTimePicker(!1, !1), (ut = y.value) == null || ut.toggleMonthPicker(!1, !1, ee), (L = y.value) == null || L.toggleYearPicker(!1, !1, ee);
    }, Y = (ee, Oe = 0) => {
      var ut, L, K;
      return ee === "month" ? (ut = y.value) == null ? void 0 : ut.toggleMonthPicker(!1, !0, Oe) : ee === "year" ? (L = y.value) == null ? void 0 : L.toggleYearPicker(!1, !0, Oe) : ee === "time" ? (K = y.value) == null ? void 0 : K.toggleTimePicker(!0, !1) : q(Oe);
    }, se = (ee, ...Oe) => {
      var ut, L;
      (ut = y.value) != null && ut[ee] && ((L = y.value) == null || L[ee](...Oe));
    }, he = () => {
      se("selectCurrentDate");
    }, fe = (ee, Oe) => {
      se("presetDate", ee, Oe);
    }, Te = () => {
      se("clearHoverDate");
    };
    return e({
      updateMonthYear: (ee, Oe) => {
        se("updateMonthYear", ee, Oe);
      },
      switchView: Y
    }), (ee, Oe) => {
      var ut;
      return re(), ye("div", {
        id: ee.uid ? `dp-menu-${ee.uid}` : void 0,
        tabindex: "0",
        ref_key: "dpMenuRef",
        ref: p,
        role: "dialog",
        class: wt(A.value),
        onMouseleave: Te,
        onClick: V,
        onKeydown: [
          pt(M, ["esc"]),
          Oe[14] || (Oe[14] = pt(kt((L) => Z("left"), ["prevent"]), ["left"])),
          Oe[15] || (Oe[15] = pt(kt((L) => Z("up"), ["prevent"]), ["up"])),
          Oe[16] || (Oe[16] = pt(kt((L) => Z("down"), ["prevent"]), ["down"])),
          Oe[17] || (Oe[17] = pt(kt((L) => Z("right"), ["prevent"]), ["right"])),
          U
        ]
      }, [
        (ee.disabled || ee.readonly) && X(d).enabled ? (re(), ye("div", {
          key: 0,
          class: wt(H.value)
        }, null, 2)) : be("", !0),
        !X(d).enabled && !ee.teleportCenter ? (re(), ye("div", {
          key: 1,
          class: wt(te.value)
        }, null, 2)) : be("", !0),
        ke("div", {
          ref_key: "innerMenuRef",
          ref: m,
          class: wt({
            dp__menu_content_wrapper: ((ut = ee.presetDates) == null ? void 0 : ut.length) || !!ee.$slots["left-sidebar"] || !!ee.$slots["right-sidebar"]
          }),
          style: ri({ "--dp-menu-width": `${f.value}px` })
        }, [
          ee.$slots["left-sidebar"] ? (re(), ye("div", EZe, [
            We(ee.$slots, "left-sidebar", Hn(Hi(I())))
          ])) : be("", !0),
          ee.presetDates.length ? (re(), ye("div", $Ze, [
            (re(!0), ye(Je, null, Mr(ee.presetDates, (L, K) => (re(), ye("div", {
              key: K,
              style: ri(L.style || {}),
              class: "dp--preset-range"
            }, [
              L.slot ? We(ee.$slots, L.slot, {
                key: 0,
                presetDate: fe,
                label: L.label,
                value: L.value
              }) : (re(), ye("div", {
                key: 1,
                role: "button",
                tabindex: "0",
                onClick: (ie) => fe(L.value, L.noTz),
                onKeydown: [
                  pt(kt((ie) => fe(L.value, L.noTz), ["prevent"]), ["enter"]),
                  pt(kt((ie) => fe(L.value, L.noTz), ["prevent"]), ["space"])
                ]
              }, er(L.label), 41, kZe))
            ], 4))), 128))
          ])) : be("", !0),
          ke("div", {
            class: "dp__instance_calendar",
            ref_key: "calendarWrapperRef",
            ref: h,
            role: "document"
          }, [
            (re(), ot(Ak(P.value), ni({
              ref_key: "dynCmpRef",
              ref: y
            }, s.value, {
              "flow-step": X(F),
              onMount: X($),
              onUpdateFlowStep: X(R),
              onResetFlow: X(O),
              onFocusMenu: N,
              onSelectDate: Oe[0] || (Oe[0] = (L) => ee.$emit("select-date")),
              onTooltipOpen: Oe[1] || (Oe[1] = (L) => ee.$emit("tooltip-open", L)),
              onTooltipClose: Oe[2] || (Oe[2] = (L) => ee.$emit("tooltip-close", L)),
              onAutoApply: Oe[3] || (Oe[3] = (L) => ee.$emit("auto-apply", L)),
              onRangeStart: Oe[4] || (Oe[4] = (L) => ee.$emit("range-start", L)),
              onRangeEnd: Oe[5] || (Oe[5] = (L) => ee.$emit("range-end", L)),
              onInvalidFixedRange: Oe[6] || (Oe[6] = (L) => ee.$emit("invalid-fixed-range", L)),
              onTimeUpdate: Oe[7] || (Oe[7] = (L) => ee.$emit("time-update")),
              onAmPmChange: Oe[8] || (Oe[8] = (L) => ee.$emit("am-pm-change", L)),
              onTimePickerOpen: Oe[9] || (Oe[9] = (L) => ee.$emit("time-picker-open", L)),
              onTimePickerClose: pe,
              onRecalculatePosition: B,
              "onUpdate:internalModelValue": Oe[10] || (Oe[10] = (L) => ee.$emit("update:internal-model-value", L))
            }), Si({ _: 2 }, [
              Mr(Q.value, (L, K) => ({
                name: L,
                fn: tt((ie) => [
                  We(ee.$slots, L, Hn(Hi({ ...ie })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          ee.$slots["right-sidebar"] ? (re(), ye("div", DZe, [
            We(ee.$slots, "right-sidebar", Hn(Hi(I())))
          ])) : be("", !0),
          ee.$slots["action-extra"] ? (re(), ye("div", OZe, [
            ee.$slots["action-extra"] ? We(ee.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: he
            }) : be("", !0)
          ])) : be("", !0)
        ], 6),
        !ee.autoApply || ee.keepActionRow ? (re(), ot(MQe, ni({
          key: 2,
          "menu-mount": b.value
        }, s.value, {
          "calendar-width": f.value,
          onClosePicker: Oe[11] || (Oe[11] = (L) => ee.$emit("close-picker")),
          onSelectDate: Oe[12] || (Oe[12] = (L) => ee.$emit("select-date")),
          onInvalidSelect: Oe[13] || (Oe[13] = (L) => ee.$emit("invalid-select")),
          onSelectNow: he
        }), Si({ _: 2 }, [
          Mr(X(W), (L, K) => ({
            name: L,
            fn: tt((ie) => [
              We(ee.$slots, L, Hn(Hi({ ...ie })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : be("", !0)
      ], 42, SZe);
    };
  }
}), AZe = typeof window < "u" ? window : void 0, $T = () => {
}, CZe = (t) => wk() ? (FB(t), !0) : !1, IZe = (t, e, r, n) => {
  if (!t)
    return $T;
  let s = $T;
  const a = Lr(
    () => X(t),
    (l) => {
      s(), l && (l.addEventListener(e, r, n), s = () => {
        l.removeEventListener(e, r, n), s = $T;
      });
    },
    { immediate: !0, flush: "post" }
  ), o = () => {
    a(), s();
  };
  return CZe(o), o;
}, PZe = (t, e, r, n = {}) => {
  const { window: s = AZe, event: a = "pointerdown" } = n;
  return s ? IZe(s, a, (o) => {
    const l = un(t), u = un(e);
    !l || !u || l === o.target || o.composedPath().includes(l) || o.composedPath().includes(u) || r(o);
  }, { passive: !0 }) : void 0;
}, RZe = /* @__PURE__ */ Dt({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...Yb
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end"
  ],
  setup(t, { expose: e, emit: r }) {
    const n = t, s = sh(), a = ue(!1), o = Zg(n, "modelValue"), l = Zg(n, "timezone"), u = ue(null), c = ue(null), d = ue(null), h = ue(!1), f = ue(null), { setMenuFocused: p, setShiftKey: m } = xj(), { clearArrowNav: b } = Ul(), { mapDatesArrToMap: y, validateDate: _, isValidTime: x } = Gv(n), { defaultedTransitions: T, defaultedTextInput: k, defaultedInline: E } = Nn(n), { menuTransition: F, showTransition: R } = Hv(T);
    Nr(() => {
      V(n.modelValue), Ia().then(() => {
        E.value.enabled || (Q(f.value).addEventListener("scroll", se), window.addEventListener("resize", he));
      }), E.value.enabled && (a.value = !0);
    });
    const $ = Ce(() => y());
    ih(() => {
      if (!E.value.enabled) {
        const Ae = Q(f.value);
        Ae && Ae.removeEventListener("scroll", se), window.removeEventListener("resize", he);
      }
    });
    const O = Ys(s, "all", n.presetDates), P = Ys(s, "input");
    Lr(
      [o, l],
      () => {
        V(o.value);
      },
      { deep: !0 }
    );
    const { openOnTop: N, menuStyle: I, xCorrect: B, setMenuPosition: W, getScrollableParent: Q, shadowRender: te } = xQe(
      u,
      c,
      d,
      f,
      E,
      r,
      n
    ), {
      inputValue: H,
      internalModelValue: A,
      parseExternalModelValue: V,
      emitModelValue: M,
      formatInputValue: Z,
      checkBeforeEmit: U
    } = wQe(r, n, h), pe = Ce(
      () => ({
        dp__main: !0,
        dp__theme_dark: n.dark,
        dp__theme_light: !n.dark,
        dp__flex_display: E.value.enabled,
        dp__flex_display_with_input: E.value.input
      })
    ), q = Ce(() => n.dark ? "dp__theme_dark" : "dp__theme_light"), Y = Ce(() => n.teleport ? {
      to: typeof n.teleport == "boolean" ? "body" : n.teleport,
      disabled: E.value.enabled
    } : { class: "dp__outer_menu_wrap" }), se = () => {
      a.value && (n.closeOnScroll ? ce() : W());
    }, he = () => {
      a.value && W();
    }, fe = () => {
      !n.disabled && !n.readonly && (te($B, n), W(!1), a.value = !0, a.value && r("open"), a.value || ie(), V(n.modelValue));
    }, Te = () => {
      H.value = "", ie(), r("update:model-value", null), r("update:model-timezone-value", null), r("cleared"), n.closeOnClearValue && ce();
    }, ee = () => {
      const Ae = A.value;
      return !Ae || !Array.isArray(Ae) && _(Ae) ? !0 : Array.isArray(Ae) ? Ae.length === 2 && _(Ae[0]) && _(Ae[1]) ? !0 : n.partialRange && !n.timePicker ? _(Ae[0]) : !1 : !1;
    }, Oe = () => {
      U() && ee() ? (M(), ce()) : r("invalid-select", A.value);
    }, ut = (Ae) => {
      L(), M(), n.closeOnAutoApply && !Ae && ce();
    }, L = () => {
      d.value && k.value.enabled && d.value.setParsedDate(A.value);
    }, K = (Ae = !1) => {
      n.autoApply && x(A.value) && ee() && (n.range && Array.isArray(A.value) ? (n.partialRange || A.value.length === 2) && ut(Ae) : ut(Ae));
    }, ie = () => {
      k.value.enabled || (A.value = null);
    }, ce = () => {
      E.value.enabled || (a.value && (a.value = !1, B.value = !1, p(!1), m(!1), b(), r("closed"), H.value && V(o.value)), ie(), r("blur"));
    }, ve = (Ae, j) => {
      if (!Ae) {
        A.value = null;
        return;
      }
      A.value = Ae, j && (Oe(), r("text-submit"));
    }, De = () => {
      n.autoApply && x(A.value) && M(), L();
    }, Re = () => a.value ? ce() : fe(), Se = (Ae) => {
      A.value = Ae;
    }, xe = () => {
      k.value.enabled && (h.value = !0, Z()), r("focus");
    }, me = () => {
      k.value.enabled && (h.value = !1, V(n.modelValue)), r("blur");
    }, Ye = (Ae) => {
      c.value && c.value.updateMonthYear(0, {
        month: yB(Ae.month),
        year: yB(Ae.year)
      });
    }, Fe = (Ae) => {
      V(Ae ?? n.modelValue);
    }, Me = (Ae, j) => {
      var ne;
      (ne = c.value) == null || ne.switchView(Ae, j);
    };
    return PZe(
      u,
      d,
      n.onClickOutside ? () => n.onClickOutside(ee) : ce
    ), e({
      closeMenu: ce,
      selectDate: Oe,
      clearValue: Te,
      openMenu: fe,
      onScroll: se,
      formatInputValue: Z,
      // exposed for testing purposes
      updateInternalModelValue: Se,
      // modify internal modelValue
      setMonthYear: Ye,
      parseModel: Fe,
      switchView: Me
    }), (Ae, j) => (re(), ye("div", {
      class: wt(pe.value),
      ref_key: "pickerWrapperRef",
      ref: f
    }, [
      je(CQe, ni({
        ref_key: "inputRef",
        ref: d,
        "is-menu-open": a.value,
        "input-value": X(H),
        "onUpdate:inputValue": j[0] || (j[0] = (ne) => Or(H) ? H.value = ne : null)
      }, Ae.$props, {
        onClear: Te,
        onOpen: fe,
        onSetInputDate: ve,
        onSetEmptyDate: X(M),
        onSelectDate: Oe,
        onToggle: Re,
        onClose: ce,
        onFocus: xe,
        onBlur: me,
        onRealBlur: j[1] || (j[1] = (ne) => h.value = !1)
      }), Si({ _: 2 }, [
        Mr(X(P), (ne, ge) => ({
          name: ne,
          fn: tt((Ge) => [
            We(Ae.$slots, ne, Hn(Hi(Ge)))
          ])
        }))
      ]), 1040, ["is-menu-open", "input-value", "onSetEmptyDate"]),
      je(gs, {
        name: X(F)(X(N)),
        css: X(R) && !X(E).enabled
      }, {
        default: tt(() => [
          a.value ? (re(), ot(Ak(Ae.teleport ? R3 : "div"), ni({
            key: 0,
            ref_key: "dpWrapMenuRef",
            ref: u
          }, Y.value, {
            class: { "dp--menu-wrapper": !X(E).enabled },
            style: X(E).enabled ? void 0 : X(I)
          }), {
            default: tt(() => [
              je($B, ni({
                ref_key: "dpMenuRef",
                ref: c,
                class: { [q.value]: !0, "dp--menu-wrapper": Ae.teleport },
                style: Ae.teleport ? X(I) : void 0,
                "open-on-top": X(N),
                "arr-map-values": $.value
              }, Ae.$props, {
                "internal-model-value": X(A),
                "onUpdate:internalModelValue": j[2] || (j[2] = (ne) => Or(A) ? A.value = ne : null),
                onClosePicker: ce,
                onSelectDate: Oe,
                onAutoApply: K,
                onTimeUpdate: De,
                onFlowStep: j[3] || (j[3] = (ne) => Ae.$emit("flow-step", ne)),
                onUpdateMonthYear: j[4] || (j[4] = (ne) => Ae.$emit("update-month-year", ne)),
                onInvalidSelect: j[5] || (j[5] = (ne) => Ae.$emit("invalid-select", X(A))),
                onInvalidFixedRange: j[6] || (j[6] = (ne) => Ae.$emit("invalid-fixed-range", ne)),
                onRecalculatePosition: X(W),
                onTooltipOpen: j[7] || (j[7] = (ne) => Ae.$emit("tooltip-open", ne)),
                onTooltipClose: j[8] || (j[8] = (ne) => Ae.$emit("tooltip-close", ne)),
                onTimePickerOpen: j[9] || (j[9] = (ne) => Ae.$emit("time-picker-open", ne)),
                onTimePickerClose: j[10] || (j[10] = (ne) => Ae.$emit("time-picker-close", ne)),
                onAmPmChange: j[11] || (j[11] = (ne) => Ae.$emit("am-pm-change", ne)),
                onRangeStart: j[12] || (j[12] = (ne) => Ae.$emit("range-start", ne)),
                onRangeEnd: j[13] || (j[13] = (ne) => Ae.$emit("range-end", ne))
              }), Si({ _: 2 }, [
                Mr(X(O), (ne, ge) => ({
                  name: ne,
                  fn: tt((Ge) => [
                    We(Ae.$slots, ne, Hn(Hi({ ...Ge })))
                  ])
                }))
              ]), 1040, ["class", "style", "open-on-top", "arr-map-values", "internal-model-value", "onRecalculatePosition"])
            ]),
            _: 3
          }, 16, ["class", "style"])) : be("", !0)
        ]),
        _: 3
      }, 8, ["name", "css"])
    ], 2));
  }
}), Hb = /* @__PURE__ */ (() => {
  const t = RZe;
  return t.install = (e) => {
    e.component("Vue3DatePicker", t);
  }, t;
})(), MZe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hb
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(MZe).forEach(([t, e]) => {
  t !== "default" && (Hb[t] = e);
});
const LZe = (t) => !!(t && t.constructor && t.call && t.apply);
function* NZe(t, e, r = (s) => s, n = 1) {
  const s = LZe(r) ? r : () => r, a = e ? t : 0, o = e ?? t;
  for (let l = a; l <= o && (yield s(l), !(l + n > o)); l += n)
    ;
}
const kB = (t, e, r, n) => Array.from(NZe(t, e, r, n)), FZe = { class: "sp-speed__content" }, BZe = { class: "sp-speed__list" }, UZe = ["onClick"], VZe = { class: "sp-speed__value" }, YZe = { class: "sp-speed__title" }, HZe = ["value", "max"], GZe = /* @__PURE__ */ Dt({
  __name: "ButtonSpeed",
  setup(t) {
    const e = tr(Oi), r = tr(lV);
    if (!r)
      throw new Error("SPEED_MODULE no module assigned");
    const { speed: n, isActive: s, update: a } = r, o = ue(!1), l = ue();
    q3(l, () => o.value = !1);
    const u = [
      ...kB(0.5, 2, (h) => +h.toFixed(1), 0.1),
      ...kB(2, 8, (h) => h, 1)
    ], c = [
      {
        title: "Медленно",
        value: 0.5
      },
      {
        title: "Обычно",
        value: 1
      },
      {
        title: "Быстрее",
        value: 1.5
      },
      {
        title: "Быстро",
        value: 2
      },
      {
        title: "Быстрее быстрого",
        value: 4
      },
      {
        title: "Очень быстро",
        value: 8
      }
    ], d = Ce(() => {
      const h = u.findIndex((f) => f === n.value);
      return h !== -1 ? h + 1 : 1;
    });
    return (h, f) => {
      var p;
      return (p = X(e)) != null && p.speed ? (re(), ot(X(oV), {
        key: 0,
        ref_key: "popper",
        ref: l,
        disabled: !X(s),
        show: o.value,
        placement: "top",
        interactive: ""
      }, {
        content: tt(() => [
          ke("div", FZe, [
            ke("div", BZe, [
              (re(), ye(Je, null, Mr(c, (m) => ke("div", {
                key: m.value,
                class: wt(["sp-speed__item", {
                  "is-active": m.value === X(n)
                }]),
                onClick: (b) => X(a)(m.value)
              }, [
                ke("div", VZe, er(m.value.toFixed(1)) + "x ", 1),
                ke("div", YZe, er(m.title), 1)
              ], 10, UZe)), 64))
            ]),
            ke("input", {
              class: "sp-speed__range",
              type: "range",
              min: "1",
              step: "1",
              value: d.value,
              max: u.length,
              onInput: f[1] || (f[1] = (m) => X(a)(u[+m.target.value - 1]))
            }, null, 40, HZe)
          ])
        ]),
        default: tt(() => [
          ke("button", {
            class: wt(["sp-speed__button", { "is-disabled": !X(s) }]),
            onClick: f[0] || (f[0] = (m) => o.value = !0)
          }, er(X(n).toFixed(1)) + "x ", 3)
        ]),
        _: 1
      }, 8, ["disabled", "show"])) : be("", !0);
    };
  }
});
const WZe = /* @__PURE__ */ Di(GZe, [["__scopeId", "data-v-23463630"]]);
//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair
function jZe(t, e) {
  var r = t.split("_");
  return e % 10 === 1 && e % 100 !== 11 ? r[0] : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? r[1] : r[2];
}
function tl(t, e, r) {
  var n = {
    ss: e ? "секунда_секунды_секунд" : "секунду_секунды_секунд",
    mm: e ? "минута_минуты_минут" : "минуту_минуты_минут",
    hh: "час_часа_часов",
    dd: "день_дня_дней",
    ww: "неделя_недели_недель",
    MM: "месяц_месяца_месяцев",
    yy: "год_года_лет"
  };
  return r === "m" ? e ? "минута" : "минуту" : t + " " + jZe(n[r], +t);
}
var kT = [
  /^янв/i,
  /^фев/i,
  /^мар/i,
  /^апр/i,
  /^ма[йя]/i,
  /^июн/i,
  /^июл/i,
  /^авг/i,
  /^сен/i,
  /^окт/i,
  /^ноя/i,
  /^дек/i
];
we.defineLocale("ru", {
  months: {
    format: "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split(
      "_"
    ),
    standalone: "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split(
      "_"
    )
  },
  monthsShort: {
    // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
    format: "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split(
      "_"
    ),
    standalone: "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split(
      "_"
    )
  },
  weekdays: {
    standalone: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split(
      "_"
    ),
    format: "воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split(
      "_"
    ),
    isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
  },
  weekdaysShort: "вс_пн_вт_ср_чт_пт_сб".split("_"),
  weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"),
  monthsParse: kT,
  longMonthsParse: kT,
  shortMonthsParse: kT,
  // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
  monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
  // копия предыдущего
  monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
  // полные названия с падежами
  monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
  // Выражение, которое соответствует только сокращённым формам
  monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
  longDateFormat: {
    LT: "H:mm",
    LTS: "H:mm:ss",
    L: "DD.MM.YYYY",
    LL: "D MMMM YYYY г.",
    LLL: "D MMMM YYYY г., H:mm",
    LLLL: "dddd, D MMMM YYYY г., H:mm"
  },
  calendar: {
    sameDay: "[Сегодня, в] LT",
    nextDay: "[Завтра, в] LT",
    lastDay: "[Вчера, в] LT",
    nextWeek: function(t) {
      if (t.week() !== this.week())
        switch (this.day()) {
          case 0:
            return "[В следующее] dddd, [в] LT";
          case 1:
          case 2:
          case 4:
            return "[В следующий] dddd, [в] LT";
          case 3:
          case 5:
          case 6:
            return "[В следующую] dddd, [в] LT";
        }
      else
        return this.day() === 2 ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";
    },
    lastWeek: function(t) {
      if (t.week() !== this.week())
        switch (this.day()) {
          case 0:
            return "[В прошлое] dddd, [в] LT";
          case 1:
          case 2:
          case 4:
            return "[В прошлый] dddd, [в] LT";
          case 3:
          case 5:
          case 6:
            return "[В прошлую] dddd, [в] LT";
        }
      else
        return this.day() === 2 ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";
    },
    sameElse: "L"
  },
  relativeTime: {
    future: "через %s",
    past: "%s назад",
    s: "несколько секунд",
    ss: tl,
    m: tl,
    mm: tl,
    h: "час",
    hh: tl,
    d: "день",
    dd: tl,
    w: "неделя",
    ww: tl,
    M: "месяц",
    MM: tl,
    y: "год",
    yy: tl
  },
  meridiemParse: /ночи|утра|дня|вечера/i,
  isPM: function(t) {
    return /^(дня|вечера)$/.test(t);
  },
  meridiem: function(t, e, r) {
    return t < 4 ? "ночи" : t < 12 ? "утра" : t < 17 ? "дня" : "вечера";
  },
  dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
  ordinal: function(t, e) {
    switch (e) {
      case "M":
      case "d":
      case "DDD":
        return t + "-й";
      case "D":
        return t + "-го";
      case "w":
      case "W":
        return t + "-я";
      default:
        return t;
    }
  },
  week: {
    dow: 1,
    // Monday is the first day of the week.
    doy: 4
    // The week that contains Jan 4th is the first week of the year.
  }
});
function Sl(t) {
  return typeof t == "string" || t instanceof String;
}
function DB(t) {
  var e;
  return typeof t == "object" && t != null && (t == null || (e = t.constructor) == null ? void 0 : e.name) === "Object";
}
function kj(t, e) {
  return Array.isArray(e) ? kj(t, (r, n) => e.includes(n)) : Object.entries(t).reduce((r, n) => {
    let [s, a] = n;
    return e(a, s) && (r[s] = a), r;
  }, {});
}
const Ze = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function KZe(t) {
  switch (t) {
    case Ze.LEFT:
      return Ze.FORCE_LEFT;
    case Ze.RIGHT:
      return Ze.FORCE_RIGHT;
    default:
      return t;
  }
}
function DT(t) {
  return t.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function d0(t, e) {
  if (e === t)
    return !0;
  const r = Array.isArray(e), n = Array.isArray(t);
  let s;
  if (r && n) {
    if (e.length != t.length)
      return !1;
    for (s = 0; s < e.length; s++)
      if (!d0(e[s], t[s]))
        return !1;
    return !0;
  }
  if (r != n)
    return !1;
  if (e && t && typeof e == "object" && typeof t == "object") {
    const a = e instanceof Date, o = t instanceof Date;
    if (a && o)
      return e.getTime() == t.getTime();
    if (a != o)
      return !1;
    const l = e instanceof RegExp, u = t instanceof RegExp;
    if (l && u)
      return e.toString() == t.toString();
    if (l != u)
      return !1;
    const c = Object.keys(e);
    for (s = 0; s < c.length; s++)
      if (!Object.prototype.hasOwnProperty.call(t, c[s]))
        return !1;
    for (s = 0; s < c.length; s++)
      if (!d0(t[c[s]], e[c[s]]))
        return !1;
    return !0;
  } else if (e && t && typeof e == "function" && typeof t == "function")
    return e.toString() === t.toString();
  return !1;
}
class zZe {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(e) {
    for (Object.assign(this, e); this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos); )
      --this.oldSelection.start;
  }
  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /** Removed symbols count */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /** Remove direction */
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? Ze.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? Ze.RIGHT : Ze.LEFT;
  }
}
function ct(t, e) {
  return new ct.InputMask(t, e);
}
function Dj(t) {
  if (t == null)
    throw new Error("mask property should be defined");
  return t instanceof RegExp ? ct.MaskedRegExp : Sl(t) ? ct.MaskedPattern : t === Date ? ct.MaskedDate : t === Number ? ct.MaskedNumber : Array.isArray(t) || t === Array ? ct.MaskedDynamic : ct.Masked && t.prototype instanceof ct.Masked ? t : ct.Masked && t instanceof ct.Masked ? t.constructor : t instanceof Function ? ct.MaskedFunction : (console.warn("Mask not found for mask", t), ct.Masked);
}
function h0(t) {
  if (!t)
    throw new Error("Options in not defined");
  if (ct.Masked) {
    if (t.prototype instanceof ct.Masked)
      return {
        mask: t
      };
    const {
      mask: e = void 0,
      ...r
    } = t instanceof ct.Masked ? {
      mask: t
    } : DB(t) && t.mask instanceof ct.Masked ? t : {};
    if (e) {
      const n = e.mask;
      return {
        ...kj(e, (s, a) => !a.startsWith("_")),
        mask: e.constructor,
        _mask: n,
        ...r
      };
    }
  }
  return DB(t) ? {
    ...t
  } : {
    mask: t
  };
}
function Ju(t) {
  if (ct.Masked && t instanceof ct.Masked)
    return t;
  const e = h0(t), r = Dj(e.mask);
  if (!r)
    throw new Error("Masked class is not found for provided mask, appropriate module needs to be imported manually before creating mask.");
  return e.mask === r && delete e.mask, e._mask && (e.mask = e._mask, delete e._mask), new r(e);
}
ct.createMask = Ju;
class NA {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let e;
    try {
      e = this._unsafeSelectionStart;
    } catch {
    }
    return e ?? this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let e;
    try {
      e = this._unsafeSelectionEnd;
    } catch {
    }
    return e ?? this.value.length;
  }
  /** Safely sets element selection */
  select(e, r) {
    if (!(e == null || r == null || e === this.selectionStart && r === this.selectionEnd))
      try {
        this._unsafeSelect(e, r);
      } catch {
      }
  }
  /** */
  get isActive() {
    return !1;
  }
  /** */
  /** */
  /** */
}
ct.MaskElement = NA;
class bc extends NA {
  /** HTMLElement to use mask on */
  constructor(e) {
    super(), this.input = e, this._handlers = {};
  }
  get rootElement() {
    var e, r, n;
    return (e = (r = (n = this.input).getRootNode) == null ? void 0 : r.call(n)) != null ? e : document;
  }
  /**
    Is element in focus
  */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /**
    Binds HTMLElement events to mask internal events
  */
  bindEvents(e) {
    Object.keys(e).forEach((r) => this._toggleEventHandler(bc.EVENTS_MAP[r], e[r]));
  }
  /**
    Unbinds HTMLElement events to mask internal events
  */
  unbindEvents() {
    Object.keys(this._handlers).forEach((e) => this._toggleEventHandler(e));
  }
  _toggleEventHandler(e, r) {
    this._handlers[e] && (this.input.removeEventListener(e, this._handlers[e]), delete this._handlers[e]), r && (this.input.addEventListener(e, r), this._handlers[e] = r);
  }
}
bc.EVENTS_MAP = {
  selectionChange: "keydown",
  input: "input",
  drop: "drop",
  click: "click",
  focus: "focus",
  commit: "blur"
};
ct.HTMLMaskElement = bc;
class qZe extends bc {
  /** InputElement to use mask on */
  constructor(e) {
    super(e), this.input = e, this._handlers = {};
  }
  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }
  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /** Sets InputElement selection */
  _unsafeSelect(e, r) {
    this.input.setSelectionRange(e, r);
  }
  get value() {
    return this.input.value;
  }
  set value(e) {
    this.input.value = e;
  }
}
ct.HTMLMaskElement = bc;
class Oj extends bc {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const e = this.rootElement, r = e.getSelection && e.getSelection(), n = r && r.anchorOffset, s = r && r.focusOffset;
    return s == null || n == null || n < s ? n : s;
  }
  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const e = this.rootElement, r = e.getSelection && e.getSelection(), n = r && r.anchorOffset, s = r && r.focusOffset;
    return s == null || n == null || n > s ? n : s;
  }
  /** Sets HTMLElement selection */
  _unsafeSelect(e, r) {
    if (!this.rootElement.createRange)
      return;
    const n = this.rootElement.createRange();
    n.setStart(this.input.firstChild || this.input, e), n.setEnd(this.input.lastChild || this.input, r);
    const s = this.rootElement, a = s.getSelection && s.getSelection();
    a && (a.removeAllRanges(), a.addRange(n));
  }
  /** HTMLElement value */
  get value() {
    return this.input.textContent || "";
  }
  set value(e) {
    this.input.textContent = e;
  }
}
ct.HTMLContenteditableMaskElement = Oj;
class XZe {
  /**
    View element
  */
  /** Internal {@link Masked} model */
  constructor(e, r) {
    this.el = e instanceof NA ? e : e.isContentEditable && e.tagName !== "INPUT" && e.tagName !== "TEXTAREA" ? new Oj(e) : new qZe(e), this.masked = Ju(r), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  maskEquals(e) {
    var r;
    return e == null || ((r = this.masked) == null ? void 0 : r.maskEquals(e));
  }
  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(e) {
    if (this.maskEquals(e))
      return;
    if (!(e instanceof ct.Masked) && this.masked.constructor === Dj(e)) {
      this.masked.updateOptions({
        mask: e
      });
      return;
    }
    const r = e instanceof ct.Masked ? e : Ju({
      mask: e
    });
    r.unmaskedValue = this.masked.unmaskedValue, this.masked = r;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(e) {
    this.value !== e && (this.masked.value = e, this.updateControl(), this.alignCursor());
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(e) {
    this.unmaskedValue !== e && (this.masked.unmaskedValue = e, this.updateControl(), this.alignCursor());
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(e) {
    this.masked.typedValueEquals(e) || (this.masked.typedValue = e, this.updateControl(), this.alignCursor());
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange
    });
  }
  /** Stops listening to element events */
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  /** Fires custom event */
  _fireEvent(e, r) {
    const n = this._listeners[e];
    n && n.forEach((s) => s(r));
  }
  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(e) {
    !this.el || !this.el.isActive || (this.el.select(e, e), this._saveSelection());
  }
  /** Stores current selection */
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl() {
    const e = this.masked.unmaskedValue, r = this.masked.value, n = this.displayValue, s = this.unmaskedValue !== e || this.value !== r;
    this._unmaskedValue = e, this._value = r, this.el.value !== n && (this.el.value = n), s && this._fireChangeEvents();
  }
  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(e) {
    const {
      mask: r,
      ...n
    } = e, s = !this.maskEquals(r), a = !d0(this.masked, n);
    s && (this.mask = r), a && this.masked.updateOptions(n), (s || a) && this.updateControl();
  }
  /** Updates cursor */
  updateCursor(e) {
    e != null && (this.cursorPos = e, this._delayUpdateCursor(e));
  }
  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(e) {
    this._abortUpdateCursor(), this._changingCursorPos = e, this._cursorChanging = setTimeout(() => {
      this.el && (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, Ze.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  /** Adds listener on custom event */
  on(e, r) {
    return this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(r), this;
  }
  /** Removes custom event listener */
  off(e, r) {
    if (!this._listeners[e])
      return this;
    if (!r)
      return delete this._listeners[e], this;
    const n = this._listeners[e].indexOf(r);
    return n >= 0 && this._listeners[e].splice(n, 1), this;
  }
  /** Handles view input event */
  _onInput(e) {
    if (this._inputEvent = e, this._abortUpdateCursor(), !this._selection)
      return this.updateValue();
    const r = new zZe({
      // new state
      value: this.el.value,
      cursorPos: this.cursorPos,
      // old state
      oldValue: this.displayValue,
      oldSelection: this._selection
    }), n = this.masked.rawInputValue, s = this.masked.splice(r.startChangePos, r.removed.length, r.inserted, r.removeDirection, {
      input: !0,
      raw: !0
    }).offset, a = n === this.masked.rawInputValue ? r.removeDirection : Ze.NONE;
    let o = this.masked.nearestInputPos(r.startChangePos + s, a);
    a !== Ze.NONE && (o = this.masked.nearestInputPos(o, Ze.NONE)), this.updateControl(), this.updateCursor(o), delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(e) {
    e.preventDefault(), e.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(e) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(e) {
    this.alignCursorFriendly();
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
ct.InputMask = XZe;
class sr {
  /** Inserted symbols */
  /** Can skip chars */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  static normalize(e) {
    return Array.isArray(e) ? e : [e, new sr()];
  }
  constructor(e) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      skip: !1,
      tailShift: 0
    }, e);
  }
  /** Aggregate changes */
  aggregate(e) {
    return this.rawInserted += e.rawInserted, this.skip = this.skip || e.skip, this.inserted += e.inserted, this.tailShift += e.tailShift, this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
}
ct.ChangeDetails = sr;
class uo {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor(e, r, n) {
    e === void 0 && (e = ""), r === void 0 && (r = 0), this.value = e, this.from = r, this.stop = n;
  }
  toString() {
    return this.value;
  }
  extend(e) {
    this.value += String(e);
  }
  appendTo(e) {
    return e.append(this.toString(), {
      tail: !0
    }).aggregate(e._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  unshift(e) {
    if (!this.value.length || e != null && this.from >= e)
      return "";
    const r = this.value[0];
    return this.value = this.value.slice(1), r;
  }
  shift() {
    if (!this.value.length)
      return "";
    const e = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), e;
  }
}
class Wi {
  /** */
  /** */
  /** Transforms value before mask processing */
  /** Transforms each char before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing at the end of editing */
  /** Format typed value to string */
  /** Parse string to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(e) {
    this._value = "", this._update({
      ...Wi.DEFAULTS,
      ...e
    }), this._initialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(e) {
    Object.keys(e).length && this.withValueRefresh(this._update.bind(this, e));
  }
  /** Sets new options */
  _update(e) {
    Object.assign(this, e);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.resolve(e, {
      input: !0
    });
  }
  /** Resolve new value */
  resolve(e, r) {
    r === void 0 && (r = {
      input: !0
    }), this.reset(), this.append(e, r, ""), this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(e) {
    this.resolve(e, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(e) {
    this.format ? this.value = this.format(e, this) : this.unmaskedValue = String(e);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: !0
    });
  }
  set rawInputValue(e) {
    this.resolve(e, {
      raw: !0
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(e, r) {
    return e;
  }
  totalInputPositions(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), Math.min(this.displayValue.length, r - e);
  }
  /** Extracts value in range considering flags */
  extractInput(e, r, n) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), this.displayValue.slice(e, r);
  }
  /** Extracts tail in range */
  extractTail(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), new uo(this.extractInput(e, r), e);
  }
  /** Appends tail */
  appendTail(e) {
    return Sl(e) && (e = new uo(String(e))), e.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(e, r) {
    return e ? (this._value += e, new sr({
      inserted: e,
      rawInserted: e
    })) : new sr();
  }
  /** Appends char */
  _appendChar(e, r, n) {
    r === void 0 && (r = {});
    const s = this.state;
    let a;
    if ([e, a] = this.doPrepareChar(e, r), a = a.aggregate(this._appendCharRaw(e, r)), a.inserted) {
      let o, l = this.doValidate(r) !== !1;
      if (l && n != null) {
        const u = this.state;
        this.overwrite === !0 && (o = n.state, n.unshift(this.displayValue.length - a.tailShift));
        let c = this.appendTail(n);
        l = c.rawInserted === n.toString(), !(l && c.inserted) && this.overwrite === "shift" && (this.state = u, o = n.state, n.shift(), c = this.appendTail(n), l = c.rawInserted === n.toString()), l && c.inserted && (this.state = u);
      }
      l || (a = new sr(), this.state = s, n && o && (n.state = o));
    }
    return a;
  }
  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new sr();
  }
  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new sr();
  }
  /** Appends symbols considering flags */
  append(e, r, n) {
    if (!Sl(e))
      throw new Error("value should be string");
    const s = Sl(n) ? new uo(String(n)) : n;
    r != null && r.tail && (r._beforeTailState = this.state);
    let a;
    [e, a] = this.doPrepare(e, r);
    for (let o = 0; o < e.length; ++o) {
      const l = this._appendChar(e[o], r, s);
      if (!l.rawInserted && !this.doSkipInvalid(e[o], r, s))
        break;
      a.aggregate(l);
    }
    return (this.eager === !0 || this.eager === "append") && r != null && r.input && e && a.aggregate(this._appendEager()), s != null && (a.tailShift += this.appendTail(s).tailShift), a;
  }
  remove(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), this._value = this.displayValue.slice(0, e) + this.displayValue.slice(r), new sr();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(e) {
    if (this._refreshing || !this._initialized)
      return e();
    this._refreshing = !0;
    const r = this.rawInputValue, n = this.value, s = e();
    return this.rawInputValue = r, this.value && this.value !== n && n.indexOf(this.value) === 0 && this.append(n.slice(this.displayValue.length), {}, ""), delete this._refreshing, s;
  }
  runIsolated(e) {
    if (this._isolated || !this._initialized)
      return e(this);
    this._isolated = !0;
    const r = this.state, n = e(this);
    return this.state = r, delete this._isolated, n;
  }
  doSkipInvalid(e, r, n) {
    return !!this.skipInvalid;
  }
  /** Prepares string before mask processing */
  doPrepare(e, r) {
    return r === void 0 && (r = {}), sr.normalize(this.prepare ? this.prepare(e, this, r) : e);
  }
  /** Prepares each char before mask processing */
  doPrepareChar(e, r) {
    return r === void 0 && (r = {}), sr.normalize(this.prepareChar ? this.prepareChar(e, this, r) : e);
  }
  /** Validates if value is acceptable */
  doValidate(e) {
    return (!this.validate || this.validate(this.value, this, e)) && (!this.parent || this.parent.doValidate(e));
  }
  /** Does additional processing at the end of editing */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  splice(e, r, n, s, a) {
    s === void 0 && (s = Ze.NONE), a === void 0 && (a = {
      input: !0
    });
    const o = e + r, l = this.extractTail(o), u = this.eager === !0 || this.eager === "remove";
    let c;
    u && (s = KZe(s), c = this.extractInput(0, o, {
      raw: !0
    }));
    let d = e;
    const h = new sr();
    if (s !== Ze.NONE && (d = this.nearestInputPos(e, r > 1 && e !== 0 && !u ? Ze.NONE : s), h.tailShift = d - e), h.aggregate(this.remove(d)), u && s !== Ze.NONE && c === this.rawInputValue)
      if (s === Ze.FORCE_LEFT) {
        let f;
        for (; c === this.rawInputValue && (f = this.displayValue.length); )
          h.aggregate(new sr({
            tailShift: -1
          })).aggregate(this.remove(f - 1));
      } else
        s === Ze.FORCE_RIGHT && l.unshift();
    return h.aggregate(this.append(n, a, l));
  }
  maskEquals(e) {
    return this.mask === e;
  }
  typedValueEquals(e) {
    const r = this.typedValue;
    return e === r || Wi.EMPTY_VALUES.includes(e) && Wi.EMPTY_VALUES.includes(r) || (this.format ? this.format(e, this) === this.format(this.typedValue, this) : !1);
  }
}
Wi.DEFAULTS = {
  skipInvalid: !0
};
Wi.EMPTY_VALUES = [void 0, null, ""];
ct.Masked = Wi;
class fu {
  /** */
  constructor(e, r) {
    e === void 0 && (e = []), r === void 0 && (r = 0), this.chunks = e, this.from = r;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(e) {
    if (!String(e))
      return;
    e = Sl(e) ? new uo(String(e)) : e;
    const r = this.chunks[this.chunks.length - 1], n = r && // if stops are same or tail has no stop
    (r.stop === e.stop || e.stop == null) && // if tail chunk goes just after last chunk
    e.from === r.from + r.toString().length;
    if (e instanceof uo)
      n ? r.extend(e.toString()) : this.chunks.push(e);
    else if (e instanceof fu) {
      if (e.stop == null) {
        let s;
        for (; e.chunks.length && e.chunks[0].stop == null; )
          s = e.chunks.shift(), s.from += e.from, this.extend(s);
      }
      e.toString() && (e.stop = e.blockIndex, this.chunks.push(e));
    }
  }
  appendTo(e) {
    if (!(e instanceof ct.MaskedPattern))
      return new uo(this.toString()).appendTo(e);
    const r = new sr();
    for (let n = 0; n < this.chunks.length && !r.skip; ++n) {
      const s = this.chunks[n], a = e._mapPosToBlock(e.displayValue.length), o = s.stop;
      let l;
      if (o != null && // if block not found or stop is behind lastBlock
      (!a || a.index <= o)) {
        if (s instanceof fu || // for continuous block also check if stop is exist
        e._stops.indexOf(o) >= 0) {
          const u = e._appendPlaceholder(o);
          r.aggregate(u);
        }
        l = s instanceof fu && e._blocks[o];
      }
      if (l) {
        const u = l.appendTail(s);
        u.skip = !1, r.aggregate(u), e._value += u.inserted;
        const c = s.toString().slice(u.rawInserted.length);
        c && r.aggregate(e.append(c, {
          tail: !0
        }));
      } else
        r.aggregate(e.append(s.toString(), {
          tail: !0
        }));
    }
    return r;
  }
  get state() {
    return {
      chunks: this.chunks.map((e) => e.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(e) {
    const {
      chunks: r,
      ...n
    } = e;
    Object.assign(this, n), this.chunks = r.map((s) => {
      const a = "chunks" in s ? new fu() : new uo();
      return a.state = s, a;
    });
  }
  unshift(e) {
    if (!this.chunks.length || e != null && this.from >= e)
      return "";
    const r = e != null ? e - this.from : e;
    let n = 0;
    for (; n < this.chunks.length; ) {
      const s = this.chunks[n], a = s.unshift(r);
      if (s.toString()) {
        if (!a)
          break;
        ++n;
      } else
        this.chunks.splice(n, 1);
      if (a)
        return a;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length)
      return "";
    let e = this.chunks.length - 1;
    for (; 0 <= e; ) {
      const r = this.chunks[e], n = r.shift();
      if (r.toString()) {
        if (!n)
          break;
        --e;
      } else
        this.chunks.splice(e, 1);
      if (n)
        return n;
    }
    return "";
  }
}
class QZe {
  constructor(e, r) {
    this.masked = e, this._log = [];
    const {
      offset: n,
      index: s
    } = e._mapPosToBlock(r) || (r < 0 ? (
      // first
      {
        index: 0,
        offset: 0
      }
    ) : (
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      }
    ));
    this.offset = n, this.index = s, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const e = this._log.pop();
    return e && (this.state = e), e;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.displayValue.length));
  }
  _pushLeft(e) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((r = this.block) == null ? void 0 : r.displayValue.length) || 0) {
      var r;
      if (e())
        return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(e) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0)
      if (e())
        return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, Ze.FORCE_LEFT), this.offset !== 0))
        return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, Ze.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, Ze.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, Ze.FORCE_RIGHT), this.offset !== this.block.value.length))
        return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, Ze.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, Ze.NONE), !0;
    });
  }
}
class Aj {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    Object.assign(this, e), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this._value.length), this._value = this._value.slice(0, e) + this._value.slice(r), this._value || (this._isRawInput = !1), new sr();
  }
  nearestInputPos(e, r) {
    r === void 0 && (r = Ze.NONE);
    const n = 0, s = this._value.length;
    switch (r) {
      case Ze.LEFT:
      case Ze.FORCE_LEFT:
        return n;
      case Ze.NONE:
      case Ze.RIGHT:
      case Ze.FORCE_RIGHT:
      default:
        return s;
    }
  }
  totalInputPositions(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this._value.length), this._isRawInput ? r - e : 0;
  }
  extractInput(e, r, n) {
    return e === void 0 && (e = 0), r === void 0 && (r = this._value.length), n === void 0 && (n = {}), n.raw && this._isRawInput && this._value.slice(e, r) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(e, r) {
    r === void 0 && (r = {});
    const n = new sr();
    if (this.isFilled)
      return n;
    const s = this.eager === !0 || this.eager === "append", o = this.char === e && (this.isUnmasking || r.input || r.raw) && (!r.raw || !s) && !r.tail;
    return o && (n.rawInserted = this.char), this._value = n.inserted = this.char, this._isRawInput = o && (r.raw || r.input), n;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const e = new sr();
    return this.isFilled || (this._value = e.inserted = this.char), e;
  }
  extractTail() {
    return new uo("");
  }
  appendTail(e) {
    return Sl(e) && (e = new uo(String(e))), e.appendTo(this);
  }
  append(e, r, n) {
    const s = this._appendChar(e[0], r);
    return n != null && (s.tailShift += this.appendTail(n).tailShift), s;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value, this._isRawInput = !!e._rawInputValue;
  }
}
class f0 {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    const {
      parent: r,
      isOptional: n,
      placeholderChar: s,
      displayChar: a,
      lazy: o,
      eager: l,
      ...u
    } = e;
    this.masked = Ju(u), Object.assign(this, {
      parent: r,
      isOptional: n,
      placeholderChar: s,
      displayChar: a,
      lazy: o,
      eager: l
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.value.length), e === 0 && r >= 1 ? (this.isFilled = !1, this.masked.remove(e, r)) : new sr();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return !!this.masked.value || this.isOptional;
  }
  _appendChar(e, r) {
    if (r === void 0 && (r = {}), this.isFilled)
      return new sr();
    const n = this.masked.state, s = this.masked._appendChar(e, this.currentMaskFlags(r));
    return s.inserted && this.doValidate(r) === !1 && (s.inserted = s.rawInserted = "", this.masked.state = n), !s.inserted && !this.isOptional && !this.lazy && !r.input && (s.inserted = this.placeholderChar), s.skip = !s.inserted && !this.isOptional, this.isFilled = !!s.inserted, s;
  }
  append(e, r, n) {
    return this.masked.append(e, this.currentMaskFlags(r), n);
  }
  _appendPlaceholder() {
    const e = new sr();
    return this.isFilled || this.isOptional || (this.isFilled = !0, e.inserted = this.placeholderChar), e;
  }
  _appendEager() {
    return new sr();
  }
  extractTail(e, r) {
    return this.masked.extractTail(e, r);
  }
  appendTail(e) {
    return this.masked.appendTail(e);
  }
  extractInput(e, r, n) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.value.length), this.masked.extractInput(e, r, n);
  }
  nearestInputPos(e, r) {
    r === void 0 && (r = Ze.NONE);
    const n = 0, s = this.value.length, a = Math.min(Math.max(e, n), s);
    switch (r) {
      case Ze.LEFT:
      case Ze.FORCE_LEFT:
        return this.isComplete ? a : n;
      case Ze.RIGHT:
      case Ze.FORCE_RIGHT:
        return this.isComplete ? a : s;
      case Ze.NONE:
      default:
        return a;
    }
  }
  totalInputPositions(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.value.length), this.value.slice(e, r).length;
  }
  doValidate(e) {
    return this.masked.doValidate(this.currentMaskFlags(e)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(e)));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(e) {
    this.masked.state = e.masked, this.isFilled = e.isFilled;
  }
  currentMaskFlags(e) {
    var r;
    return {
      ...e,
      _beforeTailState: (e == null || (r = e._beforeTailState) == null ? void 0 : r.masked) || (e == null ? void 0 : e._beforeTailState)
    };
  }
}
f0.DEFAULT_DEFINITIONS = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class ZZe extends Wi {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const r = e.mask;
    r && (e.validate = (n) => n.search(r) >= 0), super._update(e);
  }
}
ct.MaskedRegExp = ZZe;
class ji extends Wi {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  /** Enable characters overwriting */
  /** */
  /** */
  constructor(e) {
    super({
      ...ji.DEFAULTS,
      ...e,
      definitions: Object.assign({}, f0.DEFAULT_DEFINITIONS, e == null ? void 0 : e.definitions)
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    e.definitions = Object.assign({}, this.definitions, e.definitions), super._update(e), this._rebuildMask();
  }
  _rebuildMask() {
    const e = this.definitions;
    this._blocks = [], this.exposeBlock = void 0, this._stops = [], this._maskedBlocks = {};
    const r = this.mask;
    if (!r || !e)
      return;
    let n = !1, s = !1;
    for (let a = 0; a < r.length; ++a) {
      if (this.blocks) {
        const c = r.slice(a), d = Object.keys(this.blocks).filter((f) => c.indexOf(f) === 0);
        d.sort((f, p) => p.length - f.length);
        const h = d[0];
        if (h) {
          const {
            expose: f,
            ...p
          } = h0(this.blocks[h]), m = Ju({
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite,
            ...p,
            parent: this
          });
          m && (this._blocks.push(m), f && (this.exposeBlock = m), this._maskedBlocks[h] || (this._maskedBlocks[h] = []), this._maskedBlocks[h].push(this._blocks.length - 1)), a += h.length - 1;
          continue;
        }
      }
      let o = r[a], l = o in e;
      if (o === ji.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (o === "{" || o === "}") {
        n = !n;
        continue;
      }
      if (o === "[" || o === "]") {
        s = !s;
        continue;
      }
      if (o === ji.ESCAPE_CHAR) {
        if (++a, o = r[a], !o)
          break;
        l = !1;
      }
      const u = l ? new f0({
        isOptional: s,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ...h0(e[o]),
        parent: this
      }) : new Aj({
        char: o,
        eager: this.eager,
        isUnmasking: n
      });
      this._blocks.push(u);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map((e) => e.state)
    };
  }
  set state(e) {
    const {
      _blocks: r,
      ...n
    } = e;
    this._blocks.forEach((s, a) => s.state = r[a]), super.state = n;
  }
  reset() {
    super.reset(), this._blocks.forEach((e) => e.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((e) => e.isComplete);
  }
  get isFilled() {
    return this._blocks.every((e) => e.isFilled);
  }
  get isFixed() {
    return this._blocks.every((e) => e.isFixed);
  }
  get isOptional() {
    return this._blocks.every((e) => e.isOptional);
  }
  doCommit() {
    this._blocks.forEach((e) => e.doCommit()), super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((e, r) => e += r.unmaskedValue, "");
  }
  set unmaskedValue(e) {
    if (this.exposeBlock) {
      const r = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = e, this.appendTail(r), this.doCommit();
    } else
      super.unmaskedValue = e;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value : (
      // TODO return _value when not in change?
      this._blocks.reduce((e, r) => e += r.value, "")
    );
  }
  set value(e) {
    if (this.exposeBlock) {
      const r = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = e, this.appendTail(r), this.doCommit();
    } else
      super.value = e;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(e) {
    if (this.exposeBlock) {
      const r = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = e, this.appendTail(r), this.doCommit();
    } else
      super.typedValue = e;
  }
  get displayValue() {
    return this._blocks.reduce((e, r) => e += r.displayValue, "");
  }
  appendTail(e) {
    return super.appendTail(e).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var e;
    const r = new sr();
    let n = (e = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : e.index;
    if (n == null)
      return r;
    this._blocks[n].isFilled && ++n;
    for (let s = n; s < this._blocks.length; ++s) {
      const a = this._blocks[s]._appendEager();
      if (!a.inserted)
        break;
      r.aggregate(a);
    }
    return r;
  }
  _appendCharRaw(e, r) {
    r === void 0 && (r = {});
    const n = this._mapPosToBlock(this.displayValue.length), s = new sr();
    if (!n)
      return s;
    for (let o = n.index; ; ++o) {
      var a;
      const l = this._blocks[o];
      if (!l)
        break;
      const u = l._appendChar(e, {
        ...r,
        _beforeTailState: (a = r._beforeTailState) == null || (a = a._blocks) == null ? void 0 : a[o]
      }), c = u.skip;
      if (s.aggregate(u), c || u.rawInserted)
        break;
    }
    return s;
  }
  extractTail(e, r) {
    e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length);
    const n = new fu();
    return e === r || this._forEachBlocksInRange(e, r, (s, a, o, l) => {
      const u = s.extractTail(o, l);
      u.stop = this._findStopBefore(a), u.from = this._blockStartPos(a), u instanceof fu && (u.blockIndex = a), n.extend(u);
    }), n;
  }
  extractInput(e, r, n) {
    if (e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), n === void 0 && (n = {}), e === r)
      return "";
    let s = "";
    return this._forEachBlocksInRange(e, r, (a, o, l, u) => {
      s += a.extractInput(l, u, n);
    }), s;
  }
  _findStopBefore(e) {
    let r;
    for (let n = 0; n < this._stops.length; ++n) {
      const s = this._stops[n];
      if (s <= e)
        r = s;
      else
        break;
    }
    return r;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(e) {
    const r = new sr();
    if (this.lazy && e == null)
      return r;
    const n = this._mapPosToBlock(this.displayValue.length);
    if (!n)
      return r;
    const s = n.index, a = e ?? this._blocks.length;
    return this._blocks.slice(s, a).forEach((o) => {
      if (!o.lazy || e != null) {
        var l;
        const u = o._appendPlaceholder((l = o._blocks) == null ? void 0 : l.length);
        this._value += u.inserted, r.aggregate(u);
      }
    }), r;
  }
  /** Finds block in pos */
  _mapPosToBlock(e) {
    let r = "";
    for (let n = 0; n < this._blocks.length; ++n) {
      const s = this._blocks[n], a = r.length;
      if (r += s.displayValue, e <= r.length)
        return {
          index: n,
          offset: e - a
        };
    }
  }
  _blockStartPos(e) {
    return this._blocks.slice(0, e).reduce((r, n) => r += n.displayValue.length, 0);
  }
  _forEachBlocksInRange(e, r, n) {
    r === void 0 && (r = this.displayValue.length);
    const s = this._mapPosToBlock(e);
    if (s) {
      const a = this._mapPosToBlock(r), o = a && s.index === a.index, l = s.offset, u = a && o ? a.offset : this._blocks[s.index].displayValue.length;
      if (n(this._blocks[s.index], s.index, l, u), a && !o) {
        for (let c = s.index + 1; c < a.index; ++c)
          n(this._blocks[c], c, 0, this._blocks[c].displayValue.length);
        n(this._blocks[a.index], a.index, 0, a.offset);
      }
    }
  }
  remove(e, r) {
    e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length);
    const n = super.remove(e, r);
    return this._forEachBlocksInRange(e, r, (s, a, o, l) => {
      n.aggregate(s.remove(o, l));
    }), n;
  }
  nearestInputPos(e, r) {
    if (r === void 0 && (r = Ze.NONE), !this._blocks.length)
      return 0;
    const n = new QZe(this, e);
    if (r === Ze.NONE)
      return n.pushRightBeforeInput() || (n.popState(), n.pushLeftBeforeInput()) ? n.pos : this.displayValue.length;
    if (r === Ze.LEFT || r === Ze.FORCE_LEFT) {
      if (r === Ze.LEFT) {
        if (n.pushRightBeforeFilled(), n.ok && n.pos === e)
          return e;
        n.popState();
      }
      if (n.pushLeftBeforeInput(), n.pushLeftBeforeRequired(), n.pushLeftBeforeFilled(), r === Ze.LEFT) {
        if (n.pushRightBeforeInput(), n.pushRightBeforeRequired(), n.ok && n.pos <= e || (n.popState(), n.ok && n.pos <= e))
          return n.pos;
        n.popState();
      }
      return n.ok ? n.pos : r === Ze.FORCE_LEFT ? 0 : (n.popState(), n.ok || (n.popState(), n.ok) ? n.pos : 0);
    }
    return r === Ze.RIGHT || r === Ze.FORCE_RIGHT ? (n.pushRightBeforeInput(), n.pushRightBeforeRequired(), n.pushRightBeforeFilled() ? n.pos : r === Ze.FORCE_RIGHT ? this.displayValue.length : (n.popState(), n.ok || (n.popState(), n.ok) ? n.pos : this.nearestInputPos(e, Ze.LEFT))) : e;
  }
  totalInputPositions(e, r) {
    e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length);
    let n = 0;
    return this._forEachBlocksInRange(e, r, (s, a, o, l) => {
      n += s.totalInputPositions(o, l);
    }), n;
  }
  /** Get block by name */
  maskedBlock(e) {
    return this.maskedBlocks(e)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(e) {
    const r = this._maskedBlocks[e];
    return r ? r.map((n) => this._blocks[n]) : [];
  }
}
ji.DEFAULTS = {
  lazy: !0,
  placeholderChar: "_"
};
ji.STOP_CHAR = "`";
ji.ESCAPE_CHAR = "\\";
ji.InputDefinition = f0;
ji.FixedDefinition = Aj;
ct.MaskedPattern = ji;
class Hg extends ji {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  /** */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      to: r = this.to || 0,
      from: n = this.from || 0,
      maxLength: s = this.maxLength || 0,
      autofix: a = this.autofix,
      ...o
    } = e;
    this.to = r, this.from = n, this.maxLength = Math.max(String(r).length, s), this.autofix = a;
    const l = String(this.from).padStart(this.maxLength, "0"), u = String(this.to).padStart(this.maxLength, "0");
    let c = 0;
    for (; c < u.length && u[c] === l[c]; )
      ++c;
    o.mask = u.slice(0, c).replace(/0/g, "\\0") + "0".repeat(this.maxLength - c), super._update(o);
  }
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(e) {
    let r = "", n = "";
    const [, s, a] = e.match(/^(\D*)(\d*)(\D*)/) || [];
    return a && (r = "0".repeat(s.length) + a, n = "9".repeat(s.length) + a), r = r.padEnd(this.maxLength, "0"), n = n.padEnd(this.maxLength, "9"), [r, n];
  }
  doPrepareChar(e, r) {
    r === void 0 && (r = {});
    let n;
    if ([e, n] = super.doPrepareChar(e.replace(/\D/g, ""), r), !this.autofix || !e)
      return [e, n];
    const s = String(this.from).padStart(this.maxLength, "0"), a = String(this.to).padStart(this.maxLength, "0"), o = this.value + e;
    if (o.length > this.maxLength)
      return ["", n];
    const [l, u] = this.boundaries(o);
    return Number(u) < this.from ? [s[o.length - 1], n] : Number(l) > this.to ? this.autofix === "pad" && o.length < this.maxLength ? ["", n.aggregate(this.append(s[o.length - 1] + e, r))] : [a[o.length - 1], n] : [e, n];
  }
  doValidate(e) {
    const r = this.value;
    if (r.search(/[^0]/) === -1 && r.length <= this._matchFrom)
      return !0;
    const [s, a] = this.boundaries(r);
    return this.from <= Number(a) && Number(s) <= this.to && super.doValidate(e);
  }
}
ct.MaskedRange = Hg;
class Ru extends ji {
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    const {
      mask: r,
      pattern: n,
      ...s
    } = {
      ...Ru.DEFAULTS,
      ...e
    };
    super({
      ...s,
      mask: Sl(r) ? r : n
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      mask: r,
      pattern: n,
      blocks: s,
      ...a
    } = {
      ...Ru.DEFAULTS,
      ...e
    }, o = Object.assign({}, Ru.GET_DEFAULT_BLOCKS());
    e.min && (o.Y.from = e.min.getFullYear()), e.max && (o.Y.to = e.max.getFullYear()), e.min && e.max && o.Y.from === o.Y.to && (o.m.from = e.min.getMonth() + 1, o.m.to = e.max.getMonth() + 1, o.m.from === o.m.to && (o.d.from = e.min.getDate(), o.d.to = e.max.getDate())), Object.assign(o, this.blocks, s), Object.keys(o).forEach((l) => {
      const u = o[l];
      !("autofix" in u) && "autofix" in e && (u.autofix = e.autofix);
    }), super._update({
      ...a,
      mask: Sl(r) ? r : n,
      blocks: o
    });
  }
  doValidate(e) {
    const r = this.date;
    return super.doValidate(e) && (!this.isComplete || this.isDateExist(this.value) && r != null && (this.min == null || this.min <= r) && (this.max == null || r <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(e) {
    return this.format(this.parse(e, this), this).indexOf(e) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(e) {
    this.typedValue = e;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(e) {
    super.typedValue = e;
  }
  maskEquals(e) {
    return e === Date || super.maskEquals(e);
  }
}
Ru.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: Hg,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: Hg,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: Hg,
    from: 1900,
    to: 9999
  }
});
Ru.DEFAULTS = {
  mask: Date,
  pattern: "d{.}`m{.}`Y",
  format: (t, e) => {
    if (!t)
      return "";
    const r = String(t.getDate()).padStart(2, "0"), n = String(t.getMonth() + 1).padStart(2, "0"), s = t.getFullYear();
    return [r, n, s].join(".");
  },
  parse: (t, e) => {
    const [r, n, s] = t.split(".").map(Number);
    return new Date(s, n - 1, r);
  }
};
ct.MaskedDate = Ru;
class Wv extends Wi {
  /** Currently chosen mask */
  /** Currently chosen mask */
  /** Compliled {@link Masked} options */
  /** Chooses {@link Masked} depending on input value */
  constructor(e) {
    super({
      ...Wv.DEFAULTS,
      ...e
    }), this.currentMask = void 0;
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), "mask" in e && (this.exposeMask = void 0, this.compiledMasks = Array.isArray(e.mask) ? e.mask.map((r) => {
      const {
        expose: n,
        ...s
      } = h0(r), a = Ju({
        overwrite: this._overwrite,
        eager: this._eager,
        skipInvalid: this._skipInvalid,
        ...s
      });
      return n && (this.exposeMask = a), a;
    }) : []);
  }
  _appendCharRaw(e, r) {
    r === void 0 && (r = {});
    const n = this._applyDispatch(e, r);
    return this.currentMask && n.aggregate(this.currentMask._appendChar(e, this.currentMaskFlags(r))), n;
  }
  _applyDispatch(e, r, n) {
    e === void 0 && (e = ""), r === void 0 && (r = {}), n === void 0 && (n = "");
    const s = r.tail && r._beforeTailState != null ? r._beforeTailState._value : this.value, a = this.rawInputValue, o = r.tail && r._beforeTailState != null ? r._beforeTailState._rawInputValue : a, l = a.slice(o.length), u = this.currentMask, c = new sr(), d = u == null ? void 0 : u.state;
    if (this.currentMask = this.doDispatch(e, {
      ...r
    }, n), this.currentMask)
      if (this.currentMask !== u) {
        if (this.currentMask.reset(), o) {
          const h = this.currentMask.append(o, {
            raw: !0
          });
          c.tailShift = h.inserted.length - s.length;
        }
        l && (c.tailShift += this.currentMask.append(l, {
          raw: !0,
          tail: !0
        }).tailShift);
      } else
        d && (this.currentMask.state = d);
    return c;
  }
  _appendPlaceholder() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendPlaceholder()), e;
  }
  _appendEager() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendEager()), e;
  }
  appendTail(e) {
    const r = new sr();
    return e && r.aggregate(this._applyDispatch("", {}, e)), r.aggregate(this.currentMask ? this.currentMask.appendTail(e) : super.appendTail(e));
  }
  currentMaskFlags(e) {
    var r, n;
    return {
      ...e,
      _beforeTailState: ((r = e._beforeTailState) == null ? void 0 : r.currentMaskRef) === this.currentMask && ((n = e._beforeTailState) == null ? void 0 : n.currentMask) || e._beforeTailState
    };
  }
  doDispatch(e, r, n) {
    return r === void 0 && (r = {}), n === void 0 && (n = ""), this.dispatch(e, this, r, n);
  }
  doValidate(e) {
    return super.doValidate(e) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(e)));
  }
  doPrepare(e, r) {
    r === void 0 && (r = {});
    let [n, s] = super.doPrepare(e, r);
    if (this.currentMask) {
      let a;
      [n, a] = super.doPrepare(n, this.currentMaskFlags(r)), s = s.aggregate(a);
    }
    return [n, s];
  }
  doPrepareChar(e, r) {
    r === void 0 && (r = {});
    let [n, s] = super.doPrepareChar(e, r);
    if (this.currentMask) {
      let a;
      [n, a] = super.doPrepareChar(n, this.currentMaskFlags(r)), s = s.aggregate(a);
    }
    return [n, s];
  }
  reset() {
    var e;
    (e = this.currentMask) == null || e.reset(), this.compiledMasks.forEach((r) => r.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
  }
  set value(e) {
    this.exposeMask ? (this.exposeMask.value = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.value = e;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(e) {
    this.exposeMask ? (this.exposeMask.unmaskedValue = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.unmaskedValue = e;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(e) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = e, this.currentMask = this.exposeMask, this._applyDispatch();
      return;
    }
    let r = String(e);
    this.currentMask && (this.currentMask.typedValue = e, r = this.currentMask.unmaskedValue), this.unmaskedValue = r;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var e;
    return !!((e = this.currentMask) != null && e.isComplete);
  }
  get isFilled() {
    var e;
    return !!((e = this.currentMask) != null && e.isFilled);
  }
  remove(e, r) {
    const n = new sr();
    return this.currentMask && n.aggregate(this.currentMask.remove(e, r)).aggregate(this._applyDispatch()), n;
  }
  get state() {
    var e;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((r) => r.state),
      currentMaskRef: this.currentMask,
      currentMask: (e = this.currentMask) == null ? void 0 : e.state
    };
  }
  set state(e) {
    const {
      compiledMasks: r,
      currentMaskRef: n,
      currentMask: s,
      ...a
    } = e;
    r && this.compiledMasks.forEach((o, l) => o.state = r[l]), n != null && (this.currentMask = n, this.currentMask.state = s), super.state = a;
  }
  extractInput(e, r, n) {
    return this.currentMask ? this.currentMask.extractInput(e, r, n) : "";
  }
  extractTail(e, r) {
    return this.currentMask ? this.currentMask.extractTail(e, r) : super.extractTail(e, r);
  }
  doCommit() {
    this.currentMask && this.currentMask.doCommit(), super.doCommit();
  }
  nearestInputPos(e, r) {
    return this.currentMask ? this.currentMask.nearestInputPos(e, r) : super.nearestInputPos(e, r);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(e) {
    this._overwrite = e;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(e) {
    this._eager = e;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(e) {
    this._skipInvalid = e;
  }
  maskEquals(e) {
    return Array.isArray(e) ? this.compiledMasks.every((r, n) => {
      if (!e[n])
        return;
      const {
        mask: s,
        ...a
      } = e[n];
      return d0(r, a) && r.maskEquals(s);
    }) : super.maskEquals(e);
  }
  typedValueEquals(e) {
    var r;
    return !!((r = this.currentMask) != null && r.typedValueEquals(e));
  }
}
Wv.DEFAULTS = void 0;
Wv.DEFAULTS = {
  dispatch: (t, e, r, n) => {
    if (!e.compiledMasks.length)
      return;
    const s = e.rawInputValue, a = e.compiledMasks.map((o, l) => {
      const u = e.currentMask === o, c = u ? o.displayValue.length : o.nearestInputPos(o.displayValue.length, Ze.FORCE_LEFT);
      return o.rawInputValue !== s ? (o.reset(), o.append(s, {
        raw: !0
      })) : u || o.remove(c), o.append(t, e.currentMaskFlags(r)), o.appendTail(n), {
        index: l,
        weight: o.rawInputValue.length,
        totalInputPositions: o.totalInputPositions(0, Math.max(c, o.nearestInputPos(o.displayValue.length, Ze.FORCE_LEFT)))
      };
    });
    return a.sort((o, l) => l.weight - o.weight || l.totalInputPositions - o.totalInputPositions), e.compiledMasks[a[0].index];
  }
};
ct.MaskedDynamic = Wv;
class JZe extends ji {
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      enum: r,
      ...n
    } = e;
    if (r) {
      const s = r.map((l) => l.length), a = Math.min(...s), o = Math.max(...s) - a;
      n.mask = "*".repeat(a), o && (n.mask += "[" + "*".repeat(o) + "]"), this.enum = r;
    }
    super._update(n);
  }
  doValidate(e) {
    return this.enum.some((r) => r.indexOf(this.unmaskedValue) === 0) && super.doValidate(e);
  }
}
ct.MaskedEnum = JZe;
class eJe extends Wi {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update({
      ...e,
      validate: e.mask
    });
  }
}
ct.MaskedFunction = eJe;
class os extends Wi {
  /** Single char */
  /** Single char */
  /** Array of single chars */
  /** */
  /** */
  /** Digits after point */
  /** Flag to remove leading and trailing zeros in the end of editing */
  /** Flag to pad trailing zeros after point in the end of editing */
  /** Enable characters overwriting */
  /** */
  /** */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super({
      ...os.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), this._updateRegExps();
  }
  _updateRegExps() {
    const e = "^" + (this.allowNegative ? "[+|\\-]?" : ""), r = "\\d*", n = (this.scale ? "(" + DT(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
    this._numberRegExp = new RegExp(e + r + n), this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(DT).join("") + "]", "g"), this._thousandsSeparatorRegExp = new RegExp(DT(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(e) {
    return e.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(e) {
    const r = e.split(this.radix);
    return r[0] = r[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), r.join(this.radix);
  }
  doPrepareChar(e, r) {
    r === void 0 && (r = {});
    const [n, s] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
    (r.input && r.raw || !r.input && !r.raw) ? e.replace(this._mapToRadixRegExp, this.radix) : e), r);
    return e && !n && (s.skip = !0), n && !this.allowPositive && !this.value && n !== "-" && s.aggregate(this._appendChar("-")), [n, s];
  }
  _separatorsCount(e, r) {
    r === void 0 && (r = !1);
    let n = 0;
    for (let s = 0; s < e; ++s)
      this._value.indexOf(this.thousandsSeparator, s) === s && (++n, r && (e += this.thousandsSeparator.length));
    return n;
  }
  _separatorsCountFromSlice(e) {
    return e === void 0 && (e = this._value), this._separatorsCount(this._removeThousandsSeparators(e).length, !0);
  }
  extractInput(e, r, n) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), [e, r] = this._adjustRangeWithSeparators(e, r), this._removeThousandsSeparators(super.extractInput(e, r, n));
  }
  _appendCharRaw(e, r) {
    if (r === void 0 && (r = {}), !this.thousandsSeparator)
      return super._appendCharRaw(e, r);
    const n = r.tail && r._beforeTailState ? r._beforeTailState._value : this._value, s = this._separatorsCountFromSlice(n);
    this._value = this._removeThousandsSeparators(this.value);
    const a = super._appendCharRaw(e, r);
    this._value = this._insertThousandsSeparators(this._value);
    const o = r.tail && r._beforeTailState ? r._beforeTailState._value : this._value, l = this._separatorsCountFromSlice(o);
    return a.tailShift += (l - s) * this.thousandsSeparator.length, a.skip = !a.rawInserted && e === this.thousandsSeparator, a;
  }
  _findSeparatorAround(e) {
    if (this.thousandsSeparator) {
      const r = e - this.thousandsSeparator.length + 1, n = this.value.indexOf(this.thousandsSeparator, r);
      if (n <= e)
        return n;
    }
    return -1;
  }
  _adjustRangeWithSeparators(e, r) {
    const n = this._findSeparatorAround(e);
    n >= 0 && (e = n);
    const s = this._findSeparatorAround(r);
    return s >= 0 && (r = s + this.thousandsSeparator.length), [e, r];
  }
  remove(e, r) {
    e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), [e, r] = this._adjustRangeWithSeparators(e, r);
    const n = this.value.slice(0, e), s = this.value.slice(r), a = this._separatorsCount(n.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(n + s));
    const o = this._separatorsCountFromSlice(n);
    return new sr({
      tailShift: (o - a) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(e, r) {
    if (!this.thousandsSeparator)
      return e;
    switch (r) {
      case Ze.NONE:
      case Ze.LEFT:
      case Ze.FORCE_LEFT: {
        const n = this._findSeparatorAround(e - 1);
        if (n >= 0) {
          const s = n + this.thousandsSeparator.length;
          if (e < s || this.value.length <= s || r === Ze.FORCE_LEFT)
            return n;
        }
        break;
      }
      case Ze.RIGHT:
      case Ze.FORCE_RIGHT: {
        const n = this._findSeparatorAround(e);
        if (n >= 0)
          return n + this.thousandsSeparator.length;
      }
    }
    return e;
  }
  doValidate(e) {
    let r = !!this._removeThousandsSeparators(this.value).match(this._numberRegExp);
    if (r) {
      const n = this.number;
      r = r && !isNaN(n) && // check min bound for negative values
      (this.min == null || this.min >= 0 || this.min <= this.number) && // check max bound for positive values
      (this.max == null || this.max <= 0 || this.number <= this.max);
    }
    return r && super.doValidate(e);
  }
  doCommit() {
    if (this.value) {
      const e = this.number;
      let r = e;
      this.min != null && (r = Math.max(r, this.min)), this.max != null && (r = Math.min(r, this.max)), r !== e && (this.unmaskedValue = this.format(r, this));
      let n = this.value;
      this.normalizeZeros && (n = this._normalizeZeros(n)), this.padFractionalZeros && this.scale > 0 && (n = this._padFractionalZeros(n)), this._value = n;
    }
    super.doCommit();
  }
  _normalizeZeros(e) {
    const r = this._removeThousandsSeparators(e).split(this.radix);
    return r[0] = r[0].replace(/^(\D*)(0*)(\d*)/, (n, s, a, o) => s + o), e.length && !/\d$/.test(r[0]) && (r[0] = r[0] + "0"), r.length > 1 && (r[1] = r[1].replace(/0*$/, ""), r[1].length || (r.length = 1)), this._insertThousandsSeparators(r.join(this.radix));
  }
  _padFractionalZeros(e) {
    if (!e)
      return e;
    const r = e.split(this.radix);
    return r.length < 2 && r.push(""), r[1] = r[1].padEnd(this.scale, "0"), r.join(this.radix);
  }
  doSkipInvalid(e, r, n) {
    r === void 0 && (r = {});
    const s = this.scale === 0 && e !== this.thousandsSeparator && (e === this.radix || e === os.UNMASKED_RADIX || this.mapToRadix.includes(e));
    return super.doSkipInvalid(e, r, n) && !s;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, os.UNMASKED_RADIX);
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(e) {
    this.rawInputValue = this.format(e, this).replace(os.UNMASKED_RADIX, this.radix);
  }
  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(e) {
    this.typedValue = e;
  }
  /**
    Is negative allowed
  */
  get allowNegative() {
    return this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  /**
    Is positive allowed
  */
  get allowPositive() {
    return this.min != null && this.min > 0 || this.max != null && this.max > 0;
  }
  typedValueEquals(e) {
    return (super.typedValueEquals(e) || os.EMPTY_VALUES.includes(e) && os.EMPTY_VALUES.includes(this.typedValue)) && !(e === 0 && this.value === "");
  }
}
os.UNMASKED_RADIX = ".";
os.EMPTY_VALUES = [...Wi.EMPTY_VALUES, 0];
os.DEFAULTS = {
  mask: Number,
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [os.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: !0,
  padFractionalZeros: !1,
  parse: Number,
  format: (t) => t.toLocaleString("en-US", {
    useGrouping: !1,
    maximumFractionDigits: 20
  })
};
ct.MaskedNumber = os;
const pk = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function Cj(t, e, r) {
  e === void 0 && (e = pk.MASKED), r === void 0 && (r = pk.MASKED);
  const n = Ju(t);
  return (s) => n.runIsolated((a) => (a[e] = s, a[r]));
}
function tJe(t, e, r, n) {
  return Cj(e, r, n)(t);
}
ct.PIPE_TYPE = pk;
ct.createPipe = Cj;
ct.pipe = tJe;
try {
  globalThis.IMask = ct;
} catch {
}
var rJe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function nJe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function iJe(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Ij = { exports: {} };
(function(t, e) {
  (function(r, n) {
    t.exports = n();
  })(rJe, function() {
    var r;
    function n() {
      return r.apply(null, arguments);
    }
    function s(v) {
      r = v;
    }
    function a(v) {
      return v instanceof Array || Object.prototype.toString.call(v) === "[object Array]";
    }
    function o(v) {
      return v != null && Object.prototype.toString.call(v) === "[object Object]";
    }
    function l(v, g) {
      return Object.prototype.hasOwnProperty.call(v, g);
    }
    function u(v) {
      if (Object.getOwnPropertyNames)
        return Object.getOwnPropertyNames(v).length === 0;
      var g;
      for (g in v)
        if (l(v, g))
          return !1;
      return !0;
    }
    function c(v) {
      return v === void 0;
    }
    function d(v) {
      return typeof v == "number" || Object.prototype.toString.call(v) === "[object Number]";
    }
    function h(v) {
      return v instanceof Date || Object.prototype.toString.call(v) === "[object Date]";
    }
    function f(v, g) {
      var w = [], S, C = v.length;
      for (S = 0; S < C; ++S)
        w.push(g(v[S], S));
      return w;
    }
    function p(v, g) {
      for (var w in g)
        l(g, w) && (v[w] = g[w]);
      return l(g, "toString") && (v.toString = g.toString), l(g, "valueOf") && (v.valueOf = g.valueOf), v;
    }
    function m(v, g, w, S) {
      return aC(v, g, w, S, !0).utc();
    }
    function b() {
      return {
        empty: !1,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: !1,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: !1,
        userInvalidated: !1,
        iso: !1,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: !1,
        weekdayMismatch: !1
      };
    }
    function y(v) {
      return v._pf == null && (v._pf = b()), v._pf;
    }
    var _;
    Array.prototype.some ? _ = Array.prototype.some : _ = function(v) {
      var g = Object(this), w = g.length >>> 0, S;
      for (S = 0; S < w; S++)
        if (S in g && v.call(this, g[S], S, g))
          return !0;
      return !1;
    };
    function x(v) {
      if (v._isValid == null) {
        var g = y(v), w = _.call(g.parsedDateParts, function(C) {
          return C != null;
        }), S = !isNaN(v._d.getTime()) && g.overflow < 0 && !g.empty && !g.invalidEra && !g.invalidMonth && !g.invalidWeekday && !g.weekdayMismatch && !g.nullInput && !g.invalidFormat && !g.userInvalidated && (!g.meridiem || g.meridiem && w);
        if (v._strict && (S = S && g.charsLeftOver === 0 && g.unusedTokens.length === 0 && g.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(v))
          v._isValid = S;
        else
          return S;
      }
      return v._isValid;
    }
    function T(v) {
      var g = m(NaN);
      return v != null ? p(y(g), v) : y(g).userInvalidated = !0, g;
    }
    var k = n.momentProperties = [], E = !1;
    function F(v, g) {
      var w, S, C, z = k.length;
      if (c(g._isAMomentObject) || (v._isAMomentObject = g._isAMomentObject), c(g._i) || (v._i = g._i), c(g._f) || (v._f = g._f), c(g._l) || (v._l = g._l), c(g._strict) || (v._strict = g._strict), c(g._tzm) || (v._tzm = g._tzm), c(g._isUTC) || (v._isUTC = g._isUTC), c(g._offset) || (v._offset = g._offset), c(g._pf) || (v._pf = y(g)), c(g._locale) || (v._locale = g._locale), z > 0)
        for (w = 0; w < z; w++)
          S = k[w], C = g[S], c(C) || (v[S] = C);
      return v;
    }
    function R(v) {
      F(this, v), this._d = new Date(v._d != null ? v._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), E === !1 && (E = !0, n.updateOffset(this), E = !1);
    }
    function $(v) {
      return v instanceof R || v != null && v._isAMomentObject != null;
    }
    function O(v) {
      n.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + v);
    }
    function P(v, g) {
      var w = !0;
      return p(function() {
        if (n.deprecationHandler != null && n.deprecationHandler(null, v), w) {
          var S = [], C, z, oe, Xe = arguments.length;
          for (z = 0; z < Xe; z++) {
            if (C = "", typeof arguments[z] == "object") {
              C += `
[` + z + "] ";
              for (oe in arguments[0])
                l(arguments[0], oe) && (C += oe + ": " + arguments[0][oe] + ", ");
              C = C.slice(0, -2);
            } else
              C = arguments[z];
            S.push(C);
          }
          O(
            v + `
Arguments: ` + Array.prototype.slice.call(S).join("") + `
` + new Error().stack
          ), w = !1;
        }
        return g.apply(this, arguments);
      }, g);
    }
    var N = {};
    function I(v, g) {
      n.deprecationHandler != null && n.deprecationHandler(v, g), N[v] || (O(g), N[v] = !0);
    }
    n.suppressDeprecationWarnings = !1, n.deprecationHandler = null;
    function B(v) {
      return typeof Function < "u" && v instanceof Function || Object.prototype.toString.call(v) === "[object Function]";
    }
    function W(v) {
      var g, w;
      for (w in v)
        l(v, w) && (g = v[w], B(g) ? this[w] = g : this["_" + w] = g);
      this._config = v, this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
      );
    }
    function Q(v, g) {
      var w = p({}, v), S;
      for (S in g)
        l(g, S) && (o(v[S]) && o(g[S]) ? (w[S] = {}, p(w[S], v[S]), p(w[S], g[S])) : g[S] != null ? w[S] = g[S] : delete w[S]);
      for (S in v)
        l(v, S) && !l(g, S) && o(v[S]) && (w[S] = p({}, w[S]));
      return w;
    }
    function te(v) {
      v != null && this.set(v);
    }
    var H;
    Object.keys ? H = Object.keys : H = function(v) {
      var g, w = [];
      for (g in v)
        l(v, g) && w.push(g);
      return w;
    };
    var A = {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    };
    function V(v, g, w) {
      var S = this._calendar[v] || this._calendar.sameElse;
      return B(S) ? S.call(g, w) : S;
    }
    function M(v, g, w) {
      var S = "" + Math.abs(v), C = g - S.length, z = v >= 0;
      return (z ? w ? "+" : "" : "-") + Math.pow(10, Math.max(0, C)).toString().substr(1) + S;
    }
    var Z = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, U = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, pe = {}, q = {};
    function Y(v, g, w, S) {
      var C = S;
      typeof S == "string" && (C = function() {
        return this[S]();
      }), v && (q[v] = C), g && (q[g[0]] = function() {
        return M(C.apply(this, arguments), g[1], g[2]);
      }), w && (q[w] = function() {
        return this.localeData().ordinal(
          C.apply(this, arguments),
          v
        );
      });
    }
    function se(v) {
      return v.match(/\[[\s\S]/) ? v.replace(/^\[|\]$/g, "") : v.replace(/\\/g, "");
    }
    function he(v) {
      var g = v.match(Z), w, S;
      for (w = 0, S = g.length; w < S; w++)
        q[g[w]] ? g[w] = q[g[w]] : g[w] = se(g[w]);
      return function(C) {
        var z = "", oe;
        for (oe = 0; oe < S; oe++)
          z += B(g[oe]) ? g[oe].call(C, v) : g[oe];
        return z;
      };
    }
    function fe(v, g) {
      return v.isValid() ? (g = Te(g, v.localeData()), pe[g] = pe[g] || he(g), pe[g](v)) : v.localeData().invalidDate();
    }
    function Te(v, g) {
      var w = 5;
      function S(C) {
        return g.longDateFormat(C) || C;
      }
      for (U.lastIndex = 0; w >= 0 && U.test(v); )
        v = v.replace(
          U,
          S
        ), U.lastIndex = 0, w -= 1;
      return v;
    }
    var ee = {
      LTS: "h:mm:ss A",
      LT: "h:mm A",
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function Oe(v) {
      var g = this._longDateFormat[v], w = this._longDateFormat[v.toUpperCase()];
      return g || !w ? g : (this._longDateFormat[v] = w.match(Z).map(function(S) {
        return S === "MMMM" || S === "MM" || S === "DD" || S === "dddd" ? S.slice(1) : S;
      }).join(""), this._longDateFormat[v]);
    }
    var ut = "Invalid date";
    function L() {
      return this._invalidDate;
    }
    var K = "%d", ie = /\d{1,2}/;
    function ce(v) {
      return this._ordinal.replace("%d", v);
    }
    var ve = {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      w: "a week",
      ww: "%d weeks",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    };
    function De(v, g, w, S) {
      var C = this._relativeTime[w];
      return B(C) ? C(v, g, w, S) : C.replace(/%d/i, v);
    }
    function Re(v, g) {
      var w = this._relativeTime[v > 0 ? "future" : "past"];
      return B(w) ? w(g) : w.replace(/%s/i, g);
    }
    var Se = {};
    function xe(v, g) {
      var w = v.toLowerCase();
      Se[w] = Se[w + "s"] = Se[g] = v;
    }
    function me(v) {
      return typeof v == "string" ? Se[v] || Se[v.toLowerCase()] : void 0;
    }
    function Ye(v) {
      var g = {}, w, S;
      for (S in v)
        l(v, S) && (w = me(S), w && (g[w] = v[S]));
      return g;
    }
    var Fe = {};
    function Me(v, g) {
      Fe[v] = g;
    }
    function Ae(v) {
      var g = [], w;
      for (w in v)
        l(v, w) && g.push({ unit: w, priority: Fe[w] });
      return g.sort(function(S, C) {
        return S.priority - C.priority;
      }), g;
    }
    function j(v) {
      return v % 4 === 0 && v % 100 !== 0 || v % 400 === 0;
    }
    function ne(v) {
      return v < 0 ? Math.ceil(v) || 0 : Math.floor(v);
    }
    function ge(v) {
      var g = +v, w = 0;
      return g !== 0 && isFinite(g) && (w = ne(g)), w;
    }
    function Ge(v, g) {
      return function(w) {
        return w != null ? (vn(this, v, w), n.updateOffset(this, g), this) : xt(this, v);
      };
    }
    function xt(v, g) {
      return v.isValid() ? v._d["get" + (v._isUTC ? "UTC" : "") + g]() : NaN;
    }
    function vn(v, g, w) {
      v.isValid() && !isNaN(w) && (g === "FullYear" && j(v.year()) && v.month() === 1 && v.date() === 29 ? (w = ge(w), v._d["set" + (v._isUTC ? "UTC" : "") + g](
        w,
        v.month(),
        Qv(w, v.month())
      )) : v._d["set" + (v._isUTC ? "UTC" : "") + g](w));
    }
    function Es(v) {
      return v = me(v), B(this[v]) ? this[v]() : this;
    }
    function Ii(v, g) {
      if (typeof v == "object") {
        v = Ye(v);
        var w = Ae(v), S, C = w.length;
        for (S = 0; S < C; S++)
          this[w[S].unit](v[w[S].unit]);
      } else if (v = me(v), B(this[v]))
        return this[v](g);
      return this;
    }
    var na = /\d/, Ot = /\d\d/, Ur = /\d{3}/, ia = /\d{4}/, _c = /[+-]?\d{6}/, br = /\d\d?/, HA = /\d\d\d\d?/, GA = /\d\d\d\d\d\d?/, jv = /\d{1,3}/, Wb = /\d{1,4}/, Kv = /[+-]?\d{1,6}/, wc = /\d+/, zv = /[+-]?\d+/, Yj = /Z|[+-]\d\d:?\d\d/gi, qv = /Z|[+-]\d\d(?::?\d\d)?/gi, Hj = /[+-]?\d+(\.\d{1,3})?/, Rh = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Xv;
    Xv = {};
    function Be(v, g, w) {
      Xv[v] = B(g) ? g : function(S, C) {
        return S && w ? w : g;
      };
    }
    function Gj(v, g) {
      return l(Xv, v) ? Xv[v](g._strict, g._locale) : new RegExp(Wj(v));
    }
    function Wj(v) {
      return Pi(
        v.replace("\\", "").replace(
          /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
          function(g, w, S, C, z) {
            return w || S || C || z;
          }
        )
      );
    }
    function Pi(v) {
      return v.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var jb = {};
    function rr(v, g) {
      var w, S = g, C;
      for (typeof v == "string" && (v = [v]), d(g) && (S = function(z, oe) {
        oe[g] = ge(z);
      }), C = v.length, w = 0; w < C; w++)
        jb[v[w]] = S;
    }
    function Mh(v, g) {
      rr(v, function(w, S, C, z) {
        C._w = C._w || {}, g(w, C._w, C, z);
      });
    }
    function jj(v, g, w) {
      g != null && l(jb, v) && jb[v](g, w._a, w, v);
    }
    var Fn = 0, Ya = 1, sa = 2, an = 3, $s = 4, Ha = 5, Vl = 6, Kj = 7, zj = 8;
    function qj(v, g) {
      return (v % g + g) % g;
    }
    var Kr;
    Array.prototype.indexOf ? Kr = Array.prototype.indexOf : Kr = function(v) {
      var g;
      for (g = 0; g < this.length; ++g)
        if (this[g] === v)
          return g;
      return -1;
    };
    function Qv(v, g) {
      if (isNaN(v) || isNaN(g))
        return NaN;
      var w = qj(g, 12);
      return v += (g - w) / 12, w === 1 ? j(v) ? 29 : 28 : 31 - w % 7 % 2;
    }
    Y("M", ["MM", 2], "Mo", function() {
      return this.month() + 1;
    }), Y("MMM", 0, 0, function(v) {
      return this.localeData().monthsShort(this, v);
    }), Y("MMMM", 0, 0, function(v) {
      return this.localeData().months(this, v);
    }), xe("month", "M"), Me("month", 8), Be("M", br), Be("MM", br, Ot), Be("MMM", function(v, g) {
      return g.monthsShortRegex(v);
    }), Be("MMMM", function(v, g) {
      return g.monthsRegex(v);
    }), rr(["M", "MM"], function(v, g) {
      g[Ya] = ge(v) - 1;
    }), rr(["MMM", "MMMM"], function(v, g, w, S) {
      var C = w._locale.monthsParse(v, S, w._strict);
      C != null ? g[Ya] = C : y(w).invalidMonth = v;
    });
    var Xj = "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ), WA = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), jA = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Qj = Rh, Zj = Rh;
    function Jj(v, g) {
      return v ? a(this._months) ? this._months[v.month()] : this._months[(this._months.isFormat || jA).test(g) ? "format" : "standalone"][v.month()] : a(this._months) ? this._months : this._months.standalone;
    }
    function e8(v, g) {
      return v ? a(this._monthsShort) ? this._monthsShort[v.month()] : this._monthsShort[jA.test(g) ? "format" : "standalone"][v.month()] : a(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
    }
    function t8(v, g, w) {
      var S, C, z, oe = v.toLocaleLowerCase();
      if (!this._monthsParse)
        for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], S = 0; S < 12; ++S)
          z = m([2e3, S]), this._shortMonthsParse[S] = this.monthsShort(
            z,
            ""
          ).toLocaleLowerCase(), this._longMonthsParse[S] = this.months(z, "").toLocaleLowerCase();
      return w ? g === "MMM" ? (C = Kr.call(this._shortMonthsParse, oe), C !== -1 ? C : null) : (C = Kr.call(this._longMonthsParse, oe), C !== -1 ? C : null) : g === "MMM" ? (C = Kr.call(this._shortMonthsParse, oe), C !== -1 ? C : (C = Kr.call(this._longMonthsParse, oe), C !== -1 ? C : null)) : (C = Kr.call(this._longMonthsParse, oe), C !== -1 ? C : (C = Kr.call(this._shortMonthsParse, oe), C !== -1 ? C : null));
    }
    function r8(v, g, w) {
      var S, C, z;
      if (this._monthsParseExact)
        return t8.call(this, v, g, w);
      for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), S = 0; S < 12; S++) {
        if (C = m([2e3, S]), w && !this._longMonthsParse[S] && (this._longMonthsParse[S] = new RegExp(
          "^" + this.months(C, "").replace(".", "") + "$",
          "i"
        ), this._shortMonthsParse[S] = new RegExp(
          "^" + this.monthsShort(C, "").replace(".", "") + "$",
          "i"
        )), !w && !this._monthsParse[S] && (z = "^" + this.months(C, "") + "|^" + this.monthsShort(C, ""), this._monthsParse[S] = new RegExp(z.replace(".", ""), "i")), w && g === "MMMM" && this._longMonthsParse[S].test(v))
          return S;
        if (w && g === "MMM" && this._shortMonthsParse[S].test(v))
          return S;
        if (!w && this._monthsParse[S].test(v))
          return S;
      }
    }
    function KA(v, g) {
      var w;
      if (!v.isValid())
        return v;
      if (typeof g == "string") {
        if (/^\d+$/.test(g))
          g = ge(g);
        else if (g = v.localeData().monthsParse(g), !d(g))
          return v;
      }
      return w = Math.min(v.date(), Qv(v.year(), g)), v._d["set" + (v._isUTC ? "UTC" : "") + "Month"](g, w), v;
    }
    function zA(v) {
      return v != null ? (KA(this, v), n.updateOffset(this, !0), this) : xt(this, "Month");
    }
    function n8() {
      return Qv(this.year(), this.month());
    }
    function i8(v) {
      return this._monthsParseExact ? (l(this, "_monthsRegex") || qA.call(this), v ? this._monthsShortStrictRegex : this._monthsShortRegex) : (l(this, "_monthsShortRegex") || (this._monthsShortRegex = Qj), this._monthsShortStrictRegex && v ? this._monthsShortStrictRegex : this._monthsShortRegex);
    }
    function s8(v) {
      return this._monthsParseExact ? (l(this, "_monthsRegex") || qA.call(this), v ? this._monthsStrictRegex : this._monthsRegex) : (l(this, "_monthsRegex") || (this._monthsRegex = Zj), this._monthsStrictRegex && v ? this._monthsStrictRegex : this._monthsRegex);
    }
    function qA() {
      function v(oe, Xe) {
        return Xe.length - oe.length;
      }
      var g = [], w = [], S = [], C, z;
      for (C = 0; C < 12; C++)
        z = m([2e3, C]), g.push(this.monthsShort(z, "")), w.push(this.months(z, "")), S.push(this.months(z, "")), S.push(this.monthsShort(z, ""));
      for (g.sort(v), w.sort(v), S.sort(v), C = 0; C < 12; C++)
        g[C] = Pi(g[C]), w[C] = Pi(w[C]);
      for (C = 0; C < 24; C++)
        S[C] = Pi(S[C]);
      this._monthsRegex = new RegExp("^(" + S.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
        "^(" + w.join("|") + ")",
        "i"
      ), this._monthsShortStrictRegex = new RegExp(
        "^(" + g.join("|") + ")",
        "i"
      );
    }
    Y("Y", 0, 0, function() {
      var v = this.year();
      return v <= 9999 ? M(v, 4) : "+" + v;
    }), Y(0, ["YY", 2], 0, function() {
      return this.year() % 100;
    }), Y(0, ["YYYY", 4], 0, "year"), Y(0, ["YYYYY", 5], 0, "year"), Y(0, ["YYYYYY", 6, !0], 0, "year"), xe("year", "y"), Me("year", 1), Be("Y", zv), Be("YY", br, Ot), Be("YYYY", Wb, ia), Be("YYYYY", Kv, _c), Be("YYYYYY", Kv, _c), rr(["YYYYY", "YYYYYY"], Fn), rr("YYYY", function(v, g) {
      g[Fn] = v.length === 2 ? n.parseTwoDigitYear(v) : ge(v);
    }), rr("YY", function(v, g) {
      g[Fn] = n.parseTwoDigitYear(v);
    }), rr("Y", function(v, g) {
      g[Fn] = parseInt(v, 10);
    });
    function Lh(v) {
      return j(v) ? 366 : 365;
    }
    n.parseTwoDigitYear = function(v) {
      return ge(v) + (ge(v) > 68 ? 1900 : 2e3);
    };
    var XA = Ge("FullYear", !0);
    function a8() {
      return j(this.year());
    }
    function o8(v, g, w, S, C, z, oe) {
      var Xe;
      return v < 100 && v >= 0 ? (Xe = new Date(v + 400, g, w, S, C, z, oe), isFinite(Xe.getFullYear()) && Xe.setFullYear(v)) : Xe = new Date(v, g, w, S, C, z, oe), Xe;
    }
    function Nh(v) {
      var g, w;
      return v < 100 && v >= 0 ? (w = Array.prototype.slice.call(arguments), w[0] = v + 400, g = new Date(Date.UTC.apply(null, w)), isFinite(g.getUTCFullYear()) && g.setUTCFullYear(v)) : g = new Date(Date.UTC.apply(null, arguments)), g;
    }
    function Zv(v, g, w) {
      var S = 7 + g - w, C = (7 + Nh(v, 0, S).getUTCDay() - g) % 7;
      return -C + S - 1;
    }
    function QA(v, g, w, S, C) {
      var z = (7 + w - S) % 7, oe = Zv(v, S, C), Xe = 1 + 7 * (g - 1) + z + oe, Tt, nr;
      return Xe <= 0 ? (Tt = v - 1, nr = Lh(Tt) + Xe) : Xe > Lh(v) ? (Tt = v + 1, nr = Xe - Lh(v)) : (Tt = v, nr = Xe), {
        year: Tt,
        dayOfYear: nr
      };
    }
    function Fh(v, g, w) {
      var S = Zv(v.year(), g, w), C = Math.floor((v.dayOfYear() - S - 1) / 7) + 1, z, oe;
      return C < 1 ? (oe = v.year() - 1, z = C + Ga(oe, g, w)) : C > Ga(v.year(), g, w) ? (z = C - Ga(v.year(), g, w), oe = v.year() + 1) : (oe = v.year(), z = C), {
        week: z,
        year: oe
      };
    }
    function Ga(v, g, w) {
      var S = Zv(v, g, w), C = Zv(v + 1, g, w);
      return (Lh(v) - S + C) / 7;
    }
    Y("w", ["ww", 2], "wo", "week"), Y("W", ["WW", 2], "Wo", "isoWeek"), xe("week", "w"), xe("isoWeek", "W"), Me("week", 5), Me("isoWeek", 5), Be("w", br), Be("ww", br, Ot), Be("W", br), Be("WW", br, Ot), Mh(
      ["w", "ww", "W", "WW"],
      function(v, g, w, S) {
        g[S.substr(0, 1)] = ge(v);
      }
    );
    function l8(v) {
      return Fh(v, this._week.dow, this._week.doy).week;
    }
    var u8 = {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    };
    function c8() {
      return this._week.dow;
    }
    function d8() {
      return this._week.doy;
    }
    function h8(v) {
      var g = this.localeData().week(this);
      return v == null ? g : this.add((v - g) * 7, "d");
    }
    function f8(v) {
      var g = Fh(this, 1, 4).week;
      return v == null ? g : this.add((v - g) * 7, "d");
    }
    Y("d", 0, "do", "day"), Y("dd", 0, 0, function(v) {
      return this.localeData().weekdaysMin(this, v);
    }), Y("ddd", 0, 0, function(v) {
      return this.localeData().weekdaysShort(this, v);
    }), Y("dddd", 0, 0, function(v) {
      return this.localeData().weekdays(this, v);
    }), Y("e", 0, 0, "weekday"), Y("E", 0, 0, "isoWeekday"), xe("day", "d"), xe("weekday", "e"), xe("isoWeekday", "E"), Me("day", 11), Me("weekday", 11), Me("isoWeekday", 11), Be("d", br), Be("e", br), Be("E", br), Be("dd", function(v, g) {
      return g.weekdaysMinRegex(v);
    }), Be("ddd", function(v, g) {
      return g.weekdaysShortRegex(v);
    }), Be("dddd", function(v, g) {
      return g.weekdaysRegex(v);
    }), Mh(["dd", "ddd", "dddd"], function(v, g, w, S) {
      var C = w._locale.weekdaysParse(v, S, w._strict);
      C != null ? g.d = C : y(w).invalidWeekday = v;
    }), Mh(["d", "e", "E"], function(v, g, w, S) {
      g[S] = ge(v);
    });
    function p8(v, g) {
      return typeof v != "string" ? v : isNaN(v) ? (v = g.weekdaysParse(v), typeof v == "number" ? v : null) : parseInt(v, 10);
    }
    function v8(v, g) {
      return typeof v == "string" ? g.weekdaysParse(v) % 7 || 7 : isNaN(v) ? null : v;
    }
    function Kb(v, g) {
      return v.slice(g, 7).concat(v.slice(0, g));
    }
    var m8 = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), ZA = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), g8 = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), y8 = Rh, b8 = Rh, _8 = Rh;
    function w8(v, g) {
      var w = a(this._weekdays) ? this._weekdays : this._weekdays[v && v !== !0 && this._weekdays.isFormat.test(g) ? "format" : "standalone"];
      return v === !0 ? Kb(w, this._week.dow) : v ? w[v.day()] : w;
    }
    function T8(v) {
      return v === !0 ? Kb(this._weekdaysShort, this._week.dow) : v ? this._weekdaysShort[v.day()] : this._weekdaysShort;
    }
    function x8(v) {
      return v === !0 ? Kb(this._weekdaysMin, this._week.dow) : v ? this._weekdaysMin[v.day()] : this._weekdaysMin;
    }
    function S8(v, g, w) {
      var S, C, z, oe = v.toLocaleLowerCase();
      if (!this._weekdaysParse)
        for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], S = 0; S < 7; ++S)
          z = m([2e3, 1]).day(S), this._minWeekdaysParse[S] = this.weekdaysMin(
            z,
            ""
          ).toLocaleLowerCase(), this._shortWeekdaysParse[S] = this.weekdaysShort(
            z,
            ""
          ).toLocaleLowerCase(), this._weekdaysParse[S] = this.weekdays(z, "").toLocaleLowerCase();
      return w ? g === "dddd" ? (C = Kr.call(this._weekdaysParse, oe), C !== -1 ? C : null) : g === "ddd" ? (C = Kr.call(this._shortWeekdaysParse, oe), C !== -1 ? C : null) : (C = Kr.call(this._minWeekdaysParse, oe), C !== -1 ? C : null) : g === "dddd" ? (C = Kr.call(this._weekdaysParse, oe), C !== -1 || (C = Kr.call(this._shortWeekdaysParse, oe), C !== -1) ? C : (C = Kr.call(this._minWeekdaysParse, oe), C !== -1 ? C : null)) : g === "ddd" ? (C = Kr.call(this._shortWeekdaysParse, oe), C !== -1 || (C = Kr.call(this._weekdaysParse, oe), C !== -1) ? C : (C = Kr.call(this._minWeekdaysParse, oe), C !== -1 ? C : null)) : (C = Kr.call(this._minWeekdaysParse, oe), C !== -1 || (C = Kr.call(this._weekdaysParse, oe), C !== -1) ? C : (C = Kr.call(this._shortWeekdaysParse, oe), C !== -1 ? C : null));
    }
    function E8(v, g, w) {
      var S, C, z;
      if (this._weekdaysParseExact)
        return S8.call(this, v, g, w);
      for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), S = 0; S < 7; S++) {
        if (C = m([2e3, 1]).day(S), w && !this._fullWeekdaysParse[S] && (this._fullWeekdaysParse[S] = new RegExp(
          "^" + this.weekdays(C, "").replace(".", "\\.?") + "$",
          "i"
        ), this._shortWeekdaysParse[S] = new RegExp(
          "^" + this.weekdaysShort(C, "").replace(".", "\\.?") + "$",
          "i"
        ), this._minWeekdaysParse[S] = new RegExp(
          "^" + this.weekdaysMin(C, "").replace(".", "\\.?") + "$",
          "i"
        )), this._weekdaysParse[S] || (z = "^" + this.weekdays(C, "") + "|^" + this.weekdaysShort(C, "") + "|^" + this.weekdaysMin(C, ""), this._weekdaysParse[S] = new RegExp(z.replace(".", ""), "i")), w && g === "dddd" && this._fullWeekdaysParse[S].test(v))
          return S;
        if (w && g === "ddd" && this._shortWeekdaysParse[S].test(v))
          return S;
        if (w && g === "dd" && this._minWeekdaysParse[S].test(v))
          return S;
        if (!w && this._weekdaysParse[S].test(v))
          return S;
      }
    }
    function $8(v) {
      if (!this.isValid())
        return v != null ? this : NaN;
      var g = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
      return v != null ? (v = p8(v, this.localeData()), this.add(v - g, "d")) : g;
    }
    function k8(v) {
      if (!this.isValid())
        return v != null ? this : NaN;
      var g = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return v == null ? g : this.add(v - g, "d");
    }
    function D8(v) {
      if (!this.isValid())
        return v != null ? this : NaN;
      if (v != null) {
        var g = v8(v, this.localeData());
        return this.day(this.day() % 7 ? g : g - 7);
      } else
        return this.day() || 7;
    }
    function O8(v) {
      return this._weekdaysParseExact ? (l(this, "_weekdaysRegex") || zb.call(this), v ? this._weekdaysStrictRegex : this._weekdaysRegex) : (l(this, "_weekdaysRegex") || (this._weekdaysRegex = y8), this._weekdaysStrictRegex && v ? this._weekdaysStrictRegex : this._weekdaysRegex);
    }
    function A8(v) {
      return this._weekdaysParseExact ? (l(this, "_weekdaysRegex") || zb.call(this), v ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (l(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = b8), this._weekdaysShortStrictRegex && v ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
    }
    function C8(v) {
      return this._weekdaysParseExact ? (l(this, "_weekdaysRegex") || zb.call(this), v ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (l(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = _8), this._weekdaysMinStrictRegex && v ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
    }
    function zb() {
      function v(zn, qa) {
        return qa.length - zn.length;
      }
      var g = [], w = [], S = [], C = [], z, oe, Xe, Tt, nr;
      for (z = 0; z < 7; z++)
        oe = m([2e3, 1]).day(z), Xe = Pi(this.weekdaysMin(oe, "")), Tt = Pi(this.weekdaysShort(oe, "")), nr = Pi(this.weekdays(oe, "")), g.push(Xe), w.push(Tt), S.push(nr), C.push(Xe), C.push(Tt), C.push(nr);
      g.sort(v), w.sort(v), S.sort(v), C.sort(v), this._weekdaysRegex = new RegExp("^(" + C.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
        "^(" + S.join("|") + ")",
        "i"
      ), this._weekdaysShortStrictRegex = new RegExp(
        "^(" + w.join("|") + ")",
        "i"
      ), this._weekdaysMinStrictRegex = new RegExp(
        "^(" + g.join("|") + ")",
        "i"
      );
    }
    function qb() {
      return this.hours() % 12 || 12;
    }
    function I8() {
      return this.hours() || 24;
    }
    Y("H", ["HH", 2], 0, "hour"), Y("h", ["hh", 2], 0, qb), Y("k", ["kk", 2], 0, I8), Y("hmm", 0, 0, function() {
      return "" + qb.apply(this) + M(this.minutes(), 2);
    }), Y("hmmss", 0, 0, function() {
      return "" + qb.apply(this) + M(this.minutes(), 2) + M(this.seconds(), 2);
    }), Y("Hmm", 0, 0, function() {
      return "" + this.hours() + M(this.minutes(), 2);
    }), Y("Hmmss", 0, 0, function() {
      return "" + this.hours() + M(this.minutes(), 2) + M(this.seconds(), 2);
    });
    function JA(v, g) {
      Y(v, 0, 0, function() {
        return this.localeData().meridiem(
          this.hours(),
          this.minutes(),
          g
        );
      });
    }
    JA("a", !0), JA("A", !1), xe("hour", "h"), Me("hour", 13);
    function eC(v, g) {
      return g._meridiemParse;
    }
    Be("a", eC), Be("A", eC), Be("H", br), Be("h", br), Be("k", br), Be("HH", br, Ot), Be("hh", br, Ot), Be("kk", br, Ot), Be("hmm", HA), Be("hmmss", GA), Be("Hmm", HA), Be("Hmmss", GA), rr(["H", "HH"], an), rr(["k", "kk"], function(v, g, w) {
      var S = ge(v);
      g[an] = S === 24 ? 0 : S;
    }), rr(["a", "A"], function(v, g, w) {
      w._isPm = w._locale.isPM(v), w._meridiem = v;
    }), rr(["h", "hh"], function(v, g, w) {
      g[an] = ge(v), y(w).bigHour = !0;
    }), rr("hmm", function(v, g, w) {
      var S = v.length - 2;
      g[an] = ge(v.substr(0, S)), g[$s] = ge(v.substr(S)), y(w).bigHour = !0;
    }), rr("hmmss", function(v, g, w) {
      var S = v.length - 4, C = v.length - 2;
      g[an] = ge(v.substr(0, S)), g[$s] = ge(v.substr(S, 2)), g[Ha] = ge(v.substr(C)), y(w).bigHour = !0;
    }), rr("Hmm", function(v, g, w) {
      var S = v.length - 2;
      g[an] = ge(v.substr(0, S)), g[$s] = ge(v.substr(S));
    }), rr("Hmmss", function(v, g, w) {
      var S = v.length - 4, C = v.length - 2;
      g[an] = ge(v.substr(0, S)), g[$s] = ge(v.substr(S, 2)), g[Ha] = ge(v.substr(C));
    });
    function P8(v) {
      return (v + "").toLowerCase().charAt(0) === "p";
    }
    var R8 = /[ap]\.?m?\.?/i, M8 = Ge("Hours", !0);
    function L8(v, g, w) {
      return v > 11 ? w ? "pm" : "PM" : w ? "am" : "AM";
    }
    var tC = {
      calendar: A,
      longDateFormat: ee,
      invalidDate: ut,
      ordinal: K,
      dayOfMonthOrdinalParse: ie,
      relativeTime: ve,
      months: Xj,
      monthsShort: WA,
      week: u8,
      weekdays: m8,
      weekdaysMin: g8,
      weekdaysShort: ZA,
      meridiemParse: R8
    }, Er = {}, Bh = {}, Uh;
    function N8(v, g) {
      var w, S = Math.min(v.length, g.length);
      for (w = 0; w < S; w += 1)
        if (v[w] !== g[w])
          return w;
      return S;
    }
    function rC(v) {
      return v && v.toLowerCase().replace("_", "-");
    }
    function F8(v) {
      for (var g = 0, w, S, C, z; g < v.length; ) {
        for (z = rC(v[g]).split("-"), w = z.length, S = rC(v[g + 1]), S = S ? S.split("-") : null; w > 0; ) {
          if (C = Jv(z.slice(0, w).join("-")), C)
            return C;
          if (S && S.length >= w && N8(z, S) >= w - 1)
            break;
          w--;
        }
        g++;
      }
      return Uh;
    }
    function B8(v) {
      return v.match("^[^/\\\\]*$") != null;
    }
    function Jv(v) {
      var g = null, w;
      if (Er[v] === void 0 && t && t.exports && B8(v))
        try {
          g = Uh._abbr, w = iJe, w("./locale/" + v), Go(g);
        } catch {
          Er[v] = null;
        }
      return Er[v];
    }
    function Go(v, g) {
      var w;
      return v && (c(g) ? w = Wa(v) : w = Xb(v, g), w ? Uh = w : typeof console < "u" && console.warn && console.warn(
        "Locale " + v + " not found. Did you forget to load it?"
      )), Uh._abbr;
    }
    function Xb(v, g) {
      if (g !== null) {
        var w, S = tC;
        if (g.abbr = v, Er[v] != null)
          I(
            "defineLocaleOverride",
            "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
          ), S = Er[v]._config;
        else if (g.parentLocale != null)
          if (Er[g.parentLocale] != null)
            S = Er[g.parentLocale]._config;
          else if (w = Jv(g.parentLocale), w != null)
            S = w._config;
          else
            return Bh[g.parentLocale] || (Bh[g.parentLocale] = []), Bh[g.parentLocale].push({
              name: v,
              config: g
            }), null;
        return Er[v] = new te(Q(S, g)), Bh[v] && Bh[v].forEach(function(C) {
          Xb(C.name, C.config);
        }), Go(v), Er[v];
      } else
        return delete Er[v], null;
    }
    function U8(v, g) {
      if (g != null) {
        var w, S, C = tC;
        Er[v] != null && Er[v].parentLocale != null ? Er[v].set(Q(Er[v]._config, g)) : (S = Jv(v), S != null && (C = S._config), g = Q(C, g), S == null && (g.abbr = v), w = new te(g), w.parentLocale = Er[v], Er[v] = w), Go(v);
      } else
        Er[v] != null && (Er[v].parentLocale != null ? (Er[v] = Er[v].parentLocale, v === Go() && Go(v)) : Er[v] != null && delete Er[v]);
      return Er[v];
    }
    function Wa(v) {
      var g;
      if (v && v._locale && v._locale._abbr && (v = v._locale._abbr), !v)
        return Uh;
      if (!a(v)) {
        if (g = Jv(v), g)
          return g;
        v = [v];
      }
      return F8(v);
    }
    function V8() {
      return H(Er);
    }
    function Qb(v) {
      var g, w = v._a;
      return w && y(v).overflow === -2 && (g = w[Ya] < 0 || w[Ya] > 11 ? Ya : w[sa] < 1 || w[sa] > Qv(w[Fn], w[Ya]) ? sa : w[an] < 0 || w[an] > 24 || w[an] === 24 && (w[$s] !== 0 || w[Ha] !== 0 || w[Vl] !== 0) ? an : w[$s] < 0 || w[$s] > 59 ? $s : w[Ha] < 0 || w[Ha] > 59 ? Ha : w[Vl] < 0 || w[Vl] > 999 ? Vl : -1, y(v)._overflowDayOfYear && (g < Fn || g > sa) && (g = sa), y(v)._overflowWeeks && g === -1 && (g = Kj), y(v)._overflowWeekday && g === -1 && (g = zj), y(v).overflow = g), v;
    }
    var Y8 = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, H8 = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, G8 = /Z|[+-]\d\d(?::?\d\d)?/, em = [
      ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
      ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
      ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
      ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
      ["YYYY-DDD", /\d{4}-\d{3}/],
      ["YYYY-MM", /\d{4}-\d\d/, !1],
      ["YYYYYYMMDD", /[+-]\d{10}/],
      ["YYYYMMDD", /\d{8}/],
      ["GGGG[W]WWE", /\d{4}W\d{3}/],
      ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
      ["YYYYDDD", /\d{7}/],
      ["YYYYMM", /\d{6}/, !1],
      ["YYYY", /\d{4}/, !1]
    ], Zb = [
      ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
      ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
      ["HH:mm:ss", /\d\d:\d\d:\d\d/],
      ["HH:mm", /\d\d:\d\d/],
      ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
      ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
      ["HHmmss", /\d\d\d\d\d\d/],
      ["HHmm", /\d\d\d\d/],
      ["HH", /\d\d/]
    ], W8 = /^\/?Date\((-?\d+)/i, j8 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, K8 = {
      UT: 0,
      GMT: 0,
      EDT: -4 * 60,
      EST: -5 * 60,
      CDT: -5 * 60,
      CST: -6 * 60,
      MDT: -6 * 60,
      MST: -7 * 60,
      PDT: -7 * 60,
      PST: -8 * 60
    };
    function nC(v) {
      var g, w, S = v._i, C = Y8.exec(S) || H8.exec(S), z, oe, Xe, Tt, nr = em.length, zn = Zb.length;
      if (C) {
        for (y(v).iso = !0, g = 0, w = nr; g < w; g++)
          if (em[g][1].exec(C[1])) {
            oe = em[g][0], z = em[g][2] !== !1;
            break;
          }
        if (oe == null) {
          v._isValid = !1;
          return;
        }
        if (C[3]) {
          for (g = 0, w = zn; g < w; g++)
            if (Zb[g][1].exec(C[3])) {
              Xe = (C[2] || " ") + Zb[g][0];
              break;
            }
          if (Xe == null) {
            v._isValid = !1;
            return;
          }
        }
        if (!z && Xe != null) {
          v._isValid = !1;
          return;
        }
        if (C[4])
          if (G8.exec(C[4]))
            Tt = "Z";
          else {
            v._isValid = !1;
            return;
          }
        v._f = oe + (Xe || "") + (Tt || ""), e_(v);
      } else
        v._isValid = !1;
    }
    function z8(v, g, w, S, C, z) {
      var oe = [
        q8(v),
        WA.indexOf(g),
        parseInt(w, 10),
        parseInt(S, 10),
        parseInt(C, 10)
      ];
      return z && oe.push(parseInt(z, 10)), oe;
    }
    function q8(v) {
      var g = parseInt(v, 10);
      return g <= 49 ? 2e3 + g : g <= 999 ? 1900 + g : g;
    }
    function X8(v) {
      return v.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function Q8(v, g, w) {
      if (v) {
        var S = ZA.indexOf(v), C = new Date(
          g[0],
          g[1],
          g[2]
        ).getDay();
        if (S !== C)
          return y(w).weekdayMismatch = !0, w._isValid = !1, !1;
      }
      return !0;
    }
    function Z8(v, g, w) {
      if (v)
        return K8[v];
      if (g)
        return 0;
      var S = parseInt(w, 10), C = S % 100, z = (S - C) / 100;
      return z * 60 + C;
    }
    function iC(v) {
      var g = j8.exec(X8(v._i)), w;
      if (g) {
        if (w = z8(
          g[4],
          g[3],
          g[2],
          g[5],
          g[6],
          g[7]
        ), !Q8(g[1], w, v))
          return;
        v._a = w, v._tzm = Z8(g[8], g[9], g[10]), v._d = Nh.apply(null, v._a), v._d.setUTCMinutes(v._d.getUTCMinutes() - v._tzm), y(v).rfc2822 = !0;
      } else
        v._isValid = !1;
    }
    function J8(v) {
      var g = W8.exec(v._i);
      if (g !== null) {
        v._d = /* @__PURE__ */ new Date(+g[1]);
        return;
      }
      if (nC(v), v._isValid === !1)
        delete v._isValid;
      else
        return;
      if (iC(v), v._isValid === !1)
        delete v._isValid;
      else
        return;
      v._strict ? v._isValid = !1 : n.createFromInputFallback(v);
    }
    n.createFromInputFallback = P(
      "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
      function(v) {
        v._d = /* @__PURE__ */ new Date(v._i + (v._useUTC ? " UTC" : ""));
      }
    );
    function Tc(v, g, w) {
      return v ?? g ?? w;
    }
    function eK(v) {
      var g = new Date(n.now());
      return v._useUTC ? [
        g.getUTCFullYear(),
        g.getUTCMonth(),
        g.getUTCDate()
      ] : [g.getFullYear(), g.getMonth(), g.getDate()];
    }
    function Jb(v) {
      var g, w, S = [], C, z, oe;
      if (!v._d) {
        for (C = eK(v), v._w && v._a[sa] == null && v._a[Ya] == null && tK(v), v._dayOfYear != null && (oe = Tc(v._a[Fn], C[Fn]), (v._dayOfYear > Lh(oe) || v._dayOfYear === 0) && (y(v)._overflowDayOfYear = !0), w = Nh(oe, 0, v._dayOfYear), v._a[Ya] = w.getUTCMonth(), v._a[sa] = w.getUTCDate()), g = 0; g < 3 && v._a[g] == null; ++g)
          v._a[g] = S[g] = C[g];
        for (; g < 7; g++)
          v._a[g] = S[g] = v._a[g] == null ? g === 2 ? 1 : 0 : v._a[g];
        v._a[an] === 24 && v._a[$s] === 0 && v._a[Ha] === 0 && v._a[Vl] === 0 && (v._nextDay = !0, v._a[an] = 0), v._d = (v._useUTC ? Nh : o8).apply(
          null,
          S
        ), z = v._useUTC ? v._d.getUTCDay() : v._d.getDay(), v._tzm != null && v._d.setUTCMinutes(v._d.getUTCMinutes() - v._tzm), v._nextDay && (v._a[an] = 24), v._w && typeof v._w.d < "u" && v._w.d !== z && (y(v).weekdayMismatch = !0);
      }
    }
    function tK(v) {
      var g, w, S, C, z, oe, Xe, Tt, nr;
      g = v._w, g.GG != null || g.W != null || g.E != null ? (z = 1, oe = 4, w = Tc(
        g.GG,
        v._a[Fn],
        Fh(_r(), 1, 4).year
      ), S = Tc(g.W, 1), C = Tc(g.E, 1), (C < 1 || C > 7) && (Tt = !0)) : (z = v._locale._week.dow, oe = v._locale._week.doy, nr = Fh(_r(), z, oe), w = Tc(g.gg, v._a[Fn], nr.year), S = Tc(g.w, nr.week), g.d != null ? (C = g.d, (C < 0 || C > 6) && (Tt = !0)) : g.e != null ? (C = g.e + z, (g.e < 0 || g.e > 6) && (Tt = !0)) : C = z), S < 1 || S > Ga(w, z, oe) ? y(v)._overflowWeeks = !0 : Tt != null ? y(v)._overflowWeekday = !0 : (Xe = QA(w, S, C, z, oe), v._a[Fn] = Xe.year, v._dayOfYear = Xe.dayOfYear);
    }
    n.ISO_8601 = function() {
    }, n.RFC_2822 = function() {
    };
    function e_(v) {
      if (v._f === n.ISO_8601) {
        nC(v);
        return;
      }
      if (v._f === n.RFC_2822) {
        iC(v);
        return;
      }
      v._a = [], y(v).empty = !0;
      var g = "" + v._i, w, S, C, z, oe, Xe = g.length, Tt = 0, nr, zn;
      for (C = Te(v._f, v._locale).match(Z) || [], zn = C.length, w = 0; w < zn; w++)
        z = C[w], S = (g.match(Gj(z, v)) || [])[0], S && (oe = g.substr(0, g.indexOf(S)), oe.length > 0 && y(v).unusedInput.push(oe), g = g.slice(
          g.indexOf(S) + S.length
        ), Tt += S.length), q[z] ? (S ? y(v).empty = !1 : y(v).unusedTokens.push(z), jj(z, S, v)) : v._strict && !S && y(v).unusedTokens.push(z);
      y(v).charsLeftOver = Xe - Tt, g.length > 0 && y(v).unusedInput.push(g), v._a[an] <= 12 && y(v).bigHour === !0 && v._a[an] > 0 && (y(v).bigHour = void 0), y(v).parsedDateParts = v._a.slice(0), y(v).meridiem = v._meridiem, v._a[an] = rK(
        v._locale,
        v._a[an],
        v._meridiem
      ), nr = y(v).era, nr !== null && (v._a[Fn] = v._locale.erasConvertYear(nr, v._a[Fn])), Jb(v), Qb(v);
    }
    function rK(v, g, w) {
      var S;
      return w == null ? g : v.meridiemHour != null ? v.meridiemHour(g, w) : (v.isPM != null && (S = v.isPM(w), S && g < 12 && (g += 12), !S && g === 12 && (g = 0)), g);
    }
    function nK(v) {
      var g, w, S, C, z, oe, Xe = !1, Tt = v._f.length;
      if (Tt === 0) {
        y(v).invalidFormat = !0, v._d = /* @__PURE__ */ new Date(NaN);
        return;
      }
      for (C = 0; C < Tt; C++)
        z = 0, oe = !1, g = F({}, v), v._useUTC != null && (g._useUTC = v._useUTC), g._f = v._f[C], e_(g), x(g) && (oe = !0), z += y(g).charsLeftOver, z += y(g).unusedTokens.length * 10, y(g).score = z, Xe ? z < S && (S = z, w = g) : (S == null || z < S || oe) && (S = z, w = g, oe && (Xe = !0));
      p(v, w || g);
    }
    function iK(v) {
      if (!v._d) {
        var g = Ye(v._i), w = g.day === void 0 ? g.date : g.day;
        v._a = f(
          [g.year, g.month, w, g.hour, g.minute, g.second, g.millisecond],
          function(S) {
            return S && parseInt(S, 10);
          }
        ), Jb(v);
      }
    }
    function sK(v) {
      var g = new R(Qb(sC(v)));
      return g._nextDay && (g.add(1, "d"), g._nextDay = void 0), g;
    }
    function sC(v) {
      var g = v._i, w = v._f;
      return v._locale = v._locale || Wa(v._l), g === null || w === void 0 && g === "" ? T({ nullInput: !0 }) : (typeof g == "string" && (v._i = g = v._locale.preparse(g)), $(g) ? new R(Qb(g)) : (h(g) ? v._d = g : a(w) ? nK(v) : w ? e_(v) : aK(v), x(v) || (v._d = null), v));
    }
    function aK(v) {
      var g = v._i;
      c(g) ? v._d = new Date(n.now()) : h(g) ? v._d = new Date(g.valueOf()) : typeof g == "string" ? J8(v) : a(g) ? (v._a = f(g.slice(0), function(w) {
        return parseInt(w, 10);
      }), Jb(v)) : o(g) ? iK(v) : d(g) ? v._d = new Date(g) : n.createFromInputFallback(v);
    }
    function aC(v, g, w, S, C) {
      var z = {};
      return (g === !0 || g === !1) && (S = g, g = void 0), (w === !0 || w === !1) && (S = w, w = void 0), (o(v) && u(v) || a(v) && v.length === 0) && (v = void 0), z._isAMomentObject = !0, z._useUTC = z._isUTC = C, z._l = w, z._i = v, z._f = g, z._strict = S, sK(z);
    }
    function _r(v, g, w, S) {
      return aC(v, g, w, S, !1);
    }
    var oK = P(
      "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
      function() {
        var v = _r.apply(null, arguments);
        return this.isValid() && v.isValid() ? v < this ? this : v : T();
      }
    ), lK = P(
      "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
      function() {
        var v = _r.apply(null, arguments);
        return this.isValid() && v.isValid() ? v > this ? this : v : T();
      }
    );
    function oC(v, g) {
      var w, S;
      if (g.length === 1 && a(g[0]) && (g = g[0]), !g.length)
        return _r();
      for (w = g[0], S = 1; S < g.length; ++S)
        (!g[S].isValid() || g[S][v](w)) && (w = g[S]);
      return w;
    }
    function uK() {
      var v = [].slice.call(arguments, 0);
      return oC("isBefore", v);
    }
    function cK() {
      var v = [].slice.call(arguments, 0);
      return oC("isAfter", v);
    }
    var dK = function() {
      return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
    }, Vh = [
      "year",
      "quarter",
      "month",
      "week",
      "day",
      "hour",
      "minute",
      "second",
      "millisecond"
    ];
    function hK(v) {
      var g, w = !1, S, C = Vh.length;
      for (g in v)
        if (l(v, g) && !(Kr.call(Vh, g) !== -1 && (v[g] == null || !isNaN(v[g]))))
          return !1;
      for (S = 0; S < C; ++S)
        if (v[Vh[S]]) {
          if (w)
            return !1;
          parseFloat(v[Vh[S]]) !== ge(v[Vh[S]]) && (w = !0);
        }
      return !0;
    }
    function fK() {
      return this._isValid;
    }
    function pK() {
      return ks(NaN);
    }
    function tm(v) {
      var g = Ye(v), w = g.year || 0, S = g.quarter || 0, C = g.month || 0, z = g.week || g.isoWeek || 0, oe = g.day || 0, Xe = g.hour || 0, Tt = g.minute || 0, nr = g.second || 0, zn = g.millisecond || 0;
      this._isValid = hK(g), this._milliseconds = +zn + nr * 1e3 + // 1000
      Tt * 6e4 + // 1000 * 60
      Xe * 1e3 * 60 * 60, this._days = +oe + z * 7, this._months = +C + S * 3 + w * 12, this._data = {}, this._locale = Wa(), this._bubble();
    }
    function rm(v) {
      return v instanceof tm;
    }
    function t_(v) {
      return v < 0 ? Math.round(-1 * v) * -1 : Math.round(v);
    }
    function vK(v, g, w) {
      var S = Math.min(v.length, g.length), C = Math.abs(v.length - g.length), z = 0, oe;
      for (oe = 0; oe < S; oe++)
        (w && v[oe] !== g[oe] || !w && ge(v[oe]) !== ge(g[oe])) && z++;
      return z + C;
    }
    function lC(v, g) {
      Y(v, 0, 0, function() {
        var w = this.utcOffset(), S = "+";
        return w < 0 && (w = -w, S = "-"), S + M(~~(w / 60), 2) + g + M(~~w % 60, 2);
      });
    }
    lC("Z", ":"), lC("ZZ", ""), Be("Z", qv), Be("ZZ", qv), rr(["Z", "ZZ"], function(v, g, w) {
      w._useUTC = !0, w._tzm = r_(qv, v);
    });
    var mK = /([\+\-]|\d\d)/gi;
    function r_(v, g) {
      var w = (g || "").match(v), S, C, z;
      return w === null ? null : (S = w[w.length - 1] || [], C = (S + "").match(mK) || ["-", 0, 0], z = +(C[1] * 60) + ge(C[2]), z === 0 ? 0 : C[0] === "+" ? z : -z);
    }
    function n_(v, g) {
      var w, S;
      return g._isUTC ? (w = g.clone(), S = ($(v) || h(v) ? v.valueOf() : _r(v).valueOf()) - w.valueOf(), w._d.setTime(w._d.valueOf() + S), n.updateOffset(w, !1), w) : _r(v).local();
    }
    function i_(v) {
      return -Math.round(v._d.getTimezoneOffset());
    }
    n.updateOffset = function() {
    };
    function gK(v, g, w) {
      var S = this._offset || 0, C;
      if (!this.isValid())
        return v != null ? this : NaN;
      if (v != null) {
        if (typeof v == "string") {
          if (v = r_(qv, v), v === null)
            return this;
        } else
          Math.abs(v) < 16 && !w && (v = v * 60);
        return !this._isUTC && g && (C = i_(this)), this._offset = v, this._isUTC = !0, C != null && this.add(C, "m"), S !== v && (!g || this._changeInProgress ? hC(
          this,
          ks(v - S, "m"),
          1,
          !1
        ) : this._changeInProgress || (this._changeInProgress = !0, n.updateOffset(this, !0), this._changeInProgress = null)), this;
      } else
        return this._isUTC ? S : i_(this);
    }
    function yK(v, g) {
      return v != null ? (typeof v != "string" && (v = -v), this.utcOffset(v, g), this) : -this.utcOffset();
    }
    function bK(v) {
      return this.utcOffset(0, v);
    }
    function _K(v) {
      return this._isUTC && (this.utcOffset(0, v), this._isUTC = !1, v && this.subtract(i_(this), "m")), this;
    }
    function wK() {
      if (this._tzm != null)
        this.utcOffset(this._tzm, !1, !0);
      else if (typeof this._i == "string") {
        var v = r_(Yj, this._i);
        v != null ? this.utcOffset(v) : this.utcOffset(0, !0);
      }
      return this;
    }
    function TK(v) {
      return this.isValid() ? (v = v ? _r(v).utcOffset() : 0, (this.utcOffset() - v) % 60 === 0) : !1;
    }
    function xK() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function SK() {
      if (!c(this._isDSTShifted))
        return this._isDSTShifted;
      var v = {}, g;
      return F(v, this), v = sC(v), v._a ? (g = v._isUTC ? m(v._a) : _r(v._a), this._isDSTShifted = this.isValid() && vK(v._a, g.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
    }
    function EK() {
      return this.isValid() ? !this._isUTC : !1;
    }
    function $K() {
      return this.isValid() ? this._isUTC : !1;
    }
    function uC() {
      return this.isValid() ? this._isUTC && this._offset === 0 : !1;
    }
    var kK = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, DK = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function ks(v, g) {
      var w = v, S = null, C, z, oe;
      return rm(v) ? w = {
        ms: v._milliseconds,
        d: v._days,
        M: v._months
      } : d(v) || !isNaN(+v) ? (w = {}, g ? w[g] = +v : w.milliseconds = +v) : (S = kK.exec(v)) ? (C = S[1] === "-" ? -1 : 1, w = {
        y: 0,
        d: ge(S[sa]) * C,
        h: ge(S[an]) * C,
        m: ge(S[$s]) * C,
        s: ge(S[Ha]) * C,
        ms: ge(t_(S[Vl] * 1e3)) * C
        // the millisecond decimal point is included in the match
      }) : (S = DK.exec(v)) ? (C = S[1] === "-" ? -1 : 1, w = {
        y: Yl(S[2], C),
        M: Yl(S[3], C),
        w: Yl(S[4], C),
        d: Yl(S[5], C),
        h: Yl(S[6], C),
        m: Yl(S[7], C),
        s: Yl(S[8], C)
      }) : w == null ? w = {} : typeof w == "object" && ("from" in w || "to" in w) && (oe = OK(
        _r(w.from),
        _r(w.to)
      ), w = {}, w.ms = oe.milliseconds, w.M = oe.months), z = new tm(w), rm(v) && l(v, "_locale") && (z._locale = v._locale), rm(v) && l(v, "_isValid") && (z._isValid = v._isValid), z;
    }
    ks.fn = tm.prototype, ks.invalid = pK;
    function Yl(v, g) {
      var w = v && parseFloat(v.replace(",", "."));
      return (isNaN(w) ? 0 : w) * g;
    }
    function cC(v, g) {
      var w = {};
      return w.months = g.month() - v.month() + (g.year() - v.year()) * 12, v.clone().add(w.months, "M").isAfter(g) && --w.months, w.milliseconds = +g - +v.clone().add(w.months, "M"), w;
    }
    function OK(v, g) {
      var w;
      return v.isValid() && g.isValid() ? (g = n_(g, v), v.isBefore(g) ? w = cC(v, g) : (w = cC(g, v), w.milliseconds = -w.milliseconds, w.months = -w.months), w) : { milliseconds: 0, months: 0 };
    }
    function dC(v, g) {
      return function(w, S) {
        var C, z;
        return S !== null && !isNaN(+S) && (I(
          g,
          "moment()." + g + "(period, number) is deprecated. Please use moment()." + g + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
        ), z = w, w = S, S = z), C = ks(w, S), hC(this, C, v), this;
      };
    }
    function hC(v, g, w, S) {
      var C = g._milliseconds, z = t_(g._days), oe = t_(g._months);
      v.isValid() && (S = S ?? !0, oe && KA(v, xt(v, "Month") + oe * w), z && vn(v, "Date", xt(v, "Date") + z * w), C && v._d.setTime(v._d.valueOf() + C * w), S && n.updateOffset(v, z || oe));
    }
    var AK = dC(1, "add"), CK = dC(-1, "subtract");
    function fC(v) {
      return typeof v == "string" || v instanceof String;
    }
    function IK(v) {
      return $(v) || h(v) || fC(v) || d(v) || RK(v) || PK(v) || v === null || v === void 0;
    }
    function PK(v) {
      var g = o(v) && !u(v), w = !1, S = [
        "years",
        "year",
        "y",
        "months",
        "month",
        "M",
        "days",
        "day",
        "d",
        "dates",
        "date",
        "D",
        "hours",
        "hour",
        "h",
        "minutes",
        "minute",
        "m",
        "seconds",
        "second",
        "s",
        "milliseconds",
        "millisecond",
        "ms"
      ], C, z, oe = S.length;
      for (C = 0; C < oe; C += 1)
        z = S[C], w = w || l(v, z);
      return g && w;
    }
    function RK(v) {
      var g = a(v), w = !1;
      return g && (w = v.filter(function(S) {
        return !d(S) && fC(v);
      }).length === 0), g && w;
    }
    function MK(v) {
      var g = o(v) && !u(v), w = !1, S = [
        "sameDay",
        "nextDay",
        "lastDay",
        "nextWeek",
        "lastWeek",
        "sameElse"
      ], C, z;
      for (C = 0; C < S.length; C += 1)
        z = S[C], w = w || l(v, z);
      return g && w;
    }
    function LK(v, g) {
      var w = v.diff(g, "days", !0);
      return w < -6 ? "sameElse" : w < -1 ? "lastWeek" : w < 0 ? "lastDay" : w < 1 ? "sameDay" : w < 2 ? "nextDay" : w < 7 ? "nextWeek" : "sameElse";
    }
    function NK(v, g) {
      arguments.length === 1 && (arguments[0] ? IK(arguments[0]) ? (v = arguments[0], g = void 0) : MK(arguments[0]) && (g = arguments[0], v = void 0) : (v = void 0, g = void 0));
      var w = v || _r(), S = n_(w, this).startOf("day"), C = n.calendarFormat(this, S) || "sameElse", z = g && (B(g[C]) ? g[C].call(this, w) : g[C]);
      return this.format(
        z || this.localeData().calendar(C, this, _r(w))
      );
    }
    function FK() {
      return new R(this);
    }
    function BK(v, g) {
      var w = $(v) ? v : _r(v);
      return this.isValid() && w.isValid() ? (g = me(g) || "millisecond", g === "millisecond" ? this.valueOf() > w.valueOf() : w.valueOf() < this.clone().startOf(g).valueOf()) : !1;
    }
    function UK(v, g) {
      var w = $(v) ? v : _r(v);
      return this.isValid() && w.isValid() ? (g = me(g) || "millisecond", g === "millisecond" ? this.valueOf() < w.valueOf() : this.clone().endOf(g).valueOf() < w.valueOf()) : !1;
    }
    function VK(v, g, w, S) {
      var C = $(v) ? v : _r(v), z = $(g) ? g : _r(g);
      return this.isValid() && C.isValid() && z.isValid() ? (S = S || "()", (S[0] === "(" ? this.isAfter(C, w) : !this.isBefore(C, w)) && (S[1] === ")" ? this.isBefore(z, w) : !this.isAfter(z, w))) : !1;
    }
    function YK(v, g) {
      var w = $(v) ? v : _r(v), S;
      return this.isValid() && w.isValid() ? (g = me(g) || "millisecond", g === "millisecond" ? this.valueOf() === w.valueOf() : (S = w.valueOf(), this.clone().startOf(g).valueOf() <= S && S <= this.clone().endOf(g).valueOf())) : !1;
    }
    function HK(v, g) {
      return this.isSame(v, g) || this.isAfter(v, g);
    }
    function GK(v, g) {
      return this.isSame(v, g) || this.isBefore(v, g);
    }
    function WK(v, g, w) {
      var S, C, z;
      if (!this.isValid())
        return NaN;
      if (S = n_(v, this), !S.isValid())
        return NaN;
      switch (C = (S.utcOffset() - this.utcOffset()) * 6e4, g = me(g), g) {
        case "year":
          z = nm(this, S) / 12;
          break;
        case "month":
          z = nm(this, S);
          break;
        case "quarter":
          z = nm(this, S) / 3;
          break;
        case "second":
          z = (this - S) / 1e3;
          break;
        case "minute":
          z = (this - S) / 6e4;
          break;
        case "hour":
          z = (this - S) / 36e5;
          break;
        case "day":
          z = (this - S - C) / 864e5;
          break;
        case "week":
          z = (this - S - C) / 6048e5;
          break;
        default:
          z = this - S;
      }
      return w ? z : ne(z);
    }
    function nm(v, g) {
      if (v.date() < g.date())
        return -nm(g, v);
      var w = (g.year() - v.year()) * 12 + (g.month() - v.month()), S = v.clone().add(w, "months"), C, z;
      return g - S < 0 ? (C = v.clone().add(w - 1, "months"), z = (g - S) / (S - C)) : (C = v.clone().add(w + 1, "months"), z = (g - S) / (C - S)), -(w + z) || 0;
    }
    n.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", n.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function jK() {
      return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function KK(v) {
      if (!this.isValid())
        return null;
      var g = v !== !0, w = g ? this.clone().utc() : this;
      return w.year() < 0 || w.year() > 9999 ? fe(
        w,
        g ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
      ) : B(Date.prototype.toISOString) ? g ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", fe(w, "Z")) : fe(
        w,
        g ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
      );
    }
    function zK() {
      if (!this.isValid())
        return "moment.invalid(/* " + this._i + " */)";
      var v = "moment", g = "", w, S, C, z;
      return this.isLocal() || (v = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", g = "Z"), w = "[" + v + '("]', S = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", C = "-MM-DD[T]HH:mm:ss.SSS", z = g + '[")]', this.format(w + S + C + z);
    }
    function qK(v) {
      v || (v = this.isUtc() ? n.defaultFormatUtc : n.defaultFormat);
      var g = fe(this, v);
      return this.localeData().postformat(g);
    }
    function XK(v, g) {
      return this.isValid() && ($(v) && v.isValid() || _r(v).isValid()) ? ks({ to: this, from: v }).locale(this.locale()).humanize(!g) : this.localeData().invalidDate();
    }
    function QK(v) {
      return this.from(_r(), v);
    }
    function ZK(v, g) {
      return this.isValid() && ($(v) && v.isValid() || _r(v).isValid()) ? ks({ from: this, to: v }).locale(this.locale()).humanize(!g) : this.localeData().invalidDate();
    }
    function JK(v) {
      return this.to(_r(), v);
    }
    function pC(v) {
      var g;
      return v === void 0 ? this._locale._abbr : (g = Wa(v), g != null && (this._locale = g), this);
    }
    var vC = P(
      "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
      function(v) {
        return v === void 0 ? this.localeData() : this.locale(v);
      }
    );
    function mC() {
      return this._locale;
    }
    var im = 1e3, xc = 60 * im, sm = 60 * xc, gC = (365 * 400 + 97) * 24 * sm;
    function Sc(v, g) {
      return (v % g + g) % g;
    }
    function yC(v, g, w) {
      return v < 100 && v >= 0 ? new Date(v + 400, g, w) - gC : new Date(v, g, w).valueOf();
    }
    function bC(v, g, w) {
      return v < 100 && v >= 0 ? Date.UTC(v + 400, g, w) - gC : Date.UTC(v, g, w);
    }
    function e7(v) {
      var g, w;
      if (v = me(v), v === void 0 || v === "millisecond" || !this.isValid())
        return this;
      switch (w = this._isUTC ? bC : yC, v) {
        case "year":
          g = w(this.year(), 0, 1);
          break;
        case "quarter":
          g = w(
            this.year(),
            this.month() - this.month() % 3,
            1
          );
          break;
        case "month":
          g = w(this.year(), this.month(), 1);
          break;
        case "week":
          g = w(
            this.year(),
            this.month(),
            this.date() - this.weekday()
          );
          break;
        case "isoWeek":
          g = w(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1)
          );
          break;
        case "day":
        case "date":
          g = w(this.year(), this.month(), this.date());
          break;
        case "hour":
          g = this._d.valueOf(), g -= Sc(
            g + (this._isUTC ? 0 : this.utcOffset() * xc),
            sm
          );
          break;
        case "minute":
          g = this._d.valueOf(), g -= Sc(g, xc);
          break;
        case "second":
          g = this._d.valueOf(), g -= Sc(g, im);
          break;
      }
      return this._d.setTime(g), n.updateOffset(this, !0), this;
    }
    function t7(v) {
      var g, w;
      if (v = me(v), v === void 0 || v === "millisecond" || !this.isValid())
        return this;
      switch (w = this._isUTC ? bC : yC, v) {
        case "year":
          g = w(this.year() + 1, 0, 1) - 1;
          break;
        case "quarter":
          g = w(
            this.year(),
            this.month() - this.month() % 3 + 3,
            1
          ) - 1;
          break;
        case "month":
          g = w(this.year(), this.month() + 1, 1) - 1;
          break;
        case "week":
          g = w(
            this.year(),
            this.month(),
            this.date() - this.weekday() + 7
          ) - 1;
          break;
        case "isoWeek":
          g = w(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1) + 7
          ) - 1;
          break;
        case "day":
        case "date":
          g = w(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case "hour":
          g = this._d.valueOf(), g += sm - Sc(
            g + (this._isUTC ? 0 : this.utcOffset() * xc),
            sm
          ) - 1;
          break;
        case "minute":
          g = this._d.valueOf(), g += xc - Sc(g, xc) - 1;
          break;
        case "second":
          g = this._d.valueOf(), g += im - Sc(g, im) - 1;
          break;
      }
      return this._d.setTime(g), n.updateOffset(this, !0), this;
    }
    function r7() {
      return this._d.valueOf() - (this._offset || 0) * 6e4;
    }
    function n7() {
      return Math.floor(this.valueOf() / 1e3);
    }
    function i7() {
      return new Date(this.valueOf());
    }
    function s7() {
      var v = this;
      return [
        v.year(),
        v.month(),
        v.date(),
        v.hour(),
        v.minute(),
        v.second(),
        v.millisecond()
      ];
    }
    function a7() {
      var v = this;
      return {
        years: v.year(),
        months: v.month(),
        date: v.date(),
        hours: v.hours(),
        minutes: v.minutes(),
        seconds: v.seconds(),
        milliseconds: v.milliseconds()
      };
    }
    function o7() {
      return this.isValid() ? this.toISOString() : null;
    }
    function l7() {
      return x(this);
    }
    function u7() {
      return p({}, y(this));
    }
    function c7() {
      return y(this).overflow;
    }
    function d7() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    Y("N", 0, 0, "eraAbbr"), Y("NN", 0, 0, "eraAbbr"), Y("NNN", 0, 0, "eraAbbr"), Y("NNNN", 0, 0, "eraName"), Y("NNNNN", 0, 0, "eraNarrow"), Y("y", ["y", 1], "yo", "eraYear"), Y("y", ["yy", 2], 0, "eraYear"), Y("y", ["yyy", 3], 0, "eraYear"), Y("y", ["yyyy", 4], 0, "eraYear"), Be("N", s_), Be("NN", s_), Be("NNN", s_), Be("NNNN", T7), Be("NNNNN", x7), rr(
      ["N", "NN", "NNN", "NNNN", "NNNNN"],
      function(v, g, w, S) {
        var C = w._locale.erasParse(v, S, w._strict);
        C ? y(w).era = C : y(w).invalidEra = v;
      }
    ), Be("y", wc), Be("yy", wc), Be("yyy", wc), Be("yyyy", wc), Be("yo", S7), rr(["y", "yy", "yyy", "yyyy"], Fn), rr(["yo"], function(v, g, w, S) {
      var C;
      w._locale._eraYearOrdinalRegex && (C = v.match(w._locale._eraYearOrdinalRegex)), w._locale.eraYearOrdinalParse ? g[Fn] = w._locale.eraYearOrdinalParse(v, C) : g[Fn] = parseInt(v, 10);
    });
    function h7(v, g) {
      var w, S, C, z = this._eras || Wa("en")._eras;
      for (w = 0, S = z.length; w < S; ++w) {
        switch (typeof z[w].since) {
          case "string":
            C = n(z[w].since).startOf("day"), z[w].since = C.valueOf();
            break;
        }
        switch (typeof z[w].until) {
          case "undefined":
            z[w].until = 1 / 0;
            break;
          case "string":
            C = n(z[w].until).startOf("day").valueOf(), z[w].until = C.valueOf();
            break;
        }
      }
      return z;
    }
    function f7(v, g, w) {
      var S, C, z = this.eras(), oe, Xe, Tt;
      for (v = v.toUpperCase(), S = 0, C = z.length; S < C; ++S)
        if (oe = z[S].name.toUpperCase(), Xe = z[S].abbr.toUpperCase(), Tt = z[S].narrow.toUpperCase(), w)
          switch (g) {
            case "N":
            case "NN":
            case "NNN":
              if (Xe === v)
                return z[S];
              break;
            case "NNNN":
              if (oe === v)
                return z[S];
              break;
            case "NNNNN":
              if (Tt === v)
                return z[S];
              break;
          }
        else if ([oe, Xe, Tt].indexOf(v) >= 0)
          return z[S];
    }
    function p7(v, g) {
      var w = v.since <= v.until ? 1 : -1;
      return g === void 0 ? n(v.since).year() : n(v.since).year() + (g - v.offset) * w;
    }
    function v7() {
      var v, g, w, S = this.localeData().eras();
      for (v = 0, g = S.length; v < g; ++v)
        if (w = this.clone().startOf("day").valueOf(), S[v].since <= w && w <= S[v].until || S[v].until <= w && w <= S[v].since)
          return S[v].name;
      return "";
    }
    function m7() {
      var v, g, w, S = this.localeData().eras();
      for (v = 0, g = S.length; v < g; ++v)
        if (w = this.clone().startOf("day").valueOf(), S[v].since <= w && w <= S[v].until || S[v].until <= w && w <= S[v].since)
          return S[v].narrow;
      return "";
    }
    function g7() {
      var v, g, w, S = this.localeData().eras();
      for (v = 0, g = S.length; v < g; ++v)
        if (w = this.clone().startOf("day").valueOf(), S[v].since <= w && w <= S[v].until || S[v].until <= w && w <= S[v].since)
          return S[v].abbr;
      return "";
    }
    function y7() {
      var v, g, w, S, C = this.localeData().eras();
      for (v = 0, g = C.length; v < g; ++v)
        if (w = C[v].since <= C[v].until ? 1 : -1, S = this.clone().startOf("day").valueOf(), C[v].since <= S && S <= C[v].until || C[v].until <= S && S <= C[v].since)
          return (this.year() - n(C[v].since).year()) * w + C[v].offset;
      return this.year();
    }
    function b7(v) {
      return l(this, "_erasNameRegex") || a_.call(this), v ? this._erasNameRegex : this._erasRegex;
    }
    function _7(v) {
      return l(this, "_erasAbbrRegex") || a_.call(this), v ? this._erasAbbrRegex : this._erasRegex;
    }
    function w7(v) {
      return l(this, "_erasNarrowRegex") || a_.call(this), v ? this._erasNarrowRegex : this._erasRegex;
    }
    function s_(v, g) {
      return g.erasAbbrRegex(v);
    }
    function T7(v, g) {
      return g.erasNameRegex(v);
    }
    function x7(v, g) {
      return g.erasNarrowRegex(v);
    }
    function S7(v, g) {
      return g._eraYearOrdinalRegex || wc;
    }
    function a_() {
      var v = [], g = [], w = [], S = [], C, z, oe = this.eras();
      for (C = 0, z = oe.length; C < z; ++C)
        g.push(Pi(oe[C].name)), v.push(Pi(oe[C].abbr)), w.push(Pi(oe[C].narrow)), S.push(Pi(oe[C].name)), S.push(Pi(oe[C].abbr)), S.push(Pi(oe[C].narrow));
      this._erasRegex = new RegExp("^(" + S.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + g.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + v.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
        "^(" + w.join("|") + ")",
        "i"
      );
    }
    Y(0, ["gg", 2], 0, function() {
      return this.weekYear() % 100;
    }), Y(0, ["GG", 2], 0, function() {
      return this.isoWeekYear() % 100;
    });
    function am(v, g) {
      Y(0, [v, v.length], 0, g);
    }
    am("gggg", "weekYear"), am("ggggg", "weekYear"), am("GGGG", "isoWeekYear"), am("GGGGG", "isoWeekYear"), xe("weekYear", "gg"), xe("isoWeekYear", "GG"), Me("weekYear", 1), Me("isoWeekYear", 1), Be("G", zv), Be("g", zv), Be("GG", br, Ot), Be("gg", br, Ot), Be("GGGG", Wb, ia), Be("gggg", Wb, ia), Be("GGGGG", Kv, _c), Be("ggggg", Kv, _c), Mh(
      ["gggg", "ggggg", "GGGG", "GGGGG"],
      function(v, g, w, S) {
        g[S.substr(0, 2)] = ge(v);
      }
    ), Mh(["gg", "GG"], function(v, g, w, S) {
      g[S] = n.parseTwoDigitYear(v);
    });
    function E7(v) {
      return _C.call(
        this,
        v,
        this.week(),
        this.weekday(),
        this.localeData()._week.dow,
        this.localeData()._week.doy
      );
    }
    function $7(v) {
      return _C.call(
        this,
        v,
        this.isoWeek(),
        this.isoWeekday(),
        1,
        4
      );
    }
    function k7() {
      return Ga(this.year(), 1, 4);
    }
    function D7() {
      return Ga(this.isoWeekYear(), 1, 4);
    }
    function O7() {
      var v = this.localeData()._week;
      return Ga(this.year(), v.dow, v.doy);
    }
    function A7() {
      var v = this.localeData()._week;
      return Ga(this.weekYear(), v.dow, v.doy);
    }
    function _C(v, g, w, S, C) {
      var z;
      return v == null ? Fh(this, S, C).year : (z = Ga(v, S, C), g > z && (g = z), C7.call(this, v, g, w, S, C));
    }
    function C7(v, g, w, S, C) {
      var z = QA(v, g, w, S, C), oe = Nh(z.year, 0, z.dayOfYear);
      return this.year(oe.getUTCFullYear()), this.month(oe.getUTCMonth()), this.date(oe.getUTCDate()), this;
    }
    Y("Q", 0, "Qo", "quarter"), xe("quarter", "Q"), Me("quarter", 7), Be("Q", na), rr("Q", function(v, g) {
      g[Ya] = (ge(v) - 1) * 3;
    });
    function I7(v) {
      return v == null ? Math.ceil((this.month() + 1) / 3) : this.month((v - 1) * 3 + this.month() % 3);
    }
    Y("D", ["DD", 2], "Do", "date"), xe("date", "D"), Me("date", 9), Be("D", br), Be("DD", br, Ot), Be("Do", function(v, g) {
      return v ? g._dayOfMonthOrdinalParse || g._ordinalParse : g._dayOfMonthOrdinalParseLenient;
    }), rr(["D", "DD"], sa), rr("Do", function(v, g) {
      g[sa] = ge(v.match(br)[0]);
    });
    var wC = Ge("Date", !0);
    Y("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), xe("dayOfYear", "DDD"), Me("dayOfYear", 4), Be("DDD", jv), Be("DDDD", Ur), rr(["DDD", "DDDD"], function(v, g, w) {
      w._dayOfYear = ge(v);
    });
    function P7(v) {
      var g = Math.round(
        (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
      ) + 1;
      return v == null ? g : this.add(v - g, "d");
    }
    Y("m", ["mm", 2], 0, "minute"), xe("minute", "m"), Me("minute", 14), Be("m", br), Be("mm", br, Ot), rr(["m", "mm"], $s);
    var R7 = Ge("Minutes", !1);
    Y("s", ["ss", 2], 0, "second"), xe("second", "s"), Me("second", 15), Be("s", br), Be("ss", br, Ot), rr(["s", "ss"], Ha);
    var M7 = Ge("Seconds", !1);
    Y("S", 0, 0, function() {
      return ~~(this.millisecond() / 100);
    }), Y(0, ["SS", 2], 0, function() {
      return ~~(this.millisecond() / 10);
    }), Y(0, ["SSS", 3], 0, "millisecond"), Y(0, ["SSSS", 4], 0, function() {
      return this.millisecond() * 10;
    }), Y(0, ["SSSSS", 5], 0, function() {
      return this.millisecond() * 100;
    }), Y(0, ["SSSSSS", 6], 0, function() {
      return this.millisecond() * 1e3;
    }), Y(0, ["SSSSSSS", 7], 0, function() {
      return this.millisecond() * 1e4;
    }), Y(0, ["SSSSSSSS", 8], 0, function() {
      return this.millisecond() * 1e5;
    }), Y(0, ["SSSSSSSSS", 9], 0, function() {
      return this.millisecond() * 1e6;
    }), xe("millisecond", "ms"), Me("millisecond", 16), Be("S", jv, na), Be("SS", jv, Ot), Be("SSS", jv, Ur);
    var Wo, TC;
    for (Wo = "SSSS"; Wo.length <= 9; Wo += "S")
      Be(Wo, wc);
    function L7(v, g) {
      g[Vl] = ge(("0." + v) * 1e3);
    }
    for (Wo = "S"; Wo.length <= 9; Wo += "S")
      rr(Wo, L7);
    TC = Ge("Milliseconds", !1), Y("z", 0, 0, "zoneAbbr"), Y("zz", 0, 0, "zoneName");
    function N7() {
      return this._isUTC ? "UTC" : "";
    }
    function F7() {
      return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var Ie = R.prototype;
    Ie.add = AK, Ie.calendar = NK, Ie.clone = FK, Ie.diff = WK, Ie.endOf = t7, Ie.format = qK, Ie.from = XK, Ie.fromNow = QK, Ie.to = ZK, Ie.toNow = JK, Ie.get = Es, Ie.invalidAt = c7, Ie.isAfter = BK, Ie.isBefore = UK, Ie.isBetween = VK, Ie.isSame = YK, Ie.isSameOrAfter = HK, Ie.isSameOrBefore = GK, Ie.isValid = l7, Ie.lang = vC, Ie.locale = pC, Ie.localeData = mC, Ie.max = lK, Ie.min = oK, Ie.parsingFlags = u7, Ie.set = Ii, Ie.startOf = e7, Ie.subtract = CK, Ie.toArray = s7, Ie.toObject = a7, Ie.toDate = i7, Ie.toISOString = KK, Ie.inspect = zK, typeof Symbol < "u" && Symbol.for != null && (Ie[Symbol.for("nodejs.util.inspect.custom")] = function() {
      return "Moment<" + this.format() + ">";
    }), Ie.toJSON = o7, Ie.toString = jK, Ie.unix = n7, Ie.valueOf = r7, Ie.creationData = d7, Ie.eraName = v7, Ie.eraNarrow = m7, Ie.eraAbbr = g7, Ie.eraYear = y7, Ie.year = XA, Ie.isLeapYear = a8, Ie.weekYear = E7, Ie.isoWeekYear = $7, Ie.quarter = Ie.quarters = I7, Ie.month = zA, Ie.daysInMonth = n8, Ie.week = Ie.weeks = h8, Ie.isoWeek = Ie.isoWeeks = f8, Ie.weeksInYear = O7, Ie.weeksInWeekYear = A7, Ie.isoWeeksInYear = k7, Ie.isoWeeksInISOWeekYear = D7, Ie.date = wC, Ie.day = Ie.days = $8, Ie.weekday = k8, Ie.isoWeekday = D8, Ie.dayOfYear = P7, Ie.hour = Ie.hours = M8, Ie.minute = Ie.minutes = R7, Ie.second = Ie.seconds = M7, Ie.millisecond = Ie.milliseconds = TC, Ie.utcOffset = gK, Ie.utc = bK, Ie.local = _K, Ie.parseZone = wK, Ie.hasAlignedHourOffset = TK, Ie.isDST = xK, Ie.isLocal = EK, Ie.isUtcOffset = $K, Ie.isUtc = uC, Ie.isUTC = uC, Ie.zoneAbbr = N7, Ie.zoneName = F7, Ie.dates = P(
      "dates accessor is deprecated. Use date instead.",
      wC
    ), Ie.months = P(
      "months accessor is deprecated. Use month instead",
      zA
    ), Ie.years = P(
      "years accessor is deprecated. Use year instead",
      XA
    ), Ie.zone = P(
      "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
      yK
    ), Ie.isDSTShifted = P(
      "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
      SK
    );
    function B7(v) {
      return _r(v * 1e3);
    }
    function U7() {
      return _r.apply(null, arguments).parseZone();
    }
    function xC(v) {
      return v;
    }
    var Ut = te.prototype;
    Ut.calendar = V, Ut.longDateFormat = Oe, Ut.invalidDate = L, Ut.ordinal = ce, Ut.preparse = xC, Ut.postformat = xC, Ut.relativeTime = De, Ut.pastFuture = Re, Ut.set = W, Ut.eras = h7, Ut.erasParse = f7, Ut.erasConvertYear = p7, Ut.erasAbbrRegex = _7, Ut.erasNameRegex = b7, Ut.erasNarrowRegex = w7, Ut.months = Jj, Ut.monthsShort = e8, Ut.monthsParse = r8, Ut.monthsRegex = s8, Ut.monthsShortRegex = i8, Ut.week = l8, Ut.firstDayOfYear = d8, Ut.firstDayOfWeek = c8, Ut.weekdays = w8, Ut.weekdaysMin = x8, Ut.weekdaysShort = T8, Ut.weekdaysParse = E8, Ut.weekdaysRegex = O8, Ut.weekdaysShortRegex = A8, Ut.weekdaysMinRegex = C8, Ut.isPM = P8, Ut.meridiem = L8;
    function om(v, g, w, S) {
      var C = Wa(), z = m().set(S, g);
      return C[w](z, v);
    }
    function SC(v, g, w) {
      if (d(v) && (g = v, v = void 0), v = v || "", g != null)
        return om(v, g, w, "month");
      var S, C = [];
      for (S = 0; S < 12; S++)
        C[S] = om(v, S, w, "month");
      return C;
    }
    function o_(v, g, w, S) {
      typeof v == "boolean" ? (d(g) && (w = g, g = void 0), g = g || "") : (g = v, w = g, v = !1, d(g) && (w = g, g = void 0), g = g || "");
      var C = Wa(), z = v ? C._week.dow : 0, oe, Xe = [];
      if (w != null)
        return om(g, (w + z) % 7, S, "day");
      for (oe = 0; oe < 7; oe++)
        Xe[oe] = om(g, (oe + z) % 7, S, "day");
      return Xe;
    }
    function V7(v, g) {
      return SC(v, g, "months");
    }
    function Y7(v, g) {
      return SC(v, g, "monthsShort");
    }
    function H7(v, g, w) {
      return o_(v, g, w, "weekdays");
    }
    function G7(v, g, w) {
      return o_(v, g, w, "weekdaysShort");
    }
    function W7(v, g, w) {
      return o_(v, g, w, "weekdaysMin");
    }
    Go("en", {
      eras: [
        {
          since: "0001-01-01",
          until: 1 / 0,
          offset: 1,
          name: "Anno Domini",
          narrow: "AD",
          abbr: "AD"
        },
        {
          since: "0000-12-31",
          until: -1 / 0,
          offset: 1,
          name: "Before Christ",
          narrow: "BC",
          abbr: "BC"
        }
      ],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function(v) {
        var g = v % 10, w = ge(v % 100 / 10) === 1 ? "th" : g === 1 ? "st" : g === 2 ? "nd" : g === 3 ? "rd" : "th";
        return v + w;
      }
    }), n.lang = P(
      "moment.lang is deprecated. Use moment.locale instead.",
      Go
    ), n.langData = P(
      "moment.langData is deprecated. Use moment.localeData instead.",
      Wa
    );
    var ja = Math.abs;
    function j7() {
      var v = this._data;
      return this._milliseconds = ja(this._milliseconds), this._days = ja(this._days), this._months = ja(this._months), v.milliseconds = ja(v.milliseconds), v.seconds = ja(v.seconds), v.minutes = ja(v.minutes), v.hours = ja(v.hours), v.months = ja(v.months), v.years = ja(v.years), this;
    }
    function EC(v, g, w, S) {
      var C = ks(g, w);
      return v._milliseconds += S * C._milliseconds, v._days += S * C._days, v._months += S * C._months, v._bubble();
    }
    function K7(v, g) {
      return EC(this, v, g, 1);
    }
    function z7(v, g) {
      return EC(this, v, g, -1);
    }
    function $C(v) {
      return v < 0 ? Math.floor(v) : Math.ceil(v);
    }
    function q7() {
      var v = this._milliseconds, g = this._days, w = this._months, S = this._data, C, z, oe, Xe, Tt;
      return v >= 0 && g >= 0 && w >= 0 || v <= 0 && g <= 0 && w <= 0 || (v += $C(l_(w) + g) * 864e5, g = 0, w = 0), S.milliseconds = v % 1e3, C = ne(v / 1e3), S.seconds = C % 60, z = ne(C / 60), S.minutes = z % 60, oe = ne(z / 60), S.hours = oe % 24, g += ne(oe / 24), Tt = ne(kC(g)), w += Tt, g -= $C(l_(Tt)), Xe = ne(w / 12), w %= 12, S.days = g, S.months = w, S.years = Xe, this;
    }
    function kC(v) {
      return v * 4800 / 146097;
    }
    function l_(v) {
      return v * 146097 / 4800;
    }
    function X7(v) {
      if (!this.isValid())
        return NaN;
      var g, w, S = this._milliseconds;
      if (v = me(v), v === "month" || v === "quarter" || v === "year")
        switch (g = this._days + S / 864e5, w = this._months + kC(g), v) {
          case "month":
            return w;
          case "quarter":
            return w / 3;
          case "year":
            return w / 12;
        }
      else
        switch (g = this._days + Math.round(l_(this._months)), v) {
          case "week":
            return g / 7 + S / 6048e5;
          case "day":
            return g + S / 864e5;
          case "hour":
            return g * 24 + S / 36e5;
          case "minute":
            return g * 1440 + S / 6e4;
          case "second":
            return g * 86400 + S / 1e3;
          case "millisecond":
            return Math.floor(g * 864e5) + S;
          default:
            throw new Error("Unknown unit " + v);
        }
    }
    function Q7() {
      return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + ge(this._months / 12) * 31536e6 : NaN;
    }
    function Ka(v) {
      return function() {
        return this.as(v);
      };
    }
    var Z7 = Ka("ms"), J7 = Ka("s"), ez = Ka("m"), tz = Ka("h"), rz = Ka("d"), nz = Ka("w"), iz = Ka("M"), sz = Ka("Q"), az = Ka("y");
    function oz() {
      return ks(this);
    }
    function lz(v) {
      return v = me(v), this.isValid() ? this[v + "s"]() : NaN;
    }
    function Hl(v) {
      return function() {
        return this.isValid() ? this._data[v] : NaN;
      };
    }
    var uz = Hl("milliseconds"), cz = Hl("seconds"), dz = Hl("minutes"), hz = Hl("hours"), fz = Hl("days"), pz = Hl("months"), vz = Hl("years");
    function mz() {
      return ne(this.days() / 7);
    }
    var za = Math.round, Ec = {
      ss: 44,
      // a few seconds to seconds
      s: 45,
      // seconds to minute
      m: 45,
      // minutes to hour
      h: 22,
      // hours to day
      d: 26,
      // days to month/week
      w: null,
      // weeks to month
      M: 11
      // months to year
    };
    function gz(v, g, w, S, C) {
      return C.relativeTime(g || 1, !!w, v, S);
    }
    function yz(v, g, w, S) {
      var C = ks(v).abs(), z = za(C.as("s")), oe = za(C.as("m")), Xe = za(C.as("h")), Tt = za(C.as("d")), nr = za(C.as("M")), zn = za(C.as("w")), qa = za(C.as("y")), jo = z <= w.ss && ["s", z] || z < w.s && ["ss", z] || oe <= 1 && ["m"] || oe < w.m && ["mm", oe] || Xe <= 1 && ["h"] || Xe < w.h && ["hh", Xe] || Tt <= 1 && ["d"] || Tt < w.d && ["dd", Tt];
      return w.w != null && (jo = jo || zn <= 1 && ["w"] || zn < w.w && ["ww", zn]), jo = jo || nr <= 1 && ["M"] || nr < w.M && ["MM", nr] || qa <= 1 && ["y"] || ["yy", qa], jo[2] = g, jo[3] = +v > 0, jo[4] = S, gz.apply(null, jo);
    }
    function bz(v) {
      return v === void 0 ? za : typeof v == "function" ? (za = v, !0) : !1;
    }
    function _z(v, g) {
      return Ec[v] === void 0 ? !1 : g === void 0 ? Ec[v] : (Ec[v] = g, v === "s" && (Ec.ss = g - 1), !0);
    }
    function wz(v, g) {
      if (!this.isValid())
        return this.localeData().invalidDate();
      var w = !1, S = Ec, C, z;
      return typeof v == "object" && (g = v, v = !1), typeof v == "boolean" && (w = v), typeof g == "object" && (S = Object.assign({}, Ec, g), g.s != null && g.ss == null && (S.ss = g.s - 1)), C = this.localeData(), z = yz(this, !w, S, C), w && (z = C.pastFuture(+this, z)), C.postformat(z);
    }
    var u_ = Math.abs;
    function $c(v) {
      return (v > 0) - (v < 0) || +v;
    }
    function lm() {
      if (!this.isValid())
        return this.localeData().invalidDate();
      var v = u_(this._milliseconds) / 1e3, g = u_(this._days), w = u_(this._months), S, C, z, oe, Xe = this.asSeconds(), Tt, nr, zn, qa;
      return Xe ? (S = ne(v / 60), C = ne(S / 60), v %= 60, S %= 60, z = ne(w / 12), w %= 12, oe = v ? v.toFixed(3).replace(/\.?0+$/, "") : "", Tt = Xe < 0 ? "-" : "", nr = $c(this._months) !== $c(Xe) ? "-" : "", zn = $c(this._days) !== $c(Xe) ? "-" : "", qa = $c(this._milliseconds) !== $c(Xe) ? "-" : "", Tt + "P" + (z ? nr + z + "Y" : "") + (w ? nr + w + "M" : "") + (g ? zn + g + "D" : "") + (C || S || v ? "T" : "") + (C ? qa + C + "H" : "") + (S ? qa + S + "M" : "") + (v ? qa + oe + "S" : "")) : "P0D";
    }
    var Pt = tm.prototype;
    Pt.isValid = fK, Pt.abs = j7, Pt.add = K7, Pt.subtract = z7, Pt.as = X7, Pt.asMilliseconds = Z7, Pt.asSeconds = J7, Pt.asMinutes = ez, Pt.asHours = tz, Pt.asDays = rz, Pt.asWeeks = nz, Pt.asMonths = iz, Pt.asQuarters = sz, Pt.asYears = az, Pt.valueOf = Q7, Pt._bubble = q7, Pt.clone = oz, Pt.get = lz, Pt.milliseconds = uz, Pt.seconds = cz, Pt.minutes = dz, Pt.hours = hz, Pt.days = fz, Pt.weeks = mz, Pt.months = pz, Pt.years = vz, Pt.humanize = wz, Pt.toISOString = lm, Pt.toString = lm, Pt.toJSON = lm, Pt.locale = pC, Pt.localeData = mC, Pt.toIsoString = P(
      "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
      lm
    ), Pt.lang = vC, Y("X", 0, 0, "unix"), Y("x", 0, 0, "valueOf"), Be("x", zv), Be("X", Hj), rr("X", function(v, g, w) {
      w._d = new Date(parseFloat(v) * 1e3);
    }), rr("x", function(v, g, w) {
      w._d = new Date(ge(v));
    });
    //! moment.js
    return n.version = "2.29.4", s(_r), n.fn = Ie, n.min = uK, n.max = cK, n.now = dK, n.utc = m, n.unix = B7, n.months = V7, n.isDate = h, n.locale = Go, n.invalid = T, n.duration = ks, n.isMoment = $, n.weekdays = H7, n.parseZone = U7, n.localeData = Wa, n.isDuration = rm, n.monthsShort = Y7, n.weekdaysMin = W7, n.defineLocale = Xb, n.updateLocale = U8, n.locales = V8, n.weekdaysShort = G7, n.normalizeUnits = me, n.relativeTimeRounding = bz, n.relativeTimeThreshold = _z, n.calendarFormat = LK, n.prototype = Ie, n.HTML5_FMT = {
      DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
      // <input type="datetime-local" />
      DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
      // <input type="datetime-local" step="1" />
      DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
      // <input type="datetime-local" step="0.001" />
      DATE: "YYYY-MM-DD",
      // <input type="date" />
      TIME: "HH:mm",
      // <input type="time" />
      TIME_SECONDS: "HH:mm:ss",
      // <input type="time" step="1" />
      TIME_MS: "HH:mm:ss.SSS",
      // <input type="time" step="0.001" />
      WEEK: "GGGG-[W]WW",
      // <input type="week" />
      MONTH: "YYYY-MM"
      // <input type="month" />
    }, n;
  });
})(Ij);
var sJe = Ij.exports;
const OT = /* @__PURE__ */ nJe(sJe), aJe = { class: "dp__main dp__theme_light" }, oJe = { class: "dp__input_wrap" }, lJe = /* @__PURE__ */ Kq('<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" class="dp__icon dp__input_icon dp__input_icons"><path d="M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"></path><path d="M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"></path><path d="M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"></path><path d="M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"></path></svg></div>', 1), cf = "YYYY.MM.DD HH:mm", uJe = /* @__PURE__ */ Dt({
  __name: "ModalArchiveDownloadInput",
  props: {
    dates: {
      type: Array,
      required: !0
    }
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const r = t, n = ue();
    let s = null;
    const a = () => {
      n.value && (n.value.value = `${OT(r.dates[0]).format(cf)} - ${OT(r.dates[1]).format(cf)}`, s == null || s.updateValue());
    };
    return QX(() => r.dates, a), Nr(() => {
      a();
      const o = n.value;
      s = ct(o, {
        mask: `${cf} - ${cf}`,
        lazy: !1,
        blocks: {
          YYYY: {
            mask: ct.MaskedRange,
            from: 2020,
            to: 2099
          },
          MM: {
            mask: ct.MaskedRange,
            from: 1,
            to: 12
          },
          DD: {
            mask: ct.MaskedRange,
            from: 1,
            to: 31
          },
          HH: {
            mask: ct.MaskedRange,
            from: 0,
            to: 23
          },
          mm: {
            mask: ct.MaskedRange,
            from: 0,
            to: 59
          }
        }
      }), s.on("accept", () => {
        const l = (s == null ? void 0 : s.displayValue.split("-")) ?? [], u = [];
        l.forEach((c) => {
          c.trim();
          const d = OT(c, cf);
          d.isValid() && u.push(d.toDate());
        }), e("update", u);
      });
    }), nh(() => {
      s == null || s.destroy();
    }), (o, l) => (re(), ye("div", aJe, [
      ke("div", oJe, [
        ke("input", {
          ref_key: "input",
          ref: n,
          class: "dp__input dp__input_icon_pad dp__input_range",
          inputmode: "text",
          placeholder: "",
          required: "",
          autocomplete: "off",
          "aria-label": "Datepicker input"
        }, null, 512),
        lJe
      ])
    ]));
  }
}), Pj = (t) => (rc("data-v-72af7757"), t = t(), nc(), t), cJe = { class: "sp-modal-archive-download" }, dJe = /* @__PURE__ */ Pj(() => /* @__PURE__ */ ke("p", { class: "sp-modal-archive-download__title" }, " Выберите период архива для скачивания ", -1)), hJe = /* @__PURE__ */ Pj(() => /* @__PURE__ */ ke("p", { class: "sp-modal-archive-download__subtitle" }, " Максимальная продолжительность скачиваемого видео не должна превышать 12 часов ", -1)), fJe = /* @__PURE__ */ Dt({
  __name: "ModalArchiveDownload",
  props: {
    now: {
      type: Date,
      required: !0
    },
    start: {
      type: Date,
      default: null
    },
    end: {
      type: Date,
      default: null
    },
    allow: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:start", "update:end"],
  setup(t, { emit: e }) {
    const r = t, n = ue(), s = ue([/* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()]), a = ue([/* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()]), o = (f) => {
      e("update:start", f[0]), e("update:end", f[1]), s.value = f;
    }, l = ue(!1), u = ue(!1), c = (f) => {
      l.value || (a.value = s.value), l.value = !1, u.value && f && !f[1] && (s.value = [f[0], f[0]]);
    }, d = we(r.now);
    (r.start === null || r.end === null) && o([
      d.clone().subtract(2, "hour").toDate(),
      d.clone().toDate()
    ]);
    const h = (f) => {
      l.value = !0, f.length === 2 ? s.value = f : f.length === 1 && (s.value = [f[0], s.value[1]]);
    };
    return (f, p) => (re(), ye("div", cJe, [
      dJe,
      je(X(Hb), {
        ref_key: "dp",
        ref: n,
        "model-value": s.value,
        range: "",
        required: "",
        clearable: !1,
        "disable-year-select": "",
        "select-text": "Принять",
        "cancel-text": "Отмена",
        "time-picker-inline": "",
        "allowed-dates": l.value ? void 0 : t.allow,
        "prevent-min-max-navigation": "",
        locale: "ru",
        "text-input": "",
        format: "yyyy.MM.dd HH:mm",
        "input-class-name": "dp__input_range",
        onTimePickerOpen: p[1] || (p[1] = (m) => u.value = !0),
        onTimePickerClose: p[2] || (p[2] = (m) => u.value = !1),
        "onUpdate:modelValue": o,
        onInternalModelChange: c,
        onDateUpdate: p[3] || (p[3] = (m) => l.value = !1)
      }, {
        "action-preview": tt(() => []),
        "dp-input": tt(() => [
          je(uJe, {
            dates: a.value,
            onUpdate: h
          }, null, 8, ["dates"])
        ]),
        "action-buttons": tt(() => [
          ke("button", {
            type: "button",
            class: "dp__action_button dp__action_select",
            onClick: p[0] || (p[0] = (m) => n.value.selectDate())
          }, " Принять ")
        ]),
        _: 1
      }, 8, ["model-value", "allowed-dates"]),
      hJe
    ]));
  }
});
const pJe = /* @__PURE__ */ Di(fJe, [["__scopeId", "data-v-72af7757"]]), p0 = /* @__PURE__ */ new Map(), Rj = (t, e = 0) => {
  if (e > 10 || p0.has(t))
    return;
  const r = document.querySelector(`[data-player-uuid="${t}"] video`);
  if (r) {
    p0.set(t, r);
    return;
  }
  setTimeout(() => Rj(t, e + 1), 100);
}, FA = (t) => {
  Rj(t);
  const e = () => p0.get(t) ?? null;
  return ah(t).add(() => p0.delete(t)), {
    get: e
  };
};
class vJe {
  constructor() {
    kc(this, "stack", /* @__PURE__ */ new Map());
    kc(this, "isLock", !1);
    kc(this, "isUpdatedStack", !1);
  }
  async push(e) {
    for (; this.isLock; )
      await wd(100);
    const r = crypto.randomUUID();
    return this.isUpdatedStack = !0, this.stack.set(r, e), this.flush(r);
  }
  async flush(e) {
    for (; this.isLock; )
      await wd(100);
    await this.waitStack();
    const r = this.stack.get(e);
    return this.stack.delete(e), r;
  }
  async waitStack() {
    for (; this.isUpdatedStack; )
      this.isUpdatedStack = !1, await wd(500);
    this.isLock = !0, await Promise.allSettled(this.stack.values()), this.isLock = !1;
  }
}
const mJe = new vJe(), gJe = (t, e, r) => {
  if (!e)
    throw new Error("Archive link not found");
  if (!r)
    throw new Error("Archive token not found");
  const n = ue(!1);
  let s = new AbortController();
  const a = async (u, c = 0) => {
    c === 0 && (s.abort(), s = new AbortController());
    const d = new Headers();
    d.append("Accept", "application/json"), d.append("Content-Type", "application/json"), d.append("Authorization", `Bearer ${r}`);
    try {
      const h = await fetch(`${e}?date=${u.unix()}`, {
        method: "GET",
        signal: s.signal,
        headers: d
      });
      if (h.ok) {
        n.value = !1;
        const f = await h.json();
        return (f == null ? void 0 : f.data) ?? f;
      }
      return h.status === 401 && (c === 0 && cD(t).emit("unauthorized"), c < 10) ? (await wd(1500), a(u, c + 1)) : { days: [], archive: [] };
    } catch {
      return n.value = !0, { days: [], archive: [] };
    }
  }, o = async (u) => mJe.push(a(u));
  return ah(t).add(() => s.abort()), {
    hasError: n,
    get: o
  };
};
we.locale("ru");
const yJe = Dt({
  components: {
    ButtonSpeed: WZe,
    ModalArchiveDownload: pJe,
    BaseButton: si,
    BaseModal: uD,
    VueDatePicker: Hb
  },
  props: {
    live: {
      type: Boolean,
      required: !0
    },
    play: {
      type: Boolean,
      required: !0
    },
    init: {
      type: Date,
      default: void 0
    },
    isLoading: {
      type: Boolean,
      required: !0
    },
    fragment: {
      type: Object,
      required: !0
    }
  },
  emits: ["select", "update:isLoading"],
  setup() {
    var d, h, f;
    const t = tr(Oi);
    if (!t)
      throw new Error("OPTIONS no module assigned");
    const e = t.uuid, { get: r } = FA(e), n = tr(Io), s = ue((d = t.archive) == null ? void 0 : d.download), a = (h = t.archive) == null ? void 0 : h.link, o = (f = t.archive) == null ? void 0 : f.token, { get: l, hasError: u } = gJe(e, a, o), c = tr(M0);
    if (!c)
      throw new Error("DESTROYER_MODULE no module assigned");
    return {
      options: t,
      isAllowArchiveDownload: s,
      getElement: r,
      get: l,
      hasError: u,
      destroyer: c,
      events: n
    };
  },
  data: () => ({
    modal: {
      download: {
        active: !1,
        start: null,
        end: null
      }
    },
    timeline: null,
    controller: new AbortController(),
    datepicker: {
      value: we().toDate(),
      min: /* @__PURE__ */ new Date(),
      max: /* @__PURE__ */ new Date(),
      allow: [],
      format: (t) => we(t).format("L")
    },
    archive: { days: [], archive: [] },
    fragments: new Gu(),
    interval: {
      upload: 0,
      range: 0
    },
    isBlockActions: !1,
    lockTime: null,
    isSetDate: !1
  }),
  watch: {
    "datepicker.value": {
      async handler() {
        if (this.isBlockActions)
          this.isBlockActions = !1, await this.selectDate(we());
        else {
          const t = we(this.datepicker.value);
          if (this.isSetDate) {
            this.isSetDate = !1, await this.selectDate(t);
            let e = null;
            const r = we(t);
            for (const s of this.archive.archive) {
              const a = we(s.start_date), o = we(s.end_date);
              if (a <= r && r <= o) {
                e = s;
                break;
              }
            }
            const n = e ? e.id : null;
            this.select({
              item: n,
              time: this.init
            });
          } else {
            await this.selectDate(t.startOf("day"));
            const e = this.archive.archive[0] ?? null, r = e ? e.id : null;
            this.select({
              item: r,
              time: 0
            }, !0);
          }
        }
      }
    },
    init: {
      immediate: !0,
      async handler() {
        this.init && (this.isSetDate = !0, this.datepicker.value = this.init);
      }
    },
    live: {
      async handler() {
        this.live && (this.isBlockActions = !0, this.datepicker.value = we().toDate());
      }
    },
    play: {
      async handler() {
        var t;
        this.play ? this.lockTime = null : this.lockTime = ((t = this.timeline) == null ? void 0 : t.getCurrentTime()) ?? null;
      }
    },
    fragment: {
      deep: !0,
      async handler() {
        this.fragment.needNext && this.selectNextFragment();
      }
    }
  },
  created() {
    this.updateRangeDates(), this.interval.range = window.setInterval(this.updateRangeDates.bind(this), 60 * 1e3), this.destroyer.add(() => {
      var t;
      return (t = this.timeline) == null ? void 0 : t.destroy();
    }), this.destroyer.add(() => clearInterval(this.interval.upload)), this.destroyer.add(() => clearInterval(this.interval.range));
  },
  mounted() {
    var r, n, s;
    this.initTimeline(), this.initUploadArchive();
    let t = !1, e = 0;
    (r = this.timeline) == null || r.on("click", (a) => {
      t || this.select(a, !0);
    }), (n = this.timeline) == null || n.on("rangechange", () => {
      t = !0, clearTimeout(e), e = window.setTimeout(() => t = !1, 300);
    }), (s = this.timeline) == null || s.on("currentTimeTick", () => {
      var o;
      const a = (o = this.getElement()) == null ? void 0 : o.currentTime;
      this.timeline && a && this.fragment.start && (this.live ? this.timeline.setCurrentTime(Date.now()) : this.timeline.setCurrentTime((this.fragment.start + a) * 1e3));
    });
  },
  methods: {
    updateRangeDates() {
      const t = we(this.datepicker.value);
      this.datepicker.min = t.clone().startOf("day").subtract(30, "days").toDate(), this.datepicker.max = t.clone().endOf("day").toDate();
    },
    initTimeline() {
      const t = this.$refs.lineElement, e = we(this.datepicker.value);
      this.timeline = new kze(t, [], {
        maxHeight: "60px",
        locale: "ru",
        moment: we,
        max: e.clone().endOf("day").toDate(),
        min: e.clone().startOf("day").toDate(),
        selectable: !1,
        zoomMin: 5 * 60 * 1e3,
        autoResize: !1,
        showCurrentTime: !0,
        showTooltips: !1,
        stack: !1,
        stackSubgroups: !1,
        groupHeightMode: "fixed",
        showMajorLabels: !1
      }), this.timeline.setItems(this.fragments);
    },
    initUploadArchive() {
      this.interval.upload = window.setInterval(async () => {
        we(this.datepicker.value).isSame(/* @__PURE__ */ new Date(), "day") && (this.archive = await this.getArchive(we(), !1), this.pasteFragments());
      }, 2 * 60 * 1e3);
    },
    zoomIn() {
      var t;
      (t = this.timeline) == null || t.zoomIn(1);
    },
    zoomOut() {
      var t;
      (t = this.timeline) == null || t.zoomOut(1);
    },
    pasteFragments() {
      this.fragments.clear(), this.archive.archive.forEach((t) => {
        t.id = crypto.randomUUID(), this.fragments.add({
          id: t.id,
          end: we(t.end_date),
          start: we(t.start_date),
          className: "vis__item_custom"
        });
      });
    },
    select(t, e = !1) {
      var r, n;
      if (t.item) {
        const s = this.archive.archive.find((a) => a.id === t.item);
        if (s) {
          (r = this.timeline) == null || r.setCurrentTime(t.time);
          const a = we(s.start_date);
          let l = we(t.time).diff(a, "seconds") - 3;
          l <= 0 && (l = 0);
          const u = {
            offset: l,
            filename: s.filename,
            start: a.unix()
          };
          this.$emit("select", u), e && ((n = this.events) == null || n.emit("archive", u.offset + a.unix()));
        }
      }
    },
    download() {
      var r;
      const { start: t, end: e } = this.modal.download;
      t instanceof Date && e instanceof Date && ((r = this.events) == null || r.emit("archive-download", { start: t, end: e }));
    },
    selectNextFragment() {
      let t = null;
      const e = this.archive.archive.findIndex((r) => r.filename === this.fragment.value);
      if (e !== -1) {
        t = this.archive.archive[e + 1];
        const r = we(t.start_date).unix();
        if (t) {
          this.$emit("select", {
            offset: 0,
            filename: t.filename,
            start: r
          });
          return;
        }
      }
      this.$emit("select", t);
    },
    async selectDate(t) {
      var n, s, a;
      this.archive = await this.getArchive(t), this.datepicker.allow = this.archive.days.map((o) => we(o).toDate());
      const e = t.clone().startOf("day").toDate(), r = t.clone().endOf("day").toDate();
      (n = this.timeline) == null || n.setOptions({
        min: e,
        max: r
      }), (s = this.timeline) == null || s.setWindow(e, r), this.pasteFragments(), (a = this.timeline) == null || a.setCurrentTime(t.toDate());
    },
    async getArchive(t, e = !0) {
      try {
        return e && this.$emit("update:isLoading", !0), await this.get(t);
      } finally {
        await wd(300), e && this.$emit("update:isLoading", !1);
      }
    }
  }
});
const BA = (t) => (rc("data-v-feed4afd"), t = t(), nc(), t), bJe = {
  key: 0,
  class: "sp-timeline__loader"
}, _Je = /* @__PURE__ */ BA(() => /* @__PURE__ */ ke("div", { class: "sp-timeline__progress" }, [
  /* @__PURE__ */ ke("div")
], -1)), wJe = [
  _Je
], TJe = {
  key: 1,
  class: "sp-timeline__error"
}, xJe = /* @__PURE__ */ BA(() => /* @__PURE__ */ ke("p", null, " Временно невозможно загрузить архив ", -1)), SJe = /* @__PURE__ */ BA(() => /* @__PURE__ */ ke("p", null, " Пожалуйста, попробуйте позже. Мы уже занимаемся устраненим проблемы ", -1)), EJe = [
  xJe,
  SJe
], $Je = { ref: "lineElement" }, kJe = { class: "sp-timeline__controls" }, DJe = { class: "sp-timeline__zoom" };
function OJe(t, e, r, n, s, a) {
  var h, f;
  const o = Hh("BaseButton"), l = Hh("ButtonSpeed"), u = Hh("VueDatePicker"), c = Hh("ModalArchiveDownload"), d = Hh("BaseModal");
  return gd((re(), ye("div", {
    ref: "timeline",
    class: "sp-timeline",
    onPointerdown: e[5] || (e[5] = kt(() => {
    }, ["stop"])),
    onClick: e[6] || (e[6] = kt(() => {
    }, ["stop"]))
  }, [
    je(gs, null, {
      default: tt(() => [
        t.isLoading ? (re(), ye("div", bJe, wJe)) : t.hasError ? (re(), ye("div", TJe, EJe)) : be("", !0)
      ]),
      _: 1
    }),
    ke("div", $Je, null, 512),
    ke("div", kJe, [
      ke("div", DJe, [
        je(o, {
          tooltip: "Увеличить",
          icon: "zoom_in",
          onPointerdown: t.zoomIn,
          onClick: t.zoomIn
        }, null, 8, ["onPointerdown", "onClick"]),
        je(o, {
          tooltip: "Уменьшить",
          icon: "zoom_out",
          onPointerdown: t.zoomOut,
          onClick: t.zoomOut
        }, null, 8, ["onPointerdown", "onClick"])
      ]),
      ke("div", null, [
        je(l),
        t.isAllowArchiveDownload ? (re(), ot(o, {
          key: 0,
          tooltip: "Скачать архив",
          icon: "archive",
          onClick: e[0] || (e[0] = (p) => t.modal.download.active = !0)
        })) : be("", !0),
        je(u, {
          modelValue: t.datepicker.value,
          "onUpdate:modelValue": e[1] || (e[1] = (p) => t.datepicker.value = p),
          clearable: !1,
          "auto-apply": "",
          "disable-year-select": "",
          "min-date": t.datepicker.min,
          "max-date": t.datepicker.max,
          "enable-time-picker": !1,
          "allowed-dates": t.datepicker.allow,
          "prevent-min-max-navigation": "",
          format: t.datepicker.format,
          locale: "ru",
          "input-class-name": "dp__input_custom"
        }, null, 8, ["modelValue", "min-date", "max-date", "allowed-dates", "format"])
      ])
    ]),
    je(d, {
      active: t.modal.download.active,
      "onUpdate:active": e[4] || (e[4] = (p) => t.modal.download.active = p),
      onConfirm: t.download
    }, {
      default: tt(() => [
        je(c, {
          end: t.modal.download.end,
          "onUpdate:end": e[2] || (e[2] = (p) => t.modal.download.end = p),
          start: t.modal.download.start,
          "onUpdate:start": e[3] || (e[3] = (p) => t.modal.download.start = p),
          allow: t.datepicker.allow,
          now: t.datepicker.value
        }, null, 8, ["end", "start", "allow", "now"])
      ]),
      _: 1
    }, 8, ["active", "onConfirm"])
  ], 544)), [
    [_d, (f = (h = t.options) == null ? void 0 : h.archive) == null ? void 0 : f.timeline]
  ]);
}
const AJe = /* @__PURE__ */ Di(yJe, [["render", OJe], ["__scopeId", "data-v-feed4afd"]]), CJe = /* @__PURE__ */ Dt({
  __name: "ButtonSettings",
  setup(t) {
    const e = tr(Oi), r = tr(Io);
    return (n, s) => {
      var a, o;
      return (o = (a = X(e)) == null ? void 0 : a.buttons) != null && o.settings ? (re(), ot(si, {
        key: 0,
        icon: "settings",
        tooltip: "Настройки",
        onClick: s[0] || (s[0] = (l) => {
          var u;
          return (u = X(r)) == null ? void 0 : u.emit("settings");
        })
      })) : be("", !0);
    };
  }
}), IJe = /* @__PURE__ */ Dt({
  __name: "ButtonTimelapse",
  setup(t) {
    const e = tr(Oi), r = tr(Io);
    return (n, s) => {
      var a, o;
      return (o = (a = X(e)) == null ? void 0 : a.buttons) != null && o.settings ? (re(), ot(si, {
        key: 0,
        icon: "history",
        tooltip: "Таймлапс",
        onClick: s[0] || (s[0] = (l) => {
          var u;
          return (u = X(r)) == null ? void 0 : u.emit("timelapse");
        })
      })) : be("", !0);
    };
  }
}), PJe = /* @__PURE__ */ Dt({
  __name: "ButtonFeedback",
  setup(t) {
    const e = tr(Oi), r = tr(Io);
    return (n, s) => {
      var a, o;
      return (o = (a = X(e)) == null ? void 0 : a.buttons) != null && o.feedback ? (re(), ot(si, {
        key: 0,
        icon: "feedback",
        tooltip: "Сообщить о проблеме",
        onClick: s[0] || (s[0] = (l) => {
          var u;
          return (u = X(r)) == null ? void 0 : u.emit("feedback");
        })
      })) : be("", !0);
    };
  }
}), RJe = /* @__PURE__ */ Dt({
  __name: "ButtonRedmine",
  setup(t) {
    const e = tr(Oi), r = tr(Io);
    return (n, s) => {
      var a, o;
      return (o = (a = X(e)) == null ? void 0 : a.buttons) != null && o.settings ? (re(), ot(si, {
        key: 0,
        icon: "engineering",
        tooltip: "Задача монтажнику",
        onClick: s[0] || (s[0] = (l) => {
          var u;
          return (u = X(r)) == null ? void 0 : u.emit("redmine");
        })
      })) : be("", !0);
    };
  }
}), MJe = /* @__PURE__ */ Dt({
  __name: "ButtonHD",
  setup(t) {
    const e = tr(Oi), r = tr(Io);
    return (n, s) => {
      var a, o;
      return (o = (a = X(e)) == null ? void 0 : a.buttons) != null && o.hd ? (re(), ot(si, {
        key: 0,
        icon: "hd",
        tooltip: "HD режим",
        onClick: s[0] || (s[0] = (l) => {
          var u;
          return (u = X(r)) == null ? void 0 : u.emit("hd");
        })
      })) : be("", !0);
    };
  }
}), LJe = /* @__PURE__ */ Dt({
  __name: "ButtonArchive",
  setup(t) {
    const e = tr(Oi), r = tr(Io);
    return (n, s) => {
      var a, o;
      return (o = (a = X(e)) == null ? void 0 : a.buttons) != null && o.archive ? (re(), ot(si, {
        key: 0,
        icon: "archive",
        tooltip: "Архив",
        onClick: s[0] || (s[0] = (l) => {
          var u;
          return (u = X(r)) == null ? void 0 : u.emit("archive-show");
        })
      })) : be("", !0);
    };
  }
}), NJe = (t) => {
  const { get: e } = FA(t), r = ue(!1), n = ue(1), s = () => r.value = !1, a = () => r.value = !0, o = Fk((l) => {
    l && (n.value = l), r.value || (n.value = 1);
    const u = e();
    u && (u.playbackRate = n.value);
  }, 80);
  return {
    isActive: r,
    disable: s,
    enable: a,
    update: o,
    speed: Sk(n)
  };
};
function Mj(t) {
  const e = t.getBoundingClientRect(), { body: r, documentElement: n } = document, s = VA(), a = UA(), o = n.clientTop || r.clientTop || 0, l = n.clientLeft || r.clientLeft || 0, u = e.top + s - o, c = e.left + a - l;
  return { top: u, left: c };
}
function UA() {
  const t = window.pageXOffset !== void 0, e = (document.compatMode || "") === "CSS1Compat";
  return t ? window.pageXOffset : e ? document.documentElement.scrollLeft : document.body.scrollLeft;
}
function VA() {
  const t = window.pageYOffset !== void 0, e = (document.compatMode || "") === "CSS1Compat";
  return t ? window.pageYOffset : e ? document.documentElement.scrollTop : document.body.scrollTop;
}
function wo(t, e, r, n = !1) {
  t.addEventListener(e, r, n);
}
function To(t, e, r, n = !1) {
  t.removeEventListener(e, r, n);
}
function Gb() {
  return "ontouchstart" in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
function Mu(t) {
  return t.type === "wheel" || t.type === "pointerup" || t.type === "pointerdown" || t.type === "pointermove" || t.type === "mousedown" || t.type === "mousemove" || t.type === "mouseup" ? t.clientX : t.changedTouches[0].clientX;
}
function Lu(t) {
  return t.type === "wheel" || t.type === "pointerup" || t.type === "pointerdown" || t.type === "pointermove" || t.type === "mousedown" || t.type === "mousemove" || t.type === "mouseup" ? t.clientY : t.changedTouches[0].clientY;
}
function FJe(t, e, r, n) {
  t.style.transform = `translate(${e}px, ${r}px) scale(${n})`;
}
function BJe(t, e) {
  e ? t.style.transition = `transform ${e}s` : t.style.removeProperty("transition");
}
function UJe(t, e, r) {
  let n = 0, s = 0;
  switch (r) {
    case "top":
      s = (e.currentHeight - t.originalHeight) / 2;
      break;
    case "right":
      n = (e.currentWidth - t.originalWidth) / 2 * -1;
      break;
    case "bottom":
      s = (e.currentHeight - t.originalHeight) / 2 * -1;
      break;
    case "left":
      n = (e.currentWidth - t.originalWidth) / 2;
      break;
  }
  return [n, s];
}
function VJe(t, e, r) {
  let n = Math.max(0, (t.originalWidth - e.currentWidth) / 2), s = Math.max(0, (t.originalHeight - e.currentHeight) / 2);
  switch (r) {
    case "top":
      s = 0;
      break;
    case "right":
      n = 0;
      break;
    case "bottom":
      s = s * 2;
      break;
    case "left":
      n = n * 2;
      break;
  }
  return [n, s];
}
function OB(t, e, r, n, s, a) {
  const o = t + e - r, u = s / 2 - o + n;
  return u * a - u + n;
}
function AB(t, e, r, n, s) {
  switch (t) {
    case "left":
      n / 2 - s < e / 2 && (s = (n - e) / 2);
      break;
    case "right":
      n / 2 + s < e / 2 && (s = (n - e) / 2 * -1);
      break;
    default:
      if ((n - e) / 2 + r < Math.abs(s)) {
        const a = s < 0 ? -1 : 1;
        s = ((n - e) / 2 + r) * a;
      }
  }
  return s;
}
function YJe(t) {
  const e = Mj(t.$element);
  return {
    x: e.left + t.originalWidth / 2 - UA(),
    y: e.top + t.originalHeight / 2 - VA()
  };
}
const Lj = {
  // type content: `image` - only one image, `html` - any HTML content
  type: "image",
  // for type `image` computed auto (if width set null), for type `html` need set real html content width, else computed auto
  width: null,
  // for type `image` computed auto (if height set null), for type `html` need set real html content height, else computed auto
  height: null,
  // drag scrollable content
  dragScrollable: !0,
  // options for the DragScrollable module
  dragScrollableOptions: {},
  // minimum allowed proportion of scale (computed auto if null)
  minScale: null,
  // maximum allowed proportion of scale (1 = 100% content size)
  maxScale: 1,
  // content resizing speed
  speed: 1.1,
  // zoom to maximum (minimum) size on click
  zoomOnClick: !0,
  // zoom to maximum (minimum) size on double click
  zoomOnDblClick: !1,
  // smooth extinction
  smoothTime: 0.25,
  // align content `center`, `left`, `top`, `right`, `bottom`
  alignContent: "center",
  /********************/
  disableWheelZoom: !1,
  // option to reverse wheel direction
  reverseWheelDirection: !1
};
class YA {
  /**
   * @constructor
   */
  constructor() {
    this.subscribes = {};
  }
  /**
   * @param {string} eventType
   * @param {(event: Event) => void} eventHandler
   * @returns {AbstractObserver}
   */
  on(e, r) {
    return e in this.subscribes || (this.subscribes[e] = []), this.subscribes[e].push(r), this;
  }
  destroy() {
    for (let e in this)
      this.hasOwnProperty(e) && (this[e] = null);
  }
  /**
   * @param {string} eventType
   * @param {Event} event
   * @protected
   */
  _run(e, r) {
    if (this.subscribes[e])
      for (const n of this.subscribes[e])
        n(r);
  }
}
const Nj = "grab", Fj = "move", Bj = "drop";
class HJe extends YA {
  /**
   * @param {HTMLElement} target
   * @constructor
   */
  constructor(e) {
    super(), this.target = e, this.moveTimer = null, this.coordinates = null, this.coordinatesShift = null, this.isTouch = Gb(), this.events = this.isTouch ? { grab: "touchstart", move: "touchmove", drop: "touchend" } : { grab: "mousedown", move: "mousemove", drop: "mouseup" }, this.events.options = this.isTouch ? { passive: !1 } : !1, this._dropHandler = this._dropHandler.bind(this), this._grabHandler = this._grabHandler.bind(this), this._moveHandler = this._moveHandler.bind(this), wo(this.target, this.events.grab, this._grabHandler, this.events.options);
  }
  destroy() {
    To(this.target, this.events.grab, this._grabHandler, this.events.options), super.destroy();
  }
  /**
   * @param {Event|TouchEvent|MouseEvent} event
   * @private
   */
  _grabHandler(e) {
    (this.isTouch && e.touches.length === 1 || e.buttons === 1) && (this.coordinates = { x: Mu(e), y: Lu(e) }, this.coordinatesShift = { x: 0, y: 0 }, wo(document, this.events.drop, this._dropHandler, this.events.options), wo(document, this.events.move, this._moveHandler, this.events.options), this._run(Nj, e));
  }
  /**
   * @param {Event} event
   * @private
   */
  _dropHandler(e) {
    To(document, this.events.drop, this._dropHandler), To(document, this.events.move, this._moveHandler), this._run(Bj, e);
  }
  /**
   * @param {Event|TouchEvent} event
   * @private
   */
  _moveHandler(e) {
    if (this.isTouch && e.touches.length > 1)
      return !1;
    const { coordinatesShift: r, coordinates: n } = this;
    r.x = Mu(e) - n.x, r.y = Lu(e) - n.y, n.x = Mu(e), n.y = Lu(e), clearTimeout(this.moveTimer), this.moveTimer = setTimeout(() => {
      r.x = 0, r.y = 0;
    }, 50), e.data = { ...e.data || {}, x: r.x, y: r.y }, this._run(Fj, e);
  }
}
const Uj = "click", vk = "dblclick", Gg = "wheel";
class GJe extends YA {
  /**
   * @param {HTMLElement} target
   * @constructor
   */
  constructor(e) {
    super(), this.target = e, this.coordsOnDown = null, this.pressingTimeout = null, this.firstClick = !0, this.isTouch = Gb(), this.events = this.isTouch ? { down: "touchstart", up: "touchend" } : { down: "mousedown", up: "mouseup" }, this.events.options = this.isTouch ? { passive: !0 } : !1, this._downHandler = this._downHandler.bind(this), this._upHandler = this._upHandler.bind(this), this._wheelHandler = this._wheelHandler.bind(this), wo(this.target, this.events.down, this._downHandler, this.events.options), wo(this.target, this.events.up, this._upHandler, this.events.options), wo(this.target, Gg, this._wheelHandler);
  }
  destroy() {
    To(this.target, this.events.down, this._downHandler, this.events.options), To(this.target, this.events.up, this._upHandler, this.events.options), To(this.target, Gg, this._wheelHandler, this.events.options), super.destroy();
  }
  /**
   * @param {TouchEvent|MouseEvent|PointerEvent} event
   * @private
   */
  _downHandler(e) {
    this.coordsOnDown = null, (this.isTouch && e.touches.length === 1 || e.buttons === 1) && (this.coordsOnDown = { x: Mu(e), y: Lu(e) }), clearTimeout(this.pressingTimeout);
  }
  /**
   * @param {TouchEvent|MouseEvent|PointerEvent} event
   * @private
   */
  _upHandler(e) {
    const r = this.subscribes[vk] ? 200 : 0;
    this.firstClick ? (this.pressingTimeout = setTimeout(() => {
      this.coordsOnDown && this.coordsOnDown.x === Mu(e) && this.coordsOnDown.y === Lu(e) && this._run(Uj, e), this.firstClick = !0;
    }, r), this.firstClick = !1) : this.pressingTimeout = setTimeout(() => {
      this._run(vk, e), this.firstClick = !0;
    }, r / 2);
  }
  /**
   * @param {WheelEvent} event
   * @private
   */
  _wheelHandler(e) {
    this._run(Gg, e);
  }
}
const Vj = "pinchtozoom", CB = 5;
class WJe extends YA {
  /**
   * @param {HTMLElement} target
   * @constructor
   */
  constructor(e) {
    super(), this.target = e, this.fingersHypot = null, this.zoomPinchWasDetected = !1, this._touchMoveHandler = this._touchMoveHandler.bind(this), this._touchEndHandler = this._touchEndHandler.bind(this), wo(this.target, "touchmove", this._touchMoveHandler), wo(this.target, "touchend", this._touchEndHandler);
  }
  destroy() {
    To(this.target, "touchmove", this._touchMoveHandler), To(this.target, "touchend", this._touchEndHandler), super.destroy();
  }
  /**
   * @param {TouchEvent|PointerEvent} event
   * @private
   */
  _touchMoveHandler(e) {
    if (e.targetTouches.length === 2) {
      const r = e.targetTouches[0].clientX, n = e.targetTouches[0].clientY, s = e.targetTouches[1].clientX, a = e.targetTouches[1].clientY, o = Math.round(Math.sqrt(
        Math.pow(Math.abs(r - s), 2) + Math.pow(Math.abs(n - a), 2)
      ));
      let l = 0;
      if (o > this.fingersHypot + CB && (l = -1), o < this.fingersHypot - CB && (l = 1), l !== 0) {
        if (this.fingersHypot !== null || l === 1) {
          const u = Math.min(r, s) + Math.abs(r - s) / 2, c = Math.min(n, a) + Math.abs(n - a) / 2;
          e.data = { ...e.data || {}, clientX: u, clientY: c, direction: l }, this._run(Vj, e);
        }
        this.fingersHypot = o, this.zoomPinchWasDetected = !0;
      }
    }
  }
  /**
   * @private
   */
  _touchEndHandler() {
    this.zoomPinchWasDetected && (this.fingersHypot = null, this.zoomPinchWasDetected = !1);
  }
}
function Dp(t, e = {}) {
  if (this._init = this._init.bind(this), this._prepare = this._prepare.bind(this), this._computeScale = this._computeScale.bind(this), this._computePosition = this._computePosition.bind(this), this._transform = this._transform.bind(this), this.content = {}, typeof t == "string")
    this.content.$element = document.querySelector(t);
  else if (t instanceof HTMLElement)
    this.content.$element = t;
  else
    throw `WZoom: \`selectorOrHTMLElement\` must be selector or HTMLElement, and not ${{}.toString.call(t)}`;
  this.content.$element && (this.viewport = {}, this.viewport.$element = this.content.$element.parentElement, this.options = jJe(e, Lj), this.isTouch = Gb(), this.direction = 1, this.observers = [], this.options.type === "image" ? this.content.$element.complete ? this._init() : wo(this.content.$element, "load", this._init, { once: !0 }) : this._init());
}
Dp.prototype = {
  constructor: Dp,
  /**
   * @private
   */
  _init() {
    const { viewport: t, content: e, options: r, observers: n } = this;
    if (this._prepare(), this._destroyObservers(), r.dragScrollable === !0) {
      const a = new HJe(e.$element);
      n.push(a), typeof r.dragScrollableOptions.onGrab == "function" && a.on(Nj, (o) => {
        o.preventDefault(), r.dragScrollableOptions.onGrab(o, this);
      }), typeof r.dragScrollableOptions.onDrop == "function" && a.on(Bj, (o) => {
        o.preventDefault(), r.dragScrollableOptions.onDrop(o, this);
      }), a.on(Fj, (o) => {
        o.preventDefault();
        const { x: l, y: u } = o.data, c = e.currentLeft + l, d = e.currentTop + u;
        let h = (e.currentWidth - t.originalWidth) / 2 + e.correctX, f = (e.currentHeight - t.originalHeight) / 2 + e.correctY;
        Math.abs(c) <= h && (e.currentLeft = c), Math.abs(d) <= f && (e.currentTop = d), this._transform(), typeof r.dragScrollableOptions.onMove == "function" && r.dragScrollableOptions.onMove(o, this);
      });
    }
    const s = new GJe(e.$element);
    if (n.push(s), !r.disableWheelZoom)
      if (this.isTouch) {
        const a = new WJe(e.$element);
        n.push(a), a.on(Vj, (o) => {
          const { clientX: l, clientY: u, direction: c } = o.data, d = this._computeScale(c);
          this._computePosition(d, l, u), this._transform();
        });
      } else
        s.on(Gg, (a) => {
          a.preventDefault();
          const o = r.reverseWheelDirection ? -a.deltaY : a.deltaY, l = this._computeScale(o);
          this._computePosition(l, Mu(a), Lu(a)), this._transform();
        });
    if (r.zoomOnClick || r.zoomOnDblClick) {
      const a = r.zoomOnDblClick ? vk : Uj;
      s.on(a, (o) => {
        const l = this.direction === 1 ? e.maxScale : e.minScale;
        this._computePosition(l, Mu(o), Lu(o)), this._transform(), this.direction *= -1;
      });
    }
  },
  /**
   * @private
   */
  _prepare() {
    const { viewport: t, content: e, options: r } = this, { left: n, top: s } = Mj(t.$element);
    t.originalWidth = t.$element.offsetWidth, t.originalHeight = t.$element.offsetHeight, t.originalLeft = n, t.originalTop = s, r.type === "image" ? (e.originalWidth = r.width || e.$element.naturalWidth, e.originalHeight = r.height || e.$element.naturalHeight) : (e.originalWidth = r.width || e.$element.offsetWidth, e.originalHeight = r.height || e.$element.offsetHeight), e.maxScale = r.maxScale, e.minScale = r.minScale || Math.min(t.originalWidth / e.originalWidth, t.originalHeight / e.originalHeight, e.maxScale), e.currentScale = e.minScale, e.currentWidth = e.originalWidth * e.currentScale, e.currentHeight = e.originalHeight * e.currentScale, [e.alignPointX, e.alignPointY] = UJe(t, e, r.alignContent), e.currentLeft = e.alignPointX, e.currentTop = e.alignPointY, [e.correctX, e.correctY] = VJe(t, e, r.alignContent), typeof r.prepare == "function" && r.prepare(this), this._transform();
  },
  /**
   * @private
   */
  _computeScale(t) {
    this.direction = t < 0 ? 1 : -1;
    const { minScale: e, maxScale: r, currentScale: n } = this.content, s = n * Math.pow(this.options.speed, this.direction);
    return s <= e ? (this.direction = 1, e) : s >= r ? (this.direction = -1, r) : s;
  },
  /**
   * @param {number} scale
   * @param {number} x
   * @param {number} y
   * @private
   */
  _computePosition(t, e, r) {
    const { viewport: n, content: s, options: a, direction: o } = this, l = s.originalWidth * t, u = s.originalHeight * t, c = UA(), d = VA();
    let h = OB(e, c, n.originalLeft, s.currentLeft, n.originalWidth, l / s.currentWidth), f = OB(r, d, n.originalTop, s.currentTop, n.originalHeight, u / s.currentHeight);
    o === -1 && (h = AB(a.alignContent, n.originalWidth, s.correctX, l, h), f = AB(a.alignContent, n.originalHeight, s.correctY, u, f)), t === s.minScale && (h = s.alignPointX, f = s.alignPointY), s.currentWidth = l, s.currentHeight = u, s.currentLeft = h, s.currentTop = f, s.currentScale = t;
  },
  /**
   * @private
   */
  _transform() {
    BJe(this.content.$element, this.options.smoothTime), FJe(this.content.$element, this.content.currentLeft, this.content.currentTop, this.content.currentScale), typeof this.options.rescale == "function" && this.options.rescale(this);
  },
  /**
   * todo добавить проверку на то что бы переданные координаты не выходили за пределы возможного
   * @param {number} scale
   * @param {Object} coordinates
   * @private
   */
  _zoom(t, e = {}) {
    (e.x === void 0 || e.y === void 0) && (e = YJe(this.viewport)), this._computePosition(t, e.x, e.y), this._transform();
  },
  _destroyObservers() {
    for (const t of this.observers)
      t.destroy();
  },
  prepare() {
    this._prepare();
  },
  /**
   * todo добавить проверку на то что бы переданный state вообще возможен для данного instance
   * @param {number} top
   * @param {number} left
   * @param {number} scale
   */
  transform(t, e, r) {
    const { content: n } = this;
    n.currentWidth = n.originalWidth * r, n.currentHeight = n.originalHeight * r, n.currentLeft = e, n.currentTop = t, n.currentScale = r, this._transform();
  },
  zoomUp() {
    this._zoom(this._computeScale(-1));
  },
  zoomDown() {
    this._zoom(this._computeScale(1));
  },
  maxZoomUp() {
    this._zoom(this.content.maxScale);
  },
  maxZoomDown() {
    this._zoom(this.content.minScale);
  },
  zoomUpToPoint(t) {
    this._zoom(this._computeScale(-1), t);
  },
  zoomDownToPoint(t) {
    this._zoom(this._computeScale(1), t);
  },
  maxZoomUpToPoint(t) {
    this._zoom(this.content.maxScale, t);
  },
  destroy() {
    this.content.$element.style.removeProperty("transition"), this.content.$element.style.removeProperty("transform"), this.options.type === "image" && To(this.content.$element, "load", this._init), this._destroyObservers();
    for (let t in this)
      this.hasOwnProperty(t) && (this[t] = null);
  }
};
function jJe(t, e) {
  const r = Object.assign({}, e, t);
  return r.dragScrollableOptions = Object.assign({}, r.dragScrollableOptions), r.smoothTime = Number(r.smoothTime) || Lj.smoothTime, Gb() && (r.smoothTime = 0), r;
}
Dp.create = function(t, e = {}) {
  return new Dp(t, e);
};
const KJe = (t) => {
  const { get: e } = FA(t), r = ah(t);
  Nr(() => {
    setTimeout(() => {
      const n = e();
      if (n) {
        const s = Dp.create(n, {
          type: "html",
          minScale: 1,
          maxScale: 5,
          zoomOnDblClick: !1,
          zoomOnClick: !1,
          dragScrollable: !1
        });
        r.add(() => s.destroy());
      }
    }, 1500);
  });
}, zJe = ["data-player-uuid"], qJe = ["poster", "onDblclick"], XJe = /* @__PURE__ */ Dt({
  __name: "App",
  props: {
    options: {
      type: Object,
      required: !0
    },
    events: {
      type: Array,
      required: !0
    }
  },
  setup(t, { expose: e }) {
    var Q, te, H, A;
    const r = t, n = ue(), s = ue(), a = ue(), o = ue(!1), l = ue(!1), u = ue(!1), c = ue(!1), d = ue({
      value: null,
      needNext: !1,
      start: 0
    });
    vf(Oi, r.options);
    const h = r.options.uuid, f = ah(h);
    vf(M0, f);
    const p = NJe(h);
    vf(lV, p), (Q = r.options) != null && Q.zoom && KJe(h);
    const m = cD(h);
    r.events.forEach(({ event: V, callback: M }) => m.on(V, M)), vf(Io, m);
    const b = uV();
    b.set(((H = (te = r.options) == null ? void 0 : te.playlist) == null ? void 0 : H.list) ?? []);
    const y = ue((A = r.options) == null ? void 0 : A.date);
    let _ = null, x = !1;
    const T = y_(async () => {
      var M, Z;
      if (!n.value)
        return;
      if (u.value = !0, o.value = !0, await p.update(), x) {
        await n.value.play(), u.value = !1;
        return;
      }
      const V = (Z = (M = r.options) == null ? void 0 : M.camera) == null ? void 0 : Z.stream;
      V && (x = !0, l.value = !0, ya.isSupported() ? (_ = new ya(), _.attachMedia(n.value), _.loadSource(V), _.on(ya.Events.MANIFEST_PARSED, () => {
        u.value = !1;
      }), _.on(ya.Events.ERROR, () => {
        u.value = !1;
      })) : (n.value.src = V, u.value = !1));
    }, 500), k = y_(() => {
      var V, M;
      !((M = (V = r.options) == null ? void 0 : V.control) != null && M.allowPause) || !n.value || (l.value = !1, o.value = !1, n.value.pause());
    }, 500), E = () => {
      var M, Z;
      if (p.disable(), l.value)
        return;
      const V = (Z = (M = r.options) == null ? void 0 : M.camera) == null ? void 0 : Z.stream;
      V && (_ === null ? x = !1 : (_ && _.loadSource(V), l.value = !0), T());
    }, F = async (V) => {
      var M;
      if (p.enable(), await k(), d.value.needNext = !1, V === null) {
        d.value.value = null, d.value.needNext = !1, E();
        return;
      }
      n.value && (u.value = !0, l.value = !1, _ == null || _.destroy(), _ = null, n.value.poster = "", n.value.src = V.filename, n.value.currentTime = V.offset, d.value.value = V.filename, d.value.start = V.start, await wd(300)), (M = r.options) != null && M.date && (x = !0), await T();
    }, R = () => {
      var V, M;
      (M = (V = r.options) == null ? void 0 : V.buttons) != null && M.hd && m.emit("hd");
    }, $ = ue(!1), O = Fk(() => $.value = !1, 3e3), P = () => {
      var V, M;
      (M = (V = r.options) == null ? void 0 : V.control) != null && M.dynamic && ($.value = !0, O());
    }, N = y_(() => {
      $.value && (o.value ? k() : T()), P();
    }, 750);
    Lr(c, () => {
      var V, M;
      (M = (V = r.options) == null ? void 0 : V.archive) != null && M.enable && !r.options.archive.timeline && (u.value = c.value);
    });
    const { toggle: I, isFullscreen: B } = tQ(a);
    return Nr(() => {
      var V, M;
      (V = r.options) != null && V.date || T(), (M = n.value) == null || M.addEventListener("ended", () => {
        l.value === !1 && (d.value.needNext = !0);
      });
    }), f.add(() => {
      _ == null || _.destroy();
    }), e({
      call: (V, M) => {
        var Z;
        switch (V) {
          case "destroy":
            f.call();
            break;
          case "live":
            E();
            break;
          case "set-date":
            y.value = M;
            break;
          case "set-playlists":
            b.set(M);
            break;
          case "set-token": {
            r.options.archive = {
              ...(Z = r.options) == null ? void 0 : Z.archive,
              token: M
            };
            break;
          }
          case "set-speed":
            p.update(M);
            break;
          default:
            throw new Error("Invalid target");
        }
      }
    }), (V, M) => {
      var Z, U, pe;
      return re(), ye("div", {
        ref_key: "player",
        ref: s,
        class: "sp",
        "data-player-uuid": (Z = t.options) == null ? void 0 : Z.uuid,
        onMouseenter: M[2] || (M[2] = (q) => $.value = !0),
        onMouseleave: M[3] || (M[3] = (q) => $.value = !1),
        onPointerdown: M[4] || (M[4] = //@ts-ignore
        (...q) => X(N) && X(N)(...q))
      }, [
        je(Ore, {
          ref_key: "content",
          ref: a
        }, {
          default: tt(() => {
            var q, Y, se, he;
            return [
              je(vP, { top: "" }, Si({
                start: tt(() => [
                  je(kre, { class: "sp__title" })
                ]),
                _: 2
              }, [
                X(B) ? void 0 : {
                  name: "end",
                  fn: tt(() => [
                    je(Sre),
                    je(CJe)
                  ]),
                  key: "0"
                }
              ]), 1024),
              ke("video", {
                ref_key: "video",
                ref: n,
                poster: (Y = (q = t.options) == null ? void 0 : q.camera) == null ? void 0 : Y.poster,
                autoplay: "",
                class: "sp-video",
                muted: "",
                playsinline: "",
                onDblclick: kt(R, ["stop", "prevent"])
              }, null, 40, qJe),
              je(vP, {
                active: $.value,
                dynamic: (he = (se = t.options) == null ? void 0 : se.control) == null ? void 0 : he.dynamic,
                bottom: "",
                gradient: ""
              }, {
                start: tt(() => {
                  var fe, Te, ee, Oe;
                  return [
                    (Te = (fe = t.options) == null ? void 0 : fe.control) != null && Te.allowPause ? (re(), ye(Je, { key: 0 }, [
                      je(si, {
                        icon: o.value ? "pause_circle" : "play_circle",
                        tooltip: o.value ? "Пауза" : "Начать просмотр",
                        onClick: M[0] || (M[0] = () => o.value ? X(k)() : X(T)())
                      }, null, 8, ["icon", "tooltip"]),
                      (Oe = (ee = t.options) == null ? void 0 : ee.camera) != null && Oe.stream ? (re(), ot(si, {
                        key: 0,
                        disabled: l.value,
                        icon: "stream",
                        tooltip: "Онлайн",
                        onClick: E
                      }, null, 8, ["disabled"])) : be("", !0)
                    ], 64)) : be("", !0)
                  ];
                }),
                end: tt(() => {
                  var fe;
                  return [
                    X(B) ? be("", !0) : (re(), ye(Je, { key: 0 }, [
                      je(lre),
                      je(IJe),
                      je(PJe),
                      je(RJe)
                    ], 64)),
                    je(MJe),
                    je(LJe),
                    (fe = t.options.buttons) != null && fe.fullscreen ? (re(), ot(si, {
                      key: 1,
                      icon: X(B) ? "fullscreen_exit" : "fullscreen",
                      tooltip: X(B) ? "Выйти из полноэкранного режима" : "Полноэкранный режим",
                      onClick: X(I)
                    }, null, 8, ["icon", "tooltip", "onClick"])) : be("", !0)
                  ];
                }),
                _: 1
              }, 8, ["active", "dynamic"])
            ];
          }),
          _: 1
        }, 512),
        (pe = (U = t.options) == null ? void 0 : U.archive) != null && pe.enable ? (re(), ot(AJe, {
          key: 0,
          "is-loading": c.value,
          "onUpdate:isLoading": M[1] || (M[1] = (q) => c.value = q),
          fragment: d.value,
          live: l.value,
          play: o.value,
          init: y.value,
          onSelect: F
        }, null, 8, ["is-loading", "fragment", "live", "play", "init"])) : be("", !0),
        je(qte, { active: u.value }, null, 8, ["active"])
      ], 40, zJe);
    };
  }
});
const QJe = /* @__PURE__ */ Di(XJe, [["__scopeId", "data-v-2f995c75"]]);
class tet {
  constructor(e) {
    kc(this, "events", []);
    kc(this, "options");
    var r, n, s, a, o, l, u, c, d, h, f, p, m, b, y, _, x, T, k, E, F;
    this.options = Na({
      uuid: (e == null ? void 0 : e.uuid) ?? crypto.randomUUID(),
      speed: (e == null ? void 0 : e.speed) ?? !0,
      zoom: (e == null ? void 0 : e.zoom) ?? !0,
      control: {
        dynamic: ((r = e == null ? void 0 : e.control) == null ? void 0 : r.dynamic) ?? !1,
        allowPause: ((n = e == null ? void 0 : e.control) == null ? void 0 : n.allowPause) ?? !1
      },
      title: {
        show: ((s = e == null ? void 0 : e.title) == null ? void 0 : s.show) ?? !1,
        editable: ((a = e == null ? void 0 : e.title) == null ? void 0 : a.editable) ?? !1,
        value: ((o = e == null ? void 0 : e.title) == null ? void 0 : o.value) ?? ""
      },
      playlist: {
        enable: ((l = e == null ? void 0 : e.playlist) == null ? void 0 : l.enable) ?? !1,
        alreadyAdded: ((u = e == null ? void 0 : e.playlist) == null ? void 0 : u.alreadyAdded) ?? !1,
        list: ((c = e == null ? void 0 : e.playlist) == null ? void 0 : c.list) ?? []
      },
      buttons: {
        hd: ((d = e == null ? void 0 : e.buttons) == null ? void 0 : d.hd) ?? !1,
        fullscreen: ((h = e == null ? void 0 : e.buttons) == null ? void 0 : h.fullscreen) ?? !1,
        timelapse: ((f = e == null ? void 0 : e.buttons) == null ? void 0 : f.timelapse) ?? !1,
        feedback: ((p = e == null ? void 0 : e.buttons) == null ? void 0 : p.feedback) ?? !1,
        redmine: ((m = e == null ? void 0 : e.buttons) == null ? void 0 : m.redmine) ?? !1,
        info: ((b = e == null ? void 0 : e.buttons) == null ? void 0 : b.info) ?? !1,
        settings: ((y = e == null ? void 0 : e.buttons) == null ? void 0 : y.settings) ?? !1,
        archive: ((_ = e == null ? void 0 : e.buttons) == null ? void 0 : _.archive) ?? !1
      },
      camera: e == null ? void 0 : e.camera,
      date: e == null ? void 0 : e.date,
      archive: {
        enable: ((x = e == null ? void 0 : e.archive) == null ? void 0 : x.enable) ?? !1,
        download: ((T = e == null ? void 0 : e.archive) == null ? void 0 : T.download) ?? !1,
        timeline: ((k = e == null ? void 0 : e.archive) == null ? void 0 : k.timeline) ?? !1,
        token: (E = e == null ? void 0 : e.archive) == null ? void 0 : E.token,
        link: (F = e == null ? void 0 : e.archive) == null ? void 0 : F.link
      }
    });
  }
  setEvent(e, r) {
    return this.events.push({ event: e, callback: r }), this;
  }
  build(e) {
    const r = ah(this.options.uuid), n = MX(QJe, {
      options: this.options,
      events: this.events
    });
    return r.add(() => n.unmount()), n.mount(e);
  }
}
export {
  tet as SimdevPlayerBuilder
};
